import * as React from 'react';

const AMP = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#005AF0",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 0c6.628 0 12 5.373 12 12s-5.372 12-12 12C5.373 24 0 18.627 0 12S5.373 0 12 0m-.92 19.278 5.034-8.377a.44.44 0 0 0 .097-.268.455.455 0 0 0-.455-.455l-2.851.004.924-5.468-.927-.003-5.018 8.367s-.1.183-.1.291c0 .251.204.455.455.455l2.831-.004-.901 5.458z"
    }));

const Adobe = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 91 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#EB1000",
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M56.969 0h33.463v80zM33.463 0H0v80zM45.182 29.467 66.52 80H52.566l-6.368-16.054h-15.58z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h90.432v80H0z"
    }))));

const AffinityDesigner = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        fillRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        clipRule: "evenodd",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#134881",
        d: "M1024 100c0-55.192-44.808-100-100-100H100C44.808 0 0 44.808 0 100v824c0 55.192 44.808 100 100 100h824c55.192 0 100-44.808 100-100z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M2477 909.311c-.17 21.934-18.03 39.689-40 39.689h-403.69l-172.55-298.876H2477zM1603 909V733.513L1983.19 75h148.58l-321.19 556.33L1993.98 949H1643c-22.08 0-40-17.923-40-40m487.17-292.956h-150.22c-16.77 0-32.27-8.8-40.65-23.327-8.38-14.502-8.38-32.433 0-46.935l75.15-130.17zM2437 75c21.97 0 39.83 17.755 40 39.689v501.355h-347.48l-135.41-234.495L2171.1 75z",
        transform: "translate(-1528)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "translate(2271.03 -89.26)scale(1038.26)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#6be1fb"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#38bdfa"
    }))));

const AffinityPhoto = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        fillRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        clipRule: "evenodd",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#4e3188",
        d: "M1023.994 100c0-55.192-44.807-100-99.999-100H100.002C44.81 0 .002 44.808.002 100v824c0 55.192 44.808 100 100 100h823.993c55.192 0 100-44.808 100-100z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M3547 650.087V909c0 21.809-17.49 39.566-39.2 39.992l-264.42-.001-172.64-298.904zm-342.96 298.904h-467.78l234.02-404.714zm-505.34-2.629c-14.15-5.425-24.44-18.652-25.59-34.397l-.11-178.463 190.17-329.251h148.64zm449.05-542.726c12.95.054 25.34 7.661 32.03 18.935.07.114.2.344.2.344l39.3 68.052.34.564c6.42 11.234 6.67 25.389.25 36.827-13.17 23.042-26.55 45.973-39.83 68.96-6.52 11.179-18.86 18.473-31.98 18.636-25.03.105-75.22.047-75.29.047-12.95-.054-25.54-6.959-32.24-18.233-.15-.244-.43-.743-.43-.743s-39.32-68.059-39.4-68.217c-6.43-11.234-6.42-25.747 0-37.185.09-.168.29-.504.29-.504s26.31-45.638 39.48-68.457c6.52-11.179 18.89-18.87 32-19.034.22-.001.66-.011.66-.011l74.17.019zm372.14-326.51-311.25 538.875H3547V115c0-17.566-11.35-32.503-27.11-37.874M3053.34 75h428.43l-231.7 401.157-214.21-370.881zm96.18 295.191h-266.68l133.34-230.855z",
        transform: "translate(-2597.98)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "translate(3341.03 -89.259)scale(1038.25)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#f9a6ff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ea73ff"
    }))));

const AffinityPublisher = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        fillRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        clipRule: "evenodd",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#891b26",
        d: "M1024 100c0-55.192-44.808-100-100-100H100C44.808 0 0 44.808 0 100v824c0 55.192 44.808 100 100 100h824c55.192 0 100-44.808 100-100z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m4145.14 949-257.8-446.348L3754 733.508V909c0 22.077 17.92 40 40 40zm187.99 0h-148.64s-192.55-333.487-257.06-445.057c-12.63-21.85-12.64-48.87-.01-70.724 23.33-40.368 53.92-93.31 53.92-93.31zm187.99 0h-148.64l-369.29-646.928 72.14-124.89zM4628 808.578V909c0 22.077-17.92 40-40 40h-27.53L4095 143.121 4134.35 75h69.95zM4588 75h-344.36L4628 740.456V115c0-22.077-17.92-40-40-40",
        transform: "translate(-3678.99)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "translate(4421.95 -89.26)scale(1038.26)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#ffae71"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ff9350"
    }))));

const AfordinDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 196 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M109.337 48.428c0-6.421-2.518-12.579-7-17.12-4.483-4.54-10.563-7.092-16.902-7.094 6.34-.002 12.42-2.554 16.902-7.094s7-10.7 7-17.12c0 6.421 2.518 12.58 7.002 17.121a23.76 23.76 0 0 0 16.905 7.093 23.76 23.76 0 0 0-16.905 7.093c-4.484 4.54-7.002 10.7-7.002 17.12m29.694 44.055a31.5 31.5 0 0 0-11.353-15.22 30.87 30.87 0 0 0-17.943-5.805 30.86 30.86 0 0 0-17.964 5.74 31.5 31.5 0 0 0-11.406 15.18l-25.795 73.16h37.412l17.46-57.182 22.773 77.722 10.669 31.871c3.384 11.026 10.162 20.667 19.343 27.512 9.182 6.846 20.285 10.537 31.687 10.534H196zM22.692 256h1.791a53 53 0 0 0 31.165-10.155c9.085-6.602 15.897-15.923 19.477-26.651l.418-1.249.307-.961H36.44z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M79.43 209.426c17.013-3.116 29.917-18.19 29.917-36.321H35.864c-9.511.001-18.633 3.829-25.358 10.64S0 199.793 0 209.426z"
    }));

const AfordinLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 196 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M109.337 48.428c0-6.421-2.518-12.579-7-17.12-4.483-4.54-10.563-7.092-16.902-7.094 6.34-.002 12.42-2.554 16.902-7.094s7-10.7 7-17.12c0 6.421 2.518 12.58 7.002 17.121a23.76 23.76 0 0 0 16.905 7.093 23.76 23.76 0 0 0-16.905 7.093c-4.484 4.54-7.002 10.7-7.002 17.12m29.694 44.055a31.5 31.5 0 0 0-11.353-15.22 30.87 30.87 0 0 0-17.943-5.805 30.86 30.86 0 0 0-17.964 5.74 31.5 31.5 0 0 0-11.406 15.18l-25.795 73.16h37.412l17.46-57.182 22.773 77.722 10.669 31.871c3.384 11.026 10.162 20.667 19.343 27.512 9.182 6.846 20.285 10.537 31.687 10.534H196zM22.692 256h1.791a53 53 0 0 0 31.165-10.155c9.085-6.602 15.897-15.923 19.477-26.651l.418-1.249.307-.961H36.44z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M79.43 209.426c17.013-3.116 29.917-18.19 29.917-36.321H35.864c-9.511.001-18.633 3.829-25.358 10.64S0 199.793 0 209.426z"
    }));

const AfterEffects = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 83 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00005B",
        d: "M67.521 0H14.53C6.505 0 0 6.505 0 14.53v50.94C0 73.495 6.505 80 14.53 80H67.52c8.025 0 14.53-6.505 14.53-14.53V14.53C82.051 6.505 75.546 0 67.521 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#99F",
        d: "M32.962 47.863H20.247l-2.587 8.052a.65.65 0 0 1-.66.495h-6.44q-.551 0-.385-.605l11.008-31.574c.11-.33.22-.653.33-1.075.145-.734.218-1.48.22-2.23a.34.34 0 0 1 .386-.384h8.752q.384 0 .44.275L43.806 55.86q.165.55-.33.55H36.32a.51.51 0 0 1-.55-.385zM22.23 41.075h8.697q-.33-1.101-.77-2.478-.442-1.374-.937-2.944l-.99-3.138a106 106 0 0 1-.909-3.027q-.412-1.458-.743-2.67h-.055a44 44 0 0 1-1.156 4.404q-.771 2.477-1.568 5.064a136 136 0 0 1-1.569 4.788M64.062 44.73H53.219a7.7 7.7 0 0 0 1.045 3.032 5.66 5.66 0 0 0 2.505 2.064c1.38.597 2.872.89 4.376.858a20 20 0 0 0 3.55-.39 13 13 0 0 0 3.052-.795q.275-.221.276.275v5.229a.8.8 0 0 1-.083.413.8.8 0 0 1-.248.247 14 14 0 0 1-3.41 1.016c-1.597.3-3.22.438-4.844.413q-3.91 0-6.55-1.211a11.7 11.7 0 0 1-4.293-3.248 12.7 12.7 0 0 1-2.367-4.486 17.7 17.7 0 0 1-.715-4.98 17.4 17.4 0 0 1 .853-5.423 14.2 14.2 0 0 1 2.56-4.678 12.3 12.3 0 0 1 4.127-3.248c1.615-.788 3.523-1.071 5.725-1.071 1.826-.046 3.64.31 5.311 1.045a9.36 9.36 0 0 1 3.606 2.723 12.5 12.5 0 0 1 2.036 3.88c.434 1.353.657 2.764.66 4.184q0 1.212-.082 2.202t-.137 1.43a.5.5 0 0 1-.496.441q-.33 0-1.128.083t-1.982.11c-.79.019-1.623-.115-2.504-.115m-10.843-5.015h7.21q1.32 0 1.954-.027c.282-.029.555-.119.798-.265v-.33a4.4 4.4 0 0 0-.22-1.266 4.496 4.496 0 0 0-4.458-3.137 4.78 4.78 0 0 0-4.541 2.587 8 8 0 0 0-.744 2.438"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h82.051v80H0z"
    }))));

const Ahooks = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 44 44",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 44.005,
        height: 44.005,
        fill: "#4569D4",
        rx: 22.003
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M22.967 20.242q3.34-.18 5.63 3.69-.35 4.74-1.06 6.5l.35 1.23q.18 1.06 1.06 1.94 1.23 1.58 1.23 2.81l-2.99.7q-1.76-1.05-2.46-3.16-2.99 3.34-5.8 3.16-4.569-.53-5.1-5.45.53-9.141 5.98-11.25 1.93-.53 3.16-.17m-5.45 9.31.18 2.11q.35 1.23.7 1.23h1.23q2.46 0 4.57-5.27l.53-2.81q-.53-1.23-2.11-1.23h-.18q-3.86 0-4.92 5.97"
    })));

const Airbnb = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1991.3 2143.2",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#e0565b",
        d: "M1851.6 1735.6c-15 111.6-90.1 208.1-195.2 251-51.5 21.4-107.3 27.9-163.1 21.4-53.6-6.4-107.3-23.6-163-55.7-77.2-43-154.5-109.4-244.6-208.1 141.6-173.8 227.4-332.5 259.6-474.1 15-66.5 17.2-126.6 10.7-182.4-8.6-53.6-27.9-103-57.9-145.9-66.5-96.5-178.1-152.3-302.5-152.3s-236 57.9-302.5 152.3c-30 42.9-49.3 92.3-57.9 145.9-8.6 55.8-6.4 118 10.7 182.4 32.2 141.6 120.1 302.5 259.6 476.2-88 98.7-167.3 165.2-244.6 208.1-55.8 32.2-109.4 49.4-163 55.8-55.3 6.2-111.2-1.2-163-21.4-105.1-42.9-180.2-139.5-195.2-251-6.4-53.6-2.1-107.2 19.3-167.3 6.4-21.5 17.2-42.9 27.9-68.6 15-34.3 32.2-70.8 49.3-107.3l2.2-4.3c148-319.7 306.8-645.8 472-963.3l6.4-12.9c17.2-32.1 34.3-66.5 51.5-98.7 17.2-34.3 36.5-66.5 60.1-94.4 45.1-51.5 105.1-79.4 171.6-79.4s126.6 27.9 171.6 79.4c23.6 27.9 42.9 60.1 60.1 94.4 17.2 32.2 34.3 66.5 51.5 98.6l6.5 12.9c163 319.6 321.8 645.7 469.8 965.4v2.1c17.2 34.3 32.2 73 49.3 107.3 10.7 25.8 21.5 47.2 27.9 68.6 17.1 55.9 23.5 109.5 14.9 165.3m-856-100.9c-115.8-145.9-190.9-283.2-216.7-399-10.7-49.4-12.9-92.3-6.4-130.9 4.3-34.3 17.2-64.4 34.3-90.1 40.8-57.9 109.4-94.4 188.8-94.4s150.2 34.4 188.8 94.4c17.2 25.8 30 55.8 34.3 90.1 6.4 38.6 4.3 83.7-6.4 130.9-25.7 113.7-100.8 251-216.7 399m967.6-111.5c-10.7-25.7-21.5-53.6-32.2-77.2-17.2-38.6-34.3-75.1-49.4-109.4l-2.1-2.1c-148-321.8-306.8-647.9-474.1-969.7l-6.4-12.9c-17.2-32.2-34.3-66.5-51.5-100.8-21.5-38.6-42.9-79.4-77.2-118C1201.6 47.2 1102.9 0 997.8 0 890.5 0 794 47.2 723.1 128.7c-32.2 38.6-55.8 79.4-77.2 118-17.2 34.3-34.3 68.6-51.5 100.8l-6.4 12.8C422.8 682.1 261.9 1008.2 113.9 1330l-2.1 4.3c-15 34.3-32.2 70.8-49.4 109.4-11.5 25.4-22.2 51.2-32.2 77.2-27.9 79.4-36.5 154.5-25.8 231.7 23.6 160.9 130.9 296.1 278.9 356.1 55.8 23.6 113.7 34.3 173.8 34.3 17.2 0 38.6-2.1 55.8-4.3 70.8-8.6 143.7-32.1 214.5-72.9 88-49.3 171.6-120.1 266-223.1 94.4 103 180.2 173.8 266 223.1 70.8 40.8 143.7 64.3 214.5 72.9 17.2 2.2 38.6 4.3 55.8 4.3 60.1 0 120.1-10.7 173.8-34.3 150.2-60.1 255.3-197.4 278.9-356.1 17.2-75 8.6-150-19.2-229.4"
    }));

const Alacritty = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlSpace: "preserve",
        style: {
            clipRule: "evenodd",
            fillRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 1.41420996,
            enableBackground: "new"
        },
        viewBox: "0 0 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 0.025,
        x2: 1,
        y1: 0.079,
        y2: 0,
        gradientTransform: "rotate(90 177.831 370.053)scale(473.895)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#ec2802",
            stopOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#fcb200",
            stopOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__b",
        x1: 19.063,
        x2: 19,
        y1: 0,
        y2: 43.25,
        gradientTransform: "matrix(1.40188 0 0 1.34821 21.364 -32.96)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__c",
        clipPathUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.813 26.75 19 15.945l4.187 10.805L19 43.25Z",
        style: {
            fill: "none",
            stroke: "#000",
            strokeWidth: 0.03779528,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 1.41420996,
            strokeDasharray: "none",
            strokeOpacity: 1
        }
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__d",
        width: 1.192,
        height: 1.148,
        x: -0.096,
        y: -0.074,
        style: {
            colorInterpolationFilters: "sRGB"
        }
    }, /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 1.002
    }))), /*#__PURE__*/ React.createElement("g", {
        style: {
            display: "inline"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m43.566 2.972-1.39 3.37C45.912 17.854 45.912 17.854 48 27.896c2.087-10.042 2.087-10.042 5.825-21.552l-1.391-3.37L48-7.772Z",
        style: {
            clipRule: "evenodd",
            fill: "#069efe",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 0.26960364,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 1.41420996,
            strokeDasharray: "none",
            strokeOpacity: 0.4330357,
            paintOrder: "stroke markers fill"
        },
        transform: "translate(-16 35.82)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M43.093-32.96h9.814l21.729 53.928h-9.112L48-20.221 30.476 20.968h-9.112z",
        style: {
            clipRule: "evenodd",
            fill: "url(#prefix__b)",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "url(#prefix__linearGradient10962)",
            strokeWidth: 0,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 1.41420996,
            strokeDasharray: "none",
            strokeOpacity: 1
        },
        transform: "translate(-16 35.82)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19 32.395 31.5 0 6.5.133Z",
        clipPath: "url(#prefix__c)",
        style: {
            clipRule: "evenodd",
            display: "inline",
            fill: "#fff",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 0,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 0,
            strokeDasharray: "none",
            strokeDashoffset: 0,
            strokeOpacity: 1,
            paintOrder: "markers fill stroke",
            filter: "url(#prefix__d)"
        },
        transform: "matrix(1.3912 0 0 1.33794 5.567 6.717)"
    })));

const Algolia = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 485 120",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#5468FF",
        d: "M16.8-1.001h88.4c8.7 0 15.8 7.065 15.8 15.8v88.405c0 8.7-7.065 15.795-15.8 15.795H16.8c-8.7 0-15.8-7.06-15.8-15.795V14.759c0-8.695 7.06-15.76 15.8-15.76"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M73.505 25.788v-4.115a5.21 5.21 0 0 0-5.21-5.205H56.15a5.21 5.21 0 0 0-5.21 5.205v4.225c0 .47.435.8.91.69a38 38 0 0 1 10.57-1.49c3.465 0 6.895.47 10.21 1.38.44.11.875-.215.875-.69M40.22 31.173l-2.075-2.075a5.206 5.206 0 0 0-7.365 0l-2.48 2.475a5.185 5.185 0 0 0 0 7.355l2.04 2.04c.33.325.805.25 1.095-.075a40 40 0 0 1 3.975-4.66 37.7 37.7 0 0 1 4.7-4c.364-.22.4-.73.11-1.06m22.164 13.065v17.8c0 .51.55.875 1.02.62l15.825-8.19c.36-.18.47-.62.29-.98-3.28-5.755-9.37-9.685-16.405-9.94-.365 0-.73.29-.73.69m0 42.88c-13.195 0-23.915-10.705-23.915-23.88s10.72-23.875 23.915-23.875c13.2 0 23.916 10.7 23.916 23.875s-10.68 23.88-23.916 23.88m0-57.8c-18.74 0-33.94 15.18-33.94 33.92 0 18.745 15.2 33.89 33.94 33.89s33.94-15.18 33.94-33.925-15.165-33.885-33.94-33.885"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5468FF",
        d: "M240.214 94.177c-23.365.11-23.365-18.855-23.365-21.875l-.04-71.045 14.254-2.26v70.61c0 1.715 0 12.56 9.15 12.595v11.975zm-57.78-11.61c4.374 0 7.62-.255 9.88-.69V67.392a29 29 0 0 0-3.43-.695 34 34 0 0 0-4.956-.365c-1.57 0-3.175.11-4.775.365-1.605.22-3.065.655-4.34 1.275s-2.335 1.495-3.1 2.62c-.8 1.13-1.165 1.785-1.165 3.495 0 3.345 1.165 5.28 3.28 6.55 2.115 1.275 4.995 1.93 8.606 1.93m-1.24-51.685c4.7 0 8.674.585 11.884 1.75 3.206 1.165 5.796 2.8 7.69 4.875 1.935 2.11 3.245 4.915 4.046 7.9.84 2.985 1.24 6.26 1.24 9.86v36.62c-2.185.47-5.506 1.015-9.95 1.67q-6.668.984-14.986.985c-3.68 0-7.07-.365-10.095-1.055-3.065-.69-5.65-1.82-7.84-3.385-2.15-1.565-3.825-3.57-5.065-6.04-1.205-2.48-1.825-5.97-1.825-9.61 0-3.495.69-5.715 2.045-8.12q2.071-3.6 5.575-5.895c2.37-1.53 5.065-2.62 8.165-3.275s6.345-.985 9.695-.985c1.57 0 3.21.11 4.96.29 1.715.185 3.575.515 5.545.985v-2.33c0-1.635-.185-3.2-.585-4.655a10 10 0 0 0-2.045-3.895c-.985-1.13-2.255-2.005-3.86-2.62-1.605-.62-3.65-1.095-6.09-1.095-3.28 0-6.27.4-9.005.875-2.735.47-4.995 1.02-6.71 1.635l-1.71-11.68c1.785-.62 4.445-1.24 7.875-1.855 3.425-.66 7.11-.95 11.045-.95zm281.51 51.285c4.375 0 7.615-.255 9.875-.695v-14.48c-.8-.22-1.93-.475-3.425-.695a34 34 0 0 0-4.96-.365c-1.565 0-3.17.11-4.775.365-1.6.22-3.06.655-4.335 1.275-1.28.62-2.335 1.495-3.1 2.62-.805 1.13-1.165 1.785-1.165 3.495 0 3.345 1.165 5.28 3.28 6.55 2.15 1.31 4.995 1.93 8.605 1.93m-1.205-51.645c4.7 0 8.674.58 11.884 1.745 3.205 1.165 5.795 2.8 7.69 4.875s3.245 4.915 4.045 7.9c.84 2.985 1.24 6.26 1.24 9.865v36.615c-2.185.47-5.505 1.015-9.95 1.675q-6.668.981-14.985.98c-3.68 0-7.07-.365-10.094-1.055-3.065-.69-5.65-1.82-7.84-3.385-2.15-1.565-3.825-3.57-5.065-6.04-1.205-2.475-1.825-5.97-1.825-9.61 0-3.495.695-5.715 2.045-8.12q2.071-3.6 5.575-5.895c2.37-1.525 5.065-2.62 8.165-3.275s6.345-.98 9.7-.98c1.565 0 3.205.11 4.955.29s3.575.51 5.54.985v-2.33c0-1.64-.18-3.205-.58-4.66a10 10 0 0 0-2.045-3.895c-.985-1.13-2.255-2.005-3.86-2.62-1.606-.62-3.65-1.09-6.09-1.09-3.28 0-6.27.4-9.005.87-2.735.475-4.995 1.02-6.71 1.64l-1.71-11.685c1.785-.62 4.445-1.235 7.875-1.855 3.425-.62 7.105-.945 11.045-.945m-42.8-6.77c4.774 0 8.68-3.86 8.68-8.63 0-4.765-3.866-8.625-8.68-8.625-4.81 0-8.675 3.86-8.675 8.625 0 4.77 3.9 8.63 8.675 8.63m7.18 70.425h-14.326v-61.44l14.325-2.255v63.695zm-25.116 0c-23.365.11-23.365-18.855-23.365-21.875l-.04-71.045 14.255-2.26v70.61c0 1.715 0 12.56 9.15 12.595zm-46.335-31.445c0-6.155-1.35-11.285-3.974-14.85-2.625-3.605-6.305-5.385-11.01-5.385-4.7 0-8.386 1.78-11.006 5.385-2.625 3.6-3.904 8.695-3.904 14.85 0 6.225 1.315 10.405 3.94 14.01 2.625 3.64 6.305 5.425 11.01 5.425 4.7 0 8.385-1.82 11.01-5.425 2.624-3.64 3.934-7.785 3.934-14.01m14.58-.035c0 4.805-.69 8.44-2.114 12.41q-2.131 5.947-6.01 10.155c-2.59 2.8-5.69 4.985-9.336 6.515-3.644 1.525-9.26 2.4-12.065 2.4-2.81-.035-8.385-.835-11.995-2.4s-6.71-3.715-9.295-6.515c-2.59-2.805-4.594-6.19-6.054-10.155-1.456-3.97-2.185-7.605-2.185-12.41s.654-9.43 2.114-13.36 3.5-7.28 6.125-10.08c2.625-2.805 5.76-4.955 9.33-6.48 3.61-1.53 7.585-2.255 11.885-2.255 4.305 0 8.275.76 11.92 2.255 3.65 1.525 6.786 3.675 9.336 6.48 2.584 2.8 4.59 6.15 6.05 10.08 1.53 3.93 2.295 8.555 2.295 13.36zm-107.284 0c0 5.965 1.31 12.59 3.935 15.355 2.625 2.77 6.014 4.15 10.175 4.15 2.26 0 4.41-.325 6.414-.945 2.005-.62 3.606-1.35 4.886-2.22v-35.34c-1.02-.22-5.286-1.095-9.41-1.2-5.175-.15-9.11 1.965-11.88 5.345-2.736 3.39-4.12 9.32-4.12 14.855m39.625 28.095c0 9.72-2.48 16.815-7.476 21.33-4.99 4.51-12.61 6.77-22.89 6.77-3.755 0-11.555-.73-17.79-2.11l2.295-11.285c5.215 1.09 12.105 1.385 15.715 1.385 5.72 0 9.805-1.165 12.245-3.495 2.445-2.33 3.645-5.785 3.645-10.375v-2.33c-1.42.69-3.28 1.385-5.575 2.115-2.295.69-4.955 1.055-7.95 1.055-3.935 0-7.51-.62-10.75-1.86-3.245-1.235-6.055-3.055-8.35-5.46-2.295-2.4-4.12-5.42-5.395-9.025s-1.935-10.045-1.935-14.775c0-4.44.695-10.01 2.046-13.725 1.384-3.71 3.35-6.915 6.014-9.57 2.626-2.655 5.835-4.695 9.59-6.19 3.755-1.49 8.16-2.435 12.935-2.435 4.635 0 8.9.58 13.055 1.275 4.155.69 7.69 1.415 10.57 2.215v56.49z"
    })));

const Algorand = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 16,
        x2: 16,
        y1: 0,
        y2: 30,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0.5
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__c",
        width: 1.08,
        height: 1.097,
        x: -0.04,
        y: -0.04,
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in: "shadowBlurOuter1",
        in2: "SourceAlpha",
        operator: "out",
        result: "shadowBlurOuter1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0"
    })), /*#__PURE__*/ React.createElement("circle", {
        id: "prefix__a",
        cx: 16,
        cy: 15,
        r: 15
    })), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        filter: "url(#prefix__c)",
        style: {
            display: "inline",
            fillRule: "evenodd"
        }
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        fill: "#627eea",
        style: {
            display: "inline",
            fill: "#e5e5e5",
            fillOpacity: 1,
            fillRule: "evenodd"
        }
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        fill: "url(#prefix__d)",
        style: {
            display: "inline",
            mixBlendMode: "soft-light",
            fill: "url(#prefix__d)",
            fillRule: "evenodd"
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 16,
        cy: 15,
        r: 14.5,
        stroke: "#000",
        strokeOpacity: 0.097,
        style: {
            display: "inline",
            fill: "none",
            fillRule: "evenodd"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m10.332 23 7.221-12.602.991 3.257L13.022 23h2.832l3.54-6.088L20.95 23H23.5l-2.407-9.062 1.699-2.973h-2.549L19.253 7h-2.408L7.5 23Z",
        style: {
            fill: "#000",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.141594,
            strokeOpacity: 1
        }
    }));

const Aliexpress = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#e62e04",
        d: "M5 0a5 5 0 0 0-5 5v54a5 5 0 0 0 5 5h54a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#b32100",
        d: "M17.6 21.452c.245 1 .107 2.08.348 3.097.84-.615 1.4-1.63 1.285-2.687-.017-1.892-2.145-3.375-3.926-2.738-1.12.32-1.948 1.325-2.136 2.46-.224 1.3.557 2.63 1.718 3.224-.115-1.12-.384-2.3-.083-3.396.46-1.194 2.37-1.17 2.795.04zm33.138 1.356c.408-1.468-.48-3.17-1.936-3.64-1.4-.55-3.133.15-3.75 1.514-.688 1.263-.272 3.06.986 3.8.248-1.014.065-2.1.36-3.085.47-1.177 2.355-1.143 2.784.05.273 1.066.026 2.186-.077 3.262.854-.264 1.387-1.08 1.632-1.898z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M46.4 21.396c-.296.995-.113 2.072-.36 3.085-.732 4.4-3.678 8.332-7.667 10.303a14.2 14.2 0 0 1-12.798-.016c-3.952-1.966-6.875-5.865-7.626-10.218-.24-1.018-.104-2.087-.348-3.097-.424-1.2-2.334-1.235-2.794-.04-.3 1.106-.03 2.277.083 3.396.84 5.44 4.48 10.325 9.412 12.75a17.34 17.34 0 0 0 14.635.346c5.333-2.303 9.32-7.446 10.173-13.2.103-1.076.35-2.197.076-3.262-.43-1.193-2.314-1.226-2.785-.05z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f90",
        d: "M5 0a5 5 0 0 0-5 5v9.5a5 5 0 0 1 5-5h54a5 5 0 0 1 5 5V5a5 5 0 0 0-5-5z"
    }));

const AmazonWebServicesDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 304 182",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m86 66 2 9c0 3 1 5 3 8v2l-1 3-7 4-2 1-3-1-4-5-3-6c-8 9-18 14-29 14-9 0-16-3-20-8-5-4-8-11-8-19s3-15 9-20c6-6 14-8 25-8a79 79 0 0 1 22 3v-7c0-8-2-13-5-16-3-4-8-5-16-5l-11 1a80 80 0 0 0-14 5h-2c-1 0-2-1-2-3v-5l1-3c0-1 1-2 3-2l12-5 16-2c12 0 20 3 26 8 5 6 8 14 8 25zM46 82l10-2c4-1 7-4 10-7l3-6 1-9v-4a84 84 0 0 0-19-2c-6 0-11 1-15 4-3 2-4 6-4 11s1 8 3 11c3 2 6 4 11 4m80 10-4-1-2-3-23-78-1-4 2-2h10l4 1 2 4 17 66 15-66 2-4 4-1h8l4 1 2 4 16 67 17-67 2-4 4-1h9c2 0 3 1 3 2v2l-1 2-24 78-2 4-4 1h-9l-4-1-1-4-16-65-15 64-2 4-4 1zm129 3a66 66 0 0 1-27-6l-3-3-1-2v-5c0-2 1-3 2-3h2l3 1a54 54 0 0 0 23 5c6 0 11-2 14-4 4-2 5-5 5-9l-2-7-10-5-15-5c-7-2-13-6-16-10a24 24 0 0 1 5-34l10-5a44 44 0 0 1 20-2 110 110 0 0 1 12 3l4 2 3 2 1 4v4c0 3-1 4-2 4l-4-2c-6-2-12-3-19-3-6 0-11 0-14 2s-4 5-4 9c0 3 1 5 3 7s5 4 11 6l14 4c7 3 12 6 15 10s5 9 5 14l-3 12-7 8c-3 3-7 5-11 6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f90",
        d: "M274 144A220 220 0 0 1 4 124c-4-3-1-6 2-4a300 300 0 0 0 263 16c5-2 10 4 5 8"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f90",
        d: "M287 128c-4-5-28-3-38-1-4 0-4-3-1-5 19-13 50-9 53-5 4 5-1 36-18 51-3 2-6 1-5-2 5-10 13-33 9-38"
    }));

const AmazonWebServicesLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 304 182",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#252f3e",
        d: "m86 66 2 9c0 3 1 5 3 8v2l-1 3-7 4-2 1-3-1-4-5-3-6c-8 9-18 14-29 14-9 0-16-3-20-8-5-4-8-11-8-19s3-15 9-20c6-6 14-8 25-8a79 79 0 0 1 22 3v-7c0-8-2-13-5-16-3-4-8-5-16-5l-11 1a80 80 0 0 0-14 5h-2c-1 0-2-1-2-3v-5l1-3c0-1 1-2 3-2l12-5 16-2c12 0 20 3 26 8 5 6 8 14 8 25zM46 82l10-2c4-1 7-4 10-7l3-6 1-9v-4a84 84 0 0 0-19-2c-6 0-11 1-15 4-3 2-4 6-4 11s1 8 3 11c3 2 6 4 11 4m80 10-4-1-2-3-23-78-1-4 2-2h10l4 1 2 4 17 66 15-66 2-4 4-1h8l4 1 2 4 16 67 17-67 2-4 4-1h9c2 0 3 1 3 2v2l-1 2-24 78-2 4-4 1h-9l-4-1-1-4-16-65-15 64-2 4-4 1zm129 3a66 66 0 0 1-27-6l-3-3-1-2v-5c0-2 1-3 2-3h2l3 1a54 54 0 0 0 23 5c6 0 11-2 14-4 4-2 5-5 5-9l-2-7-10-5-15-5c-7-2-13-6-16-10a24 24 0 0 1 5-34l10-5a44 44 0 0 1 20-2 110 110 0 0 1 12 3l4 2 3 2 1 4v4c0 3-1 4-2 4l-4-2c-6-2-12-3-19-3-6 0-11 0-14 2s-4 5-4 9c0 3 1 5 3 7s5 4 11 6l14 4c7 3 12 6 15 10s5 9 5 14l-3 12-7 8c-3 3-7 5-11 6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f90",
        d: "M274 144A220 220 0 0 1 4 124c-4-3-1-6 2-4a300 300 0 0 0 263 16c5-2 10 4 5 8"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f90",
        d: "M287 128c-4-5-28-3-38-1-4 0-4-3-1-5 19-13 50-9 53-5 4 5-1 36-18 51-3 2-6 1-5-2 5-10 13-33 9-38"
    }));

const Android = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 150",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#34A853",
        d: "M255.285 143.47c-.084-.524-.164-1.042-.251-1.56a128.1 128.1 0 0 0-12.794-38.288 128.8 128.8 0 0 0-23.45-31.86 129.2 129.2 0 0 0-22.713-18.005c.049-.08.09-.168.14-.25 2.582-4.461 5.172-8.917 7.755-13.38l7.576-13.068c1.818-3.126 3.632-6.26 5.438-9.386a11.78 11.78 0 0 0 .662-10.484 11.67 11.67 0 0 0-4.823-5.536 11.85 11.85 0 0 0-5.004-1.61 12 12 0 0 0-2.218.018 11.74 11.74 0 0 0-8.968 5.798c-1.814 3.127-3.628 6.26-5.438 9.386l-7.576 13.069c-2.583 4.462-5.173 8.918-7.755 13.38-.282.487-.567.973-.848 1.467q-.586-.237-1.172-.462c-14.24-5.43-29.688-8.4-45.836-8.4-.442 0-.879 0-1.324.006-14.357.143-28.152 2.64-41.022 7.12a119 119 0 0 0-4.42 1.642c-.262-.455-.532-.911-.79-1.367-2.583-4.462-5.173-8.918-7.755-13.38l-7.576-13.07a3915 3915 0 0 1-5.439-9.386A11.74 11.74 0 0 0 48.5.048a11.7 11.7 0 0 0-5.01 1.612 11.7 11.7 0 0 0-4.077 4.063c-.281.474-.532.967-.742 1.473a11.8 11.8 0 0 0-.365 8.188c.259.786.594 1.554 1.023 2.296a3973 3973 0 0 1 5.439 9.386c2.53 4.357 5.054 8.713 7.58 13.069 2.582 4.462 5.168 8.918 7.75 13.38.02.038.046.075.065.112A129 129 0 0 0 45.32 64.38a129.7 129.7 0 0 0-22.2 24.015 128 128 0 0 0-9.34 15.24 128.2 128.2 0 0 0-10.843 28.764 131 131 0 0 0-1.951 9.524c-.087.518-.167 1.042-.247 1.56A125 125 0 0 0 0 149.118h256a130 130 0 0 0-.734-5.636z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#202124",
        d: "M194.59 113.712c5.122-3.41 5.867-11.3 1.661-17.62-4.203-6.323-11.763-8.682-16.883-5.273-5.122 3.41-5.868 11.3-1.662 17.621 4.203 6.322 11.764 8.682 16.883 5.272Zm-116.072-5.25c4.206-6.321 3.46-14.21-1.662-17.62-5.123-3.41-12.68-1.05-16.886 5.27-4.203 6.323-3.458 14.212 1.662 17.622 5.122 3.41 12.683 1.05 16.886-5.272"
    }));

const Angular = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 242 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        width: 242,
        height: 256,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h242v256H0z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m241 43-9 136L149 0zm-58 176-62 36-63-36 12-31h101zM121 68l32 80H88zM9 179 0 43 92 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "m241 43-9 136L149 0zm-58 176-62 36-63-36 12-31h101zM121 68l32 80H88zM9 179 0 43 92 0z"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 53.2,
        x2: 245,
        y1: 231.9,
        y2: 140.7,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#E40035"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#F60A48"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#F20755"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopColor: "#DC087D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#9717E7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6C00F5"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 44.5,
        x2: 170,
        y1: 30.7,
        y2: 174,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF31D9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF5BE1",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h242v256H0z"
    }))));

const Animate = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2
        },
        viewBox: "0 0 1146 1117",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h1145.83v1116.67H0z",
        style: {
            fill: "none"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M48.642.184h177.4c26.896 0 48.642 21.747 48.642 48.643v170.532c0 26.895-21.746 48.641-48.642 48.641h-177.4C21.746 268 0 246.254 0 219.359V48.827C0 21.931 21.746.184 48.642.184",
        style: {
            fill: "#00005b",
            fillRule: "nonzero"
        },
        transform: "scale(4.167)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M75.194 137.641h29.072c-.687-2.403-1.603-5.266-2.632-8.241a344 344 0 0 1-3.091-9.843c-1.145-3.548-2.175-6.981-3.32-10.529-1.144-3.548-2.174-6.867-3.09-10.186-.916-3.204-1.716-6.18-2.517-8.927h-.23c-1.03 4.921-2.289 9.843-3.891 14.763-1.717 5.494-3.433 11.217-5.265 16.94a225 225 0 0 1-5.036 16.023m35.825 22.775H68.556l-8.698 26.896c-.23 1.03-1.145 1.718-2.175 1.602H35.938c-1.26 0-1.603-.686-1.26-2.06L71.646 81.217c.344-1.145.687-2.061 1.145-3.548.458-2.403.686-4.922.686-7.44-.113-.572.344-1.144.916-1.258h29.758c.915 0 1.373.342 1.488.915l41.66 117.083c.344 1.259 0 1.831-1.144 1.831h-23.921c-.801.114-1.602-.458-1.831-1.259zm49.213 26.782v-67.985c0-2.059 0-4.463-.115-6.98-.114-2.633-.114-5.036-.228-7.325-.115-2.289-.229-4.464-.343-5.837-.115-.344-.115-.802.228-1.144.343-.23.687-.344 1.145-.344h18.427c.686 0 1.258.114 1.831.344.458.228.801.686.916 1.258.228.687.572 1.603.801 2.518a22 22 0 0 1 .686 3.777 38 38 0 0 1 12.133-7.096c4.463-1.488 9.155-2.289 13.848-2.289 3.663 0 7.325.573 10.758 1.717 8.126 2.632 14.535 8.927 17.397 16.938 1.831 4.693 2.517 10.873 2.517 18.313v54.135c0 1.144-.458 1.602-1.488 1.602l-21.516.23c-.916.113-1.716-.458-1.832-1.374v-51.732c-.114-3.433-.8-6.867-2.173-9.958-1.031-2.289-2.633-4.348-4.694-5.722-2.402-1.488-5.035-2.174-7.782-2.06-2.977 0-5.951.458-8.698 1.603-2.519 1.03-4.808 2.517-6.867 4.348v63.177c0 1.145-.458 1.602-1.489 1.602h-21.745c-.802.116-1.488-.457-1.602-1.258-.23-.229-.23-.344-.115-.458",
        style: {
            fill: "#99f",
            fillRule: "nonzero"
        },
        transform: "scale(4.167)"
    }));

const AntDesign = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "62.102%",
        x2: "108.197%",
        y1: "0%",
        y2: "37.864%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4285EB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#2EC7FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "69.644%",
        x2: "54.043%",
        y1: "0%",
        y2: "108.457%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#29CDFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "37.86%",
        stopColor: "#148EFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0A60FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "69.691%",
        x2: "16.723%",
        y1: "-12.974%",
        y2: "117.391%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FA816E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "41.473%",
        stopColor: "#F74A5C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#F51D2C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "68.128%",
        x2: "30.44%",
        y1: "-35.691%",
        y2: "114.943%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FA8E7D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "51.264%",
        stopColor: "#F74A5C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#F51D2C"
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M91.588 4.177 4.18 91.513a11.98 11.98 0 0 0 0 16.974l87.408 87.336a12.005 12.005 0 0 0 16.989 0l36.648-36.618c4.209-4.205 4.209-11.023 0-15.228s-11.031-4.205-15.24 0l-27.783 27.76c-1.17 1.169-2.945 1.169-4.114 0l-69.802-69.744c-1.17-1.169-1.17-2.942 0-4.11l69.802-69.745c1.17-1.169 2.944-1.169 4.114 0l27.783 27.76c4.209 4.205 11.032 4.205 15.24 0s4.209-11.022 0-15.227L108.581 4.056c-4.719-4.594-12.312-4.557-16.993.12"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M91.588 4.177 4.18 91.513a11.98 11.98 0 0 0 0 16.974l87.408 87.336a12.005 12.005 0 0 0 16.989 0l36.648-36.618c4.209-4.205 4.209-11.023 0-15.228s-11.031-4.205-15.24 0l-27.783 27.76c-1.17 1.169-2.945 1.169-4.114 0l-69.802-69.744c-1.17-1.169-1.17-2.942 0-4.11l69.802-69.745c2.912-2.51 7.664-7.596 14.642-8.786q7.778-1.325 17.009 5.837L108.58 4.056c-4.719-4.594-12.312-4.557-16.993.12"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M153.686 135.855c4.208 4.205 11.031 4.205 15.24 0l27.034-27.012c4.7-4.696 4.7-12.28 0-16.974l-27.27-27.15c-4.218-4.2-11.043-4.195-15.254.013-4.209 4.205-4.209 11.022 0 15.227l18.418 18.403c1.17 1.169 1.17 2.943 0 4.111l-18.168 18.154c-4.209 4.205-4.209 11.023 0 15.228"
    })), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 100.519,
        cy: 100.437,
        fill: "url(#prefix__d)",
        rx: 23.6,
        ry: 23.581
    })));

const AnthropicDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#ffff",
        fillRule: "evenodd",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.827 3.52h3.603L24 20h-3.603zm-7.258 0h3.767L16.906 20h-3.674l-1.343-3.461H5.017l-1.344 3.46H0L6.57 3.522zm4.132 9.959L8.453 7.687 6.205 13.48H10.7z"
    }));

const AnthropicLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.827 3.52h3.603L24 20h-3.603zm-7.258 0h3.767L16.906 20h-3.674l-1.343-3.461H5.017l-1.344 3.46H0L6.57 3.522zm4.132 9.959L8.453 7.687 6.205 13.48H10.7z"
    }));

const Apidog = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "0%",
        x2: "99.996%",
        y1: "36.301%",
        y2: "64.611%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#3BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#73F"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "102.837%",
        x2: "-5.655%",
        y1: "70.777%",
        y2: "28.962%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#99C2FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "49.941%",
        x2: "23.669%",
        y1: "69.215%",
        y2: "32.86%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#99C2FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M198.391 180.368 194 175.984l-.816-.752a93.67 93.67 0 0 0-65.318-26.504 93.67 93.67 0 0 0-65.309 26.504l-.568.56-4.327 4.384-9.288 9.264a28.24 28.24 0 0 1-20.08 8.384 28.33 28.33 0 0 1-20.006-8.264A28.19 28.19 0 0 1 0 169.6c0-7.49 2.983-14.672 8.288-19.96l20.007-19.96-19.76-19.656A28.23 28.23 0 0 1 0 89.824a28.2 28.2 0 0 1 8.288-19.96c11.06-11.033 28.962-11.033 40.022 0L62.805 84.32a93.75 93.75 0 0 0 65.317 26.48c24.4 0 47.838-9.504 65.31-26.48a3 3 0 0 1 .632-.632l8.215-8.256 5.464-5.384a27.97 27.97 0 0 1 19.951-8.256 28.3 28.3 0 0 1 20 8.264 28.185 28.185 0 0 1 6.119 30.864 27.8 27.8 0 0 1-6.296 9.176l-19.823 19.776 19.823 19.776a28.04 28.04 0 0 1 8.472 20.144 28.2 28.2 0 0 1-8.288 19.952c-11.038 11.026-28.92 11.026-39.958 0l-9.416-9.376z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M178.712 2.136a28.1 28.1 0 0 1 9.184 6.12 28.185 28.185 0 0 1-.064 39.864l-20 19.96-.503.44c-21.958 21.404-56.975 21.404-78.933 0l-.504-.44-20.015-19.96c-10.934-11.033-10.88-28.833.12-39.8C79.011-2.686 96.85-2.715 107.9 8.256l20.015 19.968 19.952-19.968A28.3 28.3 0 0 1 167.88 0a28.2 28.2 0 0 1 10.84 2.136z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M77.117 253.864a28.2 28.2 0 0 1-9.184-6.12 28.185 28.185 0 0 1 .064-39.864l20.015-19.96.504-.44c21.959-21.395 56.966-21.395 78.925 0l.504.44 20.015 19.96c10.932 11.035 10.875 28.835-.128 39.8-11.014 11.006-28.853 11.035-39.902.064l-20.016-19.968-19.95 19.96A28.3 28.3 0 0 1 87.947 256a28.2 28.2 0 0 1-10.831-2.136Z"
    }));

const Apolloio = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 128,
        height: 128,
        fill: "#FECF40",
        rx: 8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M91.044 36.135H78.489l6.51 11.134zm17.45 62.852L63.922 25 19.5 98.832h23.792c3.174 0 6.297-.8 9.058-2.316 2.98-1.638 5.23-4.012 6.989-6.89 2.056-3.367 4.053-6.773 6.077-10.16l5.178-8.67-6.678-11.167-2.961 4.755c-3.375 5.631-6.569 11.392-10.066 16.947-1.759 2.786-4.054 5.418-7.442 6.096a9.7 9.7 0 0 1-1.558.174c-.698.026-1.397.013-2.088.013l24.121-40.99 30.975 52.363z"
    }));

const AppleDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 814 1000",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2m-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3"
    }));

const AppleLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 814 1000",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76.5 0-103.7 40.8-165.9 40.8s-105.6-57-155.5-127C46.7 790.7 0 663 0 541.8c0-194.4 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2m-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3"
    }));

const AppleMusic = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 361 361",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 180,
        x2: 180,
        y1: 358.605,
        y2: 7.759,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#fa233b"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#fb5c74"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M360 112.61c0-4.3 0-8.6-.02-12.9-.02-3.62-.06-7.24-.16-10.86-.21-7.89-.68-15.84-2.08-23.64-1.42-7.92-3.75-15.29-7.41-22.49a75.63 75.63 0 0 0-33.06-33.05c-7.19-3.66-14.56-5.98-22.47-7.41C287 .86 279.04.39 271.15.18c-3.62-.1-7.24-.14-10.86-.16-4.3-.02-8.6-.02-12.9-.02H112.61c-4.3 0-8.6 0-12.9.02-3.62.02-7.24.06-10.86.16C80.96.4 73 .86 65.2 2.27c-7.92 1.42-15.28 3.75-22.47 7.41A75.63 75.63 0 0 0 9.67 42.73c-3.66 7.2-5.99 14.57-7.41 22.49C.86 73.02.39 80.98.18 88.86.08 92.48.04 96.1.02 99.72 0 104.01 0 108.31 0 112.61v134.77c0 4.3 0 8.6.02 12.9.02 3.62.06 7.24.16 10.86.21 7.89.68 15.84 2.08 23.64 1.42 7.92 3.75 15.29 7.41 22.49a75.63 75.63 0 0 0 33.06 33.05c7.19 3.66 14.56 5.98 22.47 7.41 7.8 1.4 15.76 1.87 23.65 2.08 3.62.1 7.24.14 10.86.16 4.3.03 8.6.02 12.9.02h134.77c4.3 0 8.6 0 12.9-.02 3.62-.02 7.24-.06 10.86-.16 7.89-.21 15.85-.68 23.65-2.08 7.92-1.42 15.28-3.75 22.47-7.41a75.63 75.63 0 0 0 33.06-33.05c3.66-7.2 5.99-14.57 7.41-22.49 1.4-7.8 1.87-15.76 2.08-23.64.1-3.62.14-7.24.16-10.86.03-4.3.02-8.6.02-12.9V112.61z",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "url(#prefix__a)"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M254.5 55c-.87.08-8.6 1.45-9.53 1.64l-107 21.59-.04.01c-2.79.59-4.98 1.58-6.67 3-2.04 1.71-3.17 4.13-3.6 6.95-.09.6-.24 1.82-.24 3.62v133.92c0 3.13-.25 6.17-2.37 8.76s-4.74 3.37-7.81 3.99l-6.99 1.41c-8.84 1.78-14.59 2.99-19.8 5.01-4.98 1.93-8.71 4.39-11.68 7.51-5.89 6.17-8.28 14.54-7.46 22.38.7 6.69 3.71 13.09 8.88 17.82 3.49 3.2 7.85 5.63 12.99 6.66 5.33 1.07 11.01.7 19.31-.98 4.42-.89 8.56-2.28 12.5-4.61 3.9-2.3 7.24-5.37 9.85-9.11 2.62-3.75 4.31-7.92 5.24-12.35.96-4.57 1.19-8.7 1.19-13.26V142.81c0-6.22 1.76-7.86 6.78-9.08 0 0 88.94-17.94 93.09-18.75 5.79-1.11 8.52.54 8.52 6.61v79.29c0 3.14-.03 6.32-2.17 8.92-2.12 2.59-4.74 3.37-7.81 3.99l-6.99 1.41c-8.84 1.78-14.59 2.99-19.8 5.01-4.98 1.93-8.71 4.39-11.68 7.51-5.89 6.17-8.49 14.54-7.67 22.38.7 6.69 3.92 13.09 9.09 17.82 3.49 3.2 7.85 5.56 12.99 6.6 5.33 1.07 11.01.69 19.31-.98 4.42-.89 8.56-2.22 12.5-4.55 3.9-2.3 7.24-5.37 9.85-9.11 2.62-3.75 4.31-7.92 5.24-12.35.96-4.57 1-8.7 1-13.26V64.46c.02-6.16-3.23-9.96-9.02-9.46",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#fff"
        }
    }));

const Appwrite = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 90 91",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#19191D",
        d: "M90 .839H0v90h90z"
    }), /*#__PURE__*/ React.createElement("g", {
        opacity: 0.9
    }, /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FD366E",
        fillOpacity: 0.8,
        d: "M153.6 91.037 5.806-31.793l99.144-29.674z"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__c)",
        opacity: 0.55
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FE9567",
        fillOpacity: 0.8,
        d: "M149.601 66.145 26.704-35.994l82.443-24.675z"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__d)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FD366E",
        fillOpacity: 0.8,
        d: "m99.172-30.774 29.725 93.182-78.146-1.212-12.157-73.84z"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__e)",
        opacity: 0.65
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FE9567",
        fillOpacity: 0.8,
        d: "m122.067 25.612-65.743-54.64 44.103-13.2z"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__f)",
        style: {
            mixBlendMode: "overlay"
        }
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: 51.664,
        cy: 4.998,
        fill: "#EDEDF0",
        fillOpacity: 0.4,
        rx: 51.664,
        ry: 4.998,
        transform: "scale(1 -1)rotate(-44.222 52.735 -69.976)"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__g)",
        style: {
            mixBlendMode: "overlay"
        }
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: 40.558,
        cy: 4.13,
        fill: "#EDEDF0",
        fillOpacity: 0.4,
        rx: 40.558,
        ry: 4.13,
        transform: "scale(1 -1)rotate(-44.222 36.043 -48.606)"
    }))), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__h)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M71.92 57.313v12.074H41.658c-8.817 0-16.515-4.856-20.634-12.075a24.3 24.3 0 0 1-3.132-10.442v-3.264a24 24 0 0 1 .842-4.954c2.827-10.136 12.02-17.563 22.924-17.563s20.095 7.427 22.922 17.563H51.64c-2.124-3.304-5.8-5.489-9.982-5.489s-7.859 2.185-9.983 5.489a12 12 0 0 0-1.479 3.293 12.2 12.2 0 0 0-.448 3.293c0 3.461 1.435 6.58 3.737 8.782a11.78 11.78 0 0 0 8.173 3.292H71.92Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FD366E",
        d: "M71.92 41.944V54.02H49.83a12.1 12.1 0 0 0 3.738-8.782 12.3 12.3 0 0 0-.448-3.293z"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__b",
        width: 310.336,
        height: 315.046,
        x: -75.465,
        y: -142.738,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_878_1918",
        stdDeviation: 40.636
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__c",
        width: 242.601,
        height: 246.518,
        x: -33.148,
        y: -120.521,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_878_1918",
        stdDeviation: 29.926
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__d",
        width: 315.887,
        height: 318.766,
        x: -74.198,
        y: -143.566,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_878_1918",
        stdDeviation: 56.396
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__e",
        width: 163.269,
        height: 165.364,
        x: 7.561,
        y: -90.99,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_878_1918",
        stdDeviation: 24.381
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__f",
        width: 131.272,
        height: 129.315,
        x: 38.621,
        y: -49.158,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_878_1918",
        stdDeviation: 14.222
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__g",
        width: 115.311,
        height: 113.776,
        x: 18.403,
        y: -42.926,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_878_1918",
        stdDeviation: 14.222
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__h",
        width: 65.309,
        height: 59.578,
        x: 12.252,
        y: 15.449,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", null), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 2.82
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_878_1918"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_878_1918",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: 30.605,
        x2: 102.512,
        y1: 21.004,
        y2: 98.87,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.36,
        stopColor: "#FD366E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FE9567"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M90 .839H0v90h90z"
    }))));

const Arc = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 219",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M123.632.012c13.836.398 26.332 8.52 32.32 21.089l23.761 49.984.382-.966a59 59 0 0 0 2.315-7.64l.332-1.548c4.004-20.02 23.463-32.977 43.52-29.016a36.98 36.98 0 0 1 29.018 43.526c-5.337 26.652-19.095 51.387-38.829 70.983l-.625.607 8.33 17.514c9.668 20.33-.349 44.903-21.4 51.799l-.95.297-.725.219a36.7 36.7 0 0 1-9.897 1.373 37.01 37.01 0 0 1-33.42-21.102l-6.43-13.518-1.622.402c-8.692 2.054-17.508 3.192-26.328 3.367l-2.405.024c-8.488 0-17.116-.987-25.736-2.9l-1.7-.396-6.177 12.987a36.97 36.97 0 0 1-20.713 18.852l-1.1.382a36.96 36.96 0 0 1-28.96-2.484c-17.56-9.334-24.256-31.186-15.688-49.235l7.67-16.129-.67-.65C17.39 137.46 9.054 125.67 3.524 112.996l-.737-1.733-.106-.281C-4.93 92.058 4.21 70.517 23.122 62.86c14.834-6.005 31.278-1.693 41.39 9.578l.19.218 24.446-51.422A36.86 36.86 0 0 1 121.535.01L122.57 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1A007F",
        d: "m87.118 170.045 21.896-46.068c-16.724-3.552-33.551-13.897-43.068-26.482L43.05 145.63c12.723 10.793 27.999 19.276 44.068 24.414"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4E000A",
        d: "M178.495 96.115c-11 13.483-26.275 23.483-42.62 27.379l21.827 45.93c15.931-5.38 30.827-14.069 43.69-25.206z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1A007F",
        d: "M43.05 145.631 31.602 169.7c-5.828 12.241-1.449 27.31 10.551 33.689 12.724 6.758 28.379 1.483 34.517-11.38l10.448-21.964A130.6 130.6 0 0 1 43.05 145.63"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9396",
        d: "M223.942 43.565a25.137 25.137 0 0 0-29.585 19.723c-2.414 12.07-8.069 23.31-15.862 32.862l22.862 48.137c21.103-18.31 36.688-43.24 42.275-71.137 2.724-13.655-6.104-26.896-19.69-29.585"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#002DC8",
        d: "M135.875 123.494c-4.896 1.172-9.896 1.793-14.896 1.793-3.896 0-7.93-.448-11.965-1.31-16.724-3.552-33.551-13.897-43.068-26.482-2.38-3.138-4.31-6.414-5.655-9.759-5.207-12.862-19.862-19.068-32.724-13.896C14.705 79.047 8.5 93.702 13.671 106.563c5.896 14.62 16.31 28.034 29.379 39.068a130.5 130.5 0 0 0 44.033 24.414c11.069 3.551 22.551 5.517 33.862 5.517 12.551 0 24.93-2.173 36.723-6.138z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF536A",
        d: "m213.425 169.596-12.068-25.378-22.862-48.103-.034.035s0-.035.034-.035l-33.24-69.93a25.14 25.14 0 0 0-22.69-14.344c-9.69 0-18.517 5.586-22.689 14.345L65.98 97.495c9.517 12.585 26.344 22.93 43.068 26.482l10.965-23.034c1.035-2.173 4.138-2.173 5.173 0l10.724 22.551h.069-.07l21.828 45.93 10.724 22.551a25.1 25.1 0 0 0 22.723 14.345c2.242 0 4.483-.31 6.69-.931 15.138-4.173 22.31-21.586 15.551-35.793"
    }));

const ArcDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M236.5.6C233.8.8 225.4 1.9 218 3 147 13.5 83.2 54.1 42.8 114.5c-40.7 60.9-53 138.1-33.3 209.8C26.1 385.1 66 438.4 121 473.4c9.8 6.2 34.9 18.5 47.3 23 13.7 5.1 34.1 10.2 50.9 12.7 20.4 3.2 53.2 3.2 73.6 0 28.2-4.3 50.2-11.2 75.7-23.6 24.8-12.1 45.1-26.4 64.9-45.5 59.9-58.1 87.9-139.8 75.7-221.5C498.5 147 458 83.3 397.5 42.8c-29.9-20-66.2-34-103-39.8-12.7-2-45.9-3.4-58-2.4M400.8 175c16.1 1.7 43.2 8.2 43.2 10.4 0 .9-12 38.8-12.4 39.3-.1.1-3.7-.9-7.9-2.2-20.3-6.2-46.9-7.7-67.5-3.6C293 231.3 245.1 283.7 238 348.1c-1.4 13-2.4 16.2-6.3 20.6-7.7 8.7-21.3 9.6-29.6 2-3.1-2.9-7.1-11.4-7.1-15.2 0-6.4-4.2-20.4-9-30q-15.15-30.3-48-41.7c-9-3-10.3-3.2-24-3.3-11.4 0-16.1.4-22 2-4.1 1.1-7.9 2-8.4 2s-3.7-8.8-7.2-19.5c-4.5-14-6-19.7-5.1-20.2 1.8-1.1 16-4.8 23-6 9.7-1.6 32-1.3 41.2.7 26.5 5.6 46.7 16.5 65.6 35.6l10.6 10.7 3.2-6.7c8.7-17.7 21.4-35.2 35.9-49.8 39.6-39.9 95.3-60.1 150-54.3"
    }));

const ArcDarkSoftware = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 114 46",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 23C0 10.298 10.262 0 22.92 0c12.656 0 22.919 10.298 22.919 23v22.343a.655.655 0 0 1-.656.657H33.397a.654.654 0 0 1-.655-.657V23c0-1.95-.576-3.855-1.655-5.477a9.83 9.83 0 0 0-4.409-3.63 9.79 9.79 0 0 0-10.705 2.137 9.87 9.87 0 0 0-2.688 5.047 9.9 9.9 0 0 0 .56 5.695 9.85 9.85 0 0 0 3.617 4.424 9.8 9.8 0 0 0 5.457 1.661h7.531c.363 0 .655.294.655.658v11.828a.656.656 0 0 1-.655.657h-7.53C10.261 46 0 35.702 0 23M82.02 4.2c.344-.292.317-.84-.07-1.068A22.75 22.75 0 0 0 70.394 0C57.738 0 47.476 10.298 47.476 23v22.343c0 .364.294.657.655.657h11.787a.655.655 0 0 0 .655-.657V23c0-1.632.402-3.238 1.173-4.675a9.85 9.85 0 0 1 3.242-3.557 9.8 9.8 0 0 1 9.279-.83.71.71 0 0 0 .938-.37A24.7 24.7 0 0 1 82.022 4.2zM97.898 0a22.8 22.8 0 0 1 15.909 6.444.643.643 0 0 1 0 .918l-8.327 8.359a.69.69 0 0 1-.955.005 9.79 9.79 0 0 0-10.39-1.831 9.83 9.83 0 0 0-4.284 3.451 9.88 9.88 0 0 0 3.499 14.393 9.79 9.79 0 0 0 10.51-.906.69.69 0 0 1 .906.046l8.361 8.392a.63.63 0 0 1 .192.471.63.63 0 0 1-.211.464A22.79 22.79 0 0 1 97.898 46c-12.658 0-22.92-10.298-22.92-23S85.24 0 97.898 0"
    }));

const ArcLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M236.5.6C233.8.8 225.4 1.9 218 3 147 13.5 83.2 54.1 42.8 114.5c-40.7 60.9-53 138.1-33.3 209.8C26.1 385.1 66 438.4 121 473.4c9.8 6.2 34.9 18.5 47.3 23 13.7 5.1 34.1 10.2 50.9 12.7 20.4 3.2 53.2 3.2 73.6 0 28.2-4.3 50.2-11.2 75.7-23.6 24.8-12.1 45.1-26.4 64.9-45.5 59.9-58.1 87.9-139.8 75.7-221.5C498.5 147 458 83.3 397.5 42.8c-29.9-20-66.2-34-103-39.8-12.7-2-45.9-3.4-58-2.4M400.8 175c16.1 1.7 43.2 8.2 43.2 10.4 0 .9-12 38.8-12.4 39.3-.1.1-3.7-.9-7.9-2.2-20.3-6.2-46.9-7.7-67.5-3.6C293 231.3 245.1 283.7 238 348.1c-1.4 13-2.4 16.2-6.3 20.6-7.7 8.7-21.3 9.6-29.6 2-3.1-2.9-7.1-11.4-7.1-15.2 0-6.4-4.2-20.4-9-30q-15.15-30.3-48-41.7c-9-3-10.3-3.2-24-3.3-11.4 0-16.1.4-22 2-4.1 1.1-7.9 2-8.4 2s-3.7-8.8-7.2-19.5c-4.5-14-6-19.7-5.1-20.2 1.8-1.1 16-4.8 23-6 9.7-1.6 32-1.3 41.2.7 26.5 5.6 46.7 16.5 65.6 35.6l10.6 10.7 3.2-6.7c8.7-17.7 21.4-35.2 35.9-49.8 39.6-39.9 95.3-60.1 150-54.3"
    }));

const ArcLightSoftware = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 62 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M0 12C0 5.373 5.58 0 12.465 0S24.93 5.373 24.93 12v11.657a.35.35 0 0 1-.356.343h-6.41a.35.35 0 0 1-.357-.343V12c0-2.84-2.392-5.143-5.342-5.143S7.123 9.16 7.123 12s2.392 5.143 5.342 5.143h4.096a.35.35 0 0 1 .356.343v6.171a.35.35 0 0 1-.357.343h-4.095C5.58 24 0 18.627 0 12m44.608-9.809a.335.335 0 0 0-.04-.557A12.8 12.8 0 0 0 38.286 0C31.4 0 25.82 5.373 25.82 12v11.657c0 .19.16.343.356.343h6.41a.35.35 0 0 0 .357-.343V12c0-2.84 2.392-5.143 5.342-5.143.748 0 1.46.148 2.106.415a.393.393 0 0 0 .51-.193c.82-1.903 2.1-3.575 3.707-4.888M53.243 0c3.36 0 6.41 1.28 8.652 3.362.14.13.139.346.001.479l-4.53 4.361a.386.386 0 0 1-.518.003 5.44 5.44 0 0 0-3.605-1.348C50.293 6.857 47.9 9.16 47.9 12s2.391 5.143 5.342 5.143c1.22 0 2.344-.394 3.243-1.056a.385.385 0 0 1 .492.024l4.548 4.378a.327.327 0 0 1-.011.488C59.314 22.857 56.417 24 53.243 24c-6.884 0-12.465-5.373-12.465-12s5.58-12 12.465-12",
        clipRule: "evenodd"
    }));

const Asana = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 251 232",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F06A6A",
        d: "M179.383 54.373c0 30.017-24.337 54.374-54.354 54.374-30.035 0-54.373-24.338-54.373-54.374S94.993 0 125.029 0c30.017 0 54.354 24.338 54.354 54.373M54.393 122.33C24.376 122.33.02 146.668.02 176.685s24.337 54.373 54.373 54.373 54.373-24.338 54.373-54.373c0-30.017-24.338-54.355-54.373-54.355m141.253 0c-30.035 0-54.373 24.338-54.373 54.374 0 30.035 24.338 54.373 54.373 54.373 30.017 0 54.374-24.338 54.374-54.373 0-30.036-24.338-54.374-54.374-54.374"
    }));

const AstroDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 366",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M182.022 9.147c2.982 3.702 4.502 8.697 7.543 18.687L256 246.074a276.5 276.5 0 0 0-79.426-26.891L133.318 73.008a5.63 5.63 0 0 0-10.802.017L79.784 219.11A276.5 276.5 0 0 0 0 246.04L66.76 27.783c3.051-9.972 4.577-14.959 7.559-18.654a24.54 24.54 0 0 1 9.946-7.358C88.67 0 93.885 0 104.314 0h47.683c10.443 0 15.664 0 20.074 1.774a24.55 24.55 0 0 1 9.95 7.373Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF5D01",
        d: "M189.972 256.46c-10.952 9.364-32.812 15.751-57.992 15.751-30.904 0-56.807-9.621-63.68-22.56-2.458 7.415-3.009 15.903-3.009 21.324 0 0-1.619 26.623 16.898 45.14 0-9.615 7.795-17.41 17.41-17.41 16.48 0 16.46 14.378 16.446 26.043l-.001 1.041c0 17.705 10.82 32.883 26.21 39.28a35.7 35.7 0 0 1-3.588-15.647c0-16.886 9.913-23.173 21.435-30.48 9.167-5.814 19.353-12.274 26.372-25.232a47.6 47.6 0 0 0 5.742-22.735c0-5.06-.786-9.938-2.243-14.516Z"
    }));

const AstroLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 366",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M182.022 9.147c2.982 3.702 4.502 8.697 7.543 18.687L256 246.074a276.5 276.5 0 0 0-79.426-26.891L133.318 73.008a5.63 5.63 0 0 0-10.802.017L79.784 219.11A276.5 276.5 0 0 0 0 246.04L66.76 27.783c3.051-9.972 4.577-14.959 7.559-18.654a24.54 24.54 0 0 1 9.946-7.358C88.67 0 93.885 0 104.314 0h47.683c10.443 0 15.664 0 20.074 1.774a24.55 24.55 0 0 1 9.95 7.373Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF5D01",
        d: "M189.972 256.46c-10.952 9.364-32.812 15.751-57.992 15.751-30.904 0-56.807-9.621-63.68-22.56-2.458 7.415-3.009 15.903-3.009 21.324 0 0-1.619 26.623 16.898 45.14 0-9.615 7.795-17.41 17.41-17.41 16.48 0 16.46 14.378 16.446 26.043l-.001 1.041c0 17.705 10.82 32.883 26.21 39.28a35.7 35.7 0 0 1-3.588-15.647c0-16.886 9.913-23.173 21.435-30.48 9.167-5.814 19.353-12.274 26.372-25.232a47.6 47.6 0 0 0 5.742-22.735c0-5.06-.786-9.938-2.243-14.516Z"
    }));

const Atlassian = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "99.7%",
        x2: "39.8%",
        y1: "15.8%",
        y2: "97.4%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0052CC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "92.3%",
        stopColor: "#2684FF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M76 118c-4-4-10-4-13 1L1 245a7 7 0 0 0 6 10h88c3 0 5-1 6-4 19-39 8-98-25-133"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2681FF",
        d: "M122 4c-35 56-33 117-10 163l42 84c1 3 4 4 7 4h87a7 7 0 0 0 7-10L134 4c-2-5-9-5-12 0"
    }));

const Atom = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 128.002,
        cy: 128.002,
        r: 128.002,
        fill: "#60B57D"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M117.82 59.143a3.605 3.605 0 0 1-4.515 5.62c-9.397-7.547-17.224-10.04-22.051-7.575-5.618 2.865-7.797 12.083-6.663 24.946l.17 1.737q.144 1.319.33 2.682l.269 1.839q.5 3.227 1.235 6.67c6.767-1.05 14.05-1.735 21.698-2.02a198 198 0 0 1 10.079-11.969l1.698-1.83c4.246-4.513 8.505-8.553 12.696-12.049l1.673-1.37c15.295-12.285 29.531-17.146 38.738-11.168 8.02 5.203 10.17 16.989 7.19 32.783a3.605 3.605 0 1 1-7.084-1.336c2.495-13.227.852-22.232-4.03-25.4-6.348-4.12-18.142.623-31.44 11.701l-1.484 1.257a127 127 0 0 0-2.246 1.982l-1.51 1.383a150 150 0 0 0-4.571 4.446l-1.535 1.577q-.384.4-.769.805l-1.54 1.647-1.54 1.691-1.541 1.736q-.771.879-1.54 1.78l-1.54 1.822-.299.363c3.586.019 7.235.123 10.932.315l1.435.08 2.852.182q3.551.25 7.017.599l2.758.295q.685.078 1.368.159l2.711.341q3.371.445 6.635.984l2.592.444 2.555.473 2.515.501c8.32 1.716 15.97 3.888 22.71 6.434l1.996.775c17.704 7.074 28.614 16.812 28.054 27.576-.464 8.898-8.44 16.244-21.81 21.507a3.605 3.605 0 1 1-2.64-6.708c11.024-4.34 16.971-9.817 17.25-15.174.358-6.858-7.848-13.951-21.507-19.672l-1.7-.694a109 109 0 0 0-3.557-1.343l-1.856-.649q-.94-.32-1.904-.632l-1.954-.615-2-.598q-.505-.147-1.017-.292l-2.068-.57q-.522-.14-1.05-.278l-2.133-.54a175 175 0 0 0-6.645-1.498l-2.293-.456-1.16-.22-2.348-.42-2.382-.398-1.204-.19-2.432-.36a201 201 0 0 0-2.463-.334l-2.495-.309-2.523-.282a217 217 0 0 0-3.837-.37l-2.59-.213a218 218 0 0 0-2.616-.182l-2.639-.154-2.64-.121-2.62-.09a217 217 0 0 0-8.993-.068l-2.06.038-.81 1.074a214 214 0 0 0-1.505 2.045l-1.496 2.082a221 221 0 0 0-6.566 9.801l-1.388 2.224a217 217 0 0 0-4.232 7.177q.184.453.375.908l.98 2.314q.249.58.504 1.162l1.036 2.331 1.074 2.342 1.112 2.349 1.15 2.356 1.186 2.362 1.215 2.348 1.233 2.314 1.249 2.28.63 1.126 1.272 2.227q.64 1.104 1.285 2.19l1.298 2.152q.652 1.065 1.31 2.113l1.32 2.075 1.329 2.034a192 192 0 0 0 3.356 4.904l1.353 1.886a175 175 0 0 0 2.717 3.64l1.362 1.75 1.363 1.705q.341.42.682.834l1.362 1.632 1.36 1.583a129 129 0 0 0 4.06 4.446l1.342 1.377 1.334 1.324a99 99 0 0 0 1.985 1.884l1.31 1.186a82 82 0 0 0 1.945 1.673l1.28 1.042c8.703 6.925 16.414 9.722 21.534 7.11 4.807-2.45 7.102-9.608 6.932-19.757l-.043-1.545a73 73 0 0 0-.081-1.588l-.118-1.63a86 86 0 0 0-.154-1.672l-.192-1.712-.109-.87-.246-1.769-.284-1.805-.32-1.84a128 128 0 0 0-.959-4.747l-.448-1.954-.484-1.983q-.126-.5-.256-1.002l-.539-2.025-.575-2.052-.302-1.035-.63-2.088-.666-2.111a182 182 0 0 0-1.067-3.208l-.757-2.163-.793-2.182a200 200 0 0 0-1.694-4.415l-.902-2.23-.937-2.243-.482-1.126-.991-2.261-1.028-2.272q-.261-.569-.527-1.139l-1.08-2.284-.555-1.145a3.605 3.605 0 1 1 6.48-3.159l1.196 2.49q.588 1.243 1.156 2.482l1.118 2.474a220 220 0 0 1 3.112 7.356l.957 2.426q.235.605.464 1.208l.896 2.403q.219.598.433 1.195l.835 2.376a185 185 0 0 1 1.545 4.694l.71 2.315c8.5 28.409 7.41 51.515-5.34 58.016-10.313 5.26-24.936-2.046-39.655-17.456l-1.523-1.622a138 138 0 0 1-3.044-3.415l-1.518-1.79c-4.046-4.844-8.055-10.257-11.938-16.147l-1.45-2.231a226 226 0 0 1-10.398-18.043l-.657-1.279a239 239 0 0 1-1.288-2.564l-1.247-2.559a230 230 0 0 1-2.826-6.112l-.582 1.151q-.27.54-.533 1.08l-1.038 2.147-.997 2.132-.958 2.114q-.234.527-.463 1.051l-.896 2.087q-.219.518-.433 1.035l-.836 2.056q-.204.51-.402 1.019l-.774 2.02a124 124 0 0 0-.37 1.002l-.712 1.983-.67 1.956q-.487 1.456-.926 2.88l-.565 1.883-.522 1.851q-.125.459-.245.913l-.458 1.8a92 92 0 0 0-.956 4.344l-.307 1.67c-2.04 11.83-.71 20.554 4.345 23.835 5.092 3.303 14.533.79 26.183-7.62a3.605 3.605 0 1 1 4.22 5.845c-13.807 9.968-26.013 13.216-34.327 7.822-10.046-6.519-10.752-23.757-4.066-45.202l.694-2.158q.717-2.172 1.532-4.395l.838-2.233a173 173 0 0 1 3.825-9.143l1.072-2.33 1.117-2.346a208 208 0 0 1 4.582-8.897 266 266 0 0 1-.641-1.653l-.933-2.475a189 189 0 0 1-3.296-9.713l-.714-2.374a163 163 0 0 1-1.24-4.466q-.667.134-1.322.272l-1.96.431-1.913.453q-.472.116-.938.234l-1.84.483-1.787.504q-.882.257-1.736.523l-1.683.542q-.828.276-1.628.561l-1.572.579c-10.803 4.113-17.383 9.51-17.69 15.388-.279 5.358 5.068 11.423 15.584 16.883a3.605 3.605 0 1 1-3.322 6.398C46.567 140.033 39.395 131.898 39.86 123c.645-12.406 16.305-21.875 39.597-26.656-4.714-22.525-2.315-40.051 8.52-45.577 8.009-4.088 18.472-.757 29.842 8.377Zm19.753 67.051c1.196 5.536-2.322 10.99-7.857 12.188-5.536 1.196-10.99-2.322-12.188-7.858-1.194-5.535 2.322-10.989 7.858-12.187 5.535-1.196 10.989 2.322 12.187 7.857m-34.898-25.606-.65.045q-.746.053-1.484.113l-2.345.202-2.31.228q-.573.06-1.141.124l-2.256.267-1.113.143-2.198.304-.872.133.308 1.151a167 167 0 0 0 1.568 5.342l.694 2.18.362 1.1.752 2.213q.31.895.633 1.798a239 239 0 0 1 3.54-5.705l.78-1.208a235 235 0 0 1 5.732-8.43"
    }));

const Auth0 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#EB5424",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21.98 7.448 19.62 0H4.347L2.02 7.448c-1.352 4.312.03 9.206 3.815 12.015L12.007 24l6.157-4.552c3.755-2.81 5.182-7.688 3.815-12.015l-6.16 4.58 2.343 7.45-6.157-4.597-6.158 4.58 2.358-7.433-6.188-4.55 7.63-.045L12.008 0l2.356 7.404 7.615.044z"
    }));

const Authy = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F22E46",
        d: "M256 127.998C256 198.696 198.694 256 127.997 256 57.304 256 0 198.696 0 127.998 0 57.305 57.304 0 127.997 0 198.694 0 256 57.305 256 127.998"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m117.024 100.89 30.691 30.68c4.43 4.436 11.623 4.436 16.064 0 4.431-4.435 4.441-11.622 0-16.058L133.086 84.82C111.125 62.854 75.631 62.5 53.204 83.704a10 10 0 0 0-.605.548c-.098.098-.178.202-.275.29-.1.096-.202.182-.297.278-.194.193-.371.396-.54.597-21.215 22.437-20.85 57.932 1.113 79.897L83.292 196c4.44 4.433 11.623 4.433 16.062 0 4.442-4.437 4.442-11.633.011-16.06l-30.693-30.691c-13.398-13.393-13.488-35.129-.278-48.637 13.506-13.21 35.23-13.114 48.63.279"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F5B1B2",
        d: "M156.636 60.017c-4.435 4.437-4.435 11.623.012 16.059l30.681 30.693c13.39 13.392 13.477 35.125.268 48.636-13.51 13.2-35.227 13.112-48.623-.282l-30.692-30.689c-4.438-4.437-11.633-4.437-16.066 0-4.443 4.433-4.443 11.642 0 16.065l30.682 30.694c21.968 21.965 57.458 22.322 79.889 1.116.208-.184.404-.355.61-.549.094-.095.182-.192.273-.29.1-.095.197-.183.29-.289.197-.183.365-.384.54-.594 21.215-22.428 20.86-57.911-1.102-79.889l-30.692-30.682c-4.436-4.443-11.638-4.443-16.07.001"
    }));

const AxiomDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 358 309",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M354.75 215.609 278.412 87.847c-3.501-5.871-12.127-10.676-19.17-10.676h-47.659c-11.077 0-15.618-7.547-10.093-16.772l26.136-43.627a10.82 10.82 0 0 0-.011-11.183C225.534 2.13 221.691 0 217.533 0h-66.485c-7.044 0-15.688 4.793-19.212 10.652L2.645 225.448c-3.525 5.859-3.526 15.447-.006 21.307l33.243 55.325c5.539 9.217 14.622 9.228 20.184.023l25.974-42.98c5.564-9.205 14.645-9.195 20.185.023l23.548 39.192c3.521 5.86 12.164 10.654 19.207 10.654h153.633c7.04 0 15.685-4.794 19.206-10.654l36.892-61.397c3.521-5.86 3.538-15.459.039-21.332m-103.096-6.149c5.505 9.236.945 16.794-10.132 16.794H122.021c-11.077 0-15.609-7.542-10.07-16.76l59.796-99.517c5.539-9.218 14.602-9.217 20.141.001z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h358v309H0z"
    }))));

const AxiomLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 358 309",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M354.75 215.609 278.412 87.847c-3.501-5.871-12.127-10.676-19.17-10.676h-47.659c-11.077 0-15.618-7.547-10.093-16.772l26.136-43.627a10.82 10.82 0 0 0-.011-11.183C225.534 2.13 221.691 0 217.533 0h-66.485c-7.044 0-15.688 4.793-19.212 10.652L2.645 225.448c-3.525 5.859-3.526 15.447-.006 21.307l33.243 55.325c5.539 9.217 14.622 9.228 20.184.023l25.974-42.98c5.564-9.205 14.645-9.195 20.185.023l23.548 39.192c3.521 5.86 12.164 10.654 19.207 10.654h153.633c7.04 0 15.685-4.794 19.206-10.654l36.892-61.397c3.521-5.86 3.538-15.459.039-21.332m-103.096-6.149c5.505 9.236.945 16.794-10.132 16.794H122.021c-11.077 0-15.609-7.542-10.07-16.76l59.796-99.517c5.539-9.218 14.602-9.217 20.141.001z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h358v309H0z"
    }))));

const Axure = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "21.705 19.44 335.589 80.057",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#272727",
        d: "M326.63 19.441c-13.71 0-21.455 2.647-25.902 8.85-4.646 6.479-5.58 16.706-5.58 31.11 0 28.276 4.375 40.096 31.482 40.096 3.256 0 14.385-.062 20.882-.855 2.528-.419 3.66-2.355 3.66-4.087v-3.123c0-2.43-1.836-4.264-4.273-4.264h-20.27c-15.294 0-18.052-3.605-18.444-24.101v-6.635c.13-20.974 2.888-24.662 18.445-24.662 14.345 0 17.096 3.273 17.573 21.738h-22.794v12.466h29.98c5.905 0 5.905-4.13 5.905-5.486v-3.98c-.428-28.753-7.307-37.067-30.664-37.067m-39.476 1.099-.326-.086c-2.792-.587-10.422-1.013-14.205-1.013-13.387 0-20.462 5.605-20.462 16.209v59.04c0 2.43 1.7 4.128 4.137 4.128h4.762c2.437 0 4.138-1.697 4.138-4.128V36.734c0-2.617.662-4.964 8.65-4.964l11.828-.01c1.158.138 2.263-.182 3.114-.903.929-.783 1.44-1.926 1.44-3.215v-2.987c0-1.96-1.122-3.46-3.076-4.115m-57.172-.148h-4.762c-2.436 0-4.138 1.697-4.138 4.128v62.649h-19.804c-12.25 0-17.22-.779-17.22-20.303V24.52c0-2.43-1.702-4.128-4.138-4.128h-4.627c-2.436 0-4.273 1.774-4.273 4.128v42.346c0 27.748 10.064 32.631 31.21 32.631 7.607 0 18.025 0 27.96-1.399l.23-.046c2.454-.613 3.699-2.018 3.699-4.176V24.52c0-2.43-1.702-4.128-4.137-4.128"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#74bb11",
        d: "M156.332 22.331c-.611-1.3-1.922-2.075-3.506-2.075h-6.121c-1.778 0-3.107.716-3.807 2.005l-9.072 13.255 7.942 10.861 13.866-19.89c1.522-1.849.995-3.523.698-4.156"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#009cd9",
        d: "m108.505 22.11-.008-.012c-1.383-1.843-3.223-1.843-3.828-1.843h-5.987c-1.534 0-2.79.705-3.446 1.932-.675 1.257-.532 2.767.402 4.166l22.179 30.746-25.504 35.572c-.891 1.338-1.016 2.825-.343 4.081.66 1.227 1.917 1.93 3.448 1.93h6.12c1.574 0 2.958-.817 3.65-2.104l28.547-39.337z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#eb2084",
        d: "m159.377 92.982-17.794-24.42-7.827 10.79 14.072 18.781.366.16a4.4 4.4 0 0 0 1.775.388h5.985c1.446 0 2.673-.642 3.368-1.764.712-1.15.732-2.583.055-3.935"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#272727",
        d: "M68.774 65.43v20.738c-6.06.93-15.297 1.136-18.445 1.136-13.926 0-15.452-3.805-15.452-11.886 0-7.562 2.83-9.989 11.643-9.989zM49.649 19.44c-4.303 0-10.171.112-17.472.99l-.33.073c-2.127.605-3.204 2.002-3.204 4.152v2.986c0 2.546 1.585 4.128 4.137 4.128h16.87c13.583 0 19.124 3.68 19.124 12.701v8.767H46.52c-17.393 0-24.815 6.633-24.815 22.18 0 17.328 7.682 24.08 27.4 24.08 7.987 0 22.689-.621 28.123-2.278 4.582-1.272 4.582-4.772 4.582-5.922v-47.64c0-16.295-10.52-24.217-32.16-24.217z"
    })));

const BNB = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__a",
        width: "111.7%",
        height: "111.7%",
        x: "-5.8%",
        y: "-4.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in: "shadowBlurOuter1",
        in2: "SourceAlpha",
        operator: "out",
        result: "shadowBlurOuter1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__d",
        width: "117.5%",
        height: "117.5%",
        x: "-8.8%",
        y: "-6.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.204257246 0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0.5
    })), /*#__PURE__*/ React.createElement("circle", {
        id: "prefix__b",
        cx: 16,
        cy: 15,
        r: 15
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__e",
        d: "M12.116 13.404 16 9.52l3.886 3.886 2.26-2.26L16 5l-6.144 6.144zM6 15l2.26-2.26L10.52 15l-2.26 2.26zm6.116 1.596L16 20.48l3.886-3.886 2.26 2.259L16 25l-6.144-6.144-.003-.003zM21.48 15l2.26-2.26L26 15l-2.26 2.26zm-3.188-.002h.002v.002L16 17.295l-2.291-2.292-.004-.003.004-.003.401-.402.195-.195L16 12.706l2.293 2.293"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#000",
        filter: "url(#prefix__a)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#F3BA2F",
        fillRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "url(#prefix__c)",
        fillRule: "evenodd",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 16,
        cy: 15,
        r: 14.5,
        stroke: "#000",
        strokeOpacity: 0.097
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#000",
        filter: "url(#prefix__d)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#FFF",
        fillRule: "evenodd"
    })));

const Babel = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1349 519",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F9DC3E",
        d: "m955 115 1 1h3l1-5-1-2zm-31-76v-3h-5v3zm-92 172c0-3-8-14-25-32 0-4 5-9 17-15l33-29c8-10 12-25 14-47l-1-5c-1-14-12-26-32-35-12-9-34-13-65-14-26 2-59 12-101 28q-16.5 12-39 24v3l4-2c2 0 3 1 3 2l3-1h1v1c0 1-9 9-27 21l1 3h-1l-3-1-4 2v1l3 3-4-1c-4 1-8 3-12 7l1-7c6-27 11-50 13-70v-1c-5-3-9-7-13-12v-6h-1a1864 1864 0 0 1-137 180c-4 2-5 4-4 6l-2-1c-5 8-12 14-22 16l-11 2-2 3 1 2 3-1 1 1-9 3-16 4h-8c-1 2 7 0 4 1l-11 2c-6 2-9 1-10-1h-1l-9 2c0-4-11-18-33-41 0-5 7-12 23-20l44-39c9-12 15-33 17-60v-7c-2-20-16-35-43-48-16-10-44-16-85-17-34 3-79 15-133 36-15 11-32 22-52 33l1 3 5-2q3 0 3 3l4-2h2v1c0 2-12 11-36 28l2 3h-2l-4-1c0 1-1 2-5 2v2l4 4-5-1c-8 1-15 7-23 17l2 3 11-9 1 5-5 2 4 6c8-8 16-16 26-22 5 1 7 3 7 5l4-1c26-19 51-33 76-41l1 3c-5 7-8 11-10 11 0 2 1 5 3 6Q99 298 0 472l2 5c9-2 14-4 17-6h2v3h3l4-2c0 1 1 2 3 1v4c1 3-1 8-5 15-4 4-8 13-12 26v1h4c14-16 25-32 32-47 42-13 74-25 97-37 22-1 39-7 51-17l-1-2-8 3h-2v-2c16-2 28-6 34-11 32-25 56-42 72-52 34-25 55-49 65-72l6-2h8l1-2h9l12-3 2-1-1 1h5l1 3-57 91-13 16-6 21h1l6-3-2 8 1 3 1 2v3l2-1c4-3 6-6 5-9l8 1 1 1c-3 1-4 3-4 6v1h1c21-23 72-100 113-153-1-6 20-14 64-24h2c1 7-2 23-11 50-5 16-8 25-7 26-7 21-11 33-10 35l-16 51c-10 26-18 54-23 83h4l3-2 1 1-1-4h7c2 0 4-3 5-7 0-7 1-11 4-12l8-25c4-16 7-25 9-28 6-21 10-32 13-32v2l-4 11c-7 34-15 60-23 79l3 10 1-1c19-40 45-119 80-237q1.5-16.5 15-24l-2-2v-2c4 0 7-2 8-4l-10-4 17-75 7-5v4l-4 1 4 5 19-17c4 1 6 3 6 4h2c20-15 40-25 59-32v3l-7 8 1 5c-34 95-77 188-127 276l2 3c7-1 11-3 13-5h1v3h3l2-2 3 1v3c0 2-1 6-4 11-3 3-6 10-9 20v1h2c11-12 20-24 25-36 32-9 57-19 73-28 17-1 30-5 39-13v-1l-6 2h-2v-1c12-2 21-5 26-9 24-18 42-32 55-39q57-43.5 54-81m-6 1v10l-3 4-2-17zM68 131h-1l-1-3 7-1v2zM35 468c-4-2-8-3-11-2v-5c-1-2 0-3 3-4 2 0 3 1 4 5l9-11 4 1c-1 10-4 15-9 16M395 91c-2 0-5-5-10-15l-1-4c4 0 7 5 10 16zm-5-37-1 3-49-20c32 1 49 7 50 17M183 231l-7 1v-3l7-1zm-5-106h1l1 4c-2 1-4 3-6 8l-1-4c3-4 5-6 5-8m-15 34 1 6h-2v-6zm-7 12h3c0 5-2 8-5 8h-1zm-6 17h2v1l-3 6h-3l-1-2c4 0 5-2 5-5m-6 15-1 9h-1l-1-8zM88 363c-2 11-4 17-7 17v-2c-1-5 2-10 7-15m-10 22v2q0 3-3 3v-1c0-2 1-3 3-4m-3 46h5v2l-5 2h-3c0-2 1-3 3-4m148-45c-29 14-46 24-51 29-32 11-48 18-47 21-29 11-47 19-56 24l-9-2c-1-6 2-11 8-14 4-1 9 0 14 2q7.5-4.5 27-9l-1-3H98l30-14h5v1c-8 1-13 4-14 9 0 2 1 3 3 2l10-7c13-2 48-21 105-55l1 3c0 1-5 6-15 13m-88 29c8-1 15-4 21-10 3 0 4 0 4 3-4 0-12 3-23 10h-2zm142-110-44 35c-33 22-50 33-53 33-52 29-85 44-97 45h-2c1-6 25-54 70-143 19-2 51-11 93-28l10-1c22-1 38 3 49 13v6c-8 23-16 37-26 41zm-86-48 7-1v2l-7 1zm100-17h5c5 2 7 4 7 6v1c-4 1-9-2-12-7m14-80c-5 5-18 15-38 28-7 1-32 10-76 30l-7-2v-3c-1-6 2-14 8-24 4-18 7-28 11-30l37-82c-1-6 7-9 23-12l5-1 1 5 29-4c29-3 44 3 45 17h4l-1-8h4c8 4 13 10 13 17 1 4-2 10-7 17-2 0-3-2-4-5h-3l-1 10c-15 22-26 34-32 34-6 9-10 13-11 13m22 57c-3-2-5-3-7-2l-1-5 4-1 7 5q0 3-3 3m23 28 6 4h-2l-1 1-2 1zm2 14v-2l4-1 1 2zm11 11 14-3v1l-15 4zm14 6-15 2v-1l13-4 6-1v2zm14-3c-2 0-3 0-4-2l4-1c2 0 3 0 4 2zm36-39v-2l7-1v2l-6 1zm40 239v-4h1c2 0 3 0 3 2l1 1zm27-229-3-1-11 4-3 1c-1 0-2 0-3-2l18-4 6-3 2 2zm14-5v-1l3-2 13-3 1 1zm2-26-3 2h-6c0-2 9-6 29-10l3-1v2zm35-38c-1 16-7 25-17 27v-1l-9 4h-9l-1-3c0-1 12-19 38-53l3 1c1 4 0 13-5 25m62-53h-1v-2l5-1v2zm-25 256c-3-1-6-2-8-1l-1-4c0-2 1-2 3-3l3 4 7-9 2 1q-1.5 12-6 12M855 92c-1 0-4-4-8-12v-2c2 0 5 4 8 12zm-4-28-1 2-37-15c25 1 38 5 38 13M694 199h-5v-2l5-1zm-4-81 2-1v4c-2 0-3 2-5 6v-3zm-11 26 1 4-2 1v-5zm-6 9h3q0 6-3 6h-2c2-2 2-5 2-6m-4 13h1v1l-2 4h-2l-1-1c3 0 4-2 4-4m-4 11-1 7h-1l-1-6zm-43 122c-2 8-3 12-5 13v-2c-1-4 1-8 5-11m-8 17v1c1 1 0 2-2 3v-2l2-3zm-2 35 4-1v2l-4 1h-2c0-1 0-2 2-2m112-35c-22 11-35 18-39 22-24 9-36 14-36 16-21 8-35 14-41 18-2 0-4 0-7-2-1-4 1-7 5-10 4 0 8 0 11 2 4-2 11-5 21-7v-3l-8 1c1-1 8-5 23-11h4v1c-7 1-11 3-12 6q0 3 3 3l7-6c10-2 37-16 80-42l1 2c0 1-4 5-12 10m-67 22c7-1 12-3 17-7 2-1 3 0 3 2-3 0-9 2-18 7h-1zm109-83-34 27c-25 16-38 24-40 24-40 22-64 33-74 34h-1c1-4 18-40 53-108 15-1 38-8 71-21l8-1c16-1 28 2 36 10l1 5c-7 17-13 27-20 30m-66-37h5l1 1h-6zm76-13h4c4 2 6 3 6 5v1c-4 0-7-2-10-6m10-61c-3 4-13 12-28 22-5 0-24 8-58 22l-5-1v-2c-1-5 2-11 6-18q4.5-21 9-24l28-62c-1-4 5-7 17-9h4v3l23-3c22-2 33 3 34 13h3l-1-6h3c6 4 10 8 10 13 0 3-2 8-5 13-2 0-3-1-3-4h-3l-1 8c-11 17-19 26-24 26q-6 9-9 9m12 42v-4h2l6 3c0 2-1 3-2 3zM333 429h-3l-2 2c0 2 1 2 3 2s2-1 2-3zm-10-20v1c2 0 2-1 2-3v-1c-2 0-3 1-2 3m71-133 1-1h-1l-1 1zm-1-34 3-1v-3l-3 1zm707 101-7-1-1 2v2l40-4v-2zm207-26v3l4 1v-3zm-6 1c-31 7-35 5-41 6v2h4l3-2c30-3 34-2 34-5zm-183-44-3-1-3 10v1c2 0 4-3 6-10m-37-20v-1h-1l-3 1 2 3c2 0 3-1 2-3m80 82v-2h-1v2zm165-37h2l1-3-1-2c-7 0-10 1-15 4l-1-2-8 1c0-2-1-4-2-3h-4c-5 0-8 0-10 2l-1-1h-5l-3 2v-2l-2 2v-1l-7-1h-2l1 3 3 1 3-1 4 1 3-1v1c-16 4-16 3-27 5l-2-1c-2 0-2-1-2-2l5-1 4 1 7-3v-3c-16 3-9 1-29 3h-1v-2l25-4 1 1 3-1 2-1c9 0 12 1 29-3v1l3-2h2c0-2 4-3 5-3v-3c-30 7-38 5-46 7v-1c-8 2-9 1-11 1l-2 2-1-2h-1l-25 5-1-1c-14 2-10 3-28 5l-3 1-1-1-11 1-8 2-1-1-11 2c-2 0 1-1 0-1l-3 1h-12l-19 3-8-1c1 1 0 1-1 1-8-1-12-2-12-4 1-7 3-11 6-12h1l-1 3h1l4-4v-3h-3v-2l1-5 6-10v3h3l-1-3-1-2 5-3v-1h-4v-4l11-27 2 1q3 0 3-3h-3v-1l1-5c4-5 6-9 6-14l1 2c14-27 26-54 35-83 22-60 21-66 24-80h-3l-1 5-4-1v-1q0-7.5 6-18h2l2 8h2l2-10c0-2-1-2-3-3l-2 2V15h-1l-4-5-14 1-2-4c0-2 4-3 10-4l3 1 3-2c0 1 0 2 1 1l3-1 2 1h1V0h-16l-3 2V0l-114 10h-14l-3 1-3-1-10 3-11-1-6 2h16l-21 5-3-1-47 7-6-1-13 2-22 10 1 3 5-2 8 1-1 7c-7 3-12 8-13 14-11 5-16 9-16 11v1h1l3-1 4 4v6c1 1-18 41-56 117l-51 122c-11 3-17 8-19 14 0 2 4 3 10 4v2l-3 5 1 6c0 3 8 5 24 7l2-2-3 21h1c7-9 10-15 10-18l1-1c2 0 3 2 5 6q-3 1.5-21 48l2 3 2-1c15-37 24-57 28-61l100-10 3-2 1 1h4l3-2c0 1 0 2 1 1l36-3c10 0 14-3 14-8 0-2 5-3 17-5l5 1c-1-1 5-2 17-3 0-6 2-9 5-9v-3l-11 3-14-2-5 2h-25l-3 2-2-1h-1l-3 2-8-3-4 2-6 1v-2c32-3 48-8 48-13q3 0 3 3l10-3-1-2-77 2-1 1h-10c-2 0-4 0-6 2l-3-2c-10 1-17 2-22 4h-22l-17 2-8-1c10-37 26-72 46-104l5 1 12-4 7 1c10-1 23-4 37-9l8 1 9-2 28-3c12-1 25-3 39-8v-3c-6 1-8 0-8-2-1-4-5-6-12-5v-3l8-2 20-2-1-3h-12v-3l7-1c3 0 3-1 3-3l-16-1c-38 5-76 6-114 4l-2-3c19-42 31-62 34-63l-3 8 1 1h3c7-19 14-28 19-28 23-2-3-4 46-12l5 2 80-13v-3l-18 2v-3l5-2v2l4-2c4-1 6 0 8 1l15-3 12-2 4-4-1-2h-10c0-2 1-3 3-4l21-2 10-2 2 1 4-2 1 1-4 11-3 1-1-6-2 1c-26 72-37 106-61 161-5 14-8 22-12 24 0 2 1 2 3 2 1 7-1 14-5 21-11 32-18 49-22 53l2 15c1 1 0 2-2 2l-3 1c0-5-1-7-4-6h-2c-3 5-6 11-7 18h2c4-2 5-5 5-8h5l3 1-3 9 1 2-3 8v1l10 3 8-3h33l10-4h24l4-1 2-1v1c11-1 12 0 20 1v1l-6 1 1 2c1 0 3 0 4-2q3 0 3 3l-8 2-3-1-6 1h-4l-1 1c0 1 1 2 3 2h4l22-2 8-2 1 1 4-1 8-1 18-3 1-1v1l25-5v1c5-1 2-1 4-2l1 1h3v-3h-9l-8 1-19 1v-1l10-2h4l2-2v2c15-2 20 2 86-12 4 0 4-3 6-10h-3c-6 2-9 1-19 2-1 0-2 0-2-2v-1h10c2 0 5 0 11-3zm-492 8h-5l7-21h3c1 2-1 10-5 21m5-23v-1c0-2 1-3 3-4v2q0 3-3 3m63 48v2h-8v-1zm-10 0c0 1-2 3-7 5l-10-1h-3v-3zm64-291h-5v-2l3-3h1l3 1c1 2 0 3-2 4m71-14h2v2l-5 1q0-3 3-3m-18 6-7-1v-1l18-4c0 2 1 2 3 2v3h-3l-5-1zm9 26v-1l11-2v2zm12-10v-2h6v1zm2-20h-2l1-3 13-1v2zm6 28v-3l5-1q3 0 3 3zm34-46-7 2h-2l-13-1zm-8 32v1l-10 1v-1zm16 7c0-1-2-2-5-2l-10 3h-8l-3-3 9 1 20-3h10v2zm102-26h3c3-3 7-6 12-8-4 16-10 28-17 35l-6-3c5-12 8-20 8-24m-17 30 2-1c-2 4-4 6-5 6l-1-4 4-2zm-11 26c3-11 5-17 8-18v1c-2 10-4 15-7 16l1 6c-3 3-4 6-4 8h-1l-1-9c2 0 3-1 4-4m-4 14-3 11h-2v-4zm-81 235v-1l3-1v4c-2 0-3-1-3-2m115 3-1-2-7 1v-1h1l15-2v2zm-7-22-8 1v-1l8-1 6-2c0 1 1 2 2 1l11-2c1 0 2 1 2 3zm30-2-8-1v-1l8-1v1c-1 1 2 1 0 2m1-2v-1h4v1zm9 0v-1l3-2c2 0 3 1 4 3zm12-2v-1l5-1v2zm7 0c0-2 1-3 2-3l2 2 1-1 1 2-6-1zm101-13c0-1 1-1-1-2-1 1 1 2-1 2v1l-2 2 4-1h1l-1-3zm7 5h-1v3l6-1z"
    }));

const BaseUIDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#fff",
        "aria-label": "Base UI",
        viewBox: "0 0 17 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.5 7.015A.477.477 0 0 0 9 7.5V23a8 8 0 0 0 .5-15.985M8 9.8V23c-4.418 0-8-3.94-8-8.8V1c4.418 0 8 3.94 8 8.8"
    }));

const BaseUILight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Base UI",
        viewBox: "0 0 17 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.5 7.015A.477.477 0 0 0 9 7.5V23a8 8 0 0 0 .5-15.985M8 9.8V23c-4.418 0-8-3.94-8-8.8V1c4.418 0 8 3.94 8 8.8"
    }));

const Basewell = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 165 165",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#5DE8E8",
        d: "M3 108.401c0-21.353 17.31-38.664 38.664-38.664H77.59c22.865 0 41.4 18.536 41.4 41.4 0 22.865-18.535 41.4-41.4 41.4H3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2B4FF1",
        d: "M46.792 52.664C46.792 31.31 64.102 14 85.456 14h35.928c22.864 0 41.4 18.535 41.4 41.4s-18.536 41.4-41.401 41.4h-74.59z"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 116,
        height: 84,
        x: 3,
        y: 69,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#5DE8E8",
        d: "M3 108.401c0-21.353 17.31-38.664 38.664-38.664H77.59c22.865 0 41.4 18.536 41.4 41.4 0 22.865-18.535 41.4-41.4 41.4H3z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00A5FD",
        d: "M46.792 52.664C46.792 31.31 64.102 14 85.456 14h35.928c22.864 0 41.4 18.535 41.4 41.4s-18.536 41.4-41.401 41.4h-74.59z"
    })));

const BashDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M28.057 6.53 17.952.532a3.8 3.8 0 0 0-3.88 0L3.965 6.53A4.03 4.03 0 0 0 2 10.002v11.996a4.03 4.03 0 0 0 1.948 3.472l10.105 5.998a3.8 3.8 0 0 0 3.88 0L28.04 25.47a4.03 4.03 0 0 0 1.948-3.472V10.002a4.03 4.03 0 0 0-1.93-3.472zM20.23 25.262v.86a.32.32 0 0 1-.148.265l-.512.293c-.08.042-.148 0-.148-.113v-.847a1.66 1.66 0 0 1-1.164.113c-.062-.042-.086-.122-.056-.2l.183-.78a.32.32 0 0 1 .102-.17.2.2 0 0 1 .05-.035.1.1 0 0 1 .08 0 1.4 1.4 0 0 0 1.059-.134 1.41 1.41 0 0 0 .79-1.21c0-.438-.24-.62-.82-.625-.734 0-1.4-.14-1.43-1.224a3.14 3.14 0 0 1 1.186-2.4v-.872a.34.34 0 0 1 .148-.268l.494-.314c.08-.042.148 0 .148.116v.872a1.6 1.6 0 0 1 .967-.116c.07.04.098.128.064.2l-.173.773a.33.33 0 0 1-.138.195c-.02.012-.05.008-.074 0a1.28 1.28 0 0 0-.931.152 1.17 1.17 0 0 0-.706 1.037c0 .395.208.515.907.53.935 0 1.337.423 1.348 1.362a3.35 3.35 0 0 1-1.228 2.53zm5.293-1.45a.2.2 0 0 1-.078.194L22.9 25.558c-.024.02-.06.023-.087.007s-.04-.05-.033-.08v-.66a.18.18 0 0 1 .116-.162l2.516-1.507c.024-.02.06-.023.087-.007s.04.05.033.08v.582zM27.288 9.06l-9.562 5.906c-1.193.706-2.07 1.478-2.07 2.914v11.778c0 .86.353 1.4.882 1.58a3 3 0 0 1-.53.053 3.13 3.13 0 0 1-1.595-.441L4.308 24.853A3.3 3.3 0 0 1 2.706 22V10.002a3.3 3.3 0 0 1 1.602-2.858l10.105-5.998c.98-.58 2.196-.58 3.176 0l10.105 5.998c.833.504 1.4 1.35 1.552 2.3-.328-.713-1.083-.9-1.962-.395h.003z"
    }));

const BashLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1b1b1f",
        fillRule: "evenodd",
        d: "M28.057 6.53 17.952.532a3.8 3.8 0 0 0-3.88 0L3.965 6.53A4.03 4.03 0 0 0 2 10.002v11.996a4.03 4.03 0 0 0 1.948 3.472l10.105 5.998a3.8 3.8 0 0 0 3.88 0L28.04 25.47a4.03 4.03 0 0 0 1.948-3.472V10.002a4.03 4.03 0 0 0-1.93-3.472zM20.23 25.262v.86a.32.32 0 0 1-.148.265l-.512.293c-.08.042-.148 0-.148-.113v-.847a1.66 1.66 0 0 1-1.164.113c-.062-.042-.086-.122-.056-.2l.183-.78a.32.32 0 0 1 .102-.17.2.2 0 0 1 .05-.035.1.1 0 0 1 .08 0 1.4 1.4 0 0 0 1.059-.134 1.41 1.41 0 0 0 .79-1.21c0-.438-.24-.62-.82-.625-.734 0-1.4-.14-1.43-1.224a3.14 3.14 0 0 1 1.186-2.4v-.872a.34.34 0 0 1 .148-.268l.494-.314c.08-.042.148 0 .148.116v.872a1.6 1.6 0 0 1 .967-.116c.07.04.098.128.064.2l-.173.773a.33.33 0 0 1-.138.195c-.02.012-.05.008-.074 0a1.28 1.28 0 0 0-.931.152 1.17 1.17 0 0 0-.706 1.037c0 .395.208.515.907.53.935 0 1.337.423 1.348 1.362a3.35 3.35 0 0 1-1.228 2.53zm5.293-1.45a.2.2 0 0 1-.078.194L22.9 25.558c-.024.02-.06.023-.087.007s-.04-.05-.033-.08v-.66a.18.18 0 0 1 .116-.162l2.516-1.507c.024-.02.06-.023.087-.007s.04.05.033.08v.582zM27.288 9.06l-9.562 5.906c-1.193.706-2.07 1.478-2.07 2.914v11.778c0 .86.353 1.4.882 1.58a3 3 0 0 1-.53.053 3.13 3.13 0 0 1-1.595-.441L4.308 24.853A3.3 3.3 0 0 1 2.706 22V10.002a3.3 3.3 0 0 1 1.602-2.858l10.105-5.998c.98-.58 2.196-.58 3.176 0l10.105 5.998c.833.504 1.4 1.35 1.552 2.3-.328-.713-1.083-.9-1.962-.395h.003z"
    }));

const Beacon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 93 20",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF7E23",
        fillRule: "evenodd",
        d: "M6.815 19.719c4.869 0 7.122-2.254 7.122-5.494 0-2.845-1.83-4.79-4.197-5.352 1.662-.647 2.844-2.028 2.844-4.028 0-2.59-1.94-4.845-5.911-4.845H0v19.719zM3.096 8V2.733h3.322c2.028 0 3.097.958 3.097 2.535C9.515 6.873 8.417 8 6.389 8zm7.742 5.747c0-1.944-1.24-3.324-4.196-3.324H3.096v6.563h3.577c2.928 0 4.165-1.24 4.165-3.24Zm18.78-.226H18.043c.452 2.59 2.48 3.888 4.814 3.888 1.943 0 2.983-.507 4.055-1.353l1.717 1.634C27.335 19.157 25.476 20 22.774 20c-3.687 0-7.716-2.507-7.716-7.578 0-5.1 4.14-7.632 7.432-7.632 3.325 0 7.831 2.533 7.127 8.73Zm-11.545-2.255h8.813c-.28-2.59-2.505-3.86-4.39-3.86-1.86.003-3.945 1.27-4.423 3.86m19.874-6.479c-3.293 0-7.263 2.48-7.263 7.607 0 5.126 3.97 7.606 7.263 7.606 2.535 0 4.281-1.466 4.872-2.677h.168v2.393h3.041V5.068h-3.041v2.394h-.168c-.591-1.211-2.337-2.675-4.872-2.675m.395 2.706c2.279 0 4.73 1.632 4.73 4.9 0 3.27-2.449 4.903-4.73 4.9-2.28 0-4.701-1.633-4.701-4.9 0-3.265 2.42-4.9 4.7-4.9Zm20.832 1.913 2.366-1.07c-1.323-2.364-3.603-3.546-6.252-3.549-3.322 0-7.574 2.533-7.574 7.633 0 5.097 4.252 7.578 7.574 7.578 2.676 0 4.927-1.154 6.279-3.521l-2.393-1.07c-.874 1.183-2.056 1.887-3.857 1.887-2.167 0-4.646-1.634-4.646-4.874 0-3.295 2.48-4.929 4.646-4.929 1.801 0 2.986.733 3.857 1.915M69.871 20c3.35 0 7.602-2.48 7.602-7.578 0-5.1-4.251-7.632-7.602-7.632s-7.603 2.533-7.603 7.632c0 5.098 4.252 7.578 7.603 7.578m.002-2.704c-2.166 0-4.645-1.634-4.645-4.873 0-3.295 2.476-4.93 4.645-4.93 2.17 0 4.646 1.635 4.646 4.93 0 3.24-2.477 4.873-4.646 4.873m22.858 2.423V11.24c0-4.564-2.757-6.45-5.489-6.45-3.18 0-4.758 2.477-5.04 3.323V5.071h-3.04v14.645h3.04v-8.76c.14-1.237 1.493-3.491 3.998-3.491 1.857 0 3.49 1.156 3.49 3.943v8.31z",
        clipRule: "evenodd"
    }));

const Bento = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 45 41",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#DBDBDB",
        fillRule: "evenodd",
        d: "M4.206 28.621C1.883 26.804.722 25.895.287 24.847L0 23.419v-5.847h1.464v2.909c.641-.601 1.535-1.3 2.742-2.245l11.611-9.087c2.323-1.818 3.484-2.727 4.823-3.067 1.178-.3 2.447-.3 3.625 0 1.339.34 2.5 1.25 4.822 3.067L40.7 18.236c1.207.945 2.1 1.644 2.742 2.245v-2.91h1.464v5.858c0 .478-.096.957-.287 1.418-.435 1.048-1.597 1.957-3.92 3.774l-11.61 9.088c-2.323 1.817-3.484 2.726-4.823 3.066-1.178.3-2.447.3-3.625 0-1.339-.34-2.5-1.249-4.823-3.066z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M4.206 22.764C1.883 20.947.722 20.038.287 18.99a3.65 3.65 0 0 1 0-2.837c.435-1.048 1.596-1.957 3.919-3.774l11.611-9.087C18.14 1.474 19.301.565 20.64.225c1.178-.3 2.447-.3 3.625 0 1.339.34 2.5 1.249 4.822 3.067L40.7 12.379c2.322 1.817 3.484 2.726 3.919 3.774a3.65 3.65 0 0 1 0 2.837c-.435 1.048-1.597 1.957-3.92 3.774l-11.61 9.087c-2.323 1.818-3.484 2.727-4.823 3.067-1.178.3-2.447.3-3.625 0-1.339-.34-2.5-1.25-4.823-3.067z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF8686",
        d: "M17.476 11.513c-1.161-.909-1.742-1.363-1.96-1.887a1.82 1.82 0 0 1 0-1.418c.218-.524.799-.979 1.96-1.887l1.659-1.299c1.161-.908 1.742-1.363 2.411-1.533a3.7 3.7 0 0 1 1.813 0c.67.17 1.25.625 2.41 1.533l1.66 1.299c1.161.908 1.742 1.363 1.96 1.887.19.46.19.957 0 1.418-.218.524-.799.979-1.96 1.887l-1.66 1.299c-1.16.908-1.74 1.363-2.41 1.533a3.7 3.7 0 0 1-1.813 0c-.67-.17-1.25-.625-2.411-1.533z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5AFF88",
        d: "M28.535 20.168c-1.162-.909-1.742-1.363-1.96-1.887a1.82 1.82 0 0 1 0-1.419c.218-.524.798-.978 1.96-1.887l1.658-1.298c1.162-.909 1.742-1.363 2.412-1.533a3.7 3.7 0 0 1 1.812 0c.67.17 1.25.624 2.411 1.533l1.66 1.298c1.16.909 1.741 1.363 1.959 1.887.191.461.191.958 0 1.419-.218.524-.799.978-1.96 1.887l-1.659 1.298c-1.16.909-1.742 1.363-2.411 1.533a3.7 3.7 0 0 1-1.812 0c-.67-.17-1.25-.624-2.412-1.533z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#768CFF",
        d: "M6.418 20.168c-1.162-.909-1.742-1.363-1.96-1.887a1.82 1.82 0 0 1 0-1.419c.218-.524.798-.978 1.96-1.887l1.658-1.298c1.162-.909 1.742-1.363 2.412-1.533a3.7 3.7 0 0 1 1.812 0c.67.17 1.25.624 2.411 1.533L27.43 23.63c1.161.908 1.742 1.363 1.96 1.887.19.46.19.957 0 1.418-.218.524-.799.978-1.96 1.887l-1.66 1.298c-1.16.91-1.74 1.364-2.41 1.534-.59.15-1.224.15-1.813 0-.67-.17-1.25-.625-2.411-1.534z"
    }));

const BetterAuthDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 500 500",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h500v500H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M69 121h86.988v259H69zm268.575 0H430v259h-92.425z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M427.282 121v83.456h-174.52V121zM430 296.544V380H252.762v-83.456z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M252.762 204.455v92.089h-96.774v-92.089z"
    }));

const BetterAuthLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 500 500",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M0 0h500v500H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M69 121h86.988v259H69zm268.575 0H430v259h-92.425z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M427.282 121v83.456h-174.52V121zM430 296.544V380H252.762v-83.456z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M252.762 204.455v92.089h-96.774v-92.089z"
    }));

const Binance = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 201 201",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M100.517 200.483c55.228 0 100-44.771 100-100s-44.772-100-100-100-100 44.772-100 100 44.771 100 100 100"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F3BA2F",
        fillRule: "evenodd",
        d: "m126.452 111.118 15.085 15.041-41.006 40.962-40.962-40.962 15.084-15.041 25.878 25.877zm-25.921-25.921 15.301 15.301-15.301 15.301-15.258-15.258v-.043l2.688-2.688 1.3-1.3zm-51.582.216 15.085 15.085-15.085 15.041-15.085-15.085zm103.164 0 15.085 15.085-15.085 15.041-15.084-15.085zm-51.582-51.582 40.962 40.962-15.084 15.085-25.878-25.921-25.878 25.878L59.57 74.793z",
        clipRule: "evenodd"
    }));

const Bing = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 388",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: "93.717%",
        cy: "77.818%",
        r: "143.121%",
        fx: "93.717%",
        fy: "77.818%",
        gradientTransform: "matrix(-.65486 -.5438 .75575 -.4712 .963 1.654)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00CACC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#048FCE"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: "13.893%",
        cy: "71.448%",
        r: "150.086%",
        fx: "13.893%",
        fy: "71.448%",
        gradientTransform: "matrix(.55155 -.39387 .23634 .91917 -.107 .112)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00BBEC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#2756A9"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00BBEC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#2756A9"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M129.424 122.047c-7.133.829-12.573 6.622-13.079 13.928-.218 3.147-.15 3.36 6.986 21.722 16.233 41.774 20.166 51.828 20.827 53.243 1.603 3.427 3.856 6.65 6.672 9.544 2.16 2.22 3.585 3.414 5.994 5.024 4.236 2.829 6.337 3.61 22.818 8.49 16.053 4.754 24.824 7.913 32.381 11.664 9.791 4.86 16.623 10.387 20.944 16.946 3.1 4.706 5.846 13.145 7.04 21.64.468 3.321.47 10.661.006 13.663-1.008 6.516-3.021 11.976-6.101 16.545-1.638 2.43-1.068 2.023 1.313-.939 6.74-8.379 13.605-22.7 17.108-35.687 4.24-15.718 4.817-32.596 1.66-48.57-6.147-31.108-25.786-57.955-53.444-73.06-1.738-.95-8.357-4.42-17.331-9.085a1633 1633 0 0 1-4.127-2.154c-.907-.477-2.764-1.447-4.126-2.154-1.362-.708-5.282-2.75-8.711-4.539l-8.528-4.446a6021 6021 0 0 1-8.344-4.357c-8.893-4.655-12.657-6.537-13.73-6.863-1.125-.343-3.984-.782-4.701-.723-.152.012-.838.088-1.527.168"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M148.81 277.994c-.493.292-1.184.714-1.537.938-.354.225-1.137.712-1.743 1.083a8315 8315 0 0 0-13.204 8.137 2848 2848 0 0 0-8.07 4.997 388 388 0 0 1-3.576 2.198c-.454.271-2.393 1.465-4.31 2.654a2652 2652 0 0 1-7.427 4.586 3958 3958 0 0 0-8.62 5.316 3011 3011 0 0 1-7.518 4.637c-1.564.959-3.008 1.885-3.21 2.058-.3.257-14.205 8.87-21.182 13.121-5.3 3.228-11.43 5.387-17.705 6.235-2.921.395-8.45.396-11.363.003-7.9-1.067-15.176-4.013-21.409-8.666-2.444-1.826-7.047-6.425-8.806-8.8-4.147-5.598-6.829-11.602-8.218-18.396-.32-1.564-.622-2.884-.672-2.935-.13-.13.105 2.231.528 5.319.44 3.211 1.377 7.856 2.387 11.829 7.814 30.743 30.05 55.749 60.15 67.646 8.668 3.424 17.415 5.582 26.932 6.64 3.576.4 13.699.56 17.43.276 17.117-1.296 32.02-6.334 47.308-15.996 1.362-.86 3.92-2.474 5.685-3.585a877 877 0 0 0 4.952-3.14c.958-.615 2.114-1.341 2.567-1.614a91 91 0 0 0 2.018-1.268c.656-.424 3.461-2.2 6.235-3.944l11.092-7.006 3.809-2.406.137-.086.42-.265.199-.126 2.804-1.771 9.69-6.121c12.348-7.759 16.03-10.483 21.766-16.102 2.392-2.342 5.997-6.34 6.176-6.848.037-.104.678-1.092 1.424-2.197 3.036-4.492 5.06-9.995 6.064-16.484.465-3.002.462-10.342-.005-13.663-.903-6.42-2.955-13.702-5.167-18.339-3.627-7.603-11.353-14.512-22.453-20.076-3.065-1.537-6.23-2.943-6.583-2.924-.168.009-10.497 6.322-22.954 14.03-12.457 7.71-23.268 14.4-24.025 14.87a290 290 0 0 1-2.888 1.764z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m.053 241.013.054 53.689.695 3.118c2.172 9.747 5.937 16.775 12.482 23.302 3.078 3.07 5.432 4.922 8.768 6.896 7.06 4.177 14.657 6.238 22.978 6.235 8.716-.005 16.256-2.179 24.025-6.928 1.311-.801 6.449-3.964 11.416-7.029l9.032-5.572v-127.4l-.002-58.273c-.002-37.177-.07-59.256-.188-60.988-.74-10.885-5.293-20.892-12.948-28.461-2.349-2.323-4.356-3.875-10.336-7.99a25160 25160 0 0 1-12.104-8.336L28.617 5.835C22.838 1.85 22.386 1.574 20.639.949 18.367.136 15.959-.163 13.67.084 6.998.804 1.657 5.622.269 12.171.053 13.191.013 26.751.01 100.35l-.003 86.975H0z"
    }));

const Biomejs = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 55.425",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "100%",
        fill: "none"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#60a5fa",
        d: "M32 0 17.745 24.69a32.2 32.2 0 0 1 16.869-.584l4.818 1.137-4.533 19.22-4.825-1.137c-5.93-1.399-11.628 1.716-14.036 6.685l-4.46-2.158c3.404-7.029 11.425-11.285 19.637-9.347l2.26-9.58A27.231 27.231 0 0 0 0 55.424l64 .001z",
        style: {
            paintOrder: "markers fill stroke"
        }
    }));

const Bitcoin = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__a",
        width: "111.7%",
        height: "111.7%",
        x: "-5.8%",
        y: "-4.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in: "shadowBlurOuter1",
        in2: "SourceAlpha",
        operator: "out",
        result: "shadowBlurOuter1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__d",
        width: "123.2%",
        height: "117.5%",
        x: "-11.6%",
        y: "-6.3%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.204257246 0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0.5
    })), /*#__PURE__*/ React.createElement("circle", {
        id: "prefix__b",
        cx: 16,
        cy: 15,
        r: 15
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__e",
        d: "M23.189 13.02c.314-2.096-1.283-3.223-3.465-3.975l.708-2.84-1.728-.43-.69 2.765c-.454-.114-.92-.22-1.385-.326l.695-2.783L15.596 5l-.708 2.839q-.566-.127-1.104-.26l.002-.009-2.384-.595-.46 1.846s1.283.294 1.256.312c.7.175.826.638.805 1.006l-.806 3.235q.074.017.18.057l-.183-.045-1.13 4.532c-.086.212-.303.531-.793.41.018.025-1.256-.313-1.256-.313l-.858 1.978 2.25.561c.418.105.828.215 1.231.318l-.715 2.872 1.727.43.708-2.84q.707.19 1.378.357l-.706 2.828 1.728.43.715-2.866c2.948.558 5.164.333 6.097-2.333.752-2.146-.037-3.385-1.588-4.192 1.13-.26 1.98-1.003 2.207-2.538m-3.95 5.538c-.533 2.147-4.148.986-5.32.695l.95-3.805c1.172.293 4.929.872 4.37 3.11m.535-5.569c-.487 1.953-3.495.96-4.47.717l.86-3.45c.975.243 4.118.696 3.61 2.733"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#000",
        filter: "url(#prefix__a)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#F7931A"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "url(#prefix__c)",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 16,
        cy: 15,
        r: 14.5,
        stroke: "#000",
        strokeOpacity: 0.097
    }), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#000",
        filter: "url(#prefix__d)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#FFF",
        fillRule: "evenodd"
    }))));

const Bitwarden = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 182 218",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#175DDC",
        d: "M179.304 2.69C177.498.887 175.358 0 172.913 0H9.086c-2.473 0-4.585.887-6.39 2.69C.888 4.492 0 6.627 0 9.067v109q0 12.187 4.751 24.207c3.168 7.986 7.114 15.084 11.81 21.295 4.695 6.184 10.28 12.229 16.782 18.107s12.504 10.731 17.978 14.613a230 230 0 0 0 17.2 11.008c5.974 3.466 10.225 5.795 12.726 7.015 2.5 1.22 4.529 2.191 6.03 2.828 1.139.555 2.361.86 3.695.86s2.556-.277 3.696-.86c1.528-.665 3.528-1.608 6.057-2.828 2.501-1.22 6.752-3.577 12.726-7.015a230 230 0 0 0 17.2-11.008c5.501-3.882 11.503-8.762 18.005-14.613 6.502-5.878 12.087-11.896 16.783-18.107s8.614-13.282 11.809-21.295q4.752-11.979 4.751-24.207V9.095c.028-2.468-.889-4.603-2.695-6.405m-21.117 116.403c0 39.458-67.187 73.452-67.187 73.452V23.347h67.187z"
    }));

const Blender = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0.1 16.7 2472.8 1996.5",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2007 1486a539 539 0 0 1-387 158c-150 0-288-57-387-157-48-49-84-105-106-166a429 429 0 0 1 29-358c29-52 69-100 118-140 96-78 218-120 346-120s250 41 346 119c49 40 89 87 117 140a437 437 0 0 1-77 524z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#005385",
        d: "M1300 1143c5-81 45-153 105-204 59-50 139-81 226-81 86 0 166 31 225 81 60 51 100 123 105 204 4 84-29 162-88 220-61 58-146 95-242 95s-182-37-243-95c-59-58-92-136-88-220"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ff7021",
        d: "M775 1308c0 32 10 94 26 143 32 102 86 197 162 281 78 85 173 154 284 203a913 913 0 0 0 746-1 844 844 0 0 0 283-205 757 757 0 0 0 193-438 721 721 0 0 0-109-440 795 795 0 0 0-188-208L1408 57l-2-2c-50-38-135-38-190 0-55 39-62 104-12 145l318 259-971 1h-1c-81 0-158 53-173 119-16 68 39 124 122 125l492-1-878 674-3 3c-83 63-110 169-58 235 53 68 166 68 250 1l479-393s-7 53-7 85zm1232 178a539 539 0 0 1-387 158c-150 0-288-57-387-157-48-49-84-105-106-166a429 429 0 0 1 29-358c29-52 69-100 118-140 96-78 218-120 346-120s250 41 346 119c49 40 89 87 117 140a437 437 0 0 1-77 524z"
    }));

const Blitz = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 394",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#6700EB",
        d: "M65.062 196.687a78.8 78.8 0 0 1 62.965 31.42l64.178 85.287a5.25 5.25 0 0 1 .47 5.569l-36.994 71.675c-1.775 3.44-6.533 3.843-8.863.754L0 196.687zm44.12-194.596L256 196.796h-65.062a78.8 78.8 0 0 1-62.965-31.42L63.795 80.089a5.25 5.25 0 0 1-.47-5.568l36.994-71.677c1.774-3.439 6.532-3.843 8.862-.753Z"
    }));

const Bluesky = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 226",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1185FE",
        d: "M55.491 15.172c29.35 22.035 60.917 66.712 72.509 90.686 11.592-23.974 43.159-68.651 72.509-90.686C221.686-.727 256-13.028 256 26.116c0 7.818-4.482 65.674-7.111 75.068-9.138 32.654-42.436 40.983-72.057 35.942 51.775 8.812 64.946 38 36.501 67.187-54.021 55.433-77.644-13.908-83.696-31.676-1.11-3.257-1.63-4.78-1.637-3.485-.008-1.296-.527.228-1.637 3.485-6.052 17.768-29.675 87.11-83.696 31.676-28.445-29.187-15.274-58.375 36.5-67.187-29.62 5.041-62.918-3.288-72.056-35.942C4.482 91.79 0 33.934 0 26.116 0-13.028 34.314-.727 55.491 15.172"
    }));

const BoltDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#fff",
        viewBox: "0 45.65 160 68.7",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M75.61 106.195c-14.747 0-21.962-8.468-21.962-19.136s10.04-24.157 24.782-24.157c14.746 0 21.96 8.47 21.96 19.137s-10.038 24.156-24.78 24.156m.624-13.488c5.02 0 8.473-4.707 8.473-9.727s-2.512-6.273-6.902-6.273c-4.395 0-8.473 4.703-8.473 9.723s2.512 6.277 6.902 6.277m39.844 12.547h-15.371l12.547-57.098h15.375l-12.55 56.785Zm0 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M30.117 106.195c-4.707 0-9.41-1.566-11.922-5.332l-.941 4.39L0 114.353l1.883-9.098L14.43 48.156h15.375L25.41 68.234c3.453-3.765 6.902-5.332 11.297-5.332 9.41 0 15.371 5.961 15.371 17.254s-7.215 26.04-21.96 26.04Zm5.961-22.902c0 5.336-3.766 9.414-8.785 9.414s-5.332-.941-6.902-2.824l2.511-10.352c1.883-1.883 3.766-2.824 6.274-2.824 3.765 0 6.902 2.824 6.902 6.902Zm0 0"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M144.629 106.195c-8.785 0-15.375-3.136-15.375-10.351s0-2.196.316-3.137l3.45-15.375h-6.903l3.137-13.176h6.902l2.512-11.293 17.254-7.215-1.883 7.215-2.508 11.293H160l-3.137 13.176h-8.472l-2.196 10.04v1.882c0 1.883 1.254 3.453 3.766 3.453 2.508 0 1.883 0 2.195-.316v12.238c-1.566 1.254-4.39 1.566-7.215 1.566Zm0 0"
    }));

const BoltLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#0000000",
        viewBox: "0 45.65 160 68.7",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M75.61 106.195c-14.747 0-21.962-8.468-21.962-19.136s10.04-24.157 24.782-24.157c14.746 0 21.96 8.47 21.96 19.137s-10.038 24.156-24.78 24.156m.624-13.488c5.02 0 8.473-4.707 8.473-9.727s-2.512-6.273-6.902-6.273c-4.395 0-8.473 4.703-8.473 9.723s2.512 6.277 6.902 6.277m39.844 12.547h-15.371l12.547-57.098h15.375l-12.55 56.785Zm0 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M30.117 106.195c-4.707 0-9.41-1.566-11.922-5.332l-.941 4.39L0 114.353l1.883-9.098L14.43 48.156h15.375L25.41 68.234c3.453-3.765 6.902-5.332 11.297-5.332 9.41 0 15.371 5.961 15.371 17.254s-7.215 26.04-21.96 26.04Zm5.961-22.902c0 5.336-3.766 9.414-8.785 9.414s-5.332-.941-6.902-2.824l2.511-10.352c1.883-1.883 3.766-2.824 6.274-2.824 3.765 0 6.902 2.824 6.902 6.902Zm0 0"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M144.629 106.195c-8.785 0-15.375-3.136-15.375-10.351s0-2.196.316-3.137l3.45-15.375h-6.903l3.137-13.176h6.902l2.512-11.293 17.254-7.215-1.883 7.215-2.508 11.293H160l-3.137 13.176h-8.472l-2.196 10.04v1.882c0 1.883 1.254 3.453 3.766 3.453 2.508 0 1.883 0 2.195-.316v12.238c-1.566 1.254-4.39 1.566-7.215 1.566Zm0 0"
    }));

const Bootstrap = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 204",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#7E13F8",
        d: "M53.172 0C38.565 0 27.756 12.785 28.24 26.65c.465 13.32-.139 30.573-4.482 44.642C19.402 85.402 12.034 94.34 0 95.488v12.956c12.034 1.148 19.402 10.086 23.758 24.197 4.343 14.069 4.947 31.32 4.482 44.641-.484 13.863 10.325 26.65 24.934 26.65h149.673c14.608 0 25.414-12.785 24.93-26.65-.464-13.32.139-30.572 4.482-44.641 4.359-14.11 11.707-23.05 23.741-24.197V95.488c-12.034-1.148-19.382-10.086-23.74-24.196-4.344-14.067-4.947-31.321-4.483-44.642C228.261 12.787 217.455 0 202.847 0H53.17zM173.56 125.533c0 19.092-14.24 30.67-37.872 30.67h-40.23a4.34 4.34 0 0 1-4.338-4.339V52.068a4.34 4.34 0 0 1 4.339-4.34h39.999c19.705 0 32.637 10.675 32.637 27.063 0 11.503-8.7 21.801-19.783 23.604v.601c15.089 1.655 25.248 12.104 25.248 26.537m-42.26-64.05h-22.937v32.4h19.32c14.934 0 23.17-6.014 23.17-16.764 0-10.073-7.082-15.636-19.552-15.636Zm-22.937 45.256v35.705h23.782c15.548 0 23.786-6.239 23.786-17.965 0-11.728-8.467-17.742-24.786-17.742h-22.782z"
    }));

const BraveBrowser = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 301",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "0%",
        x2: "100.097%",
        y1: "50.018%",
        y2: "50.018%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "14.13%",
        stopColor: "#FFF",
        stopOpacity: 0.958
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.7
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "-.039%",
        x2: "100%",
        y1: "49.982%",
        y2: "49.982%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#F1F1F2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "9.191%",
        stopColor: "#E4E5E6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "23.57%",
        stopColor: "#D9DADB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "43.8%",
        stopColor: "#D2D4D5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#D0D2D3"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#F15A22",
        d: "M256 97.1 246.7 72l6.4-14.4c.8-1.9.4-4-1-5.5l-17.5-17.7c-7.7-7.7-19.1-10.4-29.4-6.8l-4.9 1.7-26.8-29-45.3-.3h-.3L82.3.4 55.6 29.6l-4.8-1.7c-10.4-3.7-21.9-1-29.6 6.9l-17.8 18c-1.2 1.2-1.5 2.9-.9 4.4l6.7 15L0 97.3 6 120l27.2 103.3c3.1 11.9 10.3 22.3 20.4 29.5 0 0 33 23.3 65.5 44.4 2.9 1.9 5.9 3.2 9.1 3.2s6.2-1.3 9.1-3.2c36.6-24 65.5-44.5 65.5-44.5 10-7.2 17.2-17.6 20.3-29.5l27-103.3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M34.5 227.7 0 99.5l10.1-25.1-7-18.6 16.7-17c5.5-4.9 16.3-6.6 21.3-3.7l26.1 15 34 7.9 26.5-11 2.2 227.7c-.4 32.8 1.7 29.3-22.4 13.8L48 248.6c-6.4-6.1-11.3-13-13.5-20.9",
        opacity: 0.15,
        style: {
            mixBlendMode: "lighten"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m202.2 252.246-50.6 34.6c-14.1 7.7-20.9 15.3-22 11.6-.9-2.9-.2-11.4-.5-24.6l-.6-222.7c.1-2.2 1.6-5.9 4.2-5.5l25.8 7.8 37.2-5.8 24.6-18.1c2.6-2 6.4-1.8 8.8.5l22 21c2 2.1 2.1 6.2.9 8.8l-6.1 11.3 10.1 26.1-34.8 129.4c-5.4 16.1-13 20.3-19 25.6",
        opacity: 0.4,
        style: {
            mixBlendMode: "darken"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M134 184.801c-1.2-.5-2.5-.9-2.9-.9h-3.2c-.4 0-1.7.4-2.9.9l-13 5.4c-1.2.5-3.2 1.4-4.4 2l-19.6 10.2c-1.2.6-1.3 1.7-.2 2.5l17.3 12.2c1.1.8 2.8 2.1 3.8 3l7.7 6.6c1 .9 2.6 2.3 3.6 3.2l7.4 6.6c1 .9 2.6.9 3.6 0l7.6-6.6c1-.9 2.6-2.3 3.6-3.2l7.7-6.7c1-.9 2.7-2.2 3.8-3l17.3-12.3c1.1-.8 1-1.9-.2-2.5l-19.6-10c-1.2-.6-3.2-1.5-4.4-2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M227.813 101.557c.4-1.3.4-1.8.4-1.8 0-1.3-.1-3.5-.3-4.8l-1-2.9c-.6-1.2-1.6-3.1-2.4-4.2l-11.3-16.7c-.7-1.1-2-2.8-2.9-3.9l-14.6-18.3c-.8-1-1.6-1.9-1.7-1.8h-.2s-1.1.2-2.4.4l-22.3 4.4c-1.3.3-3.4.7-4.7.9l-.4.1c-1.3.2-3.4.1-4.7-.3l-18.7-6c-1.3-.4-3.4-1-4.6-1.3 0 0-3.8-.9-6.9-.8-3.1 0-6.9.8-6.9.8-1.3.3-3.4.9-4.6 1.3l-18.7 6c-1.3.4-3.4.5-4.7.3l-.4-.1c-1.3-.2-3.4-.7-4.7-.9l-22.5-4.2c-1.3-.3-2.4-.4-2.4-.4h-.2c-.1 0-.9.8-1.7 1.8l-14.6 18.3c-.8 1-2.1 2.8-2.9 3.9l-11.3 16.7c-.7 1.1-1.8 3-2.4 4.2l-1 2.9c-.2 1.3-.4 3.5-.3 4.8 0 0 0 .4.4 1.8.7 2.4 2.4 4.6 2.4 4.6.8 1 2.3 2.7 3.2 3.6l33.1 35.2c.9 1 1.2 2.8.7 4l-6.9 16.3c-.5 1.2-.6 3.2-.1 4.5l1.9 5.1c1.6 4.3 4.3 8.1 7.9 11l6.7 5.4c1 .8 2.8 1.1 4 .5l21.2-10.1c1.2-.6 3-1.8 4-2.7l15.2-13.7c2.2-2 2.3-5.4.3-7.6l-31.9-21.5c-1.1-.7-1.5-2.3-.9-3.5l14-26.4c.6-1.2.7-3.1.2-4.3l-1.7-3.9c-.5-1.2-2-2.6-3.2-3.1l-41.1-15.4c-1.2-.5-1.2-1 .1-1.1l26.5-2.5c1.3-.1 3.4.1 4.7.4l23.6 6.6c1.3.4 2.1 1.7 1.9 3l-8.2 44.9c-.2 1.3-.2 3.1.1 4.1s1.6 1.9 2.9 2.2l16.4 3.5c1.3.3 3.4.3 4.7 0l15.3-3.5c1.3-.3 2.6-1.3 2.9-2.2s.4-2.8.1-4.1l-8.1-44.9c-.2-1.3.6-2.7 1.9-3l23.6-6.6c1.3-.4 3.4-.5 4.7-.4l26.5 2.5c1.3.1 1.4.6.1 1.1l-41.1 15.6c-1.2.5-2.7 1.8-3.2 3.1l-1.7 3.9c-.5 1.2-.5 3.2.2 4.3l14.1 26.4c.6 1.2.2 2.7-.9 3.5l-31.9 21.6c-2.1 2.1-1.9 5.6.3 7.6l15.2 13.7c1 .9 2.8 2.1 4 2.6l21.3 10.1c1.2.6 3 .3 4-.5l6.7-5.5c3.6-2.9 6.3-6.7 7.8-11l1.9-5.1c.5-1.2.4-3.3-.1-4.5l-6.9-16.3c-.5-1.2-.2-3 .7-4l33.1-35.2c.9-1 2.3-2.6 3.2-3.6-.2-.3 1.6-2.5 2.2-4.9"
    }));

const BuildShip = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 44 44",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        fillRule: "evenodd",
        d: "M18 12a7 7 0 1 1 7 7v-4a3 3 0 1 0-3-3z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        fillRule: "evenodd",
        d: "M32 12a7 7 0 0 1-7 7h-3v-4h3a3 3 0 0 0 3-3z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        fillRule: "evenodd",
        d: "M25 5a7 7 0 0 1 7 7h-4a3 3 0 0 0-3-3z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        fillRule: "evenodd",
        d: "M25 9a3 3 0 0 0-3 3h-4a7 7 0 0 1 7-7z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        fillRule: "evenodd",
        d: "M8 22a7 7 0 0 1 7-7h3v4h-3a3 3 0 0 0-3 3z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        fillRule: "evenodd",
        d: "M18 32a7 7 0 1 0 14 0h-4a3 3 0 1 1-6 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        fillRule: "evenodd",
        d: "M22 12v20h-4V12z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        fillRule: "evenodd",
        d: "M32 32a7 7 0 0 0-7-7h-5v4h5a3 3 0 0 1 3 3z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        fillRule: "evenodd",
        d: "M8 22a7 7 0 0 0 7 7h5v-4h-5a3 3 0 0 1-3-3z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 21.111,
        x2: 29.444,
        y1: 15.889,
        y2: 9.222,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#4200FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopColor: "#0AF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0FA"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 30,
        x2: 22,
        y1: 12,
        y2: 18,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FD3DF6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D478EF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 25,
        x2: 30.5,
        y1: 7,
        y2: 12,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF69F9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FD3DF6"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 22,
        x2: 25,
        y1: 12,
        y2: 9,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#8C6CF3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF69F9"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 10,
        x2: 18,
        y1: 22,
        y2: 17,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00D1AC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#7696D9"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: 20,
        x2: 30.5,
        y1: 32,
        y2: 32,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1B71EA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#2C91ED"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: 22,
        x2: 22,
        y1: 32,
        y2: 11.775,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1B71EA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#8C6CF3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: 23.5,
        x2: 28,
        y1: 26,
        y2: 32,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00D1AC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#2C91ED"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: 10,
        x2: 20,
        y1: 22,
        y2: 27,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00D1AC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00D1AC"
    }))));

const Builder = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 293",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#18B4F4",
        d: "M256 82.32a82.17 82.17 0 0 1-30.548 64.032L5.802 21.622a12 12 0 0 1-2.32-1.726A11.63 11.63 0 0 1 0 11.613 11.61 11.61 0 0 1 11.608 0H173.72a82.25 82.25 0 0 1 58.182 24.112A82.33 82.33 0 0 1 256 82.32"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FD6B3C",
        d: "M256 210.38a82.3 82.3 0 0 1-6.256 31.508 82.3 82.3 0 0 1-17.835 26.716 82.3 82.3 0 0 1-58.19 24.117H11.61a11.6 11.6 0 0 1-6.432-2.027 11.6 11.6 0 0 1-4.216-5.26 11.6 11.6 0 0 1-.585-6.72 11.6 11.6 0 0 1 3.242-5.911 11.3 11.3 0 0 1 2.184-1.704l86.444-49.085 133.189-75.645A82.23 82.23 0 0 1 256 210.38"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A97FF2",
        d: "M225.452 146.352 92.246 222.014l-86.44 49.085a11 11 0 0 0-2.285 1.687A180.94 180.94 0 0 0 54.87 146.352 180.84 180.84 0 0 0 3.539 19.896a12 12 0 0 0 2.324 1.726l219.59 124.73Z"
    }));

const Bun = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 80 70",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M71.09 20.74c-.16-.17-.33-.34-.5-.5s-.33-.34-.5-.5-.33-.34-.5-.5-.33-.34-.5-.5-.33-.34-.5-.5-.33-.34-.5-.5-.33-.34-.5-.5A26.46 26.46 0 0 1 75.5 35.7c0 16.57-16.82 30.05-37.5 30.05-11.58 0-21.94-4.23-28.83-10.86l.5.5.5.5.5.5.5.5.5.5.5.5.5.5C19.55 65.3 30.14 69.75 42 69.75c20.68 0 37.5-13.48 37.5-30 0-7.06-3.04-13.75-8.41-19.01"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M73 35.7c0 15.21-15.67 27.54-35 27.54S3 50.91 3 35.7C3 26.27 9 17.94 18.22 13S33.18 3 38 3s8.94 4.13 19.78 10C67 17.94 73 26.27 73 35.7",
        style: {
            fill: "#fbf0df"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M73 35.7a21.7 21.7 0 0 0-.8-5.78c-2.73 33.3-43.35 34.9-59.32 24.94A40 40 0 0 0 38 63.24c19.3 0 35-12.35 35-27.54",
        "data-name": "Bottom Shadow",
        style: {
            fill: "#f6dece"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M24.53 11.17C29 8.49 34.94 3.46 40.78 3.45A9.3 9.3 0 0 0 38 3c-2.42 0-5 1.25-8.25 3.13-1.13.66-2.3 1.39-3.54 2.15-2.33 1.44-5 3.07-8 4.7C8.69 18.13 3 26.62 3 35.7v1.19c6.06-21.41 17.07-23.04 21.53-25.72",
        "data-name": "Light Shine",
        style: {
            fill: "#fffefc"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M35.12 5.53A16.41 16.41 0 0 1 29.49 18c-.28.25-.06.73.3.59 3.37-1.31 7.92-5.23 6-13.14-.08-.45-.67-.33-.67.08m2.27 0A16.24 16.24 0 0 1 39 19c-.12.35.31.65.55.36 2.19-2.8 4.1-8.36-1.62-14.36-.29-.26-.74.14-.54.49Zm2.76-.17A16.42 16.42 0 0 1 47 17.12a.33.33 0 0 0 .65.11c.92-3.49.4-9.44-7.17-12.53-.4-.16-.66.38-.33.62Zm-18.46 10.4a16.94 16.94 0 0 0 10.47-9c.18-.36.75-.22.66.18-1.73 8-7.52 9.67-11.12 9.45-.38.01-.37-.52-.01-.63",
        style: {
            fill: "#ccbea7",
            fillRule: "evenodd"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M38 65.75C17.32 65.75.5 52.27.5 35.7c0-10 6.18-19.33 16.53-24.92 3-1.6 5.57-3.21 7.86-4.62 1.26-.78 2.45-1.51 3.6-2.19C32 1.89 35 .5 38 .5s5.62 1.2 8.9 3.14c1 .57 2 1.19 3.07 1.87 2.49 1.54 5.3 3.28 9 5.27C69.32 16.37 75.5 25.69 75.5 35.7c0 16.57-16.82 30.05-37.5 30.05M38 3c-2.42 0-5 1.25-8.25 3.13-1.13.66-2.3 1.39-3.54 2.15-2.33 1.44-5 3.07-8 4.7C8.69 18.13 3 26.62 3 35.7c0 15.19 15.7 27.55 35 27.55S73 50.89 73 35.7c0-9.08-5.69-17.57-15.22-22.7-3.78-2-6.73-3.88-9.12-5.36-1.09-.67-2.09-1.29-3-1.84C42.63 4 40.42 3 38 3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M45.05 43a8.93 8.93 0 0 1-2.92 4.71 6.8 6.8 0 0 1-4 1.88A6.84 6.84 0 0 1 34 47.71 8.93 8.93 0 0 1 31.12 43a.72.72 0 0 1 .8-.81h12.34a.72.72 0 0 1 .79.81",
        "data-name": "Background",
        style: {
            fill: "#b71422"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M34 47.79a6.9 6.9 0 0 0 4.12 1.9 6.9 6.9 0 0 0 4.11-1.9 11 11 0 0 0 1-1.07 6.83 6.83 0 0 0-4.9-2.31 6.15 6.15 0 0 0-5 2.78c.23.21.43.41.67.6",
        "data-name": "Background",
        style: {
            fill: "#ff6164"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M34.16 47a5.36 5.36 0 0 1 4.19-2.08 6 6 0 0 1 4 1.69c.23-.25.45-.51.66-.77a7 7 0 0 0-4.71-1.93 6.36 6.36 0 0 0-4.89 2.36 10 10 0 0 0 .75.73",
        "data-name": "Outline"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M38.09 50.19a7.42 7.42 0 0 1-4.45-2 9.52 9.52 0 0 1-3.11-5.05 1.2 1.2 0 0 1 .26-1 1.41 1.41 0 0 1 1.13-.51h12.34a1.44 1.44 0 0 1 1.13.51 1.19 1.19 0 0 1 .25 1 9.52 9.52 0 0 1-3.11 5.05 7.42 7.42 0 0 1-4.44 2m-6.17-7.4c-.16 0-.2.07-.21.09a8.3 8.3 0 0 0 2.73 4.37A6.23 6.23 0 0 0 38.09 49a6.28 6.28 0 0 0 3.65-1.73 8.3 8.3 0 0 0 2.72-4.37.21.21 0 0 0-.2-.09Z",
        "data-name": "Outline"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 53.22,
        cy: 40.18,
        "data-name": "Right Blush",
        rx: 5.85,
        ry: 3.44,
        style: {
            fill: "#febbd0"
        }
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 22.95,
        cy: 40.18,
        "data-name": "Left Bluch",
        rx: 5.85,
        ry: 3.44,
        style: {
            fill: "#febbd0"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M25.7 38.8a5.51 5.51 0 1 0-5.5-5.51 5.51 5.51 0 0 0 5.5 5.51m24.77 0A5.51 5.51 0 1 0 45 33.29a5.5 5.5 0 0 0 5.47 5.51",
        style: {
            fillRule: "evenodd"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M24 33.64a2.07 2.07 0 1 0-2.06-2.07A2.07 2.07 0 0 0 24 33.64m24.77 0a2.07 2.07 0 1 0-2.06-2.07 2.07 2.07 0 0 0 2.04 2.07Z",
        style: {
            fill: "#fff",
            fillRule: "evenodd"
        }
    }));

const BuyMeACoffee = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 884 1279",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0D0C22",
        d: "m791.109 297.518-.878-.516-2.03-.619a4.83 4.83 0 0 0 2.908 1.135M803.896 388.891l-.98.275zM791.484 297.377a1.8 1.8 0 0 1-.366-.087 1.4 1.4 0 0 0 0 .244.74.74 0 0 0 .366-.157"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0D0C22",
        d: "M791.113 297.529h.131v-.082zM803.111 388.726l1.48-.843.551-.31.499-.533a8.5 8.5 0 0 0-2.53 1.686M793.669 299.515l-1.446-1.377-.98-.533a4.08 4.08 0 0 0 2.426 1.91M430.019 1186.18a7.55 7.55 0 0 0-2.943 2.27l.912-.58c.62-.57 1.497-1.24 2.031-1.69M641.187 1144.63c0-1.3-.636-1.06-.482 3.58 0-.37.155-.75.224-1.11.086-.83.155-1.64.258-2.47M619.284 1186.18a7.55 7.55 0 0 0-2.942 2.27l.912-.58c.619-.57 1.497-1.24 2.03-1.69M281.304 1196.06a6.3 6.3 0 0 0-3.097-1.45c.929.45 1.858.9 2.477 1.24zM247.841 1164.01a9.9 9.9 0 0 0-1.222-3.85c.474 1.23.87 2.5 1.187 3.78z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FD0",
        d: "M472.623 590.836c-45.941 19.667-98.077 41.966-165.647 41.966a313.6 313.6 0 0 1-83.623-11.528l46.733 479.806a80.17 80.17 0 0 0 25.593 52.38 80.18 80.18 0 0 0 54.313 21.19s66.262 3.44 88.373 3.44c23.796 0 95.151-3.44 95.151-3.44 20.12 0 39.503-7.57 54.303-21.2a80.15 80.15 0 0 0 25.587-52.37l50.053-530.204c-22.368-7.639-44.943-12.715-70.391-12.715-44.014-.017-79.477 15.142-120.445 32.675"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0D0C22",
        d: "m78.689 386.132.79.74.517.31a8 8 0 0 0-1.307-1.05"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0D0C22",
        d: "m879.567 341.849-7.037-35.497c-6.315-31.849-20.648-61.943-53.34-73.454-10.479-3.683-22.369-5.265-30.404-12.888-8.035-7.622-10.41-19.46-12.268-30.438-3.442-20.149-6.676-40.315-10.204-60.429-3.045-17.293-5.454-36.719-13.386-52.583-10.324-21.302-31.746-33.76-53.048-42.001a306 306 0 0 0-33.363-10.324C613.297 10.195 557.342 5.033 502.591 2.09a1376 1376 0 0 0-197.169 3.27c-48.797 4.439-100.193 9.807-146.564 26.687-16.948 6.177-34.413 13.593-47.3 26.687-15.813 16.088-20.975 40.969-9.43 61.031 8.208 14.247 22.111 24.313 36.857 30.972a299 299 0 0 0 59.844 19.478c57.297 12.664 116.642 17.636 175.178 19.753a1334 1334 0 0 0 194.433-6.35 1107 1107 0 0 0 47.817-6.314c18.738-2.874 30.765-27.376 25.242-44.445-6.608-20.406-24.365-28.321-44.444-25.241-2.96.464-5.902.894-8.862 1.324l-2.133.31q-10.204 1.29-20.407 2.409a1083 1083 0 0 1-42.259 3.717c-31.626 2.202-63.337 3.217-95.031 3.269-31.144 0-62.305-.878-93.38-2.925a1187 1187 0 0 1-42.431-3.545 1020 1020 0 0 1-19.219-2.168l-6.092-.774-1.324-.189-6.315-.912c-12.905-1.945-25.81-4.181-38.577-6.883a5.8 5.8 0 0 1 0-11.322h.241c11.064-2.357 22.213-4.37 33.397-6.125q5.593-.878 11.219-1.72h.103c7.003-.465 14.041-1.722 21.009-2.547A1336 1336 0 0 1 469.538 73.1c29.577.86 59.138 2.599 88.578 5.593a979 979 0 0 1 18.927 2.116c2.409.293 4.835.636 7.262.93l4.886.705a678 678 0 0 1 42.517 7.725c20.889 4.543 47.714 6.022 57.005 28.907 2.96 7.261 4.302 15.331 5.936 22.953l2.082 9.722q.082.262.121.533 7.382 34.413 14.78 68.826a12.6 12.6 0 0 1-2.006 9.871 12.61 12.61 0 0 1-8.593 5.254h-.138l-3.011.413-2.976.395q-14.144 1.842-28.322 3.442a1829 1829 0 0 1-55.938 5.506 1957 1957 0 0 1-111.55 6.074q-28.476.757-56.936.705a1976 1976 0 0 1-225.989-13.146c-8.122-.963-16.243-1.996-24.365-3.045 6.298.809-4.577-.62-6.779-.929a1447 1447 0 0 1-15.486-2.254c-17.327-2.599-34.55-5.799-51.843-8.604-20.906-3.441-40.9-1.72-59.81 8.604a87 87 0 0 0-36.012 37.338c-8.156 16.862-10.582 35.221-14.23 53.34C4 342.193-1.678 361.688.473 380.288 5.1 420.431 33.165 453.054 73.53 460.35c37.975 6.882 76.156 12.457 114.44 17.206a2114.8 2114.8 0 0 0 489.988 2.822 25.81 25.81 0 0 1 21.003 7.339 25.8 25.8 0 0 1 7.491 20.948l-3.82 37.132-23.091 225.077a178841 178841 0 0 1-31.126 302.866c-2.203 21.84-2.512 44.36-6.659 65.94-6.539 33.93-29.509 54.77-63.027 62.39a439 439 0 0 1-93.569 10.94c-34.912.19-69.806-1.36-104.718-1.17-37.27.21-82.918-3.23-111.687-30.97-25.277-24.36-28.77-62.51-32.211-95.5q-6.882-65.504-13.645-130.989l-25.293-242.766-16.363-157.077c-.276-2.598-.551-5.162-.809-7.778-1.962-18.737-15.228-37.079-36.134-36.133-17.894.791-38.232 16.002-36.133 36.133l12.13 116.454 25.087 240.89a378681 378681 0 0 1 21.388 205.306c1.377 13.11 2.667 26.26 4.112 39.37 7.864 71.65 62.58 110.26 130.339 121.13 39.575 6.37 80.113 7.68 120.273 8.33 51.482.83 103.48 2.81 154.118-6.52 75.038-13.77 131.337-63.87 139.372-141.59 2.295-22.44 4.589-44.88 6.883-67.33q11.442-111.361 22.85-222.739l24.881-242.61 11.408-111.188a25.812 25.812 0 0 1 20.785-22.696c21.456-4.181 41.967-11.322 57.229-27.651 24.295-25.998 29.13-59.895 20.544-94.067M72.43 365.835c.327-.155-.275 2.649-.533 3.957-.052-1.979.051-3.734.533-3.957m2.082 16.105c.172-.121.688.568 1.222 1.394-.809-.758-1.325-1.325-1.24-1.394zm2.048 2.701c.74 1.256 1.135 2.048 0 0m4.112 3.338h.103c0 .121.19.241.258.362a2.7 2.7 0 0 0-.378-.362zm720.124-4.99c-7.708 7.33-19.323 10.737-30.8 12.441-128.704 19.099-259.283 28.769-389.399 24.502-93.121-3.183-185.261-13.525-277.453-26.55-9.034-1.273-18.824-2.925-25.036-9.584-11.7-12.561-5.953-37.854-2.908-53.03 2.788-13.903 8.122-32.434 24.657-34.413 25.81-3.028 55.783 7.863 81.318 11.735a1540 1540 0 0 0 92.57 11.27c132.18 12.045 266.58 10.169 398.175-7.45a1661 1661 0 0 0 71.699-11.236c21.216-3.803 44.737-10.943 57.556 11.029 8.792 14.97 9.962 34.998 8.603 51.912a28.94 28.94 0 0 1-8.999 19.374z"
    }));

const C = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 306 345",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00599C",
        d: "M302.107 258.262c2.401-4.159 3.893-8.845 3.893-13.053V99.139c0-4.207-1.49-8.892-3.892-13.051L153 172.175z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#004482",
        d: "m166.25 341.193 126.5-73.034c3.644-2.104 6.956-5.737 9.357-9.897L153 172.175 3.893 258.263c2.4 4.159 5.714 7.793 9.357 9.896l126.5 73.034c7.287 4.208 19.213 4.208 26.5 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#659AD2",
        d: "M302.108 86.087c-2.402-4.16-5.715-7.793-9.358-9.897L166.25 3.156c-7.287-4.208-19.213-4.208-26.5 0L13.25 76.19C5.962 80.397 0 90.725 0 99.14v146.069c0 4.208 1.491 8.894 3.893 13.053L153 172.175z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M153 274.175c-56.243 0-102-45.757-102-102s45.757-102 102-102c36.292 0 70.139 19.53 88.331 50.968l-44.143 25.544c-9.105-15.736-26.038-25.512-44.188-25.512-28.122 0-51 22.878-51 51 0 28.121 22.878 51 51 51 18.152 0 35.085-9.776 44.191-25.515l44.143 25.543c-18.192 31.441-52.04 50.972-88.334 50.972"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h306v344.35H0z"
    }))));

const CPlusPlus = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 288",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#649AD2",
        d: "M255.987 84.59c-.002-4.837-1.037-9.112-3.13-12.781-2.054-3.608-5.133-6.632-9.261-9.023-34.08-19.651-68.195-39.242-102.264-58.913-9.185-5.303-18.09-5.11-27.208.27-13.565 8-81.48 46.91-101.719 58.632C4.071 67.6.015 74.984.013 84.58 0 124.101.013 163.62 0 203.141c0 4.73.993 8.923 2.993 12.537 2.056 3.717 5.177 6.824 9.401 9.269 20.24 11.722 88.164 50.63 101.726 58.631 9.121 5.382 18.027 5.575 27.215.27 34.07-19.672 68.186-39.262 102.272-58.913 4.224-2.444 7.345-5.553 9.401-9.267 1.997-3.614 2.992-7.806 2.992-12.539 0 0 0-79.018-.013-118.539"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#004482",
        d: "m128.392 143.476-125.4 72.202c2.057 3.717 5.178 6.824 9.402 9.269 20.24 11.722 88.164 50.63 101.726 58.631 9.121 5.382 18.027 5.575 27.215.27 34.07-19.672 68.186-39.262 102.272-58.913 4.224-2.444 7.345-5.553 9.401-9.267z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1A4674",
        d: "M91.25 164.863c7.297 12.738 21.014 21.33 36.75 21.33 15.833 0 29.628-8.7 36.888-21.576l-36.496-21.141z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#01589C",
        d: "M255.987 84.59c-.002-4.837-1.037-9.112-3.13-12.781l-124.465 71.667 124.616 72.192c1.997-3.614 2.99-7.806 2.992-12.539 0 0 0-79.018-.013-118.539"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M249.135 148.636h-9.738v9.74h-9.74v-9.74h-9.737V138.9h9.737v-9.738h9.74v9.738h9.738v9.737ZM128 58.847c31.135 0 58.358 16.74 73.17 41.709l.444.759-37.001 21.307c-7.333-12.609-20.978-21.094-36.613-21.094-23.38 0-42.333 18.953-42.333 42.332a42.13 42.13 0 0 0 5.583 21.003c7.297 12.738 21.014 21.33 36.75 21.33 15.659 0 29.325-8.51 36.647-21.153l.241-.423 36.947 21.406c-14.65 25.597-42.228 42.851-73.835 42.851-31.549 0-59.084-17.185-73.754-42.707-7.162-12.459-11.26-26.904-11.26-42.307 0-46.95 38.061-85.013 85.014-85.013m75.865 70.314v9.738h9.737v9.737h-9.737v9.74h-9.738v-9.74h-9.738V138.9h9.738v-9.738h9.738Z"
    }));

const CSS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#264de4",
        d: "M71.357 460.819 30.272 0h451.456l-41.129 460.746L255.724 512z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2965f1",
        d: "m405.388 431.408 35.148-393.73H256v435.146z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ebebeb",
        d: "m124.46 208.59 5.065 56.517H256V208.59zm-5.041-57.875H256V94.197H114.281zM256 355.372l-.248.066-62.944-16.996-4.023-45.076h-56.736l7.919 88.741 115.772 32.14.26-.073z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M255.805 208.59v56.517H325.4l-6.56 73.299-63.035 17.013v58.8l115.864-32.112.85-9.549 13.28-148.792 1.38-15.176 10.203-114.393H255.805v56.518h79.639L330.3 208.59z"
    }));

const CSSNew = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": "css-logo-title css-logo-description",
        viewBox: "0 0 1000 1000",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#639",
        d: "M0 0h840a160 160 0 0 1 160 160v680a160 160 0 0 1-160 160H160A160 160 0 0 1 0 840z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M816.54 919.9c-32.39 0-57.16-9.42-74.5-28.35-17.15-19.03-26.08-46.18-26.88-81.64h69.8c.4 31.36 11.42 47.08 33.08 47.08 11.04 0 18.86-3.5 23.37-10.42 4.41-6.9 6.72-17.93 6.72-33.05 0-12.02-3.01-22.04-8.83-29.95a73.2 73.2 0 0 0-29.48-21.14L783.95 750c-23.06-11.02-39.81-24.04-50.14-39.27-10.03-15.13-15.04-36.36-15.04-63.5 0-30.36 8.83-55 26.37-73.94 18.05-18.93 42.62-28.34 74-28.34 30.3 0 53.76 9.31 70.3 27.84 16.85 18.64 25.67 45.28 26.38 80.14h-67.19c.4-11.4-1.9-22.72-6.72-33.06-3.8-7.6-11.23-11.41-22.26-11.41-19.65 0-29.48 11.71-29.48 35.05 0 11.83 2.4 21.04 7.22 28.05A65.2 65.2 0 0 0 822.76 689l24.77 10.92c25.57 11.72 44.02 26.05 55.35 43.38 11.43 17.23 17.05 40.27 17.05 69.12 0 34.56-9.03 61.1-27.38 79.63-18.25 18.53-43.62 27.85-76 27.85Zm-225.42 0c-32.4 0-57.16-9.42-74.51-28.35-17.15-19.03-26.07-46.18-26.87-81.64h69.79c.4 31.36 11.43 47.08 33.1 47.08 11.02 0 18.84-3.5 23.25-10.42 4.52-6.9 6.72-17.93 6.72-33.05 0-12.02-2.9-22.04-8.72-29.95a73.2 73.2 0 0 0-29.48-21.14L558.53 750c-23.07-11.02-39.81-24.04-50.14-39.27-10.03-15.13-15.04-36.36-15.04-63.5 0-30.36 8.82-55 26.37-73.94 18.05-18.93 42.62-28.34 74-28.34 30.29 0 53.75 9.31 70.2 27.84 17.05 18.64 25.77 45.28 26.47 80.14h-67.18c.4-11.4-1.9-22.72-6.72-33.06-3.81-7.6-11.23-11.41-22.26-11.41-19.66 0-29.49 11.71-29.49 35.05 0 11.83 2.41 21.04 7.22 28.05A65.2 65.2 0 0 0 597.33 689l24.77 10.92c25.57 11.72 44.02 26.05 55.36 43.38 11.33 17.23 17.04 40.27 17.04 69.12 0 34.56-9.12 61.1-27.37 79.63s-43.62 27.85-76.01 27.85m-234.75 0c-31.7 0-56.86-8.62-75.51-25.85-18.65-17.12-27.88-42.87-27.88-76.93V648.83c0-33.85 9.83-59.5 29.48-77.13 19.96-17.43 46.13-26.24 78.52-26.24 31.39 0 56.15 9.01 74.5 26.84 18.56 17.93 27.88 44.58 27.88 80.14v13.32h-73.9v-12.92c0-13.72-3.01-23.84-8.83-30.45a26.46 26.46 0 0 0-21.66-10.32c-12.03 0-20.55 4.1-25.37 12.42a79.04 79.04 0 0 0-6.72 36.66v146.26c0 30.55 10.74 46.08 32.1 46.38 10.02 0 17.54-3.61 22.76-10.82a51.74 51.74 0 0 0 7.72-30.46V801.6h73.9v11.42c0 23.74-4.61 43.57-13.94 59.4a88.8 88.8 0 0 1-38.2 35.66 121.46 121.46 0 0 1-54.85 11.82"
    }));

const CSharp = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 -1.43 255.58 290.11",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#a179dc",
        d: "M255.57 84.45c0-4.83-1.04-9.1-3.13-12.76a24.4 24.4 0 0 0-9.24-9C209.17 43.05 175.1 23.5 141.1 3.86c-9.17-5.3-18.06-5.1-27.16.27-13.54 7.98-81.35 46.83-101.55 58.53C4.06 67.5.02 74.87 0 84.44v118.37c0 4.72 1 8.9 2.99 12.51 2.05 3.72 5.17 6.82 9.38 9.26 20.21 11.7 88.02 50.55 101.56 58.53 9.11 5.38 18 5.57 27.17.27 34.02-19.64 68.08-39.2 102.1-58.81a24.33 24.33 0 0 0 9.4-9.25c1.99-3.61 2.98-7.8 2.98-12.52z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#280068",
        d: "M128.18 143.24 2.98 215.33c2.06 3.7 5.18 6.8 9.4 9.25 20.2 11.7 88.01 50.55 101.55 58.53 9.11 5.38 18 5.57 27.17.27 34.02-19.64 68.08-39.2 102.1-58.81a24.33 24.33 0 0 0 9.4-9.25z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#390091",
        d: "M255.57 84.45c0-4.83-1.04-9.1-3.13-12.76l-124.26 71.55 124.41 72.07c2-3.6 2.99-7.79 3-12.51 0 0 0-78.9-.02-118.35"
    }), /*#__PURE__*/ React.createElement("g", {
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M201.9 116.3v13.47h13.47v-13.48h6.73v13.48h13.48v6.73H222.1v13.48h13.48v6.74H222.1v13.47h-6.73V156.7h-13.48v13.48h-6.73V156.7h-13.48v-6.73h13.47V136.5h-13.47v-6.74h13.47v-13.48zm13.47 20.2h-13.48v13.48h13.48z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.46 48.63a94.96 94.96 0 0 1 82.26 47.45l-.16-.27-41.35 23.8A47.28 47.28 0 0 0 129 96.33h-.54a47.3 47.3 0 0 0-47.3 47.3 47.1 47.1 0 0 0 6.23 23.47 47.28 47.28 0 0 0 82.29-.27l-.2.35 41.29 23.91a94.97 94.97 0 0 1-81.25 47.54h-1.06a94.96 94.96 0 0 1-95-95 95 95 0 0 1 95-95"
    })));

const CalcomDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 101 22",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        d: "M10.058 20.817C4.321 20.817 0 16.277 0 10.67 0 5.046 4.1.468 10.058.468c3.163 0 5.351.971 7.061 3.195l-2.758 2.299c-1.158-1.234-2.556-1.85-4.303-1.85-3.88 0-6.013 2.97-6.013 6.558s2.336 6.503 6.013 6.503c1.729 0 3.2-.616 4.358-1.85l2.721 2.392c-1.636 2.13-3.88 3.102-7.079 3.102M29.016 5.886h3.714v14.575h-3.714v-2.13c-.772 1.514-2.06 2.523-4.523 2.523-3.935 0-7.08-3.42-7.08-7.624 0-4.205 3.145-7.624 7.08-7.624 2.445 0 3.75 1.009 4.523 2.522zm.11 7.344c0-2.28-1.563-4.167-4.027-4.167-2.372 0-3.916 1.906-3.916 4.167 0 2.205 1.544 4.167 3.916 4.167 2.446 0 4.027-1.906 4.027-4.167M35.36 0h3.714v20.443H35.36zM40.73 18.518c0-1.196.955-2.205 2.26-2.205a2.18 2.18 0 0 1 2.226 2.205c0 1.233-.938 2.242-2.225 2.242a2.23 2.23 0 0 1-2.262-2.242M59.43 18.107c-1.38 1.681-3.476 2.747-5.958 2.747-4.432 0-7.686-3.42-7.686-7.624 0-4.205 3.254-7.624 7.686-7.624 2.39 0 4.468 1.009 5.847 2.597l-2.868 2.41c-.717-.896-1.655-1.569-2.98-1.569-2.371 0-3.916 1.906-3.916 4.167s1.545 4.167 3.917 4.167c1.434 0 2.427-.747 3.163-1.757zM59.742 13.23c0-4.205 3.255-7.624 7.686-7.624 4.432 0 7.686 3.42 7.686 7.624s-3.254 7.624-7.686 7.624c-4.431-.02-7.686-3.42-7.686-7.624m11.603 0c0-2.28-1.545-4.167-3.917-4.167-2.372-.019-3.916 1.887-3.916 4.167 0 2.26 1.544 4.167 3.916 4.167s3.917-1.906 3.917-4.167M100.232 11.548v8.895h-3.714v-7.98c0-2.522-1.177-3.606-2.942-3.606-1.655 0-2.832.823-2.832 3.607v7.979H87.03v-7.98c0-2.522-1.195-3.606-2.942-3.606-1.655 0-3.108.823-3.108 3.607v7.979h-3.714V5.868h3.714v2.018c.772-1.57 2.17-2.355 4.321-2.355 2.041 0 3.751 1.01 4.69 2.71.937-1.738 2.316-2.71 4.817-2.71 3.052.019 5.424 2.336 5.424 6.017"
    }));

const CalcomLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 101 22",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#292929",
        d: "M10.058 20.817C4.321 20.817 0 16.277 0 10.67 0 5.046 4.1.468 10.058.468c3.163 0 5.351.971 7.061 3.195l-2.758 2.299c-1.158-1.234-2.556-1.85-4.303-1.85-3.88 0-6.013 2.97-6.013 6.558s2.336 6.503 6.013 6.503c1.729 0 3.2-.616 4.358-1.85l2.721 2.392c-1.636 2.13-3.88 3.102-7.079 3.102M29.016 5.886h3.714v14.575h-3.714v-2.13c-.772 1.514-2.06 2.523-4.523 2.523-3.935 0-7.08-3.42-7.08-7.624 0-4.205 3.145-7.624 7.08-7.624 2.445 0 3.75 1.009 4.523 2.522zm.11 7.344c0-2.28-1.563-4.167-4.027-4.167-2.372 0-3.916 1.906-3.916 4.167 0 2.205 1.544 4.167 3.916 4.167 2.446 0 4.027-1.906 4.027-4.167M35.36 0h3.714v20.443H35.36zM40.73 18.518c0-1.196.955-2.205 2.26-2.205a2.18 2.18 0 0 1 2.226 2.205c0 1.233-.938 2.242-2.225 2.242a2.23 2.23 0 0 1-2.262-2.242M59.43 18.107c-1.38 1.681-3.476 2.747-5.958 2.747-4.432 0-7.686-3.42-7.686-7.624 0-4.205 3.254-7.624 7.686-7.624 2.39 0 4.468 1.009 5.847 2.597l-2.868 2.41c-.717-.896-1.655-1.569-2.98-1.569-2.371 0-3.916 1.906-3.916 4.167s1.545 4.167 3.917 4.167c1.434 0 2.427-.747 3.163-1.757zM59.742 13.23c0-4.205 3.255-7.624 7.686-7.624 4.432 0 7.686 3.42 7.686 7.624s-3.254 7.624-7.686 7.624c-4.431-.02-7.686-3.42-7.686-7.624m11.603 0c0-2.28-1.545-4.167-3.917-4.167-2.372-.019-3.916 1.887-3.916 4.167 0 2.26 1.544 4.167 3.916 4.167s3.917-1.906 3.917-4.167M100.232 11.548v8.895h-3.714v-7.98c0-2.522-1.177-3.606-2.942-3.606-1.655 0-2.832.823-2.832 3.607v7.979H87.03v-7.98c0-2.522-1.195-3.606-2.942-3.606-1.655 0-3.108.823-3.108 3.607v7.979h-3.714V5.868h3.714v2.018c.772-1.57 2.17-2.355 4.321-2.355 2.041 0 3.751 1.01 4.69 2.71.937-1.738 2.316-2.71 4.817-2.71 3.052.019 5.424 2.336 5.424 6.017"
    }));

const Calendly = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "prefix__katman_1",
        x: 0,
        y: 0,
        viewBox: "0 0 841.89 595.28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("style", null, ".prefix__st0{fill:#3664ae}.prefix__st1{fill:#5fc2d6}"), /*#__PURE__*/ React.createElement("path", {
        d: "M505.27 365.28c-14.79 12.86-33.19 28.86-66.71 28.86h-20.01c-24.22 0-46.25-8.62-62.01-24.28-15.39-15.3-23.89-36.22-23.89-58.94v-26.87c0-22.72 8.48-43.66 23.89-58.94 15.77-15.66 37.79-24.28 62.01-24.28h20.01c33.51 0 51.92 16 66.71 28.86 15.34 13.34 28.59 24.86 63.89 24.86 5.48 0 10.86-.43 16.09-1.26-.04-.11-.08-.2-.12-.3-2.1-5.1-4.57-10.12-7.42-14.96l-23.6-40.1c-21.65-36.8-61.68-59.46-104.98-59.46h-47.21c-43.3 0-83.33 22.67-104.98 59.46l-23.6 40.1c-21.65 36.8-21.65 82.12 0 118.91l23.6 40.1c21.65 36.8 61.68 59.45 104.98 59.45h47.21c43.3 0 83.33-22.67 104.98-59.45l23.6-40.1c2.85-4.85 5.32-9.85 7.42-14.95.04-.11.08-.2.12-.3-5.23-.83-10.59-1.26-16.09-1.26-35.29-.01-48.55 11.51-63.89 24.85",
        className: "prefix__st0"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M438.57 225.16h-20.01c-36.86 0-61.09 25.83-61.09 58.89v26.87c0 33.06 24.22 58.89 61.09 58.89h20.01c53.71 0 49.49-53.72 130.59-53.72 7.77 0 15.45.7 22.92 2.06a116.5 116.5 0 0 0 0-41.31c-7.48 1.36-15.15 2.06-22.92 2.06-81.1-.01-76.88-53.74-130.59-53.74",
        className: "prefix__st0"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M638.66 337.76c-13.85-10.02-29.74-16.56-46.59-19.64-.03.13-.04.26-.07.39-1.44 7.87-3.69 15.62-6.77 23.14 14.22 2.26 27.32 7.5 38.52 15.55-.04.12-.07.24-.11.37-6.46 20.57-16.2 39.96-28.93 57.6-12.58 17.42-27.79 32.76-45.22 45.57-36.18 26.62-79.27 40.68-124.63 40.68-28.08 0-55.31-5.39-80.94-16.02-24.75-10.27-46.99-24.98-66.11-43.73-19.11-18.75-34.1-40.56-44.57-64.85-10.83-25.14-16.33-51.85-16.33-79.4s5.5-54.26 16.33-79.4c10.47-24.28 25.46-46.1 44.57-64.85s41.35-33.45 66.11-43.73c25.62-10.63 52.85-16.02 80.94-16.02 45.36 0 88.45 14.06 124.63 40.68 17.43 12.82 32.63 28.15 45.22 45.57 12.73 17.65 22.47 37.04 28.93 57.6.04.13.08.25.11.37-11.19 8.04-24.3 13.3-38.52 15.55 3.08 7.53 5.34 15.3 6.77 23.17.03.13.04.25.07.38 16.85-3.08 32.73-9.62 46.59-19.64 13.28-9.64 10.71-20.53 8.69-26.99-29.27-93.21-117.8-160.99-222.48-160.99-128.55 0-232.75 102.22-232.75 228.32s104.21 228.32 232.75 228.32c104.68 0 193.21-67.79 222.48-161.05 2.03-6.42 4.61-17.3-8.69-26.95",
        className: "prefix__st0"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M585.25 253.26c-5.23.83-10.59 1.26-16.09 1.26-35.29 0-48.55-11.52-63.89-24.86-14.79-12.86-33.19-28.86-66.71-28.86h-20.01c-24.22 0-46.25 8.62-62.01 24.28-15.39 15.3-23.89 36.22-23.89 58.94v26.87c0 22.72 8.48 43.66 23.89 58.94 15.77 15.66 37.79 24.28 62.01 24.28h20.01c33.51 0 51.92-16.01 66.71-28.86 15.34-13.34 28.59-24.86 63.89-24.86 5.48 0 10.86.43 16.09 1.26 3.08-7.52 5.32-15.28 6.77-23.14.03-.13.04-.26.07-.39-7.48-1.36-15.15-2.06-22.92-2.06-81.1 0-76.88 53.72-130.59 53.72h-20.01c-36.86 0-61.09-25.83-61.09-58.89v-26.87c0-33.06 24.22-58.89 61.09-58.89h20.01c53.71 0 49.5 53.72 130.59 53.72 7.77 0 15.45-.7 22.92-2.06-.03-.13-.04-.25-.07-.38-1.43-7.85-3.69-15.61-6.77-23.15",
        className: "prefix__st1"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M585.25 253.26c-5.23.83-10.59 1.26-16.09 1.26-35.29 0-48.55-11.52-63.89-24.86-14.79-12.86-33.19-28.86-66.71-28.86h-20.01c-24.22 0-46.25 8.62-62.01 24.28-15.39 15.3-23.89 36.22-23.89 58.94v26.87c0 22.72 8.48 43.66 23.89 58.94 15.77 15.66 37.79 24.28 62.01 24.28h20.01c33.51 0 51.92-16.01 66.71-28.86 15.34-13.34 28.59-24.86 63.89-24.86 5.48 0 10.86.43 16.09 1.26 3.08-7.52 5.32-15.28 6.77-23.14.03-.13.04-.26.07-.39-7.48-1.36-15.15-2.06-22.92-2.06-81.1 0-76.88 53.72-130.59 53.72h-20.01c-36.86 0-61.09-25.83-61.09-58.89v-26.87c0-33.06 24.22-58.89 61.09-58.89h20.01c53.71 0 49.5 53.72 130.59 53.72 7.77 0 15.45-.7 22.92-2.06-.03-.13-.04-.25-.07-.38-1.43-7.85-3.69-15.61-6.77-23.15",
        className: "prefix__st1"
    }));

const Canva = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 80 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#7D2AE7",
        d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M57.27 48.205c-.331 0-.622.279-.924.888-3.414 6.922-9.31 11.82-16.133 11.82-7.89 0-12.776-7.122-12.776-16.96 0-16.668 9.286-26.304 17.443-26.304 3.811 0 6.139 2.395 6.139 6.207 0 4.524-2.57 6.919-2.57 8.514 0 .716.445 1.15 1.328 1.15 3.55 0 7.715-4.078 7.715-9.84 0-5.585-4.862-9.691-13.018-9.691-13.48 0-25.46 12.497-25.46 29.788 0 13.384 7.643 22.23 19.436 22.23 12.517 0 19.754-12.454 19.754-16.497 0-.895-.457-1.305-.935-1.305"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(-49.416 84.778 18.66)scale(61.8733)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6420FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6420FF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(54.703 1.799 25.019)scale(69.7735)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00C4CC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00C4CC",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(-45.195 92.905 16.89)scale(61.1242 28.1118)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6420FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#6420FF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__e",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(66.52 8.14 30.33)scale(62.9836 105.512)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00C4CC",
        stopOpacity: 0.726
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#00C4CC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00C4CC",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h80v80H0z"
    }))));

const Carrd = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 896 896",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 141.569,
        x2: 754.431,
        y1: 143.569,
        y2: 756.431,
        gradientTransform: "matrix(1 0 0 -1 0 898)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#7366a7"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.268,
        style: {
            stopColor: "#6b68aa"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.691,
        style: {
            stopColor: "#546db1"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#3f71b7"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M448 881.3c-239.4 0-433.4-194-433.4-433.3S208.6 14.7 448 14.7s433.4 194 433.4 433.3-194 433.3-433.4 433.3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M661.2 613.1 401.1 738c-1.6.8-3.4 1.2-5.2 1.2-2.2 0-4.4-.6-6.4-1.8-3.5-2.2-5.6-6-5.6-10.2V603.5l-140.5-58.8c-4.5-1.9-7.4-6.2-7.4-11.1V208.8c0-4.1 2.1-8 5.6-10.2s7.9-2.4 11.6-.7l270.4 129.8 127.3-61.1c3.7-1.8 8.1-1.5 11.6.7s5.6 6 5.6 10.2v324.8c-.1 4.6-2.7 8.8-6.9 10.8M260 227.9v297.7l123.9 51.9v-59.8L306 486.3c-6.1-2.5-9.1-9.5-6.7-15.6 2.5-6.2 9.5-9.1 15.6-6.7l69 27.8v-49.1L306 411.3c-6.1-2.5-9.1-9.5-6.7-15.6 2.5-6.2 9.5-9.1 15.6-6.7l69 27.8v-14.3c0-4.6 2.6-8.8 6.8-10.8l17.8-8.6-103.1-46.9c-6-2.7-8.7-9.9-6-15.9s9.9-8.7 15.9-6l121.3 55.3 59.1-28.4zm384 68.7L407.9 410v298.2L644 594.7zM453 451.8l135.3-65.4c6-2.9 13.1-.4 16 5.6s.4 13.2-5.6 16l-135.3 65.4c-1.7.8-3.5 1.2-5.2 1.2-4.5 0-8.7-2.5-10.8-6.8-2.8-5.9-.3-13.1 5.6-16m0 75 135.3-65.4c6-2.9 13.1-.4 16 5.6s.4 13.2-5.6 16l-135.3 65.4c-1.7.8-3.5 1.2-5.2 1.2-4.5 0-8.7-2.5-10.8-6.8-2.8-6-.3-13.1 5.6-16m0 74.9 135.3-65.4c6-2.9 13.1-.4 16 5.6s.4 13.2-5.6 16l-135.3 65.4c-1.7.8-3.5 1.2-5.2 1.2-4.5 0-8.7-2.5-10.8-6.8-2.8-5.9-.3-13.1 5.6-16"
    }));

const ChakraUI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 257 257",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 257,
        height: 257,
        fill: "url(#prefix__a)",
        rx: 128.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m69.558 133.985 87.592-86.99c1.636-1.624 4.27.353 3.165 2.378l-32.601 59.752c-.728 1.332.237 2.958 1.755 2.958h56.34c1.815 0 2.691 2.223 1.364 3.462l-98.728 92.142c-1.77 1.652-4.405-.676-2.984-2.636l46.736-64.473c.958-1.322.014-3.174-1.619-3.174h-59.61c-1.786 0-2.677-2.161-1.41-3.419"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 128.5,
        x2: 128.5,
        y2: 257,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#7BCBD4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#29C6B7"
    }))));

const Chartjs = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 296",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#36A2EB",
        d: "M248.572 148.807c-41.32.811-32.713 26.969-61.833 33.584-29.582 6.72-34.252-72.248-63.826-72.248-29.579 0-36.13 76.709-73.166 129.37l-1.057 1.491 79.404 45.836 120.478-69.551z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFCE56",
        d: "M248.572 146.426c-13.832-17.752-23.214-38.16-43.4-38.16-35.72 0-26.32 58.271-65.798 58.271-39.482 0-43.633-62.679-88.358-3.759-14.252 18.774-25.723 39.707-34.734 59.515l111.812 64.549 120.478-69.551z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FE6184",
        d: "M7.613 170.564c13.555-37.538 19.405-67.94 45.283-67.94 39.478 0 48.875 110.908 82.718 99.625 33.838-11.278 30.077-71.432 82.719-71.432 10.02 0 20.25 6.138 30.241 16.067v70.405l-120.478 69.55L7.613 217.29v-46.725Z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E7E9ED",
        d: "M128 295.56 0 221.673V73.89L128 0l128 73.89v147.78zM15.039 212.99 128 278.2l112.961-65.21V82.572L128 17.362 15.039 82.572z"
    }));

const Chrome = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 190.5 190.5",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M95.252 142.873c26.304 0 47.627-21.324 47.627-47.628s-21.323-47.628-47.627-47.628-47.627 21.324-47.627 47.628 21.323 47.628 47.627 47.628"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#229342",
        d: "m54.005 119.07-41.24-71.43a95.23 95.23 0 0 0-.003 95.25 95.23 95.23 0 0 0 82.496 47.61l41.24-71.43v-.011a47.6 47.6 0 0 1-17.428 17.443 47.62 47.62 0 0 1-47.632.007 47.6 47.6 0 0 1-17.433-17.437z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fbc116",
        d: "m136.495 119.067-41.239 71.43a95.23 95.23 0 0 0 82.489-47.622A95.24 95.24 0 0 0 190.5 95.248a95.24 95.24 0 0 0-12.772-47.623H95.249l-.01.007a47.6 47.6 0 0 1 23.819 6.372 47.6 47.6 0 0 1 17.439 17.431 47.62 47.62 0 0 1-.001 47.633z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1a73e8",
        d: "M95.252 132.961c20.824 0 37.705-16.881 37.705-37.706S116.076 57.55 95.252 57.55 57.547 74.431 57.547 95.255s16.881 37.706 37.705 37.706"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#e33b2e",
        d: "M95.252 47.628h82.479A95.24 95.24 0 0 0 142.87 12.76 95.23 95.23 0 0 0 95.245 0a95.2 95.2 0 0 0-47.623 12.767 95.23 95.23 0 0 0-34.856 34.872l41.24 71.43.011.006a47.62 47.62 0 0 1-.015-47.633 47.61 47.61 0 0 1 41.252-23.815z"
    }));

const Chromium = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 511.985 511.985",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__f",
        x1: 0.465,
        x2: 0.557,
        y1: -0.674,
        y2: 0.811,
        gradientTransform: "matrix(231.62575 0 0 231.62472 111.11 159.994)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#1972e7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1969d5"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__b",
        id: "prefix__e",
        x1: 101.744,
        x2: 101.599,
        y1: 33.726,
        y2: 135.466,
        gradientTransform: "matrix(3.77942 0 0 3.7794 .002 .004)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x2: 1,
        gradientTransform: "translate(29.399 42.333)scale(61.286)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#afccfb"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#8bb5f8"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__c",
        id: "prefix__g",
        x1: 0.018,
        x2: 1.77,
        y1: -0.512,
        y2: 0.499,
        gradientTransform: "matrix(94.93156 164.42687 -164.4276 94.93114 97.556 173.61)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x2: 1,
        gradientTransform: "scale(50.236)rotate(60 -.535 .902)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#659cf6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4285f4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__d",
        id: "prefix__h",
        x1: 67.452,
        x2: 67.733,
        y1: 40.321,
        y2: 95.25,
        gradientTransform: "matrix(3.77942 0 0 3.7794 .002 .004)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#3680f0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#2678ec"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "m255.993 255.994 110.85 63.997-110.85 191.994c141.38 0 255.992-114.61 255.992-255.99 0-46.642-12.536-90.332-34.331-127.998H255.99z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M255.99 0C161.24 0 78.578 51.513 34.313 128.027L145.14 319.991l110.85-63.997V127.997h221.664C433.382 51.502 350.729 0 255.99 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M.002 255.994c0 141.38 114.607 255.99 255.991 255.99l110.85-191.993-110.85-63.997-110.85 63.997L34.315 128.027C12.53 165.682 0 209.357 0 255.991"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M383.99 255.994c0 70.69-57.306 127.997-127.997 127.997-70.69 0-127.998-57.307-127.998-127.997s57.308-127.997 127.998-127.997 127.998 57.307 127.998 127.997"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M359.992 255.994c0 57.436-46.563 103.998-103.999 103.998S151.995 313.43 151.995 255.994c0-57.435 46.562-103.998 103.998-103.998s103.999 46.563 103.999 103.998"
    }));

const CiscoDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 52 28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M51.23 8.377a1.112 1.112 0 0 0-2.223 0v2.337a1.112 1.112 0 1 0 2.222 0zm-6.116-3.07c0-.614-.497-1.112-1.126-1.112a1.11 1.11 0 0 0-1.11 1.112v5.405c0 .616.496 1.115 1.11 1.115.63 0 1.126-.499 1.126-1.115zM38.985 1.11A1.11 1.11 0 0 0 37.875 0a1.11 1.11 0 0 0-1.113 1.11v11.82a1.112 1.112 0 1 0 2.223 0zm-6.13 4.197a1.11 1.11 0 1 0-2.221 0v5.405a1.111 1.111 0 1 0 2.221 0zm-6.13 3.07a1.11 1.11 0 0 0-1.105-1.111c-.616 0-1.117.498-1.117 1.11v2.338a1.11 1.11 0 1 0 2.223 0zm-6.115-3.07c0-.614-.502-1.112-1.116-1.112s-1.116.498-1.116 1.112v5.405a1.116 1.116 0 0 0 2.232 0zM14.48 1.11a1.114 1.114 0 0 0-2.23 0v11.82a1.116 1.116 0 0 0 2.23 0zM8.356 5.307a1.115 1.115 0 0 0-2.23 0v5.405a1.116 1.116 0 0 0 2.23 0zM2.23 8.377a1.115 1.115 0 0 0-2.23 0v2.337a1.115 1.115 0 0 0 2.23 0zm23.025 9.69c-.069-.018-1.096-.286-2.19-.286-2.07 0-3.318 1.12-3.318 2.783 0 1.476 1.043 2.21 2.297 2.605.138.047.342.109.477.155.56.175 1.002.436 1.002.887 0 .504-.514.83-1.63.83-.982 0-1.924-.28-2.124-.33v2.05c.112.024 1.23.242 2.426.242 1.718 0 3.685-.751 3.685-2.987 0-1.084-.664-2.083-2.121-2.547l-.62-.197c-.37-.117-1.03-.306-1.03-.848 0-.43.49-.73 1.39-.73.777 0 1.721.261 1.756.274zm16.662 1.98c1.329 0 2.322 1.048 2.322 2.342 0 1.293-.993 2.342-2.322 2.342-1.335 0-2.324-1.049-2.324-2.342s.99-2.342 2.324-2.342m4.703 2.343c0-2.546-1.966-4.609-4.702-4.609-2.74 0-4.705 2.064-4.705 4.609s1.966 4.608 4.705 4.608c2.736 0 4.702-2.064 4.702-4.608m-35.219-4.292c-.21-.06-.992-.317-2.049-.317-2.732 0-4.74 1.947-4.74 4.609 0 2.867 2.215 4.608 4.74 4.608 1.004 0 1.77-.237 2.05-.316v-2.39c-.097.054-.831.472-1.89.472-1.495 0-2.46-1.053-2.46-2.374 0-1.366 1.007-2.375 2.46-2.375 1.077 0 1.8.428 1.89.474zm23.446 0c-.212-.06-.993-.317-2.048-.317-2.737 0-4.742 1.947-4.742 4.609 0 2.867 2.216 4.608 4.742 4.608.998 0 1.766-.237 2.048-.316v-2.39c-.099.054-.833.472-1.889.472-1.495 0-2.46-1.053-2.46-2.374 0-1.366 1.007-2.375 2.46-2.375 1.074 0 1.8.428 1.889.474zM14.489 26.84h2.247v-8.904h-2.247z",
        clipRule: "evenodd"
    }));

const CiscoLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 52 28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00bceb",
        fillRule: "evenodd",
        d: "M51.23 8.377a1.112 1.112 0 0 0-2.223 0v2.337a1.112 1.112 0 1 0 2.222 0zm-6.116-3.07c0-.614-.497-1.112-1.126-1.112a1.11 1.11 0 0 0-1.11 1.112v5.405c0 .616.496 1.115 1.11 1.115.63 0 1.126-.499 1.126-1.115zM38.985 1.11A1.11 1.11 0 0 0 37.875 0a1.11 1.11 0 0 0-1.113 1.11v11.82a1.112 1.112 0 1 0 2.223 0zm-6.13 4.197a1.11 1.11 0 1 0-2.221 0v5.405a1.111 1.111 0 1 0 2.221 0zm-6.13 3.07a1.11 1.11 0 0 0-1.105-1.111c-.616 0-1.117.498-1.117 1.11v2.338a1.11 1.11 0 1 0 2.223 0zm-6.115-3.07c0-.614-.502-1.112-1.116-1.112s-1.116.498-1.116 1.112v5.405a1.116 1.116 0 0 0 2.232 0zM14.48 1.11a1.114 1.114 0 0 0-2.23 0v11.82a1.116 1.116 0 0 0 2.23 0zM8.356 5.307a1.115 1.115 0 0 0-2.23 0v5.405a1.116 1.116 0 0 0 2.23 0zM2.23 8.377a1.115 1.115 0 0 0-2.23 0v2.337a1.115 1.115 0 0 0 2.23 0zm23.025 9.69c-.069-.018-1.096-.286-2.19-.286-2.07 0-3.318 1.12-3.318 2.783 0 1.476 1.043 2.21 2.297 2.605.138.047.342.109.477.155.56.175 1.002.436 1.002.887 0 .504-.514.83-1.63.83-.982 0-1.924-.28-2.124-.33v2.05c.112.024 1.23.242 2.426.242 1.718 0 3.685-.751 3.685-2.987 0-1.084-.664-2.083-2.121-2.547l-.62-.197c-.37-.117-1.03-.306-1.03-.848 0-.43.49-.73 1.39-.73.777 0 1.721.261 1.756.274zm16.662 1.98c1.329 0 2.322 1.048 2.322 2.342 0 1.293-.993 2.342-2.322 2.342-1.335 0-2.324-1.049-2.324-2.342s.99-2.342 2.324-2.342m4.703 2.343c0-2.546-1.966-4.609-4.702-4.609-2.74 0-4.705 2.064-4.705 4.609s1.966 4.608 4.705 4.608c2.736 0 4.702-2.064 4.702-4.608m-35.219-4.292c-.21-.06-.992-.317-2.049-.317-2.732 0-4.74 1.947-4.74 4.609 0 2.867 2.215 4.608 4.74 4.608 1.004 0 1.77-.237 2.05-.316v-2.39c-.097.054-.831.472-1.89.472-1.495 0-2.46-1.053-2.46-2.374 0-1.366 1.007-2.375 2.46-2.375 1.077 0 1.8.428 1.89.474zm23.446 0c-.212-.06-.993-.317-2.048-.317-2.737 0-4.742 1.947-4.742 4.609 0 2.867 2.216 4.608 4.742 4.608.998 0 1.766-.237 2.048-.316v-2.39c-.099.054-.833.472-1.889.472-1.495 0-2.46-1.053-2.46-2.374 0-1.366 1.007-2.375 2.46-2.375 1.074 0 1.8.428 1.889.474zM14.489 26.84h2.247v-8.904h-2.247z",
        clipRule: "evenodd"
    }));

const ClaudeAI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 257",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#D97757",
        d: "m50.228 170.321 50.357-28.257.843-2.463-.843-1.361h-2.462l-8.426-.518-28.775-.778-24.952-1.037-24.175-1.296-6.092-1.297L0 125.796l.583-3.759 5.12-3.434 7.324.648 16.202 1.101 24.304 1.685 17.629 1.037 26.118 2.722h4.148l.583-1.685-1.426-1.037-1.101-1.037-25.147-17.045-27.22-18.017-14.258-10.37-7.713-5.25-3.888-4.925-1.685-10.758 7-7.713 9.397.649 2.398.648 9.527 7.323 20.35 15.75L94.817 91.9l3.889 3.24 1.555-1.102.195-.777-1.75-2.917-14.453-26.118-15.425-26.572-6.87-11.018-1.814-6.61c-.648-2.723-1.102-4.991-1.102-7.778l7.972-10.823L71.42 0l10.63 1.426 4.472 3.888 6.61 15.101 10.694 23.786 16.591 32.34 4.861 9.592 2.592 8.879.973 2.722h1.685v-1.556l1.36-18.211 2.528-22.36 2.463-28.776.843-8.1 4.018-9.722 7.971-5.25 6.222 2.981 5.12 7.324-.713 4.73-3.046 19.768-5.962 30.98-3.889 20.739h2.268l2.593-2.593 10.499-13.934 17.628-22.036 7.778-8.749 9.073-9.657 5.833-4.601h11.018l8.1 12.055-3.628 12.443-11.342 14.388-9.398 12.184-13.48 18.147-8.426 14.518.778 1.166 2.01-.194 30.46-6.481 16.462-2.982 19.637-3.37 8.88 4.148.971 4.213-3.5 8.62-20.998 5.184-24.628 4.926-36.682 8.685-.454.324.519.648 16.526 1.555 7.065.389h17.304l32.21 2.398 8.426 5.574 5.055 6.805-.843 5.184-12.962 6.611-17.498-4.148-40.83-9.721-14-3.5h-1.944v1.167l11.666 11.406 21.387 19.314 26.767 24.887 1.36 6.157-3.434 4.86-3.63-.518-23.526-17.693-9.073-7.972-20.545-17.304h-1.36v1.814l4.73 6.935 25.017 37.59 1.296 11.536-1.814 3.76-6.481 2.268-7.13-1.297-14.647-20.544-15.1-23.138-12.185-20.739-1.49.843-7.194 77.448-3.37 3.953-7.778 2.981-6.48-4.925-3.436-7.972 3.435-15.749 4.148-20.544 3.37-16.333 3.046-20.285 1.815-6.74-.13-.454-1.49.194-15.295 20.999-23.267 31.433-18.406 19.702-4.407 1.75-7.648-3.954.713-7.064 4.277-6.286 25.47-32.405 15.36-20.092 9.917-11.6-.065-1.686h-.583L44.07 198.125l-12.055 1.555-5.185-4.86.648-7.972 2.463-2.593 20.35-13.999z"
    }));

const ClerkDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m21.47 20.829-2.881-2.881a.57.57 0 0 0-.7-.084 6.85 6.85 0 0 1-7.081 0 .576.576 0 0 0-.7.084l-2.881 2.881a.576.576 0 0 0-.103.69.6.6 0 0 0 .166.186 12 12 0 0 0 14.113 0 .58.58 0 0 0 .239-.423.58.58 0 0 0-.172-.453m.002-17.668-2.88 2.88a.57.57 0 0 1-.701.084A6.857 6.857 0 0 0 8.724 8.08a6.86 6.86 0 0 0-1.222 3.692 6.86 6.86 0 0 0 .978 3.764.57.57 0 0 1-.083.699l-2.881 2.88a.567.567 0 0 1-.864-.063A11.993 11.993 0 0 1 6.771 2.7a11.99 11.99 0 0 1 14.637-.405.57.57 0 0 1 .232.418.57.57 0 0 1-.168.448m-7.118 12.261a3.427 3.427 0 1 0 0-6.854 3.427 3.427 0 0 0 0 6.854"
    }));

const ClerkLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#111",
        d: "m21.47 20.829-2.881-2.881a.57.57 0 0 0-.7-.084 6.85 6.85 0 0 1-7.081 0 .576.576 0 0 0-.7.084l-2.881 2.881a.576.576 0 0 0-.103.69.6.6 0 0 0 .166.186 12 12 0 0 0 14.113 0 .58.58 0 0 0 .239-.423.58.58 0 0 0-.172-.453m.002-17.668-2.88 2.88a.57.57 0 0 1-.701.084A6.857 6.857 0 0 0 8.724 8.08a6.86 6.86 0 0 0-1.222 3.692 6.86 6.86 0 0 0 .978 3.764.57.57 0 0 1-.083.699l-2.881 2.88a.567.567 0 0 1-.864-.063A11.993 11.993 0 0 1 6.771 2.7a11.99 11.99 0 0 1 14.637-.405.57.57 0 0 1 .232.418.57.57 0 0 1-.168.448m-7.118 12.261a3.427 3.427 0 1 0 0-6.854 3.427 3.427 0 0 0 0 6.854"
    }));

const Cloudflare = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 116",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m202.357 49.394-5.311-2.124C172.085 103.434 72.786 69.289 66.81 85.997c-.996 11.286 54.227 2.146 93.706 4.059 12.039.583 18.076 9.671 12.964 24.484l10.069.031c11.615-36.209 48.683-17.73 50.232-29.68-2.545-7.857-42.601 0-31.425-35.497Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F4811F",
        d: "M176.332 108.348c1.593-5.31 1.062-10.622-1.593-13.809s-6.374-5.31-11.154-5.842L71.17 87.634c-.531 0-1.062-.53-1.593-.53q-.797-.798 0-1.594c.531-1.062 1.062-1.594 2.124-1.594l92.946-1.062c11.154-.53 22.839-9.56 27.087-20.182l5.312-13.809c0-.532.531-1.063 0-1.594C191.203 20.182 166.772 0 138.091 0 111.535 0 88.697 16.995 80.73 40.896c-5.311-3.718-11.684-5.843-19.12-5.31-12.747 1.061-22.838 11.683-24.432 24.43-.531 3.187 0 6.374.532 9.56C16.996 70.107 0 87.103 0 108.348c0 2.124 0 3.718.531 5.842 0 1.063 1.062 1.594 1.594 1.594h170.489c1.062 0 2.125-.53 2.125-1.594z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FAAD3F",
        d: "M205.544 48.863h-2.656c-.531 0-1.062.53-1.593 1.062l-3.718 12.747c-1.593 5.31-1.062 10.623 1.594 13.809 2.655 3.187 6.373 5.31 11.153 5.843l19.652 1.062c.53 0 1.062.53 1.593.53q.795.798 0 1.594c-.531 1.063-1.062 1.594-2.125 1.594l-20.182 1.062c-11.154.53-22.838 9.56-27.087 20.182l-1.063 4.78c-.531.532 0 1.594 1.063 1.594h70.108q1.593 0 1.593-1.593c1.062-4.25 2.124-9.03 2.124-13.81 0-27.618-22.838-50.456-50.456-50.456"
    }));

const CloudflareWorkers = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 231",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "25.7%",
        y1: "100%",
        y2: "8.7%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#EB6F07"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FAB743"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "81%",
        x2: "40.5%",
        y1: "83.7%",
        y2: "29.5%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#D96504"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#D96504",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "42%",
        x2: "84%",
        y1: "8.7%",
        y2: "79.9%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#EB6F07"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#EB720A",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "50%",
        x2: "25.7%",
        y1: "100%",
        y2: "8.7%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#EE6F05"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FAB743"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: "-33.2%",
        x2: "91.7%",
        y1: "100%",
        y2: "0%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#D96504",
        stopOpacity: 0.8
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "49.8%",
        stopColor: "#D96504",
        stopOpacity: 0.2
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#D96504",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "50%",
        x2: "25.7%",
        y1: "100%",
        y2: "8.7%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA95F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFEBC8"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: "8.1%",
        x2: "96.5%",
        y1: "1.1%",
        y2: "48.8%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: "-13.7%",
        x2: "100%",
        y1: "104.2%",
        y2: "46.2%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.1
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m65.82 3.324 30.161 54.411-27.698 49.857a16 16 0 0 0 0 15.573l27.698 49.98-30.16 54.411a32 32 0 0 1-13.542-12.74L4.27 131.412a32.13 32.13 0 0 1 0-32.007l48.01-83.403a32 32 0 0 1 13.542-12.68Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M68.283 107.654a16 16 0 0 0 0 15.51l27.698 49.98-30.16 54.412a32 32 0 0 1-13.542-12.74L4.27 131.412c-3.816-6.586 17.542-14.465 64.014-23.698v-.061Z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m68.898 8.802 27.083 48.933-4.493 7.818-23.882-40.44c-6.894-11.264-17.42-5.416-30.591 17.358l1.97-3.386 13.294-23.082a32 32 0 0 1 13.419-12.68l3.139 5.479z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "m203.696 16.003 48.01 83.403c5.725 9.848 5.725 22.159 0 32.007l-48.01 83.402a32.01 32.01 0 0 1-27.698 16.004h-48.01l59.705-107.654a16 16 0 0 0 0-15.511L127.988 0h48.01a32.01 32.01 0 0 1 27.698 16.003"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "m173.536 230.45-47.395.43 57.367-108.208a16.62 16.62 0 0 0 0-15.634L126.14 0h10.834l60.197 106.546a16.62 16.62 0 0 1-.062 16.496 9617 9617 0 0 0-38.592 67.707c-11.695 20.558-6.648 33.791 15.018 39.7Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M79.978 230.819c-4.924 0-9.849-1.17-14.157-3.263l59.212-106.792a11.05 11.05 0 0 0 0-10.71L65.821 3.324A32 32 0 0 1 79.978 0h48.01l59.705 107.654a16 16 0 0 1 0 15.51L127.988 230.82h-48.01Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M183.508 110.054 122.448 0h5.54l59.705 107.654a16 16 0 0 1 0 15.51L127.988 230.82h-5.54l61.06-110.055a11.05 11.05 0 0 0 0-10.71Z",
        opacity: 0.6
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M125.033 110.054 65.821 3.324c1.846-.985 4.062-1.724 6.155-2.34 13.049 23.452 32.315 59.029 57.859 106.67a16 16 0 0 1 0 15.51L71.053 229.589c-2.093-.616-3.201-1.047-5.17-1.97l59.089-106.792a11.05 11.05 0 0 0 0-10.71z",
        opacity: 0.6
    }));

const Cloudinary = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 168",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#3448C5",
        d: "M75.06 75.202a.7.7 0 0 1 .498.208l23.56 23.581a.7.7 0 0 1-.488 1.188h-6.022a.72.72 0 0 0-.721.7v53.015a12.72 12.72 0 0 0 3.71 8.949l3.52 3.52a.7.7 0 0 1-.487 1.187H70.85c-7.027 0-12.723-5.696-12.723-12.723v-53.948a.7.7 0 0 0-.7-.7h-5.938a.7.7 0 0 1-.509-1.188l23.581-23.58a.7.7 0 0 1 .499-.21Zm52.103 13.656a.7.7 0 0 1 .498.209l23.581 23.496a.7.7 0 0 1-.509 1.188h-6.022a.72.72 0 0 0-.7.72v39.423a12.72 12.72 0 0 0 3.69 8.949l3.541 3.52a.7.7 0 0 1-.509 1.187h-27.716c-7.027 0-12.724-5.696-12.724-12.723v-40.313a.72.72 0 0 0-.7-.721h-6a.7.7 0 0 1-.488-1.188l23.56-23.538a.7.7 0 0 1 .498-.209m52.114 13.51c.183 0 .36.075.487.207l23.581 23.56a.7.7 0 0 1-.487 1.209h-6.044a.7.7 0 0 0-.7.7v25.85a12.72 12.72 0 0 0 3.711 8.949l3.52 3.52a.7.7 0 0 1-.487 1.187h-27.801c-7.027 0-12.724-5.696-12.724-12.723v-26.784a.7.7 0 0 0-.7-.7h-5.937a.7.7 0 0 1-.488-1.208l23.58-23.56a.68.68 0 0 1 .489-.207M126.686-.002c37.04.27 69.71 24.323 80.964 59.614 27.51 3.59 48.15 26.928 48.35 54.668 0 22.895-14.319 41.921-37.438 49.842l-.86.289-1.06.339v-17.092c14.695-6.192 23.326-18.428 23.326-33.378-.075-21.097-16.782-38.323-37.78-39.126l-.709-.02h-6.361l-1.527-6.066c-7.494-30.93-35.08-52.79-66.905-53.015a68.18 68.18 0 0 0-61.576 38.23l-2.36 4.861-4.454.467c-20.112 2.151-36.627 16.862-41.08 36.593-4.39 19.449 3.898 39.527 20.646 50.231l.734.46v18.025h-.106l-1.59-.721C11.744 152.636-2.99 126.08.51 98.616c3.502-27.463 24.428-49.474 51.68-54.358C66.912 16.851 95.575-.177 126.686-.002"
    }));

const Cobol = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 300 300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#005CA5",
        d: "M208.5 61.368a41.7 41.7 0 0 0 16.547-23.643 43.5 43.5 0 0 1-.169 20.221c-2.091 5.457-5.316 10.379-7.819 15.647A204 204 0 0 1 259.8 46.05c-4.519 13.95-17.072 22.387-26.297 33.093 1.781 3.835 2.625 9.272 7.5 10.397a47.2 47.2 0 0 0 23.437 1.453c8.55-2.934 12.61-11.793 16.875-19.078v13.772a148 148 0 0 1-5.456 16.388c1.875 5.128 3.834 10.237 5.456 15.44v8.925c-2.006 3.45-4.143 6.806-6.215 10.21a49.6 49.6 0 0 0-10.013-10.894 37.8 37.8 0 0 0-17.353-1.172 30.12 30.12 0 0 0 22.622 13.781c-3.366 3.469-6.216 8.55-11.531 9.085-15.385 2.315-30.066-4.735-45.366-4.688-2.644.188-6.628.225-7.359 3.488 0 6.89 2.034 13.621 1.781 20.512-.553 11.794-4.8 23.119-4.959 34.931a129.2 129.2 0 0 0 7.856 32.325c-4.903-.722-9.788-1.556-14.644-2.437-.937 1.95-1.725 3.937-2.437 5.944a42.3 42.3 0 0 0 10.678 11.203 540 540 0 0 0-2.26 4.762l-5.372 1.294a413 413 0 0 1-3.75 6.928 41.45 41.45 0 0 0-20.625.572 1076 1076 0 0 1-13.021-5.316 55.7 55.7 0 0 0 3.815-21.703c-2.644-9.206-15-9.225-18.75-17.597a58.44 58.44 0 0 1-9.581-26.728c-7.716-4.059-13.641-11.447-22.5-13.125-.45 3.835-.778 7.688-1.434 11.503a56.4 56.4 0 0 1-12.638 22.557c.366 3.956.74 7.893 1.125 11.859a1483 1483 0 0 1 9.684 9.131A91.4 91.4 0 0 1 95.7 239.55a104 104 0 0 1-15.816.721c-2.419-2.381-4.856-4.762-7.284-7.162a45.67 45.67 0 0 0 1.069-24.45c1.603-3.75 3.056-7.613 4.453-11.447a52.17 52.17 0 0 1-28.22 1.931A48 48 0 0 1 19.06 158.55a36.18 36.18 0 0 1 13.19-30.638A60.1 60.1 0 0 0 30 152.428a28.48 28.48 0 0 0 23.438 23.118 32.45 32.45 0 0 0 18.375-6.028 70.13 70.13 0 0 1 3.403-38.747 51.79 51.79 0 0 1 33.619-24.937 39.7 39.7 0 0 0 18.853-14.681 100 100 0 0 1 14.335-12.469c-2.138-2.053-4.247-4.125-6.375-6.178a20.19 20.19 0 0 0 13.415-16.04c12.038-2.813 23.916-6.198 35.813-9.479a35.6 35.6 0 0 0 13.265 5.681c2.972 3.244 4.632 10.847 10.313 8.7m-35.41 125.269c.394 7.2-.45 15.609 6.319 20.203 0-7.078-.431-14.128-.937-21.187z"
    }));

const Codesandbox = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 600 600",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#DCFF50",
        fillRule: "evenodd",
        d: "M150 150h299.832v300H150zm269.168 30.682v238.636H180.665V180.682z",
        clipRule: "evenodd"
    }));

const Codium = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 170",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(-93.94978 -1.31187 1.91351 -137.03592 119.07 85.05)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6447FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.067,
        stopColor: "#6348FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.133,
        stopColor: "#614DFC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#5C54F8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.267,
        stopColor: "#565EF3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#4E6CEC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#447BE4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.467,
        stopColor: "#3A8DDB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.533,
        stopColor: "#2F9FD1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#25B1C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopColor: "#1BC0C0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.733,
        stopColor: "#13CEB9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#0DD8B4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.867,
        stopColor: "#08DFB0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.933,
        stopColor: "#06E4AE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#05E5AD"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(-50.24352 -14.35492 14.75776 -51.65347 180.635 22.73)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6447FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.067,
        stopColor: "#6348FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.133,
        stopColor: "#614DFC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#5C54F8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.267,
        stopColor: "#565EF3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#4E6CEC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#447BE4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.467,
        stopColor: "#3A8DDB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.533,
        stopColor: "#2F9FD1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#25B1C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopColor: "#1BC0C0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.733,
        stopColor: "#13CEB9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#0DD8B4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.867,
        stopColor: "#08DFB0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.933,
        stopColor: "#06E4AE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#05E5AD"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(-50.24352 -14.35492 14.75776 -51.65347 180.635 159.67)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6447FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.067,
        stopColor: "#6348FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.133,
        stopColor: "#614DFC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#5C54F8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.267,
        stopColor: "#565EF3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#4E6CEC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#447BE4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.467,
        stopColor: "#3A8DDB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.533,
        stopColor: "#2F9FD1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#25B1C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopColor: "#1BC0C0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.733,
        stopColor: "#13CEB9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#0DD8B4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.867,
        stopColor: "#08DFB0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.933,
        stopColor: "#06E4AE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#05E5AD"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(-45.96601 -20.03622 29.70752 -68.1534 226.095 157.52)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6447FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.067,
        stopColor: "#6348FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.133,
        stopColor: "#614DFC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#5C54F8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.267,
        stopColor: "#565EF3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#4E6CEC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#447BE4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.467,
        stopColor: "#3A8DDB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.533,
        stopColor: "#2F9FD1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#25B1C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopColor: "#1BC0C0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.733,
        stopColor: "#13CEB9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#0DD8B4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.867,
        stopColor: "#08DFB0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.933,
        stopColor: "#06E4AE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#05E5AD"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__e",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(-45.96601 -20.03622 29.70752 -68.1534 226.095 31.103)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6447FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.067,
        stopColor: "#6348FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.133,
        stopColor: "#614DFC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#5C54F8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.267,
        stopColor: "#565EF3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#4E6CEC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#447BE4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.467,
        stopColor: "#3A8DDB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.533,
        stopColor: "#2F9FD1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#25B1C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopColor: "#1BC0C0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.733,
        stopColor: "#13CEB9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#0DD8B4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.867,
        stopColor: "#08DFB0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.933,
        stopColor: "#06E4AE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#05E5AD"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__f",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(29.90682 0 0 147.52703 229.683 83.74)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#05E5AD"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.32,
        stopColor: "#05E5AD",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.903,
        stopColor: "#6447FF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M84.818 0c12.181 0 23.731 2.576 34.196 7.204-23.187 13.153-39.367 42.949-39.367 77.614 0 34.659 16.196 64.46 39.367 77.613a84.4 84.4 0 0 1-34.196 7.204C37.977 169.635 0 131.658 0 84.818 0 37.98 37.977 0 84.818 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M151.704 32.693c-8.577-10.977-19.777-19.794-32.698-25.489C127.151 2.576 136.145 0 145.607 0c8.926 0 17.46 2.304 25.216 6.435-7.582 5.646-14.161 14.77-19.132 26.258z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M151.691 136.942c4.971 11.488 11.55 20.591 19.132 26.258-7.772 4.145-16.29 6.435-25.216 6.435-9.478 0-18.469-2.575-26.601-7.204 12.897-5.695 24.121-14.512 32.698-25.489z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7962FE",
        d: "M79.639 84.818c0-34.665 16.196-64.461 39.367-77.614 12.897 5.695 24.121 14.512 32.698 25.489-6.244 14.389-9.959 32.47-9.959 52.125 0 19.646 3.729 37.735 9.959 52.119a85.1 85.1 0 0 1-32.698 25.494c-23.185-13.153-39.367-42.954-39.367-77.613"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M203.084 126.414c2.399 12.788 5.872 23.514 10.06 31.083-7.085 7.7-15.391 12.13-24.289 12.13-6.383 0-12.467-2.29-18.023-6.435 13.688-7.283 25.034-20.326 32.252-36.756z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M170.832 6.435C176.388 2.29 182.472 0 188.855 0c8.885 0 17.191 4.433 24.289 12.132-4.175 7.566-7.648 18.287-10.06 31.075-7.218-16.438-18.564-29.476-32.252-36.756z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7962FE",
        d: "M151.704 136.929c11.216-14.382 17.92-32.465 17.92-52.12 0-19.652-6.704-37.735-17.92-52.116 4.98-11.48 11.553-20.599 19.141-26.264 13.683 7.281 25.029 20.327 32.247 36.756-2.32 12.29-3.633 26.49-3.633 41.611s1.33 29.312 3.633 41.605c-7.218 16.435-18.564 29.481-32.247 36.761-7.588-5.651-14.161-14.767-19.141-26.263z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#321BB2",
        d: "M151.696 136.942c-6.236-14.389-9.951-32.47-9.951-52.124 0-19.647 3.729-37.73 9.951-52.12 11.224 14.39 17.928 32.473 17.928 52.12 0 19.654-6.704 37.735-17.928 52.124"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#05E6AD",
        d: "M213.144 12.132C217.4 4.433 222.38 0 227.724 0 243.343 0 256 37.98 256 84.818c0 46.84-12.657 84.817-28.276 84.817-5.331 0-10.324-4.438-14.58-12.132 13.682-14.85 22.837-41.828 22.837-72.685 0-30.855-9.155-57.85-22.837-72.686"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M213.144 12.132C217.4 4.433 222.38 0 227.724 0 243.343 0 256 37.98 256 84.818c0 46.84-12.657 84.817-28.276 84.817-5.331 0-10.324-4.438-14.58-12.132 13.682-14.85 22.837-41.828 22.837-72.685 0-30.855-9.155-57.85-22.837-72.686"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7962FE",
        d: "M211.58 84.826c0-15.13-3.087-29.321-8.496-41.611 2.399-12.79 5.872-23.508 10.068-31.077 13.68 14.835 22.834 41.847 22.834 72.688 0 30.832-9.154 57.849-22.834 72.685-4.183-7.574-7.648-18.295-10.068-31.083 5.396-12.29 8.496-26.481 8.496-41.602"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#321BB2",
        d: "M203.084 126.423c-2.317-12.293-3.634-26.484-3.634-41.605 0-15.127 1.33-29.321 3.634-41.611 5.396 12.29 8.496 26.484 8.496 41.611 0 15.121-3.087 29.312-8.496 41.605"
    }));

const Cody = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 55 50",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd",
        clipRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF5543",
        d: "M40.888.181a5.07 5.07 0 0 1 5.066 5.073v11.594a5.07 5.07 0 0 1-5.066 5.072 5.07 5.07 0 0 1-5.066-5.072V5.254A5.07 5.07 0 0 1 40.888.18"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A112FF",
        d: "M3.257 13.225a5.07 5.07 0 0 1 5.065-5.073h11.58a5.07 5.07 0 0 1 5.065 5.073 5.07 5.07 0 0 1-5.066 5.072H8.322a5.07 5.07 0 0 1-5.065-5.072"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00CBEC",
        d: "M9.098 31.53a5.06 5.06 0 0 0-7.072-.987 5.077 5.077 0 0 0-1.013 7.102L5.066 34.6c-4.053 3.044-4.051 3.046-4.05 3.048l.003.004.007.009.015.02.156.2c.093.115.217.268.373.45.312.367.753.857 1.322 1.43a33.5 33.5 0 0 0 4.994 4.117c4.405 2.975 10.983 5.94 19.614 5.94s15.21-2.965 19.614-5.94a33.5 33.5 0 0 0 4.994-4.116c.569-.574 1.01-1.064 1.322-1.43a18 18 0 0 0 .529-.65l.015-.021.007-.01.003-.003c.002-.002.003-.004-4.05-3.048l4.053 3.044a5.077 5.077 0 0 0-1.013-7.102 5.06 5.06 0 0 0-7.071.987l-.016.02q-.039.05-.16.192c-.16.189-.43.49-.805.868a23.4 23.4 0 0 1-3.475 2.859c-3.104 2.097-7.743 4.205-13.947 4.205s-10.843-2.108-13.947-4.205a23.4 23.4 0 0 1-3.475-2.859c-.375-.377-.644-.68-.806-.868a8 8 0 0 1-.174-.212m36.79.02h-.001l-.003.004c-.001.002-.002.004 3.92 2.95l-3.922-2.946z"
    })));

const Cohere = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 75 75",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M24.3 44.7c2 0 6-.1 11.6-2.4 6.5-2.7 19.3-7.5 28.6-12.5 6.5-3.5 9.3-8.1 9.3-14.3C73.8 7 66.9 0 58.3 0h-36C10 0 0 10 0 22.3s9.4 22.4 24.3 22.4",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#39594d"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M30.4 60c0-6 3.6-11.5 9.2-13.8l11.3-4.7C62.4 36.8 75 45.2 75 57.6 75 67.2 67.2 75 57.6 75H45.3c-8.2 0-14.9-6.7-14.9-15",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#d18ee2"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.9 47.6C5.8 47.6 0 53.4 0 60.5v1.7C0 69.2 5.8 75 12.9 75s12.9-5.8 12.9-12.9v-1.7c-.1-7-5.8-12.8-12.9-12.8",
        style: {
            fill: "#ff7759"
        }
    }));

const Coinbase = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 48 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0052FF",
        d: "M0 11.077C0 4.959 4.96 0 11.077 0h25.846C43.041 0 48 4.96 48 11.077v25.846C48 43.041 43.04 48 36.923 48H11.077C4.959 48 0 43.04 0 36.923z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M23.957 32.5a8.54 8.54 0 0 1-4.508-1.396 8.5 8.5 0 0 1-3.072-3.575 8.48 8.48 0 0 1 1.207-8.969 8.541 8.541 0 0 1 12.706-.432 8.5 8.5 0 0 1 2.189 4.172H41a16.99 16.99 0 0 0-5.845-11.19A17.07 17.07 0 0 0 23.19 7.022a17.06 17.06 0 0 0-11.495 5.263A16.98 16.98 0 0 0 7 24c0 4.361 1.68 8.556 4.694 11.716a17.07 17.07 0 0 0 23.462 1.173A16.99 16.99 0 0 0 41 25.7h-8.521c0 3.4-5.113 6.8-8.522 6.8"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 48,
        height: 48,
        fill: "#fff",
        rx: 24
    }))));

const Convex = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "28 28 128 132",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F3B01C",
        d: "M108.092 130.021c18.166-2.018 35.293-11.698 44.723-27.854-4.466 39.961-48.162 65.218-83.83 49.711-3.286-1.425-6.115-3.796-8.056-6.844-8.016-12.586-10.65-28.601-6.865-43.135 10.817 18.668 32.81 30.111 54.028 28.122"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8D2676",
        d: "M53.401 90.174c-7.364 17.017-7.682 36.94 1.345 53.336-31.77-23.902-31.423-75.052-.388-98.715 2.87-2.187 6.282-3.485 9.86-3.683 14.713-.776 29.662 4.91 40.146 15.507-21.3.212-42.046 13.857-50.963 33.555"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE342F",
        d: "M114.637 61.855C103.89 46.87 87.069 36.668 68.639 36.358c35.625-16.17 79.446 10.047 84.217 48.807.444 3.598-.139 7.267-1.734 10.512-6.656 13.518-18.998 24.002-33.42 27.882 10.567-19.599 9.263-43.544-3.065-61.704"
    }));

const Coursera = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        clipRule: "evenodd",
        viewBox: "0 0 1155 164",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0056D2",
        fillRule: "nonzero",
        d: "M160 82c0-45 36-81 82-81s83 36 83 81c0 44-37 80-83 80s-82-36-82-80m125 0a43 43 0 0 0-86 0 43 43 0 0 0 86 0m706 1c0-49 40-82 76-82 24 0 38 8 48 22l3-19h37v155h-37l-4-16c-11 12-25 19-47 19-36 0-76-31-76-79m126 0c0-24-20-43-43-43-24 0-43 19-43 43 0 21 19 41 42 41 24 0 44-20 44-41M946 22V4h-40v155h40V76c0-26 12-39 34-39l4 1 7-38c-21 0-36 7-45 22m-404 0V4h-41l1 155h40V76c0-26 12-39 34-39l4 1 7-38c-21 0-36 7-45 22M339 99V4h40v90c0 20 11 32 31 32 21 0 34-13 34-38V4h40v155h-40v-18c-10 15-25 22-47 22-36 0-58-26-58-64m392-17c0-44 31-81 80-81 46 0 78 37 78 80l-1 13H770c4 18 20 32 43 32 14 0 29-5 38-17l28 22a80 80 0 0 1-66 31c-47 0-82-35-82-80m118-16c-3-16-19-28-38-28s-34 11-40 27zm-262 60 36-19c6 13 18 20 35 20 15 0 21-5 21-12 0-25-85-10-85-67 0-31 28-48 62-48 26 0 49 12 61 33l-35 19c-5-11-15-17-28-17-12 0-18 5-18 12 0 24 85 9 85 67 0 30-25 48-64 48-34 0-58-11-70-36M0 82C0 37 37 1 82 1c28 0 55 13 70 37l-34 20a43 43 0 0 0-36-19c-23 0-42 20-42 43 0 22 19 42 42 42a43 43 0 0 0 37-20l34 20A83 83 0 0 1 0 82"
    }));

const Crossplane = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 540",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M.137 122.022c-.18 4.155-.172 8.316.027 12.47C.11 135.557 0 136.61 0 137.69v210.042c0 40.169 32.785 73.036 72.858 73.036h109.65c40.058 0 72.857-32.867 72.857-73.036V137.691c0-1.23-.136-2.407-.191-3.61.199-4.017.204-8.041.014-12.059C252.098 54.1 196.179 0 127.669 0 59.145 0 3.227 54.1.137 122.009z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__c",
        d: "M.137 122.022c-.18 4.155-.172 8.316.027 12.47C.11 135.557 0 136.61 0 137.69v210.042c0 40.169 32.785 73.036 72.858 73.036h109.65c40.058 0 72.857-32.867 72.857-73.036V137.691c0-1.23-.136-2.407-.191-3.61.199-4.017.204-8.041.014-12.059C252.098 54.1 196.179 0 127.669 0 59.145 0 3.227 54.1.137 122.009z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__e",
        d: "M.137 122.022c-.18 4.155-.172 8.316.027 12.47C.11 135.557 0 136.61 0 137.69v210.042c0 40.169 32.785 73.036 72.858 73.036h109.65c40.058 0 72.857-32.867 72.857-73.036V137.691c0-1.23-.136-2.407-.191-3.61.199-4.017.204-8.041.014-12.059C252.098 54.1 196.179 0 127.669 0 59.145 0 3.227 54.1.137 122.009z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#F7D186",
        d: "M126.759 173.662c-17.689.03-32.008 14.386-31.993 32.074v301.878a32.034 32.034 0 0 0 31.993 32.074c17.678 0 32.006-14.356 32.006-32.074V205.736c.015-17.688-14.304-32.044-31.993-32.074"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9234",
        d: "M255.18 134.095c.185-4.018.185-8.041 0-12.059C252.117 54.114 196.199 0 127.675 0S3.232 54.114.142 122.036a130 130 0 0 0 .014 12.469c-.04 1.066-.15 2.12-.15 3.2v210.042c0 40.168 32.785 73.036 72.858 73.036h109.65c40.058 0 72.843-32.868 72.843-73.036V137.704c0-1.23-.123-2.406-.177-3.61"
    }), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(.635 .014)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFCD3C",
        d: "M331.874 126.028 15.19 443.465l-93.79-94.023L238.07 32.006z",
        mask: "url(#prefix__b)"
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(.635 .014)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__d",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__c"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#F3807B",
        d: "m237.783 31.705-316.67 317.437-116.704-116.992L121.052-85.286z",
        mask: "url(#prefix__d)"
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(.635 .014)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__f",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#35D0BA",
        d: "m425.964 220.351-316.67 317.423-93.79-94.022 316.671-317.423z",
        mask: "url(#prefix__f)"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#D8AE64",
        d: "m103.448 421.138 55.508 55.645v-56.11z"
    }));

const CurseForgeDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 260 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M196.422 98.77S247.874 90.623 256 66.858h-78.819V48H4l21.334 24.862v25.473s53.83-2.811 74.653 13.047c28.502 26.532-32.058 62.397-32.058 62.397l-10.384 34.512c16.239-15.529 47.188-35.618 103.933-34.65-21.594 6.854-43.307 17.56-60.211 34.65h114.71l-10.802-34.512s-83.139-49.235-8.753-75.005z"
    }));

const CurseForgeLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 260 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#130700",
        d: "M196.422 98.77S247.874 90.623 256 66.858h-78.819V48H4l21.334 24.862v25.473s53.83-2.811 74.653 13.047c28.502 26.532-32.058 62.397-32.058 62.397l-10.384 34.512c16.239-15.529 47.188-35.618 103.933-34.65-21.594 6.854-43.307 17.56-60.211 34.65h114.71l-10.802-34.512s-83.139-49.235-8.753-75.005z"
    }));

const CursorDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m11.925 24 10.425-6-10.425-6L1.5 18z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M22.35 18V6L11.925 0v12z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M11.925 0 1.5 6v12l10.425-6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#555",
        d: "M22.35 6 11.925 24V12z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        d: "m22.35 6-10.425 6L1.5 6z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 11.925,
        x2: 11.925,
        y1: 12,
        y2: 24,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.16,
        stopColor: "#ffff",
        stopOpacity: 0.39
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.658,
        stopColor: "#ffff",
        stopOpacity: 0.8
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 22.35,
        x2: 11.925,
        y1: 6.037,
        y2: 12.15,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.182,
        stopColor: "#ffff",
        stopOpacity: 0.31
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.715,
        stopColor: "#ffff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 11.925,
        x2: 1.5,
        y1: 0,
        y2: 18,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#ffff",
        stopOpacity: 0.6
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopColor: "#ffff",
        stopOpacity: 0.22
    }))));

const CursorLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m11.925 24 10.425-6-10.425-6L1.5 18z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M22.35 18V6L11.925 0v12z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M11.925 0 1.5 6v12l10.425-6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#555",
        d: "M22.35 6 11.925 24V12z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m22.35 6-10.425 6L1.5 6z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 11.925,
        x2: 11.925,
        y1: 12,
        y2: 24,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.16,
        stopOpacity: 0.39
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.658,
        stopOpacity: 0.8
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 22.35,
        x2: 11.925,
        y1: 6.037,
        y2: 12.15,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.182,
        stopOpacity: 0.31
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.715,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 11.925,
        x2: 1.5,
        y1: 0,
        y2: 18,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopOpacity: 0.6
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopOpacity: 0.22
    }))));

const Cypress = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 119 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#69D3A7",
        d: "M.854 30.359A24 24 0 0 1 0 24C0 14.16 6.181 5.16 15.382 1.611l1.207 3.122C8.669 7.79 3.349 15.531 3.349 24.001c0 1.858.247 3.698.733 5.471z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M42.45 14.493A20.67 20.67 0 0 0 24.062 3.348c-2.75 0-5.422.53-7.938 1.57l-1.283-3.09A24 24 0 0 1 24.06 0c9.016 0 17.201 4.96 21.36 12.946z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1B1E2E",
        d: "M16.877 19.05c1.942 0 3.524 1.035 4.337 2.841l.064.142 3.262-1.108-.07-.167c-1.263-3.076-4.172-4.988-7.593-4.988-2.405 0-4.36.771-5.975 2.354-1.606 1.573-2.418 3.552-2.418 5.882 0 2.31.812 4.279 2.417 5.852 1.616 1.583 3.57 2.354 5.976 2.354 3.421 0 6.33-1.912 7.593-4.986l.07-.167-3.267-1.11-.062.147c-.728 1.775-2.348 2.837-4.334 2.837-1.353 0-2.495-.473-3.4-1.404-.916-.943-1.38-2.127-1.38-3.52 0-1.403.453-2.565 1.38-3.551.902-.936 2.047-1.409 3.4-1.409m40.192-.923c-1.505-1.562-3.382-2.357-5.584-2.357-2.187 0-3.987.78-5.356 2.313v-2.01h-3.524V37.97h3.524V29.9c1.369 1.534 3.167 2.313 5.356 2.313 2.202 0 4.082-.795 5.587-2.36 1.481-1.572 2.23-3.538 2.23-5.846-.003-2.33-.751-4.306-2.233-5.88m-2.763 9.397c-.902.933-2.047 1.403-3.398 1.403-1.37 0-2.482-.46-3.4-1.403-.916-.943-1.379-2.127-1.379-3.52 0-1.434.45-2.596 1.379-3.551.916-.946 2.027-1.404 3.4-1.404 1.353 0 2.496.473 3.398 1.404.908.935 1.348 2.096 1.348 3.55 0 1.435-.442 2.586-1.348 3.521m10.732-9.564v-1.886h-3.524v15.832h3.524v-8.933c0-1.43.576-2.526 1.713-3.253 1.13-.722 2.485-.856 4.144-.403l.214.059v-3.387l-.131-.031c-2.228-.532-4.463.234-5.94 2.002m15.213-2.19c-2.323 0-4.294.792-5.857 2.354-1.585 1.583-2.388 3.562-2.388 5.882 0 2.31.813 4.279 2.418 5.852 1.616 1.583 3.57 2.354 5.976 2.354 3.259 0 6.06-1.655 7.496-4.428l.082-.16-2.981-1.32-.072.141c-.865 1.67-2.524 2.668-4.433 2.668-2.48 0-4.378-1.514-4.892-3.876h12.784l.016-.151c.278-2.555-.38-4.77-1.953-6.586-1.564-1.812-3.65-2.73-6.196-2.73m-4.546 6.64c.625-2.16 2.39-3.543 4.546-3.543 2.214 0 3.98 1.382 4.55 3.544zm22.11.085c-1.922-.36-3.581-.673-3.581-2.01 0-1.06 1.13-1.8 2.745-1.8 1.782 0 2.76.765 2.989 2.34l.025.178 3.524-.738-.025-.159c-.474-2.798-2.969-4.538-6.51-4.538-1.778 0-3.283.46-4.472 1.367-1.214.902-1.828 2.079-1.828 3.502 0 2.061 1.306 3.608 3.5 4.138.569.133 1.17.241 1.752.35 2.184.398 4.247.775 4.247 2.245 0 1.133-1.317 1.922-3.2 1.922-1.916 0-2.973-.765-3.233-2.343l-.029-.175-3.521.738.028.161c.512 2.84 3.036 4.536 6.753 4.536 1.888 0 3.506-.47 4.802-1.395 1.297-.915 1.952-2.095 1.952-3.506 0-3.7-3.279-4.317-5.918-4.813m15.266 0c-1.921-.36-3.58-.673-3.58-2.01 0-1.06 1.129-1.8 2.744-1.8 1.783 0 2.76.765 2.989 2.34l.026.178 3.524-.738-.026-.159c-.473-2.798-2.968-4.538-6.51-4.538-1.778 0-3.283.46-4.471 1.367-1.214.902-1.829 2.079-1.829 3.502 0 2.061 1.307 3.608 3.501 4.138.569.133 1.17.241 1.752.35 2.184.398 4.247.775 4.247 2.245 0 1.133-1.317 1.922-3.2 1.922-1.917 0-2.974-.765-3.234-2.343l-.028-.175-3.521.738.028.161c.512 2.84 3.035 4.536 6.752 4.536 1.888 0 3.506-.47 4.803-1.395 1.296-.915 1.952-2.095 1.952-3.506 0-3.7-3.28-4.317-5.919-4.813"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1B1E2E",
        d: "m37.306 16.074-4.648 11.761-4.679-11.761h-3.828l6.562 16.053-4.668 11.322 3.346.666 11.532-28.041z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m26.643 41.99-.815 1.973c-.162.39-.532.655-.95.673q-.411.017-.833.018C14.448 44.65 5.957 37.883 3.853 28.56l-3.267.738c1.18 5.229 4.144 9.975 8.345 13.367A24.15 24.15 0 0 0 24.009 48h.05q.48-.001.959-.02a4.44 4.44 0 0 0 3.91-2.745l1.064-2.58z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 21.558,
        x2: 39.823,
        y1: -1.549,
        y2: 17.972,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.094,
        stopColor: "#58D09E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.988,
        stopColor: "#58D09E",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: -0.256,
        x2: 34.638,
        y1: 34.922,
        y2: 44.209,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.077,
        stopColor: "#58D09E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.762,
        stopColor: "#1B1E2E"
    }))));

const D3js = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-10 -10 116 111",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h7.75a45.5 45.5 0 1 1 0 91H0V71h7.75a25.5 25.5 0 1 0 0-51H0zm36.251 0h32a27.75 27.75 0 0 1 21.331 45.5A27.75 27.75 0 0 1 68.251 91h-32a53.7 53.7 0 0 0 18.746-20H68.25a7.75 7.75 0 1 0 0-15.5H60.5a53.7 53.7 0 0 0 0-20h7.75a7.75 7.75 0 1 0 0-15.5H54.997A53.7 53.7 0 0 0 36.251 0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 7,
        x2: 50,
        y1: 64,
        y2: 107,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#f9a03c"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#f7974e"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 2,
        x2: 87,
        y1: -2,
        y2: 84,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#f26d58"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#f9a03c"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 45,
        x2: 108,
        y1: -10,
        y2: 53,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#b84e51"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#f68e48"
    })), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M-128-102v300h300z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M-72-102h300v300z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "url(#prefix__d)",
        strokeWidth: 40,
        d: "m-100-102 300 300"
    })));

const DailydevDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#FFF",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m31.48 19.944-3.533-3.533 1.765-3.531 5.74 5.74a1.873 1.873 0 0 1 0 2.648l-7.065 7.064a1.873 1.873 0 0 1-2.648-2.648l5.74-5.74Z",
        opacity: 0.56
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M25.74 11.548a1.873 1.873 0 0 1 2.649 0l1.324 1.325-15.452 15.452a1.873 1.873 0 0 1-2.649 0l-1.324-1.324zm-6.622 4.857-2.65 2.649-3.532-3.533-4.415 4.416 3.532 3.532-1.765 3.532-5.74-5.74a1.873 1.873 0 0 1 0-2.648l7.064-7.064a1.873 1.873 0 0 1 2.65 0z"
    })));

const DailydevLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#151618",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m31.48 19.944-3.533-3.533 1.765-3.531 5.74 5.74a1.873 1.873 0 0 1 0 2.648l-7.065 7.064a1.873 1.873 0 0 1-2.648-2.648l5.74-5.74Z",
        opacity: 0.56
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M25.74 11.548a1.873 1.873 0 0 1 2.649 0l1.324 1.325-15.452 15.452a1.873 1.873 0 0 1-2.649 0l-1.324-1.324zm-6.622 4.857-2.65 2.649-3.532-3.533-4.415 4.416 3.532 3.532-1.765 3.532-5.74-5.74a1.873 1.873 0 0 1 0-2.648l7.064-7.064a1.873 1.873 0 0 1 2.65 0z"
    })));

const DaisyUI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 512,
        height: 256,
        x: 256,
        y: 670.72,
        fill: "#1AD1A5",
        rx: 128
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 512,
        cy: 353.28,
        r: 256,
        fill: "#fff"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 512,
        cy: 353.28,
        r: 261,
        stroke: "#000",
        strokeOpacity: 0.2,
        strokeWidth: 10
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 512,
        cy: 353.28,
        r: 114.688,
        fill: "#FF9903"
    }));

const Dart = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: "50%",
        cy: "50.002%",
        r: "50.004%",
        fx: "50%",
        fy: "50.002%",
        gradientTransform: "scale(1 .99985)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.1
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#01579B",
        d: "M52.209 203.791 8.413 159.995C3.218 154.67 0 147.141 0 139.782c0-3.407 1.92-8.733 3.369-11.782l40.427-84.204z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#40C4FF",
        d: "M202.116 52.209 158.32 8.413C154.5 4.573 146.538 0 139.8 0c-5.796 0-11.48 1.167-15.15 3.369L43.815 43.796zM104.418 256h106.111v-45.471l-79.16-25.276-72.422 25.276z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#29B6F6",
        d: "M43.796 180.209c0 13.513 1.694 16.826 8.413 23.582l6.738 6.738h151.582l-74.097-84.204-92.636-82.53V180.21Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#01579B",
        d: "M178.534 43.777H43.796L210.529 210.51H256V106.093L202.097 52.19c-7.566-7.585-14.285-8.413-23.563-8.413"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M53.903 205.466c-6.738-6.756-8.413-13.419-8.413-25.257V45.47l-1.675-1.675v136.413c-.02 11.838-.02 15.113 10.088 25.257l5.044 5.044z",
        opacity: 0.2
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#263238",
        d: "M254.325 104.418v104.417h-45.471l1.675 1.694H256V106.093z",
        opacity: 0.2
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M202.116 52.209c-8.356-8.357-15.188-8.413-25.257-8.413H43.815l1.675 1.675h131.369c5.025 0 17.71-.847 25.257 6.738",
        opacity: 0.2
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m254.325 104.418-52.209-52.21L158.32 8.414C154.5 4.573 146.538 0 139.8 0c-5.796 0-11.48 1.167-15.15 3.369L43.815 43.796 3.388 128c-1.45 3.068-3.37 8.394-3.37 11.782 0 7.359 3.238 14.868 8.414 20.213l40.351 40.07c.96 1.185 2.09 2.39 3.426 3.726l1.675 1.675 5.044 5.044 43.796 43.796 1.675 1.675H210.49v-45.47h45.471V106.092l-1.637-1.675Z",
        opacity: 0.2
    }));

const Datadog = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 274",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#632CA6",
        fillRule: "evenodd",
        d: "m214.4 194.5-22.8-15-19 31.7-22.1-6.4-19.5 29.7 1 9.3 105.8-19.5-6.1-66zM115.7 166l17-2.3c2.7 1.2 4.6 1.7 8 2.5a25 25 0 0 0 19.8-1.8c2-1 6.3-5 8-7.1l69.6-12.7 7 86-119 21.4zm129.2-31-6.9 1.4L224.8 0 .1 26l27.7 225 26.2-4c-2.1-3-5.4-6.6-11-11.2-7.7-6.5-5-17.4-.4-24.3 6-11.7 37.2-26.5 35.4-45.2-.6-6.7-1.7-15.6-8-21.6-.2 2.5.2 5 .2 5s-2.6-3.4-3.9-7.9c-1.2-1.7-2.2-2.2-3.6-4.5-1 2.6-.8 5.7-.8 5.7s-2.2-5-2.5-9.2a14.7 14.7 0 0 0-1.6 5.5s-2.7-8-2-12.1c-1.3-3.7-5-11-4-27.7 6.9 4.8 22 3.7 27.8-5 2-2.9 3.3-10.7-1-26.2-2.7-9.9-9.5-24.6-12.1-30.2l-.3.2a428 428 0 0 1 5.3 18.5C75 70.8 76 75.6 74.3 82c-1.3 5.6-4.5 9.2-12.6 13.3-8.1 4-18.9-5.9-19.6-6.4a43.3 43.3 0 0 1-14.6-21.5c-.7-5.5 3.1-8.7 5-13.2a50 50 0 0 0-5.8 2.2s3.7-3.8 8.2-7c2-1.3 3-2.1 5-3.8h-5.2s4.8-2.5 9.8-4.4c-3.7-.2-7.2 0-7.2 0s10.7-4.8 19.2-8.3c5.8-2.4 11.5-1.7 14.7 2.9 4.1 6 8.5 9.3 17.9 11.3 5.7-2.5 7.4-3.8 14.6-5.8 6.3-7 11.3-7.8 11.3-7.8s-2.5 2.2-3.1 5.8c3.6-2.8 7.5-5.2 7.5-5.2s-1.5 1.9-3 4.9l.4.5a79 79 0 0 1 9.1-4.5l-3 4c3.1 0 9.5.2 12 .5 14.7.3 17.7-15.7 23.3-17.7 7-2.5 10.2-4 22.2 7.8 10.3 10 18.4 28.2 14.4 32.3-3.4 3.3-10-1.3-17.3-10.5a39.5 39.5 0 0 1-8.2-17.8c-1.1-6.1-5.6-9.7-5.6-9.7s2.6 5.8 2.6 11c0 2.8.3 13.2 4.8 19.1-.4.9-.6 4.3-1.1 5-5.2-6.4-16.5-11-18.3-12.2 6.2 5 20.4 16.7 26 27.9 5.1 10.6 2 20.3 4.7 22.8.7.7 11.1 13.6 13.1 20.2 3.5 11.3.2 23.2-4.4 30.6l-12.7 2c-1.9-.5-3.1-.8-4.8-1.8a32 32 0 0 0 2.8-6.5l-.7-1.3a54.4 54.4 0 0 1-16.2 14.2 27.2 27.2 0 0 1-21 1.8 117.4 117.4 0 0 1-33.4-17.9s0 2.2.6 2.7c3.8 4.4 12.7 12.3 21.3 17.8l-18.3 2 8.7 67.4c-3.9.6-4.5.9-8.7 1.5a45.1 45.1 0 0 0-18.5-26.6A35 35 0 0 0 65 200l-.5.6c6.2-.6 13.6.3 21.2 5.1 7.5 4.7 13.5 17 15.7 24.2 2.9 9.4 4.8 19.4-2.8 30-5.4 7.6-21.3 11.8-34 2.8 3.3 5.5 8 10 14.2 10.8 9.2 1.3 18-.3 24-6.5 5.2-5.3 7.9-16.4 7.2-28l8.1-1.2 3 20.9 135-16.3L245 135.1zm-82-56.8c-.5.9-1 1.4-.2 4.2v.2l.2.4.4.8c1.6 3.3 3.4 6.4 6.3 8 .8-.2 1.5-.3 2.4-.3 2.7-.1 4.5.3 5.6.9v-2.6c-.2-4.1.8-11.2-7.1-14.9-3-1.4-7.3-1-8.7.8l.7.2c2.1.7.7 1.4.3 2.3zm22.3 38.7a45.6 45.6 0 0 0-24.6 4.3c-2.8 2.2-1.5 6 .6 7.5 5.8 4.4 11 7.3 16.3 6.6 3.3-.4 6.2-5.7 8.3-10.4 1.4-3.3 1.4-6.8-.7-8zm-58-33.5c1.9-1.8-9.2-4.1-17.7 1.7-6.3 4.3-6.5 13.6-.5 18.8l1.6 1.2a51.7 51.7 0 0 1 15.9-4.7c1.3-1.4 2.8-4 2.4-8.5-.5-6.2-5.2-5.2-1.7-8.5",
        clipRule: "evenodd"
    }));

const DeepSeek = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#4D6BFE",
        d: "M23.748 4.482c-.254-.124-.364.113-.512.234-.051.039-.094.09-.137.136-.372.397-.806.657-1.373.626-.829-.046-1.537.214-2.163.848-.133-.782-.575-1.248-1.247-1.548-.352-.156-.708-.311-.955-.65-.172-.241-.219-.51-.305-.774-.055-.16-.11-.323-.293-.35-.2-.031-.278.136-.356.276-.313.572-.434 1.202-.422 1.84.027 1.436.633 2.58 1.838 3.393.137.093.172.187.129.323-.082.28-.18.552-.266.833-.055.179-.137.217-.329.14a5.5 5.5 0 0 1-1.736-1.18c-.857-.828-1.631-1.742-2.597-2.458a11 11 0 0 0-.689-.471c-.985-.957.13-1.743.388-1.836.27-.098.093-.432-.779-.428s-1.67.295-2.687.684a3 3 0 0 1-.465.137 9.6 9.6 0 0 0-2.883-.102c-1.885.21-3.39 1.102-4.497 2.623C.082 8.606-.231 10.684.152 12.85c.403 2.284 1.569 4.175 3.36 5.653 1.858 1.533 3.997 2.284 6.438 2.14 1.482-.085 3.133-.284 4.994-1.86.47.234.962.327 1.78.397.63.059 1.236-.03 1.705-.128.735-.156.684-.837.419-.961-2.155-1.004-1.682-.595-2.113-.926 1.096-1.296 2.746-2.642 3.392-7.003.05-.347.007-.565 0-.845-.004-.17.035-.237.23-.256a4.2 4.2 0 0 0 1.545-.475c1.396-.763 1.96-2.015 2.093-3.517.02-.23-.004-.467-.247-.588zM11.581 18c-2.089-1.642-3.102-2.183-3.52-2.16-.392.024-.321.471-.235.763.09.288.207.486.371.739.114.167.192.416-.113.603-.673.416-1.842-.14-1.897-.167-1.361-.802-2.5-1.86-3.301-3.307-.774-1.393-1.224-2.887-1.298-4.482-.02-.386.093-.522.477-.592a4.7 4.7 0 0 1 1.529-.039c2.132.312 3.946 1.265 5.468 2.774.868.86 1.525 1.887 2.202 2.891.72 1.066 1.494 2.082 2.48 2.914.348.292.625.514.891.677-.802.09-2.14.11-3.054-.614m1-6.44a.306.306 0 0 1 .415-.287.3.3 0 0 1 .2.288.306.306 0 0 1-.31.307.303.303 0 0 1-.304-.308zm3.11 1.596c-.2.081-.399.151-.59.16a1.25 1.25 0 0 1-.798-.254c-.274-.23-.47-.358-.552-.758a1.7 1.7 0 0 1 .016-.588c.07-.327-.008-.537-.239-.727-.187-.156-.426-.199-.688-.199a.56.56 0 0 1-.254-.078.253.253 0 0 1-.114-.358c.028-.054.16-.186.192-.21.356-.202.767-.136 1.146.016.352.144.618.408 1.001.782.391.451.462.576.685.914.176.265.336.537.445.848.067.195-.019.354-.25.452"
    }));

const DenoDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        fillRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        clipRule: "evenodd",
        viewBox: "0 0 441 441",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M229.858-2.62c121.29 5.675 215.154 108.755 209.479 230.045S330.582 442.578 209.292 436.903-5.863 328.149-.188 206.859 108.568-8.296 229.858-2.62m51.365 264.922c-13.886-.687-27.594-3.012-38.616-4.857-8.381-1.404-16.33-3.616-22.855-5.858a2.58 2.58 0 0 0-2.932.878c-.678.905-.777 2.22-.02 3.061 3.08 3.418 12.848 10.54 20.439 13.812-6.491 5.357-10.933 17.608-12.684 23.95-2.35 8.51-2.687 20.801-2.12 25.312 2.282 18.146 8.95 34.41 25.467 48.64 11.562 9.96 28.295 16.77 45.399 17.08 23.603.426 51.882-9.705 74.085-32.493 29.028-31.807 48.051-73.17 51.593-119.393 8.434-110.06-74.073-206.264-184.134-214.698S28.582 91.81 20.147 201.87c-4.368 56.998 15.655 110.28 51.267 149.576a3.185 3.185 0 0 0 5.422-2.974c-26.39-103.487 30.95-215.162 94.926-250.494 23.751-13.118 46.884-18.1 67.664-9.69 31.814 12.874 50 34.21 89.375 52.163 39.375 17.951 43.625 47.862 32.64 78.098-10.986 30.236-46.358 45.425-80.218 43.753m-68.863-160.08c-12.906 1.006-21.384 16.978-22.497 27.253-1.117 10.275 3.978 27.236 20.794 26.91 19.694-.383 25.681-17.238 23.525-33.55-1.618-12.25-11.033-21.456-21.822-20.613"
    }));

const DenoLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        fillRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        clipRule: "evenodd",
        viewBox: "0 0 401 401",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M261.684 245.149c33.861 1.662 69.225-13.535 80.203-43.776s6.721-60.148-32.661-78.086c-39.381-17.944-57.569-39.272-89.385-52.14-20.787-8.408-43.915-3.418-67.664 9.707-63.963 35.351-121.274 147.038-94.858 250.518a3.185 3.185 0 0 1-1.544 3.615 3.19 3.19 0 0 1-3.877-.64C16.282 295.06-3.759 241.788.593 184.791 8.998 74.728 105.178-7.806 215.241.599 325.296 9.003 407.83 105.182 399.425 215.245c-3.529 46.221-22.535 87.584-51.559 119.399-22.195 22.8-50.473 32.935-74.07 32.516-17.107-.303-33.839-7.112-45.409-17.066-16.516-14.228-23.191-30.485-25.474-48.635-.572-4.507-.236-16.797 2.112-25.309 1.745-6.343 6.185-18.599 12.676-23.957-7.595-3.266-17.361-10.388-20.446-13.805-.753-.838-.652-2.156.026-3.057a2.56 2.56 0 0 1 2.925-.88c6.528 2.239 14.477 4.444 22.86 5.851 11.021 1.844 24.729 4.159 38.618 4.847M192.777 85.086c10.789-.846 20.202 8.363 21.825 20.609 2.164 16.314-3.822 33.166-23.511 33.554-16.819.335-21.915-16.625-20.8-26.9 1.107-10.275 9.577-26.25 22.486-27.263"
    }));

const Designali = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1440 1440",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M410.16 364.04h253.69c116.97 0 207.22 30.93 270.73 92.75 63.5 61.84 95.26 149.91 95.26 264.21s-31.08 201.22-93.25 262.71c-62.17 61.51-151.08 92.25-266.72 92.25h-259.7V364.04Z",
        style: {
            fill: "#d93739"
        }
    }));

const DeveloperStudentClub = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        fill: "none",
        viewBox: "0 0 150 78",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M0 0h150v78H0z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("pattern", {
        id: "prefix__a",
        width: 1,
        height: 1,
        patternContentUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        transform: "matrix(.00313 0 0 .00601 0 -.462)"
    })), /*#__PURE__*/ React.createElement("image", {
        xlinkHref: "data:image/png;base64,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",
        id: "prefix__b",
        width: 320,
        height: 320
    })));

const DevtoDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M87.375 147.217c0 10.219-6.295 25.701-26.219 25.669H36V83h25.687c19.215 0 25.677 15.46 25.683 25.685zM62.582 99.819c2.104 0 4.213.788 6.316 2.363 2.098 1.575 3.156 3.944 3.16 7.095v37.837q.001 4.732-3.154 7.095c-2.104 1.575-4.213 2.363-6.317 2.363h-9.46V99.819z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M141.959 99.053h-28.886v20.871h17.658v16.064h-17.658v20.866h28.892v16.064h-33.712c-6.05.158-11.081-4.634-11.233-10.696V94.256c-.146-6.057 4.641-11.088 10.686-11.24h34.259zM198.149 161.684c-7.157 16.705-19.979 13.38-25.72 0l-20.89-78.662h17.658l16.108 61.778 16.031-61.778H219z"
    }));

const DevtoLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M87.375 147.217c0 10.219-6.295 25.701-26.219 25.669H36V83h25.687c19.215 0 25.677 15.46 25.683 25.685zM62.582 99.819c2.104 0 4.213.788 6.316 2.363 2.098 1.575 3.156 3.944 3.16 7.095v37.837q.001 4.732-3.154 7.095c-2.104 1.575-4.213 2.363-6.317 2.363h-9.46V99.819z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M141.959 99.053h-28.886v20.871h17.658v16.064h-17.658v20.866h28.892v16.064h-33.712c-6.05.158-11.081-4.634-11.233-10.696V94.256c-.146-6.057 4.641-11.088 10.686-11.24h34.259zM198.149 161.684c-7.157 16.705-19.979 13.38-25.72 0l-20.89-78.662h17.658l16.108 61.778 16.031-61.778H219z"
    }));

const DigitalOcean = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 -3.954 53.927 53.954",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#0080ff",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M24.915 50v-9.661c10.226 0 18.164-10.141 14.237-20.904a14.44 14.44 0 0 0-8.615-8.616C19.774 6.921 9.633 14.83 9.633 25.056H0C0 8.758 15.763-3.954 32.853 1.384 40.311 3.73 46.271 9.661 48.588 17.12 53.927 34.237 41.243 50 24.915 50"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15.339 40.367h9.604v-9.604H15.34zm-7.401 7.401h7.4v-7.4h-7.4zm-6.187-7.4h6.187V34.18H1.751z"
    })));

const Directus = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1024 1028",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#64F",
        d: "M0 0h1024v1028H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#754DFC",
        d: "M0 856.177V0h1024v1028h-36.522c-42.62-22.92-105.621-49.587-194.895-71.901-86.048-21.508-213.492-31.811-348.962-42.763C289.815 900.902 125.662 887.631 0 856.177"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8555F8",
        d: "M0 630.724V0h1024v864.167C987.48 836.871 914.997 793.6 788.518 757.39c-85.256-24.408-212.277-39.025-347.298-54.562C288.002 685.197 124.482 666.38 0 630.724"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#945EF5",
        d: "M0 385.079V0h1024v661.623c-31.757-27.466-103.783-78.115-240.781-122.565-84.352-27.369-210.786-46.41-345.182-66.65C285.691 449.465 123.114 424.981 0 385.079"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A366F1",
        d: "M1024 0v470.993c-28.052-26.483-99.308-81.947-243.989-131.697-83.861-28.837-209.943-50.081-343.966-72.664C284.289 241.062 122.352 213.776 0 171.81V0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B36EEE",
        d: "M170.96 0H1024v278.073c-15.53-17.825-82.814-85.727-252.614-147.449-83.346-30.296-209.037-53.737-342.645-78.655C343.042 35.986 254.087 19.396 170.96 0"
    }), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M751.713 578.4c-3.713-.928-6.807-1.856-9.591-3.094-2.059-.915-3.779-1.998-5.286-3.251-1.001-.833-1.431-2.144-1.307-3.44 1.493-15.542-.149-29.251 1.333-44.664 6.188-62.491 45.483-42.692 80.755-52.901 20.255-5.705 40.509-16.933 47.91-39.018 1.212-3.615.145-7.546-2.373-10.41-23.105-26.267-48.685-49.477-76.478-69.368-93.177-66.331-214.272-93.875-325.48-77.763-4.213.61-6.421 5.277-4.119 8.857 14.084 21.915 32.666 39.849 53.975 53.049 3.873 2.399 2.316 7.581-2.129 6.584-10.45-2.342-23.878-6.911-36.506-15.822-1.217-.858-2.785-1.075-4.168-.523-5.646 2.251-13.798 5.497-20.535 8.405-3.878 1.674-4.668 6.674-1.476 9.441 55.857 48.411 137.114 55.77 200.742 17.029 3.876-2.36 10.082 2.49 8.833 6.852-1.999 6.989-4.335 16.595-6.822 29.677-15.78 79.816-61.263 73.629-117.574 53.52-112.522-40.776-176.357-5.956-233.111-74.885-3.943-4.79-10.875-6.45-15.566-2.39-11.716 10.142-18.65 24.946-18.65 40.77 0 18.742 9.676 34.796 24.018 44.406 1.794 1.203 4.178.695 5.516-1 3.495-4.422 6.354-7.354 9.914-9.208 3.896-2.029 5.797 3.544 2.507 6.456-12.054 10.671-15.513 23.383-23.39 48.443-12.377 39.289-7.117 79.507-64.976 90.025-30.631 1.547-30.012 22.275-41.151 53.211-12.927 37.34-29.854 53.879-61.183 86.509-4.284 4.462-4.652 11.598.057 15.611 12.514 10.664 25.42 11.25 38.54 5.849 32.487-13.612 57.549-55.686 81.064-82.91 26.3-30.318 89.418-17.325 137.067-47.024 25.697-15.755 41.137-35.88 36.2-66.027-.796-4.856 4.761-7.774 6.776-3.285a90.2 90.2 0 0 1 7.377 27.005c.273 2.462 2.474 4.284 4.948 4.145 51.552-2.898 118.217 53.955 180.517 69.338 3.79.936 6.484-3.441 4.341-6.703-3.941-6.002-7.292-12.23-9.961-18.595-2.756-6.612-4.844-13.027-6.32-19.219-1.155-4.842 5.921-6.144 8.337-1.79 15.978 28.797 47.91 55.838 92.351 59.061 15.161 1.238 31.869-.619 49.196-5.878 20.73-6.187 39.913-14.231 62.809-9.899 17.017 3.093 32.797 11.755 42.698 26.296 13.893 20.258 43.221 25.626 58.852 4.453 2.127-2.881 2.306-6.733.9-10.027-34.419-80.664-121.815-86.205-159.381-95.898",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h1024v1028H0z"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__b",
        width: 920,
        height: 608.703,
        x: 52,
        y: 222,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 12
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 30
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0.0901961 0 0 0 0 0.160784 0 0 0 0 0.25098 0 0 0 0.1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_1255_4057"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 16
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0.0901961 0 0 0 0 0.160784 0 0 0 0 0.25098 0 0 0 0.1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "effect1_dropShadow_1255_4057",
        result: "effect2_dropShadow_1255_4057"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_1255_4057",
        result: "shape"
    }))));

const Discord = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 199",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#5865F2",
        d: "M216.856 16.597A208.5 208.5 0 0 0 164.042 0c-2.275 4.113-4.933 9.645-6.766 14.046q-29.538-4.442-58.533 0c-1.832-4.4-4.55-9.933-6.846-14.046a207.8 207.8 0 0 0-52.855 16.638C5.618 67.147-3.443 116.4 1.087 164.956c22.169 16.555 43.653 26.612 64.775 33.193A161 161 0 0 0 79.735 175.3a136.4 136.4 0 0 1-21.846-10.632 109 109 0 0 0 5.356-4.237c42.122 19.702 87.89 19.702 129.51 0a132 132 0 0 0 5.355 4.237 136 136 0 0 1-21.886 10.653c4.006 8.02 8.638 15.67 13.873 22.848 21.142-6.58 42.646-16.637 64.815-33.213 5.316-56.288-9.08-105.09-38.056-148.36ZM85.474 135.095c-12.645 0-23.015-11.805-23.015-26.18s10.149-26.2 23.015-26.2 23.236 11.804 23.015 26.2c.02 14.375-10.148 26.18-23.015 26.18m85.051 0c-12.645 0-23.014-11.805-23.014-26.18s10.148-26.2 23.014-26.2c12.867 0 23.236 11.804 23.015 26.2 0 14.375-10.148 26.18-23.015 26.18"
    }));

const Discordjs = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 402 402",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0B0C18",
        d: "M0 0h402v402H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FDFDFD",
        d: "M99 242.171H68.34V121.164c3.184 0 6.294-.033 9.404.006 16.137.203 32.343-.438 48.397.829 28.729 2.269 47.694 22.233 49.736 51.014.793 11.183.266 22.267-3.93 32.9-1.059 2.685-2.421 3.997-5.685 4.241-11.844.885-21.358 10.486-22.257 22.377-.237 3.129-1.661 4.3-4.139 5.309-9.775 3.981-20.01 4.559-30.377 4.342-3.328-.069-6.659-.011-10.49-.011m43.801-44.116c2.94-8.351 3.509-16.943 2.1-25.605-1.598-9.827-5.852-18.149-15.412-22.443-10.417-4.677-21.439-2.509-32.072-2.912v69.079c6.336 0 12.33.089 18.32-.018 12.51-.224 21.568-5.849 27.064-18.101"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B55BFD",
        d: "M346.965 253.019c-5.17 15.594-16.793 24.652-31.797 28.839-29.098 8.121-55.11 1.46-77.648-18.667-.35-.312-.576-.763-1.102-1.48 1.266-1.468 2.535-2.941 4.533-4.534 36.085 5.364 71.327 7.843 106.014-4.158M214.823 259.127c-7.089 14.61-18.928 22.834-34.761 25.257-19.46 2.977-36.384-1.795-49.136-17.575-2.639-3.265-4.393-7.245-6.504-10.81l23.263-6.756c4.65 6.177 11.112 10.455 20.345 11.375 5.196.654 9.686 1.556 14.108 1.295 10.912-.644 21.792-1.822 32.685-2.786"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FCDA5C",
        d: "M264.466 201.962c-13.278-7.505-20.199-18.978-20.768-34.509 9.734.24 18.957.893 28.18 1.546 3.467 8.265 10.935 11.604 18.413 14.893 12.411 5.46 24.845 10.867 37.07 16.668-13.523 3.979-26.953 6.524-40.854 4.507-7.343-1.065-14.694-2.072-22.041-3.105"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC5B5B",
        d: "M253.543 138.79c10.048-11.728 23.402-16.576 38.242-17.441 20.379-1.189 38.004 5.619 53.066 19.766-1.079 1.435-1.951 2.593-3.617 3.871-13.363-.277-25.967-.225-38.493-1.182-16.431-1.255-32.802-3.306-49.198-5.014"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5CFC9C",
        d: "M264.686 202.263c7.127.732 14.478 1.739 21.821 2.804 13.901 2.017 27.331-.528 41.039-4.228 11.229 5.62 18.202 14.366 20.713 26.729-9.615 2.137-18.868 3.868-28.121 5.599-2.885-5.61-7.743-8.929-13.302-11.413-12.531-5.597-25.076-11.163-37.597-16.782-1.502-.674-2.891-1.599-4.553-2.709"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F39153",
        d: "M253.28 138.98c16.659 1.518 33.03 3.569 49.461 4.824 12.526.957 25.13.905 38.193 1.359-3.052 4.632-6.597 9.206-10.34 14.036-7.672-6.239-15.692-11.49-25.313-12.552-6.489-.716-13.355-.733-19.701.603-10.523 2.216-14.814 9.594-13.688 21.296-9.237-.2-18.46-.853-28.13-1.498-.996-10.604 2.485-19.813 9.518-28.068"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5C6BFB",
        d: "M320.172 233.566c9.219-2.13 18.472-3.861 28.105-5.638 2.376 8.253 1.908 16.428-1.082 24.79-34.917 12.302-70.159 9.823-105.948 4.295 3.301-4.668 7.033-9.291 10.922-14.11 9.077 7.756 18.675 13.749 30.073 16.424 7.901 1.854 15.75 2.037 23.61-.196 12.324-3.503 17.621-12.761 14.32-25.565M215.047 258.83c-11.117 1.261-21.997 2.439-32.909 3.083-4.422.261-8.912-.641-13.7-1.168 16.761-2.371 25.132-10.935 26.056-27.141 9.203-2.241 17.938-4.012 26.673-5.782.817 10.77-1.057 21.025-6.12 31.008"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F35B59",
        d: "M194.15 157.062v-35.645h27.354c0 8.204 0 16.45-.469 25.165-9.273 3.806-18.079 7.143-26.885 10.48"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5DFE9D",
        d: "M221.273 227.377c-8.841 2.215-17.576 3.986-26.713 5.812a394 394 0 0 1-.036-32.682c9.214-1.292 17.927-2.105 26.64-2.917.071 9.781.143 19.562.109 29.787"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FBFBFB",
        d: "M165.776 219.606c10.677-1.166 18.71 5.413 19.061 15.177.316 8.782-7.067 16.271-15.994 16.224-9.111-.048-16.387-7.801-15.821-16.858.441-7.047 4.786-12.118 12.754-14.543"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FCDA5C",
        d: "M221.286 197.171c-8.835 1.231-17.548 2.044-26.692 2.876a231 231 0 0 1-.051-25.497c3.265-.797 6.039-1.017 8.776-1.46 5.969-.966 11.92-2.044 17.878-3.076.07 8.912.141 17.825.089 27.157"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F39153",
        d: "M221.346 169.637c-6.107 1.409-12.058 2.487-18.027 3.453-2.737.443-5.511.663-8.703 1.003-.488-5.36-.543-10.738-.531-16.573 8.871-3.795 17.677-7.132 26.806-10.493.417 7.396.511 14.815.455 22.61"
    }));

const Discourse = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 259",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M129.1 0C59.1 0 0 56.8 0 127v131.4l129-.2c70.2 0 127-59 127-129C256 59 199.1 0 129.1 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF9AE",
        d: "M130.3 49.1a78.7 78.7 0 0 0-69.1 116.2L46.9 211l51.2-11.6A78.7 78.7 0 1 0 130.4 49Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00AEEF",
        d: "M191.9 176.5A78.6 78.6 0 0 1 98 199.4l-51.2 11.7 52-6.1a78.6 78.6 0 0 0 93.9-125 78.6 78.6 0 0 1-1 96.5Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00A94F",
        d: "M187.5 161.5a78.6 78.6 0 0 1-91 32.6l-49.6 17 51.2-11.6a78.6 78.6 0 0 0 80.2-134 78.6 78.6 0 0 1 9.2 96"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F15D22",
        d: "M65.9 167a78.7 78.7 0 0 1 127-87 78.7 78.7 0 0 0-131.7 85.3L46.9 211z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D0232B",
        d: "M61.2 165.3a78.7 78.7 0 0 1 117-99.9 78.7 78.7 0 0 0-121.9 98.7L47 211l14.2-45.8Z"
    }));

const DisneyPlus = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 534 302",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M241.7 203.4c.3 0 .3 0 .6.1 4.6.6 9.1 1.4 12.5 3 3.2 1.4 5.1 3.2 6.8 6.4 2.6 4.8 2.8 11.5.4 16.6-1.8 3.8-5.6 7-9.1 8.7-3.6 1.8-7.2 2.6-11.3 3.1-7.2.8-15-.7-21.4-3.8-3.8-1.9-8.5-5.1-10.9-9.2-1.7-3-1.7-7 .4-9.9 3.4-4.6 10.6-5.6 16-5.4 4.1.2 11.6 1.4 15.5 2.8 1.1.4 5.1 2 5.8 2.7.5.5.8 1.2.6 1.9-.9 2.7-7.6 4.2-9.5 4.5-5.2.8-7.8-1.2-13.7-3.5-1.5-.6-3.4-1.2-4.9-1.3-2.7-.3-5.9.5-6.4 3.4-.3 1.5 1.5 2.9 2.8 3.5 3.1 1.4 5.7 1.8 8.8 1.9 9.1.1 19.4-1.4 26.9-6.7 1-.7 2-1.8 2-3.1 0-2.7-4.7-4.4-4.7-4.4-5-2.1-14.4-3.1-19.1-3.5-5-.4-13-1.1-14.9-1.4-2-.3-4.1-.7-5.8-1.4-1.7-.8-3.4-2.5-3.9-4.4-.9-3.4.2-7.6 2.1-10.4 5-7.2 16.7-9.9 25.5-11 8.5-1.1 22.2-1 30.5 3.4 1.3.7 1.9 1.3 1.7 2.7-.5 2.6-2.5 4.2-4.8 5-2.5.8-7.6 1.1-9.8 1.2-10 .6-22.1.3-31.7 2.9-.7.2-2 .6-2.5 1-1.5 1.6 2.8 2.1 3.7 2.3.3.1.3.1.6.1zM182 158.7s1.6-2.4 3-4.3c2.5-3.4 7-8.1 10.4-11 1-.9 2.3-1.9 2.3-1.9s-1.9.2-3 .4c-2.6.5-6.3 3-8.2 4.6-3.1 2.7-6.5 7-5 10.8.2.7.5 1.4.5 1.4m17.3 4.6c4.9-.3 9.5-1.8 13.8-4.1 4.2-2.3 10.4-6.9 9.7-12.3-.2-1.7-1.3-3.1-2.8-3.7-1.9-.8-2.8-.7-5.2 0-1.7.5-2.5.8-4.2 1.8-4.8 2.8-11.7 8.8-15.4 13.6-.9 1.1-1.7 2.4-2.4 3.3-.4.5-.8 1-.7 1.2.2.4 5.3.4 7.2.2m-12.5 9.2c-.5.5-1 1.8-1.6 2.8-.3.5-.8 1.1-1.2 1.4-1.3.9-2.4 1-3.6-.1-1.7-1.5-2.7-3.9-2.8-6.2 0-1 .1-2.1-.1-3-.3-1.4-1.7-2.9-2.5-4.3-.9-1.6-1.6-4.4-1.7-6.2-.3-5.7 2.7-10.9 6.5-15 3.9-4.2 9-7.6 14.6-10 5.2-2.2 12.9-3.7 18.7-1.7 1.9.6 4.5 2.2 5.8 3.9.3.3.5.7.8.9s.9.2 1.5.3c1.8.3 4.5 1.7 5.6 2.6 2.2 1.9 3.4 3.7 3.9 6.3 1.1 5.2-1.9 11-5.3 14.5-5.9 6-11.7 10.2-19.2 13.2-3.3 1.3-8.4 2.5-12.2 2.2-1.2-.1-2.4-.4-3.5-.5-.6-.1-2.7-.6-2.9-.7-.4-.3-.7-.4-.8-.4m6.7 11.6c.2 0 .6.1.9.3 2.6 1 3.7 3.4 4.4 6.1 1.5 6.2 2.1 20 2.4 25.4.2 4 .3 8 .5 12 .1 3.4.4 7.9-.3 11-.3 1.1-1 2.5-2.1 3.1-1.3.8-4.1.9-5.7.5-3.9-.8-5.1-3.3-5.7-7.1-1.3-9.1-.7-27 .1-34.5.3-2.5 1.2-10.5 2.5-13.8.4-1 1.4-3.3 3-3M76.2 199.3s-5.7.4-9.7.8c-5 .5-14.5 2.2-19.9 4.1-1.6.6-5 2-5.2 3.7-.3 1.7.8 3.1 2 4.5.7.8 4.6 4.6 5.7 5.5 4.6 3.9 14 9.8 20.9 12.7 2.4 1 6.3 2.4 6.3 2.4s-.3-11.2-.2-22.2c0-5.8.1-11.5.1-11.5m105.2 4.4c.3 3-.4 8.7-.6 9.4-.2 1.7-1.5 5.7-1.8 6.2-1.1 2.4-2.1 4.4-3.2 6.4-1.9 3.4-6.4 8.8-9 11.1-9.9 8.5-25.2 13.4-38.3 15-8.9 1.1-19.1.9-28.6-.8-3.2-.6-8.1-1.7-8.1-1.7s0 1.9-.1 3.3c-.1.6-.5 2.3-.8 2.8-.7 1.4-1.8 2.1-3.4 2.5-2 .4-4.1.5-5.9-.3-3-1.3-4.1-4.1-4.6-7.3-.4-2.6-.9-7.1-.9-7.1s-2.2-1.1-4.1-2c-5.7-2.8-11.2-6.3-16-9.8-1.3-1-7-5.7-8.3-6.9-3.5-3.3-6.7-6.7-9.1-10.9-1.9-3.3-2.4-6.3-1-9.8 2-4.9 9-8.6 13.8-10.7 3.5-1.6 14.6-5.2 19.1-5.8 2.2-.3 5.5-.9 5.7-1l.2-.2c.1-.1.3-5 .2-6.8 0-1.8 1.3-13.2 1.7-15.7.2-1.3 1.2-6.4 2.2-7.7.7-.9 1.8-.8 2.8-.2 5.2 3.3 6.8 14.6 7.2 20.3.2 3.5.4 8.8.4 8.8s6-.2 9.7-.1c3.6.1 7.6.7 11.3 1.2 4.8.8 14.1 2.8 19.4 5.5 4.4 2.2 8.5 6 9.9 10 1.2 3.6 1.1 6.2-.8 9.5-2.1 3.7-6.1 6.5-10.2 6.7-1.2.1-5.8-.5-7.2-1.6-.5-.4-.5-1.2-.1-1.7.1-.2 2.3-1.3 3.5-2 .6-.3 1.2-.7 1.6-1.2 1-.9 2-1.9 1.9-3.1-.1-1.5-1.8-2.5-3.3-3.1-7.3-2.9-21.9-5.3-28.9-5.7-2.8-.2-6.7-.3-6.7-.3l.8 38.9s3.2.6 5.8 1c1.5.2 7.7.8 9.3.8 12.6.3 26.6-.8 38.1-6.2 5.1-2.4 9.7-5.3 13.2-9.4 4.6-5.3 7.1-12.6 6.4-20.2-.7-8.3-6.5-18.1-11.2-24.1-12.3-15.8-33.4-28.9-52-36.5-19-7.8-37.7-12.3-57.8-13-5.2-.2-16.5.1-22.2 1.7-.8.2-1.6.5-2.4.7-.6.1-1.5.5-1.8.8l-.3.3s.4.2.7.3c.6.3 3.2.4 4.5.7 1.2.2 2.4.8 2.9 1.7.5.8.5 1.5 0 2.2-1.3 1.6-6.2 1.3-8.3 1-2.2-.4-5-1-5.5-3-.6-2.3.5-4.5 1.7-6.6 2.4-4.2 5.7-6.3 10.7-7.7 7-1.9 15.9-3.3 22.5-3.5 15-.6 29.2 2.1 43.8 6.5 8.3 2.5 19.2 6.7 27.2 10.6 5.7 2.8 14.8 7.8 19.8 11.2 1.6 1.1 11 7.9 12.4 9.1 3 2.5 7 6 9.9 8.9 5.6 5.5 12.5 13.9 15.8 20.7.8 1.6 1.4 3.2 2.5 5 .4.6 1.9 4.4 2.1 5.5.3 1.1.6 2.7.7 2.8.5.1 1.2 3.3 1.1 4.6m188.9-8.6c-7 1.6-25.5 2.5-25.5 2.5l-2.3 7.3s9.2-.8 16-.1c0 0 2.2-.3 2.4 2.5.1 2.5-.2 5.3-.2 5.3s-.1 1.7-2.5 2.1c-2.5.4-19.9 1.1-19.9 1.1l-2.8 9.5s-1 2.2 1.3 1.6c2.2-.6 20.4-4 22.8-3.5 2.5.6 5.4 4 4.5 7.1-1 3.8-19.2 15.4-30.2 14.6 0 0-5.8.4-10.7-7.5-4.6-7.5 1.7-21.7 1.7-21.7s-2.9-6.6-.8-8.9c0 0 1.2-1.1 4.9-1.4l4.5-9.2s-5.1.3-8.1-3.4c-2.8-3.5-3-5.2-.9-6.1 2.3-1.1 23.5-5 38-4.5 0 0 5.1-.5 9.4 8.3-.1 0 2 3.6-1.6 4.4m-54.7 35.5c-1.9 4.4-6.8 9.1-12.9 6.2-6-2.9-15.7-22.6-15.7-22.6s-3.7-7.3-4.4-7.2c0 0-.8-1.4-1.3 6.6s.1 23.6-3.1 26c-3 2.5-6.7 1.5-8.6-1.4-1.7-2.8-2.4-9.6-1.5-21.4 1.1-11.8 3.9-24.4 7.4-28.3s6.3-1.1 7.4 0c0 0 4.7 4.3 12.4 16.7l1.4 2.3s7 11.8 7.8 11.8c0 0 .6.5 1.1.1.7-.2.4-4 .4-4s-1.5-12.9-7.9-34.6c0 0-1-2.7-.3-5.3s3.2-1.4 3.2-1.4 9.9 5 14.8 21.2 1.6 30.9-.2 35.3m106.9-9.7c-4.5 7.9-17.3 24.4-34.3 20.5-5.6 13.6-10.3 27.4-13 47.9 0 0-.6 4-3.9 2.6-3.3-1.2-8.7-6.6-9.8-14.2-1.2-10 3.3-26.8 12.3-46.1-2.6-4.3-4.4-10.4-2.9-19.2 0 0 2.3-16.2 18.6-30.8 0 0 2-1.7 3.1-1.2 1.2.5.7 5.8-.3 8.4s-8.3 15.1-8.3 15.1-4.5 8.5-3.3 15.2c8.5-13.1 28-39.6 40-31.3 4 2.9 5.9 9.2 5.9 16 0 6-1.4 12.3-4.1 17.1m-3.5-20.8s-.7-5.2-5.8.5c-4.4 4.9-12.3 14-18.7 26.3 6.7-.8 13.1-4.4 15.1-6.2 3.2-2.8 10.6-10.5 9.4-20.6m97.1-1.2H485c-.6-10.6-1.9-20.9-3.9-31.5-.2-1.1-1.2-1.9-2.3-1.9h-7.2c-.6 0-1.2.3-1.6.8s-.6 1.1-.4 1.8c2 10.3 3.3 20.4 4 30.9h-29.9c-1.4 0-2.5 1.1-2.5 2.5v6.5c0 1.4 1.1 2.5 2.5 2.5h30.4v4.4c0 9.3-.4 17-1.3 25.7q-.15 1.05.6 1.8c.4.5 1.1.8 1.7.8h6.7c1.3 0 2.4-1 2.5-2.3.9-8.7 1.3-16.5 1.3-26v-4.4h30.7c1.4 0 2.5-1.1 2.5-2.5v-6.5c-.2-1.5-1.3-2.6-2.7-2.6",
        style: {
            fill: "#01147b"
        }
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: 1775.139,
        cy: 146.126,
        r: 756.556,
        gradientTransform: "translate(-374.472 83.852)scale(.4759)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#01147b"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.025,
        style: {
            stopColor: "#011098"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.064,
        style: {
            stopColor: "#010abd"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.103,
        style: {
            stopColor: "#0006da"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.142,
        style: {
            stopColor: "#0003ee"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.179,
        style: {
            stopColor: "#0001fb"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.216,
        style: {
            stopColor: "#00f"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#0ff",
            stopOpacity: 0
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M476.8 150.3c-15.8-39-42.7-72.3-77.5-96.1-35.7-24.5-77.5-37.4-121-37.4-71.9 0-138.5 35.7-178.3 95.5-.4.6-.5 1.5-.3 2.2.3.8.8 1.3 1.6 1.6l5.6 1.9c.3.1.7.2 1 .2 1 0 2-.5 2.6-1.4 18.3-26.8 43-49.2 71.5-64.6 29.4-15.9 62.8-24.4 96.4-24.4 40.7 0 79.9 12 113.4 34.7 32.7 22.1 58.2 53 73.5 89.3.5 1.1 1.5 1.8 2.7 1.8h6.7c.8 0 1.5-.4 1.9-1 .5-.8.5-1.6.2-2.3",
        style: {
            fill: "url(#prefix__a)"
        }
    }));

const Django = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.135 4H18.1v18.169a26.2 26.2 0 0 1-5.143.535c-4.842-.005-7.362-2.168-7.362-6.322 0-4 2.673-6.6 6.816-6.6a6.5 6.5 0 0 1 1.724.2zm0 9.142a4 4 0 0 0-1.337-.2c-2 0-3.163 1.223-3.163 3.366 0 2.087 1.107 3.239 3.138 3.239a9 9 0 0 0 1.362-.1v-6.3Z",
        style: {
            fill: "#44b78b"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M24.4 10.059v9.1c0 3.133-.235 4.639-.923 5.938A6.32 6.32 0 0 1 20.237 28l-3.678-1.733a5.7 5.7 0 0 0 3.141-2.629c.566-1.121.745-2.42.745-5.837v-7.742ZM20.441 4.02h3.964v4.028h-3.964z",
        style: {
            fill: "#44b78b"
        }
    }));

const Docker = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#008fe2",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.98 11.08h2.12a.19.19 0 0 0 .19-.19V9.01a.19.19 0 0 0-.19-.19h-2.12a.18.18 0 0 0-.18.18v1.9c0 .1.08.18.18.18m-2.95-5.43h2.12a.19.19 0 0 0 .18-.19V3.57a.19.19 0 0 0-.18-.18h-2.12a.18.18 0 0 0-.19.18v1.9c0 .1.09.18.19.18m0 2.71h2.12a.19.19 0 0 0 .18-.18V6.29a.19.19 0 0 0-.18-.18h-2.12a.18.18 0 0 0-.19.18v1.89c0 .1.09.18.19.18m-2.93 0h2.12a.19.19 0 0 0 .18-.18V6.29a.18.18 0 0 0-.18-.18H8.1a.18.18 0 0 0-.18.18v1.89c0 .1.08.18.18.18m-2.96 0h2.11a.19.19 0 0 0 .19-.18V6.29a.18.18 0 0 0-.19-.18H5.14a.19.19 0 0 0-.19.18v1.89c0 .1.08.18.19.18m5.89 2.72h2.12a.19.19 0 0 0 .18-.19V9.01a.19.19 0 0 0-.18-.19h-2.12a.18.18 0 0 0-.19.18v1.9c0 .1.09.18.19.18m-2.93 0h2.12a.18.18 0 0 0 .18-.19V9.01a.18.18 0 0 0-.18-.19H8.1a.18.18 0 0 0-.18.18v1.9c0 .1.08.18.18.18m-2.96 0h2.11a.18.18 0 0 0 .19-.19V9.01a.18.18 0 0 0-.18-.19H5.14a.19.19 0 0 0-.19.19v1.88c0 .1.08.19.19.19m-2.92 0h2.12a.18.18 0 0 0 .18-.19V9.01a.18.18 0 0 0-.18-.19H2.22a.18.18 0 0 0-.19.18v1.9c0 .1.08.18.19.18m21.54-1.19c-.06-.05-.67-.51-1.95-.51-.34 0-.68.03-1.01.09a3.77 3.77 0 0 0-1.72-2.57l-.34-.2-.23.33a4.6 4.6 0 0 0-.6 1.43c-.24.97-.1 1.88.4 2.66a4.7 4.7 0 0 1-1.75.42H.76a.75.75 0 0 0-.76.75 11.4 11.4 0 0 0 .7 4.06 6.03 6.03 0 0 0 2.4 3.12c1.18.73 3.1 1.14 5.28 1.14.98 0 1.96-.08 2.93-.26a12.3 12.3 0 0 0 3.82-1.4 10.5 10.5 0 0 0 2.61-2.13c1.25-1.42 2-3 2.55-4.4h.23c1.37 0 2.21-.55 2.68-1 .3-.3.55-.66.7-1.06l.1-.28Z"
    }));

const DocumensoDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M128.1 46.8c-8.23 0-15.1 5.65-26.57 16.94-16.1.13-24.95.99-30.77 6.81-5.82 5.83-6.69 14.68-6.81 30.77C52.65 112.8 47 119.67 47 127.9c0 8.24 5.65 15.1 16.95 26.58.12 16.1.99 24.95 6.8 30.77 5.83 5.82 14.68 6.68 30.78 6.81C113 203.36 119.87 209 128.1 209c8.24 0 15.1-5.65 26.58-16.94 16.1-.13 24.95-.99 30.77-6.81 5.83-5.83 6.69-14.67 6.82-30.77 11.3-11.48 16.94-18.34 16.94-26.58 0-8.23-5.65-15.1-16.94-26.57-.13-16.1-1-24.95-6.82-30.78-5.82-5.82-14.67-6.68-30.77-6.81-11.47-11.3-18.34-16.94-26.58-16.94m6.13 145.28h.12l-.26.2c-3.88 2.96-5.35 3.03-5.99 3.03-.63 0-2.1-.07-5.98-3.03l-.17-.13h-.03l-.07-.07h-.06l-11.89-11.11a9.78 9.78 0 0 0-5.68-2.59l-2.66-.01-14.42-.67-.32-.04c-4.84-.65-5.93-1.65-6.38-2.1-.45-.44-1.44-1.53-2.1-6.37l-.02-.22-.62-15.84a9.8 9.8 0 0 0-.27-1.9 9.8 9.8 0 0 0-2.4-4.91l-11.1-12.2v.04l-.03-.03v-.01l-.04-.06-.13-.17c-2.96-3.88-3.03-5.35-3.03-5.99s.07-2.1 3.03-5.99l.2-.25v.02l10.67-11.6a9.78 9.78 0 0 0 2.56-6l.6-9.11c.08-2.89.23-5.33.48-7.45l.04-.65.04-.04.01-.09.02-.13c.65-4.84 1.64-5.92 2.1-6.37.44-.45 1.53-1.45 6.37-2.1l.11-.01.08-.01.13-.02-.1.1 15.46-.72a9.8 9.8 0 0 0 4.89-1.58 9.8 9.8 0 0 0 3.42-2.03l11.08-10.15h-.03l.06-.06h.01l.19-.14c3.88-2.96 5.35-3.03 5.98-3.03.64 0 2.11.07 6 3.03l.1.08.06.05.09.07h-.13l11.4 10.39c.91.82 1.96 1.46 3.09 1.9a9.8 9.8 0 0 0 4.74 1.46l15.67.68-.08-.08h.1l.04.04.22.03c4.83.65 5.92 1.65 6.37 2.1s1.44 1.53 2.1 6.37c0 .1.02.21.04.32l.67 16.74a9.8 9.8 0 0 0 1.48 4.8l.28.27.96.97.36.42 10.63 11.59v-.13l.03.03v.08l.1.12.07.1c2.96 3.87 3.02 5.34 3.02 5.98s-.06 2.1-3.02 5.99l-.17.21v.1l-.03.04v-.16l-11.38 12.34a9.8 9.8 0 0 0-2.32 4.34c0 1.16 0 2.26-.02 3.32l-.71 14.84.05-.05-.03.16-.02.16c-.65 4.84-1.64 5.93-2.09 6.38-.45.44-1.54 1.44-6.37 2.09l-.33.04-.03.03-.38.02c-2.44.3-5.29.45-8.76.54l-7.8.47a9.78 9.78 0 0 0-5.98 2.52l-11.9 10.8z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M169.58 27.6C151.63 9.95 140.88 1.11 128 1.11c-12.89 0-23.63 8.84-41.58 26.51-25.2.2-39.04 1.55-48.15 10.66S27.81 61.23 27.61 86.41C9.94 104.37 1.11 115.11 1.11 128s8.83 23.63 26.5 41.59c.2 25.18 1.55 39.03 10.66 48.14s22.96 10.46 48.15 10.66c17.95 17.67 28.7 26.5 41.58 26.5 12.89 0 23.63-8.83 41.58-26.5 25.2-.2 39.04-1.55 48.15-10.66s10.46-22.96 10.66-48.15c17.67-17.95 26.5-28.7 26.5-41.58 0-12.89-8.83-23.63-26.5-41.58-.2-25.2-1.55-39.04-10.66-48.15s-22.96-10.46-48.15-10.66zM94.01 39a15.3 15.3 0 0 1-7.89 2.37l-13.88.27c-3.7.18-6.95.45-9.87.84-8.43 1.14-12.03 3.1-14.41 5.47-2.38 2.38-4.34 5.99-5.47 14.42-.4 2.87-.65 6.06-.83 9.66l-.02.02-.26 13.6a15.3 15.3 0 0 1-4.07 10.1l-7.33 7.94-2.1 2.26v.01l-.4.43a117 117 0 0 0-6.36 7.55c-5.16 6.76-6.32 10.7-6.32 14.06 0 3.37 1.16 7.3 6.32 14.06 1.8 2.37 3.95 4.88 6.46 7.65l.06.07 9.68 10.46a15.3 15.3 0 0 1 4.06 10.1l.26 13.42c.19 3.7.45 6.95.85 9.88 1.13 8.42 3.09 12.03 5.47 14.4 2.38 2.39 5.98 4.34 14.4 5.48 2.93.39 6.19.66 9.88.84h.1l13.35.26a16 16 0 0 1 2.08.18 15.3 15.3 0 0 1 7.98 3.85l10.64 9.78h43.32l.18-.17 10.36-9.58a15.3 15.3 0 0 1 10.1-4.06l13.6-.26.01-.01c3.61-.18 6.8-.45 9.68-.83 8.42-1.14 12.03-3.1 14.4-5.47 2.39-2.38 4.34-5.99 5.48-14.42.4-2.92.66-6.18.84-9.87v-.14l.26-13.28a15.3 15.3 0 0 1 4.06-10.1l9.84-10.63a118 118 0 0 0 6.36-7.55c5.16-6.76 6.32-10.7 6.32-14.06s-1.16-7.3-6.32-14.06a118 118 0 0 0-6.36-7.55l-.1-.1-9.73-10.53a15.26 15.26 0 0 1-4.07-10.1l-.26-13.28v-.14c-.18-3.7-.45-6.95-.84-9.87-1.14-8.43-3.1-12.04-5.47-14.42-2.38-2.38-5.99-4.33-14.41-5.47-2.82-.38-5.95-.64-9.47-.82l-.03-.02-13.8-.26c-.42 0-.84-.03-1.26-.08h-.04l-.1-.01a15.3 15.3 0 0 1-8.7-3.98l-7.98-7.38-2.65-2.45a121 121 0 0 0-7.55-6.36c-6.76-5.16-10.7-6.32-14.06-6.32s-7.3 1.16-14.06 6.32c-2.37 1.8-4.88 3.94-7.65 6.45l-.05.05-9.78 9.45A15.3 15.3 0 0 1 94.01 39m19.93 195.88a118 118 0 0 1-7.65-6.45h43.42a118 118 0 0 1-7.65 6.45c-6.76 5.16-10.7 6.32-14.06 6.32s-7.3-1.16-14.06-6.32",
        clipRule: "evenodd"
    }));

const DocumensoLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M128.1 46.8c-8.23 0-15.1 5.65-26.57 16.94-16.1.13-24.95.99-30.77 6.81-5.82 5.83-6.69 14.68-6.81 30.77C52.65 112.8 47 119.67 47 127.9c0 8.24 5.65 15.1 16.95 26.58.12 16.1.99 24.95 6.8 30.77 5.83 5.82 14.68 6.68 30.78 6.81C113 203.36 119.87 209 128.1 209c8.24 0 15.1-5.65 26.58-16.94 16.1-.13 24.95-.99 30.77-6.81 5.83-5.83 6.69-14.67 6.82-30.77 11.3-11.48 16.94-18.34 16.94-26.58 0-8.23-5.65-15.1-16.94-26.57-.13-16.1-1-24.95-6.82-30.78-5.82-5.82-14.67-6.68-30.77-6.81-11.47-11.3-18.34-16.94-26.58-16.94m6.13 145.28h.12l-.26.2c-3.88 2.96-5.35 3.03-5.99 3.03-.63 0-2.1-.07-5.98-3.03l-.17-.13h-.03l-.07-.07h-.06l-11.89-11.11a9.78 9.78 0 0 0-5.68-2.59l-2.66-.01-14.42-.67-.32-.04c-4.84-.65-5.93-1.65-6.38-2.1-.45-.44-1.44-1.53-2.1-6.37l-.02-.22-.62-15.84a9.8 9.8 0 0 0-.27-1.9 9.8 9.8 0 0 0-2.4-4.91l-11.1-12.2v.04l-.03-.03v-.01l-.04-.06-.13-.17c-2.96-3.88-3.03-5.35-3.03-5.99s.07-2.1 3.03-5.99l.2-.25v.02l10.67-11.6a9.78 9.78 0 0 0 2.56-6l.6-9.11c.08-2.89.23-5.33.48-7.45l.04-.65.04-.04.01-.09.02-.13c.65-4.84 1.64-5.92 2.1-6.37.44-.45 1.53-1.45 6.37-2.1l.11-.01.08-.01.13-.02-.1.1 15.46-.72a9.8 9.8 0 0 0 4.89-1.58 9.8 9.8 0 0 0 3.42-2.03l11.08-10.15h-.03l.06-.06h.01l.19-.14c3.88-2.96 5.35-3.03 5.98-3.03.64 0 2.11.07 6 3.03l.1.08.06.05.09.07h-.13l11.4 10.39c.91.82 1.96 1.46 3.09 1.9a9.8 9.8 0 0 0 4.74 1.46l15.67.68-.08-.08h.1l.04.04.22.03c4.83.65 5.92 1.65 6.37 2.1s1.44 1.53 2.1 6.37c0 .1.02.21.04.32l.67 16.74a9.8 9.8 0 0 0 1.48 4.8l.28.27.96.97.36.42 10.63 11.59v-.13l.03.03v.08l.1.12.07.1c2.96 3.87 3.02 5.34 3.02 5.98s-.06 2.1-3.02 5.99l-.17.21v.1l-.03.04v-.16l-11.38 12.34a9.8 9.8 0 0 0-2.32 4.34c0 1.16 0 2.26-.02 3.32l-.71 14.84.05-.05-.03.16-.02.16c-.65 4.84-1.64 5.93-2.09 6.38-.45.44-1.54 1.44-6.37 2.09l-.33.04-.03.03-.38.02c-2.44.3-5.29.45-8.76.54l-7.8.47a9.78 9.78 0 0 0-5.98 2.52l-11.9 10.8z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M169.58 27.6C151.63 9.95 140.88 1.11 128 1.11c-12.89 0-23.63 8.84-41.58 26.51-25.2.2-39.04 1.55-48.15 10.66S27.81 61.23 27.61 86.41C9.94 104.37 1.11 115.11 1.11 128s8.83 23.63 26.5 41.59c.2 25.18 1.55 39.03 10.66 48.14s22.96 10.46 48.15 10.66c17.95 17.67 28.7 26.5 41.58 26.5 12.89 0 23.63-8.83 41.58-26.5 25.2-.2 39.04-1.55 48.15-10.66s10.46-22.96 10.66-48.15c17.67-17.95 26.5-28.7 26.5-41.58 0-12.89-8.83-23.63-26.5-41.58-.2-25.2-1.55-39.04-10.66-48.15s-22.96-10.46-48.15-10.66zM94.01 39a15.3 15.3 0 0 1-7.89 2.37l-13.88.27c-3.7.18-6.95.45-9.87.84-8.43 1.14-12.03 3.1-14.41 5.47-2.38 2.38-4.34 5.99-5.47 14.42-.4 2.87-.65 6.06-.83 9.66l-.02.02-.26 13.6a15.3 15.3 0 0 1-4.07 10.1l-7.33 7.94-2.1 2.26v.01l-.4.43a117 117 0 0 0-6.36 7.55c-5.16 6.76-6.32 10.7-6.32 14.06 0 3.37 1.16 7.3 6.32 14.06 1.8 2.37 3.95 4.88 6.46 7.65l.06.07 9.68 10.46a15.3 15.3 0 0 1 4.06 10.1l.26 13.42c.19 3.7.45 6.95.85 9.88 1.13 8.42 3.09 12.03 5.47 14.4 2.38 2.39 5.98 4.34 14.4 5.48 2.93.39 6.19.66 9.88.84h.1l13.35.26a16 16 0 0 1 2.08.18 15.3 15.3 0 0 1 7.98 3.85l10.64 9.78h43.32l.18-.17 10.36-9.58a15.3 15.3 0 0 1 10.1-4.06l13.6-.26.01-.01c3.61-.18 6.8-.45 9.68-.83 8.42-1.14 12.03-3.1 14.4-5.47 2.39-2.38 4.34-5.99 5.48-14.42.4-2.92.66-6.18.84-9.87v-.14l.26-13.28a15.3 15.3 0 0 1 4.06-10.1l9.84-10.63a118 118 0 0 0 6.36-7.55c5.16-6.76 6.32-10.7 6.32-14.06s-1.16-7.3-6.32-14.06a118 118 0 0 0-6.36-7.55l-.1-.1-9.73-10.53a15.26 15.26 0 0 1-4.07-10.1l-.26-13.28v-.14c-.18-3.7-.45-6.95-.84-9.87-1.14-8.43-3.1-12.04-5.47-14.42-2.38-2.38-5.99-4.33-14.41-5.47-2.82-.38-5.95-.64-9.47-.82l-.03-.02-13.8-.26c-.42 0-.84-.03-1.26-.08h-.04l-.1-.01a15.3 15.3 0 0 1-8.7-3.98l-7.98-7.38-2.65-2.45a121 121 0 0 0-7.55-6.36c-6.76-5.16-10.7-6.32-14.06-6.32s-7.3 1.16-14.06 6.32c-2.37 1.8-4.88 3.94-7.65 6.45l-.05.05-9.78 9.45A15.3 15.3 0 0 1 94.01 39m19.93 195.88a118 118 0 0 1-7.65-6.45h43.42a118 118 0 0 1-7.65 6.45c-6.76 5.16-10.7 6.32-14.06 6.32s-7.3-1.16-14.06-6.32",
        clipRule: "evenodd"
    }));

const Docusaurus = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200 200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M4.883.09v1.08a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V.09z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__b",
        d: "M4.883.09v1.08a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V.09z"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M99 52h84v34H99z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3ECC5F",
        d: "M23 163c-7.398 0-13.843-4.027-17.303-10A19.9 19.9 0 0 0 3 163c0 11.046 8.954 20 20 20h20v-20z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3ECC5F",
        d: "M112.98 57.376 183 53V43c0-11.046-8.954-20-20-20H73l-2.5-4.33c-1.112-1.925-3.889-1.925-5 0L63 23l-2.5-4.33c-1.111-1.925-3.889-1.925-5 0L53 23l-2.5-4.33c-1.111-1.925-3.889-1.925-5 0L43 23q-.032.002-.065.003l-4.142-4.141c-1.57-1.571-4.252-.853-4.828 1.294l-1.369 5.104-5.192-1.392c-2.148-.575-4.111 1.389-3.535 3.536l1.39 5.193-5.102 1.367c-2.148.576-2.867 3.259-1.296 4.83l4.142 4.142q-.002.031-.003.064l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 53l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 63l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 73l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 83l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 93l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 103l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 113l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 123l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 133l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 143l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 153l-4.33 2.5c-1.925 1.111-1.925 3.889 0 5L23 163c0 11.046 8.954 20 20 20h120c11.046 0 20-8.954 20-20V83l-70.02-4.376A10.645 10.645 0 0 1 103 68c0-5.621 4.37-10.273 9.98-10.624"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3ECC5F",
        d: "M143 183h30v-40h-30z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#44D860",
        d: "M193 158c-.219 0-.428.037-.639.064q-.055-.225-.116-.451A5 5 0 0 0 190.32 148a4.96 4.96 0 0 0-3.016 1.036 27 27 0 0 0-.335-.336 4.96 4.96 0 0 0 1.011-2.987 5 5 0 0 0-9.599-1.959c-.148-.042-.297-.077-.445-.115.027-.211.064-.42.064-.639a5 5 0 0 0-5-5 5 5 0 0 0-5 5c0 .219.037.428.064.639-.148.038-.297.073-.445.115a4.998 4.998 0 0 0-9.599 1.959c0 1.125.384 2.151 1.011 2.987-3.717 3.632-6.031 8.693-6.031 14.3 0 11.046 8.954 20 20 20 9.339 0 17.16-6.41 19.361-15.064.211.027.42.064.639.064a5 5 0 0 0 5-5 5 5 0 0 0-5-5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3ECC5F",
        d: "M153 123h30v-20h-30z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#44D860",
        d: "M193 115.5a2.5 2.5 0 1 0 0-5c-.109 0-.214.019-.319.032q-.028-.113-.058-.225a2.501 2.501 0 0 0-.963-4.807c-.569 0-1.088.197-1.508.518a7 7 0 0 0-.168-.168c.314-.417.506-.931.506-1.494a2.5 2.5 0 0 0-4.8-.979A10 10 0 0 0 183 103c-5.522 0-10 4.478-10 10s4.478 10 10 10c.934 0 1.833-.138 2.69-.377a2.5 2.5 0 0 0 4.8-.979c0-.563-.192-1.077-.506-1.494q.085-.083.168-.168c.42.321.939.518 1.508.518a2.5 2.5 0 0 0 .963-4.807q.03-.112.058-.225c.105.013.21.032.319.032"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M63 55.5a2.5 2.5 0 0 1-2.5-2.5c0-4.136-3.364-7.5-7.5-7.5s-7.5 3.364-7.5 7.5a2.5 2.5 0 1 1-5 0c0-6.893 5.607-12.5 12.5-12.5S65.5 46.107 65.5 53a2.5 2.5 0 0 1-2.5 2.5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFFF50",
        d: "M103 183h60c11.046 0 20-8.954 20-20V93h-60c-11.046 0-20 8.954-20 20z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M168.02 124h-50.04a1 1 0 1 1 0-2h50.04a1 1 0 1 1 0 2m0 20h-50.04a1 1 0 1 1 0-2h50.04a1 1 0 1 1 0 2m0 20h-50.04a1 1 0 1 1 0-2h50.04a1 1 0 1 1 0 2m0-49.814h-50.04a1 1 0 1 1 0-2h50.04a1 1 0 1 1 0 2m0 19.814h-50.04a1 1 0 1 1 0-2h50.04a1 1 0 1 1 0 2m0 20h-50.04a1 1 0 1 1 0-2h50.04a1 1 0 1 1 0 2M183 61.611c-.012 0-.022-.006-.034-.005-3.09.105-4.552 3.196-5.842 5.923-1.346 2.85-2.387 4.703-4.093 4.647-1.889-.068-2.969-2.202-4.113-4.46-1.314-2.594-2.814-5.536-5.963-5.426-3.046.104-4.513 2.794-5.807 5.167-1.377 2.528-2.314 4.065-4.121 3.994-1.927-.07-2.951-1.805-4.136-3.813-1.321-2.236-2.848-4.75-5.936-4.664-2.994.103-4.465 2.385-5.763 4.4-1.373 2.13-2.335 3.428-4.165 3.351-1.973-.07-2.992-1.51-4.171-3.177-1.324-1.873-2.816-3.993-5.895-3.89-2.928.1-4.399 1.97-5.696 3.618-1.232 1.564-2.194 2.802-4.229 2.724a1 1 0 0 0-.072 2c3.017.101 4.545-1.8 5.872-3.487 1.177-1.496 2.193-2.787 4.193-2.855 1.926-.082 2.829 1.115 4.195 3.045 1.297 1.834 2.769 3.914 5.731 4.021 3.103.104 4.596-2.215 5.918-4.267 1.182-1.834 2.202-3.417 4.15-3.484 1.793-.067 2.769 1.35 4.145 3.681 1.297 2.197 2.766 4.686 5.787 4.796 3.125.108 4.634-2.62 5.949-5.035 1.139-2.088 2.214-4.06 4.119-4.126 1.793-.042 2.728 1.595 4.111 4.33 1.292 2.553 2.757 5.445 5.825 5.556l.169.003c3.064 0 4.518-3.075 5.805-5.794 1.139-2.41 2.217-4.68 4.067-4.773z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3ECC5F",
        d: "M83 183h40v-40H83z"
    }), /*#__PURE__*/ React.createElement("g", {
        transform: "rotate(-15 433.487 -340.892)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 84.522,
        height: 33.367,
        x: 0.046,
        y: 0.014,
        fill: "#D8D8D8",
        rx: 2
    }), /*#__PURE__*/ React.createElement("g", {
        fill: "#4A4A4A",
        transform: "translate(1 20.75)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 15.818,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 21.605,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 27.392,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 33.179,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 38.966,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 44.753,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 50.54,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 56.327,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 62.114,
        y: 0.339,
        rx: 1
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1.447.34h12.286a1 1 0 0 1 1 1v2.882a1 1 0 0 1-1 1H1.447a1 1 0 0 1-1-1V1.339a1 1 0 0 1 1-1zm67.634 0h12.287a1 1 0 0 1 1 1v2.882a1 1 0 0 1-1 1H69.08a1 1 0 0 1-1-1V1.339a1 1 0 0 1 1-1z"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#4A4A4A",
        transform: "translate(1 9)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1.447.404h4.69a1 1 0 0 1 1 1v2.882a1 1 0 0 1-1 1h-4.69a1 1 0 0 1-1-1V1.404a1 1 0 0 1 1-1"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 8.042,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 13.829,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 19.616,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 25.403,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 31.19,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 36.977,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 42.764,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 48.551,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 54.337,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 60.124,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 65.911,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 71.698,
        y: 0.404,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 77.485,
        y: 0.404,
        rx: 1
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#4A4A4A",
        transform: "rotate(-180 41.684 4.375)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1 0h4.691a1 1 0 0 1 1 1v2.883a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 7.595,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 13.382,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 19.169,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 24.956,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 30.743,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 36.53,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 42.317,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 48.104,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 53.891,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 59.678,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 65.465,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 71.252,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 77.038,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 7.595,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 13.382,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 19.169,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 24.956,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 30.743,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 36.53,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 42.317,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 48.104,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 53.891,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 59.678,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 65.465,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 71.252,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 77.038,
        rx: 1
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#4A4A4A"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2.447 15.19h6.68a1 1 0 0 1 1 1v2.883a1 1 0 0 1-1 1h-6.68a1 1 0 0 1-1-1v-2.882a1 1 0 0 1 1-1z"
    }), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(11.212 15.19)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 5.787,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 11.574,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 17.361,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 23.148,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 28.935,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 34.722,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 40.508,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 46.295,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 52.082,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 57.869,
        rx: 1
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M76.05 15.19h6.318a1 1 0 0 1 1 1v2.883a1 1 0 0 1-1 1h-6.319a1 1 0 0 1-1-1v-2.882a1 1 0 0 1 1-1z"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#4A4A4A",
        transform: "translate(1 26)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 0.447,
        y: 1.126,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 6.234,
        y: 1.126,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 12.021,
        y: 1.126,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 17.808,
        y: 1.126,
        rx: 1
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M24.594 1.126h27.84a1 1 0 0 1 1 1V5.01a1 1 0 0 1-1 1h-27.84a1 1 0 0 1-1-1V2.126a1 1 0 0 1 1-1m30.743 0h3.607a1 1 0 0 1 1 1V5.01a1 1 0 0 1-1 1h-3.607a1 1 0 0 1-1-1V2.126a1 1 0 0 1 1-1"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 60.848,
        y: 1.126,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 66.635,
        y: 1.126,
        rx: 1
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.883,
        height: 4.883,
        x: 77.485,
        y: 1.126,
        rx: 1
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        transform: "rotate(-180 38.471 1.648)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        transform: "translate(72.06 3.839)"
    })), /*#__PURE__*/ React.createElement("rect", {
        width: 81.379,
        height: 2.17,
        x: 1.808,
        y: 1.085,
        fill: "#4A4A4A",
        rx: 1.085
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 3.798,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 10.042,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 14.846,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 19.649,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 24.453,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 30.457,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 35.26,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 40.064,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 44.867,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 50.872,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 55.675,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 60.479,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 66.483,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 71.286,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 4.563,
        height: 1.447,
        x: 76.09,
        y: 1.447,
        fill: "#D8D8D8",
        opacity: 0.136,
        rx: 0.723
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#44D860",
        d: "M143 158c-.219 0-.428.037-.639.064-.038-.15-.074-.301-.116-.451A5 5 0 0 0 140.32 148a4.96 4.96 0 0 0-3.016 1.036 27 27 0 0 0-.335-.336 4.96 4.96 0 0 0 1.011-2.987 5 5 0 0 0-9.599-1.959c-.148-.042-.297-.077-.445-.115.027-.211.064-.42.064-.639a5 5 0 0 0-5-5 5 5 0 0 0-5 5c0 .219.037.428.064.639-.148.038-.297.073-.445.115a4.998 4.998 0 0 0-9.599 1.959c0 1.125.384 2.151 1.011 2.987-3.717 3.632-6.031 8.693-6.031 14.3 0 11.046 8.954 20 20 20 9.339 0 17.16-6.41 19.361-15.064.211.027.42.064.639.064a5 5 0 0 0 5-5 5 5 0 0 0-5-5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3ECC5F",
        d: "M83 123h40v-20H83z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#44D860",
        d: "M133 115.5a2.5 2.5 0 1 0 0-5c-.109 0-.214.019-.319.032q-.028-.113-.058-.225a2.501 2.501 0 0 0-.963-4.807c-.569 0-1.088.197-1.508.518a7 7 0 0 0-.168-.168c.314-.417.506-.931.506-1.494a2.5 2.5 0 0 0-4.8-.979A10 10 0 0 0 123 103c-5.522 0-10 4.478-10 10s4.478 10 10 10c.934 0 1.833-.138 2.69-.377a2.5 2.5 0 0 0 4.8-.979c0-.563-.192-1.077-.506-1.494q.085-.083.168-.168c.42.321.939.518 1.508.518a2.5 2.5 0 0 0 .963-4.807q.03-.112.058-.225c.105.013.21.032.319.032"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M143 41.75c-.16 0-.33-.02-.49-.05a2.5 2.5 0 0 1-.47-.14c-.15-.06-.29-.14-.431-.23-.13-.09-.259-.2-.38-.31-.109-.12-.219-.24-.309-.38s-.17-.28-.231-.43a2.6 2.6 0 0 1-.189-.96c0-.16.02-.33.05-.49s.08-.31.139-.47c.061-.15.141-.29.231-.43.09-.13.2-.26.309-.38.121-.11.25-.22.38-.31.141-.09.281-.17.431-.23s.31-.11.47-.14c.32-.07.65-.07.98 0 .159.03.32.08.47.14s.29.14.43.23c.13.09.259.2.38.31.11.12.22.25.31.38.09.14.17.28.23.43.06.16.11.31.14.47.029.16.05.33.05.49 0 .66-.271 1.31-.73 1.77-.121.11-.25.22-.38.31-.14.09-.281.17-.43.23a2.6 2.6 0 0 1-.96.19m20-1.25c-.66 0-1.3-.27-1.771-.73a4 4 0 0 1-.309-.38c-.09-.14-.17-.28-.231-.43a2.6 2.6 0 0 1-.189-.96c0-.66.27-1.3.729-1.77.121-.11.25-.22.38-.31.141-.09.281-.17.431-.23s.31-.11.47-.14c.32-.07.66-.07.98 0 .159.03.32.08.47.14s.29.14.43.23c.13.09.259.2.38.31.459.47.73 1.11.73 1.77 0 .16-.021.33-.05.49s-.08.32-.14.47c-.07.15-.14.29-.23.43-.09.13-.2.26-.31.38-.121.11-.25.22-.38.31-.14.09-.281.17-.43.23a2.6 2.6 0 0 1-.96.19"
    })));

const Dogecoin = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__a",
        width: "111.7%",
        height: "111.7%",
        x: "-5.8%",
        y: "-4.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in: "shadowBlurOuter1",
        in2: "SourceAlpha",
        operator: "out",
        result: "shadowBlurOuter1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__d",
        width: "123.3%",
        height: "121.9%",
        x: "-11.7%",
        y: "-7.8%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.204257246 0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0.5
    })), /*#__PURE__*/ React.createElement("circle", {
        id: "prefix__b",
        cx: 16,
        cy: 15,
        r: 15
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__e",
        d: "M13.248 13.61h4.314v2.286h-4.314v4.818h2.721q1.615 0 2.644-.437 1.029-.436 1.615-1.21.585-.773.796-1.815.21-1.042.21-2.252t-.21-2.252a4.4 4.4 0 0 0-.796-1.815q-.587-.774-1.615-1.21-1.029-.437-2.644-.437h-2.721zm-2.766 2.286H9v-2.285h1.482V7h6.549q1.815 0 3.142.627 1.327.628 2.168 1.715.84 1.086 1.25 2.543T24 15a11.5 11.5 0 0 1-.41 3.115q-.408 1.456-1.25 2.543-.84 1.087-2.167 1.715Q18.845 23 17.03 23h-6.549z"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#000",
        filter: "url(#prefix__a)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#C3A634"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "url(#prefix__c)",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 16,
        cy: 15,
        r: 14.5,
        stroke: "#000",
        strokeOpacity: 0.097
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#000",
        filter: "url(#prefix__d)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#FFF"
    })));

const Dotenv = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#09090B",
        d: "M0 0h24v24H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ECD53F",
        d: "M24 0v24H0V0zM10.933 15.89H6.84v5.52h4.198v-.93H7.955v-1.503h2.77v-.93h-2.77v-1.224h2.978zm2.146 0h-1.084v5.52h1.035v-3.6l2.226 3.6h1.118v-5.52h-1.036v3.686zm5.117 0h-1.208l1.973 5.52h1.19l1.976-5.52h-1.182l-1.352 4.085zM5.4 19.68H3.72v1.68H5.4z"
    }));

const Dotenvx = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ECD53F",
        d: "M0 0h24v24H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#09090B",
        d: "M24 0v24H0V0zM10.933 15.89H6.84v5.52h4.198v-.93H7.955v-1.503h2.77v-.93h-2.77v-1.224h2.978zm2.146 0h-1.084v5.52h1.035v-3.6l2.226 3.6h1.118v-5.52h-1.036v3.686zm5.117 0h-1.208l1.973 5.52h1.19l1.976-5.52h-1.182l-1.352 4.085zM5.4 19.68H3.72v1.68H5.4z"
    }));

const Dreamweaver = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 240 234",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M42.5 0h155C221 0 240 19 240 42.5v149c0 23.5-19 42.5-42.5 42.5h-155C19 234 0 215 0 191.5v-149C0 19 19 0 42.5 0",
        style: {
            fill: "#470137"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22.8 164V62c-.1-.6.4-1.2 1-1.3h.1l6.7-.2 10.4-.2 12.7-.1c12.2 0 22.4 2.2 30.4 6.6 7.7 4.1 14 10.4 18.1 18.1 4 7.7 6 16.5 6 26.5.1 7-.9 13.9-3.1 20.5A48.7 48.7 0 0 1 84.2 158a54.9 54.9 0 0 1-30.1 8.3H42.8l-11.2-.1-7.8-.2c-.7 0-1-.6-1-1.6zm21.1-84.4v66.7l3.1.1 2.8.2 3.3.1c4.6.1 9.2-.7 13.6-2.3 4-1.4 7.5-3.7 10.5-6.8 3-3.2 5.3-7 6.7-11.1a47.6 47.6 0 0 0 .1-29.1 26 26 0 0 0-17.1-16.2c-4.3-1.3-8.7-2-13.2-1.9l-5.1.1zM198 165h-18.7c-.4.1-.9-.1-1.2-.4l-.6-1.2-4.8-21.3-3.2-15.7-2.1-10.9-1.3-7.6h-.1l-2.8 12.8c-.8 4.1-1.8 8.3-2.8 12.5L157 147l-4.1 16.4c-.2 1.1-.7 1.6-1.6 1.6h-18.7c-.5.1-1-.1-1.4-.3l-.7-1.1L111 86.3c-.3-.9.1-1.3 1.2-1.3h18.9c.9 0 1.4.3 1.5 1 2 8.8 3.7 16.4 5 22.8s2.4 11.8 3.1 16.3l1.9 11 1.2 7h.3a76 76 0 0 1 2.2-12.2l2.2-10.9 3.1-14.6a315 315 0 0 1 5-20.2c.1-.2.5-.3 1.1-.3h19.6c.6 0 .9.4 1 1.1a1358 1358 0 0 1 7.3 33.9c.8 4.2 1.5 7.9 1.9 10.9.4 3.1.9 5.6 1.3 7.7.3 1.7.6 3.4.7 5.1h.3c.5-2 .9-4.4 1.3-7.1s.9-5.7 1.6-9.1l2.1-11.2c.7-4.1 1.7-8.6 2.8-13.7l3.7-16.4c.2-.9.6-1.3 1.3-1.3h17.5c.9 0 1.2.5 1 1.4l-21.6 77.1c-.1.4-.3.8-.6 1.1 0 .5-.4.7-.9.6",
        style: {
            fill: "#ff61f6"
        }
    }));

const DrizzleORMDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 160 160",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 9.631,
        height: 40.852,
        fill: "#C5F74F",
        rx: 4.816,
        transform: "matrix(.87303 .48767 -.49721 .86763 43.48 67.304)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 9.631,
        height: 40.852,
        fill: "#C5F74F",
        rx: 4.816,
        transform: "matrix(.87303 .48767 -.49721 .86763 76.94 46.534)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 9.631,
        height: 40.852,
        fill: "#C5F74F",
        rx: 4.816,
        transform: "matrix(.87303 .48767 -.49721 .86763 128.424 46.535)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 9.631,
        height: 40.852,
        fill: "#C5F74F",
        rx: 4.816,
        transform: "matrix(.87303 .48767 -.49721 .86763 94.957 67.304)"
    }));

const DrizzleORMLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 160 160",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 9.631,
        height: 40.852,
        fill: "#121212",
        rx: 4.816,
        transform: "matrix(.87303 .48767 -.49721 .86763 43.48 67.304)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 9.631,
        height: 40.852,
        fill: "#121212",
        rx: 4.816,
        transform: "matrix(.87303 .48767 -.49721 .86763 76.94 46.534)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 9.631,
        height: 40.852,
        fill: "#121212",
        rx: 4.816,
        transform: "matrix(.87303 .48767 -.49721 .86763 128.424 46.535)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 9.631,
        height: 40.852,
        fill: "#121212",
        rx: 4.816,
        transform: "matrix(.87303 .48767 -.49721 .86763 94.957 67.304)"
    }));

const Dropbox = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0061FE",
        d: "M0 0h128v128H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F7F5F2",
        d: "M43.7 32 23.404 44.75 43.701 57.5 64 44.75 84.3 57.5l20.298-12.75L84.299 32 64.002 44.75zm0 51L23.404 70.25 43.701 57.5 64 70.25 43.702 83Zm20.302-12.75L84.299 57.5l20.298 12.75L84.299 83zm0 29.75L43.7 87.25 64 74.5l20.3 12.75z"
    }));

const DubDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M32 64c17.673 0 32-14.327 32-32 0-11.844-6.435-22.186-16-27.719V48h-8v-2.14A15.9 15.9 0 0 1 32 48c-8.837 0-16-7.163-16-16s7.163-16 16-16c2.914 0 5.647.78 8 2.14V1.008A32 32 0 0 0 32 0C14.327 0 0 14.327 0 32s14.327 32 32 32",
        clipRule: "evenodd"
    }));

const DubLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 191 191",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M191 95.5c0 52.743-42.757 95.5-95.5 95.5S0 148.243 0 95.5 42.757 0 95.5 0 191 42.757 191 95.5"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        width: 191,
        height: 191,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M191 95.5c0 52.743-42.757 95.5-95.5 95.5S0 148.243 0 95.5 42.757 0 95.5 0 191 42.757 191 95.5"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#fff",
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 95,
        cy: 100,
        r: 49
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M122-14h22v162h-22z"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h191v191H0z"
    }))));

const DuckDuckGo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#DE5833",
        fillRule: "evenodd",
        d: "M64 128c35.346 0 64-28.654 64-64S99.346 0 64 0 0 28.654 0 64s28.654 64 64 64",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#DDD",
        fillRule: "evenodd",
        d: "M73 111.75c0-.5.123-.614-1.466-3.782-4.224-8.459-8.47-20.384-6.54-28.075.353-1.397-3.978-51.744-7.04-53.365-3.402-1.813-7.588-4.69-11.418-5.33-1.943-.31-4.49-.164-6.482.105-.353.047-.368.683-.03.798 1.308.443 2.895 1.212 3.83 2.375.178.22-.06.566-.342.577-.882.032-2.482.402-4.593 2.195-.244.207-.041.592.273.53 4.536-.897 9.17-.455 11.9 2.027.177.16.084.45-.147.512-23.694 6.44-19.003 27.05-12.696 52.344 5.619 22.53 7.733 29.792 8.4 32.004a.72.72 0 0 0 .423.467C55.228 118.38 73 118.524 73 113z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M122.75 64c0 32.447-26.303 58.75-58.75 58.75S5.25 96.447 5.25 64 31.553 5.25 64 5.25 122.75 31.553 122.75 64m-72.46 51.986c-1.624-5.016-6.161-19.551-10.643-37.92l-.447-1.828-.003-.016c-5.425-22.155-9.855-40.252 14.427-45.937.222-.052.33-.317.183-.492-2.786-3.305-8.005-4.388-14.604-2.111-.27.093-.506-.18-.338-.412 1.294-1.783 3.823-3.155 5.072-3.756.258-.124.242-.502-.031-.588a28 28 0 0 0-3.771-.9c-.37-.059-.404-.693-.032-.743 9.356-1.259 19.125 1.55 24.028 7.726a.33.33 0 0 0 .185.114c17.953 3.855 19.239 32.235 17.17 33.528-.407.255-1.714.108-3.438-.085-6.985-.781-20.818-2.329-9.401 18.948.113.21-.037.488-.272.525-6.416.997 1.755 21.034 7.812 34.323 23.815-5.52 41.563-26.868 41.563-52.362 0-29.685-24.065-53.75-53.75-53.75S10.25 34.315 10.25 64c0 24.947 16.995 45.924 40.04 51.986",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3CA82B",
        d: "M84.28 90.698c-1.367-.633-6.621 3.135-10.11 6.028-.728-1.031-2.103-1.78-5.203-1.242-2.713.472-4.211 1.126-4.88 2.254-4.283-1.623-11.488-4.13-13.229-1.71-1.902 2.646.476 15.161 3.003 16.786 1.32.849 7.63-3.208 10.926-6.005.532.749 1.388 1.178 3.148 1.137 2.662-.062 6.979-.681 7.649-1.921q.06-.113.105-.266c3.388 1.266 9.35 2.606 10.682 2.406 3.47-.521-.484-16.723-2.09-17.467"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4CBA3C",
        d: "M74.49 97.097c.144.256.26.526.358.8.483 1.352 1.27 5.648.674 6.709-.595 1.062-4.459 1.574-6.843 1.615s-2.92-.831-3.403-2.181c-.387-1.081-.577-3.621-.572-5.075-.098-2.158.69-2.916 4.334-3.506 2.696-.436 4.121.071 4.944.94 3.828-2.857 10.215-6.889 10.838-6.152 3.106 3.674 3.499 12.42 2.826 15.939-.22 1.151-10.505-1.139-10.505-2.38 0-5.152-1.337-6.565-2.65-6.71M51.96 95.488c.843-1.333 7.674.325 11.424 1.993 0 0-.77 3.491.456 7.604.359 1.203-8.627 6.558-9.8 5.637-1.355-1.065-3.85-12.432-2.08-15.234"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC3",
        fillRule: "evenodd",
        d: "M55.269 68.407c.553-2.404 3.127-6.933 12.321-6.823 4.648-.019 10.422-.002 14.25-.436a51.3 51.3 0 0 0 12.726-3.095c3.98-1.519 5.392-1.18 5.887-.272.544.999-.097 2.722-1.488 4.309-2.656 3.03-7.431 5.38-15.865 6.076-8.433.698-14.02-1.565-16.425 2.118-1.038 1.589-.236 5.333 7.92 6.512 11.02 1.59 20.072-1.917 21.19.201s-5.323 6.428-16.362 6.518-17.934-3.865-20.379-5.83c-3.102-2.495-4.49-6.133-3.775-9.279",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("g", {
        fill: "#14307E",
        opacity: 0.8
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M69.327 42.127c.616-1.008 1.981-1.786 4.216-1.786 2.234 0 3.285.889 4.013 1.88.148.202-.076.44-.306.34l-.168-.073c-.817-.357-1.82-.795-3.54-.82-1.838-.026-2.997.435-3.727.831-.246.134-.634-.133-.488-.372m-25.157 1.29c2.17-.907 3.876-.79 5.081-.504.254.06.43-.213.227-.377-.935-.755-3.03-1.692-5.76-.674-2.437.909-3.585 2.796-3.592 4.038-.002.292.6.317.756.07.42-.67 1.12-1.646 3.289-2.553"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M75.44 55.92a3.47 3.47 0 0 1-3.474-3.462 3.47 3.47 0 0 1 3.475-3.46 3.47 3.47 0 0 1 3.474 3.46 3.47 3.47 0 0 1-3.475 3.462m2.447-4.608a.899.899 0 0 0-1.799 0c0 .494.405.895.9.895.499 0 .9-.4.9-.895m-25.465 3.542a4.04 4.04 0 0 1-4.049 4.037 4.045 4.045 0 0 1-4.05-4.037 4.045 4.045 0 0 1 4.05-4.037 4.045 4.045 0 0 1 4.05 4.037m-1.193-1.338a1.05 1.05 0 0 0-2.097 0 1.048 1.048 0 0 0 2.097 0",
        clipRule: "evenodd"
    })));

const Ebay = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0.1 0.1 299.8 120.125",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#e53238",
        d: "M38.867 26.309C17.721 26.309.1 35.279.1 62.345c0 21.442 11.849 34.944 39.312 34.944 32.326 0 34.398-21.294 34.398-21.294H58.147s-3.358 11.466-19.69 11.466c-13.302 0-22.869-8.986-22.869-21.58h59.861v-7.904c0-12.46-7.91-31.668-36.582-31.668M38.32 36.41c12.662 0 21.294 7.757 21.294 19.383h-43.68c0-12.343 11.268-19.383 22.386-19.383"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0064d2",
        d: "M75.438.1v83.597c0 4.745-.339 11.408-.339 11.408h14.939s.537-4.785.537-9.159c0 0 7.381 11.548 27.451 11.548 21.134 0 35.49-14.674 35.49-35.695 0-19.557-13.186-35.286-35.456-35.286-20.854 0-27.334 11.261-27.334 11.261V.1zm38.766 36.753c14.352 0 23.479 10.652 23.479 24.946 0 15.328-10.541 25.355-23.376 25.355-15.318 0-23.581-11.961-23.581-25.219 0-12.354 7.414-25.082 23.478-25.082"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f5af02",
        d: "M190.645 26.309c-31.812 0-33.852 17.418-33.852 20.202h15.834s.83-10.169 16.926-10.169c10.459 0 18.564 4.788 18.564 13.991v3.276h-18.564c-24.645 0-37.674 7.21-37.674 21.841 0 14.398 12.038 22.232 28.307 22.232 22.172 0 29.314-12.251 29.314-12.251 0 4.873.375 9.675.375 9.675h14.076s-.545-5.952-.545-9.76V52.432c0-21.582-17.408-26.123-32.761-26.123m17.472 37.128v4.368c0 5.697-3.516 19.861-24.212 19.861-11.333 0-16.192-5.656-16.192-12.217 0-11.935 16.363-12.012 40.404-12.012"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#86b817",
        d: "M214.879 29.041h17.813l25.565 51.218 25.506-51.218H299.9l-46.459 91.184h-16.927l13.406-25.419z"
    }));

const EclipseIDE = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 240",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "50%",
        y1: "1089.396%",
        y2: "-159.5%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "30.33%",
        stopColor: "#473788"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.2%",
        stopColor: "#2C2255"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "49.999%",
        x2: "49.999%",
        y1: "896.537%",
        y2: "-352.359%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "30.33%",
        stopColor: "#473788"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.2%",
        stopColor: "#2C2255"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "49.999%",
        x2: "49.999%",
        y1: "215.17%",
        y2: "-166.715%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "30.33%",
        stopColor: "#473788"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "86.31%",
        stopColor: "#2C2255"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#2C2255",
        d: "M70.382 153.049H31.26c5.18 17.768 14.792 33.693 28.864 47.768 22.434 22.436 49.41 33.64 80.956 33.64 6.306 0 12.416-.47 18.35-1.365 23.761-3.587 44.565-14.33 62.39-32.275 14.162-14.07 23.842-30 29.062-47.768zM48.81 99.915H28.373a120 120 0 0 0-1.488 13.775h228.399c-.233-4.7-.743-9.285-1.497-13.775M26.885 126.482a119 119 0 0 0 1.488 13.775h225.418a119 119 0 0 0 1.5-13.775m-4.404-39.362c-5.215-17.817-14.897-33.817-29.067-47.99-17.778-17.777-38.522-28.443-62.207-32.031a123 123 0 0 0-18.532-1.386c-31.546 0-58.524 11.143-80.956 33.418C46.048 53.303 36.43 69.303 31.254 87.12"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F7941E",
        d: "M20.093 120.09C20.093 59.753 65.407 9.621 124.357.803c-1.462-.053-2.932-.112-4.409-.112C53.796.692.164 54.15.164 120.09c0 65.943 53.63 119.397 119.784 119.397 1.482 0 2.951-.056 4.419-.11-58.96-8.817-104.274-58.95-104.274-119.287"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M155.728 14.226A78 78 0 0 0 153.364.451H2.642A77.8 77.8 0 0 0 .276 14.226z",
        transform: "translate(63.083 99.461)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M155.728 27.02H.278a77.6 77.6 0 0 0 2.364 13.776h150.724a78 78 0 0 0 2.362-13.776",
        transform: "translate(63.083 99.461)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M78.003 98.636c31.3 0 58.282-18.441 70.706-45.048H7.297c12.425 26.607 39.405 45.048 70.706 45.048",
        transform: "translate(63.083 99.461)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M51.84 126.482h203.29c.108-2.035.168-4.084.168-6.147 0-2.232-.081-4.444-.208-6.647H26.885c-.126 2.2-.208 4.415-.208 6.647 0 2.063.06 4.112.168 6.147zM69.924 87.12H31.252c-1.271 4.166-2.091 8.44-2.879 12.795h224.692a114 114 0 0 0-3.075-12.795m-11.617 53.135H28.371c.766 4.352 1.638 8.623 2.888 12.794h219.479a113 113 0 0 0 3.023-12.794z"
    }));

const Edge = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: 161.8,
        cy: 68.9,
        r: 95.4,
        gradientTransform: "matrix(1 0 0 -.95 0 248.8)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: -340.3,
        cy: 63,
        r: 143.2,
        gradientTransform: "matrix(.15 -.99 -.8 -.12 176.6 -125.4)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__e",
        cx: 113.4,
        cy: 570.2,
        r: 202.4,
        gradientTransform: "matrix(-.04 1 2.13 .08 -1179.5 -106.7)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#35c1f1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.1,
        stopColor: "#34c1ed"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#2fc2df"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#2bc3d2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#36c752"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__f",
        cx: 376.5,
        cy: 568,
        r: 97.3,
        gradientTransform: "matrix(.28 .96 .78 -.23 -303.8 -148.5)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#66eb6e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#66eb6e",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 63.3,
        x2: 241.7,
        y1: 84,
        y2: 84,
        gradientTransform: "matrix(1 0 0 -1 0 266)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#0c59a4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#114a8b"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 157.3,
        x2: 46,
        y1: 161.4,
        y2: 40.1,
        gradientTransform: "matrix(1 0 0 -1 0 266)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#1b9de2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#1595df"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#0680d7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0078d4"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M235.7 195.5a94 94 0 0 1-10.6 4.7 101.9 101.9 0 0 1-35.9 6.4c-47.3 0-88.5-32.5-88.5-74.3a31.5 31.5 0 0 1 16.4-27.3c-42.8 1.8-53.8 46.4-53.8 72.5 0 74 68.1 81.4 82.8 81.4 7.9 0 19.8-2.3 27-4.6l1.3-.4a128.3 128.3 0 0 0 66.6-52.8 4 4 0 0 0-5.3-5.6",
        transform: "translate(-4.6 -5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M235.7 195.5a94 94 0 0 1-10.6 4.7 101.9 101.9 0 0 1-35.9 6.4c-47.3 0-88.5-32.5-88.5-74.3a31.5 31.5 0 0 1 16.4-27.3c-42.8 1.8-53.8 46.4-53.8 72.5 0 74 68.1 81.4 82.8 81.4 7.9 0 19.8-2.3 27-4.6l1.3-.4a128.3 128.3 0 0 0 66.6-52.8 4 4 0 0 0-5.3-5.6",
        opacity: 0.35,
        style: {
            isolation: "isolate"
        },
        transform: "translate(-4.6 -5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M110.3 246.3A79.2 79.2 0 0 1 87.6 225a80.7 80.7 0 0 1 29.5-120c3.2-1.5 8.5-4.1 15.6-4a32.4 32.4 0 0 1 25.7 13 31.9 31.9 0 0 1 6.3 18.7c0-.2 24.5-79.6-80-79.6-43.9 0-80 41.6-80 78.2a130.2 130.2 0 0 0 12.1 56 128 128 0 0 0 156.4 67 75.5 75.5 0 0 1-62.8-8Z",
        transform: "translate(-4.6 -5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M110.3 246.3A79.2 79.2 0 0 1 87.6 225a80.7 80.7 0 0 1 29.5-120c3.2-1.5 8.5-4.1 15.6-4a32.4 32.4 0 0 1 25.7 13 31.9 31.9 0 0 1 6.3 18.7c0-.2 24.5-79.6-80-79.6-43.9 0-80 41.6-80 78.2a130.2 130.2 0 0 0 12.1 56 128 128 0 0 0 156.4 67 75.5 75.5 0 0 1-62.8-8Z",
        opacity: 0.41,
        style: {
            isolation: "isolate"
        },
        transform: "translate(-4.6 -5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M157 153.8c-.9 1-3.4 2.5-3.4 5.6 0 2.6 1.7 5.2 4.8 7.3 14.3 10 41.4 8.6 41.5 8.6a59.6 59.6 0 0 0 30.3-8.3 61.4 61.4 0 0 0 30.4-52.9c.3-22.4-8-37.3-11.3-43.9C228 28.8 182.3 5 132.6 5a128 128 0 0 0-128 126.2c.5-36.5 36.8-66 80-66 3.5 0 23.5.3 42 10a72.6 72.6 0 0 1 30.9 29.3c6.1 10.6 7.2 24.1 7.2 29.5s-2.7 13.3-7.8 19.9Z",
        transform: "translate(-4.6 -5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M157 153.8c-.9 1-3.4 2.5-3.4 5.6 0 2.6 1.7 5.2 4.8 7.3 14.3 10 41.4 8.6 41.5 8.6a59.6 59.6 0 0 0 30.3-8.3 61.4 61.4 0 0 0 30.4-52.9c.3-22.4-8-37.3-11.3-43.9C228 28.8 182.3 5 132.6 5a128 128 0 0 0-128 126.2c.5-36.5 36.8-66 80-66 3.5 0 23.5.3 42 10a72.6 72.6 0 0 1 30.9 29.3c6.1 10.6 7.2 24.1 7.2 29.5s-2.7 13.3-7.8 19.9Z",
        transform: "translate(-4.6 -5)"
    }));

const Electron = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 64,
        cy: 64,
        r: 64,
        fill: "#2F3242"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A2ECFB",
        d: "M51.395 39.503a1.8 1.8 0 0 0 .646-3.542zm-22.78 4.072 1.56.9zm.324 17.36a1.8 1.8 0 0 0 3.125-1.788l-3.125 1.789Zm8.755 5.81a1.8 1.8 0 0 0-2.665 2.422zm16.055 14.956-.901 1.559.9-1.559Zm43.172 7.814a1.8 1.8 0 1 0-2.03-2.973zM52.04 35.961c-5.57-1.016-10.756-1.064-15.067-.023-4.32 1.043-7.89 3.22-9.918 6.738l3.119 1.798c1.394-2.42 3.97-4.15 7.644-5.037 3.682-.89 8.336-.89 13.576.066zm-24.985 6.715c-3.013 5.227-1.778 11.864 1.883 18.26l3.125-1.789c-3.406-5.95-3.955-11.089-1.89-14.673zm7.973 26.49c4.61 5.074 10.687 9.97 17.819 14.094l1.802-3.117c-6.842-3.956-12.62-8.624-16.956-13.397zm17.82 14.094c8.496 4.913 17.198 7.984 24.887 9.1 7.624 1.108 14.54.328 19.186-2.845l-2.03-2.973c-3.566 2.435-9.4 3.307-16.639 2.256-7.173-1.041-15.443-3.937-23.602-8.655zm52.511 1.648a6.29 6.29 0 0 0-6.288-6.295v3.6a2.69 2.69 0 0 1 2.688 2.695zm-6.288-6.295a6.29 6.29 0 0 0-6.288 6.295h3.6a2.69 2.69 0 0 1 2.688-2.695zm-6.288 6.295a6.29 6.29 0 0 0 6.288 6.295v-3.6a2.69 2.69 0 0 1-2.688-2.695zm6.288 6.295a6.29 6.29 0 0 0 6.288-6.295h-3.6a2.69 2.69 0 0 1-2.688 2.695z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A2ECFB",
        d: "M91.487 65.382a1.8 1.8 0 1 0 2.75 2.324zm7.83-21.747-1.56.9zm-14.81-8.394a1.8 1.8 0 1 0-.047 3.6zm-9.566 4.64a1.8 1.8 0 0 0-.756-3.52zm-21.157 6.492.9 1.558zM25.549 80.905a1.8 1.8 0 0 0 3.562-.522zm68.688-13.2c3.647-4.314 6.268-8.778 7.515-13.027 1.249-4.257 1.148-8.43-.876-11.941l-3.119 1.797c1.392 2.415 1.603 5.508.54 9.13-1.065 3.63-3.379 7.658-6.81 11.718zm6.639-24.968c-2.964-5.143-9.168-7.402-16.369-7.496l-.047 3.6c6.673.087 11.266 2.17 13.297 5.693zm-26.69-6.377c-6.75 1.449-14.098 4.288-21.303 8.455l1.802 3.116c6.912-3.997 13.91-6.69 20.256-8.05l-.756-3.52Zm-21.303 8.455c-8.746 5.057-15.916 11.28-20.734 17.578-4.772 6.237-7.434 12.819-6.6 18.512l3.562-.522c-.627-4.28 1.364-9.877 5.897-15.803 4.488-5.866 11.276-11.791 19.677-16.649z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A2ECFB",
        d: "M49.083 87.23a1.8 1.8 0 1 0-3.39 1.212zm29.48 9.196a1.8 1.8 0 0 0-3.086-1.853l3.087 1.853ZM79.57 85.18a1.8 1.8 0 1 0 3.436 1.073zm4.813-21.113h-1.8zM69.156 22.53a1.8 1.8 0 1 0-1.463 3.29zM45.693 88.442c1.906 5.332 4.457 9.849 7.51 13.063 3.06 3.219 6.725 5.226 10.78 5.226v-3.6c-2.785 0-5.566-1.366-8.17-4.106-2.609-2.746-4.936-6.777-6.73-11.796zm18.29 18.289c5.886 0 10.91-4.189 14.58-10.305l-3.086-1.853c-3.399 5.662-7.465 8.558-11.494 8.558zm19.023-20.478c2.02-6.467 3.177-14.07 3.177-22.186h-3.6c0 7.787-1.11 15.025-3.013 21.113zm3.177-22.186c0-9.953-1.74-19.145-4.687-26.417-2.921-7.206-7.152-12.813-12.34-15.12l-1.463 3.29c3.943 1.753 7.692 6.336 10.467 13.183 2.749 6.78 4.423 15.504 4.423 25.064z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        stroke: "#A2ECFB",
        strokeLinecap: "round",
        strokeWidth: 3.6,
        d: "M103.559 84.908a4.49 4.49 0 0 0-4.488-4.495 4.49 4.49 0 0 0-4.488 4.495 4.49 4.49 0 0 0 4.488 4.495 4.49 4.49 0 0 0 4.488-4.495zm-74.745 4.495a4.49 4.49 0 0 0 4.488-4.495 4.49 4.49 0 0 0-4.488-4.495 4.49 4.49 0 0 0-4.488 4.495 4.49 4.49 0 0 0 4.488 4.495z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 63.983,
        cy: 23.204,
        stroke: "#A2ECFB",
        strokeLinecap: "round",
        strokeWidth: 3.6,
        rx: 4.488,
        ry: 4.495
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A2ECFB",
        fillRule: "evenodd",
        d: "M64.85 68.086a4.112 4.112 0 0 1-1.733-8.037 4.105 4.105 0 0 1 4.878 3.15 4.11 4.11 0 0 1-3.145 4.887",
        clipRule: "evenodd"
    }));

const Elementor = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 400 400",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#92003B",
        d: "M200 0C89.532 0 0 89.532 0 200c0 110.431 89.532 200 200 200s200-89.532 200-200C399.964 89.532 310.431 0 200 0m-49.991 283.306h-33.315V116.658h33.315zm133.297 0h-99.982v-33.315h99.982zm0-66.667h-99.982v-33.315h99.982zm0-66.666h-99.982v-33.315h99.982z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h400v400H0z"
    }))));

const ElysiaJS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            transform: "matrix(1.11388,0,0,1.11388,0,0)",
            transformOrigin: "50% 50%",
            cursor: "move",
            transition: "transform 200ms ease-in-out 0s"
        },
        viewBox: "0 0 4040 4040",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "75%",
        x2: "25%",
        y1: "45%",
        y2: "90%",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        style: {
            stopColor: "#8d8e8d"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1%",
        style: {
            stopColor: "#8b8c8b"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "2%",
        style: {
            stopColor: "#8a8c8a"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "3%",
        style: {
            stopColor: "#8a8b8a"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "4%",
        style: {
            stopColor: "#828382"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "5%",
        style: {
            stopColor: "#878987"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "12%",
        style: {
            stopColor: "#848584"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "13%",
        style: {
            stopColor: "#838583"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "14%",
        style: {
            stopColor: "#838483"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "24%",
        style: {
            stopColor: "#7d7e7d"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "25%",
        style: {
            stopColor: "#7c7e7c"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "26%",
        style: {
            stopColor: "#7c7d7c"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "28%",
        style: {
            stopColor: "#7b7c7b"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "29%",
        style: {
            stopColor: "#7a7c7a"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "30%",
        style: {
            stopColor: "#7a7b7a"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "31%",
        style: {
            stopColor: "#797b79"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "37%",
        style: {
            stopColor: "#777877"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "38%",
        style: {
            stopColor: "#767876"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "92%",
        style: {
            stopColor: "#616261"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "93%",
        style: {
            stopColor: "#5f605e"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "94%",
        style: {
            stopColor: "#5f5f5e"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "98%",
        style: {
            stopColor: "#5d5e5c"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        style: {
            stopColor: "#5d5d5d"
        }
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "#333",
        style: {
            transform: "none"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M3390 3118c1-24 5-88 10-143 24-264-44-534-188-747-49-73-49-73-215-128s-166-55-167-92c0-36-1-37-52-48-155-34-306-19-499 50-62 22-127 40-144 40-32 0-32 0-39-109-3-60-15-144-26-186-36-140-44-132 133-138 167-5 243-22 374-82 86-40 168-94 156-104-4-4-33-18-63-30-96-38-208-111-260-167-42-46-54-70-76-142-73-243-178-358-399-437-27-10-67-34-88-54-57-53-117-135-117-158 0-19 8-21 93-27 319-22 506-6 729 63 479 150 843 466 1053 915 147 314 191 715 119 1076-23 118-81 285-137 400-61 124-167 290-184 290-9 0-13-15-13-42M321 2538c-28-146-35-229-35-433-1-188 3-236 21-330 67-328 222-622 452-854 110-112 185-181 195-181 2 0 12 24 22 53 22 69 64 150 108 212 24 33 36 61 36 82 0 30-5 35-58 62-118 60-213 144-301 269-51 72-51 72 19 72s70 0 70 34c0 30-6 37-45 60-25 15-72 50-106 77-196 164-338 527-339 867 0 47-3 62-14 62-10 0-18-18-25-52"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2180 1175c0-33 2-35 35-35s35 2 35 35-2 35-35 35-35-2-35-35m-280-180c0-33 2-35 35-35s35 2 35 35-2 35-35 35-35-2-35-35"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#666",
        style: {
            transform: "none"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M2911 3730c85-125 134-292 110-378-16-59-67-107-130-122-101-24-216 12-581 184-207 98-372 157-505 182-103 19-368 16-465-6-232-51-457-150-545-240-50-51-50-51-50-248 0-155 4-213 18-274 18-78 18-78 53-78 26 0 34 4 34 18 1 14 5 12 23-9 142-169 182-215 187-219 3-3 42-48 85-100 77-93 78-95 52-98-23-3-27-8-27-38 0-24 5-34 15-34 8 0 15-4 15-9 0-11 98-54 181-79 82-25 249-45 306-36 40 6 43 8 42 38 0 26-8 36-46 61-26 17-58 46-72 65-29 39-23 36 60-32 73-59 257-179 343-223 78-40 78-40 73-145-3-58-13-130-22-160s-19-72-22-92c-5-38-5-38 30-38 22 0 37 6 41 15q6 15-15 15c-16 0-19 4-14 18 18 48 35 148 41 245 4 59 8 107 9 107s52-18 114-40c182-65 359-86 507-59 78 14 254 71 254 82 0 6-25 7-58 3-116-13-94 5 75 62 166 57 166 57 215 130 150 222 215 497 189 800-6 68-9 127-6 132 3 4-3 18-13 31s-31 56-46 94c-68 172-199 348-336 450-33 25-143 85-155 85-3 0 13-27 36-60m434-1211c-21-82-125-297-147-307-5-2-8-9-8-15 0-7-10-18-22-26-36-23-298-111-352-119-51-7-51-7-51-49s0-42-64-49c-91-10-223 1-311 26-93 26-231 80-226 89 8 12 208 105 275 128 25 8 96 37 156 65 141 63 143 64 320 138 83 34 168 70 190 80s76 32 120 50c44 17 91 37 105 44s26 12 28 10c2-1-4-30-13-65"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M340 2611c-11-21-14-181-4-218 4-13 13-23 20-23 11 0 14 26 14 130 0 127-7 153-30 111m5-307c16-133 93-372 123-382 21-7 14 49-18 129-30 78-70 239-70 284 0 19-5 25-21 25-20 0-21-3-14-56m145-443c0-5 23-43 50-85 57-84 135-159 224-214 60-37 60-37 25-43-19-4-26-7-16-8 9 0 17-8 17-16 0-11 11-15 40-15 39 0 40 1 40 35 0 25-5 38-17 42-10 4-24 13-31 20s-20 13-28 13-14 5-14 10c0 6-6 10-14 10s-16 7-20 15c-3 8-15 15-26 15s-20 6-20 13c0 16-82 97-98 97-7 0-12 9-12 20s-4 20-10 20c-5 0-10 7-10 15s-4 15-9 15-12 11-15 25c-5 18-13 25-31 25-14 0-25-4-25-9m1790-227c0-16 12-22 68-31 86-15 194-45 208-58 6-5 35-21 65-35s56-28 57-32c2-5 8-8 13-8s17-8 27-18c15-15 16-21 6-30-7-7-22-12-34-12-11 0-20-4-20-10 0-5-9-10-19-10-30 0-51-11-51-26 0-8-10-14-24-14s-31-6-38-14c-8-7-24-17-36-20-12-4-22-14-22-22s-8-14-18-14c-20 0-72-49-72-68 0-7-4-12-10-12-5 0-10-13-10-30 0-18-5-30-13-30-12 0-57-130-57-165 0-8-4-15-9-15s-17-20-28-45c-10-25-21-45-25-45-5 0-8-9-8-20s-6-20-13-20c-16 0-67-52-67-68 0-7-9-12-20-12s-20-4-20-8-16-14-35-21-35-19-35-27c0-9-11-14-30-14-16 0-30-3-30-8 0-4-23-13-52-20-59-14-108-54-108-88 0-16-7-24-22-26s-24-11-26-25c-2-13-10-23-18-23s-14-7-14-15-4-15-10-15c-5 0-10-9-10-20 0-30 33-25 52 8 31 53 137 160 165 166 16 4 70 27 121 52 163 79 241 180 306 396 22 72 34 96 76 142 56 61 166 129 284 177 42 17 76 36 76 42 0 24-87 90-173 131-96 46-205 80-294 92-48 6-53 5-53-12M640 1512c0-5 15-26 33-48 18-21 54-68 79-105 25-36 53-71 62-78 14-12 16-9 16 24 0 28-5 38-20 42-11 3-20 14-20 24 0 11-4 19-10 19-5 0-10 7-10 15s-4 15-10 15c-5 0-10 7-10 15s-9 15-20 15c-15 0-20 7-20 25 0 14-8 29-19 35-24 12-51 13-51 2m230-283c42-37 132-99 142-99 5 0 8 11 8 25 0 16-6 25-15 25-8 0-15 5-15 10 0 6-7 10-15 10s-15 5-15 10c0 6-11 10-25 10-18 0-25 5-25 20 0 17-7 20-37 20-38-1-38-1-3-31"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2034 1195c-109-55-168-152-138-229 10-27 68-21 84 8 17 32 77 74 178 125 82 41 82 41 82 81s0 40-78 40c-63 0-87-5-128-25m-1004-65c0-5 14-17 30-25 33-17 34-15-16-85-39-56-71-118-95-187-18-53-18-53 6-53 19 0 25 8 36 50 7 28 16 50 20 50s15 20 26 45c10 25 21 45 26 45 4 0 7 7 7 15s5 15 10 15c6 0 10 9 10 20s7 20 15 20c10 0 15 11 15 35 0 19-4 35-10 35-5 0-10 7-10 15 0 10-11 15-35 15-19 0-35-4-35-10m2245-212c-50-53-50-53 3-3 28 27 52 51 52 52 0 8-9-1-55-49"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#999",
        style: {
            transform: "none"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M766 3321c-37-41-48-272-21-439 69-426 448-742 891-742 94 0 94 0 94 35 0 24-7 41-22 53-59 48-98 85-98 95 0 6 7 1 16-11 8-12 21-22 27-22 7 0 18-9 25-20s16-20 22-20c5 0 21-11 36-25s33-25 40-25c8 0 14-4 14-9 0-16 295-191 322-191 4 0 8 7 8 15 0 20 7 19 86-13 156-64 224-77 409-77 169 1 171 1 275 37 105 36 105 36 2 37-106 1-130 14-45 24 27 3 116 29 198 59 150 53 150 53 188 108 63 92 125 229 152 339 14 57 24 111 22 120-4 13-5 13-6-2 0-10-6-15-12-12-5 4-33-4-62-18s-88-40-132-57-98-40-120-50-107-46-190-80c-177-74-179-75-320-138-60-28-131-57-156-65-44-15-115-47-243-109-32-15-65-28-73-28-9 0-13-6-10-14 4-10 1-13-8-9-8 3-12 10-8 16q4.5 9-6 3c-24-15-271 147-450 297-45 37-83 67-86 67-6 0 4-54 16-97 15-49 65-111 115-142 44-29 44-29 15-33-84-12-337 41-327 69 3 7 2 13-3 13-4 0-28 28-52 62-39 56-183 235-199 248-3 3-32 37-65 75-189 226-223 259-226 218-1-10-7 11-15 47-17 82-17 263 0 358 7 39 9 72 6 72-4 0-14-8-24-19"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M345 2328c14-105 47-234 85-333 41-104 122-245 160-280 21-19 21-19 18 20-2 33-7 41-25 43-18 3-23 10-23 33 0 19-5 29-15 29-8 0-15 9-15 20 0 24-41 110-52 110-4 0-8 11-8 25s-4 25-10 25c-5 0-10 7-10 15s-12 54-26 102c-14 49-30 123-37 166-9 65-14 77-30 77-17 0-18-5-12-52m1735-481c0-18-9-67-20-108s-20-86-20-101c0-28 0-28 75-28 68 0 75 2 75 20s-7 20-60 20c-58 0-60 1-50 20 12 22 40 158 40 191 0 12-7 19-20 19-16 0-20-7-20-33M670 1635c7-8 45-36 84-62 39-25 74-49 78-52 4-4-23-5-61-3-61 4-70 2-74-14-4-17-5-17-6-1-1 11-9 17-26 17-30 0-29-3 25-73 19-26 39-47 44-47 4 0 6 18 4 40-4 40-4 40 69 40s73 0 73 35c0 24-5 35-15 35-8 0-15 5-15 10 0 6-11 10-25 10-16 0-25 6-25 15 0 8-7 15-15 15s-15 5-15 10c0 6-9 10-20 10s-20 7-20 15c0 11-11 15-36 15-31 0-35-2-24-15m1570-2c0-18 9-21 69-27 73-6 257-61 279-83 7-7 27-13 43-13 19 0 29-5 29-15 0-8 7-15 15-15s15-4 15-10c0-5 9-10 20-10s20-6 20-14-9-18-20-21-20-11-20-16-11-9-25-9c-16 0-25-6-25-15s-9-15-24-15c-35 0-56-10-56-26 0-8-10-14-25-14s-25-6-25-14c0-9-12-16-27-18-24-3-29-8-31-37-4-35-4-35 30-9 54 41 153 95 233 129 41 17 77 34 80 39 11 17-77 85-170 131-107 52-210 83-318 94-62 7-67 6-67-12M762 1348c41-60 124-136 203-187 43-28 83-51 90-51s18-7 25-15c9-11 7-21-13-47-62-81-146-265-132-288 3-6 12-10 20-10 15 0 55 109 55 152 0 21 5 28 20 28 13 0 22 9 26 25 3 14 10 25 15 25s9 7 9 15 5 15 10 15c6 0 10 9 10 20s6 20 14 20c17 0 26 22 26 61 0 24-4 29-25 29-25 0-98 30-103 43-2 4-10 7-18 7s-14 5-14 10c0 6-6 10-14 10s-16 7-20 15c-3 8-15 15-26 15s-20 6-20 13c0 19-63 77-83 77-11 0-17 8-17 25 0 21-5 25-31 25-30 0-30 0-7-32m1336-125c-16-2-28-9-28-14s-11-9-25-9-25-4-25-10c0-5-7-10-15-10s-15-4-15-10c0-5-6-10-13-10-14 0-57-44-57-59 0-5-5-11-12-13-6-2-13-31-16-66-4-62-4-62 42-62 33 0 46 4 46 14 0 8 7 16 15 20 8 3 15 12 15 21 0 8 9 15 20 15s20 4 20 9 11 12 25 15c18 5 25 13 25 31 0 14-4 25-9 25-19 0-128-81-141-105-21-39-35-6-16 38 30 74 144 147 227 147 60 0 68-12 24-33-43-20-45-37-5-37 53 0 80 19 80 57 0 30-3 33-30 33-16 0-30 5-30 10 0 10-48 11-102 3m282-14c0-6-7-17-15-25-8-9-15-26-15-39s-3-25-8-27c-11-5-52-140-52-172 0-55 25-19 61 86 19 59 47 125 62 147 27 41 27 41-3 41-16 0-30-5-30-11m-140-333c0-8-5-16-11-18s-9-19-7-38c3-35 3-35 36 9 39 53 40 61 7 61-15 0-25-6-25-14m-120-126c0-5-7-10-15-10s-15-9-15-20c0-15-7-20-27-20-14 0-59-12-99-27-61-23-74-32-74-50 0-23 0-23 73 3 76 28 195 93 217 118 11 14 8 16-24 16-20 0-36-4-36-10m-778-166c-25-17-30-44-8-44 8 0 16-7 20-15 3-8 11-15 18-15s25-7 41-14c15-8 27-11 27-7 0 5 26 12 58 15 31 3 92 12 135 18 77 12 77 12 77 45s0 33-173 33c-140 0-177-3-195-16m465-11c-4-3-7-17-7-30 0-17-6-23-21-23-12 0-23-8-26-20-3-11-9-20-14-20s-9-13-9-30c0-16 4-30 8-30 5 0 31 28 58 62 83 106 79 98 46 98-16 0-32-3-35-7"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#CCC",
        d: "M767 3320c-14-16-30-30-34-30-18 0-70-67-86-110-36-100-47-174-47-330 0-234 42-399 154-604 101-186 288-396 442-498 108-72 267-145 379-175 88-23 120-26 265-27 133 0 171 3 195 16 46 24 150 48 211 48 40 0 54 4 54 14 0 22-51 29-147 21-82-7-86-7-79 11 24 61 38 144 43 255 6 126 6 126-83 173-118 63-236 142-357 240-153 124-147 120-147 104 0-70 65-175 135-218 19-12 35-26 35-31 0-14-119-11-208 6-366 70-658 366-717 727-23 142-16 332 16 407 15 35 5 36-24 1m-417-689c-16-31-12-51 10-51 16 0 20 7 20 35 0 39-14 46-30 16m-10-228c0-51 29-208 55-296 30-103 79-217 94-217 20 0 11 52-24 139-42 105-73 231-82 329-5 61-9 72-24 72-14 0-19-7-19-27m150-529c0-14 62-112 94-149 35-40 35-40 36-2 0 30-3 37-20 37-15 0-20 7-20 25 0 16-6 25-15 25-8 0-15 9-15 19 0 35-12 51-36 51-13 0-24-3-24-6m166-225c10-12 59-48 108-80 73-48 85-59 63-59-15 0-27-4-27-9 0-12 26-21 61-21 26 0 29 3 29 34 0 35-13 46-51 46-10 0-19 7-19 15s-7 15-15 15-15 5-15 10c0 6-7 10-15 10s-15 5-15 10c0 6-8 10-19 10-10 0-21 9-24 20-4 16-14 20-43 20-37 0-37 0-18-21m1664-27c0-20 38-32 103-32 15 0 27-4 27-10 0-5 14-10 30-10 17 0 30-4 30-10 0-5 11-10 25-10s25-4 25-10c0-5 14-10 30-10 19 0 30-5 30-14 0-16 21-26 56-26 17 0 24-6 24-20 0-15 7-20 26-20 23 0 24-2 10-15-8-8-20-15-27-15-8 0-33-7-56-16-29-12-43-23-43-35 0-15-8-19-35-19-24 0-35-5-35-15 0-9-9-15-25-15-20 0-25-5-25-25 0-14 2-25 5-25s40 20 83 44c42 25 107 57 145 72 37 15 67 33 67 40 0 22-81 83-164 123s-188 74-263 86c-38 6-43 5-43-13M650 1510c0-5 12-24 28-42 15-18 44-58 65-89s47-65 57-74c20-18 20-17 20 19 0 29-4 39-20 43-11 3-20 14-20 24 0 11-4 19-9 19s-12 11-15 25c-5 18-13 25-31 25-14 0-25 5-25 10 0 6 14 10 30 10 36 0 41 25 8 34-35 9-88 7-88-4m210-265c0-9 125-97 172-121 29-14 54-21 65-17 17 7 17 6 1-17-96-136-156-262-165-345-2-22-6-101-9-176-5-137-5-137 93-118 100 18 230 55 248 69 6 5 28 11 50 15s46 12 53 18c7 5 22 11 35 12 12 1 28 3 35 4 23 2 12 27-20 46-22 13-58 20-113 23-70 4-90 1-145-21-35-15-65-25-67-23-5 5 90 142 152 221 41 52 55 78 55 102 0 31-2 33-36 33-42 0-68 12-111 53-32 30-43 57-23 57 6 0 10 15 10 34 0 29-4 36-31 45-18 6-43 11-55 11-15 0-24 6-24 15 0 8-7 15-15 15s-15 5-15 10c0 6-7 10-15 10s-15 5-15 10c0 6-9 10-20 10s-20 7-20 15c0 10-11 15-35 15-19 0-35-2-35-5m1213-26c-18-5-33-14-33-19 0-6-9-10-20-10s-20-4-20-10c0-5-7-10-15-10q-15 0-15-30c0-27-3-30-30-30-23 0-30-4-30-20 0-11-4-20-10-20-5 0-10-16-10-35s5-35 10-35c6 0 10-11 10-25 0-22 4-25 35-25s36 3 42 30c4 21 11 30 25 30 10 0 21 7 24 15 4 8 12 15 20 15s14 7 14 15 9 15 20 15c24 0 110 41 110 52 0 4 11 8 25 8 23 0 25 4 25 44 0 37-4 45-22 50-33 8-118 6-155-5m136-34c20-6 8-15-80-58-69-34-120-67-151-98-50-50-64-49-53 3 13 58 114 138 200 159 30 7 41 6 84-6m161-5q0-30-15-30c-15 0-15-10-15-30 0-16-4-30-8-30s-21-40-37-90c-17-49-33-90-37-90-5 0-8-7-8-15s-4-15-10-15c-5 0-10-7-10-15s-4-15-10-15c-5 0-10-16-10-36 0-23 4-33 11-28 30 18 92 137 124 238 20 61 47 128 61 149 24 37 24 37-6 37-27 0-30-3-30-30m-240-420c0-5-7-10-15-10s-15-4-15-8-16-14-35-21-35-17-35-22-9-9-20-9-20-4-20-10c0-5-9-10-20-10s-43-9-72-20c-54-21-190-40-285-40-39 0-53-4-53-14 0-8-6-17-12-19-7-3 21-6 62-7 75-2 75-2 5-15-38-7-100-16-137-20-38-4-68-11-68-16s11-26 24-47c13-20 27-50 30-67 28-156 22-148 86-114 32 17 86 53 119 80 34 27 65 49 70 49 4 0 20 17 34 38 14 20 47 62 75 92 42 48 62 60 134 88 80 30 198 97 212 121 5 7-5 11-28 11-20 0-36-4-36-10",
        style: {
            transform: "none"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M683 3248c-106-109-293-406-293-464 0-10-6-36-14-59-32-91-39-154-33-280 11-213 53-377 144-562 73-149 164-245 317-337 60-36 60-36-48-36-109 0-109 0-82-33 14-17 41-54 59-82 82-123 257-268 340-282 20-3 37-8 37-12 0-3-10-19-23-35-23-29-23-29 17-73 49-54 68-65 124-73 42-5 42-5-13-75-109-137-218-315-203-331 4-3 53 16 110 42 91 43 111 49 168 49 48 0 74-5 95-19 26-17 41-18 169-12 229 11 309 22 403 57 223 82 308 167 382 383 22 63 45 126 52 138 36 71 192 182 332 238 31 12 60 27 63 32 20 32-197 157-336 193-101 26-263 31-346 10-38-9-82-24-99-33-23-12-60-16-165-15-167 1-284 28-439 103-141 69-230 129-335 230-210 201-364 469-417 725-24 113-25 312-4 405 17 73 60 194 81 228 23 35 2 26-43-20m1539-2066c5-5-24-25-78-51-101-48-180-103-189-131-8-24-23-26-31-5-22 55 67 152 175 192 38 14 107 11 123-5",
        style: {
            transform: "none"
        }
    }));

const Emacs = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 256,
        height: 256,
        fill: "url(#prefix__a)",
        rx: 60
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M86.53 227.747s11.67.822 26.684-.496c6.08-.533 29.165-2.791 46.424-6.561 0 0 21.043-4.484 32.301-8.616 11.779-4.322 18.189-7.991 21.074-13.19-.126-1.065.888-4.842-4.544-7.111-13.888-5.801-29.994-4.752-61.866-5.425-35.343-1.209-47.101-7.1-53.364-11.845-6.006-4.813-2.986-18.13 22.748-29.86 12.963-6.247 63.78-17.774 63.78-17.774-17.114-8.424-49.027-23.233-55.587-26.431-5.753-2.804-14.96-7.028-16.956-12.137-2.263-4.905 5.344-9.13 9.593-10.34 13.684-3.931 33.003-6.374 50.585-6.648 8.838-.138 10.272-.704 10.272-.704 12.195-2.015 20.222-10.323 16.878-23.48-3.003-13.431-18.839-21.323-33.888-18.59-14.171 2.572-48.328 12.452-48.328 12.452 42.22-.364 49.287.338 52.443 4.732 1.864 2.595-.847 6.153-12.107 7.985-12.259 1.993-37.741 4.394-37.741 4.394-24.445 1.446-41.665 1.543-46.83 12.431-3.373 7.114 3.599 13.403 6.654 17.34 12.914 14.301 31.567 22.014 43.573 27.694 4.518 2.137 17.773 6.173 17.773 6.173-38.951-2.134-67.05 9.777-83.531 23.49-18.642 17.171-10.396 37.637 27.796 50.239 22.558 7.443 33.745 10.944 67.393 7.927 19.819-1.064 22.943-.431 23.141 1.188.278 2.28-22.014 7.944-28.099 9.692-15.483 4.447-56.068 13.427-56.271 13.471",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 0,
        x2: 256,
        y1: 0,
        y2: 256,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#8381C5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.615,
        stopColor: "#7E55B3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#A52ECB"
    })))));

const Ember = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 512 213",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M511.7 146.4c-1.2-12.2-10-17.6-18.4-17.6a22 22 0 0 0-8 1.5l-1.6.7-1.4 1c-2 1.5-5.4 3.5-8.4 4.6a43 43 0 0 1 .3-8.3v-.5c2.3-21.4-2.2-34-13.3-37.1-1.9-.5-3.8-.8-5.7-.8-6.8 0-12.8 3.3-16.7 6-3.2-4-8.7-6.4-15.5-6.4-10.2 0-18.3 4.8-21.3 12.4l-1.2 3.5A31.2 31.2 0 0 0 371 87a47.5 47.5 0 0 0-25 7.2l-.6.4a74.8 74.8 0 0 0-23.7 27.3 43 43 0 0 0-19.4-25l-.2-.2-.9-.4c10.5-18.7 19.9-43.4 14.3-67-6-25-20.7-28.8-29-28.8-3.4 0-7 .7-10.5 2h-.5a51.2 51.2 0 0 0-23.9 17.6 156.5 156.5 0 0 0-22.8 66.3l-1.4 12.9a23.2 23.2 0 0 0-18.6-9.3c-8.6 0-15.6 5.3-19.4 8.8v-.1a18 18 0 0 0-14.2-8h-1.4c-9.2 0-16.5 4-21.9 8.7-3.4-6-9.7-9.7-17-9.7h-3c-10.2 0-18.2 4.9-21.5 12.9l-.8 2.4a38 38 0 0 0-31.9-14.6h-1.3c-8.5.1-29.8 3.7-42.9 33-2 4.6-3.6 9.2-4.7 13.7a17.8 17.8 0 0 0-22 5.9c-2 3-8.4 13.4-5.2 23.7 1.7 5.5 5.7 9.7 11.3 11.8 4.8 2 11 3.9 15.7 5.2 2.9 6.5 8 14 17.1 21a39.4 39.4 0 0 0 24.4 7.3c16.3 0 32.1-7 33.8-7.8l.6-.3.2-.2c3 3.3 7.2 5.6 12.4 6.6 1.6.3 3.6.6 6 .6 8.8 0 15-4.5 20.6-13a26.5 26.5 0 0 0 23.1 11.4h.1c.6 0 1.1.4 1.7.4 5.3 0 12-1.9 17.4-10.7 4.6 8.2 13 13 23 13 8.8 0 16.5-3.7 17.9-4.4l.3-.2c3-1.5 5.4-3 7.4-4a62 62 0 0 0 35.2 7h1.1c26-5.2 43-11.4 53-16.2a50.1 50.1 0 0 0 39.9 17c13.2 0 23.8-3.8 31.5-7.9a27 27 0 0 0 9.7 6.7 19 19 0 0 0 7.4 1.5c16.2 0 23.7-19.3 25.8-25.8l4-10.4c3.3 3.6 7.7 6.6 13.2 8.1 3 .9 6.3 1.4 9.6 1.4 17.8 0 35-12.6 37.6-14.7 5-4 10.3-12.4 9.1-23.8"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E24B31",
        d: "M348.7 151.7s-2.2-8 6.2-23.3c8.3-15.2 14.8-6.9 14.8-6.9s7.2 7.8-1 19.4-20 10.8-20 10.8m-64 11c-9.6 25-32.9 14.8-32.9 14.8s-2.6-8.9 5-34c7.5-25 25.2-15.2 25.2-15.2s12.2 9.4 2.6 34.4M267.3 57.9s14.5-37.7 18-19.4c3.4 18.4-30.3 73-30.3 73 .3-12.4 12.3-53.6 12.3-53.6M60.6 151.7c.7-24.3 16.5-34.8 22-29.6 5.5 5.3 3.5 16.7-6.9 23.9-10.3 7.1-15 5.7-15 5.7m437.8-4c-.8-8.2-8.1-5.1-8.1-5.1s-11.8 9.1-22.3 8.1c-10.3-1-7-24.2-7-24.2s2.2-21.3-4-23c-6-1.9-13.6 5.4-13.6 5.4s-9.4 10.4-13.8 23.7l-1.3.3s1.4-23.2-.2-28.5c-1.2-2.6-12.4-2.4-14.2 2.3a281 281 0 0 0-11.4 50.9s-17.5 14.8-32.8 17.3c-15.3 2.4-19-7.2-19-7.2s41.6-11.5 40.1-44.7c-1.4-33.2-33.5-20.9-37.1-18.2-3.5 2.7-22.2 14-27.8 45.2l-.5 5.8s-16 10.8-25 13.7c0 0 25-42.2-5.5-61.3-13.9-8.4-24.9 9.1-24.9 9.1s41.3-46 32.2-84.9C297.9 14 288.7 12 280 15a39 39 0 0 0-17.8 12.6s-16.7 24.3-20.6 60.3c-3.8 36-9.5 79.6-9.5 79.6s-8 7.7-15.2 8.1c-7.3.4-4-21.7-4-21.7s5.6-33.8 5.2-39.5-.8-8.8-7.5-10.8-14.1 6.5-14.1 6.5-19.3 29.3-21 33.8l-1 1.9-1-1.3s13.7-39.9.6-40.4c-13-.7-21.6 14.2-21.6 14.2s-14.8 24.8-15.4 27.6l-1-1.2s6.1-28.9 4.9-36c-1.3-7.2-8-5.7-8-5.7s-8.5-1-10.8 4.5c-2.2 5.5-10.4 42-11.4 53.5 0 0-21.4 15.3-35.4 15.5s-12.6-9-12.6-9 51.5-17.6 37.4-52.4c-6.3-9-13.6-11.7-24-11.6-10.4.3-22.6 6.5-31 25.3-4 8.9-5.6 17.4-5.6 23.8 0 0-9.6 1.9-14.5-2.2-4.9-4-7.7 0-7.7 0s-8.5 12.2-.2 15.4c8.3 3.3 21.2 6.3 21.2 6.3 1.2 5.3 4.7 14 14.8 21.6 15.3 11.6 44.6-1.8 44.6-1.8l12-7.1s.5 10.8 9.2 12.4c8.8 1.6 12.5-.1 27.7-37.1 9-19 9.6-18 9.6-18l1-.2s-7 36.2-4.3 46c2.6 9.8 14.2 8.8 14.2 8.8s6.3 2.2 11.4-15.7c5.2-18 14.9-36.7 14.9-36.7h1.2s-4.3 36 2.3 47.9c6.5 11.8 23.4 3.5 23.4 3.5s11.8-6.3 13.6-8.1c0 0 14 11.8 33.8 9.6 44.2-8.7 60-20.5 60-20.5s7.5 19.2 31 21c26.9 2 41.6-15 41.6-15s-.3 11 9.1 15c9.4 3.8 15.7-16.7 15.7-16.7l15.7-42h1.4s.8 26.8 16.3 31.3c15.7 4.5 35.8-11 35.8-11s4.9-3.3 4-11.5"
    }));

const Esbuild = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 128,
        cy: 128,
        r: 128,
        fill: "#FFCF00"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#191919",
        d: "M69.285 58.715 138.571 128l-69.286 69.285-16.97-16.97L104.629 128 52.315 75.685zm76.8 0L215.371 128l-69.286 69.285-16.97-16.97L181.429 128l-52.314-52.315z"
    }));

const Ethereum = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__a",
        width: "111.7%",
        height: "111.7%",
        x: "-5.8%",
        y: "-4.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in: "shadowBlurOuter1",
        in2: "SourceAlpha",
        operator: "out",
        result: "shadowBlurOuter1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__d",
        width: "123.3%",
        height: "114.6%",
        x: "-11.7%",
        y: "-5.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in: "shadowBlurOuter1",
        in2: "SourceAlpha",
        operator: "out",
        result: "shadowBlurOuter1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.204257246 0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0.5
    })), /*#__PURE__*/ React.createElement("circle", {
        id: "prefix__b",
        cx: 16,
        cy: 15,
        r: 15
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__e",
        d: "M16.498 20.968 24 16.616l-7.502 10.379L9 16.615zm0-17.968 7.497 12.22-7.497 4.353L9 15.22z"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#000",
        filter: "url(#prefix__a)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#627EEA"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "url(#prefix__c)",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 16,
        cy: 15,
        r: 14.5,
        stroke: "#000",
        strokeOpacity: 0.097
    }), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#000",
        filter: "url(#prefix__d)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#FFF",
        fillOpacity: 0,
        fillRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#FFF",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        fillOpacity: 0.602,
        d: "M16.498 3v8.87l7.497 3.35z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16.498 3 9 15.22l7.498-3.35z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillOpacity: 0.602,
        d: "M16.498 20.968v6.027L24 16.616z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16.498 26.995v-6.028L9 16.616z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillOpacity: 0.2,
        d: "m16.498 19.573 7.497-4.353-7.497-3.348z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillOpacity: 0.602,
        d: "m9 15.22 7.498 4.353v-7.701z"
    }))));

const Exome = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 184 184",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#F5841B",
        fillRule: "evenodd",
        clipPath: "url(#prefix__a)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m23 173.5.1-.7v.7Zm37.7-42.6a278 278 0 0 1-27 19.3 379.5 379.5 0 0 1 52.7-64 378.5 378.5 0 0 1 64-52.6 272 272 0 0 1-19.5 27.1 50 50 0 0 1 10 22.4c31.8-37.5 48.9-70.3 39.6-79.6-11.8-11.7-60.8 18.4-109.6 67.2-48.9 48.8-79 97.9-67.2 109.6 9.3 9.3 42-7.7 79.4-39.3a50 50 0 0 1-22.4-10Zm113-108h-.7.6ZM161 10.3l-.1.7v-.7ZM11 160.8h-.6.7Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11 23.1h.6a2 2 0 0 1-.7 0Zm75.8 74.7a378.6 378.6 0 0 1-52.6-64 274 274 0 0 1 26.2 18.8 50 50 0 0 1 22.2-10.4C45.6 11.1 13.3-5.5 4 3.7-7.6 15.4 22.5 64.5 71.3 113.3s97.9 79 109.6 67.2c9.3-9.3-7.8-42.3-39.8-80a50 50 0 0 1-10.2 22.2 304 304 0 0 1 20 27.7 378.6 378.6 0 0 1-64-52.6Zm74.7 75.9v-.7zM174 161h-.7zM23.6 11.2v-.7z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h184v184H0z"
    }))));

const Expo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 231",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000020",
        d: "M121 85c2-3 5-4 7-4 1 0 5 1 7 4 16 22 43 67 63 101l26 40c7 8 18 3 24-6s8-15 8-22c0-4-88-168-97-182-9-13-11-16-26-16h-11c-14 0-16 3-25 16C88 30 0 194 0 198c0 7 2 13 8 22s17 14 24 6l26-40c20-34 47-79 63-101"
    }));

const ExpressjsDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M32 24.795c-1.164.296-1.884.013-2.53-.957l-4.594-6.356-.664-.88-5.365 7.257c-.613.873-1.256 1.253-2.4.944l6.87-9.222-6.396-8.33c1.1-.214 1.86-.105 2.535.88l4.765 6.435 4.8-6.4c.615-.873 1.276-1.205 2.38-.883l-2.48 3.288-3.36 4.375c-.4.5-.345.842.023 1.325zM.008 15.427l.562-2.764C2.1 7.193 8.37 4.92 12.694 8.3c2.527 1.988 3.155 4.8 3.03 7.95H1.48c-.214 5.67 3.867 9.092 9.07 7.346 1.825-.613 2.9-2.042 3.438-3.83.273-.896.725-1.036 1.567-.78-.43 2.236-1.4 4.104-3.45 5.273-3.063 1.75-7.435 1.184-9.735-1.248C1 21.6.434 19.812.18 17.9c-.04-.316-.12-.617-.18-.92q.008-.776.008-1.552zm1.498-.38h12.872c-.084-4.1-2.637-7.012-6.126-7.037-3.83-.03-6.58 2.813-6.746 7.037"
    }));

const ExpressjsLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M32 24.795c-1.164.296-1.884.013-2.53-.957l-4.594-6.356-.664-.88-5.365 7.257c-.613.873-1.256 1.253-2.4.944l6.87-9.222-6.396-8.33c1.1-.214 1.86-.105 2.535.88l4.765 6.435 4.8-6.4c.615-.873 1.276-1.205 2.38-.883l-2.48 3.288-3.36 4.375c-.4.5-.345.842.023 1.325zM.008 15.427l.562-2.764C2.1 7.193 8.37 4.92 12.694 8.3c2.527 1.988 3.155 4.8 3.03 7.95H1.48c-.214 5.67 3.867 9.092 9.07 7.346 1.825-.613 2.9-2.042 3.438-3.83.273-.896.725-1.036 1.567-.78-.43 2.236-1.4 4.104-3.45 5.273-3.063 1.75-7.435 1.184-9.735-1.248C1 21.6.434 19.812.18 17.9c-.04-.316-.12-.617-.18-.92q.008-.776.008-1.552zm1.498-.38h12.872c-.084-4.1-2.637-7.012-6.126-7.037-3.83-.03-6.58 2.813-6.746 7.037"
    }));

const Facebook = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "url(#prefix__a)",
        viewBox: "0 0 36 36",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "50%",
        y1: "97.078%",
        y2: "0%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0062E0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#19AFFF"
    }))), /*#__PURE__*/ React.createElement("path", {
        d: "M15 35.8C6.5 34.3 0 26.9 0 18 0 8.1 8.1 0 18 0s18 8.1 18 18c0 8.9-6.5 16.3-15 17.8l-1-.8h-4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m25 23 .8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7q1.5.3 3 .3c1.5 0 2-.1 3-.3V23z"
    }));

const FastAPI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#009688",
        d: "M128 0C57.33 0 0 57.33 0 128s57.33 128 128 128 128-57.33 128-128S198.67 0 128 0m-6.67 230.605v-80.288H76.699l64.128-124.922v80.288h42.966z"
    }));

const FastifyDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 167.509",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M247.942 23.314 256 2.444l-.35-1.293-79.717 21.003C184.433 9.86 181.513 0 181.513 0s-25.457 16.257-44.709 15.832c-19.251-.426-25.457-5.564-54.977 3.853-29.52 9.41-37.86 38.295-46.419 44.5S0 90.603 0 90.603l.058.359 24.207-7.707S17.625 89.51 3.52 108.52l-.659-.609.025.134s11.336 17.324 22.463 14.121c1.118-.325 2.377-.859 3.753-1.56 4.48 2.495 10.327 4.947 16.783 5.622 0 0-4.37-5.08-8.016-10.86.984-.634 1.994-1.293 3.02-1.96l-.476.334 9.217 3.386-1.017-8.666c.033-.017.058-.042.091-.059l9.059 3.328-1.126-7.882a77 77 0 0 1 3.436-1.693l9.443-35.717 39.045-26.634-3.103 7.808c-7.916 19.468-22.78 24.064-22.78 24.064l-6.206 2.352c-4.612 5.455-6.556 6.798-8.14 25.107 3.72-.934 7.273-1.16 10.492-.292 16.683 4.496 22.463 24.599 17.967 30.162-1.126 1.393-3.803 3.77-7.181 6.565h-6.773l-.092 5.488c-.234.184-.467.359-.693.542h-6.89l-.083 5.355c-.609.468-1.218.918-1.801 1.36-6.473.133-14.673-5.514-14.673-5.514 0 5.139 4.28 13.046 4.28 13.046s.283-.133.758-.367c-.417.309-.65.476-.65.476s17.324 11.552 28.235 7.273c9.7-3.804 34.816-23.606 56.495-32.981l65.603-17.283 8.65-22.413-49.997 13.17V83.597l58.664-15.457 8.65-22.413-67.297 17.734V43.324z"
    }));

const FastifyLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 167.509",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M247.942 23.314 256 2.444l-.35-1.293-79.717 21.003C184.433 9.86 181.513 0 181.513 0s-25.457 16.257-44.709 15.832c-19.251-.426-25.457-5.564-54.977 3.853-29.52 9.41-37.86 38.295-46.419 44.5S0 90.603 0 90.603l.058.359 24.207-7.707S17.625 89.51 3.52 108.52l-.659-.609.025.134s11.336 17.324 22.463 14.121c1.118-.325 2.377-.859 3.753-1.56 4.48 2.495 10.327 4.947 16.783 5.622 0 0-4.37-5.08-8.016-10.86.984-.634 1.994-1.293 3.02-1.96l-.476.334 9.217 3.386-1.017-8.666c.033-.017.058-.042.091-.059l9.059 3.328-1.126-7.882a77 77 0 0 1 3.436-1.693l9.443-35.717 39.045-26.634-3.103 7.808c-7.916 19.468-22.78 24.064-22.78 24.064l-6.206 2.352c-4.612 5.455-6.556 6.798-8.14 25.107 3.72-.934 7.273-1.16 10.492-.292 16.683 4.496 22.463 24.599 17.967 30.162-1.126 1.393-3.803 3.77-7.181 6.565h-6.773l-.092 5.488c-.234.184-.467.359-.693.542h-6.89l-.083 5.355c-.609.468-1.218.918-1.801 1.36-6.473.133-14.673-5.514-14.673-5.514 0 5.139 4.28 13.046 4.28 13.046s.283-.133.758-.367c-.417.309-.65.476-.65.476s17.324 11.552 28.235 7.273c9.7-3.804 34.816-23.606 56.495-32.981l65.603-17.283 8.65-22.413-49.997 13.17V83.597l58.664-15.457 8.65-22.413-67.297 17.734V43.324z"
    }));

const Figma = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 54 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0ACF83",
        d: "M13.333 80c7.36 0 13.334-5.973 13.334-13.333V53.334H13.333C5.973 53.334 0 59.307 0 66.667S5.973 80 13.333 80"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A259FF",
        d: "M0 40c0-7.36 5.973-13.333 13.333-13.333h13.334v26.666H13.333C5.973 53.333 0 47.36 0 40"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F24E1E",
        d: "M0 13.333C0 5.973 5.973 0 13.333 0h13.334v26.667H13.333C5.973 26.667 0 20.693 0 13.333"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF7262",
        d: "M26.667 0H40c7.36 0 13.333 5.973 13.333 13.333S47.36 26.667 40 26.667H26.667z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1ABCFE",
        d: "M53.333 40c0 7.36-5.973 13.333-13.333 13.333S26.667 47.36 26.667 40 32.64 26.667 40 26.667 53.333 32.64 53.333 40"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h53.333v80H0z"
    }))));

const Firebase = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 600 600",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9100",
        d: "M213.918 560.499c23.248 9.357 48.469 14.909 74.952 15.834 35.84 1.252 69.922-6.158 100.391-20.234-36.537-14.355-69.627-35.348-97.869-61.448-18.306 29.31-45.382 52.462-77.474 65.848"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFC400",
        d: "M291.389 494.66c-64.466-59.622-103.574-145.917-100.269-240.568.108-3.073.27-6.145.46-9.216a167 167 0 0 0-36.004-5.241 167 167 0 0 0-51.183 6.153c-17.21 30.145-27.594 64.733-28.888 101.781-3.339 95.611 54.522 179.154 138.409 212.939 32.093-13.387 59.168-36.51 77.475-65.848"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9100",
        d: "M291.39 494.657c14.988-23.986 24.075-52.106 25.133-82.403 2.783-79.695-50.792-148.251-124.942-167.381-.19 3.071-.352 6.143-.46 9.216-3.305 94.651 35.803 180.946 100.269 240.568"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#DD2C00",
        d: "M308.231 20.858C266 54.691 232.652 99.302 212.475 150.693c-11.551 29.436-18.81 61.055-20.929 94.2 74.15 19.13 127.726 87.686 124.943 167.38-1.058 30.297-10.172 58.39-25.134 82.404 28.24 26.127 61.331 47.093 97.868 61.447 73.337-33.9 125.37-106.846 128.383-193.127 1.952-55.901-19.526-105.724-49.875-147.778-32.051-44.477-159.5-194.36-159.5-194.36Z"
    }));

const FirebaseStudio = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43.5 65",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 5.9,
        x2: 27.6,
        y1: 28,
        y2: 64.5,
        "data-name": "Degradado sin nombre",
        gradientTransform: "matrix(1 0 0 -1 0 66)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#f8682f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#dd2c00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 29,
        x2: 26.5,
        y1: 38.5,
        y2: -5,
        "data-name": "Degradado sin nombre 2",
        gradientTransform: "matrix(1 0 0 -1 0 66)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#f8682f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#e92a4e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#c447ff"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 .1h44.8v64H0z",
        style: {
            fill: "none"
        }
    }))), /*#__PURE__*/ React.createElement("g", {
        style: {
            clipPath: "url(#prefix__a)"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M31.4 24.3c.4 0 .9.2 1.6.3l6.6 4.3-21.5 12.8c-.3.1-.7.2-1.1.4-.5.1-1.1.2-1.5.3h-1.4l-8.3-9.9 17.3-6.7c1.8-.7 3.3-1 4.5-1.2 1.3-.2 2.5-.4 3.9-.3Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M31 7.9c-.1-.6-.3-1.2-.5-1.7-.3-1-1.1-3-3-4.9-.3-.3-.8-.8-1.4-1.2-2.3 2.8-4.4 4.8-5.8 6-3.6 3.3-9.5 7.8-13.3 11.3-.7.6-2 1.9-3.2 4-.2.4-.5.9-.8 1.4 0 0 0 .2-.1.3-.1.3-.2.5-.4.8-.5 1.1-1.1 2.6-1.2 4.5-.2 1.7 0 3 .1 3.6 0 .2 0 .4.1.6.2.7.4 1.4.7 2 1.3 3 3.4 4.7 3.8 5 2.3 1.8 4.6 2.3 5.3 2.5 1 .2 1.9.2 2.6.2-.1-.5-.3-1.2-.4-2-.3-2.9.7-5.1 1.1-6.3.4-.8 1.2-2.8 3.1-4.6q1.35-1.2 2.7-2.1c1-.7 1.9-1.2 2.4-1.5 1.8-1.3 5.3-4.3 7.1-9 .2-.6.4-1.1.4-1.1.6-1.8 1.1-4.5.4-7.7Z",
        style: {
            fill: "url(#prefix__b)"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M14 42.3c-.6 0-1.5 0-2.6-.2-.7-.1-3-.7-5.3-2.5-.5-.4-3.7-3-4.6-7.7-.1-.6-.3-1.9-.1-3.6.2-1.9.8-3.3 1.2-4.5.4-1.1.9-1.9 1.2-2.5.1.4.4 1 .8 1.6.9 1.4 2 2.1 2.8 2.7.4.2 2.1 1.3 4.7 1.9 1.8.4 3.2.4 3.6.4 1.1 0 2.7-.2 4.7-.9 1.1-.4 2-1 2.6-1.3-.5.4-1.4.9-2.5 1.6-.9.6-1.9 1.3-2.7 2.1-1.9 1.8-2.7 3.8-3.1 4.6-.5 1.1-1.4 3.3-1.1 6.3 0 .9.2 1.6.4 2",
        style: {
            fill: "#ff9100"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M42 41.4c.8-1.6 1.1-3.3 1.1-3.3 0-.4.2-1.1.3-1.8 0-.7 0-1.8-.1-2.7-.5-2.9-2.7-5.2-3-5.5 0 0-1.5-1.5-3.7-2.6-.3-.2-.9-.4-1.7-.7-.8-.2-1.4-.3-2-.4-.7 0-1.2-.1-1.6-.2h.4c.4 0 .6.2.8.3.2 0 .5.2.8.5.1.1.3.2.4.4s.3.4.4.8c.3 1.1-.4 2.1-.6 2.5-1.7 2.6-11.1 8.1-16.6 13.8-1.4 1.5-2.4 2.8-3.2 4.4-1.7 3.8-1.1 7.4-.9 8.2 1 5.3 4.9 8.2 5.8 8.8 2.7-3 5.1-5.3 6.9-7 4.5-4.1 10.3-8.6 10.3-8.6s4.5-3.6 6.2-7.1Z",
        style: {
            fill: "url(#prefix__c)"
        }
    })));

const Firefox = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 265",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: -7907.187,
        cy: -8515.121,
        r: 80.797,
        gradientTransform: "translate(26367.938 28186.305)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.129,
        stopColor: "#ffbd4f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.186,
        stopColor: "#ffac31"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.247,
        stopColor: "#ff9d17"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.283,
        stopColor: "#ff980e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.403,
        stopColor: "#ff563b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.467,
        stopColor: "#ff3750"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.71,
        stopColor: "#f5156c"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.782,
        stopColor: "#eb0878"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.86,
        stopColor: "#e50080"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__c",
        cx: -7936.711,
        cy: -8482.089,
        r: 80.797,
        gradientTransform: "translate(26367.938 28186.305)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#960e18"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.351,
        stopColor: "#b11927",
        stopOpacity: 0.74
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.435,
        stopColor: "#db293d",
        stopOpacity: 0.343
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.497,
        stopColor: "#f5334b",
        stopOpacity: 0.094
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.53,
        stopColor: "#ff3750",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: -7926.97,
        cy: -8533.457,
        r: 58.534,
        gradientTransform: "translate(26367.938 28186.305)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.132,
        stopColor: "#fff44f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.252,
        stopColor: "#ffdc3e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.506,
        stopColor: "#ff9d12"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.526,
        stopColor: "#ff980e"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__e",
        cx: -7945.648,
        cy: -8460.984,
        r: 38.471,
        gradientTransform: "translate(26367.938 28186.305)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.353,
        stopColor: "#3a8ee6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.472,
        stopColor: "#5c79f0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.669,
        stopColor: "#9059ff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#c139e6"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__f",
        cx: -7935.62,
        cy: -8491.546,
        r: 20.397,
        gradientTransform: "matrix(3.21411 -.77707 .90934 3.76302 33365.914 25904.014)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.206,
        stopColor: "#9059ff",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.278,
        stopColor: "#8c4ff3",
        stopOpacity: 0.064
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.747,
        stopColor: "#7716a8",
        stopOpacity: 0.45
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.975,
        stopColor: "#6e008b",
        stopOpacity: 0.6
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__g",
        cx: -7937.731,
        cy: -8518.427,
        r: 27.676,
        gradientTransform: "translate(26367.938 28186.305)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#ffe226"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.121,
        stopColor: "#ffdb27"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.295,
        stopColor: "#ffc82a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.502,
        stopColor: "#ffa930"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.732,
        stopColor: "#ff7e37"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.792,
        stopColor: "#ff7139"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__h",
        cx: -7915.977,
        cy: -8535.981,
        r: 118.081,
        gradientTransform: "translate(26367.938 28186.305)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.113,
        stopColor: "#fff44f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.456,
        stopColor: "#ff980e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.622,
        stopColor: "#ff5634"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.716,
        stopColor: "#ff3647"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.904,
        stopColor: "#e31587"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__i",
        cx: -7927.165,
        cy: -8522.859,
        r: 86.499,
        gradientTransform: "matrix(.3472 3.29017 -2.15928 .22816 -15491.597 28008.376)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#fff44f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.06,
        stopColor: "#ffe847"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.168,
        stopColor: "#ffc830"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.304,
        stopColor: "#ff980e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.356,
        stopColor: "#ff8b16"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.455,
        stopColor: "#ff672a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.57,
        stopColor: "#ff3647"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.737,
        stopColor: "#e31587"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__j",
        cx: -7938.383,
        cy: -8508.176,
        r: 73.72,
        gradientTransform: "translate(26367.938 28186.305)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.137,
        stopColor: "#fff44f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.48,
        stopColor: "#ff980e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.592,
        stopColor: "#ff5634"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.655,
        stopColor: "#ff3647"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.904,
        stopColor: "#e31587"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__k",
        cx: -7918.923,
        cy: -8503.861,
        r: 80.686,
        gradientTransform: "translate(26367.938 28186.305)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.094,
        stopColor: "#fff44f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.231,
        stopColor: "#ffe141"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#ffaf1e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.626,
        stopColor: "#ff980e"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 70.786,
        x2: 6.447,
        y1: 12.393,
        y2: 74.468,
        gradientTransform: "translate(-2.999 -.01)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.048,
        stopColor: "#fff44f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.111,
        stopColor: "#ffe847"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.225,
        stopColor: "#ffc830"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.368,
        stopColor: "#ff980e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.401,
        stopColor: "#ff8b16"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.462,
        stopColor: "#ff672a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.534,
        stopColor: "#ff3647"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.705,
        stopColor: "#e31587"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__l",
        x1: 70.013,
        x2: 15.267,
        y1: 12.061,
        y2: 66.806,
        gradientTransform: "translate(-2.999 -.01)scale(3.3067)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.167,
        stopColor: "#fff44f",
        stopOpacity: 0.8
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.266,
        stopColor: "#fff44f",
        stopOpacity: 0.634
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.489,
        stopColor: "#fff44f",
        stopOpacity: 0.217
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#fff44f",
        stopOpacity: 0
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M248.033 88.713c-5.569-13.399-16.864-27.866-25.71-32.439a133.2 133.2 0 0 1 12.979 38.9l.023.215c-14.49-36.126-39.062-50.692-59.13-82.41a155 155 0 0 1-3.019-4.907 41 41 0 0 1-1.412-2.645 23.3 23.3 0 0 1-1.912-5.076.33.33 0 0 0-.291-.331.47.47 0 0 0-.241 0c-.016 0-.043.03-.063.037s-.063.036-.092.049l.049-.086c-32.19 18.849-43.113 53.741-44.118 71.194a64.1 64.1 0 0 0-35.269 13.593 38 38 0 0 0-3.307-2.506 59.4 59.4 0 0 1-.36-31.324 94.9 94.9 0 0 0-30.848 23.841h-.06c-5.079-6.438-4.722-27.667-4.431-32.102a23 23 0 0 0-4.279 2.272 93.4 93.4 0 0 0-12.526 10.73 112 112 0 0 0-11.98 14.375v.019-.023A108.3 108.3 0 0 0 4.841 108.92l-.171.846a204 204 0 0 0-1.26 8.003c0 .096-.02.185-.03.281a122 122 0 0 0-2.08 17.667v.662c.086 98.661 106.944 160.23 192.344 110.825a128.17 128.17 0 0 0 62.12-89.153c.215-1.653.39-3.29.582-4.96a131.8 131.8 0 0 0-8.313-64.378M100.322 189.031c.599.288 1.161.599 1.776.873l.089.057a69 69 0 0 1-1.865-.93m135.013-93.612v-.123l.023.136z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M248.033 88.713c-5.569-13.399-16.864-27.866-25.71-32.439a133.2 133.2 0 0 1 12.979 38.9v.122l.023.136a116.07 116.07 0 0 1-3.988 86.497c-14.688 31.516-50.242 63.819-105.894 62.248-60.132-1.703-113.089-46.323-122.989-104.766-1.802-9.216 0-13.888.906-21.378a95.4 95.4 0 0 0-2.06 17.684v.662c.086 98.661 106.944 160.23 192.344 110.825a128.17 128.17 0 0 0 62.12-89.153c.215-1.653.39-3.29.582-4.96a131.8 131.8 0 0 0-8.313-64.378"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M248.033 88.713c-5.569-13.399-16.864-27.866-25.71-32.439a133.2 133.2 0 0 1 12.979 38.9v.122l.023.136a116.07 116.07 0 0 1-3.988 86.497c-14.688 31.516-50.242 63.819-105.894 62.248-60.132-1.703-113.089-46.323-122.989-104.766-1.802-9.216 0-13.888.906-21.378a95.4 95.4 0 0 0-2.06 17.684v.662c.086 98.661 106.944 160.23 192.344 110.825a128.17 128.17 0 0 0 62.12-89.153c.215-1.653.39-3.29.582-4.96a131.8 131.8 0 0 0-8.313-64.378"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M185.754 103.778c.278.195.536.39.797.585a69.8 69.8 0 0 0-11.904-15.525C134.815 48.999 164.208 2.457 169.165.093l.049-.073c-32.19 18.849-43.113 53.741-44.118 71.194 1.495-.103 2.976-.229 4.504-.229a64.68 64.68 0 0 1 56.154 32.793"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M129.683 111.734c-.212 3.188-11.475 14.182-15.413 14.182-36.443 0-42.359 22.046-42.359 22.046 1.614 18.564 14.55 33.854 30.187 41.942.714.371 1.439.705 2.163 1.032a71 71 0 0 0 3.763 1.541 57 57 0 0 0 16.675 3.217c63.876 2.996 76.25-76.384 30.154-99.419a44.24 44.24 0 0 1 30.901 7.503A64.68 64.68 0 0 0 129.6 70.985c-1.521 0-3.009.126-4.504.229a64.1 64.1 0 0 0-35.269 13.593c1.954 1.654 4.16 3.863 8.806 8.442 8.696 8.568 31 17.443 31.05 18.485"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M129.683 111.734c-.212 3.188-11.475 14.182-15.413 14.182-36.443 0-42.359 22.046-42.359 22.046 1.614 18.564 14.55 33.854 30.187 41.942.714.371 1.439.705 2.163 1.032a71 71 0 0 0 3.763 1.541 57 57 0 0 0 16.675 3.217c63.876 2.996 76.25-76.384 30.154-99.419a44.24 44.24 0 0 1 30.901 7.503A64.68 64.68 0 0 0 129.6 70.985c-1.521 0-3.009.126-4.504.229a64.1 64.1 0 0 0-35.269 13.593c1.954 1.654 4.16 3.863 8.806 8.442 8.696 8.568 31 17.443 31.05 18.485"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M83.852 80.545a82 82 0 0 1 2.645 1.756 59.4 59.4 0 0 1-.36-31.324 94.9 94.9 0 0 0-30.849 23.841c.625-.017 19.216-.351 28.564 5.727"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M2.471 139.411c9.89 58.443 62.857 103.063 122.989 104.766 55.652 1.574 91.205-30.732 105.894-62.248a116.07 116.07 0 0 0 3.988-86.497v-.122c0-.096-.02-.153 0-.123l.023.215c4.547 29.684-10.552 58.443-34.155 77.889l-.073.166c-45.989 37.455-90.002 22.598-98.91 16.533a65 65 0 0 1-1.865-.929c-26.814-12.817-37.891-37.247-35.517-58.198a32.91 32.91 0 0 1-30.359-19.096 48.34 48.34 0 0 1 47.117-1.891 63.82 63.82 0 0 0 48.119 1.891c-.049-1.042-22.353-9.92-31.05-18.484-4.646-4.58-6.851-6.786-8.805-8.442a38 38 0 0 0-3.307-2.507c-.761-.519-1.617-1.081-2.645-1.756-9.348-6.078-27.939-5.744-28.554-5.727h-.059c-5.079-6.438-4.722-27.667-4.431-32.101a23 23 0 0 0-4.279 2.271 93.4 93.4 0 0 0-12.526 10.73 112 112 0 0 0-12.03 14.342v.019-.023A108.3 108.3 0 0 0 4.841 108.92c-.062.261-4.616 20.167-2.37 30.491"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M174.654 88.838a69.8 69.8 0 0 1 11.904 15.542 27 27 0 0 1 1.921 1.574c29.056 26.784 13.832 64.646 12.698 67.341 23.603-19.447 38.688-48.205 34.155-77.89-14.497-36.142-39.069-50.708-59.137-82.426a155 155 0 0 1-3.019-4.907 41 41 0 0 1-1.412-2.645 23.3 23.3 0 0 1-1.912-5.076.33.33 0 0 0-.291-.331.47.47 0 0 0-.241 0c-.016 0-.043.03-.063.037s-.063.036-.092.049c-4.957 2.351-34.35 48.893 5.489 88.732"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__j)",
        d: "M188.459 105.937a27 27 0 0 0-1.921-1.574c-.261-.195-.519-.39-.797-.585a44.24 44.24 0 0 0-30.901-7.503c46.095 23.048 33.728 102.415-30.154 99.419a57 57 0 0 1-16.675-3.217 67 67 0 0 1-3.763-1.541c-.725-.331-1.449-.661-2.163-1.032l.089.057c8.908 6.081 52.907 20.938 98.91-16.534l.073-.165c1.147-2.679 16.371-40.55-12.698-67.325"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__k)",
        d: "M71.911 147.962s5.916-22.046 42.359-22.046c3.938 0 15.211-10.994 15.413-14.182a63.82 63.82 0 0 1-48.119-1.892 48.34 48.34 0 0 0-47.118 1.892 32.91 32.91 0 0 0 30.359 19.096c-2.374 20.955 8.703 45.385 35.517 58.198.599.288 1.161.599 1.776.873-15.65-8.085-28.573-23.375-30.187-41.939"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M248.033 88.713c-5.569-13.399-16.864-27.866-25.71-32.439a133.2 133.2 0 0 1 12.979 38.9l.023.215c-14.49-36.126-39.062-50.692-59.13-82.41a155 155 0 0 1-3.019-4.907 41 41 0 0 1-1.412-2.645 23.3 23.3 0 0 1-1.912-5.076.33.33 0 0 0-.291-.331.47.47 0 0 0-.241 0c-.016 0-.043.03-.063.037s-.063.036-.092.049l.049-.086c-32.19 18.849-43.113 53.741-44.118 71.194 1.495-.103 2.976-.229 4.504-.229a64.68 64.68 0 0 1 56.154 32.793 44.24 44.24 0 0 0-30.901-7.503c46.096 23.048 33.729 102.415-30.154 99.419a57 57 0 0 1-16.675-3.217 67 67 0 0 1-3.763-1.541c-.724-.331-1.449-.661-2.163-1.032l.089.057a69 69 0 0 1-1.865-.93c.599.288 1.161.599 1.776.873-15.65-8.088-28.573-23.378-30.187-41.942 0 0 5.916-22.046 42.359-22.046 3.938 0 15.211-10.994 15.413-14.182-.05-1.042-22.354-9.92-31.05-18.485-4.646-4.579-6.852-6.785-8.806-8.442a38 38 0 0 0-3.307-2.506 59.4 59.4 0 0 1-.36-31.324 94.9 94.9 0 0 0-30.848 23.841h-.06c-5.079-6.438-4.722-27.667-4.431-32.102a23 23 0 0 0-4.279 2.272 93.4 93.4 0 0 0-12.526 10.73 112 112 0 0 0-11.98 14.375v.019-.023A108.3 108.3 0 0 0 4.841 108.92l-.171.846c-.242 1.128-1.323 6.855-1.479 8.085 0 .093 0-.096 0 0A149 149 0 0 0 1.3 135.717v.662c.086 98.661 106.944 160.23 192.344 110.825a128.17 128.17 0 0 0 62.12-89.153c.215-1.653.39-3.29.582-4.96a131.8 131.8 0 0 0-8.313-64.378m-12.715 6.583.024.136z"
    }));

const FlaskDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#fff",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.319 9.028c.35-.62-1.443-.835-.235-.219.112.037.087.262.235.219M4.542 3.761c-.762-.995 1.432.167.659-.875-.652-.519-1.278.585-.659.875m1.596 1.25c1.082-.144-.275-.466-.217-.013zm-.855-.205c.232-.315-.407.16 0 0m1.725 1.899c.672.016-.289-.902.511-.487-.131-.429-.932-.509-1.325-.68-.22.392.45 1.172.812 1.167zm-2.092-.086c.575-.434 1.984.257 1.08-.431-.087-.077-1.982.522-1.08.431m-.59 1.128c1.007-.342 2.383-.726 2.858.169-.484-.582-.195-1.155.262-.304.645.861.968-.391.547-.681.479.595 1.023.875.321.037.762-.917-1.528.121-2.049.11-.25.112-2.588.596-1.938.669zM6.2 10.881c.246-.304-.337-.081 0 0m-.587 1.571c-.06-.362-.175.192 0 0m-.497-.252c.562-.037.882-.621-.109-.587-1.537-.159 1.355.525-.197.33-.209.137.295.296.306.259zm24 15.245c.696 0 2.109-.216.594-.216-.237.038-1.386.03-.595.216zm-3.336-1.959c.075-.51-.337.046 0 0m2.615 1.787c.015-.444-.38.2 0 0M2.65 11.165c.499-.381-.589-.145 0 0m1.899 1.35c.306-.325-.663-.132 0 0m-.643-.18c.871-.534-.926-.462 0 0m6.442-4.055c.291-.765 1.132-.306.135-.154.021.081-.03.395-.135.154m-.8.005c-.069-1.517 1.398.54 0 0m-2.812.433c.462-.555 2.618-.354 1.04-.054-.422-.319-.747.187-1.04.054m-.195.13c.277-.325.08.287 0 0m-.759.306c.04-.514 1.272.272.204.185zm-.556-.01c.437-.325.232.182 0 0m-.059.543c.304-1.117 1.625.918.497.147a.7.7 0 0 0-.443-.152l-.057.002h.002zM2.05 11.274c-.116-.669-.1-1.842 1.015-1.445-1.488.295 1.03 1.849.712.622.625.03 1.225-.37.895.237 1.233-.137 2.087-1.205 3.279-1.056a13 13 0 0 0 3.033-.615l-.091.026c.822-.06 1.612-.945 1.162-1.468a12.785 12.785 0 0 0-3.618.308l.086-.017c-1.372.285-2.619.827-4.005 1.061-1.35.181.271.5-.115.57-.705.245.84.41-.091.667-.575-.11-1.175-.307-.928-.912-1.293.166-2.431.704-1.408 2.019h.075zm2.17 1.452c.069-.475-.512.094 0 0m22.721 14.686c.165-.49-.417.062 0 0m-2.467-1.279c.412-.379-.525-.117 0 0M4.062 13.526c.647-.254-1.175-.525-.13-.05zm-1.524-.911c-.044-.4-.237.05 0 0m-.275.208c-.025-.337-.18.127 0 0m1.857 1.205c-.087-.731-1.05-.11 0 0m3.599 2.659c.152-.14-.362-.104 0 0M4.463 14.6c-.15-.121-.117.152 0 0m-.517-.253c.011-.312-.829-.28 0 0m-.905-.228c-.172-.968-.656-.147 0 0m3.795 2.635c.011-.509-.396-.019 0 0m17.149 10.682c.64-.13 2.097.325 2.332-.17-.775-.019-2.687-.547-2.777.125l.17.029zM6.378 16.639c-.009-.166-.152.062 0 0m-1.445-.7c.499-.169-.459-.112 0 0m11.534 7.786c-.009-.501-.494.125 0 0M5.241 16.65c.775-.3-.83-.212 0 0m15.008 9.647c.27-.2-.337-.025 0 0m-2.814-1.774c-.05-.194-.196.037 0 0m-.342-.249c-.135-.347-.535-.008 0 0m-7.099-4.478c0-.506-.906-.205 0 0m-.82-.19c-.332-.279-.016-.04 0 0m-5.403-3.331c.115-.479-1.066-2.633-.557-1.08.182.325.162.942.557 1.08m2.944 2.324c.646.145 2.582 1.592 1.44.1-.585-.172-.234-1.603-.831-1.35.4.669.33.953-.512.532-1.056-.516-.592.255-.387.467-.28.065.374.245.291.25zm16.176 10.413c.482-.322-.586-.104 0 0m-1.725-1.147c.717-.602-.759.266 0 0m.337.163c.881-.637-.535-.122-.185.12zm-9.864-5.854c-.181-.371-.28.059 0 0m-.575-.333c-.025-.3-.364.025 0 0m9.335 5.886c.689-.444-.157-.375-.125.04zM6.272 18.818c.204-.302-.525-.039 0 0m14.353 9.2c.712-.61-.45-.128 0 0m-1.082-.425c1.418-.917-.582-.4 0 0M4.51 18.178c-.657-.937-.409-1.36-1.043-2.124-.12-.587-1.087-1.916-.5-.507.537.823.697 2.098 1.543 2.632zm15.274 9.675c.771-.817-.747.049 0 0m-.001.262c.004-.187-.3.082 0 0m-1.45-.994c.697-.585-.675.26 0 0m-6.369-3.936c.452.4 2.077.295.55.05-.227-.337-1.438-.255-.55-.05M7.327 20.39c-.302-.502-1.08-.455 0 0m-.814-.535c-.125-.491-.875-.487 0 0m12.111 7.607c.406-.394.016.629.675-.096.006-.519-.021-.825-.757-.195-.202.112-.292.591.082.291m-.763-.321c.025-.35-.241.3 0 0m-7.423-4.497c1.762.567-.864-.695 0 0m-1.45-.833c.425.316 1.6.898.605.12.336-.39-.642-.597-.317-.857-.825-.505-.65-.46-.072-.445-.992-.442.142-.41.087-.637-.381-.075-1.899-.675-1.005.05-.907-.462-.216.172-.49.105-.928-.252.825.706-.147.469.531.421 1.432 1.08.225.446-.16.229.862.575 1.115.75zm2.738 1.817c.769.2.765-.119.069-.212-.375-.35-1.557-.719-.5-.044.071.177.294.174.43.257zm-1.387-.7c-.16-.139.02.087 0 0m.674-13.262c.117-.144.025.174 0 0m-.403 2.403c-.27-.475.34-2.091.407-1.087-.284.781-.081 1.218.116.17.366-.825-.079 1.628-.525.918zm-.392.637c-.066-.4.225.505 0 0m.241.637c-.393-.97.365.512 0 0m.164.363c-.003-.209.054.302 0 0m-2.828-1.574c.257-.542.475.604 0 0m-1.002-.597c.161-.069.085.215 0 0m4.283 3.344c.146-1.18.129.691 0 0m-3.842-2.254c.211-.31-.562-1.4.111-.391.29.231.84.387.354.484.762.674-.187.182-.465-.092zm4.062 2.578c.055-1.037.31-.619.002.147zm-4.448-2.218c.519-.11 2.147.911.65.292-.165-.185-.52-.1-.65-.293zm4.738 3.276c.162-.577.012.381 0 0m-2.102-1.348c-.082-1.012.184.167 0 0m-2.769-1.469c-.871-1.203 2.533 1.216.559.305-.206-.054-.455-.075-.559-.305m4.806 3.258c.067-.275.009.322 0 0m.25.248c.06-.641.124.437 0 0m-1.437-.85c-.587-.352-.154-2.479.046-1.025.571-.185-.031.75.394.742-.066.591-.257.804-.437.282zm-3.886-2.259c-1.357-1.207 1.706.632.221.225zm.871.833c-.41-.771.5.322 0 0m-.438-.141c.271-.269.144.265 0 0m-.712.019c-.467-.462-.805-.891.021-.287.319.012-.707-.972.075-.312.825.15.409 1.352-.096.6zm1.355 1.049c.27-.569.457.792 0 0m-.563-.193c.05-.754.287.516 0 0m1.254.863a3.1 3.1 0 0 1-.417-1.562v-.003c.095.472 1.005 2.033.446.647-.617-1.162.737.377.877.667.062.287-.381-.079-.08.597-.55-.771-.325.425-.826-.347zm4.056 2.706c-.44-.987.312-.54.097.162zm-2.352-.755c-.194-.347.404.325 0 0m2.739 1.906c.168-.63.198.53 0 0M8.78 18.026c.274-.075.135.467 0 0m4.873 3.364c-.465-.9.587.255 0 0m.403.541c-.012-.585.134.45 0 0m4.631 3.519c.231-.014.008.175 0 0m-4.047-2.571c-.37-.387-.466-1.112-.066-.481.205.082.656 1.183.066.481m1.243 3.509c.966-.577.647 1.352 1.638.162.977-.712-.843.883.362.129.87-.584 2.157.275 2.969.556.585-.029 1.153.506 1.753.181 1.153-.312-2.257-.462-1.362-1.012a2.192 2.192 0 0 1-2.35-1.033l-.006-.01a4.87 4.87 0 0 1-3.136-1.914l-.009-.013c-.24-.394.35.055-.207-.587a8.7 8.7 0 0 1-1.527-2.079l-.023-.047c-.571-.305-.637-1.203-.696-.03.005-.741-.691-1.24-.86-1.032-.002-.714.744-.356.22-.884-.112-.74-.482-1.512-.594-2.346-.172-.402-.025-1.263-.591-.352-.206.962-.069-1.183.252-.475.421-.725-.15-.637-.175-.537.275-.61.175-1.475-.071-1.145.146-.646.231-2.377-.219-2.069.272-.675.517-3.09-.667-2.169a5 5 0 0 0-1.736.382l.033-.012c1.232.679-.125.245-.625.137-.065.627-.562.356-1.182.362.991.122-.482 1.012-1.051.667-.737.352.637 1.233.015 1.506.075.41-1.131-.15-1.037.8-.716-.301-.097 1.125.261.642 1.218.33.857 1.082.887 1.796-.197.416-.98-.978-.175-.914-.634-1.033-.701-.375-1.23.106-.125.035 1.348.684.425 1.003.812.125.835.837 1 1.287.487.509.387-.562.973.05-.37-.545-1.958-1.535-.68-1.217-.006-.55-.231-.991.161-.98.387-.702-.406 1.733.469.84.241-.106.3-.704.737.056.631.622.227 1.072-.664.504.159.541 1.192.734.998 1.581.206.744.494.47.745.427.197.722.309.191.319-.154.9.194.69.725.972 1.1.621.28-.89-1.902.177-.657 1.122 1.012.421 1.437-.587 1.275.637-.051.844.862 1.641.83.727.346 1.218 1.675-.034 1.121-.435-.391-1.974-.875-.716-.13a29 29 0 0 1 3.35 1.611l-.15-.077c.8.572 1.147 1.227 1.45 1.357-.672.321-2.028-.257-1.021-.435-.629-.114-1.335-.431-.734.35.512.429 1.812.382 2.046.431-.199.435-.537.47.008.504-.607.325.195.375.251.56zm-3.594-2.209c1.033.132-1.231-.704-.226-.075zm2.756 1.871c.897-.356-.875-.175 0 0m-5.299-3.296c.575-.062-.925-.389 0 0m3.131 1.99c.075-.319-.66-.096 0 0m4.579 2.965c-.012-.246-.229.094 0 0m-4.206-2.58c-.142-.162-.068.035 0 0m-6.757-4.293c-.096-.371-.842-.667 0 0m2.574 1.665c.775-.046-1.06-.341 0 0m2.172 1.567c-.08-.239-.42-.01 0 0m5.786 3.569c.035-.454-.441.337 0 0m-8.085-4.98c-.052-.25-.332.023 0 0m5.803 3.699c1.35.012-1.218-.184 0 0m-2.466-1.425c1.425.404-1.197-.9-.351-.147l.187.085.162.062zm1.23.979c.241-.412-1.018-.237 0 0m-4.049-2.472c.582.447 2.349.057.892-.266-.662-.354-2.158-.595-1.14.212zm3.229 2.215c.537-.202-.87-.204 0 0m-1.207-.741c.375-.262-.776-.2 0 0m-1.437-.837c-.05-.209-.77-.231 0 0m4.9 3.817c.496.312 2.899.687 1.393.129-.25.052-2.787-.717-1.395-.129zm-3.087-1.927c-.017-.207-.22.094 0 0m-.617-.308c.609-.394-.787-.005 0 0m2.708 1.891c.239-.352-.762-.134 0 0m-1.409-.787c.39-.375-.605-.235 0 0m-.824-.344c-.067-.331-.3.185 0 0m-.658-.24c.269-.12-.387-.15 0 0m-4.941-4.37c.041-.182.221.396 0 0m3.491 3.833c1.212.449-.005-.852-.562-.777-.245-.426-.938-.696-.45-.925-.88.305-.921-1.162-1.337-.953-.93-.294-.362-1.337-1.47-1.974-.101-.675-1.102-1.26-1.422-2.277-.141-.52-1.131-2.016-.522-.625a19.7 19.7 0 0 0 2.221 3.68l-.034-.047a7.54 7.54 0 0 0 2.336 2.898l.02.014c.362.348.71.879 1.221.987zm2.379 1.682a13.8 13.8 0 0 0 3.753 1.268l.088.014a19.7 19.7 0 0 0 4.336.47q1.198 0 2.36-.136l-.094.009c-.987-.446-2.009.175-2.993-.319a11.012 11.012 0 0 1-3.72-.236l.075.015a32.6 32.6 0 0 1-4.292-1.902l.179.087c-1.596-.582.825.747 1.256.856.997.566-1.096-.291-1.392-.526-.835-.469-.942-.371-.082.105.174.1.345.207.525.294zm-2.018-.875a14.6 14.6 0 0 1-3.171-2.945l-.023-.029a24 24 0 0 1-3.971-7.051l-.053-.168c-.557-1.693-.75-3.509-1.467-5.136A1.954 1.954 0 0 1 2.693 8.27l.011-.001c.575-.109 1.59-.652.366-.264-1.097.805-1.203-.731-.079-.827a.892.892 0 0 0 .785-1.301l.002.005c-.825-.537 1.999-1.128.579-1.929-1.478-1.598 2.071-1.904 1.196-.092-.209 1.393 2.479-.256 1.856 1.353.634.774 2.374.175 2.331 1.261.925.062 1.241.84 2.108.9.9.406 2.527.725 2.832 1.737-.891.707-2.954-1.456-3.053.497.023 3.075.48 6.034 1.312 8.832l-.057-.225a12.7 12.7 0 0 0 2.804 4.271 12.35 12.35 0 0 0 3.834 2.884l.074.032c1.16.548 2.508.98 3.918 1.228l.097.014c.56-.429 1.55-2.021 2.422-1.35.041.755-1.735 1.578-.084 1.495.97-.292 1.642.75 2.441-.19.735.871 3.057-.557 2.533 1.225-.707.455-1.739.18-2.448.807-1.168-.584-2.099.522-3.393.382a24 24 0 0 1-4.228.363h-.133.007a26.4 26.4 0 0 1-7.29-1.149l.187.049a14.4 14.4 0 0 1-3.7-1.86l.046.031z"
    }));

const FlaskLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.319 9.028c.35-.62-1.443-.835-.235-.219.112.037.087.262.235.219M4.542 3.761c-.762-.995 1.432.167.659-.875-.652-.519-1.278.585-.659.875m1.596 1.25c1.082-.144-.275-.466-.217-.013zm-.855-.205c.232-.315-.407.16 0 0m1.725 1.899c.672.016-.289-.902.511-.487-.131-.429-.932-.509-1.325-.68-.22.392.45 1.172.812 1.167zm-2.092-.086c.575-.434 1.984.257 1.08-.431-.087-.077-1.982.522-1.08.431m-.59 1.128c1.007-.342 2.383-.726 2.858.169-.484-.582-.195-1.155.262-.304.645.861.968-.391.547-.681.479.595 1.023.875.321.037.762-.917-1.528.121-2.049.11-.25.112-2.588.596-1.938.669zM6.2 10.881c.246-.304-.337-.081 0 0m-.587 1.571c-.06-.362-.175.192 0 0m-.497-.252c.562-.037.882-.621-.109-.587-1.537-.159 1.355.525-.197.33-.209.137.295.296.306.259zm24 15.245c.696 0 2.109-.216.594-.216-.237.038-1.386.03-.595.216zm-3.336-1.959c.075-.51-.337.046 0 0m2.615 1.787c.015-.444-.38.2 0 0M2.65 11.165c.499-.381-.589-.145 0 0m1.899 1.35c.306-.325-.663-.132 0 0m-.643-.18c.871-.534-.926-.462 0 0m6.442-4.055c.291-.765 1.132-.306.135-.154.021.081-.03.395-.135.154m-.8.005c-.069-1.517 1.398.54 0 0m-2.812.433c.462-.555 2.618-.354 1.04-.054-.422-.319-.747.187-1.04.054m-.195.13c.277-.325.08.287 0 0m-.759.306c.04-.514 1.272.272.204.185zm-.556-.01c.437-.325.232.182 0 0m-.059.543c.304-1.117 1.625.918.497.147a.7.7 0 0 0-.443-.152l-.057.002h.002zM2.05 11.274c-.116-.669-.1-1.842 1.015-1.445-1.488.295 1.03 1.849.712.622.625.03 1.225-.37.895.237 1.233-.137 2.087-1.205 3.279-1.056a13 13 0 0 0 3.033-.615l-.091.026c.822-.06 1.612-.945 1.162-1.468a12.785 12.785 0 0 0-3.618.308l.086-.017c-1.372.285-2.619.827-4.005 1.061-1.35.181.271.5-.115.57-.705.245.84.41-.091.667-.575-.11-1.175-.307-.928-.912-1.293.166-2.431.704-1.408 2.019h.075zm2.17 1.452c.069-.475-.512.094 0 0m22.721 14.686c.165-.49-.417.062 0 0m-2.467-1.279c.412-.379-.525-.117 0 0M4.062 13.526c.647-.254-1.175-.525-.13-.05zm-1.524-.911c-.044-.4-.237.05 0 0m-.275.208c-.025-.337-.18.127 0 0m1.857 1.205c-.087-.731-1.05-.11 0 0m3.599 2.659c.152-.14-.362-.104 0 0M4.463 14.6c-.15-.121-.117.152 0 0m-.517-.253c.011-.312-.829-.28 0 0m-.905-.228c-.172-.968-.656-.147 0 0m3.795 2.635c.011-.509-.396-.019 0 0m17.149 10.682c.64-.13 2.097.325 2.332-.17-.775-.019-2.687-.547-2.777.125l.17.029zM6.378 16.639c-.009-.166-.152.062 0 0m-1.445-.7c.499-.169-.459-.112 0 0m11.534 7.786c-.009-.501-.494.125 0 0M5.241 16.65c.775-.3-.83-.212 0 0m15.008 9.647c.27-.2-.337-.025 0 0m-2.814-1.774c-.05-.194-.196.037 0 0m-.342-.249c-.135-.347-.535-.008 0 0m-7.099-4.478c0-.506-.906-.205 0 0m-.82-.19c-.332-.279-.016-.04 0 0m-5.403-3.331c.115-.479-1.066-2.633-.557-1.08.182.325.162.942.557 1.08m2.944 2.324c.646.145 2.582 1.592 1.44.1-.585-.172-.234-1.603-.831-1.35.4.669.33.953-.512.532-1.056-.516-.592.255-.387.467-.28.065.374.245.291.25zm16.176 10.413c.482-.322-.586-.104 0 0m-1.725-1.147c.717-.602-.759.266 0 0m.337.163c.881-.637-.535-.122-.185.12zm-9.864-5.854c-.181-.371-.28.059 0 0m-.575-.333c-.025-.3-.364.025 0 0m9.335 5.886c.689-.444-.157-.375-.125.04zM6.272 18.818c.204-.302-.525-.039 0 0m14.353 9.2c.712-.61-.45-.128 0 0m-1.082-.425c1.418-.917-.582-.4 0 0M4.51 18.178c-.657-.937-.409-1.36-1.043-2.124-.12-.587-1.087-1.916-.5-.507.537.823.697 2.098 1.543 2.632zm15.274 9.675c.771-.817-.747.049 0 0m-.001.262c.004-.187-.3.082 0 0m-1.45-.994c.697-.585-.675.26 0 0m-6.369-3.936c.452.4 2.077.295.55.05-.227-.337-1.438-.255-.55-.05M7.327 20.39c-.302-.502-1.08-.455 0 0m-.814-.535c-.125-.491-.875-.487 0 0m12.111 7.607c.406-.394.016.629.675-.096.006-.519-.021-.825-.757-.195-.202.112-.292.591.082.291m-.763-.321c.025-.35-.241.3 0 0m-7.423-4.497c1.762.567-.864-.695 0 0m-1.45-.833c.425.316 1.6.898.605.12.336-.39-.642-.597-.317-.857-.825-.505-.65-.46-.072-.445-.992-.442.142-.41.087-.637-.381-.075-1.899-.675-1.005.05-.907-.462-.216.172-.49.105-.928-.252.825.706-.147.469.531.421 1.432 1.08.225.446-.16.229.862.575 1.115.75zm2.738 1.817c.769.2.765-.119.069-.212-.375-.35-1.557-.719-.5-.044.071.177.294.174.43.257zm-1.387-.7c-.16-.139.02.087 0 0m.674-13.262c.117-.144.025.174 0 0m-.403 2.403c-.27-.475.34-2.091.407-1.087-.284.781-.081 1.218.116.17.366-.825-.079 1.628-.525.918zm-.392.637c-.066-.4.225.505 0 0m.241.637c-.393-.97.365.512 0 0m.164.363c-.003-.209.054.302 0 0m-2.828-1.574c.257-.542.475.604 0 0m-1.002-.597c.161-.069.085.215 0 0m4.283 3.344c.146-1.18.129.691 0 0m-3.842-2.254c.211-.31-.562-1.4.111-.391.29.231.84.387.354.484.762.674-.187.182-.465-.092zm4.062 2.578c.055-1.037.31-.619.002.147zm-4.448-2.218c.519-.11 2.147.911.65.292-.165-.185-.52-.1-.65-.293zm4.738 3.276c.162-.577.012.381 0 0m-2.102-1.348c-.082-1.012.184.167 0 0m-2.769-1.469c-.871-1.203 2.533 1.216.559.305-.206-.054-.455-.075-.559-.305m4.806 3.258c.067-.275.009.322 0 0m.25.248c.06-.641.124.437 0 0m-1.437-.85c-.587-.352-.154-2.479.046-1.025.571-.185-.031.75.394.742-.066.591-.257.804-.437.282zm-3.886-2.259c-1.357-1.207 1.706.632.221.225zm.871.833c-.41-.771.5.322 0 0m-.438-.141c.271-.269.144.265 0 0m-.712.019c-.467-.462-.805-.891.021-.287.319.012-.707-.972.075-.312.825.15.409 1.352-.096.6zm1.355 1.049c.27-.569.457.792 0 0m-.563-.193c.05-.754.287.516 0 0m1.254.863a3.1 3.1 0 0 1-.417-1.562v-.003c.095.472 1.005 2.033.446.647-.617-1.162.737.377.877.667.062.287-.381-.079-.08.597-.55-.771-.325.425-.826-.347zm4.056 2.706c-.44-.987.312-.54.097.162zm-2.352-.755c-.194-.347.404.325 0 0m2.739 1.906c.168-.63.198.53 0 0M8.78 18.026c.274-.075.135.467 0 0m4.873 3.364c-.465-.9.587.255 0 0m.403.541c-.012-.585.134.45 0 0m4.631 3.519c.231-.014.008.175 0 0m-4.047-2.571c-.37-.387-.466-1.112-.066-.481.205.082.656 1.183.066.481m1.243 3.509c.966-.577.647 1.352 1.638.162.977-.712-.843.883.362.129.87-.584 2.157.275 2.969.556.585-.029 1.153.506 1.753.181 1.153-.312-2.257-.462-1.362-1.012a2.192 2.192 0 0 1-2.35-1.033l-.006-.01a4.87 4.87 0 0 1-3.136-1.914l-.009-.013c-.24-.394.35.055-.207-.587a8.7 8.7 0 0 1-1.527-2.079l-.023-.047c-.571-.305-.637-1.203-.696-.03.005-.741-.691-1.24-.86-1.032-.002-.714.744-.356.22-.884-.112-.74-.482-1.512-.594-2.346-.172-.402-.025-1.263-.591-.352-.206.962-.069-1.183.252-.475.421-.725-.15-.637-.175-.537.275-.61.175-1.475-.071-1.145.146-.646.231-2.377-.219-2.069.272-.675.517-3.09-.667-2.169a5 5 0 0 0-1.736.382l.033-.012c1.232.679-.125.245-.625.137-.065.627-.562.356-1.182.362.991.122-.482 1.012-1.051.667-.737.352.637 1.233.015 1.506.075.41-1.131-.15-1.037.8-.716-.301-.097 1.125.261.642 1.218.33.857 1.082.887 1.796-.197.416-.98-.978-.175-.914-.634-1.033-.701-.375-1.23.106-.125.035 1.348.684.425 1.003.812.125.835.837 1 1.287.487.509.387-.562.973.05-.37-.545-1.958-1.535-.68-1.217-.006-.55-.231-.991.161-.98.387-.702-.406 1.733.469.84.241-.106.3-.704.737.056.631.622.227 1.072-.664.504.159.541 1.192.734.998 1.581.206.744.494.47.745.427.197.722.309.191.319-.154.9.194.69.725.972 1.1.621.28-.89-1.902.177-.657 1.122 1.012.421 1.437-.587 1.275.637-.051.844.862 1.641.83.727.346 1.218 1.675-.034 1.121-.435-.391-1.974-.875-.716-.13a29 29 0 0 1 3.35 1.611l-.15-.077c.8.572 1.147 1.227 1.45 1.357-.672.321-2.028-.257-1.021-.435-.629-.114-1.335-.431-.734.35.512.429 1.812.382 2.046.431-.199.435-.537.47.008.504-.607.325.195.375.251.56zm-3.594-2.209c1.033.132-1.231-.704-.226-.075zm2.756 1.871c.897-.356-.875-.175 0 0m-5.299-3.296c.575-.062-.925-.389 0 0m3.131 1.99c.075-.319-.66-.096 0 0m4.579 2.965c-.012-.246-.229.094 0 0m-4.206-2.58c-.142-.162-.068.035 0 0m-6.757-4.293c-.096-.371-.842-.667 0 0m2.574 1.665c.775-.046-1.06-.341 0 0m2.172 1.567c-.08-.239-.42-.01 0 0m5.786 3.569c.035-.454-.441.337 0 0m-8.085-4.98c-.052-.25-.332.023 0 0m5.803 3.699c1.35.012-1.218-.184 0 0m-2.466-1.425c1.425.404-1.197-.9-.351-.147l.187.085.162.062zm1.23.979c.241-.412-1.018-.237 0 0m-4.049-2.472c.582.447 2.349.057.892-.266-.662-.354-2.158-.595-1.14.212zm3.229 2.215c.537-.202-.87-.204 0 0m-1.207-.741c.375-.262-.776-.2 0 0m-1.437-.837c-.05-.209-.77-.231 0 0m4.9 3.817c.496.312 2.899.687 1.393.129-.25.052-2.787-.717-1.395-.129zm-3.087-1.927c-.017-.207-.22.094 0 0m-.617-.308c.609-.394-.787-.005 0 0m2.708 1.891c.239-.352-.762-.134 0 0m-1.409-.787c.39-.375-.605-.235 0 0m-.824-.344c-.067-.331-.3.185 0 0m-.658-.24c.269-.12-.387-.15 0 0m-4.941-4.37c.041-.182.221.396 0 0m3.491 3.833c1.212.449-.005-.852-.562-.777-.245-.426-.938-.696-.45-.925-.88.305-.921-1.162-1.337-.953-.93-.294-.362-1.337-1.47-1.974-.101-.675-1.102-1.26-1.422-2.277-.141-.52-1.131-2.016-.522-.625a19.7 19.7 0 0 0 2.221 3.68l-.034-.047a7.54 7.54 0 0 0 2.336 2.898l.02.014c.362.348.71.879 1.221.987zm2.379 1.682a13.8 13.8 0 0 0 3.753 1.268l.088.014a19.7 19.7 0 0 0 4.336.47q1.198 0 2.36-.136l-.094.009c-.987-.446-2.009.175-2.993-.319a11.012 11.012 0 0 1-3.72-.236l.075.015a32.6 32.6 0 0 1-4.292-1.902l.179.087c-1.596-.582.825.747 1.256.856.997.566-1.096-.291-1.392-.526-.835-.469-.942-.371-.082.105.174.1.345.207.525.294zm-2.018-.875a14.6 14.6 0 0 1-3.171-2.945l-.023-.029a24 24 0 0 1-3.971-7.051l-.053-.168c-.557-1.693-.75-3.509-1.467-5.136A1.954 1.954 0 0 1 2.693 8.27l.011-.001c.575-.109 1.59-.652.366-.264-1.097.805-1.203-.731-.079-.827a.892.892 0 0 0 .785-1.301l.002.005c-.825-.537 1.999-1.128.579-1.929-1.478-1.598 2.071-1.904 1.196-.092-.209 1.393 2.479-.256 1.856 1.353.634.774 2.374.175 2.331 1.261.925.062 1.241.84 2.108.9.9.406 2.527.725 2.832 1.737-.891.707-2.954-1.456-3.053.497.023 3.075.48 6.034 1.312 8.832l-.057-.225a12.7 12.7 0 0 0 2.804 4.271 12.35 12.35 0 0 0 3.834 2.884l.074.032c1.16.548 2.508.98 3.918 1.228l.097.014c.56-.429 1.55-2.021 2.422-1.35.041.755-1.735 1.578-.084 1.495.97-.292 1.642.75 2.441-.19.735.871 3.057-.557 2.533 1.225-.707.455-1.739.18-2.448.807-1.168-.584-2.099.522-3.393.382a24 24 0 0 1-4.228.363h-.133.007a26.4 26.4 0 0 1-7.29-1.149l.187.049a14.4 14.4 0 0 1-3.7-1.86l.046.031z"
    }));

const FlowLauncher = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 382.6 382.5",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x2: 249.9,
        y1: 191.3,
        y2: 191.3,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#1b9de2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#1595df"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#0680d7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0078d4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__b",
        x1: 697.3,
        x2: 809.9,
        y1: 499.2,
        y2: 499.2,
        gradientTransform: "rotate(49.2 809.6 -269.1)"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 143.6,
        x2: 393.5,
        y1: 249.8,
        y2: 249.8,
        gradientTransform: "rotate(180 263.1 220.5)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#0c59a4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#114a8b"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M117 382.5H0v-189C0 90.7 84 0 186.9 0h63v120.4h-54.6c-46.8 0-78 31.2-78 78l-.1 184.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m249.9 182.6.2-46.8h-54.7c-39 0-62.4 23.4-62.4 62.4l-.2 47 54.6-.1c39 0 62.5-23.4 62.5-62.5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M265.5 0h117v189c0 102.8-84 193.5-186.8 193.5h-63V262.1h54.6c46.9 0 78.1-31.2 78.1-78z"
    }));

const Flowbite = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 48 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M36.78 19.414c-.112.766-.617 1.806-1.196 2.71a5.05 5.05 0 0 1-3.218 2.218l-5.846 1.223a4.5 4.5 0 0 0-2.432 1.403l-3.833 4.285c-.72.806-1.224.613-1.224-.467-.009.04-1.903 4.925 3.116 7.82 1.929 1.112 4.705.712 6.633-.4l10.218-5.894a15.46 15.46 0 0 0 7.416-10.249q.05-.256.092-.513l-9.727-2.136Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M34.13 13.527c1.928 1.112 2.716 2.768 2.716 4.993q-.001.453-.067.894l4.117 1.769 5.61.367c.719-4.158-.69-8.437-3.213-11.838a23.9 23.9 0 0 0-7.28-6.476 24.2 24.2 0 0 0-7.359-2.78l-2.8 3.625-.884 4.163z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M1.175 16.578q0 .005.003 0c.216-.647.487-1.37.825-2.143 1.767-4.034 5.171-6.724 9.36-8.096A15.51 15.51 0 0 1 23.94 7.65l1.03.595 3.684-7.79C16.936-1.885 4.96 5 1.19 16.533z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M28.38 38.206a6.24 6.24 0 0 1-6.975-.505l-3.392 2.332-2.923 4.724c3.245 2.7 7.458 3.568 11.668 3.085a23.9 23.9 0 0 0 9.254-3.062 24.1 24.1 0 0 0 6.09-4.976L40.36 35.57l-2.82-2.647z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M21.405 37.701a6.22 6.22 0 0 1-2.374-4.888V16.61c0-.906.266-1.06 1.051-.607-1.209-.697-4.002-3.091-7.45-1.102-1.929 1.112-3.517 3.567-3.517 5.792V32.48c0 4.409 2.284 9.007 5.577 11.94.13.117.265.226.398.338z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M41.866 7.969q-.005-.003-.003.002c.454.51.945 1.106 1.446 1.785a15.45 15.45 0 0 1 2.685 12.346 15.49 15.49 0 0 1-7.425 10.227l-1.03.593 4.563 6.882c7.888-8.968 7.908-22.77-.205-31.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M9.515 20.692a6.23 6.23 0 0 1 3.925-5.782l-.325-4.1-2.287-4.692a15.47 15.47 0 0 0-8.855 8.353A23.9 23.9 0 0 0 0 24.008c0 2.754.454 5.353 1.268 7.758l4.543.609 3.704-1.117z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M13.44 14.91a6.24 6.24 0 0 1 5.425.39l.166.095 13.343 7.697c.936.54.85 1.07-.207 1.292l.77-.161a5.05 5.05 0 0 0 2.645-1.484 6.13 6.13 0 0 0 1.664-4.22 6.23 6.23 0 0 0-3.117-5.392L23.912 7.234a15.5 15.5 0 0 0-12.593-1.292c-.166.054-.328.116-.491.176z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M28.983 47.479q.005-.003 0-.003c-.67.137-1.432.264-2.27.357A15.477 15.477 0 0 1 9.515 32.446v-1.188l-8.248.507c3.83 11.309 15.785 18.228 27.669 15.723.005 0 .025-.005.046-.01Z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 30.09,
        x2: 34.811,
        y1: 35.655,
        y2: 19.21,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1724C9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1C64F2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 40.964,
        x2: 28.545,
        y1: 15.601,
        y2: 3.225,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1C64F2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0092FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 24.247,
        x2: 5.511,
        y1: 7.532,
        y2: 8.716,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0092FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#45B2FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 22.98,
        x2: 39.805,
        y1: 42.994,
        y2: 38.454,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1C64F2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0092FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 10.903,
        x2: 22.849,
        y1: 23.524,
        y2: 35.902,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1724C9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1C64F2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: 38.176,
        x2: 46.51,
        y1: 32.453,
        y2: 15.652,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0092FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#45B2FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: 8.046,
        x2: 3.586,
        y1: 13.696,
        y2: 30.46,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1C64F2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0092FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: 30.815,
        x2: 14.517,
        y1: 12.899,
        y2: 16.957,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1724C9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1C64F2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: 9.61,
        x2: 19.999,
        y1: 32.035,
        y2: 47.662,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0092FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#45B2FF"
    }))));

const Flutter = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 317",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "4%",
        x2: "75.9%",
        y1: "27%",
        y2: "52.9%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#47C5FB",
        d: "M158 0 0 158l49 48L255 0zm-1 145-85 85 49 50 49-49 85-86z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00569E",
        d: "m121 280 37 37h97l-85-86z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00B5F8",
        d: "m72 230 48-48 50 49-49 49z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        fillOpacity: 0.8,
        d: "m121 280 41-14 4-31z"
    }));

const Fly = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 231",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: "53.096%",
        cy: "49.564%",
        r: "93.348%",
        fx: "53.096%",
        fy: "49.564%",
        gradientTransform: "matrix(.77604 0 0 1 .119 0)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#BA7BF0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "45%",
        stopColor: "#996BEC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#5046E4"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M179.016 31.598h29.478c26.22 0 47.506 21.287 47.506 47.507v103.652c0 26.22-21.287 47.507-47.506 47.507h-2.323c-13.495-2.111-19.348-6.158-23.869-9.579l-37.479-30.815a5.276 5.276 0 0 0-6.635 0l-12.176 10.012-34.292-28.197a5.26 5.26 0 0 0-6.632 0l-47.64 41.91c-9.588 7.798-15.93 6.357-20.043 5.905C6.782 210.782 0 197.556 0 182.757V79.105c0-26.22 21.287-47.507 47.51-47.507h29.412l-.053.119-.992 2.89-.308.992-1.335 5.92-.184 1.04-.586 5.93-.078 1.627-.012.57.056 2.72.134 1.593.33 2.494.421 2.245.5 2.068.648 2.238 1.683 4.74.555 1.422 2.931 6.192 1.036 1.902 3.389 5.818 1.297 2.099 4.73 6.965.683.923 6.155 8.01 1.99 2.467 7.027 8.216 1.444 1.58 5.793 6.234 2.295 2.376 3.792 3.766-.761.636-.474.428a46 46 0 0 0-3.654 3.816 33 33 0 0 0-1.572 2.008 26 26 0 0 0-2.03 3.318q-.454.9-.814 1.842a17 17 0 0 0-1.1 5.008l-.022 1.481c.054 2.088.48 4.15 1.256 6.09a17 17 0 0 0 3.387 5.31 17.2 17.2 0 0 0 3.57 2.906c1.12.686 2.313 1.25 3.554 1.68a19.9 19.9 0 0 0 8.394.954h.016a18.9 18.9 0 0 0 6.922-2.054 18 18 0 0 0 2.644-1.712 16.96 16.96 0 0 0 5.332-7.09c.873-2.18 1.3-4.51 1.262-6.854l-.068-1.225a17.3 17.3 0 0 0-1.148-4.718 20 20 0 0 0-.888-1.927 26.5 26.5 0 0 0-2.09-3.308q-.533-.72-1.103-1.413a45.5 45.5 0 0 0-4.078-4.271l-1.026-.873 1.736-1.715 7.465-7.795 2.582-2.835 4.013-4.515 2.61-3.052 3.722-4.534 2.52-3.168 3.7-4.948 1.869-2.56 2.65-3.963 2.207-3.377 4.16-7.243 2.379-4.752.069-.146 1.82-4.41q.037-.085.063-.174l1.961-6.118.206-.891.851-4.87.165-1.32.05-.807.06-3.05-.016-.567-.156-2.732-.193-2.12-.967-6.114a2 2 0 0 0-.056-.243l-1.241-4.522-.427-1.256-.558-1.39Zm14.012 129.258c-6.18.087-11.169 5.076-11.256 11.256.09 6.179 5.078 11.165 11.256 11.253 6.178-.09 11.166-5.075 11.26-11.253-.09-6.18-5.08-11.169-11.26-11.256"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M102.63 230.264H47.51A47.3 47.3 0 0 1 17.404 219.5c4.113.452 10.455 1.893 20.043-5.905l47.64-41.91a5.26 5.26 0 0 1 6.632 0l34.292 28.197 12.176-10.012a5.276 5.276 0 0 1 6.635 0l37.48 30.815c4.52 3.42 10.373 7.468 23.868 9.579h-24.932a10.6 10.6 0 0 1-6.12-2.04l-.437-.336-32.983-27.389-32.55 27.389a10.43 10.43 0 0 1-6.519 2.376Zm90.398-69.408c-6.18.087-11.169 5.076-11.256 11.256.09 6.179 5.078 11.165 11.256 11.253 6.178-.09 11.166-5.075 11.26-11.253-.09-6.18-5.08-11.169-11.26-11.256m-72.765-34.102-3.792-3.766-2.295-2.376-5.793-6.233-1.444-1.581-7.028-8.216-1.99-2.466-6.154-8.01-.683-.924-4.73-6.965-1.297-2.099-3.39-5.818-1.035-1.902-2.93-6.192-.556-1.422-1.683-4.74-.649-2.238-.499-2.068-.42-2.245L73.563 55l-.134-1.593-.056-2.72.012-.57.078-1.627.586-5.93.184-1.04 1.335-5.92.308-.992.992-2.89.318-.749 1.578-3.467 1.094-2.064 1.525-2.513 1.518-2.239 1.082-1.422 1.247-1.503 1.372-1.509 1.176-1.182 2.862-2.519 2.092-1.712q.076-.063.156-.118l2.476-1.675 1.968-1.253 3.735-1.968c.056-.034.122-.062.18-.09l5.298-2.198.49-.184 4.708-1.378 1.99-.446 2.687-.54 1.784-.27 2.734-.34 1.865-.166 3.7-.196 1.45-.016 2.748.056.714.04 3.978.331 5.264.742.608.128 5.2 1.294 1.528.455 1.697.587 2.067.782 1.634.692 2.4 1.132 1.513.777 2.719 1.596 1.013.624 3.707 2.706 1.064.923 2.585 2.354.127.128 2.192 2.351.755.851 2.572 3.418.524.816 2.042 3.449.615 1.182 1.15 2.572 1.204 3.003.427 1.256 1.241 4.522q.035.12.056.243l.967 6.114.193 2.12.156 2.732.016.567-.06 3.05-.05.807-.165 1.32-.851 4.87-.206.891-1.961 6.118q-.026.09-.062.175l-1.821 4.409-.069.146-2.38 4.752-4.159 7.243-2.207 3.377-2.65 3.963-1.868 2.56-3.701 4.948-2.52 3.168-3.723 4.534-2.61 3.052-4.012 4.515-2.582 2.835-7.465 7.795-1.736 1.715 1.026.873a45.5 45.5 0 0 1 4.078 4.271q.57.693 1.104 1.413a26.5 26.5 0 0 1 2.089 3.308q.496.938.888 1.927c.596 1.51.998 3.105 1.148 4.718l.068 1.225a17.7 17.7 0 0 1-1.262 6.853 16.96 16.96 0 0 1-5.332 7.09 18 18 0 0 1-2.644 1.713 18.9 18.9 0 0 1-6.922 2.054h-.016a19.9 19.9 0 0 1-8.394-.954 18.3 18.3 0 0 1-3.554-1.68 17.2 17.2 0 0 1-3.57-2.906 17 17 0 0 1-3.387-5.31 17.6 17.6 0 0 1-1.256-6.09l.022-1.481a17 17 0 0 1 1.1-5.008q.36-.945.814-1.842a26 26 0 0 1 2.03-3.318 32 32 0 0 1 1.572-2.008 46 46 0 0 1 3.654-3.816l.474-.428.76-.636Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m141.7 200.499 32.982 27.389a10.6 10.6 0 0 0 6.67 2.376h-78.834c2.42 0 4.764-.839 6.632-2.376zm-13.536-64.64.299.087c.097.047.178.116.265.175l.25.221a36 36 0 0 1 1.792 1.774q.61.65 1.182 1.341a19 19 0 0 1 1.347 1.83c.178.281.343.565.499.861q.202.385.362.789c.187.468.327.96.37 1.462l-.009.942a5.37 5.37 0 0 1-2.547 4.187 7.3 7.3 0 0 1-3.1 1.02l-1.162.034-.983-.087a7.5 7.5 0 0 1-1.35-.327 6.5 6.5 0 0 1-1.278-.599l-.767-.561a5.26 5.26 0 0 1-1.746-2.994 8 8 0 0 1-.09-.592l-.029-.898q.025-.364.106-.723a7.5 7.5 0 0 1 .57-1.516q.474-.91 1.073-1.743a27 27 0 0 1 2.155-2.56 32 32 0 0 1 1.534-1.521l.377-.34c.262-.175.265-.175.565-.262zm-1.93-125.195.121-.01v104.981l-.262-.483a294 294 0 0 1-9.644-19.544 209 209 0 0 1-6.545-16.385 129 129 0 0 1-3.944-13.492c-.83-3.626-1.465-7.305-1.727-11.022a54 54 0 0 1-.09-4.764q.036-2.077.168-4.147a78 78 0 0 1 .676-6.492 65 65 0 0 1 .951-5.048 53 53 0 0 1 1.067-3.935 47 47 0 0 1 2.104-5.482c.3-.642.62-1.281.958-1.908 2.026-3.754 4.776-7.212 8.378-9.525a17.5 17.5 0 0 1 7.789-2.744m13.613.265 7.062 2.014c3.271 1.207 6.42 2.781 9.314 4.746a37.4 37.4 0 0 1 10.015 9.99 37.7 37.7 0 0 1 3.879 7.477 43.9 43.9 0 0 1 2.7 12.107c.094 1.085.147 2.173.168 3.262.025 1.01.02 2.023-.062 3.033a34 34 0 0 1-1.269 6.673 53 53 0 0 1-1.83 5.25 76 76 0 0 1-2.906 6.277c-2.354 4.547-5.064 8.896-7.964 13.102a204 204 0 0 1-11.483 14.986 284 284 0 0 1-13.776 15.269 292 292 0 0 0 9.067-18.553 230 230 0 0 0 4.41-10.623 167 167 0 0 0 4.106-11.945 117 117 0 0 0 2.36-9.16 75 75 0 0 0 1.282-8.014c.23-2.245.314-4.502.258-6.754a96 96 0 0 0-.152-4.131c-.33-5.538-1.173-11.057-2.788-16.367a48 48 0 0 0-2.226-5.899c-2.067-4.502-4.952-8.712-8.855-11.783z"
    }));

const Fortran = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 300 300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#734F96",
        d: "M44.01 299.986C26.274 299.992 0 269.031 0 255.695V43.73C0 25.782 31.051 0 44.452 0L256.81.015C275.136.016 300 29.907 300 44.15v212.173c0 20.902-28.002 43.585-43.791 43.59z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m41.187 241.619 11.527-.706c23.408-1.529 23.173-1.411 24.349-19.761 1.059-17.409-.275-153.712-1.059-156.445-1.29-4.501-6.135-7.09-20.585-7.087l-14.232-.088V32.007h218.787v97.748l-25.761-.382c-.235-.235-.941-7.146-1.411-13.498-2.706-29.877-9.41-47.067-22.349-53.772-6.823-3.529-17.476-4.57-51.598-4.58l-31.8.009v73.282h5.646c9.528-.118 21.643-2.353 25.643-4.823 5.175-3.176 9.527-12.351 11.057-23.408 1.152-8.07 2.042-14.107 2.042-14.107l25.012-.008V204.92h-25.878v-4.587c0-7.528-3.529-25.055-5.999-30.348-3.882-8.116-10.469-10.939-29.172-12.704l-8.587-.823.471 37.758c.353 35.877.588 37.876 2.823 40.935 2.823 3.764 5.881 4.47 24.584 5.881l12.554.597-.085 25.634H41.186V241.62Z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h300v299.986H0z"
    }))));

const FramerDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 384",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h256v128H128zm0 128h128l128 128H128v128L0 256z"
    }));

const FramerLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 384",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h256v128H128zm0 128h128l128 128H128v128L0 256z"
    }));

const Fresh = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 216",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFDB1E",
        d: "M240 21c38 91 0 140-31 167 8 27-23 33-35 19-34 12-104 12-154-38-27-27-6-87 65-128 62-34 124-54 155-20"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M85 41C138 7 201-8 227 15c40 34-84 112-130 131-50 20-23 65-50 65-24 0-20-31-40-60-13-17 18-70 78-110"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFDB1E",
        d: "M83 38 54 60l-4 4C12 98-9 137 3 154a89 89 0 0 1 11 19l2 4 5 15c7 16 13 23 26 23 11 0 15-5 18-20l1-7 1-4 1-2v-2l1-1v-2l1-2c4-11 12-19 26-25l2-1c27-10 69-36 99-60l4-3 5-5 4-4c28-26 37-49 21-64l-1-1C203-12 139 1 83 38m142-21c13 12 5 31-20 55l-4 3-1 1-4 4-4 3c-28 23-68 47-94 58l-3 1c-17 7-27 17-32 30l-1 3-1 2v2l-1 1v3l-1 4-1 7-1 3c-2 8-4 10-10 10-9 0-13-4-18-16l-5-16-1-2a121 121 0 0 0-13-24c-7-9 2-30 20-53l3-4c14-16 33-33 54-47C141 9 201-3 225 17"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFE600",
        d: "M197 20c36 10-2 44-33 66-29 21-51 33-61 38-3 1-12-18-12-8 0 3-6 17-8 18-10 4-32 10-45 10-27 0-15-37 24-71 6-6 11-5 17-5-4-6-4-7 3-12 33-21 73-36 90-38 3 0 6 2 6 4 3-1 16-3 19-2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M88 80c7-6 12-8 16-20 4 1 6 0 10-5 2 4 13 5 19 5-6 4-9 7-12 17-11-5-24-3-33 3"
    }));

const Front = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 950 950",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 475,
        cy: 475,
        r: 425,
        fill: "#fff"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#001B38",
        d: "M308 308.2c0-45.95 37.25-83.2 83.2-83.2H658v118.4c0 22.975-18.625 41.6-41.6 41.6H508c-22.091 0-40 17.909-40 40v258.4c0 22.975-18.625 41.6-41.6 41.6H308z"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 509,
        cy: 426,
        r: 108,
        fill: "url(#prefix__a)",
        transform: "rotate(90 509 426)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 509,
        cy: 426,
        r: 108,
        fill: "url(#prefix__b)",
        opacity: 0.5,
        transform: "rotate(90 509 426)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 428.041,
        x2: 591.574,
        y1: 502.06,
        y2: 339.649,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF0057",
        stopOpacity: 0.16
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.861,
        stopColor: "#FF0057"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 428.041,
        x2: 591.574,
        y1: 502.06,
        y2: 339.649,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF0057",
        stopOpacity: 0.16
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.861,
        stopColor: "#FF0057"
    }))));

const Gatsby = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#64328B",
        d: "M64 0C28.7 0 0 28.7 0 64s28.7 64 64 64 64-28.7 64-64S99.3 0 64 0M13.2 64 64 114.8c-28.1 0-50.8-22.7-50.8-50.8m62.2 49.5-60.9-61C19.7 30 39.9 13.2 64 13.2c16.6 0 31.3 7.9 40.5 20.2L97 40.6c-7.3-10.4-19.3-17.1-33-17.1-17.6 0-32.5 11.2-38.1 26.8C33.1 57 75.4 98.8 78.1 102c12.7-4.7 22.3-15.5 25.4-28.9H81.9v-9.4l33 .2c-.1 24.3-16.9 44.5-39.5 49.6"
    }));

const Gemini = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "0%",
        x2: "68.73%",
        y1: "100%",
        y2: "30.395%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#1C7DFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "52.021%",
        stopColor: "#1C69FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#F0DCD6"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M12 24A14.3 14.3 0 0 0 0 12 14.3 14.3 0 0 0 12 0a14.305 14.305 0 0 0 12 12 14.305 14.305 0 0 0-12 12"
    }));

const Ghostty = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 27 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#3551F3",
        d: "M20.395 32a6.35 6.35 0 0 1-3.516-1.067A6.36 6.36 0 0 1 13.362 32a6.35 6.35 0 0 1-3.516-1.067A6.27 6.27 0 0 1 6.372 32h-.038a6.26 6.26 0 0 1-4.5-1.906 6.38 6.38 0 0 1-1.836-4.482v-12.25C0 5.995 5.994 0 13.362 0s13.363 5.994 13.363 13.363v12.253c0 3.393-2.626 6.192-5.978 6.375a6 6 0 0 1-.352.009"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M20.395 30.593a4.93 4.93 0 0 1-3.08-1.083.66.66 0 0 0-.42-.145.8.8 0 0 0-.487.176 4.94 4.94 0 0 1-3.046 1.055 4.94 4.94 0 0 1-3.045-1.055.75.75 0 0 0-.942 0 4.9 4.9 0 0 1-3.01 1.055h-.033a4.85 4.85 0 0 1-3.49-1.482 4.98 4.98 0 0 1-1.436-3.498V13.367c0-6.597 5.364-11.96 11.957-11.96 6.592 0 11.956 5.363 11.956 11.956v12.253c0 2.645-2.042 4.827-4.65 4.97a5 5 0 0 1-.274.007"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M23.912 13.363v12.253c0 1.876-1.447 3.463-3.32 3.566a3.5 3.5 0 0 1-2.398-.769c-.778-.626-1.873-.598-2.658.021a3.5 3.5 0 0 1-2.176.753 3.5 3.5 0 0 1-2.173-.753 2.15 2.15 0 0 0-2.684 0 3.5 3.5 0 0 1-2.15.753c-1.948.014-3.54-1.627-3.54-3.575v-12.25c0-5.825 4.724-10.549 10.55-10.549 5.825 0 10.549 4.724 10.549 10.55"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m11.28 12.437-3.93-2.27a1.07 1.07 0 0 0-1.463.392 1.07 1.07 0 0 0 .391 1.463l2.326 1.343-2.326 1.343a1.072 1.072 0 0 0 1.071 1.855l3.932-2.27a1.07 1.07 0 0 0 0-1.854zm8.902-.146h-5.164a1.071 1.071 0 1 0 0 2.143h5.164a1.071 1.071 0 1 0 0-2.143"
    }));

const Gimp = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 48 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__s",
        fill: "#2e3436",
        fillRule: "evenodd",
        stroke: "#000",
        strokeMiterlimit: 10,
        strokeWidth: 1.174,
        d: "M24.042 21.837a2.298 2.298 0 1 1-4.597 0 2.298 2.298 0 1 1 4.597 0z",
        overflow: "visible",
        style: {
            marker: "none"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__u",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M23.158 20.953a1.768 1.768 0 1 1-3.536 0 1.768 1.768 0 1 1 3.536 0",
        overflow: "visible",
        style: {
            marker: "none"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__z",
        fill: "#fff",
        d: "M8.875 37.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 1 1 2.5 0",
        opacity: 0.528,
        overflow: "visible",
        style: {
            marker: "none"
        }
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__k"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#5b676b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#141718"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__A",
        x1: 13.236,
        x2: 7.752,
        y1: 37.752,
        y2: 42.282,
        gradientTransform: "rotate(27.621 -26.244 -49.44)scale(.8523)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#696969"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#bdbdbd"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#e2e2e2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopColor: "#a3a3a3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ddd"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__b",
        id: "prefix__x",
        x1: 19.395,
        x2: 23.109,
        y1: 30.001,
        y2: 33.439,
        gradientTransform: "translate(-46.407 -1.803)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#6e3d09"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.242,
        stopColor: "#ea8113"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.621,
        stopColor: "#5c3307"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#e07c12"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__c",
        id: "prefix__w",
        x1: 37.018,
        x2: 27.754,
        y1: 19.24,
        y2: 11.182,
        gradientTransform: "translate(-49.305 1.878)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__l"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#857c63"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#221f19"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__j"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#b9b9b0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__d",
        id: "prefix__t",
        x1: 6.305,
        x2: 5.985,
        y1: 23.362,
        y2: 31.57,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__e",
        id: "prefix__p",
        x1: 14.969,
        x2: 39.525,
        y1: 19.111,
        y2: 46.986,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__f",
        id: "prefix__B",
        x1: 26.163,
        x2: 24.329,
        y1: 30.543,
        y2: 30.985,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__g",
        id: "prefix__o",
        x1: 32.35,
        x2: 21.213,
        y1: 28.083,
        y2: 30.293,
        gradientTransform: "translate(-3.837 .346)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__h",
        id: "prefix__y",
        cx: 15.415,
        cy: 35.357,
        r: 7.579,
        fx: 15.415,
        fy: 35.357,
        gradientTransform: "matrix(1.5727 0 0 1.53264 -55.367 -21.358)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__i",
        id: "prefix__v",
        cx: 69.473,
        cy: 19.598,
        r: 3.515,
        fx: 69.473,
        fy: 19.598,
        gradientTransform: "matrix(1.31849 0 0 1.31849 -22.126 -6.242)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__j",
        id: "prefix__m",
        cx: 23,
        cy: 33.938,
        r: 18.25,
        fx: 23,
        fy: 33.938,
        gradientTransform: "matrix(1 0 0 .28425 0 24.29)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__k",
        id: "prefix__r",
        cx: 6.024,
        cy: 25.271,
        r: 4.831,
        fx: 6.024,
        fy: 25.271,
        gradientTransform: "matrix(.91616 .09319 -.10877 1.0693 3.254 -3.03)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__l",
        id: "prefix__n",
        cx: 18.558,
        cy: 22.3,
        r: 19.229,
        fx: 18.558,
        fy: 22.3,
        gradientTransform: "matrix(1.77275 0 0 1.29668 -16.34 -6.616)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__i",
        id: "prefix__q",
        cx: 69.473,
        cy: 19.598,
        r: 3.515,
        fx: 69.473,
        fy: 19.598,
        gradientTransform: "matrix(1.31849 0 0 1.31849 -22.126 -6.242)",
        gradientUnits: "userSpaceOnUse"
    })), /*#__PURE__*/ React.createElement("g", {
        color: "#000"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__m)",
        fillRule: "evenodd",
        d: "M41.25 33.938a18.25 5.188 0 1 1-36.5 0 18.25 5.188 0 1 1 36.5 0",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "matrix(1 0 0 1.53012 .125 -19.991)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__n)",
        fillRule: "evenodd",
        stroke: "#2e3436",
        strokeMiterlimit: 10,
        d: "M10.374 12.468s2.875 5.928 9.6 5.76c14.092-.353 16.563-7.705 16.917-8.765.353-1.061.894-.9 1.02.08 4.596 41.72-31.897 23.82-33.193 16.713 7.247-2.12 5.48-6.187 5.48-6.187z",
        overflow: "visible",
        style: {
            marker: "none"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__o)",
        fillRule: "evenodd",
        d: "M15.738 30.066c6.739 1.348 10.17.098 12.179-1.453-.53-.685-1.436-1.436-1.436-1.436s2.353.654 3.182 1.724c.826 1.066.306 1.723.09 3.088-.481-1.199-1.38-1.648-1.501-2.124-1.807 2.497-6.307 2.393-12.514.201",
        overflow: "visible",
        style: {
            marker: "none"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "url(#prefix__p)",
        strokeMiterlimit: 10,
        d: "M36.969 11.844a12.3 12.3 0 0 1-2.688 3.094C31.65 17.117 27.231 19.1 20 19.28c-4.224.105-6.953-1.934-8.625-3.75L11.25 20c.136.419.415 1.39-.062 2.719-.515 1.429-2.155 2.891-4.97 4 .251.522.496 1.043 1.25 1.781 1.029 1.005 2.458 2.088 4.157 3.063 3.398 1.948 7.802 3.493 11.906 3.562 4.105.07 7.857-1.235 10.438-5 2.378-3.471 3.682-9.348 3-18.281z",
        opacity: 0.185,
        overflow: "visible",
        style: {
            marker: "none"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__q)",
        fillRule: "evenodd",
        stroke: "#888a85",
        strokeMiterlimit: 10,
        strokeWidth: 0.783,
        d: "M72.655 21.837a3.182 3.182 0 1 1-6.364 0 3.182 3.182 0 1 1 6.364 0z",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "matrix(1.27778 0 0 1.27778 -75.127 -6.508)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__r)",
        fillRule: "evenodd",
        stroke: "#000",
        strokeMiterlimit: 10,
        d: "M10.43 27.229a4.331 6.099 0 1 1-8.662 0 4.331 6.099 0 1 1 8.662 0z",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "rotate(-35.808 3.363 26.345)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__s",
        fillRule: "evenodd",
        strokeMiterlimit: 10,
        strokeWidth: 1.174,
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "translate(-3.927 3.396)scale(.85185)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "url(#prefix__t)",
        strokeMiterlimit: 10,
        d: "M6.094 22.156c-.798 0-1.553.446-2.188 1.344-.634.898-1.094 2.234-1.094 3.719s.46 2.82 1.094 3.718 1.39 1.344 2.188 1.344 1.577-.476 2.218-1.375c.642-.898 1.094-2.206 1.094-3.687 0-1.482-.452-2.79-1.094-3.688-.641-.898-1.42-1.375-2.218-1.375z",
        opacity: 0.281,
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "rotate(-36.833 3.366 26.6)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M5.834 23.251a1.768 2.121 0 1 1-3.536 0 1.768 2.121 0 1 1 3.536 0",
        overflow: "visible",
        style: {
            marker: "none"
        }
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__u",
        fillRule: "evenodd",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "matrix(.76667 0 0 .76667 -2.556 5.03)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__v)",
        fillRule: "evenodd",
        stroke: "#888a85",
        strokeMiterlimit: 10,
        strokeWidth: 0.667,
        d: "M72.655 21.837a3.182 3.182 0 1 1-6.364 0 3.182 3.182 0 1 1 6.364 0z",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "matrix(1.5 0 0 1.5 -82.168 -10.919)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__s",
        fillRule: "evenodd",
        strokeMiterlimit: 10,
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "translate(1.414 .707)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__u",
        fillRule: "evenodd",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "matrix(.9 0 0 .9 3.023 2.626)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__w)",
        stroke: "#673907",
        strokeLinecap: "round",
        strokeWidth: 2.46,
        d: "m-23.364 23.568 3.71 3.47c8.347-6.381 17.094-20.1 17.094-20.1 1.976-2.242-.117-3.75-2.165-2.398 0 0-12.97 10.115-18.64 19.028z",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "rotate(-106.415 23.46 5.603)scale(.40643)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__x)",
        stroke: "#888a85",
        strokeLinecap: "round",
        strokeWidth: 2.46,
        d: "m-30.45 32.814 2.247 1.934 8.492-7.367.275-.706 1.095-.018c-.438-1.562-2.942-4.383-4.817-4.383l.082 1.09-.67.38z",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "rotate(-106.415 23.46 5.603)scale(.40643)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2.46,
        d: "m-23.801 28.377-4.365 5.266",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "rotate(-106.415 23.46 5.603)scale(.40643)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__y)",
        d: "M-45.341 42.77c10.444 0 18.37 1.244 19.87-6.355 1.21-6.123-7.21-9.057-11.382-3.59-4.02 5.265-8.488 9.945-8.488 9.945",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "rotate(-106.415 23.46 5.603)scale(.40643)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__z",
        opacity: 0.528,
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "rotate(-106.415 26.245 20.84)scale(.84127)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__z",
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "scale(-.56765)rotate(73.585 37.059 -61.34)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__A)",
        d: "M-38.544 40.91s3.722.094 6.117-1.413c.847-.533 1.516.65.494 1.088-2.208.944-6.61.324-6.61.324",
        opacity: 0.428,
        overflow: "visible",
        style: {
            marker: "none"
        },
        transform: "rotate(-106.415 23.46 5.603)scale(.40643)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__B)",
        fillRule: "evenodd",
        d: "M23.003 31.737c1.497.143 2.85-.273 3.412-.475.098-.555.537-1.62 2.046-1.691l-.53-.928s-1.967 1.348-4.066 1.746z",
        overflow: "visible",
        style: {
            marker: "none"
        }
    })));

const Git = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#DE4C36",
        d: "M251.17 116.6 139.4 4.82a16.49 16.49 0 0 0-23.31 0l-23.21 23.2 29.44 29.45a19.57 19.57 0 0 1 24.8 24.96l28.37 28.38a19.61 19.61 0 1 1-11.75 11.06L137.28 95.4v69.64a19.62 19.62 0 1 1-16.13-.57V94.2a19.61 19.61 0 0 1-10.65-25.73L81.46 39.44 4.83 116.08a16.49 16.49 0 0 0 0 23.32L116.6 251.17a16.49 16.49 0 0 0 23.32 0l111.25-111.25a16.5 16.5 0 0 0 0-23.33"
    }));

const GitHubCopilotDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 208",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M205.3 31.4c14 14.8 20 35.2 22.5 63.6 6.6 0 12.8 1.5 17 7.2l7.8 10.6c2.2 3 3.4 6.6 3.4 10.4v28.7a12 12 0 0 1-4.8 9.5C215.9 187.2 172.3 208 128 208c-49 0-98.2-28.3-123.2-46.6a12 12 0 0 1-4.8-9.5v-28.7c0-3.8 1.2-7.4 3.4-10.5l7.8-10.5c4.2-5.7 10.4-7.2 17-7.2 2.5-28.4 8.4-48.8 22.5-63.6C77.3 3.2 112.6 0 127.6 0h.4c14.7 0 50.4 2.9 77.3 31.4M128 78.7c-3 0-6.5.2-10.3.6a27.1 27.1 0 0 1-6 12.1 45 45 0 0 1-32 13c-6.8 0-13.9-1.5-19.7-5.2-5.5 1.9-10.8 4.5-11.2 11-.5 12.2-.6 24.5-.6 36.8 0 6.1 0 12.3-.2 18.5 0 3.6 2.2 6.9 5.5 8.4C79.9 185.9 105 192 128 192s48-6 74.5-18.1a9.4 9.4 0 0 0 5.5-8.4c.3-18.4 0-37-.8-55.3-.4-6.6-5.7-9.1-11.2-11-5.8 3.7-13 5.1-19.7 5.1a45 45 0 0 1-32-12.9 27.1 27.1 0 0 1-6-12.1c-3.4-.4-6.9-.5-10.3-.6m-27 44c5.8 0 10.5 4.6 10.5 10.4v19.2a10.4 10.4 0 0 1-20.8 0V133c0-5.8 4.6-10.4 10.4-10.4Zm53.4 0c5.8 0 10.4 4.6 10.4 10.4v19.2a10.4 10.4 0 0 1-20.8 0V133c0-5.8 4.7-10.4 10.4-10.4Zm-73-94.4c-11.2 1.1-20.6 4.8-25.4 10-10.4 11.3-8.2 40.1-2.2 46.2A31.2 31.2 0 0 0 75 91.7c6.8 0 19.6-1.5 30.1-12.2 4.7-4.5 7.5-15.7 7.2-27-.3-9.1-2.9-16.7-6.7-19.9-4.2-3.6-13.6-5.2-24.2-4.3m69 4.3c-3.8 3.2-6.4 10.8-6.7 19.9-.3 11.3 2.5 22.5 7.2 27a41.7 41.7 0 0 0 30 12.2c8.9 0 17-2.9 21.3-7.2 6-6.1 8.2-34.9-2.2-46.3-4.8-5-14.2-8.8-25.4-9.9-10.6-1-20 .7-24.2 4.3M128 56c-2.6 0-5.6.2-9 .5.4 1.7.5 3.7.7 5.7 0 1.5 0 3-.2 4.5 3.2-.3 6-.3 8.5-.3 2.6 0 5.3 0 8.5.3-.2-1.6-.2-3-.2-4.5.2-2 .3-4 .7-5.7-3.4-.3-6.4-.5-9-.5"
    }));

const GitHubCopilotLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 208",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M205.3 31.4c14 14.8 20 35.2 22.5 63.6 6.6 0 12.8 1.5 17 7.2l7.8 10.6c2.2 3 3.4 6.6 3.4 10.4v28.7a12 12 0 0 1-4.8 9.5C215.9 187.2 172.3 208 128 208c-49 0-98.2-28.3-123.2-46.6a12 12 0 0 1-4.8-9.5v-28.7c0-3.8 1.2-7.4 3.4-10.5l7.8-10.5c4.2-5.7 10.4-7.2 17-7.2 2.5-28.4 8.4-48.8 22.5-63.6C77.3 3.2 112.6 0 127.6 0h.4c14.7 0 50.4 2.9 77.3 31.4M128 78.7c-3 0-6.5.2-10.3.6a27.1 27.1 0 0 1-6 12.1 45 45 0 0 1-32 13c-6.8 0-13.9-1.5-19.7-5.2-5.5 1.9-10.8 4.5-11.2 11-.5 12.2-.6 24.5-.6 36.8 0 6.1 0 12.3-.2 18.5 0 3.6 2.2 6.9 5.5 8.4C79.9 185.9 105 192 128 192s48-6 74.5-18.1a9.4 9.4 0 0 0 5.5-8.4c.3-18.4 0-37-.8-55.3-.4-6.6-5.7-9.1-11.2-11-5.8 3.7-13 5.1-19.7 5.1a45 45 0 0 1-32-12.9 27.1 27.1 0 0 1-6-12.1c-3.4-.4-6.9-.5-10.3-.6m-27 44c5.8 0 10.5 4.6 10.5 10.4v19.2a10.4 10.4 0 0 1-20.8 0V133c0-5.8 4.6-10.4 10.4-10.4Zm53.4 0c5.8 0 10.4 4.6 10.4 10.4v19.2a10.4 10.4 0 0 1-20.8 0V133c0-5.8 4.7-10.4 10.4-10.4Zm-73-94.4c-11.2 1.1-20.6 4.8-25.4 10-10.4 11.3-8.2 40.1-2.2 46.2A31.2 31.2 0 0 0 75 91.7c6.8 0 19.6-1.5 30.1-12.2 4.7-4.5 7.5-15.7 7.2-27-.3-9.1-2.9-16.7-6.7-19.9-4.2-3.6-13.6-5.2-24.2-4.3m69 4.3c-3.8 3.2-6.4 10.8-6.7 19.9-.3 11.3 2.5 22.5 7.2 27a41.7 41.7 0 0 0 30 12.2c8.9 0 17-2.9 21.3-7.2 6-6.1 8.2-34.9-2.2-46.3-4.8-5-14.2-8.8-25.4-9.9-10.6-1-20 .7-24.2 4.3M128 56c-2.6 0-5.6.2-9 .5.4 1.7.5 3.7.7 5.7 0 1.5 0 3-.2 4.5 3.2-.3 6-.3 8.5-.3 2.6 0 5.3 0 8.5.3-.2-1.6-.2-3-.2-4.5.2-2 .3-4 .7-5.7-3.4-.3-6.4-.5-9-.5"
    }));

const GitHubDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        fillRule: "evenodd",
        d: "M512 0C229.12 0 0 229.12 0 512c0 226.56 146.56 417.92 350.08 485.76 25.6 4.48 35.2-10.88 35.2-24.32 0-12.16-.64-52.48-.64-95.36-128.64 23.68-161.92-31.36-172.16-60.16-5.76-14.72-30.72-60.16-52.48-72.32-17.92-9.6-43.52-33.28-.64-33.92 40.32-.64 69.12 37.12 78.72 52.48 46.08 77.44 119.68 55.68 149.12 42.24 4.48-33.28 17.92-55.68 32.64-68.48-113.92-12.8-232.96-56.96-232.96-252.8 0-55.68 19.84-101.76 52.48-137.6-5.12-12.8-23.04-65.28 5.12-135.68 0 0 42.88-13.44 140.8 52.48 40.96-11.52 84.48-17.28 128-17.28s87.04 5.76 128 17.28c97.92-66.56 140.8-52.48 140.8-52.48 28.16 70.4 10.24 122.88 5.12 135.68 32.64 35.84 52.48 81.28 52.48 137.6 0 196.48-119.68 240-233.6 252.8 18.56 16 34.56 46.72 34.56 94.72 0 68.48-.64 123.52-.64 140.8 0 13.44 9.6 29.44 35.2 24.32C877.44 929.92 1024 737.92 1024 512 1024 229.12 794.88 0 512 0",
        clipRule: "evenodd"
    }));

const GitHubLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1B1F23",
        fillRule: "evenodd",
        d: "M512 0C229.12 0 0 229.12 0 512c0 226.56 146.56 417.92 350.08 485.76 25.6 4.48 35.2-10.88 35.2-24.32 0-12.16-.64-52.48-.64-95.36-128.64 23.68-161.92-31.36-172.16-60.16-5.76-14.72-30.72-60.16-52.48-72.32-17.92-9.6-43.52-33.28-.64-33.92 40.32-.64 69.12 37.12 78.72 52.48 46.08 77.44 119.68 55.68 149.12 42.24 4.48-33.28 17.92-55.68 32.64-68.48-113.92-12.8-232.96-56.96-232.96-252.8 0-55.68 19.84-101.76 52.48-137.6-5.12-12.8-23.04-65.28 5.12-135.68 0 0 42.88-13.44 140.8 52.48 40.96-11.52 84.48-17.28 128-17.28s87.04 5.76 128 17.28c97.92-66.56 140.8-52.48 140.8-52.48 28.16 70.4 10.24 122.88 5.12 135.68 32.64 35.84 52.48 81.28 52.48 137.6 0 196.48-119.68 240-233.6 252.8 18.56 16 34.56 46.72 34.56 94.72 0 68.48-.64 123.52-.64 140.8 0 13.44 9.6 29.44 35.2 24.32C877.44 929.92 1024 737.92 1024 512 1024 229.12 794.88 0 512 0",
        clipRule: "evenodd"
    }));

const GitLab = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        "aria-labelledby": "tanukiHomeDesktop",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E24329",
        d: "m31.46 12.78-.04-.12-4.35-11.35A1.14 1.14 0 0 0 25.94.6c-.24 0-.47.1-.66.24-.19.15-.33.36-.39.6l-2.94 9h-11.9l-2.94-9A1.14 1.14 0 0 0 6.07.58a1.15 1.15 0 0 0-1.14.72L.58 12.68l-.05.11a8.1 8.1 0 0 0 2.68 9.34l.02.01.04.03 6.63 4.97 3.28 2.48 2 1.52a1.35 1.35 0 0 0 1.62 0l2-1.52 3.28-2.48 6.67-5h.02a8.09 8.09 0 0 0 2.7-9.36Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC6D26",
        d: "m31.46 12.78-.04-.12a14.75 14.75 0 0 0-5.86 2.64l-9.55 7.24 6.09 4.6 6.67-5h.02a8.09 8.09 0 0 0 2.67-9.36"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FCA326",
        d: "m9.9 27.14 3.28 2.48 2 1.52a1.35 1.35 0 0 0 1.62 0l2-1.52 3.28-2.48-6.1-4.6-6.07 4.6Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC6D26",
        d: "M6.44 15.3a14.7 14.7 0 0 0-5.86-2.63l-.05.12a8.1 8.1 0 0 0 2.68 9.34l.02.01.04.03 6.63 4.97 6.1-4.6z"
    }));

const Gleam = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2000 1915",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ffaff3",
        d: "M905.5 95.13c41.483-73.507 147.51-73.507 189 0l217.42 385.27c26.9 47.672 73.23 81.278 126.9 92.095l434.05 87.471c82.87 16.699 115.52 117.34 58.4 179.4l-299.67 325.58a188.15 188.15 0 0 0-48.49 149.06l50.83 439.33c9.69 83.71-75.98 146.04-152.89 110.88l-402.64-184.05a188.55 188.55 0 0 0-156.82 0l-402.63 184.05c-76.916 35.15-162.58-27.17-152.9-110.88l50.837-439.33c6.292-54.37-11.413-108.78-48.488-149.06l-299.68-325.58c-57.118-62.055-24.463-162.7 58.403-179.4l434.05-87.471c53.674-10.817 100-44.423 126.9-92.095z"
    }), /*#__PURE__*/ React.createElement("g", {
        fill: "#151515"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1000 1.287c-50.71 0-101.42 24.727-129.33 74.184l-217.42 385.27c-21.197 37.562-57.654 64.015-99.969 72.543l-434.05 87.47c-111.38 22.446-156.79 162.2-79.932 245.7l299.68 325.58a148.08 148.08 0 0 1 38.183 117.37l-50.836 439.33c-13.042 112.71 105.87 199.11 209.26 151.86l.002-.002 402.64-184.05.002-.002a148.48 148.48 0 0 1 123.55 0l.002.002 402.64 184.05c103.38 47.263 222.3-39.144 209.25-151.86l.002.002-50.83-439.33v-.002a148.07 148.07 0 0 1 38.181-117.37l.002-.004 299.67-325.59v-.002c76.858-83.5 31.455-223.25-79.93-245.7l-434.05-87.47c-42.311-8.527-78.773-34.981-99.967-72.54l-217.42-385.28c-27.914-49.455-78.626-74.182-129.34-74.182m.002 77.426c23.044 0 46.09 12.026 59.666 36.078l217.42 385.27c32.606 57.784 88.805 98.544 153.83 111.65l434.05 87.47c54.356 10.954 74.253 72.488 36.872 113.1l-299.67 325.59c-44.938 48.81-66.415 114.84-58.793 180.74l50.83 439.33v.001c6.333 54.706-46.086 92.96-96.523 69.903h-.002l-402.64-184.05c-60.336-27.588-129.75-27.588-190.09.002l-402.63 184.05c-50.446 23.052-102.86-15.196-96.535-69.902l50.838-439.33c7.627-65.91-13.86-131.93-58.793-180.75l-299.68-325.58c-37.378-40.609-17.476-102.14 36.874-113.1l434.05-87.473c65.032-13.106 121.23-53.865 153.84-111.65v-.002l217.42-385.27c13.573-24.05 36.616-36.076 59.66-36.076"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 678.57,
        cy: 1007.1,
        r: 78.571
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 1321.4,
        cy: 1007.1,
        r: 78.571
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M929.244 1112.08a40 40 0 0 0-31.543 46.96 104.3 104.3 0 0 0 15.485 37.634l.001.002.002.004a104.2 104.2 0 0 0 28.715 28.834l.008.006a104.3 104.3 0 0 0 37.533 15.652l.014.004.016.002a104.4 104.4 0 0 0 40.666.082h.004a104.3 104.3 0 0 0 37.625-15.477l.005-.004.008-.004a104.3 104.3 0 0 0 28.819-28.699 104.1 104.1 0 0 0 15.664-37.588 40 40 0 0 0-31.35-47.086 40 40 0 0 0-47.086 31.352 24.1 24.1 0 0 1-3.627 8.7l-.012.015-.01.017a24.2 24.2 0 0 1-6.7 6.676 24.2 24.2 0 0 1-8.75 3.596l-.01.002-.01.002c-3.13.615-6.348.61-9.475-.016a24.3 24.3 0 0 1-8.734-3.646l-.014-.01-.011-.008a24.2 24.2 0 0 1-6.666-6.693l-.002-.004-.002-.002a24.3 24.3 0 0 1-3.604-8.76 40 40 0 0 0-46.959-31.543"
    })));

const Gmail = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 49.4 512 399.42",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#4285f4",
        d: "M34.91 448.818h81.454V251L0 163.727V413.91c0 19.287 15.622 34.91 34.91 34.91z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#34a853",
        d: "M395.636 448.818h81.455c19.287 0 34.909-15.622 34.909-34.909V163.727L395.636 251z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fbbc04",
        d: "M395.636 99.727V251L512 163.727v-46.545c0-43.142-49.25-67.782-83.782-41.891z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#ea4335",
        d: "M116.364 251V99.727L256 204.455 395.636 99.727V251L256 355.727z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#c5221f",
        fillRule: "nonzero",
        d: "M0 117.182v46.545L116.364 251V99.727L83.782 75.291C49.25 49.4 0 74.04 0 117.18z"
    })));

const GoDaddyDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "prefix__logo-mark",
        viewBox: "0 0 166 34",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M30.82 1.45c-3.7-2.31-8.6-1.77-12.96.98-4.35-2.75-9.24-3.3-12.95-.98-5.87 3.67-6.58 13.11-1.59 21.1 3.68 5.88 9.43 9.33 14.55 9.27 5.12.06 10.87-3.39 14.54-9.27 4.99-7.99 4.28-17.43-1.59-21.1M6.02 20.86a19.1 19.1 0 0 1-2.3-5.27 15 15 0 0 1-.5-4.97c.22-2.95 1.42-5.24 3.38-6.47 1.96-1.22 4.54-1.3 7.3-.2.42.17.83.36 1.22.57a22.5 22.5 0 0 0-3.95 4.75C8.14 14.12 7.2 19.5 8.27 23.8a19.7 19.7 0 0 1-2.25-2.95zm26-5.27a19.2 19.2 0 0 1-2.3 5.27 19.7 19.7 0 0 1-2.25 2.96c.94-3.86.3-8.58-2.02-13a.58.58 0 0 0-.83-.24l-7.23 4.52a.59.59 0 0 0-.19.81l1.06 1.7a.59.59 0 0 0 .82.18l4.68-2.92a15.1 15.1 0 0 1 .92 6.33c-.23 2.95-1.43 5.25-3.38 6.47a6.6 6.6 0 0 1-3.35.97h-.15a6.6 6.6 0 0 1-3.35-.97c-1.96-1.22-3.16-3.52-3.38-6.47a15.1 15.1 0 0 1 .5-4.97 19.67 19.67 0 0 1 6.02-9.65 15.1 15.1 0 0 1 4.25-2.63c2.74-1.09 5.34-1.02 7.3.2 1.95 1.23 3.15 3.53 3.37 6.48a15.1 15.1 0 0 1-.49 4.96",
        className: "prefix__path-mobile"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M74.06 12.9a7.23 7.23 0 0 0-7.34 7.2c0 4 3.28 7.11 7.34 7.11a7.19 7.19 0 0 0 7.37-7.12c0-4.03-3.27-7.2-7.37-7.2zm0 10.55c-1.87 0-3.29-1.51-3.29-3.39s1.42-3.4 3.3-3.4c1.9 0 3.32 1.54 3.32 3.41a3.31 3.31 0 0 1-3.33 3.38M90.58 7.36h-7.46a.6.6 0 0 0-.62.61v18.21a.6.6 0 0 0 .61.65h7.47c5.98 0 10.13-3.97 10.13-9.76 0-5.82-4.15-9.7-10.13-9.7zm.18 15.62h-4.09V11.2h4.09c3.3 0 5.59 2.47 5.59 5.86 0 3.34-2.28 5.92-5.59 5.92m24.82-9.7h-2.8a.63.63 0 0 0-.6.62v.83c-.63-1.06-2.08-1.84-3.87-1.84-3.5 0-6.79 2.76-6.79 7.15 0 4.37 3.25 7.17 6.76 7.17 1.8 0 3.28-.78 3.92-1.83v.86a.59.59 0 0 0 .58.58h2.8a.57.57 0 0 0 .6-.58V13.9a.6.6 0 0 0-.6-.62m-6.53 10.2c-1.86 0-3.26-1.43-3.26-3.41s1.4-3.41 3.26-3.41 3.25 1.42 3.25 3.4c0 1.99-1.4 3.42-3.25 3.42m22.3-16.12h-2.82a.6.6 0 0 0-.6.59v6.72c-.65-1-2.12-1.78-3.95-1.78-3.48 0-6.7 2.76-6.7 7.15 0 4.37 3.25 7.17 6.75 7.17 1.8 0 3.17-.78 3.92-1.83v.86c0 .32.26.58.58.58h2.81a.57.57 0 0 0 .59-.58V7.95a.57.57 0 0 0-.59-.59zm-6.54 16.15c-1.85 0-3.24-1.44-3.24-3.44s1.4-3.45 3.24-3.45c1.85 0 3.24 1.44 3.24 3.45 0 2-1.39 3.44-3.24 3.44M147.1 7.36h-2.8a.6.6 0 0 0-.62.59v6.72c-.64-1-2.11-1.78-3.94-1.78-3.48 0-6.7 2.76-6.7 7.15 0 4.37 3.25 7.17 6.75 7.17 1.8 0 3.17-.78 3.92-1.83v.86a.59.59 0 0 0 .59.58h2.8a.57.57 0 0 0 .58-.58V7.95a.57.57 0 0 0-.58-.59m-6.53 16.15c-1.86 0-3.24-1.44-3.24-3.44s1.39-3.45 3.24-3.45c1.84 0 3.23 1.44 3.23 3.45 0 2-1.38 3.44-3.23 3.44m21.9-9.28-4.19 14.37c-.8 2.56-2.61 4.09-5.42 4.09a6.77 6.77 0 0 1-3.35-.78c-.53-.3-.97-.58-.97-1.03 0-.27.09-.41.25-.67l.83-1.25c.24-.35.41-.46.66-.46a.96.96 0 0 1 .56.2 3 3 0 0 0 1.75.62c.86 0 1.52-.27 1.88-1.3l.36-1.2h-1.7c-.42 0-.65-.25-.75-.58l-3.75-12c-.14-.48-.01-.95.68-.95h2.96c.36 0 .6.12.77.64l2.77 9.67 2.59-9.67c.08-.34.3-.64.75-.64h2.8c.55 0 .72.38.52.94m-96.8 4.28v7.67a.63.63 0 0 1-.64.64h-2.31a.62.62 0 0 1-.64-.64v-2.01c-1.47 1.85-4.03 3.02-6.92 3.02-5.44 0-9.68-4.08-9.68-9.9 0-6.05 4.58-10.22 10.37-10.22 4.28 0 7.7 1.84 9.22 5.54a.8.8 0 0 1 .07.3c0 .18-.12.31-.5.44l-2.7 1.04a.7.7 0 0 1-.5.01.78.78 0 0 1-.33-.37 5.67 5.67 0 0 0-5.36-3.1c-3.45 0-5.92 2.7-5.92 6.19 0 3.39 2.1 6.17 6.02 6.17 2.06 0 3.7-.97 4.47-2.04h-2.45a.63.63 0 0 1-.63-.63v-2.09a.63.63 0 0 1 .63-.63h7.16a.6.6 0 0 1 .64.6z",
        className: "prefix__path-desktop"
    }));

const GoDaddyLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "prefix__logo-mark",
        viewBox: "0 0 166 34",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M30.82 1.45c-3.7-2.31-8.6-1.77-12.96.98-4.35-2.75-9.24-3.3-12.95-.98-5.87 3.67-6.58 13.11-1.59 21.1 3.68 5.88 9.43 9.33 14.55 9.27 5.12.06 10.87-3.39 14.54-9.27 4.99-7.99 4.28-17.43-1.59-21.1M6.02 20.86a19.1 19.1 0 0 1-2.3-5.27 15 15 0 0 1-.5-4.97c.22-2.95 1.42-5.24 3.38-6.47 1.96-1.22 4.54-1.3 7.3-.2.42.17.83.36 1.22.57a22.5 22.5 0 0 0-3.95 4.75C8.14 14.12 7.2 19.5 8.27 23.8a19.7 19.7 0 0 1-2.25-2.95zm26-5.27a19.2 19.2 0 0 1-2.3 5.27 19.7 19.7 0 0 1-2.25 2.96c.94-3.86.3-8.58-2.02-13a.58.58 0 0 0-.83-.24l-7.23 4.52a.59.59 0 0 0-.19.81l1.06 1.7a.59.59 0 0 0 .82.18l4.68-2.92a15.1 15.1 0 0 1 .92 6.33c-.23 2.95-1.43 5.25-3.38 6.47a6.6 6.6 0 0 1-3.35.97h-.15a6.6 6.6 0 0 1-3.35-.97c-1.96-1.22-3.16-3.52-3.38-6.47a15.1 15.1 0 0 1 .5-4.97 19.67 19.67 0 0 1 6.02-9.65 15.1 15.1 0 0 1 4.25-2.63c2.74-1.09 5.34-1.02 7.3.2 1.95 1.23 3.15 3.53 3.37 6.48a15.1 15.1 0 0 1-.49 4.96",
        className: "prefix__path-mobile"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M74.06 12.9a7.23 7.23 0 0 0-7.34 7.2c0 4 3.28 7.11 7.34 7.11a7.19 7.19 0 0 0 7.37-7.12c0-4.03-3.27-7.2-7.37-7.2zm0 10.55c-1.87 0-3.29-1.51-3.29-3.39s1.42-3.4 3.3-3.4c1.9 0 3.32 1.54 3.32 3.41a3.31 3.31 0 0 1-3.33 3.38M90.58 7.36h-7.46a.6.6 0 0 0-.62.61v18.21a.6.6 0 0 0 .61.65h7.47c5.98 0 10.13-3.97 10.13-9.76 0-5.82-4.15-9.7-10.13-9.7zm.18 15.62h-4.09V11.2h4.09c3.3 0 5.59 2.47 5.59 5.86 0 3.34-2.28 5.92-5.59 5.92m24.82-9.7h-2.8a.63.63 0 0 0-.6.62v.83c-.63-1.06-2.08-1.84-3.87-1.84-3.5 0-6.79 2.76-6.79 7.15 0 4.37 3.25 7.17 6.76 7.17 1.8 0 3.28-.78 3.92-1.83v.86a.59.59 0 0 0 .58.58h2.8a.57.57 0 0 0 .6-.58V13.9a.6.6 0 0 0-.6-.62m-6.53 10.2c-1.86 0-3.26-1.43-3.26-3.41s1.4-3.41 3.26-3.41 3.25 1.42 3.25 3.4c0 1.99-1.4 3.42-3.25 3.42m22.3-16.12h-2.82a.6.6 0 0 0-.6.59v6.72c-.65-1-2.12-1.78-3.95-1.78-3.48 0-6.7 2.76-6.7 7.15 0 4.37 3.25 7.17 6.75 7.17 1.8 0 3.17-.78 3.92-1.83v.86c0 .32.26.58.58.58h2.81a.57.57 0 0 0 .59-.58V7.95a.57.57 0 0 0-.59-.59zm-6.54 16.15c-1.85 0-3.24-1.44-3.24-3.44s1.4-3.45 3.24-3.45c1.85 0 3.24 1.44 3.24 3.45 0 2-1.39 3.44-3.24 3.44M147.1 7.36h-2.8a.6.6 0 0 0-.62.59v6.72c-.64-1-2.11-1.78-3.94-1.78-3.48 0-6.7 2.76-6.7 7.15 0 4.37 3.25 7.17 6.75 7.17 1.8 0 3.17-.78 3.92-1.83v.86a.59.59 0 0 0 .59.58h2.8a.57.57 0 0 0 .58-.58V7.95a.57.57 0 0 0-.58-.59m-6.53 16.15c-1.86 0-3.24-1.44-3.24-3.44s1.39-3.45 3.24-3.45c1.84 0 3.23 1.44 3.23 3.45 0 2-1.38 3.44-3.23 3.44m21.9-9.28-4.19 14.37c-.8 2.56-2.61 4.09-5.42 4.09a6.77 6.77 0 0 1-3.35-.78c-.53-.3-.97-.58-.97-1.03 0-.27.09-.41.25-.67l.83-1.25c.24-.35.41-.46.66-.46a.96.96 0 0 1 .56.2 3 3 0 0 0 1.75.62c.86 0 1.52-.27 1.88-1.3l.36-1.2h-1.7c-.42 0-.65-.25-.75-.58l-3.75-12c-.14-.48-.01-.95.68-.95h2.96c.36 0 .6.12.77.64l2.77 9.67 2.59-9.67c.08-.34.3-.64.75-.64h2.8c.55 0 .72.38.52.94m-96.8 4.28v7.67a.63.63 0 0 1-.64.64h-2.31a.62.62 0 0 1-.64-.64v-2.01c-1.47 1.85-4.03 3.02-6.92 3.02-5.44 0-9.68-4.08-9.68-9.9 0-6.05 4.58-10.22 10.37-10.22 4.28 0 7.7 1.84 9.22 5.54a.8.8 0 0 1 .07.3c0 .18-.12.31-.5.44l-2.7 1.04a.7.7 0 0 1-.5.01.78.78 0 0 1-.33-.37 5.67 5.67 0 0 0-5.36-3.1c-3.45 0-5.92 2.7-5.92 6.19 0 3.39 2.1 6.17 6.02 6.17 2.06 0 3.7-.97 4.47-2.04h-2.45a.63.63 0 0 1-.63-.63v-2.09a.63.63 0 0 1 .63-.63h7.16a.6.6 0 0 1 .64.6z",
        className: "prefix__path-desktop"
    }));

const GoDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 207 78",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#fff",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.2 24.1c-.4 0-.5-.2-.3-.5l2.1-2.7c.2-.3.7-.5 1.1-.5h35.7c.4 0 .5.3.3.6l-1.7 2.6c-.2.3-.7.6-1 .6zM1.1 33.3c-.4 0-.5-.2-.3-.5l2.1-2.7c.2-.3.7-.5 1.1-.5h45.6c.4 0 .6.3.5.6l-.8 2.4c-.1.4-.5.6-.9.6zM25.3 42.5c-.4 0-.5-.3-.3-.6l1.4-2.5c.2-.3.6-.6 1-.6h20c.4 0 .6.3.6.7l-.2 2.4c0 .4-.4.7-.7.7zM129.1 22.3c-6.3 1.6-10.6 2.8-16.8 4.4-1.5.4-1.6.5-2.9-1-1.5-1.7-2.6-2.8-4.7-3.8-6.3-3.1-12.4-2.2-18.1 1.5-6.8 4.4-10.3 10.9-10.2 19 .1 8 5.6 14.6 13.5 15.7 6.8.9 12.5-1.5 17-6.6.9-1.1 1.7-2.3 2.7-3.7H90.3c-2.1 0-2.6-1.3-1.9-3 1.3-3.1 3.7-8.3 5.1-10.9.3-.6 1-1.6 2.5-1.6h36.4c-.2 2.7-.2 5.4-.6 8.1-1.1 7.2-3.8 13.8-8.2 19.6-7.2 9.5-16.6 15.4-28.5 17-9.8 1.3-18.9-.6-26.9-6.6-7.4-5.6-11.6-13-12.7-22.2-1.3-10.9 1.9-20.7 8.5-29.3C71.1 9.6 80.5 3.7 92 1.6c9.4-1.7 18.4-.6 26.5 4.9 5.3 3.5 9.1 8.3 11.6 14.1.6.9.2 1.4-1 1.7"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "nonzero",
        d: "M162.2 77.6c-9.1-.2-17.4-2.8-24.4-8.8-5.9-5.1-9.6-11.6-10.8-19.3-1.8-11.3 1.3-21.3 8.1-30.2 7.3-9.6 16.1-14.6 28-16.7 10.2-1.8 19.8-.8 28.5 5.1 7.9 5.4 12.8 12.7 14.1 22.3 1.7 13.5-2.2 24.5-11.5 33.9-6.6 6.7-14.7 10.9-24 12.8-2.7.5-5.4.6-8 .9M186 37.2c-.1-1.3-.1-2.3-.3-3.3-1.8-9.9-10.9-15.5-20.4-13.3-9.3 2.1-15.3 8-17.5 17.4-1.8 7.8 2 15.7 9.2 18.9 5.5 2.4 11 2.1 16.3-.6 7.9-4.1 12.2-10.5 12.7-19.1"
    })));

const GoLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 207 78",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.2 24.1c-.4 0-.5-.2-.3-.5l2.1-2.7c.2-.3.7-.5 1.1-.5h35.7c.4 0 .5.3.3.6l-1.7 2.6c-.2.3-.7.6-1 .6zM1.1 33.3c-.4 0-.5-.2-.3-.5l2.1-2.7c.2-.3.7-.5 1.1-.5h45.6c.4 0 .6.3.5.6l-.8 2.4c-.1.4-.5.6-.9.6zM25.3 42.5c-.4 0-.5-.3-.3-.6l1.4-2.5c.2-.3.6-.6 1-.6h20c.4 0 .6.3.6.7l-.2 2.4c0 .4-.4.7-.7.7zM129.1 22.3c-6.3 1.6-10.6 2.8-16.8 4.4-1.5.4-1.6.5-2.9-1-1.5-1.7-2.6-2.8-4.7-3.8-6.3-3.1-12.4-2.2-18.1 1.5-6.8 4.4-10.3 10.9-10.2 19 .1 8 5.6 14.6 13.5 15.7 6.8.9 12.5-1.5 17-6.6.9-1.1 1.7-2.3 2.7-3.7H90.3c-2.1 0-2.6-1.3-1.9-3 1.3-3.1 3.7-8.3 5.1-10.9.3-.6 1-1.6 2.5-1.6h36.4c-.2 2.7-.2 5.4-.6 8.1-1.1 7.2-3.8 13.8-8.2 19.6-7.2 9.5-16.6 15.4-28.5 17-9.8 1.3-18.9-.6-26.9-6.6-7.4-5.6-11.6-13-12.7-22.2-1.3-10.9 1.9-20.7 8.5-29.3C71.1 9.6 80.5 3.7 92 1.6c9.4-1.7 18.4-.6 26.5 4.9 5.3 3.5 9.1 8.3 11.6 14.1.6.9.2 1.4-1 1.7"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "nonzero",
        d: "M162.2 77.6c-9.1-.2-17.4-2.8-24.4-8.8-5.9-5.1-9.6-11.6-10.8-19.3-1.8-11.3 1.3-21.3 8.1-30.2 7.3-9.6 16.1-14.6 28-16.7 10.2-1.8 19.8-.8 28.5 5.1 7.9 5.4 12.8 12.7 14.1 22.3 1.7 13.5-2.2 24.5-11.5 33.9-6.6 6.7-14.7 10.9-24 12.8-2.7.5-5.4.6-8 .9M186 37.2c-.1-1.3-.1-2.3-.3-3.3-1.8-9.9-10.9-15.5-20.4-13.3-9.3 2.1-15.3 8-17.5 17.4-1.8 7.8 2 15.7 9.2 18.9 5.5 2.4 11 2.1 16.3-.6 7.9-4.1 12.2-10.5 12.7-19.1"
    })));

const GodotEngine = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M229.81 168.288s-.338-2.075-.536-2.056l-37.653 3.633a6.12 6.12 0 0 0-5.533 5.681l-1.034 14.826-29.13 2.078-1.982-13.437c-.441-2.989-3.051-5.242-6.072-5.242h-39.74c-3.02 0-5.63 2.253-6.071 5.242l-1.983 13.437-29.13-2.078-1.034-14.826a6.12 6.12 0 0 0-5.533-5.682l-37.672-3.632c-.195-.019-.337 2.058-.532 2.058l-.05 8.148 31.904 5.145 1.044 14.959c.212 3.028 2.655 5.477 5.685 5.694l40.119 2.862q.227.016.451.017c3.015 0 5.621-2.254 6.062-5.243l2.039-13.826h29.143l2.039 13.826c.44 2.988 3.049 5.242 6.068 5.242q.223 0 .44-.016l40.124-2.862c3.029-.217 5.473-2.666 5.685-5.694l1.043-14.959 31.891-5.167z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#478CBF",
        d: "M26.175 106.847v61.441q.168 0 .336.016l37.667 3.631a4.06 4.06 0 0 1 3.657 3.756l1.162 16.628 32.857 2.344 2.264-15.346c.293-1.99 2-3.465 4.012-3.465h39.741a4.055 4.055 0 0 1 4.011 3.465l2.264 15.346 32.858-2.344 1.161-16.628a4.06 4.06 0 0 1 3.657-3.756l37.653-3.631a4 4 0 0 1 .335-.016v-4.903l.015-.005v-56.533c5.304-6.678 10.327-14.043 14.175-20.24-5.881-10.01-13.086-18.957-20.788-27.246-7.143 3.595-14.081 7.668-20.634 12.003-3.279-3.26-6.973-5.926-10.6-8.713-3.564-2.863-7.581-4.962-11.391-7.407 1.134-8.447 1.695-16.763 1.921-25.442-9.83-4.947-20.313-8.227-30.916-10.583-4.233 7.115-8.104 14.82-11.476 22.352-3.998-.668-8.015-.916-12.037-.964v-.006c-.029 0-.055.006-.078.006-.025 0-.051-.006-.076-.006v.006c-4.03.048-8.044.296-12.043.964-3.37-7.532-7.239-15.237-11.478-22.352-10.598 2.356-21.082 5.636-30.91 10.583.224 8.68.785 16.995 1.922 25.442-3.817 2.446-7.828 4.544-11.394 7.407-3.622 2.787-7.322 5.453-10.602 8.713-6.553-4.335-13.489-8.408-20.634-12.003C25.084 67.65 17.883 76.596 12 86.607c4.623 7.257 9.582 14.551 14.175 20.24"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#478CBF",
        d: "m196.018 179.681-1.167 16.716a4.06 4.06 0 0 1-3.758 3.763l-40.122 2.863a4.057 4.057 0 0 1-4.301-3.455l-2.301-15.604h-32.738l-2.301 15.604a4.053 4.053 0 0 1-4.301 3.455l-40.122-2.863a4.06 4.06 0 0 1-3.758-3.763l-1.166-16.716-33.87-3.266c.015 3.64.062 7.628.062 8.422 0 35.772 45.378 52.965 101.756 53.163h.138c56.379-.198 101.741-17.391 101.741-53.163 0-.808.049-4.78.065-8.422z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M97.304 131.788c0 12.542-10.162 22.702-22.7 22.702-12.532 0-22.697-10.16-22.697-22.702 0-12.534 10.165-22.688 22.697-22.688 12.538 0 22.7 10.154 22.7 22.688"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#414042",
        d: "M91.842 133.134c0 8.319-6.743 15.062-15.068 15.062-8.32 0-15.068-6.743-15.068-15.062s6.747-15.067 15.068-15.067c8.325 0 15.068 6.748 15.068 15.067"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M127.998 156.555c-4.035 0-7.306-2.974-7.306-6.64v-20.898c0-3.663 3.271-6.64 7.306-6.64s7.314 2.977 7.314 6.64v20.898c0 3.666-3.278 6.64-7.314 6.64m30.699-24.767c0 12.542 10.162 22.702 22.702 22.702 12.53 0 22.694-10.16 22.694-22.702 0-12.534-10.164-22.688-22.694-22.688-12.54 0-22.702 10.154-22.702 22.688"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#414042",
        d: "M164.16 133.134c0 8.319 6.74 15.062 15.059 15.062 8.328 0 15.068-6.743 15.068-15.062s-6.74-15.067-15.068-15.067c-8.319 0-15.059 6.748-15.059 15.067"
    }));

const Google = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 262",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#4285F4",
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#34A853",
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FBBC05",
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EB4335",
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
    }));

const GoogleColaboratory = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            pointerEvents: "none",
            display: "block",
            width: "100%",
            height: "100%"
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E8710A",
        d: "M4.54 9.46 2.19 7.1a6.93 6.93 0 0 0 0 9.79l2.36-2.36a3.59 3.59 0 0 1-.01-5.07"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F9AB00",
        d: "m2.19 7.1 2.35 2.36a3.59 3.59 0 0 1 5.08 0l1.71-2.93-.1-.08a6.93 6.93 0 0 0-9.04.65m9.15 10.36-1.72-2.92a3.59 3.59 0 0 1-5.08 0L2.19 16.9a6.93 6.93 0 0 0 9 .65l.11-.09M12 7.1a6.93 6.93 0 0 0 0 9.79l2.36-2.36a3.59 3.59 0 1 1 5.08-5.08l2.37-2.35a6.93 6.93 0 0 0-9.81 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E8710A",
        d: "m21.81 7.1-2.35 2.36a3.59 3.59 0 0 1-5.08 5.08L12 16.9a6.93 6.93 0 0 0 9.81-9.8"
    }));

const GoogleDrive = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 87.3 78",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0066da",
        d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L27.5 53H0c0 1.55.4 3.1 1.2 4.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00ac47",
        d: "M43.65 25 29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44A9.06 9.06 0 0 0 0 53h27.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ea4335",
        d: "M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57.5c.8-1.4 1.2-2.95 1.2-4.5H59.798l5.852 11.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00832d",
        d: "M43.65 25 57.4 1.2C56.05.4 54.5 0 52.9 0H34.4c-1.6 0-3.15.45-4.5 1.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2684fc",
        d: "M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ffba00",
        d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25 59.8 53h27.45c0-1.55-.4-3.1-1.2-4.5z"
    }));

const GoogleIdx = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        className: "prefix__w-8",
        viewBox: "0 0 192 192",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 88,
        height: 24,
        x: 28,
        y: 156,
        fill: "#8964e8",
        rx: 12
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 36,
        height: 24,
        x: 104,
        y: 120,
        fill: "#17b877",
        rx: 12
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 36,
        height: 24,
        x: 56,
        y: 120,
        fill: "#17b877",
        rx: 12
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 52,
        height: 24,
        x: 84,
        y: 84,
        fill: "#ffa23e",
        rx: 12
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 24,
        height: 24,
        x: 148,
        y: 84,
        fill: "#ffa23e",
        rx: 12
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 88,
        height: 24,
        x: 56,
        y: 48,
        fill: "#25a6e9",
        rx: 12
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 52,
        height: 24,
        x: 64,
        y: 12,
        fill: "#8964e8",
        rx: 12
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 24,
        height: 24,
        x: 28,
        y: 12,
        fill: "#8964e8",
        rx: 12
    }));

const GooglePaLM = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 229",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F9AB00",
        d: "M128 228.542c9.895 0 17.91-8.015 17.91-17.91V55.413h-35.82v155.219c0 9.895 8.015 17.91 17.91 17.91"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5BB974",
        d: "M199.356 112.053C180.043 92.755 151.193 88.845 128 100.307l76.669 76.67c3.164 3.163 8.612 1.91 9.955-2.344 6.746-21.357 1.657-45.64-15.268-62.58"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#129EAF",
        d: "M56.644 112.053C75.957 92.755 104.807 88.845 128 100.307l-76.669 76.67c-3.164 3.163-8.612 1.91-9.955-2.344-6.746-21.357-1.657-45.64 15.268-62.58"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AF5CF7",
        d: "M193.67 52.548c-30.507 0-56.402 20-65.67 47.76h121.25c4.97 0 8.283-5.254 6.03-9.687-11.523-22.611-34.776-38.073-61.61-38.073"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF8BCB",
        d: "M140.671 20.101C119.09 41.682 114.926 74.114 128 100.307l85.743-85.743c3.523-3.522 2.15-9.582-2.582-11.119-24.148-7.836-51.52-2.313-70.49 16.656"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FA7B17",
        d: "M115.329 20.101C136.91 41.682 141.074 74.114 128 100.307L42.257 14.564c-3.523-3.522-2.15-9.582 2.582-11.119 24.148-7.836 51.52-2.313 70.49 16.656"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4285F4",
        d: "M62.33 52.548c30.507 0 56.402 20 65.67 47.76H6.75c-4.97 0-8.283-5.254-6.03-9.687C12.244 68.01 35.497 52.548 62.33 52.548"
    }));

const Gradio = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 224",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "-6.452%",
        x2: "85.236%",
        y1: "49.784%",
        y2: "49.784%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#F9D100"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#F97700"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "106.079%",
        x2: "14.268%",
        y1: "49.784%",
        y2: "49.784%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#F9D100"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#F97700"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "-12.871%",
        x2: "169.796%",
        y1: "75.863%",
        y2: "74.878%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#F9D100"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#F97700"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M119.871 64.78a16.35 16.35 0 0 1 16.258 0l111.654 64c10.956 6.28 10.956 22.083 0 28.363l-111.654 64a16.35 16.35 0 0 1-16.258 0l-111.654-64c-10.956-6.28-10.956-22.083 0-28.364l111.654-64Zm8.126 33.014-78.783 45.164 78.783 45.155 78.784-45.155z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M119.871 2.165a16.35 16.35 0 0 1 16.258 0l111.654 64c10.956 6.28 10.956 22.083 0 28.363l-111.654 64a16.35 16.35 0 0 1-16.258 0l-111.654-64c-10.956-6.28-10.956-22.083 0-28.363zm8.126 33.015L49.214 80.343l78.783 45.156 78.784-45.156z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m120.19 64.755 16.174 28.412-111.93 63.723-16.175-28.412z"
    }));

const Grafana = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 279",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "49.995%",
        x2: "49.995%",
        y1: "122.45%",
        y2: "31.139%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF100"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#F05A28"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M255.59 122.775c-.46-4.675-1.226-10.04-2.759-16.017a98 98 0 0 0-7.204-19.16 106.7 106.7 0 0 0-13.412-20.54c-2.222-2.681-4.675-5.287-7.28-7.816 3.908-15.558-4.752-29.046-4.752-29.046-14.945-.92-24.448 4.675-27.973 7.204-.613-.23-1.15-.537-1.763-.767-2.529-.996-5.135-1.992-7.894-2.835a130 130 0 0 0-8.277-2.3c-2.835-.69-5.67-1.226-8.583-1.686-.537-.076-.996-.153-1.533-.23C157.646 8.738 138.946 0 138.946 0c-20.922 13.258-24.831 31.805-24.831 31.805s-.077.383-.23 1.073c-1.15.307-2.299.69-3.449.996-1.609.46-3.218 1.073-4.751 1.686a123 123 0 0 0-4.752 1.916 117 117 0 0 0-9.35 4.599c-2.989 1.686-5.9 3.525-8.737 5.441l-.766-.307c-28.97-11.036-54.643 2.223-54.643 2.223-2.376 30.809 11.572 50.198 14.331 53.724-.69 1.916-1.303 3.832-1.916 5.748-2.146 6.974-3.755 14.101-4.751 21.535-.154 1.073-.307 2.146-.384 3.219C7.894 146.916 0 173.97 0 173.97c22.302 25.674 48.359 27.283 48.359 27.283l.077-.076c3.295 5.9 7.127 11.495 11.419 16.783a112 112 0 0 0 5.671 6.362c-8.124 23.298 1.15 42.61 1.15 42.61 24.83.92 41.155-10.882 44.603-13.564a85 85 0 0 0 7.511 2.222 109.7 109.7 0 0 0 23.298 3.449c1.916.076 3.909.153 5.825.076h2.759l1.226-.076v.076c11.726 16.708 32.265 19.084 32.265 19.084 14.638-15.405 15.48-30.733 15.48-34.028v-1.38c3.066-2.145 5.979-4.445 8.738-6.974 5.824-5.288 10.959-11.342 15.25-17.857l1.15-1.839c16.554.92 28.28-10.27 28.28-10.27-2.759-17.243-12.569-25.673-14.638-27.283 0 0-.077-.076-.23-.153s-.153-.153-.153-.153c-.077-.077-.23-.154-.383-.23.076-1.073.153-2.07.23-3.142.153-1.84.153-3.756.153-5.595v-2.913l-.077-1.149-.076-1.533c0-.536-.077-.996-.154-1.456-.076-.46-.076-.996-.153-1.456l-.153-1.456-.23-1.456c-.307-1.916-.613-3.756-1.073-5.672-1.763-7.433-4.675-14.484-8.43-20.845a70.4 70.4 0 0 0-14.025-16.707c-5.365-4.752-11.42-8.584-17.704-11.42-6.36-2.835-12.952-4.675-19.543-5.518-3.295-.46-6.59-.613-9.886-.536h-2.453l-1.226.077c-.46 0-.92.076-1.303.076a52 52 0 0 0-4.981.69c-6.591 1.226-12.799 3.602-18.24 6.897s-10.193 7.358-14.025 11.956a54.7 54.7 0 0 0-8.89 15.021 52.9 52.9 0 0 0-3.525 16.094c-.077 1.303-.077 2.683-.077 3.986v.996l.077 1.073c.076.613.076 1.303.153 1.916.23 2.682.766 5.288 1.456 7.74 1.456 4.982 3.755 9.503 6.59 13.335s6.285 6.975 9.887 9.504c3.602 2.452 7.51 4.215 11.343 5.364 3.832 1.15 7.664 1.61 11.266 1.61h1.992c.23 0 .46 0 .689-.077.383 0 .766-.077 1.15-.077.076 0 .23 0 .306-.076l.383-.077c.23 0 .46-.076.69-.076.46-.077.843-.154 1.303-.23s.843-.154 1.226-.307c.843-.153 1.61-.46 2.376-.69 1.533-.536 3.066-1.15 4.368-1.839 1.38-.69 2.606-1.533 3.832-2.3.307-.23.69-.459.997-.766 1.226-.996 1.456-2.835.46-4.061-.844-1.073-2.376-1.38-3.603-.69l-.92.46a25 25 0 0 1-3.295 1.38c-1.15.382-2.375.689-3.602.919-.613.076-1.226.153-1.916.23-.306 0-.613.076-.996.076h-1.84c-.383 0-.766 0-1.149-.076h-.459c-.153 0-.383 0-.536-.077-.383-.077-.69-.077-1.073-.153-2.836-.383-5.671-1.226-8.354-2.453a29.3 29.3 0 0 1-7.74-5.058c-2.376-2.146-4.445-4.675-6.055-7.587s-2.759-6.131-3.295-9.503c-.23-1.686-.383-3.449-.307-5.135 0-.46.077-.92.077-1.38v-.613c0-.23.077-.46.077-.69.076-.919.23-1.839.383-2.758 1.303-7.358 4.981-14.562 10.653-20.003 1.456-1.38 2.988-2.606 4.598-3.755a31.7 31.7 0 0 1 5.211-2.99 36 36 0 0 1 5.672-2.068c1.915-.537 3.908-.844 5.977-1.073.997-.077 1.993-.154 3.066-.154h2.376l.843.077c2.222.153 4.368.46 6.514.996 4.292.92 8.507 2.53 12.415 4.675 7.818 4.369 14.485 11.113 18.547 19.237 2.07 4.061 3.525 8.43 4.215 12.951.153 1.15.307 2.3.383 3.45l.077.842.077.843v3.296c0 .536-.077 1.456-.077 1.992-.077 1.227-.23 2.53-.383 3.756s-.383 2.452-.613 3.678a50 50 0 0 1-.843 3.602 64 64 0 0 1-2.3 7.128 62.4 62.4 0 0 1-7.204 13.105c-5.9 8.124-13.948 14.715-23.144 18.93-4.599 2.069-9.427 3.602-14.408 4.368-2.453.46-4.982.69-7.511.766h-3.832a36 36 0 0 1-4.062-.23c-5.365-.383-10.653-1.379-15.864-2.835-5.135-1.456-10.116-3.525-14.868-5.978-9.427-5.058-17.933-11.956-24.524-20.31a79 79 0 0 1-8.584-13.334 79 79 0 0 1-5.671-14.638c-1.38-5.058-2.223-10.193-2.606-15.405l-.077-.996v-6.821c.077-2.529.307-5.211.614-7.817.306-2.606.766-5.288 1.302-7.894.537-2.605 1.15-5.211 1.916-7.817a103 103 0 0 1 5.442-14.791c4.368-9.35 10.04-17.704 16.86-24.371 1.686-1.686 3.449-3.22 5.288-4.752a78 78 0 0 1 5.748-4.138c1.916-1.303 3.985-2.453 6.055-3.526a40 40 0 0 1 3.142-1.533l3.219-1.379c2.146-.92 4.368-1.686 6.667-2.376.537-.153 1.15-.306 1.686-.536.537-.154 1.15-.307 1.686-.46 1.15-.307 2.3-.613 3.45-.843.536-.153 1.149-.23 1.762-.383.613-.154 1.15-.23 1.763-.384.613-.076 1.15-.23 1.762-.306l.843-.153.92-.154c.613-.076 1.15-.153 1.763-.23.69-.076 1.302-.153 1.992-.23.537-.076 1.456-.153 1.993-.23.383-.076.843-.076 1.226-.153l.843-.076.383-.077h.46c.69-.077 1.303-.077 1.993-.153l.996-.077h.767c.536 0 1.149-.076 1.685-.076a99 99 0 0 1 6.745 0c4.445.153 8.813.69 13.028 1.456 8.507 1.61 16.478 4.291 23.758 7.893 7.28 3.526 13.719 7.894 19.39 12.646.383.306.69.613 1.073.92.306.306.69.613.996.92.69.612 1.303 1.225 1.993 1.838.69.614 1.303 1.227 1.916 1.84a44 44 0 0 1 1.839 1.916c2.376 2.529 4.598 5.058 6.59 7.664a99 99 0 0 1 9.734 15.25l.46.92.46.92c.306.613.613 1.226.843 1.84.306.613.536 1.149.843 1.762.23.613.536 1.15.766 1.763.92 2.299 1.84 4.521 2.53 6.59 1.149 3.373 1.992 6.362 2.682 8.967a2.043 2.043 0 0 0 2.299 1.61c1.15-.077 1.992-.996 1.992-2.146.077-2.759 0-6.054-.383-9.81"
    }));

const GraphQL = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            fill: "color(display-p3 .8824 0 .5961)"
        },
        viewBox: "0 0 100 100",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "m50 6.903 37.323 21.549v43.096L50 93.097 12.677 71.548V28.451zM16.865 30.87v31.656L44.28 15.041zM50 13.51 18.398 68.246h63.205zm27.415 58.924h-54.83L50 88.261zm5.72-9.908L55.72 15.041 83.136 30.87z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 50,
        cy: 9.321,
        r: 8.82
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 85.229,
        cy: 29.66,
        r: 8.82
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 85.229,
        cy: 70.34,
        r: 8.82
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 50,
        cy: 90.679,
        r: 8.82
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 14.766,
        cy: 70.34,
        r: 8.82
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 14.766,
        cy: 29.66,
        r: 8.82
    }));

const GrokDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M395.479 633.828 735.91 381.105c16.689-12.39 40.544-7.557 48.496 11.687 41.854 101.493 23.155 223.461-60.118 307.204s-199.137 102.108-305.041 60.281l-115.691 53.866c165.934 114.059 367.431 85.852 493.345-40.861 99.875-100.439 130.807-237.345 101.884-360.806l.262.263C857.105 231.37 909.358 158.874 1016.4 10.633c2.53-3.515 5.07-7.03 7.6-10.633L883.144 141.651v-.439L395.392 633.916M325.226 695.251c-119.098-114.411-98.564-291.475 3.059-393.583 75.146-75.571 198.264-106.414 305.741-61.072l115.428-53.602c-20.797-15.114-47.447-31.371-78.03-42.794-138.234-57.206-303.731-28.735-416.101 84.182-108.089 108.699-142.079 275.833-83.71 418.451 43.603 106.59-27.874 181.985-99.874 258.083C46.224 931.893 20.622 958.87 0 987.429l325.139-292.09"
    }));

const GrokLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0A0A0A",
        d: "M395.479 633.828 735.91 381.105c16.689-12.39 40.544-7.557 48.496 11.687 41.854 101.493 23.155 223.461-60.118 307.204s-199.137 102.108-305.041 60.281l-115.691 53.866c165.934 114.059 367.431 85.852 493.345-40.861 99.875-100.439 130.807-237.345 101.884-360.806l.262.263C857.105 231.37 909.358 158.874 1016.4 10.633c2.53-3.515 5.07-7.03 7.6-10.633L883.144 141.651v-.439L395.392 633.916M325.226 695.251c-119.098-114.411-98.564-291.475 3.059-393.583 75.146-75.571 198.264-106.414 305.741-61.072l115.428-53.602c-20.797-15.114-47.447-31.371-78.03-42.794-138.234-57.206-303.731-28.735-416.101 84.182-108.089 108.699-142.079 275.833-83.71 418.451 43.603 106.59-27.874 181.985-99.874 258.083C46.224 931.893 20.622 958.87 0 987.429l325.139-292.09"
    }));

const Groq = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 201 201",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F54F35",
        d: "M0 0h201v201H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFBFB",
        d: "m128 49 1.895 1.52C136.336 56.288 140.602 64.49 142 73c.097 1.823.148 3.648.161 5.474l.03 3.247.012 3.482.017 3.613q.014 3.783.02 7.565c.01 3.84.041 7.68.072 11.521q.01 3.683.016 7.364l.038 3.457c-.033 11.717-3.373 21.83-11.475 30.547-4.552 4.23-9.148 7.372-14.891 9.73l-2.387 1.055c-9.275 3.355-20.3 2.397-29.379-1.13-5.016-2.38-9.156-5.17-13.234-8.925 3.678-4.526 7.41-8.394 12-12l3.063 2.375c5.572 3.958 11.135 5.211 17.937 4.625 6.96-1.384 12.455-4.502 17-10 4.174-6.784 4.59-12.222 4.531-20.094l.012-3.473q.004-3.62-.022-7.241c-.02-3.68 0-7.36.026-11.04a3321 3321 0 0 0-.016-7.058l.025-3.312c-.098-7.996-1.732-13.21-6.681-19.47-6.786-5.458-13.105-8.211-21.914-7.792-7.327 1.188-13.278 4.7-17.777 10.601C75.472 72.012 73.86 78.07 75 85c2.191 7.547 5.019 13.948 12 18 5.848 3.061 10.892 3.523 17.438 3.688l2.794.103c2.256.082 4.512.147 6.768.209v16c-16.682.673-29.615.654-42.852-10.848-8.28-8.296-13.338-19.55-13.71-31.277.394-9.87 3.93-17.894 9.562-25.875l1.688-2.563C84.698 35.563 110.05 34.436 128 49"
    }));

const HCaptcha = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "49.979%",
        x2: "49.979%",
        y1: "-702.201%",
        y2: "97.969%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "50%",
        x2: "50%",
        y1: "-602.243%",
        y2: "197.926%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "49.979%",
        x2: "49.979%",
        y1: "-602.243%",
        y2: "197.926%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "50.021%",
        x2: "50.021%",
        y1: "-502.498%",
        y2: "298.01%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: "50%",
        x2: "50%",
        y1: "-502.498%",
        y2: "298.01%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "49.979%",
        x2: "49.979%",
        y1: "-502.498%",
        y2: "298.01%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: "50.021%",
        x2: "50.021%",
        y1: "-402.285%",
        y2: "397.884%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: "50%",
        x2: "50%",
        y1: "-402.285%",
        y2: "397.884%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: "49.979%",
        x2: "49.979%",
        y1: "-402.285%",
        y2: "397.884%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__j",
        x1: "50.021%",
        x2: "50.021%",
        y1: "-302.328%",
        y2: "497.842%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__k",
        x1: "50%",
        x2: "50%",
        y1: "-302.328%",
        y2: "497.842%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__l",
        x1: "49.979%",
        x2: "49.979%",
        y1: "-302.328%",
        y2: "497.842%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__m",
        x1: "50.021%",
        x2: "50.021%",
        y1: "-202.328%",
        y2: "597.842%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__n",
        x1: "50%",
        x2: "50%",
        y1: "-202.328%",
        y2: "597.842%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__o",
        x1: "49.979%",
        x2: "49.979%",
        y1: "-202.328%",
        y2: "597.842%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__p",
        x1: "50%",
        x2: "50%",
        y1: "-102.37%",
        y2: "697.799%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__q",
        x1: "49.979%",
        x2: "49.979%",
        y1: "-102.37%",
        y2: "697.799%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__r",
        x1: "49.979%",
        x2: "49.979%",
        y1: "-2.37%",
        y2: "797.799%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00D4BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0074BF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M160.007 223.993h32.007V256h-32.007z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M128 223.993h32.007V256H128z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M96.007 223.993h32.007V256H96.007z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M64 223.993h32.007V256H64z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M192 192h31.993v32.007H192z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M160.007 192h32.007v32.007h-32.007z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M128 192h32.007v32.007H128z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M96.007 192h32.007v32.007H96.007z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M64 192h32.007v32.007H64z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M32.007 192h32.007v32.007H32.007z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M223.993 160.007H256V192h-32.007z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M192 160.007h31.993V192H192z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M160.007 160.007h32.007V192h-32.007zm-32.007 0h32.007V192H128z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M96.007 160.007h32.007V192H96.007zm-32.007 0h32.007V192H64z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M32.007 160.007h32.007V192H32.007z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M0 160.007h32.007V192H0z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M223.993 128H256v32.007h-32.007z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M192 128h31.993v32.007H192z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M160.007 128h32.007v32.007h-32.007zM128 128h32.007v32.007H128z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M96.007 128h32.007v32.007H96.007zM64 128h32.007v32.007H64z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M32.007 128h32.007v32.007H32.007z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M0 128h32.007v32.007H0z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__j)",
        d: "M223.993 96.007H256v32.007h-32.007z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__k)",
        d: "M192 96.007h31.993v32.007H192z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M160.007 96.007h32.007v32.007h-32.007zm-32.007 0h32.007v32.007H128z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M96.007 96.007h32.007v32.007H96.007zm-32.007 0h32.007v32.007H64z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M32.007 96.007h32.007v32.007H32.007z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M0 96.007h32.007v32.007H0z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__m)",
        d: "M223.993 64H256v32.007h-32.007z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__n)",
        d: "M192 64h31.993v32.007H192z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__o)",
        d: "M160.007 64h32.007v32.007h-32.007zM128 64h32.007v32.007H128z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__o)",
        d: "M96.007 64h32.007v32.007H96.007zM64 64h32.007v32.007H64z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__o)",
        d: "M32.007 64h32.007v32.007H32.007z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__o)",
        d: "M0 64h32.007v32.007H0z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__p)",
        d: "M192 32.007h31.993v32.007H192z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__q)",
        d: "M160.007 32.007h32.007v32.007h-32.007z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__q)",
        d: "M128 32.007h32.007v32.007H128z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__q)",
        d: "M96.007 32.007h32.007v32.007H96.007z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__q)",
        d: "M64 32.007h32.007v32.007H64z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__q)",
        d: "M32.007 32.007h32.007v32.007H32.007z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__r)",
        d: "M160.007 0h32.007v32.007h-32.007z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__r)",
        d: "M128 0h32.007v32.007H128z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__r)",
        d: "M96.007 0h32.007v32.007H96.007z",
        opacity: 0.7
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__r)",
        d: "M64 0h32.007v32.007H64z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m84.25 117.841 8.912-19.951c3.251-5.12 2.818-11.378-.745-14.9a9 9 0 0 0-1.57-1.26 9.85 9.85 0 0 0-8.223-.934 13.44 13.44 0 0 0-7.409 5.756s-12.19 28.445-16.755 41.285c-4.565 12.841-2.709 36.274 14.778 53.828 18.556 18.557 45.47 22.837 62.605 9.942a10.8 10.8 0 0 0 2.018-1.354l52.825-44.143c2.574-2.154 6.38-6.502 2.953-11.487-3.427-4.984-9.63-1.557-12.19.095l-30.423 22.12a1.354 1.354 0 0 1-1.964-.231 3.74 3.74 0 0 1 .298-4.47l46.636-39.578c4.063-3.63 4.592-8.9 1.354-12.516s-8.249-3.44-12.299.23l-41.989 32.833a1.87 1.87 0 0 1-2.709-.352 2.587 2.587 0 0 1-.217-3.44l47.557-46.148a9.305 9.305 0 0 0 .474-13.125 8.89 8.89 0 0 0-6.461-2.709 9.48 9.48 0 0 0-6.678 2.71l-48.531 45.578c-1.165 1.165-3.44 0-3.712-1.355-.1-.493.058-1.004.42-1.354L160.4 70.556a9.17 9.17 0 1 0-12.936-12.976l-56.428 62.307c-2.018 2.018-4.998 2.113-6.42.948a2.113 2.113 0 0 1-.366-2.994"
    }));

const HTML5 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 452 520",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#e34f26",
        d: "M41 460 0 0h451l-41 460-185 52"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ef652a",
        d: "m226 472 149-41 35-394H226"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ecedee",
        d: "M226 208h-75l-5-58h80V94H84l15 171h127zm0 147-64-17-4-45h-56l7 89 117 32z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M226 265h69l-7 73-62 17v59l115-32 16-174H226zm0-171v56h136l5-56z"
    }));

const HackTheBox = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 1024 791.27",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M697.938 297.501c0-.046.005-.093.005-.14 0-4.646-2.054-8.996-5.516-11.951q-.252-.217-.514-.424l-.155-.122a14.7 14.7 0 0 0-1.9-1.247L520.095 185.6q-.615-.365-1.257-.677a15.71 15.71 0 0 0-12.135-.643 16 16 0 0 0-2.923 1.397l-169.86 98.065c-4.866 2.81-7.862 8-7.862 13.618 0 .114.009.227.011.34-.003.126-.021.25-.021.376v195.836c0 5.997 3.357 11.21 8.296 13.862l169.795 98.03q.471.272.955.509l.067.03q.726.347 1.475.617.104.04.208.078a16 16 0 0 0 1.783.5q.755.169 1.52.26.122.014.244.024c.536.055 1.072.09 1.61.09.537 0 1.074-.035 1.61-.09q.121-.01.244-.024a16 16 0 0 0 1.805-.325 16 16 0 0 0 1.498-.435q.104-.038.208-.078.748-.268 1.473-.616.034-.016.069-.031.484-.237.955-.508l169.795-98.03c4.938-2.653 8.295-7.866 8.295-13.863V297.956c0-.152-.01-.303-.014-.455m-305.267-6.545 115.632-66.76a7.4 7.4 0 0 1 7.398 0l115.63 66.759c4.932 2.847 4.932 9.966 0 12.813L515.699 370.53a7.4 7.4 0 0 1-7.398 0L392.67 303.77c-4.932-2.848-4.932-9.966 0-12.814m99.298 253.755c0 5.682-6.15 9.233-11.071 6.392l-115.406-66.63a7.38 7.38 0 0 1-3.69-6.392V344.834c0-5.682 6.15-9.233 11.071-6.392l115.406 66.63a7.38 7.38 0 0 1 3.69 6.392zm170.229-66.63a7.38 7.38 0 0 1-3.69 6.392l-115.406 66.63c-4.92 2.841-11.071-.71-11.071-6.392V411.464a7.38 7.38 0 0 1 3.69-6.392l115.405-66.63c4.92-2.841 11.072.71 11.072 6.392z",
        style: {
            fill: "#9fef00"
        }
    }));

const Hashnode = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1000 1000",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#2563EB",
        fillRule: "evenodd",
        d: "M68.692 334.16c-91.59 91.589-91.59 240.085 0 331.674L334.16 931.302c91.589 91.588 240.085 91.588 331.674-.001l265.468-265.467c91.588-91.59 91.588-240.085-.001-331.674L665.834 68.692c-91.59-91.59-240.085-91.59-331.674 0zm431.302 330.06c90.694 0 164.216-73.522 164.216-164.216s-73.522-164.216-164.216-164.216-164.216 73.522-164.216 164.216S409.3 664.22 499.994 664.22",
        clipRule: "evenodd"
    }));

const Haskell = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#453a62",
        d: "M9 43H1l12-18L1 7h8l12 18z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5e5086",
        d: "M20 7h-8l12 18-12 18h8l8.16-12.24L36 43h8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8f4e8b",
        d: "M34.338 24H47v-6H30.338zm6 9H47v-6H36.338z"
    }));

const HeadlessUI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "35.871%",
        x2: "60.314%",
        y1: "7.224%",
        y2: "115.988%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#66E3FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#7064F9"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "39.172%",
        x2: "55.05%",
        y1: "0%",
        y2: "99.181%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#66E3FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#7064F9"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m50.699 159.089 156.225-52.153c-3.122-19.523-5.346-32.565-7.924-42.518-2.777-10.706-4.978-13.57-5.842-14.563a30.5 30.5 0 0 0-10.973-7.969c-1.216-.52-4.625-1.728-15.654-1.064-11.669.704-26.987 3.088-51.245 6.929-24.25 3.84-39.56 6.313-50.87 9.241-10.7 2.777-13.573 4.985-14.566 5.85a30.6 30.6 0 0 0-7.963 10.97c-.52 1.215-1.729 4.624-1.064 15.658.704 11.665 3.089 26.988 6.93 51.24 1.073 6.8 2.041 12.882 2.946 18.379"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M7.625 147.063c-7.427-46.92-11.149-70.38-3.098-89.214a71.1 71.1 0 0 1 18.6-25.605c15.423-13.466 38.88-17.178 85.796-24.611C155.854.19 179.313-3.521 198.16 4.528a71.1 71.1 0 0 1 25.595 18.595c13.477 15.426 17.19 38.886 24.618 85.814 7.435 46.92 11.149 70.387 3.097 89.214a71.1 71.1 0 0 1-18.591 25.604c-15.423 13.474-38.889 17.187-85.812 24.62-46.916 7.433-70.382 11.146-89.213 3.096a71.1 71.1 0 0 1-25.595-18.595C18.781 217.45 15.068 193.99 7.633 147.063zm82.762 83.325c12.565-.76 28.748-3.296 52.702-7.09 23.962-3.792 40.12-6.384 52.318-9.545 11.805-3.064 17.247-6.049 20.76-9.121a45.7 45.7 0 0 0 11.95-16.459c1.84-4.288 3-10.385 2.264-22.563-.76-12.562-3.297-28.749-7.09-52.705-3.794-23.955-6.38-40.126-9.54-52.312-3.066-11.81-6.059-17.25-9.124-20.763a45.7 45.7 0 0 0-16.455-11.954c-4.29-1.84-10.388-3-22.57-2.265-12.565.76-28.74 3.297-52.701 7.09-23.954 3.8-40.121 6.385-52.31 9.545-11.813 3.065-17.247 6.057-20.76 9.122a45.7 45.7 0 0 0-11.958 16.458c-1.833 4.289-2.993 10.386-2.257 22.564.76 12.57 3.29 28.748 7.091 52.704 3.794 23.956 6.379 40.127 9.54 52.313 3.065 11.81 6.05 17.25 9.124 20.763a45.7 45.7 0 0 0 16.455 11.954c4.29 1.84 10.38 3 22.57 2.264z"
    }));

const HeroUIDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 74 74",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        d: "M54.35.083H19.566C8.76.083 0 8.843 0 19.649v34.783C0 65.239 8.76 74 19.566 74H54.35c10.806 0 19.566-8.76 19.566-19.566V19.648C73.916 8.843 65.156.083 54.35.083"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#111",
        d: "M50.638 52.566V21.201h3.877v31.365zm-18.907.654q-3.638 0-6.425-1.503a11.1 11.1 0 0 1-4.378-4.204q-1.569-2.722-1.569-6.382V21.223l3.921-.022v19.604q0 2.22.74 3.877.763 1.633 2.005 2.722a8.6 8.6 0 0 0 2.722 1.634 9 9 0 0 0 2.984.523 8.8 8.8 0 0 0 3.006-.545 8.5 8.5 0 0 0 2.723-1.612q1.24-1.088 1.982-2.744.74-1.656.74-3.855V21.2h3.921v19.93q0 3.637-1.59 6.36a10.9 10.9 0 0 1-4.356 4.226q-2.788 1.503-6.426 1.503Z"
    }));

const HeroUILight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 74 74",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#111",
        d: "M54.35.083H19.566C8.76.083 0 8.843 0 19.649v34.783C0 65.239 8.76 74 19.566 74H54.35c10.806 0 19.566-8.76 19.566-19.566V19.648C73.916 8.843 65.156.083 54.35.083"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M50.638 52.566V21.201h3.877v31.365zm-18.907.654q-3.638 0-6.425-1.503a11.1 11.1 0 0 1-4.378-4.204q-1.569-2.722-1.569-6.382V21.223l3.921-.022v19.604q0 2.22.74 3.877.763 1.633 2.005 2.722a8.6 8.6 0 0 0 2.722 1.634 9 9 0 0 0 2.984.523 8.8 8.8 0 0 0 3.006-.545 8.5 8.5 0 0 0 2.723-1.612q1.24-1.088 1.982-2.744.74-1.656.74-3.855V21.2h3.921v19.93q0 3.637-1.59 6.36a10.9 10.9 0 0 1-4.356 4.226q-2.788 1.503-6.426 1.503Z"
    }));

const Heroku = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 284.4",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#430098",
        d: "M230 0c14 0 26 11 26 25v234c0 14-11 25-25 25H26c-14 0-26-11-26-25V26C0 12 11 0 25 0h1zm0 14H26c-7 0-12 5-12 11v234c0 6 5 11 11 11h205c7 0 12-5 12-11V26c0-7-5-12-12-12M64 185l32 28-32 29zM92 43v80c15-4 34-9 54-9 17 0 28 7 34 12 12 13 12 28 12 30v86h-28v-85c-1-7-4-15-18-15-29 0-61 14-62 15l-20 9V43zm100 0c-2 16-8 31-21 46h-29c11-15 18-30 22-46z"
    }));

const HomeAssistant = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 240 240",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F2F4F9",
        d: "M240 224.762c0 8.25-6.75 15-15 15H15c-8.25 0-15-6.75-15-15v-90c0-8.25 4.77-19.769 10.61-25.609l98.78-98.78c5.83-5.83 15.38-5.83 21.21 0l98.79 98.789c5.83 5.83 10.61 17.36 10.61 25.61v90z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#18BCF2",
        d: "m229.39 109.153-98.78-98.78c-5.83-5.83-15.38-5.83-21.21 0l-98.79 98.78C4.78 114.983 0 126.512 0 134.762v90c0 8.25 6.75 15 15 15h92.27l-40.63-40.63c-2.09.72-4.32 1.13-6.64 1.13-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5 20.5 9.2 20.5 20.5c0 2.33-.41 4.56-1.13 6.65l31.63 31.63v-115.88c-6.8-3.34-11.5-10.32-11.5-18.39 0-11.3 9.2-20.5 20.5-20.5s20.5 9.2 20.5 20.5c0 8.07-4.7 15.05-11.5 18.39v81.27l31.46-31.46c-.62-1.96-.96-4.04-.96-6.2 0-11.3 9.2-20.5 20.5-20.5s20.5 9.2 20.5 20.5-9.2 20.5-20.5 20.5c-2.5 0-4.88-.47-7.09-1.29L129 208.892v30.88h96c8.25 0 15-6.75 15-15v-90c0-8.25-4.77-19.77-10.61-25.61z"
    }));

const Homebrew = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 164 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#D1D2D3",
        d: "M125.534 84.857c.701-18.285-3.917-25.667-7.384-30.944-3.517-4.923-11.955-12.66-22.323-12.984-9.805-.306-12.163 5.113-21.208 5.44-1.484-16.472 10.948-25.51 10.948-25.51s-3.4-4.805-6.212-5.977C76.119 17.758 68.36 26.018 66.7 37.108c-1.747-16.335-9.914-26.781-28.018-34.062C33.54 21.034 50.518 37.84 61.548 44.477c-5.847-1.964-10.921-4.56-17.736-3.219-11.91 2.345-21.73 9.546-27.325 25.348s1.976 34.237 3.621 39.502c1.647 5.27 13.828 27.653 23.375 30.946 9.545 3.295 9.549 1.81 14.652-.163s12.837-5.597 24.198-1.48c11.353 4.114 12.835 5.1 19.91.492 7.083-4.608 16.297-18.927 18.436-23.043 2.14-4.113 3.292-6.255 3.954-8.394.823-6.263.268-3.22.9-19.61"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFEFE",
        d: "M126.215 110.162v8.941a3.793 3.793 0 0 0 3.792 3.792h14.07a17.07 17.07 0 0 1 17.066 17.067v42.61l-.002 9.287v7.314l-.001 2.261c0 4.537-1.804 8.887-5.02 12.089a17.07 17.07 0 0 1-12.107 4.976c-4.754.012-9.755.004-13.926-.054a3.79 3.79 0 0 0-3.872 3.79v5.065l-.002 2.245v1.69a2774 2774 0 0 1-.015 7.995c0 1.123-.5 2.188-1.364 2.905-4.347 3.284-19.533 10.56-53.499 10.56-33.265 0-49.106-5.433-54.048-8.295a3.8 3.8 0 0 1-1.755-3.19c-.015-7.374-.07-33.63-.129-60.724l-.008-3.698-.142-66.323v-.303zm16.82 27.927h-12.08a4.74 4.74 0 0 0-3.17 1.217l-.18.172a4.74 4.74 0 0 0-1.383 3.102l-.007.251V198c0 1.173.436 2.302 1.217 3.17l.172.182a4.73 4.73 0 0 0 3.1 1.381l.25.007h12.08a4.74 4.74 0 0 0 3.17-1.215l.182-.173a4.75 4.75 0 0 0 1.381-3.101l.007-.25V142.83a4.75 4.75 0 0 0-1.216-3.17l-.172-.183a4.75 4.75 0 0 0-3.101-1.383z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FAAF41",
        d: "M26.192 109.063V226.62a3.79 3.79 0 0 0 1.9 3.287c4.797 2.287 18.718 7.746 43.125 7.746 24.568 0 38.074-6.634 42.599-9.368a3.78 3.78 0 0 0 1.73-3.176c.01-15.589.01-116.046.01-116.046z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFDA95",
        d: "M39.328 123.714c2.8 0 5.09 2.19 5.251 4.95l.009.31v90.847a5.26 5.26 0 0 1-10.512.31l-.008-.31v-90.848a5.26 5.26 0 0 1 5.26-5.26"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFEFE",
        d: "M89.818 133.186c0-1.896-1.116-4.16-2.949-5.297a15.85 15.85 0 0 1-6.58-7.87c-24.266.816-46.412-3.444-57.57-6.453a92 92 0 0 0-8.695-2.019c-6.677-1.326-11.752-7.19-11.752-14.24 0-7.76 6.157-14.067 13.85-14.343 1.482-8.207 8.647-14.438 17.283-14.438 9.71 0 17.583 7.872 17.583 17.583a17.6 17.6 0 0 1-1.008 5.825l.05.009c2.17-6.783 8.519-11.698 16.021-11.698 7.453 0 13.77 4.857 15.975 11.577a17 17 0 0 1-.097-1.847c0-10.1 8.186-18.285 18.285-18.285 8.175 0 15.094 5.365 17.435 12.764l1.592-.417a14.3 14.3 0 0 1 7.047-1.853c7.936 0 14.369 6.434 14.365 14.367 0 7.268-5.395 13.274-12.399 14.233a21 21 0 0 0-4.638 1.205 115 115 0 0 1-12.72 3.943 15.8 15.8 0 0 1-1.811 5.908 19.66 19.66 0 0 0-2.256 10.672c-.002.223.007 1.398.007 1.623 0 4.698-3.81 7.557-8.513 7.557a8.505 8.505 0 0 1-8.505-8.506"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#010202",
        d: "m86.402 112.433.1.307-.032-.307z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#010202",
        d: "m37.192 0 2.338.939C54.557 6.982 63.305 15.28 67.1 27.519c2.399-5.319 6.043-10.048 10.277-13.912l1.536-1.37 1.317.548a9 9 0 0 1 1.709.972c.89.634 1.793 1.456 2.708 2.427a34 34 0 0 1 1.97 2.297l.338.436.377.507 1.384 1.954-1.814 1.319-.248.191-.341.28-.42.37-.493.456a28.6 28.6 0 0 0-3.524 4.058c-3.142 4.378-5.03 9.44-5.108 15.185l-.002.669.491-.08c1.692-.31 3.282-.902 5.61-1.961l1.33-.61c4.497-2.036 7.19-2.736 11.7-2.596 9.58.3 18.796 6.508 24.152 14.009q.181.273.356.55l.69 1.092.657 1.085c4.092 6.951 6.064 13.7 6.135 24.6 8.44.804 15.041 7.909 15.038 16.556 0 8.342-6.173 15.362-14.353 16.482l-.087.017v6.053c0 .84.682 1.522 1.522 1.522h14.07a19.336 19.336 0 0 1 19.336 19.337l-.001 61.472c0 5.14-2.047 10.07-5.689 13.696a19.32 19.32 0 0 1-13.703 5.64l-2.131.004-4.137-.001-5.028-.028-2.685-.03a1.524 1.524 0 0 0-1.554 1.52l-.005 12.433-.012 4.562c0 1.8-.8 3.502-2.267 4.716-2.067 1.561-4.81 3.04-8.214 4.377l-1.159.439a70 70 0 0 1-5.813 1.84l-1.425.374-1.471.36q-2.243.53-4.698.995l-1.661.302-1.707.285q-2.165.346-4.471.64l-1.87.225-1.916.208-1.96.188-2.008.17-2.053.15-2.099.13q-.53.031-1.065.059l-2.166.099-2.21.078q-1.117.032-2.256.056l-2.3.033q-1.16.012-2.344.012h-1.2q-1.193-.008-2.367-.02l-2.322-.038-2.279-.055q-1.128-.031-2.234-.072l-2.188-.09q-.542-.024-1.078-.051l-2.122-.116-2.075-.13-2.03-.148a88 88 0 0 1-.998-.079l-1.96-.169q-.484-.044-.963-.092l-1.891-.191-1.843-.207q-.456-.053-.905-.109l-1.773-.229-1.726-.239-1.676-.254a136 136 0 0 1-2.425-.404l-1.555-.285-.759-.147-1.483-.302-1.432-.313-1.382-.326-1.333-.332a72 72 0 0 1-3.694-1.062l-1.13-.372a45 45 0 0 1-1.597-.575l-1-.39q-2.191-.896-3.848-1.854a6.07 6.07 0 0 1-2.804-5.102l-.274-127.583C5.465 111.852 0 105.144 0 97.307c0-7.64 5.171-14.083 12.235-16.017-.087-2.324-.034-4.618.207-6.881.32-2.994.947-5.852 1.906-8.562 5.5-15.536 15.29-24.114 29.027-26.817a21 21 0 0 1 7.055-.219 62 62 0 0 1-5.048-5.3C37.129 23.69 33.5 12.913 36.499 2.42zm86.751 114.287-1.09.401c-.23.084-.476.154-.71.236-2.13.749-4.316 1.43-6.54 2.066-1.376.395-1.376.395-2.687.767l-.102.518a18 18 0 0 1-1.403 4.004l-.602 1.176c-.111.227-.186.468-.285.7a17.66 17.66 0 0 0-1.425 8.356l.001.333.005 1.29c0 5.866-4.686 9.83-10.782 9.83a10.73 10.73 0 0 1-7.842-3.403 10.74 10.74 0 0 1-2.779-5.622 11 11 0 0 1-.155-1.752c0-1.217-.797-2.699-1.854-3.356a18.1 18.1 0 0 1-6.794-7.349l-.073-.15-1.494.033c-17.223.293-34.754-1.815-49.145-5.107a165 165 0 0 1-4.896-1.191l-1.191-.316q-.05-.013-.103-.027a94 94 0 0 0-4.464-1.133l.27 126.614c0 .517.267 1.002.622 1.229q.988.573 2.219 1.126l.846.364q1.31.542 2.859 1.061l1.056.34a71 71 0 0 0 1.683.496l1.186.321 1.238.313 1.287.305 1.34.294q.338.074.687.145l1.413.28q.717.139 1.463.273l1.512.26q.768.127 1.561.248l1.61.237 1.659.227q.42.056.846.108l1.73.21 1.78.194 1.824.18q.463.044.93.087l1.896.162 1.942.147 1.988.131 2.035.116 2.08.102q.526.023 1.056.045l2.15.078q.54.018 1.09.033l2.215.053 1.123.02 2.282.026q1.149.008 2.324.008l1.139-.001q2.835-.014 5.53-.096l2.134-.073a71 71 0 0 0 1.05-.045l2.065-.102 2.02-.123q.5-.032.994-.068l1.954-.152.957-.08 1.885-.178.925-.095 1.812-.202.891-.107 1.744-.227 1.698-.244 1.652-.256q.815-.135 1.605-.272l1.558-.286q.766-.149 1.51-.3l1.465-.315 1.414-.324q1.392-.331 2.688-.685l1.272-.36q.311-.092.618-.186l1.2-.373 1.15-.386c3.946-1.364 6.995-2.896 9.118-4.502.344-.285.543-.709.543-1.166l.017-16.985c0-1.63.657-3.191 1.821-4.33a6.04 6.04 0 0 1 4.354-1.73l2.659.029 3.942.024 5.177.005 2.126-.005a14.8 14.8 0 0 0 10.496-4.313 14.8 14.8 0 0 0 4.352-10.48l.002-61.473a14.795 14.795 0 0 0-14.795-14.795h-14.07a6.064 6.064 0 0 1-6.064-6.064zm19.091 21.532a7.01 7.01 0 0 1 7.011 7.012V198a7.01 7.01 0 0 1-7.011 7.01h-12.078a7.01 7.01 0 0 1-7.013-7.01v-55.168a7.013 7.013 0 0 1 7.013-7.012Zm0 4.543h-12.078c-.655 0-1.283.26-1.746.72a2.48 2.48 0 0 0-.725 1.75v55.167a2.47 2.47 0 0 0 2.47 2.47h12.079c.655 0 1.283-.261 1.744-.724.464-.462.726-1.09.726-1.746v-55.168a2.47 2.47 0 0 0-2.47-2.47ZM33.404 70.796c-7.427 0-13.74 5.337-15.049 12.573l-.324 1.799-.947.036-.88.03a12 12 0 0 0-3.614.692c-4.697 1.665-8.049 6.138-8.049 11.381 0 5.346 3.504 9.983 8.438 11.612.473.156.954.294 1.453.393 1.636.299 3.261.649 4.876 1.03 1.344.318 2.68.658 4.003 1.032.569.153 1.176.295 1.762.445.809.205 1.602.415 2.432.614 15.138 3.63 34.249 5.938 52.707 5.317l1.614-.055.58 1.509a13.6 13.6 0 0 0 5.661 6.755c2.434 1.51 4.021 4.464 4.021 7.228l.009.33a6.2 6.2 0 0 0 .988 3.011c1.11 1.732 3.03 2.895 5.238 2.895 3.74 0 6.241-2.117 6.241-5.29l-.007-1.301.007-.154a21.97 21.97 0 0 1 2.52-11.916l.269-.526a13.5 13.5 0 0 0 1.281-4.533l.16-1.588 1.55-.386c1.583-.396 3.115-.847 4.648-1.296q2.017-.59 3.988-1.228a88 88 0 0 0 3.82-1.335l.713-.263a24 24 0 0 1 1.633-.48c.92-.247 1.85-.458 2.8-.593l.402-.062q.07-.014.137-.029a12.1 12.1 0 0 0 9.898-11.893c.002-6.16-4.61-11.235-10.566-11.988a12 12 0 0 0-1.529-.106 12.1 12.1 0 0 0-5.93 1.56l-.258.145-3.966 1.033-.65-2.055a16.02 16.02 0 0 0-15.27-11.179c-8.844 0-16.014 7.17-16.014 16.015q.001.815.084 1.61l1.71 16.305.476 4.543h-.068l-1.492-4.543-5.043-15.361A14.55 14.55 0 0 0 66.05 82.517a14.55 14.55 0 0 0-13.856 10.117l-.597 1.866-4.658-.763.896-2.555c.58-1.654.88-3.355.88-5.074 0-8.456-6.855-15.312-15.311-15.312M79.64 17.71l-.556.545c-5.074 5.065-9.827 13.547-10.116 18.771-.29 5.224.562 11.71.562 11.71l-3.204-.613a36 36 0 0 1-4.065-1.024l-.993-.318q-.258-.085-.526-.175l-.186-.065-.937-.324-3.741-1.338-1.027-.349c-4.177-1.365-7.138-1.723-10.599-1.042-12.15 2.39-20.652 9.84-25.622 23.874-.838 2.366-1.388 4.878-1.673 7.53-.005.044-.005.09-.01.136 3.495-5.191 9.353-8.598 15.944-8.767l.514-.006c9.784 0 17.914 7.077 19.553 16.392l.075.46.49-.445a19.06 19.06 0 0 1 12.016-4.68l.512-.006a19.06 19.06 0 0 1 14.142 6.275l.206.234.13-.447c2.5-8.301 10.109-14.39 19.17-14.614l.515-.005a20.56 20.56 0 0 1 18.664 11.934l.113.255.218-.108a16.6 16.6 0 0 1 4.139-1.304c-.043-10.393-1.873-16.478-5.769-22.939l-.623-1.007-.653-1.017c-4.556-6.376-12.585-11.785-20.547-12.034-3.881-.121-6.004.485-10.337 2.492l-.722.331c-3.97 1.802-6.28 2.481-9.996 2.616l-2.15.079-.193-2.144c-.734-8.135 1.565-15.23 5.83-21.17 1.443-2.011 2.892-3.616 4.162-4.804l.075-.073-.496-.584-.586-.643a17 17 0 0 0-1.396-1.34zM40.3 6.192l-.058.37c-1.165 7.95 2.043 16.208 8.617 24.027 4.013 4.773 9.173 9.088 13.587 11.796.686.422 1.357.81 2 1.15l.37.193-.001-.358a63 63 0 0 0-.413-6.637C62.67 22.088 55.45 12.943 40.538 6.298z"
    }));

const Hono = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 330",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF5B11",
        d: "M134.129.029q1.315-.17 2.319.662a1256 1256 0 0 1 69.573 93.427q24.141 36.346 41.082 76.862 27.055 72.162-28.16 125.564-48.313 40.83-111.318 31.805-75.312-15.355-102.373-87.133-7.048-23.367-4.638-47.706 4.014-41.896 19.878-80.838 6.61-15.888 17.228-29.154a382 382 0 0 1 16.565 21.203q3.66 3.825 7.62 7.289Q92.137 52.012 134.13.029Z",
        opacity: 0.993
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9758",
        d: "M129.49 53.7q36.47 42.3 65.93 90.114a187.3 187.3 0 0 1 15.24 33.13q12.507 49.206-26.836 81.169-38.05 26.775-83.488 15.902-48.999-15.205-56.653-65.929-1.857-15.993 3.314-31.142a225.4 225.4 0 0 1 17.89-35.78l19.878-29.155a5510 5510 0 0 0 44.726-58.31Z"
    }));

const Hoppscotch = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 748 500",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00B381",
        d: "M481.331 472.1c-60.011 33.411-132.958 37.478-197.829 8.596s-110.709-85.875-126.018-152.782c45.291 28.678 98.635 56.838 157.138 82.885s115.06 46.818 166.709 61.301",
        opacity: 0.6
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M403.097 313.899c-7.476 16.791-30.487 22.856-51.397 13.547-20.909-9.31-31.8-30.469-24.324-47.261 7.476-16.791 30.488-22.856 51.397-13.547 20.91 9.31 31.8 30.469 24.324 47.261"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M403.097 313.899c-7.476 16.791-30.487 22.856-51.397 13.547-20.909-9.31-31.8-30.469-24.324-47.261 7.476-16.791 30.488-22.856 51.397-13.547 20.91 9.31 31.8 30.469 24.324 47.261",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M528.347 386.39c21.89 6.277 43.722-2.883 48.761-20.458 5.04-17.576-8.62-36.912-30.511-43.189s-43.721 2.883-48.761 20.458c-5.039 17.576 8.621 36.912 30.511 43.189"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M528.347 386.39c21.89 6.277 43.722-2.883 48.761-20.458 5.04-17.576-8.62-36.912-30.511-43.189s-43.721 2.883-48.761 20.458c-5.039 17.576 8.621 36.912 30.511 43.189",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M224.775 179.46c19.312 12.068 27.114 34.42 17.425 49.926s-33.199 18.292-52.511 6.225-27.114-34.42-17.425-49.926 33.199-18.292 52.511-6.225"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M224.775 179.46c19.312 12.068 27.114 34.42 17.425 49.926s-33.199 18.292-52.511 6.225-27.114-34.42-17.425-49.926 33.199-18.292 52.511-6.225",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        fillRule: "evenodd",
        d: "M486.721 24.178c98.796 43.987 162.233 139.915 164.791 247.086 58.163 45.759 115.969 109.806 89.109 170.133-43.559 97.835-248.585 48.351-426.014-30.645C137.178 331.755-36.785 212.503 6.775 114.667c26.859-60.327 113.134-60.224 186.059-47.62 81.355-69.81 195.091-86.855 293.887-42.869M57.981 137.466c-14.634 32.868 64.039 126.184 279.425 222.08 215.385 95.895 337.375 91.92 352.009 59.053 12.112-27.204-38.057-85.319-94.847-120.037-1.739-1.063-4.164-2.569-7.201-4.455-27.65-17.168-105.958-65.791-177.473-97.631-21.602-9.618-30.044-35.273-20.968-55.66s29.027-34.014 71.033-35.943c19.773-.055 22.366-5.535 23.269-10.233 1.118-7.248-9.16-14.739-19.305-19.256-82.442-36.705-183.347-21.348-253.273 52.247-68.341-15.319-140.558-17.368-152.67 9.835",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        fillRule: "evenodd",
        d: "M486.721 24.178c98.796 43.987 162.233 139.915 164.791 247.086 58.163 45.759 115.969 109.806 89.109 170.133-43.559 97.835-248.585 48.351-426.014-30.645C137.178 331.755-36.785 212.503 6.775 114.667c26.859-60.327 113.134-60.224 186.059-47.62 81.355-69.81 195.091-86.855 293.887-42.869M57.981 137.466c-14.634 32.868 64.039 126.184 279.425 222.08 215.385 95.895 337.375 91.92 352.009 59.053 12.112-27.204-38.057-85.319-94.847-120.037-1.739-1.063-4.164-2.569-7.201-4.455-27.65-17.168-105.958-65.791-177.473-97.631-21.602-9.618-30.044-35.273-20.968-55.66s29.027-34.014 71.033-35.943c19.773-.055 22.366-5.535 23.269-10.233 1.118-7.248-9.16-14.739-19.305-19.256-82.442-36.705-183.347-21.348-253.273 52.247-68.341-15.319-140.558-17.368-152.67 9.835",
        clipRule: "evenodd",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(-168.25 374.853 100.865)scale(778.304 379.214)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(-168.25 374.853 100.865)scale(778.304 379.214)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__f",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(-168.25 374.853 100.865)scale(778.304 379.214)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__h",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(-168.25 374.853 100.865)scale(778.304 379.214)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 373.698,
        x2: 373.698,
        y1: 0,
        y2: 495.636,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00D196"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00B381"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 373.698,
        x2: 373.698,
        y1: 0,
        y2: 495.636,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00D196"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00B381"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 373.698,
        x2: 373.698,
        y1: 0,
        y2: 495.636,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00D196"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00B381"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: 373.698,
        x2: 373.698,
        y1: 0,
        y2: 495.636,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00D196"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#00B381"
    }))));

const Hostgator = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 355",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#2E93EE",
        d: "M195 260c-11 9-20 23-31 32 5 26-4 37 7 46 4 3 29 10 43 2 0-13-7-17-14-22-8-16-5-42-6-58"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E578B",
        d: "M200 344c-1-8-7-14-14-17 6 4 9 10 9 17zm12-3c-1-7-7-13-14-16 8 5 10 11 9 18z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E93EE",
        d: "M183 128c-5 8-8 24 34 47 0 0-18 30-23 35-6 6-9 21-4 28l10 11s13 2 19-1c7-8 9-20 4-30 0 0 35-36 33-47s-57-67-73-43"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E578B",
        d: "m223 218-17 14 8-3s6 7 1 14c0 0 9-5 3-16l5-8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E93EE",
        d: "m78 212-2 7c-2 4-4 4 2 7 5 2 9 4 14 4 8 2 7 1 3-7l-6-10c-8-12-10-11-11-1m-29-4c-3 5 1 6 7 8l7 2c7 1 5 0 2-6l-6-9c-11-17-6-3-10 5m-26-3v4c0 5-1 4 5 5h8c7-2 5-4 1-8l-5-5c-14-11-9-3-9 4M121 39S79 61 80 68c0 7 12 6 16 15 0 0-26 18-24 26s18 5 22 12c0 0-4 16 0 22s3 1 8 8c1 0-2-60 19-112"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E93EE",
        d: "M113 59c14 14 33 23 50 34 12 7 22 16 31 27 10 14 4 30 6 47a185 185 0 0 1 1 48c-3 25-4 46-22 64-22 24-46 29-73 9-10-6-19-14-27-23l-18-17c-8-8-17-14-27-19-11-4-18 1-23 4-3 1-7 3-10 1l-1-4 7-10c16-14 42-15 62-4 7 4 15 8 24 9 6 0 12-1 17-5 3-3 6-8 6-13 2-7 1-14-1-21-3-9-9-18-13-27-12-32-16-69 4-99l3-4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFCF00",
        d: "M37 230c14 7 29 23 44 40 19 23 66 56 105 4 36-49 19-118 17-125v-1c-1-2-34-44-64-50-8 7-10 19 1 40 18 36 32 88 0 120-4 4-10 8-16 10-23 8-35-6-49-19a68 68 0 0 0-38-19"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ECA93F",
        d: "M190 268c-14-2-27-7-38-16 8 12 20 20 34 22zm-63 3c5 11 13 21 22 30l9-3c-13-6-24-15-31-27m-48-3 2 3 1 1c-1-4 0-7 1-10zm15 16 6 4c-2-6-2-12 0-15z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9144",
        d: "m63 251 4 4 1-8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ECA93F",
        d: "M163 225c14-4 29-4 43 0l1-6c-28-7-44 6-44 6m45-45v-7c-31-1-47 14-47 14 15-7 31-10 47-7m-12-40-4-4c-32 0-41 15-41 15 14-9 29-13 45-11"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ECA93F",
        d: "m208 175-4-22-2-1-69-42v6c14 19 45 53 75 59"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E93EE",
        d: "M105 255c4-6 11-10 19-9 20 2 14 27 9 42-4 10-6 21-6 32 0 14 5 19-1 24-11 8-24 11-37 10-11-2-12-26 7-32 5-11 5-23 4-35 0-8-1-24 5-33"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E578B",
        d: "m100 354 5-1c-1-7 1-14 6-19-8 4-10 12-11 20m-11 0c-2-7 0-15 6-21-7 4-11 11-11 18 1 2 3 3 5 3m11-130s-3 14 7 19c8 4 17 4 22-2 7-8 17-25-10-41-16-10-17 24-17 24zm2-66 7 14c0 1 22-27 18-31-4-5-21 11-25 17"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E93EE",
        d: "M123 119c24 22-25 52-25 52 5 3 12 15 17 23 5 9 7 7 13 14s-11 17-11 17-58-31-58-51c0-3 13-25 27-39 7-7 26-27 37-16"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E93EE",
        d: "M101 214s-4 22 8 28c0 0 11 1 16-3 0 0 13-20 3-31-10-10-27 6-27 6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E578B",
        d: "m100 216 20 10c-3 0-6 0-8-2 0 0-5 9 0 14 0 0-7-2-5-15z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E93EE",
        d: "M115 53s9-52 31-53c14-1 21 17 21 17 9 0 17 3 24 8 0 0 4-7 11-5 6 2 14 17 11 42 7 1 12 5 16 10-2 3-5 5-8 5-4 1-23-6-29-2-5 4-8 10-6 17 0 0-22-3-31-15s-18-35-40-24"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F1F1F2",
        d: "M188 56s6-17 16-22c0 9 1 17 3 25zm-45-35s13 6 21 33l-29-2c5-10 7-21 8-31"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2E578B",
        d: "M148 33c3 0 6 3 6 8 0 4-3 8-6 8s-6-4-6-8c0-5 3-8 6-8m49 21c2 0 4-3 4-6s-2-6-4-6h-2l-3 6c0 3 2 6 5 6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9144",
        d: "M144 66s-16-13-24-4c-9 11 0 27 0 27s1-7 5-9c0 0 1 22 38 47 36 25 52 22 60 20s16-8 13-14-24-24-24-24-8 1-23-4c-16-6-37-17-51-36z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6B17",
        d: "M135 95c20-5 41 1 57 15l-4-2s18-1 21 2c11 7 18 19 19 33 1 6-14 10-48-7-21-11-45-41-45-41"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9144",
        d: "M176 99"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EBEEF2",
        d: "M211 109s-5 19-12 17c-2-1-1-6-2-10l-4-11zm34-7s-1 19-8 18c-3 0-3-5-4-9l-6-10z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFCF00",
        d: "M253 85c-1-13-19-19-32-10-10-2-22-9-33 2-4 3-5 9-3 14 0 0-22-3-29-14-8-12-18-27-29-28-5 0-15-1-20 10-6 10-9 30 32 61 42 31 60 39 69 39 11 0 12-4 25-6 6-1 12-12 4-22-6-8-13-14-22-19 0 0 16 13 19 19 3 7-6 11-14 13s-18 4-54-21-40-50-40-50c-5 0-5 10-5 10s-6-12 1-19c9-8 18 2 18 2h-1c-5-2-6 2-6 2 15 19 33 33 55 42 16 6 24-1 24-1 8 0 15 0 23-2 5-1 19-3 18-22"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ECA93F",
        d: "M200 84c4-1 7 4 2 6-1 2 0 4 3 4-3 2-6 1-7-2-2-3-1-7 2-8m42-2c-3-1-5 3-1 5 0 2-1 3-3 4 8 2 8-7 4-9"
    }));

const HuggingFace = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 95 88",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M13 14.789c9.828 0 13-8.763 13-13.263 0-2.338-1.572-1.602-4.09-.356-2.327 1.152-5.462 2.74-8.91 2.74-7.18 0-13-6.884-13-2.384S3.172 14.79 13 14.79"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M93.793 70.08c.75 2.16.57 4.46-.43 6.46-.72 1.46-1.75 2.59-3.01 3.6-1.52 1.2-3.41 2.22-5.69 3.2-2.72 1.16-6.04 2.25-7.56 2.65-3.89 1.01-7.63 1.65-11.42 1.68-5.42.05-10.09-1.23-13.41-4.5-1.72.21-3.46.33-5.21.33-1.66 0-3.3-.1-4.93-.3-3.33 3.25-7.98 4.52-13.38 4.47-3.79-.03-7.53-.67-11.43-1.68-1.51-.4-4.83-1.49-7.55-2.65-2.28-.98-4.17-2-5.68-3.2-1.27-1.01-2.3-2.14-3.02-3.6-.99-2-1.18-4.3-.42-6.46-.7-1.65-.88-3.54-.33-5.63.25-.95.66-1.83 1.18-2.61-.11-.41-.2-.83-.26-1.29-.38-2.74.57-5.24 2.36-7.18.88-.97 1.83-1.64 2.82-2.07-.73-3.1-1.11-6.29-1.11-9.55C5.313 18.69 24.003 0 47.063 0c7.92 0 15.33 2.2 21.65 6.04 1.14.7 2.26 1.45 3.33 2.25.53.4 1.06.81 1.57 1.24.52.42 1.03.86 1.52 1.31 1.48 1.35 2.87 2.8 4.14 4.35.43.51.84 1.04 1.24 1.58q1.215 1.605 2.25 3.33c1.05 1.72 1.97 3.52 2.77 5.39.53 1.25.99 2.53 1.4 3.84a42 42 0 0 1 1.4 6.06c.1.69.19 1.39.26 2.09.14 1.4.22 2.82.22 4.27 0 3.22-.38 6.38-1.09 9.43 1.1.43 2.14 1.13 3.11 2.19 1.79 1.94 2.74 4.45 2.36 7.19-.06.45-.15.87-.26 1.28.52.78.93 1.66 1.18 2.61.55 2.09.37 3.98-.32 5.63"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 46.75,
        cy: 41.75,
        r: 34.75,
        fill: "#FFD21E",
        fillRule: "nonzero"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFAC03",
        fillRule: "nonzero",
        d: "M81.5 41.75C81.5 22.558 65.942 7 46.75 7S12 22.558 12 41.75 27.558 76.5 46.75 76.5 81.5 60.942 81.5 41.75m-73.5 0C8 20.349 25.349 3 46.75 3S85.5 20.349 85.5 41.75 68.151 80.5 46.75 80.5 8 63.151 8 41.75"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3A3B45",
        fillRule: "nonzero",
        d: "M58.04 32.291c1.275.45 1.782 3.07 3.07 2.386a5 5 0 1 0-6.763-2.068c.612 1.151 2.554-.72 3.694-.318M34.484 32.291c-1.275.45-1.782 3.07-3.07 2.386a5 5 0 1 1 6.763-2.068c-.612 1.151-2.554-.72-3.693-.318M46.5 56.289c9.828 0 13-8.763 13-13.263 0-2.338-1.572-1.602-4.09-.356-2.327 1.152-5.462 2.74-8.91 2.74-7.18 0-13-6.884-13-2.384s3.172 13.263 13 13.263"
    }), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(33.5 41.5)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        href: "#prefix__a"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#EF4E4E",
        fillRule: "nonzero",
        d: "M13.25 25a8.673 8.673 0 0 0 2.643-16.936c-.833-.266-1.721 2.598-2.643 2.598-.861 0-1.693-2.882-2.479-2.649A8.673 8.673 0 0 0 13.25 25",
        mask: "url(#prefix__b)"
    })), /*#__PURE__*/ React.createElement("circle", {
        cx: 70.25,
        cy: 33.75,
        r: 3.25,
        fill: "#FFD21E",
        fillRule: "nonzero",
        style: {
            mixBlendMode: "multiply"
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 23.75,
        cy: 33.75,
        r: 3.25,
        fill: "#FFD21E",
        fillRule: "nonzero",
        style: {
            mixBlendMode: "multiply"
        }
    }), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFAC03",
        d: "M17.062 48c-1.62 0-3.066.665-4.075 1.871-.624.747-1.276 1.951-1.33 3.754-.678-.195-1.331-.304-1.941-.304-1.55 0-2.95.594-3.94 1.673-1.272 1.385-1.837 3.087-1.591 4.79.117.811.388 1.538.793 2.211-.854.691-1.483 1.653-1.787 2.81a5.87 5.87 0 0 0 .792 4.742 6 6 0 0 0-.228.394c-.766 1.454-.815 3.097-.14 4.627 1.026 2.319 3.573 4.146 8.519 6.107 3.077 1.22 5.892 2 5.917 2.007 4.068 1.055 7.747 1.591 10.932 1.591 5.854 0 10.045-1.793 12.457-5.329 3.882-5.694 3.327-10.902-1.696-15.922-2.78-2.778-4.628-6.874-5.013-7.773-.776-2.662-2.828-5.621-6.24-5.621q-.432 0-.863.068c-1.494.235-2.8 1.095-3.733 2.389-1.007-1.252-1.985-2.248-2.87-2.81C19.69 48.429 18.358 48 17.062 48m0 4c.51 0 1.133.217 1.82.653 2.133 1.353 6.249 8.428 7.756 11.18.505.922 1.368 1.312 2.145 1.312 1.542 0 2.746-1.533.14-3.481-3.916-2.931-2.542-7.722-.672-8.017q.124-.02.24-.019c1.7 0 2.45 2.93 2.45 2.93s2.199 5.52 5.975 9.293c3.776 3.774 3.97 6.803 1.219 10.839-1.877 2.752-5.47 3.583-9.152 3.583-3.82 0-7.734-.894-9.928-1.463-.108-.028-13.451-3.797-11.761-7.005.284-.539.752-.755 1.34-.755 2.38 0 6.71 3.542 8.57 3.542.417 0 .71-.177.83-.609.793-2.845-12.057-4.041-10.974-8.162.19-.729.709-1.025 1.437-1.024 3.145 0 10.2 5.531 11.68 5.531q.17.001.238-.103c.74-1.196.335-2.031-4.888-5.192s-8.89-5.064-6.804-7.334c.24-.262.58-.378.993-.378 3.17.001 10.663 6.819 10.663 6.819s2.022 2.103 3.245 2.103c.28 0 .52-.111.682-.385.867-1.462-8.053-8.222-8.556-11.011-.341-1.89.239-2.847 1.312-2.847"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFD21E",
        d: "M38.135 76.69c2.752-4.036 2.557-7.065-1.22-10.84-3.775-3.772-5.973-9.292-5.973-9.292s-.821-3.206-2.691-2.911-3.243 5.086.674 8.017-.78 4.92-2.287 2.169-5.622-9.827-7.756-11.18c-2.133-1.353-3.635-.595-3.132 2.194s9.424 9.549 8.556 11.012c-.868 1.462-3.927-1.72-3.927-1.72s-9.572-8.71-11.656-6.44 1.58 4.172 6.804 7.334c5.224 3.16 5.629 3.996 4.888 5.192C19.673 71.42 8.143 61.7 7.06 65.82c-1.082 4.12 11.767 5.317 10.974 8.162s-9.051-5.385-10.74-2.178c-1.69 3.208 11.653 6.977 11.76 7.005 4.31 1.118 15.257 3.487 19.08-2.12"
    })), /*#__PURE__*/ React.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFAC03",
        d: "M76.938 48c1.62 0 3.066.665 4.075 1.871.624.747 1.276 1.951 1.33 3.754.678-.195 1.331-.304 1.941-.304 1.55 0 2.95.594 3.94 1.673 1.272 1.385 1.837 3.087 1.591 4.79a5.85 5.85 0 0 1-.793 2.211c.854.691 1.483 1.653 1.787 2.81a5.87 5.87 0 0 1-.792 4.742q.122.191.228.394c.766 1.454.815 3.097.14 4.627-1.026 2.319-3.573 4.146-8.519 6.107-3.077 1.22-5.892 2-5.917 2.007-4.068 1.055-7.747 1.591-10.932 1.591-5.854 0-10.045-1.793-12.457-5.329-3.882-5.694-3.327-10.902 1.696-15.922 2.78-2.778 4.628-6.874 5.013-7.773.776-2.662 2.828-5.621 6.24-5.621q.432 0 .863.068c1.494.235 2.8 1.095 3.733 2.389 1.007-1.252 1.985-2.248 2.87-2.81C74.31 48.429 75.642 48 76.938 48m0 4c-.51 0-1.133.217-1.82.653-2.133 1.353-6.249 8.428-7.756 11.18-.505.922-1.368 1.312-2.145 1.312-1.542 0-2.746-1.533-.14-3.481 3.916-2.931 2.542-7.722.672-8.017a1.5 1.5 0 0 0-.24-.019c-1.7 0-2.45 2.93-2.45 2.93s-2.199 5.52-5.975 9.293c-3.776 3.774-3.97 6.803-1.219 10.839 1.877 2.752 5.47 3.583 9.152 3.583 3.82 0 7.734-.894 9.928-1.463.108-.028 13.451-3.797 11.761-7.005-.284-.539-.752-.755-1.34-.755-2.38 0-6.71 3.542-8.57 3.542-.417 0-.71-.177-.83-.609-.793-2.845 12.057-4.041 10.974-8.162-.19-.729-.709-1.025-1.437-1.024-3.145 0-10.2 5.531-11.68 5.531q-.17.001-.238-.103c-.74-1.196-.335-2.031 4.888-5.192s8.89-5.064 6.804-7.334c-.24-.262-.58-.378-.993-.378-3.17.001-10.663 6.819-10.663 6.819s-2.022 2.103-3.245 2.103a.74.74 0 0 1-.682-.385c-.867-1.462 8.053-8.222 8.556-11.011.341-1.89-.239-2.847-1.312-2.847"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFD21E",
        d: "M55.865 76.69c-2.752-4.036-2.557-7.065 1.22-10.84 3.775-3.772 5.973-9.292 5.973-9.292s.821-3.206 2.691-2.911 3.243 5.086-.674 8.017.78 4.92 2.287 2.169 5.622-9.827 7.756-11.18c2.133-1.353 3.635-.595 3.132 2.194s-9.424 9.549-8.556 11.012c.868 1.462 3.927-1.72 3.927-1.72s9.572-8.71 11.656-6.44-1.58 4.172-6.804 7.334c-5.224 3.16-5.629 3.996-4.888 5.192.742 1.196 12.272-8.525 13.355-4.404 1.082 4.12-11.767 5.317-10.974 8.162s9.051-5.385 10.74-2.178c1.69 3.208-11.653 6.977-11.76 7.005-4.31 1.118-15.257 3.487-19.08-2.12"
    }))));

const Hugo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        strokeWidth: 27,
        "aria-label": "Logo",
        viewBox: "0 0 1493 391",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ebb951",
        stroke: "#fcd804",
        d: "m1345.211 24.704 112.262 64.305a43 43 0 0 1 21.627 37.312v142.237a40 40 0 0 1-20.702 35.037l-120.886 66.584a42 42 0 0 1-41.216-.389l-106.242-61.155a57 57 0 0 1-28.564-49.4V138.71a64 64 0 0 1 31.172-54.939l98.01-58.564a54 54 0 0 1 54.54-.503z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#33ba91",
        stroke: "#00a88a",
        d: "m958.07 22.82 117.31 66.78a41 41 0 0 1 20.72 35.64v139.5a45 45 0 0 1-23.1 39.32L955.68 369.4a44 44 0 0 1-43.54-.41l-105.82-61.6a56 56 0 0 1-27.83-48.4V140.07a68 68 0 0 1 33.23-58.44l98.06-58.35a48 48 0 0 1 48.3-.46z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0594cb",
        stroke: "#0083c0",
        d: "m575.26 20.97 117.23 68.9a40 40 0 0 1 19.73 34.27l.73 138.67a48 48 0 0 1-24.64 42.2l-115.13 64.11a45 45 0 0 1-44.53-.42l-105.83-61.6a55 55 0 0 1-27.33-47.53V136.52a63 63 0 0 1 29.87-53.59l99.3-61.4a49 49 0 0 1 50.6-.56z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ff4088",
        stroke: "#c9177e",
        d: "m195.81 24.13 114.41 66.54a44 44 0 0 1 21.88 38.04v136.43a48 48 0 0 1-24.45 41.82L194.1 370.9a49 49 0 0 1-48.48-.23L41.05 310.48a53 53 0 0 1-26.56-45.93V135.08a55 55 0 0 1 26.1-46.8l102.8-63.46a51 51 0 0 1 52.42-.69z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M1320.72 89.15c58.79 0 106.52 47.73 106.52 106.51 0 58.8-47.73 106.52-106.52 106.52-58.78 0-106.52-47.73-106.52-106.52 0-58.78 47.74-106.51 106.52-106.51m0 39.57c36.95 0 66.94 30 66.94 66.94a66.97 66.97 0 0 1-66.94 66.94c-36.95 0-66.94-29.99-66.94-66.94a66.97 66.97 0 0 1 66.93-66.94zm-283.8 65.31c0 47.18-8.94 60.93-26.81 80.58s-41.57 27.57-71.1 27.57c-27 0-48.75-9.58-67.61-26.23-20.88-18.45-36.08-47.04-36.08-78.95 0-31.37 11.72-58.48 32.49-78.67 18.22-17.67 45.34-29.18 73.3-29.18 33.77 0 68.83 15.98 90.44 47.53l-31.73 26.82c-13.45-25.03-32.94-33.46-60.82-34.26-30.83-.88-64.77 28.53-62.25 67.75 1.4 21.94 11.65 59.65 60.96 66.57 25.9 3.63 55.36-24.02 55.36-39.04H944.4v-37.5h92.5V194zm-562.6-94.65h42.29v112.17c0 17.8.49 29.33 1.47 34.61 1.69 8.48 4.81 14.37 11.17 19.5 6.37 5.13 13.8 6.59 24.84 6.59 11.2 0 14.96-1.74 20.66-6.6 5.69-4.85 9.12-9.46 10.28-16.53 1.15-7.07 3.07-18.8 3.07-35.18V99.38h42.28v108.78c0 24.86-1.07 42.43-3.21 52.69-2.14 10.27-6.08 18.93-11.82 26-5.74 7.06-13.42 12.69-23.03 16.88-9.62 4.19-22.16 6.28-37.65 6.28-18.7 0-32.87-2.28-42.52-6.85-9.66-4.57-17.3-10.5-22.9-17.8-5.61-7.3-9.3-14.95-11.08-22.96-2.58-11.86-3.88-29.38-3.88-52.55V99.38zM93.91 299.92V92.7h43.35v75.48h71.92V92.7h43.48v207.22h-43.48v-90.61h-71.92v90.61z"
    }));

const HuluDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 251 83",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M153.602 82.461h19.917V.016h-19.917zm-34.97-23.506c0 2.895-2.431 5.326-5.326 5.326h-11.58c-2.895 0-5.326-2.431-5.326-5.326V25.722H76.483v34.854c0 14.243 9.148 21.77 22.58 21.77h19.453c12.39 0 19.917-8.917 19.917-21.77V25.722h-19.917c.116 0 .116 32.19.116 33.233m111.973-33.233v33.233c0 2.895-2.431 5.326-5.326 5.326h-11.58c-2.894 0-5.326-2.431-5.326-5.326V25.722h-19.917v34.854c0 14.243 9.148 21.77 22.58 21.77h19.454c12.39 0 19.916-8.917 19.916-21.77V25.722zm-190.829 0H27.04c-4.516 0-6.716 1.158-6.716 1.158V.016H.406v82.33h19.801V49.227c0-2.895 2.432-5.326 5.327-5.326h11.58c2.894 0 5.326 2.431 5.326 5.326v33.233h19.916V46.565c0-15.053-10.074-20.843-22.58-20.843"
    }));

const HuluLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 251 83",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1CE783",
        d: "M153.602 82.461h19.917V.016h-19.917zm-34.97-23.506c0 2.895-2.431 5.326-5.326 5.326h-11.58c-2.895 0-5.326-2.431-5.326-5.326V25.722H76.483v34.854c0 14.243 9.148 21.77 22.58 21.77h19.453c12.39 0 19.917-8.917 19.917-21.77V25.722h-19.917c.116 0 .116 32.19.116 33.233m111.973-33.233v33.233c0 2.895-2.431 5.326-5.326 5.326h-11.58c-2.894 0-5.326-2.431-5.326-5.326V25.722h-19.917v34.854c0 14.243 9.148 21.77 22.58 21.77h19.454c12.39 0 19.916-8.917 19.916-21.77V25.722zm-190.829 0H27.04c-4.516 0-6.716 1.158-6.716 1.158V.016H.406v82.33h19.801V49.227c0-2.895 2.432-5.326 5.327-5.326h11.58c2.894 0 5.326 2.431 5.326 5.326v33.233h19.916V46.565c0-15.053-10.074-20.843-22.58-20.843"
    }));

const HumeAI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1200 1200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFB5D6",
        d: "M242.943 604.746c-41.866 9.613-67.919 49.204-57.737 91.641 9.614 42.434 50.342 67.351 91.64 57.735 41.866-9.612 67.35-49.204 57.736-91.638-9.613-42.491-50.341-67.35-91.639-57.738"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D2A7E9",
        d: "M279.093 444.599c33.391 26.621 80.32 22.071 107.51-11.889 27.133-33.96 20.933-80.888-11.888-107.51-32.822-26.621-80.377-22.071-107.51 11.889s-20.933 80.888 11.888 107.51"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFDCDC",
        d: "M481.686 846.912c-39.022-18.657-83.733-2.843-102.39 35.668-18.658 38.452-3.413 83.164 35.666 102.389 39.022 18.661 83.732 2.846 102.39-35.665 18.089-39.023 3.413-83.732-35.666-102.392"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFD1A4",
        d: "M717.045 846.879c-39.021 18.656-54.325 63.936-35.665 102.389 18.657 38.455 62.798 54.892 102.389 35.667 39.024-18.656 54.325-63.936 35.668-102.389-18.66-38.455-63.311-54.895-102.392-35.667"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M955.866 604.743c-41.866-9.612-82.025 15.304-91.638 57.738-9.615 42.434 15.869 82.593 57.735 91.638 41.866 9.615 82.027-15.301 91.637-57.735 9.62-42.434-15.868-82.025-57.734-91.641"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A0B0F6",
        d: "M930.389 444.667c33.393-26.622 39.023-73.551 11.89-107.511s-74.12-38.453-107.509-11.888c-33.393 26.622-39.024 73.55-11.891 107.51 27.191 33.959 74.12 38.453 107.51 11.889"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#BBABED",
        d: "M599.384 177c-44.145 0-76.966 33.959-76.966 76.963s32.821 76.964 76.966 76.964c43.569 0 76.962-33.96 76.962-76.964-.058-43.061-33.393-76.963-76.962-76.963"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 917.02,
        x2: 959.498,
        y1: 753.152,
        y2: 610.135,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.266,
        stopColor: "#FFB7B2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.578,
        stopColor: "#AB9EFC"
    }))));

const IBM = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1000 400",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1f70c1",
        d: "M0 0v27.367h194.648V0zm222.226 0v27.367h277.383S471.276 0 433.75 0zm331.797 0v27.367h167.812L711.875 0zm288.125 0-9.961 27.367h166.289V0zM0 53.222v27.367h194.648V53.222zm222.226.039V80.59h309.57s-3.615-21.063-9.922-27.329zm331.797 0V80.59h186.211l-9.219-27.329zm268.203 0-9.219 27.329h185.469V53.261zM55.937 106.444v27.406h84.297v-27.406zm222.227 0v27.406h84.297v-27.406zm166.289 0v27.406h84.297s5.352-14.473 5.352-27.406zm165.508 0v27.406h149.453l-9.961-27.406zm193.906 0-10 27.406h150.195v-27.406zm-747.93 53.262v27.367h84.297v-27.367zm222.227 0v27.367h215.312s18.012-14.042 23.75-27.367zm331.797 0v27.367h84.297v-15.234l5.352 15.234h154.414l5.742-15.234v15.234h84.297v-27.367H785.82l-8.398 23.18-8.438-23.18zM55.937 212.928v27.367h84.297v-27.367zm222.227 0v27.367h239.062c-5.739-13.281-23.75-27.367-23.75-27.367zm331.797 0v27.367h84.297v-27.367zm99.609 0 10.195 27.367h115.781l9.688-27.367zm150.195 0v27.367h84.297v-27.367zM55.937 266.15v27.366h84.297V266.15zm222.227 0v27.366h84.297V266.15zm166.289 0v27.366h89.648c0-12.915-5.352-27.366-5.352-27.366zm165.508 0v27.366h84.297V266.15zm118.75 0 9.883 27.366h77.617l9.961-27.366zm131.054 0v27.366h84.297V266.15zM1.523 319.372v27.406h194.648v-27.406zm220.703 0v27.406h299.648c6.307-6.275 9.922-27.406 9.922-27.406zm333.321 0v27.406h138.711v-27.406zm192.343 0 10.156 27.406h39.492l9.531-27.406zm111.875 0v27.406H1000v-27.406zM1.523 372.633V400h194.648v-27.367zm220.703 0v27.328H433.75c37.526 0 65.859-27.328 65.859-27.328zm333.321 0V400h138.711v-27.367zm211.601 0 9.766 27.29 1.68.038 9.922-27.328zm92.617 0V400H1000v-27.367z"
    }));

const Illustrator = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 83 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#300",
        d: "M67.521 0H14.53C6.505 0 0 6.505 0 14.53v50.94C0 73.495 6.505 80 14.53 80H67.52c8.025 0 14.53-6.505 14.53-14.53V14.53C82.051 6.505 75.546 0 67.521 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9A00",
        d: "M39.76 48.01H27.047l-2.587 8.036a.65.65 0 0 1-.66.495h-6.44q-.551 0-.386-.605L27.982 24.23q.165-.495.33-1.128.216-1.105.22-2.23a.34.34 0 0 1 .385-.385h8.752q.385 0 .44.276L50.604 55.99q.165.55-.33.55h-7.156a.51.51 0 0 1-.55-.385zm-10.733-6.936h8.697q-.33-1.1-.77-2.477-.442-1.374-.936-2.944l-.991-3.138a105 105 0 0 1-.908-3.027q-.413-1.458-.743-2.67h-.055a45 45 0 0 1-1.156 4.404q-.771 2.476-1.569 5.063a136 136 0 0 1-1.569 4.79M58.034 26.323a4 4 0 0 1-3.027-1.211 4.36 4.36 0 0 1-1.156-3.137 4.04 4.04 0 0 1 1.238-3.055 4.25 4.25 0 0 1 3.055-1.184q1.982 0 3.11 1.184a4.25 4.25 0 0 1 1.129 3.055 4.3 4.3 0 0 1-1.184 3.137 4.22 4.22 0 0 1-3.165 1.21M54.236 55.99V29.68q0-.495.44-.496h6.77q.441 0 .441.495v26.31q0 .552-.44.551h-6.715q-.495 0-.496-.55"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h82.051v80H0z"
    }))));

const InDesign = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 83 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#49021F",
        d: "M67.521 0H14.53C6.505 0 0 6.505 0 14.53v50.94C0 73.495 6.505 80 14.53 80H67.52c8.025 0 14.53-6.505 14.53-14.53V14.53C82.051 6.505 75.546 0 67.521 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F36",
        d: "M29.798 20.929V55.99q0 .55-.496.55h-6.66q-.44 0-.44-.55V20.929q0-.44.495-.44h6.66a.39.39 0 0 1 .44.44M49.503 57.092a17.05 17.05 0 0 1-7.348-1.541 11.7 11.7 0 0 1-5.147-4.651q-1.871-3.11-1.871-7.789a14.4 14.4 0 0 1 1.871-7.21 13.74 13.74 0 0 1 5.45-5.285q3.577-1.98 8.641-1.981.275 0 .716.027.44.03 1.046.083V17.9q0-.384.33-.385h6.935a.29.29 0 0 1 .33.33v32.53q0 .938.083 2.037.083 1.102.138 1.982a.57.57 0 0 1-.33.55c-1.79.746-3.653 1.3-5.56 1.651a30 30 0 0 1-5.284.496m3.358-6.825V35.24a5.5 5.5 0 0 0-.908-.165 11 11 0 0 0-1.129-.055 8.5 8.5 0 0 0-3.853.88 7.5 7.5 0 0 0-2.89 2.532q-1.128 1.651-1.128 4.349c-.027 1.2.17 2.394.578 3.522.333.91.858 1.736 1.541 2.422a5.9 5.9 0 0 0 2.312 1.376 9 9 0 0 0 2.835.44q.77 0 1.43-.054c.41-.031.817-.105 1.212-.22"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h82.051v80H0z"
    }))));

const InflectionAIDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M11.97 31c-.61 0-.97-.386-.97-1.03v-.34c0-.642.286-.942.817-1.156L13 28.045c.817-.34 1.101-.729 1.101-1.629V5.584c0-.9-.284-1.286-1.101-1.63l-1.191-.428c-.53-.214-.809-.51-.809-1.157v-.34c0-.643.367-1.029.979-1.029h8.04c.614 0 .981.386.981 1.03v.34c0 .642-.286.942-.817 1.156l-1.19.425c-.858.34-1.145.729-1.145 1.63v20.828c0 .9.287 1.286 1.144 1.63l1.183.428c.53.214.817.51.817 1.157v.34c0 .643-.367 1.03-.98 1.03z"
    }));

const InflectionAILight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M11.97 31c-.61 0-.97-.386-.97-1.03v-.34c0-.642.286-.942.817-1.156L13 28.045c.817-.34 1.101-.729 1.101-1.629V5.584c0-.9-.284-1.286-1.101-1.63l-1.191-.428c-.53-.214-.809-.51-.809-1.157v-.34c0-.643.367-1.029.979-1.029h8.04c.614 0 .981.386.981 1.03v.34c0 .642-.286.942-.817 1.156l-1.19.425c-.858.34-1.145.729-1.145 1.63v20.828c0 .9.287 1.286 1.144 1.63l1.183.428c.53.214.817.51.817 1.157v.34c0 .643-.367 1.03-.98 1.03z"
    }));

const Infojobs = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 138 136.1",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M138 113c0 12.8-10.3 23.1-23.1 23.1H23.1C10.3 136.1 0 125.7 0 113V23.1C0 10.3 10.3 0 23.1 0h91.8C127.7 0 138 10.3 138 23.1z",
        style: {
            fill: "#167db7"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.9 89.3c-.1.7-.7 1.2-1.5 1.2H45.3c-.7 0-1.3-.4-1.3-1.1l.1-.2 7.1-59.3c.1-.7.2-1 1-1.1h12c.6 0 .9.4.9 1v.2zm28.3 2c-1.6 12.9-9.7 15.9-19.4 15.9-5.7 0-6.5-.2-8-.4-.7-.1-1.5-.2-1.5-1.3v-.5l.6-4.8c.2-1.4.7-1.7 2-1.7 1.2-.1 2.7-.1 4.5-.2 4.3-.2 7.3-.6 8.1-6.7L80 30c.1-.7.7-1.1 1.4-1.2l11.3.2h.2c.7 0 1 .4 1 1z",
        style: {
            fill: "#fff"
        }
    }));

const InngestDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 100 30",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M.928.729Q0 1.458 0 2.769q0 1.297.928 2.026.928.73 2.184.73 1.243 0 2.163-.737.92-.736.92-2.019 0-1.311-.92-2.04Q4.354 0 3.112 0 1.856 0 .928.729m4.931 6.078H.336V21.31H5.86zM7.11 21.31V6.559h4.865l.248 1.618A5.3 5.3 0 0 1 14.37 6.66a6.6 6.6 0 0 1 2.368-.452h.146q.979.015 1.804.226t1.57.714q.747.504 1.272 1.283.525.78.833 1.975t.307 2.726v8.177H17.16v-8.148q0-1.268-.599-1.859-.6-.59-1.476-.59-1.065 0-1.804.736-.738.736-.738 2.106v7.755zM23.713 6.559v14.75h5.436v-7.754q0-1.37.738-2.106t1.804-.736q.878 0 1.476.59.6.59.6 1.859v8.147h5.508v-8.176q0-1.531-.307-2.726t-.833-1.975a4.7 4.7 0 0 0-1.271-1.283 5 5 0 0 0-1.57-.714 7.7 7.7 0 0 0-1.806-.226h-.146q-1.183 0-2.367.452a5.3 5.3 0 0 0-2.148 1.516l-.248-1.618zm16.536 7.106q0-2.259 1.103-3.994a7.2 7.2 0 0 1 2.966-2.645q1.863-.91 4.157-.911 1.55 0 3.054.554l1.202-1.52q.243-.31.391-.506l2.546.622 1.428 2.22-1.914 2.26q1.418 1.573 1.418 3.687v.291a5.86 5.86 0 0 1-.73 2.697 6.44 6.44 0 0 1-1.974 2.2q.95.54 1.586 1.21.636.671.899 1.32t.343 1.07q.08.425.08.846 0 1.386-.467 2.507-.468 1.123-1.264 1.866-.797.742-1.885 1.246a9.5 9.5 0 0 1-2.272.722q-1.184.218-2.499.218-3.96 0-6.064-1.938-1.9-1.75-1.9-4.679 0-.306.015-.627h5.173v.102q0 .718.176 1.221l.028.076q.206.584.621.875.417.291.884.408.468.117 1.067.117 1.155 0 1.943-.547.79-.546.79-1.567 0-.889-.636-1.428-.611-.518-1.932-.539h-.106q-3.741 0-5.984-2.012-2.243-2.01-2.243-5.422m6.173 2.07q-.81-.795-.81-2.092 0-1.429.803-2.238.804-.809 2.06-.809 1.2 0 1.995.89.795.888.796 2.157 0 1.4-.803 2.142-.804.744-1.987.744-1.243 0-2.053-.795M57.4 13.962q0-1.56.474-2.864.475-1.304 1.272-2.193A7.7 7.7 0 0 1 61 7.397a8.3 8.3 0 0 1 2.229-.904q1.169-.285 2.396-.284 1.972 0 3.587.634t2.682 1.83q1.066 1.194 1.475 2.915.172.727.177 1.53l-.001.16q0 1.035-.249 2.216h-10.33q.277.903 1.27 1.392.994.488 2.032.488 2.191 0 3.799-1.195l2.689 3.017a8.7 8.7 0 0 1-3.047 1.83q-1.746.619-3.69.619-1.797 0-3.324-.452a8.4 8.4 0 0 1-2.725-1.363q-1.198-.91-1.885-2.412-.686-1.501-.686-3.455m10.958-1.996h-5.362q.101-.686.68-1.152.577-.466 1.336-.568a5.6 5.6 0 0 1 1.49.014q.747.117 1.28.576.533.46.576 1.13m5.212 7.798 1.797-4.009q1.038.671 2.119 1.057 1.08.386 1.688.466.606.08 1.424.124 1.505 0 1.505-.714 0-.685-1.563-.816a11.6 11.6 0 0 1-1.776-.19 8 8 0 0 1-1.702-.524 5.7 5.7 0 0 1-1.468-.897 4 4 0 0 1-1.008-1.363q-.388-.83-.388-1.865 0-1.283.57-2.245a4.1 4.1 0 0 1 1.549-1.509 8 8 0 0 1 2.163-.808 11.7 11.7 0 0 1 2.542-.263q1.769 0 3.36.481 1.594.48 2.69 1.312l-2.338 3.28q-.564-.358-1.581-.61l-.13-.032q-1.05-.262-1.913-.262h-.088q-1.315 0-1.315.729 0 .263.256.48.239.205.776.23l.078.004q1.023.03 1.9.16a9.4 9.4 0 0 1 1.805.466q.927.336 1.585.86.657.525 1.074 1.393.417.866.416 1.989 0 1.064-.372 1.917a4 4 0 0 1-1.016 1.42 5.7 5.7 0 0 1-1.534.956 8 8 0 0 1-1.878.553q-.985.168-2.082.168-1.972 0-3.945-.517-1.973-.518-3.2-1.421M87.857 6.646v4.213h2.367v5.087q-.015 1.195.248 2.142.292 1.05.79 1.713.496.663 1.212 1.093t1.505.605a8 8 0 0 0 1.71.175q2.512 0 4.252-.991l-1.199-4.067q-.788.51-1.607.51-1.432 0-1.476-1.428v-4.84h3.361V6.647h-3.331V2.39l-5.465.598v3.658z",
        clipRule: "evenodd"
    }));

const InngestLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 100 30",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M.928.729Q0 1.458 0 2.769q0 1.297.928 2.026.928.73 2.184.73 1.243 0 2.163-.737.92-.736.92-2.019 0-1.311-.92-2.04Q4.354 0 3.112 0 1.856 0 .928.729m4.931 6.078H.336V21.31H5.86zM7.11 21.31V6.559h4.865l.248 1.618A5.3 5.3 0 0 1 14.37 6.66a6.6 6.6 0 0 1 2.368-.452h.146q.979.015 1.804.226t1.57.714q.747.504 1.272 1.283.525.78.833 1.975t.307 2.726v8.177H17.16v-8.148q0-1.268-.599-1.859-.6-.59-1.476-.59-1.065 0-1.804.736-.738.736-.738 2.106v7.755zM23.713 6.559v14.75h5.436v-7.754q0-1.37.738-2.106t1.804-.736q.878 0 1.476.59.6.59.6 1.859v8.147h5.508v-8.176q0-1.531-.307-2.726t-.833-1.975a4.7 4.7 0 0 0-1.271-1.283 5 5 0 0 0-1.57-.714 7.7 7.7 0 0 0-1.806-.226h-.146q-1.183 0-2.367.452a5.3 5.3 0 0 0-2.148 1.516l-.248-1.618zm16.536 7.106q0-2.259 1.103-3.994a7.2 7.2 0 0 1 2.966-2.645q1.863-.91 4.157-.911 1.55 0 3.054.554l1.202-1.52q.243-.31.391-.506l2.546.622 1.428 2.22-1.914 2.26q1.418 1.573 1.418 3.687v.291a5.86 5.86 0 0 1-.73 2.697 6.44 6.44 0 0 1-1.974 2.2q.95.54 1.586 1.21.636.671.899 1.32t.343 1.07q.08.425.08.846 0 1.386-.467 2.507-.468 1.123-1.264 1.866-.797.742-1.885 1.246a9.5 9.5 0 0 1-2.272.722q-1.184.218-2.499.218-3.96 0-6.064-1.938-1.9-1.75-1.9-4.679 0-.306.015-.627h5.173v.102q0 .718.176 1.221l.028.076q.206.584.621.875.417.291.884.408.468.117 1.067.117 1.155 0 1.943-.547.79-.546.79-1.567 0-.889-.636-1.428-.611-.518-1.932-.539h-.106q-3.741 0-5.984-2.012-2.243-2.01-2.243-5.422m6.173 2.07q-.81-.795-.81-2.092 0-1.429.803-2.238.804-.809 2.06-.809 1.2 0 1.995.89.795.888.796 2.157 0 1.4-.803 2.142-.804.744-1.987.744-1.243 0-2.053-.795M57.4 13.962q0-1.56.474-2.864.475-1.304 1.272-2.193A7.7 7.7 0 0 1 61 7.397a8.3 8.3 0 0 1 2.229-.904q1.169-.285 2.396-.284 1.972 0 3.587.634t2.682 1.83q1.066 1.194 1.475 2.915.172.727.177 1.53l-.001.16q0 1.035-.249 2.216h-10.33q.277.903 1.27 1.392.994.488 2.032.488 2.191 0 3.799-1.195l2.689 3.017a8.7 8.7 0 0 1-3.047 1.83q-1.746.619-3.69.619-1.797 0-3.324-.452a8.4 8.4 0 0 1-2.725-1.363q-1.198-.91-1.885-2.412-.686-1.501-.686-3.455m10.958-1.996h-5.362q.101-.686.68-1.152.577-.466 1.336-.568a5.6 5.6 0 0 1 1.49.014q.747.117 1.28.576.533.46.576 1.13m5.212 7.798 1.797-4.009q1.038.671 2.119 1.057 1.08.386 1.688.466.606.08 1.424.124 1.505 0 1.505-.714 0-.685-1.563-.816a11.6 11.6 0 0 1-1.776-.19 8 8 0 0 1-1.702-.524 5.7 5.7 0 0 1-1.468-.897 4 4 0 0 1-1.008-1.363q-.388-.83-.388-1.865 0-1.283.57-2.245a4.1 4.1 0 0 1 1.549-1.509 8 8 0 0 1 2.163-.808 11.7 11.7 0 0 1 2.542-.263q1.769 0 3.36.481 1.594.48 2.69 1.312l-2.338 3.28q-.564-.358-1.581-.61l-.13-.032q-1.05-.262-1.913-.262h-.088q-1.315 0-1.315.729 0 .263.256.48.239.205.776.23l.078.004q1.023.03 1.9.16a9.4 9.4 0 0 1 1.805.466q.927.336 1.585.86.657.525 1.074 1.393.417.866.416 1.989 0 1.064-.372 1.917a4 4 0 0 1-1.016 1.42 5.7 5.7 0 0 1-1.534.956 8 8 0 0 1-1.878.553q-.985.168-2.082.168-1.972 0-3.945-.517-1.973-.518-3.2-1.421M87.857 6.646v4.213h2.367v5.087q-.015 1.195.248 2.142.292 1.05.79 1.713.496.663 1.212 1.093t1.505.605a8 8 0 0 0 1.71.175q2.512 0 4.252-.991l-1.199-4.067q-.788.51-1.607.51-1.432 0-1.476-1.428v-4.84h3.361V6.647h-3.331V2.39l-5.465.598v3.658z",
        clipRule: "evenodd"
    }));

const InstagramDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M128 23.064c34.177 0 38.225.13 51.722.745 12.48.57 19.258 2.655 23.769 4.408 5.974 2.322 10.238 5.096 14.717 9.575s7.253 8.743 9.575 14.717c1.753 4.511 3.838 11.289 4.408 23.768.615 13.498.745 17.546.745 51.723s-.13 38.226-.745 51.723c-.57 12.48-2.655 19.257-4.408 23.768-2.322 5.974-5.096 10.239-9.575 14.718s-8.743 7.253-14.717 9.574c-4.511 1.753-11.289 3.839-23.769 4.408-13.495.616-17.543.746-51.722.746s-38.228-.13-51.723-.746c-12.48-.57-19.257-2.655-23.768-4.408-5.974-2.321-10.239-5.095-14.718-9.574-4.479-4.48-7.253-8.744-9.574-14.718-1.753-4.51-3.839-11.288-4.408-23.768-.616-13.497-.746-17.545-.746-51.723s.13-38.225.746-51.722c.57-12.48 2.655-19.258 4.408-23.769 2.321-5.974 5.095-10.238 9.574-14.717 4.48-4.48 8.744-7.253 14.718-9.575 4.51-1.753 11.288-3.838 23.768-4.408 13.497-.615 17.545-.745 51.723-.745M128 0C93.237 0 88.878.147 75.226.77c-13.625.622-22.93 2.786-31.071 5.95-8.418 3.271-15.556 7.648-22.672 14.764S9.991 35.738 6.72 44.155C3.555 52.297 1.392 61.602.77 75.226.147 88.878 0 93.237 0 128s.147 39.122.77 52.774c.622 13.625 2.785 22.93 5.95 31.071 3.27 8.417 7.647 15.556 14.763 22.672s14.254 11.492 22.672 14.763c8.142 3.165 17.446 5.328 31.07 5.95 13.653.623 18.012.77 52.775.77s39.122-.147 52.774-.77c13.624-.622 22.929-2.785 31.07-5.95 8.418-3.27 15.556-7.647 22.672-14.763s11.493-14.254 14.764-22.672c3.164-8.142 5.328-17.446 5.95-31.07.623-13.653.77-18.012.77-52.775s-.147-39.122-.77-52.774c-.622-13.624-2.786-22.929-5.95-31.07-3.271-8.418-7.648-15.556-14.764-22.672S220.262 9.99 211.845 6.72c-8.142-3.164-17.447-5.328-31.071-5.95C167.122.147 162.763 0 128 0m0 62.27c-36.302 0-65.73 29.43-65.73 65.73 0 36.302 29.428 65.73 65.73 65.73 36.301 0 65.73-29.428 65.73-65.73 0-36.301-29.429-65.73-65.73-65.73m0 108.397c-23.564 0-42.667-19.103-42.667-42.667S104.436 85.333 128 85.333s42.667 19.103 42.667 42.667-19.103 42.667-42.667 42.667m83.686-110.994c0 8.484-6.876 15.36-15.36 15.36s-15.36-6.876-15.36-15.36 6.877-15.36 15.36-15.36 15.36 6.877 15.36 15.36"
    }));

const InstagramLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0A0A08",
        d: "M128 23.064c34.177 0 38.225.13 51.722.745 12.48.57 19.258 2.655 23.769 4.408 5.974 2.322 10.238 5.096 14.717 9.575s7.253 8.743 9.575 14.717c1.753 4.511 3.838 11.289 4.408 23.768.615 13.498.745 17.546.745 51.723s-.13 38.226-.745 51.723c-.57 12.48-2.655 19.257-4.408 23.768-2.322 5.974-5.096 10.239-9.575 14.718s-8.743 7.253-14.717 9.574c-4.511 1.753-11.289 3.839-23.769 4.408-13.495.616-17.543.746-51.722.746s-38.228-.13-51.723-.746c-12.48-.57-19.257-2.655-23.768-4.408-5.974-2.321-10.239-5.095-14.718-9.574-4.479-4.48-7.253-8.744-9.574-14.718-1.753-4.51-3.839-11.288-4.408-23.768-.616-13.497-.746-17.545-.746-51.723s.13-38.225.746-51.722c.57-12.48 2.655-19.258 4.408-23.769 2.321-5.974 5.095-10.238 9.574-14.717 4.48-4.48 8.744-7.253 14.718-9.575 4.51-1.753 11.288-3.838 23.768-4.408 13.497-.615 17.545-.745 51.723-.745M128 0C93.237 0 88.878.147 75.226.77c-13.625.622-22.93 2.786-31.071 5.95-8.418 3.271-15.556 7.648-22.672 14.764S9.991 35.738 6.72 44.155C3.555 52.297 1.392 61.602.77 75.226.147 88.878 0 93.237 0 128s.147 39.122.77 52.774c.622 13.625 2.785 22.93 5.95 31.071 3.27 8.417 7.647 15.556 14.763 22.672s14.254 11.492 22.672 14.763c8.142 3.165 17.446 5.328 31.07 5.95 13.653.623 18.012.77 52.775.77s39.122-.147 52.774-.77c13.624-.622 22.929-2.785 31.07-5.95 8.418-3.27 15.556-7.647 22.672-14.763s11.493-14.254 14.764-22.672c3.164-8.142 5.328-17.446 5.95-31.07.623-13.653.77-18.012.77-52.775s-.147-39.122-.77-52.774c-.622-13.624-2.786-22.929-5.95-31.07-3.271-8.418-7.648-15.556-14.764-22.672S220.262 9.99 211.845 6.72c-8.142-3.164-17.447-5.328-31.071-5.95C167.122.147 162.763 0 128 0m0 62.27c-36.302 0-65.73 29.43-65.73 65.73 0 36.302 29.428 65.73 65.73 65.73 36.301 0 65.73-29.428 65.73-65.73 0-36.301-29.429-65.73-65.73-65.73m0 108.397c-23.564 0-42.667-19.103-42.667-42.667S104.436 85.333 128 85.333s42.667 19.103 42.667 42.667-19.103 42.667-42.667 42.667m83.686-110.994c0 8.484-6.876 15.36-15.36 15.36s-15.36-6.876-15.36-15.36 6.877-15.36 15.36-15.36 15.36 6.877 15.36 15.36"
    }));

const InstatusDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 216 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#fff",
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M74.46 229.59a101.18 101.18 0 0 1-52.44-46.76C-4.37 133.33 14.38 71.8 63.89 45.41c48.22-25.7 107.83-8.58 135.28 38.06-13 30.14-33.75 61.99-61.15 91.63-20.22 21.86-41.91 40.21-63.56 54.49"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.7 253.6c-11.31-8.5-.4-36.72 13.71-55.87l4.37 6.17c-5.24 12.38-14.4 37.57 23.17 8.53 37.56-29.05 100.5-109.99 127.52-158.8 21.62-39.06-1.76-29.79-15.78-20.8l-6.15-3.31C165.79 15.7 190.6-.92 202.49 4.3c25.77 11.34 6.58 85.08-51.37 156.58C93.17 232.4 20.65 265.6 4.7 253.6m207.97-129.58a101.61 101.61 0 0 1-53.24 100.69 101.2 101.2 0 0 1-40.11 11.67c13.14-24.49 30.85-49.62 52.6-73.5a391 391 0 0 1 40.75-38.86"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h215.37v256H0z"
    }))));

const InstatusLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 216 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#000",
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M74.46 229.59a101.18 101.18 0 0 1-52.44-46.76C-4.37 133.33 14.38 71.8 63.89 45.41c48.22-25.7 107.83-8.58 135.28 38.06-13 30.14-33.75 61.99-61.15 91.63-20.22 21.86-41.91 40.21-63.56 54.49"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.7 253.6c-11.31-8.5-.4-36.72 13.71-55.87l4.37 6.17c-5.24 12.38-14.4 37.57 23.17 8.53 37.56-29.05 100.5-109.99 127.52-158.8 21.62-39.06-1.76-29.79-15.78-20.8l-6.15-3.31C165.79 15.7 190.6-.92 202.49 4.3c25.77 11.34 6.58 85.08-51.37 156.58C93.17 232.4 20.65 265.6 4.7 253.6m207.97-129.58a101.61 101.61 0 0 1-53.24 100.69 101.2 101.2 0 0 1-40.11 11.67c13.14-24.49 30.85-49.62 52.6-73.5a391 391 0 0 1 40.75-38.86"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h215.37v256H0z"
    }))));

const IntelliJIDEA = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "37%",
        x2: "178.1%",
        y1: "51%",
        y2: "41.9%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "9%",
        stopColor: "#FC801D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "23%",
        stopColor: "#B07F61"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "41%",
        stopColor: "#577DB3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "53%",
        stopColor: "#1E7CE6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "59%",
        stopColor: "#087CFA"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "73.6%",
        x2: "35.6%",
        y1: "114.8%",
        y2: "1.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FE2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "8%",
        stopColor: "#CB3979"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "16%",
        stopColor: "#9E4997"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "25%",
        stopColor: "#7557B2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "34%",
        stopColor: "#5362C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "44%",
        stopColor: "#386CDA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "54%",
        stopColor: "#2373E8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "66%",
        stopColor: "#1478F2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "79%",
        stopColor: "#0B7BF8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#087CFA"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "28.6%",
        x2: "81.8%",
        y1: "23.6%",
        y2: "129.8%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FE2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "8%",
        stopColor: "#FE295F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "21%",
        stopColor: "#FF2D76"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "30%",
        stopColor: "#FF318C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "38%",
        stopColor: "#EA3896"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "55%",
        stopColor: "#B248AE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "79%",
        stopColor: "#5A63D6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#087CFA"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M40.5 180.6 2.9 150.8l22.1-41 33.3 11.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#087CFA",
        d: "m256 68.2-4.6 148.3-98.6 39.5-53.7-34.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m256 68.2-48.8 47.6L144.5 39l31-34.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m99.1 221.3-78.5 28.4 16.5-57.5 21.2-71.3L0 101.4 37.1 0l83.8 9.9 86.3 105.9z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M49.1 48h160v160h-160z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M69 177.8h60v10H69zM99 79V68H69.2v11h8.4v37.7h-8.4v11H99v-11h-8.3V79zm28.5 49.4.2.1c-4.1.2-8.1-.8-11.8-2.6a27 27 0 0 1-7.7-6.3l8.2-9.2c1.5 1.7 3.2 3.1 5.2 4.3 1.7 1.1 3.7 1.7 5.7 1.6 2.2.2 4.3-.7 5.8-2.3a11 11 0 0 0 2.2-7.5V68h13.3v39a27 27 0 0 1-1.5 9.4c-1.7 5-5.7 9-10.8 10.6-2.8 1-5.8 1.5-8.8 1.4"
    }));

const JQueryDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 63",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m109.481 22.561.001-.002-1.638 5.805zm7.96 21.272h.002l-10.814.04zm.948-.737 1.884-7.184-1.884 7.185zm30.795-33.084-2.664 12.324 2.664-12.325z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M157.603 9.27h-7.504c-.416 0-.829.334-.918.741l-2.664 12.325-2.664 12.325a.98.98 0 0 1-.917.74h-5.311c-5.255 0-4.647-3.635-3.571-8.614l.032-.15.118-.627.022-.119.24-1.277.257-1.37c.078-.413.196-1.017.274-1.396l1.211-5.917 1.212-5.917c.084-.408-.189-.743-.606-.743h-7.702a.98.98 0 0 0-.914.742l-1.656 7.857-1.656 7.856-.002.012-.154.73c-1.907 8.709-1.401 17.013 8.966 17.273.169.005.3.007.3.007h16.273c.416 0 .828-.335.916-.743l3.509-16.495 3.509-16.497c.086-.409-.184-.742-.6-.743m29.935 26.216c.417 0 .689.334.605.742l-.728 3.561m-.728 3.563.729-3.563-.729 3.565zm-.913.75.003-.001zm-18.305-13.203c-.006-.39.438-1.062.855-1.062l-.937-.015c-.423 4.247.082 1.077.082 1.077"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M187.538 35.486c.417 0 .689.334.605.742l-.728 3.561-.119.58m-11.144 3.79-1.81.006c.597 0 1.204-.004 1.81-.006m10.535-.805.611-2.984-.611 2.986zM63.285 30.988l1.166-5.166-1.333 5.906-1.28 6.016 1.122-5.274c.086-.408.233-1.075.325-1.482m13.95-21.805h-8.24a1 1 0 0 0-.926.738l-.782 3.45-.781 3.45c-.092.405.173.738.59.738h8.305c.416 0 .83-.333.92-.74l.755-3.449.755-3.446v-.001c.09-.407-.178-.74-.595-.74zm-1.793 11.473v-.001l-2.417 11.181zM51.504 57.704H51.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M74.846 19.915h-8.305a.995.995 0 0 0-.925.74l-1.167 5.167-1.166 5.167c-.092.406-.238 1.073-.325 1.482l-1.12 5.274-1.12 5.273q-.165.74-.4 1.459s-1.552 4.617-4.16 4.565l-.326-.007c-1.264-.024-2.257-.041-2.257-.041h-.002a.99.99 0 0 0-.93.722l-.862 3.621-.86 3.62c-.097.404.164.738.578.745 1.48.017 4.792.055 6.798.055 6.516 0 9.95-3.61 12.152-13.999l2.577-11.922 2.417-11.181c.088-.407-.181-.74-.597-.74M192.83 43.746c-.417 0-.687-.334-.599-.743l6.247-29.265"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M192.321 43.375c-.05-.204-.021-.703.068-1.112l2.965-13.89-3.124 14.631c-.088.408.182.742.599.742h.759c-.417 0-1.217-.167-1.267-.37zm8.698.204c-.226.092-.754.167-1.171.167h.759a.97.97 0 0 0 .908-.743l.151-.742c-.084.407-.419 1.226-.647 1.318m1.759-6.822 1.116-5.512-.002.01zM227.431 15.7l.344 1.422c.094.407-.168.738-.584.739m-23.298 13.385c.083-.408.22-1.07.306-1.473l1.192-5.581-1.349 6.322zm-5.312-17.986-.259 1.221-2.965 13.892 3.124-14.633z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m227.773 17.121-.344-1.422-.341-1.457-.172-.737c-.675-2.62-2.656-4.133-6.955-4.133l-6.695-.008-6.165-.007h-6.937a.98.98 0 0 0-.914.74h-.001l-.306 1.45-.362 1.712-.101.48-3.124 14.632-2.965 13.891c-.089.409-.118.908-.068 1.112.051.204.85.371 1.267.371h6.258c.418 0 .945-.075 1.171-.167.228-.092.563-.91.646-1.318l1.112-5.503 1.114-5.502.002-.011.149-.732 1.349-6.322 1.192-5.583a.98.98 0 0 1 .914-.739l19.692-.01c.416 0 .679-.33.584-.737"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M253.124 4.263c-.418.003-1.099.006-1.516.006h-6.303c-.418 0-.951.281-1.186.625l-13.937 20.42c-.236.344-.504.293-.597-.113l-1.026-4.499c-.092-.407-.51-.738-.926-.738h-8.961c-.417 0-.663.327-.55.728l4.016 14.065c.114.4.122 1.06.019 1.463l-1.75 6.807c-.104.404.153.735.57.735h8.855c.417 0 .843-.33.946-.735l1.751-6.807a4.5 4.5 0 0 1 .644-1.34L255.8 4.848c.252-.332.115-.603-.301-.6zM181.938 21.88l-.001-.009c-.052.452-.469.784-.885.784h-11.36c-.393 0-.593-.267-.535-.596q.004-.015.01-.027l-.007.004.006-.039.052-.193c1.086-2.885 3.295-4.778 7.449-4.778 4.676 0 5.588 2.285 5.271 4.854m-3.333-13.113c-14.582 0-18.037 8.851-19.975 17.784-1.939 9.105-1.772 17.618 13.317 17.618h1.653q.088-.003.177-.002h.561l1.811-.007h.03c3.985-.015 7.982-.045 9.6-.058a.98.98 0 0 0 .904-.745l.611-2.985.119-.581.729-3.56c.084-.41-.19-.744-.606-.744H173.97c-5.395 0-6.997-1.433-6.406-5.648h21.684l-.002.002.015-.002a.896.896 0 0 0 .842-.75l-.002.003c3.219-12.145 2.296-20.324-11.497-20.324zm-68.918 13.066-.206.727v.002l-1.638 5.803-1.637 5.802c-.112.4-.546.728-.964.728h-8.666c-6.573 0-8.174-5.14-6.573-12.725 1.6-7.757 4.738-12.579 11.208-13.067 8.842-.667 10.61 5.552 8.476 12.73m5.943 12.616s4.086-9.92 5.014-15.652C121.91 11.125 118.069 0 103.233 0c-14.75 0-21.155 10.622-23.6 22.168-2.443 11.63.759 21.83 15.425 21.747l11.571-.043 10.814-.039c.417-.004.843-.334.949-.736l1.883-7.186c.105-.403-.15-.735-.566-.737l-1.805-.01-1.805-.011c-.355-.003-.558-.232-.515-.536a.7.7 0 0 1 .045-.17l.001.001z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M188.652 27.808a.499.499 0 0 1-.85.352.498.498 0 1 1 .85-.352"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0868AC",
        d: "M2.995 14.908c-4.073 5.854-3.566 13.47-.455 19.69q.112.224.228.443c.05.093.095.188.146.28q.044.083.09.161a24 24 0 0 0 .459.8l.17.279q.169.27.345.539.074.114.147.227.243.363.499.72l.014.02q.042.056.085.112.223.307.454.605l.172.218a26 26 0 0 0 1.178 1.39l.023.025q.61.663 1.262 1.286.098.096.194.185.326.307.662.602.057.05.113.096.293.254.591.5l.246.195q.243.196.493.386l.264.2q.274.203.553.398.102.072.202.142.028.02.055.04.267.18.538.355.116.079.233.155.416.265.842.516l.232.131q.315.181.632.355.174.091.35.18.225.12.452.235l.105.05q.091.043.184.09a26 26 0 0 0 1.704.747q.102.042.204.08a28 28 0 0 0 1.767.614q.105.031.212.064c.3.09.598.199.907.256 19.698 3.592 25.42-11.837 25.42-11.837-4.805 6.26-13.335 7.911-21.417 6.073-.306-.07-.603-.165-.902-.253a26 26 0 0 1-1.093-.35l-.12-.044a28 28 0 0 1-.765-.284q-.107-.042-.215-.084a25 25 0 0 1-.826-.344q-.083-.037-.166-.072a38 38 0 0 1-.899-.422c-.18-.088-.36-.182-.54-.274-.119-.063-.24-.123-.36-.189a21 21 0 0 1-.646-.363l-.218-.121a35 35 0 0 1-.842-.516q-.114-.075-.227-.152-.303-.194-.6-.398c-.065-.044-.128-.092-.193-.135a33 33 0 0 1-.566-.41 42 42 0 0 1-.99-.772 29 29 0 0 1-.637-.536l-.07-.059q-.34-.3-.67-.608l-.188-.182a20 20 0 0 1-.48-.471l-.19-.188q-.3-.309-.59-.624l-.028-.031q-.306-.335-.599-.681l-.157-.187q-.22-.263-.43-.532a8 8 0 0 1-.158-.197q-.254-.329-.498-.662C4.2 26.25 2.59 17.81 6.174 10.876"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0868AC",
        d: "M15.638 9.976c-2.945 4.239-2.785 9.913-.488 14.396q.578 1.131 1.303 2.175c.441.632.93 1.384 1.516 1.893q.32.35.661.686.087.087.174.172.329.321.676.628.014.011.027.024l.007.006q.384.335.788.652l.18.14q.402.31.824.602l.024.019c.124.086.25.165.377.248q.088.06.178.118.301.194.611.374l.087.05q.268.155.54.302.096.052.193.1.187.1.378.196.029.014.057.026.388.192.788.368.086.037.174.071c.214.09.43.18.646.262q.14.053.277.102.296.108.594.207l.268.086c.284.088.563.199.859.248 15.208 2.52 18.72-9.19 18.72-9.19-3.166 4.559-9.295 6.733-15.835 5.035q-.565-.149-1.12-.332a20 20 0 0 1-1.523-.57q-.089-.037-.175-.075a19 19 0 0 1-.793-.368q-.2-.1-.398-.203l-.23-.118a19 19 0 0 1-.503-.284l-.12-.068a19 19 0 0 1-.61-.372q-.092-.06-.183-.123a24 24 0 0 1-.396-.261 22 22 0 0 1-.822-.602l-.185-.145c-2.863-2.26-5.132-5.35-6.211-8.852-1.13-3.633-.887-7.71 1.072-11.02"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m120.847 56.062-2.421 5.513h-2.672l.219-5.01-1.967 5.01h-2.588l-.068-5.513.286-1.361h1.832l-.353 5.445 2.034-5.445h2.555l-.185 5.513 2.017-5.513h1.597zm4.217 1.632c.235-1.076.168-1.277-.386-1.277h-.841l-.538 2.521-.824 2.638h-1.563l1.277-5.983.186-.875h1.428l.185.404s.824-.487 1.63-.487c1.715 0 1.58 1.293 1.21 3.059zm5.077-3.85c-.688 0-1.126-.202-.957-1.042.184-.84.722-1.043 1.394-1.043.673 0 1.127.202.942 1.043-.169.823-.706 1.041-1.379 1.041zm-.739 7.732h-1.547l.303-2.69.538-2.486-1.075-.237.302-1.461h2.941zm6.706-5.416-1.933.237-.556 2.621c-.151.723-.151.925.489.925h1.293l-.269 1.378s-1.176.353-1.681.353c-1.983 0-1.966-1.092-1.613-2.723l.538-2.572-1.076-.234.319-1.463h1.127l.639-1.732h1.53l-.371 1.732h1.883zm4.016.088c-.907 0-1.378.471-1.562 1.311l2.588-.218c.117-.572-.001-1.093-1.026-1.093m-1.814 2.554c-.119.842.201 1.127 1.276 1.127h2.706l-.269 1.277s-1.63.453-2.84.453c-3.008 0-3.043-1.696-2.656-3.512.387-1.782 1.075-3.546 3.983-3.546 2.808 0 2.942 1.697 2.252 4.201zm10.62 2.772h-1.546l.303-2.689 1.092-5.11-1.077-.251.32-1.463h2.942zm5.585-5.326c-.908 0-1.379.471-1.564 1.311l2.589-.218c.117-.572 0-1.093-1.025-1.093m-1.816 2.554c-.117.842.202 1.127 1.277 1.127h2.707l-.27 1.277s-1.631.453-2.841.453c-3.008 0-3.042-1.696-2.655-3.512.387-1.782 1.076-3.546 3.983-3.546 2.807 0 2.942 1.697 2.253 4.201zm11.545-2.471s-1.966.017-2.504.017c-1.144 0-1.261.352-1.345.721l-.068.337 3.631.27s.017 1.159-.134 1.814c-.219 1.093-1.345 2.201-3.378 2.201-1.009 0-2.64-.385-2.64-.385l.286-1.328h2.505c1.109 0 1.261-.303 1.329-.605l.083-.436-3.563-.27s-.134-.892.05-1.781c.27-1.212 1.378-2.253 3.412-2.253 1.008 0 2.638.369 2.638.369zm6.758 0s-1.966.017-2.505.017c-1.142 0-1.26.352-1.344.721l-.068.337 3.631.27s.017 1.159-.134 1.814c-.218 1.093-1.345 2.201-3.378 2.201-1.009 0-2.639-.385-2.639-.385l.286-1.328h2.504c1.109 0 1.26-.303 1.329-.605l.083-.436-3.563-.27s-.134-.892.05-1.781c.27-1.212 1.378-2.253 3.413-2.253 1.007 0 2.637.369 2.637.369zm2.116 6.338h-1.344l.05-1.01c-.488-.031-.74-.384-.622-.974.185-.84.706-1.041 1.395-1.041.672 0 1.125.2.941 1.04zm8.991-6.27c-1.008 0-1.361.605-1.597 1.715-.235 1.11-.168 1.764.84 1.764h1.395l.774-3.478h-1.412zm2.303 4.285-.186.892-1.411-.017-.202-.437s-1.245.537-2.084.537c-2.152 0-2.253-1.764-1.866-3.546.386-1.815 1.227-3.53 3.362-3.53.774 0 1.815.387 1.815.387l.857-2.908h1.547zm5.564-4.353c-1.311 0-1.732.738-1.966 1.814-.219 1.093-.117 1.833 1.175 1.833 1.346 0 1.749-.723 1.984-1.833.236-1.042.168-1.814-1.193-1.814m-1.143 5.345c-2.773 0-2.992-1.73-2.622-3.53.387-1.798 1.362-3.513 4.135-3.513 2.756 0 3.009 1.715 2.621 3.513-.386 1.832-1.361 3.53-4.134 3.53m15.734-.102.303-2.656.151-.756c.219-1.008.354-1.747-.706-1.747h-.823c.034.52-.068 1.11-.202 1.73l-.723 3.43h-1.563l.303-2.657.151-.756c.219-1.008.352-1.747-.705-1.747h-.673l-1.11 5.16h-1.799l1.463-6.874h1.411l.219.42s.959-.505 1.732-.505c.587 0 1.025.27 1.176.605.336-.185 1.294-.605 1.984-.605 2.15 0 2.084 1.747 1.697 3.53l-.723 3.429zm7.144-5.243c-1.312 0-1.732.738-1.966 1.814-.219 1.093-.117 1.833 1.176 1.833 1.344 0 1.749-.723 1.984-1.833.234-1.042.167-1.814-1.194-1.814m-1.143 5.345c-2.775 0-2.992-1.73-2.622-3.53.386-1.798 1.361-3.513 4.135-3.513 2.757 0 3.008 1.715 2.621 3.513-.386 1.832-1.361 3.53-4.134 3.53m8.805-3.982c.234-1.076.168-1.277-.386-1.277h-.842l-.538 2.521-.824 2.638h-1.562l1.277-5.983.185-.875h1.429l.184.404s.824-.487 1.631-.487c1.714 0 1.579 1.293 1.21 3.059zm6.02-1.447c-.907 0-1.378.472-1.562 1.312l2.587-.218c.118-.572 0-1.093-1.025-1.093zm-1.815 2.555c-.117.842.201 1.127 1.277 1.127h2.706l-.269 1.277s-1.63.453-2.84.453c-3.008 0-3.042-1.696-2.657-3.512.388-1.782 1.077-3.546 3.984-3.546 2.806 0 2.942 1.697 2.252 4.201zm5.964 2.875c-.707 0-1.143-.202-.958-1.025.167-.842.688-1.043 1.395-1.043.655 0 1.109.2.941 1.043-.186.806-.722 1.025-1.378 1.025"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0868AC",
        d: "M26.271 6.291c-1.736 2.555-1.906 5.73-.702 8.552 1.271 2.995 3.875 5.345 6.913 6.46q.187.068.377.131.082.027.167.052c.179.056.356.122.541.157 8.398 1.622 10.675-4.31 11.282-5.183-1.995 2.873-5.349 3.563-9.462 2.564a12 12 0 0 1-2.177-.798 12.2 12.2 0 0 1-2.073-1.265C27.455 14.168 25.168 8.84 27.57 4.5"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h256v62.669H0z"
    }))));

const JQueryLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 63",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#131B28",
        d: "m109.481 22.561.001-.002-1.638 5.805zm7.96 21.272h.002l-10.814.04zm.948-.737 1.884-7.184-1.884 7.185zm30.795-33.084-2.664 12.324 2.664-12.325z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#131B28",
        d: "M157.603 9.27h-7.504c-.416 0-.829.334-.918.741l-2.664 12.325-2.664 12.325a.98.98 0 0 1-.917.74h-5.311c-5.255 0-4.647-3.635-3.571-8.614l.032-.15.118-.627.022-.119.24-1.277.257-1.37c.078-.413.196-1.017.274-1.396l1.211-5.917 1.212-5.917c.084-.408-.189-.743-.606-.743h-7.702a.98.98 0 0 0-.914.742l-1.656 7.857-1.656 7.856-.002.012-.154.73c-1.907 8.709-1.401 17.013 8.966 17.273.169.005.3.007.3.007h16.273c.416 0 .828-.335.916-.743l3.509-16.495 3.509-16.497c.086-.409-.184-.742-.6-.743m29.935 26.216c.417 0 .689.334.605.742l-.728 3.561m-.728 3.563.729-3.563-.729 3.565zm-.913.75.003-.001zm-18.305-13.203c-.006-.39.438-1.062.855-1.062l-.937-.015c-.423 4.247.082 1.077.082 1.077"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#131B28",
        d: "M187.538 35.486c.417 0 .689.334.605.742l-.728 3.561-.119.58m-11.144 3.79-1.81.006c.597 0 1.204-.004 1.81-.006m10.535-.805.611-2.984-.611 2.986zM63.285 30.988l1.166-5.166-1.333 5.906-1.28 6.016 1.122-5.274c.086-.408.233-1.075.325-1.482m13.95-21.805h-8.24a1 1 0 0 0-.926.738l-.782 3.45-.781 3.45c-.092.405.173.738.59.738h8.305c.416 0 .83-.333.92-.74l.755-3.449.755-3.446v-.001c.09-.407-.178-.74-.595-.74zm-1.793 11.473v-.001l-2.417 11.181zM51.504 57.704H51.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#131B28",
        d: "M74.846 19.915h-8.305a.995.995 0 0 0-.925.74l-1.167 5.167-1.166 5.167c-.092.406-.238 1.073-.325 1.482l-1.12 5.274-1.12 5.273q-.165.74-.4 1.459s-1.552 4.617-4.16 4.565l-.326-.007c-1.264-.024-2.257-.041-2.257-.041h-.002a.99.99 0 0 0-.93.722l-.862 3.621-.86 3.62c-.097.404.164.738.578.745 1.48.017 4.792.055 6.798.055 6.516 0 9.95-3.61 12.152-13.999l2.577-11.922 2.417-11.181c.088-.407-.181-.74-.597-.74M192.83 43.746c-.417 0-.687-.334-.599-.743l6.247-29.265"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#131B28",
        d: "M192.321 43.375c-.05-.204-.021-.703.068-1.112l2.965-13.89-3.124 14.631c-.088.408.182.742.599.742h.759c-.417 0-1.217-.167-1.267-.37zm8.698.204c-.226.092-.754.167-1.171.167h.759a.97.97 0 0 0 .908-.743l.151-.742c-.084.407-.419 1.226-.647 1.318m1.759-6.822 1.116-5.512-.002.01zM227.431 15.7l.344 1.422c.094.407-.168.738-.584.739m-23.298 13.385c.083-.408.22-1.07.306-1.473l1.192-5.581-1.349 6.322zm-5.312-17.986-.259 1.221-2.965 13.892 3.124-14.633z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#131B28",
        d: "m227.773 17.121-.344-1.422-.341-1.457-.172-.737c-.675-2.62-2.656-4.133-6.955-4.133l-6.695-.008-6.165-.007h-6.937a.98.98 0 0 0-.914.74h-.001l-.306 1.45-.362 1.712-.101.48-3.124 14.632-2.965 13.891c-.089.409-.118.908-.068 1.112.051.204.85.371 1.267.371h6.258c.418 0 .945-.075 1.171-.167.228-.092.563-.91.646-1.318l1.112-5.503 1.114-5.502.002-.011.149-.732 1.349-6.322 1.192-5.583a.98.98 0 0 1 .914-.739l19.692-.01c.416 0 .679-.33.584-.737"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#131B28",
        d: "M253.124 4.263c-.418.003-1.099.006-1.516.006h-6.303c-.418 0-.951.281-1.186.625l-13.937 20.42c-.236.344-.504.293-.597-.113l-1.026-4.499c-.092-.407-.51-.738-.926-.738h-8.961c-.417 0-.663.327-.55.728l4.016 14.065c.114.4.122 1.06.019 1.463l-1.75 6.807c-.104.404.153.735.57.735h8.855c.417 0 .843-.33.946-.735l1.751-6.807a4.5 4.5 0 0 1 .644-1.34L255.8 4.848c.252-.332.115-.603-.301-.6zM181.938 21.88l-.001-.009c-.052.452-.469.784-.885.784h-11.36c-.393 0-.593-.267-.535-.596q.004-.015.01-.027l-.007.004.006-.039.052-.193c1.086-2.885 3.295-4.778 7.449-4.778 4.676 0 5.588 2.285 5.271 4.854m-3.333-13.113c-14.582 0-18.037 8.851-19.975 17.784-1.939 9.105-1.772 17.618 13.317 17.618h1.653q.088-.003.177-.002h.561l1.811-.007h.03c3.985-.015 7.982-.045 9.6-.058a.98.98 0 0 0 .904-.745l.611-2.985.119-.581.729-3.56c.084-.41-.19-.744-.606-.744H173.97c-5.395 0-6.997-1.433-6.406-5.648h21.684l-.002.002.015-.002a.896.896 0 0 0 .842-.75l-.002.003c3.219-12.145 2.296-20.324-11.497-20.324zm-68.918 13.066-.206.727v.002l-1.638 5.803-1.637 5.802c-.112.4-.546.728-.964.728h-8.666c-6.573 0-8.174-5.14-6.573-12.725 1.6-7.757 4.738-12.579 11.208-13.067 8.842-.667 10.61 5.552 8.476 12.73m5.943 12.616s4.086-9.92 5.014-15.652C121.91 11.125 118.069 0 103.233 0c-14.75 0-21.155 10.622-23.6 22.168-2.443 11.63.759 21.83 15.425 21.747l11.571-.043 10.814-.039c.417-.004.843-.334.949-.736l1.883-7.186c.105-.403-.15-.735-.566-.737l-1.805-.01-1.805-.011c-.355-.003-.558-.232-.515-.536a.7.7 0 0 1 .045-.17l.001.001z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#131B28",
        d: "M188.652 27.808a.499.499 0 0 1-.85.352.498.498 0 1 1 .85-.352"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0868AC",
        d: "M2.995 14.908c-4.073 5.854-3.566 13.47-.455 19.69q.112.224.228.443c.05.093.095.188.146.28q.044.083.09.161a24 24 0 0 0 .459.8l.17.279q.169.27.345.539.074.114.147.227.243.363.499.72l.014.02q.042.056.085.112.223.307.454.605l.172.218a26 26 0 0 0 1.178 1.39l.023.025q.61.663 1.262 1.286.098.096.194.185.326.307.662.602.057.05.113.096.293.254.591.5l.246.195q.243.196.493.386l.264.2q.274.203.553.398.102.072.202.142.028.02.055.04.267.18.538.355.116.079.233.155.416.265.842.516l.232.131q.315.181.632.355.174.091.35.18.225.12.452.235l.105.05q.091.043.184.09a26 26 0 0 0 1.704.747q.102.042.204.08a28 28 0 0 0 1.767.614q.105.031.212.064c.3.09.598.199.907.256 19.698 3.592 25.42-11.837 25.42-11.837-4.805 6.26-13.335 7.911-21.417 6.073-.306-.07-.603-.165-.902-.253a26 26 0 0 1-1.093-.35l-.12-.044a28 28 0 0 1-.765-.284q-.107-.042-.215-.084a25 25 0 0 1-.826-.344q-.083-.037-.166-.072a38 38 0 0 1-.899-.422c-.18-.088-.36-.182-.54-.274-.119-.063-.24-.123-.36-.189a21 21 0 0 1-.646-.363l-.218-.121a35 35 0 0 1-.842-.516q-.114-.075-.227-.152-.303-.194-.6-.398c-.065-.044-.128-.092-.193-.135a33 33 0 0 1-.566-.41 42 42 0 0 1-.99-.772 29 29 0 0 1-.637-.536l-.07-.059q-.34-.3-.67-.608l-.188-.182a20 20 0 0 1-.48-.471l-.19-.188q-.3-.309-.59-.624l-.028-.031q-.306-.335-.599-.681l-.157-.187q-.22-.263-.43-.532a8 8 0 0 1-.158-.197q-.254-.329-.498-.662C4.2 26.25 2.59 17.81 6.174 10.876"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0868AC",
        d: "M15.638 9.976c-2.945 4.239-2.785 9.913-.488 14.396q.578 1.131 1.303 2.175c.441.632.93 1.384 1.516 1.893q.32.35.661.686.087.087.174.172.329.321.676.628.014.011.027.024l.007.006q.384.335.788.652l.18.14q.402.31.824.602l.024.019c.124.086.25.165.377.248q.088.06.178.118.301.194.611.374l.087.05q.268.155.54.302.096.052.193.1.187.1.378.196.029.014.057.026.388.192.788.368.086.037.174.071c.214.09.43.18.646.262q.14.053.277.102.296.108.594.207l.268.086c.284.088.563.199.859.248 15.208 2.52 18.72-9.19 18.72-9.19-3.166 4.559-9.295 6.733-15.835 5.035q-.565-.149-1.12-.332a20 20 0 0 1-1.523-.57q-.089-.037-.175-.075a19 19 0 0 1-.793-.368q-.2-.1-.398-.203l-.23-.118a19 19 0 0 1-.503-.284l-.12-.068a19 19 0 0 1-.61-.372q-.092-.06-.183-.123a24 24 0 0 1-.396-.261 22 22 0 0 1-.822-.602l-.185-.145c-2.863-2.26-5.132-5.35-6.211-8.852-1.13-3.633-.887-7.71 1.072-11.02"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0868AC",
        d: "M26.271 6.291c-1.736 2.555-1.906 5.73-.702 8.552 1.271 2.995 3.875 5.345 6.913 6.46q.187.068.377.131.082.027.167.052c.179.056.356.122.541.157 8.398 1.622 10.675-4.31 11.282-5.183-1.995 2.873-5.349 3.563-9.462 2.564a12 12 0 0 1-2.177-.798 12.2 12.2 0 0 1-2.073-1.265C27.455 14.168 25.168 8.84 27.57 4.5m93.276 51.562-2.421 5.513h-2.672l.219-5.01-1.967 5.01h-2.588l-.068-5.513.286-1.361h1.832l-.353 5.445 2.034-5.445h2.555l-.185 5.513 2.017-5.513h1.597zm4.217 1.632c.235-1.076.168-1.277-.386-1.277h-.841l-.538 2.521-.824 2.638h-1.563l1.277-5.983.186-.875h1.428l.185.404s.824-.487 1.63-.487c1.715 0 1.58 1.293 1.21 3.059zm5.077-3.85c-.688 0-1.126-.202-.958-1.042.185-.84.723-1.043 1.395-1.043.673 0 1.127.202.942 1.043-.169.823-.706 1.041-1.379 1.041zm-.739 7.732h-1.547l.303-2.69.538-2.486-1.075-.236.302-1.462h2.941zm6.706-5.416-1.933.237-.556 2.621c-.151.723-.151.925.489.925h1.293l-.269 1.378s-1.176.353-1.681.353c-1.983 0-1.966-1.092-1.613-2.723l.538-2.572-1.076-.234.319-1.463h1.127l.639-1.732h1.53l-.371 1.732h1.883zm4.016.088c-.907 0-1.378.471-1.562 1.311l2.588-.218c.117-.572-.001-1.093-1.026-1.093m-1.814 2.554c-.119.842.201 1.127 1.276 1.127h2.706l-.269 1.277s-1.63.453-2.84.453c-3.008 0-3.043-1.696-2.656-3.512.387-1.782 1.075-3.546 3.983-3.546 2.808 0 2.942 1.697 2.252 4.201zm10.62 2.772h-1.546l.303-2.689 1.092-5.11-1.077-.251.32-1.463h2.942zm5.585-5.326c-.909 0-1.379.471-1.564 1.311l2.589-.218c.117-.572 0-1.093-1.025-1.093m-1.816 2.554c-.117.842.202 1.127 1.277 1.127h2.707l-.27 1.277s-1.631.453-2.841.453c-3.008 0-3.042-1.696-2.655-3.512.387-1.782 1.076-3.546 3.983-3.546 2.807 0 2.942 1.697 2.253 4.201zm11.545-2.47s-1.966.016-2.504.016c-1.144 0-1.261.352-1.345.721l-.068.337 3.631.27s.017 1.159-.134 1.814c-.219 1.093-1.345 2.201-3.378 2.201-1.009 0-2.64-.385-2.64-.385l.286-1.328h2.505c1.109 0 1.261-.303 1.329-.605l.083-.436-3.563-.27s-.134-.892.05-1.781c.27-1.212 1.378-2.253 3.412-2.253 1.008 0 2.638.369 2.638.369zm6.758 0s-1.966.016-2.505.016c-1.142 0-1.26.352-1.344.721l-.068.337 3.631.27s.017 1.159-.134 1.814c-.218 1.093-1.345 2.201-3.378 2.201-1.009 0-2.639-.385-2.639-.385l.286-1.328h2.504c1.109 0 1.26-.303 1.329-.605l.083-.436-3.563-.27s-.134-.892.05-1.781c.27-1.212 1.378-2.253 3.413-2.253 1.007 0 2.637.369 2.637.369zm2.116 6.337h-1.344l.05-1.01c-.488-.031-.74-.384-.622-.974.185-.84.706-1.041 1.395-1.041.672 0 1.125.2.941 1.04zm8.991-6.27c-1.008 0-1.361.605-1.597 1.715-.235 1.11-.168 1.764.84 1.764h1.395l.774-3.478h-1.412zm2.303 4.285-.186.892-1.411-.017-.202-.437s-1.245.537-2.084.537c-2.152 0-2.253-1.764-1.866-3.546.386-1.815 1.227-3.53 3.362-3.53.774 0 1.815.387 1.815.387l.857-2.908h1.547zm5.564-4.353c-1.311 0-1.732.738-1.966 1.814-.219 1.093-.117 1.833 1.175 1.833 1.346 0 1.749-.723 1.984-1.833.236-1.042.168-1.814-1.193-1.814m-1.143 5.345c-2.773 0-2.992-1.73-2.622-3.53.387-1.798 1.362-3.513 4.135-3.513 2.756 0 3.009 1.715 2.621 3.513-.386 1.832-1.361 3.53-4.134 3.53m15.734-.102.303-2.656.151-.756c.219-1.008.354-1.747-.706-1.747h-.823c.034.52-.068 1.11-.202 1.73l-.723 3.43h-1.563l.303-2.657.151-.756c.219-1.008.352-1.747-.705-1.747h-.673l-1.11 5.16h-1.799l1.463-6.874h1.411l.219.42s.959-.505 1.732-.505c.587 0 1.025.27 1.176.605.336-.185 1.294-.605 1.984-.605 2.15 0 2.084 1.747 1.697 3.53l-.723 3.429zm7.144-5.243c-1.312 0-1.732.738-1.966 1.814-.219 1.093-.117 1.833 1.176 1.833 1.344 0 1.749-.723 1.984-1.833.234-1.042.167-1.814-1.194-1.814m-1.143 5.345c-2.775 0-2.992-1.73-2.622-3.53.386-1.798 1.361-3.513 4.135-3.513 2.757 0 3.008 1.715 2.621 3.513-.386 1.832-1.361 3.53-4.134 3.53m8.805-3.982c.234-1.076.168-1.277-.386-1.277h-.842l-.538 2.521-.824 2.638h-1.562l1.277-5.983.185-.875h1.429l.184.404s.824-.487 1.631-.487c1.714 0 1.579 1.293 1.21 3.059zm6.02-1.447c-.907 0-1.378.472-1.562 1.312l2.587-.218c.118-.572 0-1.093-1.025-1.093zm-1.815 2.555c-.117.842.201 1.127 1.277 1.127h2.706l-.269 1.277s-1.63.453-2.84.453c-3.008 0-3.042-1.696-2.657-3.512.388-1.782 1.077-3.546 3.984-3.546 2.806 0 2.942 1.697 2.252 4.201zm5.964 2.875c-.707 0-1.143-.202-.958-1.025.167-.842.688-1.043 1.395-1.043.655 0 1.109.2.941 1.043-.186.806-.722 1.025-1.378 1.025"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h256v62.669H0z"
    }))));

const JSON = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 160 160",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__c",
        x1: -553.27,
        x2: -666.12,
        y1: 525.91,
        y2: 413.05,
        gradientTransform: "matrix(.99884 0 0 .9987 689.01 -388.84)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__b",
        x1: -666.12,
        x2: -553.27,
        y1: 413.04,
        y2: 525.91,
        gradientTransform: "matrix(.99884 0 0 .9987 689.01 -388.84)",
        gradientUnits: "userSpaceOnUse"
    })), /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd",
        color: "#000"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M79.865 119.1c35.398 48.255 70.04-13.469 69.989-50.587C149.794 24.627 105.313.099 79.836.099 38.944.099 0 33.895 0 80.135 0 131.531 44.64 160 79.836 160c-7.965-1.147-34.506-6.834-34.863-67.967-.24-41.347 13.488-57.866 34.805-50.599.477.177 23.514 9.265 23.514 38.951 0 29.56-23.427 38.715-23.427 38.715"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M79.823 41.401C56.433 33.339 27.78 52.617 27.78 91.23c0 63.048 46.721 68.77 52.384 68.77C121.056 160 160 126.204 160 79.964 160 28.568 115.36.099 80.164.099c9.748-1.35 52.541 10.55 52.541 69.037 0 38.141-31.953 58.905-52.735 50.033-.477-.177-23.514-9.264-23.514-38.951 0-29.56 23.367-38.818 23.367-38.818z"
    })));

const JSONSchema = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 220",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#002CC4",
        d: "M70.206 0v16.767c-6.616 0-11.833 1.032-15.622 3.082s-6.475 5.23-8.043 9.543c-1.57 4.312-2.361 9.811-2.361 16.484v34.24c0 4.454-.58 8.511-1.754 12.159-1.173 3.647-3.322 6.786-6.46 9.415-3.153 2.63-7.606 4.652-13.403 6.08-.735.17-1.569.31-2.36.466v2.644l1.597.298q.394.077.763.168c5.797 1.428 10.264 3.45 13.403 6.08 3.138 2.629 5.287 5.767 6.46 9.415 1.174 3.661 1.754 7.705 1.754 12.158v34.24c0 6.688.791 12.159 2.36 16.442 1.57 4.284 4.256 7.465 8.044 9.543 3.79 2.078 9.006 3.125 15.622 3.125v16.78c-8.397 0-15.438-.918-21.15-2.742-5.71-1.824-10.263-4.623-13.698-8.383-3.436-3.761-5.896-8.525-7.408-14.293s-2.262-12.583-2.262-20.457V145.87c0-9.36-1.909-16.032-5.698-20.033-3.803-4.001-10.461-5.994-19.99-5.994V99.3c9.529 0 16.201-1.993 19.99-5.994 3.803-4.001 5.698-10.674 5.698-20.033V45.876c0-7.875.749-14.689 2.262-20.457s3.972-10.532 7.408-14.293c3.435-3.76 7.987-6.56 13.699-8.383C54.768.919 61.823 0 70.207 0Zm115.588 0c8.383 0 15.438.919 21.149 2.743s10.264 4.623 13.7 8.383c3.42 3.76 5.895 8.525 7.407 14.293s2.262 12.582 2.262 20.457v27.398c0 9.36 1.895 16.032 5.698 20.033 3.788 4 10.461 5.994 19.99 5.994v20.528c-9.529 0-16.188 1.993-19.99 5.994-3.79 4-5.698 10.674-5.698 20.033v27.384c0 7.874-.749 14.689-2.262 20.457s-3.972 10.532-7.408 14.292c-3.421 3.761-7.987 6.56-13.7 8.384-5.71 1.824-12.751 2.743-21.148 2.743v-16.781c6.616 0 11.833-1.047 15.622-3.125s6.474-5.259 8.043-9.542c1.57-4.284 2.361-9.756 2.361-16.443v-34.24c0-4.453.58-8.497 1.754-12.158 1.173-3.648 3.322-6.786 6.46-9.416s7.606-4.651 13.403-6.079c.735-.184 1.569-.311 2.36-.467v-2.643l-1.597-.305a25 25 0 0 1-.763-.162c-5.797-1.413-10.25-3.435-13.403-6.065-3.138-2.63-5.287-5.768-6.46-9.415-1.174-3.648-1.754-7.705-1.754-12.158V45.876c0-6.673-.791-12.172-2.36-16.484-1.57-4.312-4.256-7.493-8.044-9.543-3.79-2.05-9.006-3.082-15.622-3.082zm15.876 109.282c0 .976-1.866 3.436-4.128 5.472-3.79 3.404-9.334 8.707-14.568 13.853l-3.835 3.798-5.112 5.165c-3.334 3.42-5.58 5.86-5.58 6.165 0 .537 3.987 7.422 8.879 15.31l8.256 13.347a1.55 1.55 0 0 1-.17 1.866l-1.965 1.513c-1.484 1.64-2.488 2.926-2.686 4.538.257.72-.458 1.17-1.384 1.601l-1.09.49c-3.145 1.463-5.531-.075-14.063-9.928l-4.027-4.685c-4.036-4.63-7.444-8.149-7.95-8.162-1.287-.028-15.524 15.537-26.537 29.01-9.712 11.876-18.265 12.116-20.74 9.784-4.17-3.959-3.562-10.73 1.57-17.375l.667-.83c2.516-3.034 7.902-8.708 14.032-14.867l2.047-2.047 3.66-3.615a507 507 0 0 1 10.753-10.252l4.637-4.27-9.461-20.315c-5.715-12.502-5.226-13.604 3.048-14.605l7.728-.862 6.715 10.15c3.69 5.585 7.252 10.152 7.889 10.152.592 0 6.38-4.608 13.188-10.48l6.375-5.528c7.693-6.598 9.283-7.392 12.387-7.087l.89.107c2.424.337 4.598.175 5.368-.366l.175-.157c1.3-1.555 5.032.75 5.032 3.11m-38.454-92.897c6.164 0 7.083 2.15 7.083 2.15-20.938 10.927-38.652 30.409-56.946 66.29l-2.946 5.873-11.375 22.119c-.897 1.63-1.075-.646-5.084-6.115l-.684-.912c-21.372-31.905-36.95-37.9-36.857-38.407 8.257-5.32 23.724-.117 33.28 8.38l.354.339.946.825c1.558 1.399 2.289 2.302 4.61 4.886.232 0 2.678-3.861 5.22-7.975l5.92-9.71c21.291-33.577 43.557-47.771 56.479-47.743"
    }));

const JWT = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 257",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M147.386 69.071 147.129 0h-38.515l.257 69.071 19.257 26.448zm-38.515 118.371v69.328h38.515v-69.328l-19.258-26.447z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00F2E6",
        d: "m147.386 187.442 40.57 55.976 31.069-22.596-40.57-55.975-31.069-10.015zM108.871 69.071 68.044 13.095 36.975 35.691l40.57 55.976 31.326 10.014z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00B9F1",
        d: "M77.545 91.667 11.811 70.355 0 106.816l65.733 21.569 31.069-10.271zm81.653 46.732 19.257 26.448 65.734 21.311L256 149.697l-65.733-21.312z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D63AFF",
        d: "M190.267 128.385 256 106.816l-11.811-36.461-65.734 21.312-19.257 26.447zm-124.534 0L0 149.697l11.811 36.461 65.734-21.311 19.257-26.448z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FB015B",
        d: "m77.545 164.847-40.57 55.975 31.069 22.596 40.827-55.976v-32.61zm100.91-73.18 40.57-55.976-31.069-22.596-40.57 55.976v32.61z"
    }));

const Jasmine = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 255",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#8A4182"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M118 105h20l5-6V46h-30v53zm-12 24 6-19-5-7-51-16-9 28 51 16zm18 19-16-11-8 2-31 43 24 17 31-42zm24-11-16 11v9l31 42 24-17-31-43zm-3-27 6 19 8 2 50-16-9-28-50 16z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128 0C58 0 0 57 0 127a128 128 0 0 0 256 0C256 57 199 0 128 0m0 26c56 0 102 45 102 101s-46 102-102 102S26 183 26 127 72 26 128 26"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m206 155-39-12 3-8 38 13zm-49-61-7-5 24-32 6 5zm-57 0L76 61l7-4 24 32zm-49 61-3-8 38-12 3 8zm73 53h8v-40h-8z"
    })));

const Java = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 346",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#5382A1",
        d: "M83 267s-14 8 9 11c27 3 41 2 71-3 0 0 8 5 19 9-67 29-153-2-99-17m-9-37s-15 11 8 13c29 3 52 3 92-4 0 0 6 5 15 8-82 24-173 2-115-17"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E76F00",
        d: "M144 166c17 19-4 36-4 36s42-22 22-49c-18-26-32-38 44-82 0 0-119 29-62 95"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5382A1",
        d: "M233 295s10 8-10 15c-39 12-163 15-197 0-12-5 11-13 18-14l12-2c-14-9-89 19-38 28 138 22 251-10 215-27M89 190s-63 15-22 21c17 2 51 2 83-1 26-2 52-7 52-7l-16 9c-64 16-187 8-151-9 30-14 54-13 54-13m113 63c64-33 34-66 13-61l-7 2s2-3 6-5c41-14 73 43-14 66z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E76F00",
        d: "M162 0s36 36-34 91c-56 45-12 70 0 99-32-30-56-56-40-80 23-35 89-53 74-110"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5382A1",
        d: "M95 345c62 4 158-3 160-32 0 0-4 11-51 20-53 10-119 9-158 2 0 0 8 7 49 10"
    }));

const JavaScript = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1052 1052",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#f0db4f",
        d: "M0 0h1052v1052H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#323330",
        d: "M965.9 801.1c-7.7-48-39-88.3-131.7-125.9-32.2-14.8-68.1-25.399-78.8-49.8-3.8-14.2-4.3-22.2-1.9-30.8 6.9-27.9 40.2-36.6 66.6-28.6 17 5.7 33.1 18.801 42.8 39.7 45.4-29.399 45.3-29.2 77-49.399-11.6-18-17.8-26.301-25.4-34-27.3-30.5-64.5-46.2-124-45-10.3 1.3-20.699 2.699-31 4-29.699 7.5-58 23.1-74.6 44-49.8 56.5-35.6 155.399 25 196.1 59.7 44.8 147.4 55 158.6 96.9 10.9 51.3-37.699 67.899-86 62-35.6-7.4-55.399-25.5-76.8-58.4-39.399 22.8-39.399 22.8-79.899 46.1 9.6 21 19.699 30.5 35.8 48.7 76.2 77.3 266.899 73.5 301.1-43.5 1.399-4.001 10.6-30.801 3.199-72.101m-394-317.6h-98.4c0 85-.399 169.4-.399 254.4 0 54.1 2.8 103.7-6 118.9-14.4 29.899-51.7 26.2-68.7 20.399-17.3-8.5-26.1-20.6-36.3-37.699-2.8-4.9-4.9-8.7-5.601-9-26.699 16.3-53.3 32.699-80 49 13.301 27.3 32.9 51 58 66.399 37.5 22.5 87.9 29.4 140.601 17.3 34.3-10 63.899-30.699 79.399-62.199 22.4-41.3 17.6-91.3 17.4-146.6.5-90.2 0-180.4 0-270.9"
    }));

const Jest = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 283",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#99425B",
        d: "M240 139a26 26 0 0 0-29-26L247 6H93l36 107a26 26 0 0 0-28 26c0 12 8 22 19 25a115 115 0 0 1-58 49c-16-8-23-27-17-43l3-5a26 26 0 1 0-21-4c-7 14-16 30-19 48-4 21 0 44 18 57 44 30 91-18 140-31 18-4 38-3 54-13 12-6 20-18 22-31 2-12-1-25-9-35 4-5 7-11 7-17"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M236 190c-2 11-9 21-19 27-10 5-21 7-33 9l-19 3c-17 4-34 12-50 20-32 16-59 30-85 12-19-13-18-38-16-51 2-12 8-24 13-35l3-5 8 2c-5 18 3 37 21 47l3 1 2-1q22.5-7.5 39-24c8-7 14-15 20-24a33 33 0 0 0 37-28h21a33 33 0 0 0 51 23c4 7 5 16 4 24M42 119a20 20 0 1 1 0 40 20 20 0 0 1 0-40m66 20a20 20 0 1 1 40 0 20 20 0 0 1-40 0m83-24c-5 4-8 10-9 15h-23c-1-6-5-11-10-15l21-42zM102 13h136l-32 94-4 1-32-64-32 64-4-1zm131 126a20 20 0 0 1-20 20 20 20 0 1 1 20-20m13 0c0-16-12-29-27-32L256 0H84l37 107a33 33 0 0 0-11 60 110 110 0 0 1-47 39c-12-8-17-21-12-33l1-1 1-2a33 33 0 1 0-34-8l-4 8c-5 11-11 24-14 38-4 28 3 51 22 63 11 8 22 11 34 11 21 0 43-11 64-21 15-8 31-16 47-19l18-4c13-1 26-3 37-10a51 51 0 0 0 18-72c3-5 5-11 5-17"
    }));

const JetBrainsColorful = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 257",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "25.2%",
        x2: "99.2%",
        y1: "43.3%",
        y2: "67.4%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "21%",
        stopColor: "#FE2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#293896"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "2.3%",
        x2: "90.7%",
        y1: "77.1%",
        y2: "24.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FE2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1%",
        stopColor: "#FE2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "86%",
        stopColor: "#FF318C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "6.3%",
        x2: "94.6%",
        y1: "13.9%",
        y2: "87.7%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "2%",
        stopColor: "#FF318C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "21%",
        stopColor: "#FE2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "86%",
        stopColor: "#FDB60D"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "91.1%",
        x2: "2%",
        y1: "27.7%",
        y2: "68.6%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "1%",
        stopColor: "#FDB60D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "86%",
        stopColor: "#FCF84A"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M112.7 117.4 42 57.6a25.6 25.6 0 1 0-24.8 43.9h.3l.7.2 89 27.1a6 6 0 0 0 2 .4 6.4 6.4 0 0 0 3.3-11.8Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M126.8 18.7A18.6 18.6 0 0 0 98 3L11.8 55.4a25.6 25.6 0 1 0 30.6 41l77.3-63 .6-.5c4.1-3.6 6.5-8.7 6.5-14.2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M252.2 131.5 121.4 5.5A18.6 18.6 0 1 0 96 32.8l.2.3 139 117a12.6 12.6 0 0 0 17-18.6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M256 140.6a12.6 12.6 0 0 0-20-10.3L77.9 207.7a25.6 25.6 0 1 0 26.4 43.7l146.4-100.5c3.4-2.4 5.4-6.2 5.4-10.3Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M75.8 76.9h102.5v102.4H75.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M87 160.1h38.4v6.4H87zm-1.6-56.8 2.8-2.7c.6.9 1.5 1.4 2.6 1.5 1 0 1.8-.8 1.8-2.3v-10H97v10c.1 1.7-.5 3.4-1.6 4.6a6 6 0 0 1-4 1.7H91c-2 0-4-.9-5.4-2.5zM99 89.7h12.8v3.8h-8.5v2.4h7.6v3.4h-7.6v2.6h8.6v3.7h-13V89.7Zm19 3.9h-4.7v-3.9h14v3.9h-4.8v12.1h-4.4V93.6ZM87.3 112h7.5a6 6 0 0 1 4.4 1.4c.7.7 1 1.7 1 2.6 0 1.6-1 3-2.5 3.6 2 .4 3.3 2 3.2 4 0 2.8-2.2 4.5-6 4.5h-7.6v-16Zm8.5 5c0-1-.7-1.4-2-1.4h-2.2v2.8h2.1c1.4 0 2.1-.5 2.1-1.4m-1.5 4.5h-2.7v3h2.8c1.3 0 2-.6 2-1.5s-.5-1.4-1.8-1.5zm17.1 6.6-3.2-4.8h-1.5v4.8h-4.4v-16h7.1a7 7 0 0 1 5.2 1.6 5 5 0 0 1 1.4 3.4v.4c.1 2.1-1.2 4.1-3.3 4.9l3.2 4.7 6.3-15.2h4.3l6.8 16.1h-4.8l-1.1-2.9h-6.2l-1.1 3zm13-11-1.9 4.6h3.6l-1.8-4.5ZM109 116h-2.3v3.8h2.4c1.4 0 2.4-.7 2.4-1.9 0-1.3-1-2-2.5-2Zm25-4h4.3v16H134zm6 0h4.2l5.7 8.6V112h4.4v16h-3.9l-6-8.8v8.8H140zm15 13.7 2.5-3a8.3 8.3 0 0 0 5.1 2c1.2 0 1.9-.4 1.9-1.1 0-.5-.3-.9-1.4-1.2l-.4-.2h-.3l-.7-.2h-.3l-.7-.2-.6-.2c-2.6-.8-4.4-1.9-4.4-4.6 0-3 2.4-5.1 6.2-5.1 2.4-.1 4.7.7 6.6 2.1l-2.2 3a7.8 7.8 0 0 0-4.4-1.5c-1.1 0-1.6.4-1.6 1s.3.9 1.3 1.2l.5.1.3.1.7.2c3.6.8 5.9 2 5.9 5 0 3.1-2.4 5-6 5h-.5c-2.5.2-5-.6-7-2z"
    }));

const JetBrainsFleet = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 70 70",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(22.35433 -20.58122 27.17129 29.51214 38.648 42.538)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.771,
        stopColor: "#001AFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#8ACEFF"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(-30.543 79.837 -70.068)scale(16.777 22.1489)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.719,
        stopColor: "#FA00FF",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF00D6",
        stopOpacity: 0.44
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(49.385 -19.814 41.858)scale(47.8852)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.026,
        stopColor: "#8DFDFD"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.271,
        stopColor: "#87FBFB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.484,
        stopColor: "#74D6F4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.932,
        stopColor: "#0038FF"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(137.237 9.434 23.195)scale(32.8316)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.267,
        stopColor: "#0500FF",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0500FF",
        stopOpacity: 0.15
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__e",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(75.198 -4.629 32.631)scale(51.1484)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.42,
        stopColor: "#FF00E5",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.774,
        stopColor: "#FF00F5",
        stopOpacity: 0.64
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.899,
        stopColor: "#BE46FF",
        stopOpacity: 0.87
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__g",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(2.73484 22.75837 -34.39872 4.13365 29.458 35.276)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#00B2FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.571,
        stopColor: "#74C5FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#9FD7FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: 11.644,
        x2: 82.363,
        y1: 42.432,
        y2: 43.401,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.432,
        stopColor: "#FE62EE",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.818,
        stopColor: "#FD3AF5",
        stopOpacity: 0.47
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: 33.054,
        x2: 37.35,
        y1: 23.191,
        y2: 49.344,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#0038FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.724,
        stopColor: "#48BFF1",
        stopOpacity: 0.59
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#74C5FF",
        stopOpacity: 0
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M65.153 30.85c0 9.496-10.163 17.194-22.7 17.194S19.754 40.346 19.754 30.85s10.163-17.194 22.7-17.194 22.699 7.698 22.699 17.194"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M65.153 30.85c0 9.496-10.163 17.194-22.7 17.194S19.754 40.346 19.754 30.85s10.163-17.194 22.7-17.194 22.699 7.698 22.699 17.194"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M66 35c0 17.12-13.88 31-31 31S4 52.12 4 35 17.88 4 35 4c8.046 3.642 16.464 17.194 19.99 21.429 3.524 4.235 12.648 9.571 8.176-1.623C65.073 26.832 66 31.852 66 35"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M66 35c0 17.12-13.88 31-31 31S4 52.12 4 35 17.88 4 35 4c8.046 3.642 16.464 17.194 19.99 21.429 3.524 4.235 12.648 9.571 8.176-1.623C65.073 26.832 66 31.852 66 35"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M66 35c0 17.12-13.88 31-31 31S4 52.12 4 35 17.88 4 35 4c8.046 3.642 16.464 17.194 19.99 21.429 3.524 4.235 12.648 9.571 8.176-1.623C65.073 26.832 66 31.852 66 35"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M66 35c0 17.12-13.88 31-31 31S4 52.12 4 35 17.88 4 35 4c8.046 3.642 16.464 17.194 19.99 21.429 3.524 4.235 12.648 9.571 8.176-1.623C65.073 26.832 66 31.852 66 35"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M56.651 39.682c1.658 7.764-6.511 16.089-18.246 18.594s-22.59-1.757-24.248-9.52c-1.658-7.764 6.511-16.089 18.246-18.594s22.59 1.757 24.248 9.52"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M56.651 39.682c1.658 7.764-6.511 16.089-18.246 18.594s-22.59-1.757-24.248-9.52c-1.658-7.764 6.511-16.089 18.246-18.594s22.59 1.757 24.248 9.52"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D6F8F8",
        fillOpacity: 0.19,
        fillRule: "evenodd",
        d: "M51.462 49.883c3.074-3.133 4.386-6.66 3.698-9.882-.688-3.223-3.326-5.907-7.411-7.51-4.073-1.6-9.412-2.037-15.028-.838s-10.31 3.779-13.375 6.901c-3.074 3.133-4.386 6.66-3.698 9.883s3.326 5.906 7.412 7.51c4.072 1.6 9.41 2.037 15.027.838 5.616-1.2 10.31-3.779 13.375-6.902m-13.057 8.393c11.735-2.505 19.904-10.83 18.246-18.594-1.658-7.763-12.514-12.026-24.248-9.52-11.735 2.505-19.904 10.83-18.246 18.593 1.658 7.764 12.514 12.026 24.248 9.521",
        clipRule: "evenodd"
    }));

const JetBrainsMono = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h256v256H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M28 208h96v16H28zM24 66l7-7c1 2 4 4 6 4 3 0 5-2 5-6V32h11v25c0 5-1 9-4 12-3 2-6 4-10 4h-1c-5 0-10-2-14-6zm34-34h32v9H69v7h19v8H69v6h21v10H58zm48 10H94V32h35v10h-12v30h-11zM28 88h19c4-1 8 1 11 3 2 2 3 4 3 7 0 4-3 7-7 9 5 1 8 5 8 10 0 7-5 11-15 11H28zm22 12c0-2-2-3-5-3h-6v7h5c4 0 6-1 6-4m-4 11h-7v8h7c3 0 5-1 5-4 0-2-1-3-4-3zm43 17-8-12h-4v12H66V88h18c4-1 9 1 13 4q3 3 3 9c0 6-3 11-8 13l8 11 16-37h10l17 40h-12l-2-7h-16l-3 7zm32-27-5 11h9zm-38-4h-6v10h6c4 0 6-2 6-5s-2-5-6-5m62-9h11v40h-11zm15 0h11l14 21V88h11v40h-10l-15-22v22h-11zm38 34 6-8c4 3 8 5 13 5 3 0 4-1 4-3 0-1 0-2-3-3h-3l-1-1h-2l-2-1c-6-1-10-4-10-11s5-13 15-13c6 0 12 2 16 6l-5 7c-3-2-7-4-11-4-3 0-4 1-4 3l3 3h2l2 1c9 2 15 5 15 12 0 8-6 13-15 13h-1c-7 0-13-2-18-5z"
    }));

const JetBrainsPhpStorm = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 105 105",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 22.7,
        x2: 49.807,
        y1: 60.354,
        y2: 8.295,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#AF1DF5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.212,
        stopColor: "#BC20E4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.628,
        stopColor: "#DD29B8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF318C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 14.919,
        x2: 47.777,
        y1: 76.279,
        y2: 32.877,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.016,
        stopColor: "#6B57FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.424,
        stopColor: "#B74AF7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.746,
        stopColor: "#FF318C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 89.261,
        x2: 71.054,
        y1: 64.564,
        y2: 21.351,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#293896"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.075,
        stopColor: "#3B3AA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.287,
        stopColor: "#6740C0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.491,
        stopColor: "#8A44D8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.683,
        stopColor: "#A347E9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.858,
        stopColor: "#B249F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#B74AF7"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 74.34,
        x2: 44.071,
        y1: 90.066,
        y2: 45.698,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.016,
        stopColor: "#6B57FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.783,
        stopColor: "#B74AF7"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 65.166,
        x2: 55.137,
        y1: 66.25,
        y2: 13.215,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.016,
        stopColor: "#6B57FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.637,
        stopColor: "#B74AF7"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: 15.922,
        x2: 31.544,
        y1: 43.224,
        y2: 14.874,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#AF1DF5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.212,
        stopColor: "#BC20E4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.628,
        stopColor: "#DD29B8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF318C"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m57.993 21.877-3.202-9.678-14.86 7.183-19.67 1.735 2.7 33.75L50.858 50.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M31.48 30.491 5 23.532l9.152 54.958 49.308-.48z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m67.896 53.903-11.38-19.478L68.86 23.239l19.647-8.04L101 46.245l-17.992 17.87z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "m83.017 45.832-6.25-12.757-49.008 9.846 5.034 46.795L65.147 101 101 79.54z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M57.674 48.118 27.76 42.92 64.274 10.7l24.233 4.5-15.019 14.983 3.472 3.086z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M54.791 12.2 21.376 5 5 23.533l26.527 7.052z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M83 23H23v60h60z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M53 71.75H30.5v3.75H53zm-2.856-21.73 2.935-3.513c2.03 1.675 4.16 2.74 6.735 2.74 2.034 0 3.258-.806 3.258-2.13v-.064c0-1.256-.774-1.902-4.546-2.867-4.547-1.16-7.482-2.421-7.483-6.899v-.069c0-4.09 3.29-6.803 7.9-6.803a13.06 13.06 0 0 1 8.383 2.872l-2.58 3.74c-1.998-1.388-3.964-2.225-5.866-2.225s-2.904.87-2.904 1.966v.064c0 1.483.97 1.97 4.87 2.967 4.578 1.192 7.159 2.84 7.159 6.772v.063c0 4.483-3.417 6.995-8.286 6.995a14.37 14.37 0 0 1-9.575-3.609M30.568 30.758h9.181c5.36 0 8.603 3.178 8.603 7.768v.064c0 5.2-4.045 7.897-9.085 7.897h-3.756v6.74h-4.943zm8.86 11.33c2.472 0 3.916-1.475 3.916-3.402v-.064c0-2.215-1.54-3.402-4.013-3.402h-3.82v6.869z"
    }));

const JetBrainsPyCharm = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 105 105",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 38.78,
        x2: 95.91,
        y1: 41.59,
        y2: 41.59,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#07c3f2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: -29.18,
        x2: 88.46,
        y1: 85.52,
        y2: -1.32,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#fcf84a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.11,
        stopColor: "#a7eb62"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.21,
        stopColor: "#5fe077"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.27,
        stopColor: "#32da84"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.31,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.58,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.69,
        stopColor: "#20d68c"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.76,
        stopColor: "#1ed497"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.83,
        stopColor: "#19d1a9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopColor: "#13ccc2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.97,
        stopColor: "#0bc6e1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#07c3f2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 17.3,
        x2: 36.92,
        y1: 110.99,
        y2: 49.42,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.16,
        stopColor: "#24d888"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#2fd985"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.43,
        stopColor: "#41dc80"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.55,
        stopColor: "#5ae079"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.67,
        stopColor: "#7ae46f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.79,
        stopColor: "#a1ea64"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopColor: "#cff157"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fcf84a"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 43.28,
        x2: 85.97,
        y1: 57.46,
        y2: 0.06,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.09,
        stopColor: "#23d986"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.17,
        stopColor: "#2ade7b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#36e669"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.27,
        stopColor: "#3bea62"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.35,
        stopColor: "#47eb61"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.49,
        stopColor: "#67ed5d"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.69,
        stopColor: "#9af156"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.92,
        stopColor: "#e0f64d"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fcf84a"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 108.58,
        x2: 22.55,
        y1: 64.77,
        y2: 63.97,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.39,
        stopColor: "#fcf84a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.46,
        stopColor: "#ecf74c"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.61,
        stopColor: "#c1f451"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.82,
        stopColor: "#7eef5a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#3bea62"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m71.81 19.65 28.05 23.33-10.1 20.55-16.91-4.69H58.22z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m43.55 34.8-5.43 28.73-.52 9.76-13.69 5.93L4.5 81.31l5.89-62.07L45.56 4.5l21.67 14.21z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m43.55 34.8 2.64 55.36-8.77 10.34L4.5 81.31l27.03-40.28z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M79.77 30.76H46.51L75.9 4.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "m100.5 90.38-29.28 9.94-38.99-10.98L43.55 34.8l4.52-4.04 23.74-2.23-2.15 23.84 18.88-7.32z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22.5 22.5h60v60h-60z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M29.98 71.16h22.5v3.75h-22.5zM30 30h9.2c5.36 0 8.61 3.18 8.61 7.77v.06c0 5.2-4.05 7.9-9.09 7.9H35v6.74h-5zm8.86 11.33c2.47 0 3.92-1.47 3.92-3.4v-.06c0-2.22-1.54-3.41-4-3.41H35v6.87zm11.63-.02v-.06A11.41 11.41 0 0 1 62.2 29.63a11.6 11.6 0 0 1 8.86 3.46l-3.14 3.63a8.33 8.33 0 0 0-5.75-2.54c-3.79 0-6.52 3.15-6.52 7v.07c0 3.85 2.67 7.06 6.52 7.06 2.57 0 4.14-1 5.91-2.63l3.14 3.17a11.46 11.46 0 0 1-9.21 4 11.35 11.35 0 0 1-11.52-11.54"
    }));

const JetBrainsRider = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "90.8%",
        x2: "-19.1%",
        y1: "81.8%",
        y2: "19%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#DD1265"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "48%",
        stopColor: "#DD1265"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "94%",
        stopColor: "#FDB60D"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "36%",
        x2: "53.7%",
        y1: "7.3%",
        y2: "93%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "14%",
        stopColor: "#087CFA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "48%",
        stopColor: "#DD1265"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "96%",
        stopColor: "#087CFA"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "39.5%",
        x2: "56.9%",
        y1: "11.4%",
        y2: "91.7%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "28%",
        stopColor: "#DD1265"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "97%",
        stopColor: "#FDB60D"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M256 99.6 76.5 0l120.2 178.5 24.7-16.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M184.4 59 161.9 4l-49.7 49 20.3 177.6 48.2 25.4 75.3-44z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M76.5 0 0 51.5l28.5 175.9 73.3 28.2 94.9-77.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M48 48.3h160v160H48z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M68 178h60v10H68zm0-109.9h27.5a24 24 0 0 1 17.5 6.1c3.3 3.5 5.2 8.2 5.2 13v1c.4 8.4-5 16-13 18.6l14.8 21.5h-15.5L91.6 109H81.3v19.3H68V68Zm26.7 29.3c6.2 0 9.9-3.2 10.1-8v-.6c0-5.7-4-8.6-10.4-8.6h-13v17.2zM129 68.1h23.5c18.6 0 31.6 12.6 32 29.1v1c0 17-13 30-32 30H129v-60Zm13.4 12v36.2h10.2A17.1 17.1 0 0 0 171 99.1v-1a17.3 17.3 0 0 0-18.2-18h-10.2Z"
    }));

const JetBrainsRubyMine = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 105 105",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 65.05,
        x2: 52.91,
        y1: 60.03,
        y2: 28.18,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#fe2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.06,
        stopColor: "#fe3052"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.33,
        stopColor: "#fd533b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.58,
        stopColor: "#fc6c2a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.81,
        stopColor: "#fc7b20"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fc801d"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 41.93,
        x2: 60.67,
        y1: 14.45,
        y2: 31.63,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#6b57ff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fe2857"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 3.92,
        x2: 65.63,
        y1: 19.88,
        y2: 98.32,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#6b57ff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#fe2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.63,
        stopColor: "#fe2857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.64,
        stopColor: "#fe3052"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#fd533b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.76,
        stopColor: "#fc6c2a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.81,
        stopColor: "#fc7b20"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.85,
        stopColor: "#fc801d"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m83.34 4.5-27.47 9.84L34.22 4.5l-7.13 17.96h-4.61v53.02l66.67.58 10.35-52.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m82.52 38.95-43.87-26 43.87 51.42z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m43.46 98 35.88-4.78-5.57-10.71h8.75V64.37l-43.88-51.5L3.5 21.5l.04 50.4 20.2 28.6 19.61-2.49.09-.01z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22.5 22.5h60v60h-60z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M29.98 71.16h22.5v3.75h-22.5zm22.23-41.19h5.35l5.93 9.54 5.93-9.54h5.35v22.55h-4.93V37.8l-6.35 9.63h-.13l-6.28-9.53v14.62h-4.87zM30 30h10.3q4.28 0 6.56 2.28a7 7 0 0 1 1.93 5.15v.07a7 7 0 0 1-1.34 4.45 7.74 7.74 0 0 1-3.49 2.53l5.51 8h-5.8L39 45.57h-4.09v6.92H30zm10 10.91a4.12 4.12 0 0 0 2.77-.91 3 3 0 0 0 1-2.32v-.06a2.85 2.85 0 0 0-1-2.41 4.53 4.53 0 0 0-2.86-.81h-4.98v6.47z"
    }));

const JetBrainsWebStorm = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 105 105",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 38.88,
        x2: 63.72,
        y1: 6.5,
        y2: 95.94,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.28,
        stopColor: "#07c3f2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.94,
        stopColor: "#087cfa"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 46.63,
        x2: 88.66,
        y1: 17.85,
        y2: 79.48,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.14,
        stopColor: "#fcf84a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.37,
        stopColor: "#07c3f2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__c",
        x1: 88.27,
        x2: 93.79,
        y1: 25.47,
        y2: 45.02
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M17.44 91.26 4.5 14.56l23.93-9.93 15.28 9.08 14-7.55 29.17 11.2-16.36 83.14z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M100.5 37.01 88.11 6.41 65.63 4.5l-34.7 33.34 9.34 42.97 17.44 12.23 42.79-25.39L90 47.96z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M81.27 32.45 90 47.96l10.5-10.95-7.71-19.06z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22.5 22.5h60v60h-60z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M29.98 71.16h22.5v3.75h-22.5zm21.3-41.19L47.93 43.1 44.1 29.97h-3.81L36.45 43.1l-3.34-13.13h-5.25l6.43 22.51h4.22l3.68-13.03 3.64 13.03h4.27l6.42-22.51zm6.18 19.3 2.93-3.51a10.34 10.34 0 0 0 6.74 2.74c2 0 3.26-.8 3.26-2.13v-.06c0-1.26-.78-1.9-4.55-2.87-4.55-1.16-7.48-2.42-7.48-6.9v-.07c0-4.09 3.29-6.8 7.9-6.8a13 13 0 0 1 8.38 2.87l-2.58 3.74a10.54 10.54 0 0 0-5.87-2.22c-1.9 0-2.9.87-2.9 2v.07c0 1.48 1 2 4.87 3 4.58 1.2 7.16 2.84 7.16 6.78v.06c0 4.48-3.42 7-8.29 7a14.34 14.34 0 0 1-9.57-3.61"
    }));

const JetbrainsSpace = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "45.082%",
        x2: "55.522%",
        y1: "-1.343%",
        y2: "97.61%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FCF84A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "32%",
        stopColor: "#ABE682"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "79%",
        stopColor: "#36CDD2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#07C3F2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "-2.942%",
        x2: "100.445%",
        y1: "38.992%",
        y2: "62.105%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#3BEA62"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#087CFA"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "-3.308%",
        x2: "111.745%",
        y1: "71.807%",
        y2: "15.462%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#009AE5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "18%",
        stopColor: "#0490DD"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "49%",
        stopColor: "#1073C6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "89%",
        stopColor: "#2346A1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#293896"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M46.36 255.991c91.075-7.978 170.982-63.92 209.64-146.768C208.12 40.799 129.873.033 46.36 0Q35.2 0 23.936.99c-38.612 82.903-30.064 180.109 22.424 255Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M24.209 1.024a301.4 301.4 0 0 1 134.685 108.199H256C208.263 40.76 130.062-.03 46.6 0Q35.438 0 24.209 1.024"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M158.894 109.223C147.187 186.6 46.258 255.99 46.258 255.99c91.781-8.67 172.23-63.622 209.742-146.768z"
    }));

const Julia = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 320 200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        stroke: "#eee",
        strokeWidth: 2
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M67.871 164.313q0 11.303-2.543 18.253-2.541 6.955-7.234 10.797-4.688 3.844-11.246 5.145c-4.371.863-9.235 1.297-14.582 1.297q-10.858 0-16.618-3.39c-3.843-2.263-5.765-4.974-5.765-8.142 0-2.636 1.07-4.859 3.219-6.668q3.221-2.711 8.648-2.71 4.073 0 6.5 2.203c1.621 1.468 2.96 2.922 4.016 4.351q1.806 2.373 3.05 3.164 1.243.792 2.262.793 2.146 0 3.277-2.543 1.13-2.543 1.13-9.89V84.05L67.87 76.93v87.383m36.867-84.899v59.8q0 2.49.961 4.692a11.3 11.3 0 0 0 2.656 3.79 13.5 13.5 0 0 0 3.957 2.542q2.262.96 4.864.961c1.957 0 4.183-1.097 6.894-2.996 4.293-3.008 6.895-5.074 6.895-7.52V79.415h25.773v84.899h-25.773v-7.915q-5.085 4.294-10.852 6.895-5.765 2.602-11.191 2.602-6.33-.001-11.758-2.094-5.425-2.092-9.492-5.707a26.5 26.5 0 0 1-6.39-8.48q-2.317-4.86-2.317-10.4v-59.8h25.773m88.145 84.899h-25.66V45.277l25.66-7.12v126.156m10.719-80.262 25.773-7.121v87.383h-25.773V84.05m79.625 36.398a82 82 0 0 0-7.52 3.676c-2.523 1.395-4.824 2.922-6.894 4.578-2.075 1.656-3.75 3.43-5.032 5.313s-1.922 3.843-1.922 5.879q0 2.374.621 4.578.623 2.202 1.754 3.785 1.13 1.581 2.489 2.543 1.354.96 2.937.96 3.164 0 6.387-1.921 3.22-1.92 7.18-4.86v-24.53m25.882 43.863h-25.882v-6.786a95 95 0 0 1-4.184 3.336q-2.034 1.525-4.578 2.657-2.542 1.128-5.711 1.753-3.167.622-7.457.622-5.883-.001-10.57-1.696c-3.13-1.133-5.786-2.676-7.97-4.637a19.9 19.9 0 0 1-5.03-6.953q-1.753-4.01-1.754-8.757c0-3.243.62-6.18 1.867-8.82q1.863-3.954 5.086-7.122 3.221-3.163 7.515-5.652a84 84 0 0 1 9.215-4.578 130 130 0 0 1 10.23-3.84 474 474 0 0 1 10.512-3.336l2.829-.68v-8.363c0-5.426-1.04-9.27-3.11-11.531q-3.112-3.392-8.308-3.39-6.107 0-8.48 2.937-2.375 2.939-2.376 7.12a21 21 0 0 1-.508 4.637c-.336 1.508-.922 2.825-1.75 3.957q-1.242 1.697-3.562 2.711-2.316 1.02-5.82 1.02c-3.618 0-6.555-1.04-8.817-3.11-2.262-2.074-3.39-4.69-3.39-7.859q-.001-4.406 2.992-8.191c2-2.528 4.691-4.696 8.086-6.5 3.39-1.813 7.308-3.242 11.754-4.297q6.669-1.582 14.128-1.582 9.159.001 15.774 1.637 6.61 1.64 10.906 4.69 4.295 3.053 6.328 7.349c1.36 2.863 2.035 6.07 2.035 9.609v63.644"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CB3C33",
        d: "M235.273 55.09c0 9.668-7.835 17.5-17.5 17.5-9.668 0-17.5-7.832-17.5-17.5 0-9.664 7.832-17.5 17.5-17.5 9.665 0 17.5 7.836 17.5 17.5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4063D8",
        d: "M72.953 55.09c0 9.668-7.836 17.5-17.5 17.5s-17.5-7.832-17.5-17.5c0-9.664 7.836-17.5 17.5-17.5s17.5 7.836 17.5 17.5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9558B2",
        d: "M277.32 55.09c0 9.668-7.836 17.5-17.5 17.5s-17.5-7.832-17.5-17.5c0-9.664 7.836-17.5 17.5-17.5s17.5 7.836 17.5 17.5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#389826",
        d: "M256.3 18.672c0 9.664-7.835 17.5-17.5 17.5-9.667 0-17.5-7.836-17.5-17.5s7.833-17.5 17.5-17.5c9.665 0 17.5 7.836 17.5 17.5"
    })));

const Keycloak = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 168 151",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#4D4D4D",
        d: "M21.902 37.302 43.506.013l87-.011 21.486 37.659.027 75.332-21.51 37.637-86.973.03-21.853-37.663z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EDEDED",
        d: "M21.687 112.986h39.208L39.36 75.036 56.874 37.31l-34.968-.007L0 75.342"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E0E0E0",
        d: "M72.785 112.986h28.66l25.342-36.937-24.9-38.385H68.174L47.867 74.756z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ACACAC",
        d: "m0 75.338 21.687 37.659h39.212l-21.301-37.53z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9E9E9E",
        d: "m48.28 75.346 24.51 37.651h28.655l24.945-37.636z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00B8E3",
        d: "m57.985 75.365-7.397 2.154-7.098-2.158 28.978-50.23 7.249 12.541"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#33C6E9",
        d: "m79.687 112.986-7.212 12.593-19.248-20.738-9.751-29.468v-.016H57.98"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#008AAA",
        d: "M43.494 75.361h-.015v.011l-7.245 12.556-7.276-12.499 7.378-12.797 21.649-37.493h14.49"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D4D4D4",
        d: "M123.226 112.986h43.888l-.027-75.325h-43.861z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#919191",
        d: "M123.226 75.463v37.53h43.808v-37.53z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00B8E3",
        d: "M72.483 125.594H57.981l-21.747-37.67 7.245-12.548z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#008AAA",
        d: "m130.464 75.361-28.985 50.222c-2.664-3.916-7.23-12.586-7.23-12.586l21.743-37.643z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00B8E3",
        d: "m115.955 125.583-14.476-.004 28.989-50.222 7.241-12.54 7.265 12.624m-14.51-.08h-14.468l-21.75-37.693 7.199-12.525 17.605 22.382z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#33C6E9",
        d: "M137.709 62.81v.01l-7.245 12.541-29.015-50.214 14.517.007z"
    }));

const KickDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 933 300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "evenodd",
        d: "M0 0h100v66.667h33.333V33.333h33.334V0h100v100h-33.334v33.333H200v33.334h33.333V200h33.334v100h-100v-33.333h-33.334v-33.334H100V300H0zm666.667 0h100v66.667H800V33.333h33.333V0h100v100H900v33.333h-33.333v33.334H900V200h33.333v100h-100v-33.333H800v-33.334h-33.333V300h-100zM300 0h100v300H300zm233.333 0h-66.666v33.333h-33.334v233.334h33.334V300h166.666V200h-100V100h100V0z",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h933v300H0z"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__b"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h933.333v300H0z"
    }))));

const KickLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 933 300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#53FC18",
        fillRule: "evenodd",
        d: "M0 0h100v66.667h33.333V33.333h33.334V0h100v100h-33.334v33.333H200v33.334h33.333V200h33.334v100h-100v-33.333h-33.334v-33.334H100V300H0zm666.667 0h100v66.667H800V33.333h33.333V0h100v100H900v33.333h-33.333v33.334H900V200h33.333v100h-100v-33.333H800v-33.334h-33.333V300h-100zM300 0h100v300H300zm233.333 0h-66.666v33.333h-33.334v233.334h33.334V300h166.666V200h-100V100h100V0z",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h933v300H0z"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__b"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h933.333v300H0z"
    }))));

const Kotlin = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "99.991%",
        x2: ".01%",
        y1: "-.011%",
        y2: "100.01%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: ".344%",
        stopColor: "#E44857"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "46.89%",
        stopColor: "#C711E1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#7F52FF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M256 256H0V0h256L128 127.949z"
    }));

const KrakenJS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 274",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0081C2",
        d: "M128 1.3 0 64v148.1L128 275l128-62.8V64.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M225.1 185.6c-.4-2.7-1.5-5.3-3-7.4a23.2 23.2 0 0 0-5-5.2 33.4 33.4 0 0 0-12.8-5.8 45.9 45.9 0 0 0 7-13.4 26 26 0 0 0 1-10.3c-.5-3.5-1.8-6.9-3.8-9.6-1-1.3-2-2.6-3.3-3.7l-.9-.7-1-.8-.9-.7-1-.6a1.1 1.1 0 0 0-1.4 1.7l.8.8.7.8.7.8.6.9q1.35 1.8 2.1 3.6c1.2 2.5 1.6 5.1 1.4 7.7-.2 2.5-1 5-2.2 7.4a32 32 0 0 1-8 10.1l-.4.3s.1-.1 0 0h-.1a25.9 25.9 0 0 1-8.6 3.8 24.7 24.7 0 0 1-13.9-.7h-.3a25.2 25.2 0 0 0 5.7-1.6 19 19 0 0 0 11.4-13.7l.6-3.8a39 39 0 0 0 0-7v-1l-.1-.8-.1-.8-.1-.8v-.3l-.1-.2v-.3l-.2-.7-.2-1.4-.8-5.7-.2-2.8-.2-2.8v-8.5l.3-2.7a36 36 0 0 1 1.1-5.4c.5-1.7 1.2-3.4 2-5 1-1.5 2-2.9 3.3-4a9 9 0 0 1 3.4-1.7l.6-.1.7-.1a1.1 1.1 0 0 0 0-2.2l-.7-.1h-.9a11.1 11.1 0 0 0-5 1.3c-2 1-3.7 2.5-5.1 4.2a27.5 27.5 0 0 0-3.7 5.5c-1 2-1.7 4-2.4 6l-1 3-.6 3.2a83 83 0 0 0-1.8 18.7v5l-.1.6a25.4 25.4 0 0 1-1.5 6.8c-.3.6-.5 1.1-.9 1.5-.6.9-1.2 1.3-1.8 1.6a7 7 0 0 1-2.6.5 15.8 15.8 0 0 1-4.4-.5s-5-1.8-3.4-7.6a9.1 9.1 0 0 1 7-4.9s8.2-63.3-43-104C76.6 72.7 84.8 136 84.8 136c4 .6 6.2 3 7.2 5.3 1.3 5.1-2.9 7-3.4 7.2l-.7.1c-1.4.3-2.7.4-3.8.4a7 7 0 0 1-2.6-.5c-.6-.3-1.2-.7-1.9-1.6l-.8-1.5-.7-2c-.4-1.5-.6-3.1-.8-4.8v-3l-.1-.2V133a123 123 0 0 0-1.8-18.7l-.7-3.1-.9-3.1-2.4-6c-1-2-2.2-3.8-3.7-5.5a17.5 17.5 0 0 0-5.2-4.2 12.1 12.1 0 0 0-5-1.3H56a1.1 1.1 0 0 0 0 2.3h.8l.6.2a8.4 8.4 0 0 1 3.4 1.7c1.3 1.1 2.4 2.5 3.2 4a23 23 0 0 1 2 5 36 36 0 0 1 1.2 5.4l.2 2.7.2 2.8v5.7c-.2.9-.2 1.8-.3 2.8a115 115 0 0 1-1 8.5l-.2 1.4-.1.7v.3l-.1.1v.4l-.2.8v.8l-.2.9v.8a38.8 38.8 0 0 0 .6 10.9 23.8 23.8 0 0 0 3.8 7.9 18.6 18.6 0 0 0 7.6 5.8 23 23 0 0 0 5.7 1.5l-.3.1a22.7 22.7 0 0 1-14 .7 29 29 0 0 1-8.5-3.7l-.1-.1c-.1-.1 0 0 0 0l-.3-.3a25 25 0 0 1-3.6-3.5A32 32 0 0 1 52 151c-1.2-2.4-2-4.9-2.2-7.4-.2-2.6.2-5.2 1.4-7.7.5-1.2 1.2-2.5 2-3.6l.7-.9.7-.8.7-.8.8-.9a1.1 1.1 0 0 0-1.5-1.7l-1 .7-.9.7-1 .7-.8.8c-1.2 1.1-2.3 2.4-3.3 3.7-2 2.7-3.3 6-3.7 9.6-.5 3.5 0 7 1 10.3a40 40 0 0 0 7 13.4 34.2 34.2 0 0 0-12.9 5.8 23.3 23.3 0 0 0-5 5.2 16.9 16.9 0 0 0-.8 18.6 22.8 22.8 0 0 0 4 5.1l.5.6.3.3.3.3 1 .9a57.4 57.4 0 0 0 14 8.9c3 1.4 6 2.5 9 3.6v.2l.2.5.3.6.6 1 .1.3.2.2.4.5.7.9c2 2.4 4.6 4 7.2 5a20 20 0 0 0 7.9 1.1h1l.9-.1 1-.2.8-.2 1-.2h.4l.5-.2 1-.3.4-.2.4-.1 1.4-.6.1-.1h.3v-.1l.4-.2.6-.3 1.2-.5 1.2-.5a33.7 33.7 0 0 1 15.4-2c1.8.2 3.4.7 5 1.4 1.5.7 2.9 1.6 4 2.7l.4.5.4.5.2.2.2.3.3.5c.4.7.8 1.5 1 2.3l.1.6.1.7v.3l.1.3v2l-.1 1.4a1.1 1.1 0 0 0 2.2.5l.4-1.4.3-1.7.1-.8V229c-.1-1.2-.4-2.3-.7-3.3l-.4-.8-.1-.4-.2-.4-.4-.8-.5-.7-1-1.4-.6-.6-.6-.6a24.7 24.7 0 0 0-8.7-4.9 35.3 35.3 0 0 0-19.4-.5l-1.6.4-1.5.4-.8.3h-.4l-.1.1c.3-.1 0 0 0 0l-1.5.4h-.5l-.5.2H80a9.2 9.2 0 0 1-3.6-1c-1-.6-1.7-1.3-2-2-.5-.8-.5-1.4-.5-2.2.1-.7.4-1.5 1-2.5.5-1 1.3-2 2.3-3 2-1.8 4.7-3.6 7.7-5.1l.6-.3.5-.3 1.2-.5 2.4-1 2.7-1.1 1.4-.6h.2l.2-.1.4-.2.7-.4 2.9-1.4c6-2.7 18.7-7.7 30-7.7s24 5 30 7.7l2.9 1.4.7.4.4.2h.2l.2.1 1.4.6 2.7 1.1 2.4 1 1.1.5.6.3.6.3c3 1.5 5.7 3.3 7.7 5.2 1 1 1.8 2 2.4 2.9.5 1 .8 1.8.9 2.5 0 .8 0 1.4-.4 2.2-.4.7-1.1 1.4-2.1 2-1 .5-2.2.9-3.6 1H173l-.5-.1h-.5l-1.4-.5h-.2s-.2-.1.1 0h-.1l-.4-.1-.8-.3-1.5-.4-1.6-.4a35.3 35.3 0 0 0-19.4.5 24.6 24.6 0 0 0-8.7 4.9l-.6.6-.6.6-1 1.4-.5.7-.4.8-.2.4-.1.4-.4.8c-.3 1-.6 2.1-.7 3.3v2.4l.1.8c0 .6.2 1.1.3 1.7l.4 1.4c.2.5.7.8 1.2.8.6-.1 1-.6 1-1.3l-.1-1.4v-2.7l.2-.7.1-.6c.2-.8.6-1.6 1-2.3l.3-.5.2-.3.2-.2.4-.5c0-.2.2-.3.4-.5 1.1-1.1 2.5-2 4-2.7 1.6-.7 3.3-1.2 5-1.4a29.2 29.2 0 0 1 15.4 2l1.2.5 1.2.5.6.3.3.2h.1l.3.1h.1l1.4.7.4.1.5.2 1 .3.4.1.5.1.9.2.9.2 1 .2h.9l1 .1a20 20 0 0 0 7.8-1.1c2.6-1 5.2-2.6 7.2-5l.8-1 .3-.4.2-.2.1-.3.6-1 .3-.6.2-.5v-.2a65 65 0 0 0 23-12.6l1-.8.3-.3.3-.3.6-.6a29 29 0 0 0 4-5.1l1.4-3.3a17 17 0 0 0 .7-7.9M75.5 188l-.7.5-.7.5-1.4 1-.7.6-.7.5-1.3 1.2-1.3 1.3-.6.6-.6.7-1.2 1.4c-1.6 2-3 4.3-4 7-.6 1.2-1 2.7-1.2 4.2l-.2 1.1v.2a92 92 0 0 1-11.3-8.6c-1.2-1-2.2-2.2-3.2-3.4l-.8-.8-.1-.3-.2-.2-.2-.3a17.3 17.3 0 0 1-1.8-3.4l-.4-1.4c-.1-1 0-1.7.2-2.3.3-.6.7-1.2 1.3-1.8s1.4-1.2 2.4-1.7c2-1 4.5-1.8 7-2.2a28.8 28.8 0 0 1 17.3 3.3l.9.4.7.4.5.2.5.3 2 .8zm37-44a4.1 4.1 0 1 1 0-8.3 4.1 4.1 0 0 1 0 8.2Zm31 0a4.1 4.1 0 1 1 0-8.3 4.1 4.1 0 0 1 0 8.2Zm69.6 46.4a9 9 0 0 1-1.1 3l-1 1.8-.3.3-.2.2-.1.2-.8 1A47.9 47.9 0 0 1 199 206a95 95 0 0 1-4 2.6v-1.3a27.5 27.5 0 0 0-5.2-11.1l-1.3-1.5-.6-.7-.6-.6-1.3-1.3-1.3-1.2-.7-.5a10 10 0 0 0-.7-.6l-1.4-1-.7-.5-.7-.5-.3-.2 2.1-.8.5-.3.5-.2.7-.4.9-.4 1.7-1a28.3 28.3 0 0 1 22.6-.1c1 .5 1.8 1 2.4 1.7.6.6 1 1.2 1.3 1.8.2.6.3 1.3.2 2.3Z"
    }));

const Kubernetes = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 722.8 702",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M365 185a47 46 0 0 0-18 4L103 306a47 46 0 0 0-25 32L18 600a47 46 0 0 0 6 35 47 46 0 0 0 3 4l169 210a47 46 0 0 0 36 18h271a47 46 0 0 0 37-18l169-210a47 46 0 0 0 9-39l-60-263a47 46 0 0 0-26-31L388 189a47 46 0 0 0-23-4z",
        style: {
            fill: "#326ce5",
            fillOpacity: 1,
            stroke: "#fff",
            strokeWidth: 0,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: "none"
        },
        transform: "translate(-6 -175)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M368 274c-8 0-15 7-15 16v4l2 14 2 27c-1 3-3 6-5 7v7a190 190 0 0 0-122 58l-6-3c-2 0-5 1-8-1l-20-18-10-10-3-3c-3-2-7-4-10-4-5 0-9 2-12 5-5 7-3 16 4 22l3 3 12 7 22 15c2 2 3 7 3 8l5 5c-26 37-37 84-30 131l-6 2c-2 2-4 6-7 7l-26 4-14 1-4 1c-9 2-14 10-13 18 2 8 11 12 19 11h1v-1h4l13-5c9-4 17-7 25-8l9 3 6-1c15 45 45 82 84 105l-2 7c1 2 2 5 1 8l-13 24-8 11-2 4c-4 8-1 18 6 21 8 4 17 0 20-8l2-4 5-13c3-10 6-20 11-27l6-3 3-6a189 189 0 0 0 135 1l4 5c2 1 5 2 7 5l10 24 4 14 2 4c4 8 13 11 20 8 8-4 10-13 7-21l-2-4-8-12c-6-8-10-15-13-23-1-4 0-6 1-8l-2-6c40-24 70-62 84-106l6 1c2-2 4-4 8-3 8 1 16 4 26 7l13 5 4 1c9 2 17-3 19-10 2-8-4-16-12-18l-5-1-14-1c-10-1-18-2-26-5-3-1-5-5-6-6l-6-2a189 189 0 0 0-31-131l6-5c0-3 0-5 2-8 6-6 13-10 22-16l12-7 4-2c7-6 8-16 3-22s-15-7-22-1l-3 2-10 11c-7 7-13 13-19 17-3 2-7 2-9 1l-6 4c-31-33-75-54-121-58v-7c-2-2-5-3-5-7-1-8 0-16 1-27l2-14v-4c0-9-6-16-14-16zm-19 113-4 77a13 13 0 0 1-21 10l-63-44a151 151 0 0 1 88-43zm37 0c33 5 64 20 88 43l-63 44a13 13 0 0 1-21-10zm-148 71 58 52a13 13 0 0 1-5 22l-74 22c-4-35 4-68 21-96zm259 0a153 153 0 0 1 22 95l-74-21a13 13 0 0 1-5-22h-1zm-141 56h23l15 18-5 23-21 10-21-10-6-23zm75 62h3l77 13c-12 32-33 59-61 77l-30-72a13 13 0 0 1 11-18zm-128 1a13 13 0 0 1 12 18l-29 71c-27-18-49-44-61-77l76-12zm64 31c2-1 4 0 6 1 3 1 5 3 6 5l38 68a154 154 0 0 1-98-1l37-67c3-4 7-6 11-6z",
        style: {
            fontSize: "medium",
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: 400,
            fontStretch: "normal",
            textIndent: 0,
            textAlign: "start",
            textDecoration: "none",
            lineHeight: "normal",
            letterSpacing: "normal",
            wordSpacing: "normal",
            textTransform: "none",
            direction: "ltr",
            blockProgression: "tb",
            writingMode: "lr-tb",
            textAnchor: "start",
            baselineShift: "baseline",
            color: "#000",
            fill: "#fff",
            fillOpacity: 1,
            stroke: "#fff",
            strokeWidth: 0.25,
            strokeMiterlimit: 4,
            strokeOpacity: 1,
            strokeDasharray: "none",
            marker: "none",
            visibility: "visible",
            display: "inline",
            overflow: "visible",
            fontFamily: "Sans",
            InkscapeFontSpecification: "Sans"
        },
        transform: "translate(-6 -175)"
    }));

const Laravel = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 264",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF2D20",
        d: "m255.9 59.6.1 1.1v56.6c0 1.4-.8 2.8-2 3.5l-47.6 27.4v54.2c0 1.4-.7 2.8-2 3.5l-99.1 57-.7.4-.3.1q-1.05.3-2.1 0l-.4-.1-.6-.3L2 206c-1.3-.8-2.1-2.2-2.1-3.6V32.7l.1-1.1.2-.4.3-.6.2-.4.4-.5.4-.3c.2 0 .3-.2.5-.3L51.6.6c1.3-.8 2.9-.8 4.1 0L105.3 29c.2 0 .3.2.4.3l.5.3c0 .2.2.4.3.5l.3.4.3.6.1.4.2 1v106l41.2-23.7V60.7c0-.4 0-.7.2-1l.1-.4.3-.7.3-.3.3-.5.5-.3.4-.4 49.6-28.5c1.2-.7 2.8-.7 4 0L254 57l.5.4.4.3.4.5.2.3c.2.2.2.5.3.7l.2.3Zm-8.2 55.3v-47l-17.3 10-24 13.7v47zm-49.5 85v-47l-23.6 13.5-67.2 38.4v47.5l90.8-52.3Zm-190-160V200l90.9 52.3v-47.5l-47.5-26.9-.4-.4c-.2 0-.3-.1-.4-.3l-.4-.4-.3-.4-.2-.5-.2-.5v-.6l-.2-.5V63.6L25.6 49.8l-17.3-10Zm45.5-31L12.4 32.8l41.3 23.7 41.2-23.7zM75 157.3l24-13.8V39.8l-17.3 10-24 13.8v103.6l17.3-10ZM202.3 36.9 161 60.7l41.3 23.8 41.3-23.8zm-4.1 54.7-24-13.8-17.3-10v47l24 13.9 17.3 10v-47Zm-95 106 60.6-34.5 30.2-17.3-41.2-23.8-47.5 27.4L62 174.3z"
    }));

const LayersDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 33",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        fillOpacity: 0.2,
        d: "M0 18.83.08 6.832C.094 4.66 1.613 2.798 3.71 2.383L15.297.086c2.784-.552 5.368 1.627 5.35 4.51l-.08 12c-.015 2.171-1.534 4.032-3.631 4.448L5.349 23.341C2.565 23.893-.019 21.714 0 18.83"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        fillOpacity: 0.5,
        d: "m5.677 23.617.08-12c.013-2.17 1.533-4.031 3.63-4.447l11.587-2.296c2.784-.552 5.368 1.626 5.349 4.51l-.08 12c-.014 2.171-1.533 4.032-3.63 4.448l-11.587 2.297c-2.784.551-5.368-1.627-5.349-4.51z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        fillOpacity: 0.8,
        d: "m11.354 28.404.08-12c.014-2.172 1.533-4.032 3.63-4.448l11.587-2.297c2.784-.552 5.368 1.627 5.349 4.51l-.08 12c-.014 2.172-1.533 4.033-3.63 4.448l-11.587 2.297c-2.784.552-5.368-1.627-5.35-4.51z"
    }));

const LayersLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 33",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#111827",
        fillOpacity: 0.2,
        d: "M0 18.83.08 6.832C.094 4.66 1.613 2.798 3.71 2.383L15.297.086c2.784-.552 5.368 1.627 5.35 4.51l-.08 12c-.015 2.171-1.534 4.032-3.631 4.448L5.349 23.341C2.565 23.893-.019 21.714 0 18.83"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#111827",
        fillOpacity: 0.5,
        d: "m5.677 23.617.08-12c.013-2.17 1.533-4.031 3.63-4.447l11.587-2.296c2.784-.552 5.368 1.626 5.349 4.51l-.08 12c-.014 2.171-1.533 4.032-3.63 4.448l-11.587 2.297c-2.784.551-5.368-1.627-5.349-4.51z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#111827",
        fillOpacity: 0.8,
        d: "m11.354 28.404.08-12c.014-2.172 1.533-4.032 3.63-4.448l11.587-2.297c2.784-.552 5.368 1.627 5.349 4.51l-.08 12c-.014 2.172-1.533 4.033-3.63 4.448l-11.587 2.297c-2.784.552-5.368-1.627-5.35-4.51z"
    }));

const LeapWallet = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 166 166",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#24A95A",
        d: "M138.614 100.445c0 19.772-24.131 27.807-54.092 27.807-29.962 0-54.444-8.035-54.444-27.807s24.307-35.772 54.268-35.772 54.268 16.034 54.268 35.772"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#32DA6D",
        d: "M133.103 57.347c0-10.41-8.5-18.864-18.967-18.864a18.98 18.98 0 0 0-13.806 5.934c-.536.565-1.318.84-2.081.686a70 70 0 0 0-13.793-1.38c-4.78 0-9.413.467-13.793 1.372-.763.158-1.55-.112-2.088-.676-3.485-3.646-8.388-5.936-13.8-5.936-10.467 0-18.967 8.454-18.967 18.864 0 3.037.718 5.88 1.983 8.41.303.606.334 1.315.072 1.94-1.228 2.924-1.88 6.012-1.88 9.213 0 18.34 21.708 33.187 48.473 33.187s48.472-14.847 48.472-33.187c0-3.2-.652-6.289-1.88-9.213a2.33 2.33 0 0 1 .072-1.94 18.7 18.7 0 0 0 1.983-8.41"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M53.227 67.812c6.402 0 11.591-5.161 11.591-11.528s-5.19-11.528-11.59-11.528c-6.403 0-11.592 5.161-11.592 11.528s5.19 11.528 11.591 11.528M115.065 67.812c6.401 0 11.591-5.161 11.591-11.528s-5.19-11.528-11.591-11.528c-6.402 0-11.591 5.161-11.591 11.528s5.189 11.528 11.591 11.528"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#32DA6D",
        d: "M47.076 126.829c2.494 0 4.46-2.166 4.18-4.611-1.019-8.664-5.34-27.423-24.342-38.706-20.83-12.373-10.92 20.522-6.777 32.507.837 2.424-.134 5.116-2.359 6.393l-1.366.784c-1.756 1.013-1.018 3.633.984 3.633zM122.566 126.829c-2.248 0-4.004-2.166-3.758-4.611.878-8.629 4.812-27.423 21.953-38.706 18.98-12.47 9.742 21.036 6.054 32.782-.723 2.304.167 4.813 2.207 6.105l1.258.797c1.58 1.013.913 3.633-.878 3.633z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#092511",
        d: "M53.243 63.179a6.915 6.915 0 1 0 0-13.83 6.915 6.915 0 0 0 0 13.83M115.081 63.179a6.914 6.914 0 0 0 6.914-6.915 6.914 6.914 0 1 0-13.829 0 6.915 6.915 0 0 0 6.915 6.915M99.8 83.018c1.714.147 3.01 1.668 2.578 3.334a18.571 18.571 0 0 1-36.542-4.176c-.03-1.147.988-1.995 2.131-1.897l16.434 1.414z"
    }));

const LearnThis = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 45 45",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#039ff4",
        d: "M9.4 10.8s3.7 4.8 13.8 7.7c0 0 7.5 2.1 11 6.2 0 0 3.5 2.7 4.8 12.2 0 0-2.9-5.6-11.3-7.8 0 0-8.8-2.2-11.1-3.5s-4.9-3.6-5.9-6.8-1.5-6.9-1.3-8"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#028df1",
        d: "M5.1 23s4.1 3.4 9.1 5.2c0 0 4.1 1.8 10 2.7 0 0 5.4 1.1 8.3 2.8 0 0 5 2.9 7.5 10.3 0 0-2.5-3.3-7-4.1 0 0-2.6-1-10.3-1.3 0 0-5.6.1-10.7-3.1 0 0-3.7-2.1-5.8-8.6-.3 0-1-2.1-1.1-3.9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4fbcf7",
        d: "M19.2.9s2.6 4 7.2 6.4c0 0 4.3 2.4 6.7 5 0 0 2.2 2 3.7 6.2 0 0 .9 2.3 1.2 7.3 0 0-2-3.6-3.8-4.8 0 0-2-1.6-4.5-2.9S25 15.8 23.1 14s-3.3-3.9-3.7-6.2-.4-5.3-.2-6.9"
    }));

const LemonSqueezy = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 21 28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFC233",
        fillRule: "evenodd",
        d: "m6.929 17.186 7.511 3.472a3.85 3.85 0 0 1 1.943 1.983c.898 2.099-.33 4.246-2.255 5.018-1.926.772-3.979.275-4.912-1.908l-3.27-7.664c-.253-.595.384-1.178.983-.901m.45-2.248 7.754-2.931c2.577-.975 5.392.869 5.354 3.547l-.003.105c-.055 2.608-2.792 4.36-5.312 3.438l-7.786-2.85a.694.694 0 0 1-.007-1.31m-.434-1.016 7.622-3.238C17.1 9.607 17.743 6.377 15.76 4.51l-.078-.073c-1.945-1.805-5.16-1.17-6.267 1.208l-3.42 7.347c-.274.585.343 1.189.951.93m-1.962-1.28 2.772-7.598a3.68 3.68 0 0 0-.076-2.732C6.78.214 4.344-.464 2.42.31.493 1.083-.595 2.84.34 5.023l3.29 7.656c.255.593 1.132.57 1.352-.036",
        clipRule: "evenodd"
    }));

const Lightroom = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 83 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#001E36",
        d: "M67.521 0H14.53C6.505 0 0 6.505 0 14.53v50.94C0 73.495 6.505 80 14.53 80H67.52c8.025 0 14.53-6.505 14.53-14.53V14.53C82.051 6.505 75.546 0 67.521 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#31A8FF",
        d: "M43.09 56.541H21.405q-.55 0-.55-.605V20.984a.438.438 0 0 1 .495-.496h6.715a.34.34 0 0 1 .385.386v28.732h15.798q.495 0 .385.495l-.99 5.945a.53.53 0 0 1-.221.413.7.7 0 0 1-.33.082M48.54 29.185h6a.75.75 0 0 1 .715.55c.13.242.223.502.275.771q.115.532.165 1.074.055.578.055 1.238a12.9 12.9 0 0 1 3.66-2.945 10.3 10.3 0 0 1 5.092-1.238.438.438 0 0 1 .495.495v6.66q0 .387-.55.386a13.9 13.9 0 0 0-6.468 1.156 5.8 5.8 0 0 0-1.844 1.265v17.45q0 .495-.44.495h-6.66a.486.486 0 0 1-.55-.551V37.056a125 125 0 0 0-.11-5.229 17.5 17.5 0 0 0-.22-2.257.317.317 0 0 1 .384-.385"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h82.051v80H0z"
    }))));

const Linear = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 100 100",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#5E6AD2",
        d: "M1.225 61.523c-.222-.949.908-1.546 1.597-.857l36.512 36.512c.69.69.092 1.82-.857 1.597-18.425-4.323-32.93-18.827-37.252-37.252M.002 46.889a1 1 0 0 0 .29.76L52.35 99.71c.201.2.478.307.76.29 2.37-.149 4.695-.46 6.963-.927.765-.157 1.03-1.096.478-1.648L2.576 39.448c-.552-.551-1.491-.286-1.648.479a50 50 0 0 0-.926 6.962M4.21 29.705a.99.99 0 0 0 .208 1.1l64.776 64.776a.99.99 0 0 0 1.1.208 50 50 0 0 0 5.185-2.684.98.98 0 0 0 .183-1.54L8.436 24.336a.98.98 0 0 0-1.541.183 50 50 0 0 0-2.684 5.185Zm8.448-11.631a.986.986 0 0 1-.045-1.354C21.78 6.46 35.111 0 49.952 0 77.592 0 100 22.407 100 50.048c0 14.84-6.46 28.172-16.72 37.338a.986.986 0 0 1-1.354-.045L12.659 18.074Z"
    }));

const Link = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 200 200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#375BD2",
        d: "M100 200c55.229 0 100-44.771 100-100S155.229 0 100 0 0 44.772 0 100s44.772 100 100 100"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M100 25 35.048 62.5v75L100 175l64.952-37.5v-75zm37.427 96.61L100 143.217 62.573 121.61V78.39L100 56.783l37.427 21.607z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h200v200H0z"
    }))));

const LinkedIn = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0A66C2",
        d: "M218.123 218.127h-37.931v-59.403c0-14.165-.253-32.4-19.728-32.4-19.756 0-22.779 15.434-22.779 31.369v60.43h-37.93V95.967h36.413v16.694h.51a39.91 39.91 0 0 1 35.928-19.733c38.445 0 45.533 25.288 45.533 58.186zM56.955 79.27c-12.157.002-22.014-9.852-22.016-22.009s9.851-22.014 22.008-22.016c12.157-.003 22.014 9.851 22.016 22.008A22.013 22.013 0 0 1 56.955 79.27m18.966 138.858H37.95V95.967h37.97v122.16ZM237.033.018H18.89C8.58-.098.125 8.161-.001 18.471v219.053c.122 10.315 8.576 18.582 18.89 18.474h218.144c10.336.128 18.823-8.139 18.966-18.474V18.454c-.147-10.33-8.635-18.588-18.966-18.453"
    }));

const Linux = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 295",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "48.548%",
        x2: "51.047%",
        y1: "115.276%",
        y2: "41.364%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFEED7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BDBFC2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "54.407%",
        x2: "46.175%",
        y1: "2.404%",
        y2: "90.542%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.8
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "51.86%",
        x2: "47.947%",
        y1: "88.248%",
        y2: "9.748%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFEED7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BDBFC2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: "49.925%",
        x2: "49.924%",
        y1: "85.49%",
        y2: "13.811%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFEED7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BDBFC2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "53.901%",
        x2: "45.956%",
        y1: "3.102%",
        y2: "93.895%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: "45.593%",
        x2: "54.811%",
        y1: "5.475%",
        y2: "93.524%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: "49.984%",
        x2: "49.984%",
        y1: "89.845%",
        y2: "40.632%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFEED7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BDBFC2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: "53.505%",
        x2: "42.746%",
        y1: "99.975%",
        y2: "23.545%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFEED7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BDBFC2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__j",
        x1: "49.841%",
        x2: "50.241%",
        y1: "13.229%",
        y2: "94.673%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.8
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__k",
        x1: "49.927%",
        x2: "50.727%",
        y1: "37.327%",
        y2: "92.782%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__l",
        x1: "49.876%",
        x2: "49.876%",
        y1: "2.299%",
        y2: "81.204%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__m",
        x1: "49.833%",
        x2: "49.824%",
        y1: "2.272%",
        y2: "71.799%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__n",
        x1: "53.467%",
        x2: "38.949%",
        y1: "48.921%",
        y2: "98.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA63F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__o",
        x1: "52.373%",
        x2: "47.579%",
        y1: "143.009%",
        y2: "-64.622%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFEED7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BDBFC2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__p",
        x1: "30.581%",
        x2: "65.887%",
        y1: "34.024%",
        y2: "89.175%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA63F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__q",
        x1: "59.572%",
        x2: "48.361%",
        y1: "-17.216%",
        y2: "66.118%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__r",
        x1: "47.769%",
        x2: "51.373%",
        y1: "1.565%",
        y2: "104.313%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__s",
        x1: "43.55%",
        x2: "57.114%",
        y1: "4.533%",
        y2: "92.827%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__t",
        x1: "49.733%",
        x2: "50.558%",
        y1: "17.609%",
        y2: "99.385%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA63F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__u",
        x1: "50.17%",
        x2: "49.68%",
        y1: "2.89%",
        y2: "94.17%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.65
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__a",
        width: "200%",
        height: "200%",
        x: "-50%",
        y: "-50%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 6.5
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillOpacity: 0.2,
        d: "M235.125 249.359c0 17.355-52.617 31.497-117.54 31.497S.044 266.806.044 249.359c0-17.356 52.618-31.498 117.54-31.498 64.924 0 117.45 14.142 117.541 31.498",
        filter: "url(#prefix__a)",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M63.213 215.474c-11.387-16.346-13.591-69.606 12.947-102.39C89.292 97.383 92.69 86.455 93.7 71.67c.734-16.805-11.846-66.851 35.537-70.616 48.027-3.857 45.364 43.526 45.088 68.596-.183 21.12 15.52 33.15 26.355 49.68 19.927 30.303 18.274 82.461-3.765 110.745-27.916 35.354-51.791 20.018-67.678 21.304-29.752 1.745-30.762 17.54-66.024-35.905"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M169.1 122.451c8.265 7.622 29.661 41.69-4.224 62.995-11.937 7.438 10.653 35.721 21.488 22.039 19.193-24.61 6.98-63.913-4.591-77.963-7.714-9.917-19.651-13.774-12.672-7.07",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        stroke: "#000",
        strokeWidth: 0.977,
        d: "M176.805 117.86c13.59 11.02 38.292 49.587 2.204 74.748-11.846 7.806 10.468 32.508 23.049 19.927 43.618-43.894-1.102-94.308-16.53-111.664-13.774-15.151-25.987 3.49-8.723 16.989z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M147.245 25.02c-.459 12.581-14.325 23.51-30.946 24.52S86.639 41 87.097 28.419c.46-12.581 14.326-23.509 30.947-24.519 16.62-.918 29.66 8.54 29.201 21.12",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M107.483 54.957c.46 8.173-3.397 15.06-8.723 15.335s-10.01-6.06-10.469-14.233 3.398-15.06 8.724-15.335 10.01 6.06 10.468 14.233",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M117.125 55.6c.184 9.458 6.337 16.988 13.683 16.805 7.346-.184 13.131-7.99 12.948-17.54-.184-9.458-6.336-16.988-13.683-16.804-7.346.183-13.223 8.08-12.948 17.539",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M133.186 57.712c-.092 5.234 2.48 9.458 5.877 9.458 3.306 0 6.153-4.224 6.245-9.366.091-5.234-2.48-9.459-5.878-9.459-3.397 0-6.152 4.225-6.244 9.367m-21.212.092c.459 4.316-1.194 7.989-3.582 8.356-2.387.276-4.683-2.938-5.142-7.254s1.194-7.99 3.581-8.357c2.388-.275 4.684 2.939 5.143 7.255"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M124.564 54.773c-.276 2.939 1.102 5.326 3.03 5.51s3.765-2.112 4.04-4.959c.276-2.938-1.102-5.326-3.03-5.51-1.928-.183-3.765 2.113-4.04 4.96",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M99.953 55.508c.276 2.388-.734 4.5-2.203 4.683-1.47.184-2.847-1.653-3.123-4.132-.275-2.388.735-4.5 2.204-4.683 1.47-.184 2.847 1.744 3.122 4.132",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M71.027 145.684c6.52-14.785 20.386-40.772 20.662-60.883 0-15.978 47.843-19.835 51.7-3.856 3.856 15.978 13.59 39.853 19.834 51.424 6.245 11.478 24.335 48.118 5.051 80.074-17.356 28.284-69.973 50.69-98.073-3.856-9.55-18.917-7.806-42.333.826-62.903",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M65.15 134.664c-5.601 10.56-17.172 38.293 11.112 53.445 30.395 16.162 30.303 49.312-6.245 33.517-33.425-14.233-18.641-71.902-9.274-85.676 6.06-9.642 15.243-21.488 4.407-1.286",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        stroke: "#000",
        strokeWidth: 1.25,
        d: "M79.925 122.727c-8.907 14.509-30.211 48.669-1.652 66.484 38.384 23.6 27.548 47.108-7.53 25.895-49.404-29.568-5.97-89.257 13.774-112.03 22.59-25.529 4.316 4.683-4.592 19.65z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__j)",
        d: "M156.428 151.285c0 16.162-15.519 37.1-42.15 36.916-27.456.183-39.118-20.754-39.118-36.916s18.182-29.293 40.588-29.293c22.498.092 40.68 13.132 40.68 29.293",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__k)",
        d: "M141.92 100.504c-.276 16.713-11.204 20.662-24.978 20.662s-23.784-2.48-24.978-20.662c0-11.387 11.203-17.998 24.978-17.998 13.774-.092 24.977 6.52 24.977 17.998",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M58.63 126.216c9-13.682 28.008-34.711 3.582 2.939-19.835 31.038-7.346 50.965-.918 56.474 18.549 16.53 17.814 27.64 3.214 18.917-31.314-18.641-24.794-50.047-5.878-78.33",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__m)",
        d: "M188.936 131.818c-7.806-16.07-32.6-56.842 1.193-9.459 30.763 42.884 9.183 72.729 5.326 75.667-3.856 2.939-16.804 8.908-13.04-1.469 3.858-10.377 22.958-30.028 6.52-64.74",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__n)",
        stroke: "#E68C3F",
        strokeWidth: 6.25,
        d: "M51.835 258.542c-20.57-10.928-50.414 2.112-39.578-27.457 2.204-6.704-3.214-16.805.275-23.325 4.133-7.989 13.04-6.244 18.366-11.57 5.234-5.51 8.54-15.06 18.366-13.59 9.734 1.468 16.254 13.406 23.049 28.099 5.05 10.468 22.865 25.253 21.672 37.007-1.47 17.998-21.948 21.396-42.15 10.836z",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__o)",
        d: "M201.608 189.119c-3.122 5.877-16.162 15.335-24.886 12.856-8.815-2.388-12.856-15.795-11.111-25.988 1.653-11.386 11.111-12.03 23.05-6.336 12.855 6.336 16.712 11.662 12.947 19.468",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__p)",
        stroke: "#E68C3F",
        strokeWidth: 6.251,
        d: "M194.445 253.49c15.06-18.273 48.578-14.508 25.988-39.577-4.775-5.418-3.306-16.989-9.183-21.947-6.887-6.061-14.509-1.102-21.488-4.224-6.979-3.398-14.325-9.918-22.865-5.327-8.54 4.684-9.459 16.805-10.285 32.783-.735 11.479-11.203 30.671-5.602 41.231 8.081 16.346 29.11 14.142 43.435-2.938z",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__q)",
        d: "M187.925 229.064c23.325-34.435 5.97-34.16.092-36.823-5.877-2.755-12.03-8.173-18.916-4.408-6.888 3.857-7.255 13.775-7.439 26.814-.275 9.367-8.08 25.07-3.397 33.793 5.693 10.193 19.467-4.591 29.66-19.376",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__r)",
        d: "M47.06 234.023c-34.895-22.59-18.55-30.303-13.315-33.885 6.336-4.591 6.428-13.407 14.233-12.58 7.806.826 12.397 10.468 17.631 22.406 3.857 8.54 17.264 19.927 16.254 29.753-1.285 11.57-19.743 3.948-34.803-5.694",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M209.588 188.843c-2.755 4.776-13.958 12.306-21.396 10.285-7.622-1.928-11.112-12.672-9.55-20.753 1.377-9.183 9.55-9.642 19.834-5.05 10.928 4.958 14.326 9.182 11.112 15.518"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__s)",
        d: "M192.058 186.18c-1.745 3.306-9.091 8.54-14.234 7.163-5.142-1.377-7.713-8.815-6.887-14.417.735-6.336 6.244-6.704 13.223-3.581 7.53 3.49 9.918 6.428 7.898 10.835",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__t)",
        stroke: "#E68C3F",
        strokeWidth: 3.75,
        d: "M97.107 66.344c3.673-3.398 12.58-13.774 29.477-2.939 3.122 2.02 5.693 2.204 11.662 4.775 12.03 4.96 6.336 16.897-6.52 20.937-5.51 1.745-10.468 8.449-20.386 7.806-8.54-.46-10.744-6.06-15.978-9.091-9.275-5.234-10.652-12.305-5.602-16.07 5.051-3.765 6.98-5.143 7.347-5.418z",
        transform: "translate(10)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#E68C3F",
        strokeWidth: 2.5,
        d: "M148.43 75.986c-5.05.275-15.979 11.203-27.457 11.203s-18.366-10.652-20.11-10.652"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__u)",
        d: "M102.8 65.426c1.837-1.653 7.622-6.153 15.244-1.562 1.653.919 3.306 1.929 5.693 3.306 4.867 2.847 2.48 6.98-3.398 9.55-2.663 1.102-7.07 3.49-10.376 3.306-3.673-.367-6.153-2.755-8.54-4.316-4.5-2.938-4.224-5.418-2.112-7.346 1.56-1.47 3.305-2.847 3.49-2.938",
        transform: "translate(10)"
    })));

const Lit = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 320",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00E8FF",
        d: "m64 192 25.926-44.727 38.233-19.114 63.974 63.974 10.833 61.754L192 320l-64-64-38.074-25.615z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#283198",
        d: "M128 256V128l64-64v128zM0 256l64 64 9.202-60.602L64 192l-37.542 23.71z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#324FFF",
        d: "M64 192V64l64-64v128zm128 128V192l64-64v128zM0 256V128l64 64z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0FF",
        d: "M64 320V192l64 64z"
    }));

const Litecoin = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 1",
        viewBox: "0 0 82.6 82.6",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 41.3,
        cy: 41.3,
        r: 36.83,
        style: {
            fill: "#fff"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M41.3 0a41.3 41.3 0 1 0 41.3 41.3A41.18 41.18 0 0 0 41.54 0Zm.7 42.7-4.3 14.5h23a1.16 1.16 0 0 1 1.2 1.12v.38l-2 6.9a1.49 1.49 0 0 1-1.5 1.1H23.2l5.9-20.1-6.6 2L24 44l6.6-2 8.3-28.2a1.51 1.51 0 0 1 1.5-1.1h8.9a1.16 1.16 0 0 1 1.2 1.12v.38l-7 23.8 6.6-2-1.4 4.8Z",
        style: {
            fill: "#345d9d"
        }
    }), /*#__PURE__*/ React.createElement("script", null));

const Locofy = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48.3 48.3",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd",
        clipRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 24.1,
        cy: 24.1,
        r: 23.5,
        fill: "#457eff"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M18.2 10.8c-.4 1.9-2.4 12.5-2.8 14.7s1.4 4.1 3.1 4.1h2.7c.7 0 1.8.5 1.4 2.4-.4 1.8-.8 3.7-1.2 5.5s1.7 2.5 2.6 1.1 7.6-12.1 8.3-13.5-.5-3.6-2.4-3.6h-3.7c-1 0-1.1-.7-.8-2.2.4-1.5.8-3.4 1.5-6.2s-2-4.3-3.4-4.3h-3.4c-.4 0-1.5.1-1.9 2"
    })));

const Loom = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#625DF5",
        d: "M256 113.765h-74.858l64.83-37.43-14.237-24.667-64.83 37.43 37.421-64.825-24.667-14.246-37.421 64.826V0h-28.476v74.86L76.326 10.027 51.667 24.266 89.096 89.09 24.265 51.668l-14.238 24.66 64.83 37.43H0v28.477h74.85l-64.823 37.43 14.238 24.667 64.824-37.423-37.43 64.825 24.667 14.239 37.429-64.832V256h28.476v-74.853l37.422 64.826 24.665-14.239-37.428-64.832 64.83 37.43 14.24-24.667-64.825-37.423h74.85v-28.477zM128 166.73c-21.472 0-38.876-17.403-38.876-38.876S106.528 88.978 128 88.978s38.875 17.404 38.875 38.876c0 21.473-17.403 38.876-38.875 38.876"
    }));

const Lottielab = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 276 276",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 274,
        height: 274,
        x: 1,
        y: 1,
        fill: "url(#prefix__a)",
        rx: 81
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__b)",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 20,
        d: "M142.892 59.721c-30.057-5.67-40.834 99.13-23.051 131.821"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D7D5FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 20,
        d: "M119.577 191.219c17.747 32.552 50.284 32.552 65.206-4.71"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F4F3FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 20,
        d: "M142.892 59.729c30.057 5.656-2.582 97.684-50.401 145.51"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 274,
        height: 274,
        x: 1,
        y: 1,
        stroke: "url(#prefix__c)",
        strokeWidth: 2,
        rx: 81
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 2,
        x2: 274,
        y1: 2,
        y2: 274,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9688FD"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#607EF4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 132.555,
        x2: 94.765,
        y1: 62.627,
        y2: 82.582,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F4F3FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D7D5FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 2,
        x2: 274,
        y1: 2,
        y2: 274,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9688FD"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#607EF4"
    }))));

const Lovable = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        width: 121,
        height: 122,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        fillRule: "evenodd",
        d: "M36.069 0c19.92 0 36.068 16.155 36.068 36.084v13.713h12.004c19.92 0 36.069 16.156 36.069 36.084s-16.149 36.083-36.069 36.083H0v-85.88C0 16.155 16.148 0 36.069 0",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__c)"
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: 52.738,
        cy: 65.101,
        fill: "#4B73FF",
        rx: 81.373,
        ry: 81.192
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__d)"
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: 61.673,
        cy: 20.547,
        fill: "#FF66F4",
        rx: 104.216,
        ry: 81.192
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__e)"
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: 78.666,
        cy: 5.268,
        fill: "#FF0105",
        rx: 81.373,
        ry: 71.304
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__f)"
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: 63.121,
        cy: 20.527,
        fill: "#FE7B02",
        rx: 48.937,
        ry: 48.829
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__c",
        width: 235.52,
        height: 235.159,
        x: -65.022,
        y: -52.478,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_572_319",
        stdDeviation: 18.194
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__d",
        width: 281.208,
        height: 235.159,
        x: -78.93,
        y: -97.032,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_572_319",
        stdDeviation: 18.194
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__e",
        width: 235.52,
        height: 215.383,
        x: -39.094,
        y: -102.423,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_572_319",
        stdDeviation: 18.194
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__f",
        width: 170.649,
        height: 170.432,
        x: -22.204,
        y: -64.688,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_572_319",
        stdDeviation: 18.194
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 40.453,
        x2: 76.933,
        y1: 21.433,
        y2: 121.971,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.025,
        stopColor: "#FF8E63"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.56,
        stopColor: "#FF7EB0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.95,
        stopColor: "#4B73FF"
    }))));

const Lua = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 947 947",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "navy",
        d: "M835.5 473.6c0-199.8-162.2-362-362-362s-362 162.2-362 362 162.2 362 362 362 362-162.2 362-362"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M729.5 323.6c0-58.5-47.5-106-106-106s-106 47.5-106 106 47.5 106 106 106 106-47.5 106-106"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "navy",
        d: "M941.5 111.5c0-58.5-47.5-106-106-106s-106 47.5-106 106 47.5 106 106 106 106-47.4 106-106"
    }), /*#__PURE__*/ React.createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M258.1 627.8h117.3v26.7H227.8V417h30.3zM515.5 654.5v-23.8c-16 22.5-31.9 31.3-57 31.3-33.2 0-54.4-18.2-54.4-46.6V483.8h27v120.9c0 20.5 13.7 33.6 35.2 33.6 28.3 0 46.6-22.8 46.6-57.7v-96.8h27v170.7zM738.4 659.1c-8.8 2.3-13 2.9-18.6 2.9-17.6 0-26.1-7.8-28-25.1-19.2 17.6-36.5 25.1-58 25.1-34.5 0-56-19.5-56-50.5 0-22.2 10.1-37.5 30-45.6 10.4-4.2 16.3-5.5 54.7-10.4 21.5-2.6 28.3-7.5 28.3-18.9v-7.2c0-16.3-13.7-25.4-38.1-25.4-25.4 0-37.8 9.4-40.1 30.3h-27.4c.7-16.9 3.9-26.7 11.7-35.5 11.4-12.7 31.9-19.9 56.7-19.9 42 0 64.2 16.3 64.2 46.6v100.4c0 8.5 5.2 13.4 14.7 13.4 1.6 0 2.9 0 5.9-.7zm-47.6-89c-9.1 4.2-15 5.5-43.7 9.4-29 4.2-41.1 13.4-41.1 31.3 0 17.3 12.4 27.4 33.6 27.4 16 0 29.3-5.2 40.4-15.3 8.1-7.5 10.8-13 10.8-22.2z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "gray",
        strokeDasharray: 40.847,
        strokeMiterlimit: 10,
        strokeWidth: 10.861,
        d: "M890.6 261c33.5 65.8 51 138.6 51 212.5 0 258.4-209.7 468.1-468.1 468.1S5.4 731.9 5.4 473.5 215.1 5.4 473.5 5.4c83.1 0 164.6 22.1 236.2 63.9"
    }));

const MagicUI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        className: "prefix__size-6",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 256,
        height: 256,
        fill: "url(#prefix__a)",
        rx: 128
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 256,
        height: 256,
        fill: "url(#prefix__b)",
        rx: 128
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M124.157 193.675a1.46 1.46 0 0 1-.652.162H122.2q-2.283 0-5.382-.812a40.5 40.5 0 0 1-5.87-1.789q-2.773-.975-4.893-2.275-1.957-1.3-2.446-2.276a66 66 0 0 1-.163-4.715v-4.714q0-18.207 2.609-38.039 2.773-19.832 8.97-42.917.651-2.275 1.304-5.69a299 299 0 0 0 1.631-7.64q-3.914 3.09-9.295 9.917-5.382 6.664-11.416 15.931-5.871 9.104-11.904 20.157a280 280 0 0 0-10.763 22.271q-4.893 11.217-8.48 22.271-3.426 11.055-4.24 20.483-7.828-2.275-10.927-4.552Q48 187.173 48 183.921q0-2.926 1.794-8.29 1.793-5.365 5.055-12.68 3.262-7.316 7.991-16.256a981 981 0 0 1 10.437-19.508 743 743 0 0 1 12.72-22.271q6.36-10.404 12.394-18.857t11.741-14.63q5.871-6.178 11.579-9.429 2.283 0 6.034 1.138a56 56 0 0 1 7.501 2.764q3.751 1.625 6.523 3.413 2.935 1.626 3.262 2.764-2.283 4.551-5.382 13.655-3.097 9.103-6.36 20.645-3.098 11.542-6.034 24.547-2.772 12.843-4.403 24.709 3.751-8.94 8.643-18.532a412 412 0 0 1 10.6-19.182 494 494 0 0 1 11.253-18.532q5.871-8.941 11.415-16.256 5.544-7.478 10.274-13.005 4.891-5.527 8.643-8.128 2.283 0 6.034 1.138a56 56 0 0 1 7.501 2.764q3.751 1.625 6.523 3.413 2.936 1.626 3.262 2.764-5.219 9.266-9.132 22.596-3.915 13.33-6.686 27.96a389 389 0 0 0-4.077 29.099q-1.305 14.306-1.305 25.685v7.803q0 4.064.326 8.453-2.283 0-5.544-.65a43 43 0 0 1-6.197-1.463q-2.935-.976-5.382-2.276-2.446-1.138-3.425-2.601a66 66 0 0 1-.163-4.715v-4.714q0-18.207 2.61-38.039 2.772-19.832 8.969-42.917.652-2.275 1.468-6.177a537 537 0 0 0 1.63-8.128q-4.566 2.276-10.437 8.778-5.708 6.34-11.741 15.606-5.871 9.104-11.742 20.321a290 290 0 0 0-10.437 22.921 241 241 0 0 0-7.827 23.083q-3.099 11.38-3.751 20.971"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 128,
        x2: 128,
        y1: 0,
        y2: 256,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#EF786F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#D8595E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 78,
        x2: 236,
        y1: 0,
        y2: 256,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9E7AFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#FE8BBB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.667,
        stopColor: "#FFBD7A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#F8EAC3"
    }))));

const ManzDev = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 135 135",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m23.169 104.958 8.18-.896-.841-7.684-8.18.896-6.87-62.726 7.937-.87-.87-7.936 8.18-.896-.923-8.434L92.255 9.57l1.006 9.183 15.124-1.656 3.448 31.485-7.684.842 10.345 94.454-86.274 9.449Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m35.24 143.418-3.436-31.38 7.98-.874-.846-7.73 7.73-.846-.82-7.479-7.71.844-.874-7.98-7.73.847-5.106-46.627 7.98-.874-.844-7.71 7.71-.845-.876-7.999 46.646-5.108.874 7.98 15.189-1.664 1.693 15.459-7.73.846 10.639 93.578Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#cc984f",
        d: "m95.31 42.506-15.67 1.716-.875-7.98-30.898 3.384 1.693 15.459-8 .876 3.387 30.917 7.729-.846.844 7.71 15.71-1.72.903 8.25 15.209-1.666-.845-7.71-7.73.846-.903-8.25 15.71-1.72 1.747 15.96 7.98-.874z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ffcc80",
        d: "m79.361 43.999-30.648 3.356.82 7.48-8 .875L44.1 79.15l7.73-.846.873 7.98 38.937-4.265.844 7.71 7.941-.87-5.123-46.605z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m57.02 54.268 8.25-.904 1.75 15.98-8.25.903zm23.457-2.57 8.25-.903 1.75 15.98-8.25.903z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ebb267",
        d: "m67.12 69.196 23.439-2.567.819 7.479-23.439 2.567zM79.612 43.971l15.478-1.695.844 7.71-15.478 1.696z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#cc984f",
        d: "m34.399 135.727 15.458-1.693.82 7.479-15.46 1.693z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0d2061",
        d: "m66.561 139.968-1.676-15.304 24.193-2.63 1.682 15.362z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#17ffff",
        d: "m71.914 115.643 8.019-.879.897 8.192-8.019.879zM81.916 130.738l8.019-.879.82 7.498-8.018.879z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#e65100",
        d: "m73.782 131.628 8.115-.888.821 7.498-8.115.888z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#cc2554",
        d: "m64.868 124.685 8.018-.878.866 7.903-8.019.878z"
    }));

const MariaDB = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 170",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#002B64",
        d: "M250.4 0c-4 .1-2.7 1.3-11.3 3.4S220 4.8 210.7 8.7c-27.8 11.7-33.4 51.5-58.6 65.7-18.9 10.7-37.9 11.5-55 16.9a100.6 100.6 0 0 0-33.7 19.5c-8 6.8-8.1 12.8-16.4 21.4-8.8 9.1-35 .1-47 14.1 3.8 3.9 5.5 5 13 4-1.5 3-10.7 5.4-9 9.8 2 4.6 24.3 7.7 44.6-4.5 9.4-5.7 17-14 31.7-16 19-2.5 41 1.7 63 4.9-3.3 9.7-9.9 16.2-15.1 24-1.7 1.7 3.2 2 8.8.9 10-2.5 17.3-4.5 24.9-9 9.3-5.4 10.7-19.3 22.1-22.3 6.4 9.8 23.7 12.1 34.5 4.3-9.4-2.7-12-22.8-8.9-31.6 3-8.4 6-21.8 9-32.8 3.3-12 4.5-26.9 8.5-33 6-9 12.5-12.2 18.2-17.3 5.7-5.2 10.9-10.2 10.7-22 0-3.7-2-5.8-5.6-5.7"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C49A6C",
        d: "M242 7c.9 3.2 2.3 4.7 8.8 5.3-1 8.1-6.4 12.6-12.5 16.8-5.3 3.8-11.2 7.4-15 13.3-3.8 6-6.3 26.5-12.3 46.8-5.1 17.5-13 34.9-26.6 42.5-1.4-3.6.2-10.2-2.6-12.4-1.9 5.2-4 10.2-6.4 14.9a53.2 53.2 0 0 1-39.6 30.2c9.4-12.7 18.3-25.8 18.5-47.7-6.6 1.4-6.4 17-13.2 21.2-4.4.5-8.8.5-13.2.2-18.3-1.1-37-6.6-54-1.1-11.7 3.7-21.2 12.5-31 16.8-11.6 5-20.3 7-34.7 5-1.9-2.5 10.5-5.6 9.8-11-5.7-.6-9 .7-13.8-1.5.5-1 1.3-1.8 2.3-2.5 9-6.2 34.5-1.5 41.3-8.2 4.2-4.1 7-8.4 9.8-12.6A51.2 51.2 0 0 1 73 107.4c7.4-5 16.6-9.7 25.7-12.9 12.4-4.3 24.9-4.7 38-9.7 8.2-3.1 17-7 24.2-12.3 1.7-1.3 3.4-2.7 4.9-4.1 20.6-20 24.6-55.5 56.7-58.8 4-.4 7.1-.2 10-.3 3.3-.1 6.3-.5 9.5-2.3m-39.2 113.3c.3 6.1 3.9 18.3 7 21.2-6.1 1.5-16.7-1-19.4-5.3 1.4-6.3 8.6-12 12.4-16Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#002B64",
        d: "M244.2 13.8c-1.2 2.6-3.6 6-3.6 12.6 0 1.1-.9 1.9-.9.2.1-6.5 1.8-9.3 3.6-13 .9-1.5 1.4-.9 1 .2Zm-1.2-1c-1.5 2.5-5 7-5.6 13.6 0 1.2-1 1.9-.9.1.7-6.4 3.5-10.4 5.6-14 1-1.3 1.4-.7.9.4Zm-1.2-1.2c-1.6 2.3-7 7.7-8.2 14.2-.2 1.2-1.1 1.8-.9 0 1.2-6.3 5.9-11.3 8.3-14.6 1-1.3 1.5-.6.8.4m-1-1.5-.5.6c-2.4 2.6-8 9-10 14.7-.3 1-1.4 1.6-.8-.1 2-6.1 7.7-12.7 10.5-15.7 1.3-1.1 1.6-.4.8.5m-29 13.1q1.8-8.1 12.6-7.2c1.8 8-8 11.3-12.6 7.2"
    }));

const MarkdownDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 208 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#FFF",
        strokeWidth: 10,
        d: "M15 5h178a10 10 0 0 1 10 10v98a10 10 0 0 1-10 10H15a10 10 0 0 1-10-10V15A10 10 0 0 1 15 5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M30 98V30h20l20 25 20-25h20v68H90V59L70 84 50 59v39zm125 0-30-33h20V30h20v35h20z"
    }));

const MarkdownLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 208 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#000"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M15 10a5 5 0 0 0-5 5v98a5 5 0 0 0 5 5h178a5 5 0 0 0 5-5V15a5 5 0 0 0-5-5zM0 15A15 15 0 0 1 15 0h178a15 15 0 0 1 15 15v98a15 15 0 0 1-15 15H15a15 15 0 0 1-15-15z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M30 98V30h20l20 25 20-25h20v68H90V59L70 84 50 59v39zm125 0-30-33h20V30h20v35h20z"
    })));

const Mastodon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 61 65",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M60.754 14.39C59.814 7.406 53.727 1.903 46.512.836 45.294.656 40.682 0 29.997 0h-.08C19.23 0 16.938.656 15.72.836 8.705 1.873 2.299 6.82.745 13.886c-.748 3.48-.828 7.338-.689 10.877.198 5.075.237 10.142.697 15.197a71.5 71.5 0 0 0 1.664 9.968c1.477 6.056 7.458 11.096 13.317 13.152a35.7 35.7 0 0 0 19.484 1.028 28 28 0 0 0 2.107-.576c1.572-.5 3.413-1.057 4.766-2.038a.15.15 0 0 0 .062-.118v-4.899a.15.15 0 0 0-.055-.111.14.14 0 0 0-.122-.028 54 54 0 0 1-12.644 1.478c-7.328 0-9.298-3.478-9.863-4.925a15.3 15.3 0 0 1-.857-3.882.142.142 0 0 1 .178-.145 53 53 0 0 0 12.437 1.477c1.007 0 2.012 0 3.02-.026 4.213-.119 8.654-.334 12.8-1.144.103-.02.206-.038.295-.065 6.539-1.255 12.762-5.196 13.394-15.176.024-.393.083-4.115.083-4.523.003-1.386.446-9.829-.065-15.017"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M50.394 22.237v17.35H43.52V22.749c0-3.545-1.478-5.353-4.483-5.353-3.303 0-4.958 2.139-4.958 6.364v9.217h-6.835V23.76c0-4.225-1.657-6.364-4.96-6.364-2.988 0-4.48 1.808-4.48 5.353v16.84H10.93V22.237q0-5.318 2.715-8.45c1.868-2.082 4.317-3.152 7.358-3.152 3.519 0 6.178 1.354 7.951 4.057l1.711 2.871 1.714-2.871c1.773-2.704 4.432-4.056 7.945-4.056 3.038 0 5.487 1.069 7.36 3.152q2.714 3.128 2.71 8.449"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 30.5,
        x2: 30.5,
        y1: 0,
        y2: 65,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#6364FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#563ACC"
    }))));

const MaterialUI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 222",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#007FFF",
        d: "M215.8 151.1a7.1 7.1 0 0 0 3.5-6.1l.2-41.2c0-2.5 1.3-4.9 3.5-6.1l22.3-12.8A7.1 7.1 0 0 1 256 91v74.8c0 2.6-1.4 5-3.6 6.2l-84.2 48.4a7.1 7.1 0 0 1-7 0L95 182.6a7.1 7.1 0 0 1-3.6-6.2v-37.7h.1v-.1l.1-.1 54.5-31.3v-.1h-.1V70a7.1 7.1 0 0 0-10.6-6.2L95.1 87.2a7.1 7.1 0 0 1-7.1 0L47.4 63.8A7.1 7.1 0 0 0 36.7 70v66.8a7.1 7.1 0 0 1-10.6 6.2L3.6 130a7.1 7.1 0 0 1-3.6-6L.2 7.1A7.1 7.1 0 0 1 10.9.9l77 44.3a7.1 7.1 0 0 0 7.2 0L172 1a7.1 7.1 0 0 1 10.7 6.2V124c0 2.5-1.3 4.9-3.6 6.1L139 153.4a7.1 7.1 0 0 0 0 12.3l22.3 12.7a7.1 7.1 0 0 0 7 0l47.6-27.3Zm4.6-104.8a7.1 7.1 0 0 0 10.8 6l21.3-12.7a7.1 7.1 0 0 0 3.5-6.1V7.4a7.1 7.1 0 0 0-10.8-6.1L224 14.1a7.1 7.1 0 0 0-3.5 6v26.2Z"
    }));

const Matlab = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 22.645,
        x2: 26.757,
        y1: 10.881,
        y2: 23.854,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#4adddf"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.699,
        stopColor: "#3f5352"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.863,
        stopColor: "#442729"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m21 27-7-6s1-1.5 2.5-3 2.736-1.852 4.5-3c3.511-2.284 6.5-12 11-12z"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 1,
        x2: 37.775,
        y1: 27.033,
        y2: 27.033,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#4adddf"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.792,
        stopColor: "#3f5352"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#442729"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M11 33.066 1 26l13-5 7.277 5.465L14 32.066z"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 11,
        x2: 47,
        y1: 24,
        y2: 24,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.206,
        stopColor: "#53140f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#84360f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.413,
        stopColor: "#b85b10"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.511,
        stopColor: "#df7610"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.59,
        stopColor: "#f68710"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.639,
        stopColor: "#ff8d10"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.729,
        stopColor: "#fd8a10"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#f58010"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.865,
        stopColor: "#e86f10"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.925,
        stopColor: "#d65811"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.982,
        stopColor: "#c03a11"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#b72f11"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M32 3c5 0 13 27 15 34 0 0-7.017-6.63-11-6s-5.47 6.548-9.725 10.756C23.5 44.5 21 45 21 45s-.206-8.124-5-11c-2.5-1.5-5-1-5-1s6.049-2.901 9.474-8.174S28.5 3 32 3"
    }));

const MatrixDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#FFF",
        viewBox: "0 0 50 50",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M5 5a1 1 0 0 0-1 1v38a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2H6V7h2a1 1 0 1 0 0-2zm37 0a1 1 0 1 0 0 2h2v36h-2a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM31.074 17.51c-1.098-.022-2.206.25-3.095.863-.571.394-1.063.9-1.63 1.385-.86-1.718-2.42-2.177-4.197-2.207-1.8-.031-3.231.79-4.482 2.29V18H14v14h3.664s-.006-5.234.004-7.834c.002-.462.021-.934.115-1.385.29-1.389 1.755-2.247 3.174-2.133 1.352.11 2.143.848 2.209 2.45.011.279 0 8.902 0 8.902h3.666v-7.771c.006-.6.07-1.212.215-1.791.326-1.3 1.544-1.94 2.973-1.782 1.26.14 2.219.819 2.312 2.194V32H36V22c0-1-.254-1.51-.557-2.12-.732-1.475-2.538-2.333-4.369-2.37"
    }));

const MatrixLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 520 520",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.7 11.9v496.2h35.7V520H0V0h49.4v11.9zm152.6 157.3v25.1h.7c6.7-9.6 14.8-17 24.2-22.2 9.4-5.3 20.3-7.9 32.5-7.9 11.7 0 22.4 2.3 32.1 6.8s17 12.6 22.1 24c5.5-8.1 13-15.3 22.4-21.5s20.6-9.3 33.5-9.3q14.7 0 27.3 3.6c8.4 2.4 15.5 6.2 21.5 11.5s10.6 12.1 14 20.6c3.3 8.5 5 18.7 5 30.7v124.1h-50.9V249.6c0-6.2-.2-12.1-.7-17.6s-1.8-10.3-3.9-14.3c-2.2-4.1-5.3-7.3-9.5-9.7s-9.9-3.6-17-3.6c-7.2 0-13 1.4-17.4 4.1-4.4 2.8-7.9 6.3-10.4 10.8-2.5 4.4-4.2 9.4-5 15.1-.8 5.6-1.3 11.3-1.3 17v103.3h-50.9v-104c0-5.5-.1-10.9-.4-16.3-.2-5.4-1.3-10.3-3.1-14.9-1.8-4.5-4.8-8.2-9-10.9s-10.3-4.1-18.5-4.1c-2.4 0-5.6.5-9.5 1.6s-7.8 3.1-11.5 6.1-6.9 7.3-9.5 12.9-3.9 13-3.9 22.1v107.6h-50.9V169.2zm340 338.9V11.9h-35.7V0H520v520h-49.4v-11.9z"
    }));

const MattermostDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#fff",
        viewBox: "0 0 501 501",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M236 .7C137.7 7.5 54 68.2 18.2 158.5c-32 81-19.6 172.8 33 242.5 39.8 53 97.2 87 164.3 97 16.5 2.7 48 3.2 63.5 1.2 48.7-6.3 92.2-24.6 129-54.2 13-10.5 33-31.2 42.2-43.7 26.4-35.5 42.8-75.8 49-120.3 1.6-12.3 1.6-48.7 0-61-4-28.3-12-54.8-24.2-79.5-12.8-26-26.5-45.3-46.8-65.8C417.8 64 400.2 49 398.4 49c-.6 0-.4 10.5.3 26l1.3 26 7 8.7c19 23.7 32.8 53.5 38.2 83 2.5 14 3 43 1 55.8-4.5 27.8-15.2 54-31 76.5-8.6 12.2-28 31.6-40.2 40.2-24 17-50 27.6-80 33-10 1.8-49 1.8-59 0-43-7.7-78.8-26-107.2-54.8-29.3-29.7-46.5-64-52.4-104.4-2-14-1.5-42 1-55C90 121.4 132 72 192 49.7c8-3 18.4-5.8 29.5-8.2 1.7-.4 34.4-38 35.3-40.6.3-1-10.2-1-20.8-.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M322.2 24.6c-1.3.8-8.4 9.3-16 18.7-7.4 9.5-22.4 28-33.2 41.2-51 62.2-66 81.6-70.6 91-6 12-8.4 21-9 33-1.2 19.8 5 36 19 50C222 268 230 273 243 277.2c9 3 10.4 3.2 24 3.2 13.8 0 15 0 22.6-3 23.2-9 39-28.4 45-55.7 2-8.2 2-28.7.4-79.7l-2-72c-1-36.8-1.4-41.8-3-44-2-3-4.8-3.6-7.8-1.4"
    }));

const MattermostLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 501 501",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M236 .7C137.7 7.5 54 68.2 18.2 158.5c-32 81-19.6 172.8 33 242.5 39.8 53 97.2 87 164.3 97 16.5 2.7 48 3.2 63.5 1.2 48.7-6.3 92.2-24.6 129-54.2 13-10.5 33-31.2 42.2-43.7 26.4-35.5 42.8-75.8 49-120.3 1.6-12.3 1.6-48.7 0-61-4-28.3-12-54.8-24.2-79.5-12.8-26-26.5-45.3-46.8-65.8C417.8 64 400.2 49 398.4 49c-.6 0-.4 10.5.3 26l1.3 26 7 8.7c19 23.7 32.8 53.5 38.2 83 2.5 14 3 43 1 55.8-4.5 27.8-15.2 54-31 76.5-8.6 12.2-28 31.6-40.2 40.2-24 17-50 27.6-80 33-10 1.8-49 1.8-59 0-43-7.7-78.8-26-107.2-54.8-29.3-29.7-46.5-64-52.4-104.4-2-14-1.5-42 1-55C90 121.4 132 72 192 49.7c8-3 18.4-5.8 29.5-8.2 1.7-.4 34.4-38 35.3-40.6.3-1-10.2-1-20.8-.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M322.2 24.6c-1.3.8-8.4 9.3-16 18.7-7.4 9.5-22.4 28-33.2 41.2-51 62.2-66 81.6-70.6 91-6 12-8.4 21-9 33-1.2 19.8 5 36 19 50C222 268 230 273 243 277.2c9 3 10.4 3.2 24 3.2 13.8 0 15 0 22.6-3 23.2-9 39-28.4 45-55.7 2-8.2 2-28.7.4-79.7l-2-72c-1-36.8-1.4-41.8-3-44-2-3-4.8-3.6-7.8-1.4"
    }));

const MediaWiki = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        id: "prefix__svg62",
        viewBox: "0 0 50 50",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", {
        id: "prefix__defs11"
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__gradient",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        id: "prefix__stop2",
        offset: "0%",
        stopColor: "#0a00b2"
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "prefix__stop4",
        offset: "50%",
        stopColor: "red"
    }), /*#__PURE__*/ React.createElement("stop", {
        id: "prefix__stop6",
        offset: "100%",
        stopColor: "#fffc00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient873",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient875",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient877",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient879",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient881",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient883",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient885",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient887",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient889",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient891",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient893",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient895",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient897",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient899",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient901",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient903",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient905",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient907",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient909",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient911",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient913",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient915",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient917",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient919",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__gradient",
        id: "prefix__linearGradient921",
        x1: 0,
        x2: 100,
        y1: 100,
        y2: 0,
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("style", {
        id: "style9"
    }, ".prefix__petal{opacity:.65}")), /*#__PURE__*/ React.createElement("g", {
        id: "prefix__petals",
        fill: "url(#prefix__linearGradient921)",
        transform: "matrix(.5 0 0 .5 0 .026)"
    }, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path13",
        fill: "url(#prefix__linearGradient873)",
        d: "M33.6 14.8a16.94 16.94 0 0 0 3.116 11.142 11.46 11.46 0 0 0 6.858 4.3 3.03 3.03 0 0 0 2.385-.713 11.92 11.92 0 0 0 3.634-10.837c-1.257-7.54-6.19-12.43-12.4-17A32.5 32.5 0 0 0 33.6 14.8",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path15",
        fill: "url(#prefix__linearGradient875)",
        d: "M25.117 20.232a16.94 16.94 0 0 0 5.893 9.956 11.46 11.46 0 0 0 7.738 2.381 3.03 3.03 0 0 0 2.119-1.306 11.92 11.92 0 0 0 .705-11.409C38.406 12.9 32.376 9.449 25.2 6.642a32.5 32.5 0 0 0-.083 13.59",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path17",
        fill: "url(#prefix__linearGradient877)",
        d: "M18.329 27.677a16.94 16.94 0 0 0 8.271 8.092 11.46 11.46 0 0 0 8.09.3 3.03 3.03 0 0 0 1.709-1.81 11.92 11.92 0 0 0-2.271-11.2c-4.859-5.9-11.576-7.67-19.237-8.523a32.5 32.5 0 0 0 3.438 13.141",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path19",
        fill: "url(#prefix__linearGradient879)",
        d: "M13.7 36.626A16.94 16.94 0 0 0 23.781 42.3a11.46 11.46 0 0 0 7.891-1.807 3.03 3.03 0 0 0 1.182-2.193 11.92 11.92 0 0 0-5.093-10.233c-6.221-4.443-13.167-4.412-20.787-3.254A32.5 32.5 0 0 0 13.7 36.626",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path21",
        fill: "url(#prefix__linearGradient881)",
        d: "M11.543 46.468a16.94 16.94 0 0 0 11.208 2.873 11.46 11.46 0 0 0 7.155-3.788 3.03 3.03 0 0 0 .575-2.422 11.92 11.92 0 0 0-7.568-8.566c-7.16-2.681-13.861-.854-20.923 2.235a32.5 32.5 0 0 0 9.553 9.668",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path23",
        fill: "url(#prefix__linearGradient883)",
        d: "M12.008 56.532a16.94 16.94 0 0 0 11.569-.126 11.46 11.46 0 0 0 5.931-5.51 3.03 3.03 0 0 0-.072-2.488 11.92 11.92 0 0 0-9.527-6.315C12.3 41.356 6.3 44.855.279 49.669a32.5 32.5 0 0 0 11.729 6.863",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path25",
        fill: "url(#prefix__linearGradient885)",
        d: "M15.062 66.134A16.94 16.94 0 0 0 26.2 63.018a11.46 11.46 0 0 0 4.3-6.858 3.03 3.03 0 0 0-.713-2.385 11.92 11.92 0 0 0-10.837-3.634c-7.54 1.257-12.43 6.19-17 12.4a32.5 32.5 0 0 0 13.112 3.593",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path27",
        fill: "url(#prefix__linearGradient887)",
        d: "M20.5 74.618a16.94 16.94 0 0 0 9.956-5.893 11.46 11.46 0 0 0 2.381-7.738 3.03 3.03 0 0 0-1.306-2.119 11.93 11.93 0 0 0-11.409-.705c-6.958 3.166-10.4 9.2-13.212 16.376a32.5 32.5 0 0 0 13.59.079",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path29",
        fill: "url(#prefix__linearGradient889)",
        d: "M27.943 81.406a16.94 16.94 0 0 0 8.092-8.269 11.46 11.46 0 0 0 .3-8.09 3.03 3.03 0 0 0-1.81-1.709 11.92 11.92 0 0 0-11.2 2.271c-5.9 4.859-7.67 11.576-8.523 19.237a32.5 32.5 0 0 0 13.141-3.44",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path31",
        fill: "url(#prefix__linearGradient891)",
        d: "M36.891 86.035a16.94 16.94 0 0 0 5.676-10.082 11.46 11.46 0 0 0-1.807-7.891 3.03 3.03 0 0 0-2.191-1.182 11.92 11.92 0 0 0-10.233 5.094c-4.443 6.221-4.412 13.167-3.254 20.787a32.5 32.5 0 0 0 11.809-6.726",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path33",
        fill: "url(#prefix__linearGradient893)",
        d: "M46.733 88.191a16.94 16.94 0 0 0 2.873-11.207 11.46 11.46 0 0 0-3.788-7.155 3.03 3.03 0 0 0-2.422-.575 11.92 11.92 0 0 0-8.566 7.568c-2.681 7.159-.854 13.86 2.237 20.921a32.5 32.5 0 0 0 9.666-9.552",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path35",
        fill: "url(#prefix__linearGradient895)",
        d: "M56.8 87.726a16.94 16.94 0 0 0-.125-11.569 11.46 11.46 0 0 0-5.511-5.931 3.03 3.03 0 0 0-2.488.072 11.92 11.92 0 0 0-6.315 9.528c-.737 7.609 2.762 13.609 7.576 19.629A32.5 32.5 0 0 0 56.8 87.726",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path37",
        fill: "url(#prefix__linearGradient897)",
        d: "M66.4 84.672a16.94 16.94 0 0 0-3.116-11.142 11.46 11.46 0 0 0-6.858-4.3 3.03 3.03 0 0 0-2.385.713 11.92 11.92 0 0 0-3.634 10.837c1.257 7.54 6.19 12.43 12.4 17A32.5 32.5 0 0 0 66.4 84.672",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path39",
        fill: "url(#prefix__linearGradient899)",
        d: "M74.883 79.237a16.94 16.94 0 0 0-5.893-9.956 11.46 11.46 0 0 0-7.738-2.381 3.03 3.03 0 0 0-2.119 1.306 11.92 11.92 0 0 0-.705 11.409c3.166 6.958 9.2 10.4 16.375 13.212a32.5 32.5 0 0 0 .08-13.59",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path41",
        fill: "url(#prefix__linearGradient901)",
        d: "M81.671 71.792A16.94 16.94 0 0 0 73.4 63.7a11.46 11.46 0 0 0-8.09-.3 3.03 3.03 0 0 0-1.708 1.81 11.92 11.92 0 0 0 2.271 11.2c4.859 5.9 11.576 7.67 19.237 8.523a32.5 32.5 0 0 0-3.439-13.141",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path43",
        fill: "url(#prefix__linearGradient903)",
        d: "M86.3 62.843a16.94 16.94 0 0 0-10.082-5.676 11.46 11.46 0 0 0-7.891 1.807 3.03 3.03 0 0 0-1.182 2.191A11.92 11.92 0 0 0 72.239 71.4c6.221 4.443 13.167 4.412 20.787 3.254A32.5 32.5 0 0 0 86.3 62.843",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path45",
        fill: "url(#prefix__linearGradient905)",
        d: "M88.457 53a16.94 16.94 0 0 0-11.207-2.873 11.46 11.46 0 0 0-7.155 3.788 3.03 3.03 0 0 0-.574 2.422 11.93 11.93 0 0 0 7.567 8.563c7.158 2.681 13.86.854 20.921-2.237A32.5 32.5 0 0 0 88.457 53",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path47",
        fill: "url(#prefix__linearGradient907)",
        d: "M87.992 42.936a16.94 16.94 0 0 0-11.569.126 11.46 11.46 0 0 0-5.931 5.511 3.03 3.03 0 0 0 .072 2.488 11.92 11.92 0 0 0 9.527 6.315c7.609.737 13.609-2.762 19.63-7.576a32.5 32.5 0 0 0-11.729-6.864",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path49",
        fill: "url(#prefix__linearGradient909)",
        d: "M84.938 33.335A16.94 16.94 0 0 0 73.8 36.451a11.46 11.46 0 0 0-4.3 6.858 3.03 3.03 0 0 0 .714 2.385 11.92 11.92 0 0 0 10.837 3.634c7.54-1.257 12.43-6.19 17-12.4a32.5 32.5 0 0 0-13.113-3.593",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path51",
        fill: "url(#prefix__linearGradient911)",
        d: "M79.5 24.851a16.94 16.94 0 0 0-9.956 5.893 11.46 11.46 0 0 0-2.381 7.738 3.03 3.03 0 0 0 1.309 2.118 11.92 11.92 0 0 0 11.409.705c6.958-3.166 10.4-9.2 13.212-16.375a32.5 32.5 0 0 0-13.593-.079",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path53",
        fill: "url(#prefix__linearGradient913)",
        d: "M72.057 18.063a16.94 16.94 0 0 0-8.092 8.269 11.46 11.46 0 0 0-.3 8.09 3.03 3.03 0 0 0 1.81 1.709 11.92 11.92 0 0 0 11.2-2.271c5.9-4.859 7.67-11.576 8.523-19.237a32.5 32.5 0 0 0-13.141 3.44",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path55",
        fill: "url(#prefix__linearGradient915)",
        d: "M63.109 13.434a16.94 16.94 0 0 0-5.676 10.082 11.46 11.46 0 0 0 1.807 7.891 3.03 3.03 0 0 0 2.191 1.182A11.92 11.92 0 0 0 71.664 27.5c4.443-6.221 4.412-13.167 3.254-20.787a32.5 32.5 0 0 0-11.809 6.721",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path57",
        fill: "url(#prefix__linearGradient917)",
        d: "M53.267 11.278a16.94 16.94 0 0 0-2.873 11.207 11.46 11.46 0 0 0 3.788 7.155 3.03 3.03 0 0 0 2.422.575 11.92 11.92 0 0 0 8.566-7.568c2.681-7.159.854-13.86-2.237-20.921a32.5 32.5 0 0 0-9.666 9.552",
        className: "prefix__petal",
        opacity: 0.65
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__path59",
        fill: "url(#prefix__linearGradient919)",
        d: "M43.2 11.743a16.94 16.94 0 0 0 .126 11.569 11.46 11.46 0 0 0 5.511 5.931 3.03 3.03 0 0 0 2.488-.072 11.92 11.92 0 0 0 6.315-9.528c.739-7.609-2.76-13.609-7.574-19.629A32.5 32.5 0 0 0 43.2 11.743",
        className: "prefix__petal",
        opacity: 0.65
    })));

const Medusa = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 277",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "-66.697%",
        x2: "108.63%",
        y1: "81.87%",
        y2: "34.419%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "26.563%",
        stopColor: "#592EE1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#B836D9"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M223.517 44.823 161.174 8.85a65.57 65.57 0 0 0-65.792 0l-62.63 35.973C12.642 56.623 0 78.495 0 101.806v72.235c0 23.6 12.641 45.183 32.752 56.982l62.343 36.263a65.57 65.57 0 0 0 65.791 0l62.343-36.263c20.399-11.799 32.752-33.383 32.752-56.982v-72.235c.575-23.311-12.066-45.183-32.464-56.983m-95.383 157.422c-35.337 0-64.067-28.78-64.067-64.177 0-35.399 28.73-64.178 64.067-64.178 35.338 0 64.355 28.779 64.355 64.178s-28.73 64.177-64.355 64.177"
    }));

const MercadoPago = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 150 104",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0A0080",
        d: "M150 49.027c0-26.944-33.685-48.87-75-48.87-41.501 0-75 21.926-75 48.87v2.787c0 28.616 29.404 51.843 75 51.843 45.968 0 75-23.227 75-51.843z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2ABCFF",
        d: "M147.022 49.027c0 25.457-32.196 46.083-72.022 46.083S2.978 74.484 2.978 49.027 35.174 2.944 75 2.944c39.826.186 72.022 20.626 72.022 46.083"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M50.993 34.533s-.745.743-.373 1.487c1.117 1.486 4.653 2.23 8.189 1.486 2.047-.557 4.839-2.601 7.444-4.645 2.792-2.23 5.583-4.46 8.56-5.389 2.979-.93 4.84-.558 6.142-.186 1.49.372 2.978 1.3 5.584 3.345 5.024 3.716 24.751 20.997 28.101 23.97 2.792-1.3 15.075-6.503 31.638-10.22-1.117-8.919-6.514-17.095-14.702-23.784-11.353 4.831-25.31 7.247-39.082.557 0 0-7.444-3.53-14.702-3.345-10.794.186-15.447 5.017-20.472 9.849z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M114.082 56.274c-.186-.186-23.263-20.44-28.474-24.342-2.978-2.23-4.653-2.788-6.514-3.16-.93-.185-2.233 0-3.163.372-2.42.744-5.584 2.788-8.375 5.017-2.978 2.416-5.77 4.46-8.189 5.017-3.163.93-7.258 0-9.119-1.114-.744-.558-1.303-1.115-1.489-1.673-.744-1.486.559-2.787.745-2.973l6.327-6.875 2.233-2.23c-2.047.186-3.908.743-5.769 1.3-2.233.558-4.466 1.302-6.7 1.302-.93 0-5.955-.744-6.885-1.115-5.77-1.487-10.794-3.16-18.425-6.69C11.166 25.8 5.211 34.161 3.536 43.452c1.303.372 3.35.93 4.28 1.115 20.472 4.46 26.8 9.291 28.102 10.22 1.303-1.3 2.978-2.23 5.025-2.23 2.233 0 4.28 1.115 5.583 2.974 1.117-.93 2.792-1.673 4.839-1.673.93 0 1.86.186 2.977.558a6.83 6.83 0 0 1 4.095 3.716q1.117-.557 2.791-.557c1.117 0 2.233.185 3.35.743 3.722 1.672 4.28 5.389 4.094 8.176h.745c4.466 0 8.189 3.716 8.189 8.176 0 1.3-.373 2.601-.931 3.902 1.303.743 4.28 2.23 7.072 1.858 2.233-.186 2.978-.929 3.35-1.486.186-.372.372-.558.186-.93l-5.77-6.503s-.93-.93-.558-1.3c.373-.372.93.185 1.303.557 2.978 2.415 6.514 6.132 6.514 6.132s.372.557 1.675.743c1.116.186 3.163 0 4.652-1.115.373-.372.745-.743.93-1.115 1.49-1.858-.185-3.716-.185-3.716l-6.7-7.619s-.93-.929-.558-1.3c.372-.372.93.185 1.302.557a253 253 0 0 1 8.003 7.619c.558.371 3.164 2.044 6.513-.186 2.048-1.301 2.42-2.973 2.42-4.274-.186-1.672-1.489-2.787-1.489-2.787l-9.305-9.291s-.93-.744-.558-1.301c.372-.372.93.186 1.302.557 2.978 2.416 10.98 9.663 10.98 9.663.186 0 2.792 2.044 6.328-.186 1.303-.743 2.047-1.858 2.047-3.345-.372-2.044-2.047-3.53-2.047-3.53"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M69.417 67.98c-1.489 0-2.978.744-3.164.744s0-.558.186-.93c.186-.371 2.047-5.946-2.605-7.99-3.536-1.486-5.583.186-6.328.93-.186.185-.372.185-.372 0 0-.93-.558-3.717-3.536-4.646-4.28-1.3-7.072 1.672-7.816 2.787-.373-2.415-2.42-4.46-5.025-4.46a5 5 0 0 0-5.025 5.018 5 5 0 0 0 5.025 5.017c1.303 0 2.605-.558 3.536-1.487v.186c-.186 1.3-.559 5.76 4.094 7.619 1.861.743 3.536.186 4.839-.744.372-.371.372-.185.372.186-.186 1.115 0 3.717 3.536 5.017 2.605 1.115 4.28 0 5.21-.929.373-.371.56-.371.56.372.185 3.345 2.977 5.946 6.327 5.946 3.536 0 6.327-2.787 6.327-6.318.186-3.344-2.605-6.132-6.141-6.318"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0A0080",
        d: "M115.012 53.858c-7.072-6.132-23.635-20.44-27.915-23.785-2.606-1.858-4.28-2.973-5.77-3.344-.744-.186-1.674-.372-2.791-.372s-2.42.186-3.536.558c-2.792.929-5.77 3.158-8.56 5.388l-.187.186c-2.605 2.044-5.21 4.088-7.258 4.646-.93.185-1.861.371-2.605.371-2.234 0-4.28-.743-5.025-1.672-.186-.186 0-.372.186-.744l6.141-7.06c4.839-4.832 9.492-9.477 20.1-9.663h.558c6.7 0 13.213 2.973 13.958 3.345 6.327 2.973 12.655 4.46 19.168 4.46 6.7 0 13.586-1.673 21.03-5.018-.744-.743-1.675-1.3-2.605-2.044-6.328 2.787-12.469 4.088-18.425 4.088-5.955 0-12.096-1.486-17.866-4.274-.372-.186-7.63-3.53-15.26-3.53h-.558c-8.933.186-13.958 3.344-17.308 6.132-3.35 0-6.142.929-8.747 1.672-2.233.558-4.28 1.115-6.142 1.115h-2.233c-2.233 0-13.213-2.787-21.96-6.132-.93.557-1.675 1.3-2.605 2.044 9.119 3.716 20.285 6.69 23.82 6.875.931 0 2.048.186 2.979.186 2.233 0 4.652-.557 6.885-1.3 1.303-.372 2.792-.744 4.28-1.116l-1.302 1.301-6.328 6.876c-.558.557-1.674 1.858-.93 3.53.372.743.93 1.3 1.675 1.858 1.489.93 4.28 1.673 6.7 1.673.93 0 1.86 0 2.605-.372 2.606-.557 5.397-2.787 8.375-5.203 2.42-1.858 5.77-4.274 8.188-5.017.745-.186 1.675-.372 2.234-.372h.558c1.675.186 3.35.744 6.328 2.973 5.21 3.903 28.287 24.157 28.473 24.343 0 0 1.489 1.3 1.303 3.344 0 1.115-.744 2.23-1.861 2.974-.93.557-2.047.929-2.978.929-1.488 0-2.605-.744-2.605-.744s-8.002-7.247-10.98-9.662c-.372-.372-.93-.744-1.303-.744-.186 0-.372.186-.558.372-.372.557 0 1.3.744 1.858l9.305 9.291s1.117 1.115 1.303 2.416q0 2.23-2.233 3.902-1.675 1.115-3.35 1.115c-1.489 0-2.42-.557-2.605-.743l-1.303-1.301c-2.42-2.416-4.839-4.831-6.7-6.318-.372-.371-.93-.743-1.303-.743-.186 0-.372 0-.558.186s-.372.743.186 1.3a2.3 2.3 0 0 0 .372.558l6.7 7.618s1.303 1.673.186 3.16l-.186.37-.558.558c-1.117.93-2.606 1.115-3.35 1.115h-.93c-.745-.186-1.117-.371-1.303-.557-.373-.372-3.722-3.902-6.514-6.132-.372-.372-.744-.743-1.303-.743-.186 0-.372 0-.558.185-.558.558.372 1.487.558 1.859l5.77 6.317s0 .186-.186.372c-.187.372-.931.93-2.978 1.3h-.745c-2.233 0-4.466-1.114-5.583-1.672.559-1.115.745-2.415.745-3.716 0-4.645-3.908-8.548-8.561-8.548h-.372c.186-2.23-.186-6.317-4.28-7.99-1.117-.557-2.42-.743-3.537-.743-.93 0-1.86.186-2.605.557-.93-1.672-2.233-2.973-4.28-3.53-1.117-.372-2.048-.558-3.164-.558-1.675 0-3.35.558-4.839 1.487-1.303-1.672-3.536-2.787-5.583-2.787-1.861 0-3.722.743-5.211 2.044-1.861-1.301-8.933-5.947-27.916-10.22-.93-.186-2.977-.744-4.28-1.115-.186 1.115-.372 2.044-.558 3.159 0 0 3.536.929 4.28.929 19.355 4.274 25.868 8.733 26.985 9.662a7.45 7.45 0 0 0-.558 2.787c0 4.089 3.35 7.247 7.258 7.247.372 0 .93 0 1.303-.185.558 2.973 2.605 5.203 5.397 6.317.93.372 1.675.558 2.605.558.558 0 1.117 0 1.675-.186.558 1.3 1.861 3.159 4.466 4.274a7.5 7.5 0 0 0 2.792.557c.745 0 1.489-.185 2.233-.371 1.303 3.159 4.467 5.389 8.003 5.389 2.233 0 4.466-.93 6.141-2.602 1.303.743 4.28 2.23 7.258 2.23h1.117c2.978-.372 4.28-1.487 4.839-2.416.186-.186.186-.371.372-.557.744.186 1.489.371 2.233.371 1.675 0 3.164-.557 4.653-1.672s2.605-2.601 2.791-4.088c.559.186 1.117.186 1.489.186 1.675 0 3.35-.558 4.839-1.487 2.977-2.044 3.536-4.46 3.536-6.132.558.186 1.116.186 1.675.186 1.489 0 2.977-.557 4.466-1.3a6.49 6.49 0 0 0 3.164-5.018c.186-1.486-.186-2.787-.931-4.088 5.025-2.23 16.378-6.318 29.963-9.29 0-1.116-.186-2.045-.372-3.16-16.191 2.974-28.288 8.176-31.452 9.477M69.417 80.244c-3.164 0-5.77-2.415-5.956-5.574 0-.186 0-.93-.558-.93-.186 0-.372.187-.744.372-.745.558-1.675 1.301-2.792 1.301-.558 0-1.302-.186-1.86-.371-3.35-1.301-3.35-3.717-3.165-4.646 0-.186 0-.557-.186-.743l-.186-.186h-.186c-.186 0-.372 0-.558.186-1.117.743-2.047 1.115-2.978 1.115-.558 0-1.116-.186-1.675-.372-4.466-1.672-4.094-5.946-3.908-7.061 0-.186 0-.372-.186-.557l-.372-.186-.373.371c-.93.744-2.047 1.301-3.163 1.301-2.606 0-4.653-2.044-4.653-4.645 0-2.602 2.047-4.646 4.653-4.646 2.233 0 4.28 1.672 4.466 3.902l.186 1.301.745-1.115c0-.186 1.86-2.973 5.397-2.973.558 0 1.302.186 2.047.372 2.791.743 3.164 3.344 3.164 4.273 0 .558.558.558.558.558.186 0 .372-.186.558-.186.559-.557 1.675-1.486 3.35-1.486.745 0 1.675.185 2.606.557 4.28 1.858 2.419 7.247 2.419 7.433-.372.929-.372 1.3 0 1.486h.372c.186 0 .372 0 .745-.186.558-.185 1.489-.557 2.233-.557 3.164 0 5.955 2.602 5.955 5.946 0 3.345-2.605 5.946-5.955 5.946"
    }));

const MermaidDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2
        },
        viewBox: "0 0 491 491",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M407.48 111.18c-71.893-3.077-137.907 41.158-162.4 108.82-24.493-67.662-90.507-111.897-162.4-108.82-2.395 57.049 24.897 111.452 72.06 143.64 24.168 16.599 38.61 44.131 38.53 73.45v50.86H296.9v-50.86c-.084-29.317 14.355-56.85 38.52-73.45 47.176-32.176 74.472-86.587 72.06-143.64",
        style: {
            fill: "#ffff",
            fillRule: "nonzero"
        }
    }));

const MermaidLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2
        },
        viewBox: "0 0 491 491",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M407.48 111.18c-71.893-3.077-137.907 41.158-162.4 108.82-24.493-67.662-90.507-111.897-162.4-108.82-2.395 57.049 24.897 111.452 72.06 143.64 24.168 16.599 38.61 44.131 38.53 73.45v50.86H296.9v-50.86c-.084-29.317 14.355-56.85 38.52-73.45 47.176-32.176 74.472-86.587 72.06-143.64",
        style: {
            fill: "#121212",
            fillRule: "nonzero"
        }
    }));

const Messenger = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: "19.247%",
        cy: "99.465%",
        r: "108.96%",
        fx: "19.247%",
        fy: "99.465%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#09F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "60.975%",
        stopColor: "#A033FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "93.482%",
        stopColor: "#FF5280"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF7061"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M128 0C55.894 0 0 52.818 0 124.16c0 37.317 15.293 69.562 40.2 91.835 2.09 1.871 3.352 4.493 3.438 7.298l.697 22.77c.223 7.262 7.724 11.988 14.37 9.054L84.111 243.9a10.22 10.22 0 0 1 6.837-.501c11.675 3.21 24.1 4.92 37.052 4.92 72.106 0 128-52.818 128-124.16S200.106 0 128 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m51.137 160.47 37.6-59.653c5.98-9.49 18.788-11.853 27.762-5.123l29.905 22.43a7.68 7.68 0 0 0 9.252-.027l40.388-30.652c5.39-4.091 12.428 2.36 8.82 8.085l-37.6 59.654c-5.981 9.489-18.79 11.852-27.763 5.122l-29.906-22.43a7.68 7.68 0 0 0-9.25.027l-40.39 30.652c-5.39 4.09-12.427-2.36-8.818-8.085"
    }));

const Meta = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 171",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "13.878%",
        x2: "89.144%",
        y1: "55.934%",
        y2: "58.694%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0064E1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "40%",
        stopColor: "#0064E1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "83%",
        stopColor: "#0073EE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0082FB"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "54.315%",
        x2: "54.315%",
        y1: "82.782%",
        y2: "39.307%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0082FB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0064E0"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#0081FB",
        d: "M27.651 112.136c0 9.775 2.146 17.28 4.95 21.82 3.677 5.947 9.16 8.466 14.751 8.466 7.211 0 13.808-1.79 26.52-19.372 10.185-14.092 22.186-33.874 30.26-46.275l13.675-21.01c9.499-14.591 20.493-30.811 33.1-41.806C161.196 4.985 172.298 0 183.47 0c18.758 0 36.625 10.87 50.3 31.257C248.735 53.584 256 81.707 256 110.729c0 17.253-3.4 29.93-9.187 39.946-5.591 9.686-16.488 19.363-34.818 19.363v-27.616c15.695 0 19.612-14.422 19.612-30.927 0-23.52-5.484-49.623-17.564-68.273-8.574-13.23-19.684-21.313-31.907-21.313-13.22 0-23.859 9.97-35.815 27.75-6.356 9.445-12.882 20.956-20.208 33.944l-8.066 14.289c-16.203 28.728-20.307 35.271-28.408 46.07-14.2 18.91-26.324 26.076-42.287 26.076-18.935 0-30.91-8.2-38.325-20.556C2.973 139.413 0 126.202 0 111.148z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M21.802 33.206C34.48 13.666 52.774 0 73.757 0 85.91 0 97.99 3.597 110.605 13.897c13.798 11.261 28.505 29.805 46.853 60.368l6.58 10.967c15.881 26.459 24.917 40.07 30.205 46.49 6.802 8.243 11.565 10.7 17.752 10.7 15.695 0 19.612-14.422 19.612-30.927l24.393-.766c0 17.253-3.4 29.93-9.187 39.946-5.591 9.686-16.488 19.363-34.818 19.363-11.395 0-21.49-2.475-32.654-13.007-8.582-8.083-18.615-22.443-26.334-35.352l-22.96-38.352C118.528 64.08 107.96 49.73 101.845 43.23c-6.578-6.988-15.036-15.428-28.532-15.428-10.923 0-20.2 7.666-27.963 19.39z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M73.312 27.802c-10.923 0-20.2 7.666-27.963 19.39-10.976 16.568-17.698 41.245-17.698 64.944 0 9.775 2.146 17.28 4.95 21.82L9.027 149.482C2.973 139.413 0 126.202 0 111.148 0 83.772 7.514 55.24 21.802 33.206 34.48 13.666 52.774 0 73.757 0z"
    }));

const MetaMask = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "prefix__Layer_1",
        x: 0,
        y: 0,
        viewBox: "0 0 318.6 318.6",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("style", null, ".prefix__st1,.prefix__st6{fill:#e4761b;stroke:#e4761b;stroke-linecap:round;stroke-linejoin:round}.prefix__st6{fill:#f6851b;stroke:#f6851b}"), /*#__PURE__*/ React.createElement("path", {
        fill: "#e2761b",
        stroke: "#e2761b",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m274.1 35.5-99.5 73.9L193 65.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m44.4 35.5 98.7 74.6-17.5-44.3zm193.9 171.3-26.5 40.6 56.7 15.6 16.3-55.3zm-204.4.9L50.1 263l56.7-15.6-26.5-40.6z",
        className: "prefix__st1"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m103.6 138.2-15.8 23.9 56.3 2.5-2-60.5zm111.3 0-39-34.8-1.3 61.2 56.2-2.5zM106.8 247.4l33.8-16.5-29.2-22.8zm71.1-16.5 33.9 16.5-4.7-39.3z",
        className: "prefix__st1"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#d7c1b3",
        stroke: "#d7c1b3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m211.8 247.4-33.9-16.5 2.7 22.1-.3 9.3zm-105 0 31.5 14.9-.2-9.3 2.5-22.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#233447",
        stroke: "#233447",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m138.8 193.5-28.2-8.3 19.9-9.1zm40.9 0 8.3-17.4 20 9.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#cd6116",
        stroke: "#cd6116",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m106.8 247.4 4.8-40.6-31.3.9zM207 206.8l4.8 40.6 26.5-39.7zm23.8-44.7-56.2 2.5 5.2 28.9 8.3-17.4 20 9.1zm-120.2 23.1 20-9.1 8.2 17.4 5.3-28.9-56.3-2.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#e4751f",
        stroke: "#e4751f",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m87.8 162.1 23.6 46-.8-22.9zm120.3 23.1-1 22.9 23.7-46zm-64-20.6-5.3 28.9 6.6 34.1 1.5-44.9zm30.5 0-2.7 18 1.2 45 6.7-34.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m179.8 193.5-6.7 34.1 4.8 3.3 29.2-22.8 1-22.9zm-69.2-8.3.8 22.9 29.2 22.8 4.8-3.3-6.6-34.1z",
        className: "prefix__st6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#c0ad9e",
        stroke: "#c0ad9e",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m180.3 262.3.3-9.3-2.5-2.2h-37.7l-2.3 2.2.2 9.3-31.5-14.9 11 9 22.3 15.5h38.3l22.4-15.5 11-9z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#161616",
        stroke: "#161616",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m177.9 230.9-4.8-3.3h-27.7l-4.8 3.3-2.5 22.1 2.3-2.2h37.7l2.5 2.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#763d16",
        stroke: "#763d16",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m278.3 114.2 8.5-40.8-12.7-37.9-96.2 71.4 37 31.3 52.3 15.3 11.6-13.5-5-3.6 8-7.3-6.2-4.8 8-6.1zM31.8 73.4l8.5 40.8-5.4 4 8 6.1-6.1 4.8 8 7.3-5 3.6 11.5 13.5 52.3-15.3 37-31.3-96.2-71.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m267.2 153.5-52.3-15.3 15.9 23.9-23.7 46 31.2-.4h46.5zm-163.6-15.3-52.3 15.3-17.4 54.2h46.4l31.1.4-23.6-46zm71 26.4 3.3-57.7 15.2-41.1h-67.5l15 41.1 3.5 57.7 1.2 18.2.1 44.8h27.7l.2-44.8z",
        className: "prefix__st6"
    }));

const Microsoft = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F1511B",
        d: "M121.666 121.666H0V0h121.666z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#80CC28",
        d: "M256 121.666H134.335V0H256z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00ADEF",
        d: "M121.663 256.002H0V134.336h121.663z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FBBC09",
        d: "M256 256.002H134.335V134.336H256z"
    }));

const MicrosoftAzure = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: -1032.17,
        x2: -1059.21,
        y1: 145.31,
        y2: 65.43,
        gradientTransform: "matrix(1 0 0 -1 1075 158)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#114a8b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0669bc"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: -1023.73,
        x2: -1029.98,
        y1: 108.08,
        y2: 105.97,
        gradientTransform: "matrix(1 0 0 -1 1075 158)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopOpacity: 0.3
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.07,
        stopOpacity: 0.2
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.32,
        stopOpacity: 0.1
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.62,
        stopOpacity: 0.05
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: -1027.16,
        x2: -997.48,
        y1: 147.64,
        y2: 68.56,
        gradientTransform: "matrix(1 0 0 -1 1075 158)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#3ccbf4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#2892df"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M33.34 6.54h26.04l-27.03 80.1a4.15 4.15 0 0 1-3.94 2.81H8.15a4.14 4.14 0 0 1-3.93-5.47L29.4 9.38a4.15 4.15 0 0 1 3.94-2.83z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0078d4",
        d: "M71.17 60.26H29.88a1.91 1.91 0 0 0-1.3 3.31l26.53 24.76a4.17 4.17 0 0 0 2.85 1.13h23.38z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M33.34 6.54a4.12 4.12 0 0 0-3.95 2.88L4.25 83.92a4.14 4.14 0 0 0 3.91 5.54h20.79a4.44 4.44 0 0 0 3.4-2.9l5.02-14.78 17.91 16.7a4.24 4.24 0 0 0 2.67.97h23.29L71.02 60.26H41.24L59.47 6.55z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M66.6 9.36a4.14 4.14 0 0 0-3.93-2.82H33.65a4.15 4.15 0 0 1 3.93 2.82l25.18 74.62a4.15 4.15 0 0 1-3.93 5.48h29.02a4.15 4.15 0 0 0 3.93-5.48z"
    }));

const MicrosoftSQLServer = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#cfd8dc",
        d: "M23.084 11.277c-1.633-2.449-1.986-5.722-2.063-7.067-4.148.897-8.269 2.506-8.031 3.691.03.149.218.328.53.502l-.488.873c-.596-.334-.931-.719-1.022-1.179-.269-1.341 1.25-2.554 4.642-3.709a42 42 0 0 1 4.751-1.279l.597-.12V3.6c0 .042.026 4.288 1.916 7.123zM24.751 43H24.5c-8.192 0-17.309-2.573-18.386-6.879-.657-2.63 1.492-5.536 6.214-8.401l.52.854c-4.249 2.579-6.296 5.172-5.763 7.305.935 3.738 9.575 6.068 17.153 6.12.901-1.347 5.742-9.26 2.979-19.873l.967-.252c3.149 12.092-3.218 20.837-3.282 20.924z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#cfd8dc",
        d: "M9.931 39.306c-.539 0-.806-.059-.85-.07a.498.498 0 0 1-.233-.84c.072-.072 7.197-7.208 8.159-12.978l.986.164c-.827 4.964-5.715 10.623-7.656 12.707 1.939-.111 6.835-1.019 16.234-6.28-7.335-.804-8.495-6.676-8.507-6.739l.983-.181c.047.246 1.226 6.011 9.244 6.011h.008a.5.5 0 0 1 .251.933c-11.235 6.509-16.683 7.272-18.619 7.273"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#cfd8dc",
        d: "M14.524 41.7a.499.499 0 0 1-.291-.907c.034-.025 1.813-1.338 3.706-4.228a20 20 0 0 1-2.196-1.137c-.888-.533-1.559-1.105-2.06-1.691-2.57.678-4.942.946-7.025.769l.084-.996c1.876.159 4.009-.063 6.321-.64-1.573-2.688-.129-5.356-.109-5.392l.874.487c-.067.122-1.265 2.37.249 4.633 2.201-.632 4.549-1.567 6.979-2.782a32 32 0 0 0 1.225-6.276.5.5 0 0 1 .706-.406c.032.015 3.264 1.491 5.604 2.454a.5.5 0 0 1 .091.876 62.5 62.5 0 0 1-6.778 4.042 27.2 27.2 0 0 1-2.459 5.591c3.702 1.383 6.915 1.404 6.956 1.404a.5.5 0 0 1 .243.938c-4.54 2.522-11.767 3.232-12.072 3.261zm4.385-4.733c-1.04 1.614-2.062 2.773-2.826 3.53 1.998-.294 5.501-.938 8.408-2.139a23.7 23.7 0 0 1-5.582-1.391m-4.142-3.536c.393.392.883.775 1.49 1.14.736.442 1.483.817 2.22 1.135a26 26 0 0 0 2.142-4.568c-2.021.962-3.983 1.73-5.852 2.293m8.435-9.102a34 34 0 0 1-.913 4.85 63 63 0 0 0 5.062-3.026 207 207 0 0 1-4.149-1.824M17.924 10.6a.5.5 0 0 1-.325-.12c-1.61-1.378-3.505-4.182-3.585-4.301a.5.5 0 0 1 .654-.718c.011.003.938.385 7.217 1.431a.499.499 0 0 1 .29.828c-1.758 1.953-3.979 2.813-4.073 2.848a.5.5 0 0 1-.178.032m-2.277-3.854c.631.849 1.54 1.996 2.372 2.769a11.2 11.2 0 0 0 2.744-1.798c-2.583-.441-4.159-.755-5.116-.971"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#b71c1c",
        d: "M21.843 24.4a.5.5 0 0 1-.497-.552c.292-2.749-3.926-3.852-3.969-3.862a.5.5 0 0 1-.23-.838c.207-.207 5.139-5.098 11.327-7.784a.5.5 0 0 1 .689.559c-1.186 5.744-6.71 12.044-6.944 12.309a.5.5 0 0 1-.376.168m-3.388-5.115c1.184.445 3.258 1.475 3.783 3.356 1.449-1.808 4.542-5.973 5.697-9.934-4.387 2.11-8.081 5.292-9.48 6.578"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#b71c1c",
        d: "m13.079 28.36-.475-.88c1.883-1.015 4.04-2.883 5.807-5.054-1.504 1.03-2.365 1.735-2.392 1.758l-.639-.77c.039-.032 1.764-1.447 4.631-3.22.787-1.266 1.392-2.568 1.703-3.816q.08-.318.136-.615c-1.925-.687-3.701-1.094-4.921-1.269a.5.5 0 0 1-.297-.835c.085-.092 2.116-2.268 4.654-3.463a.5.5 0 0 1 .581.114c.067.073 1.44 1.615 1.091 4.805 1.155.45 2.345.997 3.491 1.648 2.759-1.24 5.892-2.356 9.229-3.03a.51.51 0 0 1 .481.168c.117.14.149.333.083.503-1.3 3.332-4.786 6.891-4.934 7.041a.503.503 0 0 1-.748-.04c-1.12-1.408-2.584-2.574-4.163-3.523a55 55 0 0 0-5.684 3.049c-2.02 3.153-5.069 6.048-7.634 7.429m14.413-10.964c1.29.832 2.491 1.81 3.484 2.948.828-.898 2.815-3.168 3.942-5.422-2.65.61-5.158 1.493-7.426 2.474m-4.693-1.274q-.05.245-.113.5c-.21.839-.544 1.701-.972 2.561a56 56 0 0 1 3.618-1.898 26 26 0 0 0-2.533-1.163m-4.751-2.45c1.111.218 2.48.574 3.941 1.086.152-1.843-.346-2.972-.647-3.472-1.376.718-2.581 1.728-3.294 2.386"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#b71c1c",
        d: "M18.05 18.5c0 4.38-3.65 7.86-6.28 10.4-.44.43-1.93.5-1.93.5.37-.38.79-.78 1.24-1.21 2.5-2.42 5.97-5.73 5.97-9.69 0-4.69-1.89-6.54-3.38-8.02-.66-.67-1.22-1.31-1.56-2.09l.31-.13c.34.15.73.32 1.03.45.24.35.56.69.93 1.06 1.53 1.53 3.67 3.63 3.67 8.73"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#b71c1c",
        d: "M42.935 19.794s-.605.086-.775.106c-8.76.97-17.8 3.49-22.97 5.56-1.87.75-3.81 1.66-5.58 2.68-.01.01-.02.01-.04.02-1.04.6-3.57 1.84-5.62 2.93 3-3.19 8.62-5.65 10.86-6.55 5.07-2.03 13.78-4.48 22.35-5.53-1.01-1.18-3.48-3.68-8.34-5.54-2.84-1.1-7.16-1.72-10.97-2.27-6.06-.87-9.51-1.45-9.84-3.1-.07-.33-.02-.66.13-.98.33.54.8.92 1.11 1.14.15.1.26.16.3.18l.01.01c1.42.75 5.25 1.3 8.44 1.76 3.86.56 8.23 1.19 11.18 2.32 6.87 2.65 9.24 6.44 9.34 6.6.09.15.415.664.415.664"
    }));

const MicrosoftTodo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 1007.922 821.827",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__c",
        cx: 410.201,
        cy: 853.349,
        r: 85,
        gradientTransform: "rotate(45 546.823 785.354)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopOpacity: 0.13
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.994,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__c",
        id: "prefix__e",
        cx: 1051.126,
        cy: 1265.852,
        r: 85,
        gradientTransform: "rotate(-135 769.601 767.5)"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__c",
        id: "prefix__h",
        cx: 27.608,
        cy: 2001.37,
        r: 85,
        gradientTransform: "scale(1 -1)rotate(45 2979.231 860.248)"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 700.766,
        x2: 749.765,
        y1: 597.024,
        y2: 597.024,
        gradientTransform: "matrix(.867 0 0 1.307 86.603 -142.296)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopOpacity: 0.13
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.994,
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__f",
        x1: 1880.8,
        x2: 1929.799,
        y1: 34.286,
        y2: 34.286,
        gradientTransform: "matrix(.867 0 0 -.796 -1446.031 767.147)"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: 308.378,
        x2: 919.318,
        y1: 811.629,
        y2: 200.689,
        gradientTransform: "rotate(-45 613.848 506.16)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#2987e6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.994,
        stopColor: "#58c1f5"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        width: 170,
        height: 205.208,
        x: 317.137,
        y: 651.827,
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m402.137 736.828 60.104 60.104-60.104 60.104-60.104-60.104z",
        className: "prefix__a"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__d",
        width: 205.208,
        height: 205.208,
        x: 837.922,
        y: 95.835,
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M983.025 276.147 862.817 155.94l60.104-60.104 120.208 120.208z",
        className: "prefix__a"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__g",
        width: 205.208,
        height: 205.208,
        x: -35.208,
        y: 299.482,
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M-35.208 419.69 85 299.482l60.104 60.104L24.896 479.794z",
        className: "prefix__a"
    })), /*#__PURE__*/ React.createElement("style", null, ".prefix__a{fill:#fff}")), /*#__PURE__*/ React.createElement("path", {
        d: "M694.422 269.785h42.5v736.5h-42.5z",
        style: {
            fill: "url(#prefix__a)"
        },
        transform: "rotate(45 852.293 570.04)"
    }), /*#__PURE__*/ React.createElement("g", {
        style: {
            mask: "url(#prefix__b)"
        }
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 402.137,
        cy: 736.827,
        r: 85,
        style: {
            fill: "url(#prefix__c)"
        }
    })), /*#__PURE__*/ React.createElement("g", {
        style: {
            mask: "url(#prefix__d)"
        }
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 922.922,
        cy: 216.043,
        r: 85,
        style: {
            fill: "url(#prefix__e)"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M185.305 515.608h42.5v448.5h-42.5z",
        style: {
            fill: "url(#prefix__f)"
        },
        transform: "rotate(135 226.655 679.927)"
    }), /*#__PURE__*/ React.createElement("g", {
        style: {
            mask: "url(#prefix__g)"
        }
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 85,
        cy: 419.69,
        r: 85,
        style: {
            fill: "url(#prefix__h)"
        }
    })), /*#__PURE__*/ React.createElement("rect", {
        width: 288,
        height: 576,
        x: 164.378,
        y: 319.982,
        rx: 42.5,
        style: {
            fill: "#195abd"
        },
        transform: "rotate(-45 163.692 559.456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 288,
        height: 864,
        x: 469.848,
        y: 74.159,
        rx: 42.5,
        style: {
            fill: "url(#prefix__i)"
        },
        transform: "rotate(45 750.47 438.164)"
    }));

const Midday = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 400 400",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 400,
        height: 400,
        fill: "#141414",
        rx: 60
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M193.565 64c-20.558.879-39.939 6.3-57.166 15.287l57.166 99.014zm0 158.705-57.163 99.01c17.226 8.985 36.606 14.406 57.163 15.285zm11.881 114.294v-114.36l57.19 99.057c-17.232 8.995-36.622 14.423-57.19 15.303m0-158.632V64c20.569.881 39.96 6.31 57.193 15.305zm-121.19 95.551 99.034-57.178-57.172 99.027a137.36 137.36 0 0 1-41.862-41.849m230.51-146.803-99.017 57.167 57.172-99.025a137.36 137.36 0 0 1 41.845 41.858M84.245 127.1a137.36 137.36 0 0 1 41.87-41.865l57.192 99.058zm-5.95 10.284C69.302 154.619 63.876 174.012 63 194.583h114.367zm.01 126.251c-8.993-17.227-14.42-36.611-15.303-57.172H177.33zm143.364-69.052h114.332c-.876-20.565-6.298-39.953-15.287-57.184zm99.035 69.037-98.998-57.157h114.293c-.882 20.555-6.307 39.934-15.295 57.157m-104.939-46.868 57.153 98.992a137.3 137.3 0 0 0 41.836-41.841z",
        clipRule: "evenodd"
    }));

const Midudev = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 228 198",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#199afc",
        d: "M73.2 126.4c-15 15-15 39.3 0 54.3L19 126.4C4 111.5 4 87.2 19 72.2L73.2 18c15-15 39.2-15 54.2 0s15 39.2 0 54.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1d5682",
        d: "m73.2 126.4 27.1-27.1 27.1 27.1c15 15 15 39.3 0 54.3-15 14.9-39.2 14.9-54.2 0-15-15-15-39.3 0-54.3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#199afc",
        d: "M185.5 84.3c8.3-8.2 8.3-21.7 0-29.9l30 29.9c8.2 8.3 8.2 21.7 0 30l-30 30c-8.3 8.3-21.7 8.3-30 0s-8.3-21.7 0-30z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1d5682",
        d: "m185.5 84.3-15 15-15-15c-8.3-8.2-8.3-21.7 0-29.9 8.3-8.3 21.7-8.3 30 0 8.3 8.2 8.3 21.7 0 29.9"
    }));

const MilanoteDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 220 220",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "evenodd",
        d: "M110 20c49.706 0 90 40.294 90 90s-40.294 90-90 90-90-40.294-90-90 40.294-90 90-90m40 55.01c0-4.455-5.386-6.685-8.536-3.536L110 102.934l-31.464-31.46C75.386 68.324 70 70.555 70 75.01V145a5 5 0 0 0 5 5h70a5 5 0 0 0 5-5Zm-40 42.065 22.929 22.926H87.07zm30-29.996v45.852l-22.929-22.926zm-60 0 22.929 22.926L80 132.931V87.08Z"
    }));

const MilanoteLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 220 220",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#31303A",
        d: "M110 20c49.706 0 90 40.294 90 90s-40.294 90-90 90-90-40.294-90-90 40.294-90 90-90m40 55.01c0-4.455-5.386-6.685-8.536-3.536L110 102.934l-31.464-31.46C75.386 68.324 70 70.555 70 75.01V145a5 5 0 0 0 5 5h70a5 5 0 0 0 5-5Zm-40 42.065 22.929 22.926H87.07zm30-29.996v45.852l-22.929-22.926zm-60 0 22.929 22.926L80 132.931V87.08Z"
    }));

const Million = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 182",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: "50%",
        cy: "49.999%",
        r: "32.306%",
        fx: "50%",
        fy: "49.999%",
        gradientTransform: "translate(0 -380193.475)skewY(90)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#845CE7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#AF73D8"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: "50.061%",
        cy: "104.167%",
        r: "67.301%",
        fx: "50.061%",
        fy: "104.167%",
        gradientTransform: "translate(0 -35820434.112)skewY(90)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#845CE7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#AF73D8"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__c",
        cx: "99.122%",
        cy: "34.222%",
        r: "42.521%",
        fx: "99.122%",
        fy: "34.222%",
        gradientTransform: "translate(0 -56809933.375)skewY(90)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#845CE7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#AF73D8"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: ".878%",
        cy: "34.21%",
        r: "42.506%",
        fx: ".878%",
        fy: "34.21%",
        gradientTransform: "translate(0 -5447320.88)skewY(90)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#845CE7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#AF73D8"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M64.995 153.355c11.777-16.858 35.745-28.399 63.396-28.399 27.65 0 51.62 11.54 63.397 28.4-11.778 16.856-35.746 28.397-63.397 28.397s-51.619-11.54-63.396-28.398"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M64.567 28.097C76.337 11.418 100.289 0 127.923 0c27.633 0 51.586 11.418 63.356 28.097-11.77 16.679-35.723 28.097-63.356 28.097S76.337 44.776 64.567 28.097"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M129.133 91.209c-17.124 16.54-40.349 25.831-64.566 25.831S17.124 107.748 0 91.209l64.567-63.112z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M256 91.24c-17.124 16.54-40.35 25.831-64.567 25.831s-47.443-9.292-64.567-25.831l64.567-63.143z"
    }));

const Mintlify = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1000 1000",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 1000,
        height: 1000,
        fill: "#041811",
        rx: 64
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0C8C5E",
        d: "M328.655 428.699a220.52 220.52 0 0 1 63.396-153.114h-.074L236.638 430.924h.074q-.868.683-1.631 1.483a221.85 221.85 0 0 0-20.835 289.917l156.896-156.896 1.631-1.558a220.3 220.3 0 0 1-44.118-135.171M705.844 589.451a222.15 222.15 0 0 1-229.932 50.643 217.7 217.7 0 0 1-58.28-31.364l-1.631 1.631-156.897 156.822a222.15 222.15 0 0 0 289.843-20.836l1.557-1.557z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#18E299",
        d: "M772.428 430.924V209H550.505a221.27 221.27 0 0 0-156.896 65.028l-1.558 1.557a220.45 220.45 0 0 0-56.278 99.135 225.7 225.7 0 0 1 53.98-7.192 220.88 220.88 0 0 1 135.171 44.192 221.18 221.18 0 0 1 76.149 103.139 222.96 222.96 0 0 1 5.636 130.796 220.07 220.07 0 0 0 99.135-56.278l1.557-1.483a221.26 221.26 0 0 0 65.027-156.97"
    }));

const MistralAI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 233",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M186.182 0h46.545v46.545h-46.545z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F7D046",
        d: "M209.455 0H256v46.545h-46.545z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h46.545v46.545H0zm0 46.545h46.545v46.546H0zm0 46.546h46.545v46.545H0zm0 46.545h46.545v46.546H0zm0 46.546h46.545v46.545H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F7D046",
        d: "M23.273 0h46.545v46.545H23.273z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F2A73B",
        d: "M209.455 46.545H256v46.546h-46.545zm-186.182 0h46.545v46.546H23.273z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M139.636 46.545h46.546v46.546h-46.546z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F2A73B",
        d: "M162.91 46.545h46.545v46.546h-46.546zm-93.092 0h46.546v46.546H69.818z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE792F",
        d: "M116.364 93.09h46.545v46.546h-46.545zm46.545 0h46.546v46.546h-46.546zm-93.09 0h46.545v46.546H69.818z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M93.09 139.636h46.546v46.546H93.091z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EB5829",
        d: "M116.364 139.636h46.545v46.546h-46.545z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE792F",
        d: "M209.455 93.09H256v46.546h-46.545zm-186.182 0h46.545v46.546H23.273z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M186.182 139.636h46.545v46.546h-46.545z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EB5829",
        d: "M209.455 139.636H256v46.546h-46.545z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M186.182 186.182h46.545v46.545h-46.545z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EB5829",
        d: "M23.273 139.636h46.545v46.546H23.273z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EA3326",
        d: "M209.455 186.182H256v46.545h-46.545zm-186.182 0h46.545v46.545H23.273z"
    }));

const ModelContextProtocolDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#fff",
        fillRule: "evenodd",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.688 2.343a2.59 2.59 0 0 0-3.61 0l-9.626 9.44a.863.863 0 0 1-1.203 0 .823.823 0 0 1 0-1.18l9.626-9.44a4.313 4.313 0 0 1 6.016 0 4.12 4.12 0 0 1 1.204 3.54 4.3 4.3 0 0 1 3.609 1.18l.05.05a4.115 4.115 0 0 1 0 5.9l-8.706 8.537a.274.274 0 0 0 0 .393l1.788 1.754a.823.823 0 0 1 0 1.18.863.863 0 0 1-1.203 0l-1.788-1.753a1.92 1.92 0 0 1 0-2.754l8.706-8.538a2.47 2.47 0 0 0 0-3.54l-.05-.049a2.59 2.59 0 0 0-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 0 1-1.204 0 .823.823 0 0 1 0-1.18l7.273-7.133a2.47 2.47 0 0 0-.003-3.537"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M14.485 4.703a.823.823 0 0 0 0-1.18.863.863 0 0 0-1.204 0l-7.119 6.982a4.115 4.115 0 0 0 0 5.9 4.314 4.314 0 0 0 6.016 0l7.12-6.982a.823.823 0 0 0 0-1.18.863.863 0 0 0-1.204 0l-7.119 6.982a2.59 2.59 0 0 1-3.61 0 2.47 2.47 0 0 1 0-3.54z"
    }));

const ModelContextProtocolLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.688 2.343a2.59 2.59 0 0 0-3.61 0l-9.626 9.44a.863.863 0 0 1-1.203 0 .823.823 0 0 1 0-1.18l9.626-9.44a4.313 4.313 0 0 1 6.016 0 4.12 4.12 0 0 1 1.204 3.54 4.3 4.3 0 0 1 3.609 1.18l.05.05a4.115 4.115 0 0 1 0 5.9l-8.706 8.537a.274.274 0 0 0 0 .393l1.788 1.754a.823.823 0 0 1 0 1.18.863.863 0 0 1-1.203 0l-1.788-1.753a1.92 1.92 0 0 1 0-2.754l8.706-8.538a2.47 2.47 0 0 0 0-3.54l-.05-.049a2.59 2.59 0 0 0-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 0 1-1.204 0 .823.823 0 0 1 0-1.18l7.273-7.133a2.47 2.47 0 0 0-.003-3.537"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M14.485 4.703a.823.823 0 0 0 0-1.18.863.863 0 0 0-1.204 0l-7.119 6.982a4.115 4.115 0 0 0 0 5.9 4.314 4.314 0 0 0 6.016 0l7.12-6.982a.823.823 0 0 0 0-1.18.863.863 0 0 0-1.204 0l-7.119 6.982a2.59 2.59 0 0 1-3.61 0 2.47 2.47 0 0 1 0-3.54z"
    }));

const Monero = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F60",
        d: "M128 0A128 128 0 0 0 7 168h38V61l83 83 83-83v107h38A128 128 0 0 0 128 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C4C4C",
        d: "m109 163-36-36v68H19a128 128 0 0 0 218 0h-54v-68l-36 36-19 19z"
    }));

const MongoDB = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 549",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#01EC64",
        d: "M175.622 61.108C152.612 33.807 132.797 6.078 128.749.32a1.03 1.03 0 0 0-1.492 0c-4.048 5.759-23.863 33.487-46.874 60.788-197.507 251.896 31.108 421.89 31.108 421.89l1.917 1.28c1.704 26.234 5.966 63.988 5.966 63.988h17.045s4.26-37.54 5.965-63.987l1.918-1.494c.213.214 228.828-169.78 31.32-421.677m-47.726 418.05s-10.227-8.744-12.997-13.222v-.428l12.358-274.292c0-.853 1.279-.853 1.279 0l12.357 274.292v.428c-2.77 4.478-12.997 13.223-12.997 13.223Z"
    }));

const Monkeytype = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2
        },
        viewBox: "0 0 300 180",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M250 120c5.519 0 10 4.481 10 10s-4.481 10-10 10-10-4.481-10-10 4.481-10 10-10M110 120h60c5.519 0 10 4.481 10 10s-4.481 10-10 10h-60c-5.519 0-10-4.481-10-10s4.481-10 10-10M90 60c5.519 0 10 4.481 10 10v20c0 5.519-4.481 10-10 10s-10-4.481-10-10V70c0-5.519 4.481-10 10-10",
        style: {
            fill: "#e2b714",
            fillRule: "nonzero"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M40.009 69.485C40.28 53.164 53.615 40 70 40c7.68 0 14.69 2.892 20 7.645A29.9 29.9 0 0 1 110 40c16.385 0 29.72 13.164 29.991 29.485q.01.256.009.515v20c0 5.519-4.481 10-10 10s-10-4.481-10-10V70c0-5.519-4.481-10-10-10s-10 4.481-10 10v20c0 5.519-4.481 10-10 10s-10-4.481-10-10V70c0-5.519-4.481-10-10-10s-10 4.481-10 10v20c0 5.519-4.481 10-10 10s-10-4.481-10-10V70q0-.258.009-.515M220 100v30c0 5.519-4.481 10-10 10s-10-4.481-10-10v-30h-28.82c-6.17 0-11.18-4.481-11.18-10s5.01-10 11.18-10h77.64c6.17 0 11.18 4.481 11.18 10s-5.01 10-11.18 10zM210 40h40c5.519 0 10 4.481 10 10s-4.481 10-10 10h-40c-5.519 0-10-4.481-10-10s4.481-10 10-10M50 120h20c5.519 0 10 4.481 10 10s-4.481 10-10 10H50c-5.519 0-10-4.481-10-10s4.481-10 10-10M165 40h5c5.519 0 10 4.481 10 10s-4.481 10-10 10h-5c-5.519 0-10-4.481-10-10s4.481-10 10-10",
        style: {
            fill: "#e2b714",
            fillRule: "nonzero"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M20 110H0V50C0 22.404 22.404 0 50 0h200c27.596 0 50 22.404 50 50v80c0 27.596-22.404 50-50 50H50c-27.596 0-50-22.404-50-50v-20zv20c0 16.557 13.443 30 30 30h200c16.557 0 30-13.443 30-30V50c0-16.557-13.443-30-30-30H50c-16.557 0-30 13.443-30 30z",
        style: {
            fill: "#e2b714",
            fillRule: "nonzero"
        }
    }));

const Moon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: "50%",
        cy: "50%",
        r: "49.789%",
        fx: "50%",
        fy: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4600D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "49.285%",
        stopColor: "#4600D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#35009F"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: "50%",
        cy: "50%",
        r: "49.603%",
        fx: "50%",
        fy: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#35019E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "18.73%",
        stopColor: "#320194"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#206"
    })), /*#__PURE__*/ React.createElement("circle", {
        id: "prefix__a",
        cx: 128,
        cy: 128,
        r: 128
    })), /*#__PURE__*/ React.createElement("circle", {
        cx: 128,
        cy: 128,
        r: 128,
        fill: "#5805FF"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__c",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ React.createElement("circle", {
        cx: 199.694,
        cy: 105.369,
        r: 128,
        fill: "url(#prefix__b)",
        mask: "url(#prefix__c)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 275.372,
        cy: 82.376,
        r: 128,
        fill: "url(#prefix__d)",
        mask: "url(#prefix__c)"
    }));

const MotionDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1103 386",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF312",
        d: "M416.473 0 198.54 385.66H0L170.17 84.522C196.549 37.842 262.377 0 317.203 0Zm486.875 96.415c0-53.249 44.444-96.415 99.27-96.415s99.27 43.166 99.27 96.415c0 53.248-44.444 96.415-99.27 96.415s-99.27-43.167-99.27-96.415M453.699 0h198.54L434.306 385.66h-198.54Zm234.492 0h198.542L716.56 301.138c-26.378 46.68-92.207 84.522-147.032 84.522h-99.27Z"
    }));

const MotionLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1103 386",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0F1115",
        d: "M416.473 0 198.54 385.66H0L170.17 84.522C196.549 37.842 262.377 0 317.203 0Zm486.875 96.415c0-53.249 44.444-96.415 99.27-96.415s99.27 43.166 99.27 96.415c0 53.248-44.444 96.415-99.27 96.415s-99.27-43.167-99.27-96.415M453.699 0h198.54L434.306 385.66h-198.54Zm234.492 0h198.542L716.56 301.138c-26.378 46.68-92.207 84.522-147.032 84.522h-99.27Z"
    }));

const MySQL = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 252",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00546B",
        d: "M236 194c-14 0-25 1-34 5-3 1-7 1-7 4l3 6c2 3 5 8 9 11l11 8 21 10 11 9 6 4-3-6-5-5q-7.5-10.5-18-18c-6-3-18-9-20-15h-1l12-3 18-3 8-2v-2l-9-10c-8-8-18-15-28-22l-18-8c-2-1-6-2-7-4l-7-13-15-30-8-20c-18-30-38-48-68-65-6-4-14-5-22-7l-13-1-8-6C34 5 8-9 1 9c-5 11 7 22 11 28l9 13 3 9c3 8 5 17 9 24l6 10c2 2 4 3 5 6-3 4-3 9-4 13-7 20-4 44 5 59 2 4 9 14 18 10 8-3 6-13 8-22l1-4 8 14c5 9 14 18 22 24 4 3 8 8 13 10l-4-4-9-10c-8-10-14-21-20-32l-7-17-3-6c-3 4-7 7-9 12-3 7-3 17-4 26h-1c-6-1-8-7-10-12-5-12-6-32-1-46 1-4 6-15 4-19-1-3-4-5-6-7l-7-12-10-30-9-13c-3-5-7-8-10-14-1-2-2-5 0-7l2-2c2-2 9 0 11 1 6 3 12 5 17 9l8 6h4c6 1 12 0 17 2 9 3 18 7 25 12 23 14 42 35 54 59 3 4 3 8 5 12l12 26c4 8 7 16 12 23 3 4 14 6 18 8l12 4 18 12c2 2 11 7 12 10"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00546B",
        d: "m58 43-7 1 6 7 4 9v-1c3-1 4-4 4-8l-2-4z"
    }));

const NHost = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 273",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0052CD",
        d: "M232.105 58.517 136.962 3.68a27.88 27.88 0 0 0-27.691 0 27.68 27.68 0 0 0-13.829 23.912v7.157l-6.202-3.583a27.88 27.88 0 0 0-27.69 0 27.69 27.69 0 0 0-13.83 23.956v7.148l-6.202-3.574a27.88 27.88 0 0 0-27.682 0A27.69 27.69 0 0 0 0 82.616v171.776a13.018 13.018 0 0 0 21.071 10.194l47.175-37.143 72.768 41.92a13.2 13.2 0 0 0 13.018 0c4.01-2.32 6.509-6.62 6.509-11.252v-103.35a47.73 47.73 0 0 0-23.86-41.246l-23.862-13.752V27.618a10.322 10.322 0 0 1 15.484-8.914l95.144 54.81a30.39 30.39 0 0 1 15.184 26.24v128.722c0 3.668-1.979 7.08-5.16 8.914l-25.21 14.528V127.241a47.73 47.73 0 0 0-23.86-41.238l-58.572-33.74v19.988l49.896 28.75a30.36 30.36 0 0 1 15.185 26.24V259.4c0 4.606 2.491 8.931 6.51 11.252a13.21 13.21 0 0 0 13.017 0l31.726-18.282c8.53-4.922 13.837-14.076 13.837-23.929V99.721a47.85 47.85 0 0 0-23.895-41.204m-104.143 69.986a30.36 30.36 0 0 1 15.184 26.25v95.885l-60.244-34.711 19.34-15.202a27.42 27.42 0 0 0 10.543-21.685v-59.255l15.185 8.727zm-32.528-18.742v69.245c0 3.182-1.442 6.142-3.933 8.087l-74.158 58.35V82.591a10.314 10.314 0 0 1 15.475-8.915L47.72 82.25v122.757l17.343-13.649V55.105a10.314 10.314 0 0 1 15.484-8.915l14.886 8.565v34.993L78.099 79.75v20.005l17.352 10.006z"
    }));

const NPM = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#cb3837",
        d: "M2 38.5h124v43.71H64v7.29H36.44v-7.29H2Zm6.89 36.43h13.78V53.07h6.89v21.86h6.89V45.79H8.89Zm34.44-29.14v36.42h13.78v-7.28h13.78V45.79Zm13.78 7.29H64v14.56h-6.89Zm20.67-7.29v29.14h13.78V53.07h6.89v21.86h6.89V53.07h6.89v21.86h6.89V45.79Z"
    }));

const Neon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "100%",
        x2: "12.069%",
        y1: "100%",
        y2: "0%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#62F755"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#8FF986",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "100%",
        x2: "40.603%",
        y1: "100%",
        y2: "76.897%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopOpacity: 0.9
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#1A1A1A",
        stopOpacity: 0
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#00E0D9",
        d: "M0 44.139C0 19.762 19.762 0 44.139 0H211.86C236.238 0 256 19.762 256 44.139v142.649c0 25.216-31.915 36.16-47.388 16.256l-48.392-62.251v75.484c0 21.939-17.784 39.723-39.722 39.723h-76.36C19.763 256 0 236.238 0 211.861zm44.139-8.825a8.817 8.817 0 0 0-8.825 8.818v167.73c0 4.878 3.946 8.831 8.818 8.831h77.688c2.44 0 3.087-1.977 3.087-4.416v-101.22c0-25.222 31.914-36.166 47.395-16.255l48.391 62.243V44.14c0-4.879.455-8.825-4.416-8.825H44.14Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M0 44.139C0 19.762 19.762 0 44.139 0H211.86C236.238 0 256 19.762 256 44.139v142.649c0 25.216-31.915 36.16-47.388 16.256l-48.392-62.251v75.484c0 21.939-17.784 39.723-39.722 39.723h-76.36C19.763 256 0 236.238 0 211.861zm44.139-8.825a8.817 8.817 0 0 0-8.825 8.818v167.73c0 4.878 3.946 8.831 8.818 8.831h77.688c2.44 0 3.087-1.977 3.087-4.416v-101.22c0-25.222 31.914-36.166 47.395-16.255l48.391 62.243V44.14c0-4.879.455-8.825-4.416-8.825H44.14Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        fillOpacity: 0.4,
        d: "M0 44.139C0 19.762 19.762 0 44.139 0H211.86C236.238 0 256 19.762 256 44.139v142.649c0 25.216-31.915 36.16-47.388 16.256l-48.392-62.251v75.484c0 21.939-17.784 39.723-39.722 39.723h-76.36C19.763 256 0 236.238 0 211.861zm44.139-8.825a8.817 8.817 0 0 0-8.825 8.818v167.73c0 4.878 3.946 8.831 8.818 8.831h77.688c2.44 0 3.087-1.977 3.087-4.416v-101.22c0-25.222 31.914-36.166 47.395-16.255l48.391 62.243V44.14c0-4.879.455-8.825-4.416-8.825H44.14Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#63F655",
        d: "M211.861 0C236.238 0 256 19.762 256 44.139v142.649c0 25.216-31.915 36.16-47.388 16.256l-48.392-62.251v75.484c0 21.939-17.784 39.723-39.722 39.723a4.41 4.41 0 0 0 4.409-4.409V115.058c0-25.223 31.914-36.167 47.395-16.256l48.391 62.243V8.825c0-4.871-3.953-8.825-8.832-8.825"
    }));

const Neovim = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 602 734",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#16B0ED",
        stopOpacity: 0.8
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0F59B2",
        stopOpacity: 0.837
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#7DB643"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#367533"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#88C649",
        stopOpacity: 0.8
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#439240",
        stopOpacity: 0.84
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M0 155.57 155-1v728L0 572.238z",
        transform: "translate(2 3)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M443.06 156.982 600-1l-3.181 728L442 572.22z",
        transform: "matrix(-1 0 0 1 1044 3)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M154.986 0 558 615.19 445.225 728 42 114.172z",
        transform: "translate(2 3)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillOpacity: 0.13,
        d: "M157 286.832 156.787 311 33 127.71 44.462 116z"
    })));

const NestJS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 264.6 255.6",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#e0234e",
        fillRule: "evenodd",
        d: "M153.3 4.2c-1.8 0-3.5.4-5 1 3.3 2.1 5.1 5 6 8.3 0 .5.2.8.3 1.3l.1 1.1c.3 5.7-1.5 6.4-2.7 9.8-1.9 4.3-1.4 9 .9 12.7.2.5.4 1 .8 1.4-2.5-16.3 11.1-18.8 13.7-23.9.2-4.4-3.5-7.4-6.4-9.5a14.3 14.3 0 0 0-7.7-2.2M174 8c-.3 1.5 0 1.1-.1 1.9l-.2 1.7-.4 1.5-.5 1.6-.8 1.5-.5.7-.4.6c-.3.5-.6 1-1 1.3-.3.4-.6.9-1 1.2l-1.3 1c-1.4 1.1-3 1.9-4.3 2.9-.5.3-1 .5-1.3 1-.5.2-.9.6-1.3 1l-1.1 1.2-1 1.3-.9 1.3-.7 1.5-.5 1.5a21 21 0 0 0-.5 1.6l-.1.9-.1.7-.1 1.7v1.1l.3 1.6c0 .6.1 1 .3 1.6l.5 1.5.4 1-14.8-5.8-7.5-2-4-1a120 120 0 0 0-11.8-1.7h-.4a115.5 115.5 0 0 0-31.9 1l-3 .6c-2 .3-3.9.8-5.7 1.2l-3 .8-2.7 1.2-2.2 1-.3.1-1.8 1-.5.1-2 1-1.2.7-.6.3-1.7 1-1.6 1-1.3.9-.1.1-1.3 1-1 .8-.4.3-1 .8c0 .2-.1.2-.2.3l-1.2 1v.2c-.5.3-.9.7-1.2 1.1l-.2.1-1 1c0 .2-.3.3-.4.5l-1 1.1-.4.3-1.4 1.6-.2.2a38 38 0 0 1-7 6 49 49 0 0 1-12.1 6c-2.7.5-5.5 1.6-7.9 1.8l-1.6.2-1.6.4-1.6.6-1.5.7-1.4.9c-.5.3-1 .7-1.3 1.1-.5.3-1 .8-1.3 1.2L10 76.4l-1 1.4-.9 1.5-.7 1.7-.6 1.7-.3 1.5v.2L6 86.2v2.1a6.9 6.9 0 0 0 .7 2.4l.7 1.2.8 1.2a17 17 0 0 0 2.4 2c1.5 1.4 1.9 1.9 3.9 2.9l1 .5h.2v.4a13.3 13.3 0 0 0 1 3.1l.5 1.2.1.3a28 28 0 0 0 1.8 2.8l1 1.2 1.3 1.1h.1a14.2 14.2 0 0 0 5.4 3l.3.1.8.2c-.2 3.5-.3 6.8.3 8 .5 1.2 3.4-2.7 6.2-7.2-.4 4.4-.6 9.7 0 11.2.7 1.6 4.6-3.4 8-9a74.7 74.7 0 0 1 92 65.8c-.8-7-9.4-10.8-13.4-9.9-2 4.8-5.2 11-10.5 14.8.4-4.3.2-8.7-.7-13-1.4 6-4.2 11.5-8 16.3a18 18 0 0 1-15.5-7l-.5-.8-.5-1.4-.4-1.3V176c0-.5.1-1 .3-1.4 0-.4.2-.9.4-1.3l.8-1.4c1-3 1-5.6-1-7l-1.1-.7-.9-.3-.5-.2-1.4-.3a5 5 0 0 0-1.3-.2l-1.4-.1h-1l-1.4.2-1.4.3-1.3.4-1.3.6-1.3.7c-15 9.8-6 32.8 4.2 39.5-3.8.7-7.8 1.5-8.9 2.3l-.1.2a60.9 60.9 0 0 0 19.2 7.4 61.5 61.5 0 0 0 72.6-51.3l.4 1.7c.2 1.2.5 2.4.6 3.7l.2 1.7v.3l.2 1.6.1 2.2v5.4l-.1.8v1.5c-.2.2-.2.4-.2.5 0 .6 0 1-.2 1.5v.6c0 .7-.2 1.2-.3 1.9v.1l-.4 1.8v.2c0 .6-.2 1.2-.4 1.8v.2l-.5 1.8v.2l-.5 1.8v.1l-.6 2-.7 1.8-.8 1.9-.7 1.9c-.4.5-.6 1.2-1 1.8l-.1.4s0 .2-.2.2a61.2 61.2 0 0 1-18.1 21.7l-1.6 1.1c0 .2-.3.2-.4.4l-1.4 1 .2.3 2.7-.4h.1a138 138 0 0 0 6.5-1.2l.9-.2 1.3-.3 1.2-.3c6.4-1.5 12.7-3.7 18.7-6.2-10.2 14-24 25.3-40.1 32.8a103.2 103.2 0 0 0 83.1-52.6c-2.7 15-8.6 29.1-17.4 41.5a101.7 101.7 0 0 0 44.5-69.2c2.2 10.2 2.8 20.7 1.8 31.1 46.7-65 4-132.5-14-150.3l-.1-.3v.1l-.1-.1-.2 2.3a87 87 0 0 1-.6 4.3l-1.1 4.3a54 54 0 0 1-3.5 8 44 44 0 0 1-9.9 12L204 86a36 36 0 0 1-7.4 4.7l-4 1.8a45.5 45.5 0 0 1-8.6 2.3l-4.4.6a49.7 49.7 0 0 1-11.9-.8l-4.3-1.1a48 48 0 0 0 20.7-6.8l3.6-2.6 3.3-2.9 3-3.2c1-1.1 1.9-2.3 2.7-3.5.2-.1.3-.4.4-.6l1.9-3.1a44.5 44.5 0 0 0 3.5-8c.4-1.4.8-2.9 1-4.3.3-1.5.6-2.9.7-4.3l.3-4.4-.1-3.1-.6-4.3c-.2-1.5-.5-3-1-4.4-.4-1.3-.8-2.7-1.4-4.1-.5-1.4-1.1-2.7-1.8-4l-2.2-3.8a71 71 0 0 0-5.5-6.9 40.4 40.4 0 0 0-12-8.6C178 9.3 176 8.6 174 8"
    }));

const Netflix = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: "48.34%",
        cy: "49.419%",
        r: "70.438%",
        fx: "48.34%",
        fy: "49.419%",
        gradientTransform: "matrix(1 0 0 .55088 0 .222)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0
    }))), /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h255.904v255.904H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B1060F",
        stroke: "#000",
        strokeWidth: 2.956,
        d: "m141.676 41.275-.067 38.361-.068 38.361-3.156-8.905-.006-.017-4.078 85.402c4.01 11.324 6.158 17.369 6.182 17.393.031.032 2.317.17 5.078.307 8.366.415 18.734 1.304 26.599 2.282 1.821.226 3.388.342 3.483.257.094-.084.145-39.143.114-86.797l-.058-86.644zm-61.538-.115v86.732c0 47.703.047 86.779.104 86.836s3.011-.222 6.565-.62c3.553-.398 8.465-.893 10.914-1.1 3.756-.317 14.97-1.038 16.268-1.046.378-.002.402-1.95.457-36.735l.058-36.734 2.713 7.677.96 2.713 4.077-85.381-1.401-3.96a32066 32066 0 0 0-6.283-17.754l-.225-.628z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M80.138 41.16v48.685l34.296 90.976c.004-2.085.008-3.211.012-5.594l.058-36.734 2.713 7.677c15.104 42.738 23.218 65.652 23.266 65.7.031.032 2.317.17 5.078.307 8.366.415 18.734 1.304 26.599 2.282 1.821.226 3.388.342 3.483.257.064-.058.107-19.21.118-46.227l-34.136-98.14-.016 9.287-.068 38.361-3.156-8.905c-3.084-8.701-5.143-14.52-17.532-49.55a32066 32066 0 0 0-6.283-17.754l-.225-.628z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E50914",
        d: "m80.139 41.16 34.365 97.377v-.044l2.713 7.677c15.104 42.738 23.218 65.652 23.266 65.7.031.032 2.317.17 5.078.307 8.366.415 18.734 1.304 26.599 2.282 1.812.225 3.37.34 3.48.258l-34.1-96.737v.017l-3.156-8.905c-3.084-8.701-5.143-14.52-17.532-49.55-3.332-9.42-6.159-17.408-6.283-17.754l-.225-.628z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B1060F",
        stroke: "#000",
        strokeWidth: 2.956,
        d: "m141.676 41.275-.067 38.361-.068 38.361-3.156-8.905-.006-.017-4.078 85.402c4.01 11.324 6.158 17.369 6.182 17.393.031.032 2.317.17 5.078.307 8.366.415 18.734 1.304 26.599 2.282 1.821.226 3.388.342 3.483.257.094-.084.145-39.143.114-86.797l-.058-86.644zm-61.538-.115v86.732c0 47.703.047 86.779.104 86.836s3.011-.222 6.565-.62c3.553-.398 8.465-.893 10.914-1.1 3.756-.317 14.97-1.038 16.268-1.046.378-.002.402-1.95.457-36.735l.058-36.734 2.713 7.677.96 2.713 4.077-85.381-1.401-3.96a32066 32066 0 0 0-6.283-17.754l-.225-.628z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M80.138 41.16v48.685l34.296 90.976c.004-2.085.008-3.211.012-5.594l.058-36.734 2.713 7.677c15.104 42.738 23.218 65.652 23.266 65.7.031.032 2.317.17 5.078.307 8.366.415 18.734 1.304 26.599 2.282 1.821.226 3.388.342 3.483.257.064-.058.107-19.21.118-46.227l-34.136-98.14-.016 9.287-.068 38.361-3.156-8.905c-3.084-8.701-5.143-14.52-17.532-49.55a32066 32066 0 0 0-6.283-17.754l-.225-.628z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E50914",
        d: "m80.139 41.16 34.365 97.377v-.044l2.713 7.677c15.104 42.738 23.218 65.652 23.266 65.7.031.032 2.317.17 5.078.307 8.366.415 18.734 1.304 26.599 2.282 1.812.225 3.37.34 3.48.258l-34.1-96.737v.017l-3.156-8.905c-3.084-8.701-5.143-14.52-17.532-49.55-3.332-9.42-6.159-17.408-6.283-17.754l-.225-.628z"
    }));

const Netlify = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 226",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#05BDBA",
        d: "M69.181 188.087h-2.417l-12.065-12.065v-2.417l18.444-18.444h12.778l1.704 1.704v12.778zM54.699 51.628v-2.417l12.065-12.065h2.417L87.625 55.59v12.778l-1.704 1.704H73.143z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#014847",
        d: "M160.906 149.198h-17.552l-1.466-1.466v-41.089c0-7.31-2.873-12.976-11.689-13.174-4.537-.119-9.727 0-15.274.218l-.833.852v53.173l-1.466 1.466H95.074l-1.466-1.466v-70.19l1.466-1.467h39.503c15.354 0 27.795 12.441 27.795 27.795v43.882z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#05BDBA",
        d: "M71.677 122.889H1.466L0 121.423V103.83l1.466-1.466h70.211l1.466 1.466v17.593zm182.857 0h-70.211l-1.466-1.466V103.83l1.466-1.466h70.211L256 103.83v17.593zM117.876 54.124V1.466L119.342 0h17.593l1.466 1.466v52.658l-1.466 1.466h-17.593zm0 169.663v-52.658l1.466-1.466h17.593l1.466 1.466v52.658l-1.466 1.465h-17.593z"
    }));

const Nextjs = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 180 180",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 180,
        height: 180,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 90,
        cy: 90,
        r: 90,
        fill: "#000"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 90,
        cy: 90,
        r: 87,
        fill: "#000",
        stroke: "#fff",
        strokeWidth: 6
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M149.508 157.52 69.142 54H54v71.97h12.114V69.384l73.885 95.461a90 90 0 0 0 9.509-7.325"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M115 54h12v72h-12z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 109,
        x2: 144.5,
        y1: 116.5,
        y2: 160.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 121,
        x2: 120.799,
        y1: 54,
        y2: 106.875,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    }))));

const NgrokDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 200 92.11",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M69.68 34.89c-2.66-2.92-5.95-4.39-9.86-4.39-2.41 0-4.63.46-6.67 1.39s-3.8 2.19-5.29 3.8c-1.48 1.62-2.65 3.5-3.51 5.68-.86 2.17-1.29 4.52-1.29 7.06 0 2.49.4 4.76 1.19 6.81.8 2.04 1.91 3.79 3.35 5.25q2.16 2.19 5.13 3.42t6.51 1.23c1.07 0 2.06-.08 2.96-.23s1.76-.4 2.58-.74c.82-.35 1.62-.79 2.42-1.32.79-.54 1.62-1.22 2.48-2.03v8.67h-.01v.84H58.75l-8.21 9.24v1.59h30.81V31.41H69.68zm-.03 15.89c-.41.92-.95 1.73-1.61 2.42-.67.69-1.46 1.22-2.38 1.61s-1.9.58-2.93.58c-1.08 0-2.08-.19-3-.58s-1.72-.92-2.39-1.61-1.19-1.5-1.58-2.42-.58-1.93-.58-3c0-1.03.2-2 .61-2.9s.95-1.68 1.65-2.35c.69-.67 1.48-1.2 2.38-1.61s1.87-.61 2.9-.61c.99 0 1.94.19 2.87.58.92.38 1.73.92 2.42 1.61a8.3 8.3 0 0 1 1.65 2.38c.41.9.61 1.89.61 2.97a7.3 7.3 0 0 1-.62 2.93M37.12 35.43c-.62-.73-1.32-1.36-2.07-1.92-.67-.49-1.38-.92-2.15-1.27-.37-.17-.76-.31-1.17-.44-.59-.19-1.23-.32-1.89-.43h-8.32l-5.5 6.27V31.5H4.35v33.08h11.67V42.26h10.96l.91-.02v22.33h11.67V43.88q0-2.64-.51-4.71c-.34-1.37-.98-2.61-1.93-3.74m78.55-4.02h-12.73l-5.06 5.7v-5.7H86.2v33.08h11.7l.01-22.14h8.49l9.27-10.48zm63.06 15.28 15.96-14.72v-.56h-15.38l-12.24 11.93V10.97H155.4v53.51h11.67V51.01l12.83 13.47h15.75v-.63zm-32.45-11.51c-1.78-1.57-3.89-2.79-6.32-3.67s-5.06-1.32-7.9-1.32c-2.88 0-5.54.45-7.96 1.35-2.43.9-4.52 2.14-6.29 3.7a16.9 16.9 0 0 0-4.13 5.55c-.99 2.13-1.48 4.42-1.48 6.87 0 2.71.49 5.17 1.48 7.38s2.35 4.11 4.1 5.7c1.74 1.59 3.81 2.82 6.22 3.68s5.03 1.29 7.87 1.29c2.88 0 5.55-.43 8.03-1.29 2.47-.86 4.59-2.07 6.35-3.65a17.1 17.1 0 0 0 4.16-5.61c1.01-2.17 1.52-4.56 1.52-7.19 0-2.62-.5-5.02-1.48-7.19-1-2.16-2.39-4.03-4.17-5.6m-7.29 15.66c-.41.92-.95 1.73-1.61 2.42-.67.69-1.46 1.22-2.38 1.61-.93.39-1.9.58-2.93.58s-2.01-.19-2.94-.58c-.92-.39-1.72-.92-2.38-1.61-.67-.69-1.2-1.5-1.61-2.42s-.61-1.94-.61-3.06c0-1.03.2-2 .61-2.9s.94-1.69 1.61-2.38 1.46-1.23 2.38-1.61c.93-.39 1.9-.58 2.94-.58 1.03 0 2.01.19 2.93.58.92.38 1.72.92 2.38 1.61.67.69 1.2 1.5 1.61 2.42s.61 1.9.61 2.93c0 1.07-.2 2.07-.61 2.99"
    }));

const NgrokLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 200 92.11",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#10239e",
        d: "M69.68 34.89c-2.66-2.92-5.95-4.39-9.86-4.39-2.41 0-4.63.46-6.67 1.39s-3.8 2.19-5.29 3.8c-1.48 1.62-2.65 3.5-3.51 5.68-.86 2.17-1.29 4.52-1.29 7.06 0 2.49.4 4.76 1.19 6.81.8 2.04 1.91 3.79 3.35 5.25q2.16 2.19 5.13 3.42t6.51 1.23c1.07 0 2.06-.08 2.96-.23s1.76-.4 2.58-.74c.82-.35 1.62-.79 2.42-1.32.79-.54 1.62-1.22 2.48-2.03v8.67h-.01v.84H58.75l-8.21 9.24v1.59h30.81V31.41H69.68zm-.03 15.89c-.41.92-.95 1.73-1.61 2.42-.67.69-1.46 1.22-2.38 1.61s-1.9.58-2.93.58c-1.08 0-2.08-.19-3-.58s-1.72-.92-2.39-1.61-1.19-1.5-1.58-2.42-.58-1.93-.58-3c0-1.03.2-2 .61-2.9s.95-1.68 1.65-2.35c.69-.67 1.48-1.2 2.38-1.61s1.87-.61 2.9-.61c.99 0 1.94.19 2.87.58.92.38 1.73.92 2.42 1.61a8.3 8.3 0 0 1 1.65 2.38c.41.9.61 1.89.61 2.97a7.3 7.3 0 0 1-.62 2.93M37.12 35.43c-.62-.73-1.32-1.36-2.07-1.92-.67-.49-1.38-.92-2.15-1.27-.37-.17-.76-.31-1.17-.44-.59-.19-1.23-.32-1.89-.43h-8.32l-5.5 6.27V31.5H4.35v33.08h11.67V42.26h10.96l.91-.02v22.33h11.67V43.88q0-2.64-.51-4.71c-.34-1.37-.98-2.61-1.93-3.74m78.55-4.02h-12.73l-5.06 5.7v-5.7H86.2v33.08h11.7l.01-22.14h8.49l9.27-10.48zm63.06 15.28 15.96-14.72v-.56h-15.38l-12.24 11.93V10.97H155.4v53.51h11.67V51.01l12.83 13.47h15.75v-.63zm-32.45-11.51c-1.78-1.57-3.89-2.79-6.32-3.67s-5.06-1.32-7.9-1.32c-2.88 0-5.54.45-7.96 1.35-2.43.9-4.52 2.14-6.29 3.7a16.9 16.9 0 0 0-4.13 5.55c-.99 2.13-1.48 4.42-1.48 6.87 0 2.71.49 5.17 1.48 7.38s2.35 4.11 4.1 5.7c1.74 1.59 3.81 2.82 6.22 3.68s5.03 1.29 7.87 1.29c2.88 0 5.55-.43 8.03-1.29 2.47-.86 4.59-2.07 6.35-3.65a17.1 17.1 0 0 0 4.16-5.61c1.01-2.17 1.52-4.56 1.52-7.19 0-2.62-.5-5.02-1.48-7.19-1-2.16-2.39-4.03-4.17-5.6m-7.29 15.66c-.41.92-.95 1.73-1.61 2.42-.67.69-1.46 1.22-2.38 1.61-.93.39-1.9.58-2.93.58s-2.01-.19-2.94-.58c-.92-.39-1.72-.92-2.38-1.61-.67-.69-1.2-1.5-1.61-2.42s-.61-1.94-.61-3.06c0-1.03.2-2 .61-2.9s.94-1.69 1.61-2.38 1.46-1.23 2.38-1.61c.93-.39 1.9-.58 2.94-.58 1.03 0 2.01.19 2.93.58.92.38 1.72.92 2.38 1.61.67.69 1.2 1.5 1.61 2.42s.61 1.9.61 2.93c0 1.07-.2 2.07-.61 2.99"
    }));

const Nodejs = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 256 292",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "68.188%",
        x2: "27.823%",
        y1: "17.487%",
        y2: "89.755%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#41873F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "32.88%",
        stopColor: "#418B3D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "63.52%",
        stopColor: "#419637"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "93.19%",
        stopColor: "#3FA92D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#3FAE2A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "43.277%",
        x2: "159.245%",
        y1: "55.169%",
        y2: "-18.306%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "13.76%",
        stopColor: "#41873F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "40.32%",
        stopColor: "#54A044"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "71.36%",
        stopColor: "#66B848"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "90.81%",
        stopColor: "#6CC04A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "-4.389%",
        x2: "101.499%",
        y1: "49.997%",
        y2: "49.997%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "9.192%",
        stopColor: "#6CC04A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "28.64%",
        stopColor: "#66B848"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "59.68%",
        stopColor: "#54A044"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "86.24%",
        stopColor: "#41873F"
    })), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__b",
        d: "M134.923 1.832c-4.344-2.443-9.502-2.443-13.846 0L6.787 67.801C2.443 70.244 0 74.859 0 79.745v132.208c0 4.887 2.715 9.502 6.787 11.945l114.29 65.968c4.344 2.444 9.502 2.444 13.846 0l114.29-65.968c4.344-2.443 6.787-7.058 6.787-11.945V79.745c0-4.886-2.715-9.501-6.787-11.944z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__e",
        d: "M134.923 1.832c-4.344-2.443-9.502-2.443-13.846 0L6.787 67.801C2.443 70.244 0 74.859 0 79.745v132.208c0 4.887 2.715 9.502 6.787 11.945l114.29 65.968c4.344 2.444 9.502 2.444 13.846 0l114.29-65.968c4.344-2.443 6.787-7.058 6.787-11.945V79.745c0-4.886-2.715-9.501-6.787-11.944z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M134.923 1.832c-4.344-2.443-9.502-2.443-13.846 0L6.787 67.801C2.443 70.244 0 74.859 0 79.745v132.208c0 4.887 2.715 9.502 6.787 11.945l114.29 65.968c4.344 2.444 9.502 2.444 13.846 0l114.29-65.968c4.344-2.443 6.787-7.058 6.787-11.945V79.745c0-4.886-2.715-9.501-6.787-11.944z"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__d",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M249.485 67.8 134.65 1.833c-1.086-.542-2.443-1.085-3.529-1.357L2.443 220.912c1.086 1.357 2.444 2.443 3.8 3.258l114.834 65.968c3.258 1.9 7.059 2.443 10.588 1.357L252.47 70.515c-.815-1.086-1.9-1.9-2.986-2.714Z",
        mask: "url(#prefix__d)"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__g",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M249.756 223.898c3.258-1.9 5.701-5.158 6.787-8.687L130.579.204c-3.258-.543-6.787-.272-9.773 1.628L6.786 67.53l122.979 224.238c1.628-.272 3.529-.815 5.158-1.63l114.833-66.239Z",
        mask: "url(#prefix__g)"
    }));

const Notion = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 268",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M16.092 11.538 164.09.608c18.179-1.56 22.85-.508 34.28 7.801l47.243 33.282C253.406 47.414 256 48.975 256 55.207v182.527c0 11.439-4.155 18.205-18.696 19.24L65.44 267.378c-10.913.517-16.11-1.043-21.825-8.327L8.826 213.814C2.586 205.487 0 199.254 0 191.97V29.726c0-9.352 4.155-17.153 16.092-18.188"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M164.09.608 16.092 11.538C4.155 12.573 0 20.374 0 29.726v162.245c0 7.284 2.585 13.516 8.826 21.843l34.789 45.237c5.715 7.284 10.912 8.844 21.825 8.327l171.864-10.404c14.532-1.035 18.696-7.801 18.696-19.24V55.207c0-5.911-2.336-7.614-9.21-12.66l-1.185-.856L198.37 8.409C186.94.1 182.27-.952 164.09.608M69.327 52.22c-14.033.945-17.216 1.159-25.186-5.323L23.876 30.778c-2.06-2.086-1.026-4.69 4.163-5.207l142.274-10.395c11.947-1.043 18.17 3.12 22.842 6.758l24.401 17.68c1.043.525 3.638 3.637.517 3.637L71.146 52.095zm-16.36 183.954V81.222c0-6.767 2.077-9.887 8.3-10.413L230.02 60.93c5.724-.517 8.31 3.12 8.31 9.879v153.917c0 6.767-1.044 12.49-10.387 13.008l-161.487 9.361c-9.343.517-13.489-2.594-13.489-10.921M212.377 89.53c1.034 4.681 0 9.362-4.681 9.897l-7.783 1.542v114.404c-6.758 3.637-12.981 5.715-18.18 5.715-8.308 0-10.386-2.604-16.609-10.396l-50.898-80.079v77.476l16.1 3.646s0 9.362-12.989 9.362l-35.814 2.077c-1.043-2.086 0-7.284 3.63-8.318l9.351-2.595V109.823l-12.98-1.052c-1.044-4.68 1.55-11.439 8.826-11.965l38.426-2.585 52.958 81.113v-71.76l-13.498-1.552c-1.043-5.733 3.111-9.896 8.3-10.404z"
    }));

const Nuget = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 512 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#004880",
        fillRule: "evenodd",
        d: "M376.624 460.825c-47.024 0-85.149-38.13-85.149-85.157 0-47.008 38.126-85.159 85.149-85.159 47.025 0 85.149 38.151 85.149 85.158 0 47.028-38.125 85.158-85.149 85.158M206.772 265.643c-29.397 0-53.218-23.844-53.218-53.224 0-29.401 23.821-53.223 53.218-53.223s53.219 23.823 53.219 53.223c0 29.38-23.821 53.224-53.219 53.224M380.392 99.5H238.277c-72.419 0-131.172 58.759-131.172 131.206v142.108c0 72.469 58.753 131.186 131.172 131.186h142.115c72.462 0 131.172-58.717 131.172-131.186V230.707c0-72.448-58.71-131.207-131.172-131.207M85.15 49.579c0 23.524-19.074 42.578-42.575 42.578C19.052 92.157 0 73.103 0 49.58 0 26.074 19.051 7 42.575 7c23.5 0 42.574 19.074 42.574 42.579Z"
    }));

const NuqsDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M64 0a64 64 0 0 1 64 64 64 64 0 0 1-64 64A64 64 0 0 1 0 64 64 64 0 0 1 64 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m35.524 25.45.42 9.36-1.14-.42q.66-5.1 3.42-7.38t7.02-2.28q5.16 0 8.04 3.24 2.94 3.24 2.94 8.82v20.46h-9.06V39.79q0-2.76-.48-4.44-.42-1.68-1.5-2.52-1.08-.9-2.88-.9-2.88 0-4.38 1.98-1.44 1.98-1.44 5.88v17.46h-9.12v-31.8zm57.831 31.8-.36-9.18 1.14.42q-.66 4.98-3.42 7.26-2.76 2.22-6.9 2.22-5.1 0-7.98-3.24t-2.88-8.82V25.45h9.12v17.46q0 2.76.42 4.44t1.44 2.58q1.08.84 2.88.84 2.76 0 4.2-1.98 1.5-1.98 1.5-5.88V25.45h9.06v31.8zm-36.568 13.2v40.8h-9.12v-15.6l.78.48q-.78 2.22-2.22 3.78-1.44 1.5-3.42 2.28t-4.38.78q-4.32 0-7.44-2.16-3.06-2.22-4.62-5.94-1.5-3.78-1.5-8.52t1.5-8.46q1.56-3.78 4.62-5.94 3.12-2.22 7.44-2.22 3.72 0 6.3 1.74t3.78 5.04l-.66.54.24-6.6zm-9.3 20.82q.78-2.22.78-4.92 0-2.64-.78-4.8-.78-2.22-2.4-3.54-1.56-1.38-3.84-1.38-3.42 0-5.28 2.82-1.8 2.76-1.8 6.9 0 4.2 1.8 6.96 1.86 2.76 5.28 2.76 2.28 0 3.84-1.32 1.62-1.32 2.4-3.48m46.245-10.5q-.36-2.16-2.04-3.42-1.62-1.32-3.72-1.32t-3.42 1.02-1.26 2.7q.06 1.62 1.62 2.52 1.56.84 4.2 1.32 4.92.78 7.92 1.98 3 1.14 4.5 3.06 1.56 1.92 1.56 4.92 0 3.12-1.86 5.22-1.8 2.1-4.98 3.18-3.18 1.02-7.32 1.02-4.62 0-8.1-1.26-3.42-1.32-5.4-3.72-1.98-2.46-2.22-5.82l9.12-.48q.3 1.56 1.08 2.7.84 1.08 2.16 1.68 1.38.54 3.18.54 2.04 0 3.54-.78 1.5-.84 1.5-2.46-.06-1.08-.72-1.8-.6-.72-1.62-1.08-.96-.36-2.64-.72-.48-.06-1.2-.24-4.86-.96-7.74-2.04-2.82-1.14-4.38-2.94-1.56-1.86-1.56-4.74 0-3.12 1.68-5.4 1.74-2.28 4.98-3.48 3.24-1.26 7.74-1.26 6 0 9.84 2.88 3.84 2.82 4.68 7.86z"
    }));

const NuqsLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M64 0a64 64 0 0 1 64 64 64 64 0 0 1-64 64A64 64 0 0 1 0 64 64 64 0 0 1 64 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m35.524 25.45.42 9.36-1.14-.42q.66-5.1 3.42-7.38t7.02-2.28q5.16 0 8.04 3.24 2.94 3.24 2.94 8.82v20.46h-9.06V39.79q0-2.76-.48-4.44-.42-1.68-1.5-2.52-1.08-.9-2.88-.9-2.88 0-4.38 1.98-1.44 1.98-1.44 5.88v17.46h-9.12v-31.8zm57.831 31.8-.36-9.18 1.14.42q-.66 4.98-3.42 7.26-2.76 2.22-6.9 2.22-5.1 0-7.98-3.24t-2.88-8.82V25.45h9.12v17.46q0 2.76.42 4.44t1.44 2.58q1.08.84 2.88.84 2.76 0 4.2-1.98 1.5-1.98 1.5-5.88V25.45h9.06v31.8zm-36.568 13.2v40.8h-9.12v-15.6l.78.48q-.78 2.22-2.22 3.78-1.44 1.5-3.42 2.28t-4.38.78q-4.32 0-7.44-2.16-3.06-2.22-4.62-5.94-1.5-3.78-1.5-8.52t1.5-8.46q1.56-3.78 4.62-5.94 3.12-2.22 7.44-2.22 3.72 0 6.3 1.74t3.78 5.04l-.66.54.24-6.6zm-9.3 20.82q.78-2.22.78-4.92 0-2.64-.78-4.8-.78-2.22-2.4-3.54-1.56-1.38-3.84-1.38-3.42 0-5.28 2.82-1.8 2.76-1.8 6.9 0 4.2 1.8 6.96 1.86 2.76 5.28 2.76 2.28 0 3.84-1.32 1.62-1.32 2.4-3.48m46.244-10.5q-.36-2.16-2.04-3.42-1.62-1.32-3.72-1.32t-3.42 1.02-1.26 2.7q.06 1.62 1.62 2.52 1.56.84 4.2 1.32 4.92.78 7.92 1.98 3 1.14 4.5 3.06 1.56 1.92 1.56 4.92 0 3.12-1.86 5.22-1.8 2.1-4.98 3.18-3.18 1.02-7.32 1.02-4.62 0-8.1-1.26-3.42-1.32-5.4-3.72-1.98-2.46-2.22-5.82l9.12-.48q.3 1.56 1.08 2.7.84 1.08 2.16 1.68 1.38.54 3.18.54 2.04 0 3.54-.78 1.5-.84 1.5-2.46-.06-1.08-.72-1.8-.6-.72-1.62-1.08-.96-.36-2.64-.72-.48-.06-1.2-.24-4.86-.96-7.74-2.04-2.82-1.14-4.38-2.94-1.56-1.86-1.56-4.74 0-3.12 1.68-5.4 1.74-2.28 4.98-3.48 3.24-1.26 7.74-1.26 6 0 9.84 2.88 3.84 2.82 4.68 7.86z"
    }));

const Nuxt = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 168",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00DC82",
        d: "M143.618 167.029h95.166c3.023 0 5.992-.771 8.61-2.237a16.96 16.96 0 0 0 6.302-6.115 16.3 16.3 0 0 0 2.304-8.352c0-2.932-.799-5.811-2.312-8.35L189.778 34.6a16.97 16.97 0 0 0-6.301-6.113 17.6 17.6 0 0 0-8.608-2.238c-3.023 0-5.991.772-8.609 2.238a16.96 16.96 0 0 0-6.3 6.113l-16.342 27.473-31.95-53.724a17 17 0 0 0-6.304-6.112A17.64 17.64 0 0 0 96.754 0c-3.022 0-5.992.772-8.61 2.237a17 17 0 0 0-6.303 6.112L2.31 141.975a16.3 16.3 0 0 0-2.31 8.35c0 2.932.793 5.813 2.304 8.352a16.96 16.96 0 0 0 6.302 6.115 17.6 17.6 0 0 0 8.61 2.237h59.737c23.669 0 41.123-10.084 53.134-29.758l29.159-48.983 15.618-26.215 46.874 78.742h-62.492zm-67.64-26.24-41.688-.01L96.782 35.796l31.181 52.492-20.877 35.084c-7.976 12.765-17.037 17.416-31.107 17.416Z"
    }));

const NxDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 150 150",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M74.919 88.363 55.344 119.13 22.888 66.463l-.075 55.137H0V28.4h23.069l32.793 55.206.032-24.987zm3.756-36.007c.15-.3 0-23.65.05-23.956H55.913c.012.369-.032 23.6-.02 23.956zm35.213 25.838a12.88 12.88 0 0 0-12.307 8.35 12.27 12.27 0 0 1 14.644-4.619c2.475 1.006 5.731 2.638 8.313 1.769a13.1 13.1 0 0 0-4.661-4.037 13.1 13.1 0 0 0-5.989-1.463m21.187 6.631c-2.344-.813-5-1.731-6.931-4.256-.375-.5-.725-1.063-1.1-1.657a13.4 13.4 0 0 0-3.331-4.012c-1.838-1.35-4.25-2.013-7.375-2.013a15.51 15.51 0 0 0-14.338 9.6 14.53 14.53 0 0 1 25.013 2.425A4.684 4.684 0 0 0 132.238 87c3.081-.656 2.875 2.25 7.518 3.237v-.83c-.018-2.788-1.531-3.438-4.681-4.582m12.65 7.912a4.52 4.52 0 0 0 2.169-3.987c-.063-18.481-15.063-34.294-33.563-34.294A33.5 33.5 0 0 0 100.4 58.47a33.5 33.5 0 0 0-12.112 11.1c-.063-.163-9.513-14.938-9.613-15.113H55.894L77.537 88.35 56.42 121.6h22.125l9.625-14.787 9.8 14.787H120.1l-20.062-31.575a4.4 4.4 0 0 1-.525-2 16.8 16.8 0 0 1 1.277-6.436 16.8 16.8 0 0 1 9.1-9.102 16.8 16.8 0 0 1 6.435-1.28h.006c9.3 0 10.85 5.562 12.857 8.174 3.962 5.163 11.874 2.9 11.874 9.631a4.43 4.43 0 0 0 2.262 3.776 4.42 4.42 0 0 0 4.401-.05m2.188.832c-1.082 2.325-3.5 2.112-4.719 3.993-1.1 1.694.712 2.576.712 2.576s2.106.975 3.363-1.944c.65-1.444.875-3.05.644-4.625"
    }));

const NxLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 150 150",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M74.919 88.363 55.344 119.13 22.888 66.463l-.075 55.137H0V28.4h23.069l32.793 55.206.032-24.987zm3.756-36.007c.15-.3 0-23.65.05-23.956H55.913c.012.369-.032 23.6-.02 23.956zm35.213 25.838a12.88 12.88 0 0 0-12.307 8.35 12.27 12.27 0 0 1 14.644-4.619c2.475 1.006 5.731 2.638 8.313 1.769a13.1 13.1 0 0 0-4.661-4.037 13.1 13.1 0 0 0-5.989-1.463m21.187 6.631c-2.344-.813-5-1.731-6.931-4.256-.375-.5-.725-1.063-1.1-1.657a13.4 13.4 0 0 0-3.331-4.012c-1.838-1.35-4.25-2.013-7.375-2.013a15.51 15.51 0 0 0-14.338 9.6 14.53 14.53 0 0 1 25.013 2.425A4.684 4.684 0 0 0 132.238 87c3.081-.656 2.875 2.25 7.518 3.237v-.83c-.018-2.788-1.531-3.438-4.681-4.582m12.65 7.912a4.52 4.52 0 0 0 2.169-3.987c-.063-18.481-15.063-34.294-33.563-34.294A33.5 33.5 0 0 0 100.4 58.47a33.5 33.5 0 0 0-12.112 11.1c-.063-.163-9.513-14.938-9.613-15.113H55.894L77.537 88.35 56.42 121.6h22.125l9.625-14.787 9.8 14.787H120.1l-20.062-31.575a4.4 4.4 0 0 1-.525-2 16.8 16.8 0 0 1 1.277-6.436 16.8 16.8 0 0 1 9.1-9.102 16.8 16.8 0 0 1 6.435-1.28h.006c9.3 0 10.85 5.562 12.857 8.174 3.962 5.163 11.874 2.9 11.874 9.631a4.43 4.43 0 0 0 2.262 3.776 4.42 4.42 0 0 0 4.401-.05m2.188.832c-1.082 2.325-3.5 2.112-4.719 3.993-1.1 1.694.712 2.576.712 2.576s2.106.975 3.363-1.944c.65-1.444.875-3.05.644-4.625"
    }));

const OBS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 75 75",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 37.5,
        cy: 37.5,
        r: 35.8,
        fill: "#302e31",
        stroke: "#fff",
        strokeWidth: 3.47
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#c4c2c4",
        d: "M19.3 18.7c1.1-5.31 4.7-10.1 9.54-12.5-.842.855-1.86 1.51-2.64 2.44-3.19 3.44-4.63 8.42-3.75 13 1.11 6.99 7.68 12.7 14.8 12.6 5.52.247 10.9-2.93 13.6-7.72 5.78.196 11.4 3.18 14.7 7.97 1.69 2.5 3.01 5.43 3.1 8.48-1.07-4.05-3.76-7.65-7.43-9.68-3.55-2-7.91-2.51-11.8-1.33-4.88 1.4-8.91 5.39-10.3 10.3-1.18 3.91-.675 8.22 1.18 11.8-2.58 4.47-7.24 7.66-12.3 8.62-3.89.816-7.98.186-11.6-1.45 3.24.945 6.76 1.11 9.98-.035 4.32-1.43 7.89-4.9 9.46-9.18 1.74-4.66 1.08-10.2-1.85-14.2-2.19-3.15-5.64-5.37-9.39-6.16-1.19-.212-2.39-.308-3.59-.418-1.91-3.85-2.61-8.32-1.65-12.5z"
    }));

const Obsidian = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 332",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: "72.819%",
        cy: "96.934%",
        r: "163.793%",
        fx: "72.819%",
        fy: "96.934%",
        gradientTransform: "rotate(-104 11141.322 0)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.4
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0.1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: "52.917%",
        cy: "90.632%",
        r: "190.361%",
        fx: "52.917%",
        fy: "90.632%",
        gradientTransform: "rotate(-82 10746.75 0)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.6
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__c",
        cx: "31.174%",
        cy: "97.138%",
        r: "178.714%",
        fx: "31.174%",
        fy: "97.138%",
        gradientTransform: "rotate(-77 10724.606 0)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.8
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.4
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: "71.813%",
        cy: "99.994%",
        r: "92.086%",
        fx: "71.813%",
        fy: "99.994%",
        gradientTransform: "translate(0 22251839.658)skewY(-90)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.3
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0.3
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__e",
        cx: "117.013%",
        cy: "34.769%",
        r: "328.729%",
        fx: "117.013%",
        fy: "34.769%",
        gradientTransform: "rotate(102 -1004.443 0)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.2
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__f",
        cx: "-9.431%",
        cy: "8.712%",
        r: "153.492%",
        fx: "-9.431%",
        fy: "8.712%",
        gradientTransform: "rotate(45 1674.397 0)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.2
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.4
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__g",
        cx: "103.902%",
        cy: "-22.172%",
        r: "394.771%",
        fx: "103.902%",
        fy: "-22.172%",
        gradientTransform: "rotate(80 3757.522 0)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.1
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.3
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__h",
        cx: "99.348%",
        cy: "89.193%",
        r: "203.824%",
        fx: "99.348%",
        fy: "89.193%",
        gradientTransform: "translate(0 -38783246.548)skewY(-90)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.2
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "50%",
        stopColor: "#FFF",
        stopOpacity: 0.2
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFF",
        stopOpacity: 0.3
    }))), /*#__PURE__*/ React.createElement("path", {
        fillOpacity: 0.3,
        d: "M209.056 308.305c-2.043 14.93-16.738 26.638-31.432 22.552-20.823-5.658-44.946-14.616-66.634-16.266l-33.317-2.515a22 22 0 0 1-14.144-6.522L6.167 246.778a21.77 21.77 0 0 1-4.244-24.124s35.36-77.478 36.775-81.485c1.257-4.008 6.13-39.211 8.958-58.07a22 22 0 0 1 7.072-12.965L122.462 9.47a22 22 0 0 1 31.903 2.672l57.048 71.978a23.18 23.18 0 0 1 4.872 14.38c0 13.594 1.179 41.646 8.8 59.72a236.8 236.8 0 0 0 27.974 45.732 11 11 0 0 1 .786 12.258c-4.95 8.408-14.851 24.595-28.76 45.26a111.7 111.7 0 0 0-16.108 46.834h.079Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#6C31E3",
        d: "M209.606 305.79c-2.043 15.009-16.737 26.717-31.432 22.71-20.744-5.737-44.79-14.695-66.555-16.345L78.38 309.64a21.92 21.92 0 0 1-14.144-6.6L6.874 244.106a21.92 21.92 0 0 1-4.243-24.36s35.438-77.792 36.774-81.878c1.336-4.007 6.13-39.289 8.958-58.305a22 22 0 0 1 7.072-13.044L123.17 5.621a22 22 0 0 1 31.902 2.75l56.97 72.292a23.34 23.34 0 0 1 4.871 14.38c0 13.673 1.18 41.804 8.723 59.955a238 238 0 0 0 27.974 45.969 11 11 0 0 1 .864 12.336c-5.03 8.487-14.851 24.674-28.838 45.497a112.6 112.6 0 0 0-16.03 46.99"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M70.365 307.44c26.638-53.983 25.93-92.722 14.537-120.225-10.372-25.459-29.781-41.489-45.025-51.468a19.2 19.2 0 0 1-1.415 4.243L2.631 219.747a21.92 21.92 0 0 0 4.321 24.36l57.284 58.933a23.8 23.8 0 0 0 6.129 4.4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M142.814 197.902a86 86 0 0 1 21.06 4.793c21.844 8.172 41.724 26.56 58.147 61.999 1.179-2.043 2.357-4.008 3.615-5.894a960 960 0 0 0 28.838-45.497 11 11 0 0 0-.786-12.336 238 238 0 0 1-28.052-45.969c-7.544-18.073-8.644-46.282-8.723-59.955 0-5.186-1.65-10.294-4.871-14.38l-56.97-72.292-.943-1.178c4.165 13.75 3.93 24.752 1.336 34.731-2.357 9.272-6.757 17.68-11.394 26.56-1.571 2.986-3.143 6.05-4.636 9.193a110 110 0 0 0-12.415 45.576c-.786 19.016 3.064 42.825 15.716 74.65h.078Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M142.736 197.902c-12.652-31.824-16.502-55.633-15.716-74.65.786-18.858 6.286-33.002 12.415-45.575l4.715-9.193c4.558-8.88 8.88-17.288 11.315-26.56a61.7 61.7 0 0 0-1.336-34.731c-8.136-8.94-21.96-9.642-30.96-1.572L55.436 66.519a22 22 0 0 0-7.072 13.044l-8.25 54.69c0 .55-.158 1.022-.236 1.572 15.244 9.901 34.574 25.931 45.025 51.312 2.043 5.029 3.772 10.294 5.029 16.03a157.2 157.2 0 0 1 52.805-5.343v.078Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M178.253 328.5c14.616 4.007 29.31-7.701 31.353-22.789a120.2 120.2 0 0 1 12.494-41.017c-16.502-35.44-36.382-53.827-58.148-61.999-23.18-8.643-48.404-5.736-74.021.472 5.736 26.01 2.357 60.034-19.487 104.273 2.436 1.257 5.186 1.965 7.936 2.2l34.496 2.593c18.701 1.336 46.597 11.001 65.377 16.266Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M127.177 122.074c-.864 18.859 1.493 40.39 14.144 72.135l-3.929-.393c-11.394-33.081-13.908-50.054-13.044-69.149.786-19.094 6.994-33.789 13.123-46.361 1.571-3.143 5.186-9.037 6.758-12.023 4.557-8.879 7.622-13.515 10.215-21.609 3.772-11.315 2.986-16.658 2.514-22.001 2.908 19.251-8.172 35.988-16.501 53.04a113.9 113.9 0 0 0-13.358 46.361z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M88.674 188.551c1.571 3.458 2.907 6.287 3.85 10.608l-3.379.786c-1.336-5.029-2.357-8.643-4.322-12.965-11.472-26.953-29.86-40.861-44.79-51.076 18.074 9.744 36.697 25.066 48.64 52.647Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M92.681 202.617c6.286 29.467-.786 66.948-21.609 103.409 17.445-36.146 25.931-70.8 18.859-102.938l2.75-.55z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M164.659 199.867c34.181 12.808 47.383 40.86 57.205 64.355-12.18-24.516-29.074-51.626-58.462-61.684-22.317-7.7-41.175-6.758-73.471.55l-.707-3.143c34.26-7.858 52.176-8.8 75.435 0z"
    }));

const OllamaDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 646 854",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M140.629.24c-7.969 1.287-17.532 5.456-24.275 10.605-20.413 15.51-36.229 48.428-42.91 89.438-2.514 15.509-4.23 37.026-4.23 53.455 0 19.371 2.268 44.136 5.517 61.239.736 3.801 1.103 7.173.797 7.418-.245.245-3.25 2.697-6.62 5.394-11.525 9.195-24.705 23.356-33.778 36.291-17.41 24.704-28.688 52.78-33.409 83.185-1.839 12.015-2.33 36.29-.858 48.305 3.25 27.708 11.586 51.125 25.87 72.581l4.658 6.927-1.349 2.268c-9.563 16.061-17.716 39.294-21.516 61.607-3.004 17.655-3.372 22.375-3.372 46.037 0 23.847.307 28.567 3.127 45.057 3.371 19.739 10.237 40.642 17.9 54.558 2.513 4.536 8.643 13.976 9.378 14.467.246.122-.49 2.39-1.655 5.026-8.827 19.31-16.367 44.995-19.493 66.635-2.207 14.834-2.514 19.616-2.514 35.248 0 19.922 1.104 29.608 5.272 45.485l.613 2.329h52.535l-1.716-3.249c-10.605-19.616-11.586-56.029-2.452-92.38 4.168-16.797 8.888-29.118 17.716-46.099l5.272-10.298v-6.314c0-5.885-.123-6.559-2.023-10.421-1.472-2.943-3.433-5.456-6.927-8.889-5.947-5.762-10.238-11.831-13.67-19.31-15.08-32.735-18.023-81.346-7.418-122.786 4.414-17.287 11.709-32.673 19.371-41.071 5.21-5.763 7.908-12.199 7.908-18.881 0-6.927-2.452-12.628-7.97-18.574-15.815-16.919-25.562-37.517-29.056-61.485-4.965-34.145 4.046-71.355 24.52-100.84 20.046-28.935 48.183-47.509 79.631-52.474 7.049-1.165 20.229-.981 27.585.368 8.031 1.41 13.057.98 18.207-1.472 6.375-3.003 9.563-6.743 13.302-15.325 3.31-7.662 5.885-11.831 12.812-20.474 8.337-10.36 16.367-17.41 29.24-25.931 14.713-9.624 31.448-16.612 48.122-19.984 6.068-1.226 8.888-1.41 20.229-1.41s14.161.184 20.229 1.41c24.459 4.966 48.735 17.594 68.106 35.493 4.168 3.862 14.16 16.245 17.348 21.395 1.226 2.022 3.372 6.314 4.72 9.501 3.739 8.582 6.927 12.322 13.302 15.325 4.966 2.391 10.176 2.882 17.9 1.594 12.199-2.084 21.578-1.9 33.532.552 40.704 8.214 76.136 41.746 91.829 86.68 13.67 39.416 9.808 80.672-10.544 112.18-3.433 5.334-6.866 9.625-11.831 14.897-10.728 11.463-10.728 25.685-.061 37.455 17.532 19.187 28.505 66.389 25.194 108.012-2.206 27.463-9.256 52.045-18.942 65.96-1.716 2.452-5.271 6.62-7.969 9.195-3.494 3.433-5.455 5.946-6.927 8.889-1.9 3.862-2.023 4.536-2.023 10.421v6.314l5.272 10.298c8.828 16.981 13.548 29.302 17.716 46.099 9.012 35.861 8.215 71.538-2.084 91.829-.858 1.716-1.594 3.31-1.594 3.494s11.709.306 26.053.306h25.992l.674-2.636c.368-1.409.981-3.555 1.287-4.781.675-2.697 2.023-10.666 3.127-18.329 1.042-7.724 1.042-36.168 0-44.75-3.923-31.141-10.483-55.845-21.21-79.201-1.165-2.636-1.901-4.904-1.656-5.026.307-.184 2.023-2.636 3.862-5.395 13.364-20.229 21.578-45.669 25.747-79.262 1.103-9.257 1.103-49.041 0-57.93-2.943-22.926-6.498-38.497-12.383-54.251-2.452-6.559-8.95-20.413-11.708-24.888l-1.349-2.268 4.659-6.927c14.283-21.456 22.62-44.873 25.869-72.581 1.471-12.015.981-36.29-.858-48.305-4.782-30.467-16-58.42-33.409-83.185-9.073-12.935-22.253-27.096-33.777-36.291-3.372-2.697-6.376-5.149-6.621-5.394-.306-.245.062-3.617.797-7.418 7.418-38.681 7.172-86.924-.613-124.625-6.743-32.857-19.003-58.971-34.819-74.051C523.209 4.286 510.336-.864 494.888.117c-35.432 2.085-63.998 42.85-75.278 107.093-1.839 10.36-3.432 22.498-3.432 25.808 0 1.287-.246 2.329-.552 2.329s-2.697-1.226-5.272-2.758c-27.34-16.184-57.746-24.827-87.354-24.827s-60.014 8.643-87.354 24.827c-2.575 1.532-4.965 2.758-5.272 2.758-.306 0-.552-1.042-.552-2.329 0-3.433-1.655-15.938-3.432-25.808-10.238-57.684-33.716-95.875-64.918-105.499C157.181.424 144.982-.434 140.629.24m10.422 49.899c8.827 6.988 18.635 26.972 24.275 49.347 1.042 4.046 2.145 8.705 2.452 10.421.245 1.656.919 5.395 1.471 8.276 2.391 12.996 3.494 27.034 3.617 44.137l.061 16.858-4.23 6.252-4.229 6.314h-9.87c-11.524 0-22.988 1.472-33.961 4.414-3.923.981-7.724 1.962-8.459 2.146-1.165.245-1.349-.123-2.023-5.15-3.617-27.279-3.433-57.5.552-82.634 4.413-28.014 14.712-53.393 24.765-60.871 2.391-1.778 2.82-1.717 5.579.49m349.538-.43c6.069 4.476 12.751 16.368 17.716 31.57 9.992 30.406 12.812 72.152 7.54 111.875-.674 5.027-.858 5.395-2.023 5.15-.735-.184-4.536-1.165-8.459-2.146-10.973-2.942-22.437-4.414-33.961-4.414h-9.87l-4.229-6.314-4.23-6.252.061-16.858c.123-23.785 2.33-42.359 7.601-63.018 5.579-22.19 15.448-42.175 24.214-49.163 2.759-2.207 3.188-2.268 5.64-.43"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M313.498 358.237c-13.303 1.288-16.919 1.778-23.295 3.066-10.36 2.145-24.214 6.927-33.838 11.647-33.47 16.367-56.519 43.646-63.569 75.216-1.41 6.253-1.594 8.337-1.594 18.881 0 10.421.184 12.689 1.533 18.635 9.379 41.256 47.385 71.723 96.549 77.301 10.666 1.165 56.765 1.165 67.431 0 39.478-4.475 73.439-25.869 88.703-55.907 4.045-8.03 6.007-13.241 7.846-21.394 1.349-5.946 1.533-8.214 1.533-18.635 0-10.544-.184-12.628-1.594-18.881-10.238-45.853-54.742-81.959-109.3-88.825-7.111-.858-25.746-1.594-30.405-1.104m22.926 33.348c18.207 1.962 36.536 8.46 51.248 18.268 7.908 5.272 19.065 16.306 23.846 23.54 5.885 8.949 9.256 18.083 10.789 29.179.674 5.088.307 8.95-1.533 17.164-2.881 12.26-11.831 25.072-23.907 34.022-5.64 4.107-17.348 10.054-24.52 12.383-13.609 4.352-22.498 5.149-54.252 4.904-20.719-.184-24.398-.368-30.344-1.471-20.29-3.801-36.351-11.893-47.998-24.214-9.441-9.931-13.732-19.003-16.061-33.654-1.042-6.805.919-18.084 4.904-27.586 4.843-11.586 17.348-25.991 29.731-34.267 14.344-9.563 33.225-16.367 50.573-18.206 6.682-.736 20.842-.736 27.524-.062"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M299.584 436.336c-4.659 2.513-7.908 8.888-6.927 13.608 1.103 5.088 5.578 10.238 12.566 14.468 3.74 2.268 3.985 2.574 4.169 4.842.122 1.349-.368 5.211-1.042 8.644-.736 3.371-1.288 6.927-1.288 7.908.062 2.636 2.514 6.927 5.088 9.011 2.269 1.839 2.698 1.9 9.073 2.084 5.824.184 7.05.061 9.379-1.042 6.008-2.943 7.54-8.337 5.333-18.697-1.839-8.643-1.471-9.992 3.127-12.628 4.842-2.82 9.992-7.785 11.524-11.157 2.943-6.436.245-13.731-6.253-17.103-1.593-.797-3.555-1.164-6.436-1.164-4.475 0-7.356 1.042-12.628 4.413l-3.004 1.901-1.9-1.165c-7.785-4.598-9.195-5.149-13.916-5.088-3.371 0-5.21.306-6.865 1.165M150.744 365.165c-10.85 3.433-18.942 11.402-23.11 22.743-2.023 5.395-3.004 13.916-2.146 18.513 2.023 10.973 11.034 20.965 21.272 23.724 12.873 3.371 22.497 1.164 31.018-7.295 4.965-4.843 7.663-9.073 10.36-15.939 1.961-4.842 2.084-5.7 2.084-12.566l.061-7.356-2.574-5.272c-4.108-8.337-11.525-14.529-20.107-16.797-4.843-1.226-12.628-1.164-16.858.245M478.153 364.982c-8.398 2.268-15.877 8.52-19.862 16.735l-2.574 5.272.061 7.356c0 6.866.123 7.724 2.084 12.566 2.698 6.866 5.395 11.096 10.36 15.939 8.521 8.459 18.145 10.666 31.019 7.295 7.417-1.962 14.834-8.215 18.39-15.51 3.065-6.191 3.8-10.666 2.82-17.716-2.268-16.122-11.709-27.83-25.747-31.937-4.107-1.226-12.076-1.226-16.551 0"
    }));

const OllamaLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 646 854",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M140.629.24c-7.969 1.287-17.532 5.456-24.275 10.605-20.413 15.51-36.229 48.428-42.91 89.438-2.514 15.509-4.23 37.026-4.23 53.455 0 19.371 2.268 44.136 5.517 61.239.736 3.801 1.103 7.173.797 7.418-.245.245-3.25 2.697-6.62 5.394-11.525 9.195-24.705 23.356-33.778 36.291-17.41 24.704-28.688 52.78-33.409 83.185-1.839 12.015-2.33 36.29-.858 48.305 3.25 27.708 11.586 51.125 25.87 72.581l4.658 6.927-1.349 2.268c-9.563 16.061-17.716 39.294-21.516 61.607-3.004 17.655-3.372 22.375-3.372 46.037 0 23.847.307 28.567 3.127 45.057 3.371 19.739 10.237 40.642 17.9 54.558 2.513 4.536 8.643 13.976 9.378 14.467.246.122-.49 2.39-1.655 5.026-8.827 19.31-16.367 44.995-19.493 66.635-2.207 14.834-2.514 19.616-2.514 35.248 0 19.922 1.104 29.608 5.272 45.485l.613 2.329h52.535l-1.716-3.249c-10.605-19.616-11.586-56.029-2.452-92.38 4.168-16.797 8.888-29.118 17.716-46.099l5.272-10.298v-6.314c0-5.885-.123-6.559-2.023-10.421-1.472-2.943-3.433-5.456-6.927-8.889-5.947-5.762-10.238-11.831-13.67-19.31-15.08-32.735-18.023-81.346-7.418-122.786 4.414-17.287 11.709-32.673 19.371-41.071 5.21-5.763 7.908-12.199 7.908-18.881 0-6.927-2.452-12.628-7.97-18.574-15.815-16.919-25.562-37.517-29.056-61.485-4.965-34.145 4.046-71.355 24.52-100.84 20.046-28.935 48.183-47.509 79.631-52.474 7.049-1.165 20.229-.981 27.585.368 8.031 1.41 13.057.98 18.207-1.472 6.375-3.003 9.563-6.743 13.302-15.325 3.31-7.662 5.885-11.831 12.812-20.474 8.337-10.36 16.367-17.41 29.24-25.931 14.713-9.624 31.448-16.612 48.122-19.984 6.068-1.226 8.888-1.41 20.229-1.41s14.161.184 20.229 1.41c24.459 4.966 48.735 17.594 68.106 35.493 4.168 3.862 14.16 16.245 17.348 21.395 1.226 2.022 3.372 6.314 4.72 9.501 3.739 8.582 6.927 12.322 13.302 15.325 4.966 2.391 10.176 2.882 17.9 1.594 12.199-2.084 21.578-1.9 33.532.552 40.704 8.214 76.136 41.746 91.829 86.68 13.67 39.416 9.808 80.672-10.544 112.18-3.433 5.334-6.866 9.625-11.831 14.897-10.728 11.463-10.728 25.685-.061 37.455 17.532 19.187 28.505 66.389 25.194 108.012-2.206 27.463-9.256 52.045-18.942 65.96-1.716 2.452-5.271 6.62-7.969 9.195-3.494 3.433-5.455 5.946-6.927 8.889-1.9 3.862-2.023 4.536-2.023 10.421v6.314l5.272 10.298c8.828 16.981 13.548 29.302 17.716 46.099 9.012 35.861 8.215 71.538-2.084 91.829-.858 1.716-1.594 3.31-1.594 3.494s11.709.306 26.053.306h25.992l.674-2.636c.368-1.409.981-3.555 1.287-4.781.675-2.697 2.023-10.666 3.127-18.329 1.042-7.724 1.042-36.168 0-44.75-3.923-31.141-10.483-55.845-21.21-79.201-1.165-2.636-1.901-4.904-1.656-5.026.307-.184 2.023-2.636 3.862-5.395 13.364-20.229 21.578-45.669 25.747-79.262 1.103-9.257 1.103-49.041 0-57.93-2.943-22.926-6.498-38.497-12.383-54.251-2.452-6.559-8.95-20.413-11.708-24.888l-1.349-2.268 4.659-6.927c14.283-21.456 22.62-44.873 25.869-72.581 1.471-12.015.981-36.29-.858-48.305-4.782-30.467-16-58.42-33.409-83.185-9.073-12.935-22.253-27.096-33.777-36.291-3.372-2.697-6.376-5.149-6.621-5.394-.306-.245.062-3.617.797-7.418 7.418-38.681 7.172-86.924-.613-124.625-6.743-32.857-19.003-58.971-34.819-74.051C523.209 4.286 510.336-.864 494.888.117c-35.432 2.085-63.998 42.85-75.278 107.093-1.839 10.36-3.432 22.498-3.432 25.808 0 1.287-.246 2.329-.552 2.329s-2.697-1.226-5.272-2.758c-27.34-16.184-57.746-24.827-87.354-24.827s-60.014 8.643-87.354 24.827c-2.575 1.532-4.965 2.758-5.272 2.758-.306 0-.552-1.042-.552-2.329 0-3.433-1.655-15.938-3.432-25.808-10.238-57.684-33.716-95.875-64.918-105.499C157.181.424 144.982-.434 140.629.24m10.422 49.899c8.827 6.988 18.635 26.972 24.275 49.347 1.042 4.046 2.145 8.705 2.452 10.421.245 1.656.919 5.395 1.471 8.276 2.391 12.996 3.494 27.034 3.617 44.137l.061 16.858-4.23 6.252-4.229 6.314h-9.87c-11.524 0-22.988 1.472-33.961 4.414-3.923.981-7.724 1.962-8.459 2.146-1.165.245-1.349-.123-2.023-5.15-3.617-27.279-3.433-57.5.552-82.634 4.413-28.014 14.712-53.393 24.765-60.871 2.391-1.778 2.82-1.717 5.579.49m349.538-.43c6.069 4.476 12.751 16.368 17.716 31.57 9.992 30.406 12.812 72.152 7.54 111.875-.674 5.027-.858 5.395-2.023 5.15-.735-.184-4.536-1.165-8.459-2.146-10.973-2.942-22.437-4.414-33.961-4.414h-9.87l-4.229-6.314-4.23-6.252.061-16.858c.123-23.785 2.33-42.359 7.601-63.018 5.579-22.19 15.448-42.175 24.214-49.163 2.759-2.207 3.188-2.268 5.64-.43"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M313.498 358.237c-13.303 1.288-16.919 1.778-23.295 3.066-10.36 2.145-24.214 6.927-33.838 11.647-33.47 16.367-56.519 43.646-63.569 75.216-1.41 6.253-1.594 8.337-1.594 18.881 0 10.421.184 12.689 1.533 18.635 9.379 41.256 47.385 71.723 96.549 77.301 10.666 1.165 56.765 1.165 67.431 0 39.478-4.475 73.439-25.869 88.703-55.907 4.045-8.03 6.007-13.241 7.846-21.394 1.349-5.946 1.533-8.214 1.533-18.635 0-10.544-.184-12.628-1.594-18.881-10.238-45.853-54.742-81.959-109.3-88.825-7.111-.858-25.746-1.594-30.405-1.104m22.926 33.348c18.207 1.962 36.536 8.46 51.248 18.268 7.908 5.272 19.065 16.306 23.846 23.54 5.885 8.949 9.256 18.083 10.789 29.179.674 5.088.307 8.95-1.533 17.164-2.881 12.26-11.831 25.072-23.907 34.022-5.64 4.107-17.348 10.054-24.52 12.383-13.609 4.352-22.498 5.149-54.252 4.904-20.719-.184-24.398-.368-30.344-1.471-20.29-3.801-36.351-11.893-47.998-24.214-9.441-9.931-13.732-19.003-16.061-33.654-1.042-6.805.919-18.084 4.904-27.586 4.843-11.586 17.348-25.991 29.731-34.267 14.344-9.563 33.225-16.367 50.573-18.206 6.682-.736 20.842-.736 27.524-.062"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M299.584 436.336c-4.659 2.513-7.908 8.888-6.927 13.608 1.103 5.088 5.578 10.238 12.566 14.468 3.74 2.268 3.985 2.574 4.169 4.842.122 1.349-.368 5.211-1.042 8.644-.736 3.371-1.288 6.927-1.288 7.908.062 2.636 2.514 6.927 5.088 9.011 2.269 1.839 2.698 1.9 9.073 2.084 5.824.184 7.05.061 9.379-1.042 6.008-2.943 7.54-8.337 5.333-18.697-1.839-8.643-1.471-9.992 3.127-12.628 4.842-2.82 9.992-7.785 11.524-11.157 2.943-6.436.245-13.731-6.253-17.103-1.593-.797-3.555-1.164-6.436-1.164-4.475 0-7.356 1.042-12.628 4.413l-3.004 1.901-1.9-1.165c-7.785-4.598-9.195-5.149-13.916-5.088-3.371 0-5.21.306-6.865 1.165M150.744 365.165c-10.85 3.433-18.942 11.402-23.11 22.743-2.023 5.395-3.004 13.916-2.146 18.513 2.023 10.973 11.034 20.965 21.272 23.724 12.873 3.371 22.497 1.164 31.018-7.295 4.965-4.843 7.663-9.073 10.36-15.939 1.961-4.842 2.084-5.7 2.084-12.566l.061-7.356-2.574-5.272c-4.108-8.337-11.525-14.529-20.107-16.797-4.843-1.226-12.628-1.164-16.858.245M478.153 364.982c-8.398 2.268-15.877 8.52-19.862 16.735l-2.574 5.272.061 7.356c0 6.866.123 7.724 2.084 12.566 2.698 6.866 5.395 11.096 10.36 15.939 8.521 8.459 18.145 10.666 31.019 7.295 7.417-1.962 14.834-8.215 18.39-15.51 3.065-6.191 3.8-10.666 2.82-17.716-2.268-16.122-11.709-27.83-25.747-31.937-4.107-1.226-12.076-1.226-16.551 0"
    }));

const OnePasswordDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M32 16c0-8.836-7.164-16-16-16S0 7.164 0 16s7.164 16 16 16 16-7.163 16-16M13.063 6.989c-.101.199-.101.459-.101.98v4.107c0 .13 0 .195.017.256a.5.5 0 0 0 .07.148c.036.05.087.092.188.174l1.079.876c.121.099.182.148.204.208.02.052.02.11 0 .162-.022.059-.083.108-.204.207l-1.08.877c-.1.082-.15.123-.187.173a.5.5 0 0 0-.07.149c-.017.06-.017.125-.017.255v8.47c0 .521 0 .782.101.98a.93.93 0 0 0 .407.407c.198.101.459.101.98.101h3.1c.521 0 .781 0 .98-.101a.93.93 0 0 0 .407-.407c.101-.198.101-.459.101-.98v-4.107c0-.13 0-.195-.016-.255a.5.5 0 0 0-.071-.149 1 1 0 0 0-.188-.174l-1.079-.876c-.121-.099-.182-.148-.204-.208a.23.23 0 0 1 0-.161c.022-.06.083-.11.204-.208l1.08-.877c.1-.081.15-.122.187-.173a.5.5 0 0 0 .07-.149c.017-.06.017-.125.017-.255V7.97c0-.521 0-.781-.101-.98a.93.93 0 0 0-.407-.407c-.199-.101-.459-.101-.98-.101h-3.1c-.521 0-.781 0-.98.101a.93.93 0 0 0-.407.407Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h32v32H0z"
    }))));

const OnePasswordLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M32 16c0-8.836-7.164-16-16-16S0 7.164 0 16s7.164 16 16 16 16-7.163 16-16M13.063 6.989c-.101.199-.101.459-.101.98v4.107c0 .13 0 .195.017.256a.5.5 0 0 0 .07.148c.036.05.087.092.188.174l1.079.876c.121.099.182.148.204.208.02.052.02.11 0 .162-.022.059-.083.108-.204.207l-1.08.877c-.1.082-.15.123-.187.173a.5.5 0 0 0-.07.149c-.017.06-.017.125-.017.255v8.47c0 .521 0 .782.101.98a.93.93 0 0 0 .407.407c.198.101.459.101.98.101h3.1c.521 0 .781 0 .98-.101a.93.93 0 0 0 .407-.407c.101-.198.101-.459.101-.98v-4.107c0-.13 0-.195-.016-.255a.5.5 0 0 0-.071-.149 1 1 0 0 0-.188-.174l-1.079-.876c-.121-.099-.182-.148-.204-.208a.23.23 0 0 1 0-.161c.022-.06.083-.11.204-.208l1.08-.877c.1-.081.15-.122.187-.173a.5.5 0 0 0 .07-.149c.017-.06.017-.125.017-.255V7.97c0-.521 0-.781-.101-.98a.93.93 0 0 0-.407-.407c-.199-.101-.459-.101-.98-.101h-3.1c-.521 0-.781 0-.98.101a.93.93 0 0 0-.407.407Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h32v32H0z"
    }))));

const OpenAIDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 260",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M239.184 106.203a64.72 64.72 0 0 0-5.576-53.103C219.452 28.459 191 15.784 163.213 21.74A65.586 65.586 0 0 0 52.096 45.22a64.72 64.72 0 0 0-43.23 31.36c-14.31 24.602-11.061 55.634 8.033 76.74a64.67 64.67 0 0 0 5.525 53.102c14.174 24.65 42.644 37.324 70.446 31.36a64.72 64.72 0 0 0 48.754 21.744c28.481.025 53.714-18.361 62.414-45.481a64.77 64.77 0 0 0 43.229-31.36c14.137-24.558 10.875-55.423-8.083-76.483Zm-97.56 136.338a48.4 48.4 0 0 1-31.105-11.255l1.535-.87 51.67-29.825a8.6 8.6 0 0 0 4.247-7.367v-72.85l21.845 12.636c.218.111.37.32.409.563v60.367c-.056 26.818-21.783 48.545-48.601 48.601m-104.466-44.61a48.35 48.35 0 0 1-5.781-32.589l1.534.921 51.722 29.826a8.34 8.34 0 0 0 8.441 0l63.181-36.425v25.221a.87.87 0 0 1-.358.665l-52.335 30.184c-23.257 13.398-52.97 5.431-66.404-17.803M23.549 85.38a48.5 48.5 0 0 1 25.58-21.333v61.39a8.29 8.29 0 0 0 4.195 7.316l62.874 36.272-21.845 12.636a.82.82 0 0 1-.767 0L41.353 151.53c-23.211-13.454-31.171-43.144-17.804-66.405v.256Zm179.466 41.695-63.08-36.63L161.73 77.86a.82.82 0 0 1 .768 0l52.233 30.184a48.6 48.6 0 0 1-7.316 87.635v-61.391a8.54 8.54 0 0 0-4.4-7.213m21.742-32.69-1.535-.922-51.619-30.081a8.39 8.39 0 0 0-8.492 0L99.98 99.808V74.587a.72.72 0 0 1 .307-.665l52.233-30.133a48.652 48.652 0 0 1 72.236 50.391zM88.061 139.097l-21.845-12.585a.87.87 0 0 1-.41-.614V65.685a48.652 48.652 0 0 1 79.757-37.346l-1.535.87-51.67 29.825a8.6 8.6 0 0 0-4.246 7.367l-.051 72.697Zm11.868-25.58L128.067 97.3l28.188 16.218v32.434l-28.086 16.218-28.188-16.218-.052-32.434Z"
    }));

const OpenAILight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 260",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M239.184 106.203a64.72 64.72 0 0 0-5.576-53.103C219.452 28.459 191 15.784 163.213 21.74A65.586 65.586 0 0 0 52.096 45.22a64.72 64.72 0 0 0-43.23 31.36c-14.31 24.602-11.061 55.634 8.033 76.74a64.67 64.67 0 0 0 5.525 53.102c14.174 24.65 42.644 37.324 70.446 31.36a64.72 64.72 0 0 0 48.754 21.744c28.481.025 53.714-18.361 62.414-45.481a64.77 64.77 0 0 0 43.229-31.36c14.137-24.558 10.875-55.423-8.083-76.483Zm-97.56 136.338a48.4 48.4 0 0 1-31.105-11.255l1.535-.87 51.67-29.825a8.6 8.6 0 0 0 4.247-7.367v-72.85l21.845 12.636c.218.111.37.32.409.563v60.367c-.056 26.818-21.783 48.545-48.601 48.601m-104.466-44.61a48.35 48.35 0 0 1-5.781-32.589l1.534.921 51.722 29.826a8.34 8.34 0 0 0 8.441 0l63.181-36.425v25.221a.87.87 0 0 1-.358.665l-52.335 30.184c-23.257 13.398-52.97 5.431-66.404-17.803M23.549 85.38a48.5 48.5 0 0 1 25.58-21.333v61.39a8.29 8.29 0 0 0 4.195 7.316l62.874 36.272-21.845 12.636a.82.82 0 0 1-.767 0L41.353 151.53c-23.211-13.454-31.171-43.144-17.804-66.405v.256Zm179.466 41.695-63.08-36.63L161.73 77.86a.82.82 0 0 1 .768 0l52.233 30.184a48.6 48.6 0 0 1-7.316 87.635v-61.391a8.54 8.54 0 0 0-4.4-7.213m21.742-32.69-1.535-.922-51.619-30.081a8.39 8.39 0 0 0-8.492 0L99.98 99.808V74.587a.72.72 0 0 1 .307-.665l52.233-30.133a48.652 48.652 0 0 1 72.236 50.391zM88.061 139.097l-21.845-12.585a.87.87 0 0 1-.41-.614V65.685a48.652 48.652 0 0 1 79.757-37.346l-1.535.87-51.67 29.825a8.6 8.6 0 0 0-4.246 7.367l-.051 72.697Zm11.868-25.58L128.067 97.3l28.188 16.218v32.434l-28.086 16.218-28.188-16.218-.052-32.434Z"
    }));

const OpenBootcamp = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "prefix__css-12xw6g8",
        viewBox: "0 0 70 51",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("ellipse", {
        cx: 18.05,
        cy: 17.585,
        fill: "#0BF082",
        rx: 16.612,
        ry: 16.585
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#047AF3",
        fillRule: "evenodd",
        d: "M35.864 17.586H18.05v32.52h17.816a8.697 8.697 0 0 0 4.298-16.26 8.697 8.697 0 0 0-4.298-16.26",
        clipRule: "evenodd"
    }));

const OpenSea = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 360 360",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M252.072 212.292c-6.246 8.37-19.386 22.266-26.694 22.266h-33.966v-22.284h27.054c3.87 0 7.56-1.566 10.224-4.32 13.896-14.4 21.924-31.536 21.924-49.914 0-31.356-23.436-59.076-59.22-75.78V67.284c0-6.444-5.22-11.664-11.664-11.664s-11.664 5.22-11.664 11.664v6.21a191 191 0 0 0-31.734-6.444c18.36 19.944 29.574 46.62 29.574 75.87 0 26.226-8.964 50.31-24.03 69.39h26.19v22.32h-38.34a9.39 9.39 0 0 1-9.396-9.396v-9.756a3.115 3.115 0 0 0-3.114-3.114H66.672c-.99 0-1.836.81-1.836 1.8-.036 39.924 31.554 69.894 69.336 69.894h106.65c25.56 0 36.99-32.76 51.966-53.604 5.814-8.064 19.764-14.544 23.994-16.344.774-.324 1.224-1.044 1.224-1.89v-12.96c0-1.314-1.296-2.304-2.574-1.944 0 0-61.65 14.166-62.37 14.364-.72.216-.99.63-.99.63z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M146.16 142.83c0-20.106-6.894-38.61-18.414-53.244L69.732 189.972h62.406c8.874-13.536 14.04-29.736 14.04-47.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0086FF",
        d: "M181.566 0C80.91-.828-.828 80.91 0 181.566c.846 97.74 80.694 177.606 178.416 178.416 100.656.864 182.43-80.91 181.566-181.566C359.172 80.712 279.306.846 181.566 0m-53.82 89.586c11.52 14.634 18.414 33.156 18.414 53.244 0 17.406-5.166 33.606-14.04 47.124H69.714l58.014-100.386zm190.26 109.656v12.96c0 .846-.45 1.566-1.224 1.89-4.23 1.8-18.18 8.28-23.994 16.344-14.976 20.844-26.406 53.604-51.966 53.604h-106.65c-37.764 0-69.354-29.97-69.336-69.894 0-.99.846-1.8 1.836-1.8h50.544a3.104 3.104 0 0 1 3.114 3.114v9.756a9.39 9.39 0 0 0 9.396 9.396h38.34v-22.32h-26.19c15.066-19.08 24.03-43.164 24.03-69.39 0-29.25-11.214-55.926-29.574-75.87a192 192 0 0 1 31.734 6.444v-6.21c0-6.444 5.22-11.664 11.664-11.664s11.664 5.22 11.664 11.664v14.976c35.784 16.704 59.22 44.424 59.22 75.78 0 18.396-8.046 35.514-21.924 49.914a14.22 14.22 0 0 1-10.224 4.32h-27.054v22.284h33.966c7.326 0 20.466-13.896 26.694-22.266 0 0 .27-.414.99-.63s62.37-14.364 62.37-14.364c1.296-.36 2.574.63 2.574 1.944z"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h360v360H0z"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__b"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h360v360H0z"
    }))));

const OpenWebUI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 500 500",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("image", {
        xlinkHref: "data:image/png;base64,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",
        width: 500,
        height: 500
    }), /*#__PURE__*/ React.createElement("style", null, "@media (prefers-color-scheme:light){:root{filter:none}}@media (prefers-color-scheme:dark){:root{filter:none}}"));

const Opera = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 1000 1000",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 416.623,
        x2: 416.623,
        y1: 16.304,
        y2: 985.446,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#ff1b2d"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.438,
        stopColor: "#fa1a2c"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.594,
        stopColor: "#ed1528"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.758,
        stopColor: "#d60e21"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.927,
        stopColor: "#b70519"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#a70014"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M335.4 781.8c-55.3-65.3-91.1-161.7-93.5-270v-23.6c2.4-108.3 38.2-204.7 93.5-270C407.2 125.1 513.8 66 632.8 66c73.2 0 141.8 22.4 200.4 61.3C745.2 48.5 629.2.5 501.9 0H500C223.9 0 0 223.9 0 500c0 268.2 211.1 487 476.2 499.4 7.9.4 15.8.6 23.8.6 128 0 244.8-48.1 333.2-127.2-58.6 38.8-127.1 61.2-200.4 61.2-119 0-225.6-59.1-297.4-152.2"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 667.709,
        x2: 667.709,
        y1: 73.426,
        y2: 930.584,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#9c0000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#ff4b4b"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M335.4 218.2c45.9-54.2 105.1-86.8 169.9-86.8 145.6 0 263.5 165 263.5 368.6s-118 368.6-263.5 368.6c-64.7 0-124-32.7-169.9-86.8C407.2 874.9 513.8 934 632.8 934c73.2 0 141.8-22.4 200.4-61.2C935.6 781.2 1000 648.1 1000 500s-64.4-281.2-166.8-372.7C774.6 88.4 706.1 66 632.8 66c-119 0-225.6 59.1-297.4 152.2"
    }));

const Outlook = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-0.13 0 33.252 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0364b8",
        d: "M28.596 2H11.404A1.404 1.404 0 0 0 10 3.404V5l9.69 3L30 5V3.404A1.404 1.404 0 0 0 28.596 2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0a2767",
        d: "M31.65 17.405A11 11 0 0 0 32 16a.67.67 0 0 0-.333-.576l-.013-.008-.004-.002L20.812 9.24a2 2 0 0 0-.145-.083 1.5 1.5 0 0 0-1.334 0 2 2 0 0 0-.145.082L8.35 15.415l-.004.002-.012.007A.67.67 0 0 0 8 16a11 11 0 0 0 .35 1.405l11.492 8.405z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#28a8ea",
        d: "M24 5h-7l-2.021 3L17 11l7 6h6v-6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0078d4",
        d: "M10 5h7v6h-7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#50d9ff",
        d: "M24 5h6v6h-6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0364b8",
        d: "m24 17-7-6h-7v6l7 6 10.832 1.768z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        d: "M10.031 5H30"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0078d4",
        d: "M17 11h7v6h-7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#064a8c",
        d: "M10 17h7v6h-7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0078d4",
        d: "M24 17h6v6h-6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0a2767",
        d: "m20.19 25.218-11.793-8.6.495-.87s10.745 6.12 10.909 6.212a.53.53 0 0 0 .42-.012l10.933-6.23.496.869z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1490df",
        d: "m31.667 16.577-.014.008-.003.002-10.838 6.174a1.5 1.5 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.5 1.5 0 0 0 32 28.5V16a.67.67 0 0 1-.333.577"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M32 28.5v-.738l-9.983-5.688-1.205.687a1.5 1.5 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.5 1.5 0 0 0 32 28.5",
        opacity: 0.05
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M31.95 28.883 21.007 22.65l-.195.11a1.5 1.5 0 0 1-1.46.092l3.774 5.061 8.254 1.797v.004a1.5 1.5 0 0 0 .57-.83z",
        opacity: 0.1
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#28a8ea",
        d: "M8.35 16.59v-.01h-.01l-.03-.02A.65.65 0 0 1 8 16v12.5A1.5 1.5 0 0 0 9.5 30h21a1.5 1.5 0 0 0 .37-.05.6.6 0 0 0 .18-.06.14.14 0 0 0 .06-.02 1 1 0 0 0 .23-.13c.02-.01.03-.01.04-.03z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M18 24.667V8.333A1.337 1.337 0 0 0 16.667 7H10.03v7.456l-1.68.958-.005.002-.012.007A.67.67 0 0 0 8 16v.005V16v10h8.667A1.337 1.337 0 0 0 18 24.667",
        opacity: 0.1
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M17 25.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03v6.456l-1.68.958-.005.002-.012.007A.67.67 0 0 0 8 16v.005V16v11h7.667A1.337 1.337 0 0 0 17 25.667",
        opacity: 0.2
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M17 23.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03v6.456l-1.68.958-.005.002-.012.007A.67.67 0 0 0 8 16v.005V16v9h7.667A1.337 1.337 0 0 0 17 23.667",
        opacity: 0.2
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16 23.667V9.333A1.337 1.337 0 0 0 14.667 8H10.03v6.456l-1.68.958-.005.002-.012.007A.67.67 0 0 0 8 16v.005V16v9h6.667A1.337 1.337 0 0 0 16 23.667",
        opacity: 0.2
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0078d4",
        d: "M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M3.867 13.468a4.2 4.2 0 0 1 1.642-1.814A4.97 4.97 0 0 1 8.119 11a4.6 4.6 0 0 1 2.413.62 4.14 4.14 0 0 1 1.598 1.733 5.6 5.6 0 0 1 .56 2.55 5.9 5.9 0 0 1-.577 2.666 4.24 4.24 0 0 1-1.645 1.794A4.8 4.8 0 0 1 7.963 21a4.73 4.73 0 0 1-2.468-.627 4.2 4.2 0 0 1-1.618-1.736 5.46 5.46 0 0 1-.567-2.519 6.06 6.06 0 0 1 .557-2.65m1.75 4.258a2.7 2.7 0 0 0 .923 1.194 2.4 2.4 0 0 0 1.443.435 2.53 2.53 0 0 0 1.541-.449 2.6 2.6 0 0 0 .897-1.197 4.6 4.6 0 0 0 .286-1.665 5 5 0 0 0-.27-1.686 2.67 2.67 0 0 0-.866-1.24 2.4 2.4 0 0 0-1.527-.473 2.5 2.5 0 0 0-1.477.439 2.74 2.74 0 0 0-.944 1.203 4.78 4.78 0 0 0-.007 3.44z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        d: "M0 0h32v32H0z"
    }));

const Oxc = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 240 240",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        x: 99,
        y: 26,
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M99 26h42v42H99z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M120 64c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17m0-7c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF915C",
        fillRule: "evenodd",
        d: "M120 64c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17m0-7c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2B3C5A",
        d: "M133 47c0 7.18-5.82 13-13 13v8c11.598 0 21-9.402 21-21zm-13-13c7.18 0 13 5.82 13 13h8c0-11.598-9.402-21-21-21zm-13 13c0-7.18 5.82-13 13-13v-8c-11.598 0-21 9.402-21 21zm13 13c-7.18 0-13-5.82-13-13h-8c0 11.598 9.402 21 21 21zm6-13a6 6 0 0 1-6 6v8c7.732 0 14-6.268 14-14zm-6-6a6 6 0 0 1 6 6h8c0-7.732-6.268-14-14-14zm-6 6a6 6 0 0 1 6-6v-8c-7.732 0-14 6.268-14 14zm6 6a6 6 0 0 1-6-6h-8c0 7.732 6.268 14 14 14z",
        mask: "url(#prefix__b)"
    }), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__c)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__d",
        width: 148,
        height: 178,
        x: 46,
        y: 26,
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M46 26h148v178H46z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M127.017 62.489C132.905 59.817 137 53.887 137 47c0-9.389-7.611-17-17-17s-17 7.611-17 17c0 6.887 4.095 12.817 9.983 15.489L112.552 75h-.052l-23.726 1.79A3 3 0 0 0 86 79.783v6.44a3 3 0 0 0 2.77 2.991L112 91l-1.104 41.769c-.333 12.612-2.388 28.067-14.71 30.774-1.365.3-2.767.457-4.186.457-7.386 0-15.91-9.093-21.37-18.417a63 63 0 0 1 6.636-2.443c1.297-.396 1.558-2.222.426-2.97-8.182-5.408-14.672-12.666-18.654-21.062-.547-1.154-2.2-1.238-2.751-.086a65 65 0 0 0-3.519 9.006c-2.761 9.002-3.465 18.391-2.073 27.631l.093.597c.193 1.203 1.683 1.629 2.559.782a55 55 0 0 1 5.236-4.466C68.627 184.191 102.218 200 120 200c17.786 0 51.39-15.817 61.424-47.452a55 55 0 0 1 5.231 4.478c.876.85 2.37.424 2.562-.781q.048-.293.091-.586c1.386-9.24.685-18.629-2.064-27.631a65 65 0 0 0-3.495-8.99c-.55-1.155-2.207-1.072-2.753.085-3.966 8.391-10.425 15.644-18.566 21.049-1.129.749-.868 2.571.427 2.968a62 62 0 0 1 6.533 2.411C163.929 154.886 155.395 164 148 164c-1.418 0-2.82-.157-4.184-.456-12.324-2.707-14.379-18.163-14.712-30.775L128 91l23.23-1.787a3 3 0 0 0 2.77-2.991v-6.44a3 3 0 0 0-2.774-2.991L127.5 75h-.052zM130 47c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF915C",
        fillRule: "evenodd",
        d: "M127.017 62.489C132.905 59.817 137 53.887 137 47c0-9.389-7.611-17-17-17s-17 7.611-17 17c0 6.887 4.095 12.817 9.983 15.489L112.552 75h-.052l-23.726 1.79A3 3 0 0 0 86 79.783v6.44a3 3 0 0 0 2.77 2.991L112 91l-1.104 41.769c-.333 12.612-2.388 28.067-14.71 30.774-1.365.3-2.767.457-4.186.457-7.386 0-15.91-9.093-21.37-18.417a63 63 0 0 1 6.636-2.443c1.297-.396 1.558-2.222.426-2.97-8.182-5.408-14.672-12.666-18.654-21.062-.547-1.154-2.2-1.238-2.751-.086a65 65 0 0 0-3.519 9.006c-2.761 9.002-3.465 18.391-2.073 27.631l.093.597c.193 1.203 1.683 1.629 2.559.782a55 55 0 0 1 5.236-4.466C68.627 184.191 102.218 200 120 200c17.786 0 51.39-15.817 61.424-47.452a55 55 0 0 1 5.231 4.478c.876.85 2.37.424 2.562-.781q.048-.293.091-.586c1.386-9.24.685-18.629-2.064-27.631a65 65 0 0 0-3.495-8.99c-.55-1.155-2.207-1.072-2.753.085-3.966 8.391-10.425 15.644-18.566 21.049-1.129.749-.868 2.571.427 2.968a62 62 0 0 1 6.533 2.411C163.929 154.886 155.395 164 148 164c-1.418 0-2.82-.157-4.184-.456-12.324-2.707-14.379-18.163-14.712-30.775L128 91l23.23-1.787a3 3 0 0 0 2.77-2.991v-6.44a3 3 0 0 0-2.774-2.991L127.5 75h-.052zM130 47c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2B3C5A",
        d: "m127.017 62.489-1.653-3.643-2.437 1.106.092 2.675zm-14.034 0 3.998.138.092-2.675-2.437-1.106zM112.552 75v4h3.864l.133-3.862zm-.052 0v-4h-.151l-.15.011zm-23.726 1.79-.3-3.988.3 3.989Zm-.004 12.423-.307 3.988zM112 91l3.999.106.1-3.802-3.792-.292zm-1.104 41.769 3.999.106zm-14.71 30.774.858 3.907zm-25.557-17.96-1.593-3.669-4.14 1.797 2.282 3.894zm6.637-2.443-1.169-3.825zm.426-2.97 2.206-3.337v-.001zm-18.654-21.062 3.614-1.714zm-2.751-.086 3.608 1.727zm-3.519 9.006-3.824-1.173zm-2.073 27.631 3.955-.596zm.093.597-3.95.635zm2.559.782 2.78 2.875zm5.236-4.466 3.812-1.211-1.707-5.377-4.509 3.391zm122.841-.024 2.409-3.193-4.512-3.404-1.709 5.387zm5.231 4.478-2.786 2.869v.001zm2.562-.781 3.95.631zm.091-.586-3.956-.593zm-2.064-27.631-3.825 1.168zm-3.495-8.99-3.611 1.719zm-2.753.085-3.617-1.709zm-18.566 21.049-2.213-3.333zm.427 2.968-1.173 3.824zm6.533 2.411 3.452 2.02 2.277-3.892-4.135-1.797zm-25.574 17.993-.858 3.907zm-14.712-30.775-3.999.105zM128 91l-.307-3.988-3.792.291.1 3.803zm23.23-1.787.307 3.988zm-.004-12.422.301-3.989zM127.5 75l.301-3.989-.15-.011h-.151zm-.052 0-3.997.138.133 3.862h3.864zm1.222-8.869C135.934 62.835 141 55.513 141 47h-8c0 5.26-3.125 9.8-7.636 11.846zM141 47c0-11.598-9.402-21-21-21v8c7.18 0 13 5.82 13 13zm-21-21c-11.598 0-21 9.402-21 21h8c0-7.18 5.82-13 13-13zM99 47c0 8.513 5.066 15.835 12.33 19.131l3.306-7.285C110.125 56.8 107 52.26 107 47zm9.986 15.351-.432 12.511 7.995.276.432-12.511zM112.552 71h-.052v8h.052zm-.353.011-23.726 1.791.602 7.977 23.726-1.79zm-23.726 1.791A7 7 0 0 0 82 79.782h8a1 1 0 0 1-.925.997zM82 79.782v6.44h8v-6.44zm0 6.44a7 7 0 0 0 6.463 6.98l.614-7.977a1 1 0 0 1 .923.997zm6.463 6.98 23.23 1.786.614-7.976-23.23-1.787-.614 7.976Zm19.538-2.308-1.104 41.769 7.998.212 1.104-41.77zm-1.104 41.769c-.164 6.229-.756 12.703-2.621 17.844-1.83 5.046-4.618 8.178-8.949 9.13l1.717 7.813c7.991-1.755 12.392-7.705 14.753-14.216 2.327-6.416 2.929-13.975 3.098-20.359zm-11.57 26.974A15.5 15.5 0 0 1 92 160v8c1.714 0 3.404-.19 5.044-.55zM92 160c-2.163 0-5.19-1.426-8.698-4.655-3.38-3.11-6.64-7.378-9.222-11.784l-6.902 4.044c2.88 4.918 6.612 9.859 10.706 13.626C81.85 164.88 86.777 168 92 168zm-19.778-10.748a58 58 0 0 1 6.212-2.286l-2.337-7.651a66 66 0 0 0-7.061 2.599zm6.212-2.286c4.551-1.39 5.403-7.53 1.464-10.133l-4.411 6.674a2.37 2.37 0 0 1-1.056-2.288 2.37 2.37 0 0 1 1.666-1.904zm1.464-10.134c-7.626-5.04-13.603-11.757-17.246-19.438l-7.228 3.428c4.32 9.11 11.325 16.91 20.063 22.685zm-17.246-19.438c-1.793-3.782-7.774-4.694-9.974-.099l7.217 3.454a2.57 2.57 0 0 1-2.385 1.448 2.42 2.42 0 0 1-2.086-1.375zm-9.974-.099a69 69 0 0 0-3.734 9.56l7.648 2.346a61 61 0 0 1 3.303-8.452zm-3.734 9.56c-2.935 9.57-3.687 19.563-2.204 29.4l7.91-1.192c-1.302-8.643-.645-17.428 1.942-25.862zm-2.204 29.4.099.636 7.898-1.269q-.045-.28-.087-.559zm.099.636c.763 4.753 6.354 5.861 9.289 3.022l-5.562-5.75a2.44 2.44 0 0 1 2.388-.58 2.57 2.57 0 0 1 1.783 2.039zm9.289 3.022a52 52 0 0 1 4.86-4.145l-4.809-6.393a59 59 0 0 0-5.613 4.788zm-1.357-6.13c5.36 16.875 16.963 29.41 29.403 37.69C96.537 199.702 110.14 204 120 204v-8c-7.921 0-20.006-3.607-31.394-11.187-11.312-7.53-21.527-18.709-26.21-33.452zM120 204c9.863 0 23.469-4.3 35.836-12.533 12.442-8.285 24.045-20.826 29.401-37.71l-7.625-2.419c-4.679 14.751-14.895 25.936-26.21 33.469C140.012 192.391 127.923 196 120 196zm59.015-48.259a52 52 0 0 1 4.854 4.154l5.573-5.739a59 59 0 0 0-5.609-4.801zm4.854 4.155c2.934 2.848 8.538 1.743 9.298-3.02l-7.9-1.262a2.57 2.57 0 0 1 1.785-2.042 2.44 2.44 0 0 1 2.39.584zm9.298-3.02q.05-.312.097-.624l-7.912-1.186q-.04.273-.085.548zm.097-.624c1.475-9.833.727-19.824-2.194-29.392l-7.651 2.336c2.576 8.437 3.23 17.224 1.933 25.87zm-2.194-29.392a69 69 0 0 0-3.709-9.541l-7.223 3.438a61 61 0 0 1 3.281 8.439zm-3.709-9.541c-2.195-4.611-8.191-3.695-9.982.095l7.233 3.418a2.42 2.42 0 0 1-2.088 1.378 2.57 2.57 0 0 1-2.386-1.453zm-9.982.095c-3.628 7.678-9.576 14.39-17.162 19.425l4.425 6.665c8.698-5.773 15.668-13.569 19.97-22.672zm-17.162 19.425c-3.927 2.607-3.074 8.732 1.467 10.125l2.346-7.648a2.38 2.38 0 0 1 1.664 1.903 2.37 2.37 0 0 1-1.052 2.285zm1.467 10.125a58 58 0 0 1 6.112 2.255l3.188-7.337a66 66 0 0 0-6.954-2.566zm4.253-3.433c-2.58 4.411-5.843 8.687-9.227 11.803-3.513 3.236-6.544 4.666-8.71 4.666v8c5.229 0 10.162-3.127 14.13-6.782 4.098-3.774 7.832-8.723 10.712-13.647zM148 160c-1.123 0-2.238-.124-3.326-.363l-1.716 7.814c1.639.36 3.328.549 5.042.549zm-3.326-.363c-4.331-.951-7.12-4.083-8.95-9.13-1.865-5.141-2.457-11.616-2.621-17.844l-7.998.211c.169 6.385.771 13.944 3.098 20.361 2.362 6.511 6.763 12.46 14.755 14.216zm-11.571-26.974-1.104-41.769-7.998.212 1.104 41.768zm-4.796-37.675 23.23-1.787-.614-7.976-23.23 1.787zm23.23-1.787a7 7 0 0 0 6.463-6.98h-8a1 1 0 0 1 .923-.996zm6.463-6.98v-6.439h-8v6.44h8Zm0-6.439a7 7 0 0 0-6.473-6.98l-.602 7.977a1 1 0 0 1-.925-.997zm-6.473-6.98-23.726-1.79-.602 7.977 23.726 1.79zM127.5 71h-.052v8h.052zm3.946 3.862-.432-12.511-7.995.276.432 12.51zM120 61c7.732 0 14-6.268 14-14h-8a6 6 0 0 1-6 6zm-14-14c0 7.732 6.268 14 14 14v-8a6 6 0 0 1-6-6zm14-14c-7.732 0-14 6.268-14 14h8a6 6 0 0 1 6-6zm14 14c0-7.732-6.268-14-14-14v8a6 6 0 0 1 6 6z",
        mask: "url(#prefix__d)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8A380F",
        d: "M86 87.148a2 2 0 0 0 1.847 1.994L112 91l6.634-6.634a.8.8 0 0 0-.565-1.366H86z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8A380F",
        fillRule: "evenodd",
        d: "M182.124 118.814c.39-.585 1.264-.532 1.567.101a65 65 0 0 1 3.553 9.113c2.749 9.002 3.45 18.391 2.064 27.631q-.043.293-.091.586c-.192 1.205-1.686 1.631-2.562.781a56.7 56.7 0 0 0-11.091-8.361 1.553 1.553 0 0 1-.642-1.971c3.368-7.583 5.849-16.672 7.053-27.47a.94.94 0 0 1 .149-.41",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8A380F",
        d: "m127 62 .5 13-5.818 5.43c-.639.596-1.682.143-1.682-.731V62zm57 78c-4 40-44 60-64 60V84.5a1.5 1.5 0 0 1 1.5-1.5H154v3.285a3 3 0 0 1-2.701 2.985L128 91l1.104 41.769c.333 12.612 2.369 28.102 14.698 30.785 1.345.293 2.729.446 4.131.446-1.385.066-2.761.554-3.652 1.616-4.867 5.798-10.395 11.645-18.574 14.285 21.5 1 51.11-13.627 56.293-60.901z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8A380F",
        fillRule: "evenodd",
        d: "M121.998 59.898C120.899 60.01 120 60.895 120 62s.898 2.012 1.995 1.883a17 17 0 0 0 10.026-4.862A17 17 0 0 0 137 47.08a.08.08 0 0 0-.081-.081.08.08 0 0 0-.079.069c-1.053 6.73-7.166 12.036-14.842 12.828Z",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h240v240H0z"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__c"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 200,
        height: 200,
        x: 20,
        y: 40,
        fill: "#fff",
        rx: 40
    }))));

const PM2 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 210",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "67.1%",
        x2: "46.2%",
        y1: "64.7%",
        y2: "45.8%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#520BF5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#9D1FE0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#9D1FE0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "67.5%",
        x2: "42.4%",
        y1: "35%",
        y2: "56.9%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#9E1FA7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#E540AE"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "100%",
        x2: "30%",
        y1: "50%",
        y2: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4B6AF2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#4CA7EB"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m175.3 0-9.4 16a5.7 5.7 0 1 1-10-5.8L162 0h-16.7c0 1-.3 2-.8 2.9l-25.8 44.6C112.2 58.5 98.6 65 88 65h-8.3a5.7 5.7 0 0 1 0-11.5H88A28 28 0 0 0 108.4 42c2.9-4 11-18 24.4-42.1h-15.3C93.5 52 79 41.9 36 41.9l-8.5 13h30a5.7 5.7 0 0 1 0 11.4H20l-7.2 11.5L107 77h-4c5.7.1 15-3.2 19.4-10.3l22.3-35.2a5.7 5.7 0 1 1 9.7 6.2L132 73a35.6 35.6 0 0 1-29.3 15.6l-96.9.7a37 37 0 0 0-5.7 15.8h128.4L194 4.5c-4-2.4-10-4.3-17.6-4.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M128.5 105.1H0a30 30 0 0 0 5 18h86c13.4-1.5 25.3 4.1 35.6 16.7l21.6 34.9a5.7 5.7 0 1 1-9.7 6 329 329 0 0 0-24.3-36.5 29 29 0 0 0-23.2-9.6H12.3l7.7 12.2h30.7a5.7 5.7 0 0 1 0 11.5H27.2l7.3 11.5c51.7 0 59 5.8 76.7 40h15c-12.8-23-21-36.5-24.4-40.6-5-6.2-12-10.9-20.8-10.9h-8a5.7 5.7 0 0 1 0-11.5h8c12.2 0 25.9 7.8 30.8 17.4l27.3 44.6.5 1H160l-6.6-11.2a5.7 5.7 0 1 1 10-5.8l10 17h5c4 0 7-.4 12.6-4L128.5 105Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m194 4.5-8 12.2 10 14.8a5.7 5.7 0 0 1-9.6 6.4L179.2 27l-8 12 28.4 46.5a33.4 33.4 0 0 1-.4 35.5l-3.4 4.7a5.7 5.7 0 1 1-9.3-6.9l3.3-4.4a22 22 0 0 0 0-23l-25.5-41.7-36.4 55.3 28.6-43 14.1 21.7a33.7 33.7 0 0 1 0 36.8l-16.8 25.7-25.9-41.2 33.3 53 15.3-20.5a5.8 5.8 0 0 1 9.2 7l-18 23.9 8.8 13.9 42.3-67c4.8-7.5 4.9-17.4.2-25.1L198.5 57a5.7 5.7 0 0 1 9.8-6l20.4 33.1c7 11.4 7 26.1-.2 37.4l-44.7 70.7-.6.8 8 12.6c3.4-2.7 5.9-5 7.3-6.9 17-21.3 34.5-47 52.7-77a32 32 0 0 0 .3-33.2c-23.6-39-49.7-80.2-57.5-84"
    }));

const PandaCSS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 259",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F6E458",
        d: "M0 29.642C0 13.272 13.271 0 29.642 0h196.716C242.728 0 256 13.271 256 29.642v199.41c0 16.372-13.271 29.643-29.642 29.643H29.642C13.272 258.695 0 245.424 0 229.052z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M164.056 57.825c-14.124-4.057-28.53-4.609-43.212-3.296-8.216.854-16.114 2.485-23.732 5.347C80.644 66.06 68.28 76.774 60.908 92.904c-5.286 11.564-7.196 23.848-7.395 36.452-.21 13.32 1.459 26.455 4.11 39.478 2.405 11.804 5.607 23.377 10.179 34.55.434 1.06.975 1.418 2.135 1.416 14.461-.031 28.923-.031 43.385-.031h12.843c.328 0 .656-.019 1.033-.04q.286-.016.622-.031-.129-.31-.238-.575a20 20 0 0 0-.407-.953c-1.045-2.237-2.113-4.464-3.18-6.692-2.316-4.832-4.63-9.664-6.724-14.591-6.351-14.94-11.215-30.324-12.699-46.608-.654-7.185-.564-14.329 1.43-21.33 2.278-8.003 7.168-13.652 15.274-16.014 7.445-2.168 14.993-2.154 22.396.24 6.608 2.137 10.916 6.65 12.748 13.408 1.408 5.19 1.407 10.436.343 15.669-.82 4.028-2.47 7.705-5.441 10.645-5.33 5.275-11.985 6.489-19.126 6.084-1.27-.072-2.537-.21-3.842-.355q-.916-.1-1.864-.197.025.302.038.562c.018.343.034.64.104.925.305 1.223.595 2.451.885 3.679.699 2.958 1.397 5.915 2.295 8.81a170 170 0 0 0 6.14 16.654c16.577-1.294 31.843-5.414 48.047-15.141.244-.154.465-.292.687-.43 6.96-4.333 12.593-9.954 16.478-17.213 6.291-11.754 7.518-24.324 5.649-37.299-1.93-13.39-7.938-24.63-18.283-33.445-7.174-6.115-15.47-10.12-24.474-12.706"
    }));

const Parcel = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 193",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "49.4%",
        x2: "50.3%",
        y1: "49.5%",
        y2: "50.4%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "50.1%",
        x2: "49.9%",
        y1: "49.9%",
        y2: "50.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "81.5%",
        x2: "93.7%",
        y1: "46.5%",
        y2: "50.2%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#C37A44"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "44.4%",
        stopColor: "#BB713D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "64.1%",
        stopColor: "#A05728"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#964E23"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "63.5%",
        x2: "41.4%",
        y1: "61.3%",
        y2: "43.4%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#E9B880"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#E4AF76"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: "50.9%",
        x2: "49.2%",
        y1: "51.1%",
        y2: "49.3%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#C37A45",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "13.3%",
        stopColor: "#C37A45"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "29.4%",
        stopColor: "#D08D55"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "50.2%",
        stopColor: "#DEA167"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "69.7%",
        stopColor: "#E8AF73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "86.3%",
        stopColor: "#ECB477"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#ECB477",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "47.4%",
        x2: "22.3%",
        y1: "28.9%",
        y2: "77.5%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "8.8%",
        stopColor: "#AF6938"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "48.3%",
        stopColor: "#9A5227"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "77.9%",
        stopColor: "#8D4520"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: "41.1%",
        x2: "56.6%",
        y1: "57.3%",
        y2: "45%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "3.3%",
        stopColor: "#E4AF76"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#E9B880"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: "49.6%",
        x2: "50.7%",
        y1: "50.5%",
        y2: "49.2%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#AF6A38",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "8.6%",
        stopColor: "#AF6A38"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "19.8%",
        stopColor: "#B87542"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "58.3%",
        stopColor: "#D59C66"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "77.7%",
        stopColor: "#E4AF76"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "92.4%",
        stopColor: "#E4AF76",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: "8.2%",
        x2: "93.2%",
        y1: "50%",
        y2: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#743F1A",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "49.3%",
        stopColor: "#743F1A",
        stopOpacity: 0.9
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "50%",
        stopColor: "#743F1A",
        stopOpacity: 0.9
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "53%",
        stopColor: "#743F1A",
        stopOpacity: 0.8
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#743F1A",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__j",
        x1: "49.9%",
        x2: "50%",
        y1: "50.1%",
        y2: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#322214"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "24%",
        stopColor: "#322314"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#322214",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__k",
        x1: "51.4%",
        x2: "48.7%",
        y1: "48.2%",
        y2: "51.6%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "4.8%",
        stopColor: "#C69866"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "41.6%",
        stopColor: "#BA8C5E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "81.3%",
        stopColor: "#B5875B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__l",
        x1: "63%",
        x2: "25%",
        y1: "46.8%",
        y2: "8.9%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#845F35"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "43.1%",
        stopColor: "#91673C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "44.1%",
        stopColor: "#976A40"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.4%",
        stopColor: "#986B40"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#AB8157"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__m",
        x1: "50%",
        x2: "50.1%",
        y1: "50%",
        y2: "50.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#322214",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#322214"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__n",
        x1: "45.7%",
        x2: "50.5%",
        y1: "62.6%",
        y2: "33.5%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#A9794B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "38.6%",
        stopColor: "#AE7F53"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "45.6%",
        stopColor: "#AC7D50"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "62.4%",
        stopColor: "#A9794B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#B2875D"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m140.5 191.3 70.3-44.4c.2-.2.6 0 .7.2.2.2.1.6-.1.7l-70.5 44.6h-.3v-1Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M140.6 192.5h-.2l-95.8-35.7a.5.5 0 0 1-.3-.7c.1-.3.4-.5.7-.4l95.5 35.6v1.2Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E8B67F",
        d: "m241.1 21.8-11 18.3-44.5 19-2.5 1-39.9 37.3c-.8.8-1.3 1.9-1.4 2.5 0 .2-.2.1-.4 0-.1 0-.4.1-.4 0 0-.9-.1-1.8-1.4-2.6l-20-13L105 75 63.9 64.4l-34.4-8.8L7.7 21.7l.3-.4L90 0h.1L118 42l.5.8c.6.9.7 1.4.7 1.8h.5v-.8l.1-.4v-.2l.2-.5.1-.2a4.6 4.6 0 0 1 .5-.9L145.8 5s0-.1.2 0l95 16.3.1.4Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M119.6 84.4 105 74.9 63.9 64.4l55.3-19.9.1-.3v.3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M119.2 44.5 63.9 64.4l-5-1.3-29.4-7.6L7.7 21.7l.4-.4L89.9 0h.1l28 42 .5.8c.6.9.7 1.4.7 1.8Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M119.4 46.6 67 65.4l-8.1-2L118 42l.5.8c.6.9.7 1.4.7 1.8h.1v2Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D2A679",
        d: "m30.2 55.7-.7-.2L7.7 21.7l.3-.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "m185.6 59-2.5 1-39.9 37.4c-.8.8-1.3 1.9-1.4 2.5 0 .2-.2.1-.4 0-.1 0-.4.1-.4 0 0-.9-.1-1.8-1.4-2.6l-20-13-.3-39.8v-.3l.4.3 66 14.5Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "m241.1 21.8-11 18.3-40.5 17.2-4 1.7-66-14.5a6.2 6.2 0 0 1 1-2.8l25.2-36.6s0-.1.2 0l95 16.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "m189.6 57.3-6.4 2.7-.9.8-63-13.9.3-2.4c0-.5.4-1.7.8-2.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M121.1 44.8v40.5l-1.5-.9-2-1.3V45l1.6-.5h.5z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#BF9064",
        d: "m140.2 191.8-95.9-35.7c-.5-.3-.6-.8-.6-1.4L39.5 73c0-.2.3-.3.3-.5 0-.3-.7-1.5-.9-1.6L0 49l.3-.8L105 74.9l34.6 22.4c1.3.8 1.4 1.7 1.4 2.5 0 .2.3.2.4.2l.4-.1c.1-.6.6-1.7 1.4-2.5l40-37.3 72.3-30.8.5.6-39.1 34.3c-.8.8-1.1 1.7-1 2.1l-4 80c0 .6-.3.7-.8 1l-70 44.4c-.3.2-.6.3-1 .1Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#BD8F63",
        d: "m141.4 100-.7 91.9h-.5L44.3 156c-.5-.2-.6-.8-.6-1.4L39.5 73v-.1h.1v-.1l.1-.2L141 99.9c0 .1.3 0 .4 0Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__j)",
        d: "M140.8 191.6v.3h-.6L44.3 156c-.4-.2-.5-.5-.6-.9l97 36.4Z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#322214",
        d: "m97.4 135.9 37.1 12.1v36.2L98 170.8l-.6-35Zm18.6 24.3.1 16.8 18 6.6v-17.1l-18-6.3Zm5.3 5.4 3.7 5.8 3.5-3.1.6.7-3.6 3.2 3.6 5.8-.5.4-3.6-5.8-3.6 3.1-.6-.7 3.7-3.2-3.7-5.9zm10.7 6.5v1.7l1 .3v1.8l-1-.3v1.5l-2-3.2zm-3.2-2 .7.2v6.6l-.7-.2V170ZM98.1 154l.3 16.5 17.2 6.3-.1-16.8zm26.9 19.7 1.9 3-3.8-1.4zm2.9-2.8v4.3l-2-2.8zm-7.4-3.9.7.3v6.6l-.7-.3zm1.6 1.8 1.8 2.9-1.8 1.4zm-15.6-8 .7.3v.4c2.2.8 4.2 3 5.3 6.3-.7-1.1-1.3-1.4-2.3-1-.4-.8-1.5-1.2-2.2-.8a2 2 0 0 0-.7-.8v6.3c0 .6-.4 1.1-1.4.9-.9-.2-1.3-1-1.2-2h.5c0 .8.1 1.2.7 1.4.5 0 .7-.1.7-.6V165a1 1 0 0 0-.8.2c-.2-.6-1.3-1.3-2-.8-.7-.9-1.8-1.2-2.4-.6.8-2.3 3-3.1 5.1-2.5zM118 167l2 3.2-2 1.6v-1.5l-.9-.3v-1.8l1 .4V167Zm5.2.7 3.8 1.3-2 1.7zm-7.1-25.2v17l18 6.4v-17.5l-18-6Zm3.3 14.7 10.8 3.7v2.2l-10.8-3.7zm-9.3 4.1c.1 0 .1.8-.1 1h-.4c-.2-.2-.3-.3-.2-.6 0-.2.7-.5.7-.4m1-1.7c.1 0 .1.8-.1 1h-.4c-.2-.2-.3-.3-.2-.6 0-.2.7-.5.7-.4m-2.8 0c.1 0 .1.8-.1 1l-.4-.1c-.2-.1-.3-.3-.2-.5 0-.3.7-.5.7-.5Zm-2.8-.5c.1 0 .1.8-.1 1h-.5c-.1-.1-.2-.3-.1-.5 0-.3.6-.5.7-.5m22.3-11.2 2.6 5.2-1.8-.7v7.5l-1.8-.6V152l-1.7-.6 2.7-3.4Zm-29.9-11.4.3 16.9 17.4 6-.2-17.1zm24 9.4 2.6 5.2-1.8-.6v7.5l-1.8-.7V150l-1.8-.6 2.8-3.4Zm-20.1-6 1.4.5.7 2.4-.8-.1 2.1 5.1-1-4.2h.6l-.7-3 7.4 2.5v4c0 1.5-1.7 3.5-4 2.5v4l3.3 2.2-8-2.8 3.2.2v-4c-2.4-.7-4-3.5-4-5.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__k)",
        d: "M141.4 100c-.4 0-.7.5-.7 1L39.4 73c0-.2.2-.3.3-.4l-.9-1.7L0 49l.3-.8L105 74.9l34.6 22.4c1.3.8 1.4 1.7 1.4 2.5 0 .2.3.2.4.2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9C6B",
        d: "M216.9 64.2c-.8.8-1.1 1.7-1 2.1l-73.6 34.8h-.1c0-.7-.4-1-.7-1.1l.3-.1a2.7 2.7 0 0 1 .3-.9c.2-.4.5-1 1-1.4l.1-.2 40-37.4 72.4-30.7.4.6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M96 109.1h.1l-.3-20.4c0-.6-.2-2-1-2.6l-37-22.4-17.2-4.4L78 81.7c.9.6 1 1.8 1 2.6l.6 19.8v.1l16.3 5Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D4A271",
        d: "M141.4 100c-.4 0-.7.5-.7 1-.1-1-.6-2.3-1.2-2.7l-34.9-22.5.4-.9 34.6 22.4c1.3.8 1.4 1.7 1.4 2.5 0 .2.3.2.4.2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#DEB37E",
        d: "m105 74.9-.4.9L0 48.8l.3-.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#DBAD77",
        d: "m216 66.3-4 80c-.1.6-.3.7-.9 1l-70 44.4a1 1 0 0 1-.3.2l.6-92c.2 0 .4.2.4 0v-.1L216 66.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__m)",
        d: "M212 146.3c-.1.6-.3.7-.9 1l-70 44.4a1 1 0 0 1-.3.2v-.3z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#322214",
        d: "m210.6 111.5-1.6 32.6-23.3 14.5 1.2-34zm-12.4 23.6-11.6 6.8-.5 16 11.5-7.1zm-5.5 6.9v.5c1.3-.7 2.6-.2 3.2 2.1-.4-.5-1.1-.3-1.6.8-.2-.5-1.2-.1-1.4.8l-.4-.2-.3 6.2c0 .6 0 1.1-.7 1.5-.3.2-1.1.3-1-.9l.4-.3c0 .8.1 1 .5.7.5-.2.4-.7.5-1.1l.2-5.9c-.3.2-.6.5-.6.9-.2-.4-1.3-.1-1.5.9-.3-.5-1.2 0-1.5 1 .6-2.8 2.2-5.2 3.7-6.2v-.5zm16.9-13.6-11 6.5-.7 15.7 11-6.8zm-3.5 5.3.4.3-2.4 5.4 2 2.8-.4.7-2-2.8-2.3 5.4-.4-.3 2.5-5.4-2.1-2.9.4-.6 2 2.7zm-6.7 6.2 1.3 1.6-1.4 2.8v-1.2l-.5.3v-1.6l.6-.4V140Zm2.2-2-.3 6-.4.4.2-6 .5-.3Zm2 3.2 1.2 1.4-2.3 1.4 1.2-2.8Zm-12.2.5-.1 1-.3.2v-.3c0-.3.4-1 .4-1Zm10.7-2.8 1 1.3-1.2 2.4zm-7.6 1.5s0 .7-.2 1c0 .2-.1.3-.2.3s-.2-.1-.1-.4zm4.4-21.8-11.7 6.5-.6 16.4 11.6-6.8zm7.7 16.4-.2 6-.4.3.2-6zm-13.2 5s0 .6-.2 1l-.2.2c-.1 0-.2 0-.1-.3 0-.3.4-1 .5-1Zm12.2-3.3-.2 3.9-1-1.3zm2.5-1.8v1.5l.5-.3v1.6l-.6.3v1.4l-1.3-1.5zm-12.8 3s0 .8-.2 1.1l-.3.3v-.4zm9.7-2.2-1.2 2.8-1-1.5zm-8.8-13.7-.1 4.2c-.1 1.4-1.2 4-2.9 5l-.2 3.9 2.3-.5-5.5 3.1 2.3-2.1.1-3.9c-1.4.9-2.6-.7-2.5-2.2v-3.8l1-.5.4 1.8-.5.4 1.1 3.4-.4-3 .4-.5-.3-2.5zm14.2-9.8-11.2 6.2-.7 16.1 11.1-6.6zm-3 13.9v1.9l-6.6 3.8v-1.9l6.7-3.8Zm-4.6-8.3 1.5 3-1.1.7-.3 6.8-1 .6.1-6.8-1 .6zm3.7-2 1.4 3-1.2.6-.2 6.9-1.1.6.3-6.9-1 .6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D7AA77",
        d: "m183.7 60.8-39.6 36.8c-1 1.1-1.8 2.7-1.8 3.5 0 0-.1.1-.1 0 0-.6-.4-1-.7-1.1l.3-.1a2.7 2.7 0 0 1 .3-.9c.2-.5.6-1.1 1.1-1.6l40-37.3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__n)",
        d: "m175 105.5.1.1 12-6v-.2l.6-19.5c0-1 .6-2 1.5-2.8l39.4-35.5-12 5.1-39.7 36c-1 1-1.3 2.2-1.4 3.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F8CE93",
        d: "M183.7 60.8 256 29.9l-.4-.6L183.1 60z"
    }));

const PatreonDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        className: "prefix__logomark",
        viewBox: "0 0 36 40",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M35.975 11.392c0 .312.021.627-.004.937q-.047.542-.149 1.08a23 23 0 0 1-.331 1.512 9 9 0 0 1-.359 1.084c-.313.767-.66 1.518-1.117 2.21q-.423.64-.864 1.266a4 4 0 0 1-.37.431c-.225.238-.442.483-.686.695a14 14 0 0 1-1.123.905c-.356.25-.756.431-1.12.674-.404.268-.866.384-1.296.587-.384.18-.795.24-1.186.38-.498.18-1.021.222-1.531.331-.544.117-1.097.203-1.643.315-.449.09-.894.198-1.34.298-.254.056-.51.098-.756.173-.304.093-.6.214-.896.324-.201.072-.412.126-.604.219-.28.14-.544.315-.823.464-.457.242-.838.585-1.184.96-.292.32-.546.681-.8 1.036-.418.587-.706 1.244-.964 1.916-.254.657-.487 1.322-.725 1.986-.221.625-.43 1.252-.655 1.875a64 64 0 0 1-.618 1.615 13.5 13.5 0 0 1-1.12 2.215c-.331.531-.685 1.049-1.142 1.478-.366.343-.72.704-1.17.944-.446.24-.906.448-1.4.557a6.6 6.6 0 0 1-1.807.129c-.229-.012-.455-.075-.684-.117-.137-.026-.276-.047-.409-.089-.112-.035-.215-.097-.322-.151-.302-.147-.624-.264-.9-.448a9 9 0 0 1-.96-.776c-.554-.492-.97-1.103-1.342-1.74a13 13 0 0 1-.681-1.319c-.192-.436-.336-.893-.492-1.345a25 25 0 0 1-.34-1.063c-.092-.317-.165-.641-.243-.963-.073-.298-.15-.594-.212-.895-.112-.536-.215-1.073-.32-1.609a36 36 0 0 1-.133-.68c-.06-.34-.114-.681-.171-1.022-.044-.254-.092-.506-.13-.76-.044-.28-.08-.56-.124-.839-.036-.242-.078-.483-.112-.725q-.047-.339-.089-.678l-.094-.73q-.043-.354-.082-.707l-.096-.818q-.018-.145-.03-.291-.052-.602-.1-1.208c-.02-.25-.04-.501-.05-.75-.021-.39-.042-.777-.05-1.166A82 82 0 0 1 0 17.18c0-.378.002-.755.027-1.13.026-.392.08-.784.122-1.176.034-.312.064-.622.105-.934.023-.175.064-.348.1-.52.092-.432.176-.863.281-1.292.076-.31.181-.61.266-.916.157-.571.393-1.11.623-1.653.106-.25.236-.49.368-.725.186-.329.366-.66.576-.97q.388-.567.823-1.098a13 13 0 0 1 .873-.965c.24-.24.512-.448.77-.665.254-.212.501-.433.77-.624.412-.296.835-.576 1.263-.849.249-.158.514-.294.774-.434.405-.219.81-.44 1.22-.648.26-.13.527-.244.794-.354.683-.277 1.364-.557 2.055-.816.46-.17.932-.303 1.399-.452.24-.077.475-.161.717-.229.2-.056.402-.086.604-.133.22-.05.434-.119.656-.16.299-.059.603-.1.907-.147q.51-.08 1.02-.152c.139-.019.283-.02.425-.03q.707-.04 1.414-.077c.188-.01.382-.051.565-.019.443.08.889.017 1.332.05.428.03.853.076 1.278.127.306.038.608.103.914.15.268.04.535.065.802.107.215.035.43.081.645.128.46.103.919.196 1.374.317.404.11.797.275 1.204.37.469.113.899.332 1.351.479.462.149.86.424 1.3.608.515.217.96.546 1.418.858.347.238.685.492 1 .77q.701.615 1.356 1.28c.258.26.478.564.713.85.38.464.658.993.928 1.523.215.424.393.874.537 1.329.12.373.156.774.245 1.156.098.42.096.844.073 1.27z"
    }));

const PatreonLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        className: "prefix__logomark",
        viewBox: "0 0 36 40",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M35.975 11.392c0 .312.021.627-.004.937q-.047.542-.149 1.08a23 23 0 0 1-.331 1.512 9 9 0 0 1-.359 1.084c-.313.767-.66 1.518-1.117 2.21q-.423.64-.864 1.266a4 4 0 0 1-.37.431c-.225.238-.442.483-.686.695a14 14 0 0 1-1.123.905c-.356.25-.756.431-1.12.674-.404.268-.866.384-1.296.587-.384.18-.795.24-1.186.38-.498.18-1.021.222-1.531.331-.544.117-1.097.203-1.643.315-.449.09-.894.198-1.34.298-.254.056-.51.098-.756.173-.304.093-.6.214-.896.324-.201.072-.412.126-.604.219-.28.14-.544.315-.823.464-.457.242-.838.585-1.184.96-.292.32-.546.681-.8 1.036-.418.587-.706 1.244-.964 1.916-.254.657-.487 1.322-.725 1.986-.221.625-.43 1.252-.655 1.875a64 64 0 0 1-.618 1.615 13.5 13.5 0 0 1-1.12 2.215c-.331.531-.685 1.049-1.142 1.478-.366.343-.72.704-1.17.944-.446.24-.906.448-1.4.557a6.6 6.6 0 0 1-1.807.129c-.229-.012-.455-.075-.684-.117-.137-.026-.276-.047-.409-.089-.112-.035-.215-.097-.322-.151-.302-.147-.624-.264-.9-.448a9 9 0 0 1-.96-.776c-.554-.492-.97-1.103-1.342-1.74a13 13 0 0 1-.681-1.319c-.192-.436-.336-.893-.492-1.345a25 25 0 0 1-.34-1.063c-.092-.317-.165-.641-.243-.963-.073-.298-.15-.594-.212-.895-.112-.536-.215-1.073-.32-1.609a36 36 0 0 1-.133-.68c-.06-.34-.114-.681-.171-1.022-.044-.254-.092-.506-.13-.76-.044-.28-.08-.56-.124-.839-.036-.242-.078-.483-.112-.725q-.047-.339-.089-.678l-.094-.73q-.043-.354-.082-.707l-.096-.818q-.018-.145-.03-.291-.052-.602-.1-1.208c-.02-.25-.04-.501-.05-.75-.021-.39-.042-.777-.05-1.166A82 82 0 0 1 0 17.18c0-.378.002-.755.027-1.13.026-.392.08-.784.122-1.176.034-.312.064-.622.105-.934.023-.175.064-.348.1-.52.092-.432.176-.863.281-1.292.076-.31.181-.61.266-.916.157-.571.393-1.11.623-1.653.106-.25.236-.49.368-.725.186-.329.366-.66.576-.97q.388-.567.823-1.098a13 13 0 0 1 .873-.965c.24-.24.512-.448.77-.665.254-.212.501-.433.77-.624.412-.296.835-.576 1.263-.849.249-.158.514-.294.774-.434.405-.219.81-.44 1.22-.648.26-.13.527-.244.794-.354.683-.277 1.364-.557 2.055-.816.46-.17.932-.303 1.399-.452.24-.077.475-.161.717-.229.2-.056.402-.086.604-.133.22-.05.434-.119.656-.16.299-.059.603-.1.907-.147q.51-.08 1.02-.152c.139-.019.283-.02.425-.03q.707-.04 1.414-.077c.188-.01.382-.051.565-.019.443.08.889.017 1.332.05.428.03.853.076 1.278.127.306.038.608.103.914.15.268.04.535.065.802.107.215.035.43.081.645.128.46.103.919.196 1.374.317.404.11.797.275 1.204.37.469.113.899.332 1.351.479.462.149.86.424 1.3.608.515.217.96.546 1.418.858.347.238.685.492 1 .77q.701.615 1.356 1.28c.258.26.478.564.713.85.38.464.658.993.928 1.523.215.424.393.874.537 1.329.12.373.156.774.245 1.156.098.42.096.844.073 1.27z"
    }));

const PayPal = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "7.056 3 37.351 45",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        xmlns: "http://www.w3.org/2000/svg",
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#002991",
        d: "M38.914 13.35c0 5.574-5.144 12.15-12.927 12.15H18.49l-.368 2.322L16.373 39H7.056l5.605-36h15.095c5.083 0 9.082 2.833 10.555 6.77a9.7 9.7 0 0 1 .603 3.58"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#60CDFF",
        d: "M44.284 23.7A12.894 12.894 0 0 1 31.53 34.5h-5.206L24.157 48H14.89l1.483-9 1.75-11.178.367-2.322h7.497c7.773 0 12.927-6.576 12.927-12.15 3.825 1.974 6.055 5.963 5.37 10.35"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#008CFF",
        d: "M38.914 13.35C37.31 12.511 35.365 12 33.248 12h-12.64L18.49 25.5h7.497c7.773 0 12.927-6.576 12.927-12.15"
    })));

const PayloadCMSDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m126.675 216.375-74.5-43a3.02 3.02 0 0 1-1.5-2.6v-66.4c0-1.15 1.25-1.875 2.25-1.3l86.5 49.95c1.2.7 2.725-.175 2.725-1.575v-32.4c0-1.3-.7-2.475-1.8-3.125L36.25 55.8a2.98 2.98 0 0 0-3.025 0L19.6 63.675a3.02 3.02 0 0 0-1.5 2.6V189.7c0 1.075.575 2.075 1.5 2.6L126.475 254a2.98 2.98 0 0 0 3.025 0l89.75-51.825c1.2-.7 1.2-2.425 0-3.125l-28-16.175a3.61 3.61 0 0 0-3.625 0l-57.95 33.45a2.98 2.98 0 0 1-3.025 0zM236.4 63.675l-106.9-61.7a2.98 2.98 0 0 0-3.025 0L69.975 34.6c-1.2.7-1.2 2.425 0 3.125l27.75 16.025c1.125.65 2.5.65 3.625 0l25.3-14.6a2.98 2.98 0 0 1 3.025 0l74.5 43c.925.55 1.5 1.525 1.5 2.6v66.75c0 1.3.7 2.475 1.8 3.125l27.7 16c1.2.7 2.725-.175 2.725-1.575V66.3a2.99 2.99 0 0 0-1.5-2.6z"
    }));

const PayloadCMSLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#2F2F2F",
        d: "m126.675 216.375-74.5-43a3.02 3.02 0 0 1-1.5-2.6v-66.4c0-1.15 1.25-1.875 2.25-1.3l86.5 49.95c1.2.7 2.725-.175 2.725-1.575v-32.4c0-1.3-.7-2.475-1.8-3.125L36.25 55.8a2.98 2.98 0 0 0-3.025 0L19.6 63.675a3.02 3.02 0 0 0-1.5 2.6V189.7c0 1.075.575 2.075 1.5 2.6L126.475 254a2.98 2.98 0 0 0 3.025 0l89.75-51.825c1.2-.7 1.2-2.425 0-3.125l-28-16.175a3.61 3.61 0 0 0-3.625 0l-57.95 33.45a2.98 2.98 0 0 1-3.025 0zM236.4 63.675l-106.9-61.7a2.98 2.98 0 0 0-3.025 0L69.975 34.6c-1.2.7-1.2 2.425 0 3.125l27.75 16.025c1.125.65 2.5.65 3.625 0l25.3-14.6a2.98 2.98 0 0 1 3.025 0l74.5 43c.925.55 1.5 1.525 1.5 2.6v66.75c0 1.3.7 2.475 1.8 3.125l27.7 16c1.2.7 2.725-.175 2.725-1.575V66.3a2.99 2.99 0 0 0-1.5-2.6z"
    }));

const Peerlist = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 56 56",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00AA45",
        d: "M28 0C6.222 0 0 6.222 0 28s6.238 28 28 28 28-6.222 28-28S49.762 0 28 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#219653",
        fillRule: "evenodd",
        d: "M7.248 7.248C3.588 10.908 2 17.153 2 28s1.591 17.092 5.253 20.752S17.161 54 28 54s17.085-1.587 20.747-5.248C52.409 45.092 54 38.846 54 28s-1.591-17.092-5.253-20.752S38.839 2 28 2C17.153 2 10.908 3.588 7.248 7.248M0 28C0 6.222 6.222 0 28 0c21.762 0 28 6.222 28 28s-6.238 28-28 28S0 49.778 0 28",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#24292E",
        fillRule: "evenodd",
        d: "M27.077 13H15v34h9.385v-7.111h2.692C34.73 39.889 41 33.905 41 26.444 41 18.984 34.73 13 27.077 13m-2.692 17.778V22.11h2.692c2.542 0 4.538 1.975 4.538 4.333s-1.996 4.334-4.538 4.334z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M18 12h11.077C36.214 12 42 17.572 42 24.444S36.214 36.89 29.077 36.89h-3.692V44H18zm7.385 17.778h3.692c3.059 0 5.538-2.388 5.538-5.334s-2.48-5.333-5.538-5.333h-3.692z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#24292E",
        fillRule: "evenodd",
        d: "M17 11h12.077C36.73 11 43 16.984 43 24.444S36.73 37.89 29.077 37.89h-2.692V45H17zm2 2v30h5.385v-7.111h4.692c6.62 0 11.923-5.16 11.923-11.445S35.698 13 29.077 13zm5.385 5.111h4.692c3.575 0 6.538 2.8 6.538 6.333s-2.963 6.334-6.538 6.334h-4.692zm2 2v8.667h2.692c2.542 0 4.538-1.976 4.538-4.334s-1.996-4.333-4.538-4.333z",
        clipRule: "evenodd"
    }));

const PenpotDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#ffff",
        style: {
            width: "100%",
            height: "100%"
        },
        viewBox: "0 0 261.922 345.941",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m-68.324 280.346-36.377 51.236v28.963l-31.656 15.057-.286-.135V564.42l123.418 58.307 7.543 3.56 7.541-3.56 123.42-58.307V375.467l-.232.11-31.666-15.061v-28.934l-1.108-1.559-35.271-49.677-36.379 51.236v.05l-26.47-37.28-26.266 36.994-.94-1.323zm6.435 29.761 14.07 19.817H-88.83l13.906-19.584zm125.327 0 14.07 19.817H36.496L50.4 310.34zM.587 324.115l14.07 19.815h-41.01l13.905-19.584zM-92.72 339.91h19.451v65.496l-19.45-9.19zm29.438 0h19.353l-.002 79.356-19.353-9.143zm95.886 0H52.06l-.002 70.147-19.45 9.187zm29.438 0h19.353v56.285l-19.353 9.143zm-92.285 14.006h19.451v81.004l-19.451-9.19zm29.437 0H18.55l-.002 71.97-19.354 9.145zm94.184 21.525 17.125 7.002-17.125 8.09zm-198.08.026v15.09l-17.123-8.09zm-16.86 23.808 108.336 51.178v155.59l-108.336-51.178zm231.756 0v155.59L1.86 606.043v-155.59z",
        color: "#fff",
        fontFamily: "sans-serif",
        fontWeight: 400,
        overflow: "visible",
        style: {
            lineHeight: "normal",
            textIndent: 0,
            textAlign: "start",
            textDecorationLine: "none",
            textDecorationStyle: "solid",
            textDecorationColor: "#fff",
            textTransform: "none",
            blockProgression: "tb",
            whiteSpace: "normal",
            isolation: "auto",
            mixBlendMode: "normal",
            solidColor: "#fff",
            solidOpacity: 1
        },
        transform: "translate(136.643 -280.346)"
    }));

const PenpotLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 261.922 345.941",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m-68.324 280.346-36.377 51.236v28.963l-31.656 15.057-.286-.135V564.42l123.418 58.307 7.543 3.56 7.541-3.56 123.42-58.307V375.467l-.232.11-31.666-15.061v-28.934l-1.108-1.559-35.271-49.677-36.379 51.236v.05l-26.47-37.28-26.266 36.994-.94-1.323zm6.435 29.761 14.07 19.817H-88.83l13.906-19.584zm125.327 0 14.07 19.817H36.496L50.4 310.34zM.587 324.115l14.07 19.815h-41.01l13.905-19.584zM-92.72 339.91h19.451v65.496l-19.45-9.19zm29.438 0h19.353l-.002 79.356-19.353-9.143zm95.886 0H52.06l-.002 70.147-19.45 9.187zm29.438 0h19.353v56.285l-19.353 9.143zm-92.285 14.006h19.451v81.004l-19.451-9.19zm29.437 0H18.55l-.002 71.97-19.354 9.145zm94.184 21.525 17.125 7.002-17.125 8.09zm-198.08.026v15.09l-17.123-8.09zm-16.86 23.808 108.336 51.178v155.59l-108.336-51.178zm231.756 0v155.59L1.86 606.043v-155.59z",
        color: "#000",
        fontFamily: "sans-serif",
        fontWeight: 400,
        overflow: "visible",
        style: {
            lineHeight: "normal",
            textIndent: 0,
            textAlign: "start",
            textDecorationLine: "none",
            textDecorationStyle: "solid",
            textDecorationColor: "#000",
            textTransform: "none",
            blockProgression: "tb",
            whiteSpace: "normal",
            isolation: "auto",
            mixBlendMode: "normal",
            solidColor: "#000",
            solidOpacity: 1
        },
        transform: "translate(136.643 -280.346)"
    }));

const PerplexityAI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#20808d",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M24 4.5v39M13.73 16.573v-9.99L24 16.573m0 14.5L13.73 41.417V27.01L24 16.573m0 0 10.27-9.99v9.99"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#20808d",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.73 31.396H9.44V16.573h29.12v14.823h-4.29"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#20808d",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M24 16.573 34.27 27.01v14.407L24 31.073"
    }));

const PerspectiveDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#363636",
        d: "M6.718 6.718c1.2-1.2 2.708-1.837 5.333-2.162C13.986 4.316 16.527 4 20 4c3.592 0 6.188.321 8.146.581 2.504.332 3.966.967 5.136 2.137 1.173 1.174 1.809 2.64 2.14 5.159.257 1.955.578 4.545.578 8.123 0 3.598-.322 6.197-.582 8.156-.333 2.498-.968 3.957-2.136 5.126-1.158 1.158-2.603 1.792-5.061 2.127-1.967.268-4.583.591-8.221.591-3.519 0-6.081-.318-8.025-.565-2.578-.328-4.068-.965-5.257-2.153-1.157-1.157-1.791-2.6-2.126-5.055C4.324 26.26 4 23.642 4 20c0-3.485.317-6.033.558-7.97.326-2.612.963-4.115 2.16-5.312",
        style: {
            fill: "#363636",
            fill: "color(display-p3 .2118 .2118 .2118)",
            fillOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M26.35 13.72c1.687 2.347 1.595 6.076-.227 8.39-1.59 2.016-4.99 2.872-8.618 1.2v6.49h-2.95V11.47h2.866l.049.822c4.31-1.542 7.069-1.09 8.88 1.429Zm-3.494 7.335c1.01-.671 1.648-1.902 1.635-3.385-.019-2.225-1.47-3.835-3.461-3.84a3.38 3.38 0 0 0-2.04.673c-.482.328-.884.78-1.153 1.33-.835 1.71-.43 3.944.933 5.03 1.082.863 2.316 1.053 3.558.486q.041-.02.082-.04l.057-.03a3 3 0 0 0 .372-.212z",
        clipRule: "evenodd",
        style: {
            fill: "#fff",
            fillOpacity: 1
        }
    }));

const PerspectiveLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M6.718 6.718c1.2-1.2 2.708-1.837 5.333-2.162C13.986 4.316 16.527 4 20 4c3.592 0 6.188.321 8.146.581 2.504.332 3.966.967 5.136 2.137 1.173 1.174 1.809 2.64 2.14 5.159.257 1.955.578 4.545.578 8.123 0 3.598-.322 6.197-.582 8.156-.333 2.498-.968 3.957-2.136 5.126-1.158 1.158-2.603 1.792-5.061 2.127-1.967.268-4.583.591-8.221.591-3.519 0-6.081-.318-8.025-.565-2.578-.328-4.068-.965-5.257-2.153-1.157-1.157-1.791-2.6-2.126-5.055C4.324 26.26 4 23.642 4 20c0-3.485.317-6.033.558-7.97.326-2.612.963-4.115 2.16-5.312",
        style: {
            fill: "#fff",
            fillOpacity: 1
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#363636",
        fillRule: "evenodd",
        d: "M26.35 13.72c1.687 2.347 1.595 6.076-.227 8.39-1.59 2.016-4.99 2.872-8.618 1.2v6.49h-2.95V11.47h2.866l.049.822c4.31-1.542 7.069-1.09 8.88 1.429Zm-3.494 7.335c1.01-.671 1.648-1.902 1.635-3.385-.019-2.225-1.47-3.835-3.461-3.84a3.38 3.38 0 0 0-2.04.673c-.482.328-.884.78-1.153 1.33-.835 1.71-.43 3.944.933 5.03 1.082.863 2.316 1.053 3.558.486q.041-.02.082-.04l.057-.03a3 3 0 0 0 .372-.212z",
        clipRule: "evenodd",
        style: {
            fill: "#363636",
            fill: "color(display-p3 .2118 .2118 .2118)",
            fillOpacity: 1
        }
    }));

const Photoshop = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 83 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#001E36",
        d: "M67.521 0H14.53C6.505 0 0 6.505 0 14.53v50.94C0 73.495 6.505 80 14.53 80H67.52c8.025 0 14.53-6.505 14.53-14.53V14.53C82.051 6.505 75.546 0 67.521 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#31A8FF",
        d: "M18.476 56.1V20.929q0-.384.33-.385c.587 0 1.122-.008 1.93-.027a1025 1025 0 0 1 5.587-.11q1.568-.028 3.11-.028 4.182 0 7.045 1.046a12.2 12.2 0 0 1 4.596 2.807 10.8 10.8 0 0 1 2.504 3.88c.515 1.42.776 2.92.771 4.431q0 4.405-2.036 7.266a11.5 11.5 0 0 1-5.505 4.156c-2.312.862-4.88 1.155-7.706 1.155q-1.21 0-1.706-.028-.495-.027-1.486-.027v10.982a.438.438 0 0 1-.496.495h-6.553q-.385 0-.385-.44m7.434-28.952V38.62q.714.055 1.32.055h1.817a12.9 12.9 0 0 0 3.936-.628 5.94 5.94 0 0 0 2.807-1.817q1.073-1.265 1.073-3.522a5.57 5.57 0 0 0-.798-3.028 5.13 5.13 0 0 0-2.394-1.954 10.2 10.2 0 0 0-4.018-.688q-1.32 0-2.34.028t-1.403.082M65.631 36.534a12.9 12.9 0 0 0-3.275-1.156 17.4 17.4 0 0 0-3.825-.44 7.1 7.1 0 0 0-2.064.247 1.85 1.85 0 0 0-1.074.688c-.18.28-.275.604-.275.936.01.322.126.632.33.88.322.377.715.686 1.156.91q1.178.634 2.422 1.128a24 24 0 0 1 5.256 2.504 8 8 0 0 1 2.698 2.835 7.56 7.56 0 0 1 .798 3.522 7.9 7.9 0 0 1-1.321 4.541 8.7 8.7 0 0 1-3.826 3.055q-2.505 1.1-6.192 1.101a22.4 22.4 0 0 1-4.651-.44 14.8 14.8 0 0 1-3.495-1.101.71.71 0 0 1-.386-.66v-5.945a.32.32 0 0 1 .138-.303.27.27 0 0 1 .303.028 14.7 14.7 0 0 0 4.238 1.678c1.315.33 2.663.505 4.018.523q1.926 0 2.835-.495a1.56 1.56 0 0 0 .908-1.431q0-.715-.826-1.376t-3.357-1.597a20.2 20.2 0 0 1-4.872-2.476 8.4 8.4 0 0 1-2.587-2.89 7.6 7.6 0 0 1-.798-3.495 7.9 7.9 0 0 1 1.156-4.129 8.4 8.4 0 0 1 3.578-3.137q2.422-1.21 6.055-1.211c1.418-.011 2.836.09 4.238.303a11.1 11.1 0 0 1 2.95.798.5.5 0 0 1 .33.303q.057.202.056.412v5.56a.37.37 0 0 1-.165.33.53.53 0 0 1-.474 0"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h82.051v80H0z"
    }))));

const PhpDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 -1 100 50",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M7.579 10.123h14.204q6.254.053 9.063 3.604 2.81 3.55 1.855 9.699-.37 2.81-1.643 5.512a16.4 16.4 0 0 1-3.392 4.876q-2.65 2.756-5.671 3.498a26 26 0 0 1-6.254.742h-6.36l-2.014 10.07H0zm6.201 6.042-3.18 15.9q.318.053.636.053h.742q5.088.053 8.48-1.007 3.392-1.113 4.558-7.738.954-5.565-1.908-6.413-2.809-.848-7.049-.795-.636.053-1.219.053h-1.113zM41.093 0h7.314L46.34 10.123h6.572q5.406.106 8.056 2.226 2.703 2.12 1.59 8.056l-3.551 17.649h-7.42L54.979 21.2q.53-2.65-.318-3.763c-.848-1.113-1.784-1.113-3.657-1.113l-5.883-.053-4.346 21.783h-7.314zm29.319 10.123h14.204q6.253.053 9.063 3.604 2.81 3.55 1.855 9.699-.37 2.81-1.643 5.512a16.4 16.4 0 0 1-3.392 4.876q-2.65 2.756-5.671 3.498a26 26 0 0 1-6.254.742h-6.36L70.2 48.124h-7.367zm6.201 6.042-3.18 15.9q.318.053.636.053h.742q5.088.053 8.48-1.007 3.392-1.113 4.558-7.738.954-5.565-1.908-6.413-2.809-.847-7.049-.795-.636.053-1.219.053H76.56z"
    }));

const PhpLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 -1 100 50",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.579 10.123h14.204q6.254.053 9.063 3.604 2.81 3.55 1.855 9.699-.37 2.81-1.643 5.512a16.4 16.4 0 0 1-3.392 4.876q-2.65 2.756-5.671 3.498a26 26 0 0 1-6.254.742h-6.36l-2.014 10.07H0zm6.201 6.042-3.18 15.9q.318.053.636.053h.742q5.088.053 8.48-1.007 3.392-1.113 4.558-7.738.954-5.565-1.908-6.413-2.809-.848-7.049-.795-.636.053-1.219.053h-1.113zM41.093 0h7.314L46.34 10.123h6.572q5.406.106 8.056 2.226 2.703 2.12 1.59 8.056l-3.551 17.649h-7.42L54.979 21.2q.53-2.65-.318-3.763c-.848-1.113-1.784-1.113-3.657-1.113l-5.883-.053-4.346 21.783h-7.314zm29.319 10.123h14.204q6.253.053 9.063 3.604 2.81 3.55 1.855 9.699-.37 2.81-1.643 5.512a16.4 16.4 0 0 1-3.392 4.876q-2.65 2.756-5.671 3.498a26 26 0 0 1-6.254.742h-6.36L70.2 48.124h-7.367zm6.201 6.042-3.18 15.9q.318.053.636.053h.742q5.088.053 8.48-1.007 3.392-1.113 4.558-7.738.954-5.565-1.908-6.413-2.809-.847-7.049-.795-.636.053-1.219.053H76.56z"
    }));

const Pinia = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 331",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "55.342%",
        x2: "42.817%",
        y1: "0%",
        y2: "42.863%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#52CE63"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#51A256"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "55.349%",
        x2: "42.808%",
        y1: "0%",
        y2: "42.863%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#52CE63"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#51A256"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "58.811%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#8AE99C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#52CE63"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "51.378%",
        x2: "44.585%",
        y1: "17.473%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFE56C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFC63A"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M67.56 173.328c30.366-2.985 41.08-27.648 44.735-64.823 3.654-37.175-21.174-70.814-31.502-69.799s-43.15 40.322-46.805 77.497c-3.654 37.175 3.205 60.11 33.572 57.125",
        transform: "rotate(-38 72.877 106.136)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M184.454 186.277c30.367 2.986 36.394-20.032 32.74-57.207-3.655-37.175-35.645-76.4-45.973-77.415s-35.989 32.542-32.334 69.717 15.201 61.92 45.567 64.905",
        transform: "rotate(52 178.34 119.085)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M129.232 151.601c27.341 0 34.878-26.184 34.878-67.013S138.531 3.745 129.232 3.745 93.605 43.758 93.605 84.588c0 40.829 8.286 67.013 35.627 67.013",
        transform: "rotate(7 128.858 77.673)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M113.386 330.307c56.896 0 103.038-16.528 103.038-91.482s-46.142-136.462-103.038-136.462c-56.897 0-103.002 61.507-103.002 136.462s46.105 91.482 103.002 91.482"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 165.427,
        cy: 216.677,
        fill: "#EAADCC",
        rx: 14.717,
        ry: 6.845
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 57.273,
        cy: 212.57,
        fill: "#EAADCC",
        rx: 14.717,
        ry: 6.845,
        transform: "rotate(7 57.273 212.57)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M96.266 210.285a2.054 2.054 0 1 0-3.406 2.295c3.151 4.676 7.997 7.39 14.373 8.119 6.348.725 12.016-.902 16.877-4.852a2.054 2.054 0 1 0-2.59-3.187c-3.999 3.249-8.563 4.559-13.82 3.958-5.23-.598-8.986-2.7-11.434-6.333M65.818 178.63a14.67 14.67 0 0 1 10.551 3.945 14.67 14.67 0 0 1 4.672 10.25 14.67 14.67 0 0 1-3.945 10.55 14.67 14.67 0 0 1-10.25 4.672 14.67 14.67 0 0 1-10.551-3.945 14.67 14.67 0 0 1-4.67-10.25 14.67 14.67 0 0 1 3.944-10.55 14.67 14.67 0 0 1 10.249-4.672"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M66.59 190.932a4.792 4.792 0 1 0-9.578.336 4.792 4.792 0 0 0 9.579-.336Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M154.99 182.366a14.67 14.67 0 0 1 10.552 3.944 14.67 14.67 0 0 1 4.67 10.25 14.67 14.67 0 0 1-3.944 10.551 14.67 14.67 0 0 1-10.25 4.671 14.67 14.67 0 0 1-10.55-3.945 14.67 14.67 0 0 1-4.672-10.25 14.67 14.67 0 0 1 3.945-10.55 14.67 14.67 0 0 1 10.25-4.671Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M65.71 175.552c9.824-.343 18.066 7.342 18.409 17.165s-7.342 18.065-17.166 18.408-18.064-7.342-18.407-17.166c-.343-9.823 7.341-18.064 17.164-18.407m12.252 17.38c-.224-6.423-5.613-11.448-12.037-11.223-6.422.224-11.447 5.612-11.222 12.035.224 6.424 5.612 11.448 12.035 11.224s11.448-5.612 11.224-12.036m76.921-13.645c9.824-.343 18.065 7.342 18.408 17.165s-7.342 18.065-17.165 18.408-18.065-7.342-18.408-17.165 7.342-18.065 17.165-18.408m12.251 17.38c-.224-6.423-5.612-11.447-12.036-11.223s-11.448 5.613-11.223 12.036 5.612 11.448 12.035 11.224c6.424-.225 11.448-5.613 11.224-12.037"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M155.763 194.668a4.792 4.792 0 1 0-9.578.335 4.792 4.792 0 0 0 9.578-.335"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ECB732",
        d: "m38.083 243.16 22.33 23.235 16.022-17.044a3.765 3.765 0 0 1 5.486 5.157l-16.283 17.324 23.1 24.036a3.765 3.765 0 1 1-5.43 5.218l-22.834-23.761-10.725 11.41a3.765 3.765 0 1 1-5.486-5.158l10.986-11.688-22.595-23.511a3.765 3.765 0 1 1 5.43-5.218Zm149.957 0a3.765 3.765 0 1 1 5.429 5.218l-22.596 23.511 10.988 11.688a3.765 3.765 0 0 1-.042 5.201l-.123.121a3.765 3.765 0 0 1-5.322-.165l-10.725-11.41-22.834 23.762a3.765 3.765 0 0 1-5.197.222l-.127-.116a3.765 3.765 0 0 1-.105-5.324l23.1-24.036-16.284-17.324a3.765 3.765 0 0 1 .042-5.2l.123-.121a3.765 3.765 0 0 1 5.321.164l16.021 17.044z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFC73B",
        d: "M136.602 126.74a3.765 3.765 0 0 1 0 5.323l-17.53 17.531 10.684 10.686a3.765 3.765 0 0 1 .12 5.2l-.12.125a3.765 3.765 0 0 1-5.324 0l-10.686-10.686-10.686 10.686a3.765 3.765 0 1 1-5.324-5.325l10.685-10.686-17.53-17.53a3.765 3.765 0 0 1-.12-5.2l.12-.125a3.765 3.765 0 0 1 5.324 0l17.531 17.53 17.531-17.53a3.765 3.765 0 0 1 5.325 0Z"
    }));

const Pinterest = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#CB1F27",
        d: "M0 128.002c0 52.414 31.518 97.442 76.619 117.239-.36-8.938-.064-19.668 2.228-29.393 2.461-10.391 16.47-69.748 16.47-69.748s-4.089-8.173-4.089-20.252c0-18.969 10.994-33.136 24.686-33.136 11.643 0 17.268 8.745 17.268 19.217 0 11.704-7.465 29.211-11.304 45.426-3.207 13.578 6.808 24.653 20.203 24.653 24.252 0 40.586-31.149 40.586-68.055 0-28.054-18.895-49.052-53.262-49.052-38.828 0-63.017 28.956-63.017 61.3 0 11.152 3.288 19.016 8.438 25.106 2.368 2.797 2.697 3.922 1.84 7.134-.614 2.355-2.024 8.025-2.608 10.272-.852 3.242-3.479 4.401-6.409 3.204-17.884-7.301-26.213-26.886-26.213-48.902 0-36.361 30.666-79.961 91.482-79.961 48.87 0 81.035 35.364 81.035 73.325 0 50.213-27.916 87.726-69.066 87.726-13.819 0-26.818-7.47-31.271-15.955 0 0-7.431 29.492-9.005 35.187-2.714 9.869-8.026 19.733-12.883 27.421a127.9 127.9 0 0 0 36.277 5.249c70.684 0 127.996-57.309 127.996-128.005C256.001 57.309 198.689 0 128.005 0 57.314 0 0 57.309 0 128.002"
    }));

const Pitch = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 57.6 65",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 63.187,
        x2: -8.41,
        y1: 171.884,
        y2: 146.689,
        gradientTransform: "matrix(1 0 0 -1 0 187.79)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#6b53ff"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#8d49f7"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5 27.5c-.6 8.7-7.6 16.6-16.4 16.9v-6.6c0-6-4.3-11.2-10.2-12.4l-22-4.3V6.4c0-4 3.6-7 7.6-6.2l22.7 4.4c12.4 2.7 19.1 12.3 18.3 22.9M16.7 48.3l-13-2.5c-1.9-.4-3.6 1.1-3.6 3v9C0 60 1.6 62 3.8 62.4l13 2.5c1.9.4 3.6-1.1 3.6-3v-9c.1-2.2-1.5-4.1-3.7-4.6m13.1-17.9L9.9 26.5c-2.9-.6-5.5 1.6-5.5 4.6v9.8h.1l13 2.5c4.5.9 7.8 4.9 7.8 9.5v2l5 1c2.9.6 5.5-1.6 5.5-4.6V37.9c.2-3.7-2.4-6.8-6-7.5",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "url(#prefix__a)"
        }
    }));

const PlanetScaleDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M256 128a128 128 0 0 1-128 128zM128 0c52 0 96.7 31 116.8 75.5L75.5 244.8q-10.95-4.95-20.7-11.7L160 128h-32l-90.5 90.5A128 128 0 0 1 128 0"
    }));

const PlanetScaleLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M256 128a128 128 0 0 1-128 128zM128 0c52 0 96.7 31 116.8 75.5L75.5 244.8q-10.95-4.95-20.7-11.7L160 128h-32l-90.5 90.5A128 128 0 0 1 128 0"
    }));

const Platzi = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            color: "#98ca3f"
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#98ca3f",
        d: "M10.64 1.13 2.49 9.28a3.84 3.84 0 0 0 0 5.44l8.15 8.15a3.84 3.84 0 0 0 5.44 0l2.72-2.71-2.72-2.72-2.72 2.72L5.2 12l8.16-8.16 5.44 5.44-5.44 5.44 2.72 2.72L21.5 12a3.84 3.84 0 0 0 0-5.44l-5.44-5.43a3.83 3.83 0 0 0-5.43 0z"
    }));

const PlayStation = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 122.88 95.18",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2.49 69.39c-4.61 3.07-3.07 8.9 6.75 11.67 10.13 3.38 21.18 4.3 31.93 2.46.61 0 1.23-.31 1.54-.31V72.76l-10.44 3.38c-3.99 1.23-7.98 1.54-11.97.61-3.07-.92-2.46-2.76 1.23-4.3l21.18-7.37V53.73L13.23 63.86a39.6 39.6 0 0 0-10.74 5.53m71.22-46.06v29.78c12.59 6.14 22.41 0 22.41-15.96 0-16.27-5.83-23.64-22.72-29.47C64.5 4.6 55.29 1.84 46.08 0v88.73l21.49 6.45V20.57c0-3.38 0-5.83 2.46-4.91 3.38.92 3.68 4.3 3.68 7.67m39.92 38.99c-8.9-3.07-18.42-4.3-27.63-3.38-4.91.31-9.52 1.54-13.82 3.07l-.92.31V74.3l19.96-7.37c3.99-1.23 7.98-1.54 11.97-.61 3.07.92 2.46 2.76-1.23 4.3l-30.7 11.36v11.67l42.37-15.66c3.07-1.23 5.83-2.76 8.29-5.22 2.15-3.08 1.23-7.38-8.29-10.45",
        style: {
            fill: "#0070d1"
        }
    }));

const Playwright = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 400 400",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#2D4552",
        d: "M136.444 221.556c-12.886 3.657-21.34 10.069-26.909 16.476 5.334-4.668 12.479-8.952 22.117-11.684 9.858-2.794 18.268-2.774 25.217-1.433v-5.434c-5.928-.542-12.724-.11-20.425 2.075m-27.498-45.68L61.09 188.484s.872 1.232 2.487 2.876l40.576-10.692s-.575 7.409-5.568 14.037c9.445-7.146 10.361-18.829 10.361-18.829m40.059 112.471C81.658 306.486 46.027 228.438 35.24 187.928c-4.984-18.699-7.16-32.861-7.74-42a15.5 15.5 0 0 1 .034-2.482c-3.494.211-5.167 2.027-4.826 7.275.58 9.134 2.755 23.295 7.74 42 10.782 40.504 46.418 118.552 113.765 100.413 14.659-3.949 25.672-11.142 33.939-20.324-7.62 6.882-17.157 12.302-29.147 15.537m12.656-160.237v4.793h26.416c-.542-1.697-1.088-3.226-1.63-4.793z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2D4552",
        d: "M193.981 167.584c11.88 3.374 18.163 11.703 21.484 19.074l13.246 3.762s-1.807-25.797-25.141-32.425c-21.829-6.202-35.262 12.129-36.896 14.501 6.35-4.524 15.623-8.228 27.307-4.912m105.441 19.193c-21.849-6.23-35.277 12.139-36.887 14.478 6.355-4.519 15.623-8.224 27.302-4.893 11.861 3.379 18.139 11.698 21.47 19.074l13.265 3.776s-1.836-25.802-25.15-32.435m-13.16 68.018-110.19-30.805s1.193 6.048 5.77 13.879l92.775 25.936c7.638-4.419 11.645-9.01 11.645-9.01m-76.395 66.307c-87.249-23.392-76.701-134.559-62.583-187.237 5.813-21.709 11.789-37.845 16.745-48.661-2.957-.609-5.406.949-7.826 5.87-5.262 10.673-11.991 28.05-18.503 52.376-14.114 52.677-24.662 163.84 62.583 187.232 41.123 11.017 73.159-5.727 97.04-32.023-22.668 20.531-51.609 32.042-87.456 22.443"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E2574C",
        d: "M161.661 262.296v-22.433l-62.329 17.674s4.606-26.76 37.112-35.981c9.858-2.794 18.269-2.775 25.217-1.433V128.11h31.208c-3.398-10.5-6.685-18.584-9.446-24.201-4.567-9.297-9.249-3.134-19.878 5.756-7.486 6.254-26.406 19.596-54.877 27.268-28.471 7.677-51.489 5.641-61.093 3.978-13.615-2.349-20.736-5.339-20.07 5.017.58 9.134 2.756 23.296 7.74 42 10.782 40.505 46.418 118.553 113.765 100.414 17.592-4.74 30.009-14.109 38.616-26.051h-25.965zM61.085 188.484l47.861-12.608s-1.395 18.412-19.337 23.142c-17.948 4.725-28.524-10.534-28.524-10.534"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2EAD33",
        d: "M341.786 129.174c-12.441 2.181-42.288 4.898-79.174-4.989-36.896-9.881-61.376-27.163-71.075-35.286-13.749-11.516-19.797-19.519-25.749-7.413-5.262 10.677-11.991 28.054-18.504 52.38-14.113 52.677-24.661 163.84 62.583 187.232 87.226 23.372 133.663-78.178 147.777-130.86 6.513-24.321 9.369-42.738 10.155-54.613.896-13.452-8.344-9.547-26.013-6.451m-175.289 43.582s13.749-21.384 37.068-14.756c23.334 6.628 25.141 32.425 25.141 32.425zm56.923 95.957c-41.017-12.015-47.343-44.723-47.343-44.723l110.185 30.806c0-.005-22.241 25.782-62.842 13.917m38.957-67.218s13.73-21.369 37.045-14.722c23.314 6.638 25.15 32.435 25.15 32.435z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D65348",
        d: "m139.88 246.04-40.548 11.492s4.405-25.092 34.275-35.036l-22.96-86.166-1.984.603c-28.471 7.678-51.489 5.641-61.093 3.978-13.615-2.348-20.736-5.339-20.07 5.018.58 9.134 2.756 23.295 7.74 42 10.782 40.504 46.418 118.552 113.765 100.413l1.984-.623zm-78.795-57.555 47.861-12.609s-1.395 18.412-19.337 23.142c-17.947 4.725-28.524-10.533-28.524-10.533"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1D8D22",
        d: "m225.27 269.163-1.855-.451c-41.017-12.014-47.343-44.722-47.343-44.722l56.818 15.882 30.081-115.591-.364-.096c-36.896-9.881-61.375-27.163-71.075-35.286-13.749-11.516-19.797-19.519-25.749-7.413-5.257 10.677-11.986 28.054-18.499 52.38-14.113 52.677-24.661 163.84 62.583 187.231l1.788.403zm-58.773-96.407s13.749-21.384 37.068-14.756c23.334 6.628 25.141 32.425 25.141 32.425z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C04B41",
        d: "m141.946 245.451-10.874 3.086c2.569 14.482 7.097 28.38 14.204 40.658 1.237-.273 2.464-.508 3.724-.853 3.302-.891 6.364-1.994 9.312-3.197-7.941-11.784-13.194-25.356-16.366-39.694m-4.246-102c-5.588 20.856-10.587 50.875-9.211 80.985 2.463-1.069 5.065-2.065 7.955-2.885l2.013-.45c-2.454-32.162 2.851-64.936 8.827-87.235a436 436 0 0 1 4.548-15.781 141 141 0 0 1-8.056 4.782 413 413 0 0 0-6.076 20.584"
    }));

const PnpmDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "76.59 44 164.008 164",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M237.6 95h-50V45h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__b",
        d: "M182.59 95h-50V45h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__c",
        d: "M127.59 95h-50V45h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__d",
        d: "M237.6 150h-50v-50h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__e",
        d: "M182.59 150h-50v-50h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__f",
        d: "M182.59 205h-50v-50h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__g",
        d: "M237.6 205h-50v-50h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__h",
        d: "M127.59 205h-50v-50h50z"
    })), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        fill: "#f9ad00"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#f9ad00"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__c",
        fill: "#f9ad00"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__d",
        fill: "#f9ad00"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#fff"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__f",
        fill: "#fff"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__g",
        fill: "#fff"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__h",
        fill: "#fff"
    }));

const PnpmLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "76.59 44 164.008 164",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M237.6 95h-50V45h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__b",
        d: "M182.59 95h-50V45h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__c",
        d: "M127.59 95h-50V45h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__d",
        d: "M237.6 150h-50v-50h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__e",
        d: "M182.59 150h-50v-50h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__f",
        d: "M182.59 205h-50v-50h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__g",
        d: "M237.6 205h-50v-50h50z"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__h",
        d: "M127.59 205h-50v-50h50z"
    })), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        fill: "#f9ad00"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#f9ad00"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__c",
        fill: "#f9ad00"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__d",
        fill: "#f9ad00"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__e",
        fill: "#4e4e4e"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__f",
        fill: "#4e4e4e"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__g",
        fill: "#4e4e4e"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__h",
        fill: "#4e4e4e"
    }));

const Pocketbase = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M9.46 170.336a8.467 8.467 0 0 1-8.468-8.467V9.459A8.467 8.467 0 0 1 9.46.992h152.41a8.467 8.467 0 0 1 8.467 8.467v76.205h76.205a8.467 8.467 0 0 1 8.467 8.467v152.41a8.467 8.467 0 0 1-8.467 8.467H94.13a8.467 8.467 0 0 1-8.467-8.467v-76.205Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#16161A",
        d: "M161.869 0H9.459A9.46 9.46 0 0 0 0 9.46v152.409l.004.27a9.46 9.46 0 0 0 9.455 9.19l75.213-.001v75.213a9.46 9.46 0 0 0 9.46 9.459H246.54a9.46 9.46 0 0 0 9.459-9.46V94.132l-.004-.27a9.46 9.46 0 0 0-9.455-9.19h-75.213V9.46A9.46 9.46 0 0 0 161.868 0Zm0 1.984a7.475 7.475 0 0 1 7.475 7.475v76.205c0 .548.444.992.992.992h76.205a7.475 7.475 0 0 1 7.475 7.475v152.41a7.474 7.474 0 0 1-7.475 7.475H94.13a7.475 7.475 0 0 1-7.475-7.475v-76.205a.99.99 0 0 0-.992-.992H9.46a7.475 7.475 0 0 1-7.475-7.475V9.459A7.475 7.475 0 0 1 9.46 1.984h152.41Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#16161A",
        d: "M57.44 128a7.056 7.056 0 0 1-7.056-7.056V43.328a7.056 7.056 0 0 1 7.056-7.056h26.482q7.694 0 14.373 1.548 6.824 1.407 11.76 4.924 5.082 3.376 7.985 9.144 2.904 5.628 2.904 13.928 0 8.02-3.049 13.928-2.903 5.91-7.985 9.708T98.15 95.08q-6.679 1.829-14.228 1.829h-5.14a7.056 7.056 0 0 0-7.056 7.055v16.98A7.056 7.056 0 0 1 64.67 128zm14.286-54.608a7.056 7.056 0 0 0 7.056 7.056h3.833q17.422 0 17.422-14.632 0-7.175-4.5-10.13-4.356-2.953-12.922-2.953h-3.833a7.056 7.056 0 0 0-7.056 7.055zm70.386 146.336a7.056 7.056 0 0 1-7.056-7.056v-77.616a7.056 7.056 0 0 1 7.056-7.056h24.61q7.373 0 13.59 1.125 6.363.986 10.99 3.658 4.626 2.674 7.229 7.034 2.748 4.362 2.747 10.975 0 3.094-1.012 6.19-.868 3.095-2.892 5.767-2.024 2.674-5.06 4.784-2.94 2.044-6.964 3.03a.35.35 0 0 0-.266.339c0 .167.121.31.285.341q9.91 1.85 15.042 6.982 5.205 5.205 5.205 14.491 0 7.035-2.747 12.099-2.748 5.064-7.664 8.441-4.915 3.236-11.567 4.924-6.505 1.548-14.17 1.548zm14.199-61.924a7.056 7.056 0 0 0 7.056 7.056h2.342q7.809 0 11.278-2.955t3.47-8.3q0-5.066-3.615-7.175-3.47-2.25-10.988-2.251h-2.487a7.056 7.056 0 0 0-7.056 7.056zm0 38.69a7.056 7.056 0 0 0 7.056 7.055h4.366q17.062 0 17.062-12.38 0-6.05-4.193-8.723-4.05-2.673-12.869-2.673h-4.366a7.056 7.056 0 0 0-7.056 7.056v9.664Z"
    }));

const PolarDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 300 300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M66.428 274.26c68.448 46.333 161.497 28.406 207.83-40.041 46.335-68.448 28.408-161.497-40.04-207.83C165.77-19.946 72.721-2.019 26.388 66.428c-46.336 68.45-28.408 161.5 40.039 207.832ZM47.956 116.67c-17.119 52.593-11.412 105.223 11.29 139.703C18.04 217.361 7.275 150.307 36.943 92.318c18.971-37.082 50.622-62.924 85.556-73.97C90.59 36.711 62.554 71.814 47.955 116.67Zm127.391 166.467c36.03-10.531 68.864-36.752 88.338-74.815 29.416-57.497 19.083-123.905-21.258-163.055 21.793 34.496 27.046 86.275 10.204 138.02-15.016 46.134-44.246 81.952-77.284 99.85m8.28-16.908c24.318-20.811 44.389-55.625 53.308-97.439 14.098-66.097-4.384-127.592-41.823-148.113 19.858 26.718 29.91 78.613 23.712 136.656-4.739 44.391-18.01 83.26-35.197 108.896M63.717 131.844c-14.201 66.586 4.66 128.501 42.657 148.561-20.378-26.396-30.777-78.891-24.498-137.694 4.661-43.657 17.574-81.974 34.349-107.614-23.957 20.886-43.687 55.392-52.507 96.747Zm136.117 17.717c1.074 67.912-20.244 123.317-47.612 123.748-27.369.433-50.425-54.27-51.498-122.182s20.244-123.318 47.613-123.75c27.368-.432 50.425 54.271 51.497 122.184",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h300v300H0z"
    }))));

const PolarLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 300 300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0062FF",
        fillRule: "evenodd",
        d: "M66.428 274.26c68.448 46.333 161.497 28.406 207.83-40.041 46.335-68.448 28.408-161.497-40.04-207.83C165.77-19.946 72.721-2.019 26.388 66.428c-46.336 68.45-28.408 161.5 40.039 207.832ZM47.956 116.67c-17.119 52.593-11.412 105.223 11.29 139.703C18.04 217.361 7.275 150.307 36.943 92.318c18.971-37.082 50.623-62.924 85.556-73.97C90.59 36.711 62.554 71.814 47.955 116.67Zm127.391 166.467c36.03-10.531 68.864-36.752 88.338-74.815 29.416-57.497 19.083-123.905-21.258-163.055 21.793 34.496 27.046 86.275 10.204 138.02-15.016 46.134-44.246 81.952-77.284 99.85m8.28-16.908c24.318-20.811 44.389-55.625 53.309-97.439 14.097-66.097-4.385-127.592-41.824-148.113 19.858 26.718 29.91 78.613 23.712 136.656-4.739 44.391-18.01 83.26-35.197 108.896M63.717 131.844c-14.201 66.586 4.66 128.501 42.657 148.561-20.378-26.396-30.777-78.891-24.498-137.694 4.661-43.657 17.574-81.974 34.349-107.614-23.957 20.886-43.687 55.392-52.507 96.747Zm136.117 17.717c1.074 67.912-20.244 123.317-47.612 123.748-27.369.433-50.425-54.27-51.498-122.182s20.244-123.318 47.613-123.75c27.368-.432 50.425 54.271 51.497 122.184",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h300v300H0z"
    }))));

const Polars = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 181 91",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        fillRule: "evenodd",
        d: "M1.499 68.093h4.15c.557 0 1.011.453 1.011 1.015v15.415c0 .559-.45 1.014-1.011 1.014h-4.15a1.013 1.013 0 0 1-1.012-1.014V69.108c0-.56.451-1.015 1.012-1.015m9.591-20.258h3.248c.808 0 1.46.657 1.46 1.464v18.794c0 .81-.655 1.464-1.46 1.464H11.09c-.807 0-1.46-.657-1.46-1.464V49.3c0-.81.656-1.464 1.46-1.464Zm-.45 24.206h4.15c.557 0 1.01.452 1.01 1.014v16.323c0 .559-.45 1.014-1.01 1.014h-4.15a1.01 1.01 0 0 1-1.012-1.014V73.055c0-.559.45-1.014 1.011-1.014Zm9.143-44.653h4.15c.557 0 1.011.452 1.011 1.014v30.564c0 .56-.45 1.015-1.011 1.015h-4.15a1.01 1.01 0 0 1-1.012-1.015V28.402c0-.559.451-1.014 1.012-1.014m0 35.462h4.15c.557 0 1.011.452 1.011 1.014v9.479c0 .559-.45 1.014-1.011 1.014h-4.15a1.013 1.013 0 0 1-1.012-1.014v-9.479c0-.559.451-1.014 1.012-1.014m.45 19.231h3.249c.807 0 1.46.657 1.46 1.464v5.378c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-5.378c0-.81.656-1.464 1.46-1.464Zm8.694-69.189h4.15c.557 0 1.01.453 1.01 1.015v21.618c0 .559-.45 1.014-1.01 1.014h-4.15a1.013 1.013 0 0 1-1.012-1.014V13.9c0-.56.451-1.015 1.012-1.015v.006Zm0 26.278h4.152a1.01 1.01 0 0 1 1.009 1.011v29.303c0 .559-.45 1.011-1.009 1.011h-4.152a1.01 1.01 0 0 1-1.009-1.011V40.18c0-.56.451-1.011 1.009-1.011ZM38.07 8.43h4.15c.558 0 1.011.453 1.011 1.015v14.416c0 .559-.45 1.014-1.01 1.014h-4.15a1.01 1.01 0 0 1-1.012-1.014V9.442c0-.558.45-1.014 1.011-1.014v.003Zm0 18.978h4.15c.558 0 1.011.452 1.011 1.015v20.74c0 .56-.45 1.015-1.01 1.015h-4.15a1.01 1.01 0 0 1-1.012-1.015v-20.74c0-.56.45-1.015 1.011-1.015m0 25.755h4.15c.558 0 1.011.452 1.011 1.014v18.636c0 .56-.45 1.014-1.01 1.014h-4.15a1.01 1.01 0 0 1-1.012-1.014V54.178c0-.559.45-1.014 1.011-1.014Zm9.588-48.35h3.249c.807 0 1.46.657 1.46 1.463v27.066c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.656-1.46-1.463V6.277c0-.81.655-1.463 1.46-1.463Zm0 32.984h3.249c.807 0 1.46.657 1.46 1.463v6.283c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-6.282c0-.81.655-1.464 1.46-1.464Zm0 11.3h3.246a1.46 1.46 0 0 1 1.459 1.463v27.97c0 .81-.655 1.463-1.46 1.463h-3.245a1.46 1.46 0 0 1-1.459-1.463V50.56c0-.81.655-1.464 1.46-1.464Zm9.144-47.9h3.248c.808 0 1.46.658 1.46 1.465V8.04c0 .81-.655 1.464-1.46 1.464h-3.248c-.807 0-1.46-.657-1.46-1.464V2.666c0-.81.656-1.464 1.46-1.464v-.003Zm0 10.842h3.248c.808 0 1.46.657 1.46 1.464v41.524c0 .81-.655 1.464-1.46 1.464h-3.248c-.807 0-1.46-.657-1.46-1.464v-41.52c0-.81.656-1.464 1.46-1.464zm0 47.443h3.248c.808 0 1.46.657 1.46 1.463v11.25c0 .81-.655 1.464-1.46 1.464h-3.248c-.807 0-1.46-.657-1.46-1.463v-11.25c0-.81.656-1.464 1.46-1.464m0 17.172h3.248c.808 0 1.46.657 1.46 1.463v7.187c0 .81-.655 1.463-1.46 1.463h-3.248c-.807 0-1.46-.656-1.46-1.463v-7.187c0-.81.656-1.463 1.46-1.463m9.144-2.261h3.248c.807 0 1.46.657 1.46 1.463V88.92c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463V75.856c0-.81.655-1.463 1.46-1.463m0-45.182h3.248c.807 0 1.46.657 1.46 1.463V62.71c0 .81-.656 1.464-1.46 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464V30.675c0-.81.655-1.463 1.46-1.463Zm0-28.468h3.248c.807 0 1.46.657 1.46 1.463v22.547c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.656-1.46-1.463V2.21c0-.81.655-1.463 1.46-1.463V.744Zm9.143 80.427h3.248c.808 0 1.46.657 1.46 1.463v6.283c0 .81-.655 1.463-1.46 1.463H75.09c-.807 0-1.46-.657-1.46-1.463v-6.282c0-.81.656-1.464 1.46-1.464Zm0-79.975h3.248c.808 0 1.46.657 1.46 1.463V41.02c0 .81-.655 1.464-1.46 1.464H75.09c-.807 0-1.46-.657-1.46-1.463V2.662c0-.81.656-1.463 1.46-1.463v-.003Zm0 44.28h3.248c.808 0 1.46.657 1.46 1.464v15.77c0 .809-.655 1.463-1.46 1.463H75.09c-.807 0-1.46-.657-1.46-1.464V46.94c0-.809.656-1.463 1.46-1.463Zm9.138-42.471h3.248c.807 0 1.46.657 1.46 1.463v10.799c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463V4.47c0-.81.656-1.463 1.46-1.463zm0 16.716h3.248c.807 0 1.46.657 1.46 1.464v41.524c0 .81-.656 1.464-1.46 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464V21.19c0-.81.656-1.465 1.46-1.465v-.003Zm9.14-15.812h3.248c.808 0 1.46.657 1.46 1.464v23.903c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464v-23.9c0-.81.655-1.464 1.46-1.464V3.91Zm0 29.822h3.248c.808 0 1.46.657 1.46 1.464v19.84c0 .809-.655 1.463-1.46 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.464v-19.84c0-.81.655-1.463 1.46-1.463Zm0 25.752h3.248c.808 0 1.46.657 1.46 1.463v8.993c0 .81-.655 1.463-1.46 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.463v-8.993c0-.81.655-1.463 1.46-1.463Zm9.086-54.217h3.248c.807 0 1.459.657 1.459 1.463v37.006a1.46 1.46 0 0 1-1.459 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.463V6.732c0-.81.655-1.463 1.459-1.463zm0 42.924h3.248c.807 0 1.459.657 1.459 1.463v29.324a1.46 1.46 0 0 1-1.459 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.463V49.653c0-.81.655-1.463 1.459-1.463Zm9.08-44.28h3.248a1.46 1.46 0 0 1 1.459 1.463v15.77c0 .809-.655 1.463-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.464V5.376c0-.81.655-1.464 1.46-1.464V3.91Zm0 21.687h3.248c.807 0 1.459.657 1.459 1.464v46.046c0 .81-.655 1.464-1.459 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464V27.064c0-.81.655-1.464 1.46-1.464v-.003Zm0 51.962h3.248c.807 0 1.459.657 1.459 1.464v8.54c0 .81-.655 1.464-1.459 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464v-8.54c0-.81.655-1.464 1.46-1.464m9.14-2.71h3.248c.808 0 1.46.657 1.46 1.464v12.606c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.463V76.313c0-.81.655-1.464 1.459-1.464Zm0-38.405h3.248c.808 0 1.46.657 1.46 1.464v8.543c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464v-8.543c0-.81.655-1.464 1.459-1.464m0-32.984h3.248c.808 0 1.46.657 1.46 1.464V31.99c0 .81-.655 1.463-1.46 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.464V4.924c0-.81.655-1.464 1.459-1.464Zm9.266 2.261h3.248c.807 0 1.459.657 1.459 1.464V41.48a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463V7.185c0-.81.655-1.464 1.46-1.464Zm0 76.36h3.248c.807 0 1.459.657 1.459 1.464v5.378a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-5.378c0-.81.655-1.464 1.46-1.464m9.012-73.647h3.248c.808 0 1.46.657 1.46 1.464v8.543c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464V9.898c0-.81.655-1.464 1.459-1.464Zm0 14.456h3.248c.808 0 1.46.657 1.46 1.464v16.221c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464v-16.22c0-.81.655-1.464 1.459-1.464Zm9.257-12.2h3.248a1.46 1.46 0 0 1 1.459 1.463v5.378a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-5.378c0-.81.655-1.464 1.46-1.464Zm0 10.843h3.248c.807 0 1.459.657 1.459 1.464v4.925c0 .81-.655 1.464-1.459 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464v-4.925c0-.81.655-1.464 1.46-1.464m0 10.392h3.248c.807 0 1.459.657 1.459 1.464v8.088a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-8.088c0-.81.655-1.464 1.46-1.464m9.14-18.522h3.248c.807 0 1.46.657 1.46 1.463v27.97c0 .81-.656 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464V14.863c0-.81.655-1.463 1.459-1.463zm9.083 8.13h3.248c.807 0 1.459.657 1.459 1.464v18.932a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.656-1.46-1.463V22.997c0-.81.655-1.464 1.46-1.464Zm9.012 10.392h3.248c.808 0 1.46.657 1.46 1.464v5.377c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464V33.39c0-.81.655-1.464 1.459-1.464Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        fillRule: "evenodd",
        d: "M1.499 68.093h4.15c.557 0 1.011.453 1.011 1.015v15.415c0 .559-.45 1.014-1.011 1.014h-4.15a1.013 1.013 0 0 1-1.012-1.014V69.108c0-.56.451-1.015 1.012-1.015m9.591-20.258h3.248c.808 0 1.46.657 1.46 1.464v18.794c0 .81-.655 1.464-1.46 1.464H11.09c-.807 0-1.46-.657-1.46-1.464V49.3c0-.81.656-1.464 1.46-1.464Zm-.45 24.206h4.15c.557 0 1.01.452 1.01 1.014v16.323c0 .559-.45 1.014-1.01 1.014h-4.15a1.01 1.01 0 0 1-1.012-1.014V73.055c0-.559.45-1.014 1.011-1.014Zm9.143-44.653h4.15c.557 0 1.011.452 1.011 1.014v30.564c0 .56-.45 1.015-1.011 1.015h-4.15a1.01 1.01 0 0 1-1.012-1.015V28.402c0-.559.451-1.014 1.012-1.014m0 35.462h4.15c.557 0 1.011.452 1.011 1.014v9.479c0 .559-.45 1.014-1.011 1.014h-4.15a1.013 1.013 0 0 1-1.012-1.014v-9.479c0-.559.451-1.014 1.012-1.014m.45 19.231h3.249c.807 0 1.46.657 1.46 1.464v5.378c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-5.378c0-.81.656-1.464 1.46-1.464Zm8.694-69.189h4.15c.557 0 1.01.453 1.01 1.015v21.618c0 .559-.45 1.014-1.01 1.014h-4.15a1.013 1.013 0 0 1-1.012-1.014V13.9c0-.56.451-1.015 1.012-1.015v.006Zm0 26.278h4.152a1.01 1.01 0 0 1 1.009 1.011v29.303c0 .559-.45 1.011-1.009 1.011h-4.152a1.01 1.01 0 0 1-1.009-1.011V40.18c0-.56.451-1.011 1.009-1.011ZM38.07 8.43h4.15c.558 0 1.011.453 1.011 1.015v14.416c0 .559-.45 1.014-1.01 1.014h-4.15a1.01 1.01 0 0 1-1.012-1.014V9.442c0-.558.45-1.014 1.011-1.014v.003Zm0 18.978h4.15c.558 0 1.011.452 1.011 1.015v20.74c0 .56-.45 1.015-1.01 1.015h-4.15a1.01 1.01 0 0 1-1.012-1.015v-20.74c0-.56.45-1.015 1.011-1.015m0 25.755h4.15c.558 0 1.011.452 1.011 1.014v18.636c0 .56-.45 1.014-1.01 1.014h-4.15a1.01 1.01 0 0 1-1.012-1.014V54.178c0-.559.45-1.014 1.011-1.014Zm9.588-48.35h3.249c.807 0 1.46.657 1.46 1.463v27.066c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.656-1.46-1.463V6.277c0-.81.655-1.463 1.46-1.463Zm0 32.984h3.249c.807 0 1.46.657 1.46 1.463v6.283c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-6.282c0-.81.655-1.464 1.46-1.464Zm0 11.3h3.246a1.46 1.46 0 0 1 1.459 1.463v27.97c0 .81-.655 1.463-1.46 1.463h-3.245a1.46 1.46 0 0 1-1.459-1.463V50.56c0-.81.655-1.464 1.46-1.464Zm9.144-47.9h3.248c.808 0 1.46.658 1.46 1.465V8.04c0 .81-.655 1.464-1.46 1.464h-3.248c-.807 0-1.46-.657-1.46-1.464V2.666c0-.81.656-1.464 1.46-1.464v-.003Zm0 10.842h3.248c.808 0 1.46.657 1.46 1.464v41.524c0 .81-.655 1.464-1.46 1.464h-3.248c-.807 0-1.46-.657-1.46-1.464v-41.52c0-.81.656-1.464 1.46-1.464zm0 47.443h3.248c.808 0 1.46.657 1.46 1.463v11.25c0 .81-.655 1.464-1.46 1.464h-3.248c-.807 0-1.46-.657-1.46-1.463v-11.25c0-.81.656-1.464 1.46-1.464m0 17.172h3.248c.808 0 1.46.657 1.46 1.463v7.187c0 .81-.655 1.463-1.46 1.463h-3.248c-.807 0-1.46-.656-1.46-1.463v-7.187c0-.81.656-1.463 1.46-1.463m9.144-2.261h3.248c.807 0 1.46.657 1.46 1.463V88.92c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463V75.856c0-.81.655-1.463 1.46-1.463m0-45.182h3.248c.807 0 1.46.657 1.46 1.463V62.71c0 .81-.656 1.464-1.46 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464V30.675c0-.81.655-1.463 1.46-1.463Zm0-28.468h3.248c.807 0 1.46.657 1.46 1.463v22.547c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.656-1.46-1.463V2.21c0-.81.655-1.463 1.46-1.463V.744Zm9.143 80.427h3.248c.808 0 1.46.657 1.46 1.463v6.283c0 .81-.655 1.463-1.46 1.463H75.09c-.807 0-1.46-.657-1.46-1.463v-6.282c0-.81.656-1.464 1.46-1.464Zm0-79.975h3.248c.808 0 1.46.657 1.46 1.463V41.02c0 .81-.655 1.464-1.46 1.464H75.09c-.807 0-1.46-.657-1.46-1.463V2.662c0-.81.656-1.463 1.46-1.463v-.003Zm0 44.28h3.248c.808 0 1.46.657 1.46 1.464v15.77c0 .809-.655 1.463-1.46 1.463H75.09c-.807 0-1.46-.657-1.46-1.464V46.94c0-.809.656-1.463 1.46-1.463Zm9.138-42.471h3.248c.807 0 1.46.657 1.46 1.463v10.799c0 .81-.656 1.463-1.46 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463V4.47c0-.81.656-1.463 1.46-1.463zm0 16.716h3.248c.807 0 1.46.657 1.46 1.464v41.524c0 .81-.656 1.464-1.46 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464V21.19c0-.81.656-1.465 1.46-1.465v-.003Zm9.14-15.812h3.248c.808 0 1.46.657 1.46 1.464v23.903c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464v-23.9c0-.81.655-1.464 1.46-1.464V3.91Zm0 29.822h3.248c.808 0 1.46.657 1.46 1.464v19.84c0 .809-.655 1.463-1.46 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.464v-19.84c0-.81.655-1.463 1.46-1.463Zm0 25.752h3.248c.808 0 1.46.657 1.46 1.463v8.993c0 .81-.655 1.463-1.46 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.463v-8.993c0-.81.655-1.463 1.46-1.463Zm9.086-54.217h3.248c.807 0 1.459.657 1.459 1.463v37.006a1.46 1.46 0 0 1-1.459 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.463V6.732c0-.81.655-1.463 1.459-1.463zm0 42.924h3.248c.807 0 1.459.657 1.459 1.463v29.324a1.46 1.46 0 0 1-1.459 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.463V49.653c0-.81.655-1.463 1.459-1.463Zm9.08-44.28h3.248a1.46 1.46 0 0 1 1.459 1.463v15.77c0 .809-.655 1.463-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.464V5.376c0-.81.655-1.464 1.46-1.464V3.91Zm0 21.687h3.248c.807 0 1.459.657 1.459 1.464v46.046c0 .81-.655 1.464-1.459 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464V27.064c0-.81.655-1.464 1.46-1.464v-.003Zm0 51.962h3.248c.807 0 1.459.657 1.459 1.464v8.54c0 .81-.655 1.464-1.459 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464v-8.54c0-.81.655-1.464 1.46-1.464m9.14-2.71h3.248c.808 0 1.46.657 1.46 1.464v12.606c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.463V76.313c0-.81.655-1.464 1.459-1.464Zm0-38.405h3.248c.808 0 1.46.657 1.46 1.464v8.543c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464v-8.543c0-.81.655-1.464 1.459-1.464m0-32.984h3.248c.808 0 1.46.657 1.46 1.464V31.99c0 .81-.655 1.463-1.46 1.463h-3.248a1.46 1.46 0 0 1-1.459-1.464V4.924c0-.81.655-1.464 1.459-1.464Zm9.266 2.261h3.248c.807 0 1.459.657 1.459 1.464V41.48a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463V7.185c0-.81.655-1.464 1.46-1.464Zm0 76.36h3.248c.807 0 1.459.657 1.459 1.464v5.378a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-5.378c0-.81.655-1.464 1.46-1.464m9.012-73.647h3.248c.808 0 1.46.657 1.46 1.464v8.543c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464V9.898c0-.81.655-1.464 1.459-1.464Zm0 14.456h3.248c.808 0 1.46.657 1.46 1.464v16.221c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464v-16.22c0-.81.655-1.464 1.459-1.464Zm9.257-12.2h3.248a1.46 1.46 0 0 1 1.459 1.463v5.378a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-5.378c0-.81.655-1.464 1.46-1.464Zm0 10.843h3.248c.807 0 1.459.657 1.459 1.464v4.925c0 .81-.655 1.464-1.459 1.464h-3.248c-.808 0-1.46-.657-1.46-1.464v-4.925c0-.81.655-1.464 1.46-1.464m0 10.392h3.248c.807 0 1.459.657 1.459 1.464v8.088a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.657-1.46-1.463v-8.088c0-.81.655-1.464 1.46-1.464m9.14-18.522h3.248c.807 0 1.46.657 1.46 1.463v27.97c0 .81-.656 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464V14.863c0-.81.655-1.463 1.459-1.463zm9.083 8.13h3.248c.807 0 1.459.657 1.459 1.464v18.932a1.46 1.46 0 0 1-1.459 1.463h-3.248c-.808 0-1.46-.656-1.46-1.463V22.997c0-.81.655-1.464 1.46-1.464Zm9.012 10.392h3.248c.808 0 1.46.657 1.46 1.464v5.377c0 .81-.655 1.464-1.46 1.464h-3.248a1.46 1.46 0 0 1-1.459-1.464V33.39c0-.81.655-1.464 1.459-1.464Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(-167.63677 71.00916 -144.91826 -342.11967 154.712 20.46)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0075FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0075FF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(-167.63677 71.00916 -144.91826 -342.11967 154.712 20.46)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0075FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0075FF",
        stopOpacity: 0
    }))));

const Polygon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 18,
        cy: 18,
        r: 18,
        fill: "#8247E5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M24.172 13.954c-.438-.25-1.002-.25-1.504 0l-3.509 2.068-2.38 1.316-3.447 2.068c-.439.25-1.003.25-1.504 0l-2.695-1.63a1.53 1.53 0 0 1-.752-1.315v-3.133c0-.502.25-1.003.752-1.316l2.695-1.567c.438-.25 1.002-.25 1.504 0l2.694 1.63c.439.25.752.751.752 1.315v2.068l2.381-1.378v-2.13c0-.502-.25-1.004-.752-1.317l-5.013-2.945c-.438-.25-1.002-.25-1.504 0l-5.138 3.008c-.501.25-.752.752-.752 1.253v5.89c0 .502.25 1.003.752 1.316l5.076 2.946c.438.25 1.002.25 1.504 0l3.446-2.006 2.381-1.378 3.447-2.006c.438-.25 1.002-.25 1.504 0l2.694 1.567c.439.25.752.752.752 1.316v3.133c0 .501-.25 1.003-.752 1.316l-2.632 1.567c-.438.25-1.002.25-1.504 0l-2.694-1.567a1.53 1.53 0 0 1-.752-1.316v-2.005L16.84 22.1v2.067c0 .502.25 1.003.752 1.316l5.075 2.946c.439.25 1.003.25 1.504 0l5.076-2.946c.439-.25.752-.752.752-1.316v-5.953c0-.5-.25-1.002-.752-1.316l-5.076-2.945z"
    })));

const Poper = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1200 1200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F14A16",
        d: "M635.473 1187.57s-24.685-29.53-24.685-85.37h-21.356c0 55.84-24.698 85.37-24.698 85.37"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 148,
        height: 137,
        x: 526,
        y: 1063,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M526.618 1063.72h147.118V1200H526.618z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        stroke: "currentColor",
        strokeWidth: 2.534,
        d: "M635.473 1187.57s-24.685-29.53-24.685-85.37h-21.356c0 55.84-24.698 85.37-24.698 85.37"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#F14A16",
        d: "M1042.99 478.459c0 332.078-250.978 624.441-442.854 624.441-184.511 0-442.862-265.667-442.862-624.441-.013-262.34 180.315-475.027 442.862-475.027 262.521 0 442.854 212.674 442.854 475.027"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        width: 893,
        height: 1143,
        x: 154,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M154 0h892.97v1142.35H154z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        stroke: "currentColor",
        strokeWidth: 2.534,
        d: "M1042.99 478.459c0 332.077-250.978 624.441-442.853 624.441-184.512 0-442.863-265.667-442.863-624.441-.013-262.34 180.315-475.027 442.863-475.027 262.52 0 442.853 212.674 442.853 475.027Z"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__c",
        width: 73,
        height: 24,
        x: 564,
        y: 1176,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M564.253 1176.54h71.848V1200h-71.848z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__c)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F14A16",
        d: "M635.486 1187.57q0 .96-.682 1.92c-.454.63-1.122 1.24-2.018 1.83-.882.6-1.978 1.16-3.261 1.71a38 38 0 0 1-4.397 1.48c-1.643.46-3.434.87-5.359 1.22-1.938.36-3.969.66-6.121.9-2.151.26-4.357.45-6.629.57-2.285.13-4.584.18-6.909.18s-4.624-.05-6.896-.18a98 98 0 0 1-6.642-.57 85 85 0 0 1-6.108-.9 58 58 0 0 1-5.359-1.22 38 38 0 0 1-4.397-1.48c-1.297-.55-2.379-1.11-3.274-1.71-.883-.59-1.564-1.2-2.019-1.83-.441-.64-.668-1.28-.668-1.92s.227-1.29.668-1.91c.455-.64 1.136-1.26 2.019-1.85.895-.6 1.977-1.16 3.274-1.69 1.283-.55 2.753-1.04 4.397-1.5 1.644-.45 3.421-.85 5.359-1.21a85 85 0 0 1 6.108-.91c2.151-.25 4.356-.44 6.642-.56 2.272-.12 4.571-.19 6.896-.19s4.624.07 6.909.19c2.272.12 4.478.31 6.629.56 2.152.24 4.183.55 6.121.91 1.925.36 3.716.76 5.359 1.21 1.644.46 3.101.95 4.397 1.5 1.283.53 2.379 1.09 3.261 1.69.896.59 1.564 1.21 2.018 1.85.455.62.682 1.27.682 1.91"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__d",
        width: 148,
        height: 62,
        x: 526,
        y: 1138,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M526.618 1138.93h147.118V1200H526.618z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__d)"
    }, /*#__PURE__*/ React.createElement("path", {
        stroke: "currentColor",
        strokeWidth: 2.534,
        d: "M635.486 1187.57q0 .96-.681 1.92c-.455.63-1.123 1.24-2.018 1.83-.883.6-1.978 1.16-3.261 1.71a38 38 0 0 1-4.397 1.48c-1.644.45-3.435.87-5.36 1.22a85 85 0 0 1-6.121.9c-2.151.26-4.356.44-6.628.56-2.286.14-4.584.19-6.91.19-2.325 0-4.624-.05-6.896-.19-2.285-.12-4.491-.3-6.642-.56a85 85 0 0 1-6.108-.9 62 62 0 0 1-5.359-1.22 38 38 0 0 1-4.397-1.48c-1.296-.55-2.379-1.11-3.274-1.71-.882-.59-1.564-1.2-2.018-1.83-.441-.64-.669-1.28-.669-1.92s.228-1.29.669-1.91c.454-.64 1.136-1.26 2.018-1.85.895-.6 1.978-1.16 3.274-1.69 1.283-.55 2.753-1.04 4.397-1.5 1.644-.45 3.421-.85 5.359-1.21a85 85 0 0 1 6.108-.91c2.151-.26 4.357-.44 6.642-.56 2.272-.12 4.571-.19 6.896-.19s4.624.07 6.91.19c2.272.12 4.477.3 6.628.56 2.152.24 4.184.55 6.121.91 1.925.36 3.716.76 5.36 1.21 1.644.46 3.1.95 4.397 1.5 1.283.53 2.378 1.09 3.261 1.69.895.59 1.563 1.21 2.018 1.85.454.62.681 1.27.681 1.91Z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M616.174 76.015s321.82 168.91 247.045 737.353c0 0 163.511-265.718 84.518-484.001C861.441 90.852 616.161 76.002 616.161 76.002z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M640.161 253.895c59.045 0 106.997 19.738 143.856 59.188 36.887 39.423 55.33 90.745 55.33 153.953 0 62.714-18.056 113.408-54.153 152.083-36.072 38.649-83.903 57.96-143.483 57.96-66.93 0-116.085-25.08-147.438-75.267v224.145h-90.184v-568.91h90.184v72.115c31.353-50.173 79.987-75.267 145.888-75.267M529.93 562.282c23.802 25.32 54.26 37.981 91.36 37.981 37.127 0 67.585-12.661 91.361-37.981 23.802-25.347 35.71-58.133 35.71-98.344 0-39.169-11.908-71.421-35.71-96.742-23.776-25.347-54.234-38.034-91.361-38.034-37.1 0-67.558 12.687-91.36 38.034-23.776 25.321-35.657 57.573-35.657 96.742 0 40.211 11.881 72.997 35.657 98.344"
    }));

const PostCSS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 79 78",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#DD3735",
        d: "M15.45 32.62c.1.08.29.14.1.3-.13.18-.29.33-.4.55-.1.18-.18.23-.33.1.2-.34.42-.66.63-.95m52.9 27.62.02.21c.05-.1.05-.16.08-.21zm0 .24v-.03zm-5.38 10.27-4.58-25.4c-.07-.02-.18-.08-.36-.13.05.1.08.18.1.26.13-.02.19-.02.24-.05 0-.02 0-.05.02-.08zm-4.73-31.12c-.03.08-.03.16-.03.24 0-.08 0-.16.03-.24m.02.53c-.02 0-.02 0-.05-.03v.03c.03.02.03.02.05 0m-.05.2v-.18c-.08.03-.16.03-.26.06.13.05.26.07.26.13z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#DD3A0A",
        d: "M78.71 33.97c-.05-1.03-.08-2.06-.18-3.09-.19-1.4-.37-2.82-.69-4.19a24 24 0 0 0-1.02-3.29c-.5-1.26-1-2.56-1.64-3.77-1.02-1.95-2.36-3.69-3.6-5.5-.82-1.17-1.87-2.11-2.66-3.3a8 8 0 0 0-1.76-1.79 46 46 0 0 0-3.27-2.35 33 33 0 0 0-2.58-1.63c-.7-.4-1.47-.71-2.2-1.06-.85-.4-1.67-.87-2.61-1.05-.24-.05-.45-.13-.69-.21-.6-.21-1.18-.45-1.79-.63-.92-.3-1.81-.64-2.76-.87a24 24 0 0 0-2.81-.53C47.39.56 46.32.5 45.26.4 44.58.32 43.9.24 43.24.2c-1-.05-2.03-.05-3.03-.07-.5-.03-1.03-.09-1.53-.06-.76.03-1.52.1-2.29.21-.73.08-1.47.21-2.18.32-.87.1-1.73.16-2.6.26-.82.1-1.66.27-2.48.4-.29.05-.58.16-.87.2-.63.14-1.28.2-1.92.4a34 34 0 0 0-6.36 2.56c-1 .55-1.95 1.21-2.9 1.85a31.6 31.6 0 0 0-5.05 4.06c-.42.41-.77.92-1.16 1.39-.66.77-1.32 1.5-1.95 2.3-.52.65-1 1.34-1.5 2.02-.9 1.21-1.65 2.5-2.36 3.8-.3.52-.56 1.05-.82 1.58-.4.79-.82 1.55-1.18 2.37a9.7 9.7 0 0 0-.64 1.76c-.36 1.3-.73 2.61-1.07 3.9a14.7 14.7 0 0 0-.42 3.56c-.03 1.06.07 2.08.18 3.14.03.26-.13.58.18.79-.1.29-.02.45.13.5-.18.29.08.47-.02.74-.03.05.08.16.13.24 0 .07-.03.18 0 .26.03.24.13.47.13.74 0 .18.16.4.21.58.03.07 0 .2-.05.26-.16.18-.13.34.1.45.14.34.08.5.06.66.05.23-.03.31 0 .37.2.42.29.9.31 1.37 0 .1.06.2.1.34.04 0 0 .5 0 .5.14-.08.25-.1.38-.16.08.34.16.66.26.95.13.21.13.32.08.34.1.48.16.92.34 1.37 0-.5-.05-1-.13-1.47.37.13.68.26.9.26L4.3 45c-.16-.15-.3-.4-.45-.55.05.21 0 .3 0 .37l-.37-.16c.1-.13.2-.26.37-.42 0-.24-.13-.45-.5-.42.16-.05.31-.13.5-.19.29-.15-.03-.44-.03-.81.03-.45-.24-.9-.31-1.37-.14-.74-.11-1.85-.19-2.58-.16-.14-.29.2-.31.23.08.64.15 1.27.2 1.9-.15-.53-.26-1.1-.39-1.74-.03.18-.05.26-.05.37-.13.13-.03.29.05.47-.18-.08-.4-.05-.4-.05v.74c-.26-.26-.33-.47-.47-.66l-.13-.63c.05-.13 0-.21 0-.29a16 16 0 0 1-.1-1.05c.2.02.34.05.47.05-.26-.34-.08-.56.03-.77.05-.1.24-.13.29-.24.2-.39.55-.7.55-1.2 0-.24.08-.5.1-.75.06-.44.11-.9.14-1.34.05-.58 0-1.16.13-1.71a29.4 29.4 0 0 1 1.47-4.72c.4-1.03.77-2.05 1.27-3.03.7-1.42 1.52-2.8 2.31-4.19.5-.87 1.03-1.69 1.58-2.53.53-.82 1.05-1.66 1.66-2.42a21.5 21.5 0 0 1 2.79-2.98c1.05-.95 2.05-1.92 3.18-2.8a32 32 0 0 1 4.69-3 36 36 0 0 1 4.13-1.8c.9-.34 1.87-.5 2.79-.78 1.05-.35 2.1-.5 3.2-.53.72-.03 1.4-.1 2.11-.19.64-.05 1.27-.1 1.95-.18-.08.1-.1.16-.13.21l-.9 1.27c-.23.34-.5.7-.73 1.05-.42.56-.87 1.1-1.27 1.69-.6.87-1.15 1.76-1.79 2.63-.63.85-1.31 1.64-1.97 2.45-.87 1.14-1.68 2.3-2.55 3.43-.8 1.08-1.63 2.11-2.4 3.19-.68.95-1.28 1.95-1.94 2.92l-2.92 4.33-2.32 3.29c-.05.08-.13.1-.2.16-.22.34-.22.52-.3.68-.2.4-.42.8-.66 1.16-.13.21-.31.4-.47.6-.03-.31.42-.47.2-.86l-.38.6-.32.63c.1.08.29.14.1.3l-.23.42a.95.95 0 0 0 .29-.27c0 .3-.16.53-.3.76-.1.21-.36.37-.54.53.02.03.2.1.23.13.24-.08.32-.2.35-.13.08-.1.15-.18.18-.26.1-.27.26-.48.52-.58.11-.05.19-.13.27-.21.79-.82 1.6-1.6 2.31-2.48 1.1-1.34 2.1-2.74 3.16-4.1.45-.59.98-1.17 1.45-1.72.08.6.03 1.18 0 1.74-.08.97-.13 1.95-.21 2.95-.03.4 0 .79-.03 1.18 0 .1-.08.19-.08.3 0 .26.08.55.08.81l-.26 2.9c-.03.2.07.42.13.6-.13 1.43.16 2.93-.08 4.43.18-.29.24-.47.24-.66.02-.15 0-.31 0-.5v-.26c.02-.48.13-.98.07-1.45a4.9 4.9 0 0 1 .06-1.53c.05-.2-.03-.47.1-.74v.4c-.02 1.5.03 3-.18 4.5-.03.14.08.37-.21.35-.24.47.05.81-.21 1.08-.05.05.05.29.08.44-.1.32-.1.32.05.35.02.58.08 1.1.1 1.66.42-1 .21-2.03.4-3.06.03.42.05.84.03 1.29 0 .69-.03 1.34-.06 2.03 0 .13-.02.26-.05.4-.08.37-.1.73-.24 1.08-.1.26-.05.66-.05.97v1c.1.45-.02.69.05.95-.08.27-.1.35-.08.42l.08.4c.53-.05.3.34.5.55-.15.22-.1.3-.1.4 0 .24-.03.45-.05.69 0 .6-.03 1.2-.03 1.79 0 .08.03.15.03.23l-.03.74c.05.08 0 .16-.08.24-.02 0-.1-3.35-.1-3.35h-.4c-.05 1.58.08 3-.2 4.48-.32.03-.43.08-.77.08-.82 0-1.63 0-2.45.03l-2.9.02c-.47 0-.97.06-1.44.06-.63 0-1.3-.08-1.92-.08-.98 0-1.92.08-2.9.1-.7.03-1.42.03-2.13.06-.47.02-.95.05-1.42.1-.2.03-.4.1-.66.18-.08 0-.26-.02-.42 0-.26.06-.5.21-.76.27-.4.08-.5.18-.45.58v.26c-.03.05.58-.08.58-.08-.05 0-.08.16-.16.29l.48-.18c.39.18.73.08 1.05.16 1.02.26 2.08.37 3.13.47.68.05 1.34.08 2.02.1.98.06 1.95.11 2.92.11.82 0 1.61-.08 2.42-.08 1.13 0 2.27.05 3.4.08.24 0 .5-.03.76-.03h1.92l5.14-.13c.97-.03 1.97-.08 2.94-.1l3-.08c1.16-.03 2.32-.03 3.45-.05.87 0 1.71-.03 2.58-.06.97-.03 1.97-.1 2.95-.16.52-.02 1.05-.08 1.58-.13.63-.05 1.29-.13 1.92-.16l2.87-.13c1.18-.08 2.36-.18 3.57-.2 1.11-.06 2.24-.03 3.35-.06.97-.03 1.95-.08 2.95-.1l1.66-.09s1.1-.02 1.65-.08c.95-.05 1.9-.15 2.85-.18.6-.03 1.2 0 1.81-.03.97-.02 1.97-.08 2.95-.08.36 0 .76.06 1.23.08-.2.19-.34.3-.5.43.1.02.21.08.32.13a.7.7 0 0 1-.42.13c-.05.13-.1.18-.16.45h.47c-.18 0-.34.23-.52.4-.21-.06-.4 0-.5.28.18.1.16.19.13.3-.32.1-.55.2-.42.54-.1.06-.24.1-.37.19-.13.2-.37.26-.32.55l.3.1c-.14.06-.27.14-.4.19-.47.29-.26.42-.16.55-.08.06-.16.1-.24.14.06.23.13.29.16.29l-.4.31c-.07.24-.18.34-.28.5s-.16.37-.3.53c-.55.6-.94 1.32-1.65 1.8-.26.18-.5.41-.74.65-.47.45-.9.95-1.4 1.37a30 30 0 0 1-2.04 1.56l-2.6 1.79c-.48.31-1 .55-1.5.84l-1.48.84c-.32.21-.6.5-.95.66-.87.37-1.8.69-2.68 1.03-.87.37-1.5.69-2.16.92-.6.21-1.24.37-1.87.5-.21.06-.45 0-.69.03-.44.08-.9.19-1.34.24-1.16.16-2.31.26-3.47.42-.69.08-1.34.2-2.03.29-.47.03-.97-.03-1.45-.03-.34 0-.7.08-1.05.03-.55-.08-1.1-.21-1.66-.32-.13-.02-.31-.08-.42-.02-.2.1-.4-.05-.6 0-.13.03-.27-.08-.4-.08-.1-.03-.24.03-.37 0-.29-.08-.55-.18-.87-.16-.31.03-.63-.13-.97-.2l-1.4-.33a2.4 2.4 0 0 1-.52-.23 4.3 4.3 0 0 1-1.55-.19c-.37-.13-.71-.31-1.1-.26-.11.03-.2-.03-.3-.03-.08-.1-.15-.31-.23-.31-.53.02-.84-.42-1.3-.56-.23-.08-.41-.34-.65-.42-.58-.23-1.05-.73-1.71-.81-.21-.03-.42-.14-.66-.21.08.1.13.18.21.26-.76-.37-1.47-.8-2.18-1.19-.1-.02-.18-.13-.26-.18l-.71-.48c-.4.08-.56-.08-.66-.13-.71-.5-1.53-.81-2.21-1.37-.3-.24-.63-.4-.84-.68a4.2 4.2 0 0 0-1.32-1.03c-.4-.21-.76-.45-1.13-.69-.19-.13-.37-.29-.37-.58 0-.18-.08-.37-.32-.26-.1-.16-.2-.34-.34-.4-.31-.12-.52-.36-.76-.57s-.42-.5-.71-.61c-.53-.21-.84-.66-1.16-1.03-.74-.87-1.4-1.82-2.08-2.74-.05-.08-.16-.13-.24-.2.1.28.24.52.37.78-.26-.1-.44-.29-.6-.47-.03.02 1.81 3.05 1.81 3.05l.45.72a.81.81 0 0 1-.79-.43c-.23-.42-.5-.68-1.02-.63-.06-.18-.11-.4-.13-.58-.11 0-.19 0-.37-.02.37.58.68 1.08 1.02 1.66l-.26-.16c.47.5.81 1.13 1.42 1.45.13.6.81.9.97 1.47l-.37-.08c-.2-.26-.45-.52-.68-.81.05.18.13.34.23.47.32.4.61.8.98 1.14.13.13.31.18.31.42.21.1.3.13.37.13.06.16-.02.4.3.34.2.4.41.4.7.27.35.34.53.37.77.16l.02.37c.1-.06.08-.14.08-.27l.26.21c.27.37.5.71.87 1 .5.43.95.87 1.42 1.27.92.76 1.95 1.4 2.98 1.98 1.26.7 2.47 1.47 3.76 2.16 1.55.81 3.21 1.37 4.92 1.76.63.13 1.24.27 1.87.42.55.16 1.1.4 1.66.53.84.19 1.7.34 2.55.5l.58.08c.24.05.52-.05.58.03.13.2.23.1.4.08.18-.06.39-.06.6-.06.73.03 1.44.19 2.18.13.16 0 .4-.13.53.13.24-.1.37-.1.47-.13.03.24 0 .24-.05.27-.05.02-.13.05-.24.13.95.18 1.85.2 2.63 0 1.37.1 2.56-.05 3.69-.45.1.13.18.32.34.05.05-.08.19-.1.3-.13.23-.05.52-.16.73-.08.24.08.32-.13.5-.13.32 0 .6-.03.9-.08.15-.03.31-.1.5-.16-.22-.1-.43-.13-.59-.13.32-.16.61-.3.9-.42-.05.08-.1.18-.21.18h.37c-.08 0-.19.24-.32.4l2.66-.66c-.3-.55.31-.37.52-.69-.26.08-.52.16-.79.21.9-.44 1.82-.84 2.71-1.23-.13.15-.29.23-.52.37.16.02.26.02.34.05.42.13.32-.27.45-.5.5 0 .7-.08.95-.16.26-.08.52-.16.79-.26.42-.19.81-.42 1.23-.63.08-.03.21 0 .32 0 .29-.2.4-.35.47-.32.37.05.63-.08.74-.42.18-.14.31-.24.44-.32l1.71-.95c.21 0 .32 0 .37-.03.35-.16.66-.34.98-.52a2 2 0 0 1-.27-.13c.27-.06.34-.08.5-.14.63-.74 1.5-1.24 2.16-1.82.29-.02.29-.1.29-.15.1-.13.21-.3.34-.4.58-.53 1.21-.97 1.74-1.53.76-.76 1.5-1.55 2.18-2.37.63-.74 1.27-1.48 1.8-2.3.73-1.13 1.36-2.29 2.02-3.47.47-.84.9-1.69 1.37-2.53.05-.08.15-.19.23-.19.71-.08 1.43-.13 2.1-.2.17-.03.35-.14.5-.22-.07-.13-.12-.29-.2-.42-.1-.16-.26-.29-.37-.45-.1-.13-.18-.29-.26-.44l-.24-.37a10 10 0 0 1-.45-.9c-.03-.08-.08-.2-.05-.29.47-1.03.66-2.13 1.1-3.16.45-1.05.58-2.24.8-3.37.18-1.08.28-2.16.41-3.24.08-.77.19-1.5.21-2.27.16-1.21.1-2.35.08-3.48-.02-1-.08-2.03-.13-3.03zM12.69 66.4c-.19-.21-.35-.45-.53-.66l.08-.08c.29.31.58.63.87.97-.16-.08-.35-.13-.42-.23m.42.23c.08-.02.16-.02.23-.05.08.13.14.29.21.45-.36-.03-.55-.19-.44-.4m27.37 10.89v-.08l1.47-.16v.08c-.5.08-.98.13-1.48.15zm6.63-.69c-.37.08-.77.13-1.13.19-.14.02-.3.15-.35-.08-.05.02-.1.02-.15.05.13.4.44.08.7.24-.57.08-1.12.13-1.68.2v-.04l.5-.09v-.07a8 8 0 0 0-.79-.06c-.08 0-.18.11-.26.14-.1.02-.21.05-.34.05-.45.02-.9.02-1.32.05l-.1-.02v-.08l5.26-.71c.02.05.02.1.05.15-.16 0-.26.06-.4.08zm.4-.26 1.73-.21c-1.21.34-1.6.4-1.74.2zm-22.93-53.2c.84-1.17 1.71-2.33 2.55-3.51.26-.35.47-.72.74-1.06.08-.1.18-.16.31-.26l-.02-.05c.1-.13.2-.24.26-.35.13-.2.21-.44.32-.68.03-.05.1-.1.1-.1.37.18.37-.21.5-.35.24-.26.48-.55.69-.81.16-.21.31-.4.45-.64.02-.08-.06-.2-.08-.31h-.08c.08-.05.16-.13.24-.19l.05-.02c.16-.24.31-.48.47-.69.32-.42.66-.84 1.03-1.2-.06.12-.1.25-.16.36.03 0 .03.03.05.03.32-.43.66-.82.97-1.24-.02-.03-.05-.06-.08-.06l-.36.4c-.03-.03-.06-.05-.08-.05.26-.35.52-.69.79-1.08l.2.4c.11-.27.22-.45.3-.64l-.27.24-.08-.08.48-.71 1.5-2.16c.18-.27.42-.48.58-.74.5-1 1.29-1.8 1.9-2.72.12-.18.3-.34.47-.5.13-.16.23-.1.34.03l2.13 2.71c.53.66 1.05 1.3 1.55 1.98.6.84 1.19 1.69 1.8 2.53.68.98 1.36 1.95 2.02 2.95 1 1.48 1.95 2.95 2.95 4.43.73 1.08 1.47 2.13 2.18 3.21h-1.34c-1.24-.02-2.5-.13-3.74-.07-1.68.08-3.4.26-5.08.4-2.13.18-4.29.2-6.42.2-.76 0-1.53.1-2.29.16-.92.05-1.82.1-2.74.13-1.08.06-2.13.08-3.2.1-.61.03-1.24 0-1.9 0zm30.18 12.11v.24c-.02 0-.05.03-.1.03-.1-.37-.21-.77-.34-1.14a8.9 8.9 0 0 0-1.03-2.21c-.53-.74-1-1.5-1.53-2.27-.13-.18-.31-.34-.47-.5-.56-.6-1.1-1.24-1.82-1.68a21.5 21.5 0 0 0-3.29-1.69 9 9 0 0 1-.92-.47h.63l4.5-.08c.98-.03 1.92-.03 2.9-.08.23 0 .36.08.5.29.23.4.47.79.73 1.18.03.06.08.13.08.21 0 .58 0 1.19.03 1.77.02.6.08 1.19.1 1.8 0 .6-.05 1.23-.02 1.86.02.9.05 1.82.05 2.74m-28.31-8.82c1.23-.05 2.42-.13 3.63-.18.94-.06 1.92-.08 2.87-.14.39-.02.76-.05 1.15 0-.42.22-.84.43-1.2.69-.48.32-.93.74-1.4 1.08-.48.34-.9.76-1.3 1.21-.5.6-1.04 1.13-1.57 1.71-.37.43-.8.82-1.1 1.27-.45.58-.85 1.2-1.27 1.87.13-2.5.29-4.98.18-7.51zm17.18 25.35c-.84.21-1.7.45-2.58.55-.73.1-1.5.08-2.26.08-.69 0-1.34-.02-2.03-.08a6.8 6.8 0 0 1-2.26-.5c-.63-.29-1.3-.55-1.92-.87a5.1 5.1 0 0 1-1.74-1.26c-.34-.42-.82-.77-1.24-1.13.08.31.27.57.56.76-.14.16-.32.08-.58-.34-.08.05-.16.08-.21.1.08-.18.15-.37.23-.52-.1-.22-.23-.45-.34-.67-.21-.34-.42-.7-.6-1.05-.06-.08-.06-.16-.11-.23a6 6 0 0 1-.37-.48c-.21-.32-.4-.66-.66-.97 0 .08.03.15.03.26-.03 0-.05.03-.05.03l-.56-1.35c-.02 0-.02 0-.05.03l.47 1.74-.08.02c-.07-.1-.15-.2-.2-.34-.06-.2-.22-.2-.35-.13-.08.05-.13.24-.1.32.18.44.4.9.6 1.34.06.16.1.29.19.45.03.05.1.1.1.18.11.21.19.42.32.6l.74.96c.23.31.44.66.65.97.03.05.1.05.13.08.14.4.58.69.9.53.08.6.74.81 1 1.4-.32-.14-.55-.24-.76-.35-.03.03-.03.05-.06.1.32.16.63.32.92.5.27.17.53.32.77.5.31.3.68.46 1.13.56a.3.3 0 0 0-.05-.1c.73.34 1.5.7 2.08 1l-8.69.15c0-.5-.03-.97-.03-1.47 0-.21.06-.4.03-.6-.08-1.22-.08-2.43-.24-3.62a28 28 0 0 1-.13-3.77c.03-.68-.02-1.4-.05-2.08 0-.92 0-1.82.03-2.74 0-.13.05-.24.1-.37h.08c.03.06 0 .13.05.16.08.08.21.21.27.19.15-.11.4-.22.44-.38.13-.31.19-.65.19-.97 0-.23.1-.4.2-.55.06-.08.09-.16.14-.26l-.34-.24c.1-.3.08-.63.47-.8.06-.02.06-.15.08-.23l.08-.66c.05.08.08.1.13.16a.4.4 0 0 1 .06-.08c0-.1-.03-.32 0-.32.31-.05.18-.4.34-.55.02-.03-.03-.1-.03-.16 0-.05 0-.13.03-.13.36-.08.31-.48.55-.66.08-.05.1-.13.2-.26.22.36-.15.55-.17.81.44-.26.57-.9.31-1.08.1-.08.21-.18.29-.29.29-.31.6-.6.87-.92.18-.24.29-.53.47-.76.1-.13.32-.24.48-.32a3.2 3.2 0 0 0 1.2-1l.22-.16c.08-.05.23-.05.26-.13.03-.05-.05-.18-.1-.26.1-.06.2-.16.42-.27l-.16.37.13.13c.24-.18.6-.4.84-.55a.8.8 0 0 0-.13-.13l-.63.32c.05-.08.05-.13.08-.16a10 10 0 0 1 1.13-.66c.92-.42 1.84-.84 2.76-1.24.16-.08.37-.02.55-.02.08 0 .13 0 .21-.03.42-.13.85-.26 1.27-.37.18-.05.39-.08.58-.08.78.03 1.57.03 2.36.08.35.03.66.1.98.21a9.9 9.9 0 0 1 2.47 1.3c.76.5 1.47 1.05 2.24 1.5a5.9 5.9 0 0 1 1.79 1.73c.58.82 1.23 1.56 1.5 2.56l.4 1.74c.07.32.25.63.18 1-.14.66-.24 1.34-.35 2-.05.27-.1.53-.08.8.05.81-.26 1.52-.58 2.26-.1.24-.26.48-.39.74.03.03.18.1.21.1l.24-.47c.02 0 .02 0 .05.03l-.37 1.13a25 25 0 0 1-1.03 2.45c-.2.45-.58.82-.84 1.24-.26.37-.47.76-.73 1.1-.24.3-.48.59-.8.8-.7.52-1.44 1.05-2.2 1.47-.48.3-1.03.45-1.56.58zm-14.03-1.4-.02.03c-.06-.03-.14-.05-.19-.1l-.63-.96c-.05-.08-.08-.15-.05-.26.29.45.58.87.9 1.29zm16.37 3.61c1.19-.5 2.16-1.21 3.05-2.03.14-.13.27-.26.43-.37a9.2 9.2 0 0 0 2.65-2.68c.85-1.22 1.4-2.59 2.08-3.88l.16-.29c-.05 3 .3 5.96.69 8.94zm26.69-.79c-.03.05-.08.1-.1.16-.03-.05-.03-.13-.06-.24-.16.42-.5.21-.74.21-1.42.03-2.87.03-4.29.03-1.37 0-2.76 0-4.13.02-.45 0-.92.1-1.37.14-1.08.05-2.15.08-3.23.1-.08 0-.16-.13-.3-.24a.9.9 0 0 1-.15.24l-.13-.18-.08.2H58c-.05-.36-.16-.7-.16-1.07 0-.8.08-1.58.1-2.37.03-.37 0-.71 0-1.06l.3.21.15-.26-.1-.08c.05-.02.1-.08.1-.1.03-.08.08-.16.08-.21 0-.19-.05-.35-.08-.5.03 0 .05 0 .08-.03l.16.79h.08c-.1-.18.24-.34-.05-.55-.03-.03.02-.19.02-.27-.08-.15-.13-.31-.2-.52.02-.03.1-.06.18-.08-.1-.06-.19-.1-.27-.13.27-.24.27-.37.03-.64.05-.02.1-.02.1-.05 0-.23 0-.47-.05-.7-.05-.27.08-.59-.31-.75.02.08.05.14.1.21l-.16.08c-.34-.31-.13-.74-.2-1.21.18.05.31.1.44.16-.05-.19-.18-.4-.26-.63h-.1v-1.74c0 .02.18.02.28.05 0-.03.03-.05.03-.08l-.3-.34.06-.06c-.21-.26-.1-.63-.1-.7V39.4c.26.26-.14.6.26.76v-.26h-.03c-.02-.4-.02-.79-.05-1.18h-.05l-.06.13h-.05l.16-6.3c.26.34.55.66.74 1 .6 1.1 1.4 2.06 2.13 3.06.63.87 1.2 1.82 1.79 2.71l2.1 3.24a63 63 0 0 0 3.19 4.51c.44.6.92 1.21 1.36 1.82l1.58 2.19.84 1.1c.16.21.4.37.56.5l-.1-.02c.07.1.12.18.18.23.29.16.31.32.16.56zM74 46.85v-.18c0 .05.03.13 0 .18m.9-11.62c-.03 0-.19-.16-.22-.18-.02.08 0 .16-.05.26-.02-.08-.2-.05-.2-.13-.03.37.15.74.12 1.1.08-.04.4-.07.48-.15a.2.2 0 0 0 .1.05c-.52.4-.4.8-.16 1.24.06.1.21.32.06.53-.06.05.02.2.05.34h.08v.05l-.24.08c-.05-.08-.37-.23-.37-.37v1.35c.27.08.27.45.37.63a.8.8 0 0 0 .1-.21l.03.02c-.02.16-.05.32-.1.48-.05.24-.1.45-.13.68 0 .03.05.08.05.1-.29.67-.13 1.4-.24 2.09-.08.5 0 1.03-.05 1.55-.05.45-.16.93-.26 1.37-.03.08-.08.1-.21.16.05-.31.02-.53-.03-.82-.03 0-.37-.18-.4-.18 0 .37.21.87.3 1.3-.09-.04-.4-.22-.43-.22-.05.32-.05.74-.08 1.08-.02.26-.26.5-.29.8 0 .15.19.25.16.52h.21c0-.53.24-1 .24-1.56h.08c.02.06.1.11.08.14-.06.29-.16.6-.14.9 0 .15.13.3.08.5-.05.15-.08.31-.1.55-.03-.14-.06-.19-.06-.27l-.29-.02c-.02.15.19.31.16.44-.02.03-.05.03-.1.06l-.87-1.27c-.69-1-1.37-2-2.05-3.03a6 6 0 0 1-.48-.79 37 37 0 0 0-2.71-4.03c-.76-.98-1.37-2.03-2.08-3.06l-1.97-2.9c-.24-.31-.53-.6-.74-.94-.68-1.08-1.29-2.2-1.97-3.27-.58-.9-1.21-1.77-1.82-2.64l-.63-.92a.4.4 0 0 1-.05-.18c-.05-.58-.1-1.16-.13-1.72 0-.52.05-1.05.05-1.6v-.48c0-.13.03-.23.03-.37l.07-.1c-.76 0-1.55-.03-2.31 0-.5.02-.77-.19-1.1-.56-1-1.13-1.74-2.42-2.61-3.63a178 178 0 0 0-2.5-3.43l-2.06-2.74c-.76-1.05-1.5-2.1-2.29-3.16-.94-1.27-1.92-2.53-2.9-3.8-.44-.58-.94-1.13-1.44-1.74.34.06.66.11.97.14l1.27.08c.95.07 1.9.13 2.84.26.79.1 1.58.26 2.4.4 1.73.28 3.44.76 5.1 1.31.97.32 1.92.74 2.87 1.13a60 60 0 0 1 6.16 3.03c.63.35 1 .9 1.47 1.4.68.71 1.37 1.42 2.03 2.16.76.87 1.47 1.77 2.2 2.66.66.8 1.35 1.58 2 2.38.22.23.38.52.56.79.42.63.9 1.24 1.26 1.92.26.5.42 1.08.6 1.63l.8 2.43c.18.6.34 1.24.47 1.87.1.42.08.87.2 1.29.17.55 0 1.16.17 1.71l.07.19c.11.1.19.2.03.37-.02.02-.02.13 0 .2.06-.05.08-.1.13-.18 0 .06.03.08.03.1 0 .11-.03.22 0 .32 0 .05.05.13.08.19.05-.06.1-.08.2-.16.24.9.27 1.79.27 2.71 0 .87.16 1.74-.2 2.58.07-.29-.12-.55-.04-.81z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#DD3735",
        d: "M58.08 45.48c.03 0 .05.03.05.03l-.03-.03c0-.03 0-.03-.02 0m4.16 26.04c-.3.2-.58.4-.95.47-.03-.02-.03-.05-.06-.08l.9-.55c.03.05.08.1.1.16zM12.89 35.8c.3-.37.58-.74.9-1.1.02.02.23.08.26.1l-.97 1.26c-.06-.05-.14-.23-.19-.26M5.42 48.72l-.63-1.36a.9.9 0 0 1 .24-.11c.29.42.42.92.63 1.37 0 0-.21.1-.24.1m6.71-12.64c-.16.23-.31.5-.47.74-.03-.03-.32.1-.34.07.15-.23.55-.66.7-.9zm47.3 36.52c.02 0 .02-.03.04-.03.19.03.4.06.6.06-.34.23-.55.2-.65-.03zM12.17 37.18c.03-.08.08-.16.13-.24l.13-.02c.11-.19.11-.32.22-.48-.03-.02-.06-.02-.08-.05-.16.1-.32.24-.48.35.06.05.06.08.06.13-.21-.03-.3.08-.4.37-.02.08-.16.1-.29.2-.02.06-.05.2-.1.32l.02.03c-.05.05-.13.08-.13.08-.16.16-.34.3-.5.45-.02.08-.05.16-.05.23.18-.18.5-.52.74-.73l.02.02.3-.47.05.08-.24.66c-.06.02-.14.08-.14.05-.1.08-.18.18-.29.26l-.47.32c-.26.24-.52.45-.81.68l-.58.9c.31-.08.4.05.37.32.36.05.4-.24.5-.45.02-.05.05-.16.1-.19l.76-.6c.06-.05.06-.16.06-.24 0-.03-.14-.03-.22-.05.24-.27.58-.71.82-1 .13-.08.26-.19.26-.27-.02-.29.16-.37.37-.47-.1-.08-.13-.16-.13-.18z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#DD3735",
        d: "m12.71 36.9-.32.52-.15-.08c-.1.6-.48 1.13-.84 1.24.1.05.2.1.29.08.07-.03.13-.16.18-.24l.7-1.03.25-.4-.1-.1zM3.95 48.45c.13 0 .26.03.42.03 0-.1.13-.08.13-.19h.08c0 .13.03.24.03.37h-.56c-.02-.02-.13-.18-.1-.21m-.21-1.21c-.08-.08-.21-.16-.21-.24-.03-.1.05-.23.13-.37l.13.53c-.03.03-.05.05-.05.08m.66-1.69c.1.27.2.56.31.82a.8.8 0 0 0-.2.1l-.35-.81c.03-.03.18-.1.24-.1zm58.58 25.2c.13-.06.28-.09.5-.14-.24.19-.43.32-.58.48-.03-.03-.06-.05-.08-.05l.16-.3zM30.63 15.06l.45-.29.05.06c-.16.2-.3.42-.48.68-.02-.18-.02-.29-.05-.42-.03 0 0 0 .03-.03m7.71 13.34.76-.35c-.02.16-.02.27-.02.37a1 1 0 0 0-.27-.05c-.16.03-.45.24-.58.26-.02 0 .1-.2.1-.23zm19.74 22.34c.05.27.55.4.05.66.08.06.16.08.24.14a.2.2 0 0 1-.05.1c-.06.03-.16.08-.21.05-.03 0-.08-.1-.08-.16 0-.23.02-.47.05-.79"
    })));

const PostHog = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 50 30",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1D4AFF",
        d: "M10.891 17.206a1 1 0 0 1-1.788 0l-.882-1.763a1 1 0 0 1 0-.894l.882-1.763a1 1 0 0 1 1.788 0l.882 1.763a1 1 0 0 1 0 .894zm0 9.997a1 1 0 0 1-1.788 0L8.22 25.44a1 1 0 0 1 0-.894l.882-1.763a1 1 0 0 1 1.788 0l.882 1.763a1 1 0 0 1 0 .894z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F9BD2B",
        d: "M0 23.408c0-.89 1.077-1.337 1.707-.707l4.583 4.583c.63.63.184 1.708-.707 1.708H1a1 1 0 0 1-1-1zm0-4.828a1 1 0 0 0 .293.708l9.411 9.41a1 1 0 0 0 .707.294h5.17c.89 0 1.337-1.077.707-1.707l-14.58-14.58C1.077 12.074 0 12.52 0 13.41zm0-9.997a1 1 0 0 0 .293.707L19.7 28.7a1 1 0 0 0 .707.293h5.17c.89 0 1.337-1.078.707-1.708L1.707 2.707C1.077 2.077 0 2.523 0 3.414zm9.997 0a1 1 0 0 0 .293.707l17.994 17.995c.63.63 1.707.183 1.707-.708v-5.169a1 1 0 0 0-.293-.707L11.704 2.707c-.63-.63-1.707-.184-1.707.707zm11.704-5.876c-.63-.63-1.707-.184-1.707.707v5.17a1 1 0 0 0 .293.706l7.997 7.998c.63.63 1.707.183 1.707-.708v-5.169a1 1 0 0 0-.293-.707z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m42.525 23.53-9.413-9.412c-.63-.63-1.707-.184-1.707.707v13.167a1 1 0 0 0 1 1h14.58a1 1 0 0 0 1-1v-1.2c0-.552-.449-.993-.997-1.064a7.72 7.72 0 0 1-4.463-2.197zm-6.321 2.263a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1D4AFF",
        d: "M0 27.992a1 1 0 0 0 1 1h4.583c.891 0 1.337-1.078.707-1.708l-4.583-4.583c-.63-.63-1.707-.184-1.707.707zm9.997-16.995-8.29-8.29C1.077 2.077 0 2.523 0 3.414v5.17a1 1 0 0 0 .293.706l9.704 9.705zm-8.29 1.707c-.63-.63-1.707-.184-1.707.707v5.17a1 1 0 0 0 .293.706l9.704 9.705v-7.998z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F54E00",
        d: "M19.994 11.411a1 1 0 0 0-.293-.707l-7.997-7.997c-.63-.63-1.707-.184-1.707.707v5.17a1 1 0 0 0 .293.706l9.704 9.705zm-9.997 17.58h5.583c.891 0 1.337-1.077.707-1.707l-6.29-6.29v7.998zm0-17.994v7.583a1 1 0 0 0 .293.708l9.704 9.704v-7.584a1 1 0 0 0-.293-.707z"
    }));

const PostgreSQL = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 432.071 445.383",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        style: {
            fillRule: "nonzero",
            clipRule: "nonzero",
            fill: "none",
            stroke: "#fff",
            strokeWidth: 12.4651,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4
        }
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M323.205 324.227c2.833-23.601 1.984-27.062 19.563-23.239l4.463.392c13.517.615 31.199-2.174 41.587-7 22.362-10.376 35.622-27.7 13.572-23.148-50.297 10.376-53.755-6.655-53.755-6.655 53.111-78.803 75.313-178.836 56.149-203.322-52.27-66.789-142.748-35.206-144.262-34.386l-.482.089c-9.938-2.062-21.06-3.294-33.554-3.496-22.761-.374-40.032 5.967-53.133 15.904 0 0-161.408-66.498-153.899 83.628 1.597 31.936 45.777 241.655 98.47 178.31 19.259-23.163 37.871-42.748 37.871-42.748 9.242 6.14 20.307 9.272 31.912 8.147l.897-.765c-.281 2.876-.157 5.689.359 9.019-13.572 15.167-9.584 17.83-36.723 23.416-27.457 5.659-11.326 15.734-.797 18.367 12.768 3.193 42.305 7.716 62.268-20.224l-.795 3.188c5.325 4.26 4.965 30.619 5.72 49.452.756 18.834 2.017 36.409 5.856 46.771 3.839 10.36 8.369 37.05 44.036 29.406 29.809-6.388 52.6-15.582 54.677-101.107",
        style: {
            fill: "#000",
            stroke: "#000",
            strokeWidth: 37.3953,
            strokeLinecap: "butt",
            strokeLinejoin: "miter"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "none",
        d: "M402.395 271.23c-50.302 10.376-53.76-6.655-53.76-6.655 53.111-78.808 75.313-178.843 56.153-203.326-52.27-66.785-142.752-35.2-144.262-34.38l-.486.087c-9.938-2.063-21.06-3.292-33.56-3.496-22.761-.373-40.026 5.967-53.127 15.902 0 0-161.411-66.495-153.904 83.63 1.597 31.938 45.776 241.657 98.471 178.312 19.26-23.163 37.869-42.748 37.869-42.748 9.243 6.14 20.308 9.272 31.908 8.147l.901-.765c-.28 2.876-.152 5.689.361 9.019-13.575 15.167-9.586 17.83-36.723 23.416-27.459 5.659-11.328 15.734-.796 18.367 12.768 3.193 42.307 7.716 62.266-20.224l-.796 3.188c5.319 4.26 9.054 27.711 8.428 48.969s-1.044 35.854 3.147 47.254 8.368 37.05 44.042 29.406c29.809-6.388 45.256-22.942 47.405-50.555 1.525-19.631 4.976-16.729 5.194-34.28l2.768-8.309c3.192-26.611.507-35.196 18.872-31.203l4.463.392c13.517.615 31.208-2.174 41.591-7 22.358-10.376 35.618-27.7 13.573-23.148z",
        style: {
            fill: "#336791",
            stroke: "none"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M215.866 286.484c-1.385 49.516.348 99.377 5.193 111.495 4.848 12.118 15.223 35.688 50.9 28.045 29.806-6.39 40.651-18.756 45.357-46.051 3.466-20.082 10.148-75.854 11.005-87.281M173.104 38.256S11.583-27.76 19.092 122.365c1.597 31.938 45.779 241.664 98.473 178.316 19.256-23.166 36.671-41.335 36.671-41.335M260.349 26.207c-5.591 1.753 89.848-34.889 144.087 34.417 19.159 24.484-3.043 124.519-56.153 203.329"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M348.282 263.953s3.461 17.036 53.764 6.653c22.04-4.552 8.776 12.774-13.577 23.155-18.345 8.514-59.474 10.696-60.146-1.069-1.729-30.355 21.647-21.133 19.96-28.739-1.525-6.85-11.979-13.573-18.894-30.338-6.037-14.633-82.796-126.849 21.287-110.183 3.813-.789-27.146-99.002-124.553-100.599-97.385-1.597-94.19 119.762-94.19 119.762",
        style: {
            strokeLinejoin: "bevel"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M188.604 274.334c-13.577 15.166-9.584 17.829-36.723 23.417-27.459 5.66-11.326 15.733-.797 18.365 12.768 3.195 42.307 7.718 62.266-20.229 6.078-8.509-.036-22.086-8.385-25.547-4.034-1.671-9.428-3.765-16.361 3.994"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M187.715 274.069c-1.368-8.917 2.93-19.528 7.536-31.942 6.922-18.626 22.893-37.255 10.117-96.339-9.523-44.029-73.396-9.163-73.436-3.193-.039 5.968 2.889 30.26-1.067 58.548-5.162 36.913 23.488 68.132 56.479 64.938"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M172.517 141.7c-.288 2.039 3.733 7.48 8.976 8.207 5.234.73 9.714-3.522 9.998-5.559.284-2.039-3.732-4.285-8.977-5.015-5.237-.731-9.719.333-9.996 2.367z",
        style: {
            fill: "#fff",
            strokeWidth: 4.155,
            strokeLinecap: "butt",
            strokeLinejoin: "miter"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M331.941 137.543c.284 2.039-3.732 7.48-8.976 8.207-5.238.73-9.718-3.522-10.005-5.559-.277-2.039 3.74-4.285 8.979-5.015s9.718.333 10.002 2.368z",
        style: {
            fill: "#fff",
            strokeWidth: 2.0775,
            strokeLinecap: "butt",
            strokeLinejoin: "miter"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M350.676 123.432c.863 15.994-3.445 26.888-3.988 43.914-.804 24.748 11.799 53.074-7.191 81.435"
    })));

const Postman = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M254.953 144.253c8.959-70.131-40.569-134.248-110.572-143.206C74.378-7.912 10.005 41.616 1.047 111.619c-8.959 70.003 40.569 134.248 110.572 143.334 70.131 8.959 134.248-40.569 143.334-110.7"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m174.2 82.184-54.007 54.007-15.229-15.23c53.11-53.11 58.358-48.503 69.236-38.777"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M120.193 137.47c-.384 0-.64-.128-.895-.384l-15.358-15.229a1.237 1.237 0 0 1 0-1.792c54.007-54.006 59.638-48.887 71.028-38.649.255.256.383.512.383.896s-.128.64-.383.896l-54.007 53.878c-.128.256-.512.384-.768.384m-13.437-16.509 13.437 13.438 52.087-52.087c-9.47-8.446-15.87-11.006-65.524 38.65Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m135.679 151.676-14.718-14.718 54.007-54.006c14.46 14.59-7.167 38.265-39.29 68.724Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M135.679 152.956c-.384 0-.64-.128-.896-.384l-14.718-14.718c-.256-.256-.256-.512-.256-.896s.128-.64.384-.895L174.2 82.056a1.237 1.237 0 0 1 1.791 0 15.58 15.58 0 0 1 4.991 11.902c-.256 14.206-16.38 32.25-44.28 58.614-.383.256-.767.384-1.023.384m-12.926-15.998c8.19 8.319 11.646 11.646 12.926 12.926 21.5-20.476 42.36-41.464 42.488-55.926.128-3.327-1.152-6.655-3.327-9.214z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m105.22 121.345 10.878 10.878q.384.384 0 .768c-.128.128-.128.128-.256.128l-22.524 4.863c-1.152.128-2.175-.64-2.431-1.791-.128-.64.128-1.28.512-1.664l13.053-13.054c.256-.256.64-.384.768-.128"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M92.934 139.262c-1.92 0-3.327-1.536-3.327-3.455 0-.896.384-1.792 1.024-2.432l13.053-13.054c.768-.64 1.792-.64 2.56 0l10.878 10.878c.768.64.768 1.792 0 2.56-.256.256-.512.384-.896.512l-22.524 4.863c-.256 0-.512.128-.768.128m11.902-16.51-12.542 12.543c-.256.256-.383.64-.128 1.024.128.383.512.511.896.383l21.116-4.607-9.342-9.342Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M202.739 52.238c-8.191-7.935-21.373-7.679-29.307.64-7.935 8.318-7.679 21.372.64 29.306A20.68 20.68 0 0 0 199.155 85l-14.59-14.59z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M188.405 89.223c-12.158 0-22.012-9.854-22.012-22.012s9.854-22.012 22.012-22.012c5.631 0 11.134 2.176 15.23 6.143.255.256.383.512.383.896s-.128.64-.384.895L186.357 70.41l13.566 13.566c.512.512.512 1.28 0 1.792l-.256.256c-3.327 2.047-7.295 3.199-11.262 3.199m0-41.337c-10.75 0-19.452 8.703-19.324 19.453 0 10.75 8.702 19.452 19.452 19.324 2.944 0 5.887-.64 8.575-2.047l-13.438-13.31c-.256-.256-.384-.512-.384-.896s.128-.64.384-.895l17.149-17.15c-3.456-2.943-7.807-4.479-12.414-4.479"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m203.122 52.622-.255-.256-18.301 18.044 14.461 14.462c1.408-.896 2.816-1.92 3.967-3.072a20.51 20.51 0 0 0 .128-29.178"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M199.155 86.28c-.384 0-.64-.128-.896-.384l-14.589-14.59c-.256-.256-.384-.512-.384-.896s.128-.64.384-.895l18.173-18.173a1.237 1.237 0 0 1 1.791 0l.384.256c8.575 8.574 8.575 22.396.128 31.098-1.28 1.28-2.687 2.432-4.223 3.328-.384.128-.64.256-.768.256m-12.798-15.87 12.926 12.926c1.024-.64 2.048-1.536 2.816-2.304 7.294-7.294 7.678-19.196.64-26.875z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M176.375 84.488a7.88 7.88 0 0 0-11.134 0l-48.247 48.247 8.063 8.063 51.062-44.792c3.328-2.816 3.584-7.807.768-11.134-.256-.128-.384-.256-.512-.384"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M124.929 142.077c-.384 0-.64-.128-.896-.383l-8.063-8.063a1.237 1.237 0 0 1 0-1.792l48.247-48.247a9.115 9.115 0 0 1 12.926 0 9.115 9.115 0 0 1 0 12.926l-.384.384-51.063 44.792q-.192.383-.767.383m-6.143-9.342 6.27 6.271 50.167-44.024c2.816-2.304 3.072-6.527.768-9.342-2.303-2.816-6.526-3.072-9.342-.768-.128.128-.256.256-.512.384z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M80.009 187.637c-.512.256-.768.768-.64 1.28l2.175 9.214c.512 1.28-.256 2.816-1.663 3.2-1.024.384-2.176 0-2.816-.768l-14.077-13.95 45.943-45.943 15.87.256 10.75 10.75c-2.56 2.175-18.045 17.149-55.542 35.961"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M78.985 202.61c-1.024 0-2.048-.383-2.688-1.151l-13.95-13.95c-.255-.256-.383-.512-.383-.896 0-.383.128-.64.384-.895l45.944-45.944c.256-.256.64-.384.895-.384l15.87.256c.383 0 .64.128.895.384l10.75 10.75c.256.256.384.64.384 1.024s-.128.64-.512.896l-.895.767c-13.566 11.902-31.995 23.804-54.902 35.194l2.175 9.086c.384 1.664-.384 3.456-1.92 4.352-.767.384-1.407.512-2.047.512Zm-14.078-15.997 13.182 13.054c.384.64 1.152.896 1.792.512s.896-1.152.512-1.792l-2.176-9.214c-.256-1.152.256-2.176 1.28-2.688 22.652-11.39 40.952-23.163 54.39-34.81l-9.47-9.47-14.718-.256z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m52.11 197.62 11.006-11.007 16.38 16.381-26.107-1.791c-1.151-.128-1.92-1.152-1.791-2.304 0-.512.128-1.024.512-1.28Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "m79.497 204.146-26.236-1.791c-1.92-.128-3.199-1.792-3.071-3.712.128-.768.384-1.535 1.024-2.047L62.22 185.59a1.237 1.237 0 0 1 1.792 0l16.38 16.38c.385.385.512.897.257 1.408q-.384.768-1.152.768m-16.381-15.74-10.11 10.11c-.384.255-.384.895 0 1.151.127.128.255.256.511.256l22.652 1.536-13.053-13.054Zm41.336-41.849c-.768 0-1.28-.64-1.28-1.28 0-.384.128-.64.384-.896l12.414-12.414a1.237 1.237 0 0 1 1.792 0l8.062 8.063c.384.384.512.768.384 1.28-.128.384-.512.767-1.023.895l-20.477 4.352zm12.414-11.902-8.446 8.446 13.821-2.943z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m124.8 140.926-14.077 3.071c-1.024.256-2.048-.384-2.303-1.408-.128-.64 0-1.28.511-1.791l7.807-7.807 8.063 7.935Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6C37",
        d: "M110.467 145.277a3.17 3.17 0 0 1-3.2-3.2c0-.895.385-1.663.897-2.303l7.806-7.807a1.237 1.237 0 0 1 1.792 0l8.062 8.063c.384.384.512.768.384 1.28-.128.384-.512.767-1.023.895l-14.078 3.072zm6.399-10.622-6.91 6.91c-.257.257-.257.512-.129.768s.384.384.768.384l11.774-2.56zm86.384-69.748c-.256-.767-1.151-1.151-1.92-.895-.767.255-1.151 1.151-.895 1.92 0 .127.128.255.128.383.768 1.536.512 3.455-.512 4.863-.512.64-.384 1.536.128 2.048.64.512 1.536.384 2.048-.256 1.92-2.432 2.303-5.503 1.023-8.063"
    }));

const PowerShell = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 96.306,
        x2: 25.454,
        y1: 35.144,
        y2: 98.431,
        gradientTransform: "matrix(1 0 0 -1 0 128)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#a9c8ff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#c7e6ff"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        fillRule: "evenodd",
        d: "M7.2 110.5c-1.7 0-3.1-.7-4.1-1.9s-1.3-2.9-.9-4.6l18.6-80.5c.8-3.4 4-6 7.4-6h92.6c1.7 0 3.1.7 4.1 1.9s1.3 2.9.9 4.6l-18.6 80.5c-.8 3.4-4 6-7.4 6z",
        clipRule: "evenodd",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 25.336,
        x2: 94.569,
        y1: 98.33,
        y2: 36.847,
        gradientTransform: "matrix(1 0 0 -1 0 128)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#2d4664"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.169,
        stopColor: "#29405b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.445,
        stopColor: "#1e2f43"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.79,
        stopColor: "#0c131b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        fillRule: "evenodd",
        d: "M120.3 18.5H28.5c-2.9 0-5.7 2.3-6.4 5.2L3.7 104.3c-.7 2.9 1.1 5.2 4 5.2h91.8c2.9 0 5.7-2.3 6.4-5.2l18.4-80.5c.7-2.9-1.1-5.3-4-5.3",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2C5591",
        fillRule: "evenodd",
        d: "M64.2 88.3h22.3c2.6 0 4.7 2.2 4.7 4.9s-2.1 4.9-4.7 4.9H64.2c-2.6 0-4.7-2.2-4.7-4.9s2.1-4.9 4.7-4.9m14.5-21.8c-.4.8-1.2 1.6-2.6 2.6L34.6 98.9c-2.3 1.6-5.5 1-7.3-1.4-1.7-2.4-1.3-5.7.9-7.3l37.4-27.1v-.6l-23.5-25c-1.9-2-1.7-5.3.4-7.4 2.2-2 5.5-2 7.4 0l28.2 30c1.7 1.9 1.8 4.5.6 6.4",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "evenodd",
        d: "M77.6 65.5c-.4.8-1.2 1.6-2.6 2.6L33.6 97.9c-2.3 1.6-5.5 1-7.3-1.4-1.7-2.4-1.3-5.7.9-7.3l37.4-27.1v-.6l-23.5-25c-1.9-2-1.7-5.3.4-7.4 2.2-2 5.5-2 7.4 0l28.2 30c1.7 1.8 1.8 4.4.5 6.4M63.5 87.8h22.3c2.6 0 4.7 2.1 4.7 4.6 0 2.6-2.1 4.6-4.7 4.6H63.5c-2.6 0-4.7-2.1-4.7-4.6 0-2.6 2.1-4.6 4.7-4.6",
        clipRule: "evenodd"
    }));

const PowerToys = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__New_Gradient_Swatch",
        x1: 202.55,
        x2: 53.45,
        y1: 257.12,
        y2: -1.12,
        "data-name": "New Gradient Swatch",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#d7ccb3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#f2e6ca"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__linear-gradient",
        x1: 134.91,
        x2: 84.09,
        y1: 145.01,
        y2: 56.99,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#ffb900"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fef000"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__linear-gradient-2",
        x1: 98.76,
        x2: 48.91,
        y1: 144.52,
        y2: 58.19,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#d83b01"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ec6725"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__linear-gradient-3",
        x1: 171.91,
        x2: 121.09,
        y1: 145.01,
        y2: 56.99,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#56b60e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#66eb6e"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__linear-gradient-4",
        x1: 207.09,
        x2: 157.24,
        y1: 143.81,
        y2: 57.48,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#0078d4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#28afea"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__New_Gradient_Swatch",
        id: "prefix__New_Gradient_Swatch-2",
        x1: 80.07,
        x2: 59.93,
        y1: 203.45,
        y2: 168.55,
        "data-name": "New Gradient Swatch"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__New_Gradient_Swatch",
        id: "prefix__New_Gradient_Swatch-3",
        x1: 138.07,
        x2: 117.93,
        y1: 203.45,
        y2: 168.55,
        "data-name": "New Gradient Swatch"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__New_Gradient_Swatch",
        id: "prefix__New_Gradient_Swatch-4",
        x1: 196.07,
        x2: 175.93,
        y1: 203.45,
        y2: 168.55,
        "data-name": "New Gradient Swatch"
    }), /*#__PURE__*/ React.createElement("style", null, ".prefix__cls-2{fill:#fff}.prefix__cls-5{mix-blend-mode:multiply}")), /*#__PURE__*/ React.createElement("g", {
        style: {
            isolation: "isolate"
        }
    }, /*#__PURE__*/ React.createElement("g", {
        id: "prefix__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "prefix__Ramp_Work",
        "data-name": "Ramp Work"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 224,
        height: 224,
        x: 16,
        y: 16,
        rx: 10.67,
        ry: 10.67,
        style: {
            fill: "url(#prefix__New_Gradient_Swatch)"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M32 32h192v192H32z",
        style: {
            fill: "#666"
        }
    }), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: "multiply",
            opacity: 0.32
        }
    }, /*#__PURE__*/ React.createElement("image", {
        xlinkHref: "data:image/png;base64,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",
        width: 180,
        height: 129,
        className: "prefix__cls-5",
        transform: "translate(38.07 42.07)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 148,
        height: 96,
        x: 54,
        y: 53,
        className: "prefix__cls-2",
        rx: 5.31,
        ry: 5.31
    })), /*#__PURE__*/ React.createElement("g", {
        style: {
            opacity: 0.24,
            mixBlendMode: "multiply"
        }
    }, /*#__PURE__*/ React.createElement("image", {
        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAABoCAYAAADmZ4I7AAAACXBIWXMAAAsSAAALEgHS3X78AAADEklEQVR4nO3Z20pUYRyG8WdGzU2gdaBGBhF4A0W30N1X3oAnkgoqSXngJsuJBf8PVuO4Td8Oen6wWIwza8CPh2+jA67X3r/pc/q/jeq3H103CpMiGvSuGeBJ3Q1Ok3SBnQM/6j7qXX8YD2hYYc3V9QxYARaBaYPTmC6on8ARsA98A07r6sK76H+8H88UMA8sA2sVWXdfB1aBWUdaE5wBe8AmsFPRdfcD4AT41R5psXUz2gLwCngLvAdeV3irNbPNONKa4Lxmtr0KbAv4CGwA28Bxm+Ha0jhTYXWhfQDeVWTzNaO5Z9NVuqX0OfCiZrL1ek3Neru1nxu12OZqVntfob2pmW7YOyxIVxnWQfJpddM5BL4AXys2+rGt1NK5Wg9MO7S6pTYhte1Y2+8v9VbFUTt9dqfOl7WUztdD0n20pi5tv9r0tzJ26nTZ1N+61FCrcHHs1GlsenBD/E+BQvp7MyPTo/IgoBhjU4yxKcbYFGNsijE2xRibYoxNMcamGGNTjLEpxtgUY2yKMTbFGJtijE0xxqYYY1OMsSnG2BRjbIoxNsUYm2KMTTHGphhjU4yxKcbYFGNsijE2xRibYoxNMcamGGNTjLEpxtgUY2yKMTbFGJtijE0xxqYYY1OMsSnG2BRjbIoxNsUYm2KMTTHGphhjU4yxKcbYFGNsijE2xRibYoxNMcamGGNTjLEpxtgUY2yKMTbFGJtijE0xxqYYY1OMsSnG2BRjbIoxNsUYm2KMTTHGphhjU4yxKcbYFGNsijE2xRibYvqxjRx2PaZhRXYO/Ki70elRDCuwI2Cv7ganRzGsGW0f2KzgzoxND+BSQ21m+wbsAgfACXDhaOueLqqps/FVcrpenNbstgWsAwt1eVrVXXShHVdLO8D3fnD92LaBj8Dz+vIVYMah1h2cV2ifgU8V3Fl7fLp3Gu2W0I36+SGwBsw50rqD0wrsU7V00J/ZBr3vmQLmgeUKbaliHDjauoUuqJ+1dO709v+/2qPjIQ1r6Zytu6HpLkZjh4M/DpqTYhpc8550k3b69M9n+keA383afjKvQ6mYAAAAAElFTkSuQmCC",
        width: 154,
        height: 103,
        className: "prefix__cls-5",
        transform: "translate(51.01 50.01)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 148,
        height: 96,
        x: 54,
        y: 53,
        className: "prefix__cls-2",
        rx: 5.31,
        ry: 5.31
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M91 53h37v96H91z",
        style: {
            fill: "url(#prefix__linear-gradient)"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91 149H59.35a5.35 5.35 0 0 1-5.35-5.35v-85.3A5.35 5.35 0 0 1 59.35 53H91z",
        style: {
            fill: "url(#prefix__linear-gradient-2)"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128 53h37v96h-37z",
        style: {
            fill: "url(#prefix__linear-gradient-3)"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M165 53h31.65c2.95 0 5.35 2.4 5.35 5.35v85.31c0 2.95-2.4 5.35-5.35 5.35H165z",
        style: {
            fill: "url(#prefix__linear-gradient-4)"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h256v256H0z",
        style: {
            fill: "none"
        }
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 32,
        height: 32,
        x: 54,
        y: 170,
        rx: 4.67,
        ry: 4.67,
        style: {
            fill: "url(#prefix__New_Gradient_Swatch-2)"
        }
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 32,
        height: 32,
        x: 112,
        y: 170,
        rx: 4.67,
        ry: 4.67,
        style: {
            fill: "url(#prefix__New_Gradient_Swatch-3)"
        }
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 32,
        height: 32,
        x: 170,
        y: 170,
        rx: 4.67,
        ry: 4.67,
        style: {
            fill: "url(#prefix__New_Gradient_Swatch-4)"
        }
    })))));

const Preact = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 296",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#673AB8",
        d: "m128 0 128 73.9v147.8l-128 73.9L0 221.7V73.9z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M34.865 220.478c17.016 21.78 71.095 5.185 122.15-34.704 51.055-39.888 80.24-88.345 63.224-110.126-17.017-21.78-71.095-5.184-122.15 34.704-51.055 39.89-80.24 88.346-63.224 110.126m7.27-5.68c-5.644-7.222-3.178-21.402 7.573-39.253 11.322-18.797 30.541-39.548 54.06-57.923s48.303-32.004 69.281-38.442c19.922-6.113 34.277-5.075 39.92 2.148s3.178 21.403-7.573 39.254c-11.322 18.797-30.541 39.547-54.06 57.923-23.52 18.375-48.304 32.004-69.281 38.441-19.922 6.114-34.277 5.076-39.92-2.147Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M220.239 220.478c17.017-21.78-12.169-70.237-63.224-110.126C105.96 70.464 51.88 53.868 34.865 75.648c-17.017 21.78 12.169 70.238 63.224 110.126s105.133 56.485 122.15 34.704m-7.27-5.68c-5.643 7.224-19.998 8.262-39.92 2.148-20.978-6.437-45.761-20.066-69.28-38.441-23.52-18.376-42.74-39.126-54.06-57.923-10.752-17.851-13.218-32.03-7.575-39.254 5.644-7.223 19.999-8.261 39.92-2.148 20.978 6.438 45.762 20.067 69.281 38.442s42.739 39.126 54.06 57.923c10.752 17.85 13.218 32.03 7.574 39.254Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M127.552 167.667c10.827 0 19.603-8.777 19.603-19.604s-8.776-19.603-19.603-19.603-19.604 8.777-19.604 19.603 8.777 19.604 19.604 19.604"
    }));

const Premiere = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 83 80",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00005B",
        d: "M14.53 0H67.52c8.035 0 14.53 6.496 14.53 14.53v50.94c0 8.034-6.495 14.53-14.53 14.53H14.53C6.496 80 0 73.504 0 65.47V14.53C0 6.496 6.496 0 14.53 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#99F",
        d: "M19.487 56.103v-35.18c0-.24.103-.376.342-.376.581 0 1.128 0 1.915-.034.82-.035 1.675-.035 2.598-.069s1.914-.034 2.974-.068 2.086-.034 3.111-.034c2.804 0 5.129.342 7.043 1.06a12.2 12.2 0 0 1 4.581 2.803 10.9 10.9 0 0 1 2.496 3.898c.513 1.435.786 2.906.786 4.444q0 4.41-2.05 7.282c-1.369 1.914-3.283 3.35-5.505 4.17-2.325.856-4.89 1.163-7.692 1.163-.821 0-1.368 0-1.71-.034s-.82-.034-1.47-.034v10.974c.034.24-.137.445-.376.479h-6.633000000000001c-.273 0-.41-.137-.41-.444m7.453-28.958v11.487c.479.035.923.069 1.333.069h1.813c1.333 0 2.666-.205 3.931-.616 1.094-.307 2.051-.957 2.803-1.812.718-.854 1.06-2.017 1.06-3.52a5.63 5.63 0 0 0-.786-3.044 4.96 4.96 0 0 0-2.393-1.948c-1.265-.513-2.633-.718-4.034-.684-.89 0-1.676 0-2.325.034-.684-.034-1.162 0-1.402.034M50.12 29.128h5.983c.341 0 .615.24.718.547.102.273.17.547.205.855.068.342.136.718.17 1.06.035.376.069.786.069 1.23a12.7 12.7 0 0 1 3.658-2.94c1.573-.889 3.385-1.333 5.197-1.333.239-.034.444.137.478.376v6.803000000000001c0 .274-.17.376-.547.376a14.9 14.9 0 0 0-3.692.342 14 14 0 0 0-2.872.923c-.65.308-1.265.718-1.743 1.265v17.436c0 .342-.137.479-.445.479h-6.735c-.273.034-.513-.137-.547-.41V37.06c0-.82 0-1.676-.034-2.564-.034-.89-.034-1.778-.069-2.667 0-.786-.068-1.539-.136-2.325a.315.315 0 0 1 .24-.376c0-.034.068-.034.102 0"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h82.051v80H0z"
    }))));

const PrettierDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 210 210",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 200)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        x: 150,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 70,
        height: 10,
        x: 70,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        fill: "#EA5E5E",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 180)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        x: 160,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 130,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        x: 70,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 40,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        fill: "#56B3B4",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 160)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 100,
        height: 10,
        x: 110,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 70,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        fill: "#BF85BF",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 140)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 180,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 140,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 100,
        height: 10,
        x: 30,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        fill: "#BF85BF",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 120)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 170,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 120,
        fill: "#BF85BF",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        x: 60,
        fill: "#EA5E5E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        fill: "#56B3B4",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 100)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 180,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 90,
        height: 10,
        x: 80,
        fill: "#56B3B4",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 30,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        fill: "#EA5E5E",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 80)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 190,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        x: 120,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 70,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        fill: "#BF85BF",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 60)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 190,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        x: 120,
        fill: "#EA5E5E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 70,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 40,
        fill: "#56B3B4",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        fill: "#F7B93E",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 40)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 180,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 150,
        fill: "#56B3B4",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        x: 90,
        fill: "#BF85BF",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 80,
        height: 10,
        fill: "#56B3B4",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 20)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 170,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 110,
        height: 10,
        x: 50,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        fill: "#EA5E5E",
        rx: 5
    })), /*#__PURE__*/ React.createElement("rect", {
        width: 70,
        height: 10,
        x: 140,
        fill: "#4D616E",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 130,
        height: 10,
        fill: "#56B3B4",
        rx: 5
    })));

const PrettierLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 210 210",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 200)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        x: 150,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 70,
        height: 10,
        x: 70,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        fill: "#EA5E5E",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 180)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        x: 160,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 130,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        x: 70,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 40,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        fill: "#56B3B4",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 160)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 100,
        height: 10,
        x: 110,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 70,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        fill: "#BF85BF",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 140)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 180,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 140,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 100,
        height: 10,
        x: 30,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        fill: "#BF85BF",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 120)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 170,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 120,
        fill: "#BF85BF",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        x: 60,
        fill: "#EA5E5E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        fill: "#56B3B4",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 100)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 180,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 90,
        height: 10,
        x: 80,
        fill: "#56B3B4",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 30,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        fill: "#EA5E5E",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 80)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 190,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        x: 120,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 70,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        fill: "#BF85BF",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 60)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 190,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 10,
        x: 120,
        fill: "#EA5E5E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 70,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 40,
        fill: "#56B3B4",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        fill: "#F7B93E",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 40)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 30,
        height: 10,
        x: 180,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20,
        height: 10,
        x: 150,
        fill: "#56B3B4",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 50,
        height: 10,
        x: 90,
        fill: "#BF85BF",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 80,
        height: 10,
        fill: "#56B3B4",
        rx: 5
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 20)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        x: 170,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 110,
        height: 10,
        x: 50,
        fill: "#F7B93E",
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 40,
        height: 10,
        fill: "#EA5E5E",
        rx: 5
    })), /*#__PURE__*/ React.createElement("rect", {
        width: 70,
        height: 10,
        x: 140,
        fill: "#CFD4D7",
        opacity: 0.5,
        rx: 5
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 130,
        height: 10,
        fill: "#56B3B4",
        rx: 5
    })));

const PrimeVideo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 800.3 246.3",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M396.5 246.3v-.4c.4-.5 1.1-.8 1.7-.7 2.9-.1 5.7-.1 8.6 0 .6 0 1.3.2 1.7.7v.4z",
        style: {
            fill: "#d1effa"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M408.5 245.9q-6-.15-12 0c-5.5-.3-11-.5-16.5-.9-14.6-1.1-29.1-3.3-43.3-6.6-49.1-11.4-92.2-34.3-129.8-67.6-3.5-3.1-6.8-6.3-10.2-9.5-.8-.7-1.5-1.7-1.9-2.7-.6-1.4-.3-2.9.7-4s2.6-1.5 4-.9c.9.4 1.8.8 2.6 1.3 35.9 22.2 75.1 38.4 116.2 48q20.7 4.8 41.7 7.5c20.1 2.5 40.4 3.4 60.6 2.7 10.9-.3 21.7-1.3 32.5-2.7 25.2-3.2 50.1-8.9 74.2-16.9 12.7-4.2 25.1-9 37.2-14.6 1.8-1 4-1.3 6-.8 3.3.8 5.3 4.2 4.5 7.5-.1.4-.3.9-.5 1.3-.8 1.5-1.9 2.8-3.3 3.8-11.5 9-23.9 16.9-37 23.5-24.7 12.5-51.1 21.4-78.3 26.5q-23.55 4.2-47.4 5.1M260.4 43.2c2.5-1.5 5.1-3.1 7.8-4.5 7-3.6 14.8-5.4 22.7-5 5.7.3 10.9 1.9 14.9 6.1 3.8 3.9 5.2 8.7 5.6 13.9.1 1.1.1 2.2.1 3.4v51.8c0 4.5-.6 5.1-5.1 5.1h-12.2c-.8 0-1.6 0-2.4-.1-1.2-.1-2.2-1.1-2.4-2.3-.2-1.1-.2-2.2-.2-3.3V62c.1-1.9-.1-3.7-.6-5.5-.8-3.1-3.6-5.3-6.8-5.5-5.9-.4-11.8.8-17.2 3.3-.8.2-1.3 1-1.2 1.8v52.6c0 1 0 1.9-.2 2.9 0 1.4-1.1 2.4-2.5 2.4-1.5.1-3 .1-4.6.1h-10.6c-3.7 0-4.5-.9-4.5-4.6V62.2c0-1.7-.1-3.5-.5-5.2-.7-3.4-3.6-5.8-7-6-6-.4-12.1.8-17.5 3.4-.8.2-1.3 1.1-1.1 1.9v53.3c0 3.7-.8 4.5-4.5 4.5H197c-3.5 0-4.4-1-4.4-4.4V40.3q0-1.2.3-2.4c.4-1.2 1.6-1.9 2.8-1.9h12.5c1.8 0 2.9 1.1 3.5 2.8.5 1.4.8 2.7 1.3 4.2 1 0 1.6-.7 2.3-1.1 5.5-3.4 11.3-6.3 17.8-7.5q7.5-1.5 15 0c4.7 1 8.9 3.8 11.6 7.8.2.3.4.5.6.7-.1.1 0 .1.1.3",
        style: {
            fill: "#00a8e1"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M467.7 93c.6-2 1.2-3.9 1.8-5.9 4.6-15.5 9.2-30.9 13.8-46.4l.6-1.8c.5-1.8 2.2-2.9 4-2.9h15.2c3.8 0 4.6 1.1 3.3 4.7l-6 15.9c-6.7 17.4-13.4 34.9-20.1 52.3-.2.6-.5 1.2-.7 1.8-.7 2.1-2.8 3.5-5 3.3q-6.6-.15-13.2 0c-3.1.1-4.9-1.3-6-4.1-2.5-6.6-5.1-13.3-7.6-19.9-6-15.7-12.1-31.4-18.1-47.2-.6-1.2-1-2.6-1.3-3.9-.3-2 .4-3 2.4-3 5.7-.1 11.4 0 17 0 2.4 0 3.5 1.6 4.1 3.7 1.1 3.8 2.2 7.7 3.4 11.5 4.1 13.9 8.1 27.9 12.2 41.8-.1.1 0 .1.2.1",
        style: {
            fill: "#232f3e"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M112.6 47c.7-.2 1.3-.6 1.7-1.2q2.7-2.7 5.7-5.1c5.2-4 11.7-6 18.2-5.5 2.6.1 3.5.9 3.7 3.4.2 3.4.1 6.9.1 10.3.1 1.4 0 2.7-.2 4.1-.4 1.8-1.1 2.5-2.9 2.7-1.4.1-2.7 0-4.1-.1-6.7-.6-13.2.7-19.5 2.8-1.4.5-1.4 1.5-1.4 2.6v48c0 .9 0 1.7-.1 2.6-.1 1.3-1.1 2.3-2.4 2.3-.7.1-1.5.1-2.2.1h-13c-.7 0-1.5 0-2.2-.1-1.3-.1-2.3-1.2-2.4-2.5-.1-.8-.1-1.6-.1-2.4V41c0-4.6.5-5.1 5.1-5.1h9.6c2.6 0 3.8.9 4.5 3.4s1.3 5 1.9 7.7m467.8 101.4c6.6.2 13.1.6 19.5 2.3 1.8.5 3.5 1.1 5.2 1.9 2.3.9 3.8 3.1 4.1 5.5.4 2.8.5 5.7.3 8.6-1.3 17.1-6.6 33.6-15.4 48.3-3.2 5.3-7.1 10.1-11.6 14.3-.9.9-2 1.6-3.2 2-1.9.5-3.1-.5-3.2-2.4.1-1 .3-2 .7-3 3.5-9.4 6.9-18.7 9.6-28.4 1.6-5.3 2.7-10.7 3.4-16.2.2-2 .3-4 .1-6-.1-3.4-2.3-6.3-5.6-7.3q-4.65-1.5-9.6-1.8c-9.2-.4-18.4 0-27.5 1.2l-12.1 1.5c-1.3.1-2.5 0-3.2-1.2s-.4-2.4.3-3.6c.8-1.1 1.8-2.1 3-2.8 7.4-5.3 15.7-8.5 24.5-10.6 6.8-1.4 13.7-2.1 20.7-2.3",
        style: {
            fill: "#00a8e1"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M538.5 75v36c-.2 2-1.1 2.9-3.1 3-5.4.1-10.7.1-16.1 0-2 0-2.9-1-3.1-2.9-.1-.6-.1-1.3-.1-1.9V40c.1-3.1.9-4 4-4h14.4c3.1 0 4 .9 4 4z",
        style: {
            fill: "#232f3e"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M151.6 74.8V39.3c.1-2.4 1-3.3 3.4-3.4q7.8-.15 15.6 0c2.3 0 3 .7 3.2 3 .1.9.1 1.7.1 2.6v66.6c0 1.1-.1 2.2-.2 3.3-.1 1.3-1.1 2.2-2.4 2.3-.6.1-1.1.1-1.7.1h-13.9c-.5 0-.9 0-1.4-.1-1.4-.1-2.6-1.2-2.7-2.6-.1-.8-.1-1.6-.1-2.4.1-11.1.1-22.5.1-33.9M163.2.1c1.6-.1 3.2.2 4.7.7 5.4 1.8 8.2 6.5 7.7 12.6-.4 5.2-4.3 9.4-9.5 10.2-2.2.4-4.5.4-6.7 0-5.7-1.1-9.9-5.3-9.5-12.5.6-7.1 5.3-11 13.3-11",
        style: {
            fill: "#00a8e1"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M527.4.1c2-.2 4 .2 5.9 1 3.9 1.5 6.6 5.1 6.8 9.3.8 9.1-5.3 13.7-13.4 13.5-1.1 0-2.2-.2-3.3-.4-6.2-1.5-9.4-6.3-8.8-13.2.5-5.5 4.8-9.6 10.7-10.1.7-.1 1.4-.2 2.1-.1",
        style: {
            fill: "#232f3e"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M76.7 66.6c-.4-5.2-1.8-10.3-3.9-15-4.1-8.6-10.4-14.9-20-17.1-11-2.4-20.9 0-29.9 6.7q-.9.9-2.1 1.5c-.2-.1-.4-.2-.4-.3-.3-1-.5-2-.8-3-.8-2.5-1.8-3.4-4.5-3.4-3 0-6.1.1-9.1 0-2.3-.1-4.4.2-6 2 0 35 0 70.1.1 105 1.3 2.1 3.3 2.5 5.6 2.4 3.6-.1 7.2 0 10.8 0 6.3 0 6.3 0 6.3-6.2v-28.5c0-.7-.3-1.5.4-2.1 5 3.9 11.1 6.3 17.4 6.9 8.8.9 16.8-1.3 23.5-7.3 4.9-4.5 8.5-10.3 10.4-16.7 2.7-8.2 2.9-16.5 2.2-24.9M52.8 87.3c-.7 3.1-2.3 5.9-4.6 8-2.6 2.2-5.8 3.5-9.2 3.5-5.1.3-10.1-.8-14.6-3.2-1.1-.5-1.8-1.6-1.7-2.8V74.7c0-6 .1-12 0-18-.1-1.4.7-2.6 2-3.1 5.5-2.6 11.2-3.8 17.2-2.6 4.2.6 7.8 3.3 9.5 7.2 1.5 3.2 2.4 6.7 2.6 10.2.6 6.4.6 12.8-1.2 18.9",
        style: {
            fill: "#00a8e1"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M800.1 82.2s0-.1 0 0q0-.15 0 0m.1-13.4v.4c-.4-.4-.6-1-.4-1.5v-.8s0-.1.1-.1h-.1v-1h.2c0-.1-.1-.1-.1-.2-.2-1.9-.6-3.8-1.1-5.6-3.7-13.2-12-21.9-25.5-25.3-6.3-1.5-12.7-1.7-19.1-.7-13.5 2-23.2 9.2-27.9 22-4.6 12.2-4.5 25.6.1 37.8 4 11.1 12 18.1 23.5 21 6.1 1.5 12.5 1.9 18.8 1 21-2.5 29.7-18.4 31.1-32.2h-.1v-1.4c-.1-.6-.2-1.1.4-1.5v.2c0-.1.1-.3.2-.4V69c0-.1-.1-.1-.1-.2m-24 19c-.6 2.1-1.5 4-2.8 5.8-2.2 3.1-5.7 5.1-9.5 5.4-1.9.2-3.8.2-5.7-.2-4.2-.8-7.7-3.6-9.4-7.5-1.5-3.1-2.4-6.5-2.7-9.9-.5-5.9-.6-11.8.8-17.6.5-2.3 1.5-4.6 2.7-6.6 2.2-3.6 6-5.9 10.2-6.2 1.9-.2 3.8-.2 5.7.2 4 .8 7.3 3.4 9.1 7.1 1.7 3.5 2.7 7.4 2.9 11.3.1 1.8.2 3.6.1 5.4.3 4.4-.2 8.7-1.4 12.8M624.9.8H611c-3.8 0-4.5.7-4.5 4.5v32.4c0 .7.3 1.4-.2 2.1-.9-.1-1.4-.7-2.1-1.1-10.4-6.1-21.3-7.2-32.3-2.1-7.7 3.6-12.5 10.1-15.6 17.8-3 7.4-3.7 15.2-3.5 23.1 0 7.4 1.7 14.7 5 21.3 3.8 7.3 9.3 12.9 17.3 15.3 10.9 3.4 21.1 1.7 30.4-5.2.7-.4 1.1-1.1 2-1.3.5 1.1.9 2.3 1.1 3.5.4 1.6 1.8 2.7 3.5 2.7h2.4c3.6 0 7.1.1 10.6 0 2.8 0 3.6-.9 3.7-3.8V4.6c-.1-3.1-.9-3.8-3.9-3.8m-18.3 73.6v18.2c.2 1.2-.5 2.3-1.6 2.8-4.8 2.7-10.3 3.8-15.7 3-4.6-.5-8.6-3.3-10.7-7.4-1.6-3.2-2.5-6.6-2.8-10.1-.8-6.3-.3-12.7 1.2-18.8.5-1.7 1.1-3.3 2-4.9 2.1-3.9 6.1-6.4 10.5-6.7 5.3-.5 10.6.5 15.4 2.7 1.2.4 1.9 1.6 1.8 2.9-.2 6.2-.1 12.2-.1 18.3",
        style: {
            fill: "#232f3e"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M348 81.3c7.5 1.4 15.2 1.5 22.7.3 4.4-.6 8.6-1.9 12.5-4 4.5-2.6 7.8-6.2 9.2-11.2 3.5-12.6-1.9-25.3-15-30-6.4-2.1-13.2-2.8-19.9-1.9-15.8 1.8-26.1 10.5-30.8 25.6-3.3 10.3-2.9 20.8-.2 31.2 3.5 13.3 12.3 21.2 25.6 24 7.6 1.7 15.3 1.4 22.9.2 4-.7 8-1.7 11.8-3.2 2.3-.9 3.5-2.3 3.4-4.9-.1-2.4 0-4.9 0-7.4 0-3-1.2-3.9-4.1-3.2s-5.7 1.3-8.6 1.9c-6.2 1.3-12.6 1.3-18.8.2-8.5-1.7-14-9-13.5-18 .9.1 1.9.2 2.8.4M345.5 66c.3-2.4 1-4.7 1.9-6.9 3-7.3 9.3-9.8 15.7-9.4 1.8.1 3.6.5 5.3 1.2 2.6 1.1 4.3 3.5 4.6 6.3.3 1.7.2 3.5-.3 5.2-1.2 3.6-4.1 5.1-7.6 5.8-2.1.5-4.3.7-6.5.5-3.9 0-7.9-.3-11.8-.9-1.5-.2-1.5-.2-1.3-1.8",
        style: {
            fill: "#00a8e1"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M685.3 82.3c5.8-.4 11.6-1.5 16.8-4.3 5.3-2.6 9-7.5 10.1-13.3.7-3.6.7-7.4-.1-11-2.1-9-7.8-14.6-16.4-17.5-4.8-1.5-9.9-2.1-14.9-1.9-16.8.4-29.6 8.9-34.8 25.7-3.5 11.1-3 22.4.4 33.5 3.5 11.4 11.5 18.3 22.9 21.4 4.9 1.2 10 1.7 15 1.5 7.3-.1 14.6-1.5 21.5-4.1 2.9-1.1 3.6-2.1 3.6-5.2v-7.2c-.1-2.9-1.3-3.9-4.2-3.2-2.2.6-4.3 1.1-6.5 1.6-6.7 1.6-13.7 1.9-20.5.7-6.8-1.3-11.4-5.2-13.2-12-.5-2-.9-4-1.1-6.1.5 0 1 0 1.4.2 6.6 1.2 13.3 1.7 20 1.2m-20.9-16c.7-3.9 1.6-7.7 4-10.9 3.7-4.9 8.8-6.3 14.6-5.7.5 0 .9.2 1.4.2 7 1.1 8.7 6.7 7.4 12.1-1 4-4.3 5.5-8 6.2-2 .4-4.1.6-6.2.5-4.1-.1-8.1-.4-12.1-1-.9-.1-1.3-.5-1.1-1.4",
        style: {
            fill: "#232f3e"
        }
    }));

const PrismaDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 310",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M254.313 235.519 148 9.749A17.06 17.06 0 0 0 133.473.037a16.87 16.87 0 0 0-15.533 8.052L2.633 194.848a17.47 17.47 0 0 0 .193 18.747L59.2 300.896a18.13 18.13 0 0 0 20.363 7.489l163.599-48.392a17.93 17.93 0 0 0 11.26-9.722 17.54 17.54 0 0 0-.101-14.76zm-23.802 9.683-138.823 41.05c-4.235 1.26-8.3-2.411-7.419-6.685l49.598-237.484c.927-4.443 7.063-5.147 9.003-1.035l91.814 194.973a6.63 6.63 0 0 1-4.18 9.18z"
    }));

const PrismaLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 310",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M254.313 235.519 148 9.749A17.06 17.06 0 0 0 133.473.037a16.87 16.87 0 0 0-15.533 8.052L2.633 194.848a17.47 17.47 0 0 0 .193 18.747L59.2 300.896a18.13 18.13 0 0 0 20.363 7.489l163.599-48.392a17.93 17.93 0 0 0 11.26-9.722 17.54 17.54 0 0 0-.101-14.76zm-23.802 9.683-138.823 41.05c-4.235 1.26-8.3-2.411-7.419-6.685l49.598-237.484c.927-4.443 7.063-5.147 9.003-1.035l91.814 194.973a6.63 6.63 0 0 1-4.18 9.18z"
    }));

const Procure = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "prefix__Layer_1",
        x: 0,
        y: 0,
        viewBox: "0 0 69.2 108.3",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("style", null, ".prefix__st0{fill:#ea6611}"), /*#__PURE__*/ React.createElement("path", {
        d: "M36.3 68.8v-26c0-1.2.6-2.4 1.7-3.1l24.5-15.4c2.4-1.5 5.5.2 5.5 3.1v22.4c0 1.9-1 3.6-2.6 4.6L39 70.4c-1.2.7-2.7-.2-2.7-1.6M32.7 104.8V78.1c0-1.2-.6-2.4-1.7-3.1L4.9 58.6c-1.7-1.1-3.9.2-3.9 2.1v25.4c0 1.2.6 2.4 1.7 3.1L30 106.3c1.2.8 2.7-.1 2.7-1.5",
        className: "prefix__st0"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M36.3 3.2v30.2c0 1.4 1.6 2.3 2.8 1.5l20.4-13.3c1.7-1.1 1.8-3.5.1-4.7L39.2 1.7c-1.2-.9-2.9 0-2.9 1.5",
        style: {
            fill: "#ff9b5a"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M32.7 2.9v65.9c0 1.4-1.6 2.3-2.8 1.5L2.7 53.2c-1-.7-1.7-1.8-1.7-3.1V21.5c0-1.2.6-2.4 1.7-3.1L30 1.3c1.2-.7 2.7.1 2.7 1.6",
        style: {
            fill: "#fe7f2d"
        }
    }));

const ProductHunt = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 960 960",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6154",
        d: "m479.5-.312 4.16.006C503.25-.264 522.588.05 542 3l4.31.634C621.48 14.813 694.02 41.355 756 86l2.344 1.688c9.448 6.834 18.77 13.756 27.656 21.312l1.618 1.365q2.665 2.25 5.32 4.51l1.59 1.35c9.75 8.358 19.06 17.176 28.137 26.254 1.527 1.526 3.063 3.043 4.599 4.56 5.621 5.59 10.854 11.313 15.78 17.543 1.933 2.39 3.967 4.625 6.081 6.856 7.269 7.992 13.506 16.85 19.875 25.562.54.737 1.082 1.474 1.64 2.233 54.686 74.827 89.219 170.281 89.563 263.51l.022 3.86c.019 4.09.024 8.181.025 12.272v2.112c.002 20.483-.165 40.713-3.25 61.013l-.634 4.31C945.204 621.363 918.738 694.192 874 756l-1.684 2.335C865.479 767.79 858.539 777.093 851 786q-1.286 1.546-2.57 3.094c-10.295 12.357-21.33 23.898-32.68 35.281l-1.575 1.583c-5.877 5.9-11.816 11.655-18.175 17.042l-2.922 2.563C783.43 853.878 773.273 861.476 763 869l-2.22 1.63c-74.858 54.706-170.242 89.228-263.522 89.573l-3.861.022c-4.09.019-8.181.024-12.272.025h-2.112c-20.483.002-40.713-.165-61.013-3.25l-4.31-.634C373.513 950.39 334.568 940.583 297 925l-3.105-1.284C262.275 910.515 231.783 894.11 204 874l-2.335-1.684C192.214 865.48 182.888 858.559 174 851l-1.618-1.365q-2.665-2.25-5.32-4.51l-1.59-1.35c-9.75-8.358-19.06-17.176-28.137-26.254a1193 1193 0 0 0-4.599-4.56c-5.621-5.59-10.854-11.313-15.78-17.543-1.933-2.39-3.967-4.625-6.081-6.856C103.606 780.57 97.369 771.713 91 763c-.54-.737-1.082-1.474-1.64-2.233C34.675 685.94.142 590.486-.202 497.257l-.022-3.86a2679 2679 0 0 1-.026-14.384C-.252 458.53-.085 438.3 3 418l.634-4.31C14.796 338.637 41.262 265.808 86 204l1.684-2.335C94.52 192.214 101.441 182.888 109 174l1.365-1.618q2.25-2.665 4.51-5.32l1.35-1.59c8.358-9.75 17.176-19.06 26.254-28.137 1.526-1.527 3.043-3.063 4.56-4.599 5.59-5.621 11.313-10.854 17.543-15.78 2.39-1.933 4.625-3.967 6.856-6.081C179.43 103.606 188.288 97.369 197 91c.737-.54 1.474-1.082 2.233-1.64C215.69 77.335 233.081 66.7 251 57l2.44-1.337C306.623 26.61 365.794 8.652 426 2l2.332-.261C445.384-.114 462.36-.361 479.5-.312"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFFEFE",
        d: "m312 240 121.813-.187 38.393-.083c15.53-.014 15.53-.014 22.81-.016q7.593-.005 15.183-.03 9.713-.03 19.424-.023 3.546-.001 7.092-.019c17.059-.08 33.456 1.08 49.972 5.67l2.355.642c44.689 12.521 80.857 42.395 103.571 82.558C699.59 341.318 704.307 354.935 708 369l.676 2.426c10.53 41.398.495 87.177-20.387 123.554-23.562 38.33-60.635 65.38-104.164 76.52-6.316 1.485-12.718 2.5-19.125 3.5l-2.828.529c-3.261.484-6.33.594-9.626.591l-3.875.004-4.213-.01h-4.466q-6.045-.001-12.092-.013c-4.216-.006-8.432-.006-12.648-.008q-11.968-.005-23.937-.021-16.177-.018-32.356-.024c-16.986-.01-33.973-.03-50.959-.048v144h-96z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6154",
        d: "m408 336 70.563-.187 22.209-.083c9.01-.014 9.01-.014 13.238-.016q4.393-.005 8.786-.03 5.63-.031 11.261-.023c2.003-.002 4.006-.017 6.01-.034 20.893.07 40.066 6.286 55.183 21.123 14.095 14.384 20.634 31.84 21 51.813-.423 21.786-8.939 39.044-24.621 54.152-15.828 13.758-35.048 17.797-55.459 17.626h-4.3c-3.79.001-7.578-.016-11.366-.037-3.574-.017-7.149-.018-10.723-.02-10.406-.016-20.812-.058-31.219-.096L408 480z"
    }));

const Pulumi = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 271",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F26E7E",
        d: "M43.705 150.707c10.013-5.781 10.03-24.497.038-41.804-9.993-17.306-26.21-26.65-36.223-20.868-10.012 5.78-10.029 24.497-.037 41.803 9.992 17.307 26.21 26.65 36.222 20.869m.06 37.058c9.993 17.306 9.976 36.022-.037 41.803s-26.23-3.562-36.222-20.869-9.976-36.022.037-41.803 26.23 3.562 36.222 20.869M112 227.214c9.992 17.306 9.976 36.021-.037 41.804-10.013 5.78-26.23-3.563-36.222-20.87-9.992-17.306-9.976-36.022.037-41.803s26.23 3.562 36.222 20.869m-.022-78.86c9.992 17.306 9.975 36.022-.037 41.803s-26.23-3.562-36.222-20.869-9.976-36.022.037-41.803c10.012-5.781 26.23 3.562 36.222 20.868Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8A3391",
        d: "M248.477 129.882c9.992-17.307 9.976-36.023-.037-41.804-10.012-5.78-26.23 3.562-36.222 20.869s-9.975 36.022.037 41.804c10.013 5.78 26.23-3.563 36.222-20.87Zm.002 37.039c10.013 5.78 10.03 24.497.038 41.803-9.992 17.307-26.21 26.65-36.222 20.869s-10.03-24.497-.038-41.804c9.993-17.306 26.21-26.65 36.222-20.868m-68.22 39.384c10.013 5.781 10.03 24.497.038 41.804-9.992 17.305-26.21 26.649-36.223 20.868-10.012-5.78-10.029-24.497-.037-41.803 9.993-17.307 26.21-26.65 36.222-20.869m-.038-78.843c10.013 5.781 10.03 24.497.037 41.804-9.992 17.306-26.21 26.65-36.222 20.869s-10.03-24.498-.037-41.804 26.209-26.65 36.222-20.869"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F7BF2A",
        d: "M164.153 20.935c0 11.562-16.2 20.935-36.185 20.935-19.984 0-36.185-9.373-36.185-20.935S107.983 0 127.968 0s36.185 9.373 36.185 20.935m-68.22 39.344c0 11.562-16.2 20.935-36.184 20.935-19.985 0-36.185-9.373-36.185-20.935s16.2-20.935 36.185-20.935c19.984 0 36.185 9.373 36.185 20.935Zm100.344 20.935c19.985 0 36.185-9.373 36.185-20.935s-16.2-20.935-36.185-20.935c-19.984 0-36.185 9.373-36.185 20.935s16.2 20.935 36.185 20.935M164.153 99.71c0 11.562-16.2 20.935-36.185 20.935-19.984 0-36.185-9.373-36.185-20.935s16.2-20.935 36.185-20.935 36.185 9.373 36.185 20.935"
    }));

const Putio = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 256,
        height: 256,
        fill: "#323232",
        rx: 20
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M59 94.25h3.76v-15h3.76v-7.5h3.76V68h3.759v-3.75h3.76v-7.5h7.52V53h3.759v-3.75h7.52V45.5h7.519v-3.75h41.357v3.75h7.519v3.75h7.52V53h7.519v3.75h3.76v3.75h3.76v3.75h3.759v7.5h3.76v7.5h3.76v7.5h3.76v37.5h-3.76v11.25h-3.76v7.5h-3.76v3.75h-3.759v3.75h-3.76v3.75h-3.76V158h-3.759v3.75h-7.52v3.75h-7.519v3.75h-15.039V173H96.597v3.75h-3.76v18.75h-3.76v3.75h-3.759V203H66.52v-3.75h-3.76v-3.75H59zm41.356 0v-7.5h3.76V83h7.519v-3.75h7.52V75.5h11.279v3.75h11.279V83h3.76v3.75h3.76v7.5h3.76v22.5h-3.76v3.75h-3.76v3.75h-3.76V128h-3.759v3.75h-26.319V128h-3.759v-3.75h-3.76v-3.75h-3.76V113h-3.76V94.25z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FDCE45",
        d: "M115.396 90.5h-7.519V98h-3.76v11.25h3.76v7.5h3.76v-7.5h3.759v-7.5h3.76V98h7.519v-3.75h7.52V90.5h3.76v-3.75h-11.28V83h-3.759v3.75h-7.52zM201.871 94.25h-3.76V128h-3.759v11.25h-3.76v7.5h-3.76v3.75h-3.76v3.75h-3.759V158h-3.76v3.75h-3.76v3.75h-3.76v3.75h-7.519V173h-7.52v3.75h-15.038v3.75h-37.598v18.75h-3.76V203h-3.76v3.75h-3.76v3.75H77.8v3.75h3.76V218h18.798v-3.75h3.76v-3.75h3.76v-18.75h3.759V188h37.598v-3.75h15.039v-3.75h7.519v-3.75h7.52V173h3.759v-3.75h3.76v-3.75h3.76v-3.75h3.76V158h3.759v-7.5h3.76v-11.25h3.76v-37.5h-3.76z"
    }));

const PyCharm = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 105 105",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 38.78,
        x2: 95.91,
        y1: 41.59,
        y2: 41.59,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#07c3f2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: -29.18,
        x2: 88.46,
        y1: 85.52,
        y2: -1.32,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#fcf84a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.11,
        stopColor: "#a7eb62"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.21,
        stopColor: "#5fe077"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.27,
        stopColor: "#32da84"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.31,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.58,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.69,
        stopColor: "#20d68c"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.76,
        stopColor: "#1ed497"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.83,
        stopColor: "#19d1a9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopColor: "#13ccc2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.97,
        stopColor: "#0bc6e1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#07c3f2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 17.3,
        x2: 36.92,
        y1: 110.99,
        y2: 49.42,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.16,
        stopColor: "#24d888"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#2fd985"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.43,
        stopColor: "#41dc80"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.55,
        stopColor: "#5ae079"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.67,
        stopColor: "#7ae46f"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.79,
        stopColor: "#a1ea64"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopColor: "#cff157"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fcf84a"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 43.28,
        x2: 85.97,
        y1: 57.46,
        y2: 0.06,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#21d789"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.09,
        stopColor: "#23d986"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.17,
        stopColor: "#2ade7b"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#36e669"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.27,
        stopColor: "#3bea62"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.35,
        stopColor: "#47eb61"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.49,
        stopColor: "#67ed5d"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.69,
        stopColor: "#9af156"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.92,
        stopColor: "#e0f64d"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fcf84a"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 108.58,
        x2: 22.55,
        y1: 64.77,
        y2: 63.97,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.39,
        stopColor: "#fcf84a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.46,
        stopColor: "#ecf74c"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.61,
        stopColor: "#c1f451"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.82,
        stopColor: "#7eef5a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#3bea62"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m71.81 19.65 28.05 23.33-10.1 20.55-16.91-4.69H58.22z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m43.55 34.8-5.43 28.73-.52 9.76-13.69 5.93L4.5 81.31l5.89-62.07L45.56 4.5l21.67 14.21z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m43.55 34.8 2.64 55.36-8.77 10.34L4.5 81.31l27.03-40.28z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M79.77 30.76H46.51L75.9 4.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "m100.5 90.38-29.28 9.94-38.99-10.98L43.55 34.8l4.52-4.04 23.74-2.23-2.15 23.84 18.88-7.32z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22.5 22.5h60v60h-60z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M29.98 71.16h22.5v3.75h-22.5zM30 30h9.2c5.36 0 8.61 3.18 8.61 7.77v.06c0 5.2-4.05 7.9-9.09 7.9H35v6.74h-5zm8.86 11.33c2.47 0 3.92-1.47 3.92-3.4v-.06c0-2.22-1.54-3.41-4-3.41H35v6.87zm11.63-.02v-.06A11.41 11.41 0 0 1 62.2 29.63a11.6 11.6 0 0 1 8.86 3.46l-3.14 3.63a8.33 8.33 0 0 0-5.75-2.54c-3.79 0-6.52 3.15-6.52 7v.07c0 3.85 2.67 7.06 6.52 7.06 2.57 0 4.14-1 5.91-2.63l3.14 3.17a11.46 11.46 0 0 1-9.21 4 11.35 11.35 0 0 1-11.52-11.54"
    }));

const Python = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "16 16 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M31.885 16c-8.124 0-7.617 3.523-7.617 3.523l.01 3.65h7.752v1.095H21.197S16 23.678 16 31.876c0 8.196 4.537 7.906 4.537 7.906h2.708v-3.804s-.146-4.537 4.465-4.537h7.688s4.32.07 4.32-4.175v-7.019S40.374 16 31.885 16m-4.275 2.454a1.394 1.394 0 1 1 0 2.79 1.393 1.393 0 0 1-1.395-1.395c0-.771.624-1.395 1.395-1.395"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M32.115 47.833c8.124 0 7.617-3.523 7.617-3.523l-.01-3.65H31.97v-1.095h10.832S48 40.155 48 31.958s-4.537-7.906-4.537-7.906h-2.708v3.803s.146 4.537-4.465 4.537h-7.688s-4.32-.07-4.32 4.175v7.019s-.656 4.247 7.833 4.247m4.275-2.454a1.393 1.393 0 0 1-1.395-1.395 1.394 1.394 0 1 1 1.395 1.395"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 19.075,
        x2: 34.898,
        y1: 18.782,
        y2: 34.658,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#387EB8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#366994"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 28.809,
        x2: 45.803,
        y1: 28.882,
        y2: 45.163,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFE052"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFC331"
    }))));

const Qt = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 54 43",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0c0",
        d: "M1 42V10l9-9h43v33l-9 9z"
    }), /*#__PURE__*/ React.createElement("text", {
        x: 9,
        y: 32,
        fill: "#FFF",
        fontFamily: "Arial",
        fontSize: 32
    }, "Qt"));

const QwenDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#ffff",
        fillRule: "evenodd",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.604 1.34q.59 1.035 1.174 2.075a.18.18 0 0 0 .157.091h5.552q.26 0 .446.327l1.454 2.57c.19.337.24.478.024.837q-.39.646-.76 1.3l-.367.658c-.106.196-.223.28-.04.512l2.652 4.637c.172.301.111.494-.043.77q-.656 1.177-1.335 2.34c-.159.272-.352.375-.68.37a43 43 0 0 0-2.327.016.1.1 0 0 0-.081.05 575 575 0 0 1-2.705 4.74c-.169.293-.38.363-.725.364q-1.495.005-3.017.002a.54.54 0 0 1-.465-.271l-1.335-2.323a.09.09 0 0 0-.083-.049H4.982a1.8 1.8 0 0 1-.805-.092l-1.603-2.77a.54.54 0 0 1-.002-.54l1.207-2.12a.2.2 0 0 0 0-.197 551 551 0 0 1-1.875-3.272l-.79-1.395c-.16-.31-.173-.496.095-.965q.697-1.22 1.387-2.436c.132-.234.304-.334.584-.335a338 338 0 0 1 2.589-.001.12.12 0 0 0 .107-.063l2.806-4.895a.49.49 0 0 1 .422-.246c.524-.001 1.053 0 1.583-.006L11.704 1c.341-.003.724.032.9.34m-3.432.403a.06.06 0 0 0-.052.03L6.254 6.788a.16.16 0 0 1-.135.078H3.253q-.084 0-.041.074l5.81 10.156q.037.062-.034.063l-2.795.015a.22.22 0 0 0-.2.116l-1.32 2.31q-.066.117.068.118l5.716.008q.068 0 .104.061l1.403 2.454q.069.122.139 0l5.006-8.76.783-1.382a.055.055 0 0 1 .096 0l1.424 2.53a.12.12 0 0 0 .107.062l2.763-.02a.04.04 0 0 0 .035-.02.04.04 0 0 0 0-.04l-2.9-5.086a.11.11 0 0 1 0-.113l.293-.507 1.12-1.977q.036-.062-.035-.062H9.2q-.088 0-.043-.077l1.434-2.505a.11.11 0 0 0 0-.114L9.225 1.774a.06.06 0 0 0-.053-.031m6.29 8.02q.07 0 .034.06l-.832 1.465-2.613 4.585a.06.06 0 0 1-.05.029.06.06 0 0 1-.05-.029L8.498 9.841q-.03-.051.028-.054l.216-.012 6.722-.012z"
    }));

const QwenLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        fillRule: "evenodd",
        style: {
            flex: "none",
            lineHeight: 1
        },
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.604 1.34q.59 1.035 1.174 2.075a.18.18 0 0 0 .157.091h5.552q.26 0 .446.327l1.454 2.57c.19.337.24.478.024.837q-.39.646-.76 1.3l-.367.658c-.106.196-.223.28-.04.512l2.652 4.637c.172.301.111.494-.043.77q-.656 1.177-1.335 2.34c-.159.272-.352.375-.68.37a43 43 0 0 0-2.327.016.1.1 0 0 0-.081.05 575 575 0 0 1-2.705 4.74c-.169.293-.38.363-.725.364q-1.495.005-3.017.002a.54.54 0 0 1-.465-.271l-1.335-2.323a.09.09 0 0 0-.083-.049H4.982a1.8 1.8 0 0 1-.805-.092l-1.603-2.77a.54.54 0 0 1-.002-.54l1.207-2.12a.2.2 0 0 0 0-.197 551 551 0 0 1-1.875-3.272l-.79-1.395c-.16-.31-.173-.496.095-.965q.697-1.22 1.387-2.436c.132-.234.304-.334.584-.335a338 338 0 0 1 2.589-.001.12.12 0 0 0 .107-.063l2.806-4.895a.49.49 0 0 1 .422-.246c.524-.001 1.053 0 1.583-.006L11.704 1c.341-.003.724.032.9.34m-3.432.403a.06.06 0 0 0-.052.03L6.254 6.788a.16.16 0 0 1-.135.078H3.253q-.084 0-.041.074l5.81 10.156q.037.062-.034.063l-2.795.015a.22.22 0 0 0-.2.116l-1.32 2.31q-.066.117.068.118l5.716.008q.068 0 .104.061l1.403 2.454q.069.122.139 0l5.006-8.76.783-1.382a.055.055 0 0 1 .096 0l1.424 2.53a.12.12 0 0 0 .107.062l2.763-.02a.04.04 0 0 0 .035-.02.04.04 0 0 0 0-.04l-2.9-5.086a.11.11 0 0 1 0-.113l.293-.507 1.12-1.977q.036-.062-.035-.062H9.2q-.088 0-.043-.077l1.434-2.505a.11.11 0 0 0 0-.114L9.225 1.774a.06.06 0 0 0-.053-.031m6.29 8.02q.07 0 .034.06l-.832 1.465-2.613 4.585a.06.06 0 0 1-.05.029.06.06 0 0 1-.05-.029L8.498 9.841q-.03-.051.028-.054l.216-.012 6.722-.012z"
    }));

const Qwik = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 274",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "22.347%",
        x2: "77.517%",
        y1: "49.545%",
        y2: "50.388%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4340C4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "12%",
        stopColor: "#4642C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#594EE4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "38.874%",
        x2: "60.879%",
        y1: "49.845%",
        y2: "50.385%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4340C4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "74%",
        stopColor: "#534ADB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#594EE4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "-.004%",
        x2: "100.123%",
        y1: "49.529%",
        y2: "50.223%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4340C4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "23%",
        stopColor: "#4340C4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "60%",
        stopColor: "#4F48D5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#594EE4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "35.4%",
        x2: "64.895%",
        y1: "49.459%",
        y2: "50.085%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0080FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#00B9FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: "-.243%",
        x2: "100.411%",
        y1: "49.366%",
        y2: "50.467%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0080FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "17%",
        stopColor: "#008BFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "47%",
        stopColor: "#00A7FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "63%",
        stopColor: "#00B9FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#00B9FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "-.125%",
        x2: "100.225%",
        y1: "49.627%",
        y2: "50.101%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00B9FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "30%",
        stopColor: "#0080FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "60%",
        stopColor: "#2D67F1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "86%",
        stopColor: "#4D55E8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#594EE4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: "4.557%",
        x2: "99.354%",
        y1: "50.184%",
        y2: "51.298%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4340C4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "12%",
        stopColor: "#4642C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#594EE4"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m175.051 236.859 25.162-15.071 49.298-86.929-76.287 89.097z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m242.337 80.408-4.926-9.4-1.932-3.663-.2.196-25.818-47.015C202.984 8.65 190.631 1.231 177.01 1.074l-25.074.206L188.15 114.8l-23.958 23.331 8.924 86.245 73.769-84.021c10.005-11.587 11.97-28.09 4.92-41.646l-9.466-18.302z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m201.113 72.256-43.18-70.907L83.41.003C70.165-.15 57.83 6.573 50.88 17.87L7.01 101.747l34.443-33.334L84.701 8.356l97.894 112.153 18.3-18.626c8.397-8.142 5.54-19.558.22-29.625z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M97.784 95.26 84.522 8.796l-73.148 88.03c-12.328 11.935-14.897 30.662-6.419 45.49l42.98 74.727c6.553 11.464 18.755 18.577 32.024 18.729l42.945.49L71.46 119.607z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M173.227 223.9 71.38 119.022l-13.196 12.59c-10.812 10.248-11.106 27.332-.728 37.921l43.99 66.384 70.65.907 1.127-12.926h.003Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "m101.584 235.903 72.292-11.599 47.704 49.464z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "m173.111 224.483 27.168-3.457 24.096 49.915c1.06 2.06-1.719 3.977-3.373 2.302l-47.89-48.76Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M182.708 120.058 84.681 8.601l12.502 85.958L71.16 118.78l101.772 105.372-7.595-85.905 17.371-18.192z"
    }));

const RDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M16 25.093c-8.839 0-16-4.796-16-10.719C0 8.458 7.161 3.661 16 3.661s16 4.797 16 10.713c0 5.923-7.161 10.719-16 10.719m2.448-17.244c-6.713 0-12.161 3.281-12.161 7.328s5.448 7.328 12.161 7.328 11.677-2.245 11.677-7.328-4.959-7.328-11.677-7.328m5.916 12.411a11.4 11.4 0 0 1 1.537.579c.287.14.547.328.776.552q.212.228.353.511l3.819 6.437h-6.172l-2.885-5.417a6.8 6.8 0 0 0-.953-1.307 1 1 0 0 0-.735-.333H18.64v7.052l-5.457.005V10.318h10.963s4.991.089 4.991 4.839a5.097 5.097 0 0 1-4.772 5.104zm-2.369-6.036h-3.307v3.063h3.307a1.515 1.515 0 0 0 1.532-1.557 1.428 1.428 0 0 0-1.532-1.505z"
    }));

const RLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16 25.093c-8.839 0-16-4.796-16-10.719C0 8.458 7.161 3.661 16 3.661s16 4.797 16 10.713c0 5.923-7.161 10.719-16 10.719m2.448-17.244c-6.713 0-12.161 3.281-12.161 7.328s5.448 7.328 12.161 7.328 11.677-2.245 11.677-7.328-4.959-7.328-11.677-7.328m5.916 12.411a11.4 11.4 0 0 1 1.537.579c.287.14.547.328.776.552q.212.228.353.511l3.819 6.437h-6.172l-2.885-5.417a6.8 6.8 0 0 0-.953-1.307 1 1 0 0 0-.735-.333H18.64v7.052l-5.457.005V10.318h10.963s4.991.089 4.991 4.839a5.097 5.097 0 0 1-4.772 5.104zm-2.369-6.036h-3.307v3.063h3.307a1.515 1.515 0 0 0 1.532-1.557 1.428 1.428 0 0 0-1.532-1.505z"
    }));

const RadixUIDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#ffff",
        style: {
            marginRight: 3
        },
        viewBox: "4 0 17 25",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 25a8 8 0 1 1 0-16zm0-25H4v8h8zm5 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    }));

const RadixUILight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#121212",
        style: {
            marginRight: 3
        },
        viewBox: "4 0 17 25",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 25a8 8 0 1 1 0-16zm0-25H4v8h8zm5 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    }));

const RailwayDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M4.8 438.2A521 521 0 0 0 0 489.7h777.8c-2.7-5.3-6.4-10-10-14.7-133-171.8-204.5-157-306.9-161.3-34-1.4-57.2-2-193-2-72.7 0-151.7.2-228.6.4A621 621 0 0 0 15 386.3h398.6v51.9zm779.1 103.5H.4c.8 13.8 2.1 27.5 4 41h723.4c32.2 0 50.3-18.3 56.1-41M45 724.3s120 294.5 466.5 299.7c207 0 385-123 465.9-299.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M511.5 0A512.2 512.2 0 0 0 65.3 260.6l202.7-.2c158.4 0 164.2.6 195.2 2l19.1.6c66.7 2.3 148.7 9.4 213.2 58.2 35 26.5 85.6 85 115.7 126.5 27.9 38.5 35.9 82.8 17 125.2-17.5 39-55 62.2-100.4 62.2H16.7s4.2 18 10.6 37.8h970.6a510.4 510.4 0 0 0 26.1-160.7A512.4 512.4 0 0 0 511.5 0"
    }));

const RailwayLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M4.8 438.2A521 521 0 0 0 0 489.7h777.8c-2.7-5.3-6.4-10-10-14.7-133-171.8-204.5-157-306.9-161.3-34-1.4-57.2-2-193-2-72.7 0-151.7.2-228.6.4A621 621 0 0 0 15 386.3h398.6v51.9zm779.1 103.5H.4c.8 13.8 2.1 27.5 4 41h723.4c32.2 0 50.3-18.3 56.1-41M45 724.3s120 294.5 466.5 299.7c207 0 385-123 465.9-299.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M511.5 0A512.2 512.2 0 0 0 65.3 260.6l202.7-.2c158.4 0 164.2.6 195.2 2l19.1.6c66.7 2.3 148.7 9.4 213.2 58.2 35 26.5 85.6 85 115.7 126.5 27.9 38.5 35.9 82.8 17 125.2-17.5 39-55 62.2-100.4 62.2H16.7s4.2 18 10.6 37.8h970.6a510.4 510.4 0 0 0 26.1-160.7A512.4 512.4 0 0 0 511.5 0"
    }));

const Raindropio = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 38 31",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M9.5.917a9.5 9.5 0 0 1 9.5 9.5v9.5H9.5a9.5 9.5 0 0 1 0-19"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__c",
        d: "M0 19.917v-9.5l.004-.27a9.5 9.5 0 1 1 9.496 9.77z"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0B7ED0",
        d: "M28.192 4.7c5.077 4.933 5.077 12.93 0 17.863q-.255.248-.519.479L19 31l-8.673-7.958q-.264-.231-.52-.479c-5.076-4.932-5.076-12.93 0-17.863 5.077-4.933 13.309-4.933 18.385 0"
    }), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(0 11.083)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        fill: "#2CD4ED"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0DB4E2",
        d: "M28.192-6.384c5.077 4.933 5.077 12.931 0 17.864q-.255.247-.519.478L19 19.917l-8.673-7.959q-.264-.23-.52-.478c-5.076-4.933-5.076-12.93 0-17.864 5.077-4.933 13.309-4.933 18.385 0",
        mask: "url(#prefix__b)"
    })), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(19 11.083)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__d",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__c"
    })), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__c",
        fill: "#3169FF"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3153FF",
        d: "M9.192-6.384c5.077 4.933 5.077 12.931 0 17.864q-.255.247-.519.478L0 19.917l-8.673-7.959q-.264-.23-.52-.478c-5.076-4.933-5.076-12.93 0-17.864 5.077-4.933 13.309-4.933 18.385 0",
        mask: "url(#prefix__d)"
    }))));

const Randevum = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 -1 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1b8cff",
        d: "M55 35H9L2 54h60Z",
        "data-name": "Path 191",
        opacity: 0.3
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#fff",
        strokeMiterlimit: 10,
        strokeWidth: 2,
        d: "M3 51h58",
        "data-name": "Line 345",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#fff",
        strokeMiterlimit: 10,
        strokeWidth: 2,
        d: "M8.125 38h47.75",
        "data-name": "Line 346",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 4,
        d: "M9 6h46v29H9z",
        "data-name": "Rectangle 44"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 4,
        d: "M9 54v6h46v-6",
        "data-name": "Path 192"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 4,
        d: "M55 35H9L2 54h60Z",
        "data-name": "Path 193"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 12h46",
        "data-name": "Line 347"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M15 32v6",
        "data-name": "Line 348"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M49 32v6",
        "data-name": "Line 349"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 4,
        d: "M15 2v4",
        "data-name": "Line 350"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 4,
        d: "M49 2v4",
        "data-name": "Line 351"
    }), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        "data-name": "Group 4"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20.5 19h5",
        "data-name": "Line 352"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M29.5 19h5",
        "data-name": "Line 353"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M38.5 19h5",
        "data-name": "Line 354"
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        stroke: "#1b8cff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        "data-name": "Group 5"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20.5 25h5",
        "data-name": "Line 355"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M29.5 25h5",
        "data-name": "Line 356"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M38.5 25h5",
        "data-name": "Line 357"
    })));

const RapidAPI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        viewBox: "0 0 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1d4371",
        d: "M.38 32C.38 49.463 14.536 63.62 32 63.62S63.62 49.463 63.62 32 49.464.38 32 .38.38 14.537.38 32"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M32 .001A31.8 31.8 0 0 0 9.374 9.373 31.8 31.8 0 0 0 0 32a31.78 31.78 0 0 0 9.374 22.627 31.8 31.8 0 0 0 22.625 9.372 31.78 31.78 0 0 0 22.627-9.374A31.8 31.8 0 0 0 64 32a31.8 31.8 0 0 0-9.374-22.627A31.8 31.8 0 0 0 31.999.001m0 .38C49.463.38 63.62 14.537 63.62 32S49.464 63.62 32 63.62.38 49.463.38 32 14.536.38 32 .38m21.182 45.816-6.3.5a2.63 2.63 0 0 1-1.848-.704l-2.28-2.197-2.258-2.12a1.32 1.32 0 0 0-.977-.307 1.306 1.306 0 0 0-1.192 1.224c-.02.302.064.603.24.85l3.993 4.774 1.42 1.55a2.11 2.11 0 0 1 .626 2.043 2.11 2.11 0 0 1-1.483 1.54 2.1 2.1 0 0 1-2.065-.55l-1.613-1.35-6.308-5.378a1.29 1.29 0 0 0-1.77.034l-6.105 5.607-1.562 1.4a2.105 2.105 0 0 1-3.598-.856 2.11 2.11 0 0 1 .567-2.074L22.04 48.6l3.8-4.873a1.4 1.4 0 0 0 .232-.903 1.31 1.31 0 0 0-1.237-1.178 1.32 1.32 0 0 0-.964.342l-2.18 2.2-2.196 2.283a2.63 2.63 0 0 1-1.822.772l-6.3-.273-2.104-.108a2.105 2.105 0 0 1-.077-4.209l2.097-.17 4.693-.584a2.644 2.644 0 0 0 2.112-2.638l-.27-14.543c-.144-7.758 6.028-14.165 13.787-14.3s14.165 6.028 14.3 13.787l.27 14.54a2.64 2.64 0 0 0 2.2 2.558l4.712.4 2.1.1a2.08 2.08 0 0 1 1.9.993c.397.656.422 1.48.04 2.152a2.1 2.1 0 0 1-1.87 1.064z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1d4371",
        d: "m41.553 23.552-5.108-3.3c-.91-.547-1.972.192-1.956 1.256.008.57.3.937.76 1.23l2.793 1.818-2.98 1.795c-.683.436-.835 1.214-.44 1.875.37.62 1.148.882 1.805.507l5.05-3c.8-.51.856-1.643.076-2.18m-13.18 2.64-2.746-1.638 2.714-1.763c.892-.584 1.12-1.37.626-2.1-.474-.696-1.266-.787-2.133-.228l-4.36 2.822c-1.214.793-1.192 1.92.057 2.668l4.408 2.607c.87.5 1.683.376 2.114-.336.436-.72.175-1.516-.68-2.034"
    }));

const RaspberryPI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 274.072 350",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M74.19.005c-1.77.055-3.676.708-5.838 2.415C63.057.377 57.922-.332 53.33 3.826c-7.091-.919-9.395.978-11.141 3.194-1.557-.032-11.648-1.6-16.275 5.303-11.629-1.376-15.305 6.841-11.141 14.502-2.375 3.677-4.836 7.309.718 14.319-1.965 3.904-.747 8.139 3.882 13.265-1.222 5.488 1.18 9.36 5.486 12.378-.806 7.51 6.887 11.876 9.184 13.433.882 4.376 2.72 8.505 11.507 10.789 1.449 6.521 6.73 7.648 11.844 9.017-16.901 9.824-31.396 22.75-31.297 54.466l-2.476 4.417c-19.379 11.785-36.815 49.664-9.55 80.453 1.781 9.637 4.768 16.56 7.427 24.221 3.978 30.873 29.937 45.328 36.783 47.037C68.315 318.26 79 325.512 93.46 330.591c13.631 14.06 28.399 19.417 43.247 19.408.218 0 .439.003.657 0 14.849.009 29.616-5.349 43.248-19.408 14.459-5.079 25.146-12.331 35.179-19.974 6.847-1.709 32.806-16.164 36.783-47.037 2.659-7.661 5.646-14.584 7.427-24.221 27.265-30.791 9.83-68.672-9.551-80.458l-2.479-4.416c.098-31.713-14.396-44.64-31.297-54.466 5.113-1.369 10.395-2.495 11.843-9.017 8.786-2.284 10.626-6.413 11.507-10.789 2.297-1.556 9.99-5.922 9.185-13.433 4.306-3.018 6.708-6.89 5.485-12.378 4.629-5.125 5.848-9.36 3.883-13.265 5.555-7.006 3.09-10.639.719-14.316 4.161-7.662.488-15.878-11.145-14.502-4.627-6.903-14.715-5.335-16.275-5.303-1.746-2.215-4.049-4.113-11.139-3.194-4.593-4.157-9.727-3.448-15.023-1.406-6.289-4.962-10.45-.984-15.203.52-7.614-2.488-9.355.92-13.096 2.308-8.304-1.754-10.827 2.065-14.808 6.098l-4.63-.092c-12.524 7.381-18.746 22.41-20.952 30.135-2.207-7.727-8.414-22.756-20.936-30.135l-4.63.092c-3.986-4.032-6.509-7.852-14.813-6.098C92.907 3.858 91.17.45 83.552 2.938c-3.12-.987-5.989-3.039-9.368-2.934z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#BC1142",
        fillRule: "evenodd",
        d: "M177.65 253.658v-.391c-.119-20.27-18.029-36.609-40.01-36.5-21.979.101-39.709 16.621-39.59 36.891v.39c.11 20.271 18.03 36.61 40.01 36.5 21.981-.1 39.701-16.62 39.59-36.89m-62.83-104.84c-16.489-10.811-40.26-3.83-53.079 15.57-12.83 19.41-9.86 43.9 6.64 54.7 16.49 10.811 40.25 3.84 53.08-15.57 12.82-19.411 9.85-43.9-6.641-54.7m44.511-1.961c-16.49 10.811-19.47 35.301-6.64 54.702 12.819 19.41 36.59 26.379 53.08 15.58 16.489-10.811 19.459-35.301 6.64-54.702-12.83-19.41-36.591-26.379-53.08-15.58M32.392 166.478c-29.54 16.87-24.41 54.411-8.471 67.23 14.49 6.431 26.28-72 8.471-67.23m205.769-.98c-17.81-4.77-6.011 73.67 8.47 67.231 15.939-12.811 21.07-50.361-8.47-67.231m-60.5-58.4c-11.32 1.9 54.25 59.16 55.26 46.38 1.04-33.32-24.53-51.57-55.26-46.38m-84.9-.98c-30.729-5.19-56.289 13.069-55.26 46.39 1.01 12.769 66.58-44.49 55.26-46.39m44.139-7.77c-18.34-.48-35.939 13.61-35.979 21.78-.05 9.931 14.5 20.101 36.11 20.351 22.06.16 36.14-8.131 36.21-18.381.079-11.61-20.07-23.931-36.341-23.75m1.121 203.6c-15.891-.39-40.261 6.37-39.961 15.03-.25 5.91 19.131 22.959 38.9 22.109 19.09.33 38.811-16.699 38.55-24.23-.039-7.759-21.499-13.599-37.489-12.909m-59.06-45.969c-13.061-15.16-30.029-24.201-41.02-17.51-7.351 5.59-8.69 24.619 1.77 43.319 15.51 22.29 37.34 24.521 46.33 19.101 9.5-7.101 4.311-31.201-7.08-44.91m115.84-4.361c-12.32 14.43-19.17 40.75-10.189 49.22 8.59 6.59 31.649 5.67 48.689-17.97 12.37-15.88 8.221-42.39 1.16-49.431-10.5-8.119-25.561 2.271-39.66 18.181",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#75A928",
        fillRule: "evenodd",
        d: "M49.247 32.48c25.851 8.78 49.17 20.491 68.71 36.6 22.939-10.85 7.12-38.21-4.07-49.07-.57 2.87-1.209 4.68-1.949 5.22-3.641-3.97-6.621-8.03-11.311-11.85-.02 2.24 1.11 4.68-1.68 6.46-2.52-3.44-5.92-6.51-10.44-9.11 2.181 3.81.38 4.96-.79 6.54-3.449-3-6.729-6.04-13.09-8.4 1.74 2.15 4.17 4.25 1.59 6.72-3.55-2.25-7.119-4.5-15.56-6.1 1.899 2.15 5.84 4.3 3.45 6.46-4.461-1.73-9.391-2.99-14.851-3.72 2.61 2.19 4.79 4.32 2.65 6.01-4.771-1.49-11.34-3.49-17.77-1.76l4.07 4.15c.45.56-9.52.43-16.09.53 2.4 3.39 4.84 6.65 6.27 12.47-.65.67-3.91.29-6.98 0 3.15 6.73 8.62 8.43 9.9 11.31-1.93 1.48-4.6 1.1-7.52.09 2.27 4.75 7.03 8 10.79 11.85-.95.681-2.61 1.091-6.54.62 3.47 3.74 7.67 7.17 12.64 10.25-.88 1.04-3.91.99-6.72 1.061 4.51 4.479 10.3 6.799 15.74 9.729-2.71 1.88-4.65 1.44-6.72 1.41 3.839 3.21 10.38 4.88 16.44 6.81-1.149 1.82-2.3 2.32-4.771 2.83 6.42 3.61 15.621 1.96 18.211 3.801-.62 1.81-2.391 2.989-4.51 3.979 10.34.61 38.609-.38 44.029-22.101C101.796 63.46 82.476 49.61 49.247 32.48m176.309 0c-33.219 17.13-52.539 30.98-63.119 42.79 5.42 21.721 33.689 22.711 44.029 22.101-2.119-.99-3.889-2.17-4.51-3.979 2.59-1.841 11.791-.19 18.211-3.801-2.471-.51-3.621-1.01-4.771-2.83 6.061-1.93 12.602-3.6 16.441-6.81-2.07.03-4.01.47-6.721-1.41 5.439-2.931 11.23-5.25 15.74-9.729-2.811-.07-5.84-.021-6.721-1.061 4.971-3.08 9.17-6.51 12.641-10.25-3.93.471-5.59.061-6.539-.62 3.76-3.851 8.52-7.1 10.789-11.85-2.92 1.01-5.59 1.39-7.52-.09 1.279-2.88 6.75-4.58 9.9-11.31-3.07.29-6.33.67-6.98 0 1.43-5.82 3.879-9.09 6.279-12.47-6.58-.1-16.549.03-16.1-.53l4.07-4.16c-6.42-1.73-13 .28-17.77 1.77-2.141-1.69.039-3.83 2.648-6.01-5.459.73-10.389 1.98-14.85 3.71-2.379-2.15 1.551-4.3 3.451-6.45-8.441 1.6-12.012 3.85-15.561 6.1-2.58-2.47-.15-4.57 1.59-6.72-6.359 2.36-9.641 5.4-13.09 8.4-1.17-1.58-2.971-2.74-.791-6.54-4.52 2.6-7.92 5.67-10.43 9.1-2.799-1.78-1.67-4.21-1.68-6.45-4.699 3.82-7.68 7.88-11.32 11.85-.73-.54-1.379-2.35-1.949-5.22-11.189 10.86-27.01 38.221-4.061 49.07 19.524-16.11 42.844-27.821 68.694-36.601",
        clipRule: "evenodd"
    }));

const Raycast = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 28 28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF6363",
        fillRule: "evenodd",
        d: "M7 18.079V21l-7-7 1.46-1.46L7 18.081zM9.921 21H7l7 7 1.46-1.46zm16.614-5.538L27.996 14l-14-14-1.458 1.466 5.539 5.538H14.73l-3.866-3.858-1.46 1.46 2.405 2.404h-1.68v10.866h10.865v-1.68l2.405 2.404 1.46-1.46-3.865-3.866V9.927zM7.73 6.276 6.265 7.738l1.568 1.566 1.461-1.46zm12.432 12.432-1.46 1.462 1.566 1.568 1.462-1.462zM4.596 9.41l-1.462 1.462L7 14.738v-2.923zm11.596 11.596h-2.924l3.866 3.866 1.462-1.462z",
        clipRule: "evenodd"
    }));

const ReactDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 569 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#58C4DC",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M285.5 201c-30.1 0-54.5 24.4-54.5 54.5s24.4 54.5 54.5 54.5 54.5-24.4 54.5-54.5-24.4-54.5-54.5-54.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M568.96 255.994c0-42.786-39.622-80.313-102.708-105.009.843-5.561 1.605-11.063 2.147-16.464 6.223-61.48-8.59-105.852-41.69-124.967-37.032-21.383-89.34-5.863-142.23 36.462C231.59 3.691 179.284-11.829 142.25 9.554c-33.099 19.115-47.912 63.488-41.69 124.967.542 5.401 1.285 10.923 2.148 16.504a289 289 0 0 0-15.375 6.365C31.011 182.71 0 217.765 0 255.994c0 42.787 39.622 80.313 102.708 105.01-.863 5.561-1.606 11.063-2.147 16.464-6.223 61.48 8.59 105.852 41.689 124.967a73.5 73.5 0 0 0 37.354 9.557c31.352 0 67.964-16.504 104.876-46.02 36.892 29.516 73.524 46.02 104.916 46.02a73.57 73.57 0 0 0 37.354-9.557c33.099-19.115 47.912-63.488 41.69-124.967-.542-5.401-1.305-10.903-2.148-16.464C529.378 336.347 569 298.76 569 255.994M389.155 27.103a47.44 47.44 0 0 1 24.087 5.903c22.982 13.271 33.299 49.272 28.281 98.764a267 267 0 0 1-1.224 10.22 479 479 0 0 0-80.288-16.845 480.3 480.3 0 0 0-54.797-61.179c31.373-24.254 60.818-36.863 83.921-36.863m-10.779 283.103a591 591 0 0 1-33.118 51.2 590 590 0 0 1-60.778 3.091 590 590 0 0 1-60.758-3.092 590 590 0 0 1-33.018-51.2 583 583 0 0 1-27.64-54.21 583 583 0 0 1 27.64-54.212 597 597 0 0 1 32.918-51.019 579 579 0 0 1 60.878-3.172 592 592 0 0 1 60.758 3.092 599 599 0 0 1 33.038 51.1 588 588 0 0 1 27.64 54.21 588 588 0 0 1-27.64 54.212m41.449-20.079a425.5 425.5 0 0 1 15.656 53.208 421 421 0 0 1-53.713 12.95 603 603 0 0 0 20.072-32.507c6.403-11.123 12.405-22.347 18.065-33.57m-173.442 100.17c12.485.763 25.23 1.205 38.137 1.205s25.732-.442 38.237-1.205a424 424 0 0 1-38.237 40.156 422 422 0 0 1-38.137-40.156m-59.051-34.133a421 421 0 0 1-53.733-12.91 425.5 425.5 0 0 1 15.596-53.127c5.58 11.223 11.561 22.447 18.065 33.57 6.503 11.124 13.227 22.087 20.072 32.507m-38.137-134.524a426 426 0 0 1-15.556-52.926 426 426 0 0 1 53.592-12.99c-6.864 10.38-13.589 21.142-20.072 32.365s-12.404 22.307-18.065 33.551m173.543-100.17c-12.485-.763-25.23-1.205-38.237-1.205q-19.35 0-38.137 1.205a422 422 0 0 1 38.137-40.157 422 422 0 0 1 38.237 40.157m79.083 66.62a591 591 0 0 0-20.172-32.527 421 421 0 0 1 53.853 12.97 429 429 0 0 1-15.596 53.127c-5.58-11.224-11.581-22.447-18.065-33.55m-274.203-56.44c-5.078-49.473 5.3-85.494 28.262-98.765a47.6 47.6 0 0 1 24.086-5.903c23.103 0 52.548 12.609 83.92 36.863a481 481 0 0 0-54.836 61.219 486 486 0 0 0-80.288 16.785c-.461-3.433-.883-6.826-1.204-10.2m-29.004 50.316a747 747 0 0 1 9.454-4.015 484.4 484.4 0 0 0 25.592 77.903 483.4 483.4 0 0 0-25.612 78.065c-51.144-20.982-80.79-50.055-80.79-78.065 0-26.543 26.094-53.468 71.356-73.888m57.326 296.857c-22.963-13.272-33.34-49.292-28.262-98.765.321-3.373.743-6.766 1.204-10.22a479 479 0 0 0 80.288 16.846 482 482 0 0 0 54.797 61.219c-43.737 33.791-83.7 44.935-107.967 30.92m285.664-98.765c5.018 49.493-5.3 85.493-28.282 98.765-24.246 14.055-64.23 2.871-107.947-30.92a482 482 0 0 0 54.777-61.219 479 479 0 0 0 80.288-16.846c.481 3.454.883 6.847 1.224 10.22m19.63-46.18a485.3 485.3 0 0 0-25.631-78.024 485.3 485.3 0 0 0 25.611-78.064c51.043 20.982 80.77 50.055 80.77 78.064 0 28.01-29.646 57.083-80.79 78.065"
    })));

const ReactLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 569 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#087EA4",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M285.5 201c-30.1 0-54.5 24.4-54.5 54.5s24.4 54.5 54.5 54.5 54.5-24.4 54.5-54.5-24.4-54.5-54.5-54.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M568.96 255.994c0-42.786-39.622-80.313-102.708-105.009.843-5.561 1.605-11.063 2.147-16.464 6.223-61.48-8.59-105.852-41.69-124.967-37.032-21.383-89.34-5.863-142.23 36.462C231.59 3.691 179.284-11.829 142.25 9.554c-33.099 19.115-47.912 63.488-41.69 124.967.542 5.401 1.285 10.923 2.148 16.504a289 289 0 0 0-15.375 6.365C31.011 182.71 0 217.765 0 255.994c0 42.787 39.622 80.313 102.708 105.01-.863 5.561-1.606 11.063-2.147 16.464-6.223 61.48 8.59 105.852 41.689 124.967a73.5 73.5 0 0 0 37.354 9.557c31.352 0 67.964-16.504 104.876-46.02 36.892 29.516 73.524 46.02 104.916 46.02a73.57 73.57 0 0 0 37.354-9.557c33.099-19.115 47.912-63.488 41.69-124.967-.542-5.401-1.305-10.903-2.148-16.464C529.378 336.347 569 298.76 569 255.994M389.155 27.103a47.44 47.44 0 0 1 24.087 5.903c22.982 13.271 33.299 49.272 28.281 98.764a267 267 0 0 1-1.224 10.22 479 479 0 0 0-80.288-16.845 480.3 480.3 0 0 0-54.797-61.179c31.373-24.254 60.818-36.863 83.921-36.863m-10.779 283.103a591 591 0 0 1-33.118 51.2 590 590 0 0 1-60.778 3.091 590 590 0 0 1-60.758-3.092 590 590 0 0 1-33.018-51.2 583 583 0 0 1-27.64-54.21 583 583 0 0 1 27.64-54.212 597 597 0 0 1 32.918-51.019 579 579 0 0 1 60.878-3.172 592 592 0 0 1 60.758 3.092 599 599 0 0 1 33.038 51.1 588 588 0 0 1 27.64 54.21 588 588 0 0 1-27.64 54.212m41.449-20.079a425.5 425.5 0 0 1 15.656 53.208 421 421 0 0 1-53.713 12.95 603 603 0 0 0 20.072-32.507c6.403-11.123 12.405-22.347 18.065-33.57m-173.442 100.17c12.485.763 25.23 1.205 38.137 1.205s25.732-.442 38.237-1.205a424 424 0 0 1-38.237 40.156 422 422 0 0 1-38.137-40.156m-59.051-34.133a421 421 0 0 1-53.733-12.91 425.5 425.5 0 0 1 15.596-53.127c5.58 11.223 11.561 22.447 18.065 33.57 6.503 11.124 13.227 22.087 20.072 32.507m-38.137-134.524a426 426 0 0 1-15.556-52.926 426 426 0 0 1 53.592-12.99c-6.864 10.38-13.589 21.142-20.072 32.365s-12.404 22.307-18.065 33.551m173.543-100.17c-12.485-.763-25.23-1.205-38.237-1.205q-19.35 0-38.137 1.205a422 422 0 0 1 38.137-40.157 422 422 0 0 1 38.237 40.157m79.083 66.62a591 591 0 0 0-20.172-32.527 421 421 0 0 1 53.853 12.97 429 429 0 0 1-15.596 53.127c-5.58-11.224-11.581-22.447-18.065-33.55m-274.203-56.44c-5.078-49.473 5.3-85.494 28.262-98.765a47.6 47.6 0 0 1 24.086-5.903c23.103 0 52.548 12.609 83.92 36.863a481 481 0 0 0-54.836 61.219 486 486 0 0 0-80.288 16.785c-.461-3.433-.883-6.826-1.204-10.2m-29.004 50.316a747 747 0 0 1 9.454-4.015 484.4 484.4 0 0 0 25.592 77.903 483.4 483.4 0 0 0-25.612 78.065c-51.144-20.982-80.79-50.055-80.79-78.065 0-26.543 26.094-53.468 71.356-73.888m57.326 296.857c-22.963-13.272-33.34-49.292-28.262-98.765.321-3.373.743-6.766 1.204-10.22a479 479 0 0 0 80.288 16.846 482 482 0 0 0 54.797 61.219c-43.737 33.791-83.7 44.935-107.967 30.92m285.664-98.765c5.018 49.493-5.3 85.493-28.282 98.765-24.246 14.055-64.23 2.871-107.947-30.92a482 482 0 0 0 54.777-61.219 479 479 0 0 0 80.288-16.846c.481 3.454.883 6.847 1.224 10.22m19.63-46.18a485.3 485.3 0 0 0-25.631-78.024 485.3 485.3 0 0 0 25.611-78.064c51.043 20.982 80.77 50.055 80.77 78.064 0 28.01-29.646 57.083-80.79 78.065"
    })));

const ReactQuery = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 230",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00435B",
        d: "m158 142.5-5 8.5a8.3 8.3 0 0 1-7.1 4.2h-37.6c-3 0-5.7-1.6-7.2-4.2l-5-8.5zm13.7-23.9-8.6 15H91l-8.7-15h89.3Zm-8.3-23.3 8.3 14.5H82.4l8.4-14.5zm-17.5-22c3 0 5.7 1.5 7.2 4l5.2 9.1H95.9l5.2-9a8.3 8.3 0 0 1 7.2-4.2h37.6Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#002B3B",
        d: "M53.5 69.3c-4.1-20.3-5-35.8-2.3-47a30.2 30.2 0 0 1 9-16.1A25.5 25.5 0 0 1 77.4 0c11 0 22.6 5 35 14.6 5 3.9 10.2 8.6 15.7 14l1.4-1.5C145 13.4 158 4.9 169.1 1.6c6.6-2 12.7-2.2 18.4-.3 6 2 10.7 6.2 14 12 5.5 9.5 7 22 5 37.6-1 6.3-2.4 13.2-4.4 20.7.8 0 1.5.2 2.3.5 19.5 6.4 33.3 13.4 41.7 21.4 5 4.7 8.2 10 9.4 15.8 1.3 6.1 0 12.3-3.3 18.1-5.5 9.5-15.6 17-30 23-5.8 2.4-12.4 4.6-19.7 6.6l.8 2.3c4.1 20.3 5 35.7 2.3 47a30.2 30.2 0 0 1-9 16.1 25.5 25.5 0 0 1-17.3 6.2c-11 0-22.6-5-35-14.6-5-4-10.4-8.7-15.9-14.2-.5.9-1.2 1.7-2 2.4C111 216 98 224.4 86.9 227.7c-6.6 2-12.7 2.2-18.4.3-6-2-10.7-6.2-14-12-5.5-9.5-7-22-5-37.6 1-6.5 2.5-13.7 4.6-21.5-.8 0-1.7-.2-2.5-.5C32.1 149.9 18.3 143 9.9 135c-5-4.7-8.2-10-9.4-15.8-1.3-6.2 0-12.3 3.3-18.1 5.5-9.6 15.6-17.1 30-23 6-2.5 12.8-4.8 20.4-6.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF4154",
        d: "M189.6 161.3c2-.3 3.8 1 4.3 2.8v.2l.2 1c6.7 35.3 2 53-14.2 53-15.8 0-36-15.1-60.4-45.2a3.7 3.7 0 0 1 2.8-6h1.4a354 354 0 0 0 66-5.8Zm-111-26.6h.1l.7 1.2a358 358 0 0 0 38.4 54.5 3.7 3.7 0 0 1-.3 5.1v.1l-1 .7c-27.2 23.4-45 28-53.2 14-8-13.7-5-38.7 8.8-75a3.7 3.7 0 0 1 6.5-.6m124.9-52h.1l1 .3c33.7 11.7 46.6 24.6 38.5 38.7q-12 20.55-69 30a3.7 3.7 0 0 1-3.9-5.5A359.6 359.6 0 0 0 199 84.9a3.7 3.7 0 0 1 4.4-2.3h.1Zm-119-6c1.7 1 2.3 3.3 1.3 5A359.6 359.6 0 0 0 57 143a3.7 3.7 0 0 1-4.5 2.3h-.1l-1-.4c-33.7-11.7-46.6-24.6-38.5-38.6q12-20.7 69-30c1-.2 1.8 0 2.5.4ZM192.6 19c8 13.7 5 38.7-8.8 75a3.7 3.7 0 0 1-6.5.6h-.1l-.7-1.2a358 358 0 0 0-38.4-54.5 3.7 3.7 0 0 1 .3-5.1v-.1l1-.7c27.2-23.4 45-28 53.2-14M77.4 10.6c15.9 0 36 15 60.4 45.1a3.7 3.7 0 0 1-2.7 6h-1.4a354 354 0 0 0-66 5.8c-2 .3-3.8-.9-4.2-2.8v-.1l-.2-1.1c-6.7-35.3-2-53 14.1-53Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFD94C",
        d: "M111.3 73.7h31.6c4.6 0 8.9 2.4 11.2 6.4l15.8 27.7c2.3 4 2.3 8.8 0 12.8l-15.8 27.6c-2.3 4-6.6 6.5-11.2 6.5h-31.6c-4.6 0-8.9-2.5-11.2-6.5l-15.8-27.6c-2.3-4-2.3-8.9 0-12.8L100 80c2.3-4 6.6-6.4 11.2-6.4ZM138 82c4.6 0 8.8 2.5 11.1 6.5l11.1 19.3c2.3 4 2.3 8.8 0 12.8l-11 19.3c-2.4 4-6.6 6.5-11.2 6.5h-22c-4.6 0-8.9-2.5-11.2-6.5l-11-19.3c-2.3-4-2.3-8.9 0-12.8l11-19.3c2.3-4 6.6-6.5 11.2-6.5zm-5.2 9.1h-11.6c-4.6 0-8.9 2.5-11.2 6.5l-5.8 10.2c-2.3 4-2.3 8.8 0 12.8l5.8 10.2c2.3 4 6.6 6.4 11.2 6.4h11.6c4.6 0 8.8-2.4 11.1-6.4l5.9-10.2c2.3-4 2.3-8.9 0-12.8L144 97.6c-2.3-4-6.5-6.5-11.1-6.5Zm-5 8.8c4.6 0 8.8 2.4 11.1 6.4l.9 1.5c2.3 4 2.3 8.8 0 12.8l-.9 1.5c-2.3 4-6.5 6.4-11.1 6.4h-1.6c-4.6 0-8.9-2.4-11.2-6.4l-.8-1.5c-2.3-4-2.3-8.9 0-12.8l.8-1.5c2.3-4 6.6-6.4 11.2-6.4zm-.8 8.6a5.7 5.7 0 1 0 0 11.4 5.7 5.7 0 1 0 0-11.4m-46.5 5.7h10.3"
    }));

const ReactRouter = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 94 61",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F44250",
        d: "M72.732 20.936c-2.677-.842-4.06-.558-6.867-.865-4.34-.473-6.07-2.17-6.803-6.535-.41-2.437.074-6.006-.974-8.215C56.084 1.11 51.394-.78 46.683.298c-3.978.912-7.288 4.887-7.471 8.968-.21 4.66 2.445 8.635 7.004 10.007 2.165.653 4.466.982 6.728 1.148 4.148.303 4.467 2.609 5.59 4.507.707 1.196 1.392 2.375 1.392 5.943s-.69 4.747-1.393 5.944c-1.122 1.894-2.506 3.134-6.654 3.44-2.262.167-4.567.496-6.729 1.15-4.558 1.376-7.213 5.347-7.004 10.006.184 4.081 3.493 8.057 7.471 8.968 4.712 1.083 9.402-.81 11.406-5.023 1.052-2.209 1.628-4.712 2.039-7.149.738-4.366 2.467-6.062 6.803-6.535 2.808-.307 5.713 0 8.344-1.495 2.78-2.031 5.264-5.08 5.264-9.306s-2.676-8.655-6.742-9.935"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#121212",
        d: "M28.2 40.774c-5.471 0-9.934-4.471-9.934-9.953s4.463-9.952 9.934-9.952 9.934 4.47 9.934 9.952c0 5.477-4.468 9.953-9.934 9.953M9.899 61C4.437 60.987-.013 56.498 0 51.012c.013-5.477 4.494-9.935 9.97-9.917 5.466.013 9.916 4.502 9.898 9.988-.013 5.472-4.493 9.93-9.969 9.917M83.714 61c-5.48.03-9.978-4.41-10.009-9.878-.03-5.49 4.402-9.996 9.86-10.027 5.48-.03 9.977 4.41 10.008 9.878.03 5.485-4.401 9.996-9.86 10.027"
    }));

const ReactWheelPickerDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M144 16h-32a64.07 64.07 0 0 0-64 64v96a64.07 64.07 0 0 0 64 64h32a64.07 64.07 0 0 0 64-64V80a64.07 64.07 0 0 0-64-64m2.34 146.34a8.004 8.004 0 0 1 11.32 11.32l-24 24a7.99 7.99 0 0 1-5.66 2.346 8 8 0 0 1-5.66-2.346l-24-24a8.004 8.004 0 1 1 11.32-11.32L120 172.69V83.31l-10.34 10.35a8.004 8.004 0 1 1-11.32-11.32l24-24a8 8 0 0 1 11.32 0l24 24a8.005 8.005 0 0 1-11.32 11.32L136 83.31v89.38z"
    }));

const ReactWheelPickerLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M144 16h-32a64.07 64.07 0 0 0-64 64v96a64.07 64.07 0 0 0 64 64h32a64.07 64.07 0 0 0 64-64V80a64.07 64.07 0 0 0-64-64m2.34 146.34a8.004 8.004 0 0 1 11.32 11.32l-24 24a7.99 7.99 0 0 1-5.66 2.346 8 8 0 0 1-5.66-2.346l-24-24a8.004 8.004 0 1 1 11.32-11.32L120 172.69V83.31l-10.34 10.35a8.004 8.004 0 1 1-11.32-11.32l24-24a8 8 0 0 1 11.32 0l24 24a8.005 8.005 0 0 1-11.32 11.32L136 83.31v89.38z"
    }));

const Reddit = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        className: "prefix___1O4jTk-dZ-VIxsCuYB6OR8",
        viewBox: "0 0 216 216",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__snoo-radial-gragient",
        cx: 169.75,
        cy: 92.19,
        r: 50.98,
        fx: 169.75,
        fy: 92.19,
        gradientTransform: "matrix(1 0 0 .87 0 11.64)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#feffff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#feffff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.51,
        stopColor: "#f9fcfc"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.62,
        stopColor: "#edf3f5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#dee9ec"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.72,
        stopColor: "#d8e4e8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.76,
        stopColor: "#ccd8df"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#c8d5dd"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.83,
        stopColor: "#ccd6de"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.85,
        stopColor: "#d8dbe2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.88,
        stopColor: "#ede3e9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopColor: "#ffebef"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__snoo-radial-gragient",
        id: "prefix__snoo-radial-gragient-2",
        cx: 47.31,
        r: 50.98,
        fx: 47.31
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__snoo-radial-gragient",
        id: "prefix__snoo-radial-gragient-3",
        cx: 109.61,
        cy: 85.59,
        r: 153.78,
        fx: 109.61,
        fy: 85.59,
        gradientTransform: "matrix(1 0 0 .7 0 25.56)"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__snoo-radial-gragient-4",
        cx: -6.01,
        cy: 64.68,
        r: 12.85,
        fx: -6.01,
        fy: 64.68,
        gradientTransform: "matrix(1.07 0 0 1.55 81.08 27.26)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#f60"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopColor: "#ff4500"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#fc4301"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.82,
        stopColor: "#f43f07"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.92,
        stopColor: "#e53812"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#d4301f"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__snoo-radial-gragient-4",
        id: "prefix__snoo-radial-gragient-5",
        cx: -73.55,
        cy: 64.68,
        r: 12.85,
        fx: -73.55,
        fy: 64.68,
        gradientTransform: "matrix(-1.07 0 0 1.55 62.87 27.26)"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__snoo-radial-gragient-6",
        cx: 107.93,
        cy: 166.96,
        r: 45.3,
        fx: 107.93,
        fy: 166.96,
        gradientTransform: "matrix(1 0 0 .66 0 57.4)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#172e35"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.29,
        stopColor: "#0e1c21"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.73,
        stopColor: "#030708"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__snoo-radial-gragient",
        id: "prefix__snoo-radial-gragient-7",
        cx: 147.88,
        cy: 32.94,
        r: 39.77,
        fx: 147.88,
        fy: 32.94,
        gradientTransform: "matrix(1 0 0 .98 0 .54)"
    }), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__snoo-radial-gragient-8",
        cx: 131.31,
        cy: 73.08,
        r: 32.6,
        fx: 131.31,
        fy: 73.08,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.48,
        stopColor: "#7a9299"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.67,
        stopColor: "#172e35"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.75
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.82,
        stopColor: "#172e35"
    })), /*#__PURE__*/ React.createElement("style", null, ".prefix__snoo-cls-11{stroke-width:0;fill:#ffc49c}")), /*#__PURE__*/ React.createElement("path", {
        fill: "#ff4500",
        strokeWidth: 0,
        d: "M108 0C48.35 0 0 48.35 0 108c0 29.82 12.09 56.82 31.63 76.37l-20.57 20.57C6.98 209.02 9.87 216 15.64 216H108c59.65 0 108-48.35 108-108S167.65 0 108 0"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 169.22,
        cy: 106.98,
        r: 25.22,
        fill: "url(#prefix__snoo-radial-gragient)",
        strokeWidth: 0
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 46.78,
        cy: 106.98,
        r: 25.22,
        fill: "url(#prefix__snoo-radial-gragient-2)",
        strokeWidth: 0
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 108.06,
        cy: 128.64,
        fill: "url(#prefix__snoo-radial-gragient-3)",
        strokeWidth: 0,
        rx: 72,
        ry: 54
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__snoo-radial-gragient-4)",
        strokeWidth: 0,
        d: "M86.78 123.48c-.42 9.08-6.49 12.38-13.56 12.38s-12.46-4.93-12.04-14.01 6.49-15.02 13.56-15.02 12.46 7.58 12.04 16.66Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__snoo-radial-gragient-5)",
        strokeWidth: 0,
        d: "M129.35 123.48c.42 9.08 6.49 12.38 13.56 12.38s12.46-4.93 12.04-14.01-6.49-15.02-13.56-15.02-12.46 7.58-12.04 16.66Z"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 79.63,
        cy: 116.37,
        className: "prefix__snoo-cls-11",
        rx: 2.8,
        ry: 3.05
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 146.21,
        cy: 116.37,
        className: "prefix__snoo-cls-11",
        rx: 2.8,
        ry: 3.05
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__snoo-radial-gragient-6)",
        strokeWidth: 0,
        d: "M108.06 142.92c-8.76 0-17.16.43-24.92 1.22-1.33.13-2.17 1.51-1.65 2.74 4.35 10.39 14.61 17.69 26.57 17.69s22.23-7.3 26.57-17.69c.52-1.23-.33-2.61-1.65-2.74-7.77-.79-16.16-1.22-24.92-1.22"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 147.49,
        cy: 49.43,
        r: 17.87,
        fill: "url(#prefix__snoo-radial-gragient-7)",
        strokeWidth: 0
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__snoo-radial-gragient-8)",
        strokeWidth: 0,
        d: "M107.8 76.92c-2.14 0-3.87-.89-3.87-2.27 0-16.01 13.03-29.04 29.04-29.04 2.14 0 3.87 1.73 3.87 3.87s-1.73 3.87-3.87 3.87c-11.74 0-21.29 9.55-21.29 21.29 0 1.38-1.73 2.27-3.87 2.27Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#842123",
        strokeWidth: 0,
        d: "M62.82 122.65c.39-8.56 6.08-14.16 12.69-14.16 6.26 0 11.1 6.39 11.28 14.33.17-8.88-5.13-15.99-12.05-15.99s-13.14 6.05-13.56 15.2 4.97 13.83 12.04 13.83h.52c-6.44-.16-11.3-4.79-10.91-13.2Zm90.48 0c-.39-8.56-6.08-14.16-12.69-14.16-6.26 0-11.1 6.39-11.28 14.33-.17-8.88 5.13-15.99 12.05-15.99 7.07 0 13.14 6.05 13.56 15.2s-4.97 13.83-12.04 13.83h-.52c6.44-.16 11.3-4.79 10.91-13.2Z"
    }));

const Redis = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 220",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#912626",
        d: "M246 169c-13.7 7-84.5 36.2-99.5 44-15.1 7.9-23.5 7.8-35.4 2.1S24 179 10.3 172.5C3.6 169.3 0 166.5 0 164v-26s98-21.3 113.9-27c15.8-5.6 21.3-5.8 34.8-.9 13.4 5 94 19.5 107.3 24.3V160c0 2.5-3 5.3-10 9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C6302B",
        d: "M246 143.2c-13.7 7.1-84.5 36.2-99.5 44-15.1 8-23.5 7.9-35.4 2.2s-87.2-36.1-100.8-42.6c-13.5-6.5-13.8-11-.5-16.2 13.4-5.2 88.2-34.6 104-40.3 16-5.6 21.4-5.8 34.9-1 13.4 5 83.8 33 97.1 37.9s13.8 8.9.2 16"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#912626",
        d: "M246 127c-13.7 7.2-84.5 36.3-99.5 44.2-15.1 7.8-23.5 7.7-35.4 2-11.9-5.6-87.2-36-100.8-42.6-6.7-3.2-10.3-6-10.3-8.5V96.2s98-21.3 113.9-27c15.8-5.7 21.3-5.9 34.8-1 13.4 5 94 19.5 107.3 24.4V118c0 2.5-3 5.4-10 9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C6302B",
        d: "M246 101.4c-13.7 7-84.5 36.2-99.5 44-15.1 7.9-23.5 7.8-35.4 2.1S24 111.4 10.3 105c-13.5-6.5-13.8-11-.5-16.1C23.2 83.5 98 54 113.8 48.5c16-5.7 21.4-6 34.9-1 13.4 5 83.8 33 97.1 37.8 13.3 5 13.8 9 .2 16"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#912626",
        d: "M246 83.7c-13.7 7-84.5 36.2-99.5 44-15.1 7.9-23.5 7.8-35.4 2.1S24 93.7 10.3 87.2C3.6 84 0 81.2 0 78.7v-26s98-21.3 113.9-27c15.8-5.6 21.3-5.8 34.8-.9 13.4 5 94 19.5 107.3 24.4v25.5c0 2.5-3 5.3-10 9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C6302B",
        d: "M246 58c-13.7 7-84.5 36.1-99.5 44-15.1 7.9-23.5 7.8-35.4 2C99.2 98.5 24 68 10.3 61.6c-13.5-6.5-13.8-11-.5-16.2C23.2 40.1 98 10.7 113.8 5c16-5.6 21.4-5.8 34.9-.9 13.4 5 83.8 33 97.1 37.8 13.3 4.9 13.8 9 .2 16"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m159.3 32.8-22 2.2-5 11.9-8-13.2L99 31.4l19-6.9-5.8-10.5 17.8 7 16.7-5.5-4.5 10.9 17 6.4M131 90.3l-41-17 58.8-9.1-17.8 26M74 39.3c17.5 0 31.5 5.5 31.5 12.2 0 6.8-14 12.2-31.4 12.2s-31.5-5.4-31.5-12.2c0-6.7 14.1-12.2 31.5-12.2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#621B1C",
        d: "M185.3 36 220 49.8l-34.8 13.7V36"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9A2928",
        d: "M146.8 51.2 185.3 36v27.5l-3.8 1.5z"
    }));

const Redux = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 -6 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#764ABC",
        d: "M177.381 169.733c9.447-.978 16.614-9.122 16.288-18.896-.325-9.773-8.47-17.592-18.243-17.592h-.651c-10.1.326-17.918 8.796-17.592 18.895.326 4.887 2.28 9.122 5.212 12.054-11.076 21.828-28.016 37.791-53.426 51.148-17.266 9.122-35.183 12.38-53.1 10.1-14.66-1.955-26.062-8.47-33.23-19.222-10.424-15.963-11.401-33.23-2.605-50.496 6.19-12.38 15.962-21.502 22.152-26.063-1.303-4.235-3.258-11.402-4.235-16.614-47.237 34.207-42.35 80.468-28.016 102.295 10.75 16.29 32.577 26.389 56.684 26.389 6.515 0 13.03-.652 19.546-2.28 41.699-8.145 73.299-32.905 91.216-69.718m57.336-40.397c-24.759-28.995-61.245-44.958-102.944-44.958h-5.212c-2.932-5.864-9.122-9.774-15.963-9.774h-.652C99.848 74.93 92.03 83.4 92.355 93.5c.326 9.773 8.47 17.592 18.243 17.592h.651c7.167-.326 13.357-4.887 15.963-11.077h5.864c24.759 0 48.214 7.167 69.39 21.176 16.288 10.751 28.016 24.76 34.531 41.7 5.538 13.683 5.212 27.04-.652 38.443-9.121 17.266-24.432 26.714-44.63 26.714-13.031 0-25.41-3.91-31.926-6.842-3.583 3.258-10.099 8.47-14.66 11.729 14.009 6.515 28.343 10.099 42.025 10.099 31.274 0 54.404-17.267 63.2-34.533 9.447-18.896 8.795-51.474-15.637-79.165M69.225 175.27c.326 9.774 8.47 17.592 18.243 17.592h.652c10.099-.325 17.917-8.796 17.591-18.895-.325-9.774-8.47-17.592-18.243-17.592h-.651c-.652 0-1.63 0-2.28.325-13.357-22.153-18.895-46.26-16.94-72.323 1.302-19.547 7.818-36.488 19.22-50.497 9.447-12.054 27.69-17.918 40.07-18.243 34.531-.652 49.19 42.351 50.168 59.618 4.235.977 11.402 3.258 16.289 4.887C189.434 27.366 156.857 0 125.584 0c-29.32 0-56.359 21.176-67.11 52.451-14.985 41.7-5.212 81.771 13.031 113.372-1.628 2.28-2.606 5.864-2.28 9.448z"
    }));

const RedwoodJS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 277",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M112.4 4C102 9.1 80 19.3 68.2 27.4c-12 8.1-10.4 15.7-15.6 21a410 410 0 0 1-31.3 26.1c-10.3 8-7.8 28.9-10.3 36.8-2.6 7.8-7.8 26.2-10.4 34-2.6 7.9 5.2 18.4 10.4 28.8 5.2 10.5 18.2 39.3 23.4 49.8 5.2 10.4 20.9 5.2 33.9 15.7s31.2 23.6 44.2 31.4c13 7.9 18.2 7.9 31.2 0 13-7.8 31.2-21 44.2-31.4 13-10.5 28.7-5.3 33.9-15.7 5.2-10.5 18.2-39.3 23.4-49.8 5.2-10.4 13-21 10.4-28.8s-7.8-26.2-10.4-34c-2.6-7.9 0-28.8-10.4-36.7a385 385 0 0 1-31.3-26.2c-8.7-8.3-5.2-13-15.6-21C177.4 19.7 154 9.3 143.6 4a33 33 0 0 0-31.2 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#BF4722",
        d: "m75.6 49.3 48.7 33.3c1.1.7 2.4 1 3.7 1.1 1.4 0 2.6-.4 3.7-1.1l48.8-33.4a6.7 6.7 0 0 0-1-11.4l-48.7-24c-1.8-1-4-1-5.8 0l-48.5 24a6.6 6.6 0 0 0-.9 11.5m69 43.7c0 2.2 1 4.3 2.9 5.5l39 26.7a6.6 6.6 0 0 0 8.1-.5l32.7-29.3a6.7 6.7 0 0 0-.2-10.2l-31.3-25a6.6 6.6 0 0 0-7.9-.3l-40.4 27.7a6.7 6.7 0 0 0-3 5.4Zm-97.1 36.3a6.7 6.7 0 0 1 2.2 5.6c-.2 2.1-1.5 4-3.3 5L23 154a6.6 6.6 0 0 1-7.5-.5 6.7 6.7 0 0 1-2.2-7.2l8.6-27.1a6.6 6.6 0 0 1 10.7-3l14.8 13.2Zm126.4 2.8-42.1-28.8a6.6 6.6 0 0 0-7.4 0L82.2 132a6.8 6.8 0 0 0-2.9 5c0 2.1.8 4.1 2.3 5.5l42 37.7a6.6 6.6 0 0 0 8.9 0l42-37.7a6.7 6.7 0 0 0-.6-10.5Zm-112.4-7.4L28.8 95.4a6.8 6.8 0 0 1 .3-10.3l31.2-25.2c2.3-1.8 5.5-1.9 8-.3l40.3 27.7a6.7 6.7 0 0 1 0 11.2l-39 26.7a6.6 6.6 0 0 1-8-.5Zm168 42-33.3-19.9a6.5 6.5 0 0 0-7.8.7L147.7 184a6.7 6.7 0 0 0 2 11.2l56.4 22.8c.7.4 1.6.5 2.4.5 2.6 0 5-1.5 6-4l17.6-39.1c1.4-3.1.3-6.8-2.6-8.6Zm4.6-47.6 8.6 27.1c.6 2 .2 4.2-1 6a6.6 6.6 0 0 1-8.8 1.8l-23.3-14a6.6 6.6 0 0 1-1-10.7l14.8-13.2a6.6 6.6 0 0 1 10.7 3M110.6 190c.4-2.3-.4-4.6-2.1-6.1l-40.7-36.4a6.5 6.5 0 0 0-7.8-.7l-33.3 20a6.8 6.8 0 0 0-2.7 8.4l17.6 39.2A6.6 6.6 0 0 0 50 218l56.4-22.9a6.7 6.7 0 0 0 4-5Zm20 11.2 45.2 18.3c2.3 1 3.8 3 4 5.4.3 2.5-.8 4.9-2.8 6.3l-45.3 31.4c-1 .8-2.4 1.2-3.7 1.2s-2.6-.4-3.7-1.2L79 231.2a6.7 6.7 0 0 1 1.3-11.7l45.3-18.3c1.6-.7 3.4-.7 5 0"
    }));

const RefineDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 120 120",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M68.944 2.111a20 20 0 0 0-17.888 0l-40 20A20 20 0 0 0 0 40v40a20 20 0 0 0 11.056 17.888l40 20.001a20 20 0 0 0 17.888 0l40-20A20 20 0 0 0 120 80V40a20 20 0 0 0-11.056-17.888zM40 40c0-11.046 8.954-20 20-20s20 8.954 20 20v40c0 11.046-8.954 20-20 20s-20-8.954-20-20z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M70 40c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10"
    }));

const RefineLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 120 120",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#14141F",
        fillRule: "evenodd",
        d: "M68.944 2.111a20 20 0 0 0-17.888 0l-40 20A20 20 0 0 0 0 40v40a20 20 0 0 0 11.056 17.888l40 20.001a20 20 0 0 0 17.888 0l40-20A20 20 0 0 0 120 80V40a20 20 0 0 0-11.056-17.888zM40 40c0-11.046 8.954-20 20-20s20 8.954 20 20v40c0 11.046-8.954 20-20 20s-20-8.954-20-20z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#14141F",
        d: "M70 40c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10"
    }));

const ReflexDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 56 12",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 11.6V.4h8.96v4.48H6.72V2.64H2.24v2.24h4.48v2.24H2.24v4.48zm6.72 0V7.12h2.24v4.48zM11.2 11.6V.4h6.72v2.24h-4.48v2.24h4.48v2.24h-4.48v2.24h4.48v2.24zM20.16 11.6V.4h6.72v2.24H22.4v2.24h4.48v2.24H22.4v4.48zM29.12 11.6V.4h2.24v8.96h4.48v2.24zM38.08 11.6V.4h6.72v2.24h-4.48v2.24h4.48v2.24h-4.48v2.24h4.48v2.24zM47.04 4.88V.4h2.24v4.48zm6.72 0V.4H56v4.48zm-4.48 2.24V4.88h4.48v2.24zm-2.24 4.48V7.12h2.24v4.48zm6.72 0V7.12H56v4.48z"
    }));

const ReflexLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 56 12",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#110F1F",
        d: "M0 11.6V.4h8.96v4.48H6.72V2.64H2.24v2.24h4.48v2.24H2.24v4.48zm6.72 0V7.12h2.24v4.48zM11.2 11.6V.4h6.72v2.24h-4.48v2.24h4.48v2.24h-4.48v2.24h4.48v2.24zM20.16 11.6V.4h6.72v2.24H22.4v2.24h4.48v2.24H22.4v4.48zM29.12 11.6V.4h2.24v8.96h4.48v2.24zM38.08 11.6V.4h6.72v2.24h-4.48v2.24h4.48v2.24h-4.48v2.24h4.48v2.24zM47.04 4.88V.4h2.24v4.48zm6.72 0V.4H56v4.48zm-4.48 2.24V4.88h4.48v2.24zm-2.24 4.48V7.12h2.24v4.48zm6.72 0V7.12H56v4.48z"
    }));

const RelaGitDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 214 254",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 214,
        height: 254,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 .5h214v253H0z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M-.5.5h38v128.222c18.536-11.478 42.665-17.28 71-17.28 27.241 0 42.879-6.582 51.947-15.807 9.128-9.287 15.053-24.756 15.053-50.158V.5h38v44.977c0 30.568-7.075 57.577-25.947 76.775-18.932 19.261-46.294 27.171-79.053 27.171-27.227 0-45.08 6.481-55.707 14.889C42.628 172.355 37.5 183.34 37.5 196.898V253.5h-38z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        width: 168,
        height: 127,
        x: 45,
        y: 127,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M193 127.848c-21.526 21.282-51.515 29.485-85.5 29.485-25.981 0-41.758 6.191-50.431 13.054C49.063 176.723 45 185.191 45 196.312V253.5h168V127.641z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M113.631 193.786c-9.102-7.888-19.154-22.171-19.631-38.866l38-.5c.023.796.346 5.316 6.525 10.671 4.962 4.3 11.089 8.268 18.779 13.248 2.208 1.43 4.544 2.943 7.019 4.572C183.619 195.609 213 216.211 213 253.5h-38c0-14.684-10.619-25.078-31.573-38.867-1.738-1.143-3.581-2.333-5.488-3.565-8.001-5.166-17.125-11.057-24.308-17.282",
        clipRule: "evenodd",
        opacity: 0.6
    }))));

const RelaGitLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 214 254",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 214,
        height: 254,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 .5h214v253H0z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M-.5.5h38v128.222c18.536-11.478 42.665-17.28 71-17.28 27.241 0 42.879-6.582 51.947-15.807 9.128-9.287 15.053-24.756 15.053-50.158V.5h38v44.977c0 30.568-7.075 57.577-25.947 76.775-18.932 19.261-46.294 27.171-79.053 27.171-27.227 0-45.08 6.481-55.707 14.889C42.628 172.355 37.5 183.34 37.5 196.898V253.5h-38z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        width: 168,
        height: 127,
        x: 45,
        y: 127,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M193 127.848c-21.526 21.282-51.515 29.485-85.5 29.485-25.981 0-41.758 6.191-50.431 13.054C49.063 176.723 45 185.191 45 196.312V253.5h168V127.641z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M113.631 193.786c-9.102-7.888-19.154-22.171-19.631-38.866l38-.5c.023.796.346 5.316 6.525 10.671 4.962 4.3 11.089 8.268 18.779 13.248 2.208 1.43 4.544 2.943 7.019 4.572C183.619 195.609 213 216.211 213 253.5h-38c0-14.684-10.619-25.078-31.573-38.867-1.738-1.143-3.581-2.333-5.488-3.565-8.001-5.166-17.125-11.057-24.308-17.282",
        clipRule: "evenodd",
        opacity: 0.6
    }))));

const RemixDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 297",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        d: "M141.675 0C218.047 0 256 36.35 256 94.414c0 43.43-26.707 71.753-62.785 76.474 30.455 6.137 48.259 23.604 51.54 58.065l.474 6.337.415 5.924.358 5.542.249 4.179.267 4.93.138 2.814.198 4.47.159 4.222.079 2.427.107 3.888.092 4.446.033 2.148.06 6.226.02 6.496v3.885h-78.758l.004-1.62.028-3.147.047-3.065.136-7.424.035-2.489.027-3.902-.004-2.496-.023-2.617-.032-2.054-.064-2.876-.094-3.05-.125-3.242-.16-3.455-.096-1.813-.16-2.833-.186-2.976-.287-4.204-.247-3.342a117 117 0 0 0-.247-3.02l-.202-1.934c-2.6-22.827-11.655-32.157-27.163-35.269l-1.307-.245a60 60 0 0 0-2.704-.408l-1.397-.164q-.353-.038-.71-.073l-1.442-.127-1.471-.103-1.502-.081-1.514-.058-1.544-.039-1.574-.018L0 198.74V136.9h127.62q3.129 0 6.066-.12l1.936-.095 1.893-.122 1.85-.15q.458-.042.909-.086l1.785-.193a86 86 0 0 0 3.442-.475l1.657-.28c20.709-3.755 31.063-14.749 31.063-36.2 0-24.075-16.867-38.666-50.602-38.666H0V0zM83.276 250.785c10.333 0 14.657 5.738 16.197 11.23l.203.79.167.782.109.617.046.306.078.603.058.59.023.29.031.569.01.278.008.54v29.507H0v-46.102z"
    }));

const RemixLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 297",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#121212",
        d: "M141.675 0C218.047 0 256 36.35 256 94.414c0 43.43-26.707 71.753-62.785 76.474 30.455 6.137 48.259 23.604 51.54 58.065l.474 6.337.415 5.924.358 5.542.249 4.179.267 4.93.138 2.814.198 4.47.159 4.222.079 2.427.107 3.888.092 4.446.033 2.148.06 6.226.02 6.496v3.885h-78.758l.004-1.62.028-3.147.047-3.065.136-7.424.035-2.489.027-3.902-.004-2.496-.023-2.617-.032-2.054-.064-2.876-.094-3.05-.125-3.242-.16-3.455-.096-1.813-.16-2.833-.186-2.976-.287-4.204-.247-3.342a117 117 0 0 0-.247-3.02l-.202-1.934c-2.6-22.827-11.655-32.157-27.163-35.269l-1.307-.245a60 60 0 0 0-2.704-.408l-1.397-.164q-.353-.038-.71-.073l-1.442-.127-1.471-.103-1.502-.081-1.514-.058-1.544-.039-1.574-.018L0 198.74V136.9h127.62q3.129 0 6.066-.12l1.936-.095 1.893-.122 1.85-.15q.458-.042.909-.086l1.785-.193a86 86 0 0 0 3.442-.475l1.657-.28c20.709-3.755 31.063-14.749 31.063-36.2 0-24.075-16.867-38.666-50.602-38.666H0V0zM83.276 250.785c10.333 0 14.657 5.738 16.197 11.23l.203.79.167.782.109.617.046.306.078.603.058.59.023.29.031.569.01.278.008.54v29.507H0v-46.102z"
    }));

const Remotion = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 250 250",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0B84F3",
        fillOpacity: 0.1,
        d: "M81.03 33.963c-3.848.208-6.95.814-10.075 1.995-1.558.583-4.114 1.852-5.52 2.73-5.881 3.662-10.364 9.169-12.702 15.577-.466 1.268-1.728 5.315-2.54 8.1-5.407 18.617-8.476 38.975-9.135 60.521-.104 3.432-.104 11.603 0 14.979.442 14.285 1.816 27.181 4.307 40.332 1.012 5.323 2.635 12.473 3.575 15.721 1.92 6.599 5.841 12.217 11.418 16.335 3.736 2.761 7.978 4.613 12.678 5.523 2.266.438 5.255.638 7.457.494 3.045-.199 9.087-1.005 13.996-1.875 22.128-3.918 42.568-10.933 61.104-20.972 11.739-6.36 21.774-13.247 31.456-21.602 9.65-8.316 17.877-17.261 25.117-27.3 1.679-2.323 2.523-3.679 3.366-5.387 2.17-4.405 3.19-8.786 3.182-13.686 0-4.565-.868-8.619-2.74-12.768-.9-2.003-1.759-3.44-3.688-6.169-7.102-10.047-14.985-18.801-24.594-27.308-14.896-13.184-32.589-23.997-52.346-32-4.283-1.733-8.501-3.257-13.579-4.909-10.751-3.487-24.056-6.511-35.313-8.02-1.767-.24-4.17-.375-5.423-.31"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0B84F3",
        fillOpacity: 0.3,
        d: "M91.457 53.379c-3.029.163-5.47.64-7.929 1.57-1.227.458-3.237 1.457-4.344 2.147-4.628 2.883-8.156 7.216-9.995 12.258-.367.999-1.36 4.182-1.998 6.374-4.256 14.65-6.67 30.67-7.19 47.625-.081 2.7-.081 9.13 0 11.786.349 11.241 1.43 21.389 3.39 31.738.796 4.188 2.074 9.815 2.813 12.371 1.511 5.193 4.597 9.614 8.985 12.854 2.94 2.173 6.278 3.63 9.977 4.345 1.782.346 4.135.503 5.867.39 2.396-.157 7.15-.791 11.014-1.476 17.412-3.083 33.497-8.603 48.083-16.503 9.237-5.005 17.134-10.424 24.752-16.999 7.594-6.543 14.068-13.583 19.765-21.482 1.321-1.828 1.985-2.895 2.649-4.239 1.707-3.466 2.51-6.914 2.504-10.77 0-3.592-.683-6.782-2.156-10.047-.708-1.576-1.385-2.707-2.902-4.854-5.59-7.906-11.792-14.795-19.354-21.489-11.722-10.374-25.644-18.883-41.191-25.181-3.37-1.363-6.689-2.562-10.685-3.862-8.46-2.745-18.93-5.124-27.788-6.311-1.39-.189-3.281-.295-4.267-.245"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0B84F3",
        d: "M102.247 73.517c-2.178.117-3.933.46-5.702 1.129-.882.33-2.328 1.047-3.123 1.544-3.329 2.073-5.866 5.189-7.189 8.815-.264.718-.978 3.008-1.437 4.584-3.06 10.535-4.797 22.055-5.17 34.249-.059 1.941-.059 6.566 0 8.476.25 8.083 1.028 15.381 2.438 22.823.573 3.013 1.491 7.059 2.023 8.897 1.087 3.734 3.305 6.914 6.461 9.244 2.114 1.562 4.515 2.61 7.175 3.125 1.282.248 2.973.361 4.219.28 1.724-.113 5.143-.569 7.921-1.061 12.522-2.218 24.089-6.187 34.578-11.868 6.643-3.599 12.322-7.497 17.801-12.225 5.461-4.705 10.117-9.768 14.213-15.449.951-1.314 1.428-2.082 1.905-3.048 1.228-2.493 1.805-4.972 1.801-7.745 0-2.583-.491-4.877-1.551-7.225-.509-1.134-.995-1.947-2.087-3.491-4.019-5.686-8.479-10.64-13.917-15.454-8.43-7.46-18.442-13.58-29.623-18.109-2.423-.98-4.81-1.842-7.684-2.777-6.083-1.973-13.613-3.685-19.983-4.538-1-.136-2.36-.213-3.069-.177"
    }));

const ReplicateDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#ffff",
        viewBox: "0 0 726 726",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M726 310.438v82.038H438.068V726h-91.766V310.438z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M726 155.219v82.183H264.845V726h-91.767V155.219z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M726 0v82.183H91.766V726H0V0z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h726v726H0z"
    }))));

const ReplicateLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 726 726",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M726 310.438v82.038H438.068V726h-91.766V310.438z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M726 155.219v82.183H264.845V726h-91.767V155.219z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M726 0v82.183H91.766V726H0V0z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h726v726H0z"
    }))));

const Replit = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F26207",
        d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h7A1.5 1.5 0 0 1 10 1.5V8H1.5A1.5 1.5 0 0 1 0 6.5zM10 8h8.5A1.5 1.5 0 0 1 20 9.5v5a1.5 1.5 0 0 1-1.5 1.5H10zM0 17.5A1.5 1.5 0 0 1 1.5 16H10v6.5A1.5 1.5 0 0 1 8.5 24h-7A1.5 1.5 0 0 1 0 22.5z"
    }));

const ResendDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 600 600",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M186 447.471V154h132.062q28.089 0 50.728 12.158 23.06 12.157 36.055 33.54 12.997 20.962 12.997 47.793 0 27.67-12.997 49.89-12.996 21.802-35.636 34.378-22.639 12.578-51.147 12.578h-64.145v103.134zm162.667 0L274.041 314.99l72.949-10.481L430 447.471zm-94.75-157.636h57.856q10.9 0 18.866-4.612 8.385-5.03 12.577-13.835 4.612-8.804 4.612-20.123t-5.031-19.705q-5.031-8.804-14.673-13.416-9.224-4.611-22.64-4.611h-51.567z"
    }));

const ResendLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 600 600",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M186 447.471V154h132.062q28.089 0 50.728 12.158 23.06 12.157 36.055 33.54 12.997 20.962 12.997 47.793 0 27.67-12.997 49.89-12.996 21.802-35.636 34.378-22.639 12.578-51.147 12.578h-64.145v103.134zm162.667 0L274.041 314.99l72.949-10.481L430 447.471zm-94.75-157.636h57.856q10.9 0 18.866-4.612 8.385-5.03 12.577-13.835 4.612-8.804 4.612-20.123t-5.031-19.705q-5.031-8.804-14.673-13.416-9.224-4.611-22.64-4.611h-51.567z"
    }));

const RobloxDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 564 115",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 512,
        height: 95,
        x: 26,
        y: 10,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M26 10h512v94.72H26z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m87.73 71.45 14.73 26.97H75.13L62.68 75.37h-11.8v23.05H26V16.7h45.52c18.83 0 30.78 10.45 30.78 29.24 0 12.1-5.57 20.76-14.57 25.5zm-36.84-33.5v16.17h17.68c5.24 0 8.52-3.1 8.52-8.17 0-5.06-3.28-8-8.52-8H50.9zm130.66 66.51-74.5-20.1L127.03 10l37.24 10.05 37.25 10.05zm-14.08-54.75L146.67 44l-5.56 20.76 20.79 5.72 5.57-20.76zm119.36 25.66c0 15.69-9.99 23.05-25.54 23.05h-48.8V16.7h47.16c15.56 0 25.54 8 25.54 22.06 0 8.83-3.27 14.71-9.5 18.8 7.05 3.1 11.14 9.3 11.14 17.8zm-50.1-39.05v12.1h16.2c4.42 0 7.04-1.97 7.04-6.22 0-3.92-2.62-5.88-7.04-5.88zm0 42.49h18.17c4.26 0 6.72-2.29 6.72-6.21 0-4.25-2.45-6.21-6.72-6.21h-18.17V78.8zm62.38-62.1h24.88v57.52h35.7v24.19H299.1V16.71zm152.11 40.86a42.43 42.43 0 0 1-26.28 39.25 42.64 42.64 0 0 1-46.4-9.21 42.46 42.46 0 0 1 30.1-72.53 42.56 42.56 0 0 1 30.13 12.41 42.38 42.38 0 0 1 12.45 30.07zm-24.89 0c0-10.14-8.02-18.15-17.68-18.15s-17.69 8.01-17.69 18.15c0 10.13 8.03 18.14 17.69 18.14s17.68-8.02 17.68-18.15zm84.82-1.31L538 98.42h-29.64l-14.73-24.03-15.23 24.03h-30.13l28-41.18-25.7-40.53h29.63l13.59 22.06 13.1-22.06h29.47z"
    })));

const RobloxLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 564 115",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 512,
        height: 95,
        x: 26,
        y: 10,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M26 10h512v94.72H26z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m87.73 71.45 14.73 26.97H75.13L62.68 75.37h-11.8v23.05H26V16.7h45.52c18.83 0 30.78 10.45 30.78 29.24 0 12.1-5.57 20.76-14.57 25.5zm-36.84-33.5v16.17h17.68c5.24 0 8.52-3.1 8.52-8.17 0-5.06-3.28-8-8.52-8H50.9zm130.66 66.51-74.5-20.1L127.03 10l37.24 10.05 37.25 10.05zm-14.08-54.75L146.67 44l-5.56 20.76 20.79 5.72 5.57-20.76zm119.36 25.66c0 15.69-9.99 23.05-25.54 23.05h-48.8V16.7h47.16c15.56 0 25.54 8 25.54 22.06 0 8.83-3.27 14.71-9.5 18.8 7.05 3.1 11.14 9.3 11.14 17.8zm-50.1-39.05v12.1h16.2c4.42 0 7.04-1.97 7.04-6.22 0-3.92-2.62-5.88-7.04-5.88zm0 42.49h18.17c4.26 0 6.72-2.29 6.72-6.21 0-4.25-2.45-6.21-6.72-6.21h-18.17V78.8zm62.38-62.1h24.88v57.52h35.7v24.19H299.1V16.71zm152.11 40.86a42.43 42.43 0 0 1-26.28 39.25 42.64 42.64 0 0 1-46.4-9.21 42.46 42.46 0 0 1 30.1-72.53 42.56 42.56 0 0 1 30.13 12.41 42.38 42.38 0 0 1 12.45 30.07zm-24.89 0c0-10.14-8.02-18.15-17.68-18.15s-17.69 8.01-17.69 18.15c0 10.13 8.03 18.14 17.69 18.14s17.68-8.02 17.68-18.15zm84.82-1.31L538 98.42h-29.64l-14.73-24.03-15.23 24.03h-30.13l28-41.18-25.7-40.53h29.63l13.59 22.06 13.1-22.06h29.47z"
    })));

const Rolldown = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 100 100",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M85 45.64H72.514l1.924-2.608L60.642 43l-6.739 9.347H67l-5.785 8.738h-9.882l12 10.248 24-10.248H75.457zm-2.667-13.307h-14L66.411 35h13.954zM78.52 37.5H64.608L62.5 40.424h13.863zm-28.316 6.692q0 3.54-1.92 6.407-1.92 2.865-5.59 4.215L51.334 71H37.33l-6.888-14.107h-4.63V71H13.333V32.333h23.772q4.178 0 7.114 1.63 2.993 1.573 4.46 4.327 1.525 2.698 1.525 5.902m-12.704.505q0-1.517-1.017-2.529-1.015-1.011-2.484-1.011h-8.187v7.137h8.187q1.469 0 2.484-1.011 1.017-1.068 1.017-2.586"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 50,
        x2: 50,
        y1: 0,
        y2: 100,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F0DB4F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.92,
        stopColor: "#FF5D13"
    }))));

const Rowy = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 26 26",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h26v26H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M0 0h26v26H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        fillOpacity: 0.8,
        d: "M0 0h26v26H0z"
    }), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: "overlay"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M0 0h26v26H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M0 0h26v26H0z"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        fillRule: "evenodd",
        d: "M11.5 18.5v-3h-6v3a3 3 0 1 0 6 0m-5-2h4v2l-.005.15A2 2 0 0 1 8.5 20.5l-.15-.006A2 2 0 0 1 6.5 18.5z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4200FF",
        fillRule: "evenodd",
        d: "M5.5 8.5v3h6v-3a3 3 0 1 0-6 0m5 2h-4v-2l.005-.15A2 2 0 0 1 8.5 6.5l.15.005A2 2 0 0 1 10.5 8.5z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        fillRule: "evenodd",
        d: "M11.5 16.5v-6h-6v6zm-5-5h4v4h-4z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        fillRule: "evenodd",
        d: "M18.5 5.5h-3v6h3a3 3 0 1 0 0-6m-1.999 5v-4H18.5l.15.005A2 2 0 0 1 20.5 8.5l-.006.15A2 2 0 0 1 18.5 10.5z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__j)",
        fillRule: "evenodd",
        d: "M10.5 8.5v3h6v-6h-3a3 3 0 0 0-3 3m3-2h2v4h-4v-2l.005-.15A2 2 0 0 1 13.5 6.5",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 13,
        x2: 13,
        y1: 0,
        y2: 26,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: 6,
        x2: 6,
        y1: 16.499,
        y2: 21.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F0A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FA0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: 5.988,
        x2: 5.988,
        y1: 11.477,
        y2: 16.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#4200FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#F0A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: 16.517,
        x2: 21.5,
        y1: 10.992,
        y2: 10.992,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0AF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0FA"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__j",
        x1: 16.5,
        x2: 11.497,
        y1: 5.998,
        y2: 5.998,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0AF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4200FF"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(-14.60336 -59.1644 66.5347 -16.42255 23.01 32.433)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff",
        stopOpacity: 0
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#C6C6C6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#C6C6C6"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__e",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(-80.599 17.196 10.8)scale(17.6864 18.7096)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FA0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.49,
        stopColor: "#F0A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4200FF"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__f",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(179.35 12.991 1.605)scale(15.2894 48.4386)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.26,
        stopColor: "#0FA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.49,
        stopColor: "#0AF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4200FF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 26,
        height: 26,
        fill: "#fff",
        rx: 8
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__b"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h26v26H0z"
    }))));

const Rsbuild = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 2500 2345",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF5A5A",
        d: "M298 1807a4381 4381 0 0 0-180 84l-36 41c-14 37-11 96-17 135l17 36 21-8s9-33 64-89l51-43s181-108 207-120z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9D3737",
        d: "M424 1839c-77 64-179 98-250 168l-18 26c124-76 251 48 364 81 27 8 2-7 0-25q-3-12 15-39v-28l-78-20 14-70 39-29c8-13 46-33 55-46l-83-19z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M1989 1829v-91l-4-71-17-68-16-45-25-41-20-36-18 45-34 56-26 32-33 28-63 34h-59l-57-27-51-28-36-47-11-35-20-119-9 24-31 58-36 52-50 45-41 22-54 15-41-2-111-50-55-67-18-36-45 90-51 65-80 84-79 50-69 52c3 30 13 51 28 64 41 32 66 87 104 114 47 35 91 52 134 79 41 25 50 72 86 92 132 74 255 83 287 78 38 7 89-1 127-1 26-6 89-12 122-26 51-21 134-51 184-83 59-38 97-96 111-113 15-17 29-50 40-68 11-24 17-47 26-72z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        d: "M902 1727c70 105 330 43 330-88 0 0-74-16-106-47l-71-86c-39 77-153 164-164 202zm831-47c-5 106 163 156 244 106 4-99-8-205-70-285-19 22-21 70-72 116a350 350 0 0 1-102 63"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#564341",
        d: "M1397 1632c16 55 100 69 160 79-51 17-108 9-155-16-26-11-48-54-5-63"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M725 1848c-12-19-179 13-255 105-37 39 15 59 52 54 112-29 96-95 260-77 2 0-29-35-57-82"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M800 1948c-77-29-196 2-256 82-21 28-54 111-17 103 93-21 160-20 172-31 43-41 74-69 186-73-14-18-57-70-85-81"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M946 2047a221 221 0 0 0-230 45c-140 127-121 205-121 205l14 25c39 15 205-32 251-45 87-25 181-34 268-62 0 0-154-149-182-168"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M1647 2224c112 9 220 45 324 84l26 8 21-4c29-46-17-94-46-128-28-28-74-41-111-48-80-8-146 55-214 88"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "M1808 2143c67-20 141 3 190 58 0 0 38 23 49 16 10-6-2-53-8-63-34-66-61-106-129-125-33 38-65 79-103 114Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "M1925 2025c93 30 68 63 153 83 5 1 6-23 6-28 0-27-72-88-111-113-16-11-56 56-48 58"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M1565 949c5 31-5 121-5 121 264-69 624-461 91-385 56-82 171-126 214-220l-2-11a865 865 0 0 0-626 324l-12 35 16 40c109 33 227 24 340 33 0 0-19 53-16 63"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__j)",
        d: "M1511 1376c-47 156 126 190 244 133 264-210 193-699-202-408-22 36-16 132-17 136z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__k)",
        d: "M1068 1408c10 73 150 88 223 55 172-57 223-391 155-490-6-9-92-21-126-25-97-9-213 81-262 209-14 34 5 77 8 112 5 48-3 103 2 138Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M1064 1439s260 180 389-162c32-88 18-218 19-277 113 55 28 368 20 405-29 132-158 236-267 207-163-43-161-173-161-173m447 61 23 9c71 53 172 34 241-12 101-82 110-192 149-304l7 7c15 117-13 236-54 345-92 183-334 168-366-45"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M1563 1239c-17 41-23 92-11 136 29 67 109 72 155 19 133-142-26-383-144-156Zm-230-2c25-292-280-133-203 78 66 106 180 10 203-78"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M1966 2005c3 19 16 37 16 37l-28-20-19-9 24-41 10 5s-5 12-3 28"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__m)",
        d: "M1907 2104c8 19 34 41 34 41l-65-20-32-3 56-63s-1 26 7 45"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__n)",
        d: "M691 2305s181-54 254-127c49-50 9-112 16-109 50 22 65 55 94 91 13 16 72 54 72 54s-97 14-137 26c-72 22-299 65-299 65"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__o)",
        d: "M1810 2175c7 41 17 52 94 91 3 1-45-15-119-34-25-6-100-18-100-18s54-21 68-30c17-12 62-31 62-31s-6 18-5 22"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__p)",
        d: "M690 2092c-9 2-41 6-73 15l-52 15c-7 2-27 4-34-1-2-2-6-9-3-10 87-19 140-42 178-66 67-40 79-71 84-95 3-10 27 13 35 22l44 45s-63 12-82 18c-43 12-85 53-97 56Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__q)",
        d: "M463 1995c80-32 160-59 246-145 6-6 23 8 25 13 12 28 33 58 19 57-85-10-137 26-175 55-27 21-123 23-115 20"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__r)",
        d: "M1978 1628c4 25 4 95 14 100 161 92 398 84 442-121l24-4 22-24a1184 1184 0 0 0 16-118l-13-57-25-52-65-73-71-41-76-23-92-9-70 6-82 20c-13 7-50 29-60 39-5 24-14 71-20 94-3 16-3 50-10 67l-2 35 10 41c22 43 47 71 58 120"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__s)",
        d: "M2049 1759c-111-252 17-502 305-498-67-44-122-50-200-54l-39 6-28-3c-48 14-110 27-146 64-1 22-14 72-19 94-6 16-25 64-24 81l28 67c20 39 31 54 40 98l18 67 9 47z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__t)",
        d: "M2142 1431c5-10 1-32-15-43-19-11-46-10-58 14-8 19 4 38 23 47 18 10 40 0 50-18"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__u)",
        d: "M2376 1422c-15 26-60 45-115 28-64-20-132-83-80-153 23-31 87-30 132-8 33 16 99 73 63 133"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ED8870",
        d: "M1990 1483c29 52 46 84 136 84 30 0 36 46 95 94 29 24 86 23 119 3 20-11 27-7 33-3 14 8 17 5 35 4 0 0 22-31 14-52-27-17-49-31-82-30l-19 18-15 22-17 11-26-2a351 351 0 0 1-65-74c-39-40-79-31-129-25-24-14-54-37-79-50"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__v)",
        d: "M653 1827a652 652 0 0 0 450-516l1-48 9-37c-5-34-3-86-5-120l28-12 24-5 19-13c12-30 10-28 8-60-193-387-817-472-1061-93-254 358-28 980 459 922z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        d: "M456 1613c15-79 425-129 466-262 18-135 67-150 184-162v-68l-18-16a956 956 0 0 1-136 29c-28 1-70 1-96 8l-10 39c13 27 27 126 27 126a481 481 0 0 1-9 55c-125 96-297 103-434 178l-8 23z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__w)",
        d: "M754 1790c-492 43-723-595-514-992 0 0-74 57-82 70-98 151-151 263-135 467l27 142 47 95a453 453 0 0 0 525 262l51-10z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__x)",
        d: "M675 1170c32 39 15 88-23 134-43 53-118 58-157 21-31-29-39-90 29-148 58-49 123-40 151-7"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__y)",
        d: "M558 891c42 42 56 143-48 247-75 75-221 163-321 53-73-80 3-205 75-268 55-49 211-118 294-32"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#564341",
        d: "m515 1567 89 68 120-29 17-157-213 61z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7D7C7D",
        d: "m605 1625-23 118 125-48 18-101z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#989697",
        d: "m605 1625-90-58-17 92 84 84z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#564341",
        d: "m662 600-17 81 172 36 20-105z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B6B6B6",
        d: "m457 582 548 30 122-47 53-370-124-104-114-13-30 26-44 12-45-1h-40l-36-5-30-7-24-7-20-13-21-13-11-21-173-13 36 112z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFED7E",
        d: "m805 271-93 79 87 68-57 92 168-43-67-95-12-23 57-82-30-8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B6B6B6",
        d: "m462 39-105 63-19 119 159-78z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#979797",
        d: "m506 152-54 429-100-66-40-78 24-208zM640 46l33 36 93 29 89 2c29-9 55-10 75-33l4-17c-44-41-114-42-170-45l-90 6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#564341",
        d: "M798 2c72 6 134 30 146 60l111 14 4 1c12 5 40 25 75 52a918 918 0 0 1 41 34l13 12a20 20 0 0 1 5 10c3 2 4 6 4 11v1l-1 3-1 13a12664 12664 0 0 1-29 242l-17 112c-3 12-23 22-68 39l-3 1-2 1c-32 11-60 20-70 20l-158-9-12 85a656 656 0 0 1 281 188l-1-1 2 2a383 383 0 0 1 59 76c27-19 54-31 82-36 127-23 234 21 278 110l9-71v-5l1-3v-6c2-17 2-32 0-49l-5-7h-10l-1-1-17-1h-2c-91-4-138-6-179-12h-4l-3-1-7-1c-61-9-96-24-107-52-10-24-1-52 21-83 14-20 31-39 53-61 35-35 100-85 167-128 86-55 170-94 243-111 95-21 172-25 187 5 9 17-1 35-25 61-16 18-39 40-68 65a2071 2071 0 0 1-63 53l-15 12h-1l-1 1v1l-3 2-12 9v1l3-1a629 629 0 0 1 86-5l4 1c40 1 73 7 99 21a103 103 0 0 1 58 81c10 69-73 165-187 236 40 1 80 11 107 33a230 230 0 0 1 76 105 304 304 0 0 1 17 102c115-61 269-59 387 3 134 71 190 201 132 354a42 42 0 0 1-36 29l1 4a80 80 0 0 1-11 41 310 310 0 0 1-50 65c-76 80-216 98-322 45l-10-5h-2l-1-1h-1v-1l-11-5-25-13a479 479 0 0 1-33 180l-1 4-1 3-3 6a381 381 0 0 1 50 27 235 235 0 0 1 55 52 211 211 0 0 1 24 39c9 22 11 41-1 55-10 12-27 15-47 11a282 282 0 0 1 21 49c8 25 6 45-11 58-6 4-15 5-26 4 18 38 17 76-12 90-15 8-34 6-63-5l-35-13h-2l-3-2-6-2-2-1-36-14a698 698 0 0 0-94-27l-18-4-21-4a647 647 0 0 0-143-12 17 17 0 0 1-7 0 822 822 0 0 1-212 19c-74-2-114-5-156-13a461 461 0 0 1-34-8c-38-8-137 5-199 25a677 677 0 0 1-51 13l-72 16-4 1h-1l-6 2h-2l-3 1-62 14a1305 1305 0 0 0-32 8l-13 4-15 4a653 653 0 0 1-37 8c-46 9-78 9-99-6-16-13-22-33-20-58a252 252 0 0 1 72-144v-1h-1a1024 1024 0 0 0-33 9l-3 1-1 1-24 6-1 1h-2l-2 1-3 1h-2l-3 1c-19 4-33 5-45 2a42 42 0 0 1-29-30l-14-4c-39-14-74-33-131-69-16-9-64-24-83-26-37-4-102 13-130 32a225 225 0 0 0-21 33v1l-3 6-1 2-1 1-7 15c-5 8-11 12-19 13-9 0-15-5-19-13-3-5-6-12-8-20a298 298 0 0 1-7-59c-2-51 5-97 22-119 24-31 61-53 119-77l67-26 24-11a525 525 0 0 1-191-189 655 655 0 0 1 30-717 582 582 0 0 1 490-230l21 1 12-59-116-7h-4a4360 4360 0 0 0-79-6c-43-21-91-53-105-67-20-20-45-88-45-112 0-37 9-108 24-196l2-11 1-4v-1l1-3 1-7v-3l1-3v-4l13-70 1-1 2-11v-1c3-9 17-18 55-40a1831 1831 0 0 1 56-32l4-2 1-1c2-1 5-2 7-1h2a5149 5149 0 0 1 74 4 11533 11533 0 0 1 84 6h1a41 41 0 0 1 17-14q15-7.5 39-12c32-7 73-9 112-6m63 2049h-5l-2 1h-5l-3 1a337 337 0 0 0-39 6c-22 5-61 26-87 47-33 26-78 80-92 111-20 49-23 79-11 88 10 7 35 7 71 0a613 613 0 0 0 50-12l13-4a1475 1475 0 0 1 94-22l4-1 4-1 2-1h4l9-2 2-1 64-14c20-4 35-9 48-13a695 695 0 0 1 127-25 304 304 0 0 1-41-28 237 237 0 0 1-36-39 350 350 0 0 0-30-35l-1-1-1-1a175 175 0 0 0-11-9 359 359 0 0 0-75-47c-4-1-28-1-53 2m985 101a142 142 0 0 0-62 17 17 17 0 0 1-5 2 556 556 0 0 1-39 21l-4 2-42 19a846 846 0 0 1 78 14l8 1 2 1 8 1c33 8 64 17 98 29a2753 2753 0 0 1 39 15l5 2 3 1 1 1 36 13c21 7 33 9 37 7 5-3 7-16 0-37a147 147 0 0 0-37-56l-1-1-17-14c-39-28-75-39-108-38m-356-669c-21 41-48 76-82 105l-1 1-2 2c-63 56-147 68-225 38l-2-1c-57-22-102-65-124-117a645 645 0 0 1-296 293l1 18c0 14 1 26 5 39a82 82 0 0 0 32 47 264 264 0 0 1 30 24 17 17 0 0 1 8 8 564 564 0 0 1 20 20l1 1 1 1 1 1 10 10 1 2 18 18c10 8 18 14 26 18 44 19 75 39 99 59 18 15 26 24 47 51a207 207 0 0 0 32 34l14 11c38 25 79 41 129 50 40 8 78 11 150 13 121 4 241-18 338-66a414 414 0 0 0 222-241 458 458 0 0 0-34-406 387 387 0 0 1-55 92c-42 51-94 82-155 85-55 2-132-37-167-90-22-33-32-63-42-120m430 559-1 1a434 434 0 0 1-67 75 212 212 0 0 1 142 61 144 144 0 0 0 36 22l13 3c1-2 1-8-2-17v-1a289 289 0 0 0-22-50 194 194 0 0 0-26-39 226 226 0 0 0-17-17 204 204 0 0 0-56-38m-1273-78a199 199 0 0 0-55 35 17 17 0 0 1-3 4 219 219 0 0 0-41 54l-1 3-1 1v1l-1 1c-9 17-16 35-15 41 1 10 3 14 7 15 6 2 14 1 28-2l8-2 4-1 20-6 1-1h2l2-1h2l3-1a1925 1925 0 0 1 34-10c21-5 38-9 51-10l7-6c29-23 73-46 99-53 18-4 42-8 64-9l-20-20-9-10h-1l-1-1-1-2-9-10-14-13c-41-16-122-15-160 3m-215-111a1425 1425 0 0 1-29 19l-1 1a4340 4340 0 0 1-36 23l-2 1-1 1h-1v1c-67 33-133 73-176 109 30-9 64-13 88-10 22 2 74 18 93 30 56 34 90 53 127 65l3 2c4-21 18-51 32-73l-10 2c-36 7-63 4-77-17-16-25-3-55 27-88 21-23 50-46 68-55l9-5q-58.5 4.5-114-6m1526 122v1a420 420 0 0 1-19 37 244 244 0 0 1 82 64l1 1a118 118 0 0 0 27 13 70 70 0 0 0 20 3h4v-3c0-5-2-10-5-16-5-11-12-23-19-33a202 202 0 0 0-47-44zM314 1815v1l-3 2a339 339 0 0 1-38 18l-31 12h-2l-2 1-32 13c-55 22-89 42-109 69-12 15-18 57-17 102a272 272 0 0 0 9 60v1-1l5-10 1-1 5-11a274 274 0 0 1 41-55c41-45 122-97 207-139l2-1 3-2a2320 2320 0 0 0 35-22l1-1 8-5a458 458 0 0 1-83-31m321 48c-30 8-62 20-82 31-38 20-92 79-83 94 4 6 19 7 43 3a307 307 0 0 0 49-14l7-3a232 232 0 0 1 64-41c30-14 78-19 122-16a122 122 0 0 1-26-54c-20-12-53-11-94 0M149 911a628 628 0 0 0-29 687 480 480 0 0 0 249 210 428 428 0 0 0 62 17l6 1c92 16 192 3 296-41l4-2 7-3a641 641 0 0 0 351-656l-18 4c-46 11-92 16-168 19h-5l-3 1h-3c-22 0-31 2-37 5-5 2-6 6-1 18 4 12 13 52 21 92l1 5v1l1 5 1 2 1 5 6 35c7 40-19 73-72 100a497 497 0 0 1-65 28v5a4053 4053 0 0 1-4 36 4906 4906 0 0 1-9 87l-9 65c-5 37-10 57-15 65-5 9-30 22-62 34-35 14-61 22-75 17-12-4-33-20-54-41-23-22-37-41-38-52-1-9 3-36 11-79a2777 2777 0 0 1 11-57l2-9c-36 12-59 23-72 34-6 5-7 9-4 15 4 8 13 19 31 35a14 14 0 0 1-19 21c-20-19-31-32-37-45-8-17-4-34 11-47 25-22 69-38 156-62l66-18c78-21 126-37 162-56 43-23 62-46 58-71l-10-51-1-4v-4c-8-36-15-71-19-81-10-25-5-43 14-53 11-6 22-7 49-8h6l5-1c74-3 119-8 163-18l21-5 16-4h4l2-1 17-4h1c10-1 14-2 17-4h1c26-17 30-43 14-79v-2c-14-30-40-64-68-92h-1a653 653 0 0 0-480-217c-189-3-361 74-466 218m576 907-2 1-9 3a89 89 0 0 1 11 3 308 308 0 0 1 0-7m1235-556-2 2a942 942 0 0 1-35 211l1 2a492 492 0 0 1 84 243l37 20 12 6 2 1 11 5c97 48 225 32 293-40a289 289 0 0 0 45-59c12-22 11-35-2-41l-10-6-5-3-1-1-5-2c-12-8-21-12-29-12-5 0-11 2-16 7a99 99 0 0 0-12 14v1l-3 4-1 2-4 6a42 42 0 0 1-27 19c-19 5-37 0-53-13-11-9-20-20-34-40a2912 2912 0 0 0-10-13c-12-18-21-27-29-30-30-14-43-15-64-10h-1l-2 1-3 1c-29 6-54-5-109-52a13 13 0 0 1 17-20c27 24 47 37 61 44a37 37 0 0 0 25 2 165 165 0 0 0 5 0l2-1c25-6 44-4 79 11 14 6 25 17 40 39l5 6 4 6v1h1c25 37 40 48 60 43 6-1 8-3 12-9l9-13 14-17a46 46 0 0 1 35-15c14 1 26 6 42 16l10 7a80 80 0 0 0 12 6c16 6 27 4 32-10 28-72 28-138 3-195-22-52-66-96-123-126a399 399 0 0 0-373 2M728 1453h-1l-75 22-13 3v6l-36 243 5-1a434 434 0 0 0 73-30 145 145 0 0 0 15-8l4-15v-1a691 691 0 0 0 15-103 5362 5362 0 0 0 13-117Zm-115 33-28 7a1635 1635 0 0 0-45 13v3l-1 2a4477 4477 0 0 0-14 75 739 739 0 0 0-12 71v1l1 1 1 1 6 9a311 311 0 0 0 56 54zm1311-261v1c-5 44-16 91-34 140-22 61-76 133-142 166a292 292 0 0 1-105 25c-43 2-81-8-109-31a194 194 0 0 0 26 59c29 43 94 75 137 74 50-2 94-28 130-73a349 349 0 0 0 58-106c25-74 41-182 39-251zm-439-198 1 2c14 83 8 177-30 283-22 61-76 133-142 166-25 12-77 25-121 25-49 0-89-12-117-41l-1 3c11 58 55 108 115 132 67 26 141 16 194-33 53-46 88-107 109-186 16-62 24-124 30-229 3-49-11-91-38-122m190 15a692 692 0 0 0-9 4l-4 2c-51 22-96 50-104 68v1l-1 2v32l-4 54c33-62 87-93 141-79 68 17 98 97 77 185l-1 3c-22 90-90 146-153 134-41-8-73-39-86-81a679 679 0 0 1-14 48c-1 10 2 23 7 37a167 167 0 0 0 12 25c21 34 58 48 106 46 34-2 72-12 91-22 57-28 106-93 125-146 34-94 41-178 30-254a199 199 0 0 0-44-48c-40-30-116-33-169-11m-411-75a175 175 0 0 0-71 33c9 24 11 46 5 65 23-11 48-15 73-8 68 17 98 98 77 186l-1 2c-22 90-90 147-153 134-33-6-60-27-76-58a679 679 0 0 1-28 105c21 30 56 43 103 43 39 0 85-12 106-22 57-28 106-94 125-147a516 516 0 0 0 23-293v-1l-3-11v-4c-46-27-109-37-179-24Zm299 307c-19 74 12 131 60 140 44 9 97-35 115-111 17-71-6-132-52-144-50-13-101 30-123 115m-423-69c-19 75 12 131 60 141 44 8 97-36 115-111 17-72-6-133-52-145-50-13-101 31-123 115m4-92-7 2h-2l-13 3 1 8 2 20a219 219 0 0 1 19-33m663-644a665 665 0 0 0-104 16c-68 15-149 53-232 106-65 41-128 90-161 124-47 46-75 86-66 107 5 12 31 23 80 31 42 6 88 9 189 13l110 5h9l2 1h6l15 1 7 1 5 2c4 3 8 8 8 15 0 6-3 10-7 13l-4 3a51 51 0 0 1-13 2l-15 2h-1l-1 1h-4l-15 2a299 299 0 0 0-31 6c-2 43-8 92-14 128v1l33-14 2-1a2241 2241 0 0 0 37-17l4-2 56-29c123-64 217-165 210-224-7-48-50-70-125-72-27-1-56 1-89 5l-17 2h-3a542 542 0 0 1-29 3 26 26 0 0 1-7-1 18 18 0 0 1-14-16c0-5 2-8 4-12l3-4 9-8 22-19 3-2 17-14 2-2h1l1-1 15-12a3529 3529 0 0 0 62-52 741 741 0 0 0 66-63 130 130 0 0 0 17-22v-1l-4-1h-1a184 184 0 0 0-37-1ZM675 609l-12 58a707 707 0 0 1 148 29l11-78-104-6zM520 163a14023 14023 0 0 0-10 68l-21 147a5027 5027 0 0 0-17 142 815 815 0 0 0-4 50v1h1l246 15h5l286 16c2 1 11-2 23-5a774 774 0 0 0 83-32l12-6v-1a953 953 0 0 0 4-20v-2l12-82v-3a11814 11814 0 0 0 30-251l-171-11-10-1a25053 25053 0 0 0-189-11l-116-6h-15l-5-1h-11l-13-1h-8l-3-1zm-26-3-146 73c-14 82-22 148-22 182 0 18 22 79 37 94 10 10 45 33 80 52a922 922 0 0 1 3-43 5277 5277 0 0 1 18-143 14930 14930 0 0 1 30-215m397 83 7 2a14 14 0 0 1 8 11c1 13-6 25-29 57l-1 2-17 25-1 1-2 3a64 64 0 0 0-5 10l1 1v1c4 8 12 18 31 42l3 4c27 33 37 50 37 66-1 6-3 9-9 12a58 58 0 0 1-7 4l-20 7a1295 1295 0 0 1-118 32 255 255 0 0 1-30 4c-6-1-10-2-13-8s-2-11 2-18l7-11 11-14 1-1 4-5 1-1 6-7 3-5a298 298 0 0 0 19-25l4-6v-1a90 90 0 0 0-6-4l-1-1-2-1h-1l-11-7-1-1h-1l-2-1-12-8a248 248 0 0 1-30-21 55 55 0 0 1-19-24c-2-7 0-11 5-17l9-11a498 498 0 0 1 39-33l3-2 3-3 1-1 3-1v-1l2-1a977 977 0 0 1 34-26c7-4 28-10 52-14a289 289 0 0 1 30-4zm-15 26h-1a324 324 0 0 0-30 5h-2a219 219 0 0 0-31 8l-37 28-1 1-1 1-2 1v1l-2 1-11 9a476 476 0 0 0-33 29v1a59 59 0 0 0 7 7l1 1a226 226 0 0 0 27 19l14 8 2 1 12 7 1 1h1c14 9 19 13 21 20 2 13-6 27-29 55l-4 5-6 7-1 1a3930 3930 0 0 0-9 12h-1 3a1238 1238 0 0 0 115-31l16-6h1v-1c-4-8-13-21-29-41l-1-1-3-4c-25-31-31-40-36-52-4-9-1-18 7-31l2-4h1v-1l1-1 17-25 1-2a386 386 0 0 0 19-29zM458 57h-1a2559 2559 0 0 0-43 25l-33 20a160 160 0 0 0-10 8h-1l-1 6v1l-5 25-11 59 133-66a641 641 0 0 1-28-78m25-7a605 605 0 0 0 32 86v1l129 6 3 1h7l12 1a134977 134977 0 0 1 214 11l114 7 13 1 140 9a1160 1160 0 0 0-74-57 340 340 0 0 0-22-14L943 88c-16 31-85 44-158 37a379 379 0 0 1-102-25c-27-11-46-24-53-40a3561 3561 0 0 0-23-2 11521 11521 0 0 0-124-8m208-17c-14 2-25 6-32 10a26 26 0 0 0-6 4c4 20 65 45 132 52h2a303 303 0 0 0 98-5c20-5 32-11 35-17a13 13 0 0 1 0-7c-4-6-15-14-32-22a304 304 0 0 0-92-20 414 414 0 0 0-105 5"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 887.4,
        x2: 1426.2,
        y1: 1515.4,
        y2: 2354.9,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFBC9C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#FFBC9C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFA67A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 619.7,
        x2: 570.9,
        y1: 1842.9,
        y2: 2039.3,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#F6A66A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 697.5,
        x2: 637.8,
        y1: 1937.2,
        y2: 2170.3,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#F6A66A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 860.8,
        x2: 767.6,
        y1: 2032,
        y2: 2378.4,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#F6A66A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: 1837,
        x2: 1891.9,
        y1: 2168.8,
        y2: 2355.9,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F57A55"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FA9F6E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: 1929.1,
        x2: 2011.7,
        y1: 2064.7,
        y2: 2237.2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F57A55"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FA9F6E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: 2003.9,
        x2: 2071.1,
        y1: 1992.4,
        y2: 2115.3,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F57A55"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#F28773"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FA9F6E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: 1575.7,
        x2: 1575.7,
        y1: 453.7,
        y2: 1070,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFE768"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#FFE768"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#FFBD4A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFBD4A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__j",
        x1: 1707.5,
        x2: 1992.3,
        y1: 1011.2,
        y2: 1479.7,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#564341"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopColor: "#564341"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#845750"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__k",
        x1: 1264,
        x2: 1550.6,
        y1: 947.5,
        y2: 1427.7,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#564341"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopColor: "#564341"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#845750"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__l",
        x1: 1945.7,
        x2: 1977.7,
        y1: 1986.8,
        y2: 2011.6,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#C35C45"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#B76455"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__m",
        x1: 1867.1,
        x2: 1906.2,
        y1: 2077.2,
        y2: 2128.2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#C35C45"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#B76455"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__n",
        x1: 1126.5,
        x2: 970.9,
        y1: 2143.3,
        y2: 2406.2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#AA6160"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#B36F5F"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__o",
        x1: 1737.3,
        x2: 1777.2,
        y1: 2177,
        y2: 2265.9,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#C35C45"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#B76455"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__p",
        x1: 868.7,
        x2: 755.2,
        y1: 2003.4,
        y2: 2204.6,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#AA6160"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#B36F5F"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__q",
        x1: 757.6,
        x2: 663.9,
        y1: 1894.8,
        y2: 2066,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#AA6160"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#B36F5F"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__r",
        x1: 2394.3,
        x2: 2004.9,
        y1: 1310.1,
        y2: 1704.8,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCB87"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.1,
        stopColor: "#FFCB87"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#FFBC9C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFBC9C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__s",
        x1: 2354,
        x2: 1867.7,
        y1: 1206.8,
        y2: 1730.7,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FBC38C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#F19675"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#F0876A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ED8870"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__t",
        x1: 2105.3,
        x2: 2105.3,
        y1: 1381.3,
        y2: 1453.1,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFFFFE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__u",
        x1: 2274.5,
        x2: 2274.5,
        y1: 1272.6,
        y2: 1456.3,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFFFFE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__v",
        x1: 288.4,
        x2: 624.3,
        y1: 689.3,
        y2: 1846.7,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCB87"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#FFCB87"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#FFBC9C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFBC9C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__w",
        x1: 11.7,
        x2: 616.7,
        y1: 1035.8,
        y2: 1632,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFCB87"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#F79E75"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopColor: "#EF876D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ED8870"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__x",
        x1: 578.3,
        x2: 585.4,
        y1: 1143.8,
        y2: 1348.2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFFFFE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__y",
        x1: 367.8,
        x2: 381.3,
        y1: 852.8,
        y2: 1240.2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFF9CE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 1h2500v2344H0z"
    }))));

const Rspack = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 578 449",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB7F45",
        d: "M345 69c-5 5-9 10-11 16-1 3-2 5-1 6 1 5 15 7 20 7l43 2 33 4 2 2c0 3-3 4-5 4h-9c-2 0-5 2-5 5l-3 31h2l12-7 11-6c13-6 25-16 36-26 8-7 15-14 18-24s-4-18-14-20"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB9655",
        d: "m474 63-14-2-34 1c-3 0-4-1-3-4l3-5 18-15 18-16 11-12V9a120 120 0 0 0-54 11c-23 10-45 23-64 40l-10 9"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFD259",
        d: "m475 63-1 1v1l-5 12-6 5-13 6-25 5h-17l-15-2-25-6-7-3-6-3-5-5-1-1-1-1-1-1-1-2"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB836A",
        d: "m31 218 14-4"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB806F",
        d: "m44 214 39-17 6-1c9-1 9 12 10 18 0 9 2 18 6 25s12 9 20 9c11-1 22-2 33-5l36-7 12-3 6-1c6 1 8 7 9 12l1 13c0 3-1 4-4 5-2 0-5-2-5-4v-5"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "m214 253-1-5"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "m213 248-1-6-1-1-3 1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "m207 242-52 11-25 3c-13 1-25 0-32-12-3-5-6-10-7-16l-2-9"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "M90 219v-14h-1l-27 11"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "m62 216-18 8v7"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB806F",
        d: "m43 231 6 20c11 23 28 41 50 53l5 3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A65E4B",
        d: "M104 307a190 190 0 0 0 79 18c13-1 25-4 37-9"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "M220 316c11-5 22-11 31-19l4-3c7-7 14-16 19-26l4-10c5-15 9-30 10-46l-1-23"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "M287 189c-1-13-3-25-8-36l-15-25"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB806F",
        d: "M264 128c-9-13-19-24-32-34"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB836A",
        d: "m233 94-6-5"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB8666",
        d: "M226 89c-18-12-38-18-59-20l-20-1c-43 0-80 25-107 58-13 17-22 38-29 59-3 10-4 20 1 29 2 3 5 5 8 5l10-1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFC68F",
        d: "m226 89-8 2h-1l-2 1-1 1h-2l-1 1-2 1h-1l-1 1h-1l-1 1h-1l-3 2h-3a1 1 0 0 1-1 1l-2 1h-8l-1 1h-17l-1 1h-8l-1 1h-5l-1 1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFE2B1",
        d: "M153 105c-9-13-24-16-39-14-17 3-36 11-47 24s-13 29-4 43"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFC68F",
        d: "M63 158c-2 0-3 1-3 2l-1 1-3 3v2l-4 3v2l-2 1v2l-2 1v2l-2 2-1 1v2l-1 1v1l-2 2-1 1v2l-1 1v1l-1 1v1c-1 1-2 1-1 2l-1 1v2c-1 1-2 1-1 2l-1 1v2l-1 2v1c-1 1-2 1-1 2v1l-1 2-1 1v1l-1 1v4"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFBF98",
        d: "M232 94v1h1v1h-2l-2 1h-1l-3 1h-3l-1 1-4 1-1 1h-2l-1 1h-1l-2 3h-2l-2 2-1 1-2 1v1l-7 3h-2l-2 1h-6l-2 1h-17v1h-5l-3 1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFE0BF",
        d: "m160 117-2-5"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFDFB6",
        d: "m158 112-4-7"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFFCE2",
        d: "m157 112-4-1-4-2h-8l-9 2-1 1h-1l-2 1-6 2c-14 5-27 13-39 23l-12 12-2 3h1v6l8 7 2 2c1 1 2 2 1 3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFDCBA",
        d: "m81 171-9-4"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFDFB6",
        d: "m72 167-9-9"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F9A288",
        d: "M264 128c3 12 5 22 5 30v22c0 12-2 23-8 34l-15 23q-27 33-66 54-16.5 9-33 12l-35 3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FB9B78",
        d: "m113 306-8 1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F9A288",
        d: "M43 231c9-2 19-3 28-2 5 0 11 0 15 4s8 10 11 17c3 5 7 8 14 9h25l68-12c3-1 4 0 5 2l4 4"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFBF98",
        d: "M44 214v-1h1l1-1-1-1 1-1v-2l1-1v-1l1-1v-1l1-1v-1l1-1v-1l1-1v-1c1-1 2-1 1-2v-1l1-1 1-1v-2l1-1v-1l2-2 1-1v-2l1-1v-1l2-1v-2l2-1v-2l3-2v-2l3-2v-1l2-2h1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFDDC4",
        d: "m82 171 9 2"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFDECE",
        d: "M90 173c24 5 48-8 61-27"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFDDC4",
        d: "M151 146c7-9 9-18 8-29"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFFEF5",
        d: "m151 146 3-8v-2l2-5c1-1 0-3-1-4h-8l-2 1h-1l-2 1h-1l-2 1h-1v1h-1l-2 1h-1l-2 1h-1l-2 1h-1l-1 1h-2l-1 1-6 2-7 4-1 1-2 2-3 3h-2l-2 3h-2l-5 6h-2l-8 8v4l1 1 5 3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D0766A",
        d: "M287 189v11l-1 10c-2 15-6 30-11 44l-4 9"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F48064",
        d: "M271 263h-3l-3 3h-2l-10 6-6 4-5 3-8 5-10 4-25 10-34 7-7 1h-2l-2 1h-9l-9 1h-17c-2 1-4 0-7-2"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D0766A",
        d: "M207 242c3 0 4 4 5 6"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D26F5A",
        d: "m220 316 8-6 4-3 4-4c13-10 26-24 35-40"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D0766A",
        d: "m89 219-1-4c-1-2-2-4-5-4l-9 2-13 3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#ABA1A0",
        d: "M317 250c-8-1-17-4-22-11 0 13 10 26 21 31l17 5c9 2 16 0 24-5 9-6 18-13 23-22a270 270 0 0 0 16-49c2-13 4-25 2-38-2-7-4-14-8-20-1-1-1 0-1 1 4 28-2 56-16 80l-9 11a62 62 0 0 1-47 17"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#6C4D48",
        d: "m319 217-4 8v7l2 6 2 3 2 2 1 1c10 0 19-3 27-8s15-11 20-20a1 1 0 0 0-1-1l-2-3-3-1-2-2h-2v-1l-9-1-2 1h-2l-3 1h-2"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#ABA1A0",
        d: "M341 209c9-10 12-22 11-36-2-18-20-32-37-19-9 6-13 16-15 26-3 15 3 34 19 37"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#C0ABA7",
        d: "M341 209c-6 7-13 9-22 8"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#6C4D48",
        d: "M414 227c-3 4-6 8-7 13l-2 8v1c7 7 15 9 25 8 12-1 22-5 29-13l2-3 1-5 1-4v-6l-2-5-5-4-6-3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#ABA1A0",
        d: "M450 214c3-7 5-14 4-22-1-14-11-27-26-23-10 2-17 11-20 20-3 7-4 13-3 20s4 13 9 18"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#C0ABA7",
        d: "M450 214c-3 7-8 12-13 15-8 5-16 4-23-2"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#ABA1A0",
        d: "M480 252a167 167 0 0 0 11-72l-2-11h-1v26c-3 16-7 30-16 44a54 54 0 0 1-47 25c-9 0-17-4-24-11v1l4 12c4 9 16 16 26 19q7.5 3 15 0c17-5 26-18 34-33"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "M513 302v21c4-1 8-2 13-5 7-3 14-7 18-13 4-4 6-11 9-16v-1h-1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "m552 288-9-5h-2l-2 4c-2 4-8 3-8-2 0-9 8-14 17-10 5 3 11 8 16 2 2-2 3-6 3-9v-25l-2-6"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A56E58",
        d: "M565 237c-3-13-9-23-17-32-5-7-12-11-21-14"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "M527 191c-4-3-8-4-11-4-7-1-11 4-14 9l-1 5-2 11c-1 11-4 22-7 31l1 1 3 4c9 13 14 27 16 43l1 11"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F39071",
        d: "m527 191 4 5v2l3 2v2l4 3v2l3 2v2l3 2v2l2 1v2l2 1v2l4 3v2l2 2h2v2h1l8 7"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D0766A",
        d: "M552 288c-7 11-16 18-27 22h-4c-5-1-6-3-8-8"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "M329 283c-17-3-30-10-37-25h-1l-10 19c-7 12-16 21-27 30"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB806F",
        d: "M254 307c-10 7-21 14-33 19h-1c-1 5 0 10 2 13 4 5 9 10 14 13l5 5c7 7 17 15 26 18 5 2 9 5 13 9l11 12 10 12 5 2 42 10c15 3 31 3 47 2l24-5a135 135 0 0 0 44-24l19-20a111 111 0 0 0 21-55"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "M503 318v-5c-1-21-5-40-14-59h-1c-8 19-20 34-41 40"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB806F",
        d: "M447 294c-13 4-26-1-37-9-14-9-17-22-19-38q0-1.5 0 0c-7 14-19 25-32 32-9 5-19 7-30 4"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F9A288",
        d: "M447 294c1 11 9 18 18 22 7 3 14 4 21 5 6 1 12 0 17-3m-249-11 3 1c4 5 11 7 18 7 9 0 19-1 28-4 12-3 20-10 25-21v-4l1-3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "M153 365h7l12-4 4-2c11-9 23-13 38-12l1-1c0-4-8-7-11-8"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "M204 338c-17-4-37 4-48 17-3 3-4 6-5 9v1h2"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D0766A",
        d: "m205 338-6 6-19 10-26 11"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A56E58",
        d: "m176 372-7 9c-2 3-3 8-4 13"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "M165 394c3 1 7 0 12-1 8-3 16-6 25-7h1q15-13.5 36-15v-1c-2-7-7-11-15-13"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "M224 357a53 53 0 0 0-41 7l-3 3-4 5"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D0766A",
        d: "M224 357c-1 6-4 11-9 14l-14 10-6 3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F39071",
        d: "M195 384v-3l-1-1h-1l-1-1h-1l-1-1h-1l-1-1h-1c-1-1-1-2-2-1l-1-1h-1l-1-1h-3l-2-1h-1v-1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D17F67",
        d: "m166 394 21-6 9-4"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "m503 364-4 7h1l4 3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A65E4B",
        d: "m503 374 8 7 5 4 10 4v-1c0-3-2-5-4-8-5-7-11-13-20-16q0-1.5 0 0-1.5 0 0 0"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D26F5A",
        d: "m504 374-1-10"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "m488 389-6 4v1l10 4"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A65E4B",
        d: "m492 398 2 1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A56E58",
        d: "M493 399c4 1 7 3 10 6l6 3 9 7h1l-1-6c-3-7-6-14-11-20"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A65E4B",
        d: "M507 389q-4.5-6-12-9h-1l-7 9"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F58961",
        d: "m508 389-2 2v1h-1l-4 3h-1l-1 1-1 1-4 2"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D26F5A",
        d: "m492 398-4-9"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A56E58",
        d: "M211 391c-11 8-18 17-23 28-3 6-4 12-3 19l2 1h5l20-4"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "m212 435 20-5 18-3 17-5c5-1 9-4 11-8q4.5-7.5 0-15c-4.5-7.5-6-9-11-12"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A4655A",
        d: "m267 387-8-5-20-2c-10 1-19 4-28 11"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D0766A",
        d: "m267 387 2 6v4c-2 6-6 11-11 15l-14 10"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F39071",
        d: "m244 422-21-23h-2l-4-5h-2l-4-3"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D17F67",
        d: "M212 435c11-3 21-8 32-13"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#825451",
        d: "m465 408-10 8a2 2 0 0 0 0 3l4 2 22 6"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A56E58",
        d: "m481 427 28 9h3l1-3c-1-13-8-21-19-25-3-1-5-2-6-1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A65E4B",
        d: "M488 407c-7-1-17-2-23 1"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#F58961",
        d: "m489 407-15 15"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D26F5A",
        d: "m474 422-7-8-1-6"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#D17F67",
        d: "m482 427-8-5"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FFDECE",
        d: "M148 179c1 5 5 8 10 9 11 3 22-1 31-8s16-20 7-31l-8-4c-12-4-25 4-33 13l-5 7c-3 4-4 10-2 14"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#AB806F",
        d: "M385 295c-7-3-15-6-17-13l-1-1-3 2c-4 5 1 10 5 12 11 6 23 8 35 5v-1l-19-4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#564341",
        fillRule: "nonzero",
        d: "M290 156c5-9 11-18 18-25 16-16 42-18 64-13 7 2 13 5 18 10l4 3 6 5h1l1-6 1-12c0-3-1-4-3-5l-18-4-28-2c-11-1-32-3-30-19 1-13 13-25 23-33A241 241 0 0 1 447 2l28-2c9 1 10 9 6 15-3 4-6 8-11 11l-27 24v1c11-1 21 0 30 2 13 3 24 10 24 24 1 10-6 22-13 30-8 8-18 16-28 23v1c9 0 16 2 22 8 12 9 19 22 22 37h1l23 3c7 3 17 7 23 12a85 85 0 0 1 28 84c-1 5-4 9-9 12l-1 1c-3 5-5 11-9 16l-4 7c-8 9-22 17-33 20l-3 2-4 5-5 15 4 5q13.5 6 21 21c2 4 4 8 3 12-1 5-5 7-10 7l-1 1c3 7 6 17 1 23-1 1-3 2-5 1l-1 1v4c1 4 3 11-1 15s-9 3-14 1l-30-10c-7-3-16-5-29-7l-20-1-23 1-16 1h-41l-19-2c-9-1-19-1-28 1l-21 3-9 2-13 3-28 6-34 7c-21 4-19-16-15-28l12-21v-1c-7 3-13 5-20 6-8 1-15-3-14-13 1-6 3-12 7-17l-1-1c-6 2-17 2-19-5-2-6 1-13 5-18 5-7 12-12 21-16v-1c-22-1-42-7-63-15-22-9-40-24-54-44l-12-17a172 172 0 0 1-14-28l-1-1c-8 1-15-1-20-8-4-6-6-13-5-22 0-11 4-21 8-31 8-23 22-47 41-64l15-13c20-16 47-29 73-30 13-1 25 0 37 1 25 3 47 13 66 28 12 10 23 22 33 37 7 9 13 19 17 30q0 1.5 0 0m55-87c-5 5-9 10-11 16-1 3-2 5-1 6 1 5 15 7 20 7l43 2 33 4 2 2c0 3-3 4-5 4h-9c-2 0-5 2-5 5l-3 31h2l12-7 11-6c13-6 25-16 36-26 8-7 15-14 18-24s-4-18-14-20l-14-2-34 1c-3 0-4-1-3-4l3-5 18-15 18-16 11-12V9a120 120 0 0 0-54 11c-23 10-45 23-64 40zM30 218l14-4 39-17 6-1c9-1 9 12 10 18 0 9 2 18 6 25s12 9 20 9c11-1 22-2 33-5l36-7 12-3 6-1c6 1 8 7 9 12l1 13c0 3-1 4-4 5-2 0-5-2-5-4v-5l-1-5-1-6-1-1-3 1-52 11-25 3c-13 1-25 0-32-12-3-5-6-10-7-16l-2-9v-14h-1l-27 11-18 8v7l6 20c11 23 28 41 50 53l5 3a190 190 0 0 0 79 18 118 118 0 0 0 68-28l4-3c7-7 14-16 19-26l4-10c5-15 9-30 10-46l-1-23c-1-13-3-25-8-36l-15-25c-9-13-19-24-32-34l-6-5c-18-12-38-18-59-20l-20-1c-43 0-80 25-107 58-13 17-22 38-29 59-3 10-4 20 1 29 2 3 5 5 8 5zm287 32c-8-1-17-4-22-11 0 13 10 26 21 31l17 5c9 2 16 0 24-5 9-6 18-13 23-22a270 270 0 0 0 16-49c2-13 4-25 2-38-2-7-4-14-8-20-1-1-1 0-1 1 4 28-2 56-16 80l-9 11a62 62 0 0 1-47 17m2-33-4 8v7l2 6 2 3 2 2 1 1c10 0 19-3 27-8s15-11 20-20a1 1 0 0 0-1-1l-2-3-3-1-2-2h-2v-1l-9-1-2 1h-2l-3 1h-2c9-10 12-22 11-36-2-18-20-32-37-19-9 6-13 16-15 26-3 15 3 34 19 37m95 10c-3 4-6 8-7 13l-2 8v1c7 7 15 9 25 8 12-1 22-5 29-13l2-3 1-5 1-4v-6l-2-5-5-4-6-3c3-7 5-14 4-22-1-14-11-27-26-23-10 2-17 11-20 20-3 7-4 13-3 20s4 13 9 18m66 25a167 167 0 0 0 11-72l-2-11h-1v26c-3 16-7 30-16 44a54 54 0 0 1-47 25c-9 0-17-4-24-11v1l4 12c4 9 16 16 26 19q7.5 3 15 0c17-5 26-18 34-33m33 50v21c4-1 8-2 13-5 7-3 14-7 18-13 4-4 6-11 9-16v-1h-1l-9-5h-2l-2 4c-2 4-8 3-8-2 0-9 8-14 17-10 5 3 11 8 16 2 2-2 3-6 3-9v-25l-2-6c-3-13-9-23-17-32-5-7-12-11-21-14-4-3-8-4-11-4-7-1-11 4-14 9l-1 5-2 11c-1 11-4 22-7 31l1 1 3 4c9 13 14 27 16 43zm-184-19c-17-3-30-10-37-25h-1l-10 19c-7 12-16 21-27 30-10 7-21 14-33 19h-1c-1 5 0 10 2 13 4 5 9 10 14 13l5 5c7 7 17 15 26 18 5 2 9 5 13 9l11 12 10 12 5 2 42 10c15 3 31 3 47 2l24-5a135 135 0 0 0 44-24l19-20a111 111 0 0 0 21-55v-5c-1-21-5-40-14-59h-1c-8 19-20 34-41 40-13 4-26-1-37-9-14-9-17-22-19-38q0-1.5 0 0c-7 14-19 25-32 32-9 5-19 7-30 4m-176 82h7l12-4 4-2c11-9 23-13 38-12l1-1c0-4-8-7-11-8-17-4-37 4-48 17-3 3-4 6-5 9v1zm23 7-7 9c-2 3-3 8-4 13 3 1 7 0 12-1 8-3 16-6 25-7h1q15-13.5 36-15v-1c-2-7-7-11-15-13a53 53 0 0 0-41 7l-3 3zm326-8-4 7h1l4 3 8 7 5 4 10 4v-1c0-3-2-5-4-8-5-7-11-13-20-16q0-1.5 0 0-1.5 0 0 0m-15 25-6 4v1l10 4 2 1c4 1 7 3 10 6l6 3 9 7h1l-1-6c-3-7-6-14-11-20q-4.5-6-12-9h-1zm-276 2c-11 8-18 17-23 28-3 6-4 12-3 19l2 1h5l20-4 20-5 18-3 17-5c5-1 9-4 11-8q4.5-7.5 0-15c-4.5-7.5-6-9-11-12l-8-5-20-2c-10 1-19 4-28 11m254 17-10 8a2 2 0 0 0 0 3l4 2 22 6 28 9h3l1-3c-1-13-8-21-19-25-3-1-5-2-6-1-7-1-17-2-23 1"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFE868",
        fillRule: "nonzero",
        d: "m474 63-1 1v1l-5 12-6 5-13 6-25 5h-17l-15-2-25-6-7-3-6-3-5-5-1-1-1-1-1-1-1-2 10-9a246 246 0 0 1 80-46c12-4 25-5 38-5v1l-11 12-18 16-18 15-3 5c-1 3 0 4 3 4l34-1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFBB49",
        fillRule: "nonzero",
        d: "M474 63c10 2 17 10 14 20s-10 17-18 24c-11 10-23 20-36 26l-11 6-12 7h-2l3-31c0-3 3-5 5-5h9c2 0 5-1 5-4l-2-2-33-4-43-2c-5 0-19-2-20-7-1-1 0-3 1-6 2-6 6-11 11-16l1 2 1 1 1 1 1 1 5 5 6 3 7 3 25 6 15 2h17l25-5 13-6 6-5 5-12v-1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFC98A",
        fillRule: "nonzero",
        d: "m226 89-8 2h-1l-2 1-1 1h-2l-1 1-2 1h-1l-1 1h-1l-1 1h-1l-3 2h-3a1 1 0 0 1-1 1l-2 1h-8l-1 1h-17l-1 1h-8l-1 1h-5l-1 1c-9-13-24-16-39-14-17 3-36 11-47 24s-13 29-4 43c-2 0-3 1-3 2l-1 1-3 3v2l-4 3v2l-2 1v2l-2 1v2l-2 2-1 1v2l-1 1v1l-2 2-1 1v2l-1 1v1l-1 1v1c-1 1-2 1-1 2l-1 1v2c-1 1-2 1-1 2l-1 1v2l-1 2v1c-1 1-2 1-1 2v1l-1 2-1 1v1l-1 1v4l-10 1c-3 0-6-2-8-5-5-9-4-19-1-29 7-21 16-42 29-59 27-33 64-58 107-58l20 1c21 2 41 8 59 20"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFC293",
        fillRule: "nonzero",
        d: "m226 89 6 5v1h1v1h-2l-2 1h-1l-3 1h-3l-1 1-4 1-1 1h-2l-1 1h-1l-2 3h-2l-2 2-1 1-2 1v1l-7 3h-2l-2 1h-6l-2 1h-17v1h-5l-3 1-2-5-4-7 1-1h5l1-1h8l1-1h17l1-1h8l2-1a1 1 0 0 0 1-1h3l3-2h1l1-1h1l1-1h1l2-1 1-1h2l1-1 2-1h1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFFBD8",
        fillRule: "nonzero",
        d: "m153 105 4 7-4-1-4-2h-8l-9 2-1 1h-1l-2 1-6 2c-14 5-27 13-39 23l-12 12-2 3h1v6l8 7 2 2c1 1 2 2 1 3l-9-4-9-9c-9-14-7-30 4-43s30-21 47-24c15-2 30 1 39 14"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFBC9C",
        fillRule: "nonzero",
        d: "M232 94c13 10 23 21 32 34 3 12 5 22 5 30v22c0 12-2 23-8 34l-15 23q-27 33-66 54-16.5 9-33 12l-35 3-8 1-5-3c-22-12-39-30-50-53l-6-20c9-2 19-3 28-2 5 0 11 0 15 4s8 10 11 17c3 5 7 8 14 9h25l68-12c3-1 4 0 5 2l4 4v5c0 2 3 4 5 4 3-1 4-2 4-5l-1-13c-1-5-3-11-9-12l-6 1-12 3-36 7c-11 3-22 4-33 5-8 0-16-2-20-9s-6-16-6-25c-1-6-1-19-10-18l-6 1-39 17v-1h1l1-1-1-1 1-1v-2l1-1v-1l1-1v-1l1-1v-1l1-1v-1l1-1v-1c1-1 2-1 1-2v-1l1-1 1-1v-2l1-1v-1l2-2 1-1v-2l1-1v-1l2-1v-2l2-1v-2l3-2v-2l3-2v-1l2-2h1l9 4 9 2c24 5 48-8 61-27 7-9 9-18 8-29l3-1h5v-1h17l2-1h6l2-1h2l7-3v-1l2-1 1-1 2-2h2l2-3h1l1-1h2l1-1 4-1 1-1h3l3-1h1l2-1h2v-1h-1zm-84 85c1 5 5 8 10 9 11 3 22-1 31-8s16-20 7-31l-8-4c-12-4-25 4-33 13l-5 7c-3 4-4 10-2 14"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFFDEB",
        fillRule: "nonzero",
        d: "m157 112 2 5c1 11-1 20-8 29l3-8v-2l2-5c1-1 0-3-1-4h-8l-2 1h-1l-2 1h-1l-2 1h-1v1h-1l-2 1h-1l-2 1h-1l-2 1h-1l-1 1h-2l-1 1-6 2-7 4-1 1-2 2-3 3h-2l-2 3h-2l-5 6h-2l-8 8v4l1 1 5 3-9-2c1-1 0-2-1-3l-2-2-8-7v-6h-1l2-3 12-12c12-10 25-18 39-23l6-2 2-1h1l1-1 9-2h8l4 2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M151 146c-13 19-37 32-61 27l-5-3-1-1v-4l8-8h2l5-6h2l2-3h2l3-3 2-2 1-1 7-4 6-2 1-1h2l1-1h1l2-1h1l2-1h1l2-1h1v-1h1l2-1h1l2-1h1l2-1h8c1 1 2 3 1 4l-2 5v2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        fillRule: "nonzero",
        d: "m264 128 15 25c5 11 7 23 8 36v11l-1 10c-2 15-6 30-11 44l-4 9h-3l-3 3h-2l-10 6-6 4-5 3-8 5-10 4-25 10-34 7-7 1h-2l-2 1h-9l-9 1h-17c-2 1-4 0-7-2l35-3q16.5-3 33-12 39-21 66-54l15-23c6-11 8-22 8-34v-22c0-8-2-18-5-30"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M295 239c5 7 14 10 22 11 18 1 33-5 47-17l9-11c14-24 20-52 16-80 0-1 0-2 1-1 4 6 6 13 8 20 2 13 0 25-2 38a270 270 0 0 1-16 49c-5 9-14 16-23 22-8 5-15 7-24 5l-17-5c-11-5-21-18-21-31m-147-60c-2-4-1-10 2-14l5-7c8-9 21-17 33-13l8 4c9 11 2 24-7 31s-20 11-31 8c-5-1-9-4-10-9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M341 209c-6 7-13 9-22 8-16-3-22-22-19-37 2-10 6-20 15-26 17-13 35 1 37 19 1 14-2 26-11 36"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFC293",
        fillRule: "nonzero",
        d: "m63 158 9 9h-1l-2 2v1l-3 2v2l-3 2v2l-2 1v2l-2 1v1l-1 1v2l-1 1-2 2v1l-1 1v2l-1 1-1 1v1c1 1 0 1-1 2v1l-1 1v1l-1 1v1l-1 1v1l-1 1v1l-1 1v2l-1 1 1 1-1 1h-1v1l-14 4v-4l1-1v-1l1-1 1-2v-1c-1-1 0-1 1-2v-1l1-2v-2l1-1c-1-1 0-1 1-2v-2l1-1c-1-1 0-1 1-2v-1l1-1v-1l1-1v-2l1-1 2-2v-1l1-1v-2l1-1 2-2v-2l2-1v-2l2-1v-2l4-3v-2l3-3 1-1c0-1 1-2 3-2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M450 214c-3 7-8 12-13 15-8 5-16 4-23-2q-7.5-7.5-9-18c-1.5-10.5 0-13 3-20 3-9 10-18 20-20 15-4 25 9 26 23 1 8-1 15-4 22"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M480 252c-8 15-17 28-34 33q-7.5 3-15 0c-10-3-22-10-26-19l-4-12v-1c7 7 15 11 24 11 20 0 36-9 47-25 9-14 13-28 16-44v-26h1l2 11v28c-2 14-5 31-11 44"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        fillRule: "nonzero",
        d: "m527 191 4 5v2l3 2v2l4 3v2l3 2v2l3 2v2l2 1v2l2 1v2l4 3v2l2 2h2v2h1l8 7 2 6v25c0 3-1 7-3 9-5 6-11 1-16-2-9-4-17 1-17 10 0 5 6 6 8 2l2-4h2l9 5c-7 11-16 18-27 22h-4c-5-1-6-3-8-8l-1-11c-2-16-7-30-16-43l-3-4-1-1c3-9 6-20 7-31l2-11 1-5c3-5 7-10 14-9 3 0 7 1 11 4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "m287 189 1 23c-1 16-5 31-10 46l-4 10c-5 10-12 19-19 26l-4 3c-9 8-20 14-31 19l8-6 4-3 4-4c13-10 26-24 35-40l4-9c5-14 9-29 11-44l1-10z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F4986E",
        fillRule: "nonzero",
        d: "M527 191c9 3 16 7 21 14 8 9 14 19 17 32l-8-7h-1v-2h-2l-2-2v-2l-4-3v-2l-2-1v-2l-2-1v-2l-3-2v-2l-3-2v-2l-4-3v-2l-3-2v-2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "m89 219-1-4c-1-2-2-4-5-4l-9 2-13 3 27-11h1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#81564F",
        fillRule: "nonzero",
        d: "M319 217c9 1 16-1 22-8h2l3-1h2l2-1 9 1v1h2l2 2 3 1 2 3a1 1 0 0 1 1 1c-5 9-12 15-20 20s-17 8-27 8l-1-1-2-2-2-3-2-6v-7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        fillRule: "nonzero",
        d: "m89 219 2 9c1 6 4 11 7 16 7 12 19 13 32 12l25-3 52-11c3 0 4 4 5 6l1 5-4-4c-1-2-2-3-5-2l-68 12h-25c-7-1-11-4-14-9-3-7-7-13-11-17s-10-4-15-4c-9-1-19 0-28 2v-7l18-8 13-3 9-2c3 0 4 2 5 4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#81564F",
        fillRule: "nonzero",
        d: "m450 214 6 3 5 4 2 5v6l-1 4-1 5-2 3c-7 8-17 12-29 13-10 1-18-1-25-8v-1l2-8c1-5 4-9 7-13 7 6 15 7 23 2 5-3 10-8 13-15"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "M212 248c-1-2-2-6-5-6l3-1 1 1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFBC9C",
        fillRule: "nonzero",
        d: "M447 294c1 11 9 18 18 22 7 3 14 4 21 5 6 1 12 0 17-3a111 111 0 0 1-21 55l-19 20a135 135 0 0 1-44 24l-24 5c-16 1-32 1-47-2a324 324 0 0 1-47-12l-10-12-11-12c-4-4-8-7-13-9-9-3-19-11-26-18l-5-5c-5-3-10-8-14-13-2-3-3-8-2-13h1c12-5 23-12 33-19l3 1c4 5 11 7 18 7 9 0 19-1 28-4 12-3 20-10 25-21v-4l1-3c11 3 21 1 30-4 13-7 25-18 32-32q0-1.5 0 0c2 16 5 29 19 38 11 8 24 13 37 9m-62 1c-7-3-15-6-17-13l-1-1-3 2c-4 5 1 10 5 12 11 6 23 8 35 5v-1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        fillRule: "nonzero",
        d: "M503 318c-5 3-11 4-17 3-7-1-14-2-21-5-9-4-17-11-18-22 21-6 33-21 41-40h1c9 19 13 38 14 59zm-174-35-1 3v4c-5 11-13 18-25 21-9 3-19 4-28 4-7 0-14-2-18-7l-3-1c11-9 20-18 27-30l10-19h1c7 15 20 22 37 25"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F67954",
        fillRule: "nonzero",
        d: "M271 263c-9 16-22 30-35 40l-4 4-4 3-8 6a104 104 0 0 1-73 5c-14-3-28-7-43-14l8-1c3 2 5 3 7 2h17l9-1h9l2-1h2l7-1 34-7 25-10 10-4 8-5 5-3 6-4 10-6h2l3-3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#564341",
        fillRule: "nonzero",
        d: "m385 295 19 4v1c-12 3-24 1-35-5-4-2-9-7-5-12l3-2 1 1c2 7 10 10 17 13"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "M552 288h1v1c-3 5-5 12-9 16-4 6-11 10-18 13-5 3-9 4-13 5v-21c2 5 3 7 8 8h4c11-4 20-11 27-22"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        fillRule: "nonzero",
        d: "m204 338-6 6-19 10-26 11h-2v-1c1-3 2-6 5-9 11-13 31-21 48-17"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "M204 338c3 1 11 4 11 8l-1 1c-15-1-27 3-38 12l-4 2-12 4h-7l26-11 19-10z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        fillRule: "nonzero",
        d: "M224 357c-1 6-4 11-9 14l-14 10-6 3v-3l-1-1h-1l-1-1h-1l-1-1h-1l-1-1h-1c-1-1-1-2-2-1l-1-1h-1l-1-1h-3l-2-1h-1v-1l4-5 3-3c5-3 10-6 16-7 9-2 17-2 25 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "M224 357c8 2 13 6 15 13v1q-21 1.5-36 15h-1c-9 1-17 4-25 7-5 1-9 2-12 1l21-6 9-4 6-3 14-10c5-3 8-8 9-14"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F67954",
        fillRule: "nonzero",
        d: "m503 374-1-10q-1.5 0 0 0 0-1.5 0 0c9 3 15 9 20 16 2 3 4 5 4 8v1l-10-4-5-4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "m502 364 1 10-4-3h-1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F4986E",
        fillRule: "nonzero",
        d: "M176 372v1h1l2 1h3l1 1h1l1 1c1-1 1 0 2 1h1l1 1h1l1 1h1l1 1h1l1 1v3l-9 4-21 6c1-5 2-10 4-13z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F67954",
        fillRule: "nonzero",
        d: "m507 389-2 2v1h-1l-4 3h-1l-1 1-1 1-4 2-2-1-4-9 7-9h1q7.5 3 12 9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F28773",
        fillRule: "nonzero",
        d: "m267 387 2 6v4c-2 6-6 11-11 15l-14 10-21-23h-2l-4-5h-2l-4-3c9-7 18-10 28-11l20 2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "M267 387c5 3 8 7 11 12s3 10 0 15c-2 4-6 7-11 8l-17 5-18 3-20 5c11-3 21-8 32-13l14-10c5-4 9-9 11-15v-4zm220 2 4 9-10-4v-1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F4986E",
        fillRule: "nonzero",
        d: "M507 389c5 6 8 13 11 20l1 6h-1l-9-7-6-3c-3-3-6-5-10-6l4-2 1-1 1-1h1l4-3h1v-1zm-296 2 4 3h2l4 5h2l21 23c-11 5-21 10-32 13l-20 4h-5l-2-1c-1-7 0-13 3-19 5-11 12-20 23-28"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F67954",
        fillRule: "nonzero",
        d: "m488 407-15 15-7-8-1-6c6-3 16-2 23-1"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F4986E",
        fillRule: "nonzero",
        d: "M488 407c1-1 3 0 6 1 11 4 18 12 19 25l-1 3h-3l-28-9-8-5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AD6560",
        fillRule: "nonzero",
        d: "m465 408 1 6 7 8 8 5-22-6-4-2a2 2 0 0 1 0-3z"
    })));

const Ruby = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 255",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "84.8%",
        x2: "58.3%",
        y1: "111.4%",
        y2: "64.6%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FB7655"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FB7655"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "41%",
        stopColor: "#E42B1E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#900"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#900"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "116.7%",
        x2: "1.7%",
        y1: "60.9%",
        y2: "19.3%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#871101"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#871101"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#911209"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#911209"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "75.8%",
        x2: "39%",
        y1: "219.3%",
        y2: "7.8%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#871101"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#871101"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#911209"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#911209"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "50%",
        x2: "66.5%",
        y1: "7.2%",
        y2: "79.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "23%",
        stopColor: "#E57252"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "46%",
        stopColor: "#DE3B20"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#A60003"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#A60003"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: "46.2%",
        x2: "49.9%",
        y1: "16.3%",
        y2: "83%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "23%",
        stopColor: "#E4714E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "56%",
        stopColor: "#BE1A0D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#A80D00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#A80D00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "37%",
        x2: "49.5%",
        y1: "15.6%",
        y2: "92.5%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "18%",
        stopColor: "#E46342"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "40%",
        stopColor: "#C82410"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#A80D00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#A80D00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: "13.6%",
        x2: "85.8%",
        y1: "58.3%",
        y2: "-46.7%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "54%",
        stopColor: "#C81F11"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#BF0905"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BF0905"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: "27.6%",
        x2: "50.7%",
        y1: "21.1%",
        y2: "79.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "31%",
        stopColor: "#DE4024"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#BF190B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BF190B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: "-20.7%",
        x2: "104.2%",
        y1: "122.3%",
        y2: "-6.3%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#BD0012"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#BD0012"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "7%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "17%",
        stopColor: "#FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "27%",
        stopColor: "#C82F1C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "33%",
        stopColor: "#820C01"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "46%",
        stopColor: "#A31601"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "72%",
        stopColor: "#B31301"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#E82609"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#E82609"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__j",
        x1: "58.8%",
        x2: "12%",
        y1: "65.2%",
        y2: "50.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#8C0C01"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#8C0C01"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "54%",
        stopColor: "#990C00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#A80D0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#A80D0E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__k",
        x1: "79.3%",
        x2: "23.1%",
        y1: "62.8%",
        y2: "17.9%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#7E110B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#7E110B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#9E0C00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#9E0C00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__l",
        x1: "92.9%",
        x2: "59.8%",
        y1: "74.1%",
        y2: "39.7%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#79130D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#79130D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#9E120B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#9E120B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__o",
        x1: "56.6%",
        x2: "3.1%",
        y1: "101.7%",
        y2: "12%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#8B2114"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#8B2114"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "43%",
        stopColor: "#9E100A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#B3100C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#B3100C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__p",
        x1: "30.9%",
        x2: "92.5%",
        y1: "35.6%",
        y2: "100.7%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#B31000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#B31000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "44%",
        stopColor: "#910F08"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#791C12"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#791C12"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__m",
        cx: "32%",
        cy: "40.2%",
        r: "69.6%",
        fx: "32%",
        fy: "40.2%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#A80D00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#A80D00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#7E0E08"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#7E0E08"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__n",
        cx: "13.5%",
        cy: "40.9%",
        r: "88.4%",
        fx: "13.5%",
        fy: "40.9%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#A30C00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#A30C00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "99%",
        stopColor: "#800E08"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#800E08"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M197.5 167.8 51.9 254.2l188.5-12.8 14.5-190z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m240.7 241.3-16.2-111.8-44.1 58.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m240.9 241.3-118.7-9.4-69.6 22z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "m52.7 254 29.7-97.1-65.2 13.9z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M180.4 188 153 81.3l-78 73.2L180.3 188Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "m248.7 82.7-73.8-60.2-20.5 66.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "m214.2 1-43.4 24L143.4.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        d: "m0 203.4 18.2-33.2-14.7-39.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m2.5 129.5 14.8 42L81.6 157 155 88.8 175.7 23 143 0 87.6 20.8C70.1 37 36.3 69 35 69.8c-1.2.6-22.4 40.6-32.5 59.7"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M54.4 54c37.9-37.4 86.7-59.6 105.4-40.7 18.8 18.9-1 64.8-39 102.3-37.8 37.5-86 61-104.7 42-18.8-18.8.5-66 38.3-103.5Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__j)",
        d: "m52.7 254 29.5-97.5 97.6 31.4c-35.3 33.1-74.6 61-127 66Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__k)",
        d: "m155 88.6 25.2 99.3c29.5-31 56-64.3 68.9-105.6l-94 6.3Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__l)",
        d: "M248.8 82.8c10-30.2 12.4-73.7-35-81.8l-38.7 21.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9E1209",
        d: "M0 203c1.4 50 37.4 50.7 52.8 51.1l-35.5-82.9z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__m)",
        d: "m155.2 88.8 69.3 42.4c1.4.8 19.7-30.8 23.8-48.6l-93 6.2Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__n)",
        d: "m82.1 156.5 39.3 75.9c23.3-12.7 41.5-28 58.1-44.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__o)",
        d: "m17.2 171.3-5.6 66.4c10.5 14.3 25 15.6 40.1 14.5-11-27.4-32.9-82-34.5-80.9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__p)",
        d: "m174.8 22.7 78.1 11C248.8 16 236 4.5 214.1 1z"
    }));

const Runway = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 300 300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFEFE",
        d: "M212.486 105.22c3.768 11.718 2.775 22.422-5.034 32.092-3.509 4.346-8.479 7.173-18.322 9.693 2.44 2.274 4.679 4.237 6.776 6.342 4.054 4.07 8.08 8.171 12.026 12.346 9.222 9.758 8.872 23.853 2.609 35-8.27 14.719-29.35 19.494-42.061 8.545-6.059-5.219-11.747-10.87-17.576-16.354-1.171-1.102-2.223-2.331-3.497-3.679-1.006 3.106-1.656 6.037-2.87 8.713-6.762 14.904-25.839 20.939-41.384 13.28-10.554-5.201-15.493-14.111-15.66-25.366-.34-23.142-.233-46.293-.054-69.439.12-15.555 12.806-28.907 28.327-29.172 23.682-.406 47.38-.349 71.065-.008 12.171.175 20.797 6.435 25.655 18.007m-87.476 2.866c-3.891-3.054-8.135-4.151-12.686-1.743-4.601 2.435-6.749 6.295-6.721 11.66.117 22.146.022 44.292.095 66.438.007 2.001.274 4.176 1.09 5.964 2.228 4.877 8.204 7.267 13.81 5.876 5.361-1.331 8.503-5.412 8.506-11.17.014-22.472-.042-44.944.054-67.416.016-3.744-1.143-6.757-4.148-9.609m25.432 38.76-3.052.145c0 5.279-.054 10.367.053 15.452.018.848.54 1.87 1.154 2.492 9.438 9.566 18.845 19.167 28.486 28.525 1.738 1.688 4.39 2.935 6.795 3.331 4.901.808 9.853-2.478 12.266-7.365 2.013-4.078 1.065-9.091-2.594-12.82-8.287-8.444-16.714-16.752-24.907-25.285-3.206-3.34-6.614-5.283-11.384-4.528-2.014.319-4.121.053-6.817.053m18.797-41.804h-23.291l1.957 23.844c12.271 0 24.621.031 36.971-.011 7.334-.026 11.98-4.774 11.936-12.051-.042-6.927-4.895-11.729-11.955-11.775-4.988-.033-9.977-.007-15.618-.007"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M125.184 108.249c2.831 2.689 3.99 5.702 3.974 9.446-.096 22.472-.04 44.944-.054 67.416-.003 5.758-3.145 9.839-8.506 11.17-5.606 1.391-11.582-.999-13.81-5.876-.816-1.788-1.083-3.963-1.09-5.964-.073-22.146.022-44.292-.095-66.438-.028-5.365 2.12-9.225 6.721-11.66 4.551-2.408 8.795-1.311 12.86 1.906M150.758 146.846c2.38 0 4.487.266 6.501-.053 4.77-.755 8.178 1.188 11.384 4.528 8.193 8.533 16.62 16.841 24.907 25.285 3.659 3.729 4.607 8.742 2.594 12.82-2.413 4.887-7.365 8.173-12.266 7.365-2.405-.396-5.057-1.643-6.795-3.331-9.641-9.358-19.048-18.959-28.486-28.525-.614-.622-1.136-1.644-1.154-2.492-.107-5.085-.053-10.173-.053-15.452 1.163-.055 2.108-.1 3.368-.145M169.565 105.042c5.315 0 10.304-.026 15.292.007 7.06.046 11.913 4.848 11.955 11.775.045 7.277-4.602 12.025-11.936 12.051-12.35.042-24.7.011-36.971.011l-1.957-23.844z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M137.645 300H0V0h300v300zm74.144-195.702c-4.75-11.344-13.379-17.604-25.555-17.78-23.694-.34-47.401-.397-71.093.008-15.528.266-28.219 13.62-28.339 29.179-.178 23.15-.286 46.306.055 69.452.167 11.257 5.107 20.169 15.666 25.371 15.551 7.66 34.635 1.624 41.4-13.283 1.214-2.676 1.865-5.608 2.871-8.715 1.275 1.349 2.327 2.578 3.499 3.68 5.831 5.485 11.521 11.138 17.583 16.358 12.716 10.95 33.804 6.175 42.077-8.547 6.265-11.15 6.616-25.247-2.61-35.007-3.947-4.176-7.974-8.278-12.031-12.348-2.097-2.105-4.337-4.069-6.778-6.343 9.846-2.521 14.818-5.349 18.329-9.695 7.812-9.672 8.805-20.378 4.926-32.33"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h300v300H0z"
    }))));

const RustDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 224 224",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m218.46 109.358-9.062-5.614q-.114-1.322-.258-2.642l7.803-7.265a3.11 3.11 0 0 0 .933-2.89 3.09 3.09 0 0 0-1.967-2.312l-9.97-3.715c-.25-.863-.512-1.72-.781-2.58l6.214-8.628a3.114 3.114 0 0 0-.592-4.263 3.13 3.13 0 0 0-1.431-.637l-10.507-1.709a81 81 0 0 0-1.263-2.353l4.417-9.7a3.12 3.12 0 0 0-.243-3.035 3.1 3.1 0 0 0-2.705-1.385l-10.671.372a85 85 0 0 0-1.685-2.044l2.456-10.381a3.125 3.125 0 0 0-3.762-3.763l-10.384 2.456a89 89 0 0 0-2.047-1.684l.373-10.671a3.11 3.11 0 0 0-1.385-2.704 3.13 3.13 0 0 0-3.034-.246l-9.681 4.417c-.782-.429-1.567-.854-2.353-1.265l-1.713-10.506a3.1 3.1 0 0 0-1.887-2.373 3.11 3.11 0 0 0-3.014.35l-8.628 6.213q-1.275-.405-2.56-.778l-3.716-9.97a3.11 3.11 0 0 0-2.311-1.97 3.13 3.13 0 0 0-2.89.933l-7.266 7.802a94 94 0 0 0-2.643-.258l-5.614-9.082A3.13 3.13 0 0 0 111.97 4c-1.09 0-2.085.56-2.642 1.478l-5.615 9.081a93 93 0 0 0-2.642.259l-7.266-7.802a3.13 3.13 0 0 0-2.89-.933 3.1 3.1 0 0 0-2.312 1.97l-3.715 9.97q-1.285.37-2.56.778L73.7 12.588a3.1 3.1 0 0 0-3.014-.35A3.13 3.13 0 0 0 68.8 14.61l-1.713 10.506q-1.186.615-2.353 1.265l-9.681-4.417a3.125 3.125 0 0 0-4.42 2.95l.372 10.67q-1.035.83-2.048 1.685l-10.383-2.456a3.14 3.14 0 0 0-2.93.832 3.12 3.12 0 0 0-.833 2.93l2.436 10.383a94 94 0 0 0-1.68 2.043l-10.672-.372a3.14 3.14 0 0 0-2.704 1.385 3.13 3.13 0 0 0-.246 3.035l4.418 9.7c-.43.779-.855 1.563-1.266 2.353l-10.507 1.71a3.1 3.1 0 0 0-2.373 1.886 3.12 3.12 0 0 0 .35 3.013l6.214 8.628a89 89 0 0 0-.78 2.58l-9.97 3.715a3.117 3.117 0 0 0-1.035 5.202l7.803 7.265q-.147 1.319-.258 2.642l-9.062 5.614A3.12 3.12 0 0 0 4 112.021c0 1.092.56 2.084 1.478 2.642l9.062 5.614q.111 1.323.258 2.642l-7.803 7.265a3.117 3.117 0 0 0 1.034 5.201l9.97 3.716a110 110 0 0 0 .78 2.58l-6.212 8.627a3.11 3.11 0 0 0 .6 4.27c.419.33.916.547 1.443.63l10.507 1.709q.611 1.188 1.265 2.353l-4.417 9.68a3.126 3.126 0 0 0 2.95 4.42l10.65-.374q.83 1.035 1.685 2.047l-2.435 10.383a3.09 3.09 0 0 0 .831 2.91 3.12 3.12 0 0 0 2.931.83l10.384-2.436a82 82 0 0 0 2.047 1.68l-.371 10.671a3.11 3.11 0 0 0 1.385 2.704 3.13 3.13 0 0 0 3.034.241l9.681-4.416q1.168.648 2.353 1.265l1.713 10.505a3.15 3.15 0 0 0 1.887 2.395 3.11 3.11 0 0 0 3.014-.349l8.628-6.213c.853.271 1.71.535 2.58.783l3.716 9.969a3.11 3.11 0 0 0 2.312 1.967 3.11 3.11 0 0 0 2.89-.933l7.266-7.802c.877.101 1.761.186 2.642.264l5.615 9.061a3.12 3.12 0 0 0 2.642 1.478 3.17 3.17 0 0 0 2.663-1.478l5.614-9.061c.884-.078 1.765-.163 2.643-.264l7.265 7.802a3.1 3.1 0 0 0 2.89.933 3.1 3.1 0 0 0 2.312-1.967l3.716-9.969c.863-.248 1.719-.512 2.58-.783l8.629 6.213a3.12 3.12 0 0 0 4.9-2.045l1.713-10.506c.793-.411 1.577-.838 2.353-1.265l9.681 4.416a3.13 3.13 0 0 0 3.035-.241 3.13 3.13 0 0 0 1.385-2.704l-.372-10.671a82 82 0 0 0 2.046-1.68l10.383 2.436a3.123 3.123 0 0 0 3.763-3.74l-2.436-10.382a85 85 0 0 0 1.68-2.048l10.672.374a3.1 3.1 0 0 0 2.704-1.385 3.12 3.12 0 0 0 .244-3.035l-4.417-9.68q.646-1.168 1.263-2.353l10.507-1.709a3.08 3.08 0 0 0 2.373-1.886 3.11 3.11 0 0 0-.35-3.014l-6.214-8.627q.408-1.286.781-2.58l9.97-3.716a3.11 3.11 0 0 0 1.967-2.311 3.11 3.11 0 0 0-.933-2.89l-7.803-7.265q.144-1.32.258-2.642l9.062-5.614a3.11 3.11 0 0 0 1.478-2.642 3.16 3.16 0 0 0-1.476-2.663zm-60.687 75.337c-3.468-.747-5.656-4.169-4.913-7.637a6.41 6.41 0 0 1 7.617-4.933c3.468.741 5.676 4.169 4.933 7.637a6.414 6.414 0 0 1-7.617 4.933zm-3.076-20.847c-3.158-.677-6.275 1.334-6.936 4.5l-3.22 15.026c-9.929 4.5-21.055 7.018-32.614 7.018-11.89 0-23.12-2.622-33.234-7.328l-3.22-15.026c-.677-3.158-3.778-5.18-6.936-4.499l-13.273 2.848a80 80 0 0 1-6.853-8.091h64.61c.731 0 1.218-.132 1.218-.797v-22.91c0-.665-.487-.797-1.218-.797H94.133v-14.469h20.415c1.864 0 9.97.533 12.551 10.898.811 3.179 2.601 13.54 3.818 16.863 1.214 3.715 6.152 11.146 11.415 11.146h32.202q.548-.002 1.166-.116a80.6 80.6 0 0 1-7.307 8.587l-13.583-2.911zm-89.38 20.537a6.407 6.407 0 0 1-7.617-4.933c-.74-3.467 1.462-6.894 4.934-7.637a6.417 6.417 0 0 1 7.617 4.933c.74 3.468-1.464 6.894-4.934 7.637m-24.564-99.28a6.44 6.44 0 0 1-3.261 8.484c-3.241 1.438-7.019-.025-8.464-3.261s.025-7.039 3.262-8.483a6.416 6.416 0 0 1 8.463 3.26M33.22 102.94l13.83-6.15c2.952-1.311 4.294-4.769 2.972-7.72l-2.848-6.44H58.36v50.362h-22.5a79.2 79.2 0 0 1-3.014-21.672c0-2.869.155-5.697.452-8.483l-.08.103zm60.687-4.892v-14.86h26.629c1.376 0 9.722 1.59 9.722 7.822 0 5.18-6.399 7.038-11.663 7.038h-24.77zm96.811 13.375c0 1.973-.072 3.922-.216 5.862h-8.113c-.811 0-1.137.532-1.137 1.327v3.715c0 8.752-4.934 10.671-9.268 11.146-4.129.464-8.691-1.726-9.248-4.252-2.436-13.684-6.482-16.595-12.881-21.672 7.948-5.036 16.204-12.487 16.204-22.498 0-10.753-7.369-17.523-12.385-20.847-7.059-4.644-14.862-5.572-16.968-5.572H52.899c11.374-12.673 26.835-21.673 44.174-24.975l9.887 10.361a5.85 5.85 0 0 0 8.278.19l11.064-10.568c23.119 4.314 42.729 18.721 54.082 38.598l-7.576 17.09c-1.306 2.951.027 6.419 2.973 7.72l14.573 6.48c.255 2.607.383 5.224.384 7.843zM106.912 24.94a6.4 6.4 0 0 1 9.062.209 6.437 6.437 0 0 1-.213 9.082 6.396 6.396 0 0 1-9.062-.21 6.436 6.436 0 0 1 .213-9.083zm75.137 60.476a6.4 6.4 0 0 1 8.463-3.26 6.425 6.425 0 0 1 3.261 8.482 6.4 6.4 0 0 1-8.463 3.261 6.425 6.425 0 0 1-3.261-8.483"
    }));

const RustLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 224 224",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m218.46 109.358-9.062-5.614q-.114-1.322-.258-2.642l7.803-7.265a3.11 3.11 0 0 0 .933-2.89 3.09 3.09 0 0 0-1.967-2.312l-9.97-3.715c-.25-.863-.512-1.72-.781-2.58l6.214-8.628a3.114 3.114 0 0 0-.592-4.263 3.13 3.13 0 0 0-1.431-.637l-10.507-1.709a81 81 0 0 0-1.263-2.353l4.417-9.7a3.12 3.12 0 0 0-.243-3.035 3.1 3.1 0 0 0-2.705-1.385l-10.671.372a85 85 0 0 0-1.685-2.044l2.456-10.381a3.125 3.125 0 0 0-3.762-3.763l-10.384 2.456a89 89 0 0 0-2.047-1.684l.373-10.671a3.11 3.11 0 0 0-1.385-2.704 3.13 3.13 0 0 0-3.034-.246l-9.681 4.417c-.782-.429-1.567-.854-2.353-1.265l-1.713-10.506a3.1 3.1 0 0 0-1.887-2.373 3.11 3.11 0 0 0-3.014.35l-8.628 6.213q-1.275-.405-2.56-.778l-3.716-9.97a3.11 3.11 0 0 0-2.311-1.97 3.13 3.13 0 0 0-2.89.933l-7.266 7.802a94 94 0 0 0-2.643-.258l-5.614-9.082A3.13 3.13 0 0 0 111.97 4c-1.09 0-2.085.56-2.642 1.478l-5.615 9.081a93 93 0 0 0-2.642.259l-7.266-7.802a3.13 3.13 0 0 0-2.89-.933 3.1 3.1 0 0 0-2.312 1.97l-3.715 9.97q-1.285.37-2.56.778L73.7 12.588a3.1 3.1 0 0 0-3.014-.35A3.13 3.13 0 0 0 68.8 14.61l-1.713 10.506q-1.186.615-2.353 1.265l-9.681-4.417a3.125 3.125 0 0 0-4.42 2.95l.372 10.67q-1.035.83-2.048 1.685l-10.383-2.456a3.14 3.14 0 0 0-2.93.832 3.12 3.12 0 0 0-.833 2.93l2.436 10.383a94 94 0 0 0-1.68 2.043l-10.672-.372a3.14 3.14 0 0 0-2.704 1.385 3.13 3.13 0 0 0-.246 3.035l4.418 9.7c-.43.779-.855 1.563-1.266 2.353l-10.507 1.71a3.1 3.1 0 0 0-2.373 1.886 3.12 3.12 0 0 0 .35 3.013l6.214 8.628a89 89 0 0 0-.78 2.58l-9.97 3.715a3.117 3.117 0 0 0-1.035 5.202l7.803 7.265q-.147 1.319-.258 2.642l-9.062 5.614A3.12 3.12 0 0 0 4 112.021c0 1.092.56 2.084 1.478 2.642l9.062 5.614q.111 1.323.258 2.642l-7.803 7.265a3.117 3.117 0 0 0 1.034 5.201l9.97 3.716a110 110 0 0 0 .78 2.58l-6.212 8.627a3.11 3.11 0 0 0 .6 4.27c.419.33.916.547 1.443.63l10.507 1.709q.611 1.188 1.265 2.353l-4.417 9.68a3.126 3.126 0 0 0 2.95 4.42l10.65-.374q.83 1.035 1.685 2.047l-2.435 10.383a3.09 3.09 0 0 0 .831 2.91 3.12 3.12 0 0 0 2.931.83l10.384-2.436a82 82 0 0 0 2.047 1.68l-.371 10.671a3.11 3.11 0 0 0 1.385 2.704 3.13 3.13 0 0 0 3.034.241l9.681-4.416q1.168.648 2.353 1.265l1.713 10.505a3.15 3.15 0 0 0 1.887 2.395 3.11 3.11 0 0 0 3.014-.349l8.628-6.213c.853.271 1.71.535 2.58.783l3.716 9.969a3.11 3.11 0 0 0 2.312 1.967 3.11 3.11 0 0 0 2.89-.933l7.266-7.802c.877.101 1.761.186 2.642.264l5.615 9.061a3.12 3.12 0 0 0 2.642 1.478 3.17 3.17 0 0 0 2.663-1.478l5.614-9.061c.884-.078 1.765-.163 2.643-.264l7.265 7.802a3.1 3.1 0 0 0 2.89.933 3.1 3.1 0 0 0 2.312-1.967l3.716-9.969c.863-.248 1.719-.512 2.58-.783l8.629 6.213a3.12 3.12 0 0 0 4.9-2.045l1.713-10.506c.793-.411 1.577-.838 2.353-1.265l9.681 4.416a3.13 3.13 0 0 0 3.035-.241 3.13 3.13 0 0 0 1.385-2.704l-.372-10.671a82 82 0 0 0 2.046-1.68l10.383 2.436a3.123 3.123 0 0 0 3.763-3.74l-2.436-10.382a85 85 0 0 0 1.68-2.048l10.672.374a3.1 3.1 0 0 0 2.704-1.385 3.12 3.12 0 0 0 .244-3.035l-4.417-9.68q.646-1.168 1.263-2.353l10.507-1.709a3.08 3.08 0 0 0 2.373-1.886 3.11 3.11 0 0 0-.35-3.014l-6.214-8.627q.408-1.286.781-2.58l9.97-3.716a3.11 3.11 0 0 0 1.967-2.311 3.11 3.11 0 0 0-.933-2.89l-7.803-7.265q.144-1.32.258-2.642l9.062-5.614a3.11 3.11 0 0 0 1.478-2.642 3.16 3.16 0 0 0-1.476-2.663zm-60.687 75.337c-3.468-.747-5.656-4.169-4.913-7.637a6.41 6.41 0 0 1 7.617-4.933c3.468.741 5.676 4.169 4.933 7.637a6.414 6.414 0 0 1-7.617 4.933zm-3.076-20.847c-3.158-.677-6.275 1.334-6.936 4.5l-3.22 15.026c-9.929 4.5-21.055 7.018-32.614 7.018-11.89 0-23.12-2.622-33.234-7.328l-3.22-15.026c-.677-3.158-3.778-5.18-6.936-4.499l-13.273 2.848a80 80 0 0 1-6.853-8.091h64.61c.731 0 1.218-.132 1.218-.797v-22.91c0-.665-.487-.797-1.218-.797H94.133v-14.469h20.415c1.864 0 9.97.533 12.551 10.898.811 3.179 2.601 13.54 3.818 16.863 1.214 3.715 6.152 11.146 11.415 11.146h32.202q.548-.002 1.166-.116a80.6 80.6 0 0 1-7.307 8.587l-13.583-2.911zm-89.38 20.537a6.407 6.407 0 0 1-7.617-4.933c-.74-3.467 1.462-6.894 4.934-7.637a6.417 6.417 0 0 1 7.617 4.933c.74 3.468-1.464 6.894-4.934 7.637m-24.564-99.28a6.44 6.44 0 0 1-3.261 8.484c-3.241 1.438-7.019-.025-8.464-3.261s.025-7.039 3.262-8.483a6.416 6.416 0 0 1 8.463 3.26M33.22 102.94l13.83-6.15c2.952-1.311 4.294-4.769 2.972-7.72l-2.848-6.44H58.36v50.362h-22.5a79.2 79.2 0 0 1-3.014-21.672c0-2.869.155-5.697.452-8.483l-.08.103zm60.687-4.892v-14.86h26.629c1.376 0 9.722 1.59 9.722 7.822 0 5.18-6.399 7.038-11.663 7.038h-24.77zm96.811 13.375c0 1.973-.072 3.922-.216 5.862h-8.113c-.811 0-1.137.532-1.137 1.327v3.715c0 8.752-4.934 10.671-9.268 11.146-4.129.464-8.691-1.726-9.248-4.252-2.436-13.684-6.482-16.595-12.881-21.672 7.948-5.036 16.204-12.487 16.204-22.498 0-10.753-7.369-17.523-12.385-20.847-7.059-4.644-14.862-5.572-16.968-5.572H52.899c11.374-12.673 26.835-21.673 44.174-24.975l9.887 10.361a5.85 5.85 0 0 0 8.278.19l11.064-10.568c23.119 4.314 42.729 18.721 54.082 38.598l-7.576 17.09c-1.306 2.951.027 6.419 2.973 7.72l14.573 6.48c.255 2.607.383 5.224.384 7.843zM106.912 24.94a6.4 6.4 0 0 1 9.062.209 6.437 6.437 0 0 1-.213 9.082 6.396 6.396 0 0 1-9.062-.21 6.436 6.436 0 0 1 .213-9.083zm75.137 60.476a6.4 6.4 0 0 1 8.463-3.26 6.425 6.425 0 0 1 3.261 8.482 6.4 6.4 0 0 1-8.463 3.261 6.425 6.425 0 0 1-3.261-8.483"
    }));

const RxJS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "12.1 8.4 262.8 272.2",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 53.496,
        x2: 177.932,
        y1: 247.701,
        y2: 115.323,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#e01d84"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.401,
        stopColor: "#df1d85"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.77,
        stopColor: "#932c87"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#5d2f88"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__b",
        cx: 190.456,
        cy: 80.2,
        r: 121.582,
        gradientTransform: "matrix(1 .00239 -.002 .8362 .16 12.685)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#e01d84"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.139,
        stopColor: "#de1e85"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.285,
        stopColor: "#d62085"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.434,
        stopColor: "#c92386"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.586,
        stopColor: "#b72786"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.739,
        stopColor: "#9d2b87"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.891,
        stopColor: "#7c2e88"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#5d2f88"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 83.212,
        x2: 137.371,
        y1: 62.336,
        y2: 62.336,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#e01d84"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.238,
        stopColor: "#da1e85"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.658,
        stopColor: "#c72085"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.999,
        stopColor: "#b52284"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#e32286",
        d: "M29.6 175.3c-5.2-16.2-6.7-33.3-3.7-50.9 1.3-7.3 3.3-14.3 5.5-21.4 0 0 13.8-45.3 60.5-66 0 0 16.1-8.5 40.3-9.1 0 0-3.3-3.2-5.4-4.6-11.4-7.6-28.4-10.1-38.7.6-3.1 3.2-5.7 6.7-8.6 9.9-3.3 3.6-7.3 6.6-11.9 8.3-4 1.5-8 1.2-12.1 1.9-4.2.7-8.5 2.2-11.9 4.9-3.7 3-5.2 7-5.6 11.6-.4 3.6-.3 7.3-.5 10.9C37 82 33.6 85 26 90.9c-3.2 2.4-5.9 5.6-7.9 9-6 10.6 3.6 21.6 4.1 32.3.1 2.2-.1 4.4-.9 6.5-.8 2.3-2.4 3.8-3.7 5.7-1.8 2.5-3 5.5-2.5 8.6s2.1 6 3.6 8.7c2.9 4.8 6.5 9.1 10.3 13.2.2 0 .4.2.6.4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M220.4 213.7c23-10 32.8-27.3 32.8-27.3 21.5-29.3 14.2-60.2 14.2-60.2-13.7 29.8-26.2 38-26.2 38 33.7-51.3.2-82.3.2-82.3 13.7 29.2-4.5 64.8-4.5 64.8-15.3 32.2-37 43.7-37 43.7 24.2 4.5 42-11.8 42-11.8-34.7 37.5-72.3 35.7-72.3 35.7 15.8 17.7 39.5 16.2 39.5 16.2-31 7.3-60.1-3-84-22.9-4.5-3.7-8.8-7.7-12.8-12 0 0-3.6-3.8-4.3-4.8l-.1-.1c-.5 18.5 18.8 35.7 18.8 35.7-24.2-10-35.3-31.7-35.3-31.7s-16.3-27.8-4.5-59.5 47.5-38.5 47.5-38.5c29.5 14.3 54.5 18.8 54.5 18.8 52.7 8.8 49.7-17 49.7-17 .5-22.2-33-45.8-33-45.8C145.9 8.4 91.9 37 91.9 37c-46.7 20.7-60.5 66-60.5 66-2.2 7.1-4.2 14.1-5.5 21.4-5.1 29.7 2.6 57.8 19.3 82.8 26 38.8 68.2 52.2 68.2 52.2 62.5 21.2 105.2-10 105.2-10 39.3-27 47.2-58.2 47.2-58.2-31.7 24.8-45.4 22.5-45.4 22.5M171.6 67.8c3 0 5.4 2.4 5.4 5.4s-2.4 5.4-5.4 5.4-5.4-2.4-5.4-5.4 2.4-5.4 5.4-5.4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M238.5 98.4c.5-22.2-33-45.8-33-45.8C145.8 8.4 91.8 37 91.8 37c-46.7 20.7-60.5 66-60.5 66-2.7 7.7-5.1 19.5-5.1 19.5-2.9 14.8-1.6 28.5-1.6 28.5 1.2 13.1 4.1 21.9 4.1 21.9 3 9.4 4.4 12.3 4.4 12.3-.1-.3-.6-2.5-.6-2.5s-4.2-20.2-.3-39.6c0 0 3.4-20.2 17.2-35.8 0 0 22.4-31.9 64.1-19.4 0 0 9 3.2 12.1 4.8 3.1 1.5 8.5 3.8 8.5 3.8 29.5 14.3 54.5 18.8 54.5 18.8 52.9 8.9 49.9-16.9 49.9-16.9m-66.9-19.7c-3 0-5.4-2.4-5.4-5.4s2.4-5.4 5.4-5.4 5.4 2.4 5.4 5.4-2.4 5.4-5.4 5.4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "m137.4 58.2-34.1-10.6c-.2 0-1.2-.5-3 0 0 0-20.1 5.1-16.6 16.1 0 0 2.1 6.9 7.8 13.6l37.5-1.8z"
    }));

const SQLite = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 512 228",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "57.7%",
        x2: "57.7%",
        y1: "2%",
        y2: "94.4%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#97D9F6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "92%",
        stopColor: "#0F80CC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0F80CC"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#003B57",
        d: "M194.5 112c-6.8 0-12.3 2-16.6 6.1-4.3 4-6.4 9.3-6.4 15.8a23.3 23.3 0 0 0 6.5 17c2.2 2.4 6.6 5.6 13.2 9.7 8 5 13.4 9 16 12 2.5 3.2 3.7 6.4 3.7 9.9 0 4.5-1.5 8.2-4.6 11a18 18 0 0 1-12.4 4 20.1 20.1 0 0 1-20.3-20.8h-2.5v22.9h2.5c.8-2.2 1.8-3.3 3.2-3.3.7 0 2.3.4 4.7 1.3 6 2.1 10.9 3.2 14.7 3.2a23 23 0 0 0 17-7 23.2 23.2 0 0 0 2.4-30.8c-3-4-9-8.6-18-14a59.5 59.5 0 0 1-15-11.3c-2.3-3-3.5-6.1-3.5-9.7 0-3.8 1.5-7 4.2-9.2 2.8-2.3 6.5-3.5 11-3.5 5.2 0 9.5 1.5 12.9 4.6 3.3 3 5.3 7.4 5.9 12.8h2.5V113h-2.3a6 6 0 0 1-.8 2c-.3.3-.7.4-1.4.4a17 17 0 0 1-4.3-1 38.6 38.6 0 0 0-12.3-2.3Zm82.4 0a44.6 44.6 0 0 0-39 22.2 43.5 43.5 0 0 0 4.5 50.2c7 8.2 15.3 13.3 25 15.3 2.1 1.1 5.3 4.1 9.4 9 4.7 5.3 8.6 9.3 11.9 11.6A35.6 35.6 0 0 0 311 227c5.3 0 10-.9 14-2.7l-.9-2.3a20.1 20.1 0 0 1-18.7-2.3c-3.6-2.5-8.3-7.1-13.8-14a47.6 47.6 0 0 0-5.4-6.1c10.6-2 19.3-7.2 26-15.4a42.8 42.8 0 0 0 10.2-28 42 42 0 0 0-13.2-31.4 44.8 44.8 0 0 0-32.4-12.9Zm51.4 0 .1 2.7c5.5 0 8.6 1.7 9.3 5 .3 1.1.4 3.3.4 6.4v59.6c0 4.5-.7 7.3-2 8.6-1.1 1.2-3.2 2-6.2 2.3l-.1 2.6h55.1l1.4-13.5h-2.5c-.7 3.7-2.3 6.3-5 7.8a30.5 30.5 0 0 1-14 2.3h-5.2q-9 0-10.5-6.6c-.2-.9-.2-1.8-.2-2.8l.2-60.3c0-4.4.5-7.4 1.7-8.9 1.2-1.4 3.3-2.3 6.4-2.5l-.2-2.7zm-50.6 3.3a28 28 0 0 1 23 11.2 48 48 0 0 1 8.8 30.5c0 12.3-3 22.1-8.9 29.5a29 29 0 0 1-23.7 11c-9.5 0-17.2-3.8-23-11.4a47.1 47.1 0 0 1-8.9-29.6q0-18.75 9-30c5.9-7.5 13.8-11.2 23.7-11.2m126.9 12.8c-1.3 0-2.4.5-3.1 1.4-.8 1-1 2-.8 3.4a6 6 0 0 0 2.2 3.4c1.1 1 2.4 1.4 3.7 1.4s2.3-.5 3-1.4c.7-1 1-2.1.7-3.4-.3-1.4-1-2.5-2-3.4a5.6 5.6 0 0 0-3.7-1.4m36.4 9.2c-2.3 8.8-7.3 13.5-14.9 14.3l.1 2.5h8.9l-.2 29.8c0 5.1.2 8.5.5 10.2 1 4.2 3.6 6.3 8.1 6.3 6.6 0 13.4-4 20.6-12l-2.2-1.8c-5.2 5.2-9.7 7.8-13.7 7.8-2.5 0-4-1.4-4.6-4.2l-.2-2.4v-33.7h13.7l-.2-4h-13.4v-12.8zm52.4 11.2c-7.6 0-13.7 3.7-18.5 11a31.3 31.3 0 0 0-4.4 24.4 21 21 0 0 0 6.7 12.2 19 19 0 0 0 12.7 4.3c4.7 0 11.4-1.2 14.1-3.7q4.2-3.6 7.8-11.7l-2-2a20.6 20.6 0 0 1-17.1 10.5c-8 0-12.8-4.3-14.6-13l-.5-3.5a46 46 0 0 0 21.4-8c4.8-3.8 9.6-7.9 8.7-12.1a9.9 9.9 0 0 0-3.9-6c-2-1.6-7.4-2.4-10.4-2.4m-83 .3-16.3 3.8v2.9l5.7-.7c2.7 0 4.3 1.2 4.8 3.7.2.8.3 2 .4 3.4l-.2 26.8c0 3.7-.5 5.8-1.3 6.5-.8.6-3 1-6.6 1v2.5h25.9v-2.5c-3.7 0-6-.3-7-.9-1-.5-1.8-1.5-2.1-3-.2-1.2-.3-3.1-.4-5.7l.1-37.8zm78.9 5c1.6 0 3 .6 4.6 1.8a7 7 0 0 1 2.8 4c1.4 7-4.9 12-19 14.7a25 25 0 0 1 2.7-14.1c2.3-4.3 5.3-6.4 8.9-6.4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0F80CC",
        d: "M157.9 10H17C7.7 10 0 17.7 0 27v155.2c0 9.4 7.7 17.2 17.1 17.2h92.7c-1-46.2 14.7-135.7 48-189.5Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M152.8 15H17c-6.5 0-12 5.4-12 12v144c30.7-11.8 76.8-22 108.7-21.5a990 990 0 0 1 39-134.5Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#003B57",
        d: "M190.7 4.9c-9.6-8.6-21.3-5.2-32.8 5a81 81 0 0 0-5.1 5c-19.7 21-38 59.7-43.7 89.2a81.5 81.5 0 0 1 5.8 17.7l.8 3.5-.9-2.8a174 174 0 0 0-.8-2 172 172 0 0 0-6.4-12.1l-3.5 11c4.5 8.2 7.3 22.4 7.3 22.4l-1.4-4.1c-1-2.9-6-11.7-7.2-13.7-2 7.5-2.8 12.6-2.1 13.8 1.4 2.4 2.7 6.5 4 11a258 258 0 0 1 4.6 25c-.3 8.6-.1 17.6.5 25.7a91 91 0 0 0 4.7 24.8l1.5-.8a111 111 0 0 1-3.9-37c.9-22.5 6-49.5 15.6-77.7 16-42.5 38.4-76.6 58.8-93-18.6 17-43.8 71.4-51.4 91.6a365.7 365.7 0 0 0-18 64c6.2-19 26.4-27.2 26.4-27.2s9.8-12.2 21.4-29.6a210 210 0 0 0-22.1 6l-7.1 3s18.1-11 33.7-16C191 73.8 214.2 25.9 190.7 4.9"
    }));

const SST = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 82 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E27152",
        fillRule: "evenodd",
        d: "M21.683 49.99a.278.278 0 0 0-.23-.434H5.12A5.12 5.12 0 0 1 0 44.431L.02 20.66c0-1.006.264-1.993.764-2.864L9.508 2.59A5.16 5.16 0 0 1 13.981 0h52.94a3.064 3.064 0 0 1 2.598 4.69l-5.693 9.1a.9.9 0 0 0 .763 1.377h12.898A4.513 4.513 0 0 1 82 19.68v22.809c0 2.547-.646 5.056-1.877 7.286-1.552 2.812-4.07 6.796-5.657 9.672a7.06 7.06 0 0 1-6.183 3.65H18.598a3.07 3.07 0 0 1-2.718-1.636 3.07 3.07 0 0 1 .172-3.163c2.166-3.197 4.767-7.03 5.631-8.307Zm7.658-2.388a3.19 3.19 0 0 0-2.612 1.353c-1.651 2.343-5.026 7.132-6.725 9.54a.923.923 0 0 0 .754 1.455h46.377a4.77 4.77 0 0 0 4.136-2.397c1.213-2.105 3.295-5.174 4.544-7.343a1.739 1.739 0 0 0-1.51-2.608zM16.264 34.32a5.7 5.7 0 0 0-4.47 2.189l-5.489 7.02a1.782 1.782 0 0 0 1.404 2.88h16.03a3.42 3.42 0 0 1 3.092-1.958h30.981a3.64 3.64 0 0 0 3.106-1.738l4.215-6.885a1.1 1.1 0 0 0-.942-1.673zm49.239 7.572a1.673 1.673 0 0 0 1.422 2.56h8.99c.694 0 1.36-.277 1.85-.764.49-.492.766-1.157.766-1.852V20.88a2.564 2.564 0 0 0-2.564-2.563H34.031a4.6 4.6 0 0 0-3.881 2.131c-1.488 2.34-3.22 6.072-4.685 8.377a1.33 1.33 0 0 0 1.122 2.042h39.821a3.308 3.308 0 0 1 2.808 5.056zM58.18 15.168c.345 0 .665-.174.854-.462l5.957-9.123a1.159 1.159 0 0 0-.97-1.793H18.652a4.885 4.885 0 0 0-4.886 4.886v17.28a4.976 4.976 0 0 0 5.212 4.97h.64c.017-.138 5.172-9.037 8.017-13.399a5.2 5.2 0 0 1 4.355-2.359z",
        clipRule: "evenodd"
    }));

const SVG = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 300 300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        stroke: "#000",
        strokeWidth: 38.009
    }, /*#__PURE__*/ React.createElement("g", {
        id: "prefix__b",
        transform: "translate(150 150)"
    }, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        fill: "#ffb13b",
        d: "M-84.149-15.851a22.417 22.417 0 1 0 0 31.702H84.15a22.417 22.417 0 1 0 0-31.702Z"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        transform: "rotate(45)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        transform: "rotate(90)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        transform: "rotate(135)"
    }))), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b"
    }));

const SWC = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 976.9 346.4",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 2.964,
        x2: 973.652,
        y1: 172.881,
        y2: 172.881,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#ffa588"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.271,
        stopColor: "#fcb371"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.836,
        stopColor: "#f4d837"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#f1e425"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M877.1 342.8c-26.1 0-50.7-10.2-69.2-28.7L663.8 170c-14.5-14.5-24-32.6-27.4-52.3-2-11.5-1.9-23.3.3-34.8h-42.6c-10.4 0-14.8 6.9-16.5 11s-3.5 12.1 3.9 19.5l62.3 62.3c14.5 14.5 24 32.6 27.4 52.3 3.2 18.2 1 37-6.1 54.4-7.2 17.3-19 32.1-34.1 42.8-16.4 11.5-35.8 17.6-56.3 17.6h-2c-26.1 0-50.7-10.2-69.2-28.7l-13.8-13.8c-6.6 9.7-14.8 18.1-24.4 24.8-16.4 11.5-35.8 17.6-56.3 17.6-26.1 0-50.7-10.2-69.2-28.7l-226-226c-3.4-3.4-7.9-5.2-12.6-5.2-10.4 0-14.8 6.9-16.5 11s-3.5 12.1 3.9 19.5l62.3 62.3c14.5 14.5 24 32.6 27.4 52.3 3.2 18.2 1 37-6.1 54.4-7.2 17.3-19 32.1-34.1 42.8-16.4 11.5-35.8 17.6-56.3 17.6H53.3c-22.1 0-40-17.9-40-40s17.9-40 40-40h28.1c10.4 0 14.8-6.9 16.5-11s3.5-12.1-3.9-19.5L31.8 170c-14.5-14.5-24-32.6-27.4-52.3-3.2-18.2-1-37 6.1-54.4 7.2-17.3 19-32.1 34.1-42.8C61 9 80.5 2.9 101 2.9c26.1 0 50.7 10.2 69.2 28.7l226 226c3.4 3.4 7.9 5.2 12.6 5.2 10.4 0 14.8-6.9 16.5-11s3.5-12.1-3.8-19.4L260.3 71.2c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0L478 175.7l.2.2 81.7 81.7c3.4 3.4 7.9 5.2 12.6 5.2h2c10.4 0 14.8-6.9 16.5-11s3.5-12.1-3.9-19.5L524.9 170c-14.5-14.5-24-32.6-27.4-52.3-3.2-18.2-1-37 6.1-54.4 7.2-17.3 19-32.1 34.1-42.8C554.1 9 573.6 2.9 594.1 2.9H757c22.1 0 40 17.9 40 40s-17.9 40-40 40h-24c-10.4 0-14.8 6.9-16.5 11s-3.5 12.1 3.9 19.5l144.1 144.1c3.4 3.4 7.9 5.2 12.6 5.2 9.1 0 16.5-7.4 16.5-16.5 0-22.1 17.9-40 40-40s40 17.9 40 40c.1 53.3-43.3 96.6-96.5 96.6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M877.1 307.8c-16.8 0-32.6-6.5-44.5-18.4L688.5 145.3c-18.3-18.3-23.5-44.6-13.6-68.5 5.1-12.2 13.4-22.1 23.7-28.8H594.1c-21.8 0-40.5 12.5-48.9 32.6s-3.9 42.2 11.5 57.6l62.3 62.3c18.3 18.3 23.5 44.6 13.6 68.5s-32.2 38.8-58.1 38.8h-2c-16.8 0-32.6-6.5-44.5-18.4l-57.5-57.5c2.6 12.1 1.4 24.9-3.6 37.1-9.9 23.9-32.2 38.8-58.1 38.8-16.8 0-32.6-6.5-44.5-18.4l-226-226c-10-10-23.3-15.5-37.4-15.5-21.8 0-40.5 12.5-48.9 32.6-8.3 20.1-3.9 42.2 11.5 57.6l62.3 62.3c18.3 18.3 23.5 44.6 13.6 68.5s-32.2 38.8-58.1 38.8h-28c-2.8 0-5-2.2-5-5s2.2-5 5-5h28.1c21.8 0 40.5-12.5 48.9-32.6s3.9-42.2-11.5-57.6l-62.3-62.3C38.2 127 33 100.7 42.9 76.8c9.9-24 32.1-38.9 58.1-38.9 16.8 0 32.6 6.5 44.5 18.4l226 226c10 10 23.3 15.5 37.4 15.5 21.8 0 40.5-12.5 48.9-32.6 8.3-20.1 4-42.1-11.4-57.5L285.1 46.5c-2-2-2-5.1 0-7.1s5.1-2 7.1 0l161.1 161.1.1.1 81.7 81.7c10 10 23.3 15.5 37.4 15.5h2c21.8 0 40.5-12.5 48.9-32.6 8.3-20.1 3.9-42.2-11.5-57.6l-62.3-62.3c-18.3-18.3-23.5-44.6-13.6-68.5S568.2 38 594.1 38H757c2.8 0 5 2.2 5 5s-2.2 5-5 5h-24c-21.8 0-40.5 12.5-48.9 32.6-8.3 20.1-3.9 42.2 11.5 57.6l144.1 144.1c10 10 23.3 15.5 37.4 15.5 28.4 0 51.5-23.1 51.5-51.5 0-2.8 2.2-5 5-5s5 2.2 5 5c.1 33.9-27.5 61.5-61.5 61.5"
    }));

const SWRDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2200 2200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M571.7 841.7c-.1.1-3.7.4-7.9.8-7.2.6-11.3 1.2-11.3 1.5 0 .1-1.6.3-3.5.5-4.5.5-6.6.9-17.5 3.4-11.6 2.8-11.6 2.8-14.5 3.9-1.4.5-2.7 1-3 1-1.4.2-12.5 4-16.5 5.7-8 3.3-18.3 8.2-23.9 11.2-3.3 1.8-6.9 3.6-7.8 3.9-1 .4-1.8 1-1.8 1.5s-.5.9-1.1.9-4.7 2.5-9.1 5.5-8.3 5.5-8.8 5.5-1 .3-1.2.8c-.1.4-2.3 2.3-4.8 4.2-6.4 5-6.6 5.1-11.3 9.3-13.2 12-27.2 26.8-29.1 30.8-.5 1-1.3 1.9-1.7 1.9s-2.1 1.9-3.7 4.2c-1.6 2.4-5 7.3-7.5 11.1-2.6 3.7-4.7 7.1-4.7 7.6s-.4 1.1-.9 1.3c-2.9 1-21.1 41.3-24.7 54.3-3.2 11.6-5.3 20.2-5.8 23-.3 1.6-1.2 7-2.1 12-1.8 10.7-2.6 24.7-2.9 58-.2 13.7-.6 26.3-1 28-4 18.7-8 28.4-17.2 41.7-8.9 12.8-22.3 24.4-35.9 31-3.3 1.6-7.1 3.5-8.5 4.3-1.4.7-7.4 2.5-13.5 4-12.4 3.1-28.7 3.7-40.5 1.5-3.6-.7-7-1.3-7.7-1.4s-1.6-.5-1.9-.9c-.4-.4-1.5-.7-2.5-.7-3.2 0-18.1-7.1-26.5-12.5-8.2-5.4-22.3-19.8-28-28.6-4.7-7.3-11.7-23-12.8-28.5-.3-1.6-1-5-1.5-7.7-.6-2.6-1.3-8.9-1.6-14-.7-11.3-.7-11.3-3.1-16.2-3.3-6.9-10.8-13.4-17.7-15.2-1.2-.4-24.2-.7-51.2-.7l-49-.1-4.8 2.3c-5.8 2.9-11.7 8.6-14.3 13.8-1.6 3.3-1.9 6-1.8 18.4 0 12.5.5 20 1.9 28.5 1.1 6.7 2.3 13.6 2.9 16 .2 1.1.9 4 1.5 6.5 4 17.7 16 47.6 24.6 61.5 1.4 2.2 2.9 4.9 3.4 6 1.9 4.2 16.8 24.8 23.1 32 6.2 7 16.5 17.9 18 19.1.8.7 3.1 2.7 5 4.4 10 9.1 28.6 22.8 39.5 29.1 7.5 4.3 23 11.9 24.3 11.9.6 0 1.2.4 1.2.9s1 1.1 2.2 1.4c1.3.3 6.6 2.2 11.8 4.2s10.2 3.8 11 4c3.6.9 21.8 5.4 24.5 6 1.7.4 4.4.9 6 1.1 1.7.1 4.4.5 6 .8 7.7 1.5 17.5 2.1 35 2.1 19.1-.1 30.4-.9 40.5-3 1.4-.3 4-.8 5.9-1.1 5.8-1 21.4-4.9 24.1-6.1.8-.3 2.4-.8 3.5-1 1.1-.1 2.9-.7 4-1.2s6.1-2.5 11-4.4c5-1.9 11.2-4.7 13.9-6.1s5.2-2.6 5.7-2.6c1.2 0 17.6-9.7 25.9-15.2 15.2-10.3 34.9-27.6 48.1-42.4 4.8-5.4 18.7-24.3 22.5-30.6 2-3.5 4.4-7.1 5.2-8.1.8-.9 1.2-1.7.8-1.7-.3 0 .4-1.7 1.7-3.8 5-8.1 15.6-33.2 18.2-43.2.2-.8 1.3-4.7 2.3-8.5 2.6-9.3 5.1-21.1 5.7-26.5.3-2.5.7-5.6 1-7 1-4.9 1.7-21.9 1.9-49 .2-15.4.9-29.9 1.5-33 2.1-10.1 6.9-23.2 10.3-28.3 1.1-1.5 1.7-2.7 1.4-2.7-1.3 0 10-14.9 15.3-20.1 10.3-10.3 19.4-16.3 36.6-24 5.9-2.7 25.4-6.2 34-6.1 10 0 25.3 2.7 33.8 5.8 6.2 2.3 17.2 7.7 17.5 8.6.2.4 1 .8 1.7.8.8 0 2 .6 2.7 1.2.7.7 3.1 2.6 5.3 4.3 2.2 1.6 6.9 5.9 10.5 9.5l6.5 6.5h78.2l78.2.1-.6-2.6c-.3-1.4-.8-3-1.2-3.5-.3-.6-.7-1.8-.8-2.8-.7-4.5-8.1-22.5-14.6-35.6-9.1-18.2-9-18.1-9.9-18.1-.5 0-.8-.4-.8-.9 0-1.2-8.1-13.5-9.2-13.9-.4-.2-.8-.8-.8-1.3 0-.8-2-3.5-4.7-6.4-.7-.8-1.3-1.8-1.3-2.3 0-.6-.3-1.2-.7-1.4-.5-.2-2.6-2.3-4.7-4.8-12.5-14.4-32.3-33-39.2-36.8-1.3-.7-2.4-1.7-2.4-2.2 0-.6-.6-1-1.3-1-.8 0-2.2-.9-3.2-2s-2.4-2-3.1-2-1.4-.4-1.6-.8c-.7-1.9-24.2-14.9-36.8-20.5-6.6-3-18.9-7.6-21.2-8.1-1.3-.2-3.4-.9-4.8-1.5-2.3-1-12.6-3.7-17.5-4.7-1.1-.2-3-.6-4.2-.9-5.3-1.2-6.9-1.5-10.8-2.1-12.2-1.9-22.8-2.7-38.8-2.8-8.2-.1-14.9 0-15 .1m687.1-.2c-.2.2-3.9.6-8.3.9-11 .9-17.2 1.8-28.5 4.1-1.4.3-3.6.7-5 1-5.2 1-25.8 7.4-32.7 10.3-4 1.6-7.3 2.8-7.3 2.7 0-.2-6 2.7-13.2 6.4-13.8 7-24.1 12.9-24.6 14.3-.2.4-.8.8-1.3.8-.6 0-3 1.5-5.4 3.2-2.3 1.8-5.5 4.2-7.1 5.3-1.5 1.1-3.2 2.4-3.8 3-.6.5-3.8 3.2-7.1 6-13.7 11.4-32.9 32.5-41.3 45.4-2 3.1-3.9 5.8-4.2 6.1-1.2 1-7 11.1-7 12 0 .6-.3 1-.7 1-.5 0-2.1 2.9-3.8 6.5-1.6 3.5-3.3 6.5-3.7 6.5-.5 0-.8.8-.8 1.8s-.6 2.6-1.4 3.7c-2.6 3.9-14.2 35.5-13 35.5.3 0 0 .9-.6 1.9-.5 1.1-1.3 3.7-1.6 5.8s-.8 4.1-1.1 4.5c-.5.9-1 3.4-1.8 8.8-.3 2-.8 4.7-1 6-.5 2.5-1.1 7.1-2.1 14.5-.2 2.2-.7 18.4-.9 36s-.6 33.3-.9 35c-.4 1.6-.9 4.6-1.2 6.5s-1.7 7.1-3.1 11.5c-7.9 25.3-27.3 47.3-52.2 59.4-5.9 2.8-16.9 6.6-22.1 7.5-1.4.3-2.5.5-2.5.6 0 .5-9.3 1.1-17.5 1.2-12.2.1-19.1-.9-30-4.3-15.7-5-29.5-13.5-41.1-25.2l-7-7.1-77.2-.1c-42.5 0-77.5.1-77.8.2-1 .4 2.2 12.7 3.5 13.5.6.4.8.8.4.8-.6 0 5.9 17.7 8.1 21.7.5 1 2.6 5.2 4.6 9.3 4.9 10.1 16 28.7 18.5 31 .3.3 1.7 2.3 3.2 4.5s3.8 5.2 5 6.6c1.3 1.5 4.2 4.9 6.5 7.6 17.5 20.6 43.2 41.6 66.3 54.1 5.1 2.8 14.5 7.6 15 7.7.3 0 2.3.9 4.5 1.9 7.2 3.3 12 5.2 15.5 6.1.3.1 1.9.7 3.5 1.4 6.7 2.8 29.2 8.5 38 9.7 2.8.3 5.2.7 5.6.9 2.9 1.8 47.3 2.7 59.4 1.2 3.3-.4 8-1 10.5-1.3s8.7-1.4 13.9-2.5c5.1-1.2 10.1-2.2 11-2.4s4.6-1.3 8.4-2.5c3.7-1.2 7.3-2.3 8-2.4.6-.2 2.1-.7 3.2-1.1s5.2-2 9-3.5c39.7-15.6 76.8-43.4 102.3-77 4-5.2 8.1-10.6 9.2-12s2-3 2-3.7c0-.6.4-1.3.8-1.5 1-.4 7.9-12.2 13.3-22.6 7-13.7 14.6-34.2 18.5-49.7.4-1.7.8-3.2.9-3.5.4-1.6 1.5-6.9 2-9.5.3-1.7.7-4.1 1-5.5.2-1.4.7-4.8 1.1-7.5.3-2.8.8-6.6 1-8.5.3-1.9.7-16.6.9-32.5.6-38.3.8-41.5 4.4-53.5 3-10.5 9.6-25 11.3-25 .4 0 .8-.5.8-1.1 0-1.2 5.8-8.9 10.4-13.9 25.4-27.1 62.3-38 97.6-29 7.2 1.8 21.6 7.5 23 9 .3.3 2.2 1.4 4.3 2.4 2 1.1 3.7 2.3 3.7 2.8 0 .4.5.8 1.1.8 1.9 0 11.2 8.1 18.9 16.6 7.9 8.7 16.3 23.9 19.8 35.9 3.8 13 4.1 16.1 4.7 40.5.6 26.9 1.3 44.9 2 49.5 2 13.6 3.8 23.8 5.1 29 2.1 8.7 7.4 25.6 9 28.7.8 1.4 1.4 3.2 1.4 3.9 0 2.2 13.7 29.4 19.2 38.2 4.8 7.8 15.1 22 21.4 29.7 3.3 4 23.2 24 28.5 28.5 5.4 4.7 24.7 18.7 25.5 18.5.4-.1 1 .3 1.3.8.9 1.5 10.2 6.8 23.1 13.2 17.6 8.9 40.7 16.8 59.1 20.4.8.2 3 .6 4.9 1 3.6.7 5.3.9 17.5 2.3 8.8 1 41 1 49 .1 13.8-1.7 19.6-2.6 26.8-4.3 3.1-.7 5.7-1 5.7-.7s.5.1 1.2-.6 2-1.2 3-1.2c1.9 0 23.7-7 29.5-9.5 10.4-4.5 27.7-13.3 35.1-17.9 4.6-2.8 9.5-5.7 10.8-6.4s2.4-1.7 2.4-2.3c0-.5.7-.9 1.5-.9s1.5-.3 1.5-.8c0-.4 2.1-2.1 4.5-3.7 2.5-1.7 4.5-3.3 4.5-3.8 0-.4.4-.7.9-.7 2.1 0 23.8-20.9 33.2-32 7.2-8.5 14.7-18.6 16.1-21.6.6-1.3 1.4-2.4 1.8-2.4s1.3-1.4 2-3c.7-1.7 1.6-3 2.1-3s.9-.9.9-2 .3-2 .8-2c.4 0 1.2-1 1.8-2.3.7-1.2 2.8-5.4 4.9-9.2 7.4-14.2 19.5-45.8 18-47.4-.3-.2-35.4-.5-78-.5l-77.4-.1-6.7 6.8c-3.6 3.7-9.8 9.1-13.8 11.8-7 4.9-21.3 12.4-25.8 13.4-1.3.2-4.8 1.1-7.8 2-15.9 4.2-37 3.8-52-1.2-2.5-.8-5.2-1.6-6.1-1.8s-2.5-.8-3.5-1.3c-1.1-.6-4.1-2.1-6.9-3.3-2.7-1.3-5.4-2.7-6-3.2-.5-.4-3-2.1-5.5-3.7s-6.1-4.4-8.2-6.2c-2-1.8-4.4-4.1-5.5-5-5.4-4.9-11.6-13-16.5-21.4-3.8-6.5-11.2-25.3-10.3-26.2.2-.3 0-1.1-.6-1.9-.6-.7-.9-1.3-.6-1.3s.1-1.5-.4-3.3c-.5-1.7-1.2-12.2-1.4-23.2-.7-28.8-1.5-50.7-2-53.4-.2-1.3-.7-4.9-1.1-8-.8-7.4-2.9-17.5-6-29.1-1.4-5.2-2.7-10-2.8-10.5-.2-.6-.8-2.3-1.4-3.8-.7-1.6-1.2-3.3-1.2-3.8 0-.6-1.1-3.5-2.5-6.5s-2.5-5.6-2.5-5.9c0-.2-.5-1.6-1.2-3.2-.6-1.5-1.2-3-1.3-3.3 0-.3-.7-1.6-1.5-3s-1.5-2.7-1.5-3c-.1-.7-4.7-9.4-8-15-1.4-2.5-3.1-5.5-3.7-6.8-.6-1.2-1.5-2.2-2-2.2-.4 0-.8-.5-.8-1.1 0-1.3-7.7-12.2-16-22.4-23.9-29.7-60.4-56.9-94.5-70.5-4.4-1.7-8.9-3.6-10-4-5.8-2.5-30-9.1-38-10.4-1.6-.2-3-.5-3-.6 0-.2-1.1-.4-2.5-.5s-4.3-.5-6.5-.8c-8.2-1.3-15.4-1.8-30.2-2.1-8.4-.2-15.4-.2-15.5-.1m683.9.1c-.1.1-3.8.5-8.2.9-4.4.3-9.1.8-10.5 1s-4.1.7-6 .9c-7.9 1.2-9.8 1.6-17.5 3.5-25.3 6.2-44.1 13.8-66 26.4-6.9 4-18.5 11.5-19.5 12.6-.3.4-2.2 1.7-4.2 3.1-2.1 1.4-3.8 2.8-3.8 3.2 0 .5-.4.8-1 .8-.5 0-1.8.8-2.9 1.7-1 1-4.9 4.5-8.6 7.8-10 8.8-20.4 20-29 30.9-1.6 2.1-3.6 4.5-4.2 5.2-.7.7-1.3 1.7-1.3 2.2 0 .6-.3 1.2-.7 1.4-1.2.5-7.3 9.5-7.3 10.6 0 .6-.4 1.2-.8 1.4-1.3.5-15.6 27-15.7 29 0 .4-.6 1.3-1.2 1.9-.7.7-1.3 2-1.3 2.9s-.3 2-.7 2.4c-.5.4-.8 1.1-.9 1.4 0 .4-.5 1.8-1.1 3.2-2.3 5.4-7.3 21.2-7.3 22.9s3.9 1.8 77.6 1.8h77.6l6.8-6.6c10.7-10.4 15.8-14.2 26.5-19.5 12.6-6.2 24.3-9.5 36-10.1 3.9-.2 7.2-.5 7.5-.6 1.1-.2 6.7 0 12 .6 48.4 5.3 86.1 45.4 88.5 94 .7 13.7 3.2 20.2 9.8 26s13.6 8 24.7 7.6c3-.1 6.2-.2 7-.2 5.2.2 24.7.2 25.5.1.6-.1 1.2-.2 1.5 0 1.7.6 15 .4 15-.3 0-.5.5-.5 1.1-.1 1 .6 11.8.9 14.4.4.6-.2 1.3-.1 1.8 0 1.7.4 13.5.1 17.7-.5 11.1-1.5 20.7-10.2 23.8-21.5.5-1.9.3-21.1-.3-27-.6-6-1.5-13.8-2.1-17.5-.3-1.7-.7-4.1-.9-5.5-.5-3.9-5.5-24.3-6.5-26.5-.5-1.1-1.6-4.5-2.5-7.5-1.7-5.6-3.9-11.2-5.5-14.2-.6-1-1-2.2-1-2.8 0-3.2-15.4-31.4-22.2-40.7-2.1-2.9-3.8-5.5-3.8-5.8 0-.4-.6-1.2-1.2-1.9-.7-.7-2.4-2.8-3.8-4.6-16.7-22.2-42.1-44.9-67.5-60.2-12.3-7.4-35.2-17.9-49-22.4-1.8-.6-19-5.5-20.5-5.8-7.3-1.7-22.3-4.1-32-5.2-5.4-.6-35.8-1.3-36.3-.8"
    }));

const SWRLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2200 2200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M571.7 841.7c-.1.1-3.7.4-7.9.8-7.2.6-11.3 1.2-11.3 1.5 0 .1-1.6.3-3.5.5-4.5.5-6.6.9-17.5 3.4-11.6 2.8-11.6 2.8-14.5 3.9-1.4.5-2.7 1-3 1-1.4.2-12.5 4-16.5 5.7-8 3.3-18.3 8.2-23.9 11.2-3.3 1.8-6.9 3.6-7.8 3.9-1 .4-1.8 1-1.8 1.5s-.5.9-1.1.9-4.7 2.5-9.1 5.5-8.3 5.5-8.8 5.5-1 .3-1.2.8c-.1.4-2.3 2.3-4.8 4.2-6.4 5-6.6 5.1-11.3 9.3-13.2 12-27.2 26.8-29.1 30.8-.5 1-1.3 1.9-1.7 1.9s-2.1 1.9-3.7 4.2c-1.6 2.4-5 7.3-7.5 11.1-2.6 3.7-4.7 7.1-4.7 7.6s-.4 1.1-.9 1.3c-2.9 1-21.1 41.3-24.7 54.3-3.2 11.6-5.3 20.2-5.8 23-.3 1.6-1.2 7-2.1 12-1.8 10.7-2.6 24.7-2.9 58-.2 13.7-.6 26.3-1 28-4 18.7-8 28.4-17.2 41.7-8.9 12.8-22.3 24.4-35.9 31-3.3 1.6-7.1 3.5-8.5 4.3-1.4.7-7.4 2.5-13.5 4-12.4 3.1-28.7 3.7-40.5 1.5-3.6-.7-7-1.3-7.7-1.4s-1.6-.5-1.9-.9c-.4-.4-1.5-.7-2.5-.7-3.2 0-18.1-7.1-26.5-12.5-8.2-5.4-22.3-19.8-28-28.6-4.7-7.3-11.7-23-12.8-28.5-.3-1.6-1-5-1.5-7.7-.6-2.6-1.3-8.9-1.6-14-.7-11.3-.7-11.3-3.1-16.2-3.3-6.9-10.8-13.4-17.7-15.2-1.2-.4-24.2-.7-51.2-.7l-49-.1-4.8 2.3c-5.8 2.9-11.7 8.6-14.3 13.8-1.6 3.3-1.9 6-1.8 18.4 0 12.5.5 20 1.9 28.5 1.1 6.7 2.3 13.6 2.9 16 .2 1.1.9 4 1.5 6.5 4 17.7 16 47.6 24.6 61.5 1.4 2.2 2.9 4.9 3.4 6 1.9 4.2 16.8 24.8 23.1 32 6.2 7 16.5 17.9 18 19.1.8.7 3.1 2.7 5 4.4 10 9.1 28.6 22.8 39.5 29.1 7.5 4.3 23 11.9 24.3 11.9.6 0 1.2.4 1.2.9s1 1.1 2.2 1.4c1.3.3 6.6 2.2 11.8 4.2s10.2 3.8 11 4c3.6.9 21.8 5.4 24.5 6 1.7.4 4.4.9 6 1.1 1.7.1 4.4.5 6 .8 7.7 1.5 17.5 2.1 35 2.1 19.1-.1 30.4-.9 40.5-3 1.4-.3 4-.8 5.9-1.1 5.8-1 21.4-4.9 24.1-6.1.8-.3 2.4-.8 3.5-1 1.1-.1 2.9-.7 4-1.2s6.1-2.5 11-4.4c5-1.9 11.2-4.7 13.9-6.1s5.2-2.6 5.7-2.6c1.2 0 17.6-9.7 25.9-15.2 15.2-10.3 34.9-27.6 48.1-42.4 4.8-5.4 18.7-24.3 22.5-30.6 2-3.5 4.4-7.1 5.2-8.1.8-.9 1.2-1.7.8-1.7-.3 0 .4-1.7 1.7-3.8 5-8.1 15.6-33.2 18.2-43.2.2-.8 1.3-4.7 2.3-8.5 2.6-9.3 5.1-21.1 5.7-26.5.3-2.5.7-5.6 1-7 1-4.9 1.7-21.9 1.9-49 .2-15.4.9-29.9 1.5-33 2.1-10.1 6.9-23.2 10.3-28.3 1.1-1.5 1.7-2.7 1.4-2.7-1.3 0 10-14.9 15.3-20.1 10.3-10.3 19.4-16.3 36.6-24 5.9-2.7 25.4-6.2 34-6.1 10 0 25.3 2.7 33.8 5.8 6.2 2.3 17.2 7.7 17.5 8.6.2.4 1 .8 1.7.8.8 0 2 .6 2.7 1.2.7.7 3.1 2.6 5.3 4.3 2.2 1.6 6.9 5.9 10.5 9.5l6.5 6.5h78.2l78.2.1-.6-2.6c-.3-1.4-.8-3-1.2-3.5-.3-.6-.7-1.8-.8-2.8-.7-4.5-8.1-22.5-14.6-35.6-9.1-18.2-9-18.1-9.9-18.1-.5 0-.8-.4-.8-.9 0-1.2-8.1-13.5-9.2-13.9-.4-.2-.8-.8-.8-1.3 0-.8-2-3.5-4.7-6.4-.7-.8-1.3-1.8-1.3-2.3 0-.6-.3-1.2-.7-1.4-.5-.2-2.6-2.3-4.7-4.8-12.5-14.4-32.3-33-39.2-36.8-1.3-.7-2.4-1.7-2.4-2.2 0-.6-.6-1-1.3-1-.8 0-2.2-.9-3.2-2s-2.4-2-3.1-2-1.4-.4-1.6-.8c-.7-1.9-24.2-14.9-36.8-20.5-6.6-3-18.9-7.6-21.2-8.1-1.3-.2-3.4-.9-4.8-1.5-2.3-1-12.6-3.7-17.5-4.7-1.1-.2-3-.6-4.2-.9-5.3-1.2-6.9-1.5-10.8-2.1-12.2-1.9-22.8-2.7-38.8-2.8-8.2-.1-14.9 0-15 .1m687.1-.2c-.2.2-3.9.6-8.3.9-11 .9-17.2 1.8-28.5 4.1-1.4.3-3.6.7-5 1-5.2 1-25.8 7.4-32.7 10.3-4 1.6-7.3 2.8-7.3 2.7 0-.2-6 2.7-13.2 6.4-13.8 7-24.1 12.9-24.6 14.3-.2.4-.8.8-1.3.8-.6 0-3 1.5-5.4 3.2-2.3 1.8-5.5 4.2-7.1 5.3-1.5 1.1-3.2 2.4-3.8 3-.6.5-3.8 3.2-7.1 6-13.7 11.4-32.9 32.5-41.3 45.4-2 3.1-3.9 5.8-4.2 6.1-1.2 1-7 11.1-7 12 0 .6-.3 1-.7 1-.5 0-2.1 2.9-3.8 6.5-1.6 3.5-3.3 6.5-3.7 6.5-.5 0-.8.8-.8 1.8s-.6 2.6-1.4 3.7c-2.6 3.9-14.2 35.5-13 35.5.3 0 0 .9-.6 1.9-.5 1.1-1.3 3.7-1.6 5.8s-.8 4.1-1.1 4.5c-.5.9-1 3.4-1.8 8.8-.3 2-.8 4.7-1 6-.5 2.5-1.1 7.1-2.1 14.5-.2 2.2-.7 18.4-.9 36s-.6 33.3-.9 35c-.4 1.6-.9 4.6-1.2 6.5s-1.7 7.1-3.1 11.5c-7.9 25.3-27.3 47.3-52.2 59.4-5.9 2.8-16.9 6.6-22.1 7.5-1.4.3-2.5.5-2.5.6 0 .5-9.3 1.1-17.5 1.2-12.2.1-19.1-.9-30-4.3-15.7-5-29.5-13.5-41.1-25.2l-7-7.1-77.2-.1c-42.5 0-77.5.1-77.8.2-1 .4 2.2 12.7 3.5 13.5.6.4.8.8.4.8-.6 0 5.9 17.7 8.1 21.7.5 1 2.6 5.2 4.6 9.3 4.9 10.1 16 28.7 18.5 31 .3.3 1.7 2.3 3.2 4.5s3.8 5.2 5 6.6c1.3 1.5 4.2 4.9 6.5 7.6 17.5 20.6 43.2 41.6 66.3 54.1 5.1 2.8 14.5 7.6 15 7.7.3 0 2.3.9 4.5 1.9 7.2 3.3 12 5.2 15.5 6.1.3.1 1.9.7 3.5 1.4 6.7 2.8 29.2 8.5 38 9.7 2.8.3 5.2.7 5.6.9 2.9 1.8 47.3 2.7 59.4 1.2 3.3-.4 8-1 10.5-1.3s8.7-1.4 13.9-2.5c5.1-1.2 10.1-2.2 11-2.4s4.6-1.3 8.4-2.5c3.7-1.2 7.3-2.3 8-2.4.6-.2 2.1-.7 3.2-1.1s5.2-2 9-3.5c39.7-15.6 76.8-43.4 102.3-77 4-5.2 8.1-10.6 9.2-12s2-3 2-3.7c0-.6.4-1.3.8-1.5 1-.4 7.9-12.2 13.3-22.6 7-13.7 14.6-34.2 18.5-49.7.4-1.7.8-3.2.9-3.5.4-1.6 1.5-6.9 2-9.5.3-1.7.7-4.1 1-5.5.2-1.4.7-4.8 1.1-7.5.3-2.8.8-6.6 1-8.5.3-1.9.7-16.6.9-32.5.6-38.3.8-41.5 4.4-53.5 3-10.5 9.6-25 11.3-25 .4 0 .8-.5.8-1.1 0-1.2 5.8-8.9 10.4-13.9 25.4-27.1 62.3-38 97.6-29 7.2 1.8 21.6 7.5 23 9 .3.3 2.2 1.4 4.3 2.4 2 1.1 3.7 2.3 3.7 2.8 0 .4.5.8 1.1.8 1.9 0 11.2 8.1 18.9 16.6 7.9 8.7 16.3 23.9 19.8 35.9 3.8 13 4.1 16.1 4.7 40.5.6 26.9 1.3 44.9 2 49.5 2 13.6 3.8 23.8 5.1 29 2.1 8.7 7.4 25.6 9 28.7.8 1.4 1.4 3.2 1.4 3.9 0 2.2 13.7 29.4 19.2 38.2 4.8 7.8 15.1 22 21.4 29.7 3.3 4 23.2 24 28.5 28.5 5.4 4.7 24.7 18.7 25.5 18.5.4-.1 1 .3 1.3.8.9 1.5 10.2 6.8 23.1 13.2 17.6 8.9 40.7 16.8 59.1 20.4.8.2 3 .6 4.9 1 3.6.7 5.3.9 17.5 2.3 8.8 1 41 1 49 .1 13.8-1.7 19.6-2.6 26.8-4.3 3.1-.7 5.7-1 5.7-.7s.5.1 1.2-.6 2-1.2 3-1.2c1.9 0 23.7-7 29.5-9.5 10.4-4.5 27.7-13.3 35.1-17.9 4.6-2.8 9.5-5.7 10.8-6.4s2.4-1.7 2.4-2.3c0-.5.7-.9 1.5-.9s1.5-.3 1.5-.8c0-.4 2.1-2.1 4.5-3.7 2.5-1.7 4.5-3.3 4.5-3.8 0-.4.4-.7.9-.7 2.1 0 23.8-20.9 33.2-32 7.2-8.5 14.7-18.6 16.1-21.6.6-1.3 1.4-2.4 1.8-2.4s1.3-1.4 2-3c.7-1.7 1.6-3 2.1-3s.9-.9.9-2 .3-2 .8-2c.4 0 1.2-1 1.8-2.3.7-1.2 2.8-5.4 4.9-9.2 7.4-14.2 19.5-45.8 18-47.4-.3-.2-35.4-.5-78-.5l-77.4-.1-6.7 6.8c-3.6 3.7-9.8 9.1-13.8 11.8-7 4.9-21.3 12.4-25.8 13.4-1.3.2-4.8 1.1-7.8 2-15.9 4.2-37 3.8-52-1.2-2.5-.8-5.2-1.6-6.1-1.8s-2.5-.8-3.5-1.3c-1.1-.6-4.1-2.1-6.9-3.3-2.7-1.3-5.4-2.7-6-3.2-.5-.4-3-2.1-5.5-3.7s-6.1-4.4-8.2-6.2c-2-1.8-4.4-4.1-5.5-5-5.4-4.9-11.6-13-16.5-21.4-3.8-6.5-11.2-25.3-10.3-26.2.2-.3 0-1.1-.6-1.9-.6-.7-.9-1.3-.6-1.3s.1-1.5-.4-3.3c-.5-1.7-1.2-12.2-1.4-23.2-.7-28.8-1.5-50.7-2-53.4-.2-1.3-.7-4.9-1.1-8-.8-7.4-2.9-17.5-6-29.1-1.4-5.2-2.7-10-2.8-10.5-.2-.6-.8-2.3-1.4-3.8-.7-1.6-1.2-3.3-1.2-3.8 0-.6-1.1-3.5-2.5-6.5s-2.5-5.6-2.5-5.9c0-.2-.5-1.6-1.2-3.2-.6-1.5-1.2-3-1.3-3.3 0-.3-.7-1.6-1.5-3s-1.5-2.7-1.5-3c-.1-.7-4.7-9.4-8-15-1.4-2.5-3.1-5.5-3.7-6.8-.6-1.2-1.5-2.2-2-2.2-.4 0-.8-.5-.8-1.1 0-1.3-7.7-12.2-16-22.4-23.9-29.7-60.4-56.9-94.5-70.5-4.4-1.7-8.9-3.6-10-4-5.8-2.5-30-9.1-38-10.4-1.6-.2-3-.5-3-.6 0-.2-1.1-.4-2.5-.5s-4.3-.5-6.5-.8c-8.2-1.3-15.4-1.8-30.2-2.1-8.4-.2-15.4-.2-15.5-.1m683.9.1c-.1.1-3.8.5-8.2.9-4.4.3-9.1.8-10.5 1s-4.1.7-6 .9c-7.9 1.2-9.8 1.6-17.5 3.5-25.3 6.2-44.1 13.8-66 26.4-6.9 4-18.5 11.5-19.5 12.6-.3.4-2.2 1.7-4.2 3.1-2.1 1.4-3.8 2.8-3.8 3.2 0 .5-.4.8-1 .8-.5 0-1.8.8-2.9 1.7-1 1-4.9 4.5-8.6 7.8-10 8.8-20.4 20-29 30.9-1.6 2.1-3.6 4.5-4.2 5.2-.7.7-1.3 1.7-1.3 2.2 0 .6-.3 1.2-.7 1.4-1.2.5-7.3 9.5-7.3 10.6 0 .6-.4 1.2-.8 1.4-1.3.5-15.6 27-15.7 29 0 .4-.6 1.3-1.2 1.9-.7.7-1.3 2-1.3 2.9s-.3 2-.7 2.4c-.5.4-.8 1.1-.9 1.4 0 .4-.5 1.8-1.1 3.2-2.3 5.4-7.3 21.2-7.3 22.9s3.9 1.8 77.6 1.8h77.6l6.8-6.6c10.7-10.4 15.8-14.2 26.5-19.5 12.6-6.2 24.3-9.5 36-10.1 3.9-.2 7.2-.5 7.5-.6 1.1-.2 6.7 0 12 .6 48.4 5.3 86.1 45.4 88.5 94 .7 13.7 3.2 20.2 9.8 26s13.6 8 24.7 7.6c3-.1 6.2-.2 7-.2 5.2.2 24.7.2 25.5.1.6-.1 1.2-.2 1.5 0 1.7.6 15 .4 15-.3 0-.5.5-.5 1.1-.1 1 .6 11.8.9 14.4.4.6-.2 1.3-.1 1.8 0 1.7.4 13.5.1 17.7-.5 11.1-1.5 20.7-10.2 23.8-21.5.5-1.9.3-21.1-.3-27-.6-6-1.5-13.8-2.1-17.5-.3-1.7-.7-4.1-.9-5.5-.5-3.9-5.5-24.3-6.5-26.5-.5-1.1-1.6-4.5-2.5-7.5-1.7-5.6-3.9-11.2-5.5-14.2-.6-1-1-2.2-1-2.8 0-3.2-15.4-31.4-22.2-40.7-2.1-2.9-3.8-5.5-3.8-5.8 0-.4-.6-1.2-1.2-1.9-.7-.7-2.4-2.8-3.8-4.6-16.7-22.2-42.1-44.9-67.5-60.2-12.3-7.4-35.2-17.9-49-22.4-1.8-.6-19-5.5-20.5-5.8-7.3-1.7-22.3-4.1-32-5.2-5.4-.6-35.8-1.3-36.3-.8"
    }));

const Safari = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 66.166 65.804",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#06c2e7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#0db8ec"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopColor: "#12aef1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.75,
        stopColor: "#1f86f9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#107ddd"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#bdbdbd"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        xlinkHref: "#prefix__a",
        id: "prefix__d",
        x1: 412.975,
        x2: 412.975,
        y1: 237.608,
        y2: 59.392,
        gradientTransform: "translate(206.79 159.773)scale(.35154)",
        gradientUnits: "userSpaceOnUse"
    }), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__f",
        width: 1.042,
        height: 1.045,
        x: -0.021,
        y: -0.022,
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 0.958
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__c",
        width: 1.096,
        height: 1.096,
        x: -0.048,
        y: -0.048,
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 3.564
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        xlinkHref: "#prefix__b",
        id: "prefix__e",
        cx: 413.061,
        cy: 136.818,
        r: 82.125,
        fx: 413.061,
        fy: 136.818,
        gradientTransform: "translate(194.545 155.58)scale(.38143)",
        gradientUnits: "userSpaceOnUse"
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M502.083 148.5a89.11 89.11 0 0 1-89.108 89.108 89.11 89.11 0 0 1-89.108-89.108 89.11 89.11 0 0 1 89.108-89.108 89.11 89.11 0 0 1 89.108 89.108",
        filter: "url(#prefix__c)",
        opacity: 0.53,
        paintOrder: "markers stroke fill",
        transform: "matrix(.33865 0 0 .3261 -106.77 -14.478)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        stroke: "#cdcdcd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.093,
        d: "M383.294 211.977a31.325 31.325 0 0 1-31.325 31.325 31.325 31.325 0 0 1-31.326-31.325 31.325 31.325 0 0 1 31.326-31.325 31.325 31.325 0 0 1 31.325 31.325",
        paintOrder: "markers stroke fill",
        transform: "translate(-318.886 -180.595)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M380.84 211.977a28.87 28.87 0 0 1-28.871 28.87 28.87 28.87 0 0 1-28.871-28.87 28.87 28.87 0 0 1 28.87-28.87 28.87 28.87 0 0 1 28.871 28.87",
        paintOrder: "markers stroke fill",
        transform: "translate(-318.886 -180.595)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f4f2f3",
        d: "M33.083 4.017a.42.42 0 0 0-.421.42v4.856a.42.42 0 1 0 .842 0V4.438a.42.42 0 0 0-.421-.421m-2.754.174a.42.42 0 0 0-.46.463l.212 2.03a.42.42 0 1 0 .837-.087l-.212-2.03a.42.42 0 0 0-.377-.376m5.527.002a.42.42 0 0 0-.377.375l-.214 2.03a.42.42 0 1 0 .837.089l.214-2.031a.42.42 0 0 0-.46-.463M27.5 4.6a.42.42 0 0 0-.41.508l1.005 4.75a.42.42 0 1 0 .824-.174l-1.005-4.75A.42.42 0 0 0 27.5 4.6zm11.183.004a.42.42 0 0 0-.414.333l-1.009 4.75a.42.42 0 1 0 .824.175l1.009-4.75a.42.42 0 0 0-.41-.508zm-13.883.757a.42.42 0 0 0-.437.55l.632 1.942a.42.42 0 1 0 .8-.26l-.63-1.942a.42.42 0 0 0-.365-.29m16.568.001a.42.42 0 0 0-.364.29l-.632 1.942a.42.42 0 1 0 .8.26l.632-1.942a.42.42 0 0 0-.436-.55M22.13 6.34a.42.42 0 0 0-.377.592l1.972 4.437a.42.42 0 1 0 .77-.342l-1.972-4.437a.42.42 0 0 0-.393-.25m21.937.015a.42.42 0 0 0-.392.25l-1.978 4.434a.42.42 0 1 0 .769.343l1.978-4.434a.42.42 0 0 0-.377-.593M19.654 7.65a.42.42 0 0 0-.394.63l1.02 1.77a.42.42 0 1 0 .73-.421L19.989 7.86a.42.42 0 0 0-.335-.21m26.858 0a.42.42 0 0 0-.335.21l-1.021 1.769a.42.42 0 1 0 .73.42l1.02-1.768a.42.42 0 0 0-.394-.63m-29.265 1.5a.422.422 0 0 0-.326.669l2.85 3.93a.42.42 0 1 0 .682-.494l-2.85-3.93a.42.42 0 0 0-.356-.174m31.702.022a.42.42 0 0 0-.356.174l-2.856 3.926a.42.42 0 1 0 .681.495l2.856-3.926a.42.42 0 0 0-.325-.669m-33.852 1.783a.42.42 0 0 0-.335.702l1.366 1.518a.42.42 0 1 0 .626-.563l-1.366-1.518a.42.42 0 0 0-.291-.14m35.975.003a.42.42 0 0 0-.29.139l-1.367 1.517a.42.42 0 1 0 .625.564l1.367-1.518a.42.42 0 0 0-.335-.702m-38.037 1.977a.42.42 0 0 0-.26.733l3.61 3.249a.42.42 0 1 0 .563-.626l-3.609-3.248a.42.42 0 0 0-.304-.108m40.109.014a.42.42 0 0 0-.304.108l-3.61 3.245a.42.42 0 1 0 .562.626l3.61-3.245a.42.42 0 0 0-.258-.734m-41.823 2.19a.42.42 0 0 0-.262.762l1.652 1.2a.42.42 0 1 0 .495-.681l-1.652-1.2a.4.4 0 0 0-.233-.081m43.535.015a.42.42 0 0 0-.233.08l-1.653 1.2a.42.42 0 1 0 .495.681l1.653-1.2a.42.42 0 0 0-.262-.76M9.72 17.49a.42.42 0 0 0-.18.785l4.204 2.427a.42.42 0 1 0 .42-.729L9.96 17.546a.4.4 0 0 0-.24-.056m46.728 0a.4.4 0 0 0-.24.056l-4.205 2.427a.42.42 0 1 0 .42.73l4.206-2.428a.42.42 0 0 0-.181-.785M8.508 19.996a.42.42 0 0 0-.18.806l1.866.832a.42.42 0 1 0 .343-.77l-1.866-.831a.4.4 0 0 0-.163-.037m49.158.017a.4.4 0 0 0-.164.037l-1.865.83a.42.42 0 1 0 .342.77l1.866-.831a.42.42 0 0 0-.179-.806M7.429 22.615a.42.42 0 0 0-.094.82l4.615 1.504a.42.42 0 1 0 .261-.8l-4.616-1.504a.4.4 0 0 0-.166-.02m51.314.018a.4.4 0 0 0-.166.02l-4.617 1.5a.42.42 0 1 0 .26.801l4.617-1.5a.42.42 0 0 0-.094-.82M6.756 25.365a.42.42 0 0 0-.09.833l1.998.424a.42.42 0 1 0 .175-.823l-1.998-.425a.4.4 0 0 0-.085-.009zm52.655.004a1 1 0 0 0-.085.009l-1.998.424a.42.42 0 1 0 .175.823l1.998-.424a.42.42 0 0 0-.09-.833zM6.247 28.13a.42.42 0 0 0-.003.838l4.828.51a.42.42 0 1 0 .089-.837l-4.829-.51a.4.4 0 0 0-.085 0m53.676.037a.4.4 0 0 0-.085 0l-4.83.504a.42.42 0 1 0 .088.837l4.83-.504a.42.42 0 0 0-.003-.837M6.165 30.96a.42.42 0 1 0 0 .842h2.043a.42.42 0 1 0 0-.842zm51.793 0a.42.42 0 1 0 0 .842h2.043a.42.42 0 1 0 0-.842zm-46.803 2.295a.4.4 0 0 0-.085 0l-4.83.504a.42.42 0 1 0 .088.838l4.83-.504a.42.42 0 0 0-.003-.838m43.853.03a.42.42 0 0 0-.003.838l4.828.51a.42.42 0 1 0 .089-.837l-4.828-.51a.4.4 0 0 0-.086-.001M8.748 36.13a.4.4 0 0 0-.085.009l-1.998.424a.42.42 0 1 0 .175.823l1.998-.424a.42.42 0 0 0-.09-.833zm48.67.004a.42.42 0 0 0-.09.833l1.997.424a.42.42 0 1 0 .175-.824l-1.998-.424a.4.4 0 0 0-.085-.01zM12.111 37.79a.4.4 0 0 0-.166.02l-4.617 1.5a.42.42 0 1 0 .26.801l4.617-1.5a.42.42 0 0 0-.094-.82m41.937.015a.42.42 0 0 0-.094.82l4.616 1.504a.42.42 0 1 0 .26-.8l-4.615-1.504a.4.4 0 0 0-.167-.02M10.35 41.08a.4.4 0 0 0-.163.036l-1.866.831a.42.42 0 1 0 .342.769l1.866-.83a.42.42 0 0 0-.179-.806m45.459.016a.42.42 0 0 0-.18.805l1.865.832a.42.42 0 1 0 .343-.769l-1.865-.832a.4.4 0 0 0-.163-.036m-41.826.912a.4.4 0 0 0-.24.056L9.538 44.49a.42.42 0 1 0 .421.73l4.205-2.428a.42.42 0 0 0-.181-.785m38.2 0a.42.42 0 0 0-.181.785l4.205 2.427a.42.42 0 1 0 .42-.729l-4.204-2.427a.4.4 0 0 0-.24-.056m-39.249 3.562a.42.42 0 0 0-.233.08l-1.653 1.2a.42.42 0 1 0 .495.682l1.653-1.2a.42.42 0 0 0-.262-.762m40.288.015a.42.42 0 0 0-.262.762l1.652 1.2a.42.42 0 1 0 .495-.681l-1.652-1.2a.4.4 0 0 0-.233-.081m-36.544.145a.42.42 0 0 0-.304.108l-3.61 3.245a.42.42 0 1 0 .562.626l3.61-3.245a.42.42 0 0 0-.258-.734m32.8.011a.421.421 0 0 0-.26.734l3.609 3.248a.42.42 0 1 0 .563-.625l-3.608-3.249a.42.42 0 0 0-.304-.107m-29.375 3.084a.42.42 0 0 0-.355.173l-2.856 3.927a.42.42 0 1 0 .68.495l2.857-3.926a.42.42 0 0 0-.326-.669m25.936.018a.421.421 0 0 0-.326.668l2.85 3.93a.42.42 0 1 0 .682-.494l-2.851-3.93a.42.42 0 0 0-.355-.174m-29.623.606a.42.42 0 0 0-.29.14l-1.367 1.517a.42.42 0 1 0 .625.563l1.367-1.517a.42.42 0 0 0-.335-.703m33.331.002a.42.42 0 0 0-.335.702l1.366 1.518a.42.42 0 1 0 .626-.563l-1.366-1.518a.42.42 0 0 0-.291-.139m-25.655 1.684a.42.42 0 0 0-.393.25l-1.978 4.433a.42.42 0 1 0 .77.343l1.977-4.434a.42.42 0 0 0-.376-.592m17.955.012a.42.42 0 0 0-.377.592l1.972 4.437a.42.42 0 1 0 .77-.342l-1.972-4.437a.42.42 0 0 0-.393-.25m-21.431 1.359a.42.42 0 0 0-.335.21l-1.021 1.768a.42.42 0 1 0 .729.421l1.02-1.769a.42.42 0 0 0-.393-.63m24.934 0a.42.42 0 0 0-.394.63l1.021 1.77a.42.42 0 1 0 .73-.422l-1.022-1.769a.42.42 0 0 0-.335-.21m-17.054.063a.42.42 0 0 0-.415.334l-1.009 4.749a.42.42 0 1 0 .824.175l1.009-4.75a.42.42 0 0 0-.41-.508zm9.16.003a.42.42 0 0 0-.41.508l1.006 4.75a.42.42 0 1 0 .823-.175l-1.006-4.75a.42.42 0 0 0-.414-.333zm-4.573.48a.42.42 0 0 0-.421.42v4.855a.42.42 0 1 0 .842 0v-4.855a.42.42 0 0 0-.421-.42m-7.727 1.568a.42.42 0 0 0-.364.29l-.631 1.942a.42.42 0 1 0 .8.26l.632-1.942a.42.42 0 0 0-.437-.55m15.45 0a.42.42 0 0 0-.437.55l.632 1.943a.42.42 0 1 0 .8-.26l-.63-1.942a.42.42 0 0 0-.365-.29m-10.365 1.083a.42.42 0 0 0-.378.375l-.213 2.03a.42.42 0 1 0 .837.088l.214-2.03a.42.42 0 0 0-.46-.463m5.267.002a.42.42 0 0 0-.46.463l.212 2.03a.42.42 0 1 0 .837-.088l-.212-2.03a.42.42 0 0 0-.377-.375",
        paintOrder: "markers stroke fill"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m469.096 100.607-65.51 38.061-41.42 65.207 60.595-44.882z",
        filter: "url(#prefix__f)",
        opacity: 0.409,
        paintOrder: "markers stroke fill",
        transform: "translate(-112.095 -20.822)scale(.35154)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ff5150",
        d: "m36.383 34.838-6.6-6.913 23.416-15.752z",
        paintOrder: "markers stroke fill"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f1f1f1",
        d: "m36.383 34.838-6.6-6.913L12.966 50.59z",
        paintOrder: "markers stroke fill"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m12.967 50.59 23.416-15.752L53.2 12.173z",
        opacity: 0.243
    }));

const Salesforce = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0.5 0.5 999 699.242",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00A1E0",
        d: "M416.224 76.763c32.219-33.57 77.074-54.391 126.682-54.391 65.946 0 123.48 36.772 154.12 91.361 26.626-11.896 56.098-18.514 87.106-18.514 118.94 0 215.368 97.268 215.368 217.247 0 119.993-96.428 217.261-215.368 217.261a213.7 213.7 0 0 1-42.422-4.227c-26.981 48.128-78.397 80.646-137.412 80.646-24.705 0-48.072-5.706-68.877-15.853-27.352 64.337-91.077 109.448-165.348 109.448-77.344 0-143.261-48.939-168.563-117.574-11.057 2.348-22.513 3.572-34.268 3.572C75.155 585.74.5 510.317.5 417.262c0-62.359 33.542-116.807 83.378-145.937-10.26-23.608-15.967-49.665-15.967-77.06C67.911 87.25 154.79.5 261.948.5c62.914 0 118.827 29.913 154.276 76.263"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M145.196 363.11c-.626 1.637.228 1.979.427 2.263 1.878 1.366 3.786 2.349 5.707 3.444 10.189 5.407 19.81 6.986 29.871 6.986 20.492 0 33.214-10.9 33.214-28.447v-.341c0-16.224-14.358-22.115-27.835-26.37l-1.75-.569c-10.161-3.302-18.927-6.147-18.927-12.836v-.355c0-5.721 5.123-9.934 13.064-9.934 8.823 0 19.297 2.932 26.042 6.66 0 0 1.978 1.281 2.704-.64.398-1.025 3.814-10.218 4.17-11.214.384-1.082-.299-1.879-.996-2.306-7.699-4.682-18.344-7.884-29.358-7.884l-2.049.014c-18.756 0-31.848 11.328-31.848 27.565v.342c0 17.119 14.444 22.669 27.978 26.54l2.177.669c9.862 3.031 18.358 5.635 18.358 12.58v.342c0 6.347-5.521 11.071-14.43 11.071-3.458 0-14.487-.071-26.398-7.6-1.438-.84-2.277-1.451-3.387-2.12-.583-.37-2.049-1.011-2.689.925zm299.998 0c-.626 1.637.228 1.979.427 2.263 1.878 1.366 3.786 2.349 5.706 3.444 10.189 5.407 19.811 6.986 29.871 6.986 20.492 0 33.215-10.9 33.215-28.447v-.341c0-16.224-14.359-22.115-27.836-26.37l-1.75-.569c-10.161-3.302-18.928-6.147-18.928-12.836v-.355c0-5.721 5.123-9.934 13.064-9.934 8.823 0 19.297 2.932 26.043 6.66 0 0 1.978 1.281 2.703-.64.398-1.025 3.814-10.218 4.17-11.214.385-1.082-.299-1.879-.996-2.306-7.699-4.682-18.344-7.884-29.358-7.884l-2.05.014c-18.756 0-31.848 11.328-31.848 27.565v.342c0 17.119 14.444 22.669 27.978 26.54l2.177.669c9.862 3.031 18.373 5.635 18.373 12.58v.342c0 6.347-5.536 11.071-14.445 11.071-3.457 0-14.486-.071-26.397-7.6-1.438-.84-2.291-1.423-3.372-2.12-.371-.242-2.107-.911-2.705.925zm204.801-34.37c0 9.919-1.85 17.731-5.493 23.253-3.601 5.465-9.051 8.126-16.649 8.126-7.613 0-13.035-2.647-16.579-8.126-3.587-5.507-5.407-13.334-5.407-23.253 0-9.904 1.82-17.703 5.407-23.168 3.544-5.407 8.966-8.04 16.579-8.04 7.599 0 13.049 2.633 16.664 8.04 3.629 5.464 5.478 13.263 5.478 23.168m17.106-18.386c-1.68-5.679-4.298-10.688-7.784-14.857-3.487-4.184-7.898-7.542-13.136-9.99-5.223-2.433-11.398-3.671-18.328-3.671-6.945 0-13.121 1.238-18.344 3.671-5.237 2.448-9.648 5.807-13.149 9.99-3.472 4.184-6.091 9.193-7.784 14.857-1.665 5.649-2.505 11.825-2.505 18.386s.84 12.751 2.505 18.386c1.693 5.664 4.298 10.674 7.799 14.857 3.486 4.184 7.912 7.528 13.135 9.904 5.236 2.377 11.398 3.586 18.344 3.586 6.93 0 13.092-1.209 18.328-3.586 5.223-2.376 9.648-5.721 13.136-9.904 3.486-4.17 6.104-9.179 7.784-14.857 1.68-5.649 2.519-11.84 2.519-18.386s-.841-12.737-2.52-18.386m140.467 47.116c-.569-1.665-2.177-1.039-2.177-1.039-2.49.954-5.138 1.836-7.955 2.277-2.861.44-6.006.669-9.379.669-8.281 0-14.856-2.462-19.566-7.329-4.725-4.867-7.372-12.736-7.344-23.381.029-9.691 2.362-16.978 6.561-22.527 4.17-5.521 10.517-8.354 18.984-8.354 7.059 0 12.438.811 18.072 2.59 0 0 1.352.583 1.992-1.181 1.494-4.156 2.604-7.13 4.198-11.698.456-1.295-.654-1.85-1.053-2.007-2.22-.868-7.457-2.276-11.413-2.874-3.7-.569-8.026-.868-12.836-.868-7.188 0-13.591 1.224-19.069 3.672-5.465 2.433-10.104 5.791-13.775 9.976-3.672 4.184-6.461 9.192-8.325 14.856-1.85 5.649-2.789 11.854-2.789 18.415 0 14.188 3.828 25.657 11.385 34.054 7.57 8.425 18.941 12.708 33.77 12.708 8.766 0 17.76-1.778 24.221-4.326 0 0 1.238-.598.697-2.034zm29.929-38.232c.811-5.507 2.334-10.09 4.682-13.661 3.544-5.422 8.951-8.396 16.551-8.396s12.623 2.988 16.223 8.396c2.391 3.571 3.43 8.354 3.843 13.661zm57.592-12.111c-1.451-5.479-5.052-11.015-7.414-13.548-3.729-4.013-7.371-6.816-10.986-8.382-4.725-2.021-10.389-3.358-16.593-3.358-7.229 0-13.79 1.21-19.112 3.714-5.336 2.505-9.818 5.921-13.334 10.176-3.516 4.24-6.162 9.292-7.842 15.027-1.693 5.707-2.547 11.926-2.547 18.485 0 6.675.883 12.894 2.633 18.486 1.765 5.636 4.582 10.602 8.396 14.714 3.799 4.142 8.695 7.387 14.558 9.648 5.821 2.249 12.894 3.416 21.019 3.401 16.722-.057 25.53-3.785 29.159-5.792.641-.355 1.253-.981.483-2.774l-3.785-10.603c-.568-1.579-2.177-.996-2.177-.996-4.142 1.537-10.032 4.298-23.766 4.27-8.979-.014-15.64-2.661-19.81-6.803-4.283-4.24-6.375-10.474-6.745-19.268l57.905.057s1.522-.028 1.68-1.509c.057-.624 1.993-11.895-1.722-24.945m-521.327 12.111c.825-5.507 2.334-10.09 4.682-13.661 3.543-5.422 8.951-8.396 16.55-8.396s12.623 2.988 16.237 8.396c2.376 3.571 3.415 8.354 3.828 13.661zm57.577-12.111c-1.451-5.479-5.037-11.015-7.399-13.548-3.729-4.013-7.372-6.816-10.986-8.382-4.725-2.021-10.388-3.358-16.593-3.358-7.215 0-13.79 1.21-19.112 3.714-5.336 2.505-9.819 5.921-13.334 10.176-3.515 4.24-6.162 9.292-7.841 15.027-1.679 5.707-2.547 11.926-2.547 18.485 0 6.675.882 12.894 2.633 18.486 1.765 5.636 4.583 10.602 8.396 14.714 3.8 4.142 8.695 7.387 14.558 9.648 5.821 2.249 12.893 3.416 21.019 3.401 16.721-.057 25.53-3.785 29.159-5.792.641-.355 1.252-.981.484-2.774l-3.771-10.603c-.584-1.579-2.191-.996-2.191-.996-4.141 1.537-10.019 4.298-23.78 4.27-8.965-.014-15.625-2.661-19.795-6.803-4.284-4.24-6.375-10.474-6.746-19.268l57.905.057s1.522-.028 1.679-1.509c.055-.624 1.99-11.895-1.738-24.945m-182.738 50.026c-2.263-1.808-2.576-2.263-3.344-3.43-1.139-1.779-1.722-4.312-1.722-7.528 0-5.095 1.679-8.752 5.166-11.214-.042.015 4.981-4.34 16.792-4.184 8.296.114 15.71 1.338 15.71 1.338v26.327h.014s-7.357 1.579-15.639 2.077c-11.783.712-17.02-3.4-16.977-3.386m23.039-40.686c-2.348-.171-5.394-.271-9.037-.271-4.966 0-9.762.626-14.259 1.836-4.525 1.209-8.595 3.103-12.096 5.606a27.9 27.9 0 0 0-8.396 9.549c-2.049 3.814-3.088 8.311-3.088 13.349 0 5.123.882 9.577 2.647 13.221 1.765 3.657 4.312 6.702 7.556 9.051 3.216 2.348 7.187 4.069 11.797 5.108 4.54 1.039 9.691 1.565 15.327 1.565 5.934 0 11.854-.483 17.589-1.466 5.678-.968 12.651-2.377 14.586-2.817a146 146 0 0 0 4.056-1.039c1.438-.355 1.324-1.893 1.324-1.893l-.029-52.952c0-11.613-3.102-20.223-9.207-25.559-6.077-5.322-15.028-8.013-26.597-8.013-4.341 0-11.328.599-15.512 1.438 0 0-12.651 2.448-17.86 6.518 0 0-1.138.712-.512 2.306l4.099 11.015c.512 1.423 1.893.939 1.893.939s.441-.171.954-.47c11.143-6.062 25.231-5.877 25.231-5.877 6.262 0 11.072 1.252 14.316 3.742 3.159 2.419 4.767 6.076 4.767 13.789v2.448a210 210 0 0 0-9.549-1.123m467.029-29.836c.44-1.31-.484-1.936-.869-2.078-.981-.384-5.905-1.423-9.705-1.665-7.271-.441-11.312.783-14.928 2.405-3.586 1.622-7.57 4.24-9.791 7.215v-7.044c0-.982-.697-1.765-1.665-1.765h-14.843c-.967 0-1.664.782-1.664 1.765v86.366c0 .968.797 1.765 1.764 1.765h15.213a1.76 1.76 0 0 0 1.75-1.765v-43.147c0-5.792.641-11.569 1.922-15.198 1.252-3.587 2.96-6.461 5.066-8.525 2.12-2.049 4.525-3.486 7.158-4.297 2.689-.826 5.663-1.096 7.77-1.096 3.031 0 6.361.782 6.361.782 1.109.128 1.736-.555 2.105-1.565.997-2.647 3.815-10.574 4.356-12.153"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M595.874 246.603c-1.85-.569-3.529-.954-5.721-1.366-2.221-.398-4.867-.598-7.869-.598-10.475 0-18.729 2.96-24.52 8.794-5.764 5.807-9.678 14.644-11.642 26.271l-.712 3.913h-13.148s-1.594-.057-1.936 1.68l-2.148 12.053c-.157 1.139.342 1.864 1.878 1.864h12.794l-12.979 72.463c-1.011 5.835-2.178 10.631-3.473 14.273-1.267 3.587-2.504 6.276-4.041 8.24-1.48 1.879-2.875 3.273-5.295 4.084-1.992.669-4.297.982-6.816.982-1.395 0-3.258-.229-4.639-.513-1.366-.271-2.092-.569-3.131-1.011 0 0-1.494-.568-2.092.926-.47 1.238-3.885 10.615-4.298 11.769-.398 1.152.171 2.049.896 2.319 1.708.598 2.974.996 5.294 1.551 3.217.755 5.934.797 8.481.797 5.322 0 10.189-.754 14.217-2.205 4.042-1.466 7.57-4.014 10.701-7.457 3.373-3.729 5.493-7.628 7.515-12.964 2.006-5.266 3.729-11.812 5.094-19.439l13.05-73.815h19.069s1.607.057 1.936-1.693l2.162-12.039c.143-1.152-.341-1.864-1.893-1.864h-18.514c.1-.412.939-6.931 3.06-13.063.911-2.604 2.618-4.725 4.056-6.177 1.424-1.423 3.06-2.433 4.854-3.017 1.835-.598 3.928-.882 6.219-.882 1.736 0 3.457.199 4.752.469 1.793.385 2.49.584 2.961.727 1.893.569 2.148.014 2.519-.896l4.426-12.153c.455-1.312-.669-1.867-1.067-2.023m-258.68 125.231c0 .968-.697 1.751-1.665 1.751h-15.355c-.968 0-1.651-.783-1.651-1.751v-123.58c0-.967.683-1.75 1.651-1.75h15.355c.968 0 1.665.783 1.665 1.75z"
    }));

const Sanity = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 512 104",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F37368",
        d: "M381.462 36.986v64.834h-20.886V26.833z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F7A199",
        d: "m85.865 89.781 15.665 13.634 65.994-34.375-6.817-16.39zm274.71-41.772 53.086-27.558-8.992-15.52-44.093 21.902z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F37368",
        d: "M211.182 31.91v69.91h-20.016V2.176zM85.865 89.78l15.665 13.634 30.169-75.422-9.718-25.817z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F04939",
        d: "M121.98 2.176h20.597l38.146 99.644h-21.176zm92.248 0L258.176 70.2v31.619l-67.01-99.644h23.062Zm81.659 0h20.74v99.644h-20.74zm64.689 18.275h-31.91V2.176h74.407l10.588 18.275z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F7A199",
        d: "M475.014 63.964v37.856h-20.596V63.964"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F04939",
        d: "m489.228 2.176-34.81 61.788h20.596L511.13 2.176z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F37368",
        d: "m454.418 63.964-35.97-61.788h22.626l24.222 42.352z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F04939",
        d: "M8.558 13.779c0 13.78 8.557 22.046 25.672 26.398l18.13 4.206c16.245 3.771 26.108 13.054 26.108 28.138.145 6.527-2.03 12.909-5.947 18.13 0-15.084-7.832-23.206-26.543-28.138l-17.84-4.06C13.78 55.26 2.756 47.572 2.756 31.183c0-6.237 2.03-12.474 5.802-17.405"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F37368",
        d: "M258.176 65.124V2.176h20.016v99.644h-20.016zM61.353 68.75c7.687 4.932 11.168 11.894 11.168 21.902-6.527 8.267-17.695 12.763-30.894 12.763-22.191 0-38-11.023-41.337-30.023h21.321c2.756 8.702 10.008 12.763 19.871 12.763 11.749.145 19.726-6.237 19.871-17.405M8.558 13.634C14.794 5.512 25.528.58 38.58.58c22.772 0 35.826 12.039 39.162 28.864H57.147c-2.32-6.672-7.978-11.894-18.276-11.894-11.168.145-18.71 6.527-19.145 16.68-7.474-4.122-11.459-12.184-11.168-20.596"
    }));

const Sass = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 384",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#CF649A",
        d: "M441 221c-18 0-34 4-47 10-5-9-9-17-10-24s-2-11-1-20 6-21 6-22c0 0-1-5-11-5-11 0-20 2-21 5l-4 15c-2 9-20 43-31 60-4-7-7-13-7-17-1-8-2-12-1-21s6-20 6-21-1-6-11-6c-11 0-20 2-21 5l-4 15-34 76-8 18c-2 4 0 0 0 1l-3 5-4 5s-1-7 1-16c3-19 12-49 12-51 0 0 2-5-6-8-7-3-9 2-10 2l-1 1s8-34-16-34c-14 0-35 17-45 31l-34 19-17 9-1-1c-29-31-82-52-79-93 0-15 6-54 101-102 79-39 141-28 152-4 16 34-33 97-115 106-31 3-47-9-51-13-4-5-5-5-7-4s-1 5 0 8c3 6 13 17 30 23 15 5 51 8 95-9 49-19 88-72 77-117-12-45-87-60-157-35-43 15-88 39-121 70-39 36-45 68-43 81 10 47 74 78 100 100l-3 2c-13 7-63 33-75 60-14 31 2 53 13 56 33 10 68-7 86-34 18-28 16-64 8-80l-1-1 11-6 18-10c-3 9-5 19-6 34-2 17 6 40 15 49 4 4 9 4 12 4 11 0 16-9 22-20l13-28s-8 41 13 41c7 0 15-9 18-14l1-1 1-2 20-37 25-57 5 20c2 8 7 16 10 24l-4 7-8 10c-10 12-23 26-24 30-2 5-2 8 2 11 3 2 8 2 13 2l18-4 17-9c10-7 16-18 15-32 0-7-3-15-6-22l3-4c16-23 28-49 28-49l5 21 9 20a89 89 0 0 0-27 36c-6 17-2 24 7 26 4 1 10-1 14-3 5-1 11-4 17-8 10-8 20-18 19-32 0-6-2-13-4-19 12-5 29-8 49-5 45 5 54 33 52 44-2 12-11 18-14 20l-4 4c1 2 2 2 5 2 3-1 23-10 24-31 1-28-25-58-71-57M97 336c-14 16-35 23-44 17-9-5-6-29 13-46 11-10 25-20 34-26l9-5 1-1 3-1c6 24 0 45-16 62m108-73c-5 13-16 45-22 43-6-1-9-26-2-50 4-12 13-26 18-32 8-9 17-12 19-8 3 5-10 39-13 47m89 43-5 1v-2l16-17 9-11v1c0 14-14 24-20 28m68-16c-2-1-1-5 4-16 2-5 7-13 15-20l2 9c0 18-13 24-21 27"
    }));

const Scala = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 416",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "0%",
        x2: "100%",
        y1: "50%",
        y2: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4F4F4F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "0%",
        x2: "100%",
        y1: "50%",
        y2: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#C40000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "red"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M0 288v-32c0-5 116-14 192-32 37 8 64 19 64 32v32c0 13-27 24-64 32-76-18-192-27-192-32",
        transform: "matrix(1 0 0 -1 0 544)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M0 160v-32c0-5 116-14 192-32 37 8 64 19 64 32v32c0 13-27 24-64 32-76-18-192-27-192-32",
        transform: "matrix(1 0 0 -1 0 288)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M0 224v-96c0 8 256 24 256 64v96c0-40-256-56-256-64",
        transform: "matrix(1 0 0 -1 0 416)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M0 96V0c0 8 256 24 256 64v96c0-40-256-56-256-64",
        transform: "matrix(1 0 0 -1 0 160)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M0 352v-96c0 8 256 24 256 64v96c0-40-256-56-256-64",
        transform: "matrix(1 0 0 -1 0 672)"
    }));

const Sentry = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 227",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#362D59",
        d: "M148.368 12.403a23.935 23.935 0 0 0-41.003 0L73.64 70.165c52.426 26.174 87.05 78.177 90.975 136.642h-23.679c-3.918-50.113-34.061-94.41-79.238-116.448l-31.213 53.97a81.6 81.6 0 0 1 47.307 62.375h-54.38a3.895 3.895 0 0 1-3.178-5.69l15.069-25.626a55 55 0 0 0-17.221-9.738L3.167 191.277a23.27 23.27 0 0 0 8.662 31.982 23.9 23.9 0 0 0 11.583 3.075h74.471a99.43 99.43 0 0 0-41.003-88.72l11.84-20.5c35.679 24.504 55.754 66.038 52.79 109.22h63.094c2.99-65.43-29.047-127.512-84.107-162.986l23.935-41.002a3.947 3.947 0 0 1 5.382-1.384c2.716 1.486 103.993 178.208 105.89 180.258a3.895 3.895 0 0 1-3.486 5.792h-24.396q.46 9.789 0 19.528h24.499A23.53 23.53 0 0 0 256 202.91a23 23 0 0 0-3.178-11.685z"
    }));

const Sequelize = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 296",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "M219 94.4V201l-90.6 53.5-.8.8V295l.8.8L256 222.2V73.7l-1.2-.3-36 20z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "m37.6 201.8 90.8 52.7V296L0 221.9V74l1.3-.1 35.9 20.8.4 1.2v106"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "M37.6 95.8 0 74 128.1 0 256 73.7l-37 20.7-90.9-51.9z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "m126.9 189.6-1-1v-40l1-.5.2-1 34.3-20 1 .2v41.3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "M90.7 169.9V127h1l34.9 20.3.3.8v41.5L90.7 170"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "m126.3 106-35.6 21 36.2 21.1 35.6-20.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "m82.6 215.7-1-1v-40l1-.5.2-1 34.3-20 1 .2v41.3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "M46.4 196v-43h1l34.9 20.3.3.8v41.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "m82 132-35.6 21.1 36.2 21.1 35.6-20.8L82 132.1"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "m174.3 216.7-1-1v-40l1-.5.3-1 34.3-20 1 .2v41.3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "M138.2 197v-43h1l34.9 20.3.3.8v41.5L138.1 197"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "m173.8 133-35.6 21.1 36.2 21.1 35.6-20.8-36.2-21.3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "m130 242.8-1-1v-40l1-.5.3-1 34.3-20 1 .2v41.3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "M93.8 223v-42.8h1l35 20.3.2.8v41.5l-36.2-19.7"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "m129.4 159.2-35.6 21 36.2 21.1 35.6-20.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "m126.9 132.9-1-1v-40l1-.6.2-1 34.3-20 1 .3v41.2l-35.5 21"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "M90.7 113V70.4h1l34.9 20.2.3.8V133z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "m126.3 49.2-35.6 21 36.2 21.1 35.6-20.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "m82.6 159-1-1v-40l1-.6.2-1 34.3-20 1 .3v41.2l-35.5 21"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "M46.4 139.2V96.4h1l34.9 20.2.3.8V159z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "m82 75.3-35.6 21 36.2 21.1 35.6-20.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "m174.3 160-1-1v-40l1-.6.3-1 34.3-20 1 .3v41.2l-35.6 21"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "M138.2 140.2V97.4h1l34.9 20.2.3.8V160z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "m173.8 76.3-35.6 21 36.2 21.1L210 97.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2F406A",
        d: "m130 186-1-1v-40l1-.5.3-1 34.3-20 1 .3V165z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2379BD",
        d: "M93.8 166.3v-42.8h1l35 20.2.2.8v41.6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#03AFEF",
        d: "m129.4 102.4-35.6 21 36.2 21.1 35.6-20.7z"
    }));

const ShadcnUiDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        d: "M0 0h256v256H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeWidth: 25,
        d: "m208 128-80 80m64-168L40 192"
    }));

const ShadcnUiLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        d: "M0 0h256v256H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 25,
        d: "m208 128-80 80m64-168L40 192"
    }));

const Shiki = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 266 266",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 219.5,
        cy: 46.5,
        r: 46.5,
        fill: "#CB7676"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4B9978",
        d: "M0 48h266v65H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#83D0DA",
        d: "M109.463 144.426q-.676-8.451-6.339-13.184-5.578-4.734-16.988-4.733-7.269 0-11.917 1.775-4.563 1.69-6.761 4.648t-2.282 6.761q-.169 3.128 1.099 5.663 1.352 2.451 4.225 4.479 2.874 1.944 7.353 3.55 4.48 1.607 10.65 2.874l14.198 3.042q14.368 3.043 24.595 8.029 10.226 4.988 16.734 11.748 6.508 6.677 9.55 15.044 3.128 8.367 3.212 18.256-.084 17.071-8.536 28.905-8.452 11.832-24.172 18.002-15.636 6.17-37.61 6.169-22.566 0-39.385-6.676-16.734-6.678-26.03-20.538-9.213-13.946-9.298-35.666h44.625q.423 7.944 3.972 13.354t9.974 8.198q6.507 2.789 15.466 2.789 7.522 0 12.593-1.86 5.071-1.859 7.691-5.155t2.705-7.522q-.085-3.973-2.62-6.931-2.451-3.042-8.114-5.409-5.662-2.45-15.298-4.564l-17.241-3.718q-22.989-4.987-36.258-16.65-13.184-11.748-13.1-32.032-.084-16.48 8.79-28.82 8.96-12.424 24.763-19.355 15.89-6.93 36.427-6.93 20.96 0 36.258 7.015 15.297 7.015 23.58 19.777 8.367 12.678 8.452 29.665z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E6CC78",
        d: "M217 0v266h-65V0z"
    }));

const Shopify = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 292",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#95BF46",
        d: "M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357a19614 19614 0 0 0-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.19.056-3.388 1.043-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635-14.558 4.511-24.9 7.718-26.221 8.133-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042 89.77-19.42S223.973 58.8 223.775 57.34zM156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023 0-9.264-1.286-16.723-3.349-22.636 8.287 1.04 13.806 10.469 17.358 21.32m-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238 0 .572-.005 1.095-.01 1.624-9.117 2.824-19.024 5.89-28.953 8.966 5.575-21.516 16.025-31.908 25.161-35.828m-11.131-10.537c1.617 0 3.246.549 4.805 1.622-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5E8E3E",
        d: "M221.237 54.983a19614 19614 0 0 0-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233 89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m135.242 104.585-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693 0 15.038 39.2 20.8 39.2 56.024 0 27.713-17.577 45.558-41.277 45.558-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232 0-19.616-32.16-20.491-32.16-52.724 0-27.129 19.472-53.382 58.778-53.382 15.145 0 22.627 4.338 22.627 4.338"
    }));

const SketchDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        color: "#ffff",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "m.38 11.986 6.412-8.704a.8.8 0 0 1 .556-.32l8.564-.952a1 1 0 0 1 .176 0l8.564.951a.8.8 0 0 1 .556.32l6.413 8.705a.8.8 0 0 1-.04.997L16.455 30.475a.6.6 0 0 1-.908 0L.418 12.983a.8.8 0 0 1-.039-.997zm17.826-7.403 6.047 5.712a.4.4 0 0 0 .674-.32l-.29-4.054a.2.2 0 0 1 .392-.07l1.326 4.642a1 1 0 0 0 .645.674l2.83.943a.2.2 0 0 1-.062.39h-2.72a1 1 0 0 0-.843.463l-7.414 11.65a.3.3 0 0 1-.523-.291l5.314-10.96a.6.6 0 0 0-.54-.862H8.958a.6.6 0 0 0-.54.862l5.314 10.96a.3.3 0 0 1-.523.292l-7.414-11.65a1 1 0 0 0-.844-.464H2.148a.2.2 0 0 1-.062-.39l2.908-.945a1 1 0 0 0 .652-.677l1.325-4.637a.2.2 0 0 1 .392.07l-.29 4.054a.4.4 0 0 0 .674.32l6.047-5.712a.2.2 0 0 1 .293.272L10.03 9.848a.4.4 0 0 0 .31.652h11.32a.4.4 0 0 0 .31-.652l-4.057-4.993a.2.2 0 0 1 .293-.272"
    }));

const SketchLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        color: "#000",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "m.38 11.986 6.412-8.704a.8.8 0 0 1 .556-.32l8.564-.952a1 1 0 0 1 .176 0l8.564.951a.8.8 0 0 1 .556.32l6.413 8.705a.8.8 0 0 1-.04.997L16.455 30.475a.6.6 0 0 1-.908 0L.418 12.983a.8.8 0 0 1-.039-.997zm17.826-7.403 6.047 5.712a.4.4 0 0 0 .674-.32l-.29-4.054a.2.2 0 0 1 .392-.07l1.326 4.642a1 1 0 0 0 .645.674l2.83.943a.2.2 0 0 1-.062.39h-2.72a1 1 0 0 0-.843.463l-7.414 11.65a.3.3 0 0 1-.523-.291l5.314-10.96a.6.6 0 0 0-.54-.862H8.958a.6.6 0 0 0-.54.862l5.314 10.96a.3.3 0 0 1-.523.292l-7.414-11.65a1 1 0 0 0-.844-.464H2.148a.2.2 0 0 1-.062-.39l2.908-.945a1 1 0 0 0 .652-.677l1.325-4.637a.2.2 0 0 1 .392.07l-.29 4.054a.4.4 0 0 0 .674.32l6.047-5.712a.2.2 0 0 1 .293.272L10.03 9.848a.4.4 0 0 0 .31.652h11.32a.4.4 0 0 0 .31-.652l-4.057-4.993a.2.2 0 0 1 .293-.272"
    }));

const Sky = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 600 450",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 426.546,
        x2: 602.69,
        y1: 212.708,
        y2: 111.007,
        gradientTransform: "matrix(1 0 0 -1 -120.945 379.362)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#e20720"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.33,
        stopColor: "#d20f81"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.72,
        stopColor: "#383088"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1493d2"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M407.4 362.9c-6.4.2-12.8-.8-18.9-3-2.4-.8-3-1.7-1.8-4.2 11.4-23.8 22.6-47.6 34-71.4 1.2-2 1.2-4.5 0-6.4-18.9-29.5-37.7-59-56.5-88.6-1.2-1.9-2.1-2.1-3.7-.5-10.9 11.7-21.9 23.3-32.9 34.8-1.5 1.6-.8 2.6 0 3.9l27.6 41.5 21.2 32.1c.9 1.4 1.7 2.6-.6 3.4-14 5.6-29.6 5.4-43.5-.5-6.2-3-11.3-7.8-14.9-13.7-14-21.9-27.8-43.8-41.9-65.6-1.7-1.7-1.6-4.4.1-6.1.1-.1.3-.2.4-.3 17.7-19 35.3-38.2 52.7-57.4 15.8-17.4 35.1-21.1 57.1-16.1 1.9.5 3.5 1.8 4.3 3.5l47.4 77.1c1.4 2.2 2.6 4.4 4.1 6.4.4.6.6 1.8 1.5 1.7s1.2-1.3 1.5-2.1l13.7-32.1c4.3-10.7 8.8-21.4 13.6-32.1 8.9-20.6 25.3-26.7 45.9-21.9 1.6.4 3.1 1 4.7 1.4 3.9 1.2 4.1 1.3 2.2 5-16.6 33.9-31.1 68.8-46.8 102.9-12.9 28.7-25.7 57.9-38.6 86.3-2.6 6.9-7.2 12.9-13.2 17.2-5.5 3.8-12.1 5.4-18.7 4.8"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 193.938,
        x2: 336.911,
        y1: 193.94,
        y2: 111.396,
        gradientTransform: "matrix(1 0 0 -1 -120.945 379.362)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#ef7d06"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.54,
        stopColor: "#e31113"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#e50766"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M139.8 308c-19.8-.3-37.4-1.5-54.9-3.2-4.6-.5-5-.8-5.2-5.3-.6-5.4-.3-10.8.8-16.1 1.9-10.5 11.2-18 21.9-17.7 10.5 0 21 1 31.4 1.5 8.6.8 17.2.7 25.7-.3 2.3-.3 4.5-1.1 6.4-2.4 3.8-1.9 5.4-6.5 3.6-10.3q-1.2-2.4-3.6-3.6c-4.1-2.2-8.6-3.6-13.2-4.2-11.6-2.4-23.4-4.4-35-6.8-13.4-2.1-25.4-9.3-33.7-20-14.7-20-10.5-48.2 9.5-62.9.6-.5 1.3-.9 2-1.4 10.3-6.8 22.1-10.7 34.4-11.4 23.8-1.7 47.7-1 71.3 2.3 2.4 0 3.2 1.3 3.6 3.6 1 5.9.8 12-.6 17.8-1.9 10.3-11.1 17.6-21.5 17-10.7 0-21.3-1.2-32.1-1.4-6.7-.4-13.4-.2-20.1.8-2.8.4-5.5 1.4-8 3-3.1 1.7-4.3 5.5-2.7 8.7q.9 1.8 2.7 2.7c3.6 1.9 7.5 3.2 11.6 3.7 13.6 2.7 27.5 4.6 41 8 11.9 2.6 22.7 9.1 30.5 18.4 14.5 17.6 13.6 55-15.4 69.9-10.8 5.4-22.6 8.4-34.7 8.8-5.2.6-10.5.8-15.7.8"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 314.598,
        x2: 428.514,
        y1: 213.51,
        y2: 147.809,
        gradientTransform: "matrix(1 0 0 -1 -120.945 379.362)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#ef7d06"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.54,
        stopColor: "#e31113"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#e50766"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M272 190.5v95.9c1.3 9.8-5.6 18.8-15.4 20.1-.1 0-.3 0-.4.1-8.4 1.9-17.1 2.3-25.7 1.3-1.5.1-2.8-1.1-2.9-2.7V117.7c0-3 .3-6.1.9-9.1 1.5-9.7 8.9-17.4 18.6-19.3 6.9-1.7 14.1-2.1 21.2-1.2 3 .4 3.5 1.9 3.5 4.5v98z"
    }));

const Skype = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "42.173%",
        x2: "57.827%",
        y1: ".584%",
        y2: "99.416%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "1%",
        stopColor: "#00B7F0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "34%",
        stopColor: "#009DE5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "76%",
        stopColor: "#0082D9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#0078D4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "6.659%",
        x2: "93.341%",
        y1: "75%",
        y2: "25%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0078D4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "37%",
        stopColor: "#007AD5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "57%",
        stopColor: "#0082D9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "74%",
        stopColor: "#0090DF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "88%",
        stopColor: "#00A3E7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#00BCF2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "30.436%",
        x2: "80.436%",
        y1: "16.124%",
        y2: "102.737%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00B7F0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#007CC1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: "45.636%",
        x2: "54.364%",
        y1: "99.815%",
        y2: ".185%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0078D4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#00BCF2"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__d",
        cx: "48.539%",
        cy: "50%",
        r: "50.021%",
        fx: "48.539%",
        fy: "50%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__c",
        d: "M179.903 104.187a75.7 75.7 0 0 0-38.567 10.55c19.535-32.94 11.499-75.273-18.749-98.764C92.34-7.52 49.337-4.827 22.255 22.255-4.826 49.336-7.519 92.34 15.973 122.587c23.491 30.248 65.823 38.284 98.765 18.749-17.49 29.642-12.843 67.344 11.322 91.852 24.166 24.508 61.798 29.685 91.684 12.613s44.542-52.118 35.705-85.382c-8.836-33.265-38.95-56.418-73.37-56.409z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M246.663 143.907a115 115 0 0 0 1.153-15.782A119.87 119.87 0 0 0 127.948 8.258c-5.28.022-10.553.407-15.781 1.152C82.62-6.514 46.125-1.165 22.392 22.57-1.342 46.303-6.691 82.797 9.233 112.344c-.745 5.228-1.13 10.5-1.153 15.781 0 66.202 53.667 119.868 119.868 119.868 5.28-.022 10.554-.407 15.782-1.152 29.546 15.924 66.04 10.575 89.775-13.16 23.733-23.733 29.083-60.228 13.158-89.774"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 75.994,
        cy: 76.171,
        r: 75.893,
        fill: "url(#prefix__a)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 179.903,
        cy: 180.08,
        r: 75.893,
        fill: "url(#prefix__b)"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__e",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__c"
    })), /*#__PURE__*/ React.createElement("circle", {
        cx: 125.547,
        cy: 133.578,
        r: 141.812,
        fill: "url(#prefix__d)",
        mask: "url(#prefix__e)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 127.948,
        cy: 128.125,
        r: 119.868,
        fill: "url(#prefix__f)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 127.948,
        cy: 128.125,
        r: 119.868,
        fill: "url(#prefix__g)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M84.239 113.408a34.76 34.76 0 0 1-4.078-17.2 31.12 31.12 0 0 1 7.27-20.746 44.33 44.33 0 0 1 18.973-12.59 73.1 73.1 0 0 1 24.736-4.167 101 101 0 0 1 16.49 1.241 70 70 0 0 1 11.438 2.926 21.9 21.9 0 0 1 8.866 5.763 11.26 11.26 0 0 1 2.837 7.625 11.17 11.17 0 0 1-2.926 8.068 9.57 9.57 0 0 1-7.27 3.014 13.7 13.7 0 0 1-5.497-1.241 103 103 0 0 0-12.856-4.7 46.5 46.5 0 0 0-12.5-1.506 29.26 29.26 0 0 0-15.605 3.9 12.94 12.94 0 0 0-6.206 11.704 11.7 11.7 0 0 0 3.192 8.156 29.8 29.8 0 0 0 8.866 6.295c3.635 1.773 8.866 4.167 16.313 7.182l2.305.886a111.4 111.4 0 0 1 20.126 10.107 40.8 40.8 0 0 1 12.501 12.767 33.6 33.6 0 0 1 4.522 17.732 35.46 35.46 0 0 1-6.295 21.367 36.7 36.7 0 0 1-17.732 12.945 73.5 73.5 0 0 1-26.155 4.255 82.4 82.4 0 0 1-35.464-6.738 20.04 20.04 0 0 1-7.358-5.674 13.48 13.48 0 0 1-2.305-7.802 9.93 9.93 0 0 1 3.103-7.89 11.35 11.35 0 0 1 8.068-2.838 21.2 21.2 0 0 1 9.486 2.394c3.635 1.773 6.472 3.192 8.866 4.078a40 40 0 0 0 7.359 2.305 39.5 39.5 0 0 0 9.487.976 25.18 25.18 0 0 0 15.958-4.256 13.83 13.83 0 0 0 5.408-11.614 12.5 12.5 0 0 0-3.369-8.866 37.9 37.9 0 0 0-9.93-7.27c-4.344-2.306-10.55-5.054-18.44-8.423a118 118 0 0 1-20.304-10.462c-4.796-3.19-8.977-6.727-11.88-11.703"
    }));

const Slack = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2447.6 2452.5",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fillRule: "evenodd",
        clipRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#36c5f0",
        d: "M897.4 0C762.1.1 652.6 109.9 652.7 245.2c-.1 135.3 109.5 245.1 244.8 245.2h244.8V245.3C1142.4 110 1032.8.2 897.4 0q.15 0 0 0m0 654H244.8C109.5 654.1-.1 763.9 0 899.2c-.2 135.3 109.4 245.1 244.7 245.3h652.7c135.3-.1 244.9-109.9 244.8-245.2.1-135.4-109.5-245.2-244.8-245.3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2eb67d",
        d: "M2447.6 899.2c.1-135.3-109.5-245.1-244.8-245.2-135.3.1-244.9 109.9-244.8 245.2v245.3h244.8c135.3-.1 244.9-109.9 244.8-245.3m-652.7 0v-654C1795 110 1685.5.2 1550.2 0c-135.3.1-244.9 109.9-244.8 245.2v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ecb22e",
        d: "M1550.1 2452.5c135.3-.1 244.9-109.9 244.8-245.2.1-135.3-109.5-245.1-244.8-245.2h-244.8v245.2c-.1 135.2 109.5 245 244.8 245.2m0-654.1h652.7c135.3-.1 244.9-109.9 244.8-245.2.2-135.3-109.4-245.1-244.7-245.3h-652.7c-135.3.1-244.9 109.9-244.8 245.2-.1 135.4 109.4 245.2 244.7 245.3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#e01e5a",
        d: "M0 1553.2c-.1 135.3 109.5 245.1 244.8 245.2 135.3-.1 244.9-109.9 244.8-245.2V1308H244.8C109.5 1308.1-.1 1417.9 0 1553.2m652.7 0v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.2v-653.9c.2-135.3-109.4-245.1-244.7-245.3-135.4 0-244.9 109.8-244.8 245.1 0 0 0 .1 0 0"
    })));

const Snapchat = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "147.353 39.286 514.631 514.631",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-260.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56q-.006.13-.014.255c-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008",
        style: {
            fill: "#fffc00"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M407.001 473.488c-1.068 0-2.087-.039-2.862-.076-.615.053-1.25.076-1.886.076-22.437 0-37.439-10.607-50.678-19.973-9.489-6.703-18.438-13.031-28.922-14.775-5.149-.854-10.271-1.287-15.22-1.287-8.917 0-15.964 1.383-21.109 2.389-3.166.617-5.896 1.148-8.006 1.148-2.21 0-4.895-.49-6.014-4.311-.887-3.014-1.523-5.934-2.137-8.746-1.536-7.027-2.65-11.316-5.281-11.723-28.141-4.342-44.768-10.738-48.08-18.484a7.2 7.2 0 0 1-.584-2.443 4.52 4.52 0 0 1 3.777-4.711c22.348-3.68 42.219-15.492 59.064-35.119 13.049-15.195 19.457-29.713 20.145-31.316a3 3 0 0 1 .101-.217c3.247-6.588 3.893-12.281 1.926-16.916-3.626-8.551-15.635-12.361-23.58-14.882-1.976-.625-3.845-1.217-5.334-1.808-7.043-2.782-18.626-8.66-17.083-16.773 1.124-5.916 8.949-10.036 15.273-10.036 1.756 0 3.312.308 4.622.923 7.146 3.348 13.575 5.045 19.104 5.045 6.876 0 10.197-2.618 11-3.362a1171 1171 0 0 0-.679-11.262c-1.614-25.675-3.627-57.627 4.546-75.95 24.462-54.847 76.339-59.112 91.651-59.112a3910 3910 0 0 0 7.582-.071c15.354 0 67.339 4.27 91.816 59.15 8.173 18.335 6.158 50.314 4.539 76.016l-.076 1.23c-.222 3.49-.427 6.793-.6 9.995.756.696 3.795 3.096 9.978 3.339 5.271-.202 11.328-1.891 17.998-5.014 2.062-.968 4.345-1.169 5.895-1.169 2.343 0 4.727.456 6.714 1.285l.106.041c5.66 2.009 9.367 6.024 9.447 10.242.071 3.932-2.851 9.809-17.223 15.485-1.472.583-3.35 1.179-5.334 1.808-7.952 2.524-19.951 6.332-23.577 14.878-1.97 4.635-1.322 10.326 1.926 16.912.036.072.067.145.102.221 1 2.344 25.205 57.535 79.209 66.432a4.523 4.523 0 0 1 3.778 4.711 7.3 7.3 0 0 1-.598 2.465c-3.289 7.703-19.915 14.09-48.064 18.438-2.642.408-3.755 4.678-5.277 11.668-.63 2.887-1.271 5.717-2.146 8.691-.819 2.797-2.641 4.164-5.567 4.164h-.441c-1.905 0-4.604-.346-8.008-1.012-5.95-1.158-12.623-2.236-21.109-2.236-4.948 0-10.069.434-15.224 1.287-10.473 1.744-19.421 8.062-28.893 14.758-13.265 9.379-28.272 19.987-50.707 19.987",
        style: {
            fill: "#fff"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M408.336 124.235c14.455 0 64.231 3.883 87.688 56.472 7.724 17.317 5.744 48.686 4.156 73.885-.248 3.999-.494 7.875-.694 11.576l-.084 1.591 1.062 1.185c.429.476 4.444 4.672 13.374 5.017l.144.008.15-.003c5.904-.225 12.554-2.059 19.776-5.442 1.064-.498 2.48-.741 3.978-.741 1.707 0 3.521.321 5.017.951l.226.09c3.787 1.327 6.464 3.829 6.505 6.093.022 1.28-.935 5.891-14.359 11.194-1.312.518-3.039 1.069-5.041 1.7-8.736 2.774-21.934 6.96-26.376 17.427-2.501 5.896-1.816 12.854 2.034 20.678 1.584 3.697 26.52 59.865 82.631 69.111a2.5 2.5 0 0 1-.229.9c-.951 2.24-6.996 9.979-44.612 15.783-5.886.902-7.328 7.5-9 15.17-.604 2.746-1.218 5.518-2.062 8.381-.258.865-.306.914-1.233.914h-.442c-1.668 0-4.2-.346-7.135-.922-5.345-1.041-12.647-2.318-21.982-2.318-5.21 0-10.577.453-15.962 1.352-11.511 1.914-20.872 8.535-30.786 15.543-13.314 9.408-27.075 19.143-48.071 19.143-.917 0-1.812-.031-2.709-.076l-.236-.01-.237.018q-.77.068-1.564.068c-20.993 0-34.76-9.732-48.068-19.143-9.916-7.008-19.282-13.629-30.791-15.543-5.38-.896-10.752-1.352-15.959-1.352-9.333 0-16.644 1.428-21.978 2.471-2.935.574-5.476 1.066-7.139 1.066-1.362 0-1.388-.08-1.676-1.064-.844-2.865-1.461-5.703-2.062-8.445-1.676-7.678-3.119-14.312-9.002-15.215-37.613-5.809-43.659-13.561-44.613-15.795a2.7 2.7 0 0 1-.231-.918c56.11-9.238 81.041-65.408 82.63-69.119 3.857-7.818 4.541-14.775 2.032-20.678-4.442-10.461-17.638-14.653-26.368-17.422-2.007-.635-3.735-1.187-5.048-1.705-11.336-4.479-14.823-8.991-14.305-11.725.601-3.153 6.067-6.359 10.837-6.359 1.072 0 2.012.173 2.707.498 7.747 3.631 14.819 5.472 21.022 5.472 9.751 0 14.091-4.537 14.557-5.055l1.057-1.182-.085-1.583c-.197-3.699-.44-7.574-.696-11.565-1.583-25.205-3.563-56.553 4.158-73.871 23.37-52.396 72.903-56.435 87.525-56.435.36 0 6.717-.065 6.717-.065.26-.002.549-.006.852-.006m0-9.038h-.017q-.498-.001-.944.004l-6.633.066c-8.566 0-25.705 1.21-44.115 9.336-10.526 4.643-19.994 10.921-28.14 18.66-9.712 9.221-17.624 20.59-23.512 33.796-8.623 19.336-6.576 51.905-4.932 78.078l.006.041c.176 2.803.361 5.73.53 8.582-1.265.581-3.316 1.194-6.339 1.194-4.864 0-10.648-1.555-17.187-4.619-1.924-.896-4.12-1.349-6.543-1.349-3.893 0-7.997 1.146-11.557 3.239-4.479 2.63-7.373 6.347-8.159 10.468-.518 2.726-.493 8.114 5.492 13.578 3.292 3.008 8.128 5.782 14.37 8.249 1.638.645 3.582 1.261 5.641 1.914 7.145 2.271 17.959 5.702 20.779 12.339 1.429 3.365.814 7.793-1.823 13.145-.069.146-.138.289-.201.439-.659 1.539-6.807 15.465-19.418 30.152-7.166 8.352-15.059 15.332-23.447 20.752-10.238 6.617-21.316 10.943-32.923 12.855a9.04 9.04 0 0 0-7.559 9.424c.078 1.33.39 2.656.931 3.939l.013.023c1.843 4.311 6.116 7.973 13.063 11.203 8.489 3.943 21.185 7.26 37.732 9.855.836 1.59 1.704 5.586 2.305 8.322.629 2.908 1.285 5.898 2.22 9.074 1.009 3.441 3.626 7.553 10.349 7.553 2.548 0 5.478-.574 8.871-1.232 4.969-.975 11.764-2.305 20.245-2.305 4.702 0 9.575.414 14.48 1.229 9.455 1.574 17.606 7.332 27.037 14 13.804 9.758 29.429 20.803 53.302 20.803.651 0 1.304-.021 1.949-.066.789.037 1.767.066 2.799.066 23.88 0 39.501-11.049 53.29-20.799l.022-.02c9.433-6.66 17.575-12.41 27.027-13.984 4.903-.814 9.775-1.229 14.479-1.229 8.102 0 14.517 1.033 20.245 2.15 3.738.736 6.643 1.09 8.872 1.09l.218.004h.226c4.917 0 8.53-2.699 9.909-7.422.916-3.109 1.57-6.029 2.215-8.986.562-2.564 1.46-6.674 2.296-8.281 16.558-2.6 29.249-5.91 37.739-9.852 6.931-3.215 11.199-6.873 13.053-11.166.556-1.287.881-2.621.954-3.979a9.036 9.036 0 0 0-7.56-9.424c-51.585-8.502-74.824-61.506-75.785-63.758a7 7 0 0 0-.205-.438c-2.637-5.354-3.246-9.777-1.816-13.148 2.814-6.631 13.621-10.062 20.771-12.332 2.07-.652 4.021-1.272 5.646-1.914 7.039-2.78 12.07-5.796 15.389-9.221 3.964-4.083 4.736-7.995 4.688-10.555-.121-6.194-4.856-11.698-12.388-14.393-2.544-1.052-5.445-1.607-8.399-1.607-2.011 0-4.989.276-7.808 1.592-6.035 2.824-11.441 4.368-16.082 4.588-2.468-.125-4.199-.66-5.32-1.171.141-2.416.297-4.898.458-7.486l.067-1.108c1.653-26.19 3.707-58.784-4.92-78.134-5.913-13.253-13.853-24.651-23.604-33.892-8.178-7.744-17.678-14.021-28.242-18.661-18.384-8.066-35.522-9.271-44.1-9.271",
        style: {
            fill: "#020202"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M147.553 39.443h514.231v514.23H147.553z",
        style: {
            fill: "none"
        }
    }));

const SocketioDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 128,
        cy: 128,
        r: 114,
        fill: "none",
        stroke: "#FFF",
        strokeWidth: 20
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M97.637 121.69c27.327-22.326 54.058-45.426 81.98-67.097-14.646 22.505-29.708 44.711-44.354 67.215-12.562.06-25.123.06-37.626-.119zm23.1 12.442c12.621 0 25.183 0 37.745.179-27.505 22.206-54.117 45.484-82.099 67.096 14.646-22.505 29.708-44.77 44.354-67.275"
    }));

const SocketioLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 128,
        cy: 128,
        r: 114,
        fill: "none",
        stroke: "#010101",
        strokeWidth: 20
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#010101",
        d: "M97.637 121.69c27.327-22.326 54.058-45.426 81.98-67.097-14.646 22.505-29.708 44.711-44.354 67.215-12.562.06-25.123.06-37.626-.119zm23.1 12.442c12.621 0 25.183 0 37.745.179-27.505 22.206-54.117 45.484-82.099 67.096 14.646-22.505 29.708-44.77 44.354-67.275"
    }));

const Solana = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "90.737%",
        x2: "35.509%",
        y1: "34.776%",
        y2: "55.415%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00FFA3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#DC1FFF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "66.588%",
        x2: "11.36%",
        y1: "43.8%",
        y2: "64.439%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00FFA3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#DC1FFF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "78.586%",
        x2: "23.358%",
        y1: "39.317%",
        y2: "59.956%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#00FFA3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#DC1FFF"
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 18,
        cy: 18,
        r: 18,
        fill: "#181E33"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M3.9 14.355a.79.79 0 0 1 .554-.23h19.153c.35 0 .525.423.277.67l-3.783 3.784a.79.79 0 0 1-.555.23H.393a.392.392 0 0 1-.277-.67z",
        transform: "translate(6 9)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M3.9.23A.8.8 0 0 1 4.454 0h19.153c.35 0 .525.422.277.67l-3.783 3.783a.79.79 0 0 1-.555.23H.393a.392.392 0 0 1-.277-.67z",
        transform: "translate(6 9)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M20.1 7.247a.79.79 0 0 0-.554-.23H.393a.392.392 0 0 0-.277.67l3.783 3.784c.145.145.344.23.555.23h19.153c.35 0 .525-.423.277-.67z",
        transform: "translate(6 9)"
    })));

const Solidity = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 1300 1300",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M773.772 253.308 643.068 485.61H381.842l130.614-232.302z",
        opacity: 0.45
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M643.068 485.61h261.318L773.772 253.308H512.456z",
        opacity: 0.6
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M512.456 717.822 643.068 485.61 512.456 253.308 381.842 485.61z",
        opacity: 0.8
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m513.721 1066.275 130.704-232.303h261.318l-130.705 232.303z",
        opacity: 0.45
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M644.424 833.973H383.107l130.613 232.303h261.317z",
        opacity: 0.6
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M775.038 601.761 644.424 833.973l130.614 232.303 130.704-232.303z",
        opacity: 0.8
    }));

const Solidjs = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 239",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "-5.859%",
        x2: "91.406%",
        y1: "38.27%",
        y2: "60.924%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "10%",
        stopColor: "#76B3E1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "30%",
        stopColor: "#DCF2FD"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#76B3E1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "56.996%",
        x2: "37.941%",
        y1: "38.44%",
        y2: "68.375%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#76B3E1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "50%",
        stopColor: "#4377BB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#1F3B77"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "10.709%",
        x2: "104.337%",
        y1: "34.532%",
        y2: "70.454%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#315AA9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "50%",
        stopColor: "#518AC8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#315AA9"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "61.993%",
        x2: "17.762%",
        y1: "29.58%",
        y2: "105.119%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#4377BB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "50%",
        stopColor: "#1A336B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#1A336B"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#76B3E1",
        d: "M256 50.473S170.667-12.32 104.654 2.17l-4.83 1.61c-9.66 3.22-17.71 8.05-22.541 14.49l-3.22 4.83-24.151 41.862 41.862 8.05c17.71 11.271 40.251 16.101 61.182 11.271l74.063 14.49z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M256 50.473S170.667-12.32 104.654 2.17l-4.83 1.61c-9.66 3.22-17.71 8.05-22.541 14.49l-3.22 4.83-24.151 41.862 41.862 8.05c17.71 11.271 40.251 16.101 61.182 11.271l74.063 14.49z",
        opacity: 0.3
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#518AC8",
        d: "m77.283 50.473-6.44 1.61c-27.371 8.05-35.422 33.811-20.931 56.352 16.1 20.931 49.912 32.201 77.283 24.151l99.824-33.811S141.686 35.982 77.283 50.473"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "m77.283 50.473-6.44 1.61c-27.371 8.05-35.422 33.811-20.931 56.352 16.1 20.931 49.912 32.201 77.283 24.151l99.824-33.811S141.686 35.982 77.283 50.473",
        opacity: 0.3
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M209.308 122.926c-18.44-23.037-49.007-32.59-77.283-24.151l-99.824 32.201L0 187.328l180.327 30.591 32.201-57.962c6.44-11.27 4.83-24.15-3.22-37.031"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M177.107 179.278c-18.44-23.037-49.008-32.59-77.283-24.151L0 187.328s85.333 64.403 151.346 48.302l4.83-1.61c27.371-8.05 37.032-33.811 20.93-54.742Z"
    }));

const SoundCloudDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 75 33.51",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#fff",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M75 23.6a10.5 10.5 0 0 1-10.63 9.91H38.82a2.14 2.14 0 0 1-2.12-2.13V3.87a2.34 2.34 0 0 1 1.41-2.24S40.46 0 45.41 0A16.74 16.74 0 0 1 54 2.36a17 17 0 0 1 8 11.08 9.8 9.8 0 0 1 2.71-.37A10.23 10.23 0 0 1 75 23.6M33.51 5.61a.83.83 0 1 0-1.65 0c-.7 9.25-1.24 17.92 0 27.14a.83.83 0 0 0 1.65 0c1.33-9.3.77-17.81 0-27.14M28.35 8.81a.87.87 0 0 0-1.73 0 103.7 103.7 0 0 0 0 23.95.87.87 0 0 0 1.72 0 93.2 93.2 0 0 0 .01-23.95M23.16 8a.84.84 0 0 0-1.67 0c-.79 8.44-1.19 16.32 0 24.74a.83.83 0 0 0 1.66 0c1.23-8.53.85-16.19.01-24.74M18 10.41a.86.86 0 0 0-1.72 0 87.6 87.6 0 0 0 0 22.36.85.85 0 0 0 1.69 0A81.7 81.7 0 0 0 18 10.41M12.79 16a.85.85 0 0 0-1.7 0c-1.23 5.76-.65 11 .05 16.83a.81.81 0 0 0 1.6 0c.77-5.91 1.36-11.03.05-16.83M7.62 15.12a.88.88 0 0 0-1.75 0C4.78 21 5.14 26.18 5.9 32.05c.08.89 1.59.88 1.69 0 .84-5.96 1.23-10.99.03-16.93M2.4 18a.88.88 0 0 0-1.75 0c-1 3.95-.69 7.22.07 11.18a.82.82 0 0 0 1.63 0c.88-4.04 1.31-7.24.05-11.18"
    })));

const SoundCloudLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 75 33.51",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M75 23.6a10.5 10.5 0 0 1-10.63 9.91H38.82a2.14 2.14 0 0 1-2.12-2.13V3.87a2.34 2.34 0 0 1 1.41-2.24S40.46 0 45.41 0A16.74 16.74 0 0 1 54 2.36a17 17 0 0 1 8 11.08 9.8 9.8 0 0 1 2.71-.37A10.23 10.23 0 0 1 75 23.6M33.51 5.61a.83.83 0 1 0-1.65 0c-.7 9.25-1.24 17.92 0 27.14a.83.83 0 0 0 1.65 0c1.33-9.3.77-17.81 0-27.14m-5.16 3.2a.87.87 0 0 0-1.73 0 103.7 103.7 0 0 0 0 23.95.87.87 0 0 0 1.72 0 93.2 93.2 0 0 0 .01-23.95M23.16 8a.84.84 0 0 0-1.67 0c-.79 8.44-1.19 16.32 0 24.74a.83.83 0 0 0 1.66 0c1.23-8.53.85-16.19.01-24.74M18 10.41a.86.86 0 0 0-1.72 0 87.6 87.6 0 0 0 0 22.36.85.85 0 0 0 1.69 0A81.7 81.7 0 0 0 18 10.41M12.79 16a.85.85 0 0 0-1.7 0c-1.23 5.76-.65 11 .05 16.83a.81.81 0 0 0 1.6 0c.77-5.91 1.36-11.03.05-16.83m-5.17-.88a.88.88 0 0 0-1.75 0C4.78 21 5.14 26.18 5.9 32.05c.08.89 1.59.88 1.69 0 .84-5.96 1.23-10.99.03-16.93M2.4 18a.88.88 0 0 0-1.75 0c-1 3.95-.69 7.22.07 11.18a.82.82 0 0 0 1.63 0c.88-4.04 1.31-7.24.05-11.18",
        "data-name": "Layer 2"
    }));

const Sourcegraph = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "-3 0 262 262",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F96316",
        d: "m74.203 33.602 56.952 208.194c3.827 13.991 18.27 22.23 32.254 18.4 13.993-3.833 22.224-18.28 18.394-32.27l-56.962-208.2c-3.83-13.987-18.27-22.228-32.254-18.394C78.607 5.157 70.373 19.609 74.203 33.6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B200F8",
        d: "M179.662 32.813 37.046 193.858c-9.621 10.86-8.616 27.464 2.233 37.087 10.85 9.62 27.438 8.617 37.059-2.238L218.954 67.665c9.621-10.86 8.616-27.459-2.233-37.083-10.854-9.63-27.446-8.624-37.059 2.23z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00B4F2",
        d: "m18.065 122.054 203.387 67.293c13.765 4.552 28.615-2.92 33.167-16.696 4.562-13.774-2.911-28.63-16.681-33.189L34.556 72.175C20.786 67.62 5.942 75.091 1.387 88.867c-4.55 13.775 2.924 28.635 16.682 33.187z"
    }));

const Spinnaker = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 297",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "82.2%",
        x2: "34.6%",
        y1: "6%",
        y2: "106.1%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2B3990"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "16%",
        stopColor: "#1E62A7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "32%",
        stopColor: "#1485BC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "49%",
        stopColor: "#0BA1CC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "66%",
        stopColor: "#05B4D7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "83%",
        stopColor: "#01C0DE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#00C4E0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "-31668%",
        x2: "-19806%",
        y1: "78954%",
        y2: "78954%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2B3990"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "16%",
        stopColor: "#1E62A7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "32%",
        stopColor: "#1485BC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "49%",
        stopColor: "#0BA1CC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "66%",
        stopColor: "#05B4D7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "83%",
        stopColor: "#01C0DE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#00C4E0"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M22 218.3c98.8 9.8 178.2-48.6 198-73.7C239.8 119.6 209.8 0 209.8 0 177.2 80 118 201.1 21.9 218.4Z",
        style: {
            mixBlendMode: "multiply"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M67.7 186.4C126 188.6 170.4 152 181 136.7c10.7-15.2-5.7-83.7-5.7-83.7-16.2 47.5-61.3 116.6-107.7 133.4Z",
        style: {
            mixBlendMode: "multiply"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#149CB5",
        d: "M3.8 270a21 21 0 0 0 6.3 4.4c2.4 1.1 5 1.7 7.6 1.7a12 12 0 0 0 7.7-2.2 7.1 7.1 0 0 0 2.8-5.9 7 7 0 0 0-2.4-5.5c-.8-.6-1.7-1.2-2.7-1.6l-3.2-1.6-7.2-3c-1.3-.6-2.5-1.2-3.6-1.9-1.2-.7-2.3-1.6-3.3-2.6s-1.8-2.2-2.4-3.5A12.4 12.4 0 0 1 7 234c1.4-1.2 3.1-2.1 5-2.7a20.4 20.4 0 0 1 21.1 5.1l-3.5 4a15.4 15.4 0 0 0-11.4-4.7 11 11 0 0 0-6.8 2 6.3 6.3 0 0 0-2.6 5.4c0 1 .3 2 .8 3 .5.8 1.2 1.6 2 2.1a50 50 0 0 0 5.7 3l7 3 4.2 2.1c1.2.8 2.3 1.7 3.3 2.8a11.8 11.8 0 0 1 3 8.4 12.9 12.9 0 0 1-4.7 9.9 16.3 16.3 0 0 1-5.3 3A24.4 24.4 0 0 1 0 274.3l3.8-4.4Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#149CB5",
        d: "M40.8 283.9v12.3h-6v-52h5l.4 4.1h.3a27 27 0 0 1 5.3-3.6 13.4 13.4 0 0 1 12.1-.1c1.7.8 3.2 2.1 4.4 3.7a18 18 0 0 1 2.6 6 30 30 0 0 1-.3 16c-.8 2.2-1.9 4.4-3.4 6.2a14.3 14.3 0 0 1-10.7 5.2c-1.8 0-3.4-.4-5-1-1.7-1-3.4-2-5-3.2zm0-11.3c1.3 1.3 3 2.3 4.6 3 1.3.5 2.7.8 4 .9 1.4 0 2.8-.4 4-1a9.8 9.8 0 0 0 3.3-3q1.5-1.95 2.1-4.5a27.4 27.4 0 0 0 .3-11.6c-.3-1.4-.9-2.9-1.7-4.2a8 8 0 0 0-7.2-3.7c-1.6 0-3.2.5-4.6 1.3-1.7 1-3.4 2.3-4.9 3.7v19.1Zm31.4-36.2c-1.2 0-2.3-.4-3.2-1.1a3.8 3.8 0 0 1-1.3-2.8c0-1.1.4-2.1 1.3-2.9a5.5 5.5 0 0 1 6.5 0c.8.8 1.3 1.8 1.3 2.9 0 1-.5 2-1.3 2.8-1 .7-2 1.1-3.3 1.1m-3.3 7.4h6.5v36H69v-36Zm11.6.2h5.1l.5 5.2h.3c1.6-1.6 3.4-3 5.4-4.3 2-1.2 4.4-1.8 6.8-1.7 3.8 0 6.6 1.2 8.4 3.5q2.7 3.6 2.7 10.5v22.6h-6.1V258c0-3.4-.6-5.8-1.7-7.3a6 6 0 0 0-5.2-2.3 9 9 0 0 0-5 1.4 32.3 32.3 0 0 0-5 4.1v25.9h-6l-.2-35.7Zm32.9 0h5l.6 5.2h.2c1.7-1.6 3.5-3 5.5-4.3 2-1.2 4.4-1.8 6.8-1.7 3.8 0 6.6 1.2 8.4 3.5q2.7 3.6 2.7 10.5v22.6h-6.2V258c0-3.4-.6-5.8-1.7-7.3a6 6 0 0 0-5.2-2.3c-1.8 0-3.6.5-5 1.4a32.4 32.4 0 0 0-5 4.1v25.9h-6.1zm32.9 27.2c0-3.9 2-7.4 5.5-9.2a46 46 0 0 1 17.4-4.5c0-1.1 0-2.3-.3-3.4a8 8 0 0 0-1.2-3 6.6 6.6 0 0 0-2.4-2 7.8 7.8 0 0 0-3.7-.8c-2.1 0-4.2.4-6.1 1.2-1.8.8-3.5 1.7-5 2.7l-2.6-4.2a41 41 0 0 1 6.4-3.2c2.6-1.1 5.4-1.6 8.3-1.6 4.5 0 7.8 1.4 9.9 4 2.1 3.3 3.2 7.1 3 11v22.5h-5.2l-.5-4.4h-.2a31 31 0 0 1-5.7 3.7c-2 1-4.3 1.6-6.6 1.6-2.9 0-5.7-.9-7.8-2.7a9.7 9.7 0 0 1-3.2-7.7m6.2-.4c-.2 1.7.5 3.4 1.9 4.5 1.3 1 3 1.4 4.6 1.3a11 11 0 0 0 5.1-1.2c1.8-1 3.6-2.2 5.1-3.7v-10.1c-2.7.3-5.3.8-7.9 1.4a21 21 0 0 0-5.2 2c-1 .6-2 1.5-2.7 2.5q-.9 1.5-.9 3.3m24.9-44.1h6.2v36h.2l15.9-19.1h7l-12.5 14.5 14.3 21.7h-7l-10.9-17.5-6.9 7.9v9.5h-6.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#149CB5",
        d: "M203 262.6c0-2.8.4-5.6 1.3-8.2a19 19 0 0 1 3.7-6 16 16 0 0 1 11.4-5.2c2.1 0 4.3.4 6.2 1.2 1.8.8 3.4 2 4.6 3.5 1.3 1.6 2.3 3.4 2.9 5.4a23.8 23.8 0 0 1 .7 10.5h-24.7c0 3.4 1.4 6.8 3.7 9.4 2.2 2.3 5.3 3.5 8.6 3.4 1.6 0 3.3-.2 4.8-.8 1.5-.5 3-1.2 4.3-2l2.2 4c-1.7 1-3.5 2-5.4 2.7a18.7 18.7 0 0 1-19.2-4c-1.6-1.7-2.9-3.8-3.7-6-1-2.5-1.4-5.2-1.4-8Zm25.7-2.8c0-3.8-.8-6.7-2.4-8.6a8 8 0 0 0-6.7-3 9 9 0 0 0-3.7.8c-1.3.5-2.3 1.3-3.3 2.2a12 12 0 0 0-2.3 3.6c-.7 1.6-1.1 3.3-1.3 5zm7.2-15.8h5.1l.5 6.5h.3c1-2 2.6-3.9 4.5-5.3a9.9 9.9 0 0 1 9.7-1.3l-1.2 5.3-1.7-.4a8.2 8.2 0 0 0-6.7 1.7c-2 1.7-3.5 4-4.4 6.4v22.9h-6V244Z"
    }));

const Spotify = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1ED760",
        d: "M128 0C57.308 0 0 57.309 0 128c0 70.696 57.309 128 128 128 70.697 0 128-57.304 128-128C256 57.314 198.697.007 127.998.007l.001-.006Zm58.699 184.614c-2.293 3.76-7.215 4.952-10.975 2.644-30.053-18.357-67.885-22.515-112.44-12.335a7.98 7.98 0 0 1-9.552-6.007 7.97 7.97 0 0 1 6-9.553c48.76-11.14 90.583-6.344 124.323 14.276 3.76 2.308 4.952 7.215 2.644 10.975m15.667-34.853c-2.89 4.695-9.034 6.178-13.726 3.289-34.406-21.148-86.853-27.273-127.548-14.92-5.278 1.594-10.852-1.38-12.454-6.649-1.59-5.278 1.386-10.842 6.655-12.446 46.485-14.106 104.275-7.273 143.787 17.007 4.692 2.89 6.175 9.034 3.286 13.72zm1.345-36.293C162.457 88.964 94.394 86.71 55.007 98.666c-6.325 1.918-13.014-1.653-14.93-7.978-1.917-6.328 1.65-13.012 7.98-14.935C93.27 62.027 168.434 64.68 215.929 92.876c5.702 3.376 7.566 10.724 4.188 16.405-3.362 5.69-10.73 7.565-16.4 4.187z"
    }));

const Spring = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#68bd45",
        d: "M58.2 3.365a29.5 29.5 0 0 1-3.419 6.064A32.094 32.094 0 1 0 9.965 55.372l1.186 1.047a32.08 32.08 0 0 0 52.67-22.253c.875-8.17-1.524-18.51-5.62-30.8zM14.53 55.558a2.744 2.744 0 1 1-.404-3.857 2.744 2.744 0 0 1 .404 3.857m43.538-9.61c-7.92 10.55-24.83 6.99-35.672 7.502 0 0-1.922.113-3.857.43 0 0 .73-.31 1.663-.663 7.614-2.65 11.213-3.16 15.838-5.54 8.708-4.427 17.322-14.122 19.112-24.2-3.313 9.695-13.373 18.032-22.53 21.418-6.276 2.313-17.614 4.566-17.614 4.566l-.457-.245c-7.714-3.75-7.952-20.457 6.077-25.845 6.143-2.366 12.02-1.067 18.654-2.65 7.084-1.683 15.28-6.99 18.615-13.916 3.73 11.08 8.224 28.422.166 39.15z"
    }));

const StabilityAI = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 213",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#9D39FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#A380FF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M72.418 212.45c49.478 0 81.658-26.205 81.658-65.626 0-30.572-19.572-49.998-54.569-58.043l-22.469-6.74c-19.71-4.424-31.215-9.738-28.505-23.312 2.255-11.292 9.002-17.667 24.69-17.667 49.872 0 68.35 17.667 68.35 17.667V16.237S123.583 0 73.223 0C25.757 0 0 24.424 0 62.236c0 30.571 17.85 48.35 54.052 56.798q3.802.95 3.885.976 8.26 2.556 22.293 6.755c18.504 4.425 23.262 9.121 23.262 23.2 0 12.872-13.374 20.19-31.074 20.19C21.432 170.154 0 144.36 0 144.36v47.078s13.402 21.01 72.418 21.01Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E80000",
        d: "M225.442 209.266c17.515 0 30.558-12.67 30.558-29.812 0-17.515-12.67-29.813-30.558-29.813-17.515 0-30.185 12.298-30.185 29.813s12.67 29.812 30.185 29.812"
    }));

const StackOverflow = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 169.61 200",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#bcbbbb",
        d: "M140.44 178.38v-48.65h21.61V200H0v-70.27h21.61v48.65z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#f48024",
        d: "m124.24 140.54 4.32-16.22-86.97-17.83-3.78 17.83zM49.7 82.16 130.72 120l7.56-16.22-81.02-37.83zm22.68-40 68.06 57.3 11.35-13.51-68.6-57.3-11.35 13.51zM116.14 0l-14.59 10.81 53.48 71.89 14.58-10.81zM37.81 162.16h86.43v-16.21H37.81z"
    }));

const Stackblitz = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 368",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#49A2F8",
        d: "M109.586 217.013H0L200.34 0l-53.926 150.233H256L55.645 367.246l53.927-150.233z"
    }));

const StatelyaiDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1000 405",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M219.76 136.638c12.601 0 22.817-10.216 22.817-22.819S232.361 91 219.759 91s-22.819 10.217-22.819 22.819c0 12.603 10.216 22.819 22.82 22.819m55.282 77.561v-.019L151.863 91c-17.822 17.823-17.722 46.619.1 64.442l39.2 39.199-.066.067 22.215 22.214c.807.807 1.341 1.921 1.341 3.152 0 1.265-.59 2.386-1.437 3.197l-25.91 25.91a4.44 4.44 0 0 1-6.277 0l-25.993-25.993a4.44 4.44 0 0 1 0-6.278c17.734-18.925 4.497-41.58-3.696-49.255l-5.795-5.795L93.6 213.805a8.88 8.88 0 0 0 0 12.555l84.257 84.257a8.876 8.876 0 0 0 12.554 0l84.077-84.077a8.4 8.4 0 0 0 2.987-6.426c0-2.306-.93-4.395-2.433-5.915m116.601-18.979c-20.552-2.691-24.019-6.909-24.019-15.345 0-8.552 7.934-13.864 20.706-13.864 14.076 0 21.077 4.579 23.41 15.312l.072.332h11.858l-.06-.48c-2.016-15.886-14.545-24.635-35.28-24.635-19.13 0-33.015 10.228-33.015 24.321 0 17.686 16.456 22.317 34.235 24.686 18.518 2.603 24.164 6.447 24.164 16.454 0 9.39-9.543 16.205-22.69 16.205-20.702 0-24.914-9.122-26.382-18.979l-.054-.361h-12.73l.06.478c1.584 12.926 9.655 28.334 39.105 28.334 20.196 0 35.425-11.357 35.425-26.416 0-17.725-13.317-23.106-34.805-26.042m118.991-37.573H438.51v11.295h29.483v77.627h13.158v-77.627h29.483zm27.749 53.349 16.117-42.908 16.117 42.908zm8.326-53.349-35.206 88.922h12.518l9.781-25.374h41.255l9.922 25.374h13.081l-34.634-88.922H546.71Zm53.18 11.295h29.483v77.627h13.158v-77.627h29.483v-11.295h-72.124zm104.48 38.557h24.97v-11.174h-24.97v-27.383h49.202v-11.295h-62.362v88.922h62.362v-11.295h-49.202zm83.713-49.852h-13.158v88.922h59.51v-11.295h-46.352zm107.175 0-25.295 40.544-26.278-40.544h-14.907l34.258 50.2v38.722h13.159v-38.605l32.39-50.317z"
    }));

const StatelyaiLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1000 405",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1A1919",
        fillRule: "evenodd",
        d: "M219.76 136.638c12.601 0 22.817-10.216 22.817-22.819S232.361 91 219.759 91s-22.819 10.217-22.819 22.819c0 12.603 10.216 22.819 22.82 22.819m55.282 77.561v-.019L151.863 91c-17.822 17.823-17.722 46.619.1 64.442l39.2 39.199-.066.067 22.215 22.214c.807.807 1.341 1.921 1.341 3.152 0 1.265-.59 2.386-1.437 3.197l-25.91 25.91a4.44 4.44 0 0 1-6.277 0l-25.993-25.993a4.44 4.44 0 0 1 0-6.278c17.734-18.925 4.497-41.58-3.696-49.255l-5.795-5.795L93.6 213.805a8.88 8.88 0 0 0 0 12.555l84.257 84.257a8.876 8.876 0 0 0 12.554 0l84.077-84.077a8.4 8.4 0 0 0 2.987-6.426c0-2.306-.93-4.395-2.433-5.915m116.601-18.979c-20.552-2.691-24.019-6.909-24.019-15.345 0-8.552 7.934-13.864 20.706-13.864 14.076 0 21.077 4.579 23.41 15.312l.072.332h11.858l-.06-.48c-2.016-15.886-14.545-24.635-35.28-24.635-19.13 0-33.015 10.228-33.015 24.321 0 17.686 16.456 22.317 34.235 24.686 18.518 2.603 24.164 6.447 24.164 16.454 0 9.39-9.543 16.205-22.69 16.205-20.702 0-24.914-9.122-26.382-18.979l-.054-.361h-12.73l.06.478c1.584 12.926 9.655 28.334 39.105 28.334 20.196 0 35.425-11.357 35.425-26.416 0-17.725-13.317-23.106-34.805-26.042m118.991-37.573H438.51v11.295h29.483v77.627h13.158v-77.627h29.483zm27.749 53.349 16.117-42.908 16.117 42.908zm8.326-53.349-35.206 88.922h12.518l9.781-25.374h41.255l9.922 25.374h13.081l-34.634-88.922H546.71Zm53.18 11.295h29.483v77.627h13.158v-77.627h29.483v-11.295h-72.124zm104.48 38.557h24.97v-11.174h-24.97v-27.383h49.202v-11.295h-62.362v88.922h62.362v-11.295h-49.202zm83.713-49.852h-13.158v88.922h59.51v-11.295h-46.352zm107.175 0-25.295 40.544-26.278-40.544h-14.907l34.258 50.2v38.722h13.159v-38.605l32.39-50.317z"
    }));

const Steam = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        fill: "#fff",
        viewBox: "0 0 65 65",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        x: 0.5,
        y: 0.5
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#111d2e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "21.2%",
        stopColor: "#051839"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "40.7%",
        stopColor: "#0a1b48"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "58.1%",
        stopColor: "#132e62"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "73.8%",
        stopColor: "#144b7e"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "87.3%",
        stopColor: "#136497"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#1387b8"
    }))), /*#__PURE__*/ React.createElement("symbol", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M1.305 41.202C5.259 54.386 17.488 64 31.959 64c17.673 0 32-14.327 32-32s-14.327-32-32-32C15.001 0 1.124 13.193.028 29.874c2.074 3.477 2.879 5.628 1.275 11.328z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m30.31 23.985.003.158-7.83 11.375a8.8 8.8 0 0 0-3.748.662 8 8 0 0 0-1.498.8L.042 29.893s-.398 6.546 1.26 11.424l12.156 5.016a8.84 8.84 0 0 0 5.242 6.27 8.88 8.88 0 0 0 11.603-4.782 8.9 8.9 0 0 0 .684-3.656L42.18 36.16l.275.005c6.705 0 12.155-5.466 12.155-12.18s-5.44-12.16-12.155-12.174c-6.702 0-12.155 5.46-12.155 12.174zm-1.88 23.05a6.844 6.844 0 0 1-8.953 3.694 6.84 6.84 0 0 1-3.524-3.362l3.957 1.64a5.04 5.04 0 0 0 6.591-2.719 5.05 5.05 0 0 0-2.715-6.601l-4.1-1.695a6.8 6.8 0 0 1 5.05.077c1.7.703 3 2.027 3.696 3.72s.692 3.56-.01 5.246M42.466 32.1a8.12 8.12 0 0 1-8.098-8.113 8.12 8.12 0 0 1 8.098-8.111 8.12 8.12 0 0 1 8.1 8.111 8.12 8.12 0 0 1-8.1 8.113m-6.068-8.126a6.09 6.09 0 0 1 6.08-6.095c3.355 0 6.084 2.73 6.084 6.095a6.09 6.09 0 0 1-6.084 6.093 6.09 6.09 0 0 1-6.081-6.093z"
    })));

const Stimulus = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#77E8B9",
        d: "M256 143.19v45.183h-52.693a32.3 32.3 0 0 1-12.726-3.17l-1.312-.67-12.8-7.424a13.95 13.95 0 0 0-11.987-.387l-.813.387-16.384 9.6a4.267 4.267 0 0 0-.462 7.37l.462.268 34.475 20.224a32.1 32.1 0 0 0 12.53 3.748l1.465.092H256v30.122a7.553 7.553 0 0 1-6.865 7.436l-.644.031H7.509a7.553 7.553 0 0 1-7.465-6.703L0 248.66v-30.12h60.075a32.1 32.1 0 0 0 12.687-3.171l1.307-.67 115.2-67.669a32.9 32.9 0 0 1 12.57-3.742l1.468-.098zm0-75.435v45.184h-60.075a32.7 32.7 0 0 0-12.685 3.176l-1.31.664-115.2 67.712a32.9 32.9 0 0 1-12.568 3.742l-1.469.098H0v-45.184h60.075a32.7 32.7 0 0 0 12.685-3.177l1.31-.663 115.2-67.712a32.9 32.9 0 0 1 12.568-3.743l1.469-.097zM248.49 0a7.51 7.51 0 0 1 7.472 6.742l.038.64v30.122h-60.075a32.1 32.1 0 0 0-12.687 3.171l-1.307.669-115.2 67.67a32.3 32.3 0 0 1-12.568 3.747l-1.47.092H0V67.67h52.693a32.9 32.9 0 0 1 12.724 3.177l1.314.663 12.8 7.467a13.95 13.95 0 0 0 11.987.387l.813-.387 16.384-9.643a4.267 4.267 0 0 0 .455-7.325L74.24 41.472a32.7 32.7 0 0 0-12.53-3.743l-1.465-.097H0V7.509A7.51 7.51 0 0 1 6.893.025L7.51 0h240.982Z"
    }));

const Storyblok = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 302",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0AB3AF",
        d: "m244.495 0-.274.292c7.15 0 11.524 5.54 11.768 12.32l.011.6v230.552c0 7.12-4.156 11.473-10.852 11.73l-.635.013H89.558l-42.423 45.82v-46.112H12.966c-6.868 0-12.619-4.146-12.95-10.844L0 243.755V12.921C0 6.067 5.567.327 12.648.013l.61-.013zm-78.93 46.989H47.135v164.47H151.43c7.954 0 15.615-1.47 22.682-3.233 6.605-1.364 12.43-4.278 17.729-7.519l1.127-.699a35.55 35.55 0 0 0 12.08-11.94l.585-.99h-.302c2.94-5.277 4.42-11.45 4.42-18.792 0-11.45-2.657-20.563-7.962-27.612-5.589-6.748-12.957-11.45-22.38-14.09a36.78 36.78 0 0 0 17.668-15.86c3.835-7.05 5.899-14.39 5.899-22.024a43.97 43.97 0 0 0-10.017-28.49c-3.242-3.825-7.369-7.049-11.78-9.404-4.405-2.463-9.058-3.654-14.447-3.801zm-16.929 91.923c3.406 0 5.963 1.662 8.237 4.447a16.4 16.4 0 0 1 3.122 9.998c0 4.164-1.424 7.497-3.689 9.725-2.374 2.06-5.236 3.404-8.36 3.586l-.725.02H89.604v-27.776zm-4.82-55.563a11.5 11.5 0 0 1 7.377 2.776c1.99 1.945 3.123 5.004 3.123 9.167 0 4.459-1.01 7.932-3.276 9.704l-.413.295c-2.099 1.542-4.68 2.844-7.291 3.035l-.653.024H89.595V83.349h54.22Z"
    }));

const Storybook = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 319",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M9.872 293.324.012 30.574C-.315 21.895 6.338 14.54 15.005 14L238.494.032c8.822-.552 16.42 6.153 16.972 14.975q.03.498.031.998v286.314c0 8.839-7.165 16.004-16.004 16.004q-.36 0-.718-.016l-213.627-9.595c-8.32-.373-14.963-7.065-15.276-15.388"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        fill: "#FF4785"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m188.665 39.127 1.527-36.716L220.884 0l1.322 37.863a2.387 2.387 0 0 1-3.864 1.96l-11.835-9.325-14.013 10.63a2.387 2.387 0 0 1-3.829-2.001m-39.251 80.853c0 6.227 41.942 3.243 47.572-1.131 0-42.402-22.752-64.684-64.415-64.684-41.662 0-65.005 22.628-65.005 56.57 0 59.117 79.78 60.249 79.78 92.494 0 9.052-4.433 14.426-14.184 14.426-12.705 0-17.729-6.49-17.138-28.552 0-4.786-48.458-6.278-49.936 0-3.762 53.466 29.548 68.887 67.665 68.887 36.935 0 65.892-19.687 65.892-55.326 0-63.36-80.961-61.663-80.961-93.06 0-12.728 9.455-14.425 15.07-14.425 5.909 0 16.546 1.042 15.66 24.801",
        mask: "url(#prefix__b)"
    }));

const Strapi = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#4945FF",
        d: "M0 88.747c0-41.836 0-62.754 12.997-75.75S46.91 0 88.747 0h78.507c41.835 0 62.752 0 75.75 12.997C256 25.993 256 46.91 256 88.747v78.507c0 41.835 0 62.752-12.997 75.75C230.006 256 209.09 256 167.253 256H88.748c-41.836 0-62.754 0-75.75-12.997C0 230.006 0 209.09 0 167.253V88.748Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M176.64 77.653H90.453V121.6H134.4v43.946h43.946V79.36c0-.943-.764-1.707-1.706-1.707"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M132.693 121.6h1.707v1.707h-1.707z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9593FF",
        d: "M90.453 121.6h42.24c.943 0 1.707.764 1.707 1.706v42.24H92.16a1.706 1.706 0 0 1-1.707-1.706zm43.947 43.946h43.946l-42.49 42.49c-.537.538-1.456.157-1.456-.602zM90.453 121.6H48.566c-.76 0-1.14-.92-.603-1.457l42.49-42.49z"
    }));

const Stripe = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 214",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#635BFF",
        d: "M512 110.08c0-36.409-17.636-65.138-51.342-65.138-33.85 0-54.33 28.73-54.33 64.854 0 42.808 24.179 64.426 58.88 64.426 16.925 0 29.725-3.84 39.396-9.244v-28.445c-9.67 4.836-20.764 7.823-34.844 7.823-13.796 0-26.027-4.836-27.591-21.618h69.547c0-1.85.284-9.245.284-12.658m-70.258-13.511c0-16.071 9.814-22.756 18.774-22.756 8.675 0 17.92 6.685 17.92 22.756zm-90.31-51.627c-13.939 0-22.899 6.542-27.876 11.094l-1.85-8.818h-31.288v165.83l35.555-7.537.143-40.249c5.12 3.698 12.657 8.96 25.173 8.96 25.458 0 48.64-20.48 48.64-65.564-.142-41.245-23.609-63.716-48.498-63.716m-8.534 97.991c-8.391 0-13.37-2.986-16.782-6.684l-.143-52.765c3.698-4.124 8.818-6.968 16.925-6.968 12.942 0 21.902 14.506 21.902 33.137 0 19.058-8.818 33.28-21.902 33.28M241.493 36.551l35.698-7.68V0l-35.698 7.538zm0 10.809h35.698v124.444h-35.698zm-38.257 10.524L200.96 47.36h-30.72v124.444h35.556V87.467c8.39-10.951 22.613-8.96 27.022-7.396V47.36c-4.551-1.707-21.191-4.836-29.582 10.524m-71.112-41.386-34.702 7.395-.142 113.92c0 21.05 15.787 36.551 36.836 36.551 11.662 0 20.195-2.133 24.888-4.693V140.8c-4.55 1.849-27.022 8.391-27.022-12.658V77.653h27.022V47.36h-27.022zM35.982 83.484c0-5.546 4.551-7.68 12.09-7.68 10.808 0 24.461 3.272 35.27 9.103V51.484c-11.804-4.693-23.466-6.542-35.27-6.542C19.2 44.942 0 60.018 0 85.192c0 39.252 54.044 32.995 54.044 49.92 0 6.541-5.688 8.675-13.653 8.675-11.804 0-26.88-4.836-38.827-11.378v33.849c13.227 5.689 26.596 8.106 38.827 8.106 29.582 0 49.92-14.648 49.92-40.106-.142-42.382-54.329-34.845-54.329-50.774"
    }));

const StyledComponents = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 318 318",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M0 0h318v318H0z"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__b",
        width: 318,
        height: 318,
        x: 0,
        y: 0,
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a"
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        stroke: "#4a4a4a",
        strokeWidth: 8,
        mask: "url(#prefix__b)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4a4a4a",
        d: "M44.284 229.416c-4.428 0-7.344 2.376-7.344 5.544 0 2.808 1.728 4.68 5.652 5.76 3.564 1.008 4.32 1.512 4.32 3.096 0 1.44-1.332 2.304-3.384 2.304-1.944 0-3.708-.756-5.184-1.872l-2.304 2.592c1.764 1.584 4.32 2.7 7.596 2.7 4.356 0 8.028-2.088 8.028-6.048 0-3.384-2.196-4.968-6.084-6.012-3.24-.9-3.996-1.476-3.996-2.736 0-1.152 1.044-1.908 2.88-1.908 1.692 0 3.204.54 4.788 1.548l1.8-2.7c-1.8-1.404-4.032-2.268-6.768-2.268m20.412 15.732 1.62 2.952c-1.368.972-3.096 1.44-4.788 1.44-3.744-.036-5.724-2.16-5.724-6.228v-10.044h-2.988v-3.312h2.988v-4.212l4.608-.54v4.752h4.428l-.468 3.312h-3.96v9.936c0 1.872.612 2.628 2.016 2.628.72 0 1.44-.216 2.268-.684m19.62-15.192-6.192 19.116c-1.44 4.464-4.248 7.344-9.9 7.776l-.468-3.348c3.78-.576 5.004-1.8 6.084-4.5h-1.584l-6.048-19.044h4.896l4.14 15.984 4.32-15.984zm7.308 19.584a7.55 7.55 0 0 0 3.06-.648l-.972-3.24c-.324.108-.648.18-1.08.18-.756 0-1.08-.432-1.08-1.332v-22.68l-4.608.504v22.32c0 3.132 1.764 4.896 4.68 4.896m21.744-10.512c0 .612-.072 1.368-.108 1.872h-11.952c.324 3.888 2.16 5.148 4.68 5.148 1.692 0 3.096-.54 4.752-1.692l1.908 2.628c-1.872 1.512-4.176 2.556-7.056 2.556-5.904 0-9.072-3.924-9.072-9.936 0-5.796 3.06-10.188 8.46-10.188 5.328 0 8.388 3.6 8.388 9.612m-4.572-1.116v-.216c0-3.132-1.116-5.004-3.708-5.004-2.16 0-3.528 1.44-3.78 5.22zm20.124-16.092 4.608.504V249h-4.068l-.324-2.412c-1.152 1.728-2.988 2.952-5.436 2.952-4.752 0-7.236-3.996-7.236-10.044 0-5.868 2.952-10.08 7.668-10.08 2.016 0 3.6.864 4.788 2.052zm-3.924 24.228c1.692 0 2.844-.828 3.924-2.448v-8.712c-1.008-1.224-2.088-2.016-3.636-2.016-2.376 0-3.96 2.016-3.96 6.588 0 4.896 1.404 6.588 3.672 6.588M44.44 265.416c-5.472 0-8.892 4.14-8.892 10.224s3.42 9.9 8.928 9.9c2.448 0 4.428-.792 6.156-2.196l-2.052-2.916c-1.404.9-2.412 1.368-3.852 1.368-2.592 0-4.284-1.62-4.284-6.228 0-4.572 1.62-6.516 4.284-6.516 1.44 0 2.592.432 3.852 1.368l2.052-2.772c-1.8-1.548-3.708-2.232-6.192-2.232m17.316 0c5.616 0 8.928 3.816 8.928 10.044 0 6.012-3.348 10.08-8.964 10.08s-8.964-3.816-8.964-10.08c0-5.976 3.348-10.044 9-10.044m0 3.492c-2.7 0-4.14 2.052-4.14 6.552 0 4.572 1.404 6.588 4.104 6.588s4.104-2.052 4.104-6.588-1.404-6.552-4.068-6.552m33.444-3.492c-2.52 0-4.284 1.224-5.724 3.204-.72-2.016-2.376-3.204-4.608-3.204-2.412 0-4.14 1.116-5.508 3.024l-.36-2.484h-3.996V285h4.608v-13.248c1.044-1.764 2.016-2.88 3.636-2.88 1.116 0 2.088.684 2.088 3.06V285h4.608v-13.248c1.044-1.764 2.016-2.88 3.6-2.88 1.152 0 2.088.684 2.088 3.06V285h4.608v-13.788c0-3.6-2.016-5.796-5.04-5.796m20.268 0c4.968 0 7.056 3.924 7.056 10.008 0 5.832-2.7 10.116-7.524 10.116-1.944 0-3.6-.684-4.788-2.088v8.892l-4.608.504v-26.892h4.032l.252 2.34c1.512-1.98 3.528-2.88 5.58-2.88m-1.764 16.596c2.52 0 3.996-1.944 3.996-6.552 0-4.824-1.296-6.588-3.6-6.588-1.62 0-2.988 1.116-3.888 2.592v8.568c.9 1.332 2.052 1.98 3.492 1.98m21.132-16.596c5.616 0 8.928 3.816 8.928 10.044 0 6.012-3.348 10.08-8.964 10.08s-8.964-3.816-8.964-10.08c0-5.976 3.348-10.044 9-10.044m0 3.492c-2.7 0-4.14 2.052-4.14 6.552 0 4.572 1.404 6.588 4.104 6.588s4.104-2.052 4.104-6.588-1.404-6.552-4.068-6.552m23.4-3.492c-2.412 0-4.32 1.116-5.796 3.024l-.36-2.484h-3.996V285h4.608v-13.248c1.116-1.764 2.34-2.88 3.996-2.88 1.44 0 2.34.684 2.34 3.06V285h4.608v-13.788c0-3.636-1.98-5.796-5.4-5.796m26.388 9.612c0 .612-.072 1.368-.108 1.872h-11.952c.324 3.888 2.16 5.148 4.68 5.148 1.692 0 3.096-.54 4.752-1.692l1.908 2.628c-1.872 1.512-4.176 2.556-7.056 2.556-5.904 0-9.072-3.924-9.072-9.936 0-5.796 3.06-10.188 8.46-10.188 5.328 0 8.388 3.6 8.388 9.612m-4.572-1.116v-.216c0-3.132-1.116-5.004-3.708-5.004-2.16 0-3.528 1.44-3.78 5.22zm18.864-8.496c-2.412 0-4.32 1.116-5.796 3.024l-.36-2.484h-3.996V285h4.608v-13.248c1.116-1.764 2.34-2.88 3.996-2.88 1.44 0 2.34.684 2.34 3.06V285h4.608v-13.788c0-3.636-1.98-5.796-5.4-5.796m20.052 15.732c-.828.468-1.548.684-2.268.684-1.404 0-2.016-.756-2.016-2.628v-9.936h3.96l.468-3.312h-4.428v-4.752l-4.608.54v4.212h-2.988v3.312h2.988v10.044c0 4.068 1.98 6.192 5.724 6.228 1.692 0 3.42-.468 4.788-1.44zm10.224-15.732c-4.428 0-7.344 2.376-7.344 5.544 0 2.808 1.728 4.68 5.652 5.76 3.564 1.008 4.32 1.512 4.32 3.096 0 1.44-1.332 2.304-3.384 2.304-1.944 0-3.708-.756-5.184-1.872l-2.304 2.592c1.764 1.584 4.32 2.7 7.596 2.7 4.356 0 8.028-2.088 8.028-6.048 0-3.384-2.196-4.968-6.084-6.012-3.24-.9-3.996-1.476-3.996-2.736 0-1.152 1.044-1.908 2.88-1.908 1.692 0 3.204.54 4.788 1.548l1.8-2.7c-1.8-1.404-4.032-2.268-6.768-2.268M79.8 87.2l-36.2 22.5 36.2 22.9-3.7 4.6-37.7-23.6v-7.9l38.1-23.6m189.3 22.7v7.8l-37.7 23.6-3.7-4.9 36.1-22.6L224.4 86l3.2-4.9"
    }), /*#__PURE__*/ React.createElement("text", {
        fill: "#000",
        fontFamily: "AppleColorEmoji, Apple Color Emoji",
        fontSize: 100,
        letterSpacing: 0.5,
        transform: "translate(38 44)"
    }, /*#__PURE__*/ React.createElement("tspan", {
        x: 70,
        y: 100
    }, "\uD83D\uDC85"))));

const SublimeText = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 332",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "55.117%",
        x2: "63.68%",
        y1: "58.68%",
        y2: "39.597%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FF9700"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "53%",
        stopColor: "#F48E00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#D06F00"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M255.288 166.795c0-3.887-2.872-6.128-6.397-5.015L6.397 238.675C2.865 239.796 0 243.86 0 247.74v78.59c0 3.887 2.865 6.135 6.397 5.015l242.494-76.888c3.525-1.12 6.397-5.185 6.397-9.071v-78.59Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9800",
        d: "M0 164.291c0 3.887 2.865 7.95 6.397 9.071l242.53 76.902c3.531 1.12 6.397-1.127 6.397-5.007V166.66c0-3.88-2.866-7.944-6.397-9.064L6.397 80.694C2.865 79.574 0 81.814 0 85.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9800",
        d: "M255.288 5.302c0-3.886-2.872-6.135-6.397-5.014L6.397 77.176C2.865 78.296 0 82.36 0 86.247v78.59c0 3.887 2.865 6.128 6.397 5.014l242.494-76.895c3.525-1.12 6.397-5.184 6.397-9.064z"
    }));

const Suno = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        className: "prefix__styles_icon__x_9Ga prefix__styles_icon__rC_ZS",
        viewBox: "0 0 122 122",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.773 8.882C0 12.362 0 16.916 0 26.027v69.946c0 9.111 0 13.666 1.773 17.145a16.27 16.27 0 0 0 7.109 7.109C12.362 122 16.916 122 26.027 122h69.946c9.111 0 13.666 0 17.145-1.773a16.27 16.27 0 0 0 7.109-7.109C122 109.639 122 105.084 122 95.973V26.027c0-9.11 0-13.666-1.773-17.145a16.27 16.27 0 0 0-7.109-7.109C109.639 0 105.084 0 95.973 0H26.027C16.917 0 12.36 0 8.882 1.773a16.27 16.27 0 0 0-7.109 7.109M105.733 61c0-24.705-12.517-44.733-27.958-44.733S49.817 36.295 49.817 61h-33.55c0 24.706 12.517 44.733 27.958 44.733S72.183 85.705 72.183 61z",
        clipRule: "evenodd"
    }));

const Supabase = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 109 113",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M63.708 110.284c-2.86 3.601-8.658 1.628-8.727-2.97l-1.007-67.251h45.22c8.19 0 12.758 9.46 7.665 15.874z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        fillOpacity: 0.2,
        d: "M63.708 110.284c-2.86 3.601-8.658 1.628-8.727-2.97l-1.007-67.251h45.22c8.19 0 12.758 9.46 7.665 15.874z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#3ECF8E",
        d: "M45.317 2.071c2.86-3.601 8.657-1.628 8.726 2.97l.442 67.251H9.83c-8.19 0-12.759-9.46-7.665-15.875z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 53.974,
        x2: 94.163,
        y1: 54.974,
        y2: 71.829,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#249361"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#3ECF8E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 36.156,
        x2: 54.484,
        y1: 30.578,
        y2: 65.081,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", null), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopOpacity: 0
    }))));

const Surrealdb = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 299",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "31.047%",
        x2: "68.957%",
        y1: "11.705%",
        y2: "88.303%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FF00A0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#9600FF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m128 78.568 71.101 39.375v-15.787L128 62.872c-10.575 5.852-61.684 34.103-71.101 39.284 8.747 4.846 100.602 55.589 156.434 86.43v15.726C205.745 208.518 128 251.46 128 251.46a76503 76503 0 0 1-85.333-47.147v-47.146L128 204.312l14.232-7.862-113.798-62.842v78.598L128 267.185c9.813-5.425 92.282-50.987 99.535-55.01v-31.42l-142.202-78.6zM28.434 86.43v31.452l142.202 78.598-42.666 23.589-71.101-39.376v15.787l71.1 39.284c10.576-5.852 61.684-34.103 71.101-39.284-8.746-4.846-100.571-55.589-156.403-86.461V94.293C50.255 90.088 128 47.147 128 47.147a76501 76501 0 0 0 85.333 47.146v47.147L128 94.293l-14.232 7.863 113.767 62.873V86.43L128 31.421c-9.844 5.455-92.282 51.017-99.566 55.01ZM128 0 0 70.735v157.166l128 70.735 128-70.705V70.735zm113.737 220.038L128 282.91 14.232 220.038V78.598L128 15.726l113.768 62.872-.03 141.44Z"
    }));

const Svelte = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 308",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF3E00",
        d: "M239.682 40.707C211.113-.182 154.69-12.301 113.895 13.69L42.247 59.356a82.2 82.2 0 0 0-37.135 55.056 86.57 86.57 0 0 0 8.536 55.576 82.4 82.4 0 0 0-12.296 30.719 87.6 87.6 0 0 0 14.964 66.244c28.574 40.893 84.997 53.007 125.787 27.016l71.648-45.664a82.18 82.18 0 0 0 37.135-55.057 86.6 86.6 0 0 0-8.53-55.577 82.4 82.4 0 0 0 12.29-30.718 87.57 87.57 0 0 0-14.963-66.244"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M106.889 270.841c-23.102 6.007-47.497-3.036-61.103-22.648a52.69 52.69 0 0 1-9.003-39.85 50 50 0 0 1 1.713-6.693l1.35-4.115 3.671 2.697a92.5 92.5 0 0 0 28.036 14.007l2.663.808-.245 2.659a16.07 16.07 0 0 0 2.89 10.656 17.14 17.14 0 0 0 18.397 6.828 15.8 15.8 0 0 0 4.403-1.935l71.67-45.672a14.92 14.92 0 0 0 6.734-9.977 15.92 15.92 0 0 0-2.713-12.011 17.16 17.16 0 0 0-18.404-6.832 15.8 15.8 0 0 0-4.396 1.933l-27.35 17.434a52.3 52.3 0 0 1-14.553 6.391c-23.101 6.007-47.497-3.036-61.101-22.649a52.68 52.68 0 0 1-9.004-39.849 49.43 49.43 0 0 1 22.34-33.114l71.664-45.677a52.2 52.2 0 0 1 14.563-6.398c23.101-6.007 47.497 3.036 61.101 22.648a52.69 52.69 0 0 1 9.004 39.85 50.6 50.6 0 0 1-1.713 6.692l-1.35 4.116-3.67-2.693a92.4 92.4 0 0 0-28.037-14.013l-2.664-.809.246-2.658a16.1 16.1 0 0 0-2.89-10.656 17.14 17.14 0 0 0-18.398-6.828 15.8 15.8 0 0 0-4.402 1.935l-71.67 45.674a14.9 14.9 0 0 0-6.73 9.975 15.9 15.9 0 0 0 2.709 12.012 17.16 17.16 0 0 0 18.404 6.832 15.8 15.8 0 0 0 4.402-1.935l27.345-17.427a52.2 52.2 0 0 1 14.552-6.397c23.101-6.006 47.497 3.037 61.102 22.65a52.68 52.68 0 0 1 9.003 39.848 49.45 49.45 0 0 1-22.34 33.12l-71.664 45.673a52.2 52.2 0 0 1-14.563 6.398"
    }));

const Svgl = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 512 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "prefix__b",
        width: 512,
        height: 512,
        x: 0,
        y: 0,
        fill: "#222",
        stroke: "#FFF",
        strokeOpacity: "100%",
        strokeWidth: 0,
        paintOrder: "stroke",
        rx: 128
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 512,
        height: 512,
        fill: "url(#prefix__a)",
        rx: 128,
        style: {
            mixBlendMode: "overlay"
        }
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "prefix__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(0 512 -512 0 256 0)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    }))), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: 101,
        y: 101,
        fill: "#e8e8e8",
        alignmentBaseline: "middle",
        style: {
            color: "#fff"
        },
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M168 32H88a56.06 56.06 0 0 0-56 56v80a56.06 56.06 0 0 0 56 56h48a8 8 0 0 0 2.53-.41c26.23-8.75 76.31-58.83 85.06-85.06A8 8 0 0 0 224 136V88a56.06 56.06 0 0 0-56-56M48 168V88a40 40 0 0 1 40-40h80a40 40 0 0 1 40 40v40h-24a56.06 56.06 0 0 0-56 56v24H88a40 40 0 0 1-40-40m96 35.14V184a40 40 0 0 1 40-40h19.14C191 163.5 163.5 191 144 203.14"
    })));

const Swagger = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#85EA2D",
        d: "M128 250a122 122 0 1 1 0-244 122 122 0 0 1 0 244"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#173647",
        d: "M128 12a116 116 0 1 1 0 232 116 116 0 0 1 0-232m0-12a128 128 0 1 0 0 256 128 128 0 0 0 0-256"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#173647",
        d: "m81 87-1 13-1 13c-2 6-5 11-11 15 11 7 12 17 13 28v17c1 5 2 6 7 6h6v14c-14 2-25-2-27-13l-2-13v-14c-1-12-3-17-15-17v-16h3c6-1 9-3 11-9l1-11 1-22c2-10 8-15 19-15h9v14h-4c-8 0-9 3-9 10m16 32a9 9 0 0 0-1 18c5 0 10-3 10-8v-1c0-5-4-9-9-9m31 0a9 9 0 0 0-9 9c0 6 4 9 9 9 6 0 9-4 9-9s-4-9-9-9m31 0a9 9 0 0 0 0 18c5 1 9-4 10-9 0-5-5-9-10-9m44 1c-6-1-9-2-10-8l-2-10-1-20c-1-16-12-21-28-19v14h6c4 0 6 1 7 5v11l3 21c1 6 5 11 10 14-9 6-11 14-12 24l-1 19c0 6-2 8-8 8h-5v14h10q15 0 18-15l1-16 1-15c1-7 4-10 12-11h2v-16z"
    }));

const Swift = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: -1845.5,
        x2: -1797.1,
        y1: 1255.6,
        y2: 981.3,
        gradientTransform: "rotate(180 -846.6 623.3)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#faae42"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#ef3e31"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M56.9 0h141.8a56.5 56.5 0 0 1 57.4 59.1v138.3a56.6 56.6 0 0 1-57.5 58.6l-144.2-.1a57 57 0 0 1-54-56.8V56.9A56.8 56.8 0 0 1 53.7.2c1-.2 2.1-.2 3.2-.2"
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 130.6,
        x2: 95.2,
        y1: 4.1,
        y2: 204.9,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#e39f3a"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#d33929"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M216 209.4a39 39 0 0 0-11.6-11.9c-4-2.7-8.7-4.4-13.5-4.6-3.4-.2-6.8.4-10 1.6a65 65 0 0 0-9.3 4.3c-3.5 1.8-7 3.6-10.7 5.1-4.4 1.8-9 3.2-13.7 4.2a89 89 0 0 1-17.8 1.4 120.3 120.3 0 0 1-77.2-30 145.4 145.4 0 0 1-22.8-25.1 47 47 0 0 1-3-4.7L0 121.2V56.7A56.6 56.6 0 0 1 56.6 0h50.5l37.4 38c84.4 57.4 57.1 120.7 57.1 120.7s24 27 14.4 50.7"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M144.7 38c84.4 57.4 57.1 120.7 57.1 120.7s24 27.1 14.3 50.8c0 0-9.9-16.6-26.5-16.6-16 0-25.4 16.6-57.6 16.6-71.7 0-105.6-59.9-105.6-59.9C91 192.1 135.1 162 135.1 162c-29.1-16.9-91-97.7-91-97.7 53.9 45.9 77.2 58 77.2 58-13.9-11.5-52.9-67.7-52.9-67.7 31.2 31.6 93.2 75.7 93.2 75.7C179.2 81.5 144.7 38 144.7 38"
    }));

const T3StackDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 258 199",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#e2e8f0",
        fillRule: "evenodd",
        d: "M165.735 25.07 188.947.972H.466V25.07z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#e2e8f0",
        d: "m163.981 96.324 90.041-92.64-32.816-.001-75.589 77.078zM233.658 131.418c0 23.657-19.178 42.836-42.835 42.836-19.108 0-35.31-12.516-40.823-29.815l-3.375-10.591-19.296 19.295 1.763 4.193c10.123 24.085 33.942 41.018 61.731 41.018 36.968 0 66.936-29.968 66.936-66.936 0-24.481-13.36-45.678-32.803-57.327l-4.561-2.733-17.668 17.895 8.061 4.255c13.615 7.188 22.87 21.473 22.87 37.91"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#e2e8f0",
        fillRule: "evenodd",
        d: "M88.263 192.669V45.646H64.165v147.023z",
        clipRule: "evenodd"
    }));

const T3StackLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 258 199",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M165.735 25.07 188.947.972H.466V25.07z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m163.981 96.324 90.041-92.64-32.816-.001-75.589 77.078zM233.658 131.418c0 23.657-19.178 42.836-42.835 42.836-19.108 0-35.31-12.516-40.823-29.815l-3.375-10.591-19.296 19.295 1.763 4.193c10.123 24.085 33.942 41.018 61.731 41.018 36.968 0 66.936-29.968 66.936-66.936 0-24.481-13.36-45.678-32.803-57.327l-4.561-2.733-17.668 17.895 8.061 4.255c13.615 7.188 22.87 21.473 22.87 37.91"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M88.263 192.669V45.646H64.165v147.023z",
        clipRule: "evenodd"
    }));

const TIDALDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1001 667",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M84 83.5.5 167l83 83c45.6 45.6 83.4 83 84 83 .5 0 38.3-37.4 84-83l83-83 83 83 83 83-83.5 83.5-83.5 83.5 83.5 83.5 83.5 83.5 83.5-83.5 83.5-83.5-83.3-83.3-83.2-83.2 83.3-83.3 83.2-83.2 83.3 83.2 83.2 83.3 83.5-83.5 83.5-83.5L917.5 83 834-.5 750.5 83 667 166.5l-83.3-83.3L500.5 0l-83.3 83.2-83.2 83.3-83.3-83.3L167.5 0z"
    }));

const TIDALLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1001 667",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M84 83.5.5 167l83 83c45.6 45.6 83.4 83 84 83 .5 0 38.3-37.4 84-83l83-83 83 83 83 83-83.5 83.5-83.5 83.5 83.5 83.5 83.5 83.5 83.5-83.5 83.5-83.5-83.3-83.3-83.2-83.2 83.3-83.3 83.2-83.2 83.3 83.2 83.2 83.3 83.5-83.5 83.5-83.5L917.5 83 834-.5 750.5 83 667 166.5l-83.3-83.3L500.5 0l-83.3 83.2-83.2 83.3-83.3-83.3L167.5 0z"
    }));

const TRPC = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 512 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 512,
        height: 512,
        fill: "#398CCB",
        rx: 150
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "m255.446 75 71.077 41.008v22.548l86.031 49.682v84.986l23.077 13.322v82.062L364.6 409.615l-31.535-18.237-76.673 44.268-76.214-44.012-31.093 17.981-71.031-41.077v-81.992l22.177-12.803v-85.505l84.184-48.6.047-.002v-23.628zm71.077 84.879v38.144l-71.031 41.008-71.03-41.008v-37.087l-.047.002-65.723 37.962v64.184l30.393-17.546 71.03 41.008v81.992l-21.489 12.427 57.766 33.358 58.226-33.611-21.049-12.174v-81.992l71.031-41.008 29.492 17.027V198.9zm-14.492 198.09v-50.054l43.338 25.016v50.054zm105.138-50.123-43.338 25.016v50.123l43.338-25.085zM96.515 357.9v-50.054l43.339 25.016v50.053zm105.139-50.054-43.339 25.016v50.053l43.339-25.015zm119.608-15.923 43.338-25.015 43.338 25.015-43.338 25.039zm-172.177-25.085-43.339 25.085 43.339 24.969 43.338-24.969zm53.838-79.476v-50.054l43.292 25.038v50.031zm105.092-50.054-43.292 25.038v50.008l43.292-24.992zm-95.861-15.97 43.292-25.015 43.339 25.015-43.339 25.016z",
        clipRule: "evenodd"
    }));

const Tabby = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 260.967,
        x2: 919.184,
        y1: 871.181,
        y2: 491.16,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#669abd"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#77dbdb"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "m297.54 934.52 585.06-337.8.01-168.9-585.07 337.83z",
        style: {
            fill: "url(#prefix__a)"
        }
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 553.505,
        x2: 626.647,
        y1: 617.828,
        y2: 744.513,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.559,
        style: {
            stopColor: "#000",
            stopOpacity: 0
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#000"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "m297.54 934.52 585.06-337.8.01-168.9-585.07 337.83z",
        style: {
            opacity: 0.16,
            fill: "url(#prefix__b)"
        }
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: 114.663,
        x2: 334.091,
        y1: 744.528,
        y2: 871.214,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#6a8fad"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#669abd"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "m151.23 681.18-.01 168.91 146.32 84.43V765.65z",
        style: {
            fill: "url(#prefix__c)"
        }
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 260.948,
        x2: 187.806,
        y1: 744.528,
        y2: 871.213,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.559,
        style: {
            stopColor: "#000",
            stopOpacity: 0
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#000"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "m151.23 681.18-.01 168.91 146.32 84.43V765.65z",
        style: {
            opacity: 0.16,
            fill: "url(#prefix__d)"
        }
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 114.663,
        x2: 553.503,
        y1: 237.793,
        y2: 491.157,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#6a8fad"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#669abd"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "m151.23 174.45-.02 168.91 292.58 168.91 146.29-84.46z",
        style: {
            fill: "url(#prefix__e)"
        }
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: 370.656,
        x2: 297.509,
        y1: 301.128,
        y2: 427.822,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.559,
        style: {
            stopColor: "#000",
            stopOpacity: 0
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#000"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "m151.23 174.45-.02 168.91 292.58 168.91 146.29-84.46z",
        style: {
            opacity: 0.15,
            fill: "url(#prefix__f)"
        }
    }), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: 78.091,
        x2: 736.337,
        y1: 554.498,
        y2: 174.459,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        style: {
            stopColor: "#ccecff"
        }
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        style: {
            stopColor: "#9feced"
        }
    })), /*#__PURE__*/ React.createElement("path", {
        d: "m297.51 765.64-146.28-84.46 438.85-253.37-438.85-253.36L297.5 90l585.11 337.82z",
        style: {
            fill: "url(#prefix__g)"
        }
    }));

const TailwindCSS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 54 33",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#38bdf8",
        fillRule: "evenodd",
        d: "M27 0Q16.2 0 13.5 10.8q4.05-5.4 9.45-4.05c2.054.513 3.522 2.004 5.147 3.653C30.744 13.09 33.808 16.2 40.5 16.2q10.8 0 13.5-10.8-4.05 5.4-9.45 4.05c-2.054-.513-3.522-2.004-5.147-3.653C36.756 3.11 33.692 0 27 0M13.5 16.2Q2.7 16.2 0 27q4.05-5.4 9.45-4.05c2.054.514 3.522 2.004 5.147 3.653C17.244 29.29 20.308 32.4 27 32.4q10.8 0 13.5-10.8-4.05 5.4-9.45 4.05c-2.054-.513-3.522-2.004-5.147-3.653C23.256 19.31 20.192 16.2 13.5 16.2",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h54v32.4H0z"
    }))));

const TanStack = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 633 633",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "71.65%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#6BDAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "31.922%",
        stopColor: "#F9FFB5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "70.627%",
        stopColor: "#FFA770"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF7373"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "43.996%",
        x2: "53.441%",
        y1: "8.54%",
        y2: "93.872%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#673800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#B65E00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2F8A00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#90FF57"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2F8A00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#90FF57"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2F8A00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#90FF57"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__h",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2F8A00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#90FF57"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2F8A00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#90FF57"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__j",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2F8A00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#90FF57"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__k",
        x1: "92.9%",
        x2: "8.641%",
        y1: "45.768%",
        y2: "54.892%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#EE2700"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF008E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__l",
        x1: "61.109%",
        x2: "43.717%",
        y1: "3.633%",
        y2: "43.072%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#3C8700"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__m",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFDF00"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF9D00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__n",
        x1: "127.279%",
        x2: "0%",
        y1: "49.778%",
        y2: "50.222%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF5E00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__o",
        x1: "127.279%",
        x2: "0%",
        y1: "47.531%",
        y2: "52.469%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF5E00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__p",
        x1: "127.279%",
        x2: "0%",
        y1: "46.195%",
        y2: "53.805%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF5E00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__q",
        x1: "127.279%",
        x2: "0%",
        y1: "35.33%",
        y2: "64.67%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF5E00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__r",
        x1: "127.279%",
        x2: "0%",
        y1: "4.875%",
        y2: "95.125%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF5E00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__s",
        x1: "78.334%",
        x2: "31.668%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF5E00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__t",
        x1: "57.913%",
        x2: "44.88%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF5E00"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__u",
        x1: "50.495%",
        x2: "49.68%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFA400"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF5E00"
    })), /*#__PURE__*/ React.createElement("circle", {
        id: "prefix__a",
        cx: 308.5,
        cy: 308.5,
        r: 308.5
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(9 8)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__c",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        fill: "url(#prefix__b)"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 81.5,
        cy: 602.5,
        fill: "#015064",
        stroke: "#00CFE2",
        strokeWidth: 25,
        mask: "url(#prefix__c)",
        rx: 214.5,
        ry: 185.968
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 535.5,
        cy: 602.5,
        fill: "#015064",
        stroke: "#00CFE2",
        strokeWidth: 25,
        mask: "url(#prefix__c)",
        rx: 214.5,
        ry: 185.968
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 81.5,
        cy: 640.5,
        fill: "#015064",
        stroke: "#00A8B8",
        strokeWidth: 25,
        mask: "url(#prefix__c)",
        rx: 214.5,
        ry: 185.968
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 535.5,
        cy: 640.5,
        fill: "#015064",
        stroke: "#00A8B8",
        strokeWidth: 25,
        mask: "url(#prefix__c)",
        rx: 214.5,
        ry: 185.968
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 81.5,
        cy: 676.5,
        fill: "#015064",
        stroke: "#007782",
        strokeWidth: 25,
        mask: "url(#prefix__c)",
        rx: 214.5,
        ry: 185.968
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 535.5,
        cy: 676.5,
        fill: "#015064",
        stroke: "#007782",
        strokeWidth: 25,
        mask: "url(#prefix__c)",
        rx: 214.5,
        ry: 185.968
    }), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__c)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        stroke: "#6E3A00",
        strokeWidth: 6.088,
        d: "M98.318 88.007q11.537 55.656 26.856 106.013t46.07 106.088l-51.903 11.67q-15.085-90.015-21.525-117.487T77.727 94.934l20.591-6.927",
        transform: "scale(-1 1)rotate(25 -300.37 -553.013)"
    }), /*#__PURE__*/ React.createElement("g", {
        stroke: "#2F8A00"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        strokeWidth: 9.343,
        d: "M108.544 66.538s-13.54-21.305-37.417-27.785q-23.875-6.481-54.048 13.892Q41.657 72.64 58.405 75.28c16.749 2.64 50.14-8.74 50.14-8.74Z",
        transform: "rotate(1 -6061.691 5926.397)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        strokeWidth: 9.343,
        d: "M108.544 67.138s-47.187-5.997-81.077 19.936Q-6.424 113.006 1.502 187.369q42.63-43.83 61.016-64.846c18.387-21.016 46.026-55.385 46.026-55.385Z",
        transform: "rotate(1 -6061.691 5926.397)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        strokeWidth: 9.343,
        d: "M108.544 66.538q-2.94-32.557 17.82-48.94Q147.123 1.212 170.303 0q-7.298 32.29-22.524 44.361-15.227 12.072-39.236 22.177Z",
        transform: "rotate(1 -6061.691 5926.397)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__h)",
        strokeWidth: 9.343,
        d: "M108.544 67.138q44.757-47.23 93.669-33.869 48.91 13.36 56.787 55.827-52.347-5.486-75.228-8.058-22.881-2.574-75.228-13.9Z",
        transform: "rotate(1 -6061.691 5926.397)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        strokeWidth: 9.343,
        d: "M108.544 67.138q52.302-14.072 88.905 17.17t45.762 77.571q-59.439-11.36-86.322-37.624a395 395 0 0 1-48.345-57.117Z",
        transform: "rotate(1 -6061.691 5926.397)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__j)",
        strokeWidth: 9.343,
        d: "M108.544 67.138Q60.037 90.331 52.75 135.436t13.698 98.462q37.31-62.127 42.096-89.849 4.787-27.721 0-76.91Z",
        transform: "rotate(1 -6061.691 5926.397)"
    }), /*#__PURE__*/ React.createElement("path", {
        strokeLinecap: "round",
        strokeWidth: 5.91,
        d: "M211.284 173.477q-20.776 32.987-28.32 60.093t-9.436 45.216"
    }), /*#__PURE__*/ React.createElement("path", {
        strokeLinecap: "round",
        strokeWidth: 5.91,
        d: "M209.814 176.884q-35.973 3.847-56.428 23.714-20.458 19.867-29.536 38.674m95.195-71.973q43.542-11.584 65.831-7.352 22.289 4.233 35.842 14.51m-109.408-1.839q30.436 13.66 54.186 29.837 23.75 16.178 35.643 30.617"
    })), /*#__PURE__*/ React.createElement("path", {
        stroke: "#830305",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 6.937,
        d: "m409.379 398.157-23.176 18.556m-58.163-41.197-22.313 28.398m7.177-50.216 53.18 59.816"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__k)",
        d: "M67.585 27.463H5.68Q0 28.49 0 34.16t5.68 7.293h67.17l41.751-30.356q3.731-3.97.92-8.006c-2.811-4.036-4.6-3.626-8.177-2.803l-39.76 27.174Z",
        transform: "scale(-1 1)rotate(-9 2092.128 2856.854)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D8D8D8",
        stroke: "#FFF",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 4.414,
        d: "m402.861 391.51.471-4.088m-21.122 1.33.472-4.087m-21.136.739.485-3.845m-24.441-9.676 2.56-2.498m-15.874-9.818 2.56-2.497"
    })), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 308.5,
        cy: 720.5,
        fill: "url(#prefix__l)",
        mask: "url(#prefix__c)",
        rx: 266,
        ry: 316.5
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 308.5,
        cy: 720.5,
        stroke: "#6DA300",
        strokeOpacity: 0.502,
        strokeWidth: 26,
        mask: "url(#prefix__c)",
        rx: 253,
        ry: 303.5
    }), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__c)"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(389 -32)"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 168.5,
        cy: 113.5,
        r: 113.5,
        fill: "url(#prefix__m)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 168.5,
        cy: 113.5,
        r: 106,
        stroke: "#FFC900",
        strokeOpacity: 0.529,
        strokeWidth: 15
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__n)",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 12,
        d: "M30 113H0"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__o)",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 12,
        d: "M33.5 79.5 7 74"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__p)",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 12,
        d: "m34 146-29 8"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__q)",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 12,
        d: "m45 177-24 13"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__r)",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 12,
        d: "m67 204-20 19"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__s)",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 12,
        d: "m94.373 227-13.834 22.847"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__t)",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 12,
        d: "M127.5 243.5 120 268"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#prefix__u)",
        strokeLinecap: "round",
        strokeLinejoin: "bevel",
        strokeWidth: 12,
        d: "m167.5 252.5.5 24.5"
    }))), /*#__PURE__*/ React.createElement("circle", {
        cx: 307.5,
        cy: 308.5,
        r: 304,
        stroke: "#000",
        strokeWidth: 25
    })));

const Tauri = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 289",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFC131",
        d: "M178.497 104.93c0 15.155-12.285 27.44-27.44 27.44-15.153 0-27.438-12.285-27.438-27.44 0-15.153 12.285-27.438 27.439-27.438s27.439 12.285 27.439 27.439Z"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 104.911,
        cy: 183.505,
        r: 27.439,
        fill: "#24C8DB",
        transform: "rotate(180 104.91 183.505)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFC131",
        d: "M207.93 192.86a104.8 104.8 0 0 1-36.168 14.717 73.6 73.6 0 0 0 3.617-33.176c29.953-10.472 49.82-38.964 49.292-70.69-.53-31.727-21.336-59.542-51.622-69.008-30.286-9.467-63.23 1.546-81.733 27.324a122.2 122.2 0 0 0-40.16 11.723C64.86 29.536 105.956-.445 152.244.005s86.794 31.224 99.636 75.697-5.026 92.103-43.95 117.157ZM52.404 92.832l25.693 3.118a73.6 73.6 0 0 1 3.243-14.593 104.8 104.8 0 0 0-28.936 11.475"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#24C8DB",
        d: "M47.913 95.577a104.8 104.8 0 0 1 36.419-14.842 73.46 73.46 0 0 0-4.116 33.3c-29.847 10.619-49.549 39.148-48.906 70.822.642 31.673 21.484 59.38 51.738 68.78s63.127-1.62 81.604-27.352a122.2 122.2 0 0 0 40.16-11.6c-13.736 44.169-54.812 74.1-101.064 73.645-46.252-.453-86.733-31.184-99.602-75.612s4.92-92.037 43.768-117.141Zm155.528 100.026-.5.25z"
    }));

const Telegram = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#2AABEE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#229ED9"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M128 0C94.06 0 61.48 13.494 37.5 37.49A128.04 128.04 0 0 0 0 128c0 33.934 13.5 66.514 37.5 90.51C61.48 242.506 94.06 256 128 256s66.52-13.494 90.5-37.49c24-23.996 37.5-56.576 37.5-90.51s-13.5-66.514-37.5-90.51C194.52 13.494 161.94 0 128 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M57.94 126.648q55.98-24.385 74.64-32.152c35.56-14.786 42.94-17.354 47.76-17.441 1.06-.017 3.42.245 4.96 1.49 1.28 1.05 1.64 2.47 1.82 3.467.16.996.38 3.266.2 5.038-1.92 20.24-10.26 69.356-14.5 92.026-1.78 9.592-5.32 12.808-8.74 13.122-7.44.684-13.08-4.912-20.28-9.63-11.26-7.386-17.62-11.982-28.56-19.188-12.64-8.328-4.44-12.906 2.76-20.386 1.88-1.958 34.64-31.748 35.26-34.45.08-.338.16-1.598-.6-2.262-.74-.666-1.84-.438-2.64-.258-1.14.256-19.12 12.152-54 35.686-5.1 3.508-9.72 5.218-13.88 5.128-4.56-.098-13.36-2.584-19.9-4.708-8-2.606-14.38-3.984-13.82-8.41.28-2.304 3.46-4.662 9.52-7.072"
    }));

const TensorFlow = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "-9 0 274 274",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E55B2D",
        d: "M145.726 42.065v42.07l72.861 42.07v-42.07zM0 84.135v42.07l36.43 21.03V105.17zm109.291 21.035-36.43 21.034v126.2l36.43 21.035v-84.135l36.435 21.035v-42.07l-36.435-21.034z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ED8E24",
        d: "M145.726 42.065 36.43 105.17v42.065l72.861-42.065v42.065l36.435-21.03zM255.022 63.1l-36.435 21.035v42.07l36.435-21.035zm-72.865 84.135-36.43 21.035v42.07l36.43-21.036zm-36.43 63.104-36.436-21.035v84.135l36.435-21.035z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F8BF3C",
        d: "M145.726 0 0 84.135l36.43 21.035 109.296-63.105 72.861 42.07L255.022 63.1zm0 126.204-36.435 21.03 36.435 21.036 36.43-21.035z"
    }));

const Terraform = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 72",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m17.2 17.5 15.5 9v18l-15.5-9zm17.3 9v18l15.5-9v-18zM0 7.5v18l15.5 9v-18zm17.2 48 15.5 9v-18l-15.5-9z",
        style: {
            fill: "#a067da",
            fillRule: "evenodd",
            strokeWidth: 0
        }
    }));

const Tether = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 1",
        viewBox: "0 0 339.43 295.27",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m62.15 1.45-61.89 130a2.52 2.52 0 0 0 .54 2.94l167.15 160.17a2.55 2.55 0 0 0 3.53 0L338.63 134.4a2.52 2.52 0 0 0 .54-2.94l-61.89-130A2.5 2.5 0 0 0 275 0H64.45a2.5 2.5 0 0 0-2.3 1.45",
        style: {
            fill: "#50af95",
            fillRule: "evenodd"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M191.19 144.8c-1.2.09-7.4.46-21.23.46-11 0-18.81-.33-21.55-.46-42.51-1.87-74.24-9.27-74.24-18.13s31.73-16.25 74.24-18.15v28.91c2.78.2 10.74.67 21.74.67 13.2 0 19.81-.55 21-.66v-28.9c42.42 1.89 74.08 9.29 74.08 18.13s-31.65 16.24-74.08 18.12Zm0-39.25V79.68h59.2V40.23H89.21v39.45h59.19v25.86c-48.11 2.21-84.29 11.74-84.29 23.16s36.18 20.94 84.29 23.16v82.9h42.78v-82.93c48-2.21 84.12-11.73 84.12-23.14s-36.09-20.93-84.12-23.15Zm0 0",
        style: {
            fill: "#fff",
            fillRule: "evenodd"
        }
    }));

const ThreadsDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Threads",
        viewBox: "0 0 192 192",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M141.537 88.988a67 67 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.396-35.12 18.036l13.779 9.452c5.73-8.695 14.724-10.548 21.348-10.548h.229c8.249.053 14.474 2.452 18.503 7.129 2.932 3.405 4.893 8.111 5.864 14.05-7.314-1.243-15.224-1.626-23.68-1.14-23.82 1.371-39.134 15.264-38.105 34.568.522 9.792 5.4 18.216 13.735 23.719 7.047 4.652 16.124 6.927 25.557 6.412 12.458-.683 22.231-5.436 29.049-14.127 5.178-6.6 8.453-15.153 9.899-25.93 5.937 3.583 10.337 8.298 12.767 13.966 4.132 9.635 4.373 25.468-8.546 38.376-11.319 11.308-24.925 16.2-45.488 16.351-22.809-.169-40.06-7.484-51.275-21.742C35.236 139.966 29.808 120.682 29.605 96c.203-24.682 5.63-43.966 16.133-57.317C56.954 24.425 74.204 17.11 97.013 16.94c22.975.17 40.526 7.52 52.171 21.847 5.71 7.026 10.015 15.86 12.853 26.162l16.147-4.308c-3.44-12.68-8.853-23.606-16.219-32.668C147.036 9.607 125.202.195 97.07 0h-.113C68.882.194 47.292 9.642 32.788 28.08 19.882 44.485 13.224 67.315 13.001 95.932L13 96v.067c.224 28.617 6.882 51.447 19.788 67.854C47.292 182.358 68.882 191.806 96.957 192h.113c24.96-.173 42.554-6.708 57.048-21.189 18.963-18.945 18.392-42.692 12.142-57.27-4.484-10.454-13.033-18.945-24.723-24.553M98.44 129.507c-10.44.588-21.286-4.098-21.82-14.135-.397-7.442 5.296-15.746 22.461-16.735a100 100 0 0 1 5.79-.169c6.235 0 12.068.606 17.371 1.765-1.978 24.702-13.58 28.713-23.802 29.274",
        className: "prefix__x19hqcy"
    }));

const ThreadsLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Threads",
        viewBox: "0 0 192 192",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M141.537 88.988a67 67 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.396-35.12 18.036l13.779 9.452c5.73-8.695 14.724-10.548 21.348-10.548h.229c8.249.053 14.474 2.452 18.503 7.129 2.932 3.405 4.893 8.111 5.864 14.05-7.314-1.243-15.224-1.626-23.68-1.14-23.82 1.371-39.134 15.264-38.105 34.568.522 9.792 5.4 18.216 13.735 23.719 7.047 4.652 16.124 6.927 25.557 6.412 12.458-.683 22.231-5.436 29.049-14.127 5.178-6.6 8.453-15.153 9.899-25.93 5.937 3.583 10.337 8.298 12.767 13.966 4.132 9.635 4.373 25.468-8.546 38.376-11.319 11.308-24.925 16.2-45.488 16.351-22.809-.169-40.06-7.484-51.275-21.742C35.236 139.966 29.808 120.682 29.605 96c.203-24.682 5.63-43.966 16.133-57.317C56.954 24.425 74.204 17.11 97.013 16.94c22.975.17 40.526 7.52 52.171 21.847 5.71 7.026 10.015 15.86 12.853 26.162l16.147-4.308c-3.44-12.68-8.853-23.606-16.219-32.668C147.036 9.607 125.202.195 97.07 0h-.113C68.882.194 47.292 9.642 32.788 28.08 19.882 44.485 13.224 67.315 13.001 95.932L13 96v.067c.224 28.617 6.882 51.447 19.788 67.854C47.292 182.358 68.882 191.806 96.957 192h.113c24.96-.173 42.554-6.708 57.048-21.189 18.963-18.945 18.392-42.692 12.142-57.27-4.484-10.454-13.033-18.945-24.723-24.553M98.44 129.507c-10.44.588-21.286-4.098-21.82-14.135-.397-7.442 5.296-15.746 22.461-16.735a100 100 0 0 1 5.79-.169c6.235 0 12.068.606 17.371 1.765-1.978 24.702-13.58 28.713-23.802 29.274",
        className: "prefix__x19hqcy"
    }));

const ThreejsDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M.38 0a.268.268 0 0 0-.256.332l2.894 11.716.01.04 2.89 11.708a.268.268 0 0 0 .447.128L23.802 7.15a.268.268 0 0 0-.112-.45l-5.784-1.667a.3.3 0 0 0-.123-.035L6.38 1.715a.27.27 0 0 0-.144-.04L.456.01A.3.3 0 0 0 .38 0m.374.654L5.71 2.08 1.99 5.664zM6.61 2.34l4.864 1.4-3.65 3.515zm-.522.12 1.217 4.926-4.877-1.4zm6.28 1.538 4.878 1.404-3.662 3.53zm-.52.13 1.208 4.9-4.853-1.392zm6.3 1.534 4.947 1.424-3.715 3.574zm-.524.12 1.215 4.926-4.876-1.398zm-15.432.696 4.964 1.424-3.726 3.586zM8.047 8.15l4.877 1.4-3.66 3.527zm-.518.137 1.236 5.017-4.963-1.432zm6.274 1.535 4.965 1.425-3.73 3.586zm-.52.127 1.235 5.012-4.958-1.43zm-9.63 2.438 4.873 1.406-3.656 3.523zm5.854 1.687 4.863 1.403-3.648 3.51zm-.54.04 1.214 4.927-4.875-1.4zm-3.896 4.02 5.037 1.442-3.782 3.638z"
    }));

const ThreejsLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M.38 0a.268.268 0 0 0-.256.332l2.894 11.716.01.04 2.89 11.708a.268.268 0 0 0 .447.128L23.802 7.15a.268.268 0 0 0-.112-.45l-5.784-1.667a.3.3 0 0 0-.123-.035L6.38 1.715a.27.27 0 0 0-.144-.04L.456.01A.3.3 0 0 0 .38 0m.374.654L5.71 2.08 1.99 5.664zM6.61 2.34l4.864 1.4-3.65 3.515zm-.522.12 1.217 4.926-4.877-1.4zm6.28 1.538 4.878 1.404-3.662 3.53zm-.52.13 1.208 4.9-4.853-1.392zm6.3 1.534 4.947 1.424-3.715 3.574zm-.524.12 1.215 4.926-4.876-1.398zm-15.432.696 4.964 1.424-3.726 3.586zM8.047 8.15l4.877 1.4-3.66 3.527zm-.518.137 1.236 5.017-4.963-1.432zm6.274 1.535 4.965 1.425-3.73 3.586zm-.52.127 1.235 5.012-4.958-1.43zm-9.63 2.438 4.873 1.406-3.656 3.523zm5.854 1.687 4.863 1.403-3.648 3.51zm-.54.04 1.214 4.927-4.875-1.4zm-3.896 4.02 5.037 1.442-3.782 3.638z"
    }));

const TikTok = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 290",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF004F",
        d: "M189.72 104.421c18.678 13.345 41.56 21.197 66.273 21.197v-47.53a67 67 0 0 1-13.918-1.456v37.413c-24.711 0-47.59-7.851-66.272-21.195v96.996c0 48.523-39.356 87.855-87.9 87.855-18.113 0-34.949-5.473-48.934-14.86 15.962 16.313 38.222 26.432 62.848 26.432 48.548 0 87.905-39.332 87.905-87.857v-96.995zm17.17-47.952c-9.546-10.423-15.814-23.893-17.17-38.785v-6.113h-13.189c3.32 18.927 14.644 35.097 30.358 44.898M69.673 225.607a40 40 0 0 1-8.203-24.33c0-22.192 18.001-40.186 40.21-40.186a40.3 40.3 0 0 1 12.197 1.883v-48.593c-4.61-.631-9.262-.9-13.912-.801v37.822a40.3 40.3 0 0 0-12.203-1.882c-22.208 0-40.208 17.992-40.208 40.187 0 15.694 8.997 29.281 22.119 35.9"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M175.803 92.849c18.683 13.344 41.56 21.195 66.272 21.195V76.631c-13.794-2.937-26.005-10.141-35.186-20.162-15.715-9.802-27.038-25.972-30.358-44.898h-34.643v189.843c-.079 22.132-18.049 40.052-40.21 40.052-13.058 0-24.66-6.221-32.007-15.86-13.12-6.618-22.118-20.206-22.118-35.898 0-22.193 18-40.187 40.208-40.187 4.255 0 8.356.662 12.203 1.882v-37.822c-47.692.985-86.047 39.933-86.047 87.834 0 23.912 9.551 45.589 25.053 61.428 13.985 9.385 30.82 14.86 48.934 14.86 48.545 0 87.9-39.335 87.9-87.857z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00F2EA",
        d: "M242.075 76.63V66.516a66.3 66.3 0 0 1-35.186-10.047 66.47 66.47 0 0 0 35.186 20.163M176.53 11.57a68 68 0 0 1-.728-5.457V0h-47.834v189.845c-.076 22.13-18.046 40.05-40.208 40.05a40.06 40.06 0 0 1-18.09-4.287c7.347 9.637 18.949 15.857 32.007 15.857 22.16 0 40.132-17.918 40.21-40.05V11.571zM99.966 113.58v-10.769a89 89 0 0 0-12.061-.818C39.355 101.993 0 141.327 0 189.845c0 30.419 15.467 57.227 38.971 72.996-15.502-15.838-25.053-37.516-25.053-61.427 0-47.9 38.354-86.848 86.048-87.833"
    }));

const Tina = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 448 621",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#EC4815",
        d: "M287.399 275.676c30.159-24.945 43.523-172.361 56.578-225.351S411.027.023 411.027.023s-14.018 24.395-8.3 42.6c5.717 18.204 44.885 34.476 44.885 34.476l-8.447 22.271s-17.641-2.256-28.138 18.742c-10.497 20.997 13.15 226.773 13.15 226.773S354.684 471.46 354.684 524c0 52.539 24.868 96.572 24.868 96.572h-34.897s-51.193-60.922-61.692-91.369c-10.499-30.446-6.301-60.893-6.301-60.893s-55.645-3.149-104.988 0-82.25 45.566-88.19 69.293c-5.938 23.726-8.398 82.969-8.398 82.969H47.493C30.7 568.744 17.36 550.169 24.596 524c20.043-72.488 16.106-113.601 11.466-131.912S0 357.794 0 357.794c15.392-31.358 31.103-46.426 98.684-47.998s158.555-9.176 188.715-34.12"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EC4815",
        d: "M106.714 520.964s7.13 65.984 45.01 99.609h32.462c-32.462-36.775-36.002-132.632-36.002-132.632-16.511 5.376-39.37 24.624-41.47 33.023"
    }));

const Todoist = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 152 152",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M45.4 250.3c-10.4 0-18.9 8.5-18.9 18.9v113.5c0 10.4 8.5 18.9 18.9 18.9H159c10.4 0 18.9-8.5 18.9-18.9V269.3c0-10.4-8.5-18.9-18.9-18.9H45.4z",
        style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "#e44332",
            fillRule: "nonzero",
            opacity: 1
        },
        transform: "translate(-25.8 -249.8)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m58.6 322 60.8-35.4c1.3-.8 1.4-3.1-.1-3.9s-4.2-2.4-5.3-3c-1.5-.8-3.2-.8-4.7.1-.7.4-49.3 28.7-51 29.6-1.9 1.1-4.4 1.1-6.3 0l-25.7-15.1v12.8c6.2 3.7 21.8 12.8 25.6 15 2.3 1.2 4.5 1.2 6.7-.1m0 24.2 60.8-35.4c1.3-.8 1.4-3.1-.1-3.9s-4.2-2.4-5.3-3c-1.5-.8-3.2-.8-4.7.1-.7.4-49.3 28.7-51 29.6-1.9 1.1-4.4 1.1-6.3 0l-25.7-15.1v12.8c6.2 3.7 21.8 12.8 25.6 15 2.3 1.2 4.5 1.2 6.7-.1m0 25.8 60.8-35.4c1.3-.8 1.4-3.1-.1-3.9s-4.2-2.4-5.3-3c-1.5-.8-3.2-.8-4.7.1-.7.4-49.3 28.7-51 29.6-1.9 1.1-4.4 1.1-6.3 0l-25.7-15.1V357c6.2 3.7 21.8 12.8 25.6 15 2.3 1.2 4.5 1.2 6.7 0",
        style: {
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "#fff",
            fillRule: "nonzero",
            opacity: 1
        },
        transform: "translate(-25.8 -249.8)"
    }));

const TogetherAIDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2159 501",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F1EFED",
        d: "M614.21 158.547c6.46 5.65 11.345 11.647 16.79 18.453l4-32h31q.07 39.38.104 78.759.014 18.287.047 36.574.03 15.95.037 31.903.003 8.434.023 16.87.02 7.962.015 15.926 0 2.9.012 5.8c.037 9.681-.182 19.257-1.12 28.898l-.231 2.41c-2.267 21.01-10.896 41.137-27.44 54.823-26.18 20.615-61.85 23.667-93.974 20.568-25.398-3.021-47.118-12.925-63.848-32.406C471.338 394.208 466 379.724 466 366h35l5 13c8.226 13.71 19.361 20.694 34.645 25.035 21.022 4.655 47.18 4.251 65.812-7.598 13.657-10.05 20.334-23.089 23.073-39.64.47-3.801.584-7.433.568-11.262l-.005-2.055c-.005-2.14-.018-4.278-.03-6.418q-.008-2.192-.014-4.384-.017-5.34-.049-10.678l-1.37 1.79c-13.35 17.323-29.914 29.013-52.08 31.962-30.036 2.917-58.91-1.822-82.636-21.283C478.397 321.11 468.323 303.659 463 284l-.969-3.527c-4.416-19.81-4.408-44.893.969-64.473l1.031-3.809c7.416-24.476 23.478-45.592 45.844-58.252 30.875-16.328 76-18.748 104.336 4.608ZM514 194l-1.805 1.703c-14.695 15.093-17.638 38.726-17.41 58.633.54 20.01 7.747 38.863 21.465 53.539 16.245 15.171 34.55 17.96 55.813 17.304 16.608-1.013 31.333-9.736 42.382-21.863 14.56-18.187 19.223-41.445 16.93-64.316-2.297-19.27-10.021-38.419-25.043-51.285-29.138-21.987-66.726-19.55-92.332 6.285m1458.785-33.836c14.484 12.364 21.496 29.09 23.215 47.836.142 3.484.154 6.965.158 10.452l.015 3.077q.016 3.29.026 6.579.02 5.208.053 10.416c.062 9.867.116 19.735.15 29.602q.032 9.068.1 18.137.021 3.45.026 6.902c.005 3.214.028 6.428.055 9.642l-.009 2.872c.066 5.188.528 8.83 3.426 13.321 3.477 2.779 7.972 2.443 12.25 2.625l7.75.375v32l-12.813.125-3.968.055c-10.879.051-22.747-.202-31.16-7.973-5.835-6.298-8.18-12.97-10.059-21.207l-1.688 1.941c-15.139 17.16-33.36 27.8-56.558 29.264a319 319 0 0 1-10.441.108l-3.739-.015c-21.974-.282-42.883-6.198-59.129-21.657-3.592-3.88-6.144-7.898-8.445-12.641l-1.176-2.395c-6.944-15.631-6.337-34.453-.637-50.355 6.524-15.726 18.16-26.393 33.75-32.938 15.222-5.34 30.484-6.908 46.516-6.703q2.647.012 5.295.018c4.57.015 9.14.054 13.71.098 4.694.042 9.387.06 14.081.08 9.154.042 18.307.11 27.461.195-.082-3.626-.195-7.25-.313-10.875l-.068-3.07c-.41-11.641-3.118-21.644-11.588-29.996-13.96-11.71-31.534-13.42-49.031-12.059-12.547 1.665-24.423 6.282-33.21 15.648-4.168 5.477-7.125 11.693-8.79 18.352h-35c1.749-17.486 7.589-30.526 20-43l2.016-2.121c30.963-30.314 95.18-28.037 127.77-2.715ZM1859.09 269.922c-6.644 8.423-8.87 17.718-7.875 28.379 1.907 9.065 6.737 15.535 14.05 20.976 15.22 9.588 34.714 9.047 51.735 5.723 15.917-4.321 28.867-12.401 37.313-26.75 5.467-9.882 6.853-18.504 6.75-29.648l-.014-2.804A1707 1707 0 0 0 1961 259q-14.528-.106-29.054-.155a3374 3374 0 0 1-13.495-.071c-4.35-.033-8.7-.05-13.052-.059q-2.475-.008-4.95-.032c-14.358-.137-30.548.362-41.36 11.239ZM1480.813 163.25c19.408 16.976 30.991 41.046 33.187 66.75.98 22.04.98 22.04-1 26h-161c2.556 23.007 6.284 40.766 24.375 56 12.24 9.101 25.435 12.395 40.438 12.313l3.225-.018c15.91-.246 29.143-4.844 40.778-16.014 6.966-7.277 11.725-15.446 14.184-25.281h35c-2.204 19.832-11.038 35.2-25 49l-2.21 2.242c-19.582 18.707-45.654 22.615-71.626 22.106-26.953-.994-51.24-11.725-69.926-31.23-15.746-18.086-25.213-41.817-25.476-65.876l-.03-2.233c-.328-31.046-.328-31.046 4.268-46.009l.633-2.118c4.96-16.014 13.5-29.154 25.367-40.882l2.207-2.238c33.989-32.476 97.06-32.17 132.605-2.512ZM1391 177l-2.832 1.285c-15.862 7.964-26.071 19.944-32.293 36.45-1.203 4.163-1.203 4.163-1.875 12.265h124c-1.75-17.495-7.728-30.424-21.172-41.93-18.068-13.226-45.104-17.56-65.828-8.07m-517-12c18.801 16.716 28.602 40.083 31.438 64.75l.245 2.067c.73 8.173-.192 15.835-.683 24.183H743c2.952 20.667 6.042 41.554 23.529 55.192 17.291 12.647 36.27 14.759 57.225 12.382 14.035-3.112 26.961-10.85 34.996-22.824 3.594-5.7 5.568-11.314 8.25-17.75h35c-4.259 23.424-15.999 43.841-35.613 57.781-16.8 11.314-35.51 15.624-55.512 15.531-1.281-.005-2.562-.01-3.882-.017-29.91-.382-54.323-10.776-75.321-32.248C709.822 299.99 705.543 267.112 707 236c2.217-28.117 13.638-54.12 35.117-72.754C779.867 133.834 837.27 134.06 874 165m-115 29c-8.456 9.94-11.682 20.25-14 33h125c-2.997-17.98-9.237-32.84-24.45-43.758C817.053 165.436 782.06 169.885 759 194m331-127h34l1 108 11-13c20.065-16.686 42.721-22.054 68.474-19.782 10.047 1.174 19.308 3.516 28.526 7.782l2.82 1.27c7.958 3.933 13.956 9.524 20.18 15.73l1.809 1.738c20.317 21.309 19.662 54.7 19.495 81.945-.019 3.646-.02 7.292-.024 10.938-.01 6.87-.034 13.74-.064 20.61a9790 9790 0 0 0-.065 23.507c-.031 16.088-.086 32.175-.151 48.262h-34l-.06-10.762a26637 26637 0 0 0-.228-35.347q-.076-10.707-.134-21.414-.05-9.345-.12-18.688a3150 3150 0 0 1-.061-9.874c.217-37.616.217-37.616-17.17-69.88-13.272-12.13-29.642-13.658-46.73-13.167-13.428.71-25.403 7.097-34.958 16.308-18.575 20.66-18.986 47.688-19.05 73.86l-.055 7.729a5760 5760 0 0 0-.095 18.124c-.028 6.89-.072 13.78-.117 20.67A18719 18719 0 0 0 1124 354h-34zm-699 99c19.739 17.16 30.757 40.188 34 66 1.793 36.444-3.63 66.431-27.707 95.027-15.913 17.122-41.083 28.147-64.297 29.096-28.72.666-28.72.666-41.996-3.123l-2.057-.586c-24.808-7.302-44.944-23.157-57.654-45.693-15.234-28.264-17.85-62.54-9-93.291 7.702-25.353 23.555-46.356 46.711-59.43 38.732-20.316 88.426-15.928 122 12m-118 27-2.137 2.266C260.408 207.294 253.664 225.054 253 241l-.156 3.438c-.669 22.169 4.997 45.16 20.347 61.882 7.373 6.847 15.35 12.23 24.809 15.68l2.512.965c17.257 5.467 36.703 3.154 52.777-4.54 15.934-8.652 27.7-22.872 32.938-40.312 7.072-25.268 5.146-50.879-7.29-74.175C369.41 188.39 354.587 178.471 337 174c-23.114-4.783-47.785 1.587-64 19M101 86h34v59h53v31h-53c.063 16.795.138 33.589.236 50.383q.07 11.698.11 23.396.034 10.2.103 20.4.037 5.397.049 10.794c.007 4.024.037 8.048.07 12.072l-.005 3.585c.086 7.548.326 15.09 5.75 20.808 6.207 3.609 11.895 3.89 18.898 3.976l2.934.059c3.076.06 6.153.106 9.23.152q3.139.057 6.277.117c5.116.098 10.232.177 15.348.258v32c-6.525.07-13.049.129-19.574.165q-3.318.022-6.636.061c-40.317.466-40.317.466-55.165-12.788-10.601-11.551-11.937-26.34-11.852-41.241v-4.083c-.002-3.665.01-7.33.024-10.994.013-3.841.014-7.682.016-11.523q.011-10.89.043-21.78c.022-8.27.033-16.542.043-24.813.021-17.001.058-34.003.101-51.004H63v-31h38zm860 0h34v59h53v31h-53c.063 16.5.138 32.998.236 49.497q.07 11.493.11 22.986.034 10.023.103 20.046.037 5.3.049 10.603c.007 3.956.037 7.913.07 11.87l-.005 3.506c.09 7.863.249 16.959 5.75 23.055 6.303 3.371 11.895 3.764 18.898 3.851l2.934.059c3.076.06 6.153.106 9.23.152q3.139.057 6.277.117c5.116.098 10.232.177 15.348.258v32a3777 3777 0 0 1-19.629.165q-3.328.022-6.656.061c-40.811.47-40.811.47-55.453-13.62-10.276-11.838-11.736-27.624-11.603-42.68V293.9c-.002-3.594.016-7.188.037-10.782.019-3.774.02-7.548.024-11.323.01-7.125.034-14.25.064-21.375.034-8.121.05-16.242.065-24.364.031-16.685.086-33.37.151-50.056h-38v-31h38zm594 59h31l4 28 5.188-5.938c11.257-12.361 24.142-19.695 40.812-22.062q3.136-.114 6.273-.098l3.154.008 3.948.028L1662 145v33l-10.563.313c-16.059.635-31.373 2.245-43.628 13.687-13.515 14.945-16.91 36.376-17.014 55.74l-.03 3.491a6450 6450 0 0 0-.081 11.363l-.063 7.902q-.074 9.318-.138 18.635-.076 10.615-.16 21.229-.17 21.82-.323 43.64h-35zm502 0h34v209h-34z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#217AFF",
        d: "M1740.313 293.813c7.498 6.155 12.256 13.45 13.562 23.125.587 9.242-1.76 17.966-7.598 25.195-5.975 6.438-13.097 10.307-21.906 11.105-9.795.248-17.556-1.584-25.246-7.863-5.62-5.368-9.784-12.759-10.363-20.598-.214-11.05 1.248-19.635 9.043-27.953 12.185-10.125 29.293-12.476 42.507-3.012Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F1EFED",
        d: "M2087 67c4.633 4.304 8.654 8.732 9.336 15.172.088 8.071-.073 14.285-5.762 20.348-6.206 5.564-12.086 5.94-20.125 5.78-4.627-.403-7.927-1.211-11.449-4.3-6.096-7.422-7.678-13.5-7-23 1.071-6.181 4.122-9.731 8.965-13.59 7.329-5.078 18.434-5.178 26.035-.41"
    }));

const TogetherAILight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2159 500",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#13171B",
        d: "M615.473 158.84c5.214 4.374 9.075 9.323 12.898 14.937 1.439 2.318 1.439 2.318 3.629 3.223l.148-2.938c.4-7.362.951-14.68 1.852-22l.251-2.095c.623-4.841.623-4.841 1.749-5.967a153 153 0 0 1 6.66-.098l2.014.005c2.13.005 4.259.018 6.389.03A3970 3970 0 0 1 666 144a82745 82745 0 0 1 .103 79.202q.014 18.39.047 36.78.03 16.038.037 32.079.003 8.483.023 16.965.02 8.006.015 16.013 0 2.917.012 5.834c.11 29.078-2.49 59.37-23.863 81.315-17.988 17.689-44.26 24.8-68.984 25.05l-2.427.03c-33.444.324-33.444.324-47.964-4.268l-3.613-1.133c-19.789-7.022-36.24-18.861-46.2-37.617-4.28-9.042-7.186-18.188-7.186-28.25h35l5 13c9.123 14.307 22.304 21.295 38.469 25.254 4.537.959 8.899 1.58 13.531 1.746l2.973.121c19.026.393 38.732-3.004 53.27-16.148 11.47-11.97 15.922-28.186 15.855-44.438l-.005-2.055c-.005-2.14-.018-4.278-.03-6.418q-.008-2.192-.014-4.384-.017-5.34-.049-10.678l-1.795 2.237-2.396 2.962-2.358 2.925C609.626 346.348 590.89 353.948 570 356c-25.036 1.745-53.63-2.994-73.285-19.71-3.005-2.666-5.858-5.468-8.715-8.29l-1.984-1.766c-17.071-15.504-24.97-41.86-26.239-64.145-.14-4.217-.164-8.432-.152-12.651l.002-2.26c.04-12.089.853-23.54 4.373-35.178l.633-2.126c4.991-16.11 13.6-28.961 25.367-40.874l1.762-1.98c29.833-32.84 89.826-33.393 123.71-8.18Zm-99.262 31.765c-17.097 17.898-21.903 39.863-21.461 63.903.412 11.893 2.987 22.763 8.25 33.492l1.152 2.387c8.107 15.64 20.942 26.21 37.536 31.87 17.938 5.348 37.3 4.013 54.125-4.32 17.137-10.038 28.25-25.977 33.335-45.039 5.407-24.75 2.876-50.486-10.96-72.148-9.673-13.8-23.455-23.984-40.204-27.128-22.91-3.879-44.403.756-61.773 16.983m1392.537-48.845c2.153-.01 4.305-.04 6.457-.072 23.198-.18 44.74 5.894 62.045 21.937 17.273 18.107 19.04 41.261 19.024 65.012q.002 5.176.03 10.354.067 14.704.077 29.41c.005 6.019.03 12.038.065 18.057q.015 3.43.007 6.86c-.007 3.19.01 6.379.033 9.568l-.025 2.848c.07 5.533.643 9.007 4.539 13.266 6.277 2.805 6.277 2.805 19 3v31l-14.688.25-4.545.11c-9.733.08-20.31-.541-28.33-6.735-6.035-6.5-8.088-13.202-10.437-21.625l-1.547 1.871c-15.02 17.496-34.586 27.16-57.453 29.129-22.73 1.136-48.9-1.392-66.798-16.939-13.133-11.959-18.983-24.608-20.386-42.39-.54-17.161 4.818-34.223 16.446-47.023 19.35-18.35 47.052-21.017 72.39-20.843l4.913.008q6.384.014 12.769.05c4.364.02 8.729.03 13.094.04q12.786.032 25.572.097c-.12-3.7-.256-7.399-.395-11.098l-.101-3.16c-.502-12.857-4.28-22.059-13.692-30.93-12.222-9.902-29.04-11.7-44.198-10.418-14.008 1.487-27.172 6.139-36.712 16.993-4.247 5.744-6.118 10.654-8.902 17.613h-34c1.933-19.333 9.196-35.258 24.305-47.934 18.273-13.45 39.102-18.246 61.443-18.306m-50.81 129.115c-5.628 7.16-7.817 16.1-6.938 25.125 2.204 10.486 7.214 17.83 16 24 17.977 8.73 39.41 8.138 58.129 1.969 14.487-5.477 25.403-15.31 31.84-29.446L1958 290l.969-2.336c2.213-6.495 2.176-12.772 2.105-19.55l-.016-2.951A1555 1555 0 0 0 1961 258q-13.47-.106-26.943-.155a2779 2779 0 0 1-12.515-.071c-4.04-.033-8.08-.05-12.119-.059a639 639 0 0 1-4.582-.032c-16.223-.167-35.044.616-46.904 13.192ZM857 153l2.754 1.398c21.417 11.895 34.879 31.84 41.727 54.96 2.453 8.725 3.66 17.116 4.207 26.142l.147 2.337c.309 6.27-.253 11.758-.835 18.163H743c3.687 26.282 3.687 26.282 17 48l1.867 2.203c9.89 10.752 24.546 16.986 39.066 17.922 18.305.685 35.11-2.134 49.505-14.438 8.2-7.958 12.076-15.922 16.562-26.687h35c-3.376 16.878-9.6 31.038-21 44l-1.984 2.273c-15.854 16.986-38.282 25.709-61.258 26.837-31.775.824-59.425-6.888-82.946-28.86-22.392-23.573-28.545-53.96-28.058-85.54.837-29.547 11.394-55.71 32.7-76.401C770.653 137.027 820.428 134.323 857 153m-98.504 40.82c-8.45 10.665-11.25 19.699-13.496 33.18h125c-3.426-18.271-7.937-31.554-22.629-43.059-28.015-18.962-66.117-15.755-88.875 9.88ZM1476 159c4.29 3.373 8.17 7.119 12 11l2.02 2.023c17.564 18.794 24.196 45.31 24.105 70.352l.012 3.309-.004 3.152-.004 2.86C1514 254 1514 254 1513 256h-161c2.372 21.35 6.097 40.73 23.344 54.93 15.372 11.334 33.984 15.447 52.824 12.76 15.18-2.745 28.878-9.13 38.125-21.842 4.057-6.333 6.266-11.524 8.707-18.848h35c-.704 6.335-1.39 11.133-3.625 16.875l-.805 2.093c-8.77 21.933-26.323 37.726-47.507 47.344-24.736 10.149-55.504 9.26-80.47.196-10.553-4.428-20.081-9.775-28.593-17.508l-2.703-2.422c-18.293-17.271-29.267-42.105-30.474-67.268-.56-36.098 3.723-67.598 29.654-94.92 33.748-31.879 92.742-35.217 130.523-8.39m-109 35c-7.319 9.591-13 20.764-13 33h124c-1.657-18.226-8.095-31.104-22-43-28.006-20.326-66.22-14.785-89 10M1090 67h34l1 108 7-9c12.857-14.07 30.177-22.973 49.259-24.211 26.024-1.005 50.682 2.357 70.928 20.274 16.24 15.137 23.115 37.286 24.813 58.937.135 4.38.127 8.757.114 13.139v3.905q-.001 5.262-.013 10.523c-.006 3.676-.006 7.351-.008 11.027q-.004 10.422-.021 20.845-.015 11.872-.022 23.746-.016 24.408-.05 48.815h-34l-.06-10.762a26637 26637 0 0 0-.228-35.347q-.076-10.707-.134-21.414-.05-9.345-.12-18.688a3150 3150 0 0 1-.061-9.874c-.033-37.39-.033-37.39-17.46-69.665-10.286-9.53-24.78-13.12-38.437-13.625-15.466.594-30.52 5.328-42 16-19.195 21.13-19.789 47.887-19.914 74.898a8637 8637 0 0 0-.175 25.704c-.039 6.852-.088 13.703-.138 20.555A28285 28285 0 0 0 1124 353h-34zm-700.312 97.313C410.145 181.708 421.704 205.577 425 232c.208 4.724.228 9.447.24 14.176.01 2.225.04 4.449.072 6.674.1 13.349-1.618 26.175-6.437 38.713l-.91 2.394C412.7 307.292 405.15 317.966 395 328l-2.395 2.426c-19.696 18.913-46.763 26.189-73.529 25.926-25.28-.757-49.016-8.343-68.076-25.352-.82-.726-1.64-1.451-2.484-2.2-18.422-17.305-29.596-43.574-30.639-68.76-.745-30.648 3.212-58.348 23.123-83.04l2.05-2.55c35.832-42.12 104.725-43.056 146.637-10.137Zm-114.825 25.699c-16.193 17.28-22.446 39.397-22.078 62.629.436 12.025 3.211 23.42 8.215 34.359l1.27 2.824C269.77 304.976 283.173 316.3 299 322c18.675 5.657 37.925 4.213 55.3-4.674 6.046-3.29 10.94-7.354 15.7-12.326l1.879-1.785c14.556-14.817 18.397-37.249 18.44-57.091-.22-18.014-5.1-34.84-16.319-49.124l-1.734-2.305c-10.268-12.68-26.11-20.14-42.079-22.132-20.062-2.038-40.37 3.485-55.324 17.449M101 86h34v58h53v32h-53c.063 16.664.138 33.328.236 49.992q.07 11.607.11 23.214.034 10.122.103 20.242.037 5.355.049 10.71c.007 3.993.037 7.986.07 11.978l-.005 3.558c.086 7.515.551 14.675 5.375 20.743 6.507 4.93 13.752 4.728 21.617 4.88l2.732.062q4.293.097 8.588.183l5.844.131c4.76.108 9.52.207 14.281.307v31c-7.256.092-14.51.172-21.765.22q-3.692.03-7.384.082c-37.527.518-37.527.518-51.835-12.044-10.755-11.077-12.327-26.282-12.243-40.948v-4.082c-.002-3.67.01-7.338.024-11.007.013-3.843.014-7.687.016-11.53q.011-10.902.043-21.802c.022-8.278.033-16.556.043-24.834.021-17.019.058-34.037.101-51.055H63v-32h38zm860 0h34v58h53v32h-53q.127 24.605.288 49.21.076 11.426.134 22.85.05 9.964.12 19.926.04 5.27.061 10.543c.016 3.93.046 7.86.078 11.791l.007 3.5c.053 12.362.053 12.362 5.312 23.18 7.132 3.698 13.604 4.166 21.457 4.316l2.736.063q4.31.098 8.62.183l5.857.131c4.777.108 9.553.207 14.33.307v31c-7.256.092-14.51.172-21.765.22q-3.692.03-7.384.082c-37.856.523-37.856.523-51.613-11.892-11.057-11.837-12.715-27.99-12.579-43.484V293.9c-.002-3.594.016-7.188.037-10.782.019-3.774.02-7.548.024-11.323q.017-10.688.064-21.375c.034-8.121.05-16.242.065-24.364.031-16.685.086-33.37.151-50.056h-38v-32h38zm594 58h31l4 28c4.656-4.446 4.656-4.446 6.96-7.531 10.525-12.742 26.635-18.625 42.58-20.286 4.34-.323 8.673-.287 13.023-.245L1662 144v34c-12.75.313-12.75.313-16.69.388-13.6.422-26.567 3.12-36.935 12.424-13.875 14.834-17.476 36.261-17.58 55.815l-.03 3.49a6416 6416 0 0 0-.081 11.38l-.063 7.906q-.074 9.328-.138 18.656-.076 10.626-.16 21.25-.17 21.846-.323 43.691h-35zm502 0h34v209h-34z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0262F2",
        d: "M1737 291c8.363 4.823 13.282 11.64 15.938 20.875 2.078 9.893.687 17.515-4.141 26.39-5.07 7.715-12.428 12.344-21.39 14.301-8.447 1.153-16.363-.36-23.844-4.441-6.967-5.777-12.966-11.977-14.563-21.125-.873-11.015.163-19.604 7.25-28.313 10.431-11.056 26.871-14.774 40.75-7.687"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#13171B",
        d: "M2085.5 65.5c5.049 3.03 8.656 7.969 10.5 13.5.146 2.268.221 4.54.25 6.813l.078 3.644c-.59 6.378-3.514 10.477-8.328 14.543-6.045 4.228-11.756 4.837-19 4-6.188-1.114-9.718-4.1-13.59-8.969-3.997-5.757-4.296-12.224-3.41-19.031 2.26-7.125 5.563-11.304 12-15 6.491-2.164 15.167-2.291 21.5.5"
    }));

const Ton = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 56 56",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0098EA",
        d: "M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M37.56 15.628H18.44c-3.516 0-5.745 3.792-3.976 6.858l11.801 20.455c.77 1.335 2.7 1.335 3.47 0l11.804-20.455c1.767-3.06-.462-6.858-3.975-6.858zM26.255 36.807l-2.57-4.974-6.202-11.092c-.409-.71.096-1.62.953-1.62h7.816V36.81zM38.51 20.739l-6.2 11.096-2.57 4.972V19.119h7.817c.857 0 1.362.91.953 1.62"
    }));

const Tor = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "50%",
        y1: "100%",
        y2: "0%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#420C5D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#951AD1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "50%",
        x2: "50%",
        y1: "100%",
        y2: "0%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#420C5D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#951AD1"
    }))), /*#__PURE__*/ React.createElement("circle", {
        cx: 128,
        cy: 128,
        r: 123,
        fill: "#F2E4FF"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M128.263 232.72v-15.517c49.15-.142 88.947-40.02 88.947-89.207 0-49.182-39.797-89.06-88.947-89.203V23.277c57.72.145 104.46 46.968 104.46 104.72 0 57.755-46.74 104.58-104.46 104.723m0-54.31c27.722-.145 50.161-22.652 50.161-50.414 0-27.758-22.439-50.264-50.161-50.41V62.073c36.295.142 65.678 29.596 65.678 65.923 0 36.331-29.383 65.785-65.678 65.927zm0-77.55c14.87.141 26.888 12.23 26.888 27.136 0 14.91-12.018 27-26.888 27.141zM0 127.995C0 198.692 57.304 256 128 256c70.692 0 128-57.308 128-128.004C256 57.304 198.692 0 128 0 57.304 0 0 57.304 0 127.996Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M12.5 14.5c63.789 0 115.5 51.487 115.5 115s-51.711 115-115.5 115z",
        transform: "matrix(-1 0 0 1 140.5 0)"
    }));

const Tron = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 201 193",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FF060A",
        d: "M100.8 192.148c55.249 0 100-42.912 100-95.824S156.049.5 100.8.5.8 43.412.8 96.324s44.79 95.824 100 95.824"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M157.045 79.12c-5.517-4.904-13.18-12.375-19.387-17.662l-.383-.23a8 8 0 0 0-2.031-1.111c-15.019-2.682-84.904-15.21-86.245-15.058a2.6 2.6 0 0 0-1.073.384l-.344.268c-.422.421-.767.92-.958 1.494l-.077.23v1.456c7.855 20.996 38.927 89.732 45.058 105.9.383 1.111 1.072 3.18 2.375 3.295h.307c.69 0 3.678-3.793 3.678-3.793s53.371-61.992 58.774-68.582a18 18 0 0 0 1.839-2.606 3.74 3.74 0 0 0-.192-2.145c-.268-.69-.766-1.341-1.341-1.84m-45.44 7.242 22.758-18.084 13.372 11.8zm-8.851-1.188L63.559 54.37l63.448 11.226zm3.525 8.046 40.115-6.207-45.862 52.989zM58.233 57.473l41.264 33.525-5.977 49.042z"
    }));

const TrustPilot = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "20.5 248.5 600 147.3",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M178.2 300.7h60.7V312H215v63.7h-13.1V312h-23.8zm58.1 20.7h11.2v10.5h.2c.4-1.5 1.1-2.9 2.1-4.3s2.2-2.7 3.7-3.8c1.4-1.2 3-2.1 4.8-2.8 1.7-.7 3.5-1.1 5.3-1.1 1.4 0 2.4.1 2.9.1.5.1 1.1.2 1.6.2v11.5c-.8-.2-1.7-.3-2.6-.4s-1.7-.2-2.6-.2q-3 0-5.7 1.2c-2.7 1.2-3.3 2-4.7 3.5-1.3 1.6-2.4 3.5-3.2 5.8s-1.2 5-1.2 8v25.8h-12zm86.8 54.3h-11.8v-7.6h-.2c-1.5 2.8-3.7 4.9-6.6 6.6s-5.9 2.5-8.9 2.5c-7.1 0-12.3-1.7-15.5-5.3-3.2-3.5-4.8-8.9-4.8-16v-34.5h12v33.3c0 4.8.9 8.2 2.8 10.1 1.8 2 4.4 3 7.7 3q3.75 0 6.3-1.2c2.55-1.2 3.1-1.8 4.1-3.1 1.1-1.3 1.8-2.9 2.3-4.7s.7-3.8.7-5.9v-31.5h12v54.3zm20.4-17.4c.4 3.5 1.7 5.9 4 7.4 2.3 1.4 5.1 2.1 8.3 2.1 1.1 0 2.4-.1 3.8-.3s2.8-.5 4-1c1.3-.5 2.3-1.2 3.1-2.2s1.2-2.2 1.1-3.7-.6-2.8-1.7-3.8-2.4-1.7-4-2.4c-1.6-.6-3.5-1.1-5.6-1.5s-4.2-.9-6.4-1.4-4.4-1.1-6.5-1.8-3.9-1.6-5.6-2.9c-1.6-1.2-3-2.7-3.9-4.6-1-1.9-1.5-4.1-1.5-6.9 0-3 .7-5.4 2.2-7.4 1.4-2 3.3-3.6 5.5-4.8s4.7-2.1 7.4-2.6 5.3-.7 7.7-.7c2.8 0 5.5.3 8 .9s4.9 1.5 6.9 2.9c2.1 1.3 3.8 3.1 5.1 5.2 1.4 2.1 2.2 4.7 2.6 7.7h-12.5c-.6-2.9-1.9-4.8-3.9-5.8-2.1-1-4.4-1.5-7.1-1.5-.8 0-1.9.1-3 .2-1.2.2-2.2.4-3.3.8-1 .4-1.9 1-2.6 1.7s-1.1 1.7-1.1 2.9c0 1.5.5 2.6 1.5 3.5s2.3 1.6 4 2.3c1.6.6 3.5 1.1 5.6 1.5s4.3.9 6.5 1.4 4.3 1.1 6.4 1.8 4 1.6 5.6 2.9c1.6 1.2 3 2.7 4 4.5s1.5 4.1 1.5 6.7c0 3.2-.7 5.9-2.2 8.2-1.5 2.2-3.4 4.1-5.7 5.5s-5 2.4-7.8 3.1c-2.9.6-5.7 1-8.5 1-3.4 0-6.6-.4-9.5-1.2s-5.5-2-7.6-3.5c-2.1-1.6-3.8-3.5-5-5.9-1.2-2.3-1.9-5.1-2-8.4h12.1v.1zm39.5-36.9h9.1V305h12v16.3h10.8v8.9h-10.8v29c0 1.3.1 2.3.2 3.3.1.9.4 1.7.7 2.3.4.6 1 1.1 1.7 1.4.8.3 1.8.5 3.2.5.8 0 1.7 0 2.5-.1s1.7-.2 2.5-.4v9.3c-1.3.2-2.6.3-3.9.4-1.3.2-2.5.2-3.9.2-3.2 0-5.7-.3-7.6-.9s-3.4-1.5-4.5-2.6c-1.1-1.2-1.8-2.6-2.2-4.3s-.6-3.8-.7-6v-32H383v-9.1zm40.3 0h11.3v7.4h.2c1.7-3.2 4-5.4 7-6.8s6.2-2.1 9.8-2.1c4.3 0 8 .7 11.2 2.3 3.2 1.5 5.8 3.5 7.9 6.2 2.1 2.6 3.7 5.7 4.7 9.2s1.6 7.3 1.6 11.2c0 3.7-.5 7.2-1.4 10.6-1 3.4-2.4 6.5-4.3 9.1s-4.3 4.7-7.3 6.3-6.4 2.4-10.4 2.4c-1.7 0-3.5-.2-5.2-.5s-3.4-.8-5-1.5-3.1-1.6-4.4-2.7c-1.4-1.1-2.5-2.4-3.4-3.8h-.2v27.1h-12v-74.4zm41.9 27.2c0-2.4-.3-4.8-1-7.1-.6-2.3-1.6-4.3-2.9-6.1s-2.9-3.2-4.7-4.3c-1.9-1.1-4.1-1.6-6.5-1.6-5 0-8.8 1.7-11.4 5.2-2.5 3.5-3.8 8.2-3.8 14 0 2.8.3 5.3 1 7.6s1.6 4.3 3 6c1.3 1.7 2.9 3 4.8 4s4 1.5 6.5 1.5c2.8 0 5-.6 6.9-1.7s3.4-2.6 4.7-4.3c1.2-1.8 2.1-3.8 2.6-6.1.5-2.4.8-4.7.8-7.1m21.1-47.9h12V312h-12zm0 20.7h12v54.3h-12zm22.7-20.7h12v75h-12zm48.6 76.5c-4.3 0-8.2-.7-11.6-2.2s-6.2-3.4-8.6-5.9c-2.3-2.5-4.1-5.6-5.3-9.1s-1.9-7.4-1.9-11.5.6-7.9 1.9-11.4c1.2-3.5 3-6.5 5.3-9.1 2.3-2.5 5.2-4.5 8.6-5.9s7.3-2.2 11.6-2.2 8.2.7 11.6 2.2c3.4 1.4 6.2 3.4 8.6 5.9 2.3 2.5 4.1 5.6 5.3 9.1s1.9 7.3 1.9 11.4c0 4.2-.6 8-1.9 11.5s-3 6.5-5.3 9.1c-2.3 2.5-5.2 4.5-8.6 5.9s-7.2 2.2-11.6 2.2m0-9.5c2.6 0 5-.6 6.9-1.7 2-1.1 3.5-2.6 4.8-4.4s2.2-3.9 2.8-6.1c.6-2.3.9-4.6.9-7q0-3.45-.9-6.9c-.9-3.45-1.5-4.3-2.8-6.1s-2.9-3.2-4.8-4.3c-2-1.1-4.3-1.7-6.9-1.7s-5 .6-6.9 1.7c-2 1.1-3.5 2.6-4.8 4.3-1.3 1.8-2.2 3.8-2.8 6.1s-.9 4.6-.9 6.9c0 2.4.3 4.7.9 7s1.5 4.3 2.8 6.1 2.9 3.3 4.8 4.4c2 1.2 4.3 1.7 6.9 1.7m31-46.3h9.1V305h12v16.3h10.8v8.9h-10.8v29c0 1.3.1 2.3.2 3.3.1.9.4 1.7.7 2.3.4.6 1 1.1 1.7 1.4.8.3 1.8.5 3.2.5.8 0 1.7 0 2.5-.1s1.7-.2 2.5-.4v9.3c-1.3.2-2.6.3-3.9.4-1.3.2-2.5.2-3.9.2-3.2 0-5.7-.3-7.6-.9s-3.4-1.5-4.5-2.6c-1.1-1.2-1.8-2.6-2.2-4.3s-.6-3.8-.7-6v-32h-9.1v-9.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00b67a",
        d: "M164.2 300.7h-54.9l-16.9-52.2-17 52.2-54.9-.1 44.4 32.3-17 52.2 44.4-32.3 44.4 32.3-16.9-52.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#005128",
        d: "m123.6 344.7-3.8-11.8-27.4 19.9z"
    }));

const TrustWallet = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 444 501",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0500FF",
        d: "M.71 72.41 222.16.11v500.52C63.98 433.89.71 305.98.71 233.69z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M443.62 72.41 222.17.11v500.52c158.18-66.74 221.45-194.65 221.45-266.94z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 385.26,
        x2: 216.61,
        y1: -34.78,
        y2: 493.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.02,
        stopColor: "#00F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.08,
        stopColor: "#0094FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.16,
        stopColor: "#48FF91"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.42,
        stopColor: "#0094FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.68,
        stopColor: "#0038FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopColor: "#0500FF"
    }))));

const Turbopack = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 293",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "49.855%",
        y1: "7.896%",
        y2: "93.343%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0096FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF1E56"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M128 0 46.16 46.768l.16 36.752L128 36.848l96 54.864L256 110V73.136zm-14.4 247.488L32 200.864V91.792l-.032-.016-.176-36.8L0 73.136v146.288l81.68 46.672zM224 200.864v-92.56l32 18.288v92.832l-128 73.152-31.888-18.224L128 255.76v-.048z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M46.4 108.369v84.128l81.6 46.64v-84.144zM128 53.441l-74.352 42.48 81.616 46.64 74.336-42.496z"
    }));

const Turborepo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 318",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "123.779%",
        x2: "123.779%",
        y1: "0%",
        y2: "698.962%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#1E90FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF1E56"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "11.486%",
        x2: "11.486%",
        y1: "-2.194%",
        y2: "512.398%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#1E90FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF1E56"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "-153.743%",
        x2: "-153.743%",
        y1: "-62.263%",
        y2: "278.479%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#1E90FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF1E56"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "-153.743%",
        x2: "-153.743%",
        y1: "-178.48%",
        y2: "162.264%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#1E90FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF1E56"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: "11.486%",
        x2: "11.486%",
        y1: "-412.397%",
        y2: "102.194%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#1E90FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF1E56"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__f",
        x1: "123.779%",
        x2: "123.779%",
        y1: "-598.961%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#1E90FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FF1E56"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M103.41.095C66.837-1.166 30.268 10.183 0 34.144l20.177 11.35c23.962-17.656 54.226-25.222 83.233-23.961z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M210.6 48.016c-25.222-26.483-58.01-42.877-93.319-46.66v21.438c30.268 5.044 56.75 18.916 78.188 40.355z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M256 151.424c-1.26-32.788-13.871-65.576-35.309-93.32l-15.136 15.133c17.657 23.96 27.747 50.444 29.008 78.187z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M220.691 259.877c21.438-27.744 34.049-60.532 35.309-93.32h-21.437c-1.26 27.744-11.351 54.227-29.008 78.187z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M117.281 316.626c34.049-3.783 68.097-20.178 93.32-46.66l-15.132-15.133c-21.437 22.7-49.185 36.571-78.188 40.354z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__f)",
        d: "M0 283.838c30.268 23.96 66.837 35.31 103.41 34.049v-21.439c-29.007 1.262-58.01-6.305-83.233-23.96z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M97.651 71.344q20.218 0 37.321 6.886 17.103 6.665 29.324 18.66 12.438 11.997 19.326 28.214 6.888 15.994 6.887 34.655.001 18.66-6.887 34.877-6.888 15.995-19.326 27.99-12.22 11.997-29.324 18.883-17.103 6.665-37.32 6.665-20.44 0-37.544-6.665c-11.257-4.591-20.954-10.885-29.101-18.882q-12.219-11.997-19.105-27.991-6.887-16.217-6.887-34.877t6.887-34.655q6.886-16.218 19.105-28.213c8.147-7.998 17.844-14.218 29.101-18.66 11.402-4.592 23.92-6.887 37.543-6.887m0 42.208q-9.554 0-18.216 3.554c-5.626 2.222-10.59 5.406-14.884 9.553q-6.441 6.22-10.219 14.661-3.775 8.442-3.776 18.439.001 9.996 3.776 18.438 3.777 8.442 10.22 14.662c4.293 4.147 9.257 7.404 14.883 9.774q8.663 3.333 18.216 3.332 9.555 0 17.994-3.332 8.665-3.554 15.106-9.774 6.666-6.22 10.441-14.662t3.777-18.438q0-9.997-3.777-18.439-3.775-8.441-10.44-14.661-6.442-6.22-15.107-9.553-8.439-3.555-17.994-3.554"
    }));

const TursoDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 201 170",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1ebca1",
        d: "M100.055 170c-2.19 0-18.2-12.8-21.3-16.45-2.44 3.73-6.44 7.96-6.44 7.96-11.05-5.57-25.17-20.06-27.83-25.13-2.62-5-12.13-62.58-12.39-79.3-.34-9.41 5.85-28.49 67.96-28.49s68.29 19.08 67.96 28.49c-.25 16.72-9.76 74.3-12.39 79.3-2.66 5.07-16.78 19.56-27.83 25.13 0 0-4-4.23-6.44-7.96-3.1 3.65-19.11 16.45-21.3 16.45"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#183134",
        d: "M100.055 132.92c-20.73 0-33.96-10.95-33.96-10.95l1.91-26.67-21.75-1.94-3.91-31.55h115.43l-3.91 31.55-21.75 1.94 1.91 26.67s-13.23 10.95-33.96 10.95z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4ff8d2",
        d: "m121.535 75.79 78.52-27.18C195.385 20.67 170.895 0 170.895 0v30.78l-14.54 3.75-9.11-10.97-7.8 15.34-39.38 10.16-39.38-10.16-7.8-15.34-9.11 10.97-14.54-3.75V0S4.725 20.67.055 48.61l78.52 27.18-2.8 37.39c6.7 1.7 13.75 3.39 24.28 3.39s17.57-1.69 24.27-3.39l-2.8-37.39z"
    }));

const TursoLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 201 170",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#183134",
        d: "M200.035 48.61C195.365 20.67 170.875 0 170.875 0v30.78l-14.54 3.75-9.11-10.97-4.81 9.46c-9.92-2.7-23.58-4.44-42.37-4.44s-32.45 1.75-42.37 4.44l-4.81-9.46-9.11 10.97-14.54-3.75V0S4.725 20.67.055 48.61l32.14 11.12c1.05 19.43 9.79 71.88 12.29 76.64 2.66 5.07 16.78 19.56 27.83 25.13 0 0 4-4.23 6.44-7.96 3.1 3.65 19.11 16.45 21.3 16.45s18.2-12.79 21.3-16.45c2.44 3.73 6.44 7.96 6.44 7.96 11.05-5.57 25.17-20.06 27.83-25.13 2.5-4.76 11.24-57.21 12.29-76.64l32.14-11.12zm-46.19 44.74-21.75 1.94 1.91 26.67s-13.23 10.95-33.96 10.95-33.96-10.95-33.96-10.95l1.91-26.67-21.75-1.94-3.72-30.04 36.05 12.48-2.8 37.39c6.7 1.7 13.75 3.39 24.28 3.39s17.57-1.69 24.27-3.39l-2.8-37.39 36.05-12.48-3.72 30.04z"
    }));

const Twilio = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#e31e26",
        transform: "translate(0 .047)scale(.93704)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M34.1 0C15.3 0 0 15.3 0 34.1s15.3 34.1 34.1 34.1C53 68.3 68.3 53 68.3 34.1S53 0 34.1 0m0 59.3C20.3 59.3 9 48 9 34.1 9 20.3 20.3 9 34.1 9 48 9 59.3 20.3 59.3 34.1 59.3 48 48 59.3 34.1 59.3"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 42.6,
        cy: 25.6,
        r: 7.1
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 42.6,
        cy: 42.6,
        r: 7.1
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 25.6,
        cy: 42.6,
        r: 7.1
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 25.6,
        cy: 25.6,
        r: 7.1
    })));

const Twitch = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 2400 2800",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m2200 1300-400 400h-400l-350 350v-350H600V200h1600z"
    }), /*#__PURE__*/ React.createElement("g", {
        fill: "#9146ff"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M500 0 0 500v1800h600v500l500-500h400l900-900V0zm1700 1300-400 400h-400l-350 350v-350H600V200h1600z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1700 550h200v600h-200zm-550 0h200v600h-200z"
    })));

const Twitter = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 209",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#55acee",
        d: "M256 25.45a105 105 0 0 1-30.166 8.27c10.845-6.5 19.172-16.793 23.093-29.057a105.2 105.2 0 0 1-33.351 12.745C205.995 7.201 192.346.822 177.239.822c-29.006 0-52.523 23.516-52.523 52.52 0 4.117.465 8.125 1.36 11.97-43.65-2.191-82.35-23.1-108.255-54.876-4.52 7.757-7.11 16.78-7.11 26.404 0 18.222 9.273 34.297 23.365 43.716a52.3 52.3 0 0 1-23.79-6.57q-.004.33-.003.661c0 25.447 18.104 46.675 42.13 51.5a52.6 52.6 0 0 1-23.718.9c6.683 20.866 26.08 36.05 49.062 36.475-17.975 14.086-40.622 22.483-65.228 22.483-4.24 0-8.42-.249-12.529-.734 23.243 14.902 50.85 23.597 80.51 23.597 96.607 0 149.434-80.031 149.434-149.435q0-3.417-.152-6.795A106.8 106.8 0 0 0 256 25.45"
    }));

const TypeGPUDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 166 166",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M70.1 78 47.2 59.2 28 84c-2 2.6-2.5 6-1.2 9.1L45 139.3c1.5 3.8 5 6.5 9 7l60.8 7.7-9.9-24.4c-9.4-21.4-18.5-38-34.8-51.6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M142.4 103.8 124 56.6a9.3 9.3 0 0 0-8-6l-51-4c-6.7-.4-8.8-4-9.5-5.9l-.3-1L45.3 3l-7.1 16.6a11 11 0 0 0 3 12.7L57 46l14.6 12c20.5 16.8 34 40.4 38.3 66.5l4.8 29.4 26.7-41.8a9.3 9.3 0 0 0 .9-8.4Z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: -4.3,
        x2: 199.3,
        y1: -95.8,
        y2: 225.6,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#D48DFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#7272FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.7,
        stopColor: "#0059DF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 45.6,
        x2: 161.9,
        y1: -25.2,
        y2: 196.7,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#D48DFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.5,
        stopColor: "#5259EE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#1E2FB6"
    }))));

const TypeGPULight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 166 166",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M70.1 79 47.2 60.2 28 85c-2 2.6-2.5 6-1.2 9.1L45 140.3c1.5 3.8 5 6.5 9 7l60.8 7.7-9.9-24.4c-9.4-21.4-18.5-38-34.8-51.6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M142.4 104.8 124 57.6a9.3 9.3 0 0 0-8-6l-51-4c-6.7-.4-8.8-4-9.5-5.9l-.3-1L45.3 4l-7.1 16.6a11 11 0 0 0 3 12.7L57 47l14.6 12c20.5 16.8 34 40.4 38.3 66.5l4.8 29.4 26.7-41.8a9.3 9.3 0 0 0 .9-8.4Z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: -4.3,
        x2: 199.3,
        y1: -94.8,
        y2: 226.6,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.4,
        stopColor: "#D48DFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.6,
        stopColor: "#6C80FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.9,
        stopColor: "#0059DF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 45.6,
        x2: 161.9,
        y1: -24.2,
        y2: 197.7,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.3,
        stopColor: "#D48DFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.8,
        stopColor: "#273DE6"
    }))));

const TypeORM = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 233",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#8E8F8F",
        d: "M138.63 32.23a5.67 5.67 0 0 1 5.66 5.52v64.99a5.67 5.67 0 0 1-5.52 5.67H85.75a5.67 5.67 0 0 1-5.66-5.52V37.9a5.67 5.67 0 0 1 5.52-5.67zm0 2.52H85.75a3.15 3.15 0 0 0-3.14 3.03v64.96c0 1.7 1.35 3.09 3.03 3.15h52.99c1.7 0 3.09-1.35 3.15-3.03V37.9a3.15 3.15 0 0 0-3.15-3.15M93.31 92.67v3.77h-3.78v-3.77zm42.18 0v3.77h-40.3v-3.77zM93.3 76.3v3.78h-3.78V76.3zm42.18 0v3.78h-40.3V76.3zM93.3 60.56v3.78h-3.78v-3.78zm42.18 0v3.78h-40.3v-3.78zm0-14.48v3.78H89.53v-3.78h45.96Zm3.15 75.54v.04a5.67 5.67 0 0 1 5.66 5.48v64.99a5.67 5.67 0 0 1-5.52 5.66H85.75a5.67 5.67 0 0 1-5.66-5.49v-65a5.67 5.67 0 0 1 5.52-5.67h53.02Zm0 2.52H85.75a3.15 3.15 0 0 0-3.14 3.03v64.96c0 1.7 1.35 3.09 3.03 3.15h52.99c1.7 0 3.07-1.34 3.15-3.02v-64.95c0-1.7-1.35-3.09-3.04-3.15h-.11zm-45.32 57.93v3.78h-3.78v-3.78zm42.18.03v3.72h-40.3v-3.72zM93.3 165.7v3.78h-3.78v-3.77h3.78Zm42.18.03v3.72h-40.3v-3.72zM93.3 149.97v3.78h-3.78v-3.78zm42.18.03v3.72h-40.3V150zm0-14.5v3.77H89.53v-3.78h45.96Zm18.4-65.18v3.14h18.88v85.53h-18.88v3.15h22.03V70.32h-3.15z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FE0902",
        d: "M19.33 14.8c3.73-6.11 9.86-9.67 16.05-11.74l.85-.28.84-.25 1.27-.35.83-.21.42-.1.83-.2.41-.08.82-.17.8-.15.8-.14.8-.13.77-.11.76-.1.74-.1.73-.08.7-.07 1.03-.09.97-.07.92-.05 1-.04.92-.03h.56l.52-.01h1.09l.35.01.63.03.28.01v15.11c-13.37-1.27-19.33 2.77-21.96 7.07l-.24.4c-.34.61-.62 1.22-.84 1.82l-.15.4-.06.2-.12.38-.11.38-.1.38-.04.19-.08.36-.03.18-.06.35-.05.34-.04.33-.05.47-.03.44-.02.34v.87l.01.23.02.28.03.33v5.56l-.03 11.33-.04 8.17-.05 6.87-.05 5.81-.05 4.57-.06 4.46-.06 3.8-.07 4.01-.05 2.1-.05 1.98-.07 2.2-.02.7v2.05l-.02.53-.02.8-.03.77-.02.47-.04.47-.03.47-.07.72-.06.47-.06.48-.07.47-.04.24-.08.48-.05.24-.1.47-.1.48-.13.47-.13.47-.15.47-.16.46-.17.47c-1.94 5-6.32 9.45-16.25 11.52 9.66 2 14.07 6.27 16.09 11.1l.18.46c.18.46.34.93.47 1.4l.14.47.23.95.1.48.04.24.08.48.08.48.06.47.06.48.05.48.04.47.04.48.04.7.03.48.02.79.01.52.01.51v.77l.01 1.27.07 2.21.06 2.34.05 2.5.06 2.66.05 3.25.07 5.38.05 4.55.03 2.57.05 6.54.06 9.71.04 10.52.02-.01v9.32l-.02.13-.02.2v.18l-.02.33v.86l.01.34.03.44.03.3.06.48.05.34.06.34.07.36.04.18.08.37.05.18.1.38.12.38.07.2.14.39.15.4.17.39c2.1 4.7 7.64 9.8 21.96 8.63l.79-.07v15.11l-.4.02-.75.02-.61.01H53l-.6-.01-.63-.02-.82-.04-.58-.02-.6-.04-.63-.04-.64-.05-.67-.06-.68-.07-.7-.08-.72-.08-.74-.1-.37-.05-.76-.12-.38-.06-.77-.13-.39-.07-.79-.15-.4-.08-.8-.17-.8-.19-.8-.2-.82-.21c-7.5-2.05-15.36-6.08-19.41-14 .88-9.71 4.87-18 12.06-23.16.33-.24.68-.47 1.02-.7l.4-.24c-.5.3-.97.62-1.44.95-7.17 5.15-11.16 13.44-12.04 23.12a26.6 26.6 0 0 1-2.76-11.7l-.1-4.17-.1-5.05-.16-5.91-.2-7.54-.18-6.53-.25-8.56-.28-9.17-.48-14.42-.11-3.35c-.29-7.57-3.32-11.26-6.49-13.04l-.37-.2-.19-.1-.37-.17-.37-.16-.37-.14c-.12-.05-.24-.1-.36-.13l-.37-.12-.35-.1-.29-.08-.27-.06-.28-.06-.27-.06-.39-.06-.25-.04-.24-.03-.36-.04h-.31l-.64-.01H0v-17.7c.83.02 1.57 0 2.3-.03l.35-.04.24-.03.25-.04.4-.07.26-.05.28-.06.27-.07.29-.07.35-.1.37-.12.36-.13c3.68-1.38 7.83-4.91 8.16-13.82l.43-12.8.33-10.47.18-5.94.27-9.53.19-6.62.13-5.05.16-6.76.1-4.2.07-3.33c.1-5.25 1.4-9.5 3.46-12.97zv-.01Zm180.64.37V.05l.41-.02.57-.02h.36l.65-.01h1.03l.83.02 1.06.04.57.03.6.03.93.07.64.05.67.06.68.07.7.07.72.1.74.1.74.1.76.12.38.07.78.13.78.16.8.16.8.18.8.2 1.21.31.82.23c7.6 2.24 15.43 6.6 19.1 15.03 1.4 3.3 2.14 6.84 2.16 10.42l.1 4.17.1 5.05.1 3.38.12 5.06.18 6.66.14 4.89.25 8.55.28 9.17.48 14.42.11 3.35c.29 7.7 3.43 11.38 6.65 13.12l.37.2.18.09.37.17.37.15.19.07.36.13.18.06.36.11.18.05.53.14.34.08.33.06.33.06.25.03.24.04.36.04c.62.03 1.26.04 1.94.03l.35-.01v17.72a25 25 0 0 0-2.3.02l-.23.03-.24.03-.37.05-.4.07-.26.05-.28.06-.27.07-.29.07-.17.05-.36.11-.19.06-.36.13-.19.07-.37.16c-3.52 1.52-7.28 5.13-7.6 13.59l-.43 12.8-.33 10.47-.18 5.94-.27 9.52-.19 6.63-.13 5.05-.16 6.75-.1 4.2-.07 3.33a27.7 27.7 0 0 1-1.63 9.14l-.13.34v.03c-3.76 9.74-12.88 14.31-21.3 16.44l-.82.2-.41.1-.82.18-.4.08-.81.16-.4.08-.79.13-.39.07-.77.12-.76.1-.74.1-.73.09-.71.07-.7.07-1 .08-.63.05-.92.05-.86.04-1.05.03h-.6l-.54.01H201l-.47-.02-.4-.02h-.15V216.7c14 1.33 19.88-3.16 22.31-7.68l.21-.4.2-.4.17-.4.15-.4.15-.4.13-.4.05-.19.11-.38.1-.38.08-.37.07-.36.06-.35.05-.34.04-.33.05-.47.02-.3.03-.48v-.87l-.01-.23-.01-.2-.03-.28-.01-.13v-8.29l.02-7.72.04-7.96.04-6.71.06-6.85.07-6.15.05-3.57.04-2.88.06-3.3.05-2.1.04-1.98.05-1.88.07-2.16v-2.05l.02-.52v-.53l.04-.8.02-.53.03-.47.04-.48.04-.48.05-.48.05-.48.07-.48.03-.24.08-.48.09-.48.1-.48.1-.48c.13-.56.29-1.11.47-1.66l.16-.47c.23-.63.49-1.24.8-1.85l.23-.45c2.29-4.2 6.73-7.8 15.36-9.6-10.89-2.25-15.1-7.38-16.74-12.96l-.14-.47-.23-.95-.1-.47-.04-.24-.08-.48-.08-.48-.06-.48-.06-.47-.05-.48-.04-.48-.04-.47-.04-.71-.03-.47-.02-.79-.01-.52-.01-.52v-.76l-.01-1.27-.05-1.48-.05-1.88-.06-2.41-.05-2.58-.05-2.7-.06-3.8-.07-5.44-.05-5.09-.05-5.9-.06-10.48-.04-11.36c.86-.47 1.7-1 2.5-1.56 4-2.87 7.01-6.73 9.05-11.28l.14-.32a27.5 27.5 0 0 1-9.2 11.6c-.68.48-1.37.92-2.08 1.33l-.43.24V30.9l.02-.13.02-.2v-.17l.02-.34v-.86l-.01-.34-.02-.29-.04-.45-.06-.48-.05-.34-.06-.34-.07-.36-.04-.18-.08-.36-.05-.2-.1-.37-.12-.38-.07-.2-.14-.39-.15-.39-.17-.4c-2.1-4.7-7.64-9.79-21.96-8.62l-.79.07Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFAB00",
        d: "m31.17 36.1.46.3.47.3v-5.55l-.01-.13-.02-.2-.01-.18-.02-.33v-.87l.02-.34.02-.29.02-.3.04-.32.04-.33.05-.34.06-.35.07-.36.04-.18.09-.38.1-.38.06-.19.12-.39.06-.2.15-.39c.22-.6.5-1.2.84-1.81l.24-.4c2.63-4.31 8.6-8.35 21.96-7.08V.3l-.28-.01-.48-.02-.32-.01-.8-.01h-.99l-.85.02-.78.02-.85.04-.92.05-.97.07-.68.06-1.05.1-.73.08-.74.1-.76.1-.78.11-.78.13-.8.14-.81.15-.82.17-.41.09-.83.19-.42.1-.83.21-1.27.35-.84.25-.85.28c-6.2 2.07-12.32 5.63-16.05 11.74 1.2 8.91 5.14 16.51 11.84 21.3m24.86 195.95v-15.11c-14.63 1.39-20.4-3.57-22.62-8.28l-.19-.4-.24-.6-.14-.4-.07-.2-.12-.39-.1-.38-.1-.38-.08-.37-.08-.36-.06-.35-.05-.34-.04-.33-.05-.47-.03-.44-.01-.34v-1.1l.02-.2.02-.28.02-.14v-9.31c-.53.32-1.05.66-1.55 1.02-7.19 5.16-11.18 13.45-12.06 23.17 4.05 7.9 11.91 11.94 19.4 13.99l.82.21.81.2.8.19.8.17.8.15.4.08.77.14.38.06.76.12.38.06.74.1.37.05.71.08.7.08.7.07.66.06.64.05.63.04.6.04.86.04.54.02.64.02H53l.54.01h1.34l.49-.02zM238.1 17.33C234.2 8.36 225.6 4 217.55 1.9l-.8-.2-.8-.19-.4-.09-.79-.16-.39-.08-.77-.15-.77-.14-.76-.12-.74-.11-.73-.1-.72-.1-.7-.07-.68-.07-.67-.06-.97-.08-.91-.06-.87-.05-.82-.03-.5-.02-.62-.01h-.57l-.52-.01h-.88l-.5.02-.38.02-.32.01v15.12c14.63-1.4 20.4 3.56 22.62 8.28l.19.4.24.6.14.4.07.2.12.38.1.39.1.37.08.37.08.36.06.35.05.34.04.33.05.47.03.44.01.34v1.1l-.02.28-.04.34v8.43c.86-.48 1.7-1 2.5-1.56 6.5-4.65 10.39-11.91 11.72-20.45Zm-11.08 177.26q-1.5-1.065-3.12-1.92v8.29l.01.13.02.2.01.18.02.33v.86l-.03.5-.02.3-.05.46-.04.33-.05.34-.06.35-.07.36-.08.37-.1.38-.1.38-.06.2-.13.39-.15.4-.15.4-.18.4-.19.4-.2.4c-2.44 4.52-8.33 9.01-22.32 7.68v15.11l.22.01.65.03.79.01h1.31l.6-.01.66-.02.81-.03.87-.05.6-.04.95-.07.66-.06.68-.06.69-.08.71-.08.72-.1.74-.1.75-.12.38-.06.77-.13.78-.15.39-.08.79-.17.4-.08.8-.2c8.55-2.06 17.96-6.63 21.8-16.56-1.51-7.93-5.35-14.64-11.47-19.02Z"
    }));

const TypeScript = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#3178C6",
        d: "M20 0h216c11.046 0 20 8.954 20 20v216c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20V20C0 8.954 8.954 0 20 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M150.518 200.475v27.62q6.738 3.453 15.938 5.179T185.849 235q9.934 0 18.874-1.899t15.678-6.257q6.738-4.359 10.669-11.394 3.93-7.033 3.93-17.391 0-7.51-2.246-13.163a30.75 30.75 0 0 0-6.479-10.055q-4.232-4.402-10.149-7.898-5.918-3.495-13.347-6.602-5.441-2.245-9.761-4.359-4.319-2.115-7.342-4.316-3.024-2.2-4.665-4.661t-1.641-5.567q0-2.848 1.468-5.135c1.468-2.287 2.362-2.834 4.147-3.927q2.677-1.64 6.565-2.547 3.887-.906 8.638-.906 3.456 0 7.299.518 3.844.517 7.732 1.597a54 54 0 0 1 7.558 2.719 41.7 41.7 0 0 1 6.781 3.797v-25.807q-6.306-2.416-13.778-3.582T198.633 107q-9.847 0-18.658 2.115-8.811 2.114-15.506 6.602-6.694 4.49-10.582 11.437Q150 134.102 150 143.769q0 12.342 7.127 21.06t21.638 14.759a292 292 0 0 1 10.625 4.575q4.924 2.244 8.509 4.66t5.658 5.265 2.073 6.474a9.9 9.9 0 0 1-1.296 4.963q-1.295 2.286-3.93 3.97-2.635 1.683-6.565 2.632t-9.2.95q-8.983 0-17.794-3.151t-16.327-9.451m-46.036-68.733H140V109H41v22.742h35.345V233h28.137z"
    }));

const Typesense = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 255",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1035BC",
        d: "M75.104 80.303q.826 4.126.826 7.979 0 3.576-.826 7.702l-34.938-.275v92.437q0 11.554 10.729 11.554h20.908q1.926 4.677 1.926 9.354t-.55 5.777q-12.656 1.65-26.135 1.65-26.685 0-26.686-22.833V95.709l-19.533.275Q0 91.858 0 88.282q0-3.852.825-7.979l19.533.275V51.692q0-7.428 2.2-10.454 2.201-3.302 8.53-3.302h7.427l1.65 1.651v41.267zm10.477 125.255q.268-6.03 3.286-13.156 3.291-7.4 7.401-11.512 21.653 11.786 38.1 11.786 9.041 0 14.524-3.563 5.757-3.563 5.759-9.594 0-9.592-14.803-15.349l-15.35-5.755q-34.533-12.608-34.534-40.292-.001-9.867 3.564-17.541c2.557-5.3 6.026-9.776 10.415-13.43q6.85-5.756 16.173-8.771 9.316-3.016 20.829-3.016 5.205 0 11.511.823c4.384.548 8.772 1.37 13.155 2.467 4.388.913 8.588 2.01 12.609 3.289q6.029 1.919 10.415 4.111 0 6.852-2.74 14.253t-7.402 10.963q-21.653-9.593-37.548-9.593-7.127 0-11.239 3.564-4.11 3.288-4.11 8.77-.001 8.498 13.706 13.43l16.719 6.03c12.057 4.203 21.013 9.96 26.86 17.268q8.772 10.965 8.772 25.49-.001 19.462-14.53 31.246-14.526 11.513-41.659 11.513-26.59 0-49.883-13.431m150.807 48.031V.83q4.143-.83 9.396-.83c3.682 0 7.09.276 10.216.829v252.76q-4.692.829-10.216.83-5.253-.001-9.396-.83"
    }));

const UXAnaRangelDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1491 970",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M350 340c-6-5-11-10-14-17-3-12-1-24 2-35 7-19 18-36 28-53 11-18 25-34 39-50 27-33 59-61 93-87 36-28 75-52 119-65 24-7 49-10 73-5 47 10 77 54 70 104-5 42-21 81-36 120l-53 127-1 1 2 1 51-16 13-3c19-5 38-5 53 11s15 36 10 56c-2 8-10 25-9 27l3-2c28-25 58-49 92-67l29-11c31-7 57 13 58 44 1 16-4 30-10 45-16 37-37 72-56 108l-12 25c-16 31-30 63-36 98l-4 26c-5 18-24 25-40 14-12-7-18-19-20-32-5-26-1-51 7-75 17-52 46-98 72-144l27-47c-15 5-27 14-38 24a863 863 0 0 0-178 233c-5 9-10 19-17 27-14 14-32 13-44-1-9-10-11-22-11-34 1-21 8-39 15-58 23-61 55-117 86-173l22-43c-30 6-59 12-87 22-5 2-7 6-9 10l-22 44c-38 77-76 153-117 228-2 5-2 8 2 12l32 31c68 64 147 94 241 89 69-5 135-19 201-38 71-20 139-49 205-81 7-4 9-7 3-13-10-10-14-22-15-35-1-19 2-38 7-56l7-23c-19 15-35 30-52 45-21 18-43 35-70 43-36 11-70-5-83-41-11-26-9-53-3-80l6-17c36-81 95-141 170-189l-46-16c-34-15-65-32-87-64-3-4-6-3-10-1-10 4-21 9-33 11l-14 1c-12 0-20-6-23-17-3-10 1-20 12-26l40-19c4-2 7-4 7-10-1-43 14-82 37-117 27-43 64-77 112-97 21-8 42-11 64-6 37 10 57 43 47 80-5 20-16 38-29 53-39 47-88 80-139 110-5 4-11 6-16 9-15 10-13 8-2 20 16 16 36 25 57 33 32 12 66 19 101 25l29 1c53 5 80 40 72 92-5 36-19 69-34 102-16 33-34 65-48 99-8 20-13 40-11 62 0 7 2 8 8 4 62-37 122-76 167-133 14-18 26-37 30-60 5-27-4-47-28-61-7-4-15-7-20-13-7-7-10-15-6-24 5-9 13-12 22-11 8 0 15 3 22 6 50 27 69 78 52 136-11 39-36 68-62 97-31 34-68 60-105 86l-3 3a1216 1216 0 0 1-413 168l-5 1c-7-1-13 3-20 4-32 5-65 8-98 10-105 6-196-27-274-97l-29-28c-6-6-9-5-13 1-28 40-60 76-93 110-33 33-69 59-113 74-15 5-31 6-46 7-14 1-28-1-41-4-9-3-18-9-26-15-27-18-38-45-43-76-7-36 1-71 15-104 6-15 12-30 20-43a915 915 0 0 1 142-168c3-2 6-4 2-8-26-29-51-60-86-80-22-12-45-20-70-21l-12-1c-13-2-21-10-22-21-1-10 5-20 16-25 16-6 32-5 48-3a774 774 0 0 1 53 16 433 433 0 0 1 57 41l5 5 7 6 25 26 9 8 9 12c3 5 5 2 7-1l8-8c4-1 7-4 9-7l28-24 86-69c68-54 132-111 189-177 25-30 47-63 55-103 6-32-6-46-39-44l-15 2c-24 5-45 16-66 29a522 522 0 0 0-190 210c-9 20-20 24-40 18m258 6c-5-3-7 2-9 4l-64 59c-1 2-4 3-4 6l38-6c7-1 12-5 14-11 8-18 16-36 25-52M204 912l16-2c36-7 64-28 90-51 43-40 79-86 110-136 3-4 2-6-1-10l-90-104c-4-5-7-5-11-1l-49 53c-35 40-67 82-90 130-12 27-21 55-16 85 3 24 16 36 41 36m828-288c0 22 4 25 21 18 18-8 33-21 47-34 41-38 79-80 116-121 21-24 42-46 58-73 11-18 4-30-18-30l-8 1c-19 2-36 10-52 20-58 38-105 87-138 148-13 23-24 47-26 71M553 461c-22 5-42 9-60 16-50 18-88 53-127 86-4 3-3 4 0 7l80 94c3 4 6 8 10 0l53-111zm500-257c44-26 83-53 119-85 13-11 24-22 33-36 4-8 11-17 4-26-6-8-17-5-26-3a198 198 0 0 0-130 150"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M1326 116c42 2 79 15 103 52 27 43 14 106-28 135-7 5-15 9-23 10-10 2-18-1-25-10-6-8-6-17-3-26 3-7 9-12 14-17 8-8 17-16 22-26 11-20 8-38-10-51a97 97 0 0 0-55-18l-20-1c-11-2-19-11-20-20-1-11 5-20 16-24l11-2c6-2 12-2 18-2"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 29.1,
        cy: 426.8,
        fill: "url(#prefix__b)",
        rx: 28.6,
        ry: 27.8
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 1281.2,
        x2: 1481.8,
        y1: 115.6,
        y2: 168,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFC16F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FA86CE"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 29.1,
        x2: 29.1,
        y1: 399,
        y2: 454.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#2E58FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#9452FF"
    }))));

const UXAnaRangelLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1491 970",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M350 340c-6-5-11-10-14-17-3-12-1-24 2-35 7-19 18-36 28-53 11-18 25-34 39-50 27-33 59-61 93-87 36-28 75-52 119-65 24-7 49-10 73-5 47 10 77 54 70 104-5 42-21 81-36 120l-53 127-1 1 2 1 51-16 13-3c19-5 38-5 53 11s15 36 10 56c-2 8-10 25-9 27l3-2c28-25 58-49 92-67l29-11c31-7 57 13 58 44 1 16-4 30-10 45-16 37-37 72-56 108l-12 25c-16 31-30 63-36 98l-4 26c-5 18-24 25-40 14-12-7-18-19-20-32-5-26-1-51 7-75 17-52 46-98 72-144l27-47c-15 5-27 14-38 24a863 863 0 0 0-178 233c-5 9-10 19-17 27-14 14-32 13-44-1-9-10-11-22-11-34 1-21 8-39 15-58 23-61 55-117 86-173l22-43c-30 6-59 12-87 22-5 2-7 6-9 10l-22 44c-38 77-76 153-117 228-2 5-2 8 2 12l32 31c68 64 147 94 241 89 69-5 135-19 201-38 71-20 139-49 205-81 7-4 9-7 3-13-10-10-14-22-15-35-1-19 2-38 7-56l7-23c-19 15-35 30-52 45-21 18-43 35-70 43-36 11-70-5-83-41-11-26-9-53-3-80l6-17c36-81 95-141 170-189l-46-16c-34-15-65-32-87-64-3-4-6-3-10-1-10 4-21 9-33 11l-14 1c-12 0-20-6-23-17-3-10 1-20 12-26l40-19c4-2 7-4 7-10-1-43 14-82 37-117 27-43 64-77 112-97 21-8 42-11 64-6 37 10 57 43 47 80-5 20-16 38-29 53-39 47-88 80-139 110-5 4-11 6-16 9-15 10-13 8-2 20 16 16 36 25 57 33 32 12 66 19 101 25l29 1c53 5 80 40 72 92-5 36-19 69-34 102-16 33-34 65-48 99-8 20-13 40-11 62 0 7 2 8 8 4 62-37 122-76 167-133 14-18 26-37 30-60 5-27-4-47-28-61-7-4-15-7-20-13-7-7-10-15-6-24 5-9 13-12 22-11 8 0 15 3 22 6 50 27 69 78 52 136-11 39-36 68-62 97-31 34-68 60-105 86l-3 3a1216 1216 0 0 1-413 168l-5 1c-7-1-13 3-20 4-32 5-65 8-98 10-105 6-196-27-274-97l-29-28c-6-6-9-5-13 1-28 40-60 76-93 110-33 33-69 59-113 74-15 5-31 6-46 7-14 1-28-1-41-4-9-3-18-9-26-15-27-18-38-45-43-76-7-36 1-71 15-104 6-15 12-30 20-43a915 915 0 0 1 142-168c3-2 6-4 2-8-26-29-51-60-86-80-22-12-45-20-70-21l-12-1c-13-2-21-10-22-21-1-10 5-20 16-25 16-6 32-5 48-3a774 774 0 0 1 53 16 433 433 0 0 1 57 41l5 5 7 6 25 26 9 8 9 12c3 5 5 2 7-1l8-8c4-1 7-4 9-7l28-24 86-69c68-54 132-111 189-177 25-30 47-63 55-103 6-32-6-46-39-44l-15 2c-24 5-45 16-66 29a522 522 0 0 0-190 210c-9 20-20 24-40 18m258 6c-5-3-7 2-9 4l-64 59c-1 2-4 3-4 6l38-6c7-1 12-5 14-11 8-18 16-36 25-52M204 912l16-2c36-7 64-28 90-51 43-40 79-86 110-136 3-4 2-6-1-10l-90-104c-4-5-7-5-11-1l-49 53c-35 40-67 82-90 130-12 27-21 55-16 85 3 24 16 36 41 36m828-288c0 22 4 25 21 18 18-8 33-21 47-34 41-38 79-80 116-121 21-24 42-46 58-73 11-18 4-30-18-30l-8 1c-19 2-36 10-52 20-58 38-105 87-138 148-13 23-24 47-26 71M553 461c-22 5-42 9-60 16-50 18-88 53-127 86-4 3-3 4 0 7l80 94c3 4 6 8 10 0l53-111zm500-257c44-26 83-53 119-85 13-11 24-22 33-36 4-8 11-17 4-26-6-8-17-5-26-3a198 198 0 0 0-130 150"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M1326 116c42 2 79 15 103 52 27 43 14 106-28 135-7 5-15 9-23 10-10 2-18-1-25-10-6-8-6-17-3-26 3-7 9-12 14-17 8-8 17-16 22-26 11-20 8-38-10-51a97 97 0 0 0-55-18l-20-1c-11-2-19-11-20-20-1-11 5-20 16-24l11-2c6-2 12-2 18-2"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 29.1,
        cy: 426.8,
        fill: "url(#prefix__b)",
        rx: 28.6,
        ry: 27.8
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 1281.2,
        x2: 1481.8,
        y1: 115.6,
        y2: 168,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFC16F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FA86CE"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 29.1,
        x2: 29.1,
        y1: 399,
        y2: 454.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#2E58FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#9452FF"
    }))));

const UXCorpRangelDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1195 1207",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m1163 707-2-1c-8-1-14-8-13-16A541 541 0 0 0 611 81c-73 0-15-6-15-14s7-15 15-15a568 568 0 0 1 570 571c0 77-1 47-4 71-1 7-7 12-14 12zM91 468c7 3 12 1 14-5s0-10-7-13l-75-27 14-40 78 28c14 5 22 13 26 24 3 11 2 25-4 41-11 33-31 44-58 34L1 482l15-41zm124-143-24 39-35-8-1 2 23 28-24 37-41-54-63-14 25-39 34 10 1-1-24-27 22-36 41 50zm11-99c7 7 13 12 18 14 5 1 9 0 13-3l16-22 27 18c-6 12-14 23-23 31-13 13-26 19-40 17-13-2-27-10-42-25a76 76 0 0 1-24-44c-2-14 5-28 19-42 8-8 18-14 30-19l20 30q-18 9-24 15c-3 3-4 7-3 12 2 5 6 11 13 18m39-40c-13-19-18-35-16-48s11-26 28-37 32-15 45-12c12 4 25 15 37 33 12 19 18 35 16 49-1 13-10 26-27 37s-32 15-45 11-26-15-38-34zm43-58c-3-2-7-1-12 2s-7 7-6 10c0 4 4 10 10 19l5 8c6 9 11 15 14 16 3 2 7 1 12-2s7-6 7-10c-1-3-4-10-10-19l-5-8c-7-9-11-14-15-16m151-70c3 7 4 14 4 19-1 5-3 11-7 16l37 42-41 17-27-35-3 1 16 40-38 15-47-115 49-20c14-6 26-7 35-4 10 3 17 11 22 24m-38 31c1-3 0-6-1-10l-6-8h-6l-5 2 9 22 4-1c3-2 5-3 5-5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m541 86-8 2 7 38-41 8-24-122 47-9c17-3 29-2 38 3 8 5 14 15 17 30s2 26-4 34-17 13-32 16m-3-29-1-11c-1-5-2-8-4-10s-4-2-7-2l-5 1 6 28 5-1c3-1 5-3 6-5m73 1136A568 568 0 0 1 40 623c0-77 2-52 5-77a15 15 0 0 1 29 4 541 541 0 0 0 537 615c73 0 42-2 63-4a15 15 0 0 1 3 29c-21 2-44 4-66 4zm184-89c2 8 2 14 0 19-1 6-4 10-9 15l29 48-43 9-21-39h-3l9 42-40 9-26-122 52-11c15-3 27-2 35 3 9 4 14 13 17 27m-42 24v-10c-1-5-3-8-4-9-2-1-4-2-7-1l-5 1 5 24 5-1c3-1 5-2 6-4m187 1-38 18-12-15-20 9 5 19-36 18-32-123 55-27zm-64-19-25-34h-1l11 41zm168-66-31 26-51-21-1 1 32 38-29 24-81-94 33-28 50 23h1l-33-39 30-25zm32-91 4-8-9-7-6 8-23-16 27-39 59 41-18 25-7-1v1c1 8-2 17-7 25-18 25-44 26-79 2a79 79 0 0 1-32-38c-5-13-1-28 11-45 8-12 18-23 29-31l27 27c-12 10-20 17-23 22-4 6-5 10-3 15 3 4 8 9 17 15 8 6 15 9 20 10s9-1 13-6m97-127-29 74-116-46 31-76 29 15-13 33 14 6 12-29 26 10-12 30 16 6 15-36 27 14zm22-101-15 74-122-24 9-42 90 17 6-34 31 9z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M997 661c-1 1-17 9-36 9s-9 0-12-1l2-9 10-37h-38l-29 3-4 1c-1-5-4-10-11-14a86 86 0 0 1-20-23c2 0 3-2 5-3 4-3 7-8 7-14 0-5-1-9-10-19l-4-4 5-8 2-21c5-2 9-6 10-10 2-5 2-10 0-14 7-1 11-3 14-7 4-4 5-9 4-14v-1c4-2 9-4 12-7 11-10 9-18 7-23-1-4-4-6-7-8 7-6 13-14 16-21 3-6 9-18-1-29l-5-3 3-5c13-25 4-36-2-40l-7-2c1-6 2-12 1-17a18 18 0 0 0-12-14c6-16 11-25 24-44 14-21 21-35 24-46 1-6 2-15-4-22s-14-7-19-7l-17 2-38 12-63 18-47 13c-11 3-21 8-31 13-1-4-5-7-9-8-8-4-16 0-23 4l-14 12v1l-7 8c-3-4-8-6-13-6-13 0-18 13-20 20-5 14-6 23-7 38h-57c1-17-1-27-8-41-4-8-10-17-20-19l-12 3-3-3c-1-1-18-20-32-20s-13 4-16 11l-2-1c-18-9-26-11-74-21a433 433 0 0 1-85-25l-17-2c-8 0-15 1-20 6-10 10-3 26 0 33 1 2 5 9 26 33 12 14 16 21 26 38-5 1-9 4-12 8-3 7-2 16 1 23-5 1-9 4-12 8-4 7-3 16 2 28 3 6 7 11 12 16l-5 5v6c-30 4-46 11-55 23-6 8-6 13-7 27 0 17 1 21 13 33l4 4v2l5 23-6 1c-8 3-19 6-24 9-20 9-32 25-34 44-1 10 0 22 8 32 0 21 11 51 25 68 13 16 28 26 45 29-10 9-15 17-15 32s2 17 7 24c-2 9-1 18 4 26 10 17 33 30 63 36l18 1-2 2c-6 7-12 13-11 22 0 5 3 9 7 12l4 2a426 426 0 0 0-46 158c-4 38-2 78 4 119l10 68 42-55a225 225 0 0 1 43-38l1 15c6 26 10 30 15 33 3 2 13 7 24-3l13-15c11-14 18-21 34-32 1 4 3 7 7 10 3 2 8 6 32-1a299 299 0 0 0 54-24c3 6 9 12 23 10l17-4a182 182 0 0 0 78-44v1l7 2c5 3 11 2 18 0 23-8 41-23 58-49l8-13c2 4 5 8 13 9 16 3 26-15 31-24 5-10 8-19 11-30 2 3 4 5 8 6 4 2 9 2 14-1 7-3 11-12 14-18v-1a216 216 0 0 0 2-72c6 0 11-4 14-11 1-4 1-9-2-23a221 221 0 0 0-18-50c9 3 19 4 30 4s24-2 36-5a93 93 0 0 0 71-86l1-52z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE2525",
        d: "M930 694c-40-18-40 43-40 43s24 22 72 9 50-59 50-59-42 24-82 7"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE2525",
        d: "M895 687c13 25 28-34 28-34s-45 1-56 16c-11 16 15-6 28 18"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE2525",
        d: "M867 682c-12 0-23 10-23 23 0 12 6 16 13 20-17 25-55 93-103 128-41 31-125 89-271 73-73-8-81-62-81-62s-66 92-41 261c0 0 36-48 102-71s133-27 236-87a329 329 0 0 0 132-126s24-48 35-114h1a23 23 0 1 0 0-45"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M538 432c-32 5-47 17-50 40-4 21 2 42 16 55a63 63 0 0 0 57 18c25-5 40-20 47-46 3-11 2-30-1-40-3-7-11-16-18-20-12-6-34-9-51-7m77 10c-2 1-4 5-2 7s6 4 11 5c2 0 5 0 8-2 5-1 5-2 5-5s0-4-4-5c-3-1-14-2-18 0m-312 1c-3 2-2 8 1 11 3 2 9 2 13-1 3-2 3-5 0-8-2-3-3-3-7-3s-6 1-7 2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m406 835-15 21c0 1-18 26-31 71a515 515 0 0 0-12 200l5 31 18-25s9-12 25-26c11-9 27-21 47-31v10c0 17 0 24 2 31 2 12 5 21 7 22 2 2 5-1 16-14a307 307 0 0 1 105-74c1 3-15 22-32 38l-10 10c0 1 10 0 18-3a299 299 0 0 0 113-71l17-14c3 3-10 25-21 38-6 7-20 19-30 26-11 8-6 9 16 3 17-4 39-14 53-25a228 228 0 0 0 69-85c2 0 0 17-5 29-3 10-10 24-17 33l-5 8c1 1 4 0 7-1 19-7 34-19 49-42 16-23 23-44 27-72 1-9 4-5 7 10 2 9 3 35 2 46-1 4-1 5 1 5 4 1 8-5 14-16 6-12 10-23 13-37a183 183 0 0 0-1-58l12 15c5 9 11 26 13 40 0 5 2 8 2 9 2 0 5-4 7-10 3-10 4-21 4-40-1-29-5-45-17-64l-5-9c3-2 24 18 29 26 3 5 4 5 5 3 1-3-3-23-7-34a226 226 0 0 0-27-53l3-14 4 4c2 2 19 17 53 17 33 0 21-1 32-4 29-8 44-27 51-41 7-16 8-29 8-30v-23l-20 11s-20 11-43 11c-24 0-19-2-27-5l-6-2v-2l7-22 4-16h-16c-1 0-13 0-26 3-21 3-35 9-41 19-2 2-4 6-5 11l-2 1-2-10c-1-13-3-19-5-29l-2-8 4 1c5 2 20 6 26 6s6-3 0-6c-4-2-14-12-19-19-10-13-23-38-22-39l8 2 9 4c4 1 8 0 8-2s-2-5-6-8c-8-10-17-23-15-25h6c4 0 6-1 7-4 2-5 2-19 0-23l-1-4 7-1c6-1 8-3 6-5l-12-9-12-9 6-1c7 1 34-3 36-4l-8-6-8-5 9-3c11-2 19-6 24-11 6-4 4-5-7-4-14 2-28 0-36-5-3-1-2-2 2-3 10-1 25-6 33-11s16-15 20-22c3-7 4-9 2-11-1-1-3 0-8 4-7 6-17 11-26 13-7 2-21 2-24 1-2-1-2-3 1-3s22-10 29-15c9-7 18-18 23-28 8-14 6-24-2-14a75 75 0 0 1-39 27c-13 3-16 2-8-2 8-6 20-16 25-23 10-12 18-35 14-37-2-1-3-1-10 9-8 9-16 16-25 21-12 6-14 6-6-3 13-13 19-23 29-48 8-18 13-27 27-48 13-19 19-31 21-40s1-10-7-10l-13 2c-4 0-20 6-36 11-22 8-39 13-65 19l-46 12a129 129 0 0 0-59 38c-2 0 2-16 6-25l3-7c0-4-11 3-20 12-7 7-16 21-18 29-2 6-3 9-4 8-2-2-5-14-6-21s-2-9-3-9c-2 0-3 3-5 9-5 14-6 20-6 36 0 10-4 14-11 13h-45c-23 0-34-4-33-13 0-17-1-25-7-37-4-8-7-11-8-10v8c2 9 1 22-1 27-2 3-2 4-3 2l-2-9c-2-9-11-26-18-34-6-6-17-14-20-14-4 0-2 3 0 6 7 8 15 22 15 29 0 6-1 2-8-5-9-8-19-15-33-22-15-8-21-9-70-19a453 453 0 0 1-85-25c-7-2-21-2-22-1-1 2 0 9 3 14s11 16 24 30c14 17 19 24 29 45a247 247 0 0 0 30 47c-1 1-8-2-16-6l-16-12-10-9c-3 0 0 12 6 21 8 13 16 20 29 27 4 3 7 5 6 6s-16-1-24-4c-11-4-16-7-22-13l-7-6c-1 0 0 7 3 13 8 16 27 27 45 27s8 2-1 5c-6 3-8 3-21 2l-15 1c0 1 5 5 11 7l5 4c0 1-6 2-13 2-35 4-54 9-61 19-3 4-3 4-4 17 0 9 3 17 8 22q9 7.5 9 15a152 152 0 0 0 8 34c0 1-7 4-20 8l-22 8c-15 6-24 18-25 30-1 11 1 16 5 21 3 4 4 4 4 10-1 17 8 44 20 58 18 22 40 29 64 21 6-2 12-2 19 0l11 4c3 1 0 2-14 7-19 6-28 11-35 18-8 8-10 12-10 22 0 9 1 12 6 17 2 2 2 3 1 7-2 5-2 12 1 17 8 13 27 24 52 28 9 2 34 2 41 1 3-1 3-1 3 1 0 4-11 21-19 29-6 6-8 8-7 9 2 1 17 0 27-2m516-183s-3 13-8 25c-5 0-12 2-19 7-6-10-17-16-29-16 11-16 56-16 56-16M696 332c5-23 22-46 42-58 14-8 33-15 63-22 22-5 52-13 76-21l26-9v1c0 2-5 5-18 11-12 6-29 12-48 17-46 13-59 17-81 27a98 98 0 0 0-49 48c-6 12-8 23-8 37 0 15 0 10-1 10-3 2-5-29-2-41m128-25-18 14a333 333 0 0 0-62 60c-10 15-13 18-15 16-2-1 13-31 21-41 13-17 33-31 63-48 15-7 18-8 11-1m-2 34-19 17c-17 14-22 19-33 31-7 8-12 12-16 12-5 0-2-1 3-11 8-12 15-21 22-26 11-9 40-27 45-27 2 0 1 0-2 4m-78 76a435 435 0 0 0 86-28 127 127 0 0 1-61 31c-10 2-26 2-31 1-4-1-2-3 6-4m-18 51 24 9c15 6 65 31 72 36l8 8c4 6 2 13-3 9l-9-8c-12-10-40-22-101-44l-25-10-25-9c-3 0-3-1-3-6 1-8 2-8 4-7a1733 1733 0 0 0 58 22m-65-159c1-3 2-1 5 10 6 17 8 19 10 8 4-19 8-31 12-37 1-2 2 0 2 6 1 8 0 11-1 16a168 168 0 0 0-9 53l-15-28c-2-8-5-24-4-28m-95 36c8-1 62 0 71 1 9 2 15 4 16 6v2l-10 1c-28 2-39 5-57 14-13 6-14 7-26 19-8 7-15 14-16 17-3 4-4 4-12 5-23 4-37 9-48 20-5 4-9 6-12 5l-6-3c-6 0-6-1-3-11 7-21 26-43 49-59 17-12 23-14 54-17m83 105-2 9-6 2c-6 3-12 7-14 11-2 2-3 7-4 14-3 20-6 28-15 40a70 70 0 0 1-67 29c-7-1-21-6-29-10-17-9-30-28-34-49-1-8-1-29 1-35 2-10 13-23 24-29 9-5 27-9 41-10l13-1 21 1c21 2 53 8 63 13 8 4 9 6 8 15M396 322c1-1 0-2 12 4s18 10 24 16c8 8 13 18 10 18-4 0-5-3-9-7l-17-14c-15-11-21-16-20-17m-4-28c0-2 1-1 15 5 18 9 36 24 46 38 3 5 4 9 3 9-2 0-5-3-9-7a334 334 0 0 0-55-46zm67 30-8-7a241 241 0 0 0-32-30c-1-2 3 0 14 6l15 10c7 7 14 21 11 21M299 463c-4-2-6-7-6-13 0-15 0-15 47-22l21-3c8-1 24 0 32 2 15 3 24 8 31 20l7 8 5-4c3-3 5-4 9-5 14-3 28 2 28 10s0 4-9 1c-7-2-15-2-23 1-5 2-5 2-6 0-2-2-2-2-2 15 0 12-2 14-7 16-7 2-7 2-6-5 4-25-5-40-26-47-8-3-32-3-42-1-28 6-39 32-30 71 1 4 2 8 1 9-1 3-4 1-6-3-4-6-5-10-6-25-2-15-4-19-12-25m-43 113c-1 8-5 4-5-4 0-9 7-18 15-21 5-1 14-1 29 2 16 3 22 6 28 12 5 4 8 13 6 17-2 5-3 5-4-1-1-7-2-9-9-13s-16-5-36-5c-12 0-19 2-21 5zm43 21c7 13 26 13 38 1 5-6 7-6 4 0-4 10-14 15-26 15-7 0-9 0-13-3-6-3-10-10-11-17-1-6 1-15 4-18s6-4 6-2-1 3-3 5c-3 5-3 13 1 19m-34 8c5 0 7-3 8-9 1-7 0-14-4-20-4-4-4-5-2-5s3 1 5 3c7 7 9 28 2 35-2 3-9 3-12 0-2-3-1-4 3-4m48 60c-1 4-19-3-28-10-7-6-21-29-19-31l11 2c6 1 10 4 13 10 6 12 10 18 17 23zm5 73c-7-10-2-21 13-29 9-4 30-12 33-12 2 1 3 1-11 13-9 8-16 20-13 22 1 1 6-3 12-8 11-9 31-22 41-27 13-6 23-8 29-4 3 2 6 2 15 3 18 0 20 2 10 5l-12 5-24 18c-2 2-4 1-6-2-10-14-21-11-26 7-3 10-6 12-14 15-16 6-41 3-47-6m208-39c10-3 12-3 12-2l-3 5c-8 6-25 14-57 25-31 11-65 20-66 19l-1-4c1-2 3-4 7-5 6-3 25-9 40-12 15-4 19-7 24-18 4-8 7-9 13-2 3 4 7 4 12 2zm-1-11c4 0 8-4 12-11 3-6 6-7 21-11l14-4c3-2 5-2 5 0 0 3-16 15-34 25-6 4-7 4-15 4s-11-1-4-3zm-128 63-8 1c-4 0-4 0-4-2l4-19 2-4c2-2 5 0 6 3l2 11c0 9 0 9-2 10m50 151-5-14c-3-12-1-33 4-45l2-8c-4-4-17 16-20 31l-2 6c-2 0-4-9-3-19 1-11 4-21 9-32 7-12 5-13-8-6-9 5-16 8-17 7l4-6 9-13c2-6 8-10 17-11l16-4s38-14 72-23a220 220 0 0 1 111-3h3l-8-5c-14-12-23-14-47-14-21 0-38 3-58 10s-78 22-102 26c-22 4-28 5-46 4-19 0-26-2-38-7-8-4-16-12-16-16 0-3 1-2 6 0 14 5 42 7 63 4 26-4 78-19 115-33 31-12 52-25 70-41 12-10 15-14 22-24 10-15 8-14 12-10 4 3 4 4 3 8l-1 8c-1 4 2 3 6-2 6-6 7-8 7-15 0-11-11-20-26-22a20 20 0 0 0-17 5 814 814 0 0 0-56 18c-26 8-47 13-68 16-13 2-17 2-42 2-30-1-35-1-53-6-24-7-45-16-53-24-6-5-12-14-11-17l6-1c13 2 31-4 39-14 10-10 14-28 11-44-2-7-8-16-15-19-6-4-18-7-32-9-6 0-10-1-10-2l75-19c52-14 71-21 77-32l10-11c2 0 2 2 2 3l1 10a79 79 0 0 0 54 74l14 7c19 15 35 21 65 27 23 4 34 7 48 14 18 9 32 21 42 37 12 18 23 46 25 63v37c-1 3-1 3 1 3 4-1 14-29 15-46 1-15-4-53-4-54-4-8 3-4 10 6 6 10 10 19 13 32 3 11 4 40 5 40 2 0 13-22 15-38 2-22-3-31-15-53l-5-11c4-3 22 23 28 40 4 9 8 27 9 35 2 13 9 1 11-18 2-17-3-37-15-56l-8-14c0-2 2-1 8 5 19 19 39 54 43 76 4 16 3 46-1 57l-2 3-1-2-1-9c-2-14-8-33-11-33-4 0-4 5-4 18 1 14-1 28-8 51l-5 17-2 2-1-20c1-18 1-28-1-31-1-2-2-2-4 1-2 2-2 3-4 16-2 22-9 45-16 57l-8 10-8 6 3-8 5-18c1-10 2-28 0-30s-5 1-7 7a150 150 0 0 1-49 81 245 245 0 0 1-10 5l7-12c8-12 13-26 16-40 2-9 2-11 0-11s-5 7-14 24c-3 6-9 13-12 17-9 12-34 35-47 45a329 329 0 0 1-30 9c-3 0-4 0-1-3l4-4c9-8 22-26 26-38 2-7 5-21 4-23s-4-1-5 2l-15 27c-7 11-23 27-36 36l-14 9a370 370 0 0 1-108-4v-39c0-7-3-6-7 1-3 6-6 17-6 27l-1 5zl1 1m174 2h-1zm-5 1v1zm247-166-5 23-2 6-1 5-2 5-1 5v-1s-49 79-131 119c-30 14 58-6 119-84v1l-1 2-1 2v1l-1 1v1l-2 4-1 2-1 1v2l-1 1-1 2v1l-1 1v1l-1 1-3 5v1l-4 6-2 3-5 7-2 3a381 381 0 0 1-22 27l-4 3-2 3-4 4-3 2-7 7a401 401 0 0 1-94 65l-7 4-17 8-5 3-16 7-9 4a444 444 0 0 1-53 19l-48 13-3 1-10 2-9 3-10 3-15 4-6 2-7 2-17 7-4 2-2 1-5 3-13 7-5 2-9 6-4 3-8 6-5 5-5 4-7 7-3 3-3 2-4 5h-1l-6 8h-1l-1-8v-2l-1-5v-8l-1-4v-7l-1-4v-11l-1-4v-41l1-3v-13l1-3v-9l1-4v-2l1-4v-5l1-3v-3l1-2v-3l1-3v-3l1-2v-3l1-2v-4l1-1 1-4v-1l1-4v-1l1-5 1-1 1-5 1-5 1-1 1-4v-1c12 30 33 48 56 58 69 30 161-8 128-4-64 8-105-1-131-15a83 83 0 0 1-42-67v-1l1-3v-1l1-1v-1l2-3 1-2 2-5 1-1 2-4v-1l2-3 2-3v-1l1-2h1v-2h1v-1l1 4 1 5 2 4 1 1 1 2v2l3 5 2 3 2 2 2 3 3 3 3 2a58 58 0 0 0 7 7l3 2 3 2 4 2 2 1 8 4 4 2a335 335 0 0 0 23 6h6l7 1h2l5 1h9l3 1h44l6-1h7l3-1h8l3-1h5l2-1h5l5-1h1l4-1h2l3-1h2l2-1 2-1h3l2-1h3l2-1h2l2-1 3-1h2l4-1 1-1 3-1h2l2-1 2-1h2l2-1 2-1 2-1h2l2-1 2-1h2l3-2h2l3-1 1-1 2-1 2-1 2-1h2l1-1 2-1 2-1 2-1 1-1h2l2-1 1-1 3-2h2l2-1 1-1 2-1 1-1 2-1 1-1h2l1-1 2-1 1-1 2-1 1-1 2-1 2-1 2-1 1-1 1-1h2l1-1 1-1 2-1 1-1 1-1h1l2-1 1-1 1-1 1-1 2-1 1-1 2-1v-1h2l1-1 1-1 1-1h1l1-1 1-1 1-1h1l1-1 2-1 3-3h1l3-3 4-4 4-3 3-3 4-4 3-3 1-1 3-3v-1l3-3h1l3-4 3-4h1l3-4 3-4 3-4 3-4 3-4h1l2-4h1l2-4 1-1 2-3v-1a100 100 0 0 1 3-3l3-4v-1l2-3h1l2-4 2-4h1l2-3v-1l2-3 1-1 1-2 1-1 2-3v-1l2-2 4-7 2-2v-1c4 3 9 4 14 5zm3-13h-1v2l-1-2-8-2a23 23 0 0 1-11-13l-1-1v-11l1-2v-2l1-2 1-2 1-2h1l1-1v-1l1-1h1l1-1h1l1-1a23 23 0 1 1 11 42m95 19c-11 3-20 4-29 4-29 0-43-13-43-13v-5c7-7 12-16 12-26 9 0 16-6 20-15l8 3c10 4 21 6 31 6 28 0 50-13 50-13s-1 46-49 59"
    }));

const UXCorpRangelLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1195 1206",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M1163 706h-2c-8-1-14-9-13-17A541 541 0 0 0 611 80c-73 0-15-6-15-14s7-15 15-15a568 568 0 0 1 570 571c0 77-1 47-4 71-1 7-7 13-14 13M91 468c7 2 11 0 14-6 2-6 0-10-7-13l-76-27 15-40 78 28c13 5 22 13 26 24 3 11 2 25-4 41-12 33-31 44-58 35L1 481l15-41zm124-143-24 39-35-9-1 2 22 28-23 37-41-54-63-13 25-40 34 10 1-1-24-27 21-35 42 49 66 13zm11-100c7 8 13 12 18 14s9 1 13-3l16-22 27 18c-6 13-14 23-23 31-13 13-26 19-40 17-13-2-27-10-42-25a76 76 0 0 1-24-44c-2-14 5-28 19-42 8-8 18-14 30-19l20 30q-18 9-24 15c-3 3-4 7-3 12 2 5 6 11 13 18m39-40c-13-19-18-35-16-48s11-25 28-37q25.5-16.5 45-12c12 4 25 15 37 33 12 19 18 35 16 49-1 14-10 26-27 37s-32 15-45 11-26-15-38-33m43-58c-3-2-7-1-12 2s-7 7-6 10c0 4 3 10 10 20l4 7c7 9 11 15 15 17 3 1 7 1 12-3 5-3 7-6 7-10-1-3-4-10-10-19l-6-7c-6-10-10-15-14-17m151-70c3 7 4 14 4 19-1 6-3 11-7 16l37 42-41 17-27-35-3 1 16 40-38 15-47-115 49-20c14-6 26-7 35-4 10 3 17 11 22 24m-38 31c1-2 0-6-1-10l-6-8h-7l-4 2 9 23 4-2c3-1 5-3 5-5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m541 85-8 2 7 38-41 8-24-121 47-10c17-3 29-2 38 3 8 5 14 15 17 30s2 27-4 34c-6 8-17 13-32 16m-3-29-1-10c-1-5-2-9-4-11-2-1-4-2-7-1h-5l6 28 5-1c3-1 5-2 6-5m73 1137A568 568 0 0 1 40 622c0-77 2-52 5-77a15 15 0 0 1 29 4 541 541 0 0 0 537 615c73 0 42-1 63-4a15 15 0 0 1 3 29c-21 2-44 4-66 4m184-90c2 8 2 14 0 20-1 5-4 10-9 14l29 48-43 9-21-39-3 1 9 41-40 9-26-122 52-11c15-3 27-2 35 3 9 5 14 14 17 27m-42 24-1-10c0-4-2-7-3-9-2-1-4-2-7-1l-5 1 5 24 5-1c3-1 5-2 6-4m187 1-38 18-12-15-20 10 5 19-36 17-32-123 55-26zm-64-19-25-34h-1l11 41zm168-66-31 27-51-21-1 1 32 37-29 24-81-94 33-27 50 23 1-1-33-39 30-24zm32-90 4-9-10-7-5 8-23-16 27-38 59 41-18 24-7-1v1c0 9-2 17-7 25-18 25-44 26-79 2a79 79 0 0 1-32-38c-5-13-1-28 10-45 9-12 19-22 30-31l27 27c-12 10-20 17-24 23-3 5-4 10-2 14 3 4 8 9 16 15 9 6 16 9 21 10 5 2 9 0 13-6zm97-127-29 73-116-46 31-76 29 15-13 34 14 5 12-29 26 11-12 29 16 6 15-36zm21-102-14 74-122-24 8-42 91 18 6-34z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M997 664c-1 1-17 9-36 9-18 0-8 0-12-1l2-10 10-36h-38c-1 0-14 0-29 3l-4 1c-1-5-4-10-11-14a86 86 0 0 1-20-23l5-3c5-3 7-8 7-14 0-5-1-9-10-19l-3-4 4-8v-1c2-4 2-12 2-20 5-2 9-6 11-10 1-5 1-10-1-14 8-1 12-3 15-7s4-9 3-14v-1c5-2 9-4 12-7 11-10 9-19 8-23-2-4-5-6-7-8 6-6 12-14 15-21 3-6 9-18-1-29l-5-3 3-6c13-24 4-35-2-39-1 0-3-2-7-2 2-6 2-12 2-17a18 18 0 0 0-13-14c6-16 12-25 25-44 14-21 21-35 23-46 1-6 2-15-4-22s-14-7-19-7l-16 2h-1l-38 12c-21 7-38 12-63 18l-47 13c-11 3-21 8-30 13-2-4-5-7-10-9-8-3-16 1-22 5l-15 12v1l-7 8c-3-4-8-6-12-6-14 0-18 13-21 20-5 14-6 22-6 38h-57c0-17-2-28-9-41-4-8-9-17-19-19-5 0-9 1-13 3l-3-4c-1 0-18-19-32-19s-13 4-16 10l-2-1c-18-8-26-10-74-20a433 433 0 0 1-85-25l-16-2c-9 0-16 1-21 6-10 10-3 26 0 32 1 3 5 10 26 34 12 14 17 21 26 38-5 1-9 4-11 8-4 7-3 16 0 23-5 1-9 4-11 8-5 7-4 16 2 28l11 16-5 5v6c-29 4-46 11-55 23-6 8-6 13-6 27-1 17 0 21 13 33l4 4v2l4 22-6 2-24 9c-19 9-32 25-34 44 0 10 0 22 9 32-1 21 10 51 24 68 13 16 28 26 45 29-9 9-14 17-14 32s2 17 6 24c-2 9 0 18 4 26 10 17 33 30 64 36l18 1-2 2c-7 7-13 13-12 21 0 5 3 10 7 13l4 2a426 426 0 0 0-46 158c-4 38-2 78 4 119l10 68 42-55a225 225 0 0 1 43-38l2 15c5 26 10 30 14 33 3 2 13 7 24-3l13-15c11-14 18-21 34-32 1 4 3 7 7 10 3 2 8 6 32-1a299 299 0 0 0 54-24c3 6 9 12 23 10l17-4a182 182 0 0 0 78-44v1l7 2c5 3 11 2 18 0 23-8 41-23 58-49l8-13c2 4 6 8 13 9 17 3 26-15 31-25 5-9 8-18 11-29 2 3 5 5 8 6 5 2 9 1 14-1 8-3 12-12 14-18v-1a216 216 0 0 0 2-72c6 0 11-5 14-11 1-4 2-9-1-23a221 221 0 0 0-18-50c8 2 18 4 29 4s24-2 36-5a93 93 0 0 0 71-86l1-52z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE2525",
        d: "M928 694c-40-17-40 43-40 43s24 23 72 10c49-13 50-59 50-59s-42 23-82 6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE2525",
        d: "M894 687c13 25 28-34 28-34s-46 1-57 16c-10 16 15-6 28 18z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EE2525",
        d: "M865 682c-12 0-22 10-22 23 0 12 5 16 13 20-18 25-56 93-103 128-42 31-126 89-271 73-74-8-82-62-82-62s-65 92-41 261c0 0 37-48 102-71 66-22 134-27 236-87s132-126 132-126 25-48 36-114a23 23 0 1 0 0-45"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M539 433c-33 4-47 16-51 40-3 21 3 41 16 55a63 63 0 0 0 57 17c25-5 40-20 47-45 3-12 3-31-1-40-3-8-10-16-18-20-11-7-34-10-51-7zm7 12-8 18-28 52c-1 1-4 0-5-3 0-3 6-18 23-49 10-19 10-19 14-19zm19 1a2374 2374 0 0 0-28 56c-14 27-15 28-19 25-2-1-1-3 11-27 15-31 28-54 30-55 1-1 5 0 6 1m14 3 2 3-21 42c-21 41-21 42-25 38-1-1 11-26 28-59l9-17c4-8 4-8 7-7m37-7c-3 1-4 5-3 7 2 2 6 4 11 5 3 1 5 0 9-1 4-2 4-3 4-6s0-3-3-4c-4-2-15-2-18-1m-313 2c-2 2-2 7 1 10s9 2 13 0c3-3 3-5 0-9-1-2-3-3-7-3s-6 1-7 2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "m406 835-15 21c0 1-17 26-31 72a515 515 0 0 0-12 200l5 30 18-25s9-12 26-25c10-10 26-21 46-31v10c0 16 1 23 2 30 2 12 5 21 7 22 3 2 5-1 16-14a307 307 0 0 1 105-74c1 3-15 22-32 38l-10 11 18-3a299 299 0 0 0 113-71l17-15c3 3-10 25-21 38-6 7-19 19-30 27-10 7-6 8 16 3 17-5 39-15 53-26a228 228 0 0 0 69-85c2 0 0 17-4 29-4 11-11 24-18 33l-5 9 7-2c19-6 34-19 49-42 16-23 23-44 27-72 1-9 4-5 7 10 2 9 3 35 2 46-1 4 0 5 2 5 3 1 7-5 13-16s10-23 13-37a183 183 0 0 0-1-57c1-1 5 4 12 15 5 9 11 25 13 39l2 9c2 0 5-4 7-10 4-10 4-20 4-40-1-28-5-45-17-64-3-4-5-8-4-9 2-2 23 18 28 26 3 5 4 6 5 3 1-2-3-23-7-34a226 226 0 0 0-27-53l3-14 4 4c2 2 19 18 53 18 33 0 21-2 32-5 30-8 44-27 51-41 7-15 8-29 8-30v-23l-19 11c-1 1-21 11-44 11-24 0-19-1-27-5l-6-2v-2c5-10 7-21 7-21l5-17h-17l-26 3c-21 3-34 10-41 19-1 2-4 6-5 11l-2 1-2-10c-1-12-3-19-5-29l-2-8 5 1c4 3 19 6 25 6 7 0 6-3 1-5s-15-13-20-19c-10-14-23-38-21-40l7 3 9 4c4 1 8-1 8-3s-2-4-6-8c-8-10-16-23-15-25h6c4 0 6-1 7-3 2-6 2-20 0-24l-1-4 7-1c6-1 8-3 6-5l-12-9-12-9h6c8 0 34-3 36-5 1-1-1-2-8-5l-8-5 9-4c11-2 19-6 24-10 6-5 4-6-7-5-14 2-28 0-36-4-3-2-2-3 2-3 10-2 25-7 33-12s16-14 20-22c3-7 4-9 2-11-1-1-3 0-8 4-7 6-17 11-26 13-6 2-21 2-24 1-2-1-1-2 1-2 3 0 23-10 29-16 9-6 19-18 23-27 8-15 6-25-2-15a75 75 0 0 1-39 27c-13 4-16 3-8-2s20-16 25-22c10-13 18-36 14-38-2-1-3 0-10 9-8 9-16 17-25 21q-18 10.5-6-3c13-13 19-23 30-48 7-17 13-27 27-48 12-18 19-31 20-40 2-9 1-10-6-10l-14 2-36 11c-22 8-39 13-65 19l-46 13a129 129 0 0 0-59 37c-2 0 2-16 6-24l3-8c0-4-11 3-20 12-7 7-15 22-18 30-2 6-3 8-4 7-2-2-5-14-6-21s-2-8-3-8c-2 0-3 2-5 9-5 13-6 20-6 35 0 10-4 14-11 14l-45-1c-23 0-34-4-33-13 1-16-1-25-7-36-4-8-7-12-8-10v7c2 9 1 22-1 28-1 2-2 3-3 1l-2-8c-2-10-11-26-18-34-6-7-17-14-20-14-4 0-2 3 1 6 7 7 14 22 14 28s-1 2-8-4c-9-9-19-16-33-23-15-8-21-9-70-19a453 453 0 0 1-85-25c-7-2-21-2-22 0-1 1 0 8 3 14l24 30c14 16 19 24 29 44a247 247 0 0 0 30 47c-1 1-8-2-16-6-4-2-10-6-16-12l-10-9c-3 0 0 12 6 21 8 13 16 21 29 28 5 2 7 4 7 5-2 2-17-1-25-4-11-4-16-7-22-13l-7-5c-1 0 0 6 3 12 8 16 27 28 45 28s8 1-1 5c-6 2-8 2-21 2h-15c0 1 5 5 11 8l5 3-13 3c-35 3-54 8-61 18-3 4-3 5-4 18 0 9 3 16 8 21 6 6 9 11 9 16a152 152 0 0 0 8 33c0 1-7 4-20 8l-22 8c-15 7-24 18-25 30 0 11 1 16 5 21 4 4 4 5 4 10-1 17 8 44 20 59 18 21 40 28 64 20 6-2 12-2 19 0l11 4c3 1 0 2-14 7-19 7-28 11-35 18-8 8-10 12-10 22s1 13 6 18c2 2 2 2 1 6-2 6-2 12 1 17 8 13 27 24 52 28 9 2 34 2 41 1 3-1 4 0 4 1 0 4-11 21-20 29l-7 9c2 2 18 0 27-2m517-183-9 25c-5 0-12 2-18 7-7-10-17-16-30-16 11-15 57-16 57-16M696 333c5-23 22-46 42-58 14-9 33-15 63-22 22-5 52-14 76-22l26-8v1l-18 11c-12 5-29 12-48 17-46 12-59 16-81 27a98 98 0 0 0-49 48c-5 11-8 22-8 37 0 14 0 9-1 9-3 3-5-29-2-40m128-26-18 15a333 333 0 0 0-62 60c-10 14-13 17-15 16-2-2 13-32 21-42 13-17 33-31 64-47 14-8 18-8 10-2m-2 34-19 17c-17 15-22 19-33 32-7 8-12 11-16 11s-2-1 4-10q10.5-18 21-27c11-9 41-27 45-27 2 0 1 1-2 4m-78 76a435 435 0 0 0 86-28 127 127 0 0 1-61 32c-9 1-26 2-30 1-5-2-2-3 5-5m-18 51 24 10c16 6 65 30 72 35l8 8c4 6 2 13-3 9l-9-7c-12-10-39-22-101-45l-25-10-25-8c-3-1-3-1-3-7 1-7 2-8 4-7a1733 1733 0 0 0 58 22m-65-159c1-2 2-1 5 10 6 17 8 19 10 8 4-19 8-31 12-37 1-2 2 0 2 7 1 8 1 10-1 15a168 168 0 0 0-8 53c-2 0-12-19-15-28-3-7-6-24-5-28m-95 36c8-1 63 0 71 2 9 1 15 3 16 5v2l-10 1c-28 2-39 5-57 14-12 6-14 7-26 19l-16 17c-3 4-3 4-12 6-23 3-37 9-48 19-5 5-9 6-11 5l-7-2c-6 0-6-1-3-11 8-22 26-44 49-60 17-12 23-14 54-17m83 106-2 8-6 3c-6 2-12 6-14 10l-4 14c-3 20-6 29-15 41a70 70 0 0 1-67 28c-7-1-21-6-29-10-17-9-30-28-33-48-2-9-2-30 0-36 2-9 14-23 24-29 9-4 27-9 41-10h13c1-1 10 0 21 1 21 2 53 8 63 12 8 4 9 7 8 16M396 322c1-1 0-1 12 5 12 5 18 9 24 16 8 7 13 17 10 17-4 0-5-3-9-6-3-4-11-10-17-15-15-11-21-16-20-17m-4-28a123 123 0 0 1 61 44c3 4 5 9 3 9s-4-4-8-8a334 334 0 0 0-56-45m67 31-8-8a241 241 0 0 0-32-30c-1-2 3 0 14 6l15 11c7 7 14 20 11 20zm-129-88c-13-7-12-9 2-4 15 6 37 13 57 17 36 9 48 13 57 20 3 3 4 7 1 6-10-5-35-13-56-18-33-10-51-16-62-22zm-31 227c-4-3-6-8-6-14 0-15 0-14 47-22l21-3c8-1 24 0 32 2 15 3 24 9 31 20l7 8c1 1 3 0 5-3 3-4 5-5 9-6 15-3 28 2 28 10 0 9 0 5-9 2-7-3-15-2-23 0-5 2-5 2-6 0-2-2-2-1-2 16 0 11-1 14-7 15-6 2-6 2-6-5 4-24-5-40-26-47-8-2-32-3-42-1-28 7-39 33-30 71l2 9c-2 3-5 2-7-3-4-6-4-10-6-24-2-16-3-20-12-25m85 1a445 445 0 0 0-23 43c-3 2-7 2-7 1a277 277 0 0 1 22-44l8-14c2-3 2-4 4-3l4 2c1 0-2 7-8 15m-2 30c-2 4-4 6-5 6-2 0-2 0 0-2l4-8c4-7 5-4 1 4m-31-1c-8 17-9 19-13 19s-3-1 2-16a177 177 0 0 1 24-45c3-7 5-8 9-6 2 2 1 5-7 19zm-95 83c-1 7-5 4-5-5s7-18 15-20c5-2 14-2 29 1 16 3 22 6 29 12 4 4 7 13 5 18s-3 4-4-2c0-6-2-9-9-12-7-5-16-6-36-6-12 1-18 2-21 5zm43 21c7 13 27 13 38 0 6-6 7-5 4 1-4 9-14 15-26 15-7 0-8-1-13-3-5-4-10-11-11-18-1-6 1-14 5-18 3-3 5-3 5-2l-2 5c-4 6-4 14 0 20m-33 7c4 0 6-2 7-9s0-13-4-19c-3-5-4-5-2-5l5 2c8 8 9 28 2 35-2 3-9 3-12 0-2-2-1-4 4-4m47 60c-1 4-19-3-28-10-6-6-21-28-19-30 1-1 1-1 11 1 6 1 10 5 13 10 6 12 10 18 17 24 4 2 6 5 6 5m5 73c-6-10-2-20 13-28 9-5 30-13 33-12 3 0 3 0-11 12-9 8-16 21-12 23l11-8c12-10 31-23 41-28 13-6 24-7 29-4 3 2 6 3 15 3 19 1 20 2 10 6l-12 5-23 17c-3 2-5 1-7-2-10-14-21-11-26 7-3 10-5 13-14 16-15 6-41 2-47-7m208-38c10-4 12-4 12-3 1 1-1 3-3 5-7 6-25 14-57 25-30 11-64 20-66 19v-4c0-2 2-3 6-5 6-3 25-9 40-12 15-4 19-6 24-17 4-9 7-10 13-3 3 4 7 4 12 2l19-8zm-1-11c4-1 9-5 12-12 3-5 7-7 21-10l14-5c4-2 5-2 5 0 0 4-15 15-33 25-7 4-8 4-16 4s-11-1-3-2m-128 62-8 1c-4 0-4 0-4-2l4-19c0-2 1-3 2-3 2-3 5-1 6 2l2 11c0 9 0 9-2 10m50 151-5-13c-2-13 0-33 5-46 2-5 2-7 1-8-4-4-17 16-20 31l-2 6c-2 0-3-9-3-18 1-12 4-22 9-32 7-12 5-14-8-6-9 5-15 8-16 6l3-5c3-3 7-9 9-14 3-6 8-9 17-11l16-4 72-23c23-6 46-9 70-8h1c13 0 27 2 40 5l3 1-8-6c-14-11-23-14-47-14-21 1-38 4-58 10-20 7-78 22-102 27-22 4-28 4-46 3-19 0-26-1-38-7-8-4-16-12-16-15 0-4 1-3 6-1 14 6 42 7 63 4 26-3 78-18 115-33 31-12 52-24 70-40 12-11 16-15 22-25 10-15 9-14 13-10 3 4 3 4 2 9l-1 7c-1 4 2 3 7-2 5-6 6-8 6-15 0-11-10-20-25-22a20 20 0 0 0-17 5 814 814 0 0 0-56 18c-27 8-48 13-69 16-13 2-17 3-42 2-30 0-35-1-53-6-24-6-44-16-53-24-6-4-11-14-10-16 0-2 1-2 5-1 13 1 31-5 39-14 10-10 14-29 11-45-2-7-8-15-14-19-7-3-19-6-33-8l-10-2 75-20c52-13 71-21 78-31 3-6 8-11 10-11l2 2v10a79 79 0 0 0 54 74l14 7c19 15 35 22 66 27 23 4 34 8 48 14 17 9 31 21 42 38 11 18 22 45 24 63 2 9 1 30 0 36-1 3-1 3 1 3 4-1 14-28 15-46 1-14-4-52-4-54-3-7 3-3 10 7 6 9 10 18 13 32 3 10 4 39 5 39 2 0 13-22 15-38 2-22-3-30-15-53l-5-11c4-3 22 23 29 40l9 36c1 12 8 1 11-18 2-18-4-37-16-57l-8-14c0-2 2-1 8 5 19 19 39 54 43 76 4 16 3 47-1 57l-2 3v-1l-2-9c-2-15-8-33-11-33s-4 4-4 17c1 14-1 28-7 51l-6 17-1 2c-2 0-2-7-1-19 0-19 0-29-2-32-1-1-2-1-3 1-3 3-3 3-4 16-3 22-10 46-17 57l-8 10-7 7 2-9 5-18c2-10 2-28 0-29-2-2-5 0-7 7a150 150 0 0 1-49 81 245 245 0 0 1-10 4l7-11c8-13 13-27 16-40 2-10 2-12 0-12s-5 7-14 24c-3 6-8 14-12 18-9 11-34 34-47 45a329 329 0 0 1-30 9c-3 0-4-1-1-4l4-4c9-7 22-26 26-38 3-7 5-20 4-22-1-3-4-2-5 1l-14 28c-8 11-24 26-37 35l-14 10a370 370 0 0 1-108-5v-38q0-10.5-6 0c-4 6-7 18-7 27v6zl1 1m174 2h-1zm242-165-5 24-2 5-1 5-2 6-1 4v1-2s-48 79-131 119c-30 14 58-5 119-83l-1 2v1l-1 1v1l-1 2-2 4a10 10 0 0 1-1 2l-1 2v1l-1 2-1 2v1h-1v2l-1 1-3 5v1l-4 6-2 3a235 235 0 0 1-22 28l-4 4-3 4-4 4-2 2-4 4-3 3-7 6a401 401 0 0 1-101 69l-17 9-5 2-16 7-9 4a444 444 0 0 1-53 19l-48 13-3 1a465 465 0 0 1-19 5l-10 3-15 4-6 2-7 3-17 7-4 1-2 1-5 3-13 7-5 3-8 6-5 3-7 6-6 4-5 4-7 7-3 3-2 2-1 1-4 4-1 1-6 7v1-1l-2-7v-8l-1-3v-5l-1-3v-8l-1-4v-15l-1-3v-35l1-3v-16l1-3v-6l1-3v-6l1-3v-6l1-2v-4l1-2v-3l1-2v-4l1-2v-3l1-2v-3l1-2 1-4v-1l1-4 1-6 1-1 1-4v-1l2-5v-1l1-4v-1c13 30 33 48 56 58 69 30 161-8 128-4-64 9-105 0-131-15a83 83 0 0 1-42-67l1-4 1-2v-1l2-3 1-1v-1l2-4v-1l1-1 2-4 2-4 2-3v-1l2-2v-1h1v-2l1 5 2 4 1 4 1 1 1 2 1 2c0 2 1 3 3 5l1 3 2 2 1 1 2 2 2 3 3 3a58 58 0 0 0 7 6l3 2 3 2 4 2 2 2 8 3 4 2a325 325 0 0 0 23 6l7 1h6l2 1h11l3 1h54l4-1h8l3-1h5l2-1h5l3-1h2l5-1h1l4-1h2l3-1h2l2-1h3l2-1h2l3-1h2l2-1 2-1h3l2-1 4-1 1-1h3l2-1 2-1h2l2-1 2-1 2-1h2l3-1 1-1 3-1h1l3-1 2-1 3-1 1-1 2-1h2l2-1 2-1 2-1 1-1 2-1h2l1-1 2-1 2-1 1-1 3-1 2-1 2-1 1-1 2-1 1-1h2l2-1 1-1 2-1 1-1 2-1 1-1h1a35 35 0 0 0 4-2l2-2h1l1-1 2-1 1-1 1-1 2-1 1-1h1l1-1 2-1 1-1 1-1h1l2-2 1-1 2-1h1l1-1 1-1 1-1h1l1-1 1-1 1-1h1l1-1 1-1 2-1 3-3h1l3-3 4-3 4-4 3-3 4-4 3-3h1l3-4 3-4h1l3-4 3-3 1-1 3-3v-1l3-3v-1l3-3v-1l3-4a92 92 0 0 0 4-4l2-4h1l2-4h1l2-4h1l2-4 3-4 2-4h1l2-4 2-3 1-1 2-3 2-4h1l1-3 1-1 2-2v-2l2-2 4-7 2-2 14 4zm3-13h-1v2-2l-8-2a23 23 0 0 1-12-13v-1l-1-1v-10l1-2v-2h1v-2h1v-1l1-1 1-1v-1l1-1h1l1-1v-1h1v-1h1l1-1h1a23 23 0 1 1 10 43zm95 20c-11 3-20 4-28 4-30 0-44-14-44-14v-5c7-6 12-15 13-25 9-1 15-7 20-15l7 2c10 5 21 6 31 6 28 0 51-12 51-12s-1 46-50 59"
    }));

const UberDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 926.905 321.777",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        d: "M53.328 229.809q5.875 15.593 16.27 26.664 10.395 11.073 24.63 16.948 14.236 5.875 30.958 5.875 16.27 0 30.506-6.102c14.236-6.102 17.776-9.792 24.856-17.173q10.62-11.072 16.496-26.438c5.876-15.366 5.875-21.692 5.875-34.347V0h47.453v316.354h-47.001v-29.376q-15.818 16.72-37.285 25.761-21.467 9.038-46.323 9.038-25.309 0-47.228-8.813-21.919-8.812-37.962-25.082c-16.043-16.27-19.132-23.876-25.308-39.092Q0 225.968 0 197.947V0h47.453v195.236q0 18.982 5.875 34.573M332.168 0v115.243q15.818-15.817 36.607-25.082c20.789-9.265 28.924-9.265 45.193-9.265q25.308 0 47.453 9.49 22.144 9.49 38.414 25.761c16.27 16.271 19.434 23.651 25.761 38.414q9.49 22.146 9.49 47.002 0 24.855-9.49 46.774-9.49 21.92-25.761 38.188-16.27 16.27-38.414 25.761-22.146 9.49-47.453 9.49-24.404 0-45.419-9.265-21.015-9.264-36.833-25.082v28.924h-45.193V0zm5.197 232.746q6.101 14.463 16.948 25.309c10.847 10.846 15.667 12.956 25.308 17.174q14.462 6.327 31.184 6.327 16.27 0 30.731-6.327c14.461-6.327 18.001-9.942 25.083-17.174q10.62-10.846 16.947-25.309 6.327-14.461 6.327-31.183c0-16.722-2.109-21.618-6.327-31.41s-9.867-18.303-16.947-25.534q-10.62-10.846-25.083-16.947c-14.463-6.101-19.885-6.102-30.731-6.102s-21.09 2.034-30.731 6.102-18.077 9.717-25.309 16.947q-10.846 10.846-17.173 25.534c-6.327 14.688-6.327 20.262-6.327 31.41q-.001 16.722 6.1 31.183m223.477-77.732q9.039-21.693 24.856-38.188c15.817-16.495 23.049-19.659 37.511-25.986s30.129-9.49 47.001-9.49q24.856 0 46.098 9.038 21.24 9.039 36.606 25.083t23.952 37.962q8.587 21.92 8.587 47.68v14.914H597.901q2.26 14.01 9.039 25.985 6.78 11.976 16.947 20.789 10.168 8.814 23.049 13.784t27.342 4.972q41.127 0 66.435-33.896l32.991 24.404q-17.173 23.05-42.481 36.155-25.31 13.106-56.944 13.106-25.76 0-48.131-9.039c-22.371-9.039-27.869-14.462-38.866-25.309s-19.659-23.576-25.986-38.188-9.491-30.506-9.491-47.679q-.002-24.404 9.037-46.097m63.497-17.852q-19.207 16.044-25.534 42.708h140.552q-5.875-26.664-25.083-42.708t-44.967-16.043q-25.76 0-44.968 16.043m246.527 5.197q-14.462 15.817-14.462 42.934v131.062h-45.646V85.868h45.193v28.472q8.588-14.01 22.371-22.145t32.766-8.136h15.817v42.482h-18.981q-22.596.001-37.058 15.818"
    }));

const UberLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 926.905 321.777",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#010202",
        d: "M53.328 229.809q5.875 15.593 16.27 26.664 10.395 11.073 24.63 16.948 14.236 5.875 30.958 5.875 16.27 0 30.506-6.102c14.236-6.102 17.776-9.792 24.856-17.173q10.62-11.072 16.496-26.438c5.876-15.366 5.875-21.692 5.875-34.347V0h47.453v316.354h-47.001v-29.376q-15.818 16.72-37.285 25.761-21.467 9.038-46.323 9.038-25.309 0-47.228-8.813-21.919-8.812-37.962-25.082c-16.043-16.27-19.132-23.876-25.308-39.092Q0 225.968 0 197.947V0h47.453v195.236q0 18.982 5.875 34.573M332.168 0v115.243q15.818-15.817 36.607-25.082c20.789-9.265 28.924-9.265 45.193-9.265q25.308 0 47.453 9.49 22.144 9.49 38.414 25.761c16.27 16.271 19.434 23.651 25.761 38.414q9.49 22.146 9.49 47.002 0 24.855-9.49 46.774-9.49 21.92-25.761 38.188-16.27 16.27-38.414 25.761-22.146 9.49-47.453 9.49-24.404 0-45.419-9.265-21.015-9.264-36.833-25.082v28.924h-45.193V0zm5.197 232.746q6.101 14.463 16.948 25.309c10.847 10.846 15.667 12.956 25.308 17.174q14.462 6.327 31.184 6.327 16.27 0 30.731-6.327c14.461-6.327 18.001-9.942 25.083-17.174q10.62-10.846 16.947-25.309 6.327-14.461 6.327-31.183c0-16.722-2.109-21.618-6.327-31.41s-9.867-18.303-16.947-25.534q-10.62-10.846-25.083-16.947c-14.463-6.101-19.885-6.102-30.731-6.102s-21.09 2.034-30.731 6.102-18.077 9.717-25.309 16.947q-10.846 10.846-17.173 25.534c-6.327 14.688-6.327 20.262-6.327 31.41q-.001 16.722 6.1 31.183m223.477-77.732q9.039-21.693 24.856-38.188c15.817-16.495 23.049-19.659 37.511-25.986s30.129-9.49 47.001-9.49q24.856 0 46.098 9.038 21.24 9.039 36.606 25.083t23.952 37.962q8.587 21.92 8.587 47.68v14.914H597.901q2.26 14.01 9.039 25.985 6.78 11.976 16.947 20.789 10.168 8.814 23.049 13.784t27.342 4.972q41.127 0 66.435-33.896l32.991 24.404q-17.173 23.05-42.481 36.155-25.31 13.106-56.944 13.106-25.76 0-48.131-9.039c-22.371-9.039-27.869-14.462-38.866-25.309s-19.659-23.576-25.986-38.188-9.491-30.506-9.491-47.679q-.002-24.404 9.037-46.097m63.497-17.852q-19.207 16.044-25.534 42.708h140.552q-5.875-26.664-25.083-42.708t-44.967-16.043q-25.76 0-44.968 16.043m246.527 5.197q-14.462 15.817-14.462 42.934v131.062h-45.646V85.868h45.193v28.472q8.588-14.01 22.371-22.145t32.766-8.136h15.817v42.482h-18.981q-22.596.001-37.058 15.818"
    }));

const Ubuntu = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 100 100",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 50,
        cy: 50,
        r: 45,
        fill: "#f47421"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 50,
        cy: 50,
        r: 21.8,
        fill: "none",
        stroke: "#fff",
        strokeWidth: 8.6
    }), /*#__PURE__*/ React.createElement("g", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 19.4,
        cy: 50,
        r: 8.4,
        fill: "#f47421"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#f47421",
        strokeWidth: 3.2,
        d: "M67 50h10"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 19.4,
        cy: 50,
        r: 6,
        fill: "#fff"
    })), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        transform: "rotate(120 50 50)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        transform: "rotate(240 50 50)"
    }));

const Udacity = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.3 0 0 7.7v17.6C0 33.4 6.5 40 14.6 40c2.7 0 5.2-.7 7.4-1.9l10.8-6.2C37.1 29.6 40 25.2 40 20V1.6L37.4.1 26 6.2v19.2c0 .8-.1 1.6-.2 2.4-.2.8-.4 1.5-.7 2.2l-.3.6c-.4 0-2.9-.9-4.2-1.8a10.1 10.1 0 0 1-2.9-2.9c-.4-.6-.7-1.2-1-1.8s-.5-1.3-.6-2-.1-1.4-.1-2.1V1.6zm6.5 36.2c-.7.3-1.7.7-2.5.9s-1.5.2-2.3.2q-1.2 0-2.4-.3c-.8-.2-1.5-.4-2.2-.7s-1.4-.7-2-1.1A9.6 9.6 0 0 1 5 32c-.4-.6-.8-1.3-1.1-2s-.5-1.5-.7-2.3-.2-1.6-.2-2.4V9.2l10-6.1V20c0 6.4 4.7 11.8 10.7 13.1-.2.3-.4.6-.7.8-1.1 1.1-2 1.8-3.2 2.3m17-14c-.1.7-.4 1.4-.6 2-.3.6-.6 1.2-1 1.8s-1.6 2.1-3.2 3-3.1 1.2-4 1.4c.6-1.6 1-3.2 1-5V7.7l8-4.6V20c0 .8 0 1.5-.2 2.2",
        style: {
            fill: "#02b3e4"
        }
    }));

const UdemyDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 91 34",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#A435F0",
        d: "M14.05 8.11 7.02 4.06 0 8.1V4.06L7.03 0l7.02 4.06V8.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 11.52h3.68v8.94a3.27 3.27 0 0 0 3.35 3.44 3.3 3.3 0 0 0 3.34-3.47v-8.91h3.68v9.15c0 2.13-.67 3.77-2 4.9a7.55 7.55 0 0 1-5.06 1.67 7.4 7.4 0 0 1-5.01-1.67C.67 24.44 0 22.87 0 20.77zm45.87 11.11a5.57 5.57 0 0 1-3.83 1.48c-2.64 0-4.41-1.5-4.61-3.83h11.89s.08-.76.08-1.46c0-2.2-.7-4.02-2.13-5.5a7.13 7.13 0 0 0-5.45-2.23 7.9 7.9 0 0 0-5.78 2.22 7.93 7.93 0 0 0-2.25 5.87v.12c0 2.4.76 4.32 2.25 5.75a8.17 8.17 0 0 0 5.87 2.16c2.8 0 5.02-1.1 6.69-3zm-7-7.46a4.7 4.7 0 0 1 2.95-.98c1.07 0 1.95.34 2.7 1a3 3 0 0 1 1.16 2.23h-8.16c.12-.9.57-1.64 1.35-2.25m44.04 14.1C81.41 32.8 79.86 34 77.46 34H75.8v-3.26h1.34c.83 0 1.6-.31 2.32-2l.73-1.68-6.3-15.54h3.75L82.1 22.7l4.6-11.2h3.73L82.9 29.27zM28.38 5.66v7.26a7.58 7.58 0 0 0-4.9-1.73c-2.16 0-3.98.76-5.47 2.31a7.87 7.87 0 0 0-2.2 5.69 8 8 0 0 0 2.2 5.72 7.37 7.37 0 0 0 5.47 2.28c2.5 0 4.06-.98 4.9-1.75v1.42h3.65V5.65h-3.65zm-1.1 16.88c-.88.88-2 1.34-3.31 1.34a4.4 4.4 0 0 1-3.26-1.34c-.85-.89-1.27-2.01-1.27-3.35s.42-2.46 1.27-3.34c.88-.89 1.95-1.34 3.26-1.34s2.43.45 3.31 1.34c.91.88 1.37 2 1.37 3.34s-.46 2.47-1.37 3.35M68.22 11.2a6.39 6.39 0 0 0-5.2 2.26c-.4-.75-1.5-2.26-4.1-2.26a5.17 5.17 0 0 0-4.14 1.9v-1.59h-3.62v15.33h3.62v-8.82c0-2.07 1.28-3.56 2.98-3.56 1.74 0 2.74 1.3 2.74 3.4v8.98h3.62v-8.82c0-2.1 1.24-3.56 3.04-3.56 1.73 0 2.73 1.3 2.73 3.4v8.97h3.65v-9.48c0-4-2.14-6.15-5.32-6.15"
    }));

const UdemyLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 91 34",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#A435F0",
        d: "M14.05 8.11 7.02 4.06 0 8.1V4.06L7.03 0l7.02 4.06V8.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M0 11.52h3.68v8.94a3.27 3.27 0 0 0 3.35 3.44 3.3 3.3 0 0 0 3.34-3.47v-8.91h3.68v9.15c0 2.13-.67 3.77-2 4.9a7.55 7.55 0 0 1-5.06 1.67 7.4 7.4 0 0 1-5.01-1.67C.67 24.44 0 22.87 0 20.77zm45.87 11.11a5.57 5.57 0 0 1-3.83 1.48c-2.64 0-4.41-1.5-4.61-3.83h11.89s.08-.76.08-1.46c0-2.2-.7-4.02-2.13-5.5a7.13 7.13 0 0 0-5.45-2.23 7.9 7.9 0 0 0-5.78 2.22 7.93 7.93 0 0 0-2.25 5.87v.12c0 2.4.76 4.32 2.25 5.75a8.17 8.17 0 0 0 5.87 2.16c2.8 0 5.02-1.1 6.69-3zm-7-7.46a4.7 4.7 0 0 1 2.95-.98c1.07 0 1.95.34 2.7 1a3 3 0 0 1 1.16 2.23h-8.16c.12-.9.57-1.64 1.35-2.25m44.04 14.1C81.41 32.8 79.86 34 77.46 34H75.8v-3.26h1.34c.83 0 1.6-.31 2.32-2l.73-1.68-6.3-15.54h3.75L82.1 22.7l4.6-11.2h3.73L82.9 29.27zM28.38 5.66v7.26a7.58 7.58 0 0 0-4.9-1.73c-2.16 0-3.98.76-5.47 2.31a7.87 7.87 0 0 0-2.2 5.69 8 8 0 0 0 2.2 5.72 7.37 7.37 0 0 0 5.47 2.28c2.5 0 4.06-.98 4.9-1.75v1.42h3.65V5.65h-3.65zm-1.1 16.88c-.88.88-2 1.34-3.31 1.34a4.4 4.4 0 0 1-3.26-1.34c-.85-.89-1.27-2.01-1.27-3.35s.42-2.46 1.27-3.34c.88-.89 1.95-1.34 3.26-1.34s2.43.45 3.31 1.34c.91.88 1.37 2 1.37 3.34s-.46 2.47-1.37 3.35M68.22 11.2a6.39 6.39 0 0 0-5.2 2.26c-.4-.75-1.5-2.26-4.1-2.26a5.17 5.17 0 0 0-4.14 1.9v-1.59h-3.62v15.33h3.62v-8.82c0-2.07 1.28-3.56 2.98-3.56 1.74 0 2.74 1.3 2.74 3.4v8.98h3.62v-8.82c0-2.1 1.24-3.56 3.04-3.56 1.73 0 2.73 1.3 2.73 3.4v8.97h3.65v-9.48c0-4-2.14-6.15-5.32-6.15"
    }));

const UnityDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 263",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M166.9 131.2 212.8 52l22.2 79.2-22.2 79.3-46-79.3zm-22.4 13 46 79.2-80-20.5L52.6 144h91.8zM190.4 39l-45.9 79.3H52.7l57.7-58.8zm65.5 65.2L228 0 123.4 28l-15.5 27.2-31.4-.2L0 131.2l76.5 76.3 31.4-.2 15.5 27.2 104.5 27.9 28-104.2-15.9-27 16-27z"
    }));

const UnityLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 263",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#222C37",
        d: "M166.9 131.2 212.8 52l22.2 79.2-22.2 79.3-46-79.3zm-22.4 13 46 79.2-80-20.5L52.6 144h91.8zM190.4 39l-45.9 79.3H52.7l57.7-58.8zm65.5 65.2L228 0 123.4 28l-15.5 27.2-31.4-.2L0 131.2l76.5 76.3 31.4-.2 15.5 27.2 104.5 27.9 28-104.2-15.9-27 16-27z"
    }));

const UnoCSS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#858585",
        d: "M137.176 195.927c0-32.813 26.6-59.412 59.412-59.412S256 163.114 256 195.927c0 32.812-26.6 59.412-59.412 59.412s-59.412-26.6-59.412-59.412"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CCC",
        d: "M137.176 59.412C137.176 26.6 163.776 0 196.588 0S256 26.6 256 59.412v53.471c0 3.28-2.66 5.941-5.941 5.941H143.117a5.94 5.94 0 0 1-5.941-5.94z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4D4D4D",
        d: "M118.824 195.927c0 32.812-26.6 59.412-59.412 59.412S0 228.74 0 195.927v-53.47a5.94 5.94 0 0 1 5.941-5.942h106.942a5.94 5.94 0 0 1 5.941 5.941z"
    }));

const UnrealEngineDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M201.2 145.8a75 75 0 0 1-41.7 50.7l-12-13.6-20.5 20.5A75.4 75.4 0 0 1 67.4 173c2.2.6 4.4 1 6.7 1.2 3.3 0 7-1.1 7-6.8V112a9.1 9.1 0 0 0-11.5-9.1c-9.5 2.2-17 25.8-17 25.8a75 75 0 0 1 64.2-75.2c-10.3 6-16 15.5-16 23.5 0 13 7.7 11.4 10 9.5v74.8a11.9 11.9 0 0 0 5.5 6 11 11 0 0 0 5 1.2c7.9 0 18-9 18-9V99a21 21 0 0 0-9.3-16.2s8.6-1.5 15.3 3.6a75 75 0 0 1 46.2-26s-22.1 17.3-22.1 40.6c0 17.3.4 59.6.4 59.6 8.2 7.9 20.4-3.6 31.4-14.8",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M128 4.8a123.2 123.2 0 1 0 0 246.4 123.2 123.2 0 0 0 0-246.4m0 241.5a118.3 118.3 0 1 1 0-236.6 118.3 118.3 0 0 1 0 236.6",
        clipRule: "evenodd"
    }));

const UnrealEngineLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M201.2 145.8a75 75 0 0 1-41.7 50.7l-12-13.6-20.5 20.5A75.4 75.4 0 0 1 67.4 173c2.2.6 4.4 1 6.7 1.2 3.3 0 7-1.1 7-6.8V112a9.1 9.1 0 0 0-11.5-9.1c-9.5 2.2-17 25.8-17 25.8a75 75 0 0 1 64.2-75.2c-10.3 6-16 15.5-16 23.5 0 13 7.7 11.4 10 9.5v74.8a11.9 11.9 0 0 0 5.5 6 11 11 0 0 0 5 1.2c7.9 0 18-9 18-9V99a21 21 0 0 0-9.3-16.2s8.6-1.5 15.3 3.6a75 75 0 0 1 46.2-26s-22.1 17.3-22.1 40.6c0 17.3.4 59.6.4 59.6 8.2 7.9 20.4-3.6 31.4-14.8",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M128 4.8a123.2 123.2 0 1 0 0 246.4 123.2 123.2 0 0 0 0-246.4m0 241.5a118.3 118.3 0 1 1 0-236.6 118.3 118.3 0 0 1 0 236.6",
        clipRule: "evenodd"
    }));

const UpLeveled = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 154 154",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "0%",
        x2: "100%",
        y1: ".121%",
        y2: "99.879%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FF3367"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "26.795%",
        stopColor: "#FF3393"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#844FFF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "0%",
        x2: "100%",
        y1: ".125%",
        y2: "99.875%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FF3367"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "26.795%",
        stopColor: "#FF3393"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#844FFF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        d: "M-1-1h156v156H-1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M8.545 145.455h130.169v9.09H-.545V15.455h9.09z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M17.653 0h136.535v136.364H17.653z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M81.005 49.09v43.82c0 .635-.273.908-.91.908h-9.102c-.637 0-.91-.273-.91-.909v-3.273c-3.732 3.091-7.92 5.091-13.745 5.091-9.921 0-15.929-5.909-15.929-15.363V49.09c0-.636.273-.91.91-.91h9.103c.637 0 .91.274.91.91v26.364c0 6.818 2.822 9.454 7.828 9.454 5.734 0 10.923-4.364 10.923-15.182V49.091c0-.636.273-.91.91-.91h9.102c.637 0 .91.274.91.91zm5.644 61.82V49.09c0-.635.273-.908.91-.908h9.102c.638 0 .91.273.91.909v2.818c3.46-2.818 7.647-4.636 13.108-4.636 12.288 0 20.753 9.09 20.753 23.727 0 14.636-8.465 23.727-20.753 23.727-5.006 0-9.193-1.454-13.107-4.545v20.727c0 .636-.273.91-.91.91h-9.103c-.637 0-.91-.274-.91-.91zM97.025 71c0 7.818 4.279 13.91 11.47 13.91 7.19 0 11.468-6.092 11.468-13.91s-4.278-13.91-11.469-13.91S97.025 63.182 97.025 71"
    }));

const Upstash = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 341",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00C98D",
        d: "M0 298.417c56.554 56.553 148.247 56.553 204.801 0 56.554-56.554 56.554-148.247 0-204.801l-25.6 25.6c42.415 42.416 42.415 111.185 0 153.6-42.416 42.416-111.185 42.416-153.601 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00C98D",
        d: "M51.2 247.216c28.277 28.277 74.123 28.277 102.4 0 28.277-28.276 28.277-74.123 0-102.4l-25.6 25.6c14.14 14.138 14.14 37.061 0 51.2-14.138 14.139-37.061 14.139-51.2 0zM256 42.415c-56.554-56.553-148.247-56.553-204.8 0-56.555 56.555-56.555 148.247 0 204.801l25.599-25.6c-42.415-42.415-42.415-111.185 0-153.6 42.416-42.416 111.185-42.416 153.6 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00C98D",
        d: "M204.8 93.616c-28.276-28.277-74.124-28.277-102.4 0-28.278 28.277-28.278 74.123 0 102.4l25.6-25.6c-14.14-14.138-14.14-37.061 0-51.2 14.138-14.139 37.06-14.139 51.2 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillOpacity: 0.4,
        d: "M256 42.415c-56.554-56.553-148.247-56.553-204.8 0-56.555 56.555-56.555 148.247 0 204.801l25.599-25.6c-42.415-42.415-42.415-111.185 0-153.6 42.416-42.416 111.185-42.416 153.6 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillOpacity: 0.4,
        d: "M204.8 93.616c-28.276-28.277-74.124-28.277-102.4 0-28.278 28.277-28.278 74.123 0 102.4l25.6-25.6c-14.14-14.138-14.14-37.061 0-51.2 14.138-14.139 37.06-14.139 51.2 0z"
    }));

const V0Dark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        strokeLinejoin: "round",
        viewBox: "0 0 16 16",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M9.503 5.5h3.75q.09 0 .174.012L9.512 9.427A1 1 0 0 1 9.5 9.25V5.5H8v3.75A2.75 2.75 0 0 0 10.75 12h3.75v-1.5h-3.75q-.09 0-.177-.012L14.49 6.57q.013.088.013.18v3.75h1.5V6.75A2.75 2.75 0 0 0 13.253 4h-3.75zM0 5v.004l5.125 6.527c.616.784 1.876.348 1.876-.649V5h-1.5v4.58L1.904 5z",
        clipRule: "evenodd"
    }));

const V0Light = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        strokeLinejoin: "round",
        viewBox: "0 0 16 16",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M9.503 5.5h3.75q.09 0 .174.012L9.512 9.427A1 1 0 0 1 9.5 9.25V5.5H8v3.75A2.75 2.75 0 0 0 10.75 12h3.75v-1.5h-3.75q-.09 0-.177-.012L14.49 6.57q.013.088.013.18v3.75h1.5V6.75A2.75 2.75 0 0 0 13.253 4h-3.75zM0 5v.004l5.125 6.527c.616.784 1.876.348 1.876-.649V5h-1.5v4.58L1.904 5z",
        clipRule: "evenodd"
    }));

const VK = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 256,
        height: 256,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M256 0H0v256h256z"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#07F",
        d: "M0 122.88C0 64.95 0 35.99 18 18 36 0 64.95 0 122.88 0h10.24C191.05 0 220.01 0 238 18c18 18 18 46.95 18 104.88v10.24c0 57.93 0 86.89-18 104.88-18 18-46.95 18-104.88 18h-10.24c-57.93 0-86.89 0-104.88-18C0 220 0 191.06 0 133.13v-10.24z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M136.21 184.43c-58.34 0-91.62-40-93.01-106.56h29.23c.96 48.85 22.5 69.54 39.57 73.81V77.87h27.52V120c16.85-1.81 34.56-21.01 40.53-42.13h27.52c-4.58 26.02-23.78 45.22-37.44 53.12 13.66 6.4 35.52 23.14 43.84 53.44h-30.29c-6.5-20.27-22.72-35.95-44.16-38.08v38.08h-3.3z"
    }))));

const VSCodium = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 199.997,
        x2: 296.665,
        y1: 214.302,
        y2: 307.573,
        gradientTransform: "translate(-200 -213)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#62A0EA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1A5FB4"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M48.26 2.274a6.113 6.113 0 0 0-1.838 8.468c10.109 15.655 12.495 27.463 11.46 37.811-4.184 19.816-13.279 23.836-21.227 23.836-7.76 0-5.682-12.771.151-16.509 3.482-2.174 7.942-3.587 11.365-3.587 3.392 0 6.142-2.741 6.142-6.123s-2.75-6.124-6.142-6.124c-3.998 0-7.92.84-11.581 2.27.748-3.529 1.024-7.343.057-11.397-1.468-6.156-5.694-12.036-13.032-17.736a6.15 6.15 0 0 0-8.621 1.065 6.114 6.114 0 0 0 1.078 8.595c5.978 4.643 7.952 8.08 8.627 10.909s.132 5.864-1.224 10.034c-1.733 5.62-3.745 10.637-4.627 15.448-.434 2.368-.471 4.945-.583 7.004-4.305-4.196-5.99-9.736-5.99-17.831-.001-3.382-2.751-6.124-6.142-6.123-3.389.003-6.135 2.743-6.136 6.123 0 11.056 3.233 21.576 11.898 28.594 7.844 7.473 27.791 4.711 27.791 16.708 0 3.386 4.956 5.034 8.347 5.034 3.478 0 7.855-2.325 7.855-5.034 0-13.612 14.345-21.885 37.96-21.849 3.392.005 6.144-2.734 6.149-6.116.006-3.383-2.738-6.13-6.13-6.136a78 78 0 0 0-4.741.145c2.64-6.209 3.811-13.045 3.569-20.429-.112-3.381-2.95-6.031-6.339-5.921-3.393.11-6.051 2.943-5.94 6.326.32 9.668-.042 18.301-7.245 22.852-2.048 1.293-4.429 2.415-6.687 2.415 1.753-4.768 3.077-9.801 3.619-15.226.346-3.462.383-7.575-.012-10.77-.613-4.95-1.353-10.564.526-14.793 1.688-3.642 5.47-5.167 11.023-5.167 3.389-.003 6.135-2.744 6.136-6.123.002-3.383-2.745-6.127-6.136-6.13-8.252 0-14.507 4.343-18.053 9.59-1.854-3.96-4.112-8.041-6.84-12.265a6.14 6.14 0 0 0-3.86-2.669 6.16 6.16 0 0 0-4.627.831"
    }));

const Valibot = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: 0.414,
        x2: 0,
        y1: 0.255,
        y2: 0.932,
        gradientUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#eab308"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ca8a04"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: 0.338,
        x2: 0.664,
        y1: 0.02,
        y2: 0.966,
        gradientUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#fde68a"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fbbf24"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x2: 1,
        y1: 0.5,
        y2: 0.5,
        gradientUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0,
        stopColor: "#7dd3fc"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0ea5e9"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        d: "M0 0h512v512H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M742.271 987.024c-66.706 0-119.121 54.673-121.874 126.408l-2.551 95.471c-3.967 78.653 71.961 105.52 126.936 105.52Z",
        transform: "translate(-592.542 -894.723)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M92.616.01h227.278c54.53-.8 95.624 40.1 98.381 93.335l6.144 135.76c.732 67.368-48.116 94.95-104.525 95.335l-227.278 2.934C34.061 327.8-1.063 283.663.022 229.105l3.8-135.76C7.41 33.54 33.3 1.093 92.616.01",
        transform: "translate(62.42 92.302)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#111827",
        d: "M167.821 102.746h213.114c51.132-.746 89.665 37.307 92.25 86.824l5.761 126.29c.686 62.669-45.117 88.326-98.011 88.685l-213.114 2.729c-54.906.396-87.844-40.662-86.824-91.414l3.56-126.289c3.368-55.634 27.642-85.818 83.264-86.825"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M27.626 0A27.626 27.626 0 1 1 0 27.626 27.626 27.626 0 0 1 27.626 0",
        transform: "translate(365.148 205.357)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M27.626 0A27.626 27.626 0 1 1 0 27.626 27.626 27.626 0 0 1 27.626 0",
        transform: "translate(152.034 205.357)"
    }));

const VercelDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 222",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m128 0 128 221.705H0z"
    }));

const VercelLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 222",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m128 0 128 221.705H0z"
    }));

const Vim = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 257",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#019833",
        d: "M128.3 2 1.9 127.9l126.4 126.5L254 127.9 128.3 1.9"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#66FE98",
        d: "M128.3 13.5V3L2.8 127.9h10.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#45FE02",
        d: "M128.3 13.5V3l125.8 125h-11.6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#017D17",
        d: "M128.3 242.8v11.8L2.8 127.9h10.7l114.8 115"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#005D04",
        d: "M128.3 242.8v11.8L254 127.9h-11.6L128.3 243"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M65.2 230.6H41l-9.5-9.3V44.5H24l-6.5-6.4V18.3l6.7-7.2h85l7.7 7.6v18.8l-6.3 7.7H104V105l60.5-59.8h-3.4l-7-7.6V17.8l7-6.4h85.8l6.8 6.8V37z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.3 256.3 0 128 128.3 0 256 128 128.3 256.2ZM3.9 128l124.4 124.5L252 128 128.3 4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFEFE",
        d: "m108 22.7 3.9-2.4-4-4H26.3L22 20.5v15.7l4.6 4.6 2.2-4.6-2.9-2.9v-11l2.2-2h77.2l2.8 2.4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFEFE",
        d: "M41.5 35.8v184.4l2.5 2.4-2 4-5.5-5.4V40.6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "gray",
        d: "m28.2 35.8-1.6 5h9.9l5.7-5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFEFE",
        d: "m166.5 35.9-3.4-2.4v-10l3.6-3.6H242l3 3.9 4-3.2-4.2-4h-81.1l-4 4.1v15.9l4.2 3.8m-65.6 76.4-7.9 19.1 89-89.3-.5-10.8z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "gray",
        d: "m107.9 22.7 4-2.4v15.5l-4.6 4.6h-8.7l-.2 76.4-7.9 19v-100h14.7l2.7-2.2v-11m136.9.1 4.3-2.1v14.1L62.4 226.6H42l2-3.8h15.7l185-191.4v-8.7M179 35.8l-4.5 4.6H164l2.6-4.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CCC",
        d: "m166 19.8-3 2.9v10.6l2.6 2.5H179v10.3L90.5 136V36h14.7l3-3V22.2l-2.7-2.2H28l-2.5 2.6v11L28 36h13.5v184l2.5 2.6h15.3L244.8 31v-8.4l-2.9-3h-76"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "gray",
        d: "M59.5 223H44l-2.7-2.8V36.4H28l-2.7-2.7V22.5l2.7-2.7h77.5l3 2.3v11l-3.2 3.1H90.8v99l88-89.2V36h-13.3l-2.7-2.6V22.6l3-3H242l3 3v8.7L59.5 222.9Zm-15.3-.6h15.1L244.6 31v-8.2l-2.8-2.8h-75.7l-2.8 2.8v10.4l2.4 2.4h13.5v10.6l-89 90.3V35.7h15l2.8-2.9V22.3l-2.6-2H28.2l-2.4 2.4v10.8l2.4 2.4h13.6V220z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CCC",
        d: "m134.6 143.8-.4.2-3.6 3-.2.5-3.6 10c-.1.3 0 .6.2.9l2.7 2.7c.2.2.4.3.6.2h11c.3 0 .5 0 .7-.2l2.9-2.9.2-.4 3-10.5c.1-.3 0-.6-.2-.9l-2.3-2.3a.8.8 0 0 0-.6-.3zm-20.3 28.4c-.3 0-.6.3-.7.6l-1.3 5.4a.8.8 0 0 0 .8 1h6.5l-16.2 46.2a.8.8 0 0 0 .8 1.1h23.5c.4 0 .7-.2.8-.5l1.6-5a.8.8 0 0 0-.8-1H124l16-46.7a.8.8 0 0 0-.8-1.1zm74.8.1c-.2 0-.3.2-.5.3l-4.8 5.5H176l-5.2-5.3a.8.8 0 0 0-.6-.3h-18.6c-.3 0-.7.2-.8.5l-1.7 5.2a.8.8 0 0 0 .8 1h5L139.4 225a.8.8 0 0 0 .8 1.1H160c.3 0 .6-.2.7-.5l1.6-4.5a.8.8 0 0 0-.8-1H158l9.9-31.2h17.9L174.5 225a.8.8 0 0 0 .8 1h19c.4 0 .7-.2.8-.5l1.8-4a.8.8 0 0 0-.8-1.2h-3.5l10-31.6h17L208.3 225a.8.8 0 0 0 .8 1h21c.4 0 .7-.2.8-.5l1.7-4.4a.8.8 0 0 0-.8-1.2h-4.1l12.6-41-.1-.8-4-5.3a.8.8 0 0 0-.6-.3h-15c-.3 0-.5 0-.6.3l-4.8 5.1H207l-5-5.3a.8.8 0 0 0-.5-.3H189Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.4 162.5c.5.5 1.2.8 1.9.8h11c.8 0 1.5-.3 2-.8l3-3c.3-.3.5-.7.6-1.1l3.1-10.6c.3-1 0-2-.7-2.7l-2.4-2.5c-.5-.5-1.2-.8-2-.7h-10.7c-.5.1-1 .3-1.3.6l-3.6 3.1c-.4.4-.6.8-.8 1.2l-3.6 10c-.3 1 0 2.2.7 3zm16.1-16.7 1.6 1.5-2.8 9.7-2.4 2.4h-10.1l-2-2 3.3-9 3-2.6zm97.1 31.2-3.9-5.3c-.6-.8-1.4-1.2-2.2-1.2h-15c-.8 0-1.5.3-2 .9l-4.2 4.6h-6.6l-4.3-4.7c-.6-.6-1.3-1-2-1h-12.5l-.2.1c-.6.1-1.1.5-1.5 1l-4.3 4.8h-6.1l-4.6-4.8c-.5-.5-1.3-.8-2-.9h-18.6c-1.2 0-2.2.8-2.6 1.9l-1.7 5.1a2.8 2.8 0 0 0 2.6 3.7h2.3l-14.7 43.1a2.8 2.8 0 0 0 2.7 3.7H160c1.1 0 2.2-.7 2.6-1.9l1.5-4.4a2.8 2.8 0 0 0-2.6-3.7h-.8l8.6-27.2h13.8l-10.5 33.6a2.8 2.8 0 0 0 2.7 3.6h19.1c1.1 0 2.1-.7 2.5-1.7l1.8-4.1a2.8 2.8 0 0 0-2.6-3.9h-.8l8.8-27.7h13l-10.7 33.8a2.8 2.8 0 0 0 2.6 3.6h21c1.2 0 2.2-.7 2.6-1.8l1.7-4.5a2.8 2.8 0 0 0-2.6-3.7h-1.5l11.9-38.5c.2-.9 0-1.9-.5-2.6ZM225 221.8h5.2l-.9 2.2h-18.6l11.7-37.4h-21L190 222.3h4.4l-.8 1.8h-16.8l11.6-37.2h-22l-11 35h4.5l-.7 2.2h-17.4l15.8-46.8h-6.1l1-2.8h17.2l5.4 5.6h9.5l5.2-5.8h11l5.2 5.6h10l5-5.4h14l3.2 4.3-13.3 43Zm-94.9-3.7a3 3 0 0 0-.8-.1h-2.6l15.1-44.1a2.8 2.8 0 0 0-2.6-3.7h-25.3c-1 .3-1.9 1-2.2 2.1l-1.3 5.5a2.8 2.8 0 0 0 2.7 3.4h3.7l-15.2 43.6a2.8 2.8 0 0 0 2.6 3.7h23.5c1.2 0 2.3-.8 2.7-2l1.5-5c.5-1.4-.3-3-1.8-3.4m-24.3 6.5 16.5-47.3h-7.8l.8-3.2h22.3L121.2 222h6.6l-.9 2.7h-21.1Z"
    }));

const VisualStudio = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        fill: "none",
        viewBox: "0 0 193 193",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("path", {
        id: "prefix__j",
        fill: "#fff",
        d: "M8.271 8.271h176.457v176.457H8.271z"
    })), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__c",
        width: 177,
        height: 177,
        x: 8,
        y: 8,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m40.621 157.524-29.408-22.057a7.28 7.28 0 0 1-2.941-5.881V63.414a7.29 7.29 0 0 1 2.941-5.88l29.408-22.058a6.66 6.66 0 0 0-2.02 5.881v110.286a6.66 6.66 0 0 0 2.02 5.881"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M181.456 38.895a7.4 7.4 0 0 0-4.081-1.213 7.14 7.14 0 0 0-5.073 2.057l-.513.515L113.117 96.5l-32.462 31.137-30.034 28.784-.515.516a7.14 7.14 0 0 1-5.073 2.059 7.4 7.4 0 0 1-4.412-1.472l-29.408-22.057a7.346 7.346 0 0 0 9.998-1.103l32.644-37.9 26.8-31.1 46.946-54.52a7.24 7.24 0 0 1 5.55-2.572 7.4 7.4 0 0 1 4.08 1.213z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m181.456 154.105-44.114 29.41a7.45 7.45 0 0 1-9.667-1.323l-47.02-54.555-26.8-31.173-32.644-37.867a7.386 7.386 0 0 0-9.998-1.064l29.408-22.057a7.4 7.4 0 0 1 4.411-1.472 7.13 7.13 0 0 1 5.074 2.06l.515.515 30.034 28.785L113.117 96.5l58.672 56.246.513.515a7.14 7.14 0 0 0 5.073 2.057 7.4 7.4 0 0 0 4.081-1.213"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M184.729 45.032v102.936a7.38 7.38 0 0 1-3.273 6.137l-44.114 29.41a7.38 7.38 0 0 0 3.272-6.14V15.625a7.44 7.44 0 0 0-3.383-6.14l44.225 29.41a7.42 7.42 0 0 1 3.273 6.137"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__c)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#5E438F",
        d: "m40.621 157.524-29.408-22.057a7.3 7.3 0 0 1-2.941-5.881V63.414a7.29 7.29 0 0 1 2.941-5.88l29.408-22.058a6.66 6.66 0 0 0-2.02 5.881v110.286a6.66 6.66 0 0 0 2.02 5.881"
    }), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__d)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__e)",
        d: "M181.455 38.895a7.4 7.4 0 0 0-4.08-1.213 7.15 7.15 0 0 0-5.073 2.057l-.513.515-31.25 29.962L113.117 96.5l-32.463 31.137-30.033 28.784-.516.516a7.14 7.14 0 0 1-5.073 2.059 7.4 7.4 0 0 1-4.411-1.472l-29.408-22.057a7.346 7.346 0 0 0 9.997-1.103l16.471-19.115 16.174-18.785 26.8-31.1 46.945-54.52a7.25 7.25 0 0 1 5.55-2.572 7.4 7.4 0 0 1 4.081 1.213z"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__f)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__g)",
        d: "m181.455 154.105-44.114 29.411a7.44 7.44 0 0 1-9.666-1.324l-47.02-54.555-26.8-31.173-16.173-18.748L21.21 58.598a7.387 7.387 0 0 0-9.997-1.065L40.62 35.477a7.4 7.4 0 0 1 4.411-1.472 7.13 7.13 0 0 1 5.073 2.06l.516.515 30.033 28.785L113.117 96.5l27.461 26.323 31.211 29.923.513.516a7.16 7.16 0 0 0 5.073 2.056 7.4 7.4 0 0 0 4.08-1.213"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__h)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__i)",
        d: "M184.729 45.032v102.935a7.38 7.38 0 0 1-3.273 6.138l-44.115 29.41a7.38 7.38 0 0 0 3.273-6.14V15.625a7.44 7.44 0 0 0-3.383-6.14l44.225 29.41a7.43 7.43 0 0 1 3.273 6.137"
    }))))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__e",
        x1: 151.642,
        x2: 20.614,
        y1: 8.271,
        y2: 140.148,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#7252AA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#7252AA"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__g",
        x1: 24.814,
        x2: 147.966,
        y1: 40.437,
        y2: 178.293,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#AE7FE2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#9A70D4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__i",
        x1: 160.457,
        x2: 160.457,
        y1: 5.936,
        y2: 183.367,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#D59DFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#C18EF1"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__d",
        width: 180.604,
        height: 161.087,
        x: 6.032,
        y: 4.386,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.246
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 0.246
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 1.295
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 2.59
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "effect1_dropShadow",
        result: "effect2_dropShadow"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__f",
        width: 180.604,
        height: 161.085,
        x: 6.032,
        y: 30.118,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.246
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 0.246
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 1.295
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 2.59
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "effect1_dropShadow",
        result: "effect2_dropShadow"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__h",
        width: 78.583,
        height: 205.117,
        x: 121.688,
        y: -6.059,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", null), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 0.13
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", null), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 7.771
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "effect1_dropShadow",
        result: "effect2_dropShadow"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__j"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__b"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__j"
    }))));

const VisualStudioCode = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 100 100",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "prefix__a",
        width: 100,
        height: 100,
        x: 0,
        y: 0,
        "mask-type": "alpha",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M70.912 99.317a6.22 6.22 0 0 0 4.96-.19l20.589-9.907A6.25 6.25 0 0 0 100 83.587V16.413a6.25 6.25 0 0 0-3.54-5.632L75.874.874a6.23 6.23 0 0 0-7.104 1.21L29.355 38.04 12.187 25.01a4.16 4.16 0 0 0-5.318.236l-5.506 5.009a4.17 4.17 0 0 0-.004 6.162L16.247 50 1.36 63.583a4.17 4.17 0 0 0 .004 6.162l5.506 5.01a4.16 4.16 0 0 0 5.318.236l17.168-13.032L68.77 97.917a6.2 6.2 0 0 0 2.143 1.4ZM75.015 27.3 45.11 50l29.906 22.701z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#0065A9",
        d: "M96.461 10.796 75.857.876a6.23 6.23 0 0 0-7.107 1.207l-67.451 61.5a4.167 4.167 0 0 0 .004 6.162l5.51 5.009a4.17 4.17 0 0 0 5.32.236l81.228-61.62c2.725-2.067 6.639-.124 6.639 3.297v-.24a6.25 6.25 0 0 0-3.539-5.63Z"
    }), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#007ACC",
        d: "m96.461 89.204-20.604 9.92a6.23 6.23 0 0 1-7.107-1.207l-67.451-61.5a4.167 4.167 0 0 1 .004-6.162l5.51-5.009a4.17 4.17 0 0 1 5.32-.236l81.228 61.62c2.725 2.067 6.639.124 6.639-3.297v.24a6.25 6.25 0 0 1-3.539 5.63Z"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__c)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1F9CF0",
        d: "M75.858 99.126a6.23 6.23 0 0 1-7.108-1.21c2.306 2.307 6.25.674 6.25-2.588V4.672c0-3.262-3.944-4.895-6.25-2.589a6.23 6.23 0 0 1 7.108-1.21l20.6 9.908A6.25 6.25 0 0 1 100 16.413v67.174a6.25 6.25 0 0 1-3.541 5.633z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        fillRule: "evenodd",
        d: "M70.851 99.317a6.22 6.22 0 0 0 4.96-.19L96.4 89.22a6.25 6.25 0 0 0 3.54-5.633V16.413a6.25 6.25 0 0 0-3.54-5.632L75.812.874a6.23 6.23 0 0 0-7.104 1.21L29.294 38.04 12.126 25.01a4.16 4.16 0 0 0-5.317.236l-5.507 5.009a4.17 4.17 0 0 0-.004 6.162L16.186 50 1.298 63.583a4.17 4.17 0 0 0 .004 6.162l5.507 5.009a4.16 4.16 0 0 0 5.317.236l17.168-13.03 39.414 35.958a6.2 6.2 0 0 0 2.143 1.4ZM74.954 27.3 45.048 50l29.906 22.701z",
        clipRule: "evenodd",
        opacity: 0.25,
        style: {
            mixBlendMode: "overlay"
        }
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__b",
        width: 116.727,
        height: 92.246,
        x: -8.394,
        y: 15.829,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", null), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 4.167
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        mode: "overlay",
        result: "effect1_dropShadow"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__c",
        width: 47.917,
        height: 116.151,
        x: 60.417,
        y: -8.076,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", null), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 4.167
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        mode: "overlay",
        result: "effect1_dropShadow"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: 49.939,
        x2: 49.939,
        y1: 0.258,
        y2: 99.742,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#fff",
        stopOpacity: 0
    }))));

const Vite = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 257",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "-.828%",
        x2: "57.636%",
        y1: "7.652%",
        y2: "78.411%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#41D1FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#BD34FE"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "43.376%",
        x2: "50.316%",
        y1: "2.242%",
        y2: "89.03%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFEA83"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "8.333%",
        stopColor: "#FFDD35"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FFA800"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M255.153 37.938 134.897 252.976c-2.483 4.44-8.862 4.466-11.382.048L.875 37.958c-2.746-4.814 1.371-10.646 6.827-9.67l120.385 21.517a6.5 6.5 0 0 0 2.322-.004l117.867-21.483c5.438-.991 9.574 4.796 6.877 9.62"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M185.432.063 96.44 17.501a3.27 3.27 0 0 0-2.634 3.014l-5.474 92.456a3.268 3.268 0 0 0 3.997 3.378l24.777-5.718c2.318-.535 4.413 1.507 3.936 3.838l-7.361 36.047c-.495 2.426 1.782 4.5 4.151 3.78l15.304-4.649c2.372-.72 4.652 1.36 4.15 3.788l-11.698 56.621c-.732 3.542 3.979 5.473 5.943 2.437l1.313-2.028 72.516-144.72c1.215-2.423-.88-5.186-3.54-4.672l-25.505 4.922c-2.396.462-4.435-1.77-3.759-4.114l16.646-57.705c.677-2.35-1.37-4.583-3.769-4.113Z"
    }));

const Vitest = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 234",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#FCC72B",
        d: "m192.115 70.808-61.2 88.488a5.27 5.27 0 0 1-2.673 2.002 5.3 5.3 0 0 1-3.343-.005 5.25 5.25 0 0 1-2.66-2.01 5.2 5.2 0 0 1-.903-3.203l2.45-48.854-39.543-8.386a5.26 5.26 0 0 1-2.292-1.118 5.22 5.22 0 0 1-1.83-4.581 5.2 5.2 0 0 1 .895-2.383L142.218 2.27a5.28 5.28 0 0 1 6.016-1.996 5.24 5.24 0 0 1 2.66 2.01c.643.942.96 2.066.903 3.203l-2.45 48.855 39.542 8.386a5.26 5.26 0 0 1 2.293 1.117 5.21 5.21 0 0 1 1.829 4.582 5.2 5.2 0 0 1-.896 2.382Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#729B1B",
        d: "M128.025 233.537a12.36 12.36 0 0 1-8.763-3.63l-57.828-57.823a12.39 12.39 0 0 1 .023-17.5 12.394 12.394 0 0 1 17.5-.024l49.068 49.061L234.917 96.733a12.39 12.39 0 0 1 17.523 17.524l-115.655 115.65a12.34 12.34 0 0 1-8.76 3.63"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#729B1B",
        fillOpacity: 0.5,
        d: "M127.975 233.537a12.36 12.36 0 0 0 8.763-3.63l57.828-57.823a12.39 12.39 0 0 0 3.605-8.754 12.395 12.395 0 0 0-12.375-12.376 12.4 12.4 0 0 0-8.755 3.606l-49.066 49.061L21.082 96.733a12.392 12.392 0 0 0-17.524 17.524l115.656 115.65a12.35 12.35 0 0 0 8.76 3.63Z"
    }));

const Vivaldi = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 456 455",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "21.587%",
        x2: "76.116%",
        y1: "5.709%",
        y2: "100.496%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopOpacity: 0.2
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "79.08%",
        stopOpacity: 0.05
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#EF3939",
        d: "M228 454.3c99.7 0 155.1 0 191.4-36.1 36.2-36.1 36.2-91.3 36.2-190.7s0-154.6-36.2-190.7C383.1.8 327.7.8 228 .8S72.9.8 36.6 36.9C.4 73 .4 128.2.4 227.6s0 154.6 36.2 190.7c36.3 36 91.7 36 191.4 36"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M376 143.7c-21.8-38.1-58.3-67.8-104.2-80.1C180.7 39.3 87.1 93.1 62.7 183.8c-12.3 45.6-4.7 91.9 17.5 129.7.3.5.6 1.1 1 1.6l80.2 138.5c13.3.4 27.7.5 43.2.5h22.6c44.3 0 79.9 0 109-3.2 36.3-4 62.3-12.9 82.4-32.9 29.3-29.2 34.9-71 36-138.7-46.8-80.8-78.5-135.5-78.6-135.6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M347.8 107.6c-66.5-66.4-174.4-66.4-241 0-66.5 66.4-66.5 174 0 240.3 66.5 66.4 174.4 66.4 241 0s66.6-174 0-240.3m-10.2 78.1c-28.1 48.7-56.2 97.4-84.3 146.2-5.2 9.1-12.8 14.5-23.2 15.3-11.6.8-20.8-4.1-26.7-14.1-17.8-30.5-35.4-61.2-53-91.8-10.7-18.6-21.5-37.2-32.2-55.9-10.8-18.8 1.4-41.7 23-42.8 11.4-.6 20.2 4.7 26 14.6 7.9 13.5 15.7 27.2 23.6 40.8 5.7 9.8 11.2 19.7 17 29.3 8.4 14.1 20.8 22 37.3 23 23.3 1.4 45-15.5 47.8-40.2.2-1.8.3-3.7.4-4.6-.1-8-1.6-14.8-4.8-21.1-8.7-17.4.6-36.9 19.5-41.1 15.4-3.4 31.4 7.9 33.4 23.5 1 6.7-.4 13-3.8 18.9"
    })));

const VoicemodDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 240 28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceGraphic",
        values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        filter: "url(#prefix__a)",
        transform: "translate(-134 -25)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        d: "M158.157 25.378v12.955a.945.945 0 0 1-1.597.69l-14.45-13.645H134l29.099 27.503a.437.437 0 0 0 .737-.32V25.379h-5.68Zm61.41 18.985L193.144 25.46a.437.437 0 0 0-.689.357v14.695a.95.95 0 0 1-.512.845.94.94 0 0 1-.982-.071L168.84 25.46a.435.435 0 0 0-.687.357V47.3h5.665l.008-9.434a.95.95 0 0 1 .512-.845.94.94 0 0 1 .982.072l22.123 15.826a.434.434 0 0 0 .69-.357V37.866a.95.95 0 0 1 .511-.845.94.94 0 0 1 .982.072l10.164 7.27zm18.953-18.985-9.042 19.108h-.683l-9.04-19.108h3.84l.396.274 4.58 10.056a.619.619 0 0 0 1.13 0l4.582-10.056.39-.274h3.846Zm10.507 19.298c-5.68 0-9.194-4.1-9.194-9.84 0-5.738 3.513-9.836 9.194-9.836s9.195 4.098 9.195 9.837-3.513 9.839-9.195 9.839m0-16.397c-3.513 0-5.41 2.734-5.41 6.558s1.895 6.56 5.41 6.56 5.41-2.734 5.41-6.56c0-3.828-1.892-6.559-5.41-6.559m17.372 16.208h-3.216l-.27-.272V25.651l.27-.273h3.216l.267.273v18.563zm18.427-5.822.27-.273h3.252l.273.273c-.543 3.827-3.525 6.012-7.861 6.012-5.963 0-9.215-4.1-9.215-9.84 0-5.738 3.252-9.836 9.215-9.836 4.336 0 7.317 2.185 7.86 5.74l-.272.272h-3.252l-.27-.273q-.813-2.463-4.066-2.46c-3.793 0-5.422 2.733-5.422 6.558s1.629 6.56 5.422 6.56c2.169 0 3.524-.822 4.066-2.734m21.162 5.823H293.21l-.273-.272V25.651l.273-.273h12.778l.272.273v2.73l-.272.273h-8.973l-.272.272v3.823l.272.272h8.428l.271.273v2.73l-.271.272h-8.428l-.272.276v4.367l.272.273h8.973l.272.272v2.73zm39.488.19c-5.678 0-9.193-4.1-9.193-9.84 0-5.738 3.513-9.836 9.193-9.836 5.681 0 9.196 4.098 9.196 9.837s-3.516 9.839-9.196 9.839m0-16.397c-3.512 0-5.408 2.734-5.408 6.558s1.894 6.56 5.408 6.56 5.41-2.734 5.41-6.56c0-3.828-1.893-6.559-5.41-6.559m19.349 16.208h-5.937l-.275-.272V25.651l.275-.273h5.937c6.747 0 9.175 3.545 9.175 9.553s-2.428 9.555-9.175 9.555m.269-15.833h-2.43l-.269.273v12.013l.27.273h2.429c3.78 0 5.129-1.913 5.129-6.28 0-4.368-1.35-6.279-5.129-6.279M331.688 44.48h-3.14l-.27-.272V33.566h-.27l-5.809 10.92h-.74l-5.808-10.92h-.27v10.642l-.27.273h-3.14l-.27-.273V25.651l.27-.273h3.189l.275.273 5.844 10.906a.619.619 0 0 0 1.107 0l5.842-10.906.275-.273h3.189l.275.273v18.557l-.28.273Z"
    })));

const VoicemodLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 240 28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#3F3F3F",
        d: "M24.157.378v12.955a.945.945 0 0 1-1.597.69L8.11.378H0l29.099 27.503a.437.437 0 0 0 .737-.32V.379h-5.68zm61.41 18.985L59.144.46a.437.437 0 0 0-.689.357v14.695a.95.95 0 0 1-1.013.948.94.94 0 0 1-.481-.174L34.84.46a.435.435 0 0 0-.687.357V22.3h5.665l.008-9.434a.95.95 0 0 1 1.013-.948.94.94 0 0 1 .481.175l22.123 15.826a.434.434 0 0 0 .69-.357V12.866a.95.95 0 0 1 1.012-.948.94.94 0 0 1 .481.175l10.164 7.27zM104.52.378l-9.042 19.108h-.683L85.755.378h3.84l.396.274 4.58 10.056a.62.62 0 0 0 1.13 0L100.283.652l.39-.274zm10.507 19.298c-5.68 0-9.194-4.1-9.194-9.84 0-5.738 3.513-9.836 9.194-9.836s9.195 4.098 9.195 9.837-3.513 9.839-9.195 9.839m0-16.397c-3.513 0-5.41 2.734-5.41 6.558s1.895 6.56 5.41 6.56 5.41-2.734 5.41-6.56c0-3.828-1.892-6.558-5.41-6.558m17.372 16.207h-3.216l-.27-.272V.651l.27-.273h3.216l.267.273v18.563zm18.427-5.822.27-.273h3.252l.273.273c-.543 3.827-3.525 6.012-7.861 6.012-5.963 0-9.215-4.1-9.215-9.84 0-5.738 3.252-9.836 9.215-9.836 4.336 0 7.317 2.185 7.86 5.74l-.272.272h-3.252l-.27-.273q-.813-2.463-4.066-2.46c-3.793 0-5.422 2.733-5.422 6.558s1.629 6.56 5.422 6.56c2.169 0 3.524-.822 4.066-2.734m21.162 5.823H159.21l-.273-.272V.651l.273-.273h12.778l.272.273v2.73l-.272.273h-8.973l-.272.272v3.823l.272.272h8.428l.271.273v2.73l-.271.272h-8.428l-.272.276v4.367l.272.273h8.973l.272.272v2.73zm39.488.19c-5.678 0-9.193-4.1-9.193-9.84 0-5.738 3.513-9.836 9.193-9.836 5.681 0 9.196 4.098 9.196 9.837s-3.516 9.839-9.196 9.839m0-16.397c-3.512 0-5.408 2.734-5.408 6.558s1.894 6.56 5.408 6.56 5.41-2.734 5.41-6.56c0-3.828-1.893-6.558-5.41-6.558m19.349 16.207h-5.937l-.275-.272V.651l.275-.273h5.937c6.747 0 9.175 3.545 9.175 9.553s-2.428 9.555-9.175 9.555m.269-15.833h-2.43l-.269.273v12.013l.27.273h2.429c3.78 0 5.129-1.913 5.129-6.28 0-4.368-1.35-6.279-5.129-6.279M197.688 19.48h-3.14l-.27-.272V8.566h-.27l-5.809 10.92h-.74l-5.808-10.92h-.27v10.642l-.27.273h-3.14l-.27-.273V.651l.27-.273h3.189l.275.273 5.844 10.906a.61.61 0 0 0 .553.342.62.62 0 0 0 .554-.342L194.228.651l.275-.273h3.189l.275.273v18.557z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h240v28H0z"
    }))));

const VoltaDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 778 222",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#fff",
        clipPath: "url(#prefix__clip0_17_17)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M328.717 221.566q-24.61 0-42.656-10.543-18.048-10.543-28-29.5-9.844-18.957-9.844-44.303t9.844-44.409q9.952-19.062 28-29.606 18.047-10.543 42.656-10.543 24.61 0 42.656 10.543 18.046 10.544 27.891 29.606 9.953 19.063 9.953 44.409t-9.953 44.303q-9.845 18.957-27.891 29.5-18.047 10.542-42.656 10.543m.219-30.884q13.343 0 22.312-7.136 8.969-7.24 13.344-19.382 4.484-12.14 4.484-27.05 0-15.016-4.484-27.157-4.375-12.246-13.344-19.489-8.969-7.242-22.312-7.241-13.672 0-22.75 7.241-8.97 7.242-13.454 19.489-4.374 12.14-4.375 27.157 0 14.91 4.375 27.05 4.485 12.141 13.454 19.382 9.078 7.136 22.75 7.136M474.416.266a8 8 0 0 1 8 8V210.37a8 8 0 0 1-8 8h-23.594a8 8 0 0 1-8-8V8.266a8 8 0 0 1 8-8zM599.021 54.792a8 8 0 0 1 8 8V76.61a8 8 0 0 1-8 8h-80.578a8 8 0 0 1-8-8v-13.82a8 8 0 0 1 8-8zm-64.734-31.19a8 8 0 0 1 8-8h23.594a8 8 0 0 1 8 8v145.567q0 7.775 2.406 11.928 2.516 4.047 6.563 5.538t8.968 1.491q3.719 0 6.782-.533c2.644-.444 5.293 1.216 5.873 3.834l4.056 18.323c.884 3.994-1.402 7.976-5.389 8.891q-1.018.234-2.134.475-5.797 1.278-14.219 1.491-14.875.426-26.797-4.366-11.922-4.899-18.922-15.123-6.89-10.223-6.781-25.559zM688.478 221.672q-15.968 0-28.765-5.538-12.687-5.643-20.125-16.613-7.328-10.97-7.328-27.05 0-13.845 5.25-22.897 5.25-9.053 14.328-14.484t20.453-8.2q11.484-2.875 23.734-4.153 14.766-1.491 23.953-2.663 9.187-1.278 13.344-3.833 4.266-2.663 4.266-8.201v-.639q0-12.034-7.328-18.637t-21.11-6.602q-14.547 0-23.078 6.176-5.345 3.92-8.486 8.74c-2.078 3.188-5.598 5.476-9.367 4.955l-21.297-2.945c-4.842-.67-8-5.52-5.97-9.967q4.242-9.288 11.214-16.225 10.062-10.116 24.609-15.122 14.547-5.112 32.157-5.112 12.14 0 24.172 2.769 12.03 2.769 21.984 9.159 9.952 6.282 15.969 17.146 6.125 10.862 6.125 27.156v101.479a8 8 0 0 1-8 8h-22.063a8 8 0 0 1-8-8V195.9h-1.312q-3.61 6.816-10.172 12.78-6.454 5.857-16.297 9.478-9.735 3.514-22.86 3.514m10.282-28.328q11.921 0 20.672-4.579 8.75-4.686 13.453-12.354 4.812-7.668 4.812-16.72v-12.314c0-2.803-3.648-4.961-6.343-4.193q-4.375 1.278-9.844 2.237a311 311 0 0 1-10.828 1.704q-5.36.745-9.297 1.278-8.86 1.171-15.86 3.833t-11.046 7.455q-4.047 4.686-4.047 12.141 0 10.65 7.984 16.081t20.344 5.431M32.337 9.452c-2.748-3.676-5.366-6.615-9.254-8-4.392-1.96-9.32-2.086-13.934.553-1.726.988-2.874 1.904-3.836 2.996-5.361 4.935-6.97 12.87-3.416 19.557l.012-.006c.814 1.766 1.611 3.27 2.59 5.101l46.334 73.545 21.06 33.428 8.138 12.916 34.278 56.612c2 3.298 4.875 6.036 8.338 7.94A23.65 23.65 0 0 0 134.034 217c3.997 0 7.925-1.002 11.387-2.906s6.337-4.642 8.337-7.94L258.943 32.568A20.9 20.9 0 0 0 262 21.721a20.9 20.9 0 0 0-3.047-10.85c-1.998-3.298-4.873-6.038-8.335-7.942A23.64 23.64 0 0 0 239.231.022h-79.008c-31.304 0-54.39 13.1-70.275 38.658l-4.657 7.682-1.165 1.92 22.437 31.24 13.806-22.787c10.549-16.583 22.533-22.624 41.141-22.624l55.138.011L133.997 170.5l-23.44-38.756.017-.031-.876-1.391-16.94-28.01-21.44-32.901-24.54-38.948zM18.214 159.003c-.555.941-1.209 2.27-1.556 3.259-1.69 5.249-.538 10.94 2.919 15.174q.256.355.538.626a17 17 0 0 0 4.428 3.495c8.186 4.51 18.595 1.79 23.317-6.07a21.8 21.8 0 0 0 2.578-3.433l10.728-17.714-21.643-32.486-1.257 2.073-2.513 4.146-5.027 8.291z"
    })));

const VoltaLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 778 222",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#0a0a0a",
        clipPath: "url(#prefix__clip0_17_17)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M328.717 221.566q-24.61 0-42.656-10.543-18.048-10.543-28-29.5-9.844-18.957-9.844-44.303t9.844-44.409q9.952-19.062 28-29.606 18.047-10.543 42.656-10.543 24.61 0 42.656 10.543 18.046 10.544 27.891 29.606 9.953 19.063 9.953 44.409t-9.953 44.303q-9.845 18.957-27.891 29.5-18.047 10.542-42.656 10.543m.219-30.884q13.343 0 22.312-7.136 8.969-7.24 13.344-19.382 4.484-12.14 4.484-27.05 0-15.016-4.484-27.157-4.375-12.246-13.344-19.489-8.969-7.242-22.312-7.241-13.672 0-22.75 7.241-8.97 7.242-13.454 19.489-4.374 12.14-4.375 27.157 0 14.91 4.375 27.05 4.485 12.141 13.454 19.382 9.078 7.136 22.75 7.136M474.416.266a8 8 0 0 1 8 8V210.37a8 8 0 0 1-8 8h-23.594a8 8 0 0 1-8-8V8.266a8 8 0 0 1 8-8zM599.021 54.792a8 8 0 0 1 8 8V76.61a8 8 0 0 1-8 8h-80.578a8 8 0 0 1-8-8v-13.82a8 8 0 0 1 8-8zm-64.734-31.19a8 8 0 0 1 8-8h23.594a8 8 0 0 1 8 8v145.567q0 7.775 2.406 11.928 2.516 4.047 6.563 5.538t8.968 1.491q3.719 0 6.782-.533c2.644-.444 5.293 1.216 5.873 3.834l4.056 18.323c.884 3.994-1.402 7.976-5.389 8.891q-1.018.234-2.134.475-5.797 1.278-14.219 1.491-14.875.426-26.797-4.366-11.922-4.899-18.922-15.123-6.89-10.223-6.781-25.559zM688.478 221.672q-15.968 0-28.765-5.538-12.687-5.643-20.125-16.613-7.328-10.97-7.328-27.05 0-13.845 5.25-22.897 5.25-9.053 14.328-14.484t20.453-8.2q11.484-2.875 23.734-4.153 14.766-1.491 23.953-2.663 9.187-1.278 13.344-3.833 4.266-2.663 4.266-8.201v-.639q0-12.034-7.328-18.637t-21.11-6.602q-14.547 0-23.078 6.176-5.345 3.92-8.486 8.74c-2.078 3.188-5.598 5.476-9.367 4.955l-21.297-2.945c-4.842-.67-8-5.52-5.97-9.967q4.242-9.288 11.214-16.225 10.062-10.116 24.609-15.122 14.547-5.112 32.157-5.112 12.14 0 24.172 2.769 12.03 2.769 21.984 9.159 9.952 6.282 15.969 17.146 6.125 10.862 6.125 27.156v101.479a8 8 0 0 1-8 8h-22.063a8 8 0 0 1-8-8V195.9h-1.312q-3.61 6.816-10.172 12.78-6.454 5.857-16.297 9.478-9.735 3.514-22.86 3.514m10.282-28.328q11.921 0 20.672-4.579 8.75-4.686 13.453-12.354 4.812-7.668 4.812-16.72v-12.314c0-2.803-3.648-4.961-6.343-4.193q-4.375 1.278-9.844 2.237a311 311 0 0 1-10.828 1.704q-5.36.745-9.297 1.278-8.86 1.171-15.86 3.833t-11.046 7.455q-4.047 4.686-4.047 12.141 0 10.65 7.984 16.081t20.344 5.431M32.337 9.452c-2.748-3.676-5.366-6.615-9.254-8-4.392-1.96-9.32-2.086-13.934.553-1.726.988-2.874 1.904-3.836 2.996-5.361 4.935-6.97 12.87-3.416 19.557l.012-.006c.814 1.766 1.611 3.27 2.59 5.101l46.334 73.545 21.06 33.428 8.138 12.916 34.278 56.612c2 3.298 4.875 6.036 8.338 7.94A23.65 23.65 0 0 0 134.034 217c3.997 0 7.925-1.002 11.387-2.906s6.337-4.642 8.337-7.94L258.943 32.568A20.9 20.9 0 0 0 262 21.721a20.9 20.9 0 0 0-3.047-10.85c-1.998-3.298-4.873-6.038-8.335-7.942A23.64 23.64 0 0 0 239.231.022h-79.008c-31.304 0-54.39 13.1-70.275 38.658l-4.657 7.682-1.165 1.92 22.437 31.24 13.806-22.787c10.549-16.583 22.533-22.624 41.141-22.624l55.138.011L133.997 170.5l-23.44-38.756.017-.031-.876-1.391-16.94-28.01-21.44-32.901-24.54-38.948zM18.214 159.003c-.555.941-1.209 2.27-1.556 3.259-1.69 5.249-.538 10.94 2.919 15.174q.256.355.538.626a17 17 0 0 0 4.428 3.495c8.186 4.51 18.595 1.79 23.317-6.07a21.8 21.8 0 0 0 2.578-3.433l10.728-17.714-21.643-32.486-1.257 2.073-2.513 4.146-5.027 8.291z"
    })));

const Vue = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 221",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#41B883",
        d: "M204.8 0H256L128 220.8 0 0h97.92L128 51.2 157.44 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#41B883",
        d: "m0 0 128 220.8L256 0h-51.2L128 132.48 50.56 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#35495E",
        d: "M50.56 0 128 133.12 204.8 0h-47.36L128 51.2 97.92 0z"
    }));

const VueUse = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 277",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#35495E",
        d: "M202.968 0v148.146c0 41.405-33.563 74.967-74.968 74.967s-74.968-33.562-74.968-74.967V0h53.036v148.146a21.932 21.932 0 1 0 43.864 0V0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#41B883",
        d: "M256 0v148.146c0 70.694-57.306 128.019-128 128.019S0 218.84 0 148.145V0h53.032v148.146c0 41.405 33.566 74.967 74.968 74.967s74.968-33.562 74.968-74.967V0z"
    }));

const Vuetify = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 400 400",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 200.025,
        cy: 199.975,
        r: 186.895,
        fill: "#fff"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AEDDFF",
        fillRule: "evenodd",
        d: "M200.025 390.404c105.171 0 190.428-85.258 190.428-190.429 0-105.17-85.257-190.428-190.428-190.428S9.596 94.805 9.596 199.975c0 105.171 85.258 190.429 190.429 190.429m0 3.793c107.265 0 194.221-86.957 194.221-194.222S307.29 5.754 200.025 5.754C92.759 5.754 5.803 92.71 5.803 199.975s86.956 194.222 194.222 194.222",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1697F6",
        d: "m203.087 172.693-58.124 100.696L200 368.773l72.896-126.26 72.863-126.26H235.651z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AEDDFF",
        d: "m127.137 242.513 3.818 6.64 54.373-94.222 22.34-38.678H54.242z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#1867C0",
        d: "M235.651 116.253C263.203 206.922 200 368.773 200 368.773l-55.037-95.384z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7BC6FF",
        d: "M207.668 116.253c-116.082 0-76.713 132.9-76.713 132.9z"
    }));

const Warp = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 400",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 0h400v400H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00CBE4",
        d: "M200 97q20.497-.141 40.996-.207c6.346-.021 12.691-.05 19.037-.095q9.19-.063 18.382-.078 3.5-.01 7.003-.043c3.277-.03 6.553-.033 9.83-.031l2.905-.044c9.263.057 16.292 3.225 23.054 9.502 5.702 6.348 7.891 12.983 7.954 21.414l.03 3.257.018 3.544.03 3.757a4448 4448 0 0 1 .08 14.43q.047 9.921.074 19.841.031 12.646.133 25.292c.048 5.943.072 11.887.08 17.83.004 3.542.019 7.083.059 10.625.044 3.96.04 7.92.032 11.881l.06 3.501c-.082 9.316-2.707 17.125-9.016 24.133-7.427 7.207-14.796 8.951-24.829 8.832h-2.96c-3.202-.001-6.405-.024-9.608-.048q-3.345-.009-6.692-.013c-5.853-.011-11.705-.04-17.558-.074-5.979-.03-11.958-.044-17.938-.06q-17.578-.05-35.156-.146a2120.714 2120.714 0 0 1-1.812 9.438l-.502 2.662A112 112 0 0 1 199 303q-20.497.141-40.996.207c-6.346.021-12.691.05-19.037.095q-9.19.063-18.382.078-3.5.01-7.003.043c-3.277.03-6.553.033-9.83.031l-2.905.044c-9.2-.056-16.32-3.2-23.054-9.435-5.64-6.49-7.89-13.98-7.954-22.443l-.03-3.232-.018-3.515-.03-3.727q-.043-6.106-.07-12.212l-.01-2.105q-.047-9.843-.074-19.685a4392 4392 0 0 0-.133-25.092 2596 2596 0 0 1-.08-17.69c-.004-3.514-.019-7.027-.059-10.541-.044-3.93-.04-7.858-.032-11.788l-.06-3.472c.082-9.282 2.711-17.124 9.045-24.07 7.39-7.06 13.814-8.948 23.778-8.832h2.988c3.242.001 6.482.024 9.723.048q3.383.009 6.764.013c5.92.011 11.84.04 17.76.074 6.046.03 12.092.044 18.138.06q17.781.05 35.561.146a2120.714 2120.714 0 0 1 1.813-9.437l.501-2.663A112 112 0 0 1 200 97"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#006CA7",
        d: "m102.066 125.66 2.988-.002c3.242.002 6.482.025 9.723.049q3.383.009 6.764.013c5.92.011 11.84.04 17.76.074 6.046.03 12.092.044 18.138.06q17.781.05 35.561.146c-4.371 19.341-8.797 38.657-13.688 57.875a10411 10411 0 0 0-3.355 13.282 1411 1411 0 0 0-9.457 40.03c-1.872 8.37-4.018 16.627-6.387 24.868-1.117 3.96-2.115 7.953-3.113 11.945h49c-4 20-4 20-7 29q-20.497.141-40.996.207c-6.346.021-12.691.05-19.037.095q-9.19.063-18.382.078-3.5.01-7.003.043c-3.277.03-6.553.033-9.83.031l-2.905.044c-9.2-.056-16.32-3.2-23.054-9.436-5.64-6.488-7.89-13.978-7.954-22.442l-.03-3.232-.018-3.515-.03-3.727q-.043-6.106-.07-12.212l-.01-2.105q-.047-9.843-.074-19.685a4392 4392 0 0 0-.133-25.092 2596 2596 0 0 1-.08-17.69c-.004-3.514-.019-7.027-.059-10.541-.044-3.93-.04-7.858-.032-11.788l-.06-3.472c.082-9.282 2.711-17.124 9.045-24.07 7.39-7.06 13.814-8.948 23.778-8.832"
    }));

const WebComponents = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 128 128",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "var(--bgcolor, #fff)",
        d: "m31 12-1 1L2 63l29 51h67l15-26v-2l14-23-15-24v-2L98 12zm21 30h21l13 21-13 21H52L40 63z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#166da5",
        d: "m122 63-12 21-18-21 18-21z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8fdb69",
        d: "M108 88 89 65 78 84l17 26z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#166da5",
        d: "M108 38 89 61 78 42l17-26z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M63 110 35 63l28-47H33L6 63l27 47z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#287bbe",
        d: "m50 38 13-22h32l13 22zm28 4h32l11 19H89z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ddf021",
        d: "m50 88 13 22h32l13-22zm28-4h32l11-19H89z"
    }));

const WebKit = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 283",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#34AADC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#007AFF"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF9D00",
        d: "M242.794 157.204c17.608 13.732 17.608 36.323 0 50.166l-82.85 65.116c-17.609 13.732-46.28 13.732-63.888 0l-82.85-65.006c-17.608-13.732-17.608-36.323 0-50.166l82.85-65.116c17.609-13.732 46.28-13.732 63.888 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillOpacity: 0.1,
        d: "M96.255 231.842 13.038 166.44C4.648 159.867 0 151.065 0 141.706s4.648-18.161 13.038-24.735l83.217-65.513c8.39-6.574 19.727-10.25 31.745-10.25s23.242 3.676 31.745 10.25l83.217 65.402c8.39 6.573 13.038 15.375 13.038 24.734s-4.648 18.161-13.038 24.735l-83.217 65.402c-8.503 6.685-19.727 10.362-31.745 10.362s-23.242-3.677-31.745-10.25Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M96.255 231.842 13.038 166.44C4.648 159.867 0 151.065 0 141.706s4.648-18.161 13.038-24.735l83.217-65.513c8.39-6.574 19.727-10.25 31.745-10.25s23.242 3.676 31.745 10.25l83.217 65.402c8.39 6.573 13.038 15.375 13.038 24.734s-4.648 18.161-13.038 24.735l-83.217 65.402c-8.503 6.685-19.727 10.362-31.745 10.362s-23.242-3.677-31.745-10.25Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillOpacity: 0.1,
        d: "m96.255 190.635-83.217-65.402C4.648 118.659 0 109.857 0 100.498s4.648-18.16 13.038-24.734L96.255 10.25C104.645 3.677 115.982 0 128 0s23.242 3.677 31.745 10.25l83.217 65.402C251.352 82.226 256 91.028 256 100.387s-4.648 18.161-13.038 24.735l-83.217 65.402c-8.503 6.685-19.727 10.361-31.745 10.361s-23.242-3.676-31.745-10.25"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "m96.255 190.635-83.217-65.402C4.648 118.659 0 109.857 0 100.498s4.648-18.16 13.038-24.734L96.255 10.25C104.645 3.677 115.982 0 128 0s23.242 3.677 31.745 10.25l83.217 65.402C251.352 82.226 256 91.028 256 100.387s-4.648 18.161-13.038 24.735l-83.217 65.402c-8.503 6.685-19.727 10.361-31.745 10.361s-23.242-3.676-31.745-10.25"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M128.287 163.176c42.524 0 76.996-28.178 76.996-62.937s-34.472-62.938-76.996-62.938-76.995 28.178-76.995 62.938 34.472 62.937 76.995 62.937m0 6.48c-46.9 0-84.921-31.08-84.921-69.417s38.02-69.417 84.921-69.417 84.922 31.079 84.922 69.417-38.02 69.416-84.922 69.416Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#8CC8F6",
        d: "M133.962 126.953c4.257-.557 8.406-1.744 12.204-3.56l24.237 9.963-12.696-19.02c6.678-8.602 6.678-19.498 0-28.1l12.696-19.02-22.843 9.39-.656 10.043c9.338 7.832 9.1 20.2-.604 27.76-2.476 1.98-5.319 3.37-8.305 4.358zm-11.33-53.35c-7.03.913-12.299 3.575-12.299 3.575l-24.215-9.962 12.696 19.02c-6.678 8.602-6.678 19.498 0 28.1l-12.696 19.02 23.467-9.646.5-9.407c-9.817-7.809-9.738-20.301.16-28.144 2.302-2.061 7.508-4.244 8.289-4.36z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m116.64 98.162-3.226 57.174 26.118-53.025 3.74-57.066zm-.338 46.185 20.92-42.446-18.332-3.345z"
    }));

const Webdev = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 215 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#6CF",
        d: "M1.075 45.08c0-2.88 2.35-5.213 5.248-5.213h27.989c2.898 0 5.248 2.334 5.248 5.212s-2.35 5.213-5.248 5.213H6.322c-2.897 0-5.247-2.334-5.247-5.213Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#06F",
        fillRule: "evenodd",
        d: "M2.612 13.594a5.273 5.273 0 0 1 7.422 0l13.994 13.9a5.187 5.187 0 0 1 0 7.371l-13.994 13.9a5.273 5.273 0 0 1-7.422 0 5.187 5.187 0 0 1 0-7.371l9.665-9.6a.865.865 0 0 0 0-1.229l-9.665-9.6a5.187 5.187 0 0 1 0-7.37Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C6F",
        d: "m18.993 39.867-8.96 8.898a5.273 5.273 0 0 1-7.42 0 5.187 5.187 0 0 1 0-7.371l1.536-1.527z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#06F",
        d: "M34.312 50.292c2.898 0 5.248-2.334 5.248-5.213s-2.35-5.212-5.248-5.212-5.248 2.334-5.248 5.212 2.35 5.213 5.248 5.213"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#5F6368",
        fillRule: "evenodd",
        d: "M200.552 45.338h-3.784l-8.256-20.33h4.128l6.02 15.717 6.02-15.717h4.128zm-28.896-12.471h11.696c-.172-2.734-2.408-4.954-5.848-4.954-2.924 0-5.16 1.879-5.848 4.954m6.192 13.154c-6.02 0-10.32-4.613-10.32-10.763s4.3-10.762 10.148-10.762c6.02 0 9.976 4.1 9.976 11.104v.342h-15.996c.172 3.929 3.096 6.662 6.536 6.662 2.408 0 4.472-1.196 5.676-3.587l3.44 1.708c-1.892 3.246-5.332 5.296-9.46 5.296m-24.08 0c-5.332 0-9.804-4.783-9.804-10.763s4.472-10.762 9.804-10.762c2.924 0 5.676 1.367 7.052 3.417h.172l-.172-2.734v-9.396h3.784v29.555h-3.612v-2.734h-.172c-1.548 2.05-4.128 3.417-7.052 3.417m.516-3.417c3.784 0 6.536-2.904 6.536-7.346 0-4.27-2.752-7.345-6.536-7.345-3.612 0-6.536 3.075-6.536 7.345 0 4.271 2.924 7.346 6.536 7.346m-11.696.171c0 1.538-1.204 2.733-2.924 2.733-1.548 0-2.924-1.366-2.924-2.733 0-1.537 1.376-2.733 2.924-2.733 1.72 0 2.924 1.196 2.924 2.733m-18.06-.17c3.612 0 6.536-3.076 6.536-7.347s-2.924-7.345-6.536-7.345c-3.784 0-6.536 3.075-6.536 7.345 0 4.271 2.752 7.346 6.536 7.346Zm.688 3.416c-2.924 0-5.676-1.367-7.052-3.417h-.172v2.734h-3.612V15.783h3.784v9.396l-.172 2.734h.172c1.376-2.05 3.956-3.417 7.052-3.417 5.332 0 9.804 4.783 9.804 10.762-.172 5.98-4.472 10.763-9.804 10.763M95.288 32.867h11.696c-.172-2.734-2.408-4.954-5.848-4.954-2.924 0-5.16 1.879-5.848 4.954m6.192 13.154c-6.02 0-10.32-4.613-10.32-10.763s4.3-10.762 10.148-10.762c6.02 0 9.976 4.1 9.976 11.104v.342H95.288c.172 3.929 3.096 6.662 6.536 6.662q3.612 0 5.676-3.587l3.44 1.708c-1.892 3.246-5.332 5.296-9.46 5.296M90.644 25.179l-6.536 20.33h-3.956l-5.16-15.546-4.988 15.545h-3.956L59.34 25.18h3.956l4.472 15.375 4.988-15.375h3.956L81.7 40.554l4.472-15.375z",
        clipRule: "evenodd"
    }));

const Webflow = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1080 674",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#146EF5",
        fillRule: "evenodd",
        d: "M1080 0 735.386 673.684H411.695l144.221-279.203h-6.471C430.464 548.934 252.942 650.61 0 673.684v-275.34s161.813-9.557 256.938-109.568H0V.006H288.77v237.509l6.481-.026L413.254.005h218.39V236.01l6.482-.01L760.555 0z",
        clipRule: "evenodd"
    }));

const WhatsApp = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 259",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00E676",
        d: "m67.663 221.823 4.185 2.093c17.44 10.463 36.971 15.346 56.503 15.346 61.385 0 111.609-50.224 111.609-111.609 0-29.297-11.859-57.897-32.785-78.824-20.927-20.927-48.83-32.785-78.824-32.785-61.385 0-111.61 50.224-110.912 112.307 0 20.926 6.278 41.156 16.741 58.594l2.79 4.186-11.16 41.156z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M219.033 37.668C195.316 13.254 162.531 0 129.048 0 57.898 0 .698 57.897 1.395 128.35c0 22.322 6.278 43.947 16.742 63.478L0 258.096l67.663-17.439c18.834 10.464 39.76 15.347 60.688 15.347 70.453 0 127.653-57.898 127.653-128.35 0-34.181-13.254-66.269-36.97-89.986ZM129.048 234.38c-18.834 0-37.668-4.882-53.712-14.648l-4.185-2.093-40.458 10.463 10.463-39.76-2.79-4.186C7.673 134.63 22.322 69.058 72.546 38.365s115.097-16.043 145.79 34.181 16.043 115.097-34.18 145.79c-16.045 10.463-35.576 16.043-55.108 16.043Zm61.385-77.428-7.673-3.488s-11.16-4.883-18.136-8.371c-.698 0-1.395-.698-2.093-.698-2.093 0-3.488.698-4.883 1.396 0 0-.697.697-10.463 11.858-.698 1.395-2.093 2.093-3.488 2.093h-.698c-.697 0-2.092-.698-2.79-1.395l-3.488-1.395c-7.673-3.488-14.648-7.674-20.229-13.254-1.395-1.395-3.488-2.79-4.883-4.185-4.883-4.883-9.766-10.464-13.253-16.742l-.698-1.395c-.697-.698-.697-1.395-1.395-2.79 0-1.395 0-2.79.698-3.488 0 0 2.79-3.488 4.882-5.58 1.396-1.396 2.093-3.488 3.488-4.883 1.395-2.093 2.093-4.883 1.395-6.976-.697-3.488-9.068-22.322-11.16-26.507-1.396-2.093-2.79-2.79-4.883-3.488H83.01c-1.396 0-2.79.698-4.186.698l-.698.697c-1.395.698-2.79 2.093-4.185 2.79-1.395 1.396-2.093 2.79-3.488 4.186-4.883 6.278-7.673 13.951-7.673 21.624 0 5.58 1.395 11.161 3.488 16.044l.698 2.093c6.278 13.253 14.648 25.112 25.81 35.575l2.79 2.79c2.092 2.093 4.185 3.488 5.58 5.58 14.649 12.557 31.39 21.625 50.224 26.508 2.093.697 4.883.697 6.976 1.395h6.975c3.488 0 7.673-1.395 10.464-2.79 2.092-1.395 3.487-1.395 4.882-2.79l1.396-1.396c1.395-1.395 2.79-2.092 4.185-3.487s2.79-2.79 3.488-4.186c1.395-2.79 2.092-6.278 2.79-9.765v-4.883s-.698-.698-2.093-1.395"
    }));

const WhopDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "prefix__Layer_1",
        x: 0,
        y: 0,
        viewBox: "0 0 383.2 196.4",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("style", null, ".prefix__st0{fill:#fff}"), /*#__PURE__*/ React.createElement("path", {
        d: "M60.9 0C35.7 0 18.4 11.1 5.2 23.5c0 0-5.3 5-5.2 5.2l55.2 55.2 55.2-55.2C99.9 14.3 80.2 0 60.9 0M197.2 0c-25.2 0-42.5 11.1-55.7 23.5 0 0-4.8 4.9-5.1 5.2L68.2 96.9l55.1 55.1L246.6 28.7C236.1 14.3 216.5 0 197.2 0M333.8 0c-25.2 0-42.5 11.1-55.7 23.5 0 0-5 4.9-5.2 5.2L136.4 165.2l14.4 14.4c22.3 22.3 58.9 22.3 81.3 0L383 28.7h.2C372.8 14.3 353.1 0 333.8 0",
        className: "prefix__st0"
    }));

const WhopLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "prefix__Layer_1",
        x: 0,
        y: 0,
        viewBox: "0 0 383.2 196.4",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("style", null, ".prefix__st0{fill:#ff6143}"), /*#__PURE__*/ React.createElement("path", {
        d: "M60.9 0C35.7 0 18.4 11.1 5.2 23.5c0 0-5.3 5-5.2 5.2l55.2 55.2 55.2-55.2C99.9 14.3 80.2 0 60.9 0M197.2 0c-25.2 0-42.5 11.1-55.7 23.5 0 0-4.8 4.9-5.1 5.2L68.2 96.9l55.1 55.1L246.6 28.7C236.1 14.3 216.5 0 197.2 0M333.8 0c-25.2 0-42.5 11.1-55.7 23.5 0 0-5 4.9-5.2 5.2L136.4 165.2l14.4 14.4c22.3 22.3 58.9 22.3 81.3 0L383 28.7h.2C372.8 14.3 353.1 0 333.8 0",
        className: "prefix__st0"
    }));

const WindiCSS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 279",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "16.639%",
        x2: "137.275%",
        y1: "36.186%",
        y2: "175.371%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "7.822%",
        stopColor: "#54C8F1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "57.292%",
        stopColor: "#41A2EF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#3386EE"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__b",
        x1: "-22.099%",
        x2: "91.451%",
        y1: "-49.621%",
        y2: "73.695%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "7.822%",
        stopColor: "#54C8F1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "57.292%",
        stopColor: "#41A2EF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#3386EE"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "8.696%",
        x2: "71.739%",
        y1: "37.461%",
        y2: "80.271%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "7.822%",
        stopColor: "#54C8F1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "57.292%",
        stopColor: "#41A2EF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#3386EE"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__d",
        x1: "60.744%",
        x2: "501.135%",
        y1: "-308.636%",
        y2: "225.788%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "7.822%",
        stopColor: "#54C8F1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "57.292%",
        stopColor: "#41A2EF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#3386EE"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M133.784 48.922C133.784 21.945 111.84 0 84.863 0c-28.43 0-45.428 21.316-45.428 41.933h27.956c0-5.8 5.423-13.978 17.472-13.978 11.56 0 20.966 9.407 20.966 20.967s-8.438 20.966-29.715 20.966H0v27.955h76.114c35.911 0 57.67-21.944 57.67-48.921m0 0C133.784 21.945 111.84 0 84.863 0c-28.43 0-45.428 21.316-45.428 41.933h27.956c0-5.8 5.423-13.978 17.472-13.978 11.56 0 20.966 9.407 20.966 20.967s-8.438 20.966-29.715 20.966H0v27.955h76.114c35.911 0 57.67-21.944 57.67-48.921"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__b)",
        d: "M195.803 229.339c0 26.978-21.945 48.922-48.922 48.922-28.43 0-45.427-21.315-45.427-41.933h27.955c0 5.8 5.423 13.979 17.472 13.979 11.56 0 20.967-9.408 20.967-20.968s-10.63-20.966-29.716-20.966H53.671v-27.956h84.461c35.912 0 57.671 21.945 57.671 48.922m0 0c0 26.978-21.945 48.922-48.922 48.922-28.43 0-45.427-21.315-45.427-41.933h27.955c0 5.8 5.423 13.979 17.472 13.979 11.56 0 20.967-9.408 20.967-20.968s-10.63-20.966-29.716-20.966H53.671v-27.956h84.461c35.912 0 57.671 21.945 57.671 48.922"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__c)",
        d: "M203.13 43.13c-30.834 0-52.585 23.45-52.585 54.284h24.76c0-15.327 11.13-26.457 27.825-26.457 16.696 0 25.044 11.13 25.044 26.457s-10.842 27.955-40.348 27.955H0v27.956h192c43.695 0 64-28.085 64-55.911 0-30.835-20.87-54.284-52.87-54.284"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__d)",
        d: "M36.647 180.417H0v28.19h36.647z"
    }));

const Windows = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 88 88",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#00adef",
        d: "m0 12.402 35.687-4.86.016 34.423-35.67.203zm35.67 33.529.028 34.453L.028 75.48.026 45.7zm4.326-39.025L87.314 0v41.527l-47.318.376zm47.329 39.349-.011 41.34-47.318-6.678-.066-34.739z"
    }));

const Windsurf = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 166 263",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#58E5BB",
        d: "M42.086 128.474 28.427 90.089c-2.383-6.696 2.436-13.802 9.291-13.48 76.537 3.589 115.804 31.534 112.144 112.12-13.311-56.28-77.153-60.255-107.776-60.255"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__b)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#58E5BB",
        d: "M21.453 57.833 7.236 20.639C4.662 13.908 9.478 6.6 16.44 6.683c78.163.938 132.738 6.243 132.738 110.722-13.311-56.28-97.101-59.572-127.725-59.572"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#prefix__c)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#58E5BB",
        d: "m63.245 201.377-14.653-41.075c-2.376-6.661 2.376-13.751 9.196-13.388 62.444 3.327 93.677 30.587 90.06 110.239-13.311-56.28-53.76-55.776-84.604-55.776Z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__a",
        width: 122.286,
        height: 116.131,
        x: 27.81,
        y: 76.598,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 2
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        k2: -1,
        k3: 1,
        operator: "arithmetic"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "shape",
        result: "effect1_innerShadow_15473_4390"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__b",
        width: 142.645,
        height: 114.724,
        x: 6.533,
        y: 6.682,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 2
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        k2: -1,
        k3: 1,
        operator: "arithmetic"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "shape",
        result: "effect1_innerShadow_15473_4390"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__c",
        width: 100.158,
        height: 114.252,
        x: 47.972,
        y: 146.9,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 2
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        k2: -1,
        k3: 1,
        operator: "arithmetic"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "shape",
        result: "effect1_innerShadow_15473_4390"
    }))));

const WordPress = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 122.52 122.523",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "#21759b"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.708 61.26c0 20.802 12.089 38.779 29.619 47.298L13.258 39.872a52.35 52.35 0 0 0-4.55 21.388M96.74 58.608c0-6.495-2.333-10.993-4.334-14.494-2.664-4.329-5.161-7.995-5.161-12.324 0-4.831 3.664-9.328 8.825-9.328.233 0 .454.029.681.042-9.35-8.566-21.807-13.796-35.489-13.796-18.36 0-34.513 9.42-43.91 23.688 1.233.037 2.395.063 3.382.063 5.497 0 14.006-.667 14.006-.667 2.833-.167 3.167 3.994.337 4.329 0 0-2.847.335-6.015.501L48.2 93.547l11.501-34.493-8.188-22.434c-2.83-.166-5.511-.501-5.511-.501-2.832-.166-2.5-4.496.332-4.329 0 0 8.679.667 13.843.667 5.496 0 14.006-.667 14.006-.667 2.835-.167 3.168 3.994.337 4.329 0 0-2.853.335-6.015.501l18.992 56.494 5.242-17.517c2.272-7.269 4.001-12.49 4.001-16.989"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m62.184 65.857-15.768 45.819a52.6 52.6 0 0 0 14.846 2.141c6.12 0 11.989-1.058 17.452-2.979a4.6 4.6 0 0 1-.374-.724zM107.376 36.046c.226 1.674.354 3.471.354 5.404 0 5.333-.996 11.328-3.996 18.824l-16.053 46.413c15.624-9.111 26.133-26.038 26.133-45.426.001-9.137-2.333-17.729-6.438-25.215"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M61.262 0C27.483 0 0 27.481 0 61.26c0 33.783 27.483 61.263 61.262 61.263s61.265-27.48 61.265-61.263C122.526 27.481 95.04 0 61.262 0m0 119.715c-32.23 0-58.453-26.223-58.453-58.455 0-32.23 26.222-58.451 58.453-58.451 32.229 0 58.45 26.221 58.45 58.451 0 32.232-26.221 58.455-58.45 58.455"
    })));

const WorkOSDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "prefix__Layer_1",
        x: 0,
        y: 0,
        viewBox: "0 0 55.4 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("style", null, ".prefix__st0{fill:#fff}"), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__logo-icon",
        d: "M0 24c0 1.1.3 2.1.8 3l9.7 16.8c1 1.7 2.5 3.1 4.4 3.7 3.6 1.2 7.5-.3 9.4-3.5l2.3-4.1-9.2-16L27.2 7l2.3-4q1.05-1.8 2.7-3h-15c-2.6 0-5.1 1.4-6.4 3.7L.8 21c-.5.9-.8 1.9-.8 3",
        className: "prefix__st0"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__logo-icon_1_",
        d: "M55.4 24c0-1.1-.3-2.1-.8-3L44.8 4C42.9.7 39-.7 35.4.5c-1.9.6-3.4 2-4.4 3.7L28.7 8 38 24l-9.8 16.9-2.3 4.1q-1.05 1.8-2.7 3h15.1c2.6 0 5.1-1.4 6.4-3.7l10-17.3c.4-.9.7-1.9.7-3",
        className: "prefix__st0"
    }));

const WorkOSLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        id: "prefix__Layer_1",
        x: 0,
        y: 0,
        viewBox: "0 0 55.4 48",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("style", null, ".prefix__st0{fill:#6363f1}"), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__logo-icon",
        d: "M0 24c0 1.1.3 2.1.8 3l9.7 16.8c1 1.7 2.5 3.1 4.4 3.7 3.6 1.2 7.5-.3 9.4-3.5l2.3-4.1-9.2-16L27.2 7l2.3-4q1.05-1.8 2.7-3h-15c-2.6 0-5.1 1.4-6.4 3.7L.8 21c-.5.9-.8 1.9-.8 3",
        className: "prefix__st0"
    }), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__logo-icon_1_",
        d: "M55.4 24c0-1.1-.3-2.1-.8-3L44.8 4C42.9.7 39-.7 35.4.5c-1.9.6-3.4 2-4.4 3.7L28.7 8 38 24l-9.8 16.9-2.3 4.1q-1.05 1.8-2.7 3h15.1c2.6 0 5.1-1.4 6.4-3.7l10-17.3c.4-.9.7-1.9.7-3",
        className: "prefix__st0"
    }));

const XAIDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        fill: "#ffff",
        viewBox: "0 0 841.89 595.28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m557.09 211.99 8.31 326.37h66.56l8.32-445.18zm83.19-155.08H538.72L379.35 284.53l50.78 72.52zM201.61 538.36h101.56l50.79-72.52-50.79-72.53zm0-326.37 228.52 326.37h101.56L303.17 211.99z"
    }));

const XAILight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 841.89 595.28",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m557.09 211.99 8.31 326.37h66.56l8.32-445.18zm83.19-155.08H538.72L379.35 284.53l50.78 72.52zM201.61 538.36h101.56l50.79-72.52-50.79-72.53zm0-326.37 228.52 326.37h101.56L303.17 211.99z"
    }));

const XD = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 240 234",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#470137",
        d: "M42.5 0h155C221 0 240 19 240 42.5v149c0 23.5-19 42.5-42.5 42.5h-155C19 234 0 215 0 191.5v-149C0 19 19 0 42.5 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ff61f6",
        d: "m126.2 61.5-30 49.5 32 52.5c.2.4.3.8.2 1.2s-.5.1-1.1.2h-22.9c-1.6 0-2.7-.1-3.4-1.1-2.1-4.2-4.3-8.3-6.4-12.5-2.1-4.1-4.4-8.3-6.8-12.6s-4.8-8.6-7.2-13h-.2c-2.1 4.3-4.4 8.6-6.7 12.9s-4.6 8.6-6.8 12.8c-2.3 4.2-4.6 8.5-6.9 12.6-.4 1-1.2 1.1-2.3 1.1h-22c-.4 0-.7.2-.7-.3-.1-.4 0-.8.2-1.1l31.1-51L36 61.4c-.3-.4-.4-.8-.2-1 .2-.3.6-.4 1-.4h22.7c.5 0 1 .1 1.4.2.4.2.7.5 1 .9 1.9 4.3 4.1 8.6 6.4 12.9 2.4 4.3 4.7 8.5 7.2 12.7 2.4 4.2 4.6 8.4 6.7 12.7h.2c2.1-4.4 4.3-8.7 6.5-12.9s4.5-8.4 6.8-12.6 4.5-8.5 6.7-12.6c.1-.4.3-.8.6-1 .4-.2.8-.3 1.3-.2h21.1c.5-.1 1 .2 1.1.7.1.1-.1.5-.3.7M172.4 167c-7.4.1-14.8-1.4-21.5-4.5-6.3-2.9-11.5-7.7-15.1-13.6-3.7-6.1-5.5-13.7-5.5-22.8-.1-7.4 1.8-14.7 5.5-21.1 3.8-6.5 9.3-11.9 15.9-15.5 7-3.9 15.4-5.8 25.3-5.8.5 0 1.2 0 2.1.1s1.9.1 3.1.2V52.4c0-.7.3-1.1 1-1.1h20.3c.5-.1.9.3 1 .7v95.4c0 1.8.1 3.8.2 6 .2 2.1.3 4.1.4 5.8 0 .7-.3 1.3-1 1.6-5.2 2.2-10.7 3.8-16.3 4.8-5.1.9-10.2 1.4-15.4 1.4m9.8-20v-44c-.9-.2-1.8-.4-2.7-.5-1.1-.1-2.2-.2-3.3-.2-3.9 0-7.8.8-11.3 2.6-3.4 1.7-6.3 4.2-8.5 7.4s-3.3 7.5-3.3 12.7c-.1 3.5.5 7 1.7 10.3 1 2.7 2.5 5.1 4.5 7.1 1.9 1.8 4.2 3.2 6.8 4 2.7.9 5.5 1.3 8.3 1.3 1.5 0 2.9-.1 4.2-.2 1.3.1 2.4-.1 3.6-.5"
    }));

const XDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1200 1227",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M714.163 519.284 1160.89 0h-105.86L667.137 450.887 357.328 0H0l468.492 681.821L0 1226.37h105.866l409.625-476.152 327.181 476.152H1200L714.137 519.284zM569.165 687.828l-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721H892.476L569.165 687.854z"
    }));

const XLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1200 1227",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M714.163 519.284 1160.89 0h-105.86L667.137 450.887 357.328 0H0l468.492 681.821L0 1226.37h105.866l409.625-476.152 327.181 476.152H1200L714.137 519.284zM569.165 687.828l-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721H892.476L569.165 687.854z"
    }));

const XRP = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 32 32",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FFF",
        stopOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopOpacity: 0.5
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__a",
        width: "111.7%",
        height: "111.7%",
        x: "-5.8%",
        y: "-4.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dy: 0.5,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 0.5
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in: "shadowBlurOuter1",
        in2: "SourceAlpha",
        operator: "out",
        result: "shadowBlurOuter1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.199473505 0"
    })), /*#__PURE__*/ React.createElement("circle", {
        id: "prefix__b",
        cx: 15,
        cy: 15,
        r: 15
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(1)"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#000",
        filter: "url(#prefix__a)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "#23292F",
        fillRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__b",
        fill: "url(#prefix__c)",
        fillRule: "evenodd",
        style: {
            mixBlendMode: "soft-light"
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 15,
        cy: 15,
        r: 14.5,
        stroke: "#000",
        strokeLinejoin: "square",
        strokeOpacity: 0.097
    })), /*#__PURE__*/ React.createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M22.363 8h2.602l-5.414 5.361a5.06 5.06 0 0 1-7.102 0L7.032 8h2.605l4.113 4.071a3.2 3.2 0 0 0 4.496 0zM9.605 22.906H7l5.45-5.393a5.06 5.06 0 0 1 7.1 0L25 22.906h-2.605L18.25 18.8a3.2 3.2 0 0 0-4.496 0z"
    }))));

const XStateDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 800 405",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M342.953 156.14c20.78 0 33.34 8.767 35.358 24.687l.061.48H366.49l-.074-.333c-2.34-10.754-9.356-15.342-23.463-15.342-12.799 0-20.752 5.323-20.752 13.889 0 8.456 3.477 12.681 24.072 15.378 21.535 2.94 34.883 8.334 34.883 26.096 0 15.089-15.264 26.467-35.5 26.467-29.518 0-37.608-15.437-39.196-28.39l-.059-.478h12.76l.054.363c1.47 9.876 5.691 19.016 26.438 19.016 13.178 0 22.74-6.83 22.74-16.239 0-10.026-5.659-13.879-24.218-16.485-17.819-2.376-34.307-7.016-34.307-24.738 0-14.122 13.914-24.371 33.085-24.371m122.576 1.11v11.316h-29.547v77.787H422.79v-77.787h-29.547V157.25zm52.908 0 34.709 89.103h-13.108l-9.947-25.427h-41.344l-9.8 25.427h-12.549l35.283-89.104zm108.826 0v11.316h-29.547v77.787h-13.188v-77.784H554.98v-11.317h72.282zm81.737 0v11.316h-49.311v27.44h25.027v11.195h-25.027v27.832H709v11.317h-62.5v-89.1zm-199.51 10.462-16.154 42.994h32.306zM99.363 113l33.464.272a10.62 10.62 0 0 1 8.304 4.108l119.56 154.056c2.71 3.488.22 8.564-4.192 8.564h-35.035c-3.31 0-6.432-1.543-8.44-4.172l-33.345-45.635-36.905 45.777a10.62 10.62 0 0 1-8.33 4.03H99.32c-4.437 0-6.917-5.122-4.165-8.603l58.543-74.144-58.595-75.718c-2.68-3.51-.154-8.569 4.263-8.532zm157.091 0c4.46-.034 6.973 5.108 4.207 8.603l-52.239 66.006c-3.726-2.932-32.644-27.14-4.745-59.556 0 0 2.183-2.554 4.435-5.195l.436-.511.435-.51a676 676 0 0 0 3.842-4.533c2.759-3.339 5.03-4.005 8.247-4.03z"
    }));

const XStateLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 800 405",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M342.953 156.14c20.78 0 33.34 8.767 35.358 24.687l.061.48H366.49l-.074-.333c-2.34-10.754-9.356-15.342-23.463-15.342-12.799 0-20.752 5.323-20.752 13.889 0 8.456 3.477 12.681 24.072 15.378 21.535 2.94 34.883 8.334 34.883 26.096 0 15.089-15.264 26.467-35.5 26.467-29.518 0-37.608-15.437-39.196-28.39l-.059-.478h12.76l.054.363c1.47 9.876 5.691 19.016 26.438 19.016 13.178 0 22.74-6.83 22.74-16.239 0-10.026-5.659-13.879-24.218-16.485-17.819-2.376-34.307-7.016-34.307-24.738 0-14.122 13.914-24.371 33.085-24.371m122.576 1.11v11.316h-29.547v77.787H422.79v-77.787h-29.547V157.25zm52.908 0 34.709 89.103h-13.108l-9.947-25.427h-41.344l-9.8 25.427h-12.549l35.283-89.104zm108.826 0v11.316h-29.547v77.787h-13.188v-77.784H554.98v-11.317h72.282zm81.737 0v11.316h-49.311v27.44h25.027v11.195h-25.027v27.832H709v11.317h-62.5v-89.1zm-199.51 10.462-16.154 42.994h32.306zM99.363 113l33.464.272a10.62 10.62 0 0 1 8.304 4.108l119.56 154.056c2.71 3.488.22 8.564-4.192 8.564h-35.035c-3.31 0-6.432-1.543-8.44-4.172l-33.345-45.635-36.905 45.777a10.62 10.62 0 0 1-8.33 4.03H99.32c-4.437 0-6.917-5.122-4.165-8.603l58.543-74.144-58.595-75.718c-2.68-3.51-.154-8.569 4.263-8.532zm157.091 0c4.46-.034 6.973 5.108 4.207 8.603l-52.239 66.006c-3.726-2.932-32.644-27.14-4.745-59.556 0 0 2.183-2.554 4.435-5.195l.436-.511.435-.51a676 676 0 0 0 3.842-4.533c2.759-3.339 5.03-4.005 8.247-4.03z"
    }));

const Xbox = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 88 88",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#107c10",
        d: "M39.73 86.91c-6.628-.635-13.338-3.015-19.102-6.776-4.83-3.15-5.92-4.447-5.92-7.032 0-5.193 5.71-14.29 15.48-24.658 5.547-5.89 13.275-12.79 14.11-12.604 1.626.363 14.616 13.034 19.48 19 7.69 9.43 11.224 17.154 9.428 20.597-1.365 2.617-9.837 7.733-16.06 9.698-5.13 1.62-11.867 2.306-17.416 1.775M8.184 67.703c-4.014-6.158-6.042-12.22-7.02-20.988-.324-2.895-.21-4.55.733-10.494 1.173-7.4 5.39-15.97 10.46-21.24 2.158-2.24 2.35-2.3 4.982-1.41 3.19 1.08 6.6 3.436 11.89 8.22l3.09 2.794-1.69 2.07c-7.828 9.61-16.09 23.24-19.2 31.67-1.69 4.58-2.37 9.18-1.64 11.095.49 1.294.04.812-1.61-1.714zm70.453 1.047c.397-1.936-.105-5.49-1.28-9.076-2.545-7.765-11.054-22.21-18.867-32.032l-2.46-3.092 2.662-2.443c3.474-3.19 5.886-5.1 8.49-6.723 2.053-1.28 4.988-2.413 6.25-2.413.777 0 3.516 2.85 5.726 5.95 3.424 4.8 5.942 10.63 7.218 16.69.825 3.92.894 12.3.133 16.21-.63 3.208-1.95 7.366-3.23 10.187-.97 2.113-3.36 6.218-4.41 7.554-.54.687-.54.686-.24-.796zM40.44 11.505C36.834 9.675 31.272 7.71 28.2 7.18c-1.076-.185-2.913-.29-4.08-.23-2.536.128-2.423-.004 1.643-1.925 3.38-1.597 6.2-2.536 10.03-3.34C40.098.78 48.193.77 52.43 1.663c4.575.965 9.964 2.97 13 4.84l.904.554-2.07-.104C60.148 6.745 54.15 8.408 47.71 11.54c-1.942.946-3.63 1.7-3.754 1.68-.123-.024-1.706-.795-3.52-1.715z"
    }));

const YGeeker = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        strokeMiterlimit: 10,
        style: {
            fillRule: "nonzero",
            clipRule: "evenodd",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        },
        viewBox: "0 0 1024 1024",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#63c862",
        d: "M536.359 484.569c-25.15-60.396 142.849-333.837 227.229-362.525 44.196-15.027 93.145 56.185 106.992 114.053 13.909 58.129 7.806 118.903-30.581 165.845-43.264 52.904-280.757 137.58-303.64 82.627"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ffca3d",
        d: "M474.634 497.831c-36.492 18.111-128.758-5.131-225.151-42.057C164.575 423.249 61.32 336.983 59.942 310.149c-2.09-40.708 57.502-77.667 126.354-90.298 69.161-12.689 150.336-15.261 196.02 23.096 77.447 65.025 160.404 221.093 92.318 254.884"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4ebffe",
        d: "M535.511 552.81c64.871 33.983 142.066 358.05 109.633 394.921-29.259 33.262-109.374 13.305-165.203-22.387-56.08-35.852-81.135-97.144-77.303-152.334 6.495-93.565 68.002-254.183 132.873-220.2"
    }));

const Yarn = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 518 518",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M259 0c143 0 259 116 259 259S402 518 259 518 0 402 0 259 116 0 259 0",
        style: {
            fill: "#2c8ebb"
        }
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M435.2 337.5c-1.8-14.2-13.8-24-29.2-23.8-23 .3-42.3 12.2-55.1 20.1-5 3.1-9.3 5.4-13 7.1.8-11.6.1-26.8-5.9-43.5-7.3-20-17.1-32.3-24.1-39.4 8.1-11.8 19.2-29 24.4-55.6 4.5-22.7 3.1-58-7.2-77.8-2.1-4-5.6-6.9-10-8.1-1.8-.5-5.2-1.5-11.9.4C293.1 96 289.6 93.8 286.9 92c-5.6-3.6-12.2-4.4-18.4-2.1-8.3 3-15.4 11-22.1 25.2-1 2.1-1.9 4.1-2.7 6.1-12.7.9-32.7 5.5-49.6 23.8-2.1 2.3-6.2 4-10.5 5.6h.1c-8.8 3.1-12.8 10.3-17.7 23.3-6.8 18.2.2 36.1 7.1 47.7-9.4 8.4-21.9 21.8-28.5 37.5-8.2 19.4-9.1 38.4-8.8 48.7-7 7.4-17.8 21.3-19 36.9-1.6 21.8 6.3 36.6 9.8 42 1 1.6 2.1 2.9 3.3 4.2-.4 2.7-.5 5.6.1 8.6 1.3 7 5.7 12.7 12.4 16.3 13.2 7 31.6 10 45.8 2.9 5.1 5.4 14.4 10.6 31.3 10.6h1c4.3 0 58.9-2.9 74.8-6.8 7.1-1.7 12-4.7 15.2-7.4 10.2-3.2 38.4-12.8 65-30 18.8-12.2 25.3-14.8 39.3-18.2 13.6-3.3 22.1-15.7 20.4-29.4m-23.8 14.7c-16 3.8-24.1 7.3-43.9 20.2-30.9 20-64.7 29.3-64.7 29.3s-2.8 4.2-10.9 6.1c-14 3.4-66.7 6.3-71.5 6.4-12.9.1-20.8-3.3-23-8.6-6.7-16 9.6-23 9.6-23s-3.6-2.2-5.7-4.2c-1.9-1.9-3.9-5.7-4.5-4.3-2.5 6.1-3.8 21-10.5 27.7-9.2 9.3-26.6 6.2-36.9.8-11.3-6 .8-20.1.8-20.1s-6.1 3.6-11-3.8c-4.4-6.8-8.5-18.4-7.4-32.7 1.2-16.3 19.4-32.1 19.4-32.1s-3.2-24.1 7.3-48.8c9.5-22.5 35.1-40.6 35.1-40.6s-21.5-23.8-13.5-45.2c5.2-14 7.3-13.9 9-14.5 6-2.3 11.8-4.8 16.1-9.5 21.5-23.2 48.9-18.8 48.9-18.8s13-39.5 25-31.8c3.7 2.4 17 32 17 32s14.2-8.3 15.8-5.2c8.6 16.7 9.6 48.6 5.8 68-6.4 32-22.4 49.2-28.8 60-1.5 2.5 17.2 10.4 29 43.1 10.9 29.9 1.2 55 2.9 57.8.3.5.4.7.4.7s12.5 1 37.6-14.5c13.4-8.3 29.3-17.6 47.4-17.8 17.5-.3 18.4 20.2 5.2 23.4",
        style: {
            fill: "#fff"
        }
    }));

const YouTube = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 180",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "red",
        d: "M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m102.421 128.06 66.328-38.418-66.328-38.418z"
    }));

const YoutubeMusic = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 192 192",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "none",
        d: "M0 0h192v192H0z"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 96,
        cy: 96,
        r: 88,
        fill: "red"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M96 50.32c25.19 0 45.68 20.49 45.68 45.68S121.19 141.68 96 141.68 50.32 121.19 50.32 96 70.81 50.32 96 50.32m0-6.4c-28.76 0-52.08 23.32-52.08 52.08S67.24 148.08 96 148.08s52.08-23.32 52.08-52.08S124.76 43.92 96 43.92"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "m79 122 45-26-45-26z"
    }));

const ZeaburDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 294 229",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M114 145h179v84H0v-84h82l114-61H0V0h293v84z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#6300FF",
        d: "M195 0H0v84h195z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F40",
        d: "M293 145H115v84h178z"
    }));

const ZeaburLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 294 229",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M114 145h179v84H0v-84h82l114-61H0V0h293v84z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#6300FF",
        d: "M195 0H0v84h195z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F40",
        d: "M293 145H115v84h178z"
    }));

const ZedDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#ffff",
        fillRule: "evenodd",
        d: "M9 6a3 3 0 0 0-3 3v66H0V9a9 9 0 0 1 9-9h80.379c4.009 0 6.016 4.847 3.182 7.682L43.055 57.187H57V51h6v7.688a4.5 4.5 0 0 1-4.5 4.5H37.055L26.743 73.5H73.5V36h6v37.5a6 6 0 0 1-6 6H20.743L10.243 90H87a3 3 0 0 0 3-3V21h6v66a9 9 0 0 1-9 9H6.621c-4.009 0-6.016-4.847-3.182-7.682L52.757 39H39v6h-6v-7.5a4.5 4.5 0 0 1 4.5-4.5h21.257l10.5-10.5H22.5V60h-6V22.5a6 6 0 0 1 6-6h52.757L85.757 6z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h96v96H0z"
    }))));

const ZedLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 6a3 3 0 0 0-3 3v66H0V9a9 9 0 0 1 9-9h80.379c4.009 0 6.016 4.847 3.182 7.682L43.055 57.187H57V51h6v7.688a4.5 4.5 0 0 1-4.5 4.5H37.055L26.743 73.5H73.5V36h6v37.5a6 6 0 0 1-6 6H20.743L10.243 90H87a3 3 0 0 0 3-3V21h6v66a9 9 0 0 1-9 9H6.621c-4.009 0-6.016-4.847-3.182-7.682L52.757 39H39v6h-6v-7.5a4.5 4.5 0 0 1 4.5-4.5h21.257l10.5-10.5H22.5V60h-6V22.5a6 6 0 0 1 6-6h52.757L85.757 6z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "prefix__a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h96v96H0z"
    }))));

const ZenBrowserDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F76F53",
        fillRule: "evenodd",
        d: "M32 44.308c6.797 0 12.308-5.51 12.308-12.308 0-6.797-5.51-12.308-12.308-12.308-6.797 0-12.308 5.51-12.308 12.308 0 6.797 5.51 12.308 12.308 12.308M41.846 32c0 5.438-4.408 9.846-9.846 9.846S22.154 37.438 22.154 32s4.408-9.846 9.846-9.846 9.846 4.408 9.846 9.846",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F76F53",
        fillRule: "evenodd",
        d: "M53.333 32c0 11.782-9.55 21.333-21.333 21.333S10.667 43.783 10.667 32 20.217 10.667 32 10.667 53.333 20.217 53.333 32M32 49.23c9.516 0 17.23-7.714 17.23-17.23S41.517 14.77 32 14.77 14.77 22.483 14.77 32 22.483 49.23 32 49.23",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F76F53",
        fillRule: "evenodd",
        d: "M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32 14.327 0 32 0s32 14.327 32 32M32 58.256c14.501 0 26.256-11.755 26.256-26.256S46.501 5.744 32 5.744 5.744 17.499 5.744 32 17.499 58.256 32 58.256",
        clipRule: "evenodd"
    }));

const ZenBrowserLight = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 64 64",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#202020",
        fillRule: "evenodd",
        d: "M32 44.308c6.797 0 12.308-5.51 12.308-12.308 0-6.797-5.51-12.308-12.308-12.308-6.797 0-12.308 5.51-12.308 12.308 0 6.797 5.51 12.308 12.308 12.308M41.846 32c0 5.438-4.408 9.846-9.846 9.846S22.154 37.438 22.154 32s4.408-9.846 9.846-9.846 9.846 4.408 9.846 9.846",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#202020",
        fillRule: "evenodd",
        d: "M53.333 32c0 11.782-9.55 21.333-21.333 21.333S10.667 43.783 10.667 32 20.217 10.667 32 10.667 53.333 20.217 53.333 32M32 49.23c9.516 0 17.23-7.714 17.23-17.23S41.517 14.77 32 14.77 14.77 22.483 14.77 32 22.483 49.23 32 49.23",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#202020",
        fillRule: "evenodd",
        d: "M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32 14.327 0 32 0s32 14.327 32 32M32 58.256c14.501 0 26.256-11.755 26.256-26.256S46.501 5.744 32 5.744 5.744 17.499 5.744 32 17.499 58.256 32 58.256",
        clipRule: "evenodd"
    }));

const Zig = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 300 176",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F7A41D",
        d: "M158.395 55.695H85.877V23.453h104.966L262.393 0 142.274 120.337h72.745v32.296H110.048l-71.55 22.655zM0 120.288V23.453h71.746V55.75h-39.46v64.592H80.73l-32.296 32.297H0zm267.709-64.593h-48.45L251.555 23.4H300v129.18h-71.746v-32.296h39.504l-.049-64.588Z"
    }));

const Zod = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 256 203",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid meet",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "prefix__c",
        width: "105.2%",
        height: "106.5%",
        x: "-2.2%",
        y: "-2.8%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ React.createElement("feOffset", {
        dx: 1,
        dy: 1,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: 2
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "shadowBlurOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
    })), /*#__PURE__*/ React.createElement("path", {
        id: "prefix__a",
        d: "M200.42 0H53.63L0 53.355l121.76 146.624 9.714-10.9L252 53.857zm-5.362 12.562 39.84 41.6-112.8 126.558L17 54.162l41.815-41.6z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#18253F",
        d: "M60.816 14.033h136.278l39.933 41.69-112.989 126.554L18.957 55.724z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#274D82",
        d: "M151.427 152.386H98.013l-24.124-29.534 68.364-.002.002-4.19h39.078z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#274D82",
        d: "m225.56 43.834-147.382 85.09-19.226-24.051 114.099-65.877-2.096-3.631 30.391-17.546zm-78.964-29.759L35.93 77.968 18.719 56.483l74.095-42.78z"
    }), /*#__PURE__*/ React.createElement("g", {
        transform: "translate(2 1.51)"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        filter: "url(#prefix__c)"
    }), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#prefix__a",
        fill: "#3068B7"
    })));

const Zoom = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "prefix__a",
        x1: "23.666%",
        x2: "76.334%",
        y1: "95.612%",
        y2: "4.388%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#0845BF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "19.11%",
        stopColor: "#0950DE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "38.23%",
        stopColor: "#0B59F6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "50%",
        stopColor: "#0B5CFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "67.32%",
        stopColor: "#0E5EFE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "77.74%",
        stopColor: "#1665FC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "86.33%",
        stopColor: "#246FF9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "93.88%",
        stopColor: "#387FF4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#4F90EE"
    }))), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#prefix__a)",
        d: "M256 128c0 13.568-1.024 27.136-3.328 40.192-6.912 43.264-41.216 77.568-84.48 84.48C155.136 254.976 141.568 256 128 256s-27.136-1.024-40.192-3.328c-43.264-6.912-77.568-41.216-84.48-84.48C1.024 155.136 0 141.568 0 128s1.024-27.136 3.328-40.192c6.912-43.264 41.216-77.568 84.48-84.48C100.864 1.024 114.432 0 128 0s27.136 1.024 40.192 3.328c43.264 6.912 77.568 41.216 84.48 84.48C254.976 100.864 256 114.432 256 128"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M204.032 207.872H75.008c-8.448 0-16.64-4.608-20.48-12.032-4.608-8.704-2.816-19.2 4.096-26.112l89.856-89.856H83.968c-17.664 0-32-14.336-32-32h118.784c8.448 0 16.64 4.608 20.48 12.032 4.608 8.704 2.816 19.2-4.096 26.112l-89.6 90.112h74.496c17.664 0 32 14.08 32 31.744"
    }));

const AMPUrl = "https://amp.dev/";
const AdobeUrl = "https://www.adobe.com/";
const AffinityDesignerUrl = "https://affinity.serif.com/en-us/designer/";
const AffinityPhotoUrl = "https://affinity.serif.com/en-us/photo/";
const AffinityPublisherUrl = "https://affinity.serif.com/en-us/publisher/";
const AfordinUrl = "https://github.com/Afordin";
const AfterEffectsUrl = "https://www.adobe.com/products/aftereffects";
const AhooksUrl = "https://ahooks.js.org/";
const AirbnbUrl = "https://www.airbnb.com";
const AlacrittyUrl = "https://alacritty.org";
const AlgoliaUrl = "https://www.algolia.com/";
const AlgorandUrl = "https://algorand.org/";
const AliexpressUrl = "https://aliexpress.com/";
const AmazonWebServicesUrl = "https://aws.amazon.com/";
const AndroidUrl = "https://www.android.com/";
const AngularUrl = "https://angular.dev/";
const AnimateUrl = "https://www.adobe.com/products/animate";
const AntDesignUrl = "https://ant.design/";
const AnthropicUrl = "https://www.anthropic.com/";
const ApidogUrl = "https://apidog.com/";
const ApolloioUrl = "https://www.apollo.io/";
const AppleMusicUrl = "https://music.apple.com/";
const AppleUrl = "https://www.apple.com";
const AppwriteUrl = "https://appwrite.io/";
const ArcBrowserUrl = "https://arc.net/";
const ArcSocialUrl = "https://arc.dev";
const ArcSoftwareUrl = "https://arc.tech";
const AsanaUrl = "https://asana.com";
const AstroUrl = "https://astro.build/";
const AtlassianUrl = "https://www.atlassian.com/";
const AtomUrl = "https://atom.io/";
const Auth0Url = "https://auth0.com/";
const AuthyUrl = "https://authy.com/";
const AxiomUrl = "https://axiom.co/";
const AxureUrl = "https://www.axure.com/";
const BNBUrl = "https://www.bnbchain.org/";
const BabelUrl = "https://babeljs.io/";
const BaseUIUrl = "https://base-ui.com/";
const BasewellUrl = "https://www.basewell.com/";
const BashUrl = "https://www.gnu.org/software/bash/";
const BeaconUrl = "https://www.beacon.com";
const BentoUrl = "https://bento.me/home";
const BetterAuthUrl = "https://www.better-auth.com/";
const BinanceUrl = "https://binance.com/";
const BingUrl = "https://www.bing.com/";
const BiomejsUrl = "https://biomejs.dev/";
const BitcoinUrl = "https://bitcoin.org/";
const BitwardenUrl = "https://bitwarden.com/";
const BlenderUrl = "https://blender.org/";
const BlitzUrl = "https://blitzjs.com/";
const BlueskyUrl = "https://blueskyweb.xyz/";
const BoltUrl = "https://bolt.new/";
const BootstrapUrl = "https://getbootstrap.com/";
const BraveBrowserUrl = "https://brave.com/";
const BuildShipUrl = "https://buildship.com/";
const BuilderUrl = "https://builder.io/";
const BunUrl = "https://bun.sh";
const BuyMeACoffeeUrl = "https://buymeacoffee.com/";
const CPlusPlusUrl = "https://en.wikipedia.org/wiki/C%2B%2B";
const CSSNewUrl = "https://es.wikipedia.org/wiki/CSS";
const CSSUrl = "https://es.wikipedia.org/wiki/CSS";
const CSharpUrl = "https://dotnet.microsoft.com/languages/csharp";
const CUrl = "https://en.wikipedia.org/wiki/C_(programming_language)";
const CalcomUrl = "https://cal.com";
const CalendlyUrl = "https://calendly.com/";
const CanvaUrl = "https://www.canva.com/";
const CarrdUrl = "https://carrd.co/";
const ChakraUIUrl = "https://chakra-ui.com";
const ChartjsUrl = "https://www.chartjs.org/";
const ChromeUrl = "https://chrome.com/";
const ChromiumUrl = "https://www.chromium.org";
const CiscoUrl = "https://www.cisco.com/";
const ClaudeAIUrl = "https://claude.ai/";
const ClerkUrl = "https://clerk.com/";
const CloudflareUrl = "https://www.cloudflare.com/";
const CloudflareWorkersUrl = "https://workers.cloudflare.com/";
const CloudinaryUrl = "https://cloudinary.com/";
const CobolUrl = "https://en.wikipedia.org/wiki/COBOL";
const CodesandboxUrl = "https://codesandbox.io/";
const CodiumUrl = "https://www.codium.ai/";
const CodyUrl = "https://about.sourcegraph.com/";
const CohereUrl = "https://cohere.com/";
const CoinbaseUrl = "https://www.coinbase.com/";
const ConvexUrl = "https://www.convex.dev/";
const CourseraUrl = "https://www.coursera.org/";
const CrossplaneUrl = "https://crossplane.io/";
const CurseForgeUrl = "https://curseforge.com/";
const CursorUrl = "https://www.cursor.com";
const CypressUrl = "https://www.cypress.io/";
const D3jsUrl = "https://d3js.org/";
const DailydevUrl = "https://daily.dev/";
const DaisyUIUrl = "https://daisyui.com/";
const DartUrl = "https://dart.dev/";
const DatadogUrl = "https://www.datadoghq.com/";
const DeepSeekUrl = "https://deepseek.com/";
const DenoUrl = "https://deno.com/";
const DesignaliUrl = "https://designali.in";
const DeveloperStudentClubUrl = "https://gdsc.community.dev/";
const DevtoUrl = "https://dev.to/";
const DigitalOceanUrl = "https://www.digitalocean.com/";
const DirectusUrl = "https://directus.io/";
const DiscordUrl = "https://discord.com/";
const DiscordjsUrl = "https://discord.js.org/";
const DiscourseUrl = "https://discourse.org/";
const DisneyPlusUrl = "https://www.disneyplus.com/";
const DjangoUrl = "https://www.djangoproject.com/";
const DockerUrl = "https://www.docker.com/";
const DocumensoUrl = "https://documenso.com";
const DocusaurusUrl = "https://docusaurus.io/";
const DogecoinUrl = "https://dogecoin.com/";
const DotenvUrl = "https://github.com/motdotla/dotenv";
const DotenvxUrl = "https://dotenvx.com";
const DreamweaverUrl = "https://www.adobe.com/products/dreamweaver.html";
const DrizzleORMUrl = "https://orm.drizzle.team/";
const DropboxUrl = "https://www.dropbox.com/";
const DubUrl = "https://dub.co";
const DuckDuckGoUrl = "https://duckduckgo.com/";
const EbayUrl = "https://www.ebay.com";
const EclipseIDEUrl = "https://www.eclipse.org/";
const EdgeUrl = "https://www.microsoft.com/en-us/edge";
const ElectronUrl = "https://www.electronjs.org";
const ElementorUrl = "https://elementor.com/";
const ElysiaJSUrl = "https://elysiajs.com/";
const EmacsUrl = "https://www.gnu.org/software/emacs/";
const EmberUrl = "https://emberjs.com/";
const EsbuildUrl = "https://esbuild.github.io/";
const EthereumUrl = "https://ethereum.org/";
const ExomeUrl = "https://exome.dev/";
const ExpoUrl = "https://expo.dev/";
const ExpressjsUrl = "https://expressjs.com";
const FacebookUrl = "https://www.facebook.com/";
const FastAPIUrl = "https://fastapi.tiangolo.com/";
const FastifyUrl = "https://www.fastify.io";
const FigmaUrl = "https://www.figma.com/";
const FirebaseStudioUrl = "https://firebase.studio/";
const FirebaseUrl = "https://firebase.google.com/";
const FirefoxUrl = "https://www.mozilla.org/en-US/firefox/";
const FlaskUrl = "https://flask.palletsprojects.com/";
const FlowLauncherUrl = "https://www.flowlauncher.com/";
const FlowbiteUrl = "https://flowbite.com/";
const FlutterUrl = "https://flutter.dev/";
const FlyUrl = "https://fly.io";
const FortranUrl = "https://fortran-lang.org/";
const FramerUrl = "https://framer.com/";
const FreshUrl = "https://fresh.deno.dev/";
const FrontUrl = "https://front.com";
const GatsbyUrl = "https://www.gatsbyjs.org/";
const GeminiUrl = "https://gemini.google.com/";
const GhosttyUrl = "https://ghostty.org/";
const GimpUrl = "https://www.gimp.org/";
const GitHubCopilotUrl = "https://github.com/features/copilot";
const GitHubUrl = "https://github.com/";
const GitLabUrl = "https://gitlab.com/";
const GitUrl = "https://git-scm.com/";
const GleamUrl = "https://gleam.run/";
const GmailUrl = "https://www.gmail.com";
const GoDaddyUrl = "https://www.godaddy.com/";
const GoUrl = "https://go.dev/";
const GodotEngineUrl = "https://godotengine.org/";
const GoogleColaboratoryUrl = "https://colab.research.google.com/";
const GoogleDriveUrl = "https://www.google.com/drive/";
const GoogleIdxUrl = "https://idx.dev/";
const GooglePaLMUrl = "https://ai.google/discover/palm2/";
const GoogleUrl = "https://www.google.com/";
const GradioUrl = "https://www.gradio.app/";
const GrafanaUrl = "https://grafana.com/";
const GraphQLUrl = "https://graphql.org/";
const GrokUrl = "https://grok.com/";
const GroqUrl = "https://groq.com/";
const HCaptchaUrl = "https://www.hcaptcha.com/";
const HTML5Url = "https://es.wikipedia.org/wiki/HTML5";
const HackTheBoxUrl = "https://www.hackthebox.com/";
const HashnodeUrl = "https://hashnode.com";
const HaskellUrl = "https://www.haskell.org/";
const HeadlessUIUrl = "https://headlessui.dev/";
const HeroUIUrl = "https://www.heroui.com/";
const HerokuUrl = "https://www.heroku.com/";
const HomeAssistantUrl = "https://github.com/home-assistant/assets/tree/master/logo";
const HomebrewUrl = "https://brew.sh/";
const HonoUrl = "https://hono.dev/";
const HoppscotchUrl = "https://hoppscotch.com";
const HostgatorUrl = "https://www.hostgator.com/";
const HuggingFaceUrl = "https://huggingface.co/";
const HugoUrl = "https://gohugo.io/";
const HuluUrl = "https://www.hulu.com/";
const HumeAIUrl = "https://hume.ai/";
const IBMUrl = "https://www.ibm.com";
const IllustratorUrl = "https://www.adobe.com/products/illustrator";
const InDesignUrl = "https://www.adobe.com/products/indesign";
const InflectionAIUrl = "https://inflection.ai/";
const InfojobsUrl = "https://www.infojobs.net/";
const InngestUrl = "https://inngest.com/";
const InstagramUrl = "https://www.instagram.com/";
const InstatusUrl = "https://instatus.com";
const IntelliJIDEAUrl = "https://www.jetbrains.com/idea/";
const JQueryUrl = "https://jquery.com";
const JSONSchemaUrl = "https://json-schema.org/";
const JSONUrl = "https://json.org/";
const JWTUrl = "https://jwt.io/";
const JasmineUrl = "https://jasmine.github.io/";
const JavaScriptUrl = "https://developer.mozilla.org/docs/Web/JavaScript";
const JavaUrl = "https://www.java.com/";
const JestUrl = "https://jestjs.io/";
const JetBrainsColorfulUrl = "https://www.jetbrains.com/";
const JetBrainsFleetUrl = "https://www.jetbrains.com/fleet/";
const JetBrainsMonoUrl = "https://www.jetbrains.com/";
const JetBrainsPhpStormUrl = "https://www.jetbrains.com/phpstorm/";
const JetBrainsPyCharmUrl = "https://www.jetbrains.com/pycharm/";
const JetBrainsRiderUrl = "https://www.jetbrains.com/rider/";
const JetBrainsRubyMineUrl = "https://www.jetbrains.com/ruby/";
const JetBrainsWebStormUrl = "https://www.jetbrains.com/webstorm/";
const JetbrainsSpaceUrl = "https://www.jetbrains.com/space/";
const JuliaUrl = "https://julialang.org/";
const KeycloakUrl = "https://keycloak.org";
const KickUrl = "https://kick.com/";
const KotlinUrl = "https://kotlinlang.org/";
const KrakenJSUrl = "https://krakenjs.com/";
const KubernetesUrl = "https://kubernetes.io/";
const LaravelUrl = "https://laravel.com/";
const LayersUrl = "https://layers.to/";
const LeapWalletUrl = "https://leapwallet.io/";
const LearnThisUrl = "https://learnthisacademy.com";
const LemonSqueezyUrl = "https://www.lemonsqueezy.com";
const LightroomUrl = "https://www.adobe.com/products/photoshop-lightroom";
const LinearUrl = "https://linear.app/";
const LinkUrl = "https://chain.link/";
const LinkedInUrl = "https://www.linkedin.com/";
const LinuxUrl = "https://www.linux.org/";
const LitUrl = "https://lit.dev/";
const LitecoinUrl = "https://litecoin.org/";
const LocofyUrl = "https://www.locofy.ai/";
const LoomUrl = "https://www.loom.com/";
const LottielabUrl = "https://www.lottielab.com/";
const LovableUrl = "https://lovable.dev/";
const LuaUrl = "https://lua.org/";
const MagicUIUrl = "https://magicui.design/";
const ManzDevUrl = "https://manz.dev/";
const MariaDBUrl = "https://mariadb.org/";
const MarkdownUrl = "https://www.markdownguide.org/";
const MastodonUrl = "https://joinmastodon.org/";
const MaterialUIUrl = "https://mui.com/";
const MatlabUrl = "https://www.mathworks.com/products/matlab.html";
const MatrixUrl = "https://matrix.org/";
const MattermostUrl = "http://mattermost.com/";
const MediaWikiUrl = "https://www.mediawiki.org/";
const MedusaUrl = "https://medusajs.com/";
const MercadoPagoUrl = "https://www.mercadopago.com/developers/";
const MermaidUrl = "https://mermaid.js.org/";
const MessengerUrl = "https://www.messenger.com/";
const MetaMaskUrl = "https://metamask.io/";
const MetaUrl = "https://about.meta.com/es/";
const MicrosoftAzureUrl = "https://azure.microsoft.com/";
const MicrosoftSQLServerUrl = "https://www.microsoft.com/en-us/sql-server/";
const MicrosoftTodoUrl = "https://to-do.office.com/";
const MicrosoftUrl = "https://www.microsoft.com/";
const MiddayUrl = "https://midday.ai/";
const MidudevUrl = "https://midu.dev";
const MilanoteUrl = "https://milanote.com";
const MillionUrl = "https://million.dev/";
const MintlifyUrl = "https://mintlify.com/";
const MistralAIUrl = "https://mistral.ai/";
const ModelContextProtocolUrl = "https://modelcontextprotocol.io/";
const MoneroUrl = "https://www.getmonero.org/";
const MongoDBUrl = "https://www.mongodb.com/";
const MonkeytypeUrl = "https://monkeytype.com/";
const MoonUrl = "https://moonjs.org/";
const MotionUrl = "https://motion.dev/";
const MySQLUrl = "https://www.mysql.com/";
const NHostUrl = "https://nhost.io/";
const NPMUrl = "https://www.npmjs.com/";
const NeonUrl = "https://neon.tech/";
const NeovimUrl = "https://neovim.io/";
const NestJSUrl = "https://nestjs.com/";
const NetflixUrl = "https://www.netflix.com/";
const NetlifyUrl = "https://www.netlify.com/";
const NextjsUrl = "https://nextjs.org/";
const NgrokUrl = "https://ngrok.com";
const NodejsUrl = "https://nodejs.org/";
const NotionUrl = "https://notion.so/";
const NugetUrl = "https://www.nuget.org/";
const NuqsUrl = "https://nuqs.47ng.com/";
const NuxtUrl = "https://nuxtjs.org/";
const NxUrl = "https://nx.dev";
const OBSUrl = "https://obsproject.com/";
const ObsidianUrl = "https://obsidian.md/";
const OllamaUrl = "https://www.ollama.com/";
const OnePasswordUrl = "https://1password.com";
const OpenAIUrl = "https://openai.com/";
const OpenBootcampUrl = "https://open-bootcamp.com/";
const OpenSeaUrl = "https://opensea.io/";
const OpenWebUIUrl = "https://openwebui.com/";
const OperaUrl = "https://www.opera.com";
const OutlookUrl = "https://www.outlook.com";
const OxcUrl = "https://oxc.rs/";
const PM2Url = "https://pm2.io/";
const PandaCSSUrl = "https://panda-css.com/";
const ParcelUrl = "https://parceljs.org/";
const PatreonUrl = "https://www.patreon.com/";
const PayPalUrl = "https://paypal.com";
const PayloadCMSUrl = "https://payloadcms.com";
const PeerlistUrl = "https://www.peerlist.io/";
const PenpotUrl = "https://penpot.app/";
const PerplexityAIUrl = "https://perplexity.ai/";
const PerspectiveUrl = "https://perspective.co/";
const PhotoshopUrl = "https://www.adobe.com/products/photoshop";
const PhpUrl = "https://www.php.net/";
const PiniaUrl = "https://pinia.vuejs.org/";
const PinterestUrl = "https://pinterest.com/";
const PitchUrl = "https://pitch.com";
const PlanetScaleUrl = "https://planetscale.com/";
const PlatziUrl = "https://platzi.com/";
const PlayStationUrl = "https://www.playstation.com/";
const PlaywrightUrl = "https://playwright.dev/";
const PnpmUrl = "https://pnpm.io/";
const PocketbaseUrl = "https://pocketbase.io/";
const PolarUrl = "https://polar.sh/";
const PolarsUrl = "https://pola.rs/";
const PolygonUrl = "https://polygon.technology/";
const PoperUrl = "https://www.poper.ai";
const PostCSSUrl = "https://postcss.org/";
const PostHogUrl = "https://posthog.com/";
const PostgreSQLUrl = "https://www.postgresql.org/";
const PostmanUrl = "https://www.getpostman.com/";
const PowerShellUrl = "https://learn.microsoft.com/en-us/powershell/";
const PowerToysUrl = "https://learn.microsoft.com/en-us/windows/powertoys/";
const PreactUrl = "https://preactjs.com/";
const PremiereUrl = "https://www.adobe.com/products/premiere";
const PrettierUrl = "https://prettier.io/";
const PrimeVideoUrl = "https://primevideo.com/";
const PrismaUrl = "https://prisma.io/";
const ProcureUrl = "https://procure.biz/";
const ProductHuntUrl = "https://www.producthunt.com/";
const PulumiUrl = "https://www.pulumi.com/";
const PutioUrl = "https://put.io/";
const PyCharmUrl = "https://www.jetbrains.com/pycharm/";
const PythonUrl = "https://www.python.org/";
const QtUrl = "https://www.qt.io/";
const QwenUrl = "https://chat.qwenlm.ai/";
const QwikUrl = "https://qwik.builder.io/";
const RUrl = "https://www.r-project.org/";
const RadixUIUrl = "https://www.radix-ui.com/";
const RailwayUrl = "https://railway.app/";
const RaindropioUrl = "https://raindrop.io/";
const RandevumUrl = "https://www.randevum.co";
const RapidAPIUrl = "https://rapidapi.com";
const RaspberryPIUrl = "https://www.raspberrypi.com/";
const RaycastUrl = "https://raycast.com/";
const ReactQueryUrl = "https://tanstack.com/query/v4";
const ReactRouterUrl = "https://reactrouter.com/en/main";
const ReactUrl = "https://react.dev/";
const ReactWheelPickerUrl = "https://react-wheel-picker.chanhdai.com";
const RedditUrl = "https://www.reddit.com/";
const RedisUrl = "https://redis.io/";
const ReduxUrl = "https://redux.js.org/";
const RedwoodJSUrl = "https://redwoodjs.com/";
const RefineUrl = "https://refine.dev/";
const ReflexUrl = "https://reflex.dev/";
const RelaGitUrl = "https://rela.dev";
const RemixUrl = "https://remix.run/";
const RemotionUrl = "https://www.remotion.dev/";
const ReplicateUrl = "https://replicate.com/";
const ReplitUrl = "https://replit.com/";
const ResendUrl = "https://resend.com/";
const RobloxUrl = "https://www.roblox.com/";
const RolldownUrl = "https://rolldown.rs/";
const RowyUrl = "https://www.rowy.io/";
const RsbuildUrl = "https://rsbuild.rs";
const RspackUrl = "https://rspack.rs/";
const RubyUrl = "https://www.ruby-lang.org/";
const RunwayUrl = "https://runwayml.com/";
const RustUrl = "https://www.rust-lang.org/";
const RxJSUrl = "https://rxjs.dev/";
const SQLiteUrl = "https://www.sqlite.org/";
const SSTUrl = "https://sst.dev/";
const SVGUrl = "https://www.w3.org/TR/SVG/";
const SWCUrl = "https://swc.rs/";
const SWRUrl = "https://swr.vercel.app/";
const SafariUrl = "https://www.apple.com/safari";
const SalesforceUrl = "https://www.salesforce.com";
const SanityUrl = "https://www.sanity.io";
const SassUrl = "https://sass-lang.com/";
const ScalaUrl = "https://www.scala-lang.org/";
const SentryUrl = "https://sentry.io/";
const SequelizeUrl = "https://sequelize.org/";
const ShadcnUiUrl = "https://ui.shadcn.com/";
const ShikiUrl = "https://shiki.style/";
const ShopifyUrl = "https://www.shopify.com";
const SketchUrl = "https://www.sketch.com/";
const SkyUrl = "https://www.sky.com";
const SkypeUrl = "https://www.skype.com/";
const SlackUrl = "https://www.slack.com";
const SnapchatUrl = "https://www.snapchat.com";
const SocketioUrl = "https://socket.io/";
const SolanaUrl = "https://solana.com/";
const SolidityUrl = "https://soliditylang.org/";
const SolidjsUrl = "https://www.solidjs.com/";
const SoundCloudUrl = "https://soundcloud.com/";
const SourcegraphUrl = "https://about.sourcegraph.com/";
const SpinnakerUrl = "https://spinnaker.io/";
const SpotifyUrl = "https://www.spotify.com/";
const SpringUrl = "https://spring.io/";
const StabilityAIUrl = "https://stability.ai/";
const StackOverflowUrl = "https://stackoverflow.com/";
const StackblitzUrl = "https://stackblitz.com/";
const StatelyaiUrl = "https://stately.ai/";
const SteamUrl = "https://store.steampowered.com/";
const StimulusUrl = "https://stimulus.hotwired.dev/";
const StoryblokUrl = "https://www.storyblok.com/";
const StorybookUrl = "https://storybook.js.org/";
const StrapiUrl = "https://strapi.io/";
const StripeUrl = "https://stripe.com/";
const StyledComponentsUrl = "https://styled-components.com/";
const SublimeTextUrl = "https://www.sublimetext.com/";
const SunoUrl = "https://suno.com/";
const SupabaseUrl = "https://supabase.com/";
const SurrealdbUrl = "https://surrealdb.com/";
const SvelteUrl = "https://svelte.dev/";
const SvglUrl = "https://svgl.app";
const SwaggerUrl = "https://swagger.io/";
const SwiftUrl = "https://swift.org/";
const T3StackUrl = "https://create.t3.gg/";
const TIDALUrl = "https://tidal.com/";
const TRPCUrl = "https://trpc.io/";
const TabbyUrl = "https://tabby.sh/";
const TailwindCSSUrl = "https://tailwindcss.com/";
const TanStackUrl = "https://tanstack.com/";
const TauriUrl = "https://tauri.app/";
const TelegramUrl = "https://web.telegram.org/";
const TensorFlowUrl = "https://www.tensorflow.org/";
const TerraformUrl = "https://terraform.io";
const TetherUrl = "https://tether.to/";
const ThreadsUrl = "https://threads.net/";
const ThreejsUrl = "https://threejs.org/";
const TikTokUrl = "https://www.tiktok.com/";
const TinaUrl = "https://tina.io/";
const TodoistUrl = "https://todoist.com/";
const TogetherAIUrl = "https://www.together.ai/";
const TonUrl = "https://ton.org/";
const TorUrl = "https://www.torproject.org/";
const TronUrl = "https://tron.network/";
const TrustPilotUrl = "https://www.trustpilot.com";
const TrustWalletUrl = "https://trustwallet.com/";
const TurbopackUrl = "https://turbo.build/";
const TurborepoUrl = "https://turborepo.org/";
const TursoUrl = "https://turso.tech";
const TwilioUrl = "https://twilio.com";
const TwitchUrl = "https://twitch.tv";
const TwitterUrl = "https://twitter.com/";
const TypeGPUUrl = "https://typegpu.com";
const TypeORMUrl = "https://typeorm.io/";
const TypeScriptUrl = "https://www.typescriptlang.org";
const TypesenseUrl = "https://typesense.org/";
const UXAnaRangelUrl = "https://uxanarangel.com/";
const UXCorpRangelUrl = "https://github.com/UXCorpRangel/";
const UberUrl = "https://www.uber.com";
const UbuntuUrl = "https://ubuntu.com/";
const UdacityUrl = "https://www.udacity.com/";
const UdemyUrl = "https://www.udemy.com/";
const UnityUrl = "https://unity.com/";
const UnoCSSUrl = "https://unocss.dev/";
const UnrealEngineUrl = "https://www.unrealengine.com/";
const UpLeveledUrl = "https://upleveled.io/";
const UpstashUrl = "https://upstash.com/";
const V0Url = "https://v0.dev/";
const VKUrl = "https://vk.com";
const VSCodiumUrl = "https://vscodium.com/";
const ValibotUrl = "https://valibot.dev";
const VercelUrl = "https://vercel.com/";
const VimUrl = "https://www.vim.org/";
const VisualStudioCodeUrl = "https://code.visualstudio.com/";
const VisualStudioUrl = "https://visualstudio.microsoft.com";
const ViteUrl = "https://vitejs.dev";
const VitestUrl = "https://vitest.dev/";
const VivaldiUrl = "https://vivaldi.com";
const VoicemodUrl = "https://voicemod.net/";
const VoltaUrl = "https://volta.net/";
const VueUrl = "https://vuejs.org/";
const VueUseUrl = "https://vueuse.org/";
const VuetifyUrl = "https://vuetifyjs.com/";
const WarpUrl = "https://www.warp.dev/";
const WebComponentsUrl = "https://www.webcomponents.org/";
const WebKitUrl = "https://webkit.org/";
const WebdevUrl = "https://web.dev/";
const WebflowUrl = "https://www.webflow.com";
const WhatsAppUrl = "https://web.whatsapp.com/";
const WhopUrl = "https://whop.com/";
const WindiCSSUrl = "https://windicss.org/";
const WindowsUrl = "https://www.microsoft.com/windows";
const WindsurfUrl = "https://codeium.com/windsurf";
const WordPressUrl = "https://wordpress.org/";
const WorkOSUrl = "https://workos.com/";
const XAIUrl = "https://grok.com/";
const XDUrl = "https://www.adobe.com/products/xd";
const XRPUrl = "https://xrpl.org/";
const XStateUrl = "https://github.com/statelyai/xstate";
const XUrl = "https://x.com";
const XboxUrl = "https://www.xbox.com/";
const YGeekerUrl = "https://www.ygeeker.com";
const YarnUrl = "https://yarnpkg.com/";
const YouTubeUrl = "https://www.youtube.com/";
const YoutubeMusicUrl = "https://music.youtube.com/";
const ZeaburUrl = "https://zeabur.com/";
const ZedUrl = "https://zed.dev/";
const ZenBrowserUrl = "https://zen-browser.app/";
const ZigUrl = "https://ziglang.org/";
const ZodUrl = "https://zod.dev/";
const ZoomUrl = "https://zoom.us/";

export { AMP, AMPUrl, Adobe, AdobeUrl, AffinityDesigner, AffinityDesignerUrl, AffinityPhoto, AffinityPhotoUrl, AffinityPublisher, AffinityPublisherUrl, AfordinDark, AfordinLight, AfordinUrl, AfterEffects, AfterEffectsUrl, Ahooks, AhooksUrl, Airbnb, AirbnbUrl, Alacritty, AlacrittyUrl, Algolia, AlgoliaUrl, Algorand, AlgorandUrl, Aliexpress, AliexpressUrl, AmazonWebServicesDark, AmazonWebServicesLight, AmazonWebServicesUrl, Android, AndroidUrl, Angular, AngularUrl, Animate, AnimateUrl, AntDesign, AntDesignUrl, AnthropicDark, AnthropicLight, AnthropicUrl, Apidog, ApidogUrl, Apolloio, ApolloioUrl, AppleDark, AppleLight, AppleMusic, AppleMusicUrl, AppleUrl, Appwrite, AppwriteUrl, Arc, ArcBrowserUrl, ArcDark, ArcDarkSoftware, ArcLight, ArcLightSoftware, ArcSocialUrl, ArcSoftwareUrl, Asana, AsanaUrl, AstroDark, AstroLight, AstroUrl, Atlassian, AtlassianUrl, Atom, AtomUrl, Auth0, Auth0Url, Authy, AuthyUrl, AxiomDark, AxiomLight, AxiomUrl, Axure, AxureUrl, BNB, BNBUrl, Babel, BabelUrl, BaseUIDark, BaseUILight, BaseUIUrl, Basewell, BasewellUrl, BashDark, BashLight, BashUrl, Beacon, BeaconUrl, Bento, BentoUrl, BetterAuthDark, BetterAuthLight, BetterAuthUrl, Binance, BinanceUrl, Bing, BingUrl, Biomejs, BiomejsUrl, Bitcoin, BitcoinUrl, Bitwarden, BitwardenUrl, Blender, BlenderUrl, Blitz, BlitzUrl, Bluesky, BlueskyUrl, BoltDark, BoltLight, BoltUrl, Bootstrap, BootstrapUrl, BraveBrowser, BraveBrowserUrl, BuildShip, BuildShipUrl, Builder, BuilderUrl, Bun, BunUrl, BuyMeACoffee, BuyMeACoffeeUrl, C, CPlusPlus, CPlusPlusUrl, CSS, CSSNew, CSSNewUrl, CSSUrl, CSharp, CSharpUrl, CUrl, CalcomDark, CalcomLight, CalcomUrl, Calendly, CalendlyUrl, Canva, CanvaUrl, Carrd, CarrdUrl, ChakraUI, ChakraUIUrl, Chartjs, ChartjsUrl, Chrome, ChromeUrl, Chromium, ChromiumUrl, CiscoDark, CiscoLight, CiscoUrl, ClaudeAI, ClaudeAIUrl, ClerkDark, ClerkLight, ClerkUrl, Cloudflare, CloudflareUrl, CloudflareWorkers, CloudflareWorkersUrl, Cloudinary, CloudinaryUrl, Cobol, CobolUrl, Codesandbox, CodesandboxUrl, Codium, CodiumUrl, Cody, CodyUrl, Cohere, CohereUrl, Coinbase, CoinbaseUrl, Convex, ConvexUrl, Coursera, CourseraUrl, Crossplane, CrossplaneUrl, CurseForgeDark, CurseForgeLight, CurseForgeUrl, CursorDark, CursorLight, CursorUrl, Cypress, CypressUrl, D3js, D3jsUrl, DailydevDark, DailydevLight, DailydevUrl, DaisyUI, DaisyUIUrl, Dart, DartUrl, Datadog, DatadogUrl, DeepSeek, DeepSeekUrl, DenoDark, DenoLight, DenoUrl, Designali, DesignaliUrl, DeveloperStudentClub, DeveloperStudentClubUrl, DevtoDark, DevtoLight, DevtoUrl, DigitalOcean, DigitalOceanUrl, Directus, DirectusUrl, Discord, DiscordUrl, Discordjs, DiscordjsUrl, Discourse, DiscourseUrl, DisneyPlus, DisneyPlusUrl, Django, DjangoUrl, Docker, DockerUrl, DocumensoDark, DocumensoLight, DocumensoUrl, Docusaurus, DocusaurusUrl, Dogecoin, DogecoinUrl, Dotenv, DotenvUrl, Dotenvx, DotenvxUrl, Dreamweaver, DreamweaverUrl, DrizzleORMDark, DrizzleORMLight, DrizzleORMUrl, Dropbox, DropboxUrl, DubDark, DubLight, DubUrl, DuckDuckGo, DuckDuckGoUrl, Ebay, EbayUrl, EclipseIDE, EclipseIDEUrl, Edge, EdgeUrl, Electron, ElectronUrl, Elementor, ElementorUrl, ElysiaJS, ElysiaJSUrl, Emacs, EmacsUrl, Ember, EmberUrl, Esbuild, EsbuildUrl, Ethereum, EthereumUrl, Exome, ExomeUrl, Expo, ExpoUrl, ExpressjsDark, ExpressjsLight, ExpressjsUrl, Facebook, FacebookUrl, FastAPI, FastAPIUrl, FastifyDark, FastifyLight, FastifyUrl, Figma, FigmaUrl, Firebase, FirebaseStudio, FirebaseStudioUrl, FirebaseUrl, Firefox, FirefoxUrl, FlaskDark, FlaskLight, FlaskUrl, FlowLauncher, FlowLauncherUrl, Flowbite, FlowbiteUrl, Flutter, FlutterUrl, Fly, FlyUrl, Fortran, FortranUrl, FramerDark, FramerLight, FramerUrl, Fresh, FreshUrl, Front, FrontUrl, Gatsby, GatsbyUrl, Gemini, GeminiUrl, Ghostty, GhosttyUrl, Gimp, GimpUrl, Git, GitHubCopilotDark, GitHubCopilotLight, GitHubCopilotUrl, GitHubDark, GitHubLight, GitHubUrl, GitLab, GitLabUrl, GitUrl, Gleam, GleamUrl, Gmail, GmailUrl, GoDaddyDark, GoDaddyLight, GoDaddyUrl, GoDark, GoLight, GoUrl, GodotEngine, GodotEngineUrl, Google, GoogleColaboratory, GoogleColaboratoryUrl, GoogleDrive, GoogleDriveUrl, GoogleIdx, GoogleIdxUrl, GooglePaLM, GooglePaLMUrl, GoogleUrl, Gradio, GradioUrl, Grafana, GrafanaUrl, GraphQL, GraphQLUrl, GrokDark, GrokLight, GrokUrl, Groq, GroqUrl, HCaptcha, HCaptchaUrl, HTML5, HTML5Url, HackTheBox, HackTheBoxUrl, Hashnode, HashnodeUrl, Haskell, HaskellUrl, HeadlessUI, HeadlessUIUrl, HeroUIDark, HeroUILight, HeroUIUrl, Heroku, HerokuUrl, HomeAssistant, HomeAssistantUrl, Homebrew, HomebrewUrl, Hono, HonoUrl, Hoppscotch, HoppscotchUrl, Hostgator, HostgatorUrl, HuggingFace, HuggingFaceUrl, Hugo, HugoUrl, HuluDark, HuluLight, HuluUrl, HumeAI, HumeAIUrl, IBM, IBMUrl, Illustrator, IllustratorUrl, InDesign, InDesignUrl, InflectionAIDark, InflectionAILight, InflectionAIUrl, Infojobs, InfojobsUrl, InngestDark, InngestLight, InngestUrl, InstagramDark, InstagramLight, InstagramUrl, InstatusDark, InstatusLight, InstatusUrl, IntelliJIDEA, IntelliJIDEAUrl, JQueryDark, JQueryLight, JQueryUrl, JSON, JSONSchema, JSONSchemaUrl, JSONUrl, JWT, JWTUrl, Jasmine, JasmineUrl, Java, JavaScript, JavaScriptUrl, JavaUrl, Jest, JestUrl, JetBrainsColorful, JetBrainsColorfulUrl, JetBrainsFleet, JetBrainsFleetUrl, JetBrainsMono, JetBrainsMonoUrl, JetBrainsPhpStorm, JetBrainsPhpStormUrl, JetBrainsPyCharm, JetBrainsPyCharmUrl, JetBrainsRider, JetBrainsRiderUrl, JetBrainsRubyMine, JetBrainsRubyMineUrl, JetBrainsWebStorm, JetBrainsWebStormUrl, JetbrainsSpace, JetbrainsSpaceUrl, Julia, JuliaUrl, Keycloak, KeycloakUrl, KickDark, KickLight, KickUrl, Kotlin, KotlinUrl, KrakenJS, KrakenJSUrl, Kubernetes, KubernetesUrl, Laravel, LaravelUrl, LayersDark, LayersLight, LayersUrl, LeapWallet, LeapWalletUrl, LearnThis, LearnThisUrl, LemonSqueezy, LemonSqueezyUrl, Lightroom, LightroomUrl, Linear, LinearUrl, Link, LinkUrl, LinkedIn, LinkedInUrl, Linux, LinuxUrl, Lit, LitUrl, Litecoin, LitecoinUrl, Locofy, LocofyUrl, Loom, LoomUrl, Lottielab, LottielabUrl, Lovable, LovableUrl, Lua, LuaUrl, MagicUI, MagicUIUrl, ManzDev, ManzDevUrl, MariaDB, MariaDBUrl, MarkdownDark, MarkdownLight, MarkdownUrl, Mastodon, MastodonUrl, MaterialUI, MaterialUIUrl, Matlab, MatlabUrl, MatrixDark, MatrixLight, MatrixUrl, MattermostDark, MattermostLight, MattermostUrl, MediaWiki, MediaWikiUrl, Medusa, MedusaUrl, MercadoPago, MercadoPagoUrl, MermaidDark, MermaidLight, MermaidUrl, Messenger, MessengerUrl, Meta, MetaMask, MetaMaskUrl, MetaUrl, Microsoft, MicrosoftAzure, MicrosoftAzureUrl, MicrosoftSQLServer, MicrosoftSQLServerUrl, MicrosoftTodo, MicrosoftTodoUrl, MicrosoftUrl, Midday, MiddayUrl, Midudev, MidudevUrl, MilanoteDark, MilanoteLight, MilanoteUrl, Million, MillionUrl, Mintlify, MintlifyUrl, MistralAI, MistralAIUrl, ModelContextProtocolDark, ModelContextProtocolLight, ModelContextProtocolUrl, Monero, MoneroUrl, MongoDB, MongoDBUrl, Monkeytype, MonkeytypeUrl, Moon, MoonUrl, MotionDark, MotionLight, MotionUrl, MySQL, MySQLUrl, NHost, NHostUrl, NPM, NPMUrl, Neon, NeonUrl, Neovim, NeovimUrl, NestJS, NestJSUrl, Netflix, NetflixUrl, Netlify, NetlifyUrl, Nextjs, NextjsUrl, NgrokDark, NgrokLight, NgrokUrl, Nodejs, NodejsUrl, Notion, NotionUrl, Nuget, NugetUrl, NuqsDark, NuqsLight, NuqsUrl, Nuxt, NuxtUrl, NxDark, NxLight, NxUrl, OBS, OBSUrl, Obsidian, ObsidianUrl, OllamaDark, OllamaLight, OllamaUrl, OnePasswordDark, OnePasswordLight, OnePasswordUrl, OpenAIDark, OpenAILight, OpenAIUrl, OpenBootcamp, OpenBootcampUrl, OpenSea, OpenSeaUrl, OpenWebUI, OpenWebUIUrl, Opera, OperaUrl, Outlook, OutlookUrl, Oxc, OxcUrl, PM2, PM2Url, PandaCSS, PandaCSSUrl, Parcel, ParcelUrl, PatreonDark, PatreonLight, PatreonUrl, PayPal, PayPalUrl, PayloadCMSDark, PayloadCMSLight, PayloadCMSUrl, Peerlist, PeerlistUrl, PenpotDark, PenpotLight, PenpotUrl, PerplexityAI, PerplexityAIUrl, PerspectiveDark, PerspectiveLight, PerspectiveUrl, Photoshop, PhotoshopUrl, PhpDark, PhpLight, PhpUrl, Pinia, PiniaUrl, Pinterest, PinterestUrl, Pitch, PitchUrl, PlanetScaleDark, PlanetScaleLight, PlanetScaleUrl, Platzi, PlatziUrl, PlayStation, PlayStationUrl, Playwright, PlaywrightUrl, PnpmDark, PnpmLight, PnpmUrl, Pocketbase, PocketbaseUrl, PolarDark, PolarLight, PolarUrl, Polars, PolarsUrl, Polygon, PolygonUrl, Poper, PoperUrl, PostCSS, PostCSSUrl, PostHog, PostHogUrl, PostgreSQL, PostgreSQLUrl, Postman, PostmanUrl, PowerShell, PowerShellUrl, PowerToys, PowerToysUrl, Preact, PreactUrl, Premiere, PremiereUrl, PrettierDark, PrettierLight, PrettierUrl, PrimeVideo, PrimeVideoUrl, PrismaDark, PrismaLight, PrismaUrl, Procure, ProcureUrl, ProductHunt, ProductHuntUrl, Pulumi, PulumiUrl, Putio, PutioUrl, PyCharm, PyCharmUrl, Python, PythonUrl, Qt, QtUrl, QwenDark, QwenLight, QwenUrl, Qwik, QwikUrl, RDark, RLight, RUrl, RadixUIDark, RadixUILight, RadixUIUrl, RailwayDark, RailwayLight, RailwayUrl, Raindropio, RaindropioUrl, Randevum, RandevumUrl, RapidAPI, RapidAPIUrl, RaspberryPI, RaspberryPIUrl, Raycast, RaycastUrl, ReactDark, ReactLight, ReactQuery, ReactQueryUrl, ReactRouter, ReactRouterUrl, ReactUrl, ReactWheelPickerDark, ReactWheelPickerLight, ReactWheelPickerUrl, Reddit, RedditUrl, Redis, RedisUrl, Redux, ReduxUrl, RedwoodJS, RedwoodJSUrl, RefineDark, RefineLight, RefineUrl, ReflexDark, ReflexLight, ReflexUrl, RelaGitDark, RelaGitLight, RelaGitUrl, RemixDark, RemixLight, RemixUrl, Remotion, RemotionUrl, ReplicateDark, ReplicateLight, ReplicateUrl, Replit, ReplitUrl, ResendDark, ResendLight, ResendUrl, RobloxDark, RobloxLight, RobloxUrl, Rolldown, RolldownUrl, Rowy, RowyUrl, Rsbuild, RsbuildUrl, Rspack, RspackUrl, Ruby, RubyUrl, Runway, RunwayUrl, RustDark, RustLight, RustUrl, RxJS, RxJSUrl, SQLite, SQLiteUrl, SST, SSTUrl, SVG, SVGUrl, SWC, SWCUrl, SWRDark, SWRLight, SWRUrl, Safari, SafariUrl, Salesforce, SalesforceUrl, Sanity, SanityUrl, Sass, SassUrl, Scala, ScalaUrl, Sentry, SentryUrl, Sequelize, SequelizeUrl, ShadcnUiDark, ShadcnUiLight, ShadcnUiUrl, Shiki, ShikiUrl, Shopify, ShopifyUrl, SketchDark, SketchLight, SketchUrl, Sky, SkyUrl, Skype, SkypeUrl, Slack, SlackUrl, Snapchat, SnapchatUrl, SocketioDark, SocketioLight, SocketioUrl, Solana, SolanaUrl, Solidity, SolidityUrl, Solidjs, SolidjsUrl, SoundCloudDark, SoundCloudLight, SoundCloudUrl, Sourcegraph, SourcegraphUrl, Spinnaker, SpinnakerUrl, Spotify, SpotifyUrl, Spring, SpringUrl, StabilityAI, StabilityAIUrl, StackOverflow, StackOverflowUrl, Stackblitz, StackblitzUrl, StatelyaiDark, StatelyaiLight, StatelyaiUrl, Steam, SteamUrl, Stimulus, StimulusUrl, Storyblok, StoryblokUrl, Storybook, StorybookUrl, Strapi, StrapiUrl, Stripe, StripeUrl, StyledComponents, StyledComponentsUrl, SublimeText, SublimeTextUrl, Suno, SunoUrl, Supabase, SupabaseUrl, Surrealdb, SurrealdbUrl, Svelte, SvelteUrl, Svgl, SvglUrl, Swagger, SwaggerUrl, Swift, SwiftUrl, T3StackDark, T3StackLight, T3StackUrl, TIDALDark, TIDALLight, TIDALUrl, TRPC, TRPCUrl, Tabby, TabbyUrl, TailwindCSS, TailwindCSSUrl, TanStack, TanStackUrl, Tauri, TauriUrl, Telegram, TelegramUrl, TensorFlow, TensorFlowUrl, Terraform, TerraformUrl, Tether, TetherUrl, ThreadsDark, ThreadsLight, ThreadsUrl, ThreejsDark, ThreejsLight, ThreejsUrl, TikTok, TikTokUrl, Tina, TinaUrl, Todoist, TodoistUrl, TogetherAIDark, TogetherAILight, TogetherAIUrl, Ton, TonUrl, Tor, TorUrl, Tron, TronUrl, TrustPilot, TrustPilotUrl, TrustWallet, TrustWalletUrl, Turbopack, TurbopackUrl, Turborepo, TurborepoUrl, TursoDark, TursoLight, TursoUrl, Twilio, TwilioUrl, Twitch, TwitchUrl, Twitter, TwitterUrl, TypeGPUDark, TypeGPULight, TypeGPUUrl, TypeORM, TypeORMUrl, TypeScript, TypeScriptUrl, Typesense, TypesenseUrl, UXAnaRangelDark, UXAnaRangelLight, UXAnaRangelUrl, UXCorpRangelDark, UXCorpRangelLight, UXCorpRangelUrl, UberDark, UberLight, UberUrl, Ubuntu, UbuntuUrl, Udacity, UdacityUrl, UdemyDark, UdemyLight, UdemyUrl, UnityDark, UnityLight, UnityUrl, UnoCSS, UnoCSSUrl, UnrealEngineDark, UnrealEngineLight, UnrealEngineUrl, UpLeveled, UpLeveledUrl, Upstash, UpstashUrl, V0Dark, V0Light, V0Url, VK, VKUrl, VSCodium, VSCodiumUrl, Valibot, ValibotUrl, VercelDark, VercelLight, VercelUrl, Vim, VimUrl, VisualStudio, VisualStudioCode, VisualStudioCodeUrl, VisualStudioUrl, Vite, ViteUrl, Vitest, VitestUrl, Vivaldi, VivaldiUrl, VoicemodDark, VoicemodLight, VoicemodUrl, VoltaDark, VoltaLight, VoltaUrl, Vue, VueUrl, VueUse, VueUseUrl, Vuetify, VuetifyUrl, Warp, WarpUrl, WebComponents, WebComponentsUrl, WebKit, WebKitUrl, Webdev, WebdevUrl, Webflow, WebflowUrl, WhatsApp, WhatsAppUrl, WhopDark, WhopLight, WhopUrl, WindiCSS, WindiCSSUrl, Windows, WindowsUrl, Windsurf, WindsurfUrl, WordPress, WordPressUrl, WorkOSDark, WorkOSLight, WorkOSUrl, XAIDark, XAILight, XAIUrl, XD, XDUrl, XDark, XLight, XRP, XRPUrl, XStateDark, XStateLight, XStateUrl, XUrl, Xbox, XboxUrl, YGeeker, YGeekerUrl, Yarn, YarnUrl, YouTube, YouTubeUrl, YoutubeMusic, YoutubeMusicUrl, ZeaburDark, ZeaburLight, ZeaburUrl, ZedDark, ZedLight, ZedUrl, ZenBrowserDark, ZenBrowserLight, ZenBrowserUrl, Zig, ZigUrl, Zod, ZodUrl, Zoom, ZoomUrl };
